function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
            return;
        }
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("izbAs", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$c0931941d1005798$export$2e2bcd8739ae039);
    var $6HujX;
    var $c0931941d1005798$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6HujX")).default);
});
parcelRegister("6HujX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$895c6f85b3904883$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jsg6S;
    var $9NiTW;
    const $895c6f85b3904883$var$ProformaJiraIssueFormsDirectWrapper = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsg6S")).default), null));
    var $895c6f85b3904883$export$2e2bcd8739ae039 = $895c6f85b3904883$var$ProformaJiraIssueFormsDirectWrapper;
});
parcelRegister("jsg6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a95982ca9f14b39$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cC9Cp;
    var $e0acb;
    var $5bpEQ;
    var $dAfqg;
    var $3TpKp;
    var $90yGq;
    var $koeKL;
    var $2tT7R;
    var $iTtd7;
    var $bmKPg;
    var $ieDtd;
    const $3a95982ca9f14b39$var$ProformaJiraIssueForms = ({ isEmbed: isEmbed })=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { isProjectAdmin: isProjectAdmin, projectId: projectId, projectKey: projectKey, projectType: projectType, simplified: simplified } = projectContext ?? {};
        const [templateFormId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('templateFormId');
        const [issueTypeId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('issueTypeId');
        const [requestTypeId] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('requestTypeId');
        const [settings, setSettings] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const proformaSupportedProjectType = projectType && (0, (0, parcelRequire("e0acb")).toSupportedProjectType)(projectType);
            if (projectId && projectKey && simplified !== undefined && templateFormId && issueTypeId && proformaSupportedProjectType) setSettings({
                analytics: {
                    channel: (0, (0, parcelRequire("5bpEQ")).ANALYTICS_CHANNEL)
                },
                flags: {},
                urls: (0, (0, parcelRequire("5bpEQ")).getUrls)(environment, cloudId),
                environment: (0, (0, parcelRequire("cC9Cp")).toProformaEnvironment)(environment),
                context: {
                    projectId: projectId,
                    projectKey: projectKey,
                    projectType: proformaSupportedProjectType,
                    isSimplifiedProject: simplified,
                    templateFormId: Number(templateFormId),
                    issueTypeId: issueTypeId,
                    requestTypeId: requestTypeId,
                    userIsProjectAdmin: isProjectAdmin,
                    intlLocale: locale,
                    isEmbed: !!isEmbed
                }
            });
        }, [
            environment,
            cloudId,
            projectId,
            projectKey,
            projectType,
            simplified,
            templateFormId,
            issueTypeId,
            requestTypeId,
            isProjectAdmin,
            locale,
            isEmbed
        ]);
        if (projectContext !== null && projectId && settings) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTtd7")).JiraIssueFormsDirectApp), {
            settings: settings,
            reporterAccountId: accountId ?? undefined
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TpKp")).JsmPageInteractiveEvent), null));
        return null;
    };
    var $3a95982ca9f14b39$export$2e2bcd8739ae039 = $3a95982ca9f14b39$var$ProformaJiraIssueForms;
});
parcelRegister("cC9Cp", function(module, exports) {
    $parcel$export(module.exports, "toProformaEnvironment", ()=>$498398f11ffa02f4$export$81a9ecf6b01a04d4);
    var $fxMku;
    const $498398f11ffa02f4$export$81a9ecf6b01a04d4 = (environment)=>{
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("fxMku")).Environment).DEVELOPMENT;
            case 'staging':
                return (0, (0, parcelRequire("fxMku")).Environment).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("fxMku")).Environment).PRODUCTION;
            case 'local':
            default:
                return (0, (0, parcelRequire("fxMku")).Environment).LOCAL;
        }
    };
});
parcelRegister("fxMku", function(module, exports) {
    $parcel$export(module.exports, "Environment", ()=>$b50f6d5564bbfb55$export$7dc6752a22ab011a);
    let $b50f6d5564bbfb55$export$7dc6752a22ab011a = function(Environment) {
        Environment["PRODUCTION"] = "prod";
        Environment["STAGING"] = "staging";
        Environment["DEVELOPMENT"] = "dev";
        Environment["LOCAL"] = "local";
        return Environment;
    }({});
});
parcelRegister("e0acb", function(module, exports) {
    $parcel$export(module.exports, "toSupportedProjectType", ()=>$e673c09a1dbad9a8$export$f86c633814403e83);
    var $2vSU6;
    const $e673c09a1dbad9a8$export$f86c633814403e83 = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return projectType;
            default:
                return undefined;
        }
    };
});
parcelRegister("5bpEQ", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$1cd284857d4cae3e$export$85183a312807388d);
    $parcel$export(module.exports, "getUrls", ()=>$1cd284857d4cae3e$export$c69765bbdb1543ad);
    const $1cd284857d4cae3e$export$85183a312807388d = 'productAnalytics';
    const $1cd284857d4cae3e$export$c69765bbdb1543ad = (environment, cloudId)=>({
            api: `/gateway/api/proforma/cloudid/${cloudId}`,
            jira: '',
            templatesService: environment === 'prod' ? 'https://proforma-templates.services.atlassian.com' : 'https://proforma-templates.stg.services.atlassian.com',
            analyticsService: environment === 'prod' ? 'https://proforma-analytics.services.atlassian.com' : 'https://proforma-analytics.stg.services.atlassian.com'
        });
});
parcelRegister("3TpKp", function(module, exports) {
    $parcel$export(module.exports, "JsmPageInteractiveEvent", ()=>$bbb7386cf97044f2$export$c4ba40c380ee9a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), args);
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
        isExpectedToHaveSsr: false,
        withMarks: [],
        extra: {}
    };
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("iTtd7", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueFormsDirectApp", ()=>$dc1405b086839054$export$ffdf110afae16909);
    var $5uXOq = parcelRequire("5uXOq");
    var $alnGD = parcelRequire("alnGD");
    var $2NMNM;
    var $bKCvK;
    var $jkADf;
    var $agcXw;
    var $bv2Tr;
    var $iu3cq;
    var $6W5Vt;
    var $9rYSe;
    var $6jvUj;
    var $bV8dQ;
    var $51w3E;
    var $2Zsrr;
    var $bpKCm;
    var $30GOg;
    var $5R2g4;
    var $c6IF8;
    var $dQKc8;
    var $2tirv;
    var $ewILP;
    var $ke4ek;
    var $gWroG;
    var $foFS5;
    const $dc1405b086839054$var$JiraIssueFormsDirectBaseApp = ({ settings: settings, reporterAccountId: reporterAccountId })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [moduleContext, setModuleContext] = (0, $5uXOq.useState)();
        const project = (0, $5uXOq.useMemo)(()=>({
                id: settings.context.projectId.toString(),
                key: settings.context.projectKey,
                name: '',
                projectType: settings.context.projectType.toUpperCase(),
                simplified: settings.context.isSimplifiedProject,
                avatar: {
                    large: ''
                }
            }), [
            settings
        ]);
        const formDetails = (0, $5uXOq.useMemo)(()=>({
                projectId: settings.context.projectId,
                projectFormId: settings.context.templateFormId,
                name: '',
                issueType: {
                    id: settings.context.issueTypeId,
                    name: ''
                },
                requestType: settings.context.requestTypeId === undefined ? undefined : {
                    id: settings.context.requestTypeId,
                    name: ''
                }
            }), [
            settings
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const utils = (0, (0, parcelRequire("6jvUj")).createUtils)(settings, 'IssueCreateDirect', showFlag, createAnalyticsEvent, settings.context.intlLocale);
            setModuleContext({
                apis: {
                    apiUtil: utils.apiUtil
                },
                utils: {
                    errorUtils: utils.errorUtils
                }
            });
        }, [
            createAnalyticsEvent,
            settings,
            settings.context.intlLocale,
            showFlag
        ]);
        if (!moduleContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bv2Tr")).ErrorBoundary), {
            errorUtils: moduleContext.utils.errorUtils
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6W5Vt")).PfFlagsProvider), {
            flags: settings.flags
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9rYSe")).UtilsProvider), {
            utils: moduleContext.utils
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5R2g4")).FieldDataServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dQKc8")).FormChoicesServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c6IF8")).FormServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tirv")).IssueCreateServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ke4ek")).UserChoicesServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ewILP")).LabelChoicesServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Zsrr")).AffectedServicesChoicesServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bpKCm")).AttachmentServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("30GOg")).CmdbChoicesServiceContainer), {
            apiUtil: moduleContext.apis.apiUtil,
            reporterAccountId: reporterAccountId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gWroG")).IssueFormsDirect), {
            formDetails: formDetails,
            project: project,
            userIsProjectAdmin: settings.context.userIsProjectAdmin,
            reporterAccountId: reporterAccountId,
            isEmbed: settings.context.isEmbed
        })))))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agcXw")).FireScreenAnalytics), null))));
    };
    const $dc1405b086839054$export$ffdf110afae16909 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bV8dQ")).AnalyticsProvider), props.settings.analytics, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jkADf")).ContextWrapper), {
            sourceName: "proformaJiraIssueCreateDirect",
            sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
            attributes: (0, (0, parcelRequire("foFS5")).getAnalyticsAttributesForIssueFormsDirect)(props.settings.context)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("51w3E")).PackageIntlProvider), {
            locale: props.settings.context.intlLocale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCvK")).FlagsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iu3cq")).MediaProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($dc1405b086839054$var$JiraIssueFormsDirectBaseApp, props))))));
    (0, $alnGD.configure)({
        isolateGlobalState: true
    });
});
parcelRegister("alnGD", function(module, exports) {
    $parcel$export(module.exports, "observable", ()=>observable);
    $parcel$export(module.exports, "computed", ()=>computed);
    $parcel$export(module.exports, "getDependencyTree", ()=>getDependencyTree);
    $parcel$export(module.exports, "Reaction", ()=>Reaction);
    $parcel$export(module.exports, "spy", ()=>spy);
    $parcel$export(module.exports, "action", ()=>action);
    $parcel$export(module.exports, "runInAction", ()=>runInAction);
    $parcel$export(module.exports, "configure", ()=>configure);
    $parcel$export(module.exports, "toJS", ()=>toJS);
    $parcel$export(module.exports, "transaction", ()=>transaction);
    var $6cAn5 = parcelRequire("6cAn5");
    var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
    var EMPTY_ARRAY = [];
    Object.freeze(EMPTY_ARRAY);
    var EMPTY_OBJECT = {};
    Object.freeze(EMPTY_OBJECT);
    var mockGlobal = {};
    function getGlobal() {
        if (typeof window !== "undefined") return window;
        if (typeof $parcel$global !== "undefined") return $parcel$global;
        if (typeof self !== "undefined") return self;
        return mockGlobal;
    }
    function getNextId() {
        return ++globalState.mobxGuid;
    }
    function fail(message) {
        invariant(false, message);
        throw "X";
    }
    function invariant(check, message) {
        if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
    }
    var deprecatedMessages = [];
    function deprecated(msg, thing) {
        return false;
    }
    function once(func) {
        var invoked = false;
        return function() {
            if (invoked) return;
            invoked = true;
            return func.apply(this, arguments);
        };
    }
    var noop = function() {};
    function unique(list) {
        var res = [];
        list.forEach(function(item) {
            if (res.indexOf(item) === -1) res.push(item);
        });
        return res;
    }
    function isObject(value) {
        return value !== null && typeof value === "object";
    }
    function isPlainObject(value) {
        if (value === null || typeof value !== "object") return false;
        var proto = Object.getPrototypeOf(value);
        return proto === Object.prototype || proto === null;
    }
    function convertToMap(dataStructure) {
        if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
        else if (Array.isArray(dataStructure)) return new Map(dataStructure);
        else if (isPlainObject(dataStructure)) {
            var map = new Map();
            for(var key in dataStructure)map.set(key, dataStructure[key]);
            return map;
        } else return fail("Cannot convert to map from '" + dataStructure + "'");
    }
    function makeNonEnumerable(object, propNames) {
        for(var i = 0; i < propNames.length; i++)addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
    function addHiddenProp(object, propName, value) {
        Object.defineProperty(object, propName, {
            enumerable: false,
            writable: true,
            configurable: true,
            value: value
        });
    }
    function addHiddenFinalProp(object, propName, value) {
        Object.defineProperty(object, propName, {
            enumerable: false,
            writable: false,
            configurable: true,
            value: value
        });
    }
    function isPropertyConfigurable(object, prop) {
        var descriptor = Object.getOwnPropertyDescriptor(object, prop);
        return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
    }
    function assertPropertyConfigurable(object, prop) {}
    function createInstanceofPredicate(name, clazz) {
        var propName = "isMobX" + name;
        clazz.prototype[propName] = true;
        return function(x) {
            return isObject(x) && x[propName] === true;
        };
    }
    function areBothNaN(a, b) {
        return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
    }
    function isArrayLike(x) {
        return Array.isArray(x) || isObservableArray(x);
    }
    function isES6Map(thing) {
        if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map) return true;
        return false;
    }
    function isES6Set(thing) {
        return thing instanceof Set;
    }
    function iteratorToArray(it) {
        var res = [];
        while(true){
            var r = it.next();
            if (r.done) break;
            res.push(r.value);
        }
        return res;
    }
    function primitiveSymbol() {
        return typeof Symbol === "function" && Symbol.toPrimitive || "@@toPrimitive";
    }
    function toPrimitive(value) {
        return value === null ? null : typeof value === "object" ? "" + value : value;
    }
    function forOf(iter, callback) {
        var next = iter.next();
        while(!next.done){
            callback(next.value);
            next = iter.next();
        }
    }
    function iteratorSymbol() {
        return typeof Symbol === "function" && Symbol.iterator || "@@iterator";
    }
    function declareIterator(prototType, iteratorFactory) {
        addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
    }
    function makeIterable(iterator) {
        iterator[iteratorSymbol()] = getSelf;
        return iterator;
    }
    function toStringTagSymbol() {
        return typeof Symbol === "function" && Symbol.toStringTag || "@@toStringTag";
    }
    function getSelf() {
        return this;
    }
    var Atom = function() {
        function Atom(name) {
            if (name === void 0) name = "Atom@" + getNextId();
            this.name = name;
            this.isPendingUnobservation = false;
            this.isBeingObserved = false;
            this.observers = [];
            this.observersIndexes = {};
            this.diffValue = 0;
            this.lastAccessedBy = 0;
            this.lowestObserverState = IDerivationState.NOT_TRACKING;
        }
        Atom.prototype.onBecomeUnobserved = function() {};
        Atom.prototype.onBecomeObserved = function() {};
        Atom.prototype.reportObserved = function() {
            return reportObserved(this);
        };
        Atom.prototype.reportChanged = function() {
            startBatch();
            propagateChanged(this);
            endBatch();
        };
        Atom.prototype.toString = function() {
            return this.name;
        };
        return Atom;
    }();
    var isAtom = createInstanceofPredicate("Atom", Atom);
    function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
        if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
        var atom = new Atom(name);
        onBecomeObserved(atom, onBecomeObservedHandler);
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
        return atom;
    }
    function identityComparer(a, b) {
        return a === b;
    }
    function structuralComparer(a, b) {
        return deepEqual(a, b);
    }
    function shallowComparer(a, b) {
        return deepEqual(a, b, 1);
    }
    function defaultComparer(a, b) {
        return areBothNaN(a, b) || identityComparer(a, b);
    }
    var comparer = {
        identity: identityComparer,
        structural: structuralComparer,
        default: defaultComparer,
        shallow: shallowComparer
    };
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    }
    function __spread() {
        for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
        return ar;
    }
    var enumerableDescriptorCache = {};
    var nonEnumerableDescriptorCache = {};
    function createPropertyInitializerDescriptor(prop, enumerable) {
        var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
        return cache[prop] || (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function() {
                initializeInstance(this);
                return this[prop];
            },
            set: function(value) {
                initializeInstance(this);
                this[prop] = value;
            }
        });
    }
    function initializeInstance(target) {
        if (target.__mobxDidRunLazyInitializers === true) return;
        var decorators = target.__mobxDecorators;
        if (decorators) {
            addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
            for(var key in decorators){
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        }
    }
    function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
        return function decoratorFactory() {
            var decoratorArguments;
            var decorator = function decorate(target, prop, descriptor, applyImmediately) {
                if (applyImmediately === true) {
                    propertyCreator(target, prop, descriptor, target, decoratorArguments);
                    return null;
                }
                if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                    var inheritedDecorators = target.__mobxDecorators;
                    addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
                }
                target.__mobxDecorators[prop] = {
                    prop: prop,
                    propertyCreator: propertyCreator,
                    descriptor: descriptor,
                    decoratorTarget: target,
                    decoratorArguments: decoratorArguments
                };
                return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
            };
            if (quacksLikeADecorator(arguments)) {
                decoratorArguments = EMPTY_ARRAY;
                return decorator.apply(null, arguments);
            } else {
                decoratorArguments = Array.prototype.slice.call(arguments);
                return decorator;
            }
        };
    }
    function quacksLikeADecorator(args) {
        return (args.length === 2 || args.length === 3) && typeof args[1] === "string" || args.length === 4 && args[3] === true;
    }
    function deepEnhancer(v, _, name) {
        if (isObservable(v)) return v;
        if (Array.isArray(v)) return observable.array(v, {
            name: name
        });
        if (isPlainObject(v)) return observable.object(v, undefined, {
            name: name
        });
        if (isES6Map(v)) return observable.map(v, {
            name: name
        });
        if (isES6Set(v)) return observable.set(v, {
            name: name
        });
        return v;
    }
    function shallowEnhancer(v, _, name) {
        if (v === undefined || v === null) return v;
        if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
        if (Array.isArray(v)) return observable.array(v, {
            name: name,
            deep: false
        });
        if (isPlainObject(v)) return observable.object(v, undefined, {
            name: name,
            deep: false
        });
        if (isES6Map(v)) return observable.map(v, {
            name: name,
            deep: false
        });
        if (isES6Set(v)) return observable.set(v, {
            name: name,
            deep: false
        });
        return fail(false);
    }
    function referenceEnhancer(newValue) {
        return newValue;
    }
    function refStructEnhancer(v, oldValue, name) {
        if (deepEqual(v, oldValue)) return oldValue;
        return v;
    }
    function createDecoratorForEnhancer(enhancer) {
        invariant(enhancer);
        var decorator = createPropDecorator(true, function(target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
            var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
            defineObservableProperty(target, propertyName, initialValue, enhancer);
        });
        var res = (typeof $6cAn5 !== "undefined" && $6cAn5.env, decorator);
        res.enhancer = enhancer;
        return res;
    }
    var defaultCreateObservableOptions = {
        deep: true,
        name: undefined,
        defaultDecorator: undefined
    };
    var shallowCreateObservableOptions = {
        deep: false,
        name: undefined,
        defaultDecorator: undefined
    };
    Object.freeze(defaultCreateObservableOptions);
    Object.freeze(shallowCreateObservableOptions);
    function assertValidOption(key) {
        if (!/^(deep|name|equals|defaultDecorator)$/.test(key)) fail("invalid option for (extend)observable: " + key);
    }
    function asCreateObservableOptions(thing) {
        if (thing === null || thing === undefined) return defaultCreateObservableOptions;
        if (typeof thing === "string") return {
            name: thing,
            deep: true
        };
        return thing;
    }
    function getEnhancerFromOptions(options) {
        return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
    }
    var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
    var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
    var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
    var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
    function createObservable(v, arg2, arg3) {
        if (typeof arguments[1] === "string") return deepDecorator.apply(null, arguments);
        if (isObservable(v)) return v;
        var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v;
        if (res !== v) return res;
        fail(false);
    }
    var observableFactories = {
        box: function(value, options) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
            var o = asCreateObservableOptions(options);
            return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
        },
        shallowBox: function(value, name) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowBox");
            deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
            return observable.box(value, {
                name: name,
                deep: false
            });
        },
        array: function(initialValues, options) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
            var o = asCreateObservableOptions(options);
            return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
        },
        shallowArray: function(initialValues, name) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowArray");
            deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
            return observable.array(initialValues, {
                name: name,
                deep: false
            });
        },
        map: function(initialValues, options) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
            var o = asCreateObservableOptions(options);
            return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
        },
        shallowMap: function(initialValues, name) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowMap");
            deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
            return observable.map(initialValues, {
                name: name,
                deep: false
            });
        },
        set: function(initialValues, options) {
            if (arguments.length > 2) incorrectlyUsedAsDecorator("set");
            var o = asCreateObservableOptions(options);
            return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
        },
        object: function(props, decorators, options) {
            if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
            var o = asCreateObservableOptions(options);
            return extendObservable({}, props, decorators, o);
        },
        shallowObject: function(props, name) {
            if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("shallowObject");
            deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
            return observable.object(props, {}, {
                name: name,
                deep: false
            });
        },
        ref: refDecorator,
        shallow: shallowDecorator,
        deep: deepDecorator,
        struct: refStructDecorator
    };
    var observable = createObservable;
    Object.keys(observableFactories).forEach(function(name) {
        return observable[name] = observableFactories[name];
    });
    function incorrectlyUsedAsDecorator(methodName) {
        fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
    }
    var computedDecorator = createPropDecorator(false, function(instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
        var get = descriptor.get, set = descriptor.set;
        var options = decoratorArgs[0] || {};
        defineComputedProperty(instance, propertyName, __assign({
            get: get,
            set: set
        }, options));
    });
    var computedStructDecorator = computedDecorator({
        equals: comparer.structural
    });
    var computed = function computed(arg1, arg2, arg3) {
        if (typeof arg2 === "string") return computedDecorator.apply(null, arguments);
        if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) return computedDecorator.apply(null, arguments);
        var opts = typeof arg2 === "object" ? arg2 : {};
        opts.get = arg1;
        opts.set = typeof arg2 === "function" ? arg2 : opts.set;
        opts.name = opts.name || arg1.name || "";
        return new ComputedValue(opts);
    };
    computed.struct = computedStructDecorator;
    var IDerivationState;
    (function(IDerivationState) {
        IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
        IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
        IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
        IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
    })(IDerivationState || (IDerivationState = {}));
    var TraceMode;
    (function(TraceMode) {
        TraceMode[TraceMode["NONE"] = 0] = "NONE";
        TraceMode[TraceMode["LOG"] = 1] = "LOG";
        TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
    })(TraceMode || (TraceMode = {}));
    var CaughtException = function() {
        function CaughtException(cause) {
            this.cause = cause;
        }
        return CaughtException;
    }();
    function isCaughtException(e) {
        return e instanceof CaughtException;
    }
    function shouldCompute(derivation) {
        switch(derivation.dependenciesState){
            case IDerivationState.UP_TO_DATE:
                return false;
            case IDerivationState.NOT_TRACKING:
            case IDerivationState.STALE:
                return true;
            case IDerivationState.POSSIBLY_STALE:
                var prevAllowStateReads = allowStateReadsStart(true);
                var prevUntracked = untrackedStart();
                var obs = derivation.observing, l = obs.length;
                for(var i = 0; i < l; i++){
                    var obj = obs[i];
                    if (isComputedValue(obj)) {
                        if (globalState.disableErrorBoundaries) obj.get();
                        else try {
                            obj.get();
                        } catch (e) {
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                        if (derivation.dependenciesState === IDerivationState.STALE) {
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                }
                changeDependenciesStateTo0(derivation);
                untrackedEnd(prevUntracked);
                allowStateReadsEnd(prevAllowStateReads);
                return false;
        }
    }
    function isComputingDerivation() {
        return globalState.trackingDerivation !== null;
    }
    function checkIfStateModificationsAreAllowed(atom) {
        var hasObservers = atom.observers.length > 0;
        if (globalState.computationDepth > 0 && hasObservers) fail(false);
        if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict")) fail(false);
    }
    function checkIfStateReadsAreAllowed(observable) {}
    function trackDerivedFunction(derivation, f, context) {
        var prevAllowStateReads = allowStateReadsStart(true);
        changeDependenciesStateTo0(derivation);
        derivation.newObserving = new Array(derivation.observing.length + 100);
        derivation.unboundDepsCount = 0;
        derivation.runId = ++globalState.runId;
        var prevTracking = globalState.trackingDerivation;
        globalState.trackingDerivation = derivation;
        var result;
        if (globalState.disableErrorBoundaries === true) result = f.call(context);
        else try {
            result = f.call(context);
        } catch (e) {
            result = new CaughtException(e);
        }
        globalState.trackingDerivation = prevTracking;
        bindDependencies(derivation);
        if (derivation.observing.length === 0) warnAboutDerivationWithoutDependencies(derivation);
        allowStateReadsEnd(prevAllowStateReads);
        return result;
    }
    function warnAboutDerivationWithoutDependencies(derivation) {
        return;
    }
    function bindDependencies(derivation) {
        var prevObserving = derivation.observing;
        var observing = derivation.observing = derivation.newObserving;
        var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
        var i0 = 0, l = derivation.unboundDepsCount;
        for(var i = 0; i < l; i++){
            var dep = observing[i];
            if (dep.diffValue === 0) {
                dep.diffValue = 1;
                if (i0 !== i) observing[i0] = dep;
                i0++;
            }
            if (dep.dependenciesState > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState;
        }
        observing.length = i0;
        derivation.newObserving = null;
        l = prevObserving.length;
        while(l--){
            var dep = prevObserving[l];
            if (dep.diffValue === 0) removeObserver(dep, derivation);
            dep.diffValue = 0;
        }
        while(i0--){
            var dep = observing[i0];
            if (dep.diffValue === 1) {
                dep.diffValue = 0;
                addObserver(dep, derivation);
            }
        }
        if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
            derivation.dependenciesState = lowestNewObservingDerivationState;
            derivation.onBecomeStale();
        }
    }
    function clearObserving(derivation) {
        var obs = derivation.observing;
        derivation.observing = [];
        var i = obs.length;
        while(i--)removeObserver(obs[i], derivation);
        derivation.dependenciesState = IDerivationState.NOT_TRACKING;
    }
    function untracked(action) {
        var prev = untrackedStart();
        var res = action();
        untrackedEnd(prev);
        return res;
    }
    function untrackedStart() {
        var prev = globalState.trackingDerivation;
        globalState.trackingDerivation = null;
        return prev;
    }
    function untrackedEnd(prev) {
        globalState.trackingDerivation = prev;
    }
    function allowStateReadsStart(allowStateReads) {
        var prev = globalState.allowStateReads;
        globalState.allowStateReads = allowStateReads;
        return prev;
    }
    function allowStateReadsEnd(prev) {
        globalState.allowStateReads = prev;
    }
    function changeDependenciesStateTo0(derivation) {
        if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
        derivation.dependenciesState = IDerivationState.UP_TO_DATE;
        var obs = derivation.observing;
        var i = obs.length;
        while(i--)obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    var currentActionId = 0;
    var nextActionId = 1;
    var functionNameDescriptor = Object.getOwnPropertyDescriptor(function() {}, "name");
    var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
    function createAction(actionName, fn) {
        var res = function() {
            return executeAction(actionName, fn, this, arguments);
        };
        res.isMobxAction = true;
        return res;
    }
    function executeAction(actionName, fn, scope, args) {
        var runInfo = _startAction(actionName, scope, args);
        try {
            return fn.apply(scope, args);
        } catch (err) {
            runInfo.error = err;
            throw err;
        } finally{
            _endAction(runInfo);
        }
    }
    function _startAction(actionName, scope, args) {
        var notifySpy = isSpyEnabled() && !!actionName;
        var startTime = 0;
        if (notifySpy) {
            startTime = Date.now();
            var l = args && args.length || 0;
            var flattendArgs = new Array(l);
            if (l > 0) for(var i = 0; i < l; i++)flattendArgs[i] = args[i];
            spyReportStart({
                type: "action",
                name: actionName,
                object: scope,
                arguments: flattendArgs
            });
        }
        var prevDerivation = untrackedStart();
        startBatch();
        var prevAllowStateChanges = allowStateChangesStart(true);
        var prevAllowStateReads = allowStateReadsStart(true);
        var runInfo = {
            prevDerivation: prevDerivation,
            prevAllowStateChanges: prevAllowStateChanges,
            prevAllowStateReads: prevAllowStateReads,
            notifySpy: notifySpy,
            startTime: startTime,
            actionId: nextActionId++,
            parentActionId: currentActionId
        };
        currentActionId = runInfo.actionId;
        return runInfo;
    }
    function _endAction(runInfo) {
        if (currentActionId !== runInfo.actionId) fail("invalid action stack. did you forget to finish an action?");
        currentActionId = runInfo.parentActionId;
        if (runInfo.error !== undefined) globalState.suppressReactionErrors = true;
        allowStateChangesEnd(runInfo.prevAllowStateChanges);
        allowStateReadsEnd(runInfo.prevAllowStateReads);
        endBatch();
        untrackedEnd(runInfo.prevDerivation);
        if (runInfo.notifySpy) spyReportEnd({
            time: Date.now() - runInfo.startTime
        });
        globalState.suppressReactionErrors = false;
    }
    function allowStateChanges(allowStateChanges, func) {
        var prev = allowStateChangesStart(allowStateChanges);
        var res;
        try {
            res = func();
        } finally{
            allowStateChangesEnd(prev);
        }
        return res;
    }
    function allowStateChangesStart(allowStateChanges) {
        var prev = globalState.allowStateChanges;
        globalState.allowStateChanges = allowStateChanges;
        return prev;
    }
    function allowStateChangesEnd(prev) {
        globalState.allowStateChanges = prev;
    }
    function allowStateChangesInsideComputed(func) {
        var prev = globalState.computationDepth;
        globalState.computationDepth = 0;
        var res;
        try {
            res = func();
        } finally{
            globalState.computationDepth = prev;
        }
        return res;
    }
    var ObservableValue = function(_super) {
        __extends(ObservableValue, _super);
        function ObservableValue(value, enhancer, name, notifySpy, equals) {
            if (name === void 0) name = "ObservableValue@" + getNextId();
            if (notifySpy === void 0) notifySpy = true;
            if (equals === void 0) equals = comparer.default;
            var _this = _super.call(this, name) || this;
            _this.enhancer = enhancer;
            _this.name = name;
            _this.equals = equals;
            _this.hasUnreportedChange = false;
            _this.value = enhancer(value, undefined, name);
            if (notifySpy && isSpyEnabled()) spyReport({
                type: "create",
                name: _this.name,
                newValue: "" + _this.value
            });
            return _this;
        }
        ObservableValue.prototype.dehanceValue = function(value) {
            if (this.dehancer !== undefined) return this.dehancer(value);
            return value;
        };
        ObservableValue.prototype.set = function(newValue) {
            var oldValue = this.value;
            newValue = this.prepareNewValue(newValue);
            if (newValue !== globalState.UNCHANGED) {
                var notifySpy = isSpyEnabled();
                if (notifySpy) spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
                this.setNewValue(newValue);
                if (notifySpy) spyReportEnd();
            }
        };
        ObservableValue.prototype.prepareNewValue = function(newValue) {
            checkIfStateModificationsAreAllowed(this);
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this,
                    type: "update",
                    newValue: newValue
                });
                if (!change) return globalState.UNCHANGED;
                newValue = change.newValue;
            }
            newValue = this.enhancer(newValue, this.value, this.name);
            return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
        };
        ObservableValue.prototype.setNewValue = function(newValue) {
            var oldValue = this.value;
            this.value = newValue;
            this.reportChanged();
            if (hasListeners(this)) notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        };
        ObservableValue.prototype.get = function() {
            this.reportObserved();
            return this.dehanceValue(this.value);
        };
        ObservableValue.prototype.intercept = function(handler) {
            return registerInterceptor(this, handler);
        };
        ObservableValue.prototype.observe = function(listener, fireImmediately) {
            if (fireImmediately) listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
            return registerListener(this, listener);
        };
        ObservableValue.prototype.toJSON = function() {
            return this.get();
        };
        ObservableValue.prototype.toString = function() {
            return this.name + "[" + this.value + "]";
        };
        ObservableValue.prototype.valueOf = function() {
            return toPrimitive(this.get());
        };
        return ObservableValue;
    }(Atom);
    ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
    var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
    var ComputedValue = function() {
        function ComputedValue(options) {
            this.dependenciesState = IDerivationState.NOT_TRACKING;
            this.observing = [];
            this.newObserving = null;
            this.isBeingObserved = false;
            this.isPendingUnobservation = false;
            this.observers = [];
            this.observersIndexes = {};
            this.diffValue = 0;
            this.runId = 0;
            this.lastAccessedBy = 0;
            this.lowestObserverState = IDerivationState.UP_TO_DATE;
            this.unboundDepsCount = 0;
            this.__mapid = "#" + getNextId();
            this.value = new CaughtException(null);
            this.isComputing = false;
            this.isRunningSetter = false;
            this.isTracing = TraceMode.NONE;
            invariant(options.get, "missing option for computed: get");
            this.derivation = options.get;
            this.name = options.name || "ComputedValue@" + getNextId();
            if (options.set) this.setter = createAction(this.name + "-setter", options.set);
            this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
            this.scope = options.context;
            this.requiresReaction = !!options.requiresReaction;
            this.keepAlive = !!options.keepAlive;
        }
        ComputedValue.prototype.onBecomeStale = function() {
            propagateMaybeChanged(this);
        };
        ComputedValue.prototype.onBecomeUnobserved = function() {};
        ComputedValue.prototype.onBecomeObserved = function() {};
        ComputedValue.prototype.get = function() {
            if (this.isComputing) fail("Cycle detected in computation " + this.name + ": " + this.derivation);
            if (globalState.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
                if (shouldCompute(this)) {
                    this.warnAboutUntrackedRead();
                    startBatch();
                    this.value = this.computeValue(false);
                    endBatch();
                }
            } else {
                reportObserved(this);
                if (shouldCompute(this)) {
                    if (this.trackAndCompute()) propagateChangeConfirmed(this);
                }
            }
            var result = this.value;
            if (isCaughtException(result)) throw result.cause;
            return result;
        };
        ComputedValue.prototype.peek = function() {
            var res = this.computeValue(false);
            if (isCaughtException(res)) throw res.cause;
            return res;
        };
        ComputedValue.prototype.set = function(value) {
            if (this.setter) {
                invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
                this.isRunningSetter = true;
                try {
                    this.setter.call(this.scope, value);
                } finally{
                    this.isRunningSetter = false;
                }
            } else invariant(false, false);
        };
        ComputedValue.prototype.trackAndCompute = function() {
            if (isSpyEnabled()) spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
            var oldValue = this.value;
            var wasSuspended = this.dependenciesState === IDerivationState.NOT_TRACKING;
            var newValue = this.computeValue(true);
            var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
            if (changed) this.value = newValue;
            return changed;
        };
        ComputedValue.prototype.computeValue = function(track) {
            this.isComputing = true;
            globalState.computationDepth++;
            var res;
            if (track) res = trackDerivedFunction(this, this.derivation, this.scope);
            else {
                if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope);
                else try {
                    res = this.derivation.call(this.scope);
                } catch (e) {
                    res = new CaughtException(e);
                }
            }
            globalState.computationDepth--;
            this.isComputing = false;
            return res;
        };
        ComputedValue.prototype.suspend = function() {
            if (!this.keepAlive) {
                clearObserving(this);
                this.value = undefined;
            }
        };
        ComputedValue.prototype.observe = function(listener, fireImmediately) {
            var _this = this;
            var firstTime = true;
            var prevValue = undefined;
            return autorun(function() {
                var newValue = _this.get();
                if (!firstTime || fireImmediately) {
                    var prevU = untrackedStart();
                    listener({
                        type: "update",
                        object: _this,
                        newValue: newValue,
                        oldValue: prevValue
                    });
                    untrackedEnd(prevU);
                }
                firstTime = false;
                prevValue = newValue;
            });
        };
        ComputedValue.prototype.warnAboutUntrackedRead = function() {
            return;
        };
        ComputedValue.prototype.toJSON = function() {
            return this.get();
        };
        ComputedValue.prototype.toString = function() {
            return this.name + "[" + this.derivation.toString() + "]";
        };
        ComputedValue.prototype.valueOf = function() {
            return toPrimitive(this.get());
        };
        return ComputedValue;
    }();
    ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
    var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
    var persistentKeys = [
        "mobxGuid",
        "spyListeners",
        "enforceActions",
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "allowStateReads",
        "disableErrorBoundaries",
        "runId",
        "UNCHANGED"
    ];
    var MobXGlobals = function() {
        function MobXGlobals() {
            this.version = 5;
            this.UNCHANGED = {};
            this.trackingDerivation = null;
            this.computationDepth = 0;
            this.runId = 0;
            this.mobxGuid = 0;
            this.inBatch = 0;
            this.pendingUnobservations = [];
            this.pendingReactions = [];
            this.isRunningReactions = false;
            this.allowStateChanges = true;
            this.allowStateReads = true;
            this.enforceActions = false;
            this.spyListeners = [];
            this.globalReactionErrorHandlers = [];
            this.computedRequiresReaction = false;
            this.reactionRequiresObservable = false;
            this.observableRequiresReaction = false;
            this.computedConfigurable = false;
            this.disableErrorBoundaries = false;
            this.suppressReactionErrors = false;
        }
        return MobXGlobals;
    }();
    var canMergeGlobalState = true;
    var isolateCalled = false;
    var globalState = function() {
        var global1 = getGlobal();
        if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
        if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
        if (!canMergeGlobalState) {
            setTimeout(function() {
                if (!isolateCalled) fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }, 1);
            return new MobXGlobals();
        } else if (global1.__mobxGlobals) {
            global1.__mobxInstanceCount += 1;
            if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
            return global1.__mobxGlobals;
        } else {
            global1.__mobxInstanceCount = 1;
            return global1.__mobxGlobals = new MobXGlobals();
        }
    }();
    function isolateGlobalState() {
        if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) fail("isolateGlobalState should be called before MobX is running any reactions");
        isolateCalled = true;
        if (canMergeGlobalState) {
            if (--getGlobal().__mobxInstanceCount === 0) getGlobal().__mobxGlobals = undefined;
            globalState = new MobXGlobals();
        }
    }
    function getGlobalState() {
        return globalState;
    }
    function resetGlobalState() {
        var defaultGlobals = new MobXGlobals();
        for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
        globalState.allowStateChanges = !globalState.enforceActions;
    }
    function hasObservers(observable) {
        return observable.observers && observable.observers.length > 0;
    }
    function getObservers(observable) {
        return observable.observers;
    }
    function addObserver(observable, node) {
        var l = observable.observers.length;
        if (l) observable.observersIndexes[node.__mapid] = l;
        observable.observers[l] = node;
        if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState;
    }
    function removeObserver(observable, node) {
        if (observable.observers.length === 1) {
            observable.observers.length = 0;
            queueForUnobservation(observable);
        } else {
            var list = observable.observers;
            var map = observable.observersIndexes;
            var filler = list.pop();
            if (filler !== node) {
                var index = map[node.__mapid] || 0;
                if (index) map[filler.__mapid] = index;
                else delete map[filler.__mapid];
                list[index] = filler;
            }
            delete map[node.__mapid];
        }
    }
    function queueForUnobservation(observable) {
        if (observable.isPendingUnobservation === false) {
            observable.isPendingUnobservation = true;
            globalState.pendingUnobservations.push(observable);
        }
    }
    function startBatch() {
        globalState.inBatch++;
    }
    function endBatch() {
        if (--globalState.inBatch === 0) {
            runReactions();
            var list = globalState.pendingUnobservations;
            for(var i = 0; i < list.length; i++){
                var observable = list[i];
                observable.isPendingUnobservation = false;
                if (observable.observers.length === 0) {
                    if (observable.isBeingObserved) {
                        observable.isBeingObserved = false;
                        observable.onBecomeUnobserved();
                    }
                    if (observable instanceof ComputedValue) observable.suspend();
                }
            }
            globalState.pendingUnobservations = [];
        }
    }
    function reportObserved(observable) {
        checkIfStateReadsAreAllowed(observable);
        var derivation = globalState.trackingDerivation;
        if (derivation !== null) {
            if (derivation.runId !== observable.lastAccessedBy) {
                observable.lastAccessedBy = derivation.runId;
                derivation.newObserving[derivation.unboundDepsCount++] = observable;
                if (!observable.isBeingObserved) {
                    observable.isBeingObserved = true;
                    observable.onBecomeObserved();
                }
            }
            return true;
        } else if (observable.observers.length === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
        return false;
    }
    function propagateChanged(observable) {
        if (observable.lowestObserverState === IDerivationState.STALE) return;
        observable.lowestObserverState = IDerivationState.STALE;
        var observers = observable.observers;
        var i = observers.length;
        while(i--){
            var d = observers[i];
            if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
                if (d.isTracing !== TraceMode.NONE) logTraceInfo(d, observable);
                d.onBecomeStale();
            }
            d.dependenciesState = IDerivationState.STALE;
        }
    }
    function propagateChangeConfirmed(observable) {
        if (observable.lowestObserverState === IDerivationState.STALE) return;
        observable.lowestObserverState = IDerivationState.STALE;
        var observers = observable.observers;
        var i = observers.length;
        while(i--){
            var d = observers[i];
            if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;
            else if (d.dependenciesState === IDerivationState.UP_TO_DATE) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
        }
    }
    function propagateMaybeChanged(observable) {
        if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
        observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
        var observers = observable.observers;
        var i = observers.length;
        while(i--){
            var d = observers[i];
            if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
                d.dependenciesState = IDerivationState.POSSIBLY_STALE;
                if (d.isTracing !== TraceMode.NONE) logTraceInfo(d, observable);
                d.onBecomeStale();
            }
        }
    }
    function logTraceInfo(derivation, observable) {
        console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
        if (derivation.isTracing === TraceMode.BREAK) {
            var lines = [];
            printDepTree(getDependencyTree(derivation), lines, 1);
            new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
        }
    }
    function printDepTree(tree, lines, depth) {
        if (lines.length >= 1000) {
            lines.push("(and many more)");
            return;
        }
        lines.push("" + new Array(depth).join("\t") + tree.name);
        if (tree.dependencies) tree.dependencies.forEach(function(child) {
            return printDepTree(child, lines, depth + 1);
        });
    }
    var Reaction = function() {
        function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
            if (name === void 0) name = "Reaction@" + getNextId();
            if (requiresObservable === void 0) requiresObservable = false;
            this.name = name;
            this.onInvalidate = onInvalidate;
            this.errorHandler = errorHandler;
            this.requiresObservable = requiresObservable;
            this.observing = [];
            this.newObserving = [];
            this.dependenciesState = IDerivationState.NOT_TRACKING;
            this.diffValue = 0;
            this.runId = 0;
            this.unboundDepsCount = 0;
            this.__mapid = "#" + getNextId();
            this.isDisposed = false;
            this._isScheduled = false;
            this._isTrackPending = false;
            this._isRunning = false;
            this.isTracing = TraceMode.NONE;
        }
        Reaction.prototype.onBecomeStale = function() {
            this.schedule();
        };
        Reaction.prototype.schedule = function() {
            if (!this._isScheduled) {
                this._isScheduled = true;
                globalState.pendingReactions.push(this);
                runReactions();
            }
        };
        Reaction.prototype.isScheduled = function() {
            return this._isScheduled;
        };
        Reaction.prototype.runReaction = function() {
            if (!this.isDisposed) {
                startBatch();
                this._isScheduled = false;
                if (shouldCompute(this)) {
                    this._isTrackPending = true;
                    try {
                        this.onInvalidate();
                        if (this._isTrackPending && isSpyEnabled()) spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    } catch (e) {
                        this.reportExceptionInDerivation(e);
                    }
                }
                endBatch();
            }
        };
        Reaction.prototype.track = function(fn) {
            startBatch();
            var notify = isSpyEnabled();
            var startTime;
            if (notify) {
                startTime = Date.now();
                spyReportStart({
                    name: this.name,
                    type: "reaction"
                });
            }
            this._isRunning = true;
            var result = trackDerivedFunction(this, fn, undefined);
            this._isRunning = false;
            this._isTrackPending = false;
            if (this.isDisposed) clearObserving(this);
            if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);
            if (notify) spyReportEnd({
                time: Date.now() - startTime
            });
            endBatch();
        };
        Reaction.prototype.reportExceptionInDerivation = function(error) {
            var _this = this;
            if (this.errorHandler) {
                this.errorHandler(error, this);
                return;
            }
            if (globalState.disableErrorBoundaries) throw error;
            var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
            if (globalState.suppressReactionErrors) console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)");
            else console.error(message, error);
            if (isSpyEnabled()) spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
            globalState.globalReactionErrorHandlers.forEach(function(f) {
                return f(error, _this);
            });
        };
        Reaction.prototype.dispose = function() {
            if (!this.isDisposed) {
                this.isDisposed = true;
                if (!this._isRunning) {
                    startBatch();
                    clearObserving(this);
                    endBatch();
                }
            }
        };
        Reaction.prototype.getDisposer = function() {
            var r = this.dispose.bind(this);
            r.$mobx = this;
            return r;
        };
        Reaction.prototype.toString = function() {
            return "Reaction[" + this.name + "]";
        };
        Reaction.prototype.trace = function(enterBreakPoint) {
            if (enterBreakPoint === void 0) enterBreakPoint = false;
            trace(this, enterBreakPoint);
        };
        return Reaction;
    }();
    function onReactionError(handler) {
        globalState.globalReactionErrorHandlers.push(handler);
        return function() {
            var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
            if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
        };
    }
    var MAX_REACTION_ITERATIONS = 100;
    var reactionScheduler = function(f) {
        return f();
    };
    function runReactions() {
        if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
        reactionScheduler(runReactionsHelper);
    }
    function runReactionsHelper() {
        globalState.isRunningReactions = true;
        var allReactions = globalState.pendingReactions;
        var iterations = 0;
        while(allReactions.length > 0){
            if (++iterations === MAX_REACTION_ITERATIONS) {
                console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
                allReactions.splice(0);
            }
            var remainingReactions = allReactions.splice(0);
            for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction();
        }
        globalState.isRunningReactions = false;
    }
    var isReaction = createInstanceofPredicate("Reaction", Reaction);
    function setReactionScheduler(fn) {
        var baseScheduler = reactionScheduler;
        reactionScheduler = function(f) {
            return fn(function() {
                return baseScheduler(f);
            });
        };
    }
    function isSpyEnabled() {
        return !!globalState.spyListeners.length;
    }
    function spyReport(event) {
        if (!globalState.spyListeners.length) return;
        var listeners = globalState.spyListeners;
        for(var i = 0, l = listeners.length; i < l; i++)listeners[i](event);
    }
    function spyReportStart(event) {
        var change = __assign(__assign({}, event), {
            spyReportStart: true
        });
        spyReport(change);
    }
    var END_EVENT = {
        spyReportEnd: true
    };
    function spyReportEnd(change) {
        if (change) spyReport(__assign(__assign({}, change), {
            spyReportEnd: true
        }));
        else spyReport(END_EVENT);
    }
    function spy(listener) {
        globalState.spyListeners.push(listener);
        return once(function() {
            globalState.spyListeners = globalState.spyListeners.filter(function(l) {
                return l !== listener;
            });
        });
    }
    function dontReassignFields() {
        fail(false);
    }
    function namedActionDecorator(name) {
        return function(target, prop, descriptor) {
            if (descriptor) {
                if (descriptor.value) return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true
                };
                var initializer_1 = descriptor.initializer;
                return {
                    enumerable: false,
                    configurable: true,
                    writable: true,
                    initializer: function() {
                        return createAction(name, initializer_1.call(this));
                    }
                };
            }
            return actionFieldDecorator(name).apply(this, arguments);
        };
    }
    function actionFieldDecorator(name) {
        return function(target, prop, descriptor) {
            Object.defineProperty(target, prop, {
                configurable: true,
                enumerable: false,
                get: function() {
                    return undefined;
                },
                set: function(value) {
                    addHiddenProp(this, prop, action(name, value));
                }
            });
        };
    }
    function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
        if (applyToInstance === true) {
            defineBoundAction(target, propertyName, descriptor.value);
            return null;
        }
        if (descriptor) return {
            configurable: true,
            enumerable: false,
            get: function() {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
        return {
            enumerable: false,
            configurable: true,
            set: function(v) {
                defineBoundAction(this, propertyName, v);
            },
            get: function() {
                return undefined;
            }
        };
    }
    var action = function action(arg1, arg2, arg3, arg4) {
        if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1);
        if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2);
        if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1);
        if (arg4 === true) arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
        else return namedActionDecorator(arg2).apply(null, arguments);
    };
    action.bound = boundActionDecorator;
    function runInAction(arg1, arg2) {
        var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
        var fn = typeof arg1 === "function" ? arg1 : arg2;
        return executeAction(actionName, fn, this, undefined);
    }
    function isAction(thing) {
        return typeof thing === "function" && thing.isMobxAction === true;
    }
    function defineBoundAction(target, propertyName, fn) {
        addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
    }
    function autorun(view, opts) {
        if (opts === void 0) opts = EMPTY_OBJECT;
        var name = opts && opts.name || view.name || "Autorun@" + getNextId();
        var runSync = !opts.scheduler && !opts.delay;
        var reaction;
        if (runSync) reaction = new Reaction(name, function() {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
        else {
            var scheduler_1 = createSchedulerFromOptions(opts);
            var isScheduled_1 = false;
            reaction = new Reaction(name, function() {
                if (!isScheduled_1) {
                    isScheduled_1 = true;
                    scheduler_1(function() {
                        isScheduled_1 = false;
                        if (!reaction.isDisposed) reaction.track(reactionRunner);
                    });
                }
            }, opts.onError, opts.requiresObservable);
        }
        function reactionRunner() {
            view(reaction);
        }
        reaction.schedule();
        return reaction.getDisposer();
    }
    var run = function(f) {
        return f();
    };
    function createSchedulerFromOptions(opts) {
        return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
            return setTimeout(f, opts.delay);
        } : run;
    }
    function reaction(expression, effect, opts) {
        if (opts === void 0) opts = EMPTY_OBJECT;
        if (typeof opts === "boolean") {
            opts = {
                fireImmediately: opts
            };
            deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
        }
        var name = opts.name || "Reaction@" + getNextId();
        var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
        var runSync = !opts.scheduler && !opts.delay;
        var scheduler = createSchedulerFromOptions(opts);
        var firstTime = true;
        var isScheduled = false;
        var value;
        var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
        var r = new Reaction(name, function() {
            if (firstTime || runSync) reactionRunner();
            else if (!isScheduled) {
                isScheduled = true;
                scheduler(reactionRunner);
            }
        }, opts.onError, opts.requiresObservable);
        function reactionRunner() {
            isScheduled = false;
            if (r.isDisposed) return;
            var changed = false;
            r.track(function() {
                var nextValue = expression(r);
                changed = firstTime || !equals(value, nextValue);
                value = nextValue;
            });
            if (firstTime && opts.fireImmediately) effectAction(value, r);
            if (!firstTime && changed === true) effectAction(value, r);
            if (firstTime) firstTime = false;
        }
        r.schedule();
        return r.getDisposer();
    }
    function wrapErrorHandler(errorHandler, baseFn) {
        return function() {
            try {
                return baseFn.apply(this, arguments);
            } catch (e) {
                errorHandler.call(this, e);
            }
        };
    }
    function onBecomeObserved(thing, arg2, arg3) {
        return interceptHook("onBecomeObserved", thing, arg2, arg3);
    }
    function onBecomeUnobserved(thing, arg2, arg3) {
        return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
    }
    function interceptHook(hook, thing, arg2, arg3) {
        var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
        var cb = typeof arg3 === "function" ? arg3 : arg2;
        var orig = atom[hook];
        if (typeof orig !== "function") return fail(false);
        atom[hook] = function() {
            orig.call(this);
            cb.call(this);
        };
        return function() {
            atom[hook] = orig;
        };
    }
    function configure(options) {
        var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
        if (options.isolateGlobalState === true) isolateGlobalState();
        if (enforceActions !== undefined) {
            if (typeof enforceActions === "boolean" || enforceActions === "strict") deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
            var ea = void 0;
            switch(enforceActions){
                case true:
                case "observed":
                    ea = true;
                    break;
                case false:
                case "never":
                    ea = false;
                    break;
                case "strict":
                case "always":
                    ea = "strict";
                    break;
                default:
                    fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
            }
            globalState.enforceActions = ea;
            globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
        }
        if (computedRequiresReaction !== undefined) globalState.computedRequiresReaction = !!computedRequiresReaction;
        if (reactionRequiresObservable !== undefined) globalState.reactionRequiresObservable = !!reactionRequiresObservable;
        if (observableRequiresReaction !== undefined) {
            globalState.observableRequiresReaction = !!observableRequiresReaction;
            globalState.allowStateReads = !globalState.observableRequiresReaction;
        }
        if (computedConfigurable !== undefined) globalState.computedConfigurable = !!computedConfigurable;
        if (disableErrorBoundaries !== undefined) {
            if (disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
            globalState.disableErrorBoundaries = !!disableErrorBoundaries;
        }
        if (typeof arrayBuffer === "number") reserveArrayBuffer(arrayBuffer);
        if (reactionScheduler) setReactionScheduler(reactionScheduler);
    }
    function decorate(thing, decorators) {
        var target = typeof thing === "function" ? thing.prototype : thing;
        var _loop_1 = function(prop) {
            var propertyDecorators = decorators[prop];
            if (!Array.isArray(propertyDecorators)) propertyDecorators = [
                propertyDecorators
            ];
            var descriptor = Object.getOwnPropertyDescriptor(target, prop);
            var newDescriptor = propertyDecorators.reduce(function(accDescriptor, decorator) {
                return decorator(target, prop, accDescriptor);
            }, descriptor);
            if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
        };
        for(var prop in decorators)_loop_1(prop);
        return thing;
    }
    function extendShallowObservable(target, properties, decorators) {
        deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
        return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
    }
    function extendObservable(target, properties, decorators, options) {
        var key;
        options = asCreateObservableOptions(options);
        var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
        initializeInstance(target);
        asObservableObject(target, options.name, defaultDecorator.enhancer);
        startBatch();
        try {
            var keys = Object.getOwnPropertyNames(properties);
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i];
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor) Object.defineProperty(target, key, resultDescriptor);
            }
        } finally{
            endBatch();
        }
        return target;
    }
    function getDependencyTree(thing, property) {
        return nodeToDependencyTree(getAtom(thing, property));
    }
    function nodeToDependencyTree(node) {
        var result = {
            name: node.name
        };
        if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
        return result;
    }
    function getObserverTree(thing, property) {
        return nodeToObserverTree(getAtom(thing, property));
    }
    function nodeToObserverTree(node) {
        var result = {
            name: node.name
        };
        if (hasObservers(node)) result.observers = getObservers(node).map(nodeToObserverTree);
        return result;
    }
    var generatorId = 0;
    function FlowCancellationError() {
        this.message = "FLOW_CANCELLED";
    }
    FlowCancellationError.prototype = Object.create(Error.prototype);
    function isFlowCancellationError(error) {
        return error instanceof FlowCancellationError;
    }
    function flow(generator) {
        if (arguments.length !== 1) fail("Flow expects one 1 argument and cannot be used as decorator");
        var name = generator.name || "<unnamed flow>";
        return function() {
            var ctx = this;
            var args = arguments;
            var runId = ++generatorId;
            var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
            var rejector;
            var pendingPromise = undefined;
            var res = new Promise(function(resolve, reject) {
                var stepId = 0;
                rejector = reject;
                function onFulfilled(res) {
                    pendingPromise = undefined;
                    var ret;
                    try {
                        ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                    } catch (e) {
                        return reject(e);
                    }
                    next(ret);
                }
                function onRejected(err) {
                    pendingPromise = undefined;
                    var ret;
                    try {
                        ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                    } catch (e) {
                        return reject(e);
                    }
                    next(ret);
                }
                function next(ret) {
                    if (ret && typeof ret.then === "function") {
                        ret.then(next, reject);
                        return;
                    }
                    if (ret.done) return resolve(ret.value);
                    pendingPromise = Promise.resolve(ret.value);
                    return pendingPromise.then(onFulfilled, onRejected);
                }
                onFulfilled(undefined);
            });
            res.cancel = action(name + " - runid: " + runId + " - cancel", function() {
                try {
                    if (pendingPromise) cancelPromise(pendingPromise);
                    var res_1 = gen.return(undefined);
                    var yieldedPromise = Promise.resolve(res_1.value);
                    yieldedPromise.then(noop, noop);
                    cancelPromise(yieldedPromise);
                    rejector(new FlowCancellationError());
                } catch (e) {
                    rejector(e);
                }
            });
            return res;
        };
    }
    function cancelPromise(promise) {
        if (typeof promise.cancel === "function") promise.cancel();
    }
    function interceptReads(thing, propOrHandler, handler) {
        var target;
        if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
        else if (isObservableObject(thing)) {
            if (typeof propOrHandler !== "string") return fail(false);
            target = getAdministration(thing, propOrHandler);
        } else return fail(false);
        if (target.dehancer !== undefined) return fail(false);
        target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
        return function() {
            target.dehancer = undefined;
        };
    }
    function intercept(thing, propOrHandler, handler) {
        if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);
        else return interceptInterceptable(thing, propOrHandler);
    }
    function interceptInterceptable(thing, handler) {
        return getAdministration(thing).intercept(handler);
    }
    function interceptProperty(thing, property, handler) {
        return getAdministration(thing, property).intercept(handler);
    }
    function _isComputed(value, property) {
        if (value === null || value === undefined) return false;
        if (property !== undefined) {
            if (isObservableObject(value) === false) return false;
            if (!value.$mobx.values[property]) return false;
            var atom = getAtom(value, property);
            return isComputedValue(atom);
        }
        return isComputedValue(value);
    }
    function isComputed(value) {
        if (arguments.length > 1) return fail(false);
        return _isComputed(value);
    }
    function isComputedProp(value, propName) {
        if (typeof propName !== "string") return fail(false);
        return _isComputed(value, propName);
    }
    function _isObservable(value, property) {
        if (value === null || value === undefined) return false;
        if (property !== undefined) {
            if (isObservableObject(value)) {
                var o = value.$mobx;
                return o.values && !!o.values[property];
            }
            return false;
        }
        return isObservableObject(value) || !!value.$mobx || isAtom(value) || isReaction(value) || isComputedValue(value);
    }
    function isObservable(value) {
        if (arguments.length !== 1) fail(false);
        return _isObservable(value);
    }
    function isObservableProp(value, propName) {
        if (typeof propName !== "string") return fail(false);
        return _isObservable(value, propName);
    }
    function keys(obj) {
        if (isObservableObject(obj)) return obj.$mobx.getKeys();
        if (isObservableMap(obj)) return iteratorToArray(obj.keys());
        if (isObservableSet(obj)) return iteratorToArray(obj.keys());
        if (isObservableArray(obj)) return obj.map(function(_, index) {
            return index;
        });
        return fail(false);
    }
    function values(obj) {
        if (isObservableObject(obj)) return keys(obj).map(function(key) {
            return obj[key];
        });
        if (isObservableMap(obj)) return keys(obj).map(function(key) {
            return obj.get(key);
        });
        if (isObservableSet(obj)) return iteratorToArray(obj.values());
        if (isObservableArray(obj)) return obj.slice();
        return fail(false);
    }
    function entries(obj) {
        if (isObservableObject(obj)) return keys(obj).map(function(key) {
            return [
                key,
                obj[key]
            ];
        });
        if (isObservableMap(obj)) return keys(obj).map(function(key) {
            return [
                key,
                obj.get(key)
            ];
        });
        if (isObservableSet(obj)) return iteratorToArray(obj.entries());
        if (isObservableArray(obj)) return obj.map(function(key, index) {
            return [
                index,
                key
            ];
        });
        return fail(false);
    }
    function set(obj, key, value) {
        if (arguments.length === 2 && !isObservableSet(obj)) {
            startBatch();
            var values_1 = key;
            try {
                for(var key_1 in values_1)set(obj, key_1, values_1[key_1]);
            } finally{
                endBatch();
            }
            return;
        }
        if (isObservableObject(obj)) {
            var adm = obj.$mobx;
            var existingObservable = adm.values[key];
            if (existingObservable) adm.write(obj, key, value);
            else defineObservableProperty(obj, key, value, adm.defaultEnhancer);
        } else if (isObservableMap(obj)) obj.set(key, value);
        else if (isObservableSet(obj)) obj.add(key);
        else if (isObservableArray(obj)) {
            if (typeof key !== "number") key = parseInt(key, 10);
            invariant(key >= 0, "Not a valid index: '" + key + "'");
            startBatch();
            if (key >= obj.length) obj.length = key + 1;
            obj[key] = value;
            endBatch();
        } else return fail(false);
    }
    function remove(obj, key) {
        if (isObservableObject(obj)) obj.$mobx.remove(key);
        else if (isObservableMap(obj)) obj.delete(key);
        else if (isObservableSet(obj)) obj.delete(key);
        else if (isObservableArray(obj)) {
            if (typeof key !== "number") key = parseInt(key, 10);
            invariant(key >= 0, "Not a valid index: '" + key + "'");
            obj.splice(key, 1);
        } else return fail(false);
    }
    function has(obj, key) {
        if (isObservableObject(obj)) {
            var adm = getAdministration(obj);
            adm.getKeys();
            return !!adm.values[key];
        } else if (isObservableMap(obj)) return obj.has(key);
        else if (isObservableSet(obj)) return obj.has(key);
        else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
        else return fail(false);
    }
    function get(obj, key) {
        if (!has(obj, key)) return undefined;
        if (isObservableObject(obj)) return obj[key];
        else if (isObservableMap(obj)) return obj.get(key);
        else if (isObservableArray(obj)) return obj[key];
        else return fail(false);
    }
    function observe(thing, propOrCb, cbOrFire, fireImmediately) {
        if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
        else return observeObservable(thing, propOrCb, cbOrFire);
    }
    function observeObservable(thing, listener, fireImmediately) {
        return getAdministration(thing).observe(listener, fireImmediately);
    }
    function observeObservableProperty(thing, property, listener, fireImmediately) {
        return getAdministration(thing, property).observe(listener, fireImmediately);
    }
    var defaultOptions = {
        detectCycles: true,
        exportMapsAsObjects: true,
        recurseEverything: false
    };
    function cache(map, key, value, options) {
        if (options.detectCycles) map.set(key, value);
        return value;
    }
    function toJSHelper(source, options, __alreadySeen) {
        if (!options.recurseEverything && !isObservable(source)) return source;
        if (typeof source !== "object") return source;
        if (source === null) return null;
        if (source instanceof Date) return source;
        if (isObservableValue(source)) return toJSHelper(source.get(), options, __alreadySeen);
        if (isObservable(source)) keys(source);
        var detectCycles = options.detectCycles === true;
        if (detectCycles && source !== null && __alreadySeen.has(source)) return __alreadySeen.get(source);
        if (isObservableArray(source) || Array.isArray(source)) {
            var res_1 = cache(__alreadySeen, source, [], options);
            var toAdd = source.map(function(value) {
                return toJSHelper(value, options, __alreadySeen);
            });
            res_1.length = toAdd.length;
            for(var i = 0, l = toAdd.length; i < l; i++)res_1[i] = toAdd[i];
            return res_1;
        }
        if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
            if (options.exportMapsAsObjects === false) {
                var res_2 = cache(__alreadySeen, source, new Set(), options);
                source.forEach(function(value) {
                    res_2.add(toJSHelper(value, options, __alreadySeen));
                });
                return res_2;
            } else {
                var res_3 = cache(__alreadySeen, source, [], options);
                source.forEach(function(value) {
                    res_3.push(toJSHelper(value, options, __alreadySeen));
                });
                return res_3;
            }
        }
        if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
            if (options.exportMapsAsObjects === false) {
                var res_4 = cache(__alreadySeen, source, new Map(), options);
                source.forEach(function(value, key) {
                    res_4.set(key, toJSHelper(value, options, __alreadySeen));
                });
                return res_4;
            } else {
                var res_5 = cache(__alreadySeen, source, {}, options);
                source.forEach(function(value, key) {
                    res_5[key] = toJSHelper(value, options, __alreadySeen);
                });
                return res_5;
            }
        }
        var res = cache(__alreadySeen, source, {}, options);
        for(var key in source)res[key] = toJSHelper(source[key], options, __alreadySeen);
        return res;
    }
    function toJS(source, options) {
        if (typeof options === "boolean") options = {
            detectCycles: options
        };
        if (!options) options = defaultOptions;
        options.detectCycles = options.detectCycles === undefined ? options.recurseEverything === true : options.detectCycles === true;
        var __alreadySeen;
        if (options.detectCycles) __alreadySeen = new Map();
        return toJSHelper(source, options, __alreadySeen);
    }
    function trace() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var enterBreakPoint = false;
        if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
        var derivation = getAtomFromArgs(args);
        if (!derivation) return fail(false);
        if (derivation.isTracing === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
        derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
    }
    function getAtomFromArgs(args) {
        switch(args.length){
            case 0:
                return globalState.trackingDerivation;
            case 1:
                return getAtom(args[0]);
            case 2:
                return getAtom(args[0], args[1]);
        }
    }
    function transaction(action, thisArg) {
        if (thisArg === void 0) thisArg = undefined;
        startBatch();
        try {
            return action.apply(thisArg);
        } finally{
            endBatch();
        }
    }
    function when(predicate, arg1, arg2) {
        if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
        return _when(predicate, arg1, arg2 || {});
    }
    function _when(predicate, effect, opts) {
        var timeoutHandle;
        if (typeof opts.timeout === "number") timeoutHandle = setTimeout(function() {
            if (!disposer.$mobx.isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
        opts.name = opts.name || "When@" + getNextId();
        var effectAction = createAction(opts.name + "-effect", effect);
        var disposer = autorun(function(r) {
            if (predicate()) {
                r.dispose();
                if (timeoutHandle) clearTimeout(timeoutHandle);
                effectAction();
            }
        }, opts);
        return disposer;
    }
    function whenPromise(predicate, opts) {
        var cancel;
        var res = new Promise(function(resolve, reject) {
            var disposer = _when(predicate, resolve, __assign(__assign({}, opts), {
                onError: reject
            }));
            cancel = function() {
                disposer();
                reject("WHEN_CANCELLED");
            };
        });
        res.cancel = cancel;
        return res;
    }
    function hasInterceptors(interceptable) {
        return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
    }
    function registerInterceptor(interceptable, handler) {
        var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
        interceptors.push(handler);
        return once(function() {
            var idx = interceptors.indexOf(handler);
            if (idx !== -1) interceptors.splice(idx, 1);
        });
    }
    function interceptChange(interceptable, change) {
        var prevU = untrackedStart();
        try {
            var interceptors = interceptable.interceptors;
            if (interceptors) for(var i = 0, l = interceptors.length; i < l; i++){
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change) break;
            }
            return change;
        } finally{
            untrackedEnd(prevU);
        }
    }
    function hasListeners(listenable) {
        return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
    }
    function registerListener(listenable, handler) {
        var listeners = listenable.changeListeners || (listenable.changeListeners = []);
        listeners.push(handler);
        return once(function() {
            var idx = listeners.indexOf(handler);
            if (idx !== -1) listeners.splice(idx, 1);
        });
    }
    function notifyListeners(listenable, change) {
        var prevU = untrackedStart();
        var listeners = listenable.changeListeners;
        if (!listeners) return;
        listeners = listeners.slice();
        for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
        untrackedEnd(prevU);
    }
    var MAX_SPLICE_SIZE = 10000;
    var safariPrototypeSetterInheritanceBug = function() {
        var v = false;
        var p = {};
        Object.defineProperty(p, "0", {
            set: function() {
                v = true;
            }
        });
        Object.create(p)["0"] = 1;
        return v === false;
    }();
    var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
    var StubArray = function() {
        function StubArray() {}
        return StubArray;
    }();
    function inherit(ctor, proto) {
        if (typeof Object["setPrototypeOf"] !== "undefined") Object["setPrototypeOf"](ctor.prototype, proto);
        else if (typeof ctor.prototype.__proto__ !== "undefined") ctor.prototype.__proto__ = proto;
        else ctor["prototype"] = proto;
    }
    inherit(StubArray, Array.prototype);
    if (Object.isFrozen(Array)) [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function(key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
    var ObservableArrayAdministration = function() {
        function ObservableArrayAdministration(name, enhancer, array, owned) {
            this.array = array;
            this.owned = owned;
            this.values = [];
            this.lastKnownLength = 0;
            this.atom = new Atom(name || "ObservableArray@" + getNextId());
            this.enhancer = function(newV, oldV) {
                return enhancer(newV, oldV, name + "[..]");
            };
        }
        ObservableArrayAdministration.prototype.dehanceValue = function(value) {
            if (this.dehancer !== undefined) return this.dehancer(value);
            return value;
        };
        ObservableArrayAdministration.prototype.dehanceValues = function(values) {
            if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
            return values;
        };
        ObservableArrayAdministration.prototype.intercept = function(handler) {
            return registerInterceptor(this, handler);
        };
        ObservableArrayAdministration.prototype.observe = function(listener, fireImmediately) {
            if (fireImmediately === void 0) fireImmediately = false;
            if (fireImmediately) listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
            return registerListener(this, listener);
        };
        ObservableArrayAdministration.prototype.getArrayLength = function() {
            this.atom.reportObserved();
            return this.values.length;
        };
        ObservableArrayAdministration.prototype.setArrayLength = function(newLength) {
            if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
            var currentLength = this.values.length;
            if (newLength === currentLength) return;
            else if (newLength > currentLength) {
                var newItems = new Array(newLength - currentLength);
                for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
                this.spliceWithArray(currentLength, 0, newItems);
            } else this.spliceWithArray(newLength, currentLength - newLength);
        };
        ObservableArrayAdministration.prototype.updateArrayLength = function(oldLength, delta) {
            if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
            this.lastKnownLength += delta;
            if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE) reserveArrayBuffer(oldLength + delta + 1);
        };
        ObservableArrayAdministration.prototype.spliceWithArray = function(index, deleteCount, newItems) {
            var _this = this;
            checkIfStateModificationsAreAllowed(this.atom);
            var length = this.values.length;
            if (index === undefined) index = 0;
            else if (index > length) index = length;
            else if (index < 0) index = Math.max(0, length + index);
            if (arguments.length === 1) deleteCount = length - index;
            else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
            else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
            if (newItems === undefined) newItems = EMPTY_ARRAY;
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.array,
                    type: "splice",
                    index: index,
                    removedCount: deleteCount,
                    added: newItems
                });
                if (!change) return EMPTY_ARRAY;
                deleteCount = change.removedCount;
                newItems = change.added;
            }
            newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
                return _this.enhancer(v, undefined);
            });
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength(length, lengthDelta);
            var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
            if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
            return this.dehanceValues(res);
        };
        ObservableArrayAdministration.prototype.spliceItemsIntoValues = function(index, deleteCount, newItems) {
            var _a;
            if (newItems.length < MAX_SPLICE_SIZE) return (_a = this.values).splice.apply(_a, __spread([
                index,
                deleteCount
            ], newItems));
            else {
                var res = this.values.slice(index, index + deleteCount);
                this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
                return res;
            }
        };
        ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function(index, newValue, oldValue) {
            var notifySpy = !this.owned && isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.atom.name
            }));
            this.atom.reportChanged();
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        };
        ObservableArrayAdministration.prototype.notifyArraySplice = function(index, added, removed) {
            var notifySpy = !this.owned && isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.atom.name
            }));
            this.atom.reportChanged();
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        };
        return ObservableArrayAdministration;
    }();
    var ObservableArray = function(_super) {
        __extends(ObservableArray, _super);
        function ObservableArray(initialValues, enhancer, name, owned) {
            if (name === void 0) name = "ObservableArray@" + getNextId();
            if (owned === void 0) owned = false;
            var _this = _super.call(this) || this;
            var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
            addHiddenFinalProp(_this, "$mobx", adm);
            if (initialValues && initialValues.length) {
                var prev = allowStateChangesStart(true);
                _this.spliceWithArray(0, 0, initialValues);
                allowStateChangesEnd(prev);
            }
            if (safariPrototypeSetterInheritanceBug) Object.defineProperty(adm.array, "0", ENTRY_0);
            return _this;
        }
        ObservableArray.prototype.intercept = function(handler) {
            return this.$mobx.intercept(handler);
        };
        ObservableArray.prototype.observe = function(listener, fireImmediately) {
            if (fireImmediately === void 0) fireImmediately = false;
            return this.$mobx.observe(listener, fireImmediately);
        };
        ObservableArray.prototype.clear = function() {
            return this.splice(0);
        };
        ObservableArray.prototype.concat = function() {
            var arrays = [];
            for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
            this.$mobx.atom.reportObserved();
            return Array.prototype.concat.apply(this.peek(), arrays.map(function(a) {
                return isObservableArray(a) ? a.peek() : a;
            }));
        };
        ObservableArray.prototype.replace = function(newItems) {
            return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
        };
        ObservableArray.prototype.toJS = function() {
            return this.slice();
        };
        ObservableArray.prototype.toJSON = function() {
            return this.toJS();
        };
        ObservableArray.prototype.peek = function() {
            this.$mobx.atom.reportObserved();
            return this.$mobx.dehanceValues(this.$mobx.values);
        };
        ObservableArray.prototype.find = function(predicate, thisArg, fromIndex) {
            if (fromIndex === void 0) fromIndex = 0;
            if (arguments.length === 3) deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
            var idx = this.findIndex.apply(this, arguments);
            return idx === -1 ? undefined : this.get(idx);
        };
        ObservableArray.prototype.findIndex = function(predicate, thisArg, fromIndex) {
            if (fromIndex === void 0) fromIndex = 0;
            if (arguments.length === 3) deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
            var items = this.peek(), l = items.length;
            for(var i = fromIndex; i < l; i++)if (predicate.call(thisArg, items[i], i, this)) return i;
            return -1;
        };
        ObservableArray.prototype.splice = function(index, deleteCount) {
            var newItems = [];
            for(var _i = 2; _i < arguments.length; _i++)newItems[_i - 2] = arguments[_i];
            switch(arguments.length){
                case 0:
                    return [];
                case 1:
                    return this.$mobx.spliceWithArray(index);
                case 2:
                    return this.$mobx.spliceWithArray(index, deleteCount);
            }
            return this.$mobx.spliceWithArray(index, deleteCount, newItems);
        };
        ObservableArray.prototype.spliceWithArray = function(index, deleteCount, newItems) {
            return this.$mobx.spliceWithArray(index, deleteCount, newItems);
        };
        ObservableArray.prototype.push = function() {
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            var adm = this.$mobx;
            adm.spliceWithArray(adm.values.length, 0, items);
            return adm.values.length;
        };
        ObservableArray.prototype.pop = function() {
            return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
        };
        ObservableArray.prototype.shift = function() {
            return this.splice(0, 1)[0];
        };
        ObservableArray.prototype.unshift = function() {
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            var adm = this.$mobx;
            adm.spliceWithArray(0, 0, items);
            return adm.values.length;
        };
        ObservableArray.prototype.reverse = function() {
            var clone = this.slice();
            return clone.reverse.apply(clone, arguments);
        };
        ObservableArray.prototype.sort = function(compareFn) {
            var clone = this.slice();
            return clone.sort.apply(clone, arguments);
        };
        ObservableArray.prototype.remove = function(value) {
            var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
            if (idx > -1) {
                this.splice(idx, 1);
                return true;
            }
            return false;
        };
        ObservableArray.prototype.move = function(fromIndex, toIndex) {
            deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
            function checkIndex(index) {
                if (index < 0) throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
                var length = this.$mobx.values.length;
                if (index >= length) throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
            checkIndex.call(this, fromIndex);
            checkIndex.call(this, toIndex);
            if (fromIndex === toIndex) return;
            var oldItems = this.$mobx.values;
            var newItems;
            if (fromIndex < toIndex) newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
            else newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
            this.replace(newItems);
        };
        ObservableArray.prototype.get = function(index) {
            var impl = this.$mobx;
            if (impl) {
                if (index < impl.values.length) {
                    impl.atom.reportObserved();
                    return impl.dehanceValue(impl.values[index]);
                }
                console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
            }
            return undefined;
        };
        ObservableArray.prototype.set = function(index, newValue) {
            var adm = this.$mobx;
            var values = adm.values;
            if (index < values.length) {
                checkIfStateModificationsAreAllowed(adm.atom);
                var oldValue = values[index];
                if (hasInterceptors(adm)) {
                    var change = interceptChange(adm, {
                        type: "update",
                        object: this,
                        index: index,
                        newValue: newValue
                    });
                    if (!change) return;
                    newValue = change.newValue;
                }
                newValue = adm.enhancer(newValue, oldValue);
                var changed = newValue !== oldValue;
                if (changed) {
                    values[index] = newValue;
                    adm.notifyArrayChildUpdate(index, newValue, oldValue);
                }
            } else if (index === values.length) adm.spliceWithArray(index, 0, [
                newValue
            ]);
            else throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        };
        return ObservableArray;
    }(StubArray);
    declareIterator(ObservableArray.prototype, function() {
        this.$mobx.atom.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    });
    Object.defineProperty(ObservableArray.prototype, "length", {
        enumerable: false,
        configurable: true,
        get: function() {
            return this.$mobx.getArrayLength();
        },
        set: function(newLength) {
            this.$mobx.setArrayLength(newLength);
        }
    });
    addHiddenProp(ObservableArray.prototype, toStringTagSymbol(), "Array");
    [
        "indexOf",
        "join",
        "lastIndexOf",
        "slice",
        "toString",
        "toLocaleString"
    ].forEach(function(funcName) {
        var baseFunc = Array.prototype[funcName];
        invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
        addHiddenProp(ObservableArray.prototype, funcName, function() {
            return baseFunc.apply(this.peek(), arguments);
        });
    });
    [
        "every",
        "filter",
        "forEach",
        "map",
        "some"
    ].forEach(function(funcName) {
        var baseFunc = Array.prototype[funcName];
        invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
        addHiddenProp(ObservableArray.prototype, funcName, function(callback, thisArg) {
            var _this = this;
            var adm = this.$mobx;
            adm.atom.reportObserved();
            var dehancedValues = adm.dehanceValues(adm.values);
            return dehancedValues[funcName](function(element, index) {
                return callback.call(thisArg, element, index, _this);
            }, thisArg);
        });
    });
    [
        "reduce",
        "reduceRight"
    ].forEach(function(funcName) {
        addHiddenProp(ObservableArray.prototype, funcName, function() {
            var _this = this;
            var adm = this.$mobx;
            adm.atom.reportObserved();
            var callback = arguments[0];
            arguments[0] = function(accumulator, currentValue, index) {
                currentValue = adm.dehanceValue(currentValue);
                return callback(accumulator, currentValue, index, _this);
            };
            return adm.values[funcName].apply(adm.values, arguments);
        });
    });
    makeNonEnumerable(ObservableArray.prototype, [
        "constructor",
        "intercept",
        "observe",
        "clear",
        "concat",
        "get",
        "replace",
        "toJS",
        "toJSON",
        "peek",
        "find",
        "findIndex",
        "splice",
        "spliceWithArray",
        "push",
        "pop",
        "set",
        "shift",
        "unshift",
        "reverse",
        "sort",
        "remove",
        "move",
        "toString",
        "toLocaleString"
    ]);
    var ENTRY_0 = createArrayEntryDescriptor(0);
    function createArrayEntryDescriptor(index) {
        return {
            enumerable: false,
            configurable: false,
            get: function() {
                return this.get(index);
            },
            set: function(value) {
                this.set(index, value);
            }
        };
    }
    function createArrayBufferItem(index) {
        Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
    }
    function reserveArrayBuffer(max) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
    reserveArrayBuffer(1000);
    var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
    function isObservableArray(thing) {
        return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
    }
    var ObservableMapMarker = {};
    var ObservableMap = function() {
        function ObservableMap(initialData, enhancer, name) {
            if (enhancer === void 0) enhancer = deepEnhancer;
            if (name === void 0) name = "ObservableMap@" + getNextId();
            this.enhancer = enhancer;
            this.name = name;
            this.$mobx = ObservableMapMarker;
            this._keysAtom = createAtom(this.name + ".keys()");
            if (typeof Map !== "function") throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
            this._data = new Map();
            this._hasMap = new Map();
            this.merge(initialData);
        }
        ObservableMap.prototype._has = function(key) {
            return this._data.has(key);
        };
        ObservableMap.prototype.has = function(key) {
            var _this = this;
            if (!globalState.trackingDerivation) return this._has(key);
            var entry = this._hasMap.get(key);
            if (!entry) {
                var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
                this._hasMap.set(key, newEntry);
                onBecomeUnobserved(newEntry, function() {
                    return _this._hasMap.delete(key);
                });
            }
            return entry.get();
        };
        ObservableMap.prototype.set = function(key, value) {
            var hasKey = this._has(key);
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: hasKey ? "update" : "add",
                    object: this,
                    newValue: value,
                    name: key
                });
                if (!change) return this;
                value = change.newValue;
            }
            if (hasKey) this._updateValue(key, value);
            else this._addValue(key, value);
            return this;
        };
        ObservableMap.prototype.delete = function(key) {
            var _this = this;
            checkIfStateModificationsAreAllowed(this._keysAtom);
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: "delete",
                    object: this,
                    name: key
                });
                if (!change) return false;
            }
            if (this._has(key)) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                } : null;
                if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                    name: this.name,
                    key: key
                }));
                transaction(function() {
                    _this._keysAtom.reportChanged();
                    _this._updateHasMapEntry(key, false);
                    var observable = _this._data.get(key);
                    observable.setNewValue(undefined);
                    _this._data.delete(key);
                });
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
                return true;
            }
            return false;
        };
        ObservableMap.prototype._updateHasMapEntry = function(key, value) {
            var entry = this._hasMap.get(key);
            if (entry) entry.setNewValue(value);
        };
        ObservableMap.prototype._updateValue = function(key, newValue) {
            var observable = this._data.get(key);
            newValue = observable.prepareNewValue(newValue);
            if (newValue !== globalState.UNCHANGED) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                } : null;
                if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                    name: this.name,
                    key: key
                }));
                observable.setNewValue(newValue);
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
            }
        };
        ObservableMap.prototype._addValue = function(key, newValue) {
            var _this = this;
            checkIfStateModificationsAreAllowed(this._keysAtom);
            transaction(function() {
                var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
                _this._data.set(key, observable);
                newValue = observable.value;
                _this._updateHasMapEntry(key, true);
                _this._keysAtom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.name,
                key: key
            }));
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        };
        ObservableMap.prototype.get = function(key) {
            if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
            return this.dehanceValue(undefined);
        };
        ObservableMap.prototype.dehanceValue = function(value) {
            if (this.dehancer !== undefined) return this.dehancer(value);
            return value;
        };
        ObservableMap.prototype.keys = function() {
            this._keysAtom.reportObserved();
            return this._data.keys();
        };
        ObservableMap.prototype.values = function() {
            var self1 = this;
            var keys = this.keys();
            return makeIterable({
                next: function() {
                    var _a = keys.next(), done = _a.done, value = _a.value;
                    return {
                        done: done,
                        value: done ? undefined : self1.get(value)
                    };
                }
            });
        };
        ObservableMap.prototype.entries = function() {
            var self1 = this;
            var keys = this.keys();
            return makeIterable({
                next: function() {
                    var _a = keys.next(), done = _a.done, value = _a.value;
                    return {
                        done: done,
                        value: done ? undefined : [
                            value,
                            self1.get(value)
                        ]
                    };
                }
            });
        };
        ObservableMap.prototype.forEach = function(callback, thisArg) {
            var _this = this;
            this._keysAtom.reportObserved();
            this._data.forEach(function(_, key) {
                return callback.call(thisArg, _this.get(key), key, _this);
            });
        };
        ObservableMap.prototype.merge = function(other) {
            var _this = this;
            if (isObservableMap(other)) other = other.toJS();
            transaction(function() {
                var prev = allowStateChangesStart(true);
                try {
                    if (isPlainObject(other)) Object.keys(other).forEach(function(key) {
                        return _this.set(key, other[key]);
                    });
                    else if (Array.isArray(other)) other.forEach(function(_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return _this.set(key, value);
                    });
                    else if (isES6Map(other)) {
                        if (other.constructor !== Map) fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name);
                        else other.forEach(function(value, key) {
                            return _this.set(key, value);
                        });
                    } else if (other !== null && other !== undefined) fail("Cannot initialize map from " + other);
                } finally{
                    allowStateChangesEnd(prev);
                }
            });
            return this;
        };
        ObservableMap.prototype.clear = function() {
            var _this = this;
            transaction(function() {
                untracked(function() {
                    _this._data.forEach(function(_, key) {
                        return _this.delete(key);
                    });
                });
            });
        };
        ObservableMap.prototype.replace = function(values) {
            var _this = this;
            transaction(function() {
                var replacementMap = convertToMap(values);
                var orderedData = new Map();
                var keysReportChangedCalled = false;
                forOf(_this._data.keys(), function(key) {
                    if (!replacementMap.has(key)) {
                        var deleted = _this.delete(key);
                        if (deleted) keysReportChangedCalled = true;
                        else {
                            var value = _this._data.get(key);
                            orderedData.set(key, value);
                        }
                    }
                });
                forOf(replacementMap.entries(), function(_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    var keyExisted = _this._data.has(key);
                    _this.set(key, value);
                    if (_this._data.has(key)) {
                        var value_1 = _this._data.get(key);
                        orderedData.set(key, value_1);
                        if (!keyExisted) keysReportChangedCalled = true;
                    }
                });
                if (!keysReportChangedCalled) {
                    if (_this._data.size !== orderedData.size) _this._keysAtom.reportChanged();
                    else {
                        var iter1 = _this._data.keys();
                        var iter2 = orderedData.keys();
                        var next1 = iter1.next();
                        var next2 = iter2.next();
                        while(!next1.done){
                            if (next1.value !== next2.value) {
                                _this._keysAtom.reportChanged();
                                break;
                            }
                            next1 = iter1.next();
                            next2 = iter2.next();
                        }
                    }
                }
                _this._data = orderedData;
            });
            return this;
        };
        Object.defineProperty(ObservableMap.prototype, "size", {
            get: function() {
                this._keysAtom.reportObserved();
                return this._data.size;
            },
            enumerable: true,
            configurable: true
        });
        ObservableMap.prototype.toPOJO = function() {
            var _this = this;
            var res = {};
            this.forEach(function(_, key) {
                return res[typeof key === "symbol" ? key : stringifyKey(key)] = _this.get(key);
            });
            return res;
        };
        ObservableMap.prototype.toJS = function() {
            return new Map(this);
        };
        ObservableMap.prototype.toJSON = function() {
            return this.toPOJO();
        };
        ObservableMap.prototype.toString = function() {
            var _this = this;
            return this.name + "[{ " + iteratorToArray(this.keys()).map(function(key) {
                return stringifyKey(key) + ": " + ("" + _this.get(key));
            }).join(", ") + " }]";
        };
        ObservableMap.prototype.observe = function(listener, fireImmediately) {
            return registerListener(this, listener);
        };
        ObservableMap.prototype.intercept = function(handler) {
            return registerInterceptor(this, handler);
        };
        return ObservableMap;
    }();
    function stringifyKey(key) {
        if (key && key.toString) return key.toString();
        else return new String(key).toString();
    }
    declareIterator(ObservableMap.prototype, function() {
        return this.entries();
    });
    addHiddenFinalProp(ObservableMap.prototype, toStringTagSymbol(), "Map");
    var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
    var ObservableSetMarker = {};
    var ObservableSet = function() {
        function ObservableSet(initialData, enhancer, name) {
            if (enhancer === void 0) enhancer = deepEnhancer;
            if (name === void 0) name = "ObservableSet@" + getNextId();
            this.name = name;
            this.$mobx = ObservableSetMarker;
            this._data = new Set();
            this._atom = createAtom(this.name);
            if (typeof Set !== "function") throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
            this.enhancer = function(newV, oldV) {
                return enhancer(newV, oldV, name);
            };
            if (initialData) this.replace(initialData);
        }
        ObservableSet.prototype.dehanceValue = function(value) {
            if (this.dehancer !== undefined) return this.dehancer(value);
            return value;
        };
        ObservableSet.prototype.clear = function() {
            var _this = this;
            transaction(function() {
                untracked(function() {
                    _this._data.forEach(function(value) {
                        _this.delete(value);
                    });
                });
            });
        };
        ObservableSet.prototype.forEach = function(callbackFn, thisArg) {
            var _this = this;
            this._atom.reportObserved();
            this._data.forEach(function(value) {
                callbackFn.call(thisArg, value, value, _this);
            });
        };
        Object.defineProperty(ObservableSet.prototype, "size", {
            get: function() {
                this._atom.reportObserved();
                return this._data.size;
            },
            enumerable: true,
            configurable: true
        });
        ObservableSet.prototype.add = function(value) {
            var _this = this;
            checkIfStateModificationsAreAllowed(this._atom);
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: "add",
                    object: this,
                    newValue: value
                });
                if (!change) return this;
            }
            if (!this.has(value)) {
                transaction(function() {
                    _this._data.add(_this.enhancer(value, undefined));
                    _this._atom.reportChanged();
                });
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                    type: "add",
                    object: this,
                    newValue: value
                } : null;
                if (notify) notifyListeners(this, change);
            }
            return this;
        };
        ObservableSet.prototype.delete = function(value) {
            var _this = this;
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: "delete",
                    object: this,
                    oldValue: value
                });
                if (!change) return false;
            }
            if (this.has(value)) {
                var notifySpy = isSpyEnabled();
                var notify = hasListeners(this);
                var change = notify || notifySpy ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                } : null;
                transaction(function() {
                    _this._atom.reportChanged();
                    _this._data.delete(value);
                });
                if (notify) notifyListeners(this, change);
                return true;
            }
            return false;
        };
        ObservableSet.prototype.has = function(value) {
            this._atom.reportObserved();
            return this._data.has(this.dehanceValue(value));
        };
        ObservableSet.prototype.entries = function() {
            var nextIndex = 0;
            var keys = iteratorToArray(this.keys());
            var values = iteratorToArray(this.values());
            return makeIterable({
                next: function() {
                    var index = nextIndex;
                    nextIndex += 1;
                    return index < values.length ? {
                        value: [
                            keys[index],
                            values[index]
                        ],
                        done: false
                    } : {
                        done: true
                    };
                }
            });
        };
        ObservableSet.prototype.keys = function() {
            return this.values();
        };
        ObservableSet.prototype.values = function() {
            this._atom.reportObserved();
            var self1 = this;
            var nextIndex = 0;
            var observableValues;
            if (this._data.values !== undefined) observableValues = iteratorToArray(this._data.values());
            else {
                observableValues = [];
                this._data.forEach(function(e) {
                    return observableValues.push(e);
                });
            }
            return makeIterable({
                next: function() {
                    return nextIndex < observableValues.length ? {
                        value: self1.dehanceValue(observableValues[nextIndex++]),
                        done: false
                    } : {
                        done: true
                    };
                }
            });
        };
        ObservableSet.prototype.replace = function(other) {
            var _this = this;
            if (isObservableSet(other)) other = other.toJS();
            transaction(function() {
                var prev = allowStateChangesStart(true);
                try {
                    if (Array.isArray(other)) {
                        _this.clear();
                        other.forEach(function(value) {
                            return _this.add(value);
                        });
                    } else if (isES6Set(other)) {
                        _this.clear();
                        other.forEach(function(value) {
                            return _this.add(value);
                        });
                    } else if (other !== null && other !== undefined) fail("Cannot initialize set from " + other);
                } finally{
                    allowStateChangesEnd(prev);
                }
            });
            return this;
        };
        ObservableSet.prototype.observe = function(listener, fireImmediately) {
            return registerListener(this, listener);
        };
        ObservableSet.prototype.intercept = function(handler) {
            return registerInterceptor(this, handler);
        };
        ObservableSet.prototype.toJS = function() {
            return new Set(this);
        };
        ObservableSet.prototype.toString = function() {
            return this.name + "[ " + iteratorToArray(this.keys()).join(", ") + " ]";
        };
        return ObservableSet;
    }();
    declareIterator(ObservableSet.prototype, function() {
        return this.values();
    });
    addHiddenFinalProp(ObservableSet.prototype, toStringTagSymbol(), "Set");
    var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);
    var ObservableObjectAdministration = function() {
        function ObservableObjectAdministration(target, name, defaultEnhancer) {
            this.target = target;
            this.name = name;
            this.defaultEnhancer = defaultEnhancer;
            this.values = {};
        }
        ObservableObjectAdministration.prototype.read = function(owner, key) {
            if (this.target !== owner) {
                this.illegalAccess(owner, key);
                if (!this.values[key]) return undefined;
            }
            return this.values[key].get();
        };
        ObservableObjectAdministration.prototype.write = function(owner, key, newValue) {
            var instance = this.target;
            if (instance !== owner) this.illegalAccess(owner, key);
            var observable = this.values[key];
            if (observable instanceof ComputedValue) {
                observable.set(newValue);
                return;
            }
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: "update",
                    object: instance,
                    name: key,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = observable.prepareNewValue(newValue);
            if (newValue !== globalState.UNCHANGED) {
                var notify = hasListeners(this);
                var notifySpy = isSpyEnabled();
                var change = notify || notifySpy ? {
                    type: "update",
                    object: instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                } : null;
                if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                    name: this.name,
                    key: key
                }));
                observable.setNewValue(newValue);
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
            }
        };
        ObservableObjectAdministration.prototype.remove = function(key) {
            if (!this.values[key]) return;
            var target = this.target;
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: target,
                    name: key,
                    type: "remove"
                });
                if (!change) return;
            }
            try {
                startBatch();
                var notify = hasListeners(this);
                var notifySpy = isSpyEnabled();
                var oldValue = this.values[key].get();
                if (this.keys) this.keys.remove(key);
                delete this.values[key];
                delete this.target[key];
                var change = notify || notifySpy ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                } : null;
                if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                    name: this.name,
                    key: key
                }));
                if (notify) notifyListeners(this, change);
                if (notifySpy) spyReportEnd();
            } finally{
                endBatch();
            }
        };
        ObservableObjectAdministration.prototype.illegalAccess = function(owner, propName) {
            console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
        };
        ObservableObjectAdministration.prototype.observe = function(callback, fireImmediately) {
            return registerListener(this, callback);
        };
        ObservableObjectAdministration.prototype.intercept = function(handler) {
            return registerInterceptor(this, handler);
        };
        ObservableObjectAdministration.prototype.getKeys = function() {
            var _this = this;
            if (this.keys === undefined) this.keys = new ObservableArray(Object.keys(this.values).filter(function(key) {
                return _this.values[key] instanceof ObservableValue;
            }), referenceEnhancer, "keys(" + this.name + ")", true);
            return this.keys.slice();
        };
        return ObservableObjectAdministration;
    }();
    function asObservableObject(target, name, defaultEnhancer) {
        if (name === void 0) name = "";
        if (defaultEnhancer === void 0) defaultEnhancer = deepEnhancer;
        var adm = target.$mobx;
        if (adm) return adm;
        if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
        if (!name) name = "ObservableObject@" + getNextId();
        adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
        addHiddenFinalProp(target, "$mobx", adm);
        return adm;
    }
    function defineObservableProperty(target, propName, newValue, enhancer) {
        var adm = asObservableObject(target);
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(adm)) {
            var change = interceptChange(adm, {
                object: target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        var observable = adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false);
        newValue = observable.value;
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        if (adm.keys) adm.keys.push(propName);
        notifyPropertyAddition(adm, target, propName, newValue);
    }
    function defineComputedProperty(target, propName, options) {
        var adm = asObservableObject(target);
        options.name = adm.name + "." + propName;
        options.context = target;
        adm.values[propName] = new ComputedValue(options);
        Object.defineProperty(target, propName, generateComputedPropConfig(propName));
    }
    var observablePropertyConfigs = Object.create(null);
    var computedPropertyConfigs = Object.create(null);
    function generateObservablePropConfig(propName) {
        return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function() {
                return this.$mobx.read(this, propName);
            },
            set: function(v) {
                this.$mobx.write(this, propName, v);
            }
        });
    }
    function getAdministrationForComputedPropOwner(owner) {
        var adm = owner.$mobx;
        if (!adm) {
            initializeInstance(owner);
            return owner.$mobx;
        }
        return adm;
    }
    function generateComputedPropConfig(propName) {
        return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
            configurable: globalState.computedConfigurable,
            enumerable: false,
            get: function() {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function(v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        });
    }
    function notifyPropertyAddition(adm, object, key, newValue) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy) spyReportStart(__assign(__assign({}, change), {
            name: adm.name,
            key: key
        }));
        if (notify) notifyListeners(adm, change);
        if (notifySpy) spyReportEnd();
    }
    var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
    function isObservableObject(thing) {
        if (isObject(thing)) {
            initializeInstance(thing);
            return isObservableObjectAdministration(thing.$mobx);
        }
        return false;
    }
    function getAtom(thing, property) {
        if (typeof thing === "object" && thing !== null) {
            if (isObservableArray(thing)) {
                if (property !== undefined) fail(false);
                return thing.$mobx.atom;
            }
            if (isObservableSet(thing)) return thing.$mobx;
            if (isObservableMap(thing)) {
                var anyThing = thing;
                if (property === undefined) return anyThing._keysAtom;
                var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
                if (!observable) fail(false);
                return observable;
            }
            initializeInstance(thing);
            if (property && !thing.$mobx) thing[property];
            if (isObservableObject(thing)) {
                if (!property) return fail(false);
                var observable = thing.$mobx.values[property];
                if (!observable) fail(false);
                return observable;
            }
            if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
        } else if (typeof thing === "function") {
            if (isReaction(thing.$mobx)) return thing.$mobx;
        }
        return fail(false);
    }
    function getAdministration(thing, property) {
        if (!thing) fail("Expecting some object");
        if (property !== undefined) return getAdministration(getAtom(thing, property));
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
        if (isObservableMap(thing) || isObservableSet(thing)) return thing;
        initializeInstance(thing);
        if (thing.$mobx) return thing.$mobx;
        fail(false);
    }
    function getDebugName(thing, property) {
        var named;
        if (property !== undefined) named = getAtom(thing, property);
        else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
        else named = getAtom(thing);
        return named.name;
    }
    var toString = Object.prototype.toString;
    function deepEqual(a, b, depth) {
        if (depth === void 0) depth = -1;
        return eq(a, b, depth);
    }
    function eq(a, b, depth, aStack, bStack) {
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        if (a == null || b == null) return false;
        if (a !== a) return b !== b;
        var type = typeof a;
        if (type !== "function" && type !== "object" && typeof b != "object") return false;
        a = unwrap(a);
        b = unwrap(b);
        var className = toString.call(a);
        if (className !== toString.call(b)) return false;
        switch(className){
            case "[object RegExp]":
            case "[object String]":
                return "" + a === "" + b;
            case "[object Number]":
                if (+a !== +a) return +b !== +b;
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case "[object Date]":
            case "[object Boolean]":
                return +a === +b;
            case "[object Symbol]":
                return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
        }
        var areArrays = className === "[object Array]";
        if (!areArrays) {
            if (typeof a != "object" || typeof b != "object") return false;
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
        }
        if (depth === 0) return false;
        else if (depth < 0) depth = -1;
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while(length--){
            if (aStack[length] === a) return bStack[length] === b;
        }
        aStack.push(a);
        bStack.push(b);
        if (areArrays) {
            length = a.length;
            if (length !== b.length) return false;
            while(length--){
                if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
            }
        } else {
            var keys = Object.keys(a);
            var key = void 0;
            length = keys.length;
            if (Object.keys(b).length !== length) return false;
            while(length--){
                key = keys[length];
                if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
            }
        }
        aStack.pop();
        bStack.pop();
        return true;
    }
    function unwrap(a) {
        if (isObservableArray(a)) return a.peek();
        if (isES6Map(a) || isObservableMap(a)) return iteratorToArray(a.entries());
        if (isES6Set(a) || isObservableSet(a)) return iteratorToArray(a.entries());
        return a;
    }
    function has$1(a, key) {
        return Object.prototype.hasOwnProperty.call(a, key);
    }
    try {
        "production";
    } catch (e) {
        var g = getGlobal();
        if (typeof $6cAn5 === "undefined") g.process = {};
        g.process.env = {};
    }
    (function() {
        function testCodeMinification() {}
        testCodeMinification.name;
        var varName;
    })();
    var $mobx = "$mobx";
    if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
    var warnedAboutDefaultExport_1;
});
parcelRegister("jkADf", function(module, exports) {
    $parcel$export(module.exports, "ContextWrapper", ()=>$e64f0f96877c6709$export$34282a1f95511a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $daJ0i;
    const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
        const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
        const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
        return (0, ($parcel$interopDefault($9xWGk)))({
            source: source,
            ...rest
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
    const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
        const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: data
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children));
    };
});
parcelRegister("agcXw", function(module, exports) {
    $parcel$export(module.exports, "FireUIAnalytics", ()=>$5625c4255a3b29d6$export$1f3555c9be6c5e08);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$5625c4255a3b29d6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$5625c4255a3b29d6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$5625c4255a3b29d6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $h8yj2;
    const $5625c4255a3b29d6$var$getFixedActionAndActionSubject = (props)=>{
        const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
        if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const fixedAction = action || eventNameSplit[1];
        const fixedActionSubject = actionSubject || eventNameSplit[0];
        if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        return {
            action: fixedAction,
            actionSubject: fixedActionSubject
        };
    };
    const $5625c4255a3b29d6$var$getFixedActionSubjectId = (props)=>{
        const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
        if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
        const fixedActionSubjectId = actionSubjectId || componentName;
        return {
            actionSubjectId: fixedActionSubjectId
        };
    };
    class $5625c4255a3b29d6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes } = this.props;
            if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
            const { action: action, actionSubject: actionSubject } = $5625c4255a3b29d6$var$getFixedActionAndActionSubject(this.props);
            const { actionSubjectId: actionSubjectId } = $5625c4255a3b29d6$var$getFixedActionSubjectId(this.props);
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("h8yj2")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $5625c4255a3b29d6$var$WithAnalytics = (0, (0, parcelRequire("cb25w")).default)()($5625c4255a3b29d6$var$FireComponent);
    const $5625c4255a3b29d6$export$1f3555c9be6c5e08 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$a1562d08625f5d7e)
        });
    const $5625c4255a3b29d6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$947dac6c72b26f81)
        });
    const $5625c4255a3b29d6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$12346a674644c156)
        });
    const $5625c4255a3b29d6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';
parcelRegister("h8yj2", function(module, exports) {
    $parcel$export(module.exports, "fireAnalytics", ()=>$b264de6d6a035739$export$34ac71ce24cddec2);
    $parcel$export(module.exports, "fireUIAnalytics", ()=>$b264de6d6a035739$export$5d00cd31b1bf8e94);
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$b264de6d6a035739$export$13990ad4625571ed);
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$b264de6d6a035739$export$79f423cc3fd39762);
    $parcel$export(module.exports, "fireScreenAnalytics", ()=>$b264de6d6a035739$export$6f46fb37ad7d962b);
    var $hYfgW = parcelRequire("hYfgW");
    var $4zfLY;
    const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
        const castedEvent = event;
        const clonedEvent = castedEvent.clone();
        if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
        clonedEvent.update({
            ...payload,
            analyticsType: type
        }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
    };
    const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
        const castedEvent = event;
        return (0, ($parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
    };
    const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
        const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        const castedEvent = event;
        const action = event.payload && event.payload.action || argumentsAction;
        const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
        if (!action) throw new Error('Mandatory "action" field is missing from UI event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        if (!action) throw new Error('Mandatory "action" field is missing from Track event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
        const { attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
            attributes: attributes
        });
    };
});
parcelRegister("4zfLY", function(module, exports) {
    $parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", ()=>$ccaec2c661eabde7$export$e6baab532ef8c6bf);
    const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
        const arr = string.split(' ');
        switch(arr.length){
            case 1:
                return {
                    actionSubject: undefined,
                    action: undefined,
                    actionSubjectId: arr[0],
                    attributes: undefined
                };
            case 2:
                return {
                    actionSubject: arr[0],
                    action: arr[1],
                    actionSubjectId: undefined,
                    attributes: undefined
                };
            default:
                throw Error('Event of this type is not supported');
        }
    };
    const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
        if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        if (typeof one === 'object') return {
            actionSubject: undefined,
            action: undefined,
            actionSubjectId: undefined,
            attributes: one
        };
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
        if (typeof one === 'string' && typeof two === 'string') {
            const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            const actionSubjectId = two;
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: undefined
            };
        }
        if (typeof one === 'string' && typeof two === 'object') {
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: two
            };
        }
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
        if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
            const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            const actionSubjectId = two;
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: three
            };
        }
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
        switch(args.length){
            case 0:
                return {
                    actionSubject: undefined,
                    action: undefined,
                    actionSubjectId: undefined,
                    attributes: undefined
                };
            case 1:
                return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
            case 2:
                return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
            case 3:
                return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
            default:
                throw Error('Can not fire an empty event');
        }
    };
});
parcelRegister("bv2Tr", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$85f4d5778164d0dc$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $92Z2l;
    var $erWXD;
    class $85f4d5778164d0dc$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false,
                errorInfo: null,
                error: null
            };
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                hasError: true,
                error: error,
                errorInfo: errorInfo.componentStack
            });
            this.props.errorUtils.reportError(error, {
                actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_UI,
                id: 'errorBoundary',
                errorInfo: errorInfo
            });
        }
        render() {
            if (this.state.hasError) {
                const { renderError: renderError } = this.props;
                return renderError ? renderError({
                    error: this.state.error
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPage, null, (0, ($parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPageSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                    appearance: "error",
                    title: "Something went wrong"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, "Refresh the page and try again. ", (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), "If the error persists,", ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: "https://support.thinktilt.com",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, "contact support"), "."))));
            }
            return this.props.children;
        }
    }
    const $85f4d5778164d0dc$var$ErrorPage = (0, $dAHxw.default).div({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    });
    const $85f4d5778164d0dc$var$ErrorPageSection = (0, $dAHxw.default).div({});
});
parcelRegister("dAHxw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e506934574c3414$export$2e2bcd8739ae039);
    parcelRequire("bS32t");
    parcelRequire("5uXOq");
    parcelRequire("bS0aY");
    var $bWGt6 = parcelRequire("bWGt6");
    parcelRequire("l9ACI");
    parcelRequire("7PpcK");
    parcelRequire("lDKn9");
    var $9e506934574c3414$var$tags = [
        'a',
        'abbr',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'base',
        'bdi',
        'bdo',
        'big',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'cite',
        'code',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'keygen',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'meter',
        'nav',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'param',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'title',
        'tr',
        'track',
        'u',
        'ul',
        'var',
        'video',
        'wbr',
        'circle',
        'clipPath',
        'defs',
        'ellipse',
        'foreignObject',
        'g',
        'image',
        'line',
        'linearGradient',
        'mask',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialGradient',
        'rect',
        'stop',
        'svg',
        'text',
        'tspan'
    ];
    var $9e506934574c3414$var$newStyled = (0, $bWGt6.default).bind();
    $9e506934574c3414$var$tags.forEach(function(tagName) {
        $9e506934574c3414$var$newStyled[tagName] = $9e506934574c3414$var$newStyled(tagName);
    });
    var $9e506934574c3414$export$2e2bcd8739ae039 = $9e506934574c3414$var$newStyled;
});
parcelRegister("erWXD", function(module, exports) {
    $parcel$export(module.exports, "ActionSubject", ()=>$a85152b408a7fe70$export$7f97440769de1377);
    $parcel$export(module.exports, "Action", ()=>$a85152b408a7fe70$export$e19cd5f9376f8cee);
    $parcel$export(module.exports, "FormUpdateType", ()=>$a85152b408a7fe70$export$d7867a52899740a0);
    let $a85152b408a7fe70$export$7f97440769de1377 = function(ActionSubject) {
        ActionSubject["FORM"] = "form";
        ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
        ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
        ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
        ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
        ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
        ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
        ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
        ActionSubject["TEMPLATE_FORM"] = "templateForm";
        ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
        ActionSubject["BUTTON"] = "button";
        ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
        ActionSubject["SELECT_ITEM"] = "selectItem";
        ActionSubject["FILTER"] = "filter";
        ActionSubject["LIST"] = "list";
        ActionSubject["PANEL"] = "panel";
        ActionSubject["SECTION"] = "section";
        ActionSubject["TABLE"] = "table";
        ActionSubject["MODAL"] = "modal";
        ActionSubject["PROFORMA_API"] = "proformaAPI";
        ActionSubject["PROFORMA_UI"] = "proformaUI";
        ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
        ActionSubject["ATTACHMENT"] = "proformaAttachment";
        ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
        ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
        ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
        ActionSubject["REQUEST_TYPE"] = "requestType";
        ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
        ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
        ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
        ActionSubject["FORM_VALIDATION"] = "formValidation";
        ActionSubject["FORM_EDIT"] = "formEdit";
        ActionSubject["FORM_SAVE"] = "formSave";
        ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
        ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
        ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
        ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
        ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
        ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
        ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
        return ActionSubject;
    }({});
    let $a85152b408a7fe70$export$e19cd5f9376f8cee = function(Action) {
        Action["ADDED"] = "added";
        Action["CLICKED"] = "clicked";
        Action["CREATED"] = "created";
        Action["DELETED"] = "deleted";
        Action["DOWNLOADED"] = "downloaded";
        Action["EXPORTED"] = "exported";
        Action["UPDATED"] = "updated";
        Action["VIEWED"] = "viewed";
        Action["SELECTED"] = "selected";
        Action["COPIED"] = "copied";
        Action["FAILED"] = "failed";
        Action["FINISHED"] = "finished";
        Action["STARTED"] = "started";
        Action["STOPPED"] = "stopped";
        return Action;
    }({});
    let $a85152b408a7fe70$export$d7867a52899740a0 = function(FormUpdateType) {
        FormUpdateType["REOPEN"] = "REOPEN";
        FormUpdateType["SAVE"] = "SAVE";
        FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
        FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
        FormUpdateType["SUBMIT"] = "SUBMIT";
        FormUpdateType["CLOSE"] = "CLOSE";
        return FormUpdateType;
    }({});
});
parcelRegister("iu3cq", function(module, exports) {
    $parcel$export(module.exports, "MediaProvider", ()=>$d74d82b21dcfae89$export$57164260bc1f1218);
    $parcel$export(module.exports, "useMediaContext", ()=>$d74d82b21dcfae89$export$2d636d13f24b27df);
    var $5uXOq = parcelRequire("5uXOq");
    const $d74d82b21dcfae89$var$MediaContext = (0, $5uXOq.createContext)(undefined);
    const $d74d82b21dcfae89$export$57164260bc1f1218 = ({ children: children, mediaContext: mediaContext })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d74d82b21dcfae89$var$MediaContext.Provider, {
            value: mediaContext
        }, children);
    };
    function $d74d82b21dcfae89$export$2d636d13f24b27df() {
        const mediaContext = (0, $5uXOq.useContext)($d74d82b21dcfae89$var$MediaContext);
        const { mediaApiUploadToken: mediaApiUploadToken, mediaApiReadToken: mediaApiReadToken, projectId: projectId, portalId: portalId, issueKey: issueKey, mediaUploadAndViewContexts: mediaUploadAndViewContexts, mediaReadTokenRefresh: mediaReadTokenRefresh, mediaApiError: mediaApiError } = mediaContext !== null && mediaContext !== void 0 ? mediaContext : {};
        return {
            mediaApiUploadToken: mediaApiUploadToken,
            mediaApiReadToken: mediaApiReadToken,
            mediaUploadAndViewContexts: mediaUploadAndViewContexts,
            projectId: projectId,
            portalId: portalId,
            issueKey: issueKey,
            mediaReadTokenRefresh: mediaReadTokenRefresh,
            mediaApiError: mediaApiError
        };
    }
});
parcelRegister("6W5Vt", function(module, exports) {
    $parcel$export(module.exports, "PfFlagsProvider", ()=>$50ccc1a344ad6c19$export$33dbaef47fd9c29b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8251k;
    const $50ccc1a344ad6c19$var$PfFlagsContext = (0, $5uXOq.createContext)(undefined);
    const $50ccc1a344ad6c19$export$33dbaef47fd9c29b = ({ flags: flags, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($50ccc1a344ad6c19$var$PfFlagsContext.Provider, {
            value: flags
        }, children);
    };
    function $50ccc1a344ad6c19$export$a37d68d19485eb11() {
        const flags = (0, $5uXOq.useContext)($50ccc1a344ad6c19$var$PfFlagsContext);
        if (flags === undefined) throw new Error(`usePfFlags must be used within a PfFlagsProvider. ${(0, (0, parcelRequire("8251k")).errorMessageDuplicateCommonCore)}`);
        return flags;
    }
});
parcelRegister("8251k", function(module, exports) {
    $parcel$export(module.exports, "errorMessageDuplicateCommonCore", ()=>$5d926790292467ac$export$202e68bc03a230f);
    const $5d926790292467ac$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";
});
parcelRegister("9rYSe", function(module, exports) {
    $parcel$export(module.exports, "UtilsProvider", ()=>$01c68bca0be3a904$export$df5be093c1f55d13);
    var $5uXOq = parcelRequire("5uXOq");
    var $ex6Rw;
    const $01c68bca0be3a904$export$df5be093c1f55d13 = ({ utils: utils, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ex6Rw")).PfErrorUtilsProvider), {
            errorUtils: utils.errorUtils
        }, children);
    };
});
parcelRegister("ex6Rw", function(module, exports) {
    $parcel$export(module.exports, "PfErrorUtilsProvider", ()=>$a9497877cb60343e$export$b71d28c58577f663);
    $parcel$export(module.exports, "usePfErrorUtils", ()=>$a9497877cb60343e$export$19d62bf1891c25ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8251k;
    const $a9497877cb60343e$var$PfErrorUtilsContext = (0, $5uXOq.createContext)(undefined);
    const $a9497877cb60343e$export$b71d28c58577f663 = ({ errorUtils: errorUtils, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a9497877cb60343e$var$PfErrorUtilsContext.Provider, {
            value: errorUtils
        }, children);
    };
    function $a9497877cb60343e$export$19d62bf1891c25ff() {
        const errorUtils = (0, $5uXOq.useContext)($a9497877cb60343e$var$PfErrorUtilsContext);
        if (errorUtils === undefined) throw new Error(`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${(0, (0, parcelRequire("8251k")).errorMessageDuplicateCommonCore)}`);
        return errorUtils;
    }
});
parcelRegister("6jvUj", function(module, exports) {
    $parcel$export(module.exports, "createErrorUtils", ()=>$498d4489c00ccef2$export$7a2f0d878b08650d);
    $parcel$export(module.exports, "createUtils", ()=>$498d4489c00ccef2$export$b6881d4b4863cacc);
    $parcel$export(module.exports, "createUtils2", ()=>$498d4489c00ccef2$export$e4e37e88de17afb6);
    var $a1RLT;
    var $j93Fo;
    var $gFGsm;
    function $498d4489c00ccef2$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
        return new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    }
    function $498d4489c00ccef2$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
        const errorUtils = new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
        (0, (0, parcelRequire("j93Fo")).setNoticeLocale)(locale);
        const apiUtil = new (0, (0, parcelRequire("a1RLT")).ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
        return {
            apiUtil: apiUtil,
            errorUtils: errorUtils
        };
    }
    function $498d4489c00ccef2$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
        const errorUtils = new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
        (0, (0, parcelRequire("j93Fo")).setNoticeLocale)(locale);
        const apiUtil = new (0, (0, parcelRequire("a1RLT")).ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
        return {
            apiUtil: apiUtil,
            errorUtils: errorUtils
        };
    }
});
parcelRegister("a1RLT", function(module, exports) {
    $parcel$export(module.exports, "AcceptedResponseType", ()=>$74d3b548944c3270$export$9126c50ecfe2a46d);
    $parcel$export(module.exports, "ApiUtil", ()=>$74d3b548944c3270$export$baa861b25a2283a4);
    var $kCVub;
    var $erWXD;
    var $bRqoO;
    var $caW8j;
    let $74d3b548944c3270$export$9126c50ecfe2a46d = function(AcceptedResponseType) {
        AcceptedResponseType["Json"] = "json";
        AcceptedResponseType["Blob"] = "blob";
        return AcceptedResponseType;
    }({});
    class $74d3b548944c3270$export$baa861b25a2283a4 {
        constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
            this.errorUtils = void 0;
            this.jiraUrl = void 0;
            this.proformaUrl = void 0;
            this.createAnalyticsEvent = void 0;
            this.jiraUrl = jiraUrl;
            this.proformaUrl = proformaUrl;
            this.errorUtils = errorUtils;
            this.createAnalyticsEvent = createAnalyticsEvent;
        }
        get(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'GET', path, responseType, requestName);
        }
        jiraGet(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'GET', path, responseType, requestName);
        }
        put(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
        }
        jiraPut(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
        }
        post(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'POST', path, responseType, requestName, body);
        }
        jiraPost(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'POST', path, responseType, requestName, body);
        }
        delete(path, body, requestName, responseType = 'none') {
            return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
        }
        createApiUrl(relativePath) {
            return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
        }
        createJiraUrl(relativePath) {
            return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
        }
        getAnalyticsSource() {
            try {
                var _analyticsData$payloa, _analyticsData$payloa2;
                const analyticsEvent = this.createAnalyticsEvent({});
                const analyticsData = (0, (0, parcelRequire("kCVub")).extractAWCDataFromEvent)(analyticsEvent);
                return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 ? void 0 : (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
            } catch (e) {
                return 'unknown';
            }
        }
        fetchApi(proForma, method, path, responseType, requestName, body) {
            const analyticsSource = this.getAnalyticsSource();
            return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
                method: method,
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Experimental-Experience': analyticsSource,
                    ...responseType === $74d3b548944c3270$export$9126c50ecfe2a46d.Json ? {
                        Accept: 'application/json'
                    } : {}
                },
                ...body && {
                    body: JSON.stringify(body)
                }
            }).catch((error)=>{
                const message = `No response from API: ${error.message || ''}`;
                const apiError = $74d3b548944c3270$var$toApiError(0, {
                    error: message
                }, true, requestName);
                this.errorUtils.reportError(error, {
                    actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_API,
                    id: 'fetchApi',
                    attributes: {
                        path: path,
                        method: method,
                        responseType: responseType,
                        requestName: requestName,
                        apiError: JSON.stringify(apiError),
                        isClientFetchError: true
                    }
                });
                return Promise.reject(apiError);
            }).then((response)=>{
                let errorObj = new Error(response.statusText);
                if (!response.ok) {
                    var _ref, _response$headers$get;
                    const traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
                    let apiErrorPromise;
                    try {
                        const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$74d3b548944c3270$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                            const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                            errorObj = error;
                            return $74d3b548944c3270$var$toApiError(response.status, {
                                error: message
                            }, false, requestName, traceId);
                        });
                        if (response.status === 401) this.errorUtils.notifyUser((0, (0, parcelRequire("bRqoO")).NoticeType).ErrorApiUnauthorised);
                        if (response.status === 403) this.errorUtils.notifyUser((0, (0, parcelRequire("bRqoO")).NoticeType).ErrorApiMissingPermissions);
                        if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                        else apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                            error: response.body || ''
                        }, false, requestName, traceId));
                    } catch (error) {
                        const message = `Unexpected response from API: ${response.body || ''}`;
                        errorObj = error;
                        apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId));
                    }
                    apiErrorPromise.catch((apiError)=>{
                        this.errorUtils.reportError(errorObj, {
                            actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_API,
                            id: 'fetchApi',
                            attributes: {
                                status: response.status,
                                statusGroup: `${Math.floor(response.status / 100)}xx`,
                                traceId: traceId,
                                path: path,
                                method: method,
                                responseType: responseType,
                                requestName: requestName,
                                apiError: JSON.stringify(apiError),
                                isClientFetchError: false
                            }
                        });
                    });
                    return apiErrorPromise;
                }
                if (response.status === 204) return '';
                switch(responseType){
                    case 'json':
                        return response.json();
                    case 'blob':
                        return response.blob();
                    case 'text':
                        return response.text();
                    case 'none':
                        return '';
                    default:
                        return response;
                }
            });
        }
    }
    function $74d3b548944c3270$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
        if (Object.keys(responseJson).length === 0) return (0, (0, parcelRequire("caW8j")).constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
        const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
        const context = responseJson['context'];
        const contextId = responseJson['contextId'];
        const details = responseJson['details'];
        return (0, (0, parcelRequire("caW8j")).constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
    }
});
parcelRegister("kCVub", function(module, exports) {
    $parcel$export(module.exports, "extractAWCDataFromEvent", ()=>$d006147c8436533b$export$1c850cf68c053906);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8HgKr;
    const $d006147c8436533b$export$1c850cf68c053906 = (event)=>{
        const castedEvent = event;
        const analyticsType = (0, (0, parcelRequire("8HgKr")).getAnalyticsType)(castedEvent);
        const attributes = (0, (0, parcelRequire("8HgKr")).getAttributes)(castedEvent);
        const source = (0, (0, parcelRequire("8HgKr")).getSource)(castedEvent);
        const actionSubject = (0, (0, parcelRequire("8HgKr")).getActionSubject)(castedEvent);
        if (analyticsType === (0, $6e65040b988c460f$export$f1d537d508d2945a)) return {
            type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
            payload: {
                name: source,
                attributes: attributes
            }
        };
        switch(analyticsType){
            case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
            case 0, $6e65040b988c460f$export$947dac6c72b26f81:
            case 0, $6e65040b988c460f$export$12346a674644c156:
                {
                    const action = (0, (0, parcelRequire("8HgKr")).getAction)(castedEvent);
                    const actionSubjectId = (0, (0, parcelRequire("8HgKr")).getActionSubjectId)(castedEvent);
                    const containerId = (0, (0, parcelRequire("8HgKr")).getContainerId)(castedEvent);
                    const containerType = (0, (0, parcelRequire("8HgKr")).getContainerType)(castedEvent);
                    const objectId = (0, (0, parcelRequire("8HgKr")).getObjectId)(castedEvent);
                    const objectType = (0, (0, parcelRequire("8HgKr")).getObjectType)(castedEvent);
                    const tags = (0, (0, parcelRequire("8HgKr")).getTags)(castedEvent);
                    return {
                        type: analyticsType,
                        payload: (0, ($parcel$interopDefault($9xWGk)))({
                            action: action,
                            actionSubject: actionSubject,
                            actionSubjectId: actionSubjectId,
                            source: source,
                            tags: tags,
                            containerType: containerType,
                            containerId: containerId,
                            objectType: objectType,
                            objectId: objectId,
                            attributes: attributes
                        }, (0, ($parcel$interopDefault($cjFoH))))
                    };
                }
            default:
                return {
                    payload: {
                        source: source,
                        actionSubject: actionSubject,
                        attributes: attributes
                    },
                    type: undefined
                };
        }
    };
});
parcelRegister("8HgKr", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsType", ()=>$6831e52439d2a9a2$export$a3569ac53b82a914);
    $parcel$export(module.exports, "getAttributes", ()=>$6831e52439d2a9a2$export$fe94072fee8a6976);
    $parcel$export(module.exports, "getSource", ()=>$6831e52439d2a9a2$export$dd2b6e807fb37ba3);
    $parcel$export(module.exports, "getActionSubject", ()=>$6831e52439d2a9a2$export$6f40cdf6d42c018d);
    $parcel$export(module.exports, "getAction", ()=>$6831e52439d2a9a2$export$6ca3170acb89054);
    $parcel$export(module.exports, "getActionSubjectId", ()=>$6831e52439d2a9a2$export$b6f8db3ad0711b02);
    $parcel$export(module.exports, "getContainerId", ()=>$6831e52439d2a9a2$export$7c8178cc9001d237);
    $parcel$export(module.exports, "getContainerType", ()=>$6831e52439d2a9a2$export$acc6f3e19803b3dc);
    $parcel$export(module.exports, "getObjectId", ()=>$6831e52439d2a9a2$export$fa986b91291934c7);
    $parcel$export(module.exports, "getObjectType", ()=>$6831e52439d2a9a2$export$11cc42aebef2ef3a);
    $parcel$export(module.exports, "getTags", ()=>$6831e52439d2a9a2$export$af63d7414243dad3);
    var $183uB = parcelRequire("183uB");
    var $cjFoH = parcelRequire("cjFoH");
    var $hYfgW = parcelRequire("hYfgW");
    var $1UikQ = parcelRequire("1UikQ");
    var $9xWGk = parcelRequire("9xWGk");
    var $kGsr8 = parcelRequire("kGsr8");
    const $6831e52439d2a9a2$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
    const $6831e52439d2a9a2$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
    const $6831e52439d2a9a2$export$fe94072fee8a6976 = (event)=>{
        const contextAttributes = $6831e52439d2a9a2$var$extractFromContext(event, 'attributes');
        const payloadAttributes = event.payload.attributes;
        const allAttributes = (0, ($parcel$interopDefault($1UikQ)))(contextAttributes.reduce((result, extraAttributes)=>(0, ($parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
        const sources = $6831e52439d2a9a2$var$extractFromContext(event, 'source');
        const namespaces = sources.filter(Boolean).join('.');
        return (0, ($parcel$interopDefault($9xWGk)))({
            ...allAttributes,
            namespaces: namespaces
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
    const $6831e52439d2a9a2$export$dd2b6e807fb37ba3 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'source').filter(Boolean));
    const $6831e52439d2a9a2$export$6f40cdf6d42c018d = (event)=>{
        const { actionSubject: actionSubject } = event.payload;
        if (actionSubject) return actionSubject;
        const component = (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'component').filter(Boolean)) || (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'componentName').filter(Boolean));
        return component;
    };
    const $6831e52439d2a9a2$export$6ca3170acb89054 = (event)=>event.payload.action;
    const $6831e52439d2a9a2$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
    const $6831e52439d2a9a2$export$7c8178cc9001d237 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerId').filter(Boolean));
    const $6831e52439d2a9a2$export$acc6f3e19803b3dc = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerType').filter(Boolean));
    const $6831e52439d2a9a2$export$fa986b91291934c7 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectId').filter(Boolean));
    const $6831e52439d2a9a2$export$11cc42aebef2ef3a = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectType').filter(Boolean));
    const $6831e52439d2a9a2$export$af63d7414243dad3 = (event)=>{
        const tags = (0, ($parcel$interopDefault($kGsr8)))((0, ($parcel$interopDefault($183uB)))($6831e52439d2a9a2$var$extractFromContext(event, 'tags'))).filter(Boolean);
        return tags.length ? tags : undefined;
    };
});
parcelRegister("bRqoO", function(module, exports) {
    $parcel$export(module.exports, "NoticeType", ()=>$8a291f441fcc3884$export$3b5003ffe8119af2);
    $parcel$export(module.exports, "Notices", ()=>$8a291f441fcc3884$export$ba15f0a357d713fd);
    var $9svqU;
    var $7fcWf;
    let $8a291f441fcc3884$export$3b5003ffe8119af2 = function(NoticeType) {
        NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
        NoticeType["ConfirmChangeFormAvailabilityToInternal"] = "ConfirmChangeFormAvailabilityToInternal";
        NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
        NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
        NoticeType["ConfirmChangeFormAvailabilityToExternal"] = "ConfirmChangeFormAvailabilityToExternal";
        NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
        NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
        NoticeType["ConfirmSubmitFormPdf"] = "ConfirmSubmitFormPdf";
        NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
        NoticeType["ConfirmSubmitFormPdfLock"] = "ConfirmSubmitFormPdfLock";
        NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
        NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
        NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
        NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
        NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
        NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
        NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
        NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
        NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
        NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
        NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
        NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
        NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
        NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
        return NoticeType;
    }({});
    const $8a291f441fcc3884$export$ba15f0a357d713fd = {
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmDeleteForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).DeleteFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).DeleteFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Delete],
            isWarningNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToInternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityToInternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Change]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToInternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToInternalHeader],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToInternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).MakeInternal]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToExternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityToExternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Change]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToExternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToExternalHeader],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToExternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).MakeExternal]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmCancelEdit]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).CancelEditFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).CancelEditFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Confirm]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormPdf]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormPdfMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormLock]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormLockMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormPdfLock]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormPdfLockMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmReopenForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ReopenFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ReopenFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Reopen]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUnauthorised]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UnauthorisedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UnauthorisedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiMissingPermissions]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).MissingPermissionsTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).MissingPermissionsMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiAddConnectionFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).AddConnectionFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).AddConnectionFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUpdateConnectionFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UpdateConnectionFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UpdateConnectionFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSubmitFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SubmitFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SubmitFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormInvalidAnswersFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormInvalidAnswersMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailedOnConflict]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedOnConflictMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveTemplateFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveTemplateFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveTemplateFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadTemplateFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadTemplateFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadTemplateFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadJiraFieldsFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadJiraFieldsFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadJiraFieldsFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadDataConnectionsFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadDataConnectionsFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadDataConnectionsFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadSettingsRefDataFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadSettingsRefDataFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadSettingsRefDataFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        }
    };
});
parcelRegister("9svqU", function(module, exports) {
    $parcel$export(module.exports, "ApiErrorMessage", ()=>$6e2f1c86cfbb31d7$export$231e36d3eb058aab);
    $parcel$export(module.exports, "IntlApiErrorMessages", ()=>$6e2f1c86cfbb31d7$export$4a210a14fc5cbd69);
    var $7VHMR;
    let $6e2f1c86cfbb31d7$export$231e36d3eb058aab = function(ApiErrorMessage) {
        ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
        ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
        ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
        ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
        ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
        ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
        ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
        ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
        ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
        ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
        ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
        ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
        ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
        ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
        ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
        ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
        ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
        ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
        ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
        ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
        ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
        ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
        ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
        ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
        return ApiErrorMessage;
    }({});
    const $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedTitle]: {
            id: 'ui-notices.apiError.title.UnauthorisedTitle',
            defaultMessage: 'Error: User Unauthorised'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedMsg]: {
            id: 'ui-notices.apiError.msg.UnauthorisedMsg',
            defaultMessage: 'Try refreshing your page or logging into Jira again.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsTitle]: {
            id: 'ui-notices.apiError.title.MissingPermissionsTitle',
            defaultMessage: 'Error: User is not allowed this action'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsMsg]: {
            id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
            defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedTitle]: {
            id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
            defaultMessage: 'Error: Adding data connection failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedMsg]: {
            id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
            defaultMessage: 'A server error occurred while trying to add the data connection.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedTitle]: {
            id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
            defaultMessage: 'Error: Updating data connection failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedMsg]: {
            id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
            defaultMessage: 'A server error occurred while trying to update the data connection.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
            defaultMessage: 'Error: Submitting form failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to submit the form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SaveFormFailedTitle',
            defaultMessage: "We couldn\u2019t save your changes",
            description: 'The title on the error flag informing customers that their form failed to save.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to save the form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormInvalidAnswersMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
            defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
            description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedOnConflictMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
            defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
            description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
            defaultMessage: 'Error: Saving template form failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to save the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
            defaultMessage: "We couldn\u2019t load your form"
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
            defaultMessage: 'Refresh the page to try again'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
            defaultMessage: 'Error: Loading Jira fields failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
            defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
            defaultMessage: 'Error: Loading data connections failed.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
            defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
            defaultMessage: 'Error: Loading form settings reference data failed.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
            defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
        }
    });
});
parcelRegister("7fcWf", function(module, exports) {
    $parcel$export(module.exports, "NoticeMessage", ()=>$5463f86ac7c8d952$export$cd61f3d27ce0e442);
    $parcel$export(module.exports, "IntlNoticeMessages", ()=>$5463f86ac7c8d952$export$5f3ce93e2cd01692);
    var $7VHMR;
    let $5463f86ac7c8d952$export$cd61f3d27ce0e442 = function(NoticeMessage) {
        NoticeMessage["Delete"] = "Delete";
        NoticeMessage["Discard"] = "Discard";
        NoticeMessage["Change"] = "Change";
        NoticeMessage["Confirm"] = "Confirm";
        NoticeMessage["Submit"] = "Submit";
        NoticeMessage["Reopen"] = "Reopen";
        NoticeMessage["Close"] = "Close";
        NoticeMessage["Cancel"] = "Cancel";
        NoticeMessage["UpgradeNow"] = "UpgradeNow";
        NoticeMessage["MakeInternal"] = "MakeInternal";
        NoticeMessage["MakeExternal"] = "MakeExternal";
        NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
        NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
        NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
        NoticeMessage["ChangeFormAvailabilityToInternalMsg"] = "ChangeFormAvailabilityToInternalMsg";
        NoticeMessage["ChangeFormAvailabilityToExternalMsg"] = "ChangeFormAvailabilityToExternalMsg";
        NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
        NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
        NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
        NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
        NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
        NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
        NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
        NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
        NoticeMessage["SubmitFormPdfMsg"] = "SubmitFormPdfMsg";
        NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
        NoticeMessage["SubmitFormPdfLockMsg"] = "SubmitFormPdfLockMsg";
        NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
        NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
        NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
        NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
        NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
        NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
        return NoticeMessage;
    }({});
    const $5463f86ac7c8d952$export$5f3ce93e2cd01692 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Delete]: {
            id: 'ui-notices.confirmText.Delete',
            defaultMessage: 'Delete'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Discard]: {
            id: 'ui-notices.confirmText.Discard',
            defaultMessage: 'Discard'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Change]: {
            id: 'ui-notices.confirmText.Change',
            defaultMessage: 'Change'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Confirm]: {
            id: 'ui-notices.confirmText.Confirm',
            defaultMessage: 'Confirm'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Submit]: {
            id: 'ui-notices.confirmText.Submit',
            defaultMessage: 'Submit'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Reopen]: {
            id: 'ui-notices.confirmText.Reopen',
            defaultMessage: 'Reopen'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Close]: {
            id: 'ui-notices.confirmText.Close',
            defaultMessage: 'Close'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Cancel]: {
            id: 'ui-notices.confirmText.Cancel',
            defaultMessage: 'Cancel'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.UpgradeNow]: {
            id: 'ui-notices.confirmText.UpgradeNow',
            defaultMessage: 'Upgrade Now'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeInternal]: {
            id: 'ui-notices.confirmText.MakeInternal',
            defaultMessage: 'Make internal'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeExternal]: {
            id: 'ui-notices.confirmText.MakeExternal',
            defaultMessage: 'Make external'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormTitle]: {
            id: 'ui-notices.title.DeleteFormTitle',
            defaultMessage: 'Confirm Deleting Form'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormMsg]: {
            id: 'ui-notices.msg.DeleteFormMsg',
            defaultMessage: "Are you sure you want to delete the \u201C{formName}\u201D form? This cannot be undone."
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityTitle]: {
            id: 'ui-notices.title.ChangeFormAvailabilityTitle',
            defaultMessage: 'Confirm Changing Form Availability'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityToInternalMsg]: {
            id: 'ui-notices.msg.ChangeFormAvailabilityToInternalMsg',
            defaultMessage: 'Please confirm you want to change the form so that it is only accessible through the Jira issue, and not through the Customer Portal.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityToExternalMsg]: {
            id: 'ui-notices.msg.ChangeFormAvailabilityToExternalMsg',
            defaultMessage: 'Please confirm you want to change the form so that it is accessible through the Jira issue and the Customer Portal.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalHeader]: {
            id: 'ui-notices.title.ChangeFormInternalHeader',
            defaultMessage: 'Make form internal only and hide from customer'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalMsg]: {
            id: 'ui-notices.msg.ChangeFormInternalMsg',
            defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalHeader]: {
            id: 'ui-notices.title.ChangeFormToExternalHeader',
            defaultMessage: 'Make form external and show to customer'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalMsg]: {
            id: 'ui-notices.msg.ChangeFormToExternalMsg',
            defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormTitle]: {
            id: 'ui-notices.title.CancelEditFormTitle',
            defaultMessage: 'Confirm Discarding Changes'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormMsg]: {
            id: 'ui-notices.msg.CancelEditFormMsg',
            defaultMessage: 'There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose "Confirm". Are you sure you want to continue?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormTitle]: {
            id: 'ui-notices.title.SubmitFormTitle',
            defaultMessage: 'Confirm Form Submission'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormMsg]: {
            id: 'ui-notices.msg.SubmitFormMsg',
            defaultMessage: 'Are you sure you want to submit this form ?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormPdfMsg]: {
            id: 'ui-notices.msg.SubmitFormPdfMsg',
            defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormLockMsg]: {
            id: 'ui-notices.msg.SubmitFormLockMsg',
            defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormPdfLockMsg]: {
            id: 'ui-notices.msg.SubmitFormPdfLockMsg',
            defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ? Once submitted no further changes can be made.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormTitle]: {
            id: 'ui-notices.title.ReopenFormTitle',
            defaultMessage: 'Confirm Reopening Form'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormMsg]: {
            id: 'ui-notices.msg.ReopenFormMsg',
            defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations1]: {
            id: 'ui-notices.msg.ErrorExplanations1',
            defaultMessage: 'Please refer to our'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations2]: {
            id: 'ui-notices.msg.ErrorExplanations2',
            defaultMessage: 'Error Explanations'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations3]: {
            id: 'ui-notices.msg.ErrorExplanations3',
            defaultMessage: 'page for more details or contact'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations4]: {
            id: 'ui-notices.msg.ErrorExplanations4',
            defaultMessage: 'ThinkTilt Support'
        }
    });
});
parcelRegister("caW8j", function(module, exports) {
    $parcel$export(module.exports, "constructApiError", ()=>$8dd38339de80c582$export$4fb8f0e1418096d0);
    $parcel$export(module.exports, "isUnknownApiError", ()=>$8dd38339de80c582$export$a072859f46abbb91);
    $parcel$export(module.exports, "getFormSaveErrors", ()=>$8dd38339de80c582$export$ed98b2247c52f4f6);
    var $3KrJl;
    var $8w794;
    function $8dd38339de80c582$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
        switch(error){
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).client:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).client,
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).clientWithDetails:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).clientWithDetails,
                    context: (0, (0, parcelRequire("8w794")).ErrorContextOf)(context),
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).json:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).json,
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).jwt:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).jwt,
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            default:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).unknown,
                    message: error,
                    status: status,
                    responseJson: responseJson,
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    requestName: requestName
                };
        }
    }
    const $8dd38339de80c582$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, (0, parcelRequire("3KrJl")).ApiErrorType).unknown;
    const $8dd38339de80c582$export$ed98b2247c52f4f6 = (apiError)=>{
        if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
            generalErrors: [],
            errorsByQuestionId: {},
            ...apiError.responseJson
        };
        return undefined;
    };
});
parcelRegister("3KrJl", function(module, exports) {
    $parcel$export(module.exports, "ApiErrorType", ()=>$2bab2d9fb6f6d466$export$eb26b24d7b7bab09);
    let $2bab2d9fb6f6d466$export$eb26b24d7b7bab09 = function(ApiErrorType) {
        ApiErrorType["client"] = "client";
        ApiErrorType["clientWithDetails"] = "clientWithDetails";
        ApiErrorType["json"] = "json";
        ApiErrorType["jwt"] = "jwt";
        ApiErrorType["unknown"] = "unknown";
        ApiErrorType["timeout"] = "timeout";
        return ApiErrorType;
    }({});
});
parcelRegister("8w794", function(module, exports) {
    $parcel$export(module.exports, "ErrorContextOf", ()=>$6336dacbdad88890$export$2c172aed648e926c);
    let $6336dacbdad88890$export$21818dff4f4f7174 = function(ErrorContext) {
        ErrorContext["I18nAccessPathKey"] = "err.access.path";
        ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
        ErrorContext["I18nEntityFormKey"] = "err.entity.form";
        ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
        ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
        ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
        ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
        ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
        ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
        ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
        ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
        ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
        ErrorContext["I18nInternalServerError"] = "err.server.internal";
        ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
        return ErrorContext;
    }({});
    function $6336dacbdad88890$export$2c172aed648e926c(context) {
        switch(context){
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError;
            default:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nUnknownContextError;
        }
    }
});
parcelRegister("j93Fo", function(module, exports) {
    $parcel$export(module.exports, "setNoticeLocale", ()=>$df01b3b500941fc5$export$caf904df61b5b10d);
    $parcel$export(module.exports, "showNotice", ()=>$df01b3b500941fc5$export$b25305d7fdb340d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $24oqM;
    let $df01b3b500941fc5$var$locale = 'en-US';
    function $df01b3b500941fc5$export$caf904df61b5b10d(newLocale) {
        $df01b3b500941fc5$var$locale = newLocale;
    }
    function $df01b3b500941fc5$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
        return new Promise((resolve)=>{
            const dialogTargetNode = document.getElementById('pf-dialog-container');
            if (!dialogTargetNode) {
                console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
                resolve(false);
            }
            const handleClose = (confirmed)=>{
                resolve(!!confirmed);
                $df01b3b500941fc5$var$closeNotice();
            };
            (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("24oqM")).Notice), {
                noticeType: noticeType,
                handleClose: handleClose,
                settings: {
                    intlValues: intlValues,
                    errorDetails: errorDetails,
                    customLocale: $df01b3b500941fc5$var$locale
                }
            }), dialogTargetNode);
        });
    }
    function $df01b3b500941fc5$var$closeNotice() {
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            console.error(`Could not close notice. The target Node for the dialog is not available`);
            return false;
        }
        const closed = (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(dialogTargetNode);
        if (!closed) console.error(`Could not close notice. There is no dialog to unmount`);
        return closed;
    }
});
parcelRegister("24oqM", function(module, exports) {
    $parcel$export(module.exports, "Notice", ()=>$181ee7fa9c781879$export$71802e30fd294f61);
    var $5uXOq = parcelRequire("5uXOq");
    var $dlLGv;
    var $fiX4W;
    var $8v3RR;
    var $bRqoO;
    const $181ee7fa9c781879$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
        const notice = (0, (0, parcelRequire("bRqoO")).Notices)[noticeType];
        if (!notice) {
            console.error(`Could not show notice, notice type ${noticeType} does not exist`);
            handleClose();
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlLGv")).PackageIntlProvider), {
            locale: customLocale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8v3RR")).NoticeDialog), {
            title: notice.title,
            titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
            message: notice.message,
            messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
            confirmText: notice.confirmText,
            confirmLink: notice.confirmLink,
            handleClose: handleClose,
            isErrorNotice: notice.isErrorNotice,
            errorDetails: errorDetails,
            isWarningNotice: notice.isWarningNotice,
            overrideZIndex: overrideZIndex
        }));
    };
});
parcelRegister("dlLGv", function(module, exports) {
    $parcel$export(module.exports, "PackageIntlProvider", ()=>$9b8239ac40bcdc9c$export$dfce9acc1b75df7a);
    $parcel$export(module.exports, "withPackageIntlProvider", ()=>$9b8239ac40bcdc9c$export$38662a78c6a3a7ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $i9OHB;
    var $ioVpW;
    const $9b8239ac40bcdc9c$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9OHB")).ProformaIntlProvider), {
            locale: locale,
            messages: (0, (0, parcelRequire("ioVpW")).default)
        }, children);
    const $9b8239ac40bcdc9c$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($9b8239ac40bcdc9c$export$dfce9acc1b75df7a, {
                locale: intl.locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
});
parcelRegister("i9OHB", function(module, exports) {
    $parcel$export(module.exports, "ProformaIntlProvider", ()=>$d38065afc4acf5f2$export$f345b4b8e42e419e);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $iyjlq;
    const $d38065afc4acf5f2$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
        var _getCodesFromLocale;
        const { language: language, country: country } = (_getCodesFromLocale = (0, (0, parcelRequire("iyjlq")).getCodesFromLocale)(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
        const lazyMessages = (0, (0, parcelRequire("iyjlq")).useLazyMessages)(messages, language !== null && language !== void 0 ? language : (0, (0, parcelRequire("iyjlq")).DEFAULT_LOCALE), country);
        if (lazyMessages === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: lazyMessages,
            locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
            defaultLocale: (0, (0, parcelRequire("iyjlq")).DEFAULT_LOCALE),
            defaultRichTextElements: {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks),
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("strong", null, chunks)
            }
        }, children);
    };
});
parcelRegister("iyjlq", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$d81a686b660c1f7e$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "getCodesFromLocale", ()=>$d81a686b660c1f7e$export$4d25b49b6dc1b540);
    $parcel$export(module.exports, "useLazyMessages", ()=>$d81a686b660c1f7e$export$7ddce3b5511cfaa8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d81a686b660c1f7e$export$1af4c7e47ad72f44 = 'en';
    const $d81a686b660c1f7e$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
    const $d81a686b660c1f7e$export$4d25b49b6dc1b540 = (locale)=>{
        const match = $d81a686b660c1f7e$var$localeRegex.exec(locale);
        if (match) {
            const [, language, country] = match;
            return {
                language: language.toLowerCase(),
                country: country === null || country === void 0 ? void 0 : country.toUpperCase()
            };
        }
        console.error('Unable to determine language and country from invalid locale.');
        return undefined;
    };
    const $d81a686b660c1f7e$var$loadLazyMessages = async (lazyMessages, language, country)=>{
        var _await$default, _await, _ref;
        return (_await$default = (_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
    };
    const $d81a686b660c1f7e$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            $d81a686b660c1f7e$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
        }, [
            country,
            language,
            lazyMessages,
            setMessages
        ]);
        return messages;
    };
});
parcelRegister("ioVpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d65701c9e2552e18$export$2e2bcd8739ae039);
    const $d65701c9e2552e18$var$lazyMessages = {
        cs: ()=>(parcelRequire("5KuqU")),
        da: ()=>(parcelRequire("iA3yG")),
        de: ()=>(parcelRequire("568Uq")),
        en: ()=>(parcelRequire("63JIa")),
        en_GB: ()=>(parcelRequire("9ZY0m")),
        en_ZZ: ()=>(parcelRequire("cjbck")),
        es: ()=>(parcelRequire("5WaKz")),
        fi: ()=>(parcelRequire("2sFGM")),
        fr: ()=>(parcelRequire("cbXIS")),
        hu: ()=>(parcelRequire("3YLM7")),
        it: ()=>(parcelRequire("gmriO")),
        ja: ()=>(parcelRequire("iJL6I")),
        ko: ()=>(parcelRequire("cmjAj")),
        nb: ()=>(parcelRequire("1lBem")),
        nl: ()=>(parcelRequire("g1Q3q")),
        pl: ()=>(parcelRequire("c8WMF")),
        pt_BR: ()=>(parcelRequire("1CmlQ")),
        ru: ()=>(parcelRequire("kyGpX")),
        sv: ()=>(parcelRequire("aaBSS")),
        th: ()=>(parcelRequire("e1jaB")),
        tr: ()=>(parcelRequire("3VPFe")),
        uk: ()=>(parcelRequire("263DJ")),
        vi: ()=>(parcelRequire("YbVTE")),
        zh: ()=>(parcelRequire("c6pcg")),
        zh_TW: ()=>(parcelRequire("j8MqE"))
    };
    var $d65701c9e2552e18$export$2e2bcd8739ae039 = $d65701c9e2552e18$var$lazyMessages;
});
parcelRegister("5KuqU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bOMSG").then(()=>parcelRequire('bSYnh'));
});
parcelRegister("iA3yG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("99s0m").then(()=>parcelRequire('fr8Uf'));
});
parcelRegister("568Uq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("41WhO").then(()=>parcelRequire('6EC1L'));
});
parcelRegister("63JIa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iZTjR").then(()=>parcelRequire('iSOzX'));
});
parcelRegister("9ZY0m", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dzFRq").then(()=>parcelRequire('eBxLi'));
});
parcelRegister("cjbck", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("DijSr").then(()=>parcelRequire('8e7FB'));
});
parcelRegister("5WaKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("abWEg").then(()=>parcelRequire('bSBGI'));
});
parcelRegister("2sFGM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6OcKU").then(()=>parcelRequire('jStmS'));
});
parcelRegister("cbXIS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ffJfg").then(()=>parcelRequire('lVomF'));
});
parcelRegister("3YLM7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3qpTf").then(()=>parcelRequire('gV19l'));
});
parcelRegister("gmriO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eK7PP").then(()=>parcelRequire('iRfhX'));
});
parcelRegister("iJL6I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lt3Cs").then(()=>parcelRequire('kEMuB'));
});
parcelRegister("cmjAj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dHRzd").then(()=>parcelRequire('lJY2E'));
});
parcelRegister("1lBem", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hwtzD").then(()=>parcelRequire('icvbb'));
});
parcelRegister("g1Q3q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7KTDh").then(()=>parcelRequire('btUKW'));
});
parcelRegister("c8WMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ly7Tk").then(()=>parcelRequire('UaJXH'));
});
parcelRegister("1CmlQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5nTxr").then(()=>parcelRequire('dqi2n'));
});
parcelRegister("kyGpX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cuJeo").then(()=>parcelRequire('deEZs'));
});
parcelRegister("aaBSS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7khh5").then(()=>parcelRequire('gtyia'));
});
parcelRegister("e1jaB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("35Enp").then(()=>parcelRequire('cRlYl'));
});
parcelRegister("3VPFe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2yjYv").then(()=>parcelRequire('c7xZi'));
});
parcelRegister("263DJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3l58i").then(()=>parcelRequire('4rorX'));
});
parcelRegister("YbVTE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4mWuc").then(()=>parcelRequire('1vLaj'));
});
parcelRegister("c6pcg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lG0k3").then(()=>parcelRequire('auLUs'));
});
parcelRegister("j8MqE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jvhrA").then(()=>parcelRequire('3SBDK'));
});
parcelRegister("fiX4W", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$b2465d41ca8b525b$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "ProFormaIntlProvider", ()=>$b2465d41ca8b525b$export$23e25b3437f9c000);
    $parcel$export(module.exports, "withProFormaIntlProvider", ()=>$b2465d41ca8b525b$export$a98a2d834cadecf0);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $ioVpW;
    var $hPkt9;
    const $b2465d41ca8b525b$export$1af4c7e47ad72f44 = 'en-US';
    const $b2465d41ca8b525b$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
        var _ref, _ref2;
        const commonCoreI18nMessages = (0, (0, parcelRequire("hPkt9")).useLazyI18nMessages)(locale, (0, (0, parcelRequire("ioVpW")).default));
        if (!commonCoreI18nMessages) return null;
        const { language: language, country: country } = (0, (0, parcelRequire("hPkt9")).getCodesFromLocale)(locale);
        const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
        const aggregateMessages = {
            ...commonCoreI18nMessages,
            ...messages
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: aggregateMessages,
            locale: country ? `${language}-${country}` : language,
            defaultLocale: $b2465d41ca8b525b$export$1af4c7e47ad72f44,
            defaultRichTextElements: {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks),
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("strong", null, chunks)
            }
        }, children);
    };
    const $b2465d41ca8b525b$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b2465d41ca8b525b$export$23e25b3437f9c000, {
                i18nMessages: i18nMessages,
                locale: intl.locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
});
parcelRegister("hPkt9", function(module, exports) {
    $parcel$export(module.exports, "getCodesFromLocale", ()=>$cfa713d6b7186a1c$export$4d25b49b6dc1b540);
    $parcel$export(module.exports, "useLazyI18nMessages", ()=>$cfa713d6b7186a1c$export$30a7082641f381ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $fiX4W;
    const $cfa713d6b7186a1c$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
    const $cfa713d6b7186a1c$export$4d25b49b6dc1b540 = (locale)=>{
        let match = $cfa713d6b7186a1c$var$localeRegex.exec(locale);
        if (!match) {
            console.error('Unable to get language and country from invalid locale, falling back to default locale.');
            match = $cfa713d6b7186a1c$var$localeRegex.exec((0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE));
        }
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    };
    const $cfa713d6b7186a1c$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
        var _await$default, _await, _ref;
        const { language: language, country: country } = $cfa713d6b7186a1c$export$4d25b49b6dc1b540(locale);
        return (_await$default = (_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
    };
    const $cfa713d6b7186a1c$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            $cfa713d6b7186a1c$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
        }, [
            locale,
            setMessages,
            lazyI18nMessages
        ]);
        return messages;
    };
});
parcelRegister("8v3RR", function(module, exports) {
    $parcel$export(module.exports, "NoticeDialog", ()=>$63043807ff653784$export$7ccde09c2c5f5940);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $abT4b;
    var $fsAfP;
    var $7fcWf;
    var $42b2A;
    const $63043807ff653784$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
        const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
        const actions = [];
        if (isErrorNotice) ;
        else if (confirmLink) actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close]),
            onClick: ()=>handleClose(false),
            appearance: 'subtle'
        });
        else actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Cancel]),
            onClick: ()=>handleClose(false),
            appearance: 'subtle'
        });
        const primaryButtonAppearance = appearance || 'primary';
        if (confirmLink) actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), confirmText),
            href: confirmLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            appearance: primaryButtonAppearance
        });
        else actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), confirmText),
            onClick: ()=>handleClose(true),
            appearance: primaryButtonAppearance
        });
        let onOpenCompleteF;
        if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
            overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onOpenComplete: onOpenCompleteF,
            onClose: ()=>handleClose(),
            shouldCloseOnOverlayClick: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42b2A")).ModalTitleContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: appearance
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, title, {
            values: titleVars
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, message, {
            values: messageVars
        }))), isErrorNotice && (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations1]), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abT4b")).PfLink), {
            href: "http://links.thinktilt.net/error-explanations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations2])), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations3]), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abT4b")).PfLink), {
            href: "https://support.thinktilt.com/"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fsAfP")).ErrorSection), {
            errorDetails: errorDetails
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, actions.map(({ text: text, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), props, text))));
    };
});
parcelRegister("abT4b", function(module, exports) {
    $parcel$export(module.exports, "PfLink", ()=>$76b5a57dfb2cdc0a$export$9522c077a5f2be27);
    var $5uXOq = parcelRequire("5uXOq");
    const $76b5a57dfb2cdc0a$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: href,
            id: id,
            rel: popup ? 'noreferrer noopener' : undefined,
            target: popup ? '_blank' : undefined,
            onClick: onClick
        }, children);
    };
});
parcelRegister("fsAfP", function(module, exports) {
    $parcel$export(module.exports, "ErrorSection", ()=>$b41597dfedacbba9$export$b0bceea2ea86179a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $dTlW6;
    const $b41597dfedacbba9$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
        const [showErrorDetails, setShowErrorDetails] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorSectionLabel, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, "Show error details:"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            isChecked: showErrorDetails,
            onChange: ()=>{
                setShowErrorDetails(!showErrorDetails);
            }
        })), showErrorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorDetailsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("code", null, errorDetails)));
    };
    const $b41597dfedacbba9$var$ErrorSectionLabel = (0, $dAHxw.default).div({
        display: 'flex',
        marginTop: "var(--ds-space-250, 20px)",
        '> p': {
            marginTop: "var(--ds-space-025, 2px)"
        }
    });
    const $b41597dfedacbba9$var$ErrorDetailsWrapper = (0, $dAHxw.default).div({
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        padding: "var(--ds-space-100, 8px)",
        fontSize: '12px'
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("42b2A", function(module, exports) {
    $parcel$export(module.exports, "ModalTitleContainer", ()=>$2effe9ca9018cbff$export$8bbe98d958a85a9d);
    var $dAHxw = parcelRequire("dAHxw");
    const $2effe9ca9018cbff$export$8bbe98d958a85a9d = (0, $dAHxw.default).span({
        'h1, h1 > span': {
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: 1
        }
    });
});
parcelRegister("gFGsm", function(module, exports) {
    $parcel$export(module.exports, "LiveErrorUtils", ()=>$c23168a474488ad4$export$f2a509cffb92cb9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $31NxU;
    var $3kk8J;
    var $8vvJk;
    var $ousew;
    var $7nnPp;
    var $h8yj2;
    var $aIZdc;
    var $9e9ba;
    var $erWXD;
    var $bRqoO;
    var $fxMku;
    const $c23168a474488ad4$var$TAGS = [
        'module',
        'actionSubject',
        'url'
    ];
    const $c23168a474488ad4$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
    const $c23168a474488ad4$var$SENTRY_PROJECT_ID = '6388218';
    const $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
    const $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
    const $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN = (0, (0, parcelRequire("aIZdc")).isFedRamp)() ? $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN : $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN;
    class $c23168a474488ad4$export$f2a509cffb92cb9c {
        constructor(moduleName, showFlag, createAnalyticsEvent, environment){
            this.moduleName = void 0;
            this.showFlag = void 0;
            this.createAnalyticsEvent = void 0;
            this.sentryHub = void 0;
            this.environment = void 0;
            this.moduleName = moduleName;
            this.showFlag = showFlag;
            this.createAnalyticsEvent = createAnalyticsEvent;
            this.environment = environment;
            this.sentryHub = this.getSentryHub(environment);
        }
        reportError(error, options) {
            var _options$actionSubjec;
            const errorPrefix = `Proforma(${this.moduleName}): `;
            const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, (0, parcelRequire("8vvJk")).Severity).Error;
            switch(severity){
                case (0, (0, parcelRequire("8vvJk")).Severity).Warning:
                    console.warn(errorPrefix, error);
                    break;
                case (0, (0, parcelRequire("8vvJk")).Severity).Info:
                    console.info(errorPrefix, error);
                    break;
                default:
                    console.error(errorPrefix, error);
                    break;
            }
            const actionSubject = (_options$actionSubjec = options === null || options === void 0 ? void 0 : options.actionSubject) !== null && _options$actionSubjec !== void 0 ? _options$actionSubjec : (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_UI;
            const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                    key,
                    typeof value === 'string' ? (0, (0, parcelRequire("9e9ba")).maskEmailIds)(value) : value
                ]));
            const details = {
                actionSubject: actionSubject,
                errorId: options === null || options === void 0 ? void 0 : options.id,
                severity: severity,
                module: this.moduleName,
                errorMsg: error.message,
                errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
                isClientFetchError: error.isClientFetchError,
                requestName: error.requestName,
                traceId: error.traceId,
                status: error.status,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl(),
                ...attributes
            };
            (0, (0, parcelRequire("h8yj2")).fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, details);
            if (this.environment === (0, (0, parcelRequire("fxMku")).Environment).LOCAL || this.sentryHub === undefined) return;
            const sentryHub = this.sentryHub;
            sentryHub.withScope((scope)=>{
                scope.setLevel(severity);
                Object.keys(details).forEach((key)=>{
                    const value = details[key];
                    if (value) {
                        if ($c23168a474488ad4$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                        else scope.setExtra(key, value);
                    }
                });
                sentryHub.captureException(error);
            });
        }
        notifyUser(errorNotice, customDescription) {
            const notice = (0, (0, parcelRequire("bRqoO")).Notices)[errorNotice];
            if (notice) {
                this.showFlag({
                    appearance: 'error',
                    isAutoDismiss: true,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                        label: "",
                        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                    }),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), notice.title),
                    description: customDescription ? customDescription : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), notice.message)
                });
                return Promise.resolve();
            } else {
                console.error(`Could not show error, notice type ${errorNotice} does not exist`);
                return Promise.reject();
            }
        }
        getSentryHub(environment) {
            try {
                const client = new (0, (0, parcelRequire("31NxU")).BrowserClient)({
                    environment: environment,
                    dsn: $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN
                });
                return new (0, (0, parcelRequire("3kk8J")).Hub)(client);
            } catch (error) {
                const actionSubject = 'getProformaSentryHub';
                const details = {
                    actionSubject: actionSubject,
                    severity: (0, (0, parcelRequire("8vvJk")).Severity).Error,
                    module: this.moduleName,
                    errorMsg: error.message,
                    userAgent: this.getBrowserUserAgent(),
                    url: this.getUrl()
                };
                (0, (0, parcelRequire("h8yj2")).fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, details);
            }
        }
        getBrowserUserAgent() {
            var _window$navigator$use, _window, _window$navigator;
            return (_window$navigator$use = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : 'unknown';
        }
        getUrl() {
            var _window$document$loca, _window2, _window2$document, _window2$document$loc;
            return (_window$document$loca = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : (_window2$document$loc = _window2$document.location) === null || _window2$document$loc === void 0 ? void 0 : _window2$document$loc.host) !== null && _window$document$loca !== void 0 ? _window$document$loca : 'unknown';
        }
    }
});
parcelRegister("31NxU", function(module, exports) {
    $parcel$export(module.exports, "BrowserClient", ()=>$2347e5dedbca2ded$export$1df9218a526d318d);
    var $3VFsf;
    var $fVKZK;
    var $9Up1Q;
    parcelRequire("3xuhl");
    var $eUO5L;
    var $aHQIJ;
    var $1jQdQ;
    var $86ilb;
    var $7n7dK;
    var $3Y2SJ;
    var $2347e5dedbca2ded$export$1df9218a526d318d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BrowserClient, _super);
        function BrowserClient(options) {
            if (options === void 0) options = {};
            var _this = this;
            options._metadata = options._metadata || {};
            options._metadata.sdk = options._metadata.sdk || {
                name: 'sentry.javascript.browser',
                packages: [
                    {
                        name: 'npm:@sentry/browser',
                        version: (0, (0, parcelRequire("9Up1Q")).SDK_VERSION)
                    }
                ],
                version: (0, (0, parcelRequire("9Up1Q")).SDK_VERSION)
            };
            _this = _super.call(this, (0, (0, parcelRequire("1jQdQ")).BrowserBackend), options) || this;
            return _this;
        }
        BrowserClient.prototype.showReportDialog = function(options) {
            if (options === void 0) options = {};
            var document = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().document;
            if (!document) return;
            if (!this._isEnabled()) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Trying to call showReportDialog with Sentry Client disabled');
                return;
            }
            (0, (0, parcelRequire("7n7dK")).injectReportDialog)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                dsn: options.dsn || this.getDsn()
            }));
        };
        BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
            event.platform = event.platform || 'javascript';
            return _super.prototype._prepareEvent.call(this, event, scope, hint);
        };
        BrowserClient.prototype._sendEvent = function(event) {
            var integration = this.getIntegration((0, (0, parcelRequire("3Y2SJ")).Breadcrumbs));
            if (integration) integration.addSentryBreadcrumb(event);
            _super.prototype._sendEvent.call(this, event);
        };
        return BrowserClient;
    }((0, (0, parcelRequire("fVKZK")).BaseClient));
});
parcelRegister("fVKZK", function(module, exports) {
    $parcel$export(module.exports, "BaseClient", ()=>$b990a217eb724e06$export$4f22f74eddb7716a);
    var $3VFsf;
    var $gfYRq;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $gI8Be;
    var $okkfE;
    var $aHQIJ;
    var $ha3jm;
    var $gBQwe;
    var $4mVTs;
    var $f7sqx;
    var $keOcA;
    var $3knVN;
    var $bYhbK;
    var $b990a217eb724e06$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
    var $b990a217eb724e06$export$4f22f74eddb7716a = function() {
        function BaseClient(backendClass, options) {
            this._integrations = {};
            this._numProcessing = 0;
            this._backend = new backendClass(options);
            this._options = options;
            if (options.dsn) this._dsn = (0, (0, parcelRequire("ha3jm")).makeDsn)(options.dsn);
        }
        BaseClient.prototype.captureException = function(exception, hint, scope) {
            var _this = this;
            if ((0, (0, parcelRequire("1vYJz")).checkOrSetAlreadyCaught)(exception)) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
                return;
            }
            var eventId = hint && hint.event_id;
            this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
                return _this._captureEvent(event, hint, scope);
            }).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
            var _this = this;
            var eventId = hint && hint.event_id;
            var promisedEvent = (0, (0, parcelRequire("okkfE")).isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
            this._process(promisedEvent.then(function(event) {
                return _this._captureEvent(event, hint, scope);
            }).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureEvent = function(event, hint, scope) {
            if (hint && hint.originalException && (0, (0, parcelRequire("1vYJz")).checkOrSetAlreadyCaught)(hint.originalException)) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
                return;
            }
            var eventId = hint && hint.event_id;
            this._process(this._captureEvent(event, hint, scope).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureSession = function(session) {
            if (!this._isEnabled()) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('SDK not enabled, will not capture session.');
                return;
            }
            if (!(typeof session.release === 'string')) (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Discarded session because of missing or non-string release');
            else {
                this._sendSession(session);
                session.update({
                    init: false
                });
            }
        };
        BaseClient.prototype.getDsn = function() {
            return this._dsn;
        };
        BaseClient.prototype.getOptions = function() {
            return this._options;
        };
        BaseClient.prototype.getTransport = function() {
            return this._getBackend().getTransport();
        };
        BaseClient.prototype.flush = function(timeout) {
            var _this = this;
            return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                return _this.getTransport().close(timeout).then(function(transportFlushed) {
                    return clientFinished && transportFlushed;
                });
            });
        };
        BaseClient.prototype.close = function(timeout) {
            var _this = this;
            return this.flush(timeout).then(function(result) {
                _this.getOptions().enabled = false;
                return result;
            });
        };
        BaseClient.prototype.setupIntegrations = function() {
            if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, (0, parcelRequire("bYhbK")).setupIntegrations)(this._options);
        };
        BaseClient.prototype.getIntegration = function(integration) {
            try {
                return this._integrations[integration.id] || null;
            } catch (_oO) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
                return null;
            }
        };
        BaseClient.prototype._updateSessionFromEvent = function(session, event) {
            var e_1, _a;
            var crashed = false;
            var errored = false;
            var exceptions = event.exception && event.exception.values;
            if (exceptions) {
                errored = true;
                try {
                    for(var exceptions_1 = (0, (0, parcelRequire("3VFsf")).__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                        var ex = exceptions_1_1.value;
                        var mechanism = ex.mechanism;
                        if (mechanism && mechanism.handled === false) {
                            crashed = true;
                            break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
            var sessionNonTerminal = session.status === 'ok';
            var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
            if (shouldUpdateAndSend) {
                session.update((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, crashed && {
                    status: 'crashed'
                }), {
                    errors: session.errors || Number(errored || crashed)
                }));
                this.captureSession(session);
            }
        };
        BaseClient.prototype._sendSession = function(session) {
            this._getBackend().sendSession(session);
        };
        BaseClient.prototype._isClientDoneProcessing = function(timeout) {
            var _this = this;
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve) {
                var ticked = 0;
                var tick = 1;
                var interval = setInterval(function() {
                    if (_this._numProcessing == 0) {
                        clearInterval(interval);
                        resolve(true);
                    } else {
                        ticked += tick;
                        if (timeout && ticked >= timeout) {
                            clearInterval(interval);
                            resolve(false);
                        }
                    }
                }, tick);
            });
        };
        BaseClient.prototype._getBackend = function() {
            return this._backend;
        };
        BaseClient.prototype._isEnabled = function() {
            return this.getOptions().enabled !== false && this._dsn !== undefined;
        };
        BaseClient.prototype._prepareEvent = function(event, scope, hint) {
            var _this = this;
            var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
            var prepared = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event), {
                event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)()),
                timestamp: event.timestamp || (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)()
            });
            this._applyClientOptions(prepared);
            this._applyIntegrationsMetadata(prepared);
            var finalScope = scope;
            if (hint && hint.captureContext) finalScope = (0, (0, parcelRequire("gfYRq")).Scope).clone(finalScope).update(hint.captureContext);
            var result = (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(prepared);
            if (finalScope) result = finalScope.applyToEvent(prepared, hint);
            return result.then(function(evt) {
                if (evt) evt.sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, evt.sdkProcessingMetadata), {
                    normalizeDepth: (0, (0, parcelRequire("gBQwe")).normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
                });
                if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
                return evt;
            });
        };
        BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
            if (!event) return null;
            var normalized = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event), event.breadcrumbs && {
                breadcrumbs: event.breadcrumbs.map(function(b) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, b), b.data && {
                        data: (0, (0, parcelRequire("gBQwe")).normalize)(b.data, depth, maxBreadth)
                    });
                })
            }), event.user && {
                user: (0, (0, parcelRequire("gBQwe")).normalize)(event.user, depth, maxBreadth)
            }), event.contexts && {
                contexts: (0, (0, parcelRequire("gBQwe")).normalize)(event.contexts, depth, maxBreadth)
            }), event.extra && {
                extra: (0, (0, parcelRequire("gBQwe")).normalize)(event.extra, depth, maxBreadth)
            });
            if (event.contexts && event.contexts.trace) normalized.contexts.trace = event.contexts.trace;
            normalized.sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, normalized.sdkProcessingMetadata), {
                baseClientNormalized: true
            });
            return normalized;
        };
        BaseClient.prototype._applyClientOptions = function(event) {
            var options = this.getOptions();
            var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
            if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
            if (event.release === undefined && release !== undefined) event.release = release;
            if (event.dist === undefined && dist !== undefined) event.dist = dist;
            if (event.message) event.message = (0, (0, parcelRequire("keOcA")).truncate)(event.message, maxValueLength);
            var exception = event.exception && event.exception.values && event.exception.values[0];
            if (exception && exception.value) exception.value = (0, (0, parcelRequire("keOcA")).truncate)(exception.value, maxValueLength);
            var request = event.request;
            if (request && request.url) request.url = (0, (0, parcelRequire("keOcA")).truncate)(request.url, maxValueLength);
        };
        BaseClient.prototype._applyIntegrationsMetadata = function(event) {
            var integrationsArray = Object.keys(this._integrations);
            if (integrationsArray.length > 0) {
                event.sdk = event.sdk || {};
                event.sdk.integrations = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.integrations || [], integrationsArray);
            }
        };
        BaseClient.prototype._sendEvent = function(event) {
            this._getBackend().sendEvent(event);
        };
        BaseClient.prototype._captureEvent = function(event, hint, scope) {
            return this._processEvent(event, hint, scope).then(function(finalEvent) {
                return finalEvent.event_id;
            }, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error(reason);
                return undefined;
            });
        };
        BaseClient.prototype._processEvent = function(event, hint, scope) {
            var _this = this;
            var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
            var transport = this.getTransport();
            function recordLostEvent(outcome, category) {
                if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
            }
            if (!this._isEnabled()) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)('SDK not enabled, will not capture event.'));
            var isTransaction = event.type === 'transaction';
            if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
                recordLostEvent('sample_rate', 'event');
                return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
            }
            return this._prepareEvent(event, scope, hint).then(function(prepared) {
                if (prepared === null) {
                    recordLostEvent('event_processor', event.type || 'event');
                    throw new (0, (0, parcelRequire("f7sqx")).SentryError)('An event processor returned null, will not send event.');
                }
                var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                if (isInternalException || isTransaction || !beforeSend) return prepared;
                var beforeSendResult = beforeSend(prepared, hint);
                return $b990a217eb724e06$var$_ensureBeforeSendRv(beforeSendResult);
            }).then(function(processedEvent) {
                if (processedEvent === null) {
                    recordLostEvent('before_send', event.type || 'event');
                    throw new (0, (0, parcelRequire("f7sqx")).SentryError)('`beforeSend` returned `null`, will not send event.');
                }
                var session = scope && scope.getSession && scope.getSession();
                if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
                _this._sendEvent(processedEvent);
                return processedEvent;
            }).then(null, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) throw reason;
                _this.captureException(reason, {
                    data: {
                        __sentry__: true
                    },
                    originalException: reason
                });
                throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
            });
        };
        BaseClient.prototype._process = function(promise) {
            var _this = this;
            this._numProcessing += 1;
            promise.then(function(value) {
                _this._numProcessing -= 1;
                return value;
            }, function(reason) {
                _this._numProcessing -= 1;
                return reason;
            });
        };
        return BaseClient;
    }();
    function $b990a217eb724e06$var$_ensureBeforeSendRv(rv) {
        var nullErr = '`beforeSend` method has to return `null` or a valid event.';
        if ((0, (0, parcelRequire("okkfE")).isThenable)(rv)) return rv.then(function(event) {
            if (!((0, (0, parcelRequire("okkfE")).isPlainObject)(event) || event === null)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)(nullErr);
            return event;
        }, function(e) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)("beforeSend rejected with " + e);
        });
        else if (!((0, (0, parcelRequire("okkfE")).isPlainObject)(rv) || rv === null)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)(nullErr);
        return rv;
    }
});
parcelRegister("gfYRq", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$bd5d41be26a98453$export$775b6bb06e53a214);
    $parcel$export(module.exports, "addGlobalEventProcessor", ()=>$bd5d41be26a98453$export$8e4e25f54d456511);
    var $3VFsf;
    parcelRequire("2zyAl");
    var $gI8Be;
    var $eUO5L;
    var $okkfE;
    var $4mVTs;
    var $bd5d41be26a98453$var$MAX_BREADCRUMBS = 100;
    var $bd5d41be26a98453$export$775b6bb06e53a214 = function() {
        function Scope() {
            this._notifyingListeners = false;
            this._scopeListeners = [];
            this._eventProcessors = [];
            this._breadcrumbs = [];
            this._user = {};
            this._tags = {};
            this._extra = {};
            this._contexts = {};
            this._sdkProcessingMetadata = {};
        }
        Scope.clone = function(scope) {
            var newScope = new Scope();
            if (scope) {
                newScope._breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(scope._breadcrumbs);
                newScope._tags = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._tags);
                newScope._extra = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._extra);
                newScope._contexts = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._contexts);
                newScope._user = scope._user;
                newScope._level = scope._level;
                newScope._span = scope._span;
                newScope._session = scope._session;
                newScope._transactionName = scope._transactionName;
                newScope._fingerprint = scope._fingerprint;
                newScope._eventProcessors = (0, (0, parcelRequire("3VFsf")).__spread)(scope._eventProcessors);
                newScope._requestSession = scope._requestSession;
            }
            return newScope;
        };
        Scope.prototype.addScopeListener = function(callback) {
            this._scopeListeners.push(callback);
        };
        Scope.prototype.addEventProcessor = function(callback) {
            this._eventProcessors.push(callback);
            return this;
        };
        Scope.prototype.setUser = function(user) {
            this._user = user || {};
            if (this._session) this._session.update({
                user: user
            });
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getUser = function() {
            return this._user;
        };
        Scope.prototype.getRequestSession = function() {
            return this._requestSession;
        };
        Scope.prototype.setRequestSession = function(requestSession) {
            this._requestSession = requestSession;
            return this;
        };
        Scope.prototype.setTags = function(tags) {
            this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), tags);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTag = function(key, value) {
            var _a;
            this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setExtras = function(extras) {
            this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), extras);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setExtra = function(key, extra) {
            var _a;
            this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setFingerprint = function(fingerprint) {
            this._fingerprint = fingerprint;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setLevel = function(level) {
            this._level = level;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTransactionName = function(name) {
            this._transactionName = name;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTransaction = function(name) {
            return this.setTransactionName(name);
        };
        Scope.prototype.setContext = function(key, context) {
            var _a;
            if (context === null) delete this._contexts[key];
            else this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setSpan = function(span) {
            this._span = span;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getSpan = function() {
            return this._span;
        };
        Scope.prototype.getTransaction = function() {
            var span = this.getSpan();
            return span && span.transaction;
        };
        Scope.prototype.setSession = function(session) {
            if (!session) delete this._session;
            else this._session = session;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getSession = function() {
            return this._session;
        };
        Scope.prototype.update = function(captureContext) {
            if (!captureContext) return this;
            if (typeof captureContext === 'function') {
                var updatedScope = captureContext(this);
                return updatedScope instanceof Scope ? updatedScope : this;
            }
            if (captureContext instanceof Scope) {
                this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), captureContext._tags);
                this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), captureContext._extra);
                this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), captureContext._contexts);
                if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
                if (captureContext._level) this._level = captureContext._level;
                if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
                if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            } else if ((0, (0, parcelRequire("okkfE")).isPlainObject)(captureContext)) {
                captureContext;
                this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), captureContext.tags);
                this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), captureContext.extra);
                this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), captureContext.contexts);
                if (captureContext.user) this._user = captureContext.user;
                if (captureContext.level) this._level = captureContext.level;
                if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
                if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            }
            return this;
        };
        Scope.prototype.clear = function() {
            this._breadcrumbs = [];
            this._tags = {};
            this._extra = {};
            this._user = {};
            this._contexts = {};
            this._level = undefined;
            this._transactionName = undefined;
            this._fingerprint = undefined;
            this._requestSession = undefined;
            this._span = undefined;
            this._session = undefined;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
            var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $bd5d41be26a98453$var$MAX_BREADCRUMBS) : $bd5d41be26a98453$var$MAX_BREADCRUMBS;
            if (maxCrumbs <= 0) return this;
            var mergedBreadcrumb = (0, (0, parcelRequire("3VFsf")).__assign)({
                timestamp: (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)()
            }, breadcrumb);
            this._breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(this._breadcrumbs, [
                mergedBreadcrumb
            ]).slice(-maxCrumbs);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.clearBreadcrumbs = function() {
            this._breadcrumbs = [];
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.applyToEvent = function(event, hint) {
            if (this._extra && Object.keys(this._extra).length) event.extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), event.extra);
            if (this._tags && Object.keys(this._tags).length) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), event.tags);
            if (this._user && Object.keys(this._user).length) event.user = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._user), event.user);
            if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), event.contexts);
            if (this._level) event.level = this._level;
            if (this._transactionName) event.transaction = this._transactionName;
            if (this._span) {
                event.contexts = (0, (0, parcelRequire("3VFsf")).__assign)({
                    trace: this._span.getTraceContext()
                }, event.contexts);
                var transactionName = this._span.transaction && this._span.transaction.name;
                if (transactionName) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)({
                    transaction: transactionName
                }, event.tags);
            }
            this._applyFingerprint(event);
            event.breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(event.breadcrumbs || [], this._breadcrumbs);
            event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
            event.sdkProcessingMetadata = this._sdkProcessingMetadata;
            return this._notifyEventProcessors((0, (0, parcelRequire("3VFsf")).__spread)($bd5d41be26a98453$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
        };
        Scope.prototype.setSDKProcessingMetadata = function(newData) {
            this._sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._sdkProcessingMetadata), newData);
            return this;
        };
        Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
            var _this = this;
            if (index === void 0) index = 0;
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                var processor = processors[index];
                if (event === null || typeof processor !== 'function') resolve(event);
                else {
                    var result = processor((0, (0, parcelRequire("3VFsf")).__assign)({}, event), hint);
                    if ((0, (0, parcelRequire("okkfE")).isThenable)(result)) result.then(function(final) {
                        return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                    }).then(null, reject);
                    else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
                }
            });
        };
        Scope.prototype._notifyScopeListeners = function() {
            var _this = this;
            if (!this._notifyingListeners) {
                this._notifyingListeners = true;
                this._scopeListeners.forEach(function(callback) {
                    callback(_this);
                });
                this._notifyingListeners = false;
            }
        };
        Scope.prototype._applyFingerprint = function(event) {
            event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
                event.fingerprint
            ] : [];
            if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
            if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
        };
        return Scope;
    }();
    function $bd5d41be26a98453$var$getGlobalEventProcessors() {
        return (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('globalEventProcessors', function() {
            return [];
        });
    }
    function $bd5d41be26a98453$export$8e4e25f54d456511(callback) {
        $bd5d41be26a98453$var$getGlobalEventProcessors().push(callback);
    }
});
parcelRegister("2zyAl", function(module, exports) {
    $parcel$export(module.exports, "getGlobalObject", ()=>(parcelRequire("eUO5L")).getGlobalObject);
    $parcel$export(module.exports, "getGlobalSingleton", ()=>(parcelRequire("eUO5L")).getGlobalSingleton);
    $parcel$export(module.exports, "isPlainObject", ()=>(parcelRequire("okkfE")).isPlainObject);
    $parcel$export(module.exports, "isThenable", ()=>(parcelRequire("okkfE")).isThenable);
    $parcel$export(module.exports, "consoleSandbox", ()=>(parcelRequire("aHQIJ")).consoleSandbox);
    $parcel$export(module.exports, "logger", ()=>(parcelRequire("aHQIJ")).logger);
    $parcel$export(module.exports, "uuid4", ()=>(parcelRequire("1vYJz")).uuid4);
    $parcel$export(module.exports, "dropUndefinedKeys", ()=>(parcelRequire("59M0S")).dropUndefinedKeys);
    $parcel$export(module.exports, "SyncPromise", ()=>(parcelRequire("4mVTs")).SyncPromise);
    parcelRequire("eUO5L");
    parcelRequire("okkfE");
    parcelRequire("aHQIJ");
    parcelRequire("1vYJz");
    var $3kiq9;
    parcelRequire("59M0S");
    parcelRequire("4mVTs");
    var $gI8Be;
    $parcel$exportWildcard(module.exports, (0, parcelRequire("3kiq9")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("gI8Be")));
});
parcelRegister("eUO5L", function(module, exports) {
    $parcel$export(module.exports, "getGlobalObject", ()=>$adbd26dd4cdaba08$export$256479dc0cea61c4);
    $parcel$export(module.exports, "getGlobalSingleton", ()=>$adbd26dd4cdaba08$export$7e223ec222791509);
    var $3kiq9;
    var $adbd26dd4cdaba08$var$fallbackGlobalObject = {};
    function $adbd26dd4cdaba08$export$256479dc0cea61c4() {
        return (0, (0, parcelRequire("3kiq9")).isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $adbd26dd4cdaba08$var$fallbackGlobalObject;
    }
    function $adbd26dd4cdaba08$export$7e223ec222791509(name, creator, obj) {
        var global1 = obj || $adbd26dd4cdaba08$export$256479dc0cea61c4();
        var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
        var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
        return singleton;
    }
});
parcelRegister("3kiq9", function(module, exports) {
    $parcel$export(module.exports, "isNodeEnv", ()=>isNodeEnv, (v)=>isNodeEnv = v);
    $parcel$export(module.exports, "dynamicRequire", ()=>dynamicRequire, (v)=>dynamicRequire = v);
    var $diNsD;
    var $6cAn5 = parcelRequire("6cAn5");
    function isNodeEnv() {
        return !(0, (0, parcelRequire("diNsD")).isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
    }
    function dynamicRequire(mod, request) {
        return mod.require(request);
    }
    function loadModule(moduleName) {
        var mod;
        try {
            mod = dynamicRequire(module, moduleName);
        } catch (e) {}
        try {
            var cwd = dynamicRequire(module, 'process').cwd;
            mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
        } catch (e) {}
        return mod;
    }
});
parcelRegister("diNsD", function(module, exports) {
    $parcel$export(module.exports, "isBrowserBundle", ()=>$9af352b66430744d$export$2928c40372e623c0);
    function $9af352b66430744d$export$2928c40372e623c0() {
        return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
    }
});
parcelRegister("okkfE", function(module, exports) {
    $parcel$export(module.exports, "isError", ()=>$04920240eebc235f$export$e6127cc7fe7395c3);
    $parcel$export(module.exports, "isInstanceOf", ()=>$04920240eebc235f$export$49034edbe6b62415);
    $parcel$export(module.exports, "isErrorEvent", ()=>$04920240eebc235f$export$9f9636d330b71954);
    $parcel$export(module.exports, "isDOMError", ()=>$04920240eebc235f$export$ef9e2056653f0c8e);
    $parcel$export(module.exports, "isDOMException", ()=>$04920240eebc235f$export$12e869b2a583f783);
    $parcel$export(module.exports, "isString", ()=>$04920240eebc235f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isPrimitive", ()=>$04920240eebc235f$export$c3825b437cbdea5c);
    $parcel$export(module.exports, "isPlainObject", ()=>$04920240eebc235f$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "isEvent", ()=>$04920240eebc235f$export$9671ea99bd126ace);
    $parcel$export(module.exports, "isElement", ()=>$04920240eebc235f$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isRegExp", ()=>$04920240eebc235f$export$49841c62b9eff15);
    $parcel$export(module.exports, "isThenable", ()=>$04920240eebc235f$export$f5b060c2914b97c8);
    $parcel$export(module.exports, "isSyntheticEvent", ()=>$04920240eebc235f$export$bc2894c7158efbac);
    $parcel$export(module.exports, "isNaN", ()=>$04920240eebc235f$export$c9f5652083b8129d);
    var $04920240eebc235f$var$objectToString = Object.prototype.toString;
    function $04920240eebc235f$export$e6127cc7fe7395c3(wat) {
        switch($04920240eebc235f$var$objectToString.call(wat)){
            case '[object Error]':
            case '[object Exception]':
            case '[object DOMException]':
                return true;
            default:
                return $04920240eebc235f$export$49034edbe6b62415(wat, Error);
        }
    }
    function $04920240eebc235f$var$isBuiltin(wat, ty) {
        return $04920240eebc235f$var$objectToString.call(wat) === "[object " + ty + "]";
    }
    function $04920240eebc235f$export$9f9636d330b71954(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'ErrorEvent');
    }
    function $04920240eebc235f$export$ef9e2056653f0c8e(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'DOMError');
    }
    function $04920240eebc235f$export$12e869b2a583f783(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'DOMException');
    }
    function $04920240eebc235f$export$844ec244b1367d54(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'String');
    }
    function $04920240eebc235f$export$c3825b437cbdea5c(wat) {
        return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
    }
    function $04920240eebc235f$export$53b83ca8eaab0383(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'Object');
    }
    function $04920240eebc235f$export$9671ea99bd126ace(wat) {
        return typeof Event !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Event);
    }
    function $04920240eebc235f$export$45a5e7f76e0caa8d(wat) {
        return typeof Element !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Element);
    }
    function $04920240eebc235f$export$49841c62b9eff15(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'RegExp');
    }
    function $04920240eebc235f$export$f5b060c2914b97c8(wat) {
        return Boolean(wat && wat.then && typeof wat.then === 'function');
    }
    function $04920240eebc235f$export$bc2894c7158efbac(wat) {
        return $04920240eebc235f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
    }
    function $04920240eebc235f$export$c9f5652083b8129d(wat) {
        return typeof wat === 'number' && wat !== wat;
    }
    function $04920240eebc235f$export$49034edbe6b62415(wat, base) {
        try {
            return wat instanceof base;
        } catch (_e) {
            return false;
        }
    }
});
parcelRegister("aHQIJ", function(module, exports) {
    $parcel$export(module.exports, "CONSOLE_LEVELS", ()=>$7cb6d0bbf859a350$export$2a2b1d2252a69ecb);
    $parcel$export(module.exports, "consoleSandbox", ()=>$7cb6d0bbf859a350$export$cda52e2a8927a2ca);
    $parcel$export(module.exports, "logger", ()=>$7cb6d0bbf859a350$export$af88d00dbe7f521);
    var $3VFsf;
    var $1pUkh;
    var $eUO5L;
    var $7cb6d0bbf859a350$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $7cb6d0bbf859a350$var$PREFIX = 'Sentry Logger ';
    var $7cb6d0bbf859a350$export$2a2b1d2252a69ecb = [
        'debug',
        'info',
        'warn',
        'error',
        'log',
        'assert'
    ];
    function $7cb6d0bbf859a350$export$cda52e2a8927a2ca(callback) {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        if (!('console' in global)) return callback();
        var originalConsole = global.console;
        var wrappedLevels = {};
        $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(level) {
            var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
            if (level in global.console && originalWrappedFunc) {
                wrappedLevels[level] = originalConsole[level];
                originalConsole[level] = originalWrappedFunc;
            }
        });
        try {
            return callback();
        } finally{
            Object.keys(wrappedLevels).forEach(function(level) {
                originalConsole[level] = wrappedLevels[level];
            });
        }
    }
    function $7cb6d0bbf859a350$var$makeLogger() {
        var enabled = false;
        var logger = {
            enable: function() {
                enabled = true;
            },
            disable: function() {
                enabled = false;
            }
        };
        if (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
            logger[name] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (enabled) $7cb6d0bbf859a350$export$cda52e2a8927a2ca(function() {
                    var _a;
                    (_a = $7cb6d0bbf859a350$var$global.console)[name].apply(_a, (0, (0, parcelRequire("3VFsf")).__spread)([
                        $7cb6d0bbf859a350$var$PREFIX + "[" + name + "]:"
                    ], args));
                });
            };
        });
        else $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
            logger[name] = function() {
                return undefined;
            };
        });
        return logger;
    }
    var $7cb6d0bbf859a350$export$af88d00dbe7f521;
    if (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$af88d00dbe7f521 = (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('logger', $7cb6d0bbf859a350$var$makeLogger);
    else $7cb6d0bbf859a350$export$af88d00dbe7f521 = $7cb6d0bbf859a350$var$makeLogger();
});
parcelRegister("1pUkh", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$1083d16d6e02eb4b$export$48a8984ec0bf2e44);
    var $1083d16d6e02eb4b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("1vYJz", function(module, exports) {
    $parcel$export(module.exports, "uuid4", ()=>$11a7cc3993e3d0c3$export$19f53698e68b2496);
    $parcel$export(module.exports, "parseUrl", ()=>$11a7cc3993e3d0c3$export$7a5253c0f62e0150);
    $parcel$export(module.exports, "getEventDescription", ()=>$11a7cc3993e3d0c3$export$4157119e2b157127);
    $parcel$export(module.exports, "addExceptionTypeValue", ()=>$11a7cc3993e3d0c3$export$f26508487bf83ee7);
    $parcel$export(module.exports, "addExceptionMechanism", ()=>$11a7cc3993e3d0c3$export$c69a9a0313b03bb1);
    $parcel$export(module.exports, "checkOrSetAlreadyCaught", ()=>$11a7cc3993e3d0c3$export$6de4ffac6a2f1098);
    var $3VFsf;
    var $eUO5L;
    var $59M0S;
    var $keOcA;
    function $11a7cc3993e3d0c3$export$19f53698e68b2496() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var crypto = global.crypto || global.msCrypto;
        if (!(crypto === void 0) && crypto.getRandomValues) {
            var arr = new Uint16Array(8);
            crypto.getRandomValues(arr);
            arr[3] = arr[3] & 0xfff | 0x4000;
            arr[4] = arr[4] & 0x3fff | 0x8000;
            var pad = function(num) {
                var v = num.toString(16);
                while(v.length < 4)v = "0" + v;
                return v;
            };
            return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
        }
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    function $11a7cc3993e3d0c3$export$7a5253c0f62e0150(url) {
        if (!url) return {};
        var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
        if (!match) return {};
        var query = match[6] || '';
        var fragment = match[8] || '';
        return {
            host: match[4],
            path: match[5],
            protocol: match[2],
            relative: match[5] + query + fragment
        };
    }
    function $11a7cc3993e3d0c3$var$getFirstException(event) {
        return event.exception && event.exception.values ? event.exception.values[0] : undefined;
    }
    function $11a7cc3993e3d0c3$export$4157119e2b157127(event) {
        var message = event.message, eventId = event.event_id;
        if (message) return message;
        var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
        if (firstException) {
            if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
            return firstException.type || firstException.value || eventId || '<unknown>';
        }
        return eventId || '<unknown>';
    }
    function $11a7cc3993e3d0c3$export$f26508487bf83ee7(event, value, type) {
        var exception = event.exception = event.exception || {};
        var values = exception.values = exception.values || [];
        var firstException = values[0] = values[0] || {};
        if (!firstException.value) firstException.value = value || '';
        if (!firstException.type) firstException.type = type || 'Error';
    }
    function $11a7cc3993e3d0c3$export$c69a9a0313b03bb1(event, newMechanism) {
        var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
        if (!firstException) return;
        var defaultMechanism = {
            type: 'generic',
            handled: true
        };
        var currentMechanism = firstException.mechanism;
        firstException.mechanism = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, defaultMechanism), currentMechanism), newMechanism);
        if (newMechanism && 'data' in newMechanism) {
            var mergedData = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
            firstException.mechanism.data = mergedData;
        }
    }
    var $11a7cc3993e3d0c3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
    function $11a7cc3993e3d0c3$export$d364f2020ab30578(input) {
        var match = input.match($11a7cc3993e3d0c3$var$SEMVER_REGEXP) || [];
        var major = parseInt(match[1], 10);
        var minor = parseInt(match[2], 10);
        var patch = parseInt(match[3], 10);
        return {
            buildmetadata: match[5],
            major: isNaN(major) ? undefined : major,
            minor: isNaN(minor) ? undefined : minor,
            patch: isNaN(patch) ? undefined : patch,
            prerelease: match[4]
        };
    }
    function $11a7cc3993e3d0c3$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
        if (linesOfContext === void 0) linesOfContext = 5;
        var lineno = frame.lineno || 0;
        var maxLines = lines.length;
        var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
        frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
            return (0, (0, parcelRequire("keOcA")).snipLine)(line, 0);
        });
        frame.context_line = (0, (0, parcelRequire("keOcA")).snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
        frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
            return (0, (0, parcelRequire("keOcA")).snipLine)(line, 0);
        });
    }
    function $11a7cc3993e3d0c3$export$ce084c78234bd35(urlPath) {
        return urlPath.split(/[\?#]/, 1)[0];
    }
    function $11a7cc3993e3d0c3$export$6de4ffac6a2f1098(exception) {
        if (exception && exception.__sentry_captured__) return true;
        try {
            (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(exception, '__sentry_captured__', true);
        } catch (err) {}
        return false;
    }
});
parcelRegister("59M0S", function(module, exports) {
    $parcel$export(module.exports, "fill", ()=>$3c130969d9628ee3$export$9563e054e6f787fb);
    $parcel$export(module.exports, "markFunctionWrapped", ()=>$3c130969d9628ee3$export$5c1499e2e5d010ae);
    $parcel$export(module.exports, "addNonEnumerableProperty", ()=>$3c130969d9628ee3$export$e73679ffaf56810e);
    $parcel$export(module.exports, "getOriginalFunction", ()=>$3c130969d9628ee3$export$e6cc1e135e2092e5);
    $parcel$export(module.exports, "urlEncode", ()=>$3c130969d9628ee3$export$9ef804feabbcbaf1);
    $parcel$export(module.exports, "convertToPlainObject", ()=>$3c130969d9628ee3$export$62ff257738bf57f5);
    $parcel$export(module.exports, "extractExceptionKeysForMessage", ()=>$3c130969d9628ee3$export$b0244d5063c0b61b);
    $parcel$export(module.exports, "dropUndefinedKeys", ()=>$3c130969d9628ee3$export$d25f2688db1bb433);
    var $3VFsf;
    var $fB1v8;
    var $okkfE;
    var $keOcA;
    function $3c130969d9628ee3$export$9563e054e6f787fb(source, name, replacementFactory) {
        if (!(name in source)) return;
        var original = source[name];
        var wrapped = replacementFactory(original);
        if (typeof wrapped === 'function') try {
            $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original);
        } catch (_Oo) {}
        source[name] = wrapped;
    }
    function $3c130969d9628ee3$export$e73679ffaf56810e(obj, name, value) {
        Object.defineProperty(obj, name, {
            value: value,
            writable: true,
            configurable: true
        });
    }
    function $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original) {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3c130969d9628ee3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    }
    function $3c130969d9628ee3$export$e6cc1e135e2092e5(func) {
        return func.__sentry_original__;
    }
    function $3c130969d9628ee3$export$9ef804feabbcbaf1(object) {
        return Object.keys(object).map(function(key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
        }).join('&');
    }
    function $3c130969d9628ee3$export$62ff257738bf57f5(value) {
        var newObj = value;
        if ((0, (0, parcelRequire("okkfE")).isError)(value)) newObj = (0, (0, parcelRequire("3VFsf")).__assign)({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, $3c130969d9628ee3$var$getOwnProperties(value));
        else if ((0, (0, parcelRequire("okkfE")).isEvent)(value)) {
            var event_1 = value;
            newObj = (0, (0, parcelRequire("3VFsf")).__assign)({
                type: event_1.type,
                target: $3c130969d9628ee3$var$serializeEventTarget(event_1.target),
                currentTarget: $3c130969d9628ee3$var$serializeEventTarget(event_1.currentTarget)
            }, $3c130969d9628ee3$var$getOwnProperties(event_1));
            if (typeof CustomEvent !== 'undefined' && (0, (0, parcelRequire("okkfE")).isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
        }
        return newObj;
    }
    function $3c130969d9628ee3$var$serializeEventTarget(target) {
        try {
            return (0, (0, parcelRequire("okkfE")).isElement)(target) ? (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(target) : Object.prototype.toString.call(target);
        } catch (_oO) {
            return '<unknown>';
        }
    }
    function $3c130969d9628ee3$var$getOwnProperties(obj) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    }
    function $3c130969d9628ee3$export$b0244d5063c0b61b(exception, maxLength) {
        if (maxLength === void 0) maxLength = 40;
        var keys = Object.keys($3c130969d9628ee3$export$62ff257738bf57f5(exception));
        keys.sort();
        if (!keys.length) return '[object has no keys]';
        if (keys[0].length >= maxLength) return (0, (0, parcelRequire("keOcA")).truncate)(keys[0], maxLength);
        for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
            var serialized = keys.slice(0, includedKeys).join(', ');
            if (serialized.length > maxLength) continue;
            if (includedKeys === keys.length) return serialized;
            return (0, (0, parcelRequire("keOcA")).truncate)(serialized, maxLength);
        }
        return '';
    }
    function $3c130969d9628ee3$export$d25f2688db1bb433(val) {
        var e_1, _a;
        if ((0, (0, parcelRequire("okkfE")).isPlainObject)(val)) {
            var rv = {};
            try {
                for(var _b = (0, (0, parcelRequire("3VFsf")).__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var key = _c.value;
                    if (typeof val[key] !== 'undefined') rv[key] = $3c130969d9628ee3$export$d25f2688db1bb433(val[key]);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return rv;
        }
        if (Array.isArray(val)) return val.map($3c130969d9628ee3$export$d25f2688db1bb433);
        return val;
    }
    function $3c130969d9628ee3$export$92b78acdbe066b6b(wat) {
        var objectified;
        switch(true){
            case wat === undefined || wat === null:
                objectified = new String(wat);
                break;
            case typeof wat === 'symbol' || typeof wat === 'bigint':
                objectified = Object(wat);
                break;
            case (0, (0, parcelRequire("okkfE")).isPrimitive)(wat):
                objectified = new wat.constructor(wat);
                break;
            default:
                objectified = wat;
                break;
        }
        return objectified;
    }
});
parcelRegister("fB1v8", function(module, exports) {
    $parcel$export(module.exports, "htmlTreeAsString", ()=>$b5ab79d71b24e1dd$export$5647df6b7814ac86);
    $parcel$export(module.exports, "getLocationHref", ()=>$b5ab79d71b24e1dd$export$1cfafeee2987818b);
    var $eUO5L;
    var $okkfE;
    function $b5ab79d71b24e1dd$export$5647df6b7814ac86(elem, keyAttrs) {
        try {
            var currentElem = elem;
            var MAX_TRAVERSE_HEIGHT = 5;
            var MAX_OUTPUT_LEN = 80;
            var out = [];
            var height = 0;
            var len = 0;
            var separator = ' > ';
            var sepLength = separator.length;
            var nextStr = void 0;
            while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
                nextStr = $b5ab79d71b24e1dd$var$_htmlElementAsString(currentElem, keyAttrs);
                if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
                out.push(nextStr);
                len += nextStr.length;
                currentElem = currentElem.parentNode;
            }
            return out.reverse().join(separator);
        } catch (_oO) {
            return '<unknown>';
        }
    }
    function $b5ab79d71b24e1dd$var$_htmlElementAsString(el, keyAttrs) {
        var elem = el;
        var out = [];
        var className;
        var classes;
        var key;
        var attr;
        var i;
        if (!elem || !elem.tagName) return '';
        out.push(elem.tagName.toLowerCase());
        var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
            return elem.getAttribute(keyAttr);
        }).map(function(keyAttr) {
            return [
                keyAttr,
                elem.getAttribute(keyAttr)
            ];
        }) : null;
        if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
        else {
            if (elem.id) out.push("#" + elem.id);
            className = elem.className;
            if (className && (0, (0, parcelRequire("okkfE")).isString)(className)) {
                classes = className.split(/\s+/);
                for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
            }
        }
        var allowedAttrs = [
            'type',
            'name',
            'title',
            'alt'
        ];
        for(i = 0; i < allowedAttrs.length; i++){
            key = allowedAttrs[i];
            attr = elem.getAttribute(key);
            if (attr) out.push("[" + key + "=\"" + attr + "\"]");
        }
        return out.join('');
    }
    function $b5ab79d71b24e1dd$export$1cfafeee2987818b() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        try {
            return global.document.location.href;
        } catch (oO) {
            return '';
        }
    }
});
parcelRegister("keOcA", function(module, exports) {
    $parcel$export(module.exports, "truncate", ()=>$ebbc0e804ef05913$export$6a506b36fdea397d);
    $parcel$export(module.exports, "snipLine", ()=>$ebbc0e804ef05913$export$4215662d762d6f9d);
    $parcel$export(module.exports, "safeJoin", ()=>$ebbc0e804ef05913$export$465e9d514283d4fd);
    $parcel$export(module.exports, "isMatchingPattern", ()=>$ebbc0e804ef05913$export$cdded5b28a5f8c6d);
    var $okkfE;
    function $ebbc0e804ef05913$export$6a506b36fdea397d(str, max) {
        if (max === void 0) max = 0;
        if (typeof str !== 'string' || max === 0) return str;
        return str.length <= max ? str : str.substr(0, max) + "...";
    }
    function $ebbc0e804ef05913$export$4215662d762d6f9d(line, colno) {
        var newLine = line;
        var lineLength = newLine.length;
        if (lineLength <= 150) return newLine;
        if (colno > lineLength) colno = lineLength;
        var start = Math.max(colno - 60, 0);
        if (start < 5) start = 0;
        var end = Math.min(start + 140, lineLength);
        if (end > lineLength - 5) end = lineLength;
        if (end === lineLength) start = Math.max(end - 140, 0);
        newLine = newLine.slice(start, end);
        if (start > 0) newLine = "'{snip} " + newLine;
        if (end < lineLength) newLine += ' {snip}';
        return newLine;
    }
    function $ebbc0e804ef05913$export$465e9d514283d4fd(input, delimiter) {
        if (!Array.isArray(input)) return '';
        var output = [];
        for(var i = 0; i < input.length; i++){
            var value = input[i];
            try {
                output.push(String(value));
            } catch (e) {
                output.push('[value cannot be serialized]');
            }
        }
        return output.join(delimiter);
    }
    function $ebbc0e804ef05913$export$cdded5b28a5f8c6d(value, pattern) {
        if (!(0, (0, parcelRequire("okkfE")).isString)(value)) return false;
        if ((0, (0, parcelRequire("okkfE")).isRegExp)(pattern)) return pattern.test(value);
        if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
        return false;
    }
    function $ebbc0e804ef05913$export$466fc863a824cea6(regexString) {
        return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
    }
});
parcelRegister("4mVTs", function(module, exports) {
    $parcel$export(module.exports, "resolvedSyncPromise", ()=>$32e61feb582e8017$export$1fda8aa4d135f8aa);
    $parcel$export(module.exports, "SyncPromise", ()=>$32e61feb582e8017$export$6f292d4960313241);
    $parcel$export(module.exports, "rejectedSyncPromise", ()=>$32e61feb582e8017$export$78e43115b553f358);
    var $okkfE;
    function $32e61feb582e8017$export$1fda8aa4d135f8aa(value) {
        return new $32e61feb582e8017$export$6f292d4960313241(function(resolve) {
            resolve(value);
        });
    }
    function $32e61feb582e8017$export$78e43115b553f358(reason) {
        return new $32e61feb582e8017$export$6f292d4960313241(function(_, reject) {
            reject(reason);
        });
    }
    var $32e61feb582e8017$export$6f292d4960313241 = function() {
        function SyncPromise(executor) {
            var _this = this;
            this._state = 0;
            this._handlers = [];
            this._resolve = function(value) {
                _this._setResult(1, value);
            };
            this._reject = function(reason) {
                _this._setResult(2, reason);
            };
            this._setResult = function(state, value) {
                if (_this._state !== 0) return;
                if ((0, (0, parcelRequire("okkfE")).isThenable)(value)) {
                    value.then(_this._resolve, _this._reject);
                    return;
                }
                _this._state = state;
                _this._value = value;
                _this._executeHandlers();
            };
            this._executeHandlers = function() {
                if (_this._state === 0) return;
                var cachedHandlers = _this._handlers.slice();
                _this._handlers = [];
                cachedHandlers.forEach(function(handler) {
                    if (handler[0]) return;
                    if (_this._state === 1) handler[1](_this._value);
                    if (_this._state === 2) handler[2](_this._value);
                    handler[0] = true;
                });
            };
            try {
                executor(this._resolve, this._reject);
            } catch (e) {
                this._reject(e);
            }
        }
        SyncPromise.prototype.then = function(onfulfilled, onrejected) {
            var _this = this;
            return new SyncPromise(function(resolve, reject) {
                _this._handlers.push([
                    false,
                    function(result) {
                        if (!onfulfilled) resolve(result);
                        else try {
                            resolve(onfulfilled(result));
                        } catch (e) {
                            reject(e);
                        }
                    },
                    function(reason) {
                        if (!onrejected) reject(reason);
                        else try {
                            resolve(onrejected(reason));
                        } catch (e) {
                            reject(e);
                        }
                    }
                ]);
                _this._executeHandlers();
            });
        };
        SyncPromise.prototype.catch = function(onrejected) {
            return this.then(function(val) {
                return val;
            }, onrejected);
        };
        SyncPromise.prototype.finally = function(onfinally) {
            var _this = this;
            return new SyncPromise(function(resolve, reject) {
                var val;
                var isRejected;
                return _this.then(function(value) {
                    isRejected = false;
                    val = value;
                    if (onfinally) onfinally();
                }, function(reason) {
                    isRejected = true;
                    val = reason;
                    if (onfinally) onfinally();
                }).then(function() {
                    if (isRejected) {
                        reject(val);
                        return;
                    }
                    resolve(val);
                });
            });
        };
        return SyncPromise;
    }();
});
parcelRegister("gI8Be", function(module, exports) {
    $parcel$export(module.exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds, (v)=>dateTimestampInSeconds = v);
    $parcel$export(module.exports, "timestampInSeconds", ()=>timestampInSeconds, (v)=>timestampInSeconds = v);
    var $eUO5L;
    var $3kiq9;
    var dateTimestampSource = {
        nowSeconds: function() {
            return Date.now() / 1000;
        }
    };
    function getBrowserPerformance() {
        var performance = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().performance;
        if (!performance || !performance.now) return undefined;
        var timeOrigin = Date.now() - performance.now();
        return {
            now: function() {
                return performance.now();
            },
            timeOrigin: timeOrigin
        };
    }
    function getNodePerformance() {
        try {
            var perfHooks = (0, (0, parcelRequire("3kiq9")).dynamicRequire)(module, 'perf_hooks');
            return perfHooks.performance;
        } catch (_) {
            return undefined;
        }
    }
    var platformPerformance = (0, (0, parcelRequire("3kiq9")).isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
    var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
        nowSeconds: function() {
            return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
        }
    };
    var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
    var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
    var timestampWithMs = timestampInSeconds;
    var usingPerformanceAPI = platformPerformance !== undefined;
    var _browserPerformanceTimeOriginMode;
    var browserPerformanceTimeOrigin = function() {
        var performance = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().performance;
        if (!performance || !performance.now) {
            _browserPerformanceTimeOriginMode = 'none';
            return undefined;
        }
        var threshold = 3600000;
        var performanceNow = performance.now();
        var dateNow = Date.now();
        var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
        var timeOriginIsReliable = timeOriginDelta < threshold;
        var navigationStart = performance.timing && performance.timing.navigationStart;
        var hasNavigationStart = typeof navigationStart === 'number';
        var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
        var navigationStartIsReliable = navigationStartDelta < threshold;
        if (timeOriginIsReliable || navigationStartIsReliable) {
            if (timeOriginDelta <= navigationStartDelta) {
                _browserPerformanceTimeOriginMode = 'timeOrigin';
                return performance.timeOrigin;
            } else {
                _browserPerformanceTimeOriginMode = 'navigationStart';
                return navigationStart;
            }
        }
        _browserPerformanceTimeOriginMode = 'dateNow';
        return dateNow;
    }();
});
parcelRegister("3xuhl", function(module, exports) {
    $parcel$export(module.exports, "forget", ()=>(parcelRequire("hZpZ3")).forget);
    $parcel$export(module.exports, "getLocationHref", ()=>(parcelRequire("fB1v8")).getLocationHref);
    $parcel$export(module.exports, "htmlTreeAsString", ()=>(parcelRequire("fB1v8")).htmlTreeAsString);
    $parcel$export(module.exports, "dsnToString", ()=>(parcelRequire("ha3jm")).dsnToString);
    $parcel$export(module.exports, "makeDsn", ()=>(parcelRequire("ha3jm")).makeDsn);
    $parcel$export(module.exports, "SentryError", ()=>(parcelRequire("f7sqx")).SentryError);
    $parcel$export(module.exports, "getGlobalObject", ()=>(parcelRequire("eUO5L")).getGlobalObject);
    $parcel$export(module.exports, "addInstrumentationHandler", ()=>(parcelRequire("iDqcL")).addInstrumentationHandler);
    $parcel$export(module.exports, "isDOMError", ()=>(parcelRequire("okkfE")).isDOMError);
    $parcel$export(module.exports, "isDOMException", ()=>(parcelRequire("okkfE")).isDOMException);
    $parcel$export(module.exports, "isError", ()=>(parcelRequire("okkfE")).isError);
    $parcel$export(module.exports, "isErrorEvent", ()=>(parcelRequire("okkfE")).isErrorEvent);
    $parcel$export(module.exports, "isEvent", ()=>(parcelRequire("okkfE")).isEvent);
    $parcel$export(module.exports, "isInstanceOf", ()=>(parcelRequire("okkfE")).isInstanceOf);
    $parcel$export(module.exports, "isPlainObject", ()=>(parcelRequire("okkfE")).isPlainObject);
    $parcel$export(module.exports, "isPrimitive", ()=>(parcelRequire("okkfE")).isPrimitive);
    $parcel$export(module.exports, "isString", ()=>(parcelRequire("okkfE")).isString);
    $parcel$export(module.exports, "isThenable", ()=>(parcelRequire("okkfE")).isThenable);
    $parcel$export(module.exports, "logger", ()=>(parcelRequire("aHQIJ")).logger);
    $parcel$export(module.exports, "addExceptionMechanism", ()=>(parcelRequire("1vYJz")).addExceptionMechanism);
    $parcel$export(module.exports, "addExceptionTypeValue", ()=>(parcelRequire("1vYJz")).addExceptionTypeValue);
    $parcel$export(module.exports, "checkOrSetAlreadyCaught", ()=>(parcelRequire("1vYJz")).checkOrSetAlreadyCaught);
    $parcel$export(module.exports, "getEventDescription", ()=>(parcelRequire("1vYJz")).getEventDescription);
    $parcel$export(module.exports, "parseUrl", ()=>(parcelRequire("1vYJz")).parseUrl);
    $parcel$export(module.exports, "uuid4", ()=>(parcelRequire("1vYJz")).uuid4);
    $parcel$export(module.exports, "normalize", ()=>(parcelRequire("gBQwe")).normalize);
    $parcel$export(module.exports, "normalizeToSize", ()=>(parcelRequire("gBQwe")).normalizeToSize);
    $parcel$export(module.exports, "addNonEnumerableProperty", ()=>(parcelRequire("59M0S")).addNonEnumerableProperty);
    $parcel$export(module.exports, "extractExceptionKeysForMessage", ()=>(parcelRequire("59M0S")).extractExceptionKeysForMessage);
    $parcel$export(module.exports, "fill", ()=>(parcelRequire("59M0S")).fill);
    $parcel$export(module.exports, "getOriginalFunction", ()=>(parcelRequire("59M0S")).getOriginalFunction);
    $parcel$export(module.exports, "markFunctionWrapped", ()=>(parcelRequire("59M0S")).markFunctionWrapped);
    $parcel$export(module.exports, "urlEncode", ()=>(parcelRequire("59M0S")).urlEncode);
    $parcel$export(module.exports, "makePromiseBuffer", ()=>(parcelRequire("6dKoA")).makePromiseBuffer);
    $parcel$export(module.exports, "severityFromString", ()=>(parcelRequire("5L8AU")).severityFromString);
    $parcel$export(module.exports, "createStackParser", ()=>(parcelRequire("1M66C")).createStackParser);
    $parcel$export(module.exports, "getFunctionName", ()=>(parcelRequire("1M66C")).getFunctionName);
    $parcel$export(module.exports, "eventStatusFromHttpCode", ()=>(parcelRequire("h2Oxu")).eventStatusFromHttpCode);
    $parcel$export(module.exports, "isMatchingPattern", ()=>(parcelRequire("keOcA")).isMatchingPattern);
    $parcel$export(module.exports, "safeJoin", ()=>(parcelRequire("keOcA")).safeJoin);
    $parcel$export(module.exports, "truncate", ()=>(parcelRequire("keOcA")).truncate);
    $parcel$export(module.exports, "isNativeFetch", ()=>(parcelRequire("9BO8q")).isNativeFetch);
    $parcel$export(module.exports, "supportsFetch", ()=>(parcelRequire("9BO8q")).supportsFetch);
    $parcel$export(module.exports, "supportsReferrerPolicy", ()=>(parcelRequire("9BO8q")).supportsReferrerPolicy);
    $parcel$export(module.exports, "rejectedSyncPromise", ()=>(parcelRequire("4mVTs")).rejectedSyncPromise);
    $parcel$export(module.exports, "resolvedSyncPromise", ()=>(parcelRequire("4mVTs")).resolvedSyncPromise);
    $parcel$export(module.exports, "SyncPromise", ()=>(parcelRequire("4mVTs")).SyncPromise);
    $parcel$export(module.exports, "createEnvelope", ()=>(parcelRequire("2cvr9")).createEnvelope);
    $parcel$export(module.exports, "getEnvelopeType", ()=>(parcelRequire("2cvr9")).getEnvelopeType);
    $parcel$export(module.exports, "serializeEnvelope", ()=>(parcelRequire("2cvr9")).serializeEnvelope);
    $parcel$export(module.exports, "createClientReportEnvelope", ()=>(parcelRequire("fLq1q")).createClientReportEnvelope);
    $parcel$export(module.exports, "disabledUntil", ()=>(parcelRequire("giEo2")).disabledUntil);
    $parcel$export(module.exports, "isRateLimited", ()=>(parcelRequire("giEo2")).isRateLimited);
    $parcel$export(module.exports, "updateRateLimits", ()=>(parcelRequire("giEo2")).updateRateLimits);
    parcelRequire("hZpZ3");
    parcelRequire("fB1v8");
    parcelRequire("ha3jm");
    parcelRequire("f7sqx");
    parcelRequire("eUO5L");
    parcelRequire("iDqcL");
    parcelRequire("okkfE");
    parcelRequire("aHQIJ");
    parcelRequire("1vYJz");
    var $3kiq9;
    parcelRequire("gBQwe");
    parcelRequire("59M0S");
    parcelRequire("6dKoA");
    parcelRequire("5L8AU");
    parcelRequire("1M66C");
    parcelRequire("h2Oxu");
    parcelRequire("keOcA");
    parcelRequire("9BO8q");
    parcelRequire("4mVTs");
    var $gI8Be;
    parcelRequire("2cvr9");
    parcelRequire("fLq1q");
    parcelRequire("giEo2");
    $parcel$exportWildcard(module.exports, (0, parcelRequire("3kiq9")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("gI8Be")));
});
parcelRegister("hZpZ3", function(module, exports) {
    $parcel$export(module.exports, "forget", ()=>$d18c4a06ec047594$export$93c25f2590a5b540);
    function $d18c4a06ec047594$export$93c25f2590a5b540(promise) {
        promise.then(null, function(e) {
            console.error(e);
        });
    }
});
parcelRegister("ha3jm", function(module, exports) {
    $parcel$export(module.exports, "dsnToString", ()=>$033962d845f489d3$export$44d472fbb931a776);
    $parcel$export(module.exports, "makeDsn", ()=>$033962d845f489d3$export$128827c3562ec0cb);
    var $3VFsf;
    var $f7sqx;
    var $1pUkh;
    var $033962d845f489d3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
    function $033962d845f489d3$var$isValidProtocol(protocol) {
        return protocol === 'http' || protocol === 'https';
    }
    function $033962d845f489d3$export$44d472fbb931a776(dsn, withPassword) {
        if (withPassword === void 0) withPassword = false;
        var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
        return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
    }
    function $033962d845f489d3$var$dsnFromString(str) {
        var match = $033962d845f489d3$var$DSN_REGEX.exec(str);
        if (!match) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: " + str);
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) projectId = projectMatch[0];
        }
        return $033962d845f489d3$var$dsnFromComponents({
            host: host,
            pass: pass,
            path: path,
            projectId: projectId,
            port: port,
            protocol: protocol,
            publicKey: publicKey
        });
    }
    function $033962d845f489d3$var$dsnFromComponents(components) {
        if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
        return {
            user: components.publicKey || '',
            protocol: components.protocol,
            publicKey: components.publicKey || '',
            pass: components.pass || '',
            host: components.host,
            port: components.port || '',
            path: components.path || '',
            projectId: components.projectId
        };
    }
    function $033962d845f489d3$var$validateDsn(dsn) {
        if (!(0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD)) return;
        var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
        var requiredComponents = [
            'protocol',
            'publicKey',
            'host',
            'projectId'
        ];
        requiredComponents.forEach(function(component) {
            if (!dsn[component]) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: " + component + " missing");
        });
        if (!projectId.match(/^\d+$/)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
        if (!$033962d845f489d3$var$isValidProtocol(protocol)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
        if (port && isNaN(parseInt(port, 10))) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid port " + port);
        return true;
    }
    function $033962d845f489d3$export$128827c3562ec0cb(from) {
        var components = typeof from === 'string' ? $033962d845f489d3$var$dsnFromString(from) : $033962d845f489d3$var$dsnFromComponents(from);
        $033962d845f489d3$var$validateDsn(components);
        return components;
    }
});
parcelRegister("f7sqx", function(module, exports) {
    $parcel$export(module.exports, "SentryError", ()=>$b01d8f7464044e0f$export$5949942ba2a7c0e2);
    var $3VFsf;
    var $aKKyi;
    var $b01d8f7464044e0f$export$5949942ba2a7c0e2 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SentryError, _super);
        function SentryError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            _this.message = message;
            _this.name = _newTarget.prototype.constructor.name;
            (0, (0, parcelRequire("aKKyi")).setPrototypeOf)(_this, _newTarget.prototype);
            return _this;
        }
        return SentryError;
    }(Error);
});
parcelRegister("aKKyi", function(module, exports) {
    $parcel$export(module.exports, "setPrototypeOf", ()=>$020532d4ed9bf426$export$1cb0d91350beb6cc);
    var $020532d4ed9bf426$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
        __proto__: []
    }) instanceof Array ? $020532d4ed9bf426$var$setProtoOf : $020532d4ed9bf426$var$mixinProperties);
    function $020532d4ed9bf426$var$setProtoOf(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    }
    function $020532d4ed9bf426$var$mixinProperties(obj, proto) {
        for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) obj[prop] = proto[prop];
        return obj;
    }
});
parcelRegister("iDqcL", function(module, exports) {
    $parcel$export(module.exports, "addInstrumentationHandler", ()=>$d9103240d7f3ffea$export$285b9172a3741fb7);
    var $3VFsf;
    var $1pUkh;
    var $eUO5L;
    var $okkfE;
    var $aHQIJ;
    var $59M0S;
    var $1M66C;
    var $9BO8q;
    var $d9103240d7f3ffea$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $d9103240d7f3ffea$var$handlers = {};
    var $d9103240d7f3ffea$var$instrumented = {};
    function $d9103240d7f3ffea$var$instrument(type) {
        if ($d9103240d7f3ffea$var$instrumented[type]) return;
        $d9103240d7f3ffea$var$instrumented[type] = true;
        switch(type){
            case 'console':
                $d9103240d7f3ffea$var$instrumentConsole();
                break;
            case 'dom':
                $d9103240d7f3ffea$var$instrumentDOM();
                break;
            case 'xhr':
                $d9103240d7f3ffea$var$instrumentXHR();
                break;
            case 'fetch':
                $d9103240d7f3ffea$var$instrumentFetch();
                break;
            case 'history':
                $d9103240d7f3ffea$var$instrumentHistory();
                break;
            case 'error':
                $d9103240d7f3ffea$var$instrumentError();
                break;
            case 'unhandledrejection':
                $d9103240d7f3ffea$var$instrumentUnhandledRejection();
                break;
            default:
                (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('unknown instrumentation type:', type);
                return;
        }
    }
    function $d9103240d7f3ffea$export$285b9172a3741fb7(type, callback) {
        $d9103240d7f3ffea$var$handlers[type] = $d9103240d7f3ffea$var$handlers[type] || [];
        $d9103240d7f3ffea$var$handlers[type].push(callback);
        $d9103240d7f3ffea$var$instrument(type);
    }
    function $d9103240d7f3ffea$var$triggerHandlers(type, data) {
        var e_1, _a;
        if (!type || !$d9103240d7f3ffea$var$handlers[type]) return;
        try {
            for(var _b = (0, (0, parcelRequire("3VFsf")).__values)($d9103240d7f3ffea$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
                var handler = _c.value;
                try {
                    handler(data);
                } catch (e) {
                    (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, (0, parcelRequire("1M66C")).getFunctionName)(handler) + "\nError:", e);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    function $d9103240d7f3ffea$var$instrumentConsole() {
        if (!('console' in $d9103240d7f3ffea$var$global)) return;
        (0, (0, parcelRequire("aHQIJ")).CONSOLE_LEVELS).forEach(function(level) {
            if (!(level in $d9103240d7f3ffea$var$global.console)) return;
            (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    $d9103240d7f3ffea$var$triggerHandlers('console', {
                        args: args,
                        level: level
                    });
                    if (originalConsoleMethod) originalConsoleMethod.apply($d9103240d7f3ffea$var$global.console, args);
                };
            });
        });
    }
    function $d9103240d7f3ffea$var$instrumentFetch() {
        if (!(0, (0, parcelRequire("9BO8q")).supportsNativeFetch)()) return;
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global, 'fetch', function(originalFetch) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var handlerData = {
                    args: args,
                    fetchData: {
                        method: $d9103240d7f3ffea$var$getFetchMethod(args),
                        url: $d9103240d7f3ffea$var$getFetchUrl(args)
                    },
                    startTimestamp: Date.now()
                };
                $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData));
                return originalFetch.apply($d9103240d7f3ffea$var$global, args).then(function(response) {
                    $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData), {
                        endTimestamp: Date.now(),
                        response: response
                    }));
                    return response;
                }, function(error) {
                    $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData), {
                        endTimestamp: Date.now(),
                        error: error
                    }));
                    throw error;
                });
            };
        });
    }
    function $d9103240d7f3ffea$var$getFetchMethod(fetchArgs) {
        if (fetchArgs === void 0) fetchArgs = [];
        if ('Request' in $d9103240d7f3ffea$var$global && (0, (0, parcelRequire("okkfE")).isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
        if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
        return 'GET';
    }
    function $d9103240d7f3ffea$var$getFetchUrl(fetchArgs) {
        if (fetchArgs === void 0) fetchArgs = [];
        if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
        if ('Request' in $d9103240d7f3ffea$var$global && (0, (0, parcelRequire("okkfE")).isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
        return String(fetchArgs[0]);
    }
    function $d9103240d7f3ffea$var$instrumentXHR() {
        if (!('XMLHttpRequest' in $d9103240d7f3ffea$var$global)) return;
        var xhrproto = XMLHttpRequest.prototype;
        (0, (0, parcelRequire("59M0S")).fill)(xhrproto, 'open', function(originalOpen) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var xhr = this;
                var url = args[1];
                var xhrInfo = xhr.__sentry_xhr__ = {
                    method: (0, (0, parcelRequire("okkfE")).isString)(args[0]) ? args[0].toUpperCase() : args[0],
                    url: args[1]
                };
                if ((0, (0, parcelRequire("okkfE")).isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
                var onreadystatechangeHandler = function() {
                    if (xhr.readyState === 4) {
                        try {
                            xhrInfo.status_code = xhr.status;
                        } catch (e) {}
                        $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                            args: args,
                            endTimestamp: Date.now(),
                            startTimestamp: Date.now(),
                            xhr: xhr
                        });
                    }
                };
                if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, (0, parcelRequire("59M0S")).fill)(xhr, 'onreadystatechange', function(original) {
                    return function() {
                        var readyStateArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
                else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
                return originalOpen.apply(xhr, args);
            };
        });
        (0, (0, parcelRequire("59M0S")).fill)(xhrproto, 'send', function(originalSend) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
                $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                    args: args,
                    startTimestamp: Date.now(),
                    xhr: this
                });
                return originalSend.apply(this, args);
            };
        });
    }
    var $d9103240d7f3ffea$var$lastHref;
    function $d9103240d7f3ffea$var$instrumentHistory() {
        if (!(0, (0, parcelRequire("9BO8q")).supportsHistory)()) return;
        var oldOnPopState = $d9103240d7f3ffea$var$global.onpopstate;
        $d9103240d7f3ffea$var$global.onpopstate = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var to = $d9103240d7f3ffea$var$global.location.href;
            var from = $d9103240d7f3ffea$var$lastHref;
            $d9103240d7f3ffea$var$lastHref = to;
            $d9103240d7f3ffea$var$triggerHandlers('history', {
                from: from,
                to: to
            });
            if (oldOnPopState) try {
                return oldOnPopState.apply(this, args);
            } catch (_oO) {}
        };
        function historyReplacementFunction(originalHistoryFunction) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var url = args.length > 2 ? args[2] : undefined;
                if (url) {
                    var from = $d9103240d7f3ffea$var$lastHref;
                    var to = String(url);
                    $d9103240d7f3ffea$var$lastHref = to;
                    $d9103240d7f3ffea$var$triggerHandlers('history', {
                        from: from,
                        to: to
                    });
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.history, 'pushState', historyReplacementFunction);
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.history, 'replaceState', historyReplacementFunction);
    }
    var $d9103240d7f3ffea$var$debounceDuration = 1000;
    var $d9103240d7f3ffea$var$debounceTimerID;
    var $d9103240d7f3ffea$var$lastCapturedEvent;
    function $d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce(previous, current) {
        if (!previous) return true;
        if (previous.type !== current.type) return true;
        try {
            if (previous.target !== current.target) return true;
        } catch (e) {}
        return false;
    }
    function $d9103240d7f3ffea$var$shouldSkipDOMEvent(event) {
        if (event.type !== 'keypress') return false;
        try {
            var target = event.target;
            if (!target || !target.tagName) return true;
            if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
        } catch (e) {}
        return true;
    }
    function $d9103240d7f3ffea$var$makeDOMEventHandler(handler, globalListener) {
        if (globalListener === void 0) globalListener = false;
        return function(event) {
            if (!event || $d9103240d7f3ffea$var$lastCapturedEvent === event) return;
            if ($d9103240d7f3ffea$var$shouldSkipDOMEvent(event)) return;
            var name = event.type === 'keypress' ? 'input' : event.type;
            if ($d9103240d7f3ffea$var$debounceTimerID === undefined) {
                handler({
                    event: event,
                    name: name,
                    global: globalListener
                });
                $d9103240d7f3ffea$var$lastCapturedEvent = event;
            } else if ($d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce($d9103240d7f3ffea$var$lastCapturedEvent, event)) {
                handler({
                    event: event,
                    name: name,
                    global: globalListener
                });
                $d9103240d7f3ffea$var$lastCapturedEvent = event;
            }
            clearTimeout($d9103240d7f3ffea$var$debounceTimerID);
            $d9103240d7f3ffea$var$debounceTimerID = $d9103240d7f3ffea$var$global.setTimeout(function() {
                $d9103240d7f3ffea$var$debounceTimerID = undefined;
            }, $d9103240d7f3ffea$var$debounceDuration);
        };
    }
    function $d9103240d7f3ffea$var$instrumentDOM() {
        if (!('document' in $d9103240d7f3ffea$var$global)) return;
        var triggerDOMHandler = $d9103240d7f3ffea$var$triggerHandlers.bind(null, 'dom');
        var globalDOMEventHandler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler, true);
        $d9103240d7f3ffea$var$global.document.addEventListener('click', globalDOMEventHandler, false);
        $d9103240d7f3ffea$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
        [
            'EventTarget',
            'Node'
        ].forEach(function(target) {
            var proto = $d9103240d7f3ffea$var$global[target] && $d9103240d7f3ffea$var$global[target].prototype;
            if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
            (0, (0, parcelRequire("59M0S")).fill)(proto, 'addEventListener', function(originalAddEventListener) {
                return function(type, listener, options) {
                    if (type === 'click' || type == 'keypress') try {
                        var el = this;
                        var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_1[type] = handlers_1[type] || {
                            refCount: 0
                        };
                        if (!handlerForType.handler) {
                            var handler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    } catch (e) {}
                    return originalAddEventListener.call(this, type, listener, options);
                };
            });
            (0, (0, parcelRequire("59M0S")).fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
                return function(type, listener, options) {
                    if (type === 'click' || type == 'keypress') try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type];
                            }
                            if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                        }
                    } catch (e) {}
                    return originalRemoveEventListener.call(this, type, listener, options);
                };
            });
        });
    }
    var $d9103240d7f3ffea$var$_oldOnErrorHandler = null;
    function $d9103240d7f3ffea$var$instrumentError() {
        $d9103240d7f3ffea$var$_oldOnErrorHandler = $d9103240d7f3ffea$var$global.onerror;
        $d9103240d7f3ffea$var$global.onerror = function(msg, url, line, column, error) {
            $d9103240d7f3ffea$var$triggerHandlers('error', {
                column: column,
                error: error,
                line: line,
                msg: msg,
                url: url
            });
            if ($d9103240d7f3ffea$var$_oldOnErrorHandler) return $d9103240d7f3ffea$var$_oldOnErrorHandler.apply(this, arguments);
            return false;
        };
    }
    var $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = null;
    function $d9103240d7f3ffea$var$instrumentUnhandledRejection() {
        $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = $d9103240d7f3ffea$var$global.onunhandledrejection;
        $d9103240d7f3ffea$var$global.onunhandledrejection = function(e) {
            $d9103240d7f3ffea$var$triggerHandlers('unhandledrejection', e);
            if ($d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler) return $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
            return true;
        };
    }
});
parcelRegister("1M66C", function(module, exports) {
    $parcel$export(module.exports, "createStackParser", ()=>$14af02975f6319e3$export$a5739666fb2d03d4);
    $parcel$export(module.exports, "getFunctionName", ()=>$14af02975f6319e3$export$aad197c7121a6651);
    var $3VFsf;
    var $14af02975f6319e3$var$STACKTRACE_LIMIT = 50;
    function $14af02975f6319e3$export$a5739666fb2d03d4() {
        var parsers = [];
        for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
        var sortedParsers = parsers.sort(function(a, b) {
            return a[0] - b[0];
        }).map(function(p) {
            return p[1];
        });
        return function(stack, skipFirst) {
            var e_1, _a, e_2, _b;
            if (skipFirst === void 0) skipFirst = 0;
            var frames = [];
            try {
                for(var _c = (0, (0, parcelRequire("3VFsf")).__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var line = _d.value;
                    try {
                        for(var sortedParsers_1 = (e_2 = void 0, (0, (0, parcelRequire("3VFsf")).__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                            var parser = sortedParsers_1_1.value;
                            var frame = parser(line);
                            if (frame) {
                                frames.push(frame);
                                break;
                            }
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return $14af02975f6319e3$export$c55c24c0eeba0205(frames);
        };
    }
    function $14af02975f6319e3$export$c55c24c0eeba0205(stack) {
        if (!stack.length) return [];
        var localStack = stack;
        var firstFrameFunction = localStack[0].function || '';
        var lastFrameFunction = localStack[localStack.length - 1].function || '';
        if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
        if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
        return localStack.slice(0, $14af02975f6319e3$var$STACKTRACE_LIMIT).map(function(frame) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, frame), {
                filename: frame.filename || localStack[0].filename,
                function: frame.function || '?'
            });
        }).reverse();
    }
    var $14af02975f6319e3$var$defaultFunctionName = '<anonymous>';
    function $14af02975f6319e3$export$aad197c7121a6651(fn) {
        try {
            if (!fn || typeof fn !== 'function') return $14af02975f6319e3$var$defaultFunctionName;
            return fn.name || $14af02975f6319e3$var$defaultFunctionName;
        } catch (e) {
            return $14af02975f6319e3$var$defaultFunctionName;
        }
    }
});
parcelRegister("9BO8q", function(module, exports) {
    $parcel$export(module.exports, "supportsFetch", ()=>$6fee758568fb716d$export$edf3cb81fd7d2a3e);
    $parcel$export(module.exports, "isNativeFetch", ()=>$6fee758568fb716d$export$18cf36ed71d733e7);
    $parcel$export(module.exports, "supportsNativeFetch", ()=>$6fee758568fb716d$export$c82d238e23c40b21);
    $parcel$export(module.exports, "supportsReferrerPolicy", ()=>$6fee758568fb716d$export$2d308b428295192f);
    $parcel$export(module.exports, "supportsHistory", ()=>$6fee758568fb716d$export$67fc34576016d6ec);
    var $1pUkh;
    var $eUO5L;
    var $aHQIJ;
    function $6fee758568fb716d$export$caa710b4d7f9cadf() {
        try {
            new ErrorEvent('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$1c08bd1a7eb3c472() {
        try {
            new DOMError('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$ab12a5d056f1d3a() {
        try {
            new DOMException('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$edf3cb81fd7d2a3e() {
        if (!('fetch' in (0, (0, parcelRequire("eUO5L")).getGlobalObject)())) return false;
        try {
            new Headers();
            new Request('');
            new Response();
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$18cf36ed71d733e7(func) {
        return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
    }
    function $6fee758568fb716d$export$c82d238e23c40b21() {
        if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        if ($6fee758568fb716d$export$18cf36ed71d733e7(global.fetch)) return true;
        var result = false;
        var doc = global.document;
        if (doc && typeof doc.createElement === 'function') try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) result = $6fee758568fb716d$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
            doc.head.removeChild(sandbox);
        } catch (err) {
            (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
        return result;
    }
    function $6fee758568fb716d$export$531055a6c684a70a() {
        return 'ReportingObserver' in (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    }
    function $6fee758568fb716d$export$2d308b428295192f() {
        if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
        try {
            new Request('_', {
                referrerPolicy: 'origin'
            });
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$67fc34576016d6ec() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var chrome = global.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
        return !isChromePackagedApp && hasHistoryApi;
    }
});
parcelRegister("gBQwe", function(module, exports) {
    $parcel$export(module.exports, "normalize", ()=>$c178d7365214c01f$export$a3295358bff77e);
    $parcel$export(module.exports, "normalizeToSize", ()=>$c178d7365214c01f$export$23fbbb20bed71033);
    var $3VFsf;
    var $okkfE;
    var $kbQkj;
    var $59M0S;
    var $1M66C;
    function $c178d7365214c01f$export$a3295358bff77e(input, depth, maxProperties) {
        if (depth === void 0) depth = Infinity;
        if (maxProperties === void 0) maxProperties = Infinity;
        try {
            return $c178d7365214c01f$export$588732934346abbf('', input, depth, maxProperties);
        } catch (err) {
            return {
                ERROR: "**non-serializable** (" + err + ")"
            };
        }
    }
    function $c178d7365214c01f$export$23fbbb20bed71033(object, depth, maxSize) {
        if (depth === void 0) depth = 3;
        if (maxSize === void 0) maxSize = 102400;
        var normalized = $c178d7365214c01f$export$a3295358bff77e(object, depth);
        if ($c178d7365214c01f$var$jsonSize(normalized) > maxSize) return $c178d7365214c01f$export$23fbbb20bed71033(object, depth - 1, maxSize);
        return normalized;
    }
    function $c178d7365214c01f$export$588732934346abbf(key, value, depth, maxProperties, memo) {
        if (depth === void 0) depth = Infinity;
        if (maxProperties === void 0) maxProperties = Infinity;
        if (memo === void 0) memo = (0, (0, parcelRequire("kbQkj")).memoBuilder)();
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
        var valueWithToJSON = value;
        if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
            return valueWithToJSON.toJSON();
        } catch (err) {}
        if (value === null || [
            'number',
            'boolean',
            'string'
        ].includes(typeof value) && !(0, (0, parcelRequire("okkfE")).isNaN)(value)) return value;
        var stringified = $c178d7365214c01f$var$stringifyValue(key, value);
        if (!stringified.startsWith('[object ')) return stringified;
        if (depth === 0) return stringified.replace('object ', '');
        if (memoize(value)) return '[Circular ~]';
        var normalized = Array.isArray(value) ? [] : {};
        var numAdded = 0;
        var visitable = (0, (0, parcelRequire("okkfE")).isError)(value) || (0, (0, parcelRequire("okkfE")).isEvent)(value) ? (0, (0, parcelRequire("59M0S")).convertToPlainObject)(value) : value;
        for(var visitKey in visitable){
            if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
            if (numAdded >= maxProperties) {
                normalized[visitKey] = '[MaxProperties ~]';
                break;
            }
            var visitValue = visitable[visitKey];
            normalized[visitKey] = $c178d7365214c01f$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
            numAdded += 1;
        }
        unmemoize(value);
        return normalized;
    }
    function $c178d7365214c01f$var$stringifyValue(key, value) {
        try {
            if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
            if (key === 'domainEmitter') return '[DomainEmitter]';
            if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
            if (typeof window !== 'undefined' && value === window) return '[Window]';
            if (typeof document !== 'undefined' && value === document) return '[Document]';
            if ((0, (0, parcelRequire("okkfE")).isSyntheticEvent)(value)) return '[SyntheticEvent]';
            if (typeof value === 'number' && value !== value) return '[NaN]';
            if (value === void 0) return '[undefined]';
            if (typeof value === 'function') return "[Function: " + (0, (0, parcelRequire("1M66C")).getFunctionName)(value) + "]";
            if (typeof value === 'symbol') return "[" + String(value) + "]";
            if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
            return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
        } catch (err) {
            return "**non-serializable** (" + err + ")";
        }
    }
    function $c178d7365214c01f$var$utf8Length(value) {
        return ~-encodeURI(value).split(/%..|./).length;
    }
    function $c178d7365214c01f$var$jsonSize(value) {
        return $c178d7365214c01f$var$utf8Length(JSON.stringify(value));
    }
});
parcelRegister("kbQkj", function(module, exports) {
    $parcel$export(module.exports, "memoBuilder", ()=>$eb2d6cb7d9719f25$export$8115b0b78e956ab3);
    function $eb2d6cb7d9719f25$export$8115b0b78e956ab3() {
        var hasWeakSet = typeof WeakSet === 'function';
        var inner = hasWeakSet ? new WeakSet() : [];
        function memoize(obj) {
            if (hasWeakSet) {
                if (inner.has(obj)) return true;
                inner.add(obj);
                return false;
            }
            for(var i = 0; i < inner.length; i++){
                var value = inner[i];
                if (value === obj) return true;
            }
            inner.push(obj);
            return false;
        }
        function unmemoize(obj) {
            if (hasWeakSet) inner.delete(obj);
            else {
                for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
        return [
            memoize,
            unmemoize
        ];
    }
});
parcelRegister("6dKoA", function(module, exports) {
    $parcel$export(module.exports, "makePromiseBuffer", ()=>$4877f229d6ada624$export$85a4f67f852183e6);
    var $f7sqx;
    var $4mVTs;
    function $4877f229d6ada624$export$85a4f67f852183e6(limit) {
        var buffer = [];
        function isReady() {
            return limit === undefined || buffer.length < limit;
        }
        function remove(task) {
            return buffer.splice(buffer.indexOf(task), 1)[0];
        }
        function add(taskProducer) {
            if (!isReady()) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)('Not adding Promise due to buffer limit reached.'));
            var task = taskProducer();
            if (buffer.indexOf(task) === -1) buffer.push(task);
            task.then(function() {
                return remove(task);
            }).then(null, function() {
                return remove(task).then(null, function() {});
            });
            return task;
        }
        function drain(timeout) {
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                var counter = buffer.length;
                if (!counter) return resolve(true);
                var capturedSetTimeout = setTimeout(function() {
                    if (timeout && timeout > 0) resolve(false);
                }, timeout);
                buffer.forEach(function(item) {
                    (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(item).then(function() {
                        if (!--counter) {
                            clearTimeout(capturedSetTimeout);
                            resolve(true);
                        }
                    }, reject);
                });
            });
        }
        return {
            $: buffer,
            add: add,
            drain: drain
        };
    }
});
parcelRegister("5L8AU", function(module, exports) {
    $parcel$export(module.exports, "severityFromString", ()=>$431802330db86aeb$export$e01cef29b4327697);
    var $8vvJk;
    var $c1CzK;
    function $431802330db86aeb$var$isSupportedSeverity(level) {
        return (0, (0, parcelRequire("c1CzK")).SeverityLevels).indexOf(level) !== -1;
    }
    function $431802330db86aeb$export$e01cef29b4327697(level) {
        if (level === 'warn') return (0, (0, parcelRequire("8vvJk")).Severity).Warning;
        if ($431802330db86aeb$var$isSupportedSeverity(level)) return level;
        return (0, (0, parcelRequire("8vvJk")).Severity).Log;
    }
});
parcelRegister("8vvJk", function(module, exports) {
    $parcel$export(module.exports, "Severity", ()=>$6319d4e940dba412$export$918a9776c0a3cf27);
    var $6319d4e940dba412$export$918a9776c0a3cf27;
    (function(Severity) {
        Severity["Fatal"] = "fatal";
        Severity["Error"] = "error";
        Severity["Warning"] = "warning";
        Severity["Log"] = "log";
        Severity["Info"] = "info";
        Severity["Debug"] = "debug";
        Severity["Critical"] = "critical";
    })($6319d4e940dba412$export$918a9776c0a3cf27 || ($6319d4e940dba412$export$918a9776c0a3cf27 = {}));
    var $6319d4e940dba412$export$484b1ea9aec914c = [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug',
        'critical'
    ];
});
parcelRegister("c1CzK", function(module, exports) {
    $parcel$export(module.exports, "SeverityLevels", ()=>$8c138058cfd4daeb$export$484b1ea9aec914c);
    var $8c138058cfd4daeb$export$484b1ea9aec914c = [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug',
        'critical'
    ];
});
parcelRegister("h2Oxu", function(module, exports) {
    $parcel$export(module.exports, "eventStatusFromHttpCode", ()=>$c689d399d8025b2a$export$82713360d763c449);
    function $c689d399d8025b2a$export$82713360d763c449(code) {
        if (code >= 200 && code < 300) return 'success';
        if (code === 429) return 'rate_limit';
        if (code >= 400 && code < 500) return 'invalid';
        if (code >= 500) return 'failed';
        return 'unknown';
    }
});
parcelRegister("2cvr9", function(module, exports) {
    $parcel$export(module.exports, "createEnvelope", ()=>$19a51673c063482c$export$f93f7f385160c44e);
    $parcel$export(module.exports, "getEnvelopeType", ()=>$19a51673c063482c$export$d84939284bbafcd4);
    $parcel$export(module.exports, "serializeEnvelope", ()=>$19a51673c063482c$export$32f9b428425aac85);
    var $3VFsf;
    var $okkfE;
    function $19a51673c063482c$export$f93f7f385160c44e(headers, items) {
        if (items === void 0) items = [];
        return [
            headers,
            items
        ];
    }
    function $19a51673c063482c$export$d650323442802f6f(envelope, newItem) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), headers = _a[0], items = _a[1];
        return [
            headers,
            (0, (0, parcelRequire("3VFsf")).__spread)(items, [
                newItem
            ])
        ];
    }
    function $19a51673c063482c$export$d84939284bbafcd4(envelope) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), _b = (0, (0, parcelRequire("3VFsf")).__read)(_a[1], 1), _c = (0, (0, parcelRequire("3VFsf")).__read)(_b[0], 1), firstItemHeader = _c[0];
        return firstItemHeader.type;
    }
    function $19a51673c063482c$export$32f9b428425aac85(envelope) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), headers = _a[0], items = _a[1];
        var serializedHeaders = JSON.stringify(headers);
        return items.reduce(function(acc, item) {
            var _a = (0, (0, parcelRequire("3VFsf")).__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
            var serializedPayload = (0, (0, parcelRequire("okkfE")).isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
            return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
        }, serializedHeaders);
    }
});
parcelRegister("fLq1q", function(module, exports) {
    $parcel$export(module.exports, "createClientReportEnvelope", ()=>$b79f6e3445ee6042$export$f3b9ed77c03eeb00);
    var $2cvr9;
    var $gI8Be;
    function $b79f6e3445ee6042$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
        var clientReportItem = [
            {
                type: 'client_report'
            },
            {
                timestamp: timestamp || (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)(),
                discarded_events: discarded_events
            }
        ];
        return (0, (0, parcelRequire("2cvr9")).createEnvelope)(dsn ? {
            dsn: dsn
        } : {}, [
            clientReportItem
        ]);
    }
});
parcelRegister("giEo2", function(module, exports) {
    $parcel$export(module.exports, "disabledUntil", ()=>$bddda7bd22e98b4c$export$b89fc7b2e4c799e7);
    $parcel$export(module.exports, "isRateLimited", ()=>$bddda7bd22e98b4c$export$6c91fec22056810a);
    $parcel$export(module.exports, "updateRateLimits", ()=>$bddda7bd22e98b4c$export$699aff705e0d49d4);
    var $3VFsf;
    var $bddda7bd22e98b4c$export$b09ce39faaeb1e7c = 60000;
    function $bddda7bd22e98b4c$export$615352e17ed7741(header, now) {
        if (now === void 0) now = Date.now();
        var headerDelay = parseInt("" + header, 10);
        if (!isNaN(headerDelay)) return headerDelay * 1000;
        var headerDate = Date.parse("" + header);
        if (!isNaN(headerDate)) return headerDate - now;
        return $bddda7bd22e98b4c$export$b09ce39faaeb1e7c;
    }
    function $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) {
        return limits[category] || limits.all || 0;
    }
    function $bddda7bd22e98b4c$export$6c91fec22056810a(limits, category, now) {
        if (now === void 0) now = Date.now();
        return $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) > now;
    }
    function $bddda7bd22e98b4c$export$699aff705e0d49d4(limits, headers, now) {
        var e_1, _a, e_2, _b;
        if (now === void 0) now = Date.now();
        var updatedRateLimits = (0, (0, parcelRequire("3VFsf")).__assign)({}, limits);
        var rateLimitHeader = headers['x-sentry-rate-limits'];
        var retryAfterHeader = headers['retry-after'];
        if (rateLimitHeader) try {
            for(var _c = (0, (0, parcelRequire("3VFsf")).__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000;
                if (!parameters[1]) updatedRateLimits.all = now + delay;
                else try {
                    for(var _e = (e_2 = void 0, (0, (0, parcelRequire("3VFsf")).__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var category = _f.value;
                        updatedRateLimits[category] = now + delay;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        else if (retryAfterHeader) updatedRateLimits.all = now + $bddda7bd22e98b4c$export$615352e17ed7741(retryAfterHeader, now);
        return updatedRateLimits;
    }
});
parcelRegister("3knVN", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$26c5cd9556cd8ba2$export$48a8984ec0bf2e44);
    var $26c5cd9556cd8ba2$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("bYhbK", function(module, exports) {
    $parcel$export(module.exports, "setupIntegrations", ()=>$8b72a18ea9aa7e3f$export$51abed9797baa598);
    var $3VFsf;
    var $gfYRq;
    var $3kk8J;
    parcelRequire("3xuhl");
    var $59M0S;
    var $aHQIJ;
    var $3knVN;
    var $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e = [];
    function $8b72a18ea9aa7e3f$var$filterDuplicates(integrations) {
        return integrations.reduce(function(acc, integrations) {
            if (acc.every(function(accIntegration) {
                return integrations.name !== accIntegration.name;
            })) acc.push(integrations);
            return acc;
        }, []);
    }
    function $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options) {
        var defaultIntegrations = options.defaultIntegrations && (0, (0, parcelRequire("3VFsf")).__spread)(options.defaultIntegrations) || [];
        var userIntegrations = options.integrations;
        var integrations = (0, (0, parcelRequire("3VFsf")).__spread)($8b72a18ea9aa7e3f$var$filterDuplicates(defaultIntegrations));
        if (Array.isArray(userIntegrations)) integrations = (0, (0, parcelRequire("3VFsf")).__spread)(integrations.filter(function(integrations) {
            return userIntegrations.every(function(userIntegration) {
                return userIntegration.name !== integrations.name;
            });
        }), $8b72a18ea9aa7e3f$var$filterDuplicates(userIntegrations));
        else if (typeof userIntegrations === 'function') {
            integrations = userIntegrations(integrations);
            integrations = Array.isArray(integrations) ? integrations : [
                integrations
            ];
        }
        var integrationsNames = integrations.map(function(i) {
            return i.name;
        });
        var alwaysLastToRun = 'Debug';
        if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, (0, parcelRequire("3VFsf")).__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
        return integrations;
    }
    function $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration) {
        if ($8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
        integration.setupOnce((0, (0, parcelRequire("gfYRq")).addGlobalEventProcessor), (0, (0, parcelRequire("3kk8J")).getCurrentHub));
        $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.push(integration.name);
        (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Integration installed: " + integration.name);
    }
    function $8b72a18ea9aa7e3f$export$51abed9797baa598(options) {
        var integrations = {};
        $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options).forEach(function(integration) {
            integrations[integration.name] = integration;
            $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration);
        });
        (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(integrations, 'initialized', true);
        return integrations;
    }
});
parcelRegister("3kk8J", function(module, exports) {
    $parcel$export(module.exports, "Hub", ()=>$26c2dcb27d4dffef$export$8c41bb232f1008b1);
    $parcel$export(module.exports, "makeMain", ()=>$26c2dcb27d4dffef$export$4188a14ad302d1bc);
    $parcel$export(module.exports, "getHubFromCarrier", ()=>$26c2dcb27d4dffef$export$bfa8a924a84a76b7);
    $parcel$export(module.exports, "getCurrentHub", ()=>$26c2dcb27d4dffef$export$a07cdf6544bbd7c);
    var $3VFsf;
    parcelRequire("2zyAl");
    var $aHQIJ;
    var $gI8Be;
    var $eUO5L;
    var $3kiq9;
    var $1vYJz;
    var $23Apf;
    var $gfYRq;
    var $lTZg9;
    var $26c2dcb27d4dffef$export$24a86ef7798177e4 = 4;
    var $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS = 100;
    var $26c2dcb27d4dffef$export$8c41bb232f1008b1 = function() {
        function Hub(client, scope, _version) {
            if (scope === void 0) scope = new (0, (0, parcelRequire("gfYRq")).Scope)();
            if (_version === void 0) _version = $26c2dcb27d4dffef$export$24a86ef7798177e4;
            this._version = _version;
            this._stack = [
                {}
            ];
            this.getStackTop().scope = scope;
            if (client) this.bindClient(client);
        }
        Hub.prototype.isOlderThan = function(version) {
            return this._version < version;
        };
        Hub.prototype.bindClient = function(client) {
            var top = this.getStackTop();
            top.client = client;
            if (client && client.setupIntegrations) client.setupIntegrations();
        };
        Hub.prototype.pushScope = function() {
            var scope = (0, (0, parcelRequire("gfYRq")).Scope).clone(this.getScope());
            this.getStack().push({
                client: this.getClient(),
                scope: scope
            });
            return scope;
        };
        Hub.prototype.popScope = function() {
            if (this.getStack().length <= 1) return false;
            return !!this.getStack().pop();
        };
        Hub.prototype.withScope = function(callback) {
            var scope = this.pushScope();
            try {
                callback(scope);
            } finally{
                this.popScope();
            }
        };
        Hub.prototype.getClient = function() {
            return this.getStackTop().client;
        };
        Hub.prototype.getScope = function() {
            return this.getStackTop().scope;
        };
        Hub.prototype.getStack = function() {
            return this._stack;
        };
        Hub.prototype.getStackTop = function() {
            return this._stack[this._stack.length - 1];
        };
        Hub.prototype.captureException = function(exception, hint) {
            var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            var finalHint = hint;
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error('Sentry syntheticException');
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: exception,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureException', exception, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, finalHint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.captureMessage = function(message, level, hint) {
            var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            var finalHint = hint;
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error(message);
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: message,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureMessage', message, level, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, finalHint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.captureEvent = function(event, hint) {
            var eventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            if (event.type !== 'transaction') this._lastEventId = eventId;
            this._invokeClient('captureEvent', event, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, hint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.lastEventId = function() {
            return this._lastEventId;
        };
        Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (!scope || !client) return;
            var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS : _d;
            if (maxBreadcrumbs <= 0) return;
            var timestamp = (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)();
            var mergedBreadcrumb = (0, (0, parcelRequire("3VFsf")).__assign)({
                timestamp: timestamp
            }, breadcrumb);
            var finalBreadcrumb = beforeBreadcrumb ? (0, (0, parcelRequire("aHQIJ")).consoleSandbox)(function() {
                return beforeBreadcrumb(mergedBreadcrumb, hint);
            }) : mergedBreadcrumb;
            if (finalBreadcrumb === null) return;
            scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
        };
        Hub.prototype.setUser = function(user) {
            var scope = this.getScope();
            if (scope) scope.setUser(user);
        };
        Hub.prototype.setTags = function(tags) {
            var scope = this.getScope();
            if (scope) scope.setTags(tags);
        };
        Hub.prototype.setExtras = function(extras) {
            var scope = this.getScope();
            if (scope) scope.setExtras(extras);
        };
        Hub.prototype.setTag = function(key, value) {
            var scope = this.getScope();
            if (scope) scope.setTag(key, value);
        };
        Hub.prototype.setExtra = function(key, extra) {
            var scope = this.getScope();
            if (scope) scope.setExtra(key, extra);
        };
        Hub.prototype.setContext = function(name, context) {
            var scope = this.getScope();
            if (scope) scope.setContext(name, context);
        };
        Hub.prototype.configureScope = function(callback) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (scope && client) callback(scope);
        };
        Hub.prototype.run = function(callback) {
            var oldHub = $26c2dcb27d4dffef$export$4188a14ad302d1bc(this);
            try {
                callback(this);
            } finally{
                $26c2dcb27d4dffef$export$4188a14ad302d1bc(oldHub);
            }
        };
        Hub.prototype.getIntegration = function(integration) {
            var client = this.getClient();
            if (!client) return null;
            try {
                return client.getIntegration(integration);
            } catch (_oO) {
                (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
                return null;
            }
        };
        Hub.prototype.startSpan = function(context) {
            return this._callExtensionMethod('startSpan', context);
        };
        Hub.prototype.startTransaction = function(context, customSamplingContext) {
            return this._callExtensionMethod('startTransaction', context, customSamplingContext);
        };
        Hub.prototype.traceHeaders = function() {
            return this._callExtensionMethod('traceHeaders');
        };
        Hub.prototype.captureSession = function(endSession) {
            if (endSession === void 0) endSession = false;
            if (endSession) return this.endSession();
            this._sendSessionUpdate();
        };
        Hub.prototype.endSession = function() {
            var layer = this.getStackTop();
            var scope = layer && layer.scope;
            var session = scope && scope.getSession();
            if (session) session.close();
            this._sendSessionUpdate();
            if (scope) scope.setSession();
        };
        Hub.prototype.startSession = function(context) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
            var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
            var userAgent = (global.navigator || {}).userAgent;
            var session = new (0, (0, parcelRequire("lTZg9")).Session)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
                release: release,
                environment: environment
            }, scope && {
                user: scope.getUser()
            }), userAgent && {
                userAgent: userAgent
            }), context));
            if (scope) {
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === 'ok') currentSession.update({
                    status: 'exited'
                });
                this.endSession();
                scope.setSession(session);
            }
            return session;
        };
        Hub.prototype._sendSessionUpdate = function() {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (!scope) return;
            var session = scope.getSession && scope.getSession();
            if (session) {
                if (client && client.captureSession) client.captureSession(session);
            }
        };
        Hub.prototype._invokeClient = function(method) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
            if (client && client[method]) (_a = client)[method].apply(_a, (0, (0, parcelRequire("3VFsf")).__spread)(args, [
                scope
            ]));
        };
        Hub.prototype._callExtensionMethod = function(method) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var carrier = $26c2dcb27d4dffef$export$19eade501500c6c1();
            var sentry = carrier.__SENTRY__;
            if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
            (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
        };
        return Hub;
    }();
    function $26c2dcb27d4dffef$export$19eade501500c6c1() {
        var carrier = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        carrier.__SENTRY__ = carrier.__SENTRY__ || {
            extensions: {},
            hub: undefined
        };
        return carrier;
    }
    function $26c2dcb27d4dffef$export$4188a14ad302d1bc(hub) {
        var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
        var oldHub = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, hub);
        return oldHub;
    }
    function $26c2dcb27d4dffef$export$a07cdf6544bbd7c() {
        var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
        if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(registry) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, new $26c2dcb27d4dffef$export$8c41bb232f1008b1());
        if ((0, (0, parcelRequire("3kiq9")).isNodeEnv)()) return $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry);
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    }
    function $26c2dcb27d4dffef$export$1c4d656130202699() {
        (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
        var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
        return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
    }
    function $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry) {
        try {
            var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
            var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
            if (!activeDomain) return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
            if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(activeDomain) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) {
                var registryHubTopStack = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).getStackTop();
                $26c2dcb27d4dffef$export$849f05434e95d2f2(activeDomain, new $26c2dcb27d4dffef$export$8c41bb232f1008b1(registryHubTopStack.client, (0, (0, parcelRequire("gfYRq")).Scope).clone(registryHubTopStack.scope)));
            }
            return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain);
        } catch (_Oo) {
            return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        }
    }
    function $26c2dcb27d4dffef$var$hasHubOnCarrier(carrier) {
        return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
    }
    function $26c2dcb27d4dffef$export$bfa8a924a84a76b7(carrier) {
        return (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('hub', function() {
            return new $26c2dcb27d4dffef$export$8c41bb232f1008b1();
        }, carrier);
    }
    function $26c2dcb27d4dffef$export$849f05434e95d2f2(carrier, hub) {
        if (!carrier) return false;
        var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
        __SENTRY__.hub = hub;
        return true;
    }
});
parcelRegister("23Apf", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$17f81a1bea39bc90$export$48a8984ec0bf2e44);
    var $17f81a1bea39bc90$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("lTZg9", function(module, exports) {
    $parcel$export(module.exports, "Session", ()=>$ff1e40e1db4f1b32$export$1fb4852a55678982);
    parcelRequire("2zyAl");
    var $59M0S;
    var $gI8Be;
    var $1vYJz;
    var $ff1e40e1db4f1b32$export$1fb4852a55678982 = function() {
        function Session(context) {
            this.errors = 0;
            this.sid = (0, (0, parcelRequire("1vYJz")).uuid4)();
            this.duration = 0;
            this.status = 'ok';
            this.init = true;
            this.ignoreDuration = false;
            var startingTime = (0, (0, parcelRequire("gI8Be")).timestampInSeconds)();
            this.timestamp = startingTime;
            this.started = startingTime;
            if (context) this.update(context);
        }
        Session.prototype.update = function(context) {
            if (context === void 0) context = {};
            if (context.user) {
                if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
                if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
            }
            this.timestamp = context.timestamp || (0, (0, parcelRequire("gI8Be")).timestampInSeconds)();
            if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
            if (context.sid) this.sid = context.sid.length === 32 ? context.sid : (0, (0, parcelRequire("1vYJz")).uuid4)();
            if (context.init !== undefined) this.init = context.init;
            if (!this.did && context.did) this.did = "" + context.did;
            if (typeof context.started === 'number') this.started = context.started;
            if (this.ignoreDuration) this.duration = undefined;
            else if (typeof context.duration === 'number') this.duration = context.duration;
            else {
                var duration = this.timestamp - this.started;
                this.duration = duration >= 0 ? duration : 0;
            }
            if (context.release) this.release = context.release;
            if (context.environment) this.environment = context.environment;
            if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
            if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
            if (typeof context.errors === 'number') this.errors = context.errors;
            if (context.status) this.status = context.status;
        };
        Session.prototype.close = function(status) {
            if (status) this.update({
                status: status
            });
            else if (this.status === 'ok') this.update({
                status: 'exited'
            });
            else this.update();
        };
        Session.prototype.toJSON = function() {
            return (0, (0, parcelRequire("59M0S")).dropUndefinedKeys)({
                sid: "" + this.sid,
                init: this.init,
                started: new Date(this.started * 1000).toISOString(),
                timestamp: new Date(this.timestamp * 1000).toISOString(),
                status: this.status,
                errors: this.errors,
                did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
                duration: this.duration,
                attrs: {
                    release: this.release,
                    environment: this.environment,
                    ip_address: this.ipAddress,
                    user_agent: this.userAgent
                }
            });
        };
        return Session;
    }();
});
parcelRegister("9Up1Q", function(module, exports) {
    $parcel$export(module.exports, "SDK_VERSION", ()=>$736cc23961be74e3$export$31499a9cd224b78c);
    var $736cc23961be74e3$export$31499a9cd224b78c = '6.19.7';
});
parcelRegister("1jQdQ", function(module, exports) {
    $parcel$export(module.exports, "BrowserBackend", ()=>$0f601308e4e6ba6f$export$2526e21aec9d0ce7);
    var $3VFsf;
    var $ccWrZ;
    var $S4fte;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $9BO8q;
    var $c8Het;
    var $bUa9S;
    var $huxes;
    var $5egvK;
    var $2EUFJ;
    var $0f601308e4e6ba6f$export$2526e21aec9d0ce7 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BrowserBackend, _super);
        function BrowserBackend() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        BrowserBackend.prototype.eventFromException = function(exception, hint) {
            return (0, (0, parcelRequire("c8Het")).eventFromException)(exception, hint, this._options.attachStacktrace);
        };
        BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
            if (level === void 0) level = (0, (0, parcelRequire("8vvJk")).Severity).Info;
            return (0, (0, parcelRequire("c8Het")).eventFromMessage)(message, level, hint, this._options.attachStacktrace);
        };
        BrowserBackend.prototype._setupTransport = function() {
            if (!this._options.dsn) return _super.prototype._setupTransport.call(this);
            var transportOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._options.transportOptions), {
                dsn: this._options.dsn,
                tunnel: this._options.tunnel,
                sendClientReports: this._options.sendClientReports,
                _metadata: this._options._metadata
            });
            var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
            var url = (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
            if (this._options.transport) return new this._options.transport(transportOptions);
            if ((0, (0, parcelRequire("9BO8q")).supportsFetch)()) {
                var requestOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, transportOptions.fetchParameters);
                this._newTransport = (0, (0, parcelRequire("huxes")).makeNewFetchTransport)({
                    requestOptions: requestOptions,
                    url: url
                });
                return new (0, (0, parcelRequire("bUa9S")).FetchTransport)(transportOptions);
            }
            this._newTransport = (0, (0, parcelRequire("5egvK")).makeNewXHRTransport)({
                url: url,
                headers: transportOptions.headers
            });
            return new (0, (0, parcelRequire("2EUFJ")).XHRTransport)(transportOptions);
        };
        return BrowserBackend;
    }((0, (0, parcelRequire("ccWrZ")).BaseBackend));
});
parcelRegister("ccWrZ", function(module, exports) {
    $parcel$export(module.exports, "BaseBackend", ()=>$8e33f21400272aa3$export$8f43a53a38d7e95f);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $aHQIJ;
    var $f7sqx;
    var $S4fte;
    var $3knVN;
    var $bf08D;
    var $aMFZ3;
    var $8e33f21400272aa3$export$8f43a53a38d7e95f = function() {
        function BaseBackend(options) {
            this._options = options;
            if (!this._options.dsn) (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('No DSN provided, backend will not do anything.');
            this._transport = this._setupTransport();
        }
        BaseBackend.prototype.eventFromException = function(_exception, _hint) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)('Backend has to implement `eventFromException` method');
        };
        BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)('Backend has to implement `eventFromMessage` method');
        };
        BaseBackend.prototype.sendEvent = function(event) {
            if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
                var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
                var env = (0, (0, parcelRequire("bf08D")).createEventEnvelope)(event, api);
                this._newTransport.send(env).then(null, function(reason) {
                    (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending event:', reason);
                });
            } else this._transport.sendEvent(event).then(null, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending event:', reason);
            });
        };
        BaseBackend.prototype.sendSession = function(session) {
            if (!this._transport.sendSession) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Dropping session because custom transport doesn't implement sendSession");
                return;
            }
            if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
                var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
                var _a = (0, (0, parcelRequire("3VFsf")).__read)((0, (0, parcelRequire("bf08D")).createSessionEnvelope)(session, api), 1), env = _a[0];
                this._newTransport.send(env).then(null, function(reason) {
                    (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending session:', reason);
                });
            } else this._transport.sendSession(session).then(null, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending session:', reason);
            });
        };
        BaseBackend.prototype.getTransport = function() {
            return this._transport;
        };
        BaseBackend.prototype._setupTransport = function() {
            return new (0, (0, parcelRequire("aMFZ3")).NoopTransport)();
        };
        return BaseBackend;
    }();
});
parcelRegister("S4fte", function(module, exports) {
    $parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", ()=>$0a2856eddb28200f$export$c1677e22ac2217a5);
    $parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>$0a2856eddb28200f$export$9964600bfe84e6a3);
    $parcel$export(module.exports, "initAPIDetails", ()=>$0a2856eddb28200f$export$ad00a06efb2a29cb);
    $parcel$export(module.exports, "getReportDialogEndpoint", ()=>$0a2856eddb28200f$export$671c7ed8e40a7a57);
    parcelRequire("3xuhl");
    var $ha3jm;
    var $59M0S;
    var $0a2856eddb28200f$var$SENTRY_API_VERSION = '7';
    var $0a2856eddb28200f$export$2c4e825dc9120f87 = function() {
        function API(dsn, metadata, tunnel) {
            if (metadata === void 0) metadata = {};
            this.dsn = dsn;
            this._dsnObject = (0, (0, parcelRequire("ha3jm")).makeDsn)(dsn);
            this.metadata = metadata;
            this._tunnel = tunnel;
        }
        API.prototype.getDsn = function() {
            return this._dsnObject;
        };
        API.prototype.forceEnvelope = function() {
            return !!this._tunnel;
        };
        API.prototype.getBaseApiEndpoint = function() {
            return $0a2856eddb28200f$var$getBaseApiEndpoint(this._dsnObject);
        };
        API.prototype.getStoreEndpoint = function() {
            return $0a2856eddb28200f$var$getStoreEndpoint(this._dsnObject);
        };
        API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
            return $0a2856eddb28200f$export$c1677e22ac2217a5(this._dsnObject);
        };
        API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
            return $0a2856eddb28200f$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
        };
        return API;
    }();
    function $0a2856eddb28200f$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
        return {
            initDsn: dsn,
            metadata: metadata || {},
            dsn: (0, (0, parcelRequire("ha3jm")).makeDsn)(dsn),
            tunnel: tunnel
        };
    }
    function $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) {
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    }
    function $0a2856eddb28200f$var$_getIngestEndpoint(dsn, target) {
        return "" + $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
    }
    function $0a2856eddb28200f$var$_encodedAuth(dsn) {
        return (0, (0, parcelRequire("59M0S")).urlEncode)({
            sentry_key: dsn.publicKey,
            sentry_version: $0a2856eddb28200f$var$SENTRY_API_VERSION
        });
    }
    function $0a2856eddb28200f$var$getStoreEndpoint(dsn) {
        return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'store');
    }
    function $0a2856eddb28200f$export$c1677e22ac2217a5(dsn) {
        return $0a2856eddb28200f$var$getStoreEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
    }
    function $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) {
        return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'envelope');
    }
    function $0a2856eddb28200f$export$9964600bfe84e6a3(dsn, tunnel) {
        return tunnel ? tunnel : $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
    }
    function $0a2856eddb28200f$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
        var header = [
            "Sentry sentry_version=" + $0a2856eddb28200f$var$SENTRY_API_VERSION
        ];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.publicKey);
        if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', ')
        };
    }
    function $0a2856eddb28200f$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
        var dsn = (0, (0, parcelRequire("ha3jm")).makeDsn)(dsnLike);
        var endpoint = $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
        var encodedOptions = "dsn=" + (0, (0, parcelRequire("ha3jm")).dsnToString)(dsn);
        for(var key in dialogOptions){
            if (key === 'dsn') continue;
            if (key === 'user') {
                if (!dialogOptions.user) continue;
                if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
                if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
        return endpoint + "?" + encodedOptions;
    }
});
parcelRegister("bf08D", function(module, exports) {
    $parcel$export(module.exports, "createSessionEnvelope", ()=>$82f133e7faf6394e$export$124b03c077baa2f3);
    $parcel$export(module.exports, "sessionToSentryRequest", ()=>$82f133e7faf6394e$export$977ee6eda1884ec3);
    $parcel$export(module.exports, "createEventEnvelope", ()=>$82f133e7faf6394e$export$c31057337a18010f);
    $parcel$export(module.exports, "eventToSentryRequest", ()=>$82f133e7faf6394e$export$2006389de558b996);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $2cvr9;
    var $ha3jm;
    var $gBQwe;
    var $S4fte;
    function $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api) {
        if (!api.metadata || !api.metadata.sdk) return;
        var _a = api.metadata.sdk, name = _a.name, version = _a.version;
        return {
            name: name,
            version: version
        };
    }
    function $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
        if (!sdkInfo) return event;
        event.sdk = event.sdk || {};
        event.sdk.name = event.sdk.name || sdkInfo.name;
        event.sdk.version = event.sdk.version || sdkInfo.version;
        event.sdk.integrations = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
        event.sdk.packages = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.packages || [], sdkInfo.packages || []);
        return event;
    }
    function $82f133e7faf6394e$export$124b03c077baa2f3(session, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
        });
        var type = 'aggregates' in session ? 'sessions' : 'session';
        var envelopeItem = [
            {
                type: type
            },
            session
        ];
        var envelope = (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
            envelopeItem
        ]);
        return [
            envelope,
            type
        ];
    }
    function $82f133e7faf6394e$export$977ee6eda1884ec3(session, api) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)($82f133e7faf6394e$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
        return {
            body: (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope),
            type: type,
            url: (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
        };
    }
    function $82f133e7faf6394e$export$c31057337a18010f(event, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var eventType = event.type || 'event';
        var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
        var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
        $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
        event.tags = event.tags || {};
        event.extra = event.extra || {};
        if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
            event.tags.skippedNormalization = true;
            event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
        }
        delete event.sdkProcessingMetadata;
        var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            event
        ];
        return (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
    }
    function $82f133e7faf6394e$export$2006389de558b996(event, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var eventType = event.type || 'event';
        var useEnvelope = eventType === 'transaction' || !!api.tunnel;
        var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
        var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
        $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
        event.tags = event.tags || {};
        event.extra = event.extra || {};
        if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
            event.tags.skippedNormalization = true;
            event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
        }
        delete event.sdkProcessingMetadata;
        var body;
        try {
            body = JSON.stringify(event);
        } catch (err) {
            event.tags.JSONStringifyError = true;
            event.extra.JSONStringifyError = err;
            try {
                body = JSON.stringify((0, (0, parcelRequire("gBQwe")).normalize)(event));
            } catch (newErr) {
                var innerErr = newErr;
                body = JSON.stringify({
                    message: 'JSON.stringify error after renormalization',
                    extra: {
                        message: innerErr.message,
                        stack: innerErr.stack
                    }
                });
            }
        }
        var req = {
            body: body,
            type: eventType,
            url: useEnvelope ? (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, (0, parcelRequire("S4fte")).getStoreEndpointWithUrlEncodedAuth)(api.dsn)
        };
        if (useEnvelope) {
            var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
                event_id: event.event_id,
                sent_at: new Date().toISOString()
            }, sdkInfo && {
                sdk: sdkInfo
            }), !!api.tunnel && {
                dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
            });
            var eventItem = [
                {
                    type: eventType,
                    sample_rates: [
                        {
                            id: samplingMethod,
                            rate: sampleRate
                        }
                    ]
                },
                req.body
            ];
            var envelope = (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
                eventItem
            ]);
            req.body = (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope);
        }
        return req;
    }
});
parcelRegister("aMFZ3", function(module, exports) {
    $parcel$export(module.exports, "NoopTransport", ()=>$7d9ef429c62e7388$export$6f2767450ea1346c);
    parcelRequire("3xuhl");
    var $4mVTs;
    var $7d9ef429c62e7388$export$6f2767450ea1346c = function() {
        function NoopTransport() {}
        NoopTransport.prototype.sendEvent = function(_) {
            return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)({
                reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
                status: 'skipped'
            });
        };
        NoopTransport.prototype.close = function(_) {
            return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(true);
        };
        return NoopTransport;
    }();
});
parcelRegister("c8Het", function(module, exports) {
    $parcel$export(module.exports, "exceptionFromError", ()=>$8d67c476e355940c$export$a6c2d27607295951);
    $parcel$export(module.exports, "eventFromException", ()=>$8d67c476e355940c$export$ea3ec7e569b823fc);
    $parcel$export(module.exports, "eventFromUnknownInput", ()=>$8d67c476e355940c$export$9dd56ed1ef0c3420);
    $parcel$export(module.exports, "eventFromMessage", ()=>$8d67c476e355940c$export$5425b53185d13d6c);
    var $3VFsf;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $1M66C;
    var $59M0S;
    var $okkfE;
    var $gBQwe;
    var $4mVTs;
    var $6hYiK;
    function $8d67c476e355940c$export$a6c2d27607295951(ex) {
        var frames = $8d67c476e355940c$export$d478b2c12fbcfdda(ex);
        var exception = {
            type: ex && ex.name,
            value: $8d67c476e355940c$var$extractMessage(ex)
        };
        if (frames.length) exception.stacktrace = {
            frames: frames
        };
        if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
        return exception;
    }
    function $8d67c476e355940c$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
        var event = {
            exception: {
                values: [
                    {
                        type: (0, (0, parcelRequire("okkfE")).isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                        value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, (0, parcelRequire("59M0S")).extractExceptionKeysForMessage)(exception)
                    }
                ]
            },
            extra: {
                __serialized__: (0, (0, parcelRequire("gBQwe")).normalizeToSize)(exception)
            }
        };
        if (syntheticException) {
            var frames_1 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
            if (frames_1.length) event.stacktrace = {
                frames: frames_1
            };
        }
        return event;
    }
    function $8d67c476e355940c$export$73fbea5a0a5234af(ex) {
        return {
            exception: {
                values: [
                    $8d67c476e355940c$export$a6c2d27607295951(ex)
                ]
            }
        };
    }
    function $8d67c476e355940c$export$d478b2c12fbcfdda(ex) {
        var stacktrace = ex.stacktrace || ex.stack || '';
        var popSize = $8d67c476e355940c$var$getPopSize(ex);
        try {
            return (0, (0, parcelRequire("1M66C")).createStackParser)((0, (0, parcelRequire("6hYiK")).opera10StackParser), (0, (0, parcelRequire("6hYiK")).opera11StackParser), (0, (0, parcelRequire("6hYiK")).chromeStackParser), (0, (0, parcelRequire("6hYiK")).winjsStackParser), (0, (0, parcelRequire("6hYiK")).geckoStackParser))(stacktrace, popSize);
        } catch (e) {}
        return [];
    }
    var $8d67c476e355940c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
    function $8d67c476e355940c$var$getPopSize(ex) {
        if (ex) {
            if (typeof ex.framesToPop === 'number') return ex.framesToPop;
            if ($8d67c476e355940c$var$reactMinifiedRegexp.test(ex.message)) return 1;
        }
        return 0;
    }
    function $8d67c476e355940c$var$extractMessage(ex) {
        var message = ex && ex.message;
        if (!message) return 'No error message';
        if (message.error && typeof message.error.message === 'string') return message.error.message;
        return message;
    }
    function $8d67c476e355940c$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
        (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event);
        event.level = (0, (0, parcelRequire("8vvJk")).Severity).Error;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(event);
    }
    function $8d67c476e355940c$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
        if (level === void 0) level = (0, (0, parcelRequire("8vvJk")).Severity).Info;
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
        event.level = level;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(event);
    }
    function $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
        var event;
        if ((0, (0, parcelRequire("okkfE")).isErrorEvent)(exception) && exception.error) {
            var errorEvent = exception;
            return $8d67c476e355940c$export$73fbea5a0a5234af(errorEvent.error);
        }
        if ((0, (0, parcelRequire("okkfE")).isDOMError)(exception) || (0, (0, parcelRequire("okkfE")).isDOMException)(exception)) {
            var domException = exception;
            if ('stack' in exception) event = $8d67c476e355940c$export$73fbea5a0a5234af(exception);
            else {
                var name_1 = domException.name || ((0, (0, parcelRequire("okkfE")).isDOMError)(domException) ? 'DOMError' : 'DOMException');
                var message = domException.message ? name_1 + ": " + domException.message : name_1;
                event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
                (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, message);
            }
            if ('code' in domException) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event.tags), {
                'DOMException.code': "" + domException.code
            });
            return event;
        }
        if ((0, (0, parcelRequire("okkfE")).isError)(exception)) return $8d67c476e355940c$export$73fbea5a0a5234af(exception);
        if ((0, (0, parcelRequire("okkfE")).isPlainObject)(exception) || (0, (0, parcelRequire("okkfE")).isEvent)(exception)) {
            var objectException = exception;
            event = $8d67c476e355940c$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
            (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, {
                synthetic: true
            });
            return event;
        }
        event = $8d67c476e355940c$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
        (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, "" + exception, undefined);
        (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    function $8d67c476e355940c$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
        var event = {
            message: input
        };
        if (attachStacktrace && syntheticException) {
            var frames_2 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
            if (frames_2.length) event.stacktrace = {
                frames: frames_2
            };
        }
        return event;
    }
});
parcelRegister("6hYiK", function(module, exports) {
    $parcel$export(module.exports, "chromeStackParser", ()=>$49431b32a95d7ea3$export$c693d9295441d8f9);
    $parcel$export(module.exports, "geckoStackParser", ()=>$49431b32a95d7ea3$export$c9ddf1e2b5d48bff);
    $parcel$export(module.exports, "winjsStackParser", ()=>$49431b32a95d7ea3$export$b6d155d85c1dcba5);
    $parcel$export(module.exports, "opera10StackParser", ()=>$49431b32a95d7ea3$export$966ec832d9699d6);
    $parcel$export(module.exports, "opera11StackParser", ()=>$49431b32a95d7ea3$export$989a1824b4734ce6);
    var $3VFsf;
    var $49431b32a95d7ea3$var$UNKNOWN_FUNCTION = '?';
    var $49431b32a95d7ea3$var$OPERA10_PRIORITY = 10;
    var $49431b32a95d7ea3$var$OPERA11_PRIORITY = 20;
    var $49431b32a95d7ea3$var$CHROME_PRIORITY = 30;
    var $49431b32a95d7ea3$var$WINJS_PRIORITY = 40;
    var $49431b32a95d7ea3$var$GECKO_PRIORITY = 50;
    function $49431b32a95d7ea3$var$createFrame(filename, func, lineno, colno) {
        var frame = {
            filename: filename,
            function: func,
            in_app: true
        };
        if (lineno !== undefined) frame.lineno = lineno;
        if (colno !== undefined) frame.colno = colno;
        return frame;
    }
    var $49431b32a95d7ea3$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var $49431b32a95d7ea3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var $49431b32a95d7ea3$var$chrome = function(line) {
        var parts = $49431b32a95d7ea3$var$chromeRegex.exec(line);
        if (parts) {
            var isEval = parts[2] && parts[2].indexOf('eval') === 0;
            if (isEval) {
                var subMatch = $49431b32a95d7ea3$var$chromeEvalRegex.exec(parts[2]);
                if (subMatch) {
                    parts[2] = subMatch[1];
                    parts[3] = subMatch[2];
                    parts[4] = subMatch[3];
                }
            }
            var _a = (0, (0, parcelRequire("3VFsf")).__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
            return $49431b32a95d7ea3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
        }
        return;
    };
    var $49431b32a95d7ea3$export$c693d9295441d8f9 = [
        $49431b32a95d7ea3$var$CHROME_PRIORITY,
        $49431b32a95d7ea3$var$chrome
    ];
    var $49431b32a95d7ea3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
    var $49431b32a95d7ea3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var $49431b32a95d7ea3$var$gecko = function(line) {
        var _a;
        var parts = $49431b32a95d7ea3$var$geckoREgex.exec(line);
        if (parts) {
            var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval) {
                var subMatch = $49431b32a95d7ea3$var$geckoEvalRegex.exec(parts[3]);
                if (subMatch) {
                    parts[1] = parts[1] || 'eval';
                    parts[3] = subMatch[1];
                    parts[4] = subMatch[2];
                    parts[5] = '';
                }
            }
            var filename = parts[3];
            var func = parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION;
            _a = (0, (0, parcelRequire("3VFsf")).__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
            return $49431b32a95d7ea3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
        }
        return;
    };
    var $49431b32a95d7ea3$export$c9ddf1e2b5d48bff = [
        $49431b32a95d7ea3$var$GECKO_PRIORITY,
        $49431b32a95d7ea3$var$gecko
    ];
    var $49431b32a95d7ea3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    var $49431b32a95d7ea3$var$winjs = function(line) {
        var parts = $49431b32a95d7ea3$var$winjsRegex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
    };
    var $49431b32a95d7ea3$export$b6d155d85c1dcba5 = [
        $49431b32a95d7ea3$var$WINJS_PRIORITY,
        $49431b32a95d7ea3$var$winjs
    ];
    var $49431b32a95d7ea3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var $49431b32a95d7ea3$var$opera10 = function(line) {
        var parts = $49431b32a95d7ea3$var$opera10Regex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[3] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
    };
    var $49431b32a95d7ea3$export$966ec832d9699d6 = [
        $49431b32a95d7ea3$var$OPERA10_PRIORITY,
        $49431b32a95d7ea3$var$opera10
    ];
    var $49431b32a95d7ea3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
    var $49431b32a95d7ea3$var$opera11 = function(line) {
        var parts = $49431b32a95d7ea3$var$opera11Regex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[5], parts[3] || parts[4] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
    };
    var $49431b32a95d7ea3$export$989a1824b4734ce6 = [
        $49431b32a95d7ea3$var$OPERA11_PRIORITY,
        $49431b32a95d7ea3$var$opera11
    ];
    var $49431b32a95d7ea3$var$extractSafariExtensionDetails = function(func, filename) {
        var isSafariExtension = func.indexOf('safari-extension') !== -1;
        var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
        return isSafariExtension || isSafariWebExtension ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : $49431b32a95d7ea3$var$UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
        ] : [
            func,
            filename
        ];
    };
});
parcelRegister("bUa9S", function(module, exports) {
    $parcel$export(module.exports, "FetchTransport", ()=>$8aaccde9cc8aea61$export$2bdee3f9b92f4e82);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $f7sqx;
    var $9BO8q;
    var $4mVTs;
    var $7xYoj;
    var $ad8JG;
    var $8aaccde9cc8aea61$export$2bdee3f9b92f4e82 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(FetchTransport, _super);
        function FetchTransport(options, fetchImpl) {
            if (fetchImpl === void 0) fetchImpl = (0, (0, parcelRequire("ad8JG")).getNativeFetchImplementation)();
            var _this = _super.call(this, options) || this;
            _this._fetch = fetchImpl;
            return _this;
        }
        FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
            var _this = this;
            if (this._isRateLimited(sentryRequest.type)) {
                this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
                return Promise.reject({
                    event: originalPayload,
                    type: sentryRequest.type,
                    reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                    status: 429
                });
            }
            var options = {
                body: sentryRequest.body,
                method: 'POST',
                referrerPolicy: (0, (0, parcelRequire("9BO8q")).supportsReferrerPolicy)() ? 'origin' : ''
            };
            if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
            if (this.options.headers !== undefined) options.headers = this.options.headers;
            return this._buffer.add(function() {
                return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                    _this._fetch(sentryRequest.url, options).then(function(response) {
                        var headers = {
                            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                            'retry-after': response.headers.get('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: response,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }).catch(reject);
                });
            }).then(undefined, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
                else _this.recordLostEvent('network_error', sentryRequest.type);
                throw reason;
            });
        };
        return FetchTransport;
    }((0, (0, parcelRequire("7xYoj")).BaseTransport));
});
parcelRegister("7xYoj", function(module, exports) {
    $parcel$export(module.exports, "BaseTransport", ()=>$57ea75eadd985084$export$74b99d619e90f481);
    var $3VFsf;
    var $bf08D;
    var $S4fte;
    parcelRequire("3xuhl");
    var $fLq1q;
    var $giEo2;
    var $ha3jm;
    var $h2Oxu;
    var $eUO5L;
    var $aHQIJ;
    var $6dKoA;
    var $2cvr9;
    var $86ilb;
    var $ad8JG;
    function $57ea75eadd985084$var$requestTypeToCategory(ty) {
        var tyStr = ty;
        return tyStr === 'event' ? 'error' : tyStr;
    }
    var $57ea75eadd985084$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $57ea75eadd985084$export$74b99d619e90f481 = function() {
        function BaseTransport(options) {
            var _this = this;
            this.options = options;
            this._buffer = (0, (0, parcelRequire("6dKoA")).makePromiseBuffer)(30);
            this._rateLimits = {};
            this._outcomes = {};
            this._api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(options.dsn, options._metadata, options.tunnel);
            this.url = (0, (0, parcelRequire("S4fte")).getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
            if (this.options.sendClientReports && $57ea75eadd985084$var$global.document) $57ea75eadd985084$var$global.document.addEventListener('visibilitychange', function() {
                if ($57ea75eadd985084$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
            });
        }
        BaseTransport.prototype.sendEvent = function(event) {
            return this._sendRequest((0, (0, parcelRequire("bf08D")).eventToSentryRequest)(event, this._api), event);
        };
        BaseTransport.prototype.sendSession = function(session) {
            return this._sendRequest((0, (0, parcelRequire("bf08D")).sessionToSentryRequest)(session, this._api), session);
        };
        BaseTransport.prototype.close = function(timeout) {
            return this._buffer.drain(timeout);
        };
        BaseTransport.prototype.recordLostEvent = function(reason, category) {
            var _a;
            if (!this.options.sendClientReports) return;
            var key = $57ea75eadd985084$var$requestTypeToCategory(category) + ":" + reason;
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Adding outcome: " + key);
            this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
        };
        BaseTransport.prototype._flushOutcomes = function() {
            if (!this.options.sendClientReports) return;
            var outcomes = this._outcomes;
            this._outcomes = {};
            if (!Object.keys(outcomes).length) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log('No outcomes to flush');
                return;
            }
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
            var url = (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
            var discardedEvents = Object.keys(outcomes).map(function(key) {
                var _a = (0, (0, parcelRequire("3VFsf")).__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
                return {
                    reason: reason,
                    category: category,
                    quantity: outcomes[key]
                };
            });
            var envelope = (0, (0, parcelRequire("fLq1q")).createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, (0, parcelRequire("ha3jm")).dsnToString)(this._api.dsn));
            try {
                (0, (0, parcelRequire("ad8JG")).sendReport)(url, (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope));
            } catch (e) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error(e);
            }
        };
        BaseTransport.prototype._handleResponse = function(_a) {
            var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
            var status = (0, (0, parcelRequire("h2Oxu")).eventStatusFromHttpCode)(response.status);
            this._rateLimits = (0, (0, parcelRequire("giEo2")).updateRateLimits)(this._rateLimits, headers);
            if (this._isRateLimited(requestType)) (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
            if (status === 'success') {
                resolve({
                    status: status
                });
                return;
            }
            reject(response);
        };
        BaseTransport.prototype._disabledUntil = function(requestType) {
            var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
            return new Date((0, (0, parcelRequire("giEo2")).disabledUntil)(this._rateLimits, category));
        };
        BaseTransport.prototype._isRateLimited = function(requestType) {
            var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
            return (0, (0, parcelRequire("giEo2")).isRateLimited)(this._rateLimits, category);
        };
        return BaseTransport;
    }();
});
parcelRegister("86ilb", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$5e5d1c5a13c7017d$export$48a8984ec0bf2e44);
    var $5e5d1c5a13c7017d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("ad8JG", function(module, exports) {
    $parcel$export(module.exports, "getNativeFetchImplementation", ()=>$76f1e50a4e2b3aa8$export$8be2119ce08e3379);
    $parcel$export(module.exports, "sendReport", ()=>$76f1e50a4e2b3aa8$export$84bb63b2c17ec44d);
    parcelRequire("3xuhl");
    var $hZpZ3;
    var $eUO5L;
    var $9BO8q;
    var $aHQIJ;
    var $86ilb;
    var $76f1e50a4e2b3aa8$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $76f1e50a4e2b3aa8$var$cachedFetchImpl;
    function $76f1e50a4e2b3aa8$export$8be2119ce08e3379() {
        if ($76f1e50a4e2b3aa8$var$cachedFetchImpl) return $76f1e50a4e2b3aa8$var$cachedFetchImpl;
        if ((0, (0, parcelRequire("9BO8q")).isNativeFetch)($76f1e50a4e2b3aa8$var$global.fetch)) return $76f1e50a4e2b3aa8$var$cachedFetchImpl = $76f1e50a4e2b3aa8$var$global.fetch.bind($76f1e50a4e2b3aa8$var$global);
        var document = $76f1e50a4e2b3aa8$var$global.document;
        var fetchImpl = $76f1e50a4e2b3aa8$var$global.fetch;
        if (document && typeof document.createElement === 'function') try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
            document.head.removeChild(sandbox);
        } catch (e) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
        return $76f1e50a4e2b3aa8$var$cachedFetchImpl = fetchImpl.bind($76f1e50a4e2b3aa8$var$global);
    }
    function $76f1e50a4e2b3aa8$export$84bb63b2c17ec44d(url, body) {
        var isRealNavigator = Object.prototype.toString.call($76f1e50a4e2b3aa8$var$global && $76f1e50a4e2b3aa8$var$global.navigator) === '[object Navigator]';
        var hasSendBeacon = isRealNavigator && typeof $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon === 'function';
        if (hasSendBeacon) {
            var sendBeacon = $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon.bind($76f1e50a4e2b3aa8$var$global.navigator);
            return sendBeacon(url, body);
        }
        if ((0, (0, parcelRequire("9BO8q")).supportsFetch)()) {
            var fetch_1 = $76f1e50a4e2b3aa8$export$8be2119ce08e3379();
            return (0, (0, parcelRequire("hZpZ3")).forget)(fetch_1(url, {
                body: body,
                method: 'POST',
                credentials: 'omit',
                keepalive: true
            }));
        }
    }
});
parcelRegister("huxes", function(module, exports) {
    $parcel$export(module.exports, "makeNewFetchTransport", ()=>$cbbf04388348e7ab$export$1c57e6bfd09bad13);
    var $3VFsf;
    var $6Vta0;
    var $ad8JG;
    function $cbbf04388348e7ab$export$1c57e6bfd09bad13(options, nativeFetch) {
        if (nativeFetch === void 0) nativeFetch = (0, (0, parcelRequire("ad8JG")).getNativeFetchImplementation)();
        function makeRequest(request) {
            var requestOptions = (0, (0, parcelRequire("3VFsf")).__assign)({
                body: request.body,
                method: 'POST',
                referrerPolicy: 'origin'
            }, options.requestOptions);
            return nativeFetch(options.url, requestOptions).then(function(response) {
                return response.text().then(function(body) {
                    return {
                        body: body,
                        headers: {
                            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                            'retry-after': response.headers.get('Retry-After')
                        },
                        reason: response.statusText,
                        statusCode: response.status
                    };
                });
            });
        }
        return (0, (0, parcelRequire("6Vta0")).createTransport)({
            bufferSize: options.bufferSize
        }, makeRequest);
    }
});
parcelRegister("6Vta0", function(module, exports) {
    $parcel$export(module.exports, "createTransport", ()=>$50aeaf944e235b68$export$d09f50d9ab7f7b69);
    parcelRequire("3xuhl");
    var $giEo2;
    var $h2Oxu;
    var $2cvr9;
    var $6dKoA;
    var $4mVTs;
    var $50aeaf944e235b68$export$d8a725a7dce95622 = 'error';
    var $50aeaf944e235b68$export$99adc6fe67a3c63e = 'transaction';
    var $50aeaf944e235b68$export$9d7ad34f132fe68f = 'attachment';
    var $50aeaf944e235b68$export$42d9e7b5fc564c45 = 'session';
    var $50aeaf944e235b68$export$e515cf6dfd2f98b8 = 30;
    function $50aeaf944e235b68$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
        if (buffer === void 0) buffer = (0, (0, parcelRequire("6dKoA")).makePromiseBuffer)(options.bufferSize || $50aeaf944e235b68$export$e515cf6dfd2f98b8);
        var rateLimits = {};
        var flush = function(timeout) {
            return buffer.drain(timeout);
        };
        function send(envelope) {
            var envCategory = (0, (0, parcelRequire("2cvr9")).getEnvelopeType)(envelope);
            var category = envCategory === 'event' ? 'error' : envCategory;
            var request = {
                category: category,
                body: (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope)
            };
            if ((0, (0, parcelRequire("giEo2")).isRateLimited)(rateLimits, category)) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)({
                status: 'rate_limit',
                reason: $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category)
            });
            var requestTask = function() {
                return makeRequest(request).then(function(_a) {
                    var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                    var status = (0, (0, parcelRequire("h2Oxu")).eventStatusFromHttpCode)(statusCode);
                    if (headers) rateLimits = (0, (0, parcelRequire("giEo2")).updateRateLimits)(rateLimits, headers);
                    if (status === 'success') return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)({
                        status: status,
                        reason: reason
                    });
                    return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)({
                        status: status,
                        reason: reason || body || (status === 'rate_limit' ? $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                    });
                });
            };
            return buffer.add(requestTask);
        }
        return {
            send: send,
            flush: flush
        };
    }
    function $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) {
        return "Too many " + category + " requests, backing off until: " + new Date((0, (0, parcelRequire("giEo2")).disabledUntil)(rateLimits, category)).toISOString();
    }
});
parcelRegister("5egvK", function(module, exports) {
    $parcel$export(module.exports, "makeNewXHRTransport", ()=>$3ceb115445ff80d8$export$4c0ac1dd4bbf4921);
    var $6Vta0;
    parcelRequire("3xuhl");
    var $4mVTs;
    var $3ceb115445ff80d8$var$XHR_READYSTATE_DONE = 4;
    function $3ceb115445ff80d8$export$4c0ac1dd4bbf4921(options) {
        function makeRequest(request) {
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, _reject) {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === $3ceb115445ff80d8$var$XHR_READYSTATE_DONE) {
                        var response = {
                            body: xhr.response,
                            headers: {
                                'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                                'retry-after': xhr.getResponseHeader('Retry-After')
                            },
                            reason: xhr.statusText,
                            statusCode: xhr.status
                        };
                        resolve(response);
                    }
                };
                xhr.open('POST', options.url);
                for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
                xhr.send(request.body);
            });
        }
        return (0, (0, parcelRequire("6Vta0")).createTransport)({
            bufferSize: options.bufferSize
        }, makeRequest);
    }
});
parcelRegister("2EUFJ", function(module, exports) {
    $parcel$export(module.exports, "XHRTransport", ()=>$1efb47151abb73ac$export$874a283af77e8e62);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $f7sqx;
    var $4mVTs;
    var $7xYoj;
    var $1efb47151abb73ac$export$874a283af77e8e62 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(XHRTransport, _super);
        function XHRTransport() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
            var _this = this;
            if (this._isRateLimited(sentryRequest.type)) {
                this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
                return Promise.reject({
                    event: originalPayload,
                    type: sentryRequest.type,
                    reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                    status: 429
                });
            }
            return this._buffer.add(function() {
                return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                    var request = new XMLHttpRequest();
                    request.onreadystatechange = function() {
                        if (request.readyState === 4) {
                            var headers = {
                                'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                                'retry-after': request.getResponseHeader('Retry-After')
                            };
                            _this._handleResponse({
                                requestType: sentryRequest.type,
                                response: request,
                                headers: headers,
                                resolve: resolve,
                                reject: reject
                            });
                        }
                    };
                    request.open('POST', sentryRequest.url);
                    for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                    request.send(sentryRequest.body);
                });
            }).then(undefined, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
                else _this.recordLostEvent('network_error', sentryRequest.type);
                throw reason;
            });
        };
        return XHRTransport;
    }((0, (0, parcelRequire("7xYoj")).BaseTransport));
});
parcelRegister("7n7dK", function(module, exports) {
    $parcel$export(module.exports, "shouldIgnoreOnError", ()=>$55e0484034c91259$export$b79738ab10c590b2);
    $parcel$export(module.exports, "wrap", ()=>$55e0484034c91259$export$4997ffc0176396a6);
    $parcel$export(module.exports, "injectReportDialog", ()=>$55e0484034c91259$export$deb9aac8ea0b576c);
    var $3VFsf;
    var $7zHWg;
    var $S4fte;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $59M0S;
    var $eUO5L;
    var $aHQIJ;
    var $86ilb;
    var $55e0484034c91259$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $55e0484034c91259$var$ignoreOnError = 0;
    function $55e0484034c91259$export$b79738ab10c590b2() {
        return $55e0484034c91259$var$ignoreOnError > 0;
    }
    function $55e0484034c91259$export$1265a142ff5ba165() {
        $55e0484034c91259$var$ignoreOnError += 1;
        setTimeout(function() {
            $55e0484034c91259$var$ignoreOnError -= 1;
        });
    }
    function $55e0484034c91259$export$4997ffc0176396a6(fn, options, before) {
        if (options === void 0) options = {};
        if (typeof fn !== 'function') return fn;
        try {
            var wrapper = fn.__sentry_wrapped__;
            if (wrapper) return wrapper;
            if ((0, (0, parcelRequire("59M0S")).getOriginalFunction)(fn)) return fn;
        } catch (e) {
            return fn;
        }
        var sentryWrapped = function() {
            var args = Array.prototype.slice.call(arguments);
            try {
                if (before && typeof before === 'function') before.apply(this, arguments);
                var wrappedArguments = args.map(function(arg) {
                    return $55e0484034c91259$export$4997ffc0176396a6(arg, options);
                });
                return fn.apply(this, wrappedArguments);
            } catch (ex) {
                $55e0484034c91259$export$1265a142ff5ba165();
                (0, (0, parcelRequire("7zHWg")).withScope)(function(scope) {
                    scope.addEventProcessor(function(event) {
                        if (options.mechanism) {
                            (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, undefined, undefined);
                            (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, options.mechanism);
                        }
                        event.extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event.extra), {
                            arguments: args
                        });
                        return event;
                    });
                    (0, (0, parcelRequire("7zHWg")).captureException)(ex);
                });
                throw ex;
            }
        };
        try {
            for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
        } catch (_oO) {}
        (0, (0, parcelRequire("59M0S")).markFunctionWrapped)(sentryWrapped, fn);
        (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
        try {
            var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
            if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
                get: function() {
                    return fn.name;
                }
            });
        } catch (_oO) {}
        return sentryWrapped;
    }
    function $55e0484034c91259$export$deb9aac8ea0b576c(options) {
        if (options === void 0) options = {};
        if (!$55e0484034c91259$var$global.document) return;
        if (!options.eventId) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Missing eventId option in showReportDialog call');
            return;
        }
        if (!options.dsn) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Missing dsn option in showReportDialog call');
            return;
        }
        var script = $55e0484034c91259$var$global.document.createElement('script');
        script.async = true;
        script.src = (0, (0, parcelRequire("S4fte")).getReportDialogEndpoint)(options.dsn, options);
        if (options.onLoad) script.onload = options.onLoad;
        var injectionPoint = $55e0484034c91259$var$global.document.head || $55e0484034c91259$var$global.document.body;
        if (injectionPoint) injectionPoint.appendChild(script);
    }
});
parcelRegister("7zHWg", function(module, exports) {
    $parcel$export(module.exports, "captureException", ()=>$583de2969a487e4e$export$f5282963edea4a68);
    $parcel$export(module.exports, "captureMessage", ()=>$583de2969a487e4e$export$45654777c133ae80);
    $parcel$export(module.exports, "captureEvent", ()=>$583de2969a487e4e$export$1462b974fdcf6ba2);
    $parcel$export(module.exports, "configureScope", ()=>$583de2969a487e4e$export$99d44f04437e9cb8);
    $parcel$export(module.exports, "addBreadcrumb", ()=>$583de2969a487e4e$export$efda9a273d7a036d);
    $parcel$export(module.exports, "setContext", ()=>$583de2969a487e4e$export$2f04de43fe27971a);
    $parcel$export(module.exports, "setExtras", ()=>$583de2969a487e4e$export$bb4922da0dd51b92);
    $parcel$export(module.exports, "setTags", ()=>$583de2969a487e4e$export$74a8fb34822092e6);
    $parcel$export(module.exports, "setExtra", ()=>$583de2969a487e4e$export$8e8e7789d42ed61d);
    $parcel$export(module.exports, "setTag", ()=>$583de2969a487e4e$export$a37d07ee78eb4569);
    $parcel$export(module.exports, "setUser", ()=>$583de2969a487e4e$export$8b6bb3dd62a01be2);
    $parcel$export(module.exports, "withScope", ()=>$583de2969a487e4e$export$ec58d9285c204497);
    $parcel$export(module.exports, "startTransaction", ()=>$583de2969a487e4e$export$e262da7ae6480481);
    var $3VFsf;
    var $3kk8J;
    function $583de2969a487e4e$var$callOnHub(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var hub = (0, (0, parcelRequire("3kk8J")).getCurrentHub)();
        if (hub && hub[method]) return hub[method].apply(hub, (0, (0, parcelRequire("3VFsf")).__spread)(args));
        throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
    }
    function $583de2969a487e4e$export$f5282963edea4a68(exception, captureContext) {
        var syntheticException = new Error('Sentry syntheticException');
        return $583de2969a487e4e$var$callOnHub('captureException', exception, {
            captureContext: captureContext,
            originalException: exception,
            syntheticException: syntheticException
        });
    }
    function $583de2969a487e4e$export$45654777c133ae80(message, captureContext) {
        var syntheticException = new Error(message);
        var level = typeof captureContext === 'string' ? captureContext : undefined;
        var context = typeof captureContext !== 'string' ? {
            captureContext: captureContext
        } : undefined;
        return $583de2969a487e4e$var$callOnHub('captureMessage', message, level, (0, (0, parcelRequire("3VFsf")).__assign)({
            originalException: message,
            syntheticException: syntheticException
        }, context));
    }
    function $583de2969a487e4e$export$1462b974fdcf6ba2(event) {
        return $583de2969a487e4e$var$callOnHub('captureEvent', event);
    }
    function $583de2969a487e4e$export$99d44f04437e9cb8(callback) {
        $583de2969a487e4e$var$callOnHub('configureScope', callback);
    }
    function $583de2969a487e4e$export$efda9a273d7a036d(breadcrumb) {
        $583de2969a487e4e$var$callOnHub('addBreadcrumb', breadcrumb);
    }
    function $583de2969a487e4e$export$2f04de43fe27971a(name, context) {
        $583de2969a487e4e$var$callOnHub('setContext', name, context);
    }
    function $583de2969a487e4e$export$bb4922da0dd51b92(extras) {
        $583de2969a487e4e$var$callOnHub('setExtras', extras);
    }
    function $583de2969a487e4e$export$74a8fb34822092e6(tags) {
        $583de2969a487e4e$var$callOnHub('setTags', tags);
    }
    function $583de2969a487e4e$export$8e8e7789d42ed61d(key, extra) {
        $583de2969a487e4e$var$callOnHub('setExtra', key, extra);
    }
    function $583de2969a487e4e$export$a37d07ee78eb4569(key, value) {
        $583de2969a487e4e$var$callOnHub('setTag', key, value);
    }
    function $583de2969a487e4e$export$8b6bb3dd62a01be2(user) {
        $583de2969a487e4e$var$callOnHub('setUser', user);
    }
    function $583de2969a487e4e$export$ec58d9285c204497(callback) {
        $583de2969a487e4e$var$callOnHub('withScope', callback);
    }
    function $583de2969a487e4e$export$5b9bc6fc91daaf9f(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        $583de2969a487e4e$var$callOnHub.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spread)([
            '_invokeClient',
            method
        ], args));
    }
    function $583de2969a487e4e$export$e262da7ae6480481(context, customSamplingContext) {
        return $583de2969a487e4e$var$callOnHub('startTransaction', (0, (0, parcelRequire("3VFsf")).__assign)({}, context), customSamplingContext);
    }
});
parcelRegister("3Y2SJ", function(module, exports) {
    $parcel$export(module.exports, "Breadcrumbs", ()=>$2e3935ee4e2a5168$export$2dc68d50d56fbbd);
    var $3VFsf;
    var $3kk8J;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $iDqcL;
    var $1vYJz;
    var $eUO5L;
    var $fB1v8;
    var $keOcA;
    var $5L8AU;
    var $2e3935ee4e2a5168$export$2dc68d50d56fbbd = function() {
        function Breadcrumbs(options) {
            this.name = Breadcrumbs.id;
            this._options = (0, (0, parcelRequire("3VFsf")).__assign)({
                console: true,
                dom: true,
                fetch: true,
                history: true,
                sentry: true,
                xhr: true
            }, options);
        }
        Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
            if (!this._options.sentry) return;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
                event_id: event.event_id,
                level: event.level,
                message: (0, (0, parcelRequire("1vYJz")).getEventDescription)(event)
            }, {
                event: event
            });
        };
        Breadcrumbs.prototype.setupOnce = function() {
            if (this._options.console) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('console', $2e3935ee4e2a5168$var$_consoleBreadcrumb);
            if (this._options.dom) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('dom', $2e3935ee4e2a5168$var$_domBreadcrumb(this._options.dom));
            if (this._options.xhr) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('xhr', $2e3935ee4e2a5168$var$_xhrBreadcrumb);
            if (this._options.fetch) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('fetch', $2e3935ee4e2a5168$var$_fetchBreadcrumb);
            if (this._options.history) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('history', $2e3935ee4e2a5168$var$_historyBreadcrumb);
        };
        Breadcrumbs.id = 'Breadcrumbs';
        return Breadcrumbs;
    }();
    function $2e3935ee4e2a5168$var$_domBreadcrumb(dom) {
        function _innerDomBreadcrumb(handlerData) {
            var target;
            var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
            if (typeof keyAttrs === 'string') keyAttrs = [
                keyAttrs
            ];
            try {
                target = handlerData.event.target ? (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(handlerData.event, keyAttrs);
            } catch (e) {
                target = '<unknown>';
            }
            if (target.length === 0) return;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: "ui." + handlerData.name,
                message: target
            }, {
                event: handlerData.event,
                name: handlerData.name,
                global: handlerData.global
            });
        }
        return _innerDomBreadcrumb;
    }
    function $2e3935ee4e2a5168$var$_consoleBreadcrumb(handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, (0, parcelRequire("5L8AU")).severityFromString)(handlerData.level),
            message: (0, (0, parcelRequire("keOcA")).safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + ((0, (0, parcelRequire("keOcA")).safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    }
    function $2e3935ee4e2a5168$var$_xhrBreadcrumb(handlerData) {
        if (handlerData.endTimestamp) {
            if (handlerData.xhr.__sentry_own_request__) return;
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code
                },
                type: 'http'
            }, {
                xhr: handlerData.xhr,
                input: body
            });
            return;
        }
    }
    function $2e3935ee4e2a5168$var$_fetchBreadcrumb(handlerData) {
        if (!handlerData.endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') return;
        if (handlerData.error) (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: (0, (0, parcelRequire("8vvJk")).Severity).Error,
            type: 'http'
        }, {
            data: handlerData.error,
            input: handlerData.args
        });
        else (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData.fetchData), {
                status_code: handlerData.response.status
            }),
            type: 'http'
        }, {
            input: handlerData.args,
            response: handlerData.response
        });
    }
    function $2e3935ee4e2a5168$var$_historyBreadcrumb(handlerData) {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, (0, parcelRequire("1vYJz")).parseUrl)(global.location.href);
        var parsedFrom = (0, (0, parcelRequire("1vYJz")).parseUrl)(from);
        var parsedTo = (0, (0, parcelRequire("1vYJz")).parseUrl)(to);
        if (!parsedFrom.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    }
});
parcelRegister("9e9ba", function(module, exports) {
    $parcel$export(module.exports, "maskEmailIds", ()=>$6b7c8aa13a9e7ef7$export$7a75efd77ad928b4);
    const $6b7c8aa13a9e7ef7$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
    const $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4 = (text)=>text.replace($6b7c8aa13a9e7ef7$var$EMAIL_REGEX, '***@***');
});
parcelRegister("bV8dQ", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsProvider", ()=>$8adb655be51f0bfa$export$1b581a2ec13e37f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvUB1;
    const $8adb655be51f0bfa$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
        const sendEvent = (0, $5uXOq.useCallback)((event)=>{
            var _event$clone;
            const { actionSubject: actionSubject, attributes: attributes } = event.payload;
            const context = {};
            if (actionSubject) {
                context.component = actionSubject;
                context.componentName = actionSubject;
            }
            if (attributes) context.attributes = attributes;
            event.context.push(context);
            (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
        }, [
            channel
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
            channel: (0, $6e65040b988c460f$export$2ceccf177fae277c),
            onEvent: sendEvent
        }, children);
    };
});
parcelRegister("51w3E", function(module, exports) {
    $parcel$export(module.exports, "PackageIntlProvider", ()=>$3a85e9ca49ba7c46$export$dfce9acc1b75df7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $fiX4W;
    var $aJMGy;
    const $3a85e9ca49ba7c46$var$i18nMessages = (0, parcelRequire("aJMGy"));
    const $3a85e9ca49ba7c46$var$LOCALE_REGEX = /([a-z]+)(?:[-_]([A-Z]+))?/i;
    const $3a85e9ca49ba7c46$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>{
        let match = $3a85e9ca49ba7c46$var$LOCALE_REGEX.exec(locale);
        if (!match) {
            console.error('Unable to get language and country from invalid locale, falling back to default locale.');
            match = $3a85e9ca49ba7c46$var$LOCALE_REGEX.exec((0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE));
        }
        const [, languagePart, countryPart] = match;
        const language = languagePart.toLowerCase();
        const country = countryPart === null || countryPart === void 0 ? void 0 : countryPart.toUpperCase();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: country && $3a85e9ca49ba7c46$var$i18nMessages[`${language}_${country}`] || $3a85e9ca49ba7c46$var$i18nMessages[language] || $3a85e9ca49ba7c46$var$i18nMessages[0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE],
            locale: country ? `${language}-${country}` : language,
            defaultLocale: (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE),
            defaultRichTextElements: {
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("strong", null, chunks)
            }
        }, children);
    };
});
parcelRegister("aJMGy", function(module, exports) {
    $parcel$export(module.exports, "cs", ()=>(parcelRequire("cMpqA")).default);
    $parcel$export(module.exports, "da", ()=>(parcelRequire("bmet5")).default);
    $parcel$export(module.exports, "de", ()=>(parcelRequire("5gZPv")).default);
    $parcel$export(module.exports, "en", ()=>(parcelRequire("5xL3T")).default);
    $parcel$export(module.exports, "en_GB", ()=>(parcelRequire("GqOub")).default);
    $parcel$export(module.exports, "en_ZZ", ()=>(parcelRequire("57UJa")).default);
    $parcel$export(module.exports, "es", ()=>(parcelRequire("6boQd")).default);
    $parcel$export(module.exports, "fi", ()=>(parcelRequire("dlz8J")).default);
    $parcel$export(module.exports, "fr", ()=>(parcelRequire("aPgl0")).default);
    $parcel$export(module.exports, "hu", ()=>(parcelRequire("6J5AL")).default);
    $parcel$export(module.exports, "it", ()=>(parcelRequire("1M5Ys")).default);
    $parcel$export(module.exports, "ja", ()=>(parcelRequire("bLeGY")).default);
    $parcel$export(module.exports, "ko", ()=>(parcelRequire("CjKDf")).default);
    $parcel$export(module.exports, "nb", ()=>(parcelRequire("17Bak")).default);
    $parcel$export(module.exports, "nl", ()=>(parcelRequire("9kBkv")).default);
    $parcel$export(module.exports, "pl", ()=>(parcelRequire("8Cv29")).default);
    $parcel$export(module.exports, "pt_BR", ()=>(parcelRequire("5SndE")).default);
    $parcel$export(module.exports, "ru", ()=>(parcelRequire("3Q4bF")).default);
    $parcel$export(module.exports, "sv", ()=>(parcelRequire("byyqD")).default);
    $parcel$export(module.exports, "th", ()=>(parcelRequire("jZ2BW")).default);
    $parcel$export(module.exports, "tr", ()=>(parcelRequire("lLvYG")).default);
    $parcel$export(module.exports, "uk", ()=>(parcelRequire("cfPf5")).default);
    $parcel$export(module.exports, "vi", ()=>(parcelRequire("dHJWH")).default);
    $parcel$export(module.exports, "zh", ()=>(parcelRequire("ljUGJ")).default);
    $parcel$export(module.exports, "zh_TW", ()=>(parcelRequire("172LK")).default);
    var $cMpqA;
    var $bmet5;
    var $5gZPv;
    var $5xL3T;
    var $GqOub;
    var $57UJa;
    var $6boQd;
    var $dlz8J;
    var $aPgl0;
    var $6J5AL;
    var $1M5Ys;
    var $bLeGY;
    var $CjKDf;
    var $17Bak;
    var $9kBkv;
    var $8Cv29;
    var $5SndE;
    var $3Q4bF;
    var $byyqD;
    var $jZ2BW;
    var $lLvYG;
    var $cfPf5;
    var $dHJWH;
    var $ljUGJ;
    var $172LK;
});
parcelRegister("cMpqA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94ddb1256b9e5b23$export$2e2bcd8739ae039);
    var $94ddb1256b9e5b23$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "Vytvo\u0159it dal\u0161\xed po\u017Eadavek",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "Vytvo\u0159it",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Zkuste to znovu pozd\u011Bji.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "V\xe1\u0161 po\u017Eadavek se nepoda\u0159ilo vytvo\u0159it.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Vy\u0159e\u0161te v\u0161echny neplatn\xe9 odpov\u011Bdi a\xa0zkontrolujte, zda jsou vypln\u011Bna v\u0161echna povinn\xe1 pole.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Kop\xedrovat odkaz",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Vytvo\u0159ili jste po\u017Eadavek "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "Zobrazit po\u017Eadavek",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "Upravit formul\xe1\u0159",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Upravit formul\xe1\u0159 \u017E\xe1dosti",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Po\u017E\xe1dejte spr\xe1vce, aby p\u0159esunul pole <strong>{formFieldName}</strong> z\xa0podm\xedn\u011Bn\xe9 sekce nebo zru\u0161il p\u0159\xedznak \u201Epovinn\xe9\u201C u\xa0propojen\xe9ho pole <strong>{jiraFieldName}</strong> v\xa0Jira ve formul\xe1\u0159i \u017E\xe1dosti typu <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "P\u0159esu\u0148te pole <strong>{formFieldName}</strong> z\xa0podm\xedn\u011Bn\xe9 sekce nebo zru\u0161te p\u0159\xedznak \u201Epovinn\xe9\u201C u\xa0propojen\xe9ho pole <strong>{jiraFieldName}</strong> v\xa0Jira ve formul\xe1\u0159i \u017E\xe1dosti typu <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "Povinn\xe9 pole v\xa0podm\xedn\u011Bn\xe9 sekci",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Po\u017E\xe1dejte spr\xe1vce, aby propojil pole v\xa0tomto formul\xe1\u0159i s\xa0polem Jira <strong>{jiraFieldName}</strong> ve formul\xe1\u0159i \u017E\xe1dosti typu <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Propojte pole v\xa0tomto formul\xe1\u0159i s\xa0polem Jira <strong>{jiraFieldName}</strong> ve formul\xe1\u0159i \u017E\xe1dosti <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "Povinn\xe9 pole nen\xed p\u0159ipojeno",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Po\u017E\xe1dejte spr\xe1vce, aby ozna\u010Dil pole <strong>{formFieldName}</strong> v\xa0tomto formul\xe1\u0159i jako \u201Epovinn\xe9\u201C, aby odpov\xeddalo propojen\xe9mu poli <strong>{jiraFieldName}</strong> v\xa0Jira ve formul\xe1\u0159i \u017E\xe1dosti typu <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Ozna\u010Dte pole <strong>{formFieldName}</strong> v\xa0tomto formul\xe1\u0159i jako \u201Epovinn\xe9\u201C, aby odpov\xeddalo propojen\xe9mu poli <strong>{jiraFieldName}</strong> v\xa0Jira ve formul\xe1\u0159i \u017E\xe1dosti typu <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "Povinn\xe9 pole neodpov\xedd\xe1",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Obnovte str\xe1nku a\xa0zkuste to znovu.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "V\xe1\u0161 formul\xe1\u0159 se nepoda\u0159ilo na\u010D\xedst",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Odeberte atributy, kter\xe9 u\u017E neexistuj\xed ve filtru konfigurace vlastn\xedch pol\xed Aktiv, a\xa0zkontrolujte, zda je dotaz AQL platn\xfd.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Pro toto pole se nepoda\u0159ilo na\u010D\xedst \u017E\xe1dn\xe9 objekty",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "Vytvo\u0159it dal\u0161\xed po\u017Eadavek",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Zobrazte si po\u017Eadavek <a>issueKey</a> a\xa0budete jej moci aktualizovat nebo spravovat.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "V\xe1\u0161 po\u017Eadavek byl vytvo\u0159en",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Vytv\xe1\u0159ejte po\u017Eadavky pomoc\xed vlo\u017Een\xfdch formul\xe1\u0159\u016F vlo\u017Een\xedm tohoto odkazu na libovoln\xfd web Atlassian. <a>Kop\xedrovat odkaz</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Obnovte str\xe1nku a\xa0zkuste to znovu.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "P\u0159i na\u010D\xedt\xe1n\xed va\u0161ich formul\xe1\u0159\u016F se vyskytly probl\xe9my",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Obnovte str\xe1nku a\xa0zkuste to znovu.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "P\u0159i na\u010D\xedt\xe1n\xed va\u0161ich projekt\u016F se vyskytly probl\xe9my",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "Vyberte formul\xe1\u0159.",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "Vyberte typ po\u017Eadavku.",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Vytv\xe1\u0159ejte po\u017Eadavky pomoc\xed formul\xe1\u0159e nebo p\u0159\xedm\xe9ho odkazu na formul\xe1\u0159. <a>Dal\u0161\xed informace o\xa0pou\u017E\xedv\xe1n\xed formul\xe1\u0159\u016F k\xa0vytv\xe1\u0159en\xed po\u017Eadavk\u016F</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "Vytvo\u0159it po\u017Eadavek",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Tento projekt slu\u017Eby nem\xe1 \u017E\xe1dn\xe9 p\u0159idru\u017Een\xe9 formul\xe1\u0159e.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Tento softwarov\xfd projekt nem\xe1 \u017E\xe1dn\xe9 p\u0159idru\u017Een\xe9 formul\xe1\u0159e.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Tento obchodn\xed projekt nem\xe1 \u017E\xe1dn\xe9 p\u0159idru\u017Een\xe9 formul\xe1\u0159e.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Vyberte projekt.',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Vyberte typ \u017E\xe1dosti."
    };
});
parcelRegister("bmet5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$844cf8d7a3d6f628$export$2e2bcd8739ae039);
    var $844cf8d7a3d6f628$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Opret en anden sag',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Opret',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Pr\xf8v igen senere.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': 'Vi kunne ikke oprette din sag.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "L\xf8s eventuelle ugyldige svar, og kontroll\xe9r, at alle p\xe5kr\xe6vede felter er udfyldt.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Kopi\xe9r link",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Du har oprettet sagen "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Vis sag',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Rediger formular',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Rediger anmodningsformular',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Bed din administrator om at flytte feltet <strong>{formFieldName}</strong> ud af betingelsessektionen, eller fjern statussen &quot;P\xe5kr\xe6vet&quot; fra det tilknyttede Jira-felt <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Flyt feltet <strong>{formFieldName}</strong> ud af betingelsessektionen, eller fjern statussen &quot;P\xe5kr\xe6vet&quot; fra det tilknyttede Jira-felt <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': '"P\xe5kr\xe6vet" felt i betingelsesafsnittet',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': 'Bed din administrator om at knytte et felt i denne formular til Jira-feltet <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Knyt et felt i denne formular til Jira-feltet <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'Det "p\xe5kr\xe6vede" felt er ikke tilknyttet',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Bed din administrator om at markere feltet <strong>{formFieldName}</strong> i denne formular som &quot;P\xe5kr\xe6vet&quot; for at matche det tilknyttede Jira-felt <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Mark\xe9r feltet <strong>{formFieldName}</strong> i denne formular som &quot;P\xe5kr\xe6vet&quot; for at matche det tilknyttede Jira-felt <strong>{jiraFieldName}</strong> i anmodningsformularen <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'Det "p\xe5kr\xe6vede" felt matcher ikke',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Opdater siden, og pr\xf8v igen.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Vi kunne ikke indl\xe6se din formular",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Fjern attributter, der ikke l\xe6ngere findes i konfigurationsfilteret for brugerdefineret Aktiver-felt, og s\xf8rg for, at AQL-foresp\xf8rgslen er gyldig.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': 'Vi kunne ikke hente nogen objekter for dette felt',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Opret en anden sag',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'Se <a>issueKey</a> for at opdatere eller administrere denne sag.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Vi har oprettet din sag',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Opret sager ved hj\xe6lp af indlejrede formularer ved at inds\xe6tte dette link p\xe5 et Atlassian-websted. <a>Kopi\xe9r link</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Opdater siden, og pr\xf8v igen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Vi har problemer med at indl\xe6se dine formularer",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Opdater siden, og pr\xf8v igen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Vi har problemer med at indl\xe6se dine projekter",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "V\xe6lg en formular",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "V\xe6lg en sagstype",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Opret sager ved hj\xe6lp af en formular eller direkte fra et link til en formular. <a>F\xe5 mere at vide om brug af formularer til at oprette sager.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Opret sag',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': 'Dette serviceprojekt har ingen tilknyttede formularer.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': 'Dette softwareprojekt har ingen tilknyttede formularer.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': 'Dette forretningsprojekt har ingen tilknyttede formularer.',
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "V\xe6lg et projekt",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "V\xe6lg en anmodningstype"
    };
});
parcelRegister("5gZPv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d6e687eac27b406$export$2e2bcd8739ae039);
    var $3d6e687eac27b406$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Weiteren Vorgang erstellen',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Erstellen',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Bitte versuchen Sie es sp\xe4ter erneut.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': 'Ihr Vorgang konnte nicht erstellt werden.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Bitte bearbeiten Sie alle ung\xfcltigen Antworten und stellen Sie sicher, dass alle erforderlichen Felder ausgef\xfcllt sind.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Link kopieren',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Sie haben den Vorgang "{issueKey}" erstellt.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Vorgang anzeigen',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Formular bearbeiten',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Anfrageformular bearbeiten',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Bitten Sie Ihren Administrator, das Feld <strong>{formFieldName}</strong> aus dem bedingten Abschnitt zu verschieben, oder entfernen Sie den Status &quot;Erforderlich&quot; aus dem verkn\xfcpften Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': 'Verschieben Sie das Feld <strong>{formFieldName}</strong> aus dem bedingten Abschnitt oder entfernen Sie den Status &quot;Erforderlich&quot; aus dem Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': '"Erforderliches" Feld im bedingten Abschnitt',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Bitten Sie Ihren Administrator, ein Feld in diesem Formular mit dem Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong> zu verkn\xfcpfen.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Verkn\xfcpfen Sie ein Feld in diesem Formular mit dem Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': '"Erforderliches" Feld ist nicht verkn\xfcpft',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Bitten Sie Ihren Administrator, das Feld <strong>{formFieldName}</strong> in diesem Formular als &quot;Erforderlich&quot; zu kennzeichnen, damit es mit dem verkn\xfcpften Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong> \xfcbereinstimmt.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Kennzeichnen Sie das Feld <strong>{formFieldName}</strong> in diesem Formular als &quot;Pflichtfeld&quot;, damit es mit seinem verkn\xfcpften Jira-Feld <strong>{jiraFieldName}</strong> im Anfrageformular <strong>{typeName}</strong> \xfcbereinstimmt.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': '"Erforderliches" Feld stimmt nicht \xfcberein',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': 'Ihr Formular konnte nicht geladen werden',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Entfernen Sie Attribute, die nicht mehr existieren, aus dem Konfigurationsfilter f\xfcr benutzerdefinierte Assets-Felder und stellen Sie sicher, dass die AQL-Abfrage g\xfcltig ist.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "F\xfcr dieses Feld konnten keine Objekte abgerufen werden",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Weiteren Vorgang erstellen',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': '<a>issueKey</a> anzeigen, um diesen Vorgang zu aktualisieren oder zu verwalten.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Ihr Vorgang wurde erstellt',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Erstellen Sie Vorg\xe4nge mithilfe von eingebetteten Formularen, indem Sie diesen Link auf einer beliebigen Atlassian-Site einf\xfcgen. <a>Link kopieren</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': 'Beim Laden Ihrer Formulare ist ein Problem aufgetreten',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': 'Beim Laden Ihrer Projekte ist ein Problem aufgetreten',
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "Formular ausw\xe4hlen",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "Vorgangstyp ausw\xe4hlen",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Erstellen Sie Vorg\xe4nge mithilfe eines Formulars oder direkt \xfcber einen Link zu einem Formular. <a>Hier finden Sie weitere Informationen zum Erstellen von Vorg\xe4ngen mithilfe von Formularen.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Vorgang erstellen',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "F\xfcr dieses Serviceprojekt gibt es keine zugeh\xf6rigen Formulare.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "F\xfcr dieses Softwareprojekt gibt es keine zugeh\xf6rigen Formulare.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "F\xfcr dieses Gesch\xe4ftsprojekt gibt es keine zugeh\xf6rigen Formulare.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "Projekt ausw\xe4hlen",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Anfragetyp ausw\xe4hlen"
    };
});
parcelRegister("5xL3T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40948a529a530633$export$2e2bcd8739ae039);
    var $40948a529a530633$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Create another issue',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Create',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': 'Please try again later.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "We couldn\u2019t create your issue.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': 'Resolve any invalid answers and check all required fields are complete.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copy link',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'You\u2019ve created "{issueKey}" issue.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'View issue',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Edit form',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Edit request form',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Ask your admin to move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u2018Required\u2019 field in conditional section",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': 'Ask your admin to link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u2018Required\u2019 field is not linked",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Ask your admin to mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u2018Required\u2019 field does not match",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "We couldn\u2019t load your form",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': 'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "We couldn't fetch any objects for this field",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Create another issue',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'View <a>issueKey</a> to update, or manage this issue.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "We\u2019ve created your issue",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': 'Create issues using embedded forms by pasting this link on any Atlassian site. <a>Copy link</a>',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "We\u2019re having trouble loading your forms",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "We\u2019re having trouble loading your projects",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Select a form',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Select an issue type',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': 'Create issues using a form, or from a link to a form directly. <a>Learn more about using forms to create issues.</a>',
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Create issue',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "This service project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "This software project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "This business project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Select a project',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Select a request type'
    };
});
parcelRegister("GqOub", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07f8b8eb37bf4911$export$2e2bcd8739ae039);
    var $07f8b8eb37bf4911$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Create another issue',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Create',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': 'Please try again later.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "We couldn\u2019t create your issue.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': 'Resolve any invalid answers and check all required fields are complete.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copy link',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'You\u2019ve created "{issueKey}" issue.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'View issue',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Edit form',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Edit request form',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Ask your admin to move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u2018Required\u2019 field in conditional section",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': 'Ask your admin to link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u2018Required\u2019 field is not linked",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Ask your admin to mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u2018Required\u2019 field does not match",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "We couldn\u2019t load your form",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': 'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "We couldn't fetch any objects for this field",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Create another issue',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'View <a>issueKey</a> to update, or manage this issue.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "We\u2019ve created your issue",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': 'Create issues using embedded forms by pasting this link on any Atlassian site. <a>Copy link</a>',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "We\u2019re having trouble loading your forms",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': 'Refresh the page and try again.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "We\u2019re having trouble loading your projects",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Select a form',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Select an issue type',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': 'Create issues using a form, or from a link to a form directly. <a>Learn more about using forms to create issues.</a>',
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Create issue',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "This service project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "This software project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "This business project doesn\u2019t have any associated forms.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Select a project',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Select a request type'
    };
});
parcelRegister("57UJa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bb99c16efa3c9f5$export$2e2bcd8739ae039);
    var $3bb99c16efa3c9f5$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u2063\u2062Create another issue\x8f\u200C\u200D\u200D\u2061\x9d\x81\u2060\u2061\u206B\u206B\u2060\x8d\u200C\u200C\u200C\u206C\x9d\u206C\u206E\x81\u206F\u2060\u206D\u200C\u200D\u2060\x8d\x9d\u200D\x8d\u206E\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u2063\u2062Create\u206F\x9d\u206F\u2061\u206A\x9d\x9d\u061C\u206C\x9d\x9d\u200C\x9d\u206E\x8d\u2060\x8d\x8f\u061C\u2061\u2061\u206F\u206B\x9d\u200D\u206E\u2060\u206E\u206F\u206E\u206F\u206A\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u2063\u2062Please try again later.\u206D\u200D\u206B\u206E\u061C\u206D\x9d\x81\x8f\x8d\u206A\u200D\x81\u206B\u200C\x8d\x9d\u061C\u061C\u061C\u206C\u2061\u206A\u200C\u2060\u200C\x8d\u061C\x81\u2060\x9d\x90\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u2063\u2062We couldn\u2019t create your issue.\x8d\u061C\u200C\u200D\x90\u2061\u2061\u206A\x90\u206B\u206B\x81\x90\x90\u206D\u200C\u206B\u2061\x9d\u206F\u200D\x9d\u061C\x9d\u206C\u200D\u206D\u061C\x8f\x81\u206D\u2060\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u2063\u2062Resolve any invalid answers and check all required fields are complete.\x8f\x81\u206B\u206A\u200C\u2060\u206E\u206C\x8d\x90\u2060\u200D\x9d\u206F\x90\u206A\u200C\x90\u2061\u200D\u206B\x8f\x8d\u061C\x8f\u061C\u2061\x8f\u206F\x81\u206F\u206B\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u2063\u2062Copy link\u206B\x81\u206B\u206C\u2061\u2061\u206C\u206F\x9d\u206B\u061C\u206B\u206C\u206A\u2060\u206E\u200C\u206E\u206A\x9d\u2061\x81\u2060\x81\u200D\u206E\u061C\u206D\u200D\u206E\u206E\u206C\u2063\u2064",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': '\u2063\u2062You\u2019ve created "{issueKey}" issue.\u206D\u206C\u206C\u206C\u200D\u206F\x8f\x8f\u206D\u206A\x8d\u2060\u061C\x8d\x8d\u206A\u206E\u200C\u206B\u206F\x8d\x81\u200C\x8d\u206D\u061C\u206D\x90\u206B\u206E\u206C\x9d\u2063\u2064',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u2063\u2062View issue\u206F\u206F\u206C\x8f\u2060\x8f\u206F\u206A\x8d\u200C\u2060\u200D\x9d\u200C\u206C\u206E\x8f\u2060\u206C\x90\x90\u206A\x9d\u2060\u200C\u206E\u206E\x8d\x8d\u2061\u2060\u2060\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u2063\u2062Edit form\u200C\u200D\x9d\u2061\u206F\x81\u206B\u206D\u206A\x8f\u200C\u061C\u2061\u206F\u206E\x90\u206F\x90\u206E\u206C\u206F\u206A\u206E\x8d\x9d\x9d\u206D\u200C\u061C\u2061\x90\u206C\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u2063\u2062Edit request form\x81\x90\u2060\u206A\x9d\u2061\x9d\x81\x90\u206C\u061C\u200D\x8d\u200C\x8f\u206E\x9d\x8f\u200C\x81\u206B\x8d\u061C\u200C\u2060\x81\u206D\u206D\u206C\x90\x81\u2061\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u2063\u2062Ask your admin to move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.\u206F\u2061\x8f\x8f\u206C\u206A\u206B\u206F\x81\u206C\u206B\u206D\u206E\u200C\u2060\x9d\x9d\u061C\u206B\u2060\u206A\x8d\u206E\u206A\x90\u206F\u200C\u200C\u206A\u206C\u206A\x81\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u2063\u2062Move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.\u206D\x8f\x90\u2060\u061C\u206A\u206F\u200C\u206C\u206F\x8f\x8f\x90\x8f\x8f\u2060\u206D\x90\u206A\u206D\u206F\u206F\u206B\x8f\x90\u2060\u206B\u206C\u2061\u206E\u206D\x8d\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u2063\u2062\u2018Required\u2019 field in conditional section\u206A\x9d\x81\u200D\x9d\x9d\x8d\u206C\u206F\u2060\u206B\x9d\u206B\u206F\u2060\u206D\u200D\u206E\x9d\x8f\x8f\u206B\u2061\u2060\u206A\u2061\x8f\u206E\u206B\u061C\u061C\x8d\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u2063\u2062Ask your admin to link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.\x81\u2061\x9d\x8f\u206C\u2061\u200C\u206A\u2061\u206E\u206B\u2060\x8d\u206A\u206F\x9d\u206C\u200C\u206A\x81\u206F\x90\u061C\u206D\x8f\u206B\x81\u206C\x8d\u206A\u061C\u2060\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u2063\u2062Link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.\x8d\u061C\x8d\x81\x8d\u206D\x9d\u200C\u206E\u200C\x81\x81\x9d\x81\u206F\u206E\x90\x8f\u200C\u206D\x81\u200C\u206A\u2060\u206A\x8f\u206D\u200C\x9d\x8d\x81\x90\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u2063\u2062\u2018Required\u2019 field is not linked\u2060\u061C\u200D\u2061\u206E\u206E\u206B\u206F\u206C\u206E\x90\x8f\u206A\u200C\x8f\x8f\u206B\u2060\u206F\u200C\u206D\u206F\u206C\x81\u2061\u206C\u200D\u206E\u200C\u206A\u2061\u061C\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u2063\u2062Ask your admin to mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.\u206F\u206E\x90\u200D\u206C\u206B\x8f\u061C\x81\u200D\u200C\x8f\u206E\u2060\u206D\u200C\u200C\x8d\u200C\u2060\u2061\x90\x90\x8d\x81\u206C\x8f\x90\x81\u2060\x81\x9d\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u2063\u2062Mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.\u2061\x8d\u206B\u2061\x9d\u206E\x90\x90\u2060\x81\x81\u206D\u200C\u206D\u206D\u2061\x8d\u206F\u2060\u2060\u206F\u200D\u206C\u206F\x90\x81\u206C\u2061\u2060\u206D\x90\x9d\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u2063\u2062\u2018Required\u2019 field does not match\u2060\u206A\x90\x8f\u2060\u200C\u200D\x90\x8d\u206C\u200C\u200D\x8f\x90\u2060\u206F\u206E\u206C\u206C\u2061\x90\u2061\u206F\x8f\u200C\u206C\x8f\x8d\u2060\u206C\x8d\u206D\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u2063\u2062Refresh the page and try again.\x81\u2060\x90\x9d\u206F\x9d\u206E\u206D\u200D\u206F\u206B\u206E\x90\u206D\x81\u200D\x90\u061C\u206A\x8d\u061C\u206D\u200C\u061C\u061C\u206F\u206E\x8f\u206E\u206A\u200D\u206B\u2063\u2064",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u2063\u2062We couldn\u2019t load your form\u200D\u2061\u200D\u206D\u200D\x8d\u2060\x90\u206E\x8d\u200C\u206C\u200D\u206D\x90\u200C\u061C\u2060\x81\u200C\u206D\u2061\u206E\x81\u200D\u206C\x8d\x81\x9d\u206B\x8d\u2061\u2063\u2064",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u2063\u2062Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.\u206D\u206D\x90\u206B\u200D\u200C\u206E\u200D\x9d\u2061\x8f\u2061\x81\u2061\x9d\x9d\x9d\u206F\u206B\u206B\u200D\u206A\u206C\u2061\u2061\u206F\u206D\u200D\u2061\u206A\u206B\x8f\u2063\u2064",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u2063\u2062We couldn't fetch any objects for this field\u061C\x8f\u206B\u061C\u200D\x90\u2060\u206A\u2060\u206C\x8f\u206E\u206C\u206D\u2061\x8d\u206A\u206F\x8f\u206A\x81\u206D\x8d\u206F\x81\u206A\x81\u206A\u206B\u206E\u2061\u2060\u2063\u2064",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u2063\u2062Create another issue\x90\x90\u2061\x8f\u2060\u2061\u206F\u206A\u206F\x8f\x8f\x81\u206C\u206C\u206C\x81\x90\x90\u206A\x9d\x9d\u2061\u206B\x8f\x8f\u2061\u200C\x81\u061C\u206F\x8f\u2060\u2063\u2064",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u2063\u2062View <a>issueKey</a> to update, or manage this issue.\u206C\u206A\u206B\x8f\x8d\x81\u206F\u206F\x81\x8d\u206B\x9d\u206F\u206B\u206E\x8d\x8f\u2060\u206E\u206C\u2061\x8d\u2060\u2061\u206D\u206F\u061C\u2061\x9d\x8f\x81\u206B\u2063\u2064",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u2063\u2062We\u2019ve created your issue\u2060\x90\u2060\u061C\u206A\u206A\u206A\x90\u206B\x9d\u200D\x81\u2060\u2061\u206E\u206B\x81\u206F\u200C\x9d\u2060\u206C\x90\u206E\u206F\u206D\u200C\x8d\u206A\u2061\x8d\x9d\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u2063\u2062Create issues using embedded forms by pasting this link on any Atlassian site. <a>Copy link</a>\u206D\x8f\x90\u2060\u200C\u206D\u206F\x9d\u206E\u2060\u206A\x9d\u200C\u061C\x9d\u206F\u061C\u206D\x8f\x8d\u206E\u206F\u206C\x81\u2061\x90\u206A\x8f\u206C\u206A\x81\u206B\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u2063\u2062Refresh the page and try again.\u061C\u206B\x8d\u2060\x9d\u206E\u2061\u2060\u206E\u200C\x8d\u2060\u206C\u200C\u206A\u2060\u206C\u206C\u2060\u061C\u061C\u206E\u200D\u200D\u061C\u200C\u206D\x8d\x90\x8f\x9d\u206F\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u2063\u2062We\u2019re having trouble loading your forms\x8f\u200D\x9d\u206E\u206C\x81\u206C\u206B\x9d\x9d\u061C\u206A\x8d\u206A\u200D\u200D\u200D\u061C\x8f\u200D\x9d\u200C\u2061\u2061\x81\u206B\u2061\u206A\u206D\u206E\x90\x8f\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u2063\u2062Refresh the page and try again.\u200C\u200C\u200C\u2060\u2061\x8d\x8d\u206D\x90\u206A\u2061\x8f\u206A\u206D\u2061\u200C\u206C\u206A\u206B\u206A\u206E\u200C\x90\x81\u206E\x9d\u2060\u200C\u2060\u2061\u206E\x81\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u2063\u2062We\u2019re having trouble loading your projects\u206C\u206A\u206A\x8f\u206A\u206B\u206A\x8d\u206B\u2061\u206E\u2060\u206A\u200D\x9d\u206E\u206C\u2061\u2060\u061C\u206B\u206B\x81\x8d\u206D\u2061\u206D\u206B\u206B\x8f\u2060\u206C\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u2063\u2062Select a form\x9d\u206F\u206A\x9d\u206D\u200C\x8f\u206B\u206D\x81\u206F\x8d\x8f\u206F\x9d\x90\u206F\u206F\u206A\x90\u206B\x8d\u200D\u206E\x90\u206C\x81\u206D\u206C\u2061\u206D\u206F\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u2063\u2062Select an issue type\x8f\u200C\x81\u2061\x90\u061C\x9d\x8f\u206B\u206E\u2060\x8f\u206E\u206D\u061C\u206F\x8f\u2061\u206F\x8f\x9d\x8d\x81\x81\u206B\u200C\u2061\u2060\u206B\u2060\u206C\u2060\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u2063\u2062Create issues using a form, or from a link to a form directly. <a>Learn more about using forms to create issues.</a>\u200D\u206B\u206F\x90\u2060\x81\u206B\x8f\u200D\u200C\x90\u061C\x90\u061C\u206D\u206C\u206A\u206C\u206B\x90\u206F\x81\u206F\u206B\u206D\u206F\u2060\x90\u206E\x8d\x81\u206D\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u2063\u2062Create issue\u206E\u206D\x8d\u061C\u2061\u206B\u206D\x8d\u2060\x81\x9d\u2060\x8d\x9d\u200D\u2060\u206F\u206B\u206F\x90\u2061\u2061\u206B\u2061\u200C\u2061\x8f\x81\u2060\u206D\u200D\u206B\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u2063\u2062This service project doesn\u2019t have any associated forms.\u200C\u206B\u2060\u206A\u200C\x81\x9d\u206E\u206F\u206A\u206C\u206B\x81\u2060\x90\x81\x81\u200C\x8d\u200C\u206E\u2060\u206E\u206F\u206C\u200D\u206D\u2061\u200D\x8d\u206B\u206F\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u2063\u2062This software project doesn\u2019t have any associated forms.\u200D\u206B\u061C\x81\x8f\u206F\u206F\u206F\u061C\u206C\x8f\u200C\u200D\u206E\x8d\u206C\u061C\u206B\u200C\x8f\u200D\u206E\u061C\u206F\u206F\u206A\u206A\u206A\u206F\u061C\u206D\x8f\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u2063\u2062This business project doesn\u2019t have any associated forms.\x8d\x8d\u206C\u2061\x8f\u2060\u200C\u206B\u206D\x90\x9d\u200D\x8f\x81\u206D\u2061\u206E\u200D\x8f\u206A\u206B\u206A\x9d\u200C\u200C\x81\u2061\x90\u2060\u206B\u061C\u206D\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u2063\u2062Select a project\u200C\u206E\u206C\u2061\u2061\x8f\u206E\u2060\u2060\x8d\u206F\u206C\x9d\u206F\x81\u206A\u2060\u206C\u206D\x81\u206E\x90\u206F\x8f\u200C\x90\x81\u206E\u200D\u200C\x90\u200D\u2063\u2064",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u2063\u2062Select a request type\u2060\u200C\u206A\u061C\u206B\u2061\u200D\u200C\u2061\x81\u206B\u200C\u206C\u200C\x9d\u200C\x81\x8f\u2060\x81\u206B\u206C\u206A\x81\x8f\u061C\u206E\u206E\u206B\u206A\u2061\x81\u2063\u2064"
    };
});
parcelRegister("6boQd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48070a1980391356$export$2e2bcd8739ae039);
    var $48070a1980391356$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Crear otra incidencia',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Crear',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Int\xe9ntalo de nuevo m\xe1s tarde.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': 'No hemos podido crear tu incidencia.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Corrige las respuestas no v\xe1lidas y comprueba que todos los campos obligatorios est\xe9n completos.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copiar enlace',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Has creado la incidencia "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Ver incidencia',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Editar formulario',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Editar formulario de solicitud',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Pide a tu administrador que saque el campo <strong>{formFieldName}</strong> de la secci\xf3n condicional o que elimine el estado de obligatoriedad de su campo de Jira vinculado <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Saca el campo <strong>{formFieldName}</strong> de la secci\xf3n condicional o elimina el estado de obligatoriedad de su campo de Jira vinculado <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': 'El campo "Obligatorio" en una secci\xf3n condicional',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': 'Pide a tu administrador que vincule un campo de este formulario con el campo de Jira <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Vincula un campo de este formulario con el campo de Jira <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'El campo "Obligatorio" no est\xe1 vinculado',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': 'Pide a tu administrador que marque el campo <strong>{formFieldName}</strong> de este formulario como &quot;Obligatorio&quot; para que coincida con su campo de Jira vinculado <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': 'Marca el campo <strong>{formFieldName}</strong> de este formulario como obligatorio para que coincida con su campo de Jira vinculado <strong>{jiraFieldName}</strong> en el formulario de solicitud <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'El campo obligatorio no coincide',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Actualiza la p\xe1gina e int\xe9ntalo de nuevo.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': 'No hemos podido cargar tu formulario.',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Elimina los atributos que ya no existan en el filtro de configuraci\xf3n de campo personalizado de Activos y aseg\xfarate de que la consulta de AQL sea v\xe1lida.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "No hemos podido obtener ning\xfan objeto para este campo",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Crear otra incidencia',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'Consulta <a>issueKey</a> para actualizar o gestionar esta incidencia.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Hemos creado tu incidencia',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': 'Crea incidencias con formularios integrados pegando este enlace en cualquier sitio de Atlassian. <a>Copiar enlace</a>',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Actualiza la p\xe1gina e int\xe9ntalo de nuevo.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': 'Tenemos problemas para cargar tus formularios.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Actualiza la p\xe1gina e int\xe9ntalo de nuevo.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': 'Tenemos problemas para cargar tus proyectos.',
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Seleccionar un formulario',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Seleccionar un tipo de incidencia',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Crea incidencias con un formulario o directamente desde un enlace a un formulario. <a>Obt\xe9n m\xe1s informaci\xf3n sobre c\xf3mo crear incidencias con formularios.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Crear incidencia',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': 'Este proyecto de asistencia no tiene formularios asociados.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': 'Este proyecto de software no tiene formularios asociados.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': 'Este proyecto empresarial no tiene formularios asociados.',
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Seleccionar un proyecto',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Seleccionar un tipo de solicitud'
    };
});
parcelRegister("dlz8J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b787e92b17f4605$export$2e2bcd8739ae039);
    var $9b787e92b17f4605$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Luo toinen asia',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Luo',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Yrit\xe4 my\xf6hemmin uudelleen.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Asiasi luominen ep\xe4onnistui.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Korjaa virheelliset vastaukset ja tarkista, ett\xe4 kaikki pakolliset kent\xe4t on t\xe4ytetty.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Kopioi linkki',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Olet luonut asian avaimella "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "N\xe4yt\xe4 asia",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Muokkaa lomaketta',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Muokkaa pyynt\xf6lomaketta",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Pyyd\xe4 yll\xe4pit\xe4j\xe4\xe4 siirt\xe4m\xe4\xe4n kentt\xe4 <strong>{formFieldName}</strong> pois ehdollisten osiosta tai poista tila &quot;Pakollinen&quot; tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen linkitetyst\xe4 Jira-kent\xe4st\xe4 <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Siirr\xe4 kentt\xe4 <strong>{formFieldName}</strong> pois ehdollisten osiosta tai poista tila &quot;Pakollinen&quot; tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen linkitetyst\xe4 Jira-kent\xe4st\xe4 <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': '"Pakollinen" kentt\xe4 ehdollisten osiossa',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Pyyd\xe4 yll\xe4pit\xe4j\xe4\xe4 yhdist\xe4m\xe4\xe4n t\xe4m\xe4n lomakkeen kentt\xe4 tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen Jira-kentt\xe4\xe4n <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Linkit\xe4 t\xe4m\xe4n lomakkeen kentt\xe4 tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen Jira-kentt\xe4\xe4n <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'Tyypin "Pakollinen" kentt\xe4\xe4 ei ole linkitetty',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Pyyd\xe4 yll\xe4pit\xe4j\xe4\xe4 merkitsem\xe4\xe4n t\xe4m\xe4n lomakkeen kent\xe4n <strong>{formFieldName}</strong> tyypiksi &quot;Pakollinen&quot;, jotta se vastaa tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen linkitetty\xe4 Jira-kentt\xe4\xe4 <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Merkitse t\xe4m\xe4n lomakkeen kent\xe4n <strong>{formFieldName}</strong> tyypiksi &quot;Pakollinen&quot;, jotta se vastaa tyypin <strong>{typeName}</strong> pyynt\xf6lomakkeen yhdistetty\xe4 Jira-kentt\xe4\xe4 <strong>{jiraFieldName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'Tyypin "Pakollinen" kentt\xe4 ei t\xe4sm\xe4\xe4',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "P\xe4ivit\xe4 sivu ja yrit\xe4 uudelleen.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Lomakkeesi lataaminen ep\xe4onnistui.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Poista ominaisuudet, joita ei en\xe4\xe4 ole Resurssien muokattavan kent\xe4n m\xe4\xe4rityssuodattimessa, ja varmista, ett\xe4 AQL-kysely on kelvollinen.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "T\xe4lle kent\xe4lle ei voitu hakea kohteita",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Luo toinen asia',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "P\xe4ivit\xe4 tai hallinnoi t\xe4t\xe4 asiaa n\xe4ytt\xe4m\xe4ll\xe4 <a>issueKey</a>.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Asia luotiin',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Luo asioita k\xe4ytt\xe4m\xe4ll\xe4 upotettuja lomakkeita liitt\xe4m\xe4ll\xe4 t\xe4m\xe4 linkki mihin tahansa Atlassian-sivustoon. <a>Kopioi linkki</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "P\xe4ivit\xe4 sivu ja yrit\xe4 uudelleen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': 'Lomakkeidesi lataamisessa on ongelma',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "P\xe4ivit\xe4 sivu ja yrit\xe4 uudelleen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': 'Projektiesi lataaminen ei onnistu',
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Valitse lomake',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Valitse asiatyyppi',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Luo asioita k\xe4ytt\xe4m\xe4ll\xe4 lomaketta tai suoraan linkist\xe4 lomakkeeseen. <a>Lue lis\xe4\xe4 lomakkeiden k\xe4yt\xf6st\xe4 asioiden luomiseen.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Luo asia',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "T\xe4h\xe4n palveluprojektiin ei ole liitetty lomakkeita.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "T\xe4h\xe4n ohjelmistoprojektiin ei ole liitetty lomakkeita.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "T\xe4h\xe4n liiketoimintaprojektiin ei ole liitetty lomakkeita.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Valitse projekti',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Valitse pyynt\xf6tyyppi"
    };
});
parcelRegister("aPgl0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e1b5722a817aeb3$export$2e2bcd8739ae039);
    var $7e1b5722a817aeb3$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "Cr\xe9er un autre ticket",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "Cr\xe9er",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Veuillez r\xe9essayer ult\xe9rieurement.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Impossible de cr\xe9er votre ticket.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "R\xe9solvez les r\xe9ponses non valides et v\xe9rifiez que tous les champs obligatoires sont renseign\xe9s.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copier le lien',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "Vous avez cr\xe9\xe9 le ticket \xab\xa0{issueKey}\xa0\xbb.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Afficher le ticket',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Modifier le formulaire',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Modifier le formulaire de la demande',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Demandez \xe0 votre administrateur de d\xe9placer le champ <strong>{formFieldName}</strong> hors de la section conditionnelle ou de supprimer l'\xe9tat \xab\xa0obligatoire\xa0\xbb du champ\xa0Jira <strong>{jiraFieldName}</strong> li\xe9 sur le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "D\xe9placez le champ <strong>{formFieldName}</strong> hors de la section conditionnelle ou supprimez l'\xe9tat \xab\xa0obligatoire\xa0\xbb du champ\xa0Jira <strong>{jiraFieldName}</strong> li\xe9 sur le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "Champ \xab\xa0obligatoire\xa0\xbb dans la section conditionnelle",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Demandez \xe0 votre administrateur de lier un champ de ce formulaire au champ\xa0Jira <strong>{jiraFieldName}</strong> dans le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Liez un champ de ce formulaire au champ\xa0Jira <strong>{jiraFieldName}</strong> dans le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "Le champ \xab\xa0obligatoire\xa0\xbb n'est pas li\xe9",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Demandez \xe0 votre administrateur de marquer le champ <strong>{formFieldName}</strong> dans ce formulaire comme \xab\xa0obligatoire\xa0\xbb pour qu'il corresponde au champ\xa0Jira <strong>{jiraFieldName}</strong> li\xe9 dans le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Marquez le champ <strong>{formFieldName}</strong> dans ce formulaire comme \xab\xa0obligatoire\xa0\xbb pour qu'il corresponde au champ\xa0Jira <strong>{jiraFieldName}</strong> li\xe9 dans le formulaire de la demande <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "Le champ \xab\xa0obligatoire\xa0\xbb ne correspond pas",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Actualisez la page, puis r\xe9essayez.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': 'Impossible de charger votre formulaire',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Supprimez les attributs qui n'existent plus dans le filtre de configuration de champ personnalis\xe9 Actifs et assurez-vous que la requ\xeate\xa0AQL est valide.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Nous n'avons trouv\xe9 aucun objet pour ce champ",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "Cr\xe9er un autre ticket",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Affichez la cl\xe9 de ticket\xa0<a>issueKey</a> pour mettre \xe0 jour ou g\xe9rer ce ticket.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "Nous avons cr\xe9\xe9 votre ticket",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Cr\xe9ez des tickets \xe0 l'aide de formulaires int\xe9gr\xe9s en collant ce lien sur n'importe quel site\xa0Atlassian. <a>Copier le lien</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Actualisez la page, puis r\xe9essayez.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Nous rencontrons des difficult\xe9s pour charger vos formulaires",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Actualisez la page, puis r\xe9essayez.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Nous rencontrons des difficult\xe9s pour charger vos projets",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "S\xe9lectionner un formulaire",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "S\xe9lectionner un type de ticket",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Cr\xe9ez des tickets \xe0 l'aide d'un formulaire ou directement \xe0 partir d'un lien vers un formulaire. <a>En savoir plus sur l'utilisation des formulaires pour cr\xe9er des tickets</a>.",
        'proforma-jira-issue-forms.ui.general.header.page-header': "Cr\xe9er un ticket",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Ce projet de services n'est associ\xe9 \xe0 aucun formulaire.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Ce projet logiciel n'est associ\xe9 \xe0 aucun formulaire.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Ce projet m\xe9tier n'est associ\xe9 \xe0 aucun formulaire.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "S\xe9lectionner un projet",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "S\xe9lectionner un type de demande"
    };
});
parcelRegister("6J5AL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e5b487ee907d2fe$export$2e2bcd8739ae039);
    var $4e5b487ee907d2fe$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "M\xe1sik \xfcgy l\xe9trehoz\xe1sa",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "L\xe9trehoz\xe1s",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Pr\xf3b\xe1lkozz \xfajra k\xe9s\u0151bb.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Nem siker\xfclt l\xe9trehozni az \xfcgyet.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Oldd meg az \xe9rv\xe9nytelen v\xe1laszokat, \xe9s ellen\u0151rizd, hogy az \xf6sszes k\xf6telez\u0151 mez\u0151 ki van-e t\xf6ltve.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Link m\xe1sol\xe1sa",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "L\xe9trehoztad a(z) {issueKey} \xfcgyet.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\xdcgy megtekint\xe9se",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u0170rlap szerkeszt\xe9se",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "K\xe9relem\u0171rlap szerkeszt\xe9se",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "K\xe9rd meg az adminisztr\xe1torodat, hogy t\xe1vol\xedtsa el a(z) <strong>{formFieldName}</strong> mez\u0151t a felt\xe9teleket tartalmaz\xf3 szakaszb\xf3l, vagy t\xf6r\xf6lje a &quot;k\xf6telez\u0151&quot; \xe1llapotot a hozz\xe1kapcsolt <strong>{jiraFieldName}</strong> Jira-mez\u0151b\u0151l a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "T\xe1vol\xedtsd el a(z) <strong>{formFieldName}</strong> mez\u0151t a felt\xe9teleket tartalmaz\xf3 szakaszb\xf3l, vagy t\xf6r\xf6ld a &quot;k\xf6telez\u0151&quot; \xe1llapotot a hozz\xe1kapcsolt <strong>{jiraFieldName}</strong> Jira-mez\u0151b\u0151l a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u201EK\xf6telez\u0151\u201C mez\u0151 a felt\xe9teleket tartalmaz\xf3 szakaszban",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "K\xe9rd meg az adminisztr\xe1torodat, hogy kapcsoljon \xf6ssze egy mez\u0151t ezen az \u0171rlapon a(z) <strong>{jiraFieldName}</strong> Jira-mez\u0151vel a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Kapcsolj \xf6ssze egy mez\u0151t ezen az \u0171rlapon a(z) <strong>{jiraFieldName}</strong> Jira-mez\u0151vel a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "A \u201Ek\xf6telez\u0151\u201C mez\u0151 nincs hozz\xe1kapcsolva",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "K\xe9rd meg az adminisztr\xe1torodat, hogy a(z) <strong>{formFieldName}</strong> mez\u0151t jel\xf6lje meg \u201Ek\xf6telez\u0151k\xe9nt\u201C ezen az \u0171rlapon, hogy egyezzen a hozz\xe1kapcsolt <strong>{jiraFieldName}</strong> Jira-mez\u0151vel a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "A(z) <strong>{formFieldName}</strong> mez\u0151t jel\xf6ld meg sz\xfcks\xe9gesk\xe9nt ezen az \u0171rlapon, hogy egyezzen a hozz\xe1kapcsolt <strong>{jiraFieldName}</strong> Jira-mez\u0151vel a(z) <strong>{typeName}</strong> k\xe9relem\u0171rlapon.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "A \u201ESz\xfcks\xe9ges\u201C mez\u0151 nem egyezik",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Friss\xedtsd az oldalt, majd pr\xf3b\xe1lkozz \xfajra.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Nem siker\xfclt bet\xf6lteni az \u0171rlapot",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "T\xe1vol\xedtsd el az Eszk\xf6z\xf6k-egy\xe9ni mez\u0151 konfigur\xe1ci\xf3s sz\u0171r\u0151j\xe9ben m\xe1r nem l\xe9tez\u0151 attrib\xfatumokat, \xe9s gondoskodj r\xf3la, hogy az AQL-lek\xe9rdez\xe9s \xe9rv\xe9nyes legyen.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Nem siker\xfclt lek\xe9rni egyetlen objektumot sem ehhez a mez\u0151h\xf6z",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "M\xe1sik \xfcgy l\xe9trehoz\xe1sa",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Az \xfcgy friss\xedt\xe9s\xe9hez vagy kezel\xe9s\xe9hez tekintsd meg a k\xf6vetkez\u0151 \xfcgykulcsot: <a>issueKey</a>.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "L\xe9trehoztuk az \xfcgyet",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Illeszd be ezt a linket b\xe1rmilyen Atlassian-webhelyre, \xe9s hozz l\xe9tre \xfcgyeket a be\xe1gyazott \u0171rlapokkal. <a>Link m\xe1sol\xe1sa</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Friss\xedtsd az oldalt, majd pr\xf3b\xe1lkozz \xfajra.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Probl\xe9ma mer\xfclt fel az \u0171rlapok bet\xf6lt\xe9se sor\xe1n",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Friss\xedtsd az oldalt, majd pr\xf3b\xe1lkozz \xfajra.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Probl\xe9ma mer\xfclt fel a projektek bet\xf6lt\xe9se sor\xe1n",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "V\xe1lassz ki egy \u0171rlapot",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "V\xe1lassz ki egy \xfcgyt\xedpust",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Hozz l\xe9tre \xfcgyeket egy \u0171rlap vagy egy k\xf6zvetlen\xfcl az \u0171rlapra mutat\xf3 link seg\xedts\xe9g\xe9vel. <a>Tov\xe1bbi inform\xe1ci\xf3 az \xfcgyek \u0171rlapok seg\xedts\xe9g\xe9vel t\xf6rt\xe9n\u0151 l\xe9trehoz\xe1s\xe1r\xf3l.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\xdcgy l\xe9trehoz\xe1sa",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Ehhez az \xfcgyf\xe9lszolg\xe1lati projekthez nincs t\xe1rs\xedtva \u0171rlap.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Ehhez a szoftverprojekthez nincs t\xe1rs\xedtva \u0171rlap.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Ehhez az \xfczleti projekthez nincs t\xe1rs\xedtva \u0171rlap.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "V\xe1lassz ki egy projektet",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "V\xe1lassz ki egy k\xe9relemt\xedpust"
    };
});
parcelRegister("1M5Ys", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14aee87731a7b9c6$export$2e2bcd8739ae039);
    var $14aee87731a7b9c6$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Crea un altro ticket',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Crea',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Riprova pi\xf9 tardi.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Non \xe8 stato possibile creare il ticket.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': 'Risolvi eventuali risposte non valide e verifica che tutti i campi obbligatori siano stati completati.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copia il link',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Hai creato il ticket "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Visualizza il ticket',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Modifica il modulo',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Modifica il modulo di richiesta',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Chiedi all'amministratore di spostare il campo <strong>{formFieldName}</strong> all'esterno della sezione condizionale o di rimuovere lo stato &quot;obbligatorio&quot; dal campo Jira <strong>{jiraFieldName}</strong> collegato nel modulo di richiesta <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Sposta il campo <strong>{formFieldName}</strong> all'esterno della sezione condizionale, oppure rimuovi lo stato &quot;obbligatorio&quot; dal campo Jira <strong>{jiraFieldName}</strong> collegato nel modulo di richiesta <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': 'Campo "obbligatorio" nella sezione condizionale',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Chiedi all'amministratore di collegare un campo di questo modulo al campo Jira <strong>{jiraFieldName}</strong> nel modulo di richiesta <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Collega un campo di questo modulo al campo Jira <strong>{jiraFieldName}</strong> nel modulo di richiesta <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'Il campo "obbligatorio" non \xe8 collegato',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Chiedi all'amministratore di contrassegnare il campo <strong>{formFieldName}</strong> in questo modulo come &quot;obbligatorio&quot; in modo che corrisponda al campo Jira <strong>{jiraFieldName}</strong> collegato nel modulo di richiesta <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': 'Contrassegna il campo <strong>{formFieldName}</strong> in questo modulo come &quot;obbligatorio&quot; in modo che corrisponda al campo Jira <strong>{jiraFieldName}</strong> collegato nel modulo di richiesta <strong>{typeName}</strong>.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'Il campo "obbligatorio" non corrisponde',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': 'Aggiorna la pagina e riprova.',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Non \xe8 stato possibile caricare il modulo",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Rimuovi gli attributi che non esistono pi\xf9 nel filtro di configurazione dei campi personalizzati di Risorse e assicurati che la query AQL sia valida.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': 'Impossibile recuperare gli oggetti di questo campo',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Crea un altro ticket',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'Visualizza <a>issueKey</a> per aggiornare o gestire questo ticket.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Abbiamo creato il ticket',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': 'Incolla questo link in qualsiasi sito Atlassian per creare ticket usando i moduli incorporati. <a>Copia link</a>',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': 'Aggiorna la pagina e riprova.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Si \xe8 verificato un problema durante il caricamento dei tuoi moduli",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': 'Aggiorna la pagina e riprova.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Si \xe8 verificato un problema durante il caricamento dei tuoi progetti",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Seleziona un modulo',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Seleziona un tipo di ticket',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Usa un modulo o un link a un modulo per creare i ticket. <a>Scopri di pi\xf9 sull'uso dei moduli per la creazione di ticket.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Crea un ticket',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Questo progetto di service management non \xe8 associato ad alcun modulo.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Questo progetto software non \xe8 associato ad alcun modulo.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Questo progetto aziendale non \xe8 associato ad alcun modulo.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Seleziona un progetto',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Seleziona un tipo di richiesta'
    };
});
parcelRegister("bLeGY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88ff7b0d023586ba$export$2e2bcd8739ae039);
    var $88ff7b0d023586ba$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u5225\u306E\u8AB2\u984C\u3092\u4F5C\u6210",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u4F5C\u6210",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u5F8C\u307B\u3069\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u8AB2\u984C\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u7121\u52B9\u306A\u56DE\u7B54\u3092\u89E3\u6C7A\u3057\u3066\u3001\u3059\u3079\u3066\u306E\u300C\u5FC5\u9808\u300D\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u5165\u529B\u6E08\u307F\u3067\u3042\u308B\u3053\u3068\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "\u8AB2\u984C\u300C{issueKey}\u300D\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u8AB2\u984C\u3092\u8868\u793A",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u30D5\u30A9\u30FC\u30E0\u3092\u7DE8\u96C6",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u3092\u7DE8\u96C6",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "<strong>{formFieldName}</strong> \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6761\u4EF6\u4ED8\u304D\u30BB\u30AF\u30B7\u30E7\u30F3\u304B\u3089\u79FB\u52D5\u3059\u308B\u3001\u307E\u305F\u306F <strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u4E0A\u306E\u30EA\u30F3\u30AF\u3055\u308C\u305F <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u304B\u3089\u300C\u5FC5\u9808\u300D\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u524A\u9664\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u306B\u3054\u4F9D\u983C\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "<strong>{formFieldName}</strong> \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6761\u4EF6\u4ED8\u304D\u30BB\u30AF\u30B7\u30E7\u30F3\u304B\u3089\u79FB\u52D5\u3059\u308B\u304B\u3001<strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u4E0A\u306E\u30EA\u30F3\u30AF\u3055\u308C\u305F <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u304B\u3089\u300C\u5FC5\u9808\u300D\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u6761\u4EF6\u4ED8\u304D\u30BB\u30AF\u30B7\u30E7\u30F3\u306E\u300C\u5FC5\u9808\u300D\u30D5\u30A3\u30FC\u30EB\u30C9",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092 <strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u306E <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u3068\u30EA\u30F3\u30AF\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u306B\u3054\u4F9D\u983C\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092 <strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u306E <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u3068\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u300C\u5FC5\u9808\u300D\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u30EA\u30F3\u30AF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E <strong>{formFieldName}</strong> \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u300C\u5FC5\u9808\u300D\u3068\u3057\u3066\u30DE\u30FC\u30AF\u3057\u3066\u3001<strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u4E0A\u306E\u30EA\u30F3\u30AF\u3055\u308C\u305F <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u3068\u4E00\u81F4\u3055\u305B\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u306B\u3054\u4F9D\u983C\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E <strong>{formFieldName}</strong> \u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u300C\u5FC5\u9808\u300D\u3068\u3057\u3066\u30DE\u30FC\u30AF\u3057\u3066\u3001<strong>{typeName}</strong> \u30EA\u30AF\u30A8\u30B9\u30C8 \u30D5\u30A9\u30FC\u30E0\u4E0A\u306E\u30EA\u30F3\u30AF\u3055\u308C\u305F <strong>{jiraFieldName}</strong> Jira \u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u4E00\u81F4\u3055\u305B\u307E\u3059\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u300C\u5FC5\u9808\u300D\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u4E00\u81F4\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u30D5\u30A9\u30FC\u30E0\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u30A2\u30BB\u30C3\u30C8 \u30AB\u30B9\u30BF\u30E0 \u30D5\u30A3\u30FC\u30EB\u30C9\u8A2D\u5B9A\u30D5\u30A3\u30EB\u30BF\u30FC\u306B\u3059\u3067\u306B\u5B58\u5728\u3057\u306A\u3044\u5C5E\u6027\u3092\u524A\u9664\u3057\u3001AQL \u30AF\u30A8\u30EA\u304C\u6709\u52B9\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u5225\u306E\u8AB2\u984C\u3092\u4F5C\u6210",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "<a>issueKey</a> \u3092\u8868\u793A\u3057\u3066\u66F4\u65B0\u3059\u308B\u304B\u3001\u3053\u306E\u8AB2\u984C\u306E\u7BA1\u7406\u3092\u884C\u3044\u307E\u3059\u3002",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u8AB2\u984C\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u3053\u306E\u30EA\u30F3\u30AF\u3092\u4EFB\u610F\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30B5\u30A4\u30C8\u306B\u8CBC\u308A\u4ED8\u3051\u3066\u3001\u57CB\u3081\u8FBC\u307F\u30D5\u30A9\u30FC\u30E0\u3067\u8AB2\u984C\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002<a>\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u30D5\u30A9\u30FC\u30E0\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u30D5\u30A9\u30FC\u30E0\u3092\u9078\u629E",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u8AB2\u984C\u30BF\u30A4\u30D7\u3092\u9078\u629E",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F7F\u7528\u3059\u308B\u304B\u3001\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u30EA\u30F3\u30AF\u304B\u3089\u76F4\u63A5\u8AB2\u984C\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002<a>\u30D5\u30A9\u30FC\u30E0\u306B\u3088\u308B\u8AB2\u984C\u4F5C\u6210\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u8AB2\u984C\u3092\u4F5C\u6210",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u3053\u306E\u30B5\u30FC\u30D3\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30D5\u30A9\u30FC\u30E0\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u3053\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30D5\u30A9\u30FC\u30E0\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u3053\u306E\u30D3\u30B8\u30CD\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30D5\u30A9\u30FC\u30E0\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u9078\u629E",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u3092\u9078\u629E"
    };
});
parcelRegister("CjKDf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0732dee3201c99b4$export$2e2bcd8739ae039);
    var $0732dee3201c99b4$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\uB2E4\uB978 \uC774\uC288 \uB9CC\uB4E4\uAE30",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\uB9CC\uB4E4\uAE30",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\uC774\uC288\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB2F5\uBCC0\uC744 \uD574\uACB0\uD558\uACE0 \uBAA8\uB4E0 \uD544\uC218 \uD544\uB4DC\uB97C \uC791\uC131\uD588\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\uB9C1\uD06C \uBCF5\uC0AC",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': '"{issueKey}" \uC774\uC288\uB97C \uB9CC\uB4E4\uC5C8\uC2B5\uB2C8\uB2E4.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\uC774\uC288 \uBCF4\uAE30",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\uC591\uC2DD \uD3B8\uC9D1",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\uC694\uCCAD \uC591\uC2DD \uD3B8\uC9D1",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\uAD00\uB9AC\uC790\uC5D0\uAC8C <strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC5D0\uC11C <strong>{formFieldName}</strong> \uD544\uB4DC\uB97C \uC870\uAC74\uBD80 \uC139\uC158 \uBC16\uC73C\uB85C \uC774\uB3D9\uD558\uAC70\uB098 \uC5F0\uACB0\uB41C <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC5D0\uC11C '\uD544\uC218' \uC0C1\uD0DC\uB97C \uC81C\uAC70\uD558\uB3C4\uB85D \uC694\uCCAD\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "<strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC5D0\uC11C <strong>{formFieldName}</strong> \uD544\uB4DC\uB97C \uC870\uAC74\uBD80 \uC139\uC158 \uBC16\uC73C\uB85C \uC774\uB3D9\uD558\uAC70\uB098 \uC5F0\uACB0\uB41C <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC5D0\uC11C '\uD544\uC218' \uC0C1\uD0DC\uB97C \uC81C\uAC70\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\uC870\uAC74\uBD80 \uC139\uC158\uC758 '\uD544\uC218' \uD544\uB4DC",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\uAD00\uB9AC\uC790\uC5D0\uAC8C \uC774 \uC591\uC2DD\uC758 \uD544\uB4DC\uB97C <strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC758 <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC640 \uC5F0\uACB0\uD558\uB3C4\uB85D \uC694\uCCAD\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\uC774 \uC591\uC2DD\uC758 \uD544\uB4DC\uB97C <strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC758 <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC640 \uC5F0\uACB0\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "'\uD544\uC218' \uD544\uB4DC\uAC00 \uC5F0\uACB0\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\uAD00\uB9AC\uC790\uC5D0\uAC8C <strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC758 \uC5F0\uACB0\uB41C <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC640 \uC77C\uCE58\uD558\uB3C4\uB85D \uC774 \uC591\uC2DD\uC758 <strong>{formFieldName}</strong> \uD544\uB4DC\uB97C '\uD544\uC218'\uB85C \uD45C\uC2DC\uD558\uB3C4\uB85D \uC694\uCCAD\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "<strong>{typeName}</strong> \uC694\uCCAD \uC591\uC2DD\uC758 \uC5F0\uACB0\uB41C <strong>{jiraFieldName}</strong> Jira \uD544\uB4DC\uC640 \uC77C\uCE58\uD558\uB3C4\uB85D \uC774 \uC591\uC2DD\uC758 <strong>{formFieldName}</strong> \uD544\uB4DC\uB97C '\uD544\uC218'\uB85C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "'\uD544\uC218' \uD544\uB4DC\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\uC591\uC2DD\uC744 \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\uC790\uC0B0 \uC0AC\uC6A9\uC790 \uC9C0\uC815 \uD544\uB4DC \uAD6C\uC131 \uD544\uD130\uC5D0 \uB354 \uC774\uC0C1 \uC5C6\uB294 \uD2B9\uC131\uC744 \uC81C\uAC70\uD558\uACE0 AQL \uCFFC\uB9AC\uAC00 \uC720\uD6A8\uD55C\uC9C0 \uD655\uC778\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\uC774 \uD544\uB4DC\uC5D0 \uB300\uD574 \uAC1C\uCCB4\uB97C \uAC00\uC838\uC62C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\uB2E4\uB978 \uC774\uC288 \uB9CC\uB4E4\uAE30",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\uC774 \uC774\uC288\uB97C \uC5C5\uB370\uC774\uD2B8 \uB610\uB294 \uAD00\uB9AC\uD558\uB824\uBA74 <a>issueKey</a>\uC744(\uB97C) \uD655\uC778\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\uC774\uC288\uB97C \uB9CC\uB4E4\uC5C8\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Atlassian \uC0AC\uC774\uD2B8\uC5D0 \uC774 \uB9C1\uD06C\uB97C \uBD99\uC5EC\uB123\uC5B4 \uD3EC\uD568\uB41C \uC591\uC2DD\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC774\uC288\uB97C \uB9CC\uB4DC\uC138\uC694. <a>\uB9C1\uD06C \uBCF5\uC0AC</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\uC591\uC2DD\uC744 \uB85C\uB4DC\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\uD504\uB85C\uC81D\uD2B8\uB97C \uB85C\uB4DC\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\uC591\uC2DD \uC120\uD0DD",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\uC774\uC288 \uC720\uD615 \uC120\uD0DD",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\uC591\uC2DD\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC774\uC288\uB97C \uB9CC\uB4E4\uAC70\uB098 \uB9C1\uD06C\uC5D0\uC11C \uC591\uC2DD\uC73C\uB85C \uBC14\uB85C \uC774\uC288\uB97C \uB9CC\uB4DC\uC138\uC694. <a>\uC591\uC2DD\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC774\uC288\uB97C \uB9CC\uB4DC\uB294 \uBC29\uBC95\uC744 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\uC774\uC288 \uB9CC\uB4E4\uAE30",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\uC774 \uC11C\uBE44\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uB41C \uC591\uC2DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\uC774 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uB41C \uC591\uC2DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\uC774 \uBE44\uC988\uB2C8\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uB41C \uC591\uC2DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\uD504\uB85C\uC81D\uD2B8 \uC120\uD0DD",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\uC694\uCCAD \uC720\uD615 \uC120\uD0DD"
    };
});
parcelRegister("17Bak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d134638500f1e31$export$2e2bcd8739ae039);
    var $0d134638500f1e31$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Opprett en sak til',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Opprett',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Pr\xf8v igjen senere.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': 'Vi kan ikke opprette saken din.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "H\xe5ndter eventuelle ugyldige svar og sjekk at alle obligatoriske felt er fylt ut.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Kopier kobling',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "Du opprettet saken \xab{issueKey}\xbb.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Vis sak',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Rediger skjema',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Rediger foresp\xf8rselsskjema",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Be administratoren din om \xe5 flytte <strong>{formFieldName}</strong>-feltet fra den betingede delen, eller fjern \xabobligatorisk\xbb-statusen fra det tilknyttede Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Flytt <strong>{formFieldName}</strong>-feltet fra den betingede delen, eller fjern \xabobligatorisk\xbb-statusen fra det tilknyttede Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\xabObligatorisk\xbb felt i betinget seksjon",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Be administratoren din om \xe5 koble et felt i dette skjemaet til Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Koble et felt i dette skjemaet til Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\xabObligatorisk\xbb felt er ikke tilknyttet",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Be administratoren din om \xe5 merke <strong>{formFieldName}</strong>-feltet i dette skjemaet som \xabobligatorisk\xbb for \xe5 matche det tilknyttede Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Merk <strong>{formFieldName}</strong>-feltet i dette skjemaet som \xabobligatorisk\xbb for \xe5 matche det tilknyttede Jira-feltet <strong>{jiraFieldName}</strong> i <strong>{typeName}</strong>-foresp\xf8rselsskjemaet.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\xabObligatorisk\xbb felt matcher ikke",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Oppdater siden og pr\xf8v p\xe5 nytt.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': 'Vi kan ikke laste inn skjemaet ditt',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Fjern attributter som ikke lenger finnes i konfigurasjonsfilteret for det egendefinerte Ressurser-feltet, og p\xe5se at AQL-sp\xf8rringen er gyldig.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': 'Vi kan ikke hente noen objekter for dette feltet',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Opprett en sak til',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Vis <a>issueKey</a> for \xe5 oppdatere, eller administrer denne saken.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'Vi har opprettet saken',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Opprett saker ved hjelp av innebygde skjemaer ved \xe5 lime inn denne koblingen p\xe5 et Atlassian-nettsted. <a>Kopier kobling</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Oppdater siden og pr\xf8v p\xe5 nytt.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': 'Vi kan ikke laste inn skjemaene dine',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Oppdater siden og pr\xf8v p\xe5 nytt.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Vi har problemer med \xe5 laste inn prosjektene dine.",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Velg skjema',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Velg sakstype',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Opprett saker ved hjelp av et skjema, eller direkte fra en kobling til et skjema. <a>Finn ut mer om \xe5 bruke skjemaer til \xe5 opprette saker.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Opprett sak',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': 'Dette serviceprosjektet har ingen tilknyttede skjemaer.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': 'Dette programvareprosjektet har ingen tilknyttede skjemaer.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': 'Dette virksomhetsprosjektet har ingen tilknyttede skjemaer.',
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Velg prosjekt',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Velg foresp\xf8rselstype"
    };
});
parcelRegister("9kBkv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb2f03dd504a5e7$export$2e2bcd8739ae039);
    var $6cb2f03dd504a5e7$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Nog een issue aanmaken',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Aanmaken',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': 'Probeer het later opnieuw.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': 'We konden je issue niet aanmaken.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': 'Wijzig ongeldige antwoorden en controleer of alle vereiste velden zijn ingevuld.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Link kopi\xebren",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Je hebt de issue "{issueKey}" aangemaakt.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Issue bekijken',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Formulier bewerken',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Aanvraagformulier bewerken',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Vraag je beheerder om het veld <strong>{formFieldName}</strong> uit de voorwaardelijke sectie te verplaatsen, of de status 'vereist' te verwijderen uit het gekoppelde Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Verplaats het veld <strong>{formFieldName}</strong> uit de voorwaardelijke sectie, of verwijder de status \u2018vereist\u2019 uit het gekoppelde Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u2018Vereist\u2019 veld in voorwaardelijke sectie",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': 'Vraag je beheerder om een veld in dit formulier te koppelen met het Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': 'Koppel een veld in dit formulier met het Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u2018Vereist\u2019 veld is niet gekoppeld",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Vraag je beheerder om het veld <strong>{formFieldName}</strong> op dit formulier te markeren als \u2018vereist\u2019 zodat deze overeenkomt met het gekoppelde Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Markeer het veld <strong>{formFieldName}</strong> op dit formulier als \u2018vereist\u2019 zodat deze overeenkomt met het gekoppelde Jira-veld <strong>{jiraFieldName}</strong> op het <strong>{typeName}</strong> aanvraagformulier.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u2018Vereist\u2019 veld komt niet overeen",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': 'Vernieuw de pagina en probeer het opnieuw.',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': 'We konden je formulier niet laden',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': 'Verwijder attributen die niet meer bestaan in de filter voor configuratie van Assets aangepaste velden en zorg ervoor dat het AQL-verzoek geldig is.',
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': 'We konden geen objecten ophalen voor dit veld',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Nog een issue aanmaken',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'Bekijk <a>issueKey</a> om deze issue bij te werken of te beheren.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'We hebben je issue aangemaakt',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Maak issues aan met behulp van ingebedde formulieren door deze link in een Atlassian-site te plakken. <a>Link kopi\xebren</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': 'Vernieuw de pagina en probeer het opnieuw.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': 'We kunnen je formulieren niet laden',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': 'Vernieuw de pagina en probeer het opnieuw.',
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': 'We kunnen je projecten niet laden',
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Een formulier selecteren',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Een issuetype selecteren',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': 'Maak issues aan met behulp van een formulier of rechtstreeks vanuit een link naar een formulier. <a>Meer informatie over het gebruiken van formulieren om issues aan te maken.</a>',
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Issue aanmaken',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': 'Dit serviceproject heeft geen bijbehorende formulieren.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': 'Dit softwareproject heeft geen bijbehorende formulieren.',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': 'Dit zakelijke project heeft geen bijbehorende formulieren.',
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Een project selecteren',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Een aanvraagtype selecteren'
    };
});
parcelRegister("8Cv29", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6469f1fd8c2ee20a$export$2e2bcd8739ae039);
    var $6469f1fd8c2ee20a$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "Utw\xf3rz nast\u0119pne zg\u0142oszenie",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "Utw\xf3rz",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Spr\xf3buj ponownie p\xf3\u017Aniej.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Nie mo\u017Cna utworzy\u0107 zg\u0142oszenia.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Popraw wszelkie nieprawid\u0142owe odpowiedzi i sprawd\u017A, czy wszystkie wymagane pola s\u0105 wype\u0142nione.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Kopiuj \u0142\u0105cze",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Utworzono zg\u0142oszenie "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "Wy\u015Bwietl zg\u0142oszenie",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': 'Edytuj formularz',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': 'Edytuj formularz wniosku',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Popro\u015B administratora o przeniesienie pola <strong>{formFieldName}</strong> poza sekcj\u0119 warunkow\u0105 lub usuni\u0119cie statusu \u201Ewymagane\u201D z powi\u0105zanego z nim pola Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Przenie\u015B pole <strong>{formFieldName}</strong> poza sekcj\u0119 warunkow\u0105 lub usu\u0144 status \u201Ewymagane\u201D z powi\u0105zanego z nim pola Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "Pole \u201Ewymagane\u201D w sekcji warunkowej",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Popro\u015B administratora o powi\u0105zanie pola w tym formularzu z polem Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Po\u0142\u0105cz pole w tym formularzu z polem Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "Pole \u201Ewymagane\u201D nie jest powi\u0105zane",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Popro\u015B administratora o oznaczenie pola <strong>{formFieldName}</strong> w tym formularzu jako \u201Ewymagane\u201D, aby by\u0142o zgodne z powi\u0105zanym polem Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Oznacz pole <strong>{formFieldName}</strong> w tym formularzu jako &quot;wymagane&quot;, aby by\u0142o zgodne z powi\u0105zanym polem Jira <strong>{jiraFieldName}</strong> w formularzu wniosku <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'Pole "wymagane" jest niezgodne',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Od\u015Bwie\u017C stron\u0119 i spr\xf3buj ponownie.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Nie mo\u017Cna za\u0142adowa\u0107 formularza",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Usu\u0144 atrybuty, kt\xf3re ju\u017C nie istniej\u0105 w\xa0filtrze konfiguracji pola niestandardowego Zasob\xf3w, i\xa0upewnij si\u0119, \u017Ce\xa0zapytanie AQL jest prawid\u0142owe.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Nie mo\u017Cna pobra\u0107 \u017Cadnych obiekt\xf3w dla tego pola",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "Utw\xf3rz kolejne zg\u0142oszenie",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Wy\u015Bwietl <a>issueKey</a>, aby zaktualizowa\u0107 to zg\u0142oszenie lub nim zarz\u0105dza\u0107.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "Utworzyli\u015Bmy Twoje zg\u0142oszenie",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Tw\xf3rz zg\u0142oszenia za pomoc\u0105 osadzonych formularzy, wklejaj\u0105c to \u0142\u0105cze w dowolnej witrynie Atlassian. <a>Kopiuj \u0142\u0105cze</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Od\u015Bwie\u017C stron\u0119 i spr\xf3buj ponownie.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Wyst\u0105pi\u0142 problem podczas \u0142adowania Twoich formularzy",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Od\u015Bwie\u017C stron\u0119 i spr\xf3buj ponownie.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Wyst\u0105pi\u0142 problem podczas \u0142adowania Twoich projekt\xf3w",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': 'Wybierz formularz',
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "Wybierz typ zg\u0142oszenia",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Tw\xf3rz zg\u0142oszenia za pomoc\u0105 formularza lub korzystaj\u0105c bezpo\u015Brednio z \u0142\u0105cza do formularza. <a>Dowiedz si\u0119 wi\u0119cej na temat tworzenia zg\u0142osze\u0144 za pomoc\u0105 formularzy.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "Utw\xf3rz zg\u0142oszenie",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Ten projekt us\u0142ugowy nie ma \u017Cadnych powi\u0105zanych formularzy.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Ten projekt oprogramowania nie ma \u017Cadnych powi\u0105zanych formularzy.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Ten projekt biznesowy nie ma \u017Cadnych powi\u0105zanych formularzy.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Wybierz projekt',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': 'Wybierz typ wniosku'
    };
});
parcelRegister("5SndE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$447401b9515f353f$export$2e2bcd8739ae039);
    var $447401b9515f353f$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': 'Criar outro item',
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Criar',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': 'Tente de novo mais tarde.',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "N\xe3o foi poss\xedvel criar o item.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Resolva todas as respostas inv\xe1lidas e verifique se todos os campos obrigat\xf3rios est\xe3o preenchidos.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': 'Copiar link',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "Voc\xea criou o item ''{issueKey}'.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': 'Visualizar item',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "Editar formul\xe1rio",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Editar formul\xe1rio de solicita\xe7\xe3o",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Pe\xe7a ao administrador para mover o campo <strong>{formFieldName}</strong> para fora da se\xe7\xe3o condicional ou remover o status &quot;obrigat\xf3rio&quot; do campo vinculado do Jira <strong>{jiraFieldName}</strong> no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Mova o campo <strong>{formFieldName}</strong> para fora da se\xe7\xe3o condicional ou remova o status &quot;obrigat\xf3rio&quot; do campo <strong>{jiraFieldName}</strong> vinculado do Jira no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': 'Campo "obrigat\xf3rio" na se\xe7\xe3o condicional',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Pe\xe7a ao administrador para vincular um campo neste formul\xe1rio ao campo <strong>{jiraFieldName}</strong> do Jira no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Vincule um campo neste formul\xe1rio ao campo do Jira <strong>{jiraFieldName}</strong> no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'O campo "obrigat\xf3rio" n\xe3o est\xe1 vinculado',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Pe\xe7a ao administrador para marcar o campo <strong>{formFieldName}</strong> neste formul\xe1rio como &quot;obrigat\xf3rio&quot;, para corresponder ao campo vinculado <strong>{jiraFieldName}</strong> do Jira no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Marque o campo <strong>{formFieldName}</strong> neste formul\xe1rio como &quot;obrigat\xf3rio&quot; para corresponder ao campo <strong>{jiraFieldName}</strong> vinculado do Jira vinculado no formul\xe1rio de solicita\xe7\xe3o <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'O campo "obrigat\xf3rio" n\xe3o corresponde',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Atualize a p\xe1gina e tente de novo.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "N\xe3o foi poss\xedvel carregar o formul\xe1rio",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Remova os atributos que n\xe3o existem mais no filtro de configura\xe7\xe3o do campo personalizado Recursos e verifique se a consulta AQL \xe9 v\xe1lida.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "N\xe3o foi poss\xedvel buscar objetos para este campo",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': 'Criar outro item',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': 'Visualize <a>IssueKey</a> para atualizar ou gerenciar este item.',
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': 'O item foi criado',
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Crie itens usando formul\xe1rios incorporados colando esse link em qualquer site da Atlassian. <a>Copiar link</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Atualize a p\xe1gina e tente de novo.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "H\xe1 alguns problemas para carregar os formul\xe1rios",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Atualize a p\xe1gina e tente de novo.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "H\xe1 alguns problemas para carregar os projetos",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "Selecionar o formul\xe1rio",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': 'Selecionar o tipo do item',
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Crie itens usando um formul\xe1rio ou por meio de um link direto para um formul\xe1rio. <a>Saiba mais sobre como usar formul\xe1rios para criar itens.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': 'Criar item',
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Este projeto de servi\xe7o n\xe3o tem formul\xe1rios associados.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Este projeto de software n\xe3o tem formul\xe1rios associados.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Este projeto de neg\xf3cios n\xe3o tem formul\xe1rios associados.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': 'Selecionar um projeto',
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Selecionar o tipo de solicita\xe7\xe3o"
    };
});
parcelRegister("3Q4bF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cb979e72f401773$export$2e2bcd8739ae039);
    var $2cb979e72f401773$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0435\u0449\u0435 \u043E\u0434\u043D\u0443 \u0437\u0430\u0434\u0430\u0447\u0443",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u0418\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0432\u0441\u0435 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u043E\u0442\u0432\u0435\u0442\u044B \u0438 \u0443\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0432\u0441\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "\u0421\u043E\u0437\u0434\u0430\u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0430 \xab{issueKey}\xbb.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0438\u0437 \u0443\u0441\u043B\u043E\u0432\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0438\u043B\u0438 \u0443\u0431\u0440\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\xbb \u0443 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044F Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0438\u0437 \u0443\u0441\u043B\u043E\u0432\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0438\u043B\u0438 \u0443\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\xbb \u0443 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044F Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\xab\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435\xbb \u043F\u043E\u043B\u0435 \u0432 \u0443\u0441\u043B\u043E\u0432\u043D\u043E\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0432\u044F\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u0441 \u043F\u043E\u043B\u0435\u043C Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u0421\u0432\u044F\u0436\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0432 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u0441 \u043F\u043E\u043B\u0435\u043C Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\xab\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435\xbb \u043F\u043E\u043B\u0435 \u043D\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u043E",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0432 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u043A\u0430\u043A \xab\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435\xbb, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u043B\u043E \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u043C\u0443 \u043F\u043E\u043B\u044E Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0432 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u043A\u0430\u043A \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u043B\u043E \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u043C\u0443 \u043F\u043E\u043B\u044E Jira <strong>{jiraFieldName}</strong> \u0432 \u0444\u043E\u0440\u043C\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\xab\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435\xbb \u043F\u043E\u043B\u0435 \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u0423\u0434\u0430\u043B\u0438\u0442\u0435 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442, \u0438\u0437 \u0444\u0438\u043B\u044C\u0442\u0440\u0430 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u043F\u043E\u043B\u044F \xab\u0410\u043A\u0442\u0438\u0432\u044B\xbb \u0438 \u0443\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E AQL-\u0437\u0430\u043F\u0440\u043E\u0441 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u043C.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0435\u0449\u0435 \u043E\u0434\u043D\u0443 \u0437\u0430\u0434\u0430\u0447\u0443",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0437\u0430\u0434\u0430\u0447\u0443 <a>issueKey</a>, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0435\u0435 \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u0417\u0430\u0434\u0430\u0447\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445 \u0444\u043E\u0440\u043C\xa0\u2014 \u043F\u0440\u043E\u0441\u0442\u043E \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u044D\u0442\u0443 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043B\u044E\u0431\u043E\u0439 \u0441\u0430\u0439\u0442 Atlassian. <a>\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u043E\u0440\u043C \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0444\u043E\u0440\u043C\u044B \u0438\u043B\u0438 \u043F\u0440\u044F\u043C\u043E\u0439 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0444\u043E\u0440\u043C\u0443. <a>\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0444\u043E\u0440\u043C.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u0423 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043D\u0435\u0442 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0444\u043E\u0440\u043C.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u0423 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E \u043D\u0435\u0442 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0444\u043E\u0440\u043C.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u0423 \u044D\u0442\u043E\u0433\u043E \u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043D\u0435\u0442 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0444\u043E\u0440\u043C.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430"
    };
});
parcelRegister("byyqD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$869d937be3eab889$export$2e2bcd8739ae039);
    var $869d937be3eab889$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "Skapa ett annat \xe4rende",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': 'Skapa',
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "F\xf6rs\xf6k igen senare.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Vi kunde inte skapa ditt \xe4rende.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "L\xf6s eventuella ogiltiga svar och kontrollera att alla obligatoriska f\xe4lt \xe4r ifyllda.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Kopiera l\xe4nk",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'Du har skapat \xe4rendet "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "Visa \xe4rende",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "Redigera formul\xe4ret",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Redigera f\xf6rfr\xe5gningsformul\xe4r",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Be din administrat\xf6r att flytta f\xe4ltet <strong>{formFieldName}</strong> fr\xe5n det villkorliga avsnittet, eller ta bort statusen \u201Dobligatoriskt\u201D fr\xe5n det l\xe4nkade Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Flytta f\xe4ltet <strong>{formFieldName}</strong> fr\xe5n det villkorliga avsnittet, eller ta bort statusen \u201Dobligatoriskt\u201D fr\xe5n det l\xe4nkade Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u201DObligatoriskt\u201D f\xe4lt i den villkorliga sektionen",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Be din administrat\xf6r att l\xe4nka ett f\xe4lt i detta formul\xe4r till Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "L\xe4nka ett f\xe4lt i detta formul\xe4r till Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u201DObligatoriskt\u201D f\xe4lt \xe4r inte l\xe4nkat",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Be din administrat\xf6r att markera f\xe4ltet <strong>{formFieldName}</strong> i detta formul\xe4r som \u201Dobligatoriskt\u201D f\xf6r att matcha det l\xe4nkade Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "Markera f\xe4ltet <strong>{formFieldName}</strong> i detta formul\xe4r som \u201Dobligatoriskt\u201D f\xf6r att matcha det l\xe4nkade Jira-f\xe4ltet <strong>{jiraFieldName}</strong> i f\xf6rfr\xe5gningsformul\xe4ret <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u201DObligatoriskt\u201D f\xe4lt matchar inte",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Uppdatera sidan och f\xf6rs\xf6k igen.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Vi kunde inte l\xe4sa in ditt formul\xe4r",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Ta bort attribut som inte l\xe4ngre finns i konfigurationsfiltret f\xf6r anpassade f\xe4lt f\xf6r tillg\xe5ngar och kontrollera att AQL-fr\xe5gan \xe4r giltig.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Det gick inte att h\xe4mta objekt f\xf6r f\xe4ltet",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "Skapa ett till \xe4rende",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Visa <a>issueKey</a> f\xf6r att uppdatera eller hantera \xe4rendet.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "Vi har skapat ditt \xe4rende",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Skapa \xe4renden med inb\xe4ddade formul\xe4r genom att klistra in den h\xe4r l\xe4nken p\xe5 valfri Atlassian-webbplats. <a>Kopiera l\xe4nk</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Uppdatera sidan och f\xf6rs\xf6k igen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Vi kan inte l\xe4sa in dina formul\xe4r",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Uppdatera sidan och f\xf6rs\xf6k igen.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Vi kan inte l\xe4sa in dina projekt",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "V\xe4lj ett formul\xe4r",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "V\xe4lj en \xe4rendetyp",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Skapa \xe4renden med ett formul\xe4r, eller fr\xe5n en l\xe4nk direkt till ett formul\xe4r. <a>L\xe4s mer om att anv\xe4nda formul\xe4r f\xf6r att skapa \xe4renden.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "Skapa \xe4rende",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Serviceprojektet har inga kopplade formul\xe4r.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Programvaruprojektet har inga kopplade formul\xe4r.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Aff\xe4rsprojektet har inga kopplade formul\xe4r.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "V\xe4lj ett projekt",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "V\xe4lj en f\xf6rfr\xe5gningstyp"
    };
});
parcelRegister("jZ2BW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8c5bd53c34c9a28$export$2e2bcd8739ae039);
    var $e8c5bd53c34c9a28$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E2D\u0E35\u0E01\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u0E08\u0E31\u0E14\u0E17\u0E33",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E08\u0E31\u0E14\u0E17\u0E33\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E44\u0E14\u0E49\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E04\u0E23\u0E1A\u0E16\u0E49\u0E27\u0E19\u0E41\u0E25\u0E49\u0E27",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': '\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E08\u0E31\u0E14\u0E17\u0E33\u0E1B\u0E31\u0E0D\u0E2B\u0E32 "{issueKey}" \u0E41\u0E25\u0E49\u0E27',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u0E14\u0E39\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E22\u0E49\u0E32\u0E22\u0E0A\u0E48\u0E2D\u0E07 <strong>{formFieldName}</strong> \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02 \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30 &quot;\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38&quot; \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07 Jira <strong>{jiraFieldName}</strong> \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u0E22\u0E49\u0E32\u0E22\u0E0A\u0E48\u0E2D\u0E07 <strong>{formFieldName}</strong> \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02 \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30 &quot;\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38&quot; \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07 Jira <strong>{jiraFieldName}</strong> \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': '\u0E0A\u0E48\u0E2D\u0E07 "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38" \u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E0A\u0E48\u0E2D\u0E07 Jira <strong>{jiraFieldName}</strong> \u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E1F\u0E34\u0E25\u0E14\u0E4C\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22 <strong>{jiraFieldName}</strong>\u0E1F\u0E34\u0E25\u0E14\u0E4C Jira \u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': '\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E0A\u0E48\u0E2D\u0E07 "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38"',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E0A\u0E48\u0E2D\u0E07 <strong>{formFieldName}</strong> \u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19 &quot;\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38&quot; \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E0A\u0E48\u0E2D\u0E07 Jira <strong>{jiraFieldName}</strong> \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u0E17\u0E33\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E0A\u0E48\u0E2D\u0E07 <strong>{formFieldName}</strong> \u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19 \u2018\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38\u2019 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E0A\u0E48\u0E2D\u0E07 Jira <strong>{jiraFieldName}</strong> \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E04\u0E33\u0E02\u0E2D <strong>{typeName}</strong>",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u0E0A\u0E48\u0E2D\u0E07 '\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38' \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u0E25\u0E1A\u0E04\u0E38\u0E13\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A Assets \u0E2D\u0E2D\u0E01\u0E41\u0E25\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E33\u0E16\u0E32\u0E21 AQL \u0E19\u0E31\u0E49\u0E19\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E36\u0E07\u0E2B\u0E31\u0E27\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E43\u0E14 \u0E46 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E2D\u0E35\u0E01\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u0E14\u0E39 <a>issueKey</a> \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 \u0E2B\u0E23\u0E37\u0E2D\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E17\u0E35\u0E48\u0E1D\u0E31\u0E07\u0E44\u0E27\u0E49\u0E20\u0E32\u0E22\u0E43\u0E19\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E27\u0E32\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C Atlassian \u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49 <a>\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2B\u0E25\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2B\u0E25\u0E14\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07 <a>\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D"
    };
});
parcelRegister("lLvYG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd86cae6b9a96383$export$2e2bcd8739ae039);
    var $fd86cae6b9a96383$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "Ba\u015Fka bir konu olu\u015Ftur",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "Olu\u015Ftur",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "L\xfctfen daha sonra yeniden deneyin.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Konunuz olu\u015Fturulamad\u0131.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Ge\xe7ersiz yan\u0131tlar\u0131 d\xfczeltin ve t\xfcm zorunlu alanlar\u0131n dolduruldu\u011Fundan emin olun.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Ba\u011Flant\u0131y\u0131 kopyala",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': '"{issueKey}" konusunu olu\u015Fturdunuz.',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "Konuyu g\xf6r\xfcnt\xfcle",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "Formu d\xfczenle",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "Talep formunu d\xfczenleyin",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Y\xf6neticinizden <strong>{formFieldName}</strong> alan\u0131n\u0131 ko\u015Fullu b\xf6l\xfcmden ta\u015F\u0131mas\u0131n\u0131 veya <strong>{typeName}</strong> talep formunda ba\u011Fl\u0131 oldu\u011Fu <strong>{jiraFieldName}</strong> Jira alan\u0131ndan &quot;zorunlu&quot; durumunu kald\u0131rmas\u0131n\u0131 isteyin.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "<strong>{formFieldName}</strong> alan\u0131n\u0131 ko\u015Fullu b\xf6l\xfcmden ta\u015F\u0131y\u0131n veya <strong>{typeName}</strong> talep formunda ba\u011Fl\u0131 oldu\u011Fu <strong>{jiraFieldName}</strong> Jira alan\u0131ndan &quot;zorunlu&quot; durumunu kald\u0131r\u0131n.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': 'Ko\u015Fullu b\xf6l\xfcmdeki "zorunlu" alan',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Y\xf6neticinizden bu formdaki bir alan\u0131 <strong>{typeName}</strong> talep formundaki <strong>{jiraFieldName}</strong> Jira alan\u0131na ba\u011Flamas\u0131n\u0131 isteyin.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Bu formdaki bir alan\u0131 <strong>{typeName}</strong> talep formundaki <strong>{jiraFieldName}</strong> Jira alan\u0131na ba\u011Flay\u0131n.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': '"Zorunlu" alan ba\u011Flanmam\u0131\u015F',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Y\xf6neticinizden <strong>{typeName}</strong> talep formunda ba\u011Fl\u0131 oldu\u011Fu <strong>{jiraFieldName}</strong> Jira alan\u0131yla e\u015Fle\u015Fmesi i\xe7in bu formdaki <strong>{formFieldName}</strong> alan\u0131n\u0131 &quot;zorunlu&quot; olarak i\u015Faretlemesini isteyin.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "<strong>{typeName}</strong> talep formunda ba\u011Fl\u0131 oldu\u011Fu <strong>{jiraFieldName}</strong> Jira alan\u0131yla e\u015Fle\u015Fmesi i\xe7in bu formdaki <strong>{formFieldName}</strong> alan\u0131n\u0131 &quot;gerekli&quot; olarak i\u015Faretleyin.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': '"Gerekli" alan e\u015Fle\u015Fmiyor',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "Sayfay\u0131 yenileyin ve tekrar deneyin.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Formunuz y\xfcklenemedi",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "Art\u0131k Varl\u0131klar \xf6zel alan\u0131 yap\u0131land\u0131rma filtresinde mevcut olmayan nitelikleri kald\u0131r\u0131n ve AQL sorgusunun ge\xe7erli oldu\u011Fundan emin olun.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Bu alan i\xe7in hi\xe7bir nesne al\u0131namad\u0131",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "Ba\u015Fka bir konu olu\u015Ftur",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Bu konuyu g\xfcncellemek veya y\xf6netmek i\xe7in <a>issueKey</a> anahtarl\u0131 konuyu g\xf6r\xfcnt\xfcleyin.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "Konunuz olu\u015Fturuldu",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "Bu ba\u011Flant\u0131y\u0131 herhangi bir Atlassian sitesine yap\u0131\u015Ft\u0131r\u0131p ekli formlar\u0131 kullanarak konu olu\u015Fturun. <a>Ba\u011Flant\u0131y\u0131 kopyalay\u0131n</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "Sayfay\u0131 yenileyin ve tekrar deneyin.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Formunuz y\xfcklenirken bir sorunla kar\u015F\u0131la\u015F\u0131ld\u0131",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "Sayfay\u0131 yenileyin ve tekrar deneyin.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Projeleriniz y\xfcklenirken bir sorunla kar\u015F\u0131la\u015F\u0131ld\u0131",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "Bir form se\xe7in",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "Bir konu t\xfcr\xfc se\xe7in",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "Do\u011Frudan bir formu veya forma y\xf6nlendiren bir ba\u011Flant\u0131y\u0131 kullanarak konu olu\u015Fturun. <a>Konu olu\u015Fturmak i\xe7in formlar\u0131 kullanmak hakk\u0131nda daha fazla bilgi edinin.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "Konu olu\u015Fturun",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "Bu destek projesinde ili\u015Fkili form yok.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "Bu yaz\u0131l\u0131m projesinde ili\u015Fkili form yok.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "Bu i\u015F projesinde ili\u015Fkili form yok.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "Bir proje se\xe7in",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Bir talep t\xfcr\xfc se\xe7in"
    };
});
parcelRegister("cfPf5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ebea262b98a8d43$export$2e2bcd8739ae039);
    var $8ebea262b98a8d43$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0449\u0435 \u043E\u0434\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u0437\u0433\u043E\u0434\u043E\u043C.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u0412\u0438\u043F\u0440\u0430\u0432\u0442\u0435 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0439 \u043F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043E \u0432\u0441\u0456 \u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "\u0412\u0438 \u0441\u0442\u0432\u043E\u0440\u0438\u043B\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \xab{issueKey}\xbb.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \u0437\u0430\u043F\u0438\u0442\u0443",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0437 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0443\u043C\u043E\u0432\u0438 \u0430\u0431\u043E \u0441\u043A\u0430\u0441\u0443\u0439\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044F Jira <strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0456\u0442\u044C \u043F\u043E\u043B\u0435 <strong>{formFieldName}</strong> \u0437 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0443\u043C\u043E\u0432\u0438 \u0430\u0431\u043E \u0441\u043A\u0430\u0441\u0443\u0439\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044F Jira <strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u041F\u043E\u043B\u0435 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb \u0432 \u0440\u043E\u0437\u0434\u0456\u043B\u0456 \u0443\u043C\u043E\u0432\u0438",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u0442\u0438 \u043F\u043E\u043B\u0435 \u0432 \u0446\u0456\u0439 \u0444\u043E\u0440\u043C\u0456 \u0437 \u043F\u043E\u043B\u0435\u043C Jira <strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u041F\u043E\u0432\u2019\u044F\u0436\u0456\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 \u0446\u0456\u0439 \u0444\u043E\u0440\u043C\u0456 \u0437 \u043F\u043E\u043B\u0435\u043C Jira<strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u041F\u043E\u043B\u0435 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb \u043D\u0435 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u041F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u044F <strong>{formFieldName}</strong> \u0446\u0456\u0454\u0457 \u0444\u043E\u0440\u043C\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb, \u0449\u043E\u0431 \u0432\u043E\u043D\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u043E \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u043C\u0443 \u0437 \u043D\u0438\u043C \u043F\u043E\u043B\u044E Jira <strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0434\u043B\u044F \u043F\u043E\u043B\u044F <strong>{formFieldName}</strong> \u0456\u0437 \u0446\u0456\u0454\u0457 \u0444\u043E\u0440\u043C\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443 \xab\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435\xbb, \u0449\u043E\u0431 \u0432\u043E\u043D\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u043E \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u043C\u0443 \u0437 \u043D\u0438\u043C \u043F\u043E\u043B\u044E Jira <strong>{jiraFieldName}</strong> \u0443 \u0444\u043E\u0440\u043C\u0456 \u0437\u0430\u043F\u0438\u0442\u0443 <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u041F\u043E\u043B\u0435 \xab\u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E\xbb \u043D\u0435 \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u041E\u043D\u043E\u0432\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u0412\u0438\u0434\u0430\u043B\u0456\u0442\u044C \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0438, \u044F\u043A\u0456 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0456\u0441\u043D\u0443\u044E\u0442\u044C \u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0456 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u0457 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u043E\u0433\u043E \u043F\u043E\u043B\u044F \xab\u0420\u0435\u0441\u0443\u0440\u0441\u0438\xbb, \u0456 \u043F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0437\u0430\u043F\u0438\u0442 AQL \u0434\u0456\u0439\u0441\u043D\u0438\u0439.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043E\u0431\u2019\u0454\u043A\u0442\u0438 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0449\u0435 \u043E\u0434\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u044C\u0442\u0435 \u043A\u043E\u0434 <a>issueKey</a>, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0430\u0431\u043E \u043A\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043D\u0438\u043C.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0432\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0445 \u0444\u043E\u0440\u043C, \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0447\u0438 \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0431\u0443\u0434\u044C-\u044F\u043A\u043E\u043C\u0443 \u0441\u0430\u0439\u0442\u0456 Atlassian. <a>\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u041E\u043D\u043E\u0432\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0438",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u041E\u043D\u043E\u0432\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0438",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0443",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0444\u043E\u0440\u043C \u0430\u0431\u043E \u043F\u0440\u044F\u043C\u0438\u0445 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u044C \u043D\u0430 \u0444\u043E\u0440\u043C\u0438. <a>\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0444\u043E\u0440\u043C</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0456 \u0437 \u043F\u0440\u043E\u0454\u043A\u0442\u043E\u043C \u0441\u043B\u0443\u0436\u0431\u0438 \u0444\u043E\u0440\u043C\u0438.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0456 \u0437 \u043F\u0440\u043E\u0454\u043A\u0442\u043E\u043C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C\u0438.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0456 \u0437 \u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u043E\u043C \u0444\u043E\u0440\u043C\u0438.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u043E\u0454\u043A\u0442",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443"
    };
});
parcelRegister("dHJWH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fa2ee64931f9fb7$export$2e2bcd8739ae039);
    var $9fa2ee64931f9fb7$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "T\u1EA1o v\u1EA5n \u0111\u1EC1 kh\xe1c",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "T\u1EA1o",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "Vui l\xf2ng th\u1EED l\u1EA1i sau.",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA1o v\u1EA5n \u0111\u1EC1 cho b\u1EA1n",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "Gi\u1EA3i quy\u1EBFt m\u1ECDi c\xe2u tr\u1EA3 l\u1EDDi kh\xf4ng h\u1EE3p l\u1EC7 v\xe0 ki\u1EC3m tra \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o t\u1EA5t c\u1EA3 c\xe1c tr\u01B0\u1EDDng b\u1EAFt bu\u1ED9c \u0111\xe3 ho\xe0n t\u1EA5t.",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "Sao ch\xe9p li\xean k\u1EBFt",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': 'B\u1EA1n \u0111\xe3 t\u1EA1o v\u1EA5n \u0111\u1EC1 "{issueKey}".',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "Xem v\u1EA5n \u0111\u1EC1",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "S\u1EEDa bi\u1EC3u m\u1EABu",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "S\u1EEDa bi\u1EC3u m\u1EABu y\xeau c\u1EA7u",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "Y\xeau c\u1EA7u qu\u1EA3n tr\u1ECB vi\xean c\u1EE7a b\u1EA1n di chuy\u1EC3n tr\u01B0\u1EDDng <strong>{formFieldName}</strong> ra kh\u1ECFi m\u1EE5c c\xf3 \u0111i\u1EC1u ki\u1EC7n ho\u1EB7c x\xf3a tr\u1EA1ng th\xe1i &quot;b\u1EAFt bu\u1ED9c&quot; kh\u1ECFi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> \u0111\xe3 li\xean k\u1EBFt tr\xean bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "Di chuy\u1EC3n tr\u01B0\u1EDDng <strong>{formFieldName}</strong> ra kh\u1ECFi m\u1EE5c c\xf3 \u0111i\u1EC1u ki\u1EC7n ho\u1EB7c x\xf3a tr\u1EA1ng th\xe1i &quot;b\u1EAFt bu\u1ED9c&quot; kh\u1ECFi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> \u0111\xe3 li\xean k\u1EBFt tr\xean bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': 'Tr\u01B0\u1EDDng "b\u1EAFt bu\u1ED9c" trong m\u1EE5c c\xf3 \u0111i\u1EC1u ki\u1EC7n',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "Y\xeau c\u1EA7u qu\u1EA3n tr\u1ECB vi\xean c\u1EE7a b\u1EA1n li\xean k\u1EBFt m\u1ED9t tr\u01B0\u1EDDng trong bi\u1EC3u m\u1EABu n\xe0y v\u1EDBi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> trong bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "Li\xean k\u1EBFt m\u1ED9t tr\u01B0\u1EDDng trong bi\u1EC3u m\u1EABu n\xe0y v\u1EDBi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> trong bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': 'Tr\u01B0\u1EDDng "b\u1EAFt bu\u1ED9c" kh\xf4ng \u0111\u01B0\u1EE3c li\xean k\u1EBFt',
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "Y\xeau c\u1EA7u qu\u1EA3n tr\u1ECB vi\xean c\u1EE7a b\u1EA1n \u0111\xe1nh d\u1EA5u tr\u01B0\u1EDDng <strong>{formFieldName}</strong> trong bi\u1EC3u m\u1EABu n\xe0y l\xe0 &quot;b\u1EAFt bu\u1ED9c&quot; \u0111\u1EC3 kh\u1EDBp v\u1EDBi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> \u0111\xe3 li\xean k\u1EBFt trong bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u0110\xe1nh d\u1EA5u tr\u01B0\u1EDDng <strong>{formFieldName}</strong> trong bi\u1EC3u m\u1EABu n\xe0y l\xe0 &quot;b\u1EAFt bu\u1ED9c&quot; \u0111\u1EC3 kh\u1EDBp v\u1EDBi tr\u01B0\u1EDDng Jira <strong>{jiraFieldName}</strong> \u0111\xe3 li\xean k\u1EBFt trong bi\u1EC3u m\u1EABu y\xeau c\u1EA7u <strong>{typeName}</strong>.",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': 'Tr\u01B0\u1EDDng "b\u1EAFt bu\u1ED9c" kh\xf4ng kh\u1EDBp',
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "L\xe0m m\u1EDBi trang r\u1ED3i th\u1EED l\u1EA1i.",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA3i bi\u1EC3u m\u1EABu c\u1EE7a b\u1EA1n",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "X\xf3a c\xe1c thu\u1ED9c t\xednh kh\xf4ng c\xf2n t\u1ED3n t\u1EA1i trong b\u1ED9 l\u1ECDc c\u1EA5u h\xecnh Tr\u01B0\u1EDDng t\xf9y ch\u1EC9nh Assets v\xe0 \u0111\u1EA3m b\u1EA3o truy v\u1EA5n AQL h\u1EE3p l\u1EC7.",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "Ch\xfang t\xf4i kh\xf4ng t\xecm n\u1EA1p \u0111\u01B0\u1EE3c \u0111\u1ED1i t\u01B0\u1EE3ng n\xe0o cho tr\u01B0\u1EDDng n\xe0y",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "T\u1EA1o v\u1EA5n \u0111\u1EC1 kh\xe1c",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "Xem <a>issueKey</a> \u0111\u1EC3 c\u1EADp nh\u1EADt ho\u1EB7c qu\u1EA3n l\xfd v\u1EA5n \u0111\u1EC1 n\xe0y.",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "Ch\xfang t\xf4i \u0111\xe3 t\u1EA1o v\u1EA5n \u0111\u1EC1 c\u1EE7a b\u1EA1n",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "T\u1EA1o v\u1EA5n \u0111\u1EC1 d\xf9ng bi\u1EC3u m\u1EABu nh\xfang b\u1EB1ng c\xe1ch d\xe1n li\xean k\u1EBFt n\xe0y v\xe0o b\u1EA5t k\u1EF3 trang Atlassian n\xe0o. <a>Sao ch\xe9p li\xean k\u1EBFt</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "L\xe0m m\u1EDBi trang r\u1ED3i th\u1EED l\u1EA1i.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "Ch\xfang t\xf4i g\u1EB7p v\u1EA5n \u0111\u1EC1 khi t\u1EA3i bi\u1EC3u m\u1EABu c\u1EE7a b\u1EA1n",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "L\xe0m m\u1EDBi trang r\u1ED3i th\u1EED l\u1EA1i.",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "Ch\xfang t\xf4i g\u1EB7p v\u1EA5n \u0111\u1EC1 khi t\u1EA3i d\u1EF1 \xe1n c\u1EE7a b\u1EA1n",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "Ch\u1ECDn bi\u1EC3u m\u1EABu",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "Ch\u1ECDn lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "T\u1EA1o v\u1EA5n \u0111\u1EC1 b\u1EB1ng bi\u1EC3u m\u1EABu, ho\u1EB7c t\u1EA1o li\xean k\u1EBFt tr\u1EF1c ti\u1EBFp \u0111\u1EBFn bi\u1EC3u m\u1EABu. <a>T\xecm hi\u1EC3u th\xeam v\u1EC1 vi\u1EC7c s\u1EED d\u1EE5ng bi\u1EC3u m\u1EABu \u0111\u1EC3 t\u1EA1o v\u1EA5n \u0111\u1EC1.</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "T\u1EA1o v\u1EA5n \u0111\u1EC1",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "D\u1EF1 \xe1n d\u1ECBch v\u1EE5 n\xe0y kh\xf4ng c\xf3 b\u1EA5t k\u1EF3 bi\u1EC3u m\u1EABu li\xean k\u1EBFt n\xe0o.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "D\u1EF1 \xe1n ph\u1EA7n m\u1EC1m n\xe0y kh\xf4ng c\xf3 b\u1EA5t k\u1EF3 bi\u1EC3u m\u1EABu li\xean k\u1EBFt n\xe0o.",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "D\u1EF1 \xe1n kinh doanh n\xe0y kh\xf4ng c\xf3 b\u1EA5t k\u1EF3 bi\u1EC3u m\u1EABu li\xean k\u1EBFt n\xe0o.",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "Ch\u1ECDn d\u1EF1 \xe1n",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "Ch\u1ECDn lo\u1EA1i y\xeau c\u1EA7u"
    };
});
parcelRegister("ljUGJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f857586e29257e46$export$2e2bcd8739ae039);
    var $f857586e29257e46$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u521B\u5EFA\u5176\u4ED6\u4E8B\u52A1",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u521B\u5EFA",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u65E0\u6CD5\u521B\u5EFA\u60A8\u7684\u4E8B\u52A1\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u8BF7\u5904\u7406\u6240\u6709\u65E0\u6548\u7B54\u6848\uFF0C\u5E76\u786E\u4FDD\u5DF2\u586B\u5199\u6240\u6709\u5FC5\u586B\u5B57\u6BB5\u3002",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u590D\u5236\u94FE\u63A5",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': '\u60A8\u5DF2\u521B\u5EFA "{issueKey}" \u4E8B\u52A1\u3002',
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u67E5\u770B\u4E8B\u52A1",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u7F16\u8F91\u8868\u5355",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u7F16\u8F91\u8BF7\u6C42\u8868\u5355",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u8BF7\u7BA1\u7406\u5458\u5C06 &quot;<strong>{formFieldName}</strong>&quot; \u5B57\u6BB5\u4ECE\u6761\u4EF6\u90E8\u5206\u79FB\u9664\uFF0C\u6216\u5728 &quot;<strong>{typeName}</strong>&quot; \u95E8\u6237\u8868\u5355\u4E0A\uFF0C\u4ECE\u4E0E\u6B64\u5B57\u6BB5\u94FE\u63A5\u7684 &quot;<strong>{jiraFieldName}</strong>&quot; Jira \u5B57\u6BB5\u4E2D\u79FB\u9664\u201C\u5FC5\u586B\u201D\u72B6\u6001\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u5C06 &quot;<strong>{formFieldName}</strong>&quot; \u5B57\u6BB5\u4ECE\u6761\u4EF6\u90E8\u5206\u79FB\u9664\uFF0C\u6216\u5728 &quot;<strong>{typeName}</strong>&quot; \u8BF7\u6C42\u8868\u5355\u4E0A\uFF0C\u4ECE\u4E0E\u6B64\u5B57\u6BB5\u94FE\u63A5\u7684 &quot;<strong>{jiraFieldName}</strong>&quot; Jira \u5B57\u6BB5\u4E2D\u79FB\u9664\u201C\u5FC5\u586B\u201D\u72B6\u6001\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u6761\u4EF6\u90E8\u5206\u4E2D\u7684\u201C\u5FC5\u586B\u201D\u5B57\u6BB5",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u8BF7\u7BA1\u7406\u5458\u5C06\u6B64\u8868\u5355\u4E2D\u7684\u5B57\u6BB5\u4E0E &quot;<strong>{typeName}</strong>&quot; \u8BF7\u6C42\u8868\u5355\u4E2D\u7684 &quot;<strong>{jiraFieldName}</strong>&quot; Jira \u5B57\u6BB5\u94FE\u63A5\u8D77\u6765\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u5C06\u6B64\u8868\u5355\u4E2D\u7684\u5B57\u6BB5\u4E0E<strong>{typeName}</strong>\u8BF7\u6C42\u8868\u5355\u4E2D\u7684<strong>{jiraFieldName}</strong> Jira \u5B57\u6BB5\u94FE\u63A5\u8D77\u6765\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u201C\u5FC5\u586B\u201D\u5B57\u6BB5\u672A\u94FE\u63A5",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u8BF7\u7BA1\u7406\u5458\u5C06\u6B64\u8868\u5355\u4E2D\u7684 &quot;<strong>{formFieldName}</strong>&quot; \u5B57\u6BB5\u6807\u8BB0\u4E3A\u201C\u5FC5\u586B\u201D\uFF0C\u4EE5\u5339\u914D &quot;<strong>{typeName}</strong>&quot; \u8BF7\u6C42\u8868\u5355\u4E2D\u4E0E\u6B64\u5B57\u6BB5\u94FE\u63A5\u7684 &quot;<strong>{jiraFieldName}</strong>&quot; Jira \u5B57\u6BB5\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u5C06\u6B64\u8868\u5355\u4E2D\u7684 &quot;<strong>{formFieldName}</strong>&quot; \u5B57\u6BB5\u6807\u8BB0\u4E3A\u201C\u5FC5\u586B\u201D\uFF0C\u4EE5\u5339\u914D &quot;<strong>{typeName}</strong>&quot; \u8BF7\u6C42\u8868\u5355\u4E2D\u4E0E\u6B64\u5B57\u6BB5\u94FE\u63A5\u7684 &quot;<strong>{jiraFieldName}</strong>&quot; Jira \u5B57\u6BB5\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u201C\u5FC5\u586B\u201D\u5B57\u6BB5\u4E0D\u5339\u914D",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u8BF7\u5237\u65B0\u9875\u9762\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u65E0\u6CD5\u52A0\u8F7D\u60A8\u7684\u8868\u5355",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u8BF7\u79FB\u9664\u8D44\u4EA7\u81EA\u5B9A\u4E49\u5B57\u6BB5\u914D\u7F6E\u7B5B\u9009\u5668\u4E2D\u4E0D\u590D\u5B58\u5728\u7684\u5C5E\u6027\uFF0C\u5E76\u786E\u4FDD AQL \u67E5\u8BE2\u6709\u6548\u3002",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u65E0\u6CD5\u4E3A\u6B64\u5B57\u6BB5\u83B7\u53D6\u4EFB\u4F55\u5BF9\u8C61",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u521B\u5EFA\u5176\u4ED6\u4E8B\u52A1",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u67E5\u770B <a>issueKey</a> \u4EE5\u66F4\u65B0\u6216\u7BA1\u7406\u6B64\u4E8B\u52A1\u3002",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u6211\u4EEC\u5DF2\u521B\u5EFA\u60A8\u7684\u4E8B\u52A1",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u5C06\u6B64\u94FE\u63A5\u7C98\u8D34\u5230\u4EFB\u610F Atlassian \u7AD9\u70B9\u4E0A\uFF0C\u4ECE\u800C\u4F7F\u7528\u5D4C\u5165\u5F0F\u8868\u5355\u521B\u5EFA\u4E8B\u52A1\u3002<a>\u590D\u5236\u94FE\u63A5</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u8BF7\u5237\u65B0\u9875\u9762\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u52A0\u8F7D\u60A8\u7684\u8868\u5355\u65F6\u51FA\u9519",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u8BF7\u5237\u65B0\u9875\u9762\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u52A0\u8F7D\u60A8\u7684\u9879\u76EE\u65F6\u51FA\u9519",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u9009\u62E9\u8868\u5355",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u9009\u62E9\u4E8B\u52A1\u7C7B\u578B",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u4F7F\u7528\u8868\u5355\u6216\u76F4\u63A5\u901A\u8FC7\u8868\u5355\u94FE\u63A5\u521B\u5EFA\u4E8B\u52A1\u3002<a>\u4E86\u89E3\u6709\u5173\u4F7F\u7528\u8868\u5355\u521B\u5EFA\u4E8B\u52A1\u7684\u66F4\u591A\u4FE1\u606F</a>\u3002",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u521B\u5EFA\u4E8B\u52A1",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u6B64\u670D\u52A1\u9879\u76EE\u6CA1\u6709\u4EFB\u4F55\u5173\u8054\u7684\u8868\u5355\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u6B64\u8F6F\u4EF6\u9879\u76EE\u6CA1\u6709\u4EFB\u4F55\u5173\u8054\u7684\u8868\u5355\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u6B64\u4E1A\u52A1\u9879\u76EE\u6CA1\u6709\u4EFB\u4F55\u5173\u8054\u7684\u8868\u5355\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u9009\u62E9\u9879\u76EE",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u9009\u62E9\u8BF7\u6C42\u7C7B\u578B"
    };
});
parcelRegister("172LK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cf897cccea53296$export$2e2bcd8739ae039);
    var $0cf897cccea53296$export$2e2bcd8739ae039 = {
        'proforma-jira-issue-forms.common.ui.footer.create-another-label': "\u5EFA\u7ACB\u53E6\u4E00\u500B\u8B70\u984C",
        'proforma-jira-issue-forms.common.ui.footer.create-button-label': "\u5EFA\u7ACB",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description': "\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title': "\u6211\u5011\u7121\u6CD5\u5EFA\u7ACB\u60A8\u7684\u8B70\u984C\u3002",
        'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description': "\u8655\u7406\u7121\u6548\u7684\u56DE\u7B54\uFF0C\u4E26\u6AA2\u67E5\u6240\u6709\u5FC5\u586B\u6B04\u4F4D\u662F\u5426\u5DF2\u586B\u5BEB\u3002",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action': "\u8907\u88FD\u9023\u7D50",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title': "\u60A8\u5DF2\u5EFA\u7ACB\u300C{issueKey}\u300D\u8B70\u984C\u3002",
        'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action': "\u6AA2\u8996\u8B70\u984C",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin': "\u7DE8\u8F2F\u8868\u55AE",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin': "\u7DE8\u8F2F\u8ACB\u6C42\u8868\u55AE",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin': "\u8981\u6C42\u60A8\u7684\u7BA1\u7406\u54E1\u5C07 <strong>{formFieldName}</strong> \u6B04\u4F4D\u79FB\u51FA\u689D\u4EF6\u5340\u6BB5\u4E4B\u5916\uFF0C\u6216\u5F9E <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u5DF2\u9023\u7D50\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u4E2D\uFF0C\u79FB\u9664\u300C\u5FC5\u586B\u300D\u72C0\u614B\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin': "\u5C07 <strong>{formFieldName}</strong> \u6B04\u4F4D\u79FB\u51FA\u689D\u4EF6\u5340\u6BB5\u4E4B\u5916\uFF0C\u6216\u5F9E <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u5DF2\u9023\u7D50\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u4E2D\uFF0C\u79FB\u9664\u300C\u5FC5\u586B\u300D\u72C0\u614B\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title': "\u689D\u4EF6\u5340\u6BB5\u4E2D\u7684\u300C\u5FC5\u586B\u300D\u6B04\u4F4D",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin': "\u8981\u6C42\u60A8\u7684\u7BA1\u7406\u54E1\u5C07\u6B64\u8868\u55AE\u4E2D\u7684\u6B04\u4F4D\u8207 <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u4E2D\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u9023\u7D50\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin': "\u5C07\u6B64\u8868\u55AE\u4E2D\u7684\u6B04\u4F4D\u8207 <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u4E2D\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u9023\u7D50\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title': "\u300C\u5FC5\u586B\u300D\u6B04\u4F4D\u672A\u9023\u7D50",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin': "\u8981\u6C42\u60A8\u7684\u7BA1\u7406\u54E1\u5C07\u6B64\u8868\u55AE\u4E2D\u7684 <strong>{formFieldName}</strong> \u6B04\u4F4D\u6A19\u793A\u70BA\u300C\u5FC5\u586B\u300D\uFF0C\u4EE5\u7B26\u5408 <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u4E2D\uFF0C\u5DF2\u9023\u7D50\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin': "\u5C07\u6B64\u8868\u55AE\u4E2D\u7684 <strong>{formFieldName}</strong> \u6B04\u4F4D\u6A19\u793A\u70BA\u300C\u5FC5\u8981\u300D\uFF0C\u4EE5\u7B26\u5408 <strong>{typeName}</strong> \u8ACB\u6C42\u8868\u55AE\u4E2D\uFF0C\u5DF2\u9023\u7D50\u7684 <strong>{jiraFieldName}</strong> Jira \u6B04\u4F4D\u3002",
        'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title': "\u300C\u5FC5\u8981\u300D\u6B04\u4F4D\u4E0D\u76F8\u7B26",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
        'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title': "\u6211\u5011\u7121\u6CD5\u8F09\u5165\u60A8\u7684\u8868\u55AE",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-description': "\u79FB\u9664\u300CAssets \u81EA\u8A02\u6B04\u4F4D\u300D\u7D44\u614B\u7BE9\u9078\u689D\u4EF6\u4E2D\u5DF2\u4E0D\u5B58\u5728\u7684\u5C6C\u6027\uFF0C\u4E26\u78BA\u4FDD AQL \u67E5\u8A62\u6709\u6548\u3002",
        'proforma-jira-issue-forms.controllers.form-store.object-search-error-title': "\u6211\u5011\u7121\u6CD5\u64F7\u53D6\u6B64\u6B04\u4F4D\u7684\u4EFB\u4F55\u7269\u4EF6",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed': "\u5EFA\u7ACB\u53E6\u4E00\u500B\u8B70\u984C",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed': "\u6AA2\u8996 <a>issueKey</a> \u4EE5\u66F4\u65B0\uFF0C\u6216\u7BA1\u7406\u6B64\u8B70\u984C\u3002",
        'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed': "\u6211\u5011\u5DF2\u7D93\u5EFA\u7ACB\u4E86\u60A8\u7684\u8B70\u984C",
        'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed': "\u5C07\u6B64\u9023\u7D50\u8CBC\u5230\u4EFB\u4F55 Atlassian \u7DB2\u7AD9\uFF0C\u5373\u53EF\u4F7F\u7528\u5D4C\u5165\u5F0F\u8868\u55AE\u5EFA\u7ACB\u8B70\u984C\u3002<a>\u8907\u88FD\u9023\u7D50</a>",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title': "\u6211\u5011\u5728\u8F09\u5165\u60A8\u7684\u8868\u55AE\u6642\u9047\u5230\u554F\u984C",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
        'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title': "\u6211\u5011\u5728\u8F09\u5165\u60A8\u7684\u5C08\u6848\u6642\u9047\u5230\u554F\u984C",
        'proforma-jira-issue-forms.ui.general.header.form-placeholder': "\u9078\u53D6\u8868\u55AE",
        'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder': "\u9078\u53D6\u8B70\u984C\u985E\u578B",
        'proforma-jira-issue-forms.ui.general.header.page-description-embed': "\u4F7F\u7528\u8868\u55AE (\u6216\u76F4\u63A5\u900F\u904E\u8868\u55AE\u7684\u9023\u7D50) \u5EFA\u7ACB\u8B70\u984C\u3002<a>\u9032\u4E00\u6B65\u4E86\u89E3\u5982\u4F55\u4F7F\u7528\u8868\u55AE\u5EFA\u7ACB\u8B70\u984C\u3002</a>",
        'proforma-jira-issue-forms.ui.general.header.page-header': "\u5EFA\u7ACB\u8B70\u984C",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm': "\u6B64\u670D\u52D9\u5C08\u6848\u6C92\u6709\u4EFB\u4F55\u76F8\u95DC\u806F\u7684\u8868\u55AE\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw': "\u6B64\u8EDF\u9AD4\u5C08\u6848\u6C92\u6709\u4EFB\u4F55\u76F8\u95DC\u806F\u7684\u8868\u55AE\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm': "\u6B64\u696D\u52D9\u5C08\u6848\u6C92\u6709\u4EFB\u4F55\u76F8\u95DC\u806F\u7684\u8868\u55AE\u3002",
        'proforma-jira-issue-forms.ui.general.header.project-placeholder': "\u9078\u53D6\u5C08\u6848",
        'proforma-jira-issue-forms.ui.general.header.request-type-placeholder': "\u9078\u53D6\u8981\u6C42\u985E\u578B"
    };
});
parcelRegister("2Zsrr", function(module, exports) {
    $parcel$export(module.exports, "AffectedServicesChoicesServiceContainer", ()=>$22d757311c00f5c7$export$c704bf3e9b01a909);
    $parcel$export(module.exports, "useAffectedServicesChoicesService", ()=>$22d757311c00f5c7$export$8ccb3bdb869736d2);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $22d757311c00f5c7$var$actions = {
        load: (query)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    const uri = `/rest/service-registry-api/service?query=${query || ''}`;
                    apiUtil.jiraGet(uri).then((data)=>data.services.map((affectedService)=>({
                                value: affectedService.id,
                                label: affectedService.name
                            }))).then((affectedServices)=>{
                        setState({
                            data: affectedServices,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $22d757311c00f5c7$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $22d757311c00f5c7$var$actions,
        name: 'AffectedServicesChoicesService'
    });
    const $22d757311c00f5c7$export$c704bf3e9b01a909 = (0, (0, parcelRequire("gg7kZ")).createContainer)($22d757311c00f5c7$var$Store);
    const $22d757311c00f5c7$export$8ccb3bdb869736d2 = (0, (0, parcelRequire("3sQ5x")).createHook)($22d757311c00f5c7$var$Store);
});
parcelRegister("bpKCm", function(module, exports) {
    $parcel$export(module.exports, "AttachmentServiceContainer", ()=>$84f630cf0da84aea$export$e03f9353dff576e7);
    $parcel$export(module.exports, "useAttachmentService", ()=>$84f630cf0da84aea$export$ac9c877773868b1e);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $84f630cf0da84aea$var$actions = {
        loadMediaApiUploadToken: (projectId)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    apiUtil.jiraGet(`/rest/api/2/attachment/upload/project/${projectId}/credentials`).then((response)=>{
                        setState({
                            data: response,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $84f630cf0da84aea$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $84f630cf0da84aea$var$actions,
        name: 'AttachmentService'
    });
    const $84f630cf0da84aea$export$e03f9353dff576e7 = (0, (0, parcelRequire("gg7kZ")).createContainer)($84f630cf0da84aea$var$Store);
    const $84f630cf0da84aea$export$ac9c877773868b1e = (0, (0, parcelRequire("3sQ5x")).createHook)($84f630cf0da84aea$var$Store);
});
parcelRegister("30GOg", function(module, exports) {
    $parcel$export(module.exports, "CmdbChoicesServiceContainer", ()=>$2312944a07eb1933$export$6af8abe05b048b3d);
    $parcel$export(module.exports, "useCmdbChoicesService", ()=>$2312944a07eb1933$export$846aa21961927b50);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $2312944a07eb1933$var$actions = {
        load: (jiraField, query, projectId, issueTypeId, requestTypeId, templateFormId, fieldConfigId, fieldValueMap)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil, reporterAccountId: reporterAccountId })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    const uri = `/rest/servicedesk/cmdb/1/proforma/field/${jiraField}/config/${fieldConfigId}/autocomplete`;
                    apiUtil.jiraPost(uri, {
                        query: query,
                        templateFormId: templateFormId,
                        fieldValueMap: {
                            ...reporterAccountId ? {
                                reporter: reporterAccountId
                            } : {},
                            ...fieldValueMap,
                            pid: projectId,
                            issuetype: issueTypeId,
                            requesttype: requestTypeId
                        }
                    }, 'cmdbAutocomplete').then((data)=>data.results.map((cmdbObject)=>({
                                value: cmdbObject.id,
                                label: cmdbObject.label
                            }))).then((cmdbObjects)=>{
                        setState({
                            data: cmdbObjects,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $2312944a07eb1933$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $2312944a07eb1933$var$actions,
        name: 'CmdbChoicesService'
    });
    const $2312944a07eb1933$export$6af8abe05b048b3d = (0, (0, parcelRequire("gg7kZ")).createContainer)($2312944a07eb1933$var$Store);
    const $2312944a07eb1933$export$846aa21961927b50 = (0, (0, parcelRequire("3sQ5x")).createHook)($2312944a07eb1933$var$Store);
});
parcelRegister("5R2g4", function(module, exports) {
    $parcel$export(module.exports, "FieldDataServiceContainer", ()=>$4433a76b7ac4aa9f$export$711730d9c79bfab5);
    $parcel$export(module.exports, "useFieldDataService", ()=>$4433a76b7ac4aa9f$export$3b57b73ac92843b9);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $4433a76b7ac4aa9f$var$actions = {
        load: (formDetails, request)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    apiUtil.post(`/api/cloud/createissue/project/${formDetails.projectId}/issuetype/${formDetails.issueType.id}/form/${formDetails.projectFormId}/fielddata`, request).then((response)=>{
                        setState({
                            data: response,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $4433a76b7ac4aa9f$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $4433a76b7ac4aa9f$var$actions,
        name: 'FieldDataService'
    });
    const $4433a76b7ac4aa9f$export$711730d9c79bfab5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($4433a76b7ac4aa9f$var$Store);
    const $4433a76b7ac4aa9f$export$3b57b73ac92843b9 = (0, (0, parcelRequire("3sQ5x")).createHook)($4433a76b7ac4aa9f$var$Store);
});
parcelRegister("c6IF8", function(module, exports) {
    $parcel$export(module.exports, "FormServiceContainer", ()=>$8d08b09a3cccc394$export$2d84925b90daa696);
    $parcel$export(module.exports, "useFormService", ()=>$8d08b09a3cccc394$export$5a61d044f64ee3d5);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $5aQYy;
    var $i4y6A;
    const $8d08b09a3cccc394$var$initialState = {
        data: undefined,
        error: undefined,
        loading: false
    };
    const $8d08b09a3cccc394$var$actions = {
        load: (formDetails)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    var _formDetails$requestT;
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    apiUtil.get(`/api/cloud/createissue/form/${formDetails.projectId}/${formDetails.projectFormId}/issuetype/${formDetails.issueType.id}?${(0, (0, parcelRequire("i4y6A")).urlParam)('requestTypeId', (_formDetails$requestT = formDetails.requestType) === null || _formDetails$requestT === void 0 ? void 0 : _formDetails$requestT.id, '')}`).then((response)=>{
                        setState({
                            data: (0, (0, parcelRequire("5aQYy")).convertTemplateFormToUnsavedForm)(response),
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            },
        reset: ()=>({ setState: setState })=>{
                setState($8d08b09a3cccc394$var$initialState);
            }
    };
    const $8d08b09a3cccc394$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $8d08b09a3cccc394$var$initialState,
        actions: $8d08b09a3cccc394$var$actions,
        name: 'FormService'
    });
    const $8d08b09a3cccc394$export$2d84925b90daa696 = (0, (0, parcelRequire("gg7kZ")).createContainer)($8d08b09a3cccc394$var$Store);
    const $8d08b09a3cccc394$export$5a61d044f64ee3d5 = (0, (0, parcelRequire("3sQ5x")).createHook)($8d08b09a3cccc394$var$Store);
});
parcelRegister("5aQYy", function(module, exports) {
    $parcel$export(module.exports, "convertTemplateFormToUnsavedForm", ()=>$3c46fac54e6c7429$export$336bdbb8f937b813);
    var $4aJmI;
    function $3c46fac54e6c7429$export$336bdbb8f937b813(templateForm) {
        const convertedForm = {
            id: undefined,
            updated: templateForm.updated,
            design: templateForm.design,
            ...templateForm.publish && {
                publish: templateForm.publish
            },
            state: $3c46fac54e6c7429$var$createStateFromTemplateForm(templateForm)
        };
        return convertedForm;
    }
    function $3c46fac54e6c7429$var$createStateFromTemplateForm(templateForm) {
        return {
            visibility: (0, (0, parcelRequire("4aJmI")).FormVisibility).Internal,
            status: (0, (0, parcelRequire("4aJmI")).FormStatus).Open,
            answers: $3c46fac54e6c7429$var$populateDefaultAnswers(templateForm.design.questions)
        };
    }
    function $3c46fac54e6c7429$var$populateDefaultAnswers(questions) {
        const formAnswers = {};
        Object.keys(questions).forEach((key)=>{
            const question = questions[key];
            if (question.defaultAnswer) formAnswers[key] = question.defaultAnswer;
        });
        return formAnswers;
    }
});
parcelRegister("4aJmI", function(module, exports) {
    $parcel$export(module.exports, "defaultFormPublishing", ()=>$309b493b4ac9e842$export$ff4a00b513452bc5);
    $parcel$export(module.exports, "isShowCondition", ()=>$309b493b4ac9e842$export$c385a29f77656020);
    $parcel$export(module.exports, "FormConditionType", ()=>$309b493b4ac9e842$export$943ba666dd740a86);
    $parcel$export(module.exports, "FormAnswerEmpty", ()=>$309b493b4ac9e842$export$f1c794d8fb489e8c);
    $parcel$export(module.exports, "FormVisibility", ()=>$309b493b4ac9e842$export$c501a2032cd34718);
    $parcel$export(module.exports, "FormStatus", ()=>$309b493b4ac9e842$export$fc8a1cc6d4fd1a88);
    $parcel$export(module.exports, "FormSectionType", ()=>$309b493b4ac9e842$export$d636d1a763e6b20b);
    $parcel$export(module.exports, "FormQuestionType", ()=>$309b493b4ac9e842$export$5fcf8ca5ea137df2);
    const $309b493b4ac9e842$export$ff4a00b513452bc5 = {
        submitOnCreate: true,
        validateOnCreate: true
    };
    function $309b493b4ac9e842$export$c385a29f77656020(c) {
        return c.t === $309b493b4ac9e842$export$943ba666dd740a86.Show;
    }
    const $309b493b4ac9e842$export$f1c794d8fb489e8c = {};
    let $309b493b4ac9e842$export$c501a2032cd34718 = function(FormVisibility) {
        FormVisibility["Internal"] = "i";
        FormVisibility["External"] = "e";
        return FormVisibility;
    }({});
    let $309b493b4ac9e842$export$fc8a1cc6d4fd1a88 = function(FormStatus) {
        FormStatus["Open"] = "o";
        FormStatus["Submitted"] = "s";
        FormStatus["Locked"] = "l";
        return FormStatus;
    }({});
    let $309b493b4ac9e842$export$943ba666dd740a86 = function(FormConditionType) {
        FormConditionType["Show"] = "sh";
        return FormConditionType;
    }({});
    let $309b493b4ac9e842$export$d636d1a763e6b20b = function(FormSectionType) {
        FormSectionType["Block"] = "b";
        FormSectionType["Page"] = "p";
        return FormSectionType;
    }({});
    let $309b493b4ac9e842$export$5fcf8ca5ea137df2 = function(FormQuestionType) {
        FormQuestionType["Attachment"] = "at";
        FormQuestionType["ChoiceCascading"] = "cc";
        FormQuestionType["ChoiceDropdown"] = "cd";
        FormQuestionType["ChoiceDropdownMultiple"] = "cl";
        FormQuestionType["ChoiceMultiple"] = "cm";
        FormQuestionType["ChoiceSingle"] = "cs";
        FormQuestionType["CmdbObject"] = "ob";
        FormQuestionType["Date"] = "da";
        FormQuestionType["DateTime"] = "dt";
        FormQuestionType["Number"] = "no";
        FormQuestionType["TextEmail"] = "te";
        FormQuestionType["TextLong"] = "tl";
        FormQuestionType["TextParagraph"] = "pg";
        FormQuestionType["RichTextParagraph"] = "rt";
        FormQuestionType["TextShort"] = "ts";
        FormQuestionType["TextUrl"] = "tu";
        FormQuestionType["Time"] = "ti";
        FormQuestionType["UserMultiple"] = "um";
        FormQuestionType["UserSingle"] = "us";
        return FormQuestionType;
    }({});
});
parcelRegister("i4y6A", function(module, exports) {
    $parcel$export(module.exports, "urlParam", ()=>$d2830e48bbbec036$export$c58cbe8a8ef2f1b3);
    const $d2830e48bbbec036$export$c58cbe8a8ef2f1b3 = (name, value, joiner = '&')=>{
        return value === undefined ? '' : `${joiner}${name}=${value}`;
    };
});
parcelRegister("dQKc8", function(module, exports) {
    $parcel$export(module.exports, "FormChoicesServiceContainer", ()=>$a153f6f9b5f5843b$export$949d0248e593f68);
    $parcel$export(module.exports, "useFormChoicesService", ()=>$a153f6f9b5f5843b$export$1d18bc8132e59955);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $a153f6f9b5f5843b$var$actions = {
        load: (formDetails)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    const typeSegments = formDetails.requestType ? `requesttype/${formDetails.requestType.id}` : `issuetype/${formDetails.issueType.id}`;
                    apiUtil.get(`/api/3/createissue/form/${formDetails.projectId}/${formDetails.projectFormId}/${typeSegments}/formchoices`).then((response)=>{
                        setState({
                            data: response,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $a153f6f9b5f5843b$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $a153f6f9b5f5843b$var$actions,
        name: 'FormChoicesService'
    });
    const $a153f6f9b5f5843b$export$949d0248e593f68 = (0, (0, parcelRequire("gg7kZ")).createContainer)($a153f6f9b5f5843b$var$Store);
    const $a153f6f9b5f5843b$export$1d18bc8132e59955 = (0, (0, parcelRequire("3sQ5x")).createHook)($a153f6f9b5f5843b$var$Store);
});
parcelRegister("2tirv", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateServiceContainer", ()=>$1ccc988dbbe71c67$export$f0c18ade67810d84);
    $parcel$export(module.exports, "useIssueCreateService", ()=>$1ccc988dbbe71c67$export$80858d640301e504);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $1ccc988dbbe71c67$var$initialState = {
        data: undefined,
        error: undefined,
        loading: false
    };
    const $1ccc988dbbe71c67$var$actions = {
        createIssue: (formDetails, answers)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    var _formDetails$requestT;
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    apiUtil.put('/api/2/createissue', {
                        projectId: formDetails.projectId,
                        templateFormId: formDetails.projectFormId,
                        issueTypeId: formDetails.issueType.id,
                        requestTypeId: (_formDetails$requestT = formDetails.requestType) === null || _formDetails$requestT === void 0 ? void 0 : _formDetails$requestT.id,
                        answers: answers
                    }).then((response)=>{
                        setState({
                            data: response,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            },
        reset: ()=>({ setState: setState })=>{
                setState($1ccc988dbbe71c67$var$initialState);
            }
    };
    const $1ccc988dbbe71c67$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $1ccc988dbbe71c67$var$initialState,
        actions: $1ccc988dbbe71c67$var$actions,
        name: 'IssueCreateService'
    });
    const $1ccc988dbbe71c67$export$f0c18ade67810d84 = (0, (0, parcelRequire("gg7kZ")).createContainer)($1ccc988dbbe71c67$var$Store);
    const $1ccc988dbbe71c67$export$80858d640301e504 = (0, (0, parcelRequire("3sQ5x")).createHook)($1ccc988dbbe71c67$var$Store);
});
parcelRegister("ewILP", function(module, exports) {
    $parcel$export(module.exports, "LabelChoicesServiceContainer", ()=>$a936c8545324d854$export$9f027ac826b97546);
    $parcel$export(module.exports, "useLabelChoicesService", ()=>$a936c8545324d854$export$b8bf9efc3f4ad865);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $a936c8545324d854$var$actions = {
        load: (jiraField, query)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    let uri = '';
                    const isCustomLabelsField = jiraField.startsWith('customfield_');
                    if (isCustomLabelsField) {
                        const customFieldId = jiraField === null || jiraField === void 0 ? void 0 : jiraField.split('_')[1];
                        uri = `/rest/api/1.0/labels/suggest?customFieldId=${customFieldId}&query=${query !== null && query !== void 0 ? query : ''}`;
                    } else uri = `/rest/api/1.0/labels/suggest?query=${query !== null && query !== void 0 ? query : ''}`;
                    apiUtil.jiraGet(uri).then((data)=>data.suggestions.map((jiraLabel)=>({
                                value: jiraLabel.label,
                                label: jiraLabel.label
                            }))).then((jiraLabels)=>{
                        setState({
                            data: jiraLabels,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $a936c8545324d854$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $a936c8545324d854$var$actions,
        name: 'LabelChoicesService'
    });
    const $a936c8545324d854$export$9f027ac826b97546 = (0, (0, parcelRequire("gg7kZ")).createContainer)($a936c8545324d854$var$Store);
    const $a936c8545324d854$export$b8bf9efc3f4ad865 = (0, (0, parcelRequire("3sQ5x")).createHook)($a936c8545324d854$var$Store);
});
parcelRegister("ke4ek", function(module, exports) {
    $parcel$export(module.exports, "UserChoicesServiceContainer", ()=>$eb986573e40a7efc$export$8692151881063e0d);
    $parcel$export(module.exports, "useUserChoicesService", ()=>$eb986573e40a7efc$export$3803457805b49cff);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $eb986573e40a7efc$var$actions = {
        load: (projectId, jiraField, query)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    (jiraField === 'assignee' ? apiUtil.jiraGet(`/rest/api/3/user/assignable/search?project=${projectId}&query=${encodeURIComponent(query)}`).then((data)=>data.map((user)=>{
                            var _user$displayName;
                            return {
                                value: user.accountId,
                                label: (_user$displayName = user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : ''
                            };
                        })) : apiUtil.jiraGet(`/rest/api/3/user/picker?query=${encodeURIComponent(query)}`).then((data)=>data.users.map((user)=>{
                            var _user$displayName2;
                            return {
                                value: user.accountId,
                                label: (_user$displayName2 = user.displayName) !== null && _user$displayName2 !== void 0 ? _user$displayName2 : ''
                            };
                        }))).then((users)=>{
                        setState({
                            data: users,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            },
        loadWithFieldConfig: (jiraField, fieldConfigId, projectId, query)=>({ getState: getState, setState: setState }, { apiUtil: apiUtil })=>{
                if (!getState().loading) {
                    setState({
                        data: undefined,
                        error: undefined,
                        loading: true
                    });
                    let usersP;
                    if (jiraField === 'assignee') {
                        const url = `/rest/api/3/user/assignable/search?project=${projectId}&query=${encodeURIComponent(query)}`;
                        usersP = $eb986573e40a7efc$var$getAssignableUsers(apiUtil, url);
                    } else if (jiraField && fieldConfigId) {
                        const url = `/rest/api/1.0/users/picker?fieldName=${jiraField}&fieldConfigId=${fieldConfigId}&projectId=${projectId}&showAvatar=true&&query=${encodeURIComponent(query)}`;
                        usersP = $eb986573e40a7efc$var$getFoundUsers(apiUtil, url);
                    } else {
                        const url = `/rest/api/3/user/picker?query=${encodeURIComponent(query)}`;
                        usersP = $eb986573e40a7efc$var$getFoundUsers(apiUtil, url);
                    }
                    usersP.then((users)=>{
                        setState({
                            data: users,
                            loading: false
                        });
                    }).catch((apiError)=>{
                        setState({
                            error: apiError,
                            loading: false
                        });
                    });
                }
            }
    };
    const $eb986573e40a7efc$var$getFoundUsers = (apiUtil, url)=>apiUtil.jiraGet(url).then((data)=>data.users.map($eb986573e40a7efc$var$userPickerToSelectOption));
    const $eb986573e40a7efc$var$getAssignableUsers = (apiUtil, url)=>apiUtil.jiraGet(url).then((data)=>data.map($eb986573e40a7efc$var$toSelectOption));
    const $eb986573e40a7efc$var$userPickerToSelectOption = (user)=>{
        var _user$displayName3;
        return {
            value: user.accountId,
            label: (_user$displayName3 = user.displayName) !== null && _user$displayName3 !== void 0 ? _user$displayName3 : ''
        };
    };
    const $eb986573e40a7efc$var$toSelectOption = (user)=>{
        var _user$displayName4;
        return {
            value: user.accountId,
            label: (_user$displayName4 = user.displayName) !== null && _user$displayName4 !== void 0 ? _user$displayName4 : ''
        };
    };
    const $eb986573e40a7efc$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            error: undefined,
            loading: false
        },
        actions: $eb986573e40a7efc$var$actions,
        name: 'UserChoicesService'
    });
    const $eb986573e40a7efc$export$8692151881063e0d = (0, (0, parcelRequire("gg7kZ")).createContainer)($eb986573e40a7efc$var$Store);
    const $eb986573e40a7efc$export$3803457805b49cff = (0, (0, parcelRequire("3sQ5x")).createHook)($eb986573e40a7efc$var$Store);
});
parcelRegister("gWroG", function(module, exports) {
    $parcel$export(module.exports, "IssueFormsDirect", ()=>$c55750997929fc82$export$9c49ee193e67a6d8);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lVJAU;
    var $2NMNM;
    var $bKCvK;
    var $dFdBd;
    var $iu3cq;
    var $koRkL;
    var $gBWfu;
    var $lzGq6;
    var $gjvhH;
    var $2ygsB;
    var $anpr8;
    var $bpKCm;
    var $c6IF8;
    var $bGdl8;
    const $c55750997929fc82$export$9c49ee193e67a6d8 = ({ formDetails: formDetails, project: project, userIsProjectAdmin: userIsProjectAdmin, reporterAccountId: reporterAccountId, isEmbed: isEmbed })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const [{ data: mediaApiUploadToken }, { loadMediaApiUploadToken: loadMediaApiUploadToken }] = (0, (0, parcelRequire("bpKCm")).useAttachmentService)();
        const [{ data: form, error: formLoadError, loading: formLoading }, { load: loadForm }] = (0, (0, parcelRequire("c6IF8")).useFormService)();
        const [{ formStore: formStore }, { clear: clearFormStore, create: createFormStore }] = (0, (0, parcelRequire("anpr8")).useFormStoreController)(reporterAccountId);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [formValidationResultMessage, setFormValidationResultMessage] = (0, $5uXOq.useState)();
        const [lastCreatedIssueKey, setLastCreatedIssueKey] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            loadMediaApiUploadToken(formDetails.projectId);
        }, [
            formDetails === null || formDetails === void 0 ? void 0 : formDetails.projectId,
            loadMediaApiUploadToken
        ]);
        (0, $5uXOq.useEffect)(()=>{
            loadForm(formDetails);
        }, [
            formDetails,
            loadForm
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (form) createFormStore(formDetails, form);
            else clearFormStore();
        }, [
            clearFormStore,
            createFormStore,
            form,
            formDetails
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (formLoadError) {
                const newFormValidationResultMessage = (0, (0, parcelRequire("2ygsB")).getFormValidationResultMessage)(formLoadError, project, formDetails, intl, push, showFlag, createAnalyticsEvent, userIsProjectAdmin);
                if (newFormValidationResultMessage) setFormValidationResultMessage(newFormValidationResultMessage);
            }
        }, [
            createAnalyticsEvent,
            formDetails,
            formLoadError,
            project,
            push,
            showFlag,
            userIsProjectAdmin
        ]);
        const mediaContext = {
            mediaApiUploadToken: mediaApiUploadToken,
            projectId: formDetails === null || formDetails === void 0 ? void 0 : formDetails.projectId
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iu3cq")).MediaProvider), {
            mediaContext: mediaContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsContent), null, isEmbed && lastCreatedIssueKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGdl8")).IssueCreatedEmbedded), {
            issueKey: lastCreatedIssueKey,
            onCreateClick: ()=>setLastCreatedIssueKey(undefined)
        }) : formLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBodyWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBody), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dFdBd")).LoadingSpinner), null))) : formValidationResultMessage ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBodyWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBody), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gBWfu")).FormValidationMessage), {
            formValidationResultMessage: formValidationResultMessage
        }))) : formStore ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBodyWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjvhH")).IssueFormsBody), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzGq6")).FormWithName), {
            formStore: formStore
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koRkL")).Footer), {
            formDetails: formDetails,
            formStore: formStore,
            project: project,
            userIsProjectAdmin: userIsProjectAdmin,
            onIssueCreated: isEmbed ? setLastCreatedIssueKey : undefined
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)));
    };
});
parcelRegister("dFdBd", function(module, exports) {
    $parcel$export(module.exports, "LoadingSpinner", ()=>$9f29a73d0e173b34$export$b08b517936747730);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $eZJjh;
    const $9f29a73d0e173b34$export$b08b517936747730 = ({ size: size = 'medium', children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($9f29a73d0e173b34$var$LoadingSpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: size
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($9f29a73d0e173b34$var$LoadingSpinnerMessage, null, children));
    const $9f29a73d0e173b34$var$LoadingSpinnerContainer = (0, $dAHxw.default).div({
        textAlign: 'center'
    });
    const $9f29a73d0e173b34$var$LoadingSpinnerMessage = (0, $dAHxw.default).p({});
});
parcelRegister("koRkL", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$ed9f6b9093dc2c8d$export$a06f1c675e846f6f);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $ousew;
    var $koVbs;
    var $lVJAU;
    var $2NMNM;
    var $ldJSL;
    var $2rqOp;
    var $kkJfY;
    var $bKCvK;
    var $btivG;
    var $7nnPp;
    var $bEQ2i;
    var $8LS7b;
    var $caW8j;
    var $2tirv;
    var $iuiC7;
    var $2ygsB;
    var $jVT9j;
    var $hRCZb;
    const $ed9f6b9093dc2c8d$export$a06f1c675e846f6f = (0, $jJXgM.observer)(({ formDetails: formDetails, formStore: formStore, project: project, showCreateAnother: showCreateAnother, userIsProjectAdmin: userIsProjectAdmin, onIssueCreated: onIssueCreated })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [{ data: issueCreateResponse, error: issueCreateError, loading: issueCreating }, { createIssue: createIssue, reset: resetCreateIssue }] = (0, (0, parcelRequire("2tirv")).useIssueCreateService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { set: setFormSaveErrors, clear: clearFormSaveErrors } = (0, (0, parcelRequire("bEQ2i")).useFormSaveErrorsActions)();
        const [createAnother, setCreateAnother] = (0, $5uXOq.useState)(false);
        const [creatingIssue, setCreatingIssue] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (issueCreateResponse) {
                const issueUrl = `/browse/${issueCreateResponse.issueKey}`;
                if (onIssueCreated) onIssueCreated(issueCreateResponse.issueKey);
                else if (createAnother) showFlag({
                    actions: [
                        {
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).successfullyCreatedFlagViewIssueAction),
                            href: issueUrl,
                            target: '_blank'
                        },
                        {
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).successfullyCreatedFlagCopyLinkAction),
                            onClick: ()=>(0, (0, parcelRequire("iuiC7")).copyToClipboard)(`${window.location.origin}${issueUrl}`)
                        }
                    ],
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                        label: "Success",
                        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                    }),
                    id: 'create-success',
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("jVT9j")).messages).successfullyCreatedFlagTitle, {
                        values: {
                            issueKey: issueCreateResponse.issueKey
                        }
                    }))
                });
                else push(issueUrl);
                resetCreateIssue();
                clearFormSaveErrors();
                formStore.discardModifiedAnswers();
                formStore.hideValidations();
                setCreatingIssue(false);
            }
        }, [
            clearFormSaveErrors,
            createAnother,
            formStore,
            issueCreateResponse,
            onIssueCreated,
            push,
            resetCreateIssue,
            showFlag
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (issueCreateError) {
                setCreatingIssue(false);
                const newFormValidationResultMessage = (0, (0, parcelRequire("2ygsB")).getFormValidationResultMessage)(issueCreateError, project, formDetails, intl, push, showFlag, createAnalyticsEvent, userIsProjectAdmin, false);
                const formSaveErrors = (0, (0, parcelRequire("caW8j")).getFormSaveErrors)(issueCreateError);
                if (newFormValidationResultMessage) {
                    const { title: title, description: description, actions: actions } = newFormValidationResultMessage;
                    showFlag({
                        id: 'save-conflict',
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                            label: "error",
                            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                        }),
                        title: title,
                        description: description,
                        actions: actions.map((action)=>({
                                ...action,
                                target: '_blank'
                            }))
                    });
                } else if (formSaveErrors) {
                    const showGeneralErrorMsg = Object.keys(formSaveErrors.errorsByQuestionId).length === 0 && formSaveErrors.generalErrors.length > 0;
                    setFormSaveErrors(formSaveErrors.errorsByQuestionId);
                    showFlag({
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                            label: "error",
                            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                        }),
                        id: 'create-error',
                        description: showGeneralErrorMsg ? formSaveErrors.generalErrors[0] : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).failedCreatingWithSaveErrorsFlagDescription),
                        title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).failedCreatingFlagTitle)
                    });
                } else showFlag({
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                        label: "error",
                        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                    }),
                    id: 'create-error',
                    description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).failedCreatingFlagDescription),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).failedCreatingFlagTitle)
                });
                resetCreateIssue();
            }
        }, [
            createAnalyticsEvent,
            formDetails,
            issueCreateError,
            project,
            push,
            resetCreateIssue,
            showFlag,
            userIsProjectAdmin
        ]);
        const onCreateClick = ()=>{
            if (!creatingIssue && !issueCreating) {
                setCreatingIssue(true);
                if (formStore.validateOnCreate) formStore.validate();
                if (formStore.invalid) setCreatingIssue(false);
                else createIssue(formDetails, (0, (0, parcelRequire("8LS7b")).convertAnswers)(formStore.questions));
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hRCZb")).IssueFormsFooterWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hRCZb")).IssueFormsFooter), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hRCZb")).IssueFormsFooterLeftWrapper), null, showCreateAnother && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            isChecked: createAnother,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).createAnotherLabel),
            onChange: (event)=>setCreateAnother(event.target.checked),
            testId: "proforma-jira-issue-forms.ui.issue-forms.footer.create-another-checkbox"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            isLoading: creatingIssue || issueCreating,
            onClick: onCreateClick,
            testId: "proforma-jira-issue-forms.ui.issue-forms.footer.create-button",
            isDisabled: formStore.isUploadingMedia
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jVT9j")).messages).createButtonLabel)))));
    });
});
parcelRegister("f2sTC", function(module, exports) {
    $parcel$export(module.exports, "observer", ()=>(parcelRequire("jJXgM")).observer);
    parcelRequire("7qxfo");
    parcelRequire("jcjpM");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dkbyT = parcelRequire("dkbyT");
    var $aZ24W = parcelRequire("aZ24W");
    var $jJXgM = parcelRequire("jJXgM");
    var $diuRl = parcelRequire("diuRl");
    var $9rP9c = parcelRequire("9rP9c");
    var $fB7Vm = parcelRequire("fB7Vm");
    var $ic428 = parcelRequire("ic428");
    var $g4qUw = parcelRequire("g4qUw");
    var $a3gxK = parcelRequire("a3gxK");
    (0, $dkbyT.observerBatching)((0, $7nsd3.unstable_batchedUpdates));
});
parcelRegister("7qxfo", function(module, exports) {
    var $alnGD = parcelRequire("alnGD");
    var $5uXOq = parcelRequire("5uXOq");
    if (!(0, $5uXOq.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
    if (!(0, $alnGD.spy)) throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
});
parcelRegister("jcjpM", function(module, exports) {
    $parcel$export(module.exports, "unstable_batchedUpdates", ()=>(parcelRequire("7nsd3")).unstable_batchedUpdates);
    var $7nsd3 = parcelRequire("7nsd3");
});
parcelRegister("dkbyT", function(module, exports) {
    $parcel$export(module.exports, "observerBatching", ()=>$9b361c8d596d377c$export$294943bbc3c74f4f);
    var $alnGD = parcelRequire("alnGD");
    var $fB7Vm = parcelRequire("fB7Vm");
    var $9b361c8d596d377c$var$observerBatchingConfiguredSymbol = (0, $fB7Vm.getSymbol)("observerBatching");
    function $9b361c8d596d377c$export$fb2daceae6f5097a(callback) {
        callback();
    }
    function $9b361c8d596d377c$export$294943bbc3c74f4f(reactionScheduler) {
        if (!reactionScheduler) reactionScheduler = $9b361c8d596d377c$export$fb2daceae6f5097a;
        (0, $alnGD.configure)({
            reactionScheduler: reactionScheduler
        });
        (0, $fB7Vm.getGlobal)()[$9b361c8d596d377c$var$observerBatchingConfiguredSymbol] = true;
    }
    var $9b361c8d596d377c$export$13ce1459b9a04b51 = function() {
        return !!(0, $fB7Vm.getGlobal)()[$9b361c8d596d377c$var$observerBatchingConfiguredSymbol];
    };
});
parcelRegister("fB7Vm", function(module, exports) {
    $parcel$export(module.exports, "useForceUpdate", ()=>$b5b0754b512ef7f7$export$91db9bc4f8ac944a);
    $parcel$export(module.exports, "isPlainObject", ()=>$b5b0754b512ef7f7$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "getSymbol", ()=>$b5b0754b512ef7f7$export$57af67db727bc7c7);
    $parcel$export(module.exports, "getGlobal", ()=>$b5b0754b512ef7f7$export$a4e55266d2135a7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $b5b0754b512ef7f7$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    var $b5b0754b512ef7f7$var$EMPTY_ARRAY = [];
    function $b5b0754b512ef7f7$export$89e33b3d84d8c331(fn) {
        (0, $5uXOq.useEffect)(function() {
            return fn;
        }, $b5b0754b512ef7f7$var$EMPTY_ARRAY);
    }
    function $b5b0754b512ef7f7$export$91db9bc4f8ac944a() {
        var _a = $b5b0754b512ef7f7$var$__read((0, $5uXOq.useState)(0), 2), setTick = _a[1];
        var update = (0, $5uXOq.useCallback)(function() {
            setTick(function(tick) {
                return tick + 1;
            });
        }, []);
        return update;
    }
    function $b5b0754b512ef7f7$export$53b83ca8eaab0383(value) {
        if (!value || typeof value !== "object") return false;
        var proto = Object.getPrototypeOf(value);
        return !proto || proto === Object.prototype;
    }
    function $b5b0754b512ef7f7$export$57af67db727bc7c7(name) {
        if (typeof Symbol === "function") return Symbol.for(name);
        return "__$mobx-react " + name + "__";
    }
    var $b5b0754b512ef7f7$var$mockGlobal = {};
    function $b5b0754b512ef7f7$export$a4e55266d2135a7f() {
        if (typeof window !== "undefined") return window;
        if (typeof $parcel$global !== "undefined") return $parcel$global;
        if (typeof self !== "undefined") return self;
        return $b5b0754b512ef7f7$var$mockGlobal;
    }
});
parcelRegister("aZ24W", function(module, exports) {
    $parcel$export(module.exports, "isUsingStaticRendering", ()=>$7ff136aa028e6424$export$55979271896d643e);
    var $7ff136aa028e6424$var$globalIsUsingStaticRendering = false;
    function $7ff136aa028e6424$export$7613124ee4202834(enable) {
        $7ff136aa028e6424$var$globalIsUsingStaticRendering = enable;
    }
    function $7ff136aa028e6424$export$55979271896d643e() {
        return $7ff136aa028e6424$var$globalIsUsingStaticRendering;
    }
});
parcelRegister("jJXgM", function(module, exports) {
    $parcel$export(module.exports, "observer", ()=>$e5f0320777ce83cc$export$b6ae1bc530f4c149);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZ24W = parcelRequire("aZ24W");
    var $diuRl = parcelRequire("diuRl");
    var $e5f0320777ce83cc$var$__assign = undefined && undefined.__assign || function() {
        $e5f0320777ce83cc$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $e5f0320777ce83cc$var$__assign.apply(this, arguments);
    };
    function $e5f0320777ce83cc$export$b6ae1bc530f4c149(baseComponent, options) {
        if ((0, $aZ24W.isUsingStaticRendering)()) return baseComponent;
        var realOptions = $e5f0320777ce83cc$var$__assign({
            forwardRef: false
        }, options);
        var baseComponentName = baseComponent.displayName || baseComponent.name;
        var wrappedComponent = function(props, ref) {
            return (0, $diuRl.useObserver)(function() {
                return baseComponent(props, ref);
            }, baseComponentName);
        };
        wrappedComponent.displayName = baseComponentName;
        var memoComponent;
        if (realOptions.forwardRef) memoComponent = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(wrappedComponent));
        else memoComponent = (0, $5uXOq.memo)(wrappedComponent);
        $e5f0320777ce83cc$var$copyStaticProperties(baseComponent, memoComponent);
        memoComponent.displayName = baseComponentName;
        return memoComponent;
    }
    var $e5f0320777ce83cc$var$hoistBlackList = {
        $$typeof: true,
        render: true,
        compare: true,
        type: true
    };
    function $e5f0320777ce83cc$var$copyStaticProperties(base, target) {
        Object.keys(base).forEach(function(key) {
            if (!$e5f0320777ce83cc$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
        });
    }
});
parcelRegister("diuRl", function(module, exports) {
    $parcel$export(module.exports, "useObserver", ()=>$9ae4e4d0873f62b3$export$b9c7ecd090a87b14);
    var $alnGD = parcelRequire("alnGD");
    var $5uXOq = parcelRequire("5uXOq");
    var $kic6x = parcelRequire("kic6x");
    var $gLdfn = parcelRequire("gLdfn");
    var $aZ24W = parcelRequire("aZ24W");
    var $fB7Vm = parcelRequire("fB7Vm");
    var $a3gxK = parcelRequire("a3gxK");
    var $9ae4e4d0873f62b3$var$EMPTY_OBJECT = {};
    function $9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName) {
        return "observer" + baseComponentName;
    }
    function $9ae4e4d0873f62b3$export$b9c7ecd090a87b14(fn, baseComponentName, options) {
        if (baseComponentName === void 0) baseComponentName = "observed";
        if (options === void 0) options = $9ae4e4d0873f62b3$var$EMPTY_OBJECT;
        if ((0, $aZ24W.isUsingStaticRendering)()) return fn();
        var wantedForceUpdateHook = options.useForceUpdate || (0, $fB7Vm.useForceUpdate);
        var forceUpdate = wantedForceUpdateHook();
        var queuedForceUpdate = (0, $a3gxK.useQueuedForceUpdate)(forceUpdate);
        var reactionTrackingRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        if (!reactionTrackingRef.current) {
            var newReaction_1 = new (0, $alnGD.Reaction)($9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName), function() {
                if (trackingData_1.mounted) queuedForceUpdate();
                else {
                    newReaction_1.dispose();
                    reactionTrackingRef.current = null;
                }
            });
            var trackingData_1 = (0, $gLdfn.createTrackingData)(newReaction_1);
            reactionTrackingRef.current = trackingData_1;
            (0, $gLdfn.scheduleCleanupOfReactionIfLeaked)(reactionTrackingRef);
        }
        var reaction = reactionTrackingRef.current.reaction;
        (0, ($parcel$interopDefault($5uXOq))).useDebugValue(reaction, (0, $kic6x.printDebugValue));
        (0, ($parcel$interopDefault($5uXOq))).useEffect(function() {
            (0, $gLdfn.recordReactionAsCommitted)(reactionTrackingRef);
            if (reactionTrackingRef.current) reactionTrackingRef.current.mounted = true;
            else {
                reactionTrackingRef.current = {
                    reaction: new (0, $alnGD.Reaction)($9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName), function() {
                        queuedForceUpdate();
                    }),
                    cleanAt: Infinity
                };
                queuedForceUpdate();
            }
            return function() {
                reactionTrackingRef.current.reaction.dispose();
                reactionTrackingRef.current = null;
            };
        }, []);
        return (0, $a3gxK.useQueuedForceUpdateBlock)(function() {
            var rendering;
            var exception;
            reaction.track(function() {
                try {
                    rendering = fn();
                } catch (e) {
                    exception = e;
                }
            });
            if (exception) throw exception;
            return rendering;
        });
    }
});
parcelRegister("kic6x", function(module, exports) {
    $parcel$export(module.exports, "printDebugValue", ()=>$ec5ee0ca53ebf31f$export$ef795f1f307682c7);
    var $alnGD = parcelRequire("alnGD");
    function $ec5ee0ca53ebf31f$export$ef795f1f307682c7(v) {
        return (0, $alnGD.getDependencyTree)(v);
    }
});
parcelRegister("gLdfn", function(module, exports) {
    $parcel$export(module.exports, "createTrackingData", ()=>$c33b4fb78bda2447$export$bbb1082a9abc1839);
    $parcel$export(module.exports, "scheduleCleanupOfReactionIfLeaked", ()=>$c33b4fb78bda2447$export$674b151f0ca8d79f);
    $parcel$export(module.exports, "recordReactionAsCommitted", ()=>$c33b4fb78bda2447$export$ab63aa5c46b8d26f);
    function $c33b4fb78bda2447$export$bbb1082a9abc1839(reaction) {
        var trackingData = {
            cleanAt: Date.now() + $c33b4fb78bda2447$export$6c9b1ff66852295c,
            reaction: reaction
        };
        return trackingData;
    }
    var $c33b4fb78bda2447$export$6c9b1ff66852295c = 10000;
    var $c33b4fb78bda2447$export$262a80afc9566214 = 10000;
    var $c33b4fb78bda2447$var$uncommittedReactionRefs = new Set();
    var $c33b4fb78bda2447$var$reactionCleanupHandle;
    function $c33b4fb78bda2447$var$ensureCleanupTimerRunning() {
        if ($c33b4fb78bda2447$var$reactionCleanupHandle === undefined) $c33b4fb78bda2447$var$reactionCleanupHandle = setTimeout($c33b4fb78bda2447$var$cleanUncommittedReactions, $c33b4fb78bda2447$export$262a80afc9566214);
    }
    function $c33b4fb78bda2447$export$674b151f0ca8d79f(ref) {
        $c33b4fb78bda2447$var$uncommittedReactionRefs.add(ref);
        $c33b4fb78bda2447$var$ensureCleanupTimerRunning();
    }
    function $c33b4fb78bda2447$export$ab63aa5c46b8d26f(reactionRef) {
        $c33b4fb78bda2447$var$uncommittedReactionRefs.delete(reactionRef);
    }
    function $c33b4fb78bda2447$var$cleanUncommittedReactions() {
        $c33b4fb78bda2447$var$reactionCleanupHandle = undefined;
        var now = Date.now();
        $c33b4fb78bda2447$var$uncommittedReactionRefs.forEach(function(ref) {
            var tracking = ref.current;
            if (tracking) {
                if (now >= tracking.cleanAt) {
                    tracking.reaction.dispose();
                    ref.current = null;
                    $c33b4fb78bda2447$var$uncommittedReactionRefs.delete(ref);
                }
            }
        });
        if ($c33b4fb78bda2447$var$uncommittedReactionRefs.size > 0) $c33b4fb78bda2447$var$ensureCleanupTimerRunning();
    }
    function $c33b4fb78bda2447$export$e4e43e0ec68bea7() {
        if ($c33b4fb78bda2447$var$reactionCleanupHandle) {
            clearTimeout($c33b4fb78bda2447$var$reactionCleanupHandle);
            $c33b4fb78bda2447$var$cleanUncommittedReactions();
        }
    }
    function $c33b4fb78bda2447$export$8ccb7f898b3f89a3() {
        if ($c33b4fb78bda2447$var$reactionCleanupHandle) {
            clearTimeout($c33b4fb78bda2447$var$reactionCleanupHandle);
            $c33b4fb78bda2447$var$reactionCleanupHandle = undefined;
        }
        $c33b4fb78bda2447$var$uncommittedReactionRefs.clear();
    }
});
parcelRegister("a3gxK", function(module, exports) {
    $parcel$export(module.exports, "useQueuedForceUpdate", ()=>$7517045cc96643b0$export$68f31d22c29ca55);
    $parcel$export(module.exports, "useQueuedForceUpdateBlock", ()=>$7517045cc96643b0$export$7cdb73c439d9f744);
    var $5uXOq = parcelRequire("5uXOq");
    var $7517045cc96643b0$var$insideRender = false;
    var $7517045cc96643b0$var$forceUpdateQueue = [];
    function $7517045cc96643b0$export$68f31d22c29ca55(forceUpdate) {
        return function() {
            if ($7517045cc96643b0$var$insideRender) $7517045cc96643b0$var$forceUpdateQueue.push(forceUpdate);
            else forceUpdate();
        };
    }
    function $7517045cc96643b0$export$7cdb73c439d9f744(callback) {
        $7517045cc96643b0$var$insideRender = true;
        $7517045cc96643b0$var$forceUpdateQueue = [];
        try {
            var result = callback();
            $7517045cc96643b0$var$insideRender = false;
            var queue_1 = $7517045cc96643b0$var$forceUpdateQueue.length > 0 ? $7517045cc96643b0$var$forceUpdateQueue : undefined;
            (0, ($parcel$interopDefault($5uXOq))).useLayoutEffect(function() {
                if (queue_1) queue_1.forEach(function(x) {
                    return x();
                });
            }, [
                queue_1
            ]);
            return result;
        } finally{
            $7517045cc96643b0$var$insideRender = false;
        }
    }
});
parcelRegister("9rP9c", function(module, exports) {
    var $diuRl = parcelRequire("diuRl");
    function $6e0e4f738816fdc3$export$c1cbdee04e18ea8b(_a) {
        var children = _a.children, render = _a.render;
        var component = children || render;
        if (typeof component !== "function") return null;
        return (0, $diuRl.useObserver)(component);
    }
    $6e0e4f738816fdc3$export$c1cbdee04e18ea8b.propTypes = {
        children: $6e0e4f738816fdc3$var$ObserverPropsCheck,
        render: $6e0e4f738816fdc3$var$ObserverPropsCheck
    };
    $6e0e4f738816fdc3$export$c1cbdee04e18ea8b.displayName = "Observer";
    function $6e0e4f738816fdc3$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
        var extraKey = key === "children" ? "render" : "children";
        var hasProp = typeof props[key] === "function";
        var hasExtraProp = typeof props[extraKey] === "function";
        if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
        if (hasProp || hasExtraProp) return null;
        return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
    }
});
parcelRegister("ic428", function(module, exports) {
    $parcel$export(module.exports, "useAsObservableSourceInternal", ()=>$d3ec79ea917503e0$export$3ad4ae20ecfadabf);
    var $alnGD = parcelRequire("alnGD");
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("fB7Vm");
    var $d3ec79ea917503e0$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    function $d3ec79ea917503e0$export$3ad4ae20ecfadabf(current, usedByLocalStore) {
        var culprit = usedByLocalStore ? "useLocalStore" : "useAsObservableSource";
        var _a, initialSource;
        if (usedByLocalStore && current === undefined) return undefined;
        var _b = $d3ec79ea917503e0$var$__read((0, ($parcel$interopDefault($5uXOq))).useState(function() {
            return (0, $alnGD.observable)(current, {}, {
                deep: false
            });
        }), 1), res = _b[0];
        (0, $alnGD.runInAction)(function() {
            Object.assign(res, current);
        });
        return res;
    }
    function $d3ec79ea917503e0$export$e0ded3646391939c(current) {
        return $d3ec79ea917503e0$export$3ad4ae20ecfadabf(current, false);
    }
});
parcelRegister("g4qUw", function(module, exports) {
    var $alnGD = parcelRequire("alnGD");
    var $5uXOq = parcelRequire("5uXOq");
    var $ic428 = parcelRequire("ic428");
    var $fB7Vm = parcelRequire("fB7Vm");
    function $bb31e4eee5e1ad6a$export$f5b97ae82d1eeaf3(initializer, current) {
        var source = (0, $ic428.useAsObservableSourceInternal)(current, true);
        return (0, ($parcel$interopDefault($5uXOq))).useState(function() {
            var local = (0, $alnGD.observable)(initializer(source));
            if ((0, $fB7Vm.isPlainObject)(local)) (0, $alnGD.runInAction)(function() {
                Object.keys(local).forEach(function(key) {
                    var value = local[key];
                    if (typeof value === "function") local[key] = $bb31e4eee5e1ad6a$var$wrapInTransaction(value, local);
                });
            });
            return local;
        })[0];
    }
    function $bb31e4eee5e1ad6a$var$wrapInTransaction(fn, context) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return (0, $alnGD.transaction)(function() {
                return fn.apply(context, args);
            });
        };
    }
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("bEQ2i", function(module, exports) {
    $parcel$export(module.exports, "useFormSaveErrorsActions", ()=>$87cbcb65748b9438$export$48041cd2370efddc);
    $parcel$export(module.exports, "useFormSaveQuestionError", ()=>$87cbcb65748b9438$export$6c13595b521b4dfd);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    var $2NMNM;
    var $h8yj2;
    var $erWXD;
    const $87cbcb65748b9438$var$initialState = {
        errorsByQuestionId: {}
    };
    const $87cbcb65748b9438$var$actions = {
        set: (errorsByQuestionId)=>({ setState: setState })=>setState({
                    errorsByQuestionId: errorsByQuestionId
                }),
        setFromJiraFieldErrors: (form, jiraFieldErrors)=>({ setState: setState })=>{
                const formQuestionsByJiraField = form.questions.reduce((accQuestions, question)=>{
                    const jiraField = question.formQuestion.jiraField;
                    if (!jiraField) return accQuestions;
                    return {
                        ...accQuestions,
                        [jiraField]: question
                    };
                }, {});
                const errorsByQuestionId = Object.entries(jiraFieldErrors).reduce((accErrorsByQuestionId, [jiraField, error])=>{
                    var _formQuestionsByJiraF, _formQuestionsByJiraF2;
                    const questionId = ((_formQuestionsByJiraF = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF === void 0 ? void 0 : _formQuestionsByJiraF.id) && Number((_formQuestionsByJiraF2 = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF2 === void 0 ? void 0 : _formQuestionsByJiraF2.id);
                    if (!questionId) return accErrorsByQuestionId;
                    return {
                        ...accErrorsByQuestionId,
                        [questionId]: error
                    };
                }, {});
                setState({
                    ...$87cbcb65748b9438$var$initialState,
                    errorsByQuestionId: errorsByQuestionId
                });
            },
        clear: ()=>({ setState: setState })=>setState($87cbcb65748b9438$var$initialState)
    };
    const $87cbcb65748b9438$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $87cbcb65748b9438$var$initialState,
        actions: $87cbcb65748b9438$var$actions,
        name: `FormSaveErrors`
    });
    const $87cbcb65748b9438$var$useFormSaveErrors = (0, (0, parcelRequire("3sQ5x")).createHook)($87cbcb65748b9438$var$Store);
    const $87cbcb65748b9438$export$48041cd2370efddc = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { set: set, setFromJiraFieldErrors: setFromJiraFieldErrors, clear: clear }] = $87cbcb65748b9438$var$useFormSaveErrors();
        const setWithAnalytics = (0, $5uXOq.useCallback)((errorsByQuestionId)=>{
            if (Object.keys(errorsByQuestionId).length > 0) (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM_SAVE} ${(0, (0, parcelRequire("erWXD")).Action).STOPPED}`);
            set(errorsByQuestionId);
        }, [
            createAnalyticsEvent,
            set
        ]);
        const setWithJiraFieldErrorsWithAnalytics = (0, $5uXOq.useCallback)((form, jiraFieldErrors)=>{
            if (Object.keys(jiraFieldErrors).length > 0) (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM_SAVE} ${(0, (0, parcelRequire("erWXD")).Action).STOPPED}`);
            setFromJiraFieldErrors(form, jiraFieldErrors);
        }, [
            createAnalyticsEvent,
            setFromJiraFieldErrors
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                set: setWithAnalytics,
                setFromJiraFieldErrors: setWithJiraFieldErrorsWithAnalytics,
                clear: clear
            }), [
            clear,
            setWithAnalytics,
            setWithJiraFieldErrorsWithAnalytics
        ]);
    };
    const $87cbcb65748b9438$export$6c13595b521b4dfd = (questionId)=>{
        const [{ errorsByQuestionId: errorsByQuestionId }] = $87cbcb65748b9438$var$useFormSaveErrors();
        return errorsByQuestionId[questionId];
    };
});
parcelRegister("8LS7b", function(module, exports) {
    $parcel$export(module.exports, "convertAnswers", ()=>$662cb095ff9aa35e$export$ebf64a9da647b95d);
    var $4aJmI;
    var $4QmvR;
    const $662cb095ff9aa35e$export$ebf64a9da647b95d = (questions)=>{
        const answersMap = {};
        questions.forEach((question)=>{
            answersMap[question.id.toString()] = $662cb095ff9aa35e$var$getFormAnswer(question);
        });
        return answersMap;
    };
    const $662cb095ff9aa35e$export$1f200de465f7a566 = (answer)=>{
        return answer === undefined ? null : answer;
    };
    function $662cb095ff9aa35e$var$getFormAnswer(question) {
        var _toDateTimeQuestionAn, _toDateTimeQuestionAn2, _toChoiceQuestionAnsw, _toChoiceQuestionAnsw2;
        switch(question.formQuestion.type){
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Number:
                return {
                    text: $662cb095ff9aa35e$export$1f200de465f7a566((0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(question.currentAnswer))
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph:
                return {
                    adf: (0, (0, parcelRequire("4QmvR")).toRichTextQuestionAnswer)(question.currentAnswer) || null
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime:
                return {
                    date: ((_toDateTimeQuestionAn = (0, (0, parcelRequire("4QmvR")).toDateTimeQuestionAnswer)(question.currentAnswer)) === null || _toDateTimeQuestionAn === void 0 ? void 0 : _toDateTimeQuestionAn.date) || null,
                    time: ((_toDateTimeQuestionAn2 = (0, (0, parcelRequire("4QmvR")).toDateTimeQuestionAnswer)(question.currentAnswer)) === null || _toDateTimeQuestionAn2 === void 0 ? void 0 : _toDateTimeQuestionAn2.time) || null
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date:
                return {
                    date: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(question.currentAnswer) || null
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Time:
                return {
                    time: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(question.currentAnswer) || null
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject:
                return {
                    text: (_toChoiceQuestionAnsw = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.text,
                    choices: (_toChoiceQuestionAnsw2 = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw2 === void 0 ? void 0 : _toChoiceQuestionAnsw2.choices
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple:
                return {
                    users: (0, (0, parcelRequire("4QmvR")).toUserPickerQuestionAnswer)(question.currentAnswer)
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment:
                return {
                    files: (0, (0, parcelRequire("4QmvR")).toAttachmentQuestionAnswer)(question.currentAnswer)
                };
            default:
                return {
                    text: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(question.currentAnswer)
                };
        }
    }
});
parcelRegister("4QmvR", function(module, exports) {
    $parcel$export(module.exports, "toRichTextQuestionAnswer", ()=>$386d7b5ac0037e42$export$957053b5df8c35dd);
    $parcel$export(module.exports, "toTextQuestionAnswer", ()=>$386d7b5ac0037e42$export$4392c3957775e9f7);
    $parcel$export(module.exports, "toDateTimeQuestionAnswer", ()=>$386d7b5ac0037e42$export$6305e45d67abc440);
    $parcel$export(module.exports, "toDateTimeQuestionAnswerOrEmpty", ()=>$386d7b5ac0037e42$export$c747b9cbc376a41c);
    $parcel$export(module.exports, "toChoiceQuestionAnswer", ()=>$386d7b5ac0037e42$export$bb1c52eccaca93f1);
    $parcel$export(module.exports, "toChoiceQuestionAnswerOrEmpty", ()=>$386d7b5ac0037e42$export$cf2ff167d32b34bc);
    $parcel$export(module.exports, "toUserPickerQuestionAnswer", ()=>$386d7b5ac0037e42$export$4ed34efc5377e1e1);
    $parcel$export(module.exports, "toUserPickerQuestionAnswerOrEmpty", ()=>$386d7b5ac0037e42$export$40f309d38988372e);
    $parcel$export(module.exports, "toAttachmentQuestionAnswer", ()=>$386d7b5ac0037e42$export$97d32e27706e0cc4);
    $parcel$export(module.exports, "QuestionStore", ()=>$386d7b5ac0037e42$export$429c93ea52a8aa75);
    var $9kzTP = parcelRequire("9kzTP");
    var $7Jkpx = parcelRequire("7Jkpx");
    parcelRequire("cTQjS");
    var $alnGD = parcelRequire("alnGD");
    var $kz2lw;
    var $jLSMy;
    var $4aJmI;
    var $ctPpG;
    var $djQya;
    var $386d7b5ac0037e42$var$_class, $386d7b5ac0037e42$var$_descriptor, $386d7b5ac0037e42$var$_descriptor2, $386d7b5ac0037e42$var$_descriptor3, $386d7b5ac0037e42$var$_descriptor4, $386d7b5ac0037e42$var$_descriptor5, $386d7b5ac0037e42$var$_descriptor6, $386d7b5ac0037e42$var$_descriptor7, $386d7b5ac0037e42$var$_descriptor8, $386d7b5ac0037e42$var$_descriptor9, $386d7b5ac0037e42$var$_descriptor10, $386d7b5ac0037e42$var$_descriptor11, $386d7b5ac0037e42$var$_descriptor12, $386d7b5ac0037e42$var$_descriptor13, $386d7b5ac0037e42$var$_descriptor14, $386d7b5ac0037e42$var$_descriptor15, $386d7b5ac0037e42$var$_descriptor16, $386d7b5ac0037e42$var$_descriptor17, $386d7b5ac0037e42$var$_descriptor18, $386d7b5ac0037e42$var$_descriptor19, $386d7b5ac0037e42$var$_descriptor20, $386d7b5ac0037e42$var$_descriptor21, $386d7b5ac0037e42$var$_descriptor22, $386d7b5ac0037e42$var$_descriptor23, $386d7b5ac0037e42$var$_descriptor24, $386d7b5ac0037e42$var$_class2;
    const $386d7b5ac0037e42$var$isArray = (value)=>{
        return !!value && value.length != null && value.splice != null;
    };
    const $386d7b5ac0037e42$export$85d7ec96a7f16e50 = (answer)=>{
        return typeof answer === 'object' && answer.hasOwnProperty('content') && answer.hasOwnProperty('version') && answer.hasOwnProperty('type') && answer.type === 'doc';
    };
    const $386d7b5ac0037e42$export$957053b5df8c35dd = (answer)=>$386d7b5ac0037e42$export$85d7ec96a7f16e50(answer) ? answer : undefined;
    const $386d7b5ac0037e42$var$isTextQuestionAnswer = (answer)=>typeof answer === 'string';
    const $386d7b5ac0037e42$export$4392c3957775e9f7 = (answer)=>$386d7b5ac0037e42$var$isTextQuestionAnswer(answer) ? answer : undefined;
    const $386d7b5ac0037e42$var$isDateTimeQuestionAnswer = (answer)=>(answer === null || answer === void 0 ? void 0 : answer.date) !== undefined;
    const $386d7b5ac0037e42$export$6305e45d67abc440 = (answer)=>$386d7b5ac0037e42$var$isDateTimeQuestionAnswer(answer) ? answer : undefined;
    const $386d7b5ac0037e42$export$c747b9cbc376a41c = (answer)=>$386d7b5ac0037e42$var$isDateTimeQuestionAnswer(answer) ? answer : {
            date: '',
            time: ''
        };
    const $386d7b5ac0037e42$var$isChoiceQuestionAnswer = (answer)=>(answer === null || answer === void 0 ? void 0 : answer.choices) !== undefined;
    const $386d7b5ac0037e42$export$bb1c52eccaca93f1 = (answer)=>$386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) ? answer : undefined;
    const $386d7b5ac0037e42$export$cf2ff167d32b34bc = (answer)=>$386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) ? answer : {
            text: '',
            choices: []
        };
    const $386d7b5ac0037e42$var$isUserPickerQuestionAnswer = (answer)=>{
        return $386d7b5ac0037e42$var$isArray(answer);
    };
    const $386d7b5ac0037e42$export$4ed34efc5377e1e1 = (answer)=>$386d7b5ac0037e42$var$isUserPickerQuestionAnswer(answer) ? answer : undefined;
    const $386d7b5ac0037e42$export$40f309d38988372e = (answer)=>$386d7b5ac0037e42$var$isUserPickerQuestionAnswer(answer) ? answer : [];
    const $386d7b5ac0037e42$export$30613a542e82c0b7 = (answer)=>$386d7b5ac0037e42$var$isArray(answer) && answer.every((a)=>a.id !== undefined);
    const $386d7b5ac0037e42$export$97d32e27706e0cc4 = (answer)=>$386d7b5ac0037e42$export$30613a542e82c0b7(answer) ? answer : undefined;
    const $386d7b5ac0037e42$var$extractAnswer = (questionType, answer)=>{
        var _console$debug, _console;
        switch(questionType){
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Number:
                return answer.text || '';
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime:
                return {
                    date: answer.date || '',
                    time: answer.time || ''
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date:
                return answer.date || '';
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Time:
                return answer.time || '';
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject:
                return {
                    text: answer.text || '',
                    choices: answer.choices || []
                };
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple:
                return answer.users || [];
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph:
                return answer.adf || (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment:
                return answer.files || [];
            default:
                (_console$debug = (_console = console).debug) === null || _console$debug === void 0 || _console$debug.call(_console, `Question type ${questionType} is not handled.`);
                return '';
        }
    };
    const $386d7b5ac0037e42$var$sortById = (a, b)=>{
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
    };
    let $386d7b5ac0037e42$export$429c93ea52a8aa75 = ($386d7b5ac0037e42$var$_class = ($386d7b5ac0037e42$var$_class2 = class QuestionStore {
        constructor(intl, questionKey, _formQuestion, loadChoicesAsync, onFieldChange, populateDefaultValueOnEmptySearch, _currentAnswer, onFieldDirty){
            var _formQuestion$conditi;
            this.intl = intl;
            this.id = void 0;
            this.formQuestion = void 0;
            this.conditions = void 0;
            this.hasJiraField = void 0;
            this.hasDataConnection = void 0;
            (0, $9kzTP.default)(this, "answer", $386d7b5ac0037e42$var$_descriptor, this);
            (0, $9kzTP.default)(this, "modifiedAnswer", $386d7b5ac0037e42$var$_descriptor2, this);
            (0, $9kzTP.default)(this, "validating", $386d7b5ac0037e42$var$_descriptor3, this);
            (0, $9kzTP.default)(this, "loading", $386d7b5ac0037e42$var$_descriptor4, this);
            (0, $9kzTP.default)(this, "isUploadingMedia", $386d7b5ac0037e42$var$_descriptor5, this);
            (0, $9kzTP.default)(this, "choices", $386d7b5ac0037e42$var$_descriptor6, this);
            (0, $9kzTP.default)(this, "answerChoicesAsObjects", $386d7b5ac0037e42$var$_descriptor7, this);
            (0, $9kzTP.default)(this, "dependentFieldChangedCount", $386d7b5ac0037e42$var$_descriptor8, this);
            (0, $9kzTP.default)(this, "otherChoiceId", $386d7b5ac0037e42$var$_descriptor9, this);
            (0, $9kzTP.default)(this, "revisionToken", $386d7b5ac0037e42$var$_descriptor10, this);
            (0, $9kzTP.default)(this, "issueFieldData", $386d7b5ac0037e42$var$_descriptor11, this);
            this.loadChoicesAsync = void 0;
            this.onFieldChange = void 0;
            this.populateDefaultValueOnEmptySearch = void 0;
            this.onFieldDirty = void 0;
            this.attachmentEqual = (a1, a2)=>{
                if (a1 === undefined || a2 === undefined) return false;
                return a1['id'] === a2['id'];
            };
            this.hasAttachmentFieldModified = ()=>{
                const af1 = this.answer;
                const af2 = this.modifiedAnswer;
                if (af1 === undefined || af2 === undefined) return false;
                return !(af1.length === af2.length && af1.every((a, idx)=>this.attachmentEqual(a, af2[idx])));
            };
            this.choiceToOption = (choice)=>{
                var _choice$children;
                return {
                    value: choice.id,
                    label: choice.label,
                    children: (_choice$children = choice.children) === null || _choice$children === void 0 ? void 0 : _choice$children.map(this.choiceToOption)
                };
            };
            this.availableOptions = ()=>{
                return this.choices.map(this.choiceToOption);
            };
            this.getAnswerChoicesAsObjects = ()=>{
                const choices = this.answerChoicesAsObjects;
                const currentChoiceOptions = choices.map(this.choiceToOption);
                const choiceAnswer = $386d7b5ac0037e42$export$cf2ff167d32b34bc(this.currentAnswer);
                return currentChoiceOptions.filter((option)=>choiceAnswer.choices.includes(option.value) || choiceAnswer.choices.map((choice)=>choice.split(':')[0]).includes(option.value));
            };
            (0, $9kzTP.default)(this, "setLastUpdated", $386d7b5ac0037e42$var$_descriptor12, this);
            (0, $9kzTP.default)(this, "setAnswer", $386d7b5ac0037e42$var$_descriptor13, this);
            (0, $9kzTP.default)(this, "doPopulateDefaultValueOnEmptySearch", $386d7b5ac0037e42$var$_descriptor14, this);
            (0, $9kzTP.default)(this, "onDependentFieldChanged", $386d7b5ac0037e42$var$_descriptor15, this);
            (0, $9kzTP.default)(this, "validate", $386d7b5ac0037e42$var$_descriptor16, this);
            (0, $9kzTP.default)(this, "hideValidation", $386d7b5ac0037e42$var$_descriptor17, this);
            (0, $9kzTP.default)(this, "setUploadingMedia", $386d7b5ac0037e42$var$_descriptor18, this);
            (0, $9kzTP.default)(this, "discardModifiedAnswer", $386d7b5ac0037e42$var$_descriptor19, this);
            (0, $9kzTP.default)(this, "setAnswerFromFieldValue", $386d7b5ac0037e42$var$_descriptor20, this);
            (0, $9kzTP.default)(this, "setChoices", $386d7b5ac0037e42$var$_descriptor21, this);
            this._setChoices = (choices)=>{
                this.choices.splice(0, this.choices.length, ...choices);
                const otherChoice = this._setOtherChoiceLabel(choices);
                this.otherChoiceId = otherChoice === null || otherChoice === void 0 ? void 0 : otherChoice.id;
            };
            this._setOtherChoiceLabel = (choices)=>{
                const otherChoice = choices.find((choice)=>choice.other);
                if (otherChoice) otherChoice.label = this.intl.formatMessage((0, (0, parcelRequire("jLSMy")).IntlChoiceMessages)[(0, (0, parcelRequire("jLSMy")).ChoiceMessage).OtherPlaceholder]);
                return otherChoice;
            };
            this._isAsyncChoicesQuestion = ()=>{
                var _this$choices;
                return !(((_this$choices = this.choices) === null || _this$choices === void 0 ? void 0 : _this$choices.length) > 0);
            };
            (0, $9kzTP.default)(this, "setAnswerChoicesAsObjects", $386d7b5ac0037e42$var$_descriptor22, this);
            this._setAnswerChoicesAsObjects = (answerChoicesAsObjects)=>{
                this.answerChoicesAsObjects.splice(0, this.answerChoicesAsObjects.length, ...answerChoicesAsObjects);
                this._setOtherChoiceLabel(this.answerChoicesAsObjects);
            };
            (0, $9kzTP.default)(this, "setIssueFieldData", $386d7b5ac0037e42$var$_descriptor23, this);
            (0, $9kzTP.default)(this, "update", $386d7b5ac0037e42$var$_descriptor24, this);
            this._update = (constructing, formQuestion, currentAnswer)=>{
                this._setChoices(formQuestion.choices || []);
                this.answer = $386d7b5ac0037e42$var$extractAnswer(formQuestion.type, currentAnswer || (0, (0, parcelRequire("4aJmI")).FormAnswerEmpty));
                if (!constructing) {
                    this.hideValidation();
                    this.discardModifiedAnswer();
                    this.setLastUpdated();
                }
            };
            this.loadChoicesAsync = loadChoicesAsync;
            this.onFieldChange = onFieldChange;
            this.onFieldDirty = onFieldDirty;
            this.populateDefaultValueOnEmptySearch = populateDefaultValueOnEmptySearch;
            this.id = parseInt(questionKey, 10);
            this.revisionToken = `${this.id}-${Date.now()}`;
            this.formQuestion = _formQuestion;
            this.conditions = ((_formQuestion$conditi = _formQuestion.conditions) === null || _formQuestion$conditi === void 0 ? void 0 : _formQuestion$conditi.map((condition)=>parseInt(condition))) || [];
            this.hasJiraField = !!_formQuestion.jiraField;
            this.hasDataConnection = !!_formQuestion.dcId;
            this._setChoices(_formQuestion.choices || []);
            this._setAnswerChoicesAsObjects(_formQuestion.choices || []);
            this.answer = $386d7b5ac0037e42$var$extractAnswer(_formQuestion.type, _currentAnswer || (0, (0, parcelRequire("4aJmI")).FormAnswerEmpty));
            switch(_formQuestion.type){
                case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
                    this.formQuestion.validation.rgx = {
                        p: /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/
                    };
                    break;
                case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
                    this.formQuestion.validation.rgx = {
                        p: /((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/
                    };
                    break;
                default:
            }
            this._update(true, _formQuestion, _currentAnswer);
        }
        get answerModified() {
            if (this.formQuestion.type === (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment) return this.hasAttachmentFieldModified();
            else return this.modifiedAnswer !== undefined;
        }
        get currentAnswer() {
            if (this.modifiedAnswer !== undefined) return this.modifiedAnswer;
            if (this.answer != null) return this.answer;
            return 0, (0, parcelRequire("4aJmI")).FormAnswerEmpty;
        }
        get isAsyncChoicesField() {
            var _this$issueFieldData, _this$issueFieldData$, _this$issueFieldData2, _this$issueFieldData3;
            const linkedJiraFieldSchemaSystem = (_this$issueFieldData = this.issueFieldData) === null || _this$issueFieldData === void 0 ? void 0 : (_this$issueFieldData$ = _this$issueFieldData.schema) === null || _this$issueFieldData$ === void 0 ? void 0 : _this$issueFieldData$.system;
            if (linkedJiraFieldSchemaSystem && (0, (0, parcelRequire("ctPpG")).asyncChoicesFieldSchemaSystems).includes(linkedJiraFieldSchemaSystem)) return true;
            const linkedJiraFieldSchemaCustom = (_this$issueFieldData2 = this.issueFieldData) === null || _this$issueFieldData2 === void 0 ? void 0 : (_this$issueFieldData3 = _this$issueFieldData2.schema) === null || _this$issueFieldData3 === void 0 ? void 0 : _this$issueFieldData3.custom;
            if (linkedJiraFieldSchemaCustom && (0, (0, parcelRequire("ctPpG")).asyncChoicesFieldSchemaCustoms).includes(linkedJiraFieldSchemaCustom)) return true;
            return false;
        }
        get validationErrors() {
            var _this$issueFieldData4;
            if (this.answerModified || this.validating) {
                const currentAnswerForTextQuestion = $386d7b5ac0037e42$export$4392c3957775e9f7(this.currentAnswer) || '';
                switch(this.formQuestion.type){
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph:
                        return (0, (0, parcelRequire("djQya")).getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph:
                        return (0, (0, parcelRequire("djQya")).getRichTextValidation)(this.formQuestion.validation, (0, $alnGD.toJS)($386d7b5ac0037e42$export$957053b5df8c35dd(this.currentAnswer)) || (0, (0, parcelRequire("kz2lw")).getEmptyADF)());
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
                        return (0, (0, parcelRequire("djQya")).getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
                        return (0, (0, parcelRequire("djQya")).getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Number:
                        return (0, (0, parcelRequire("djQya")).getNumberValidation)(this.formQuestion.validation, currentAnswerForTextQuestion);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime:
                        return (0, (0, parcelRequire("djQya")).getDateTimeValidation)(this.formQuestion.validation, $386d7b5ac0037e42$export$c747b9cbc376a41c(this.currentAnswer));
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date:
                        return (0, (0, parcelRequire("djQya")).getDateValidation)(this.formQuestion.validation, currentAnswerForTextQuestion);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Time:
                        return (0, (0, parcelRequire("djQya")).getTimeValidation)(this.formQuestion.validation, currentAnswerForTextQuestion);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject:
                        return (0, (0, parcelRequire("djQya")).getChoiceValidation)(this.formQuestion.validation, this.choices, $386d7b5ac0037e42$export$cf2ff167d32b34bc(this.currentAnswer), (_this$issueFieldData4 = this.issueFieldData) === null || _this$issueFieldData4 === void 0 ? void 0 : _this$issueFieldData4.asyncRequiredChoice);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle:
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple:
                        return (0, (0, parcelRequire("djQya")).getUserPickerValidation)(this.formQuestion.validation, $386d7b5ac0037e42$export$4ed34efc5377e1e1(this.currentAnswer) || []);
                    case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment:
                        return (0, (0, parcelRequire("djQya")).getAttachmentValidation)(this.formQuestion.validation, (0, $alnGD.toJS)($386d7b5ac0037e42$export$97d32e27706e0cc4(this.currentAnswer)) || [], this.formQuestion.type);
                    default:
                }
            }
        }
    }, $386d7b5ac0037e42$var$_class2.optionToChoice = (option)=>{
        var _option$children;
        return {
            id: option.value,
            label: option.label,
            children: (_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.map($386d7b5ac0037e42$var$_class2.optionToChoice)
        };
    }, $386d7b5ac0037e42$var$_class2), $386d7b5ac0037e42$var$_descriptor = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answer", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $386d7b5ac0037e42$var$_descriptor2 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "modifiedAnswer", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $386d7b5ac0037e42$var$_descriptor3 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validating", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return false;
        }
    }), $386d7b5ac0037e42$var$_descriptor4 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "loading", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return false;
        }
    }), $386d7b5ac0037e42$var$_descriptor5 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "isUploadingMedia", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return false;
        }
    }), $386d7b5ac0037e42$var$_descriptor6 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "choices", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return [];
        }
    }), $386d7b5ac0037e42$var$_descriptor7 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answerChoicesAsObjects", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return [];
        }
    }), $386d7b5ac0037e42$var$_descriptor8 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "dependentFieldChangedCount", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return 0;
        }
    }), $386d7b5ac0037e42$var$_descriptor9 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "otherChoiceId", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $386d7b5ac0037e42$var$_descriptor10 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "revisionToken", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $386d7b5ac0037e42$var$_descriptor11 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "issueFieldData", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answerModified", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "answerModified"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "currentAnswer", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "currentAnswer"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "isAsyncChoicesField", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "isAsyncChoicesField"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validationErrors", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "validationErrors"), $386d7b5ac0037e42$var$_class.prototype), $386d7b5ac0037e42$var$_descriptor12 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setLastUpdated", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.revisionToken = `${this.id}-${Date.now()}`;
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor13 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswer", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (answer, modifiedAnswer = true)=>{
                if (modifiedAnswer) {
                    this.modifiedAnswer = answer;
                    if (this.answerModified) {
                        var _this$onFieldDirty;
                        (_this$onFieldDirty = this.onFieldDirty) === null || _this$onFieldDirty === void 0 || _this$onFieldDirty.call(this);
                    }
                } else {
                    this.modifiedAnswer = undefined;
                    this.answer = answer;
                }
                if ($386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) && answer.choiceObjects != null) this.setAnswerChoicesAsObjects(answer.choiceObjects);
                this.setLastUpdated();
                this.onFieldChange({
                    jiraField: this.formQuestion.jiraField,
                    questionType: this.formQuestion.type
                }, $386d7b5ac0037e42$export$4392c3957775e9f7(answer) || '');
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor14 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "doPopulateDefaultValueOnEmptySearch", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                var _this$issueFieldData5;
                if (!this.populateDefaultValueOnEmptySearch || !((_this$issueFieldData5 = this.issueFieldData) !== null && _this$issueFieldData5 !== void 0 && _this$issueFieldData5.populateDefaultValueOnEmptySearch) || !this.isAsyncChoicesField) return Promise.resolve();
                this.loading = true;
                return this.loadChoicesAsync('').then((options)=>{
                    var _this$formQuestion$va, _this$issueFieldData$2, _this$issueFieldData6;
                    const choices = options.map($386d7b5ac0037e42$export$429c93ea52a8aa75.optionToChoice);
                    const maxAllowedChoices = Math.min((_this$formQuestion$va = this.formQuestion.validation.mxs) !== null && _this$formQuestion$va !== void 0 ? _this$formQuestion$va : choices.length, (_this$issueFieldData$2 = (_this$issueFieldData6 = this.issueFieldData) === null || _this$issueFieldData6 === void 0 ? void 0 : _this$issueFieldData6.maxAllowedChoices) !== null && _this$issueFieldData$2 !== void 0 ? _this$issueFieldData$2 : choices.length);
                    const validatedChoices = choices.splice(0, maxAllowedChoices);
                    this.setAnswer({
                        choices: validatedChoices.map(({ id: id })=>id),
                        choiceObjects: validatedChoices
                    }, false);
                }).finally(()=>{
                    this.loading = false;
                });
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor15 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "onDependentFieldChanged", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.dependentFieldChangedCount++;
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor16 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validate", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.validating = true;
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor17 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "hideValidation", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.validating = false;
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor18 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setUploadingMedia", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (isUploadingMedia)=>{
                this.isUploadingMedia = isUploadingMedia;
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor19 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "discardModifiedAnswer", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.modifiedAnswer = undefined;
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor20 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswerFromFieldValue", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (answer)=>{
                this.answer = $386d7b5ac0037e42$var$extractAnswer(this.formQuestion.type, answer);
                this.modifiedAnswer = undefined;
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor21 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setChoices", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (choices)=>{
                const currentAnswerChoices = this.getAnswerChoicesAsObjects().map($386d7b5ac0037e42$export$429c93ea52a8aa75.optionToChoice);
                const newAnswerChoices = choices.filter((choice)=>{
                    var _toChoiceQuestionAnsw;
                    return ((_toChoiceQuestionAnsw = $386d7b5ac0037e42$export$bb1c52eccaca93f1(this.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.choices.includes(choice.id)) && !currentAnswerChoices.some(({ id: id })=>id === choice.id);
                });
                this.setAnswerChoicesAsObjects([
                    ...currentAnswerChoices,
                    ...newAnswerChoices
                ]);
                this._setChoices(choices);
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor22 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswerChoicesAsObjects", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (choices)=>{
                let sortedChoices;
                if (!this._isAsyncChoicesQuestion()) sortedChoices = choices.slice().sort((a, b)=>this.choices.findIndex((choice)=>choice.id === a.id) - this.choices.findIndex((choice)=>choice.id === b.id));
                else sortedChoices = choices.slice().sort($386d7b5ac0037e42$var$sortById);
                this._setAnswerChoicesAsObjects(sortedChoices);
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor23 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setIssueFieldData", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (issueFieldData)=>{
                this.issueFieldData = issueFieldData;
                this.setLastUpdated();
            };
        }
    }), $386d7b5ac0037e42$var$_descriptor24 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "update", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (formQuestion, currentAnswer)=>this._update(false, formQuestion, currentAnswer);
        }
    }), $386d7b5ac0037e42$var$_class);
});
parcelRegister("9kzTP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb1d438ffa235a6$export$2e2bcd8739ae039);
    function $6cb1d438ffa235a6$export$2e2bcd8739ae039(e, i, r, l) {
        r && Object.defineProperty(e, i, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(l) : void 0
        });
    }
});
parcelRegister("7Jkpx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a0c9192206f93ca$export$2e2bcd8739ae039);
    function $5a0c9192206f93ca$export$2e2bcd8739ae039(i, e, r, n, l) {
        var a = {};
        return Object.keys(n).forEach(function(i) {
            a[i] = n[i];
        }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
            return n(i, e, r) || r;
        }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
    }
});
parcelRegister("cTQjS", function(module, exports) {
    function $964334b28db9c870$export$2e2bcd8739ae039(r, e) {
        throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
    }
});
parcelRegister("kz2lw", function(module, exports) {
    $parcel$export(module.exports, "getEmptyADF", ()=>$06167b6274ea84aa$export$d109ab46c9575565);
    var $ebjue;
    const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
            type: 'doc',
            version: 1,
            content: []
        });
});
parcelRegister("ebjue", function(module, exports) {
    $parcel$export(module.exports, "isEmpty", ()=>$9e55b7d6fded4629$export$dd1bc94b04021eeb);
    const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
});
parcelRegister("jLSMy", function(module, exports) {
    $parcel$export(module.exports, "ChoiceMessage", ()=>$e64ce6b26902a7d4$export$875538404f4123ab);
    $parcel$export(module.exports, "IntlChoiceMessages", ()=>$e64ce6b26902a7d4$export$253372a934dae76);
    var $7VHMR;
    let $e64ce6b26902a7d4$export$875538404f4123ab = function(ChoiceMessage) {
        ChoiceMessage["OtherPlaceholder"] = "OtherPlaceholder";
        return ChoiceMessage;
    }({});
    const $e64ce6b26902a7d4$export$253372a934dae76 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$e64ce6b26902a7d4$export$875538404f4123ab.OtherPlaceholder]: {
            id: 'form-system.ChoiceQuestion.OtherPlaceholder',
            defaultMessage: 'Other...'
        }
    });
});
parcelRegister("ctPpG", function(module, exports) {
    $parcel$export(module.exports, "AFFECTED_SERVICES_SCHEMA_CUSTOM", ()=>$91601312dc4b477f$export$f38b84edab004d9a);
    $parcel$export(module.exports, "CMDB_SCHEMA_CUSTOM", ()=>$91601312dc4b477f$export$701618b68a89ad17);
    $parcel$export(module.exports, "LABELS_SCHEMA_CUSTOM", ()=>$91601312dc4b477f$export$9af6b0504e2cd927);
    $parcel$export(module.exports, "LABELS_SCHEMA_SYSTEM", ()=>$91601312dc4b477f$export$65f164d21923031);
    $parcel$export(module.exports, "asyncChoicesFieldSchemaCustoms", ()=>$91601312dc4b477f$export$e0a5682f246556b7);
    $parcel$export(module.exports, "asyncChoicesFieldSchemaSystems", ()=>$91601312dc4b477f$export$4c6a5fe7f37267b9);
    $parcel$export(module.exports, "isAsyncCreatable", ()=>$91601312dc4b477f$export$eb35d73dc2127303);
    const $91601312dc4b477f$export$f38b84edab004d9a = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $91601312dc4b477f$export$701618b68a89ad17 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $91601312dc4b477f$export$9af6b0504e2cd927 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $91601312dc4b477f$export$65f164d21923031 = 'labels';
    const $91601312dc4b477f$export$e0a5682f246556b7 = [
        $91601312dc4b477f$export$f38b84edab004d9a,
        $91601312dc4b477f$export$701618b68a89ad17,
        $91601312dc4b477f$export$9af6b0504e2cd927
    ];
    const $91601312dc4b477f$export$4c6a5fe7f37267b9 = [
        $91601312dc4b477f$export$65f164d21923031
    ];
    const $91601312dc4b477f$export$eb35d73dc2127303 = (question)=>{
        var _question$issueFieldD, _question$issueFieldD2, _question$issueFieldD3, _question$issueFieldD4;
        return ((_question$issueFieldD = question.issueFieldData) === null || _question$issueFieldD === void 0 ? void 0 : (_question$issueFieldD2 = _question$issueFieldD.schema) === null || _question$issueFieldD2 === void 0 ? void 0 : _question$issueFieldD2.custom) === $91601312dc4b477f$export$9af6b0504e2cd927 || ((_question$issueFieldD3 = question.issueFieldData) === null || _question$issueFieldD3 === void 0 ? void 0 : (_question$issueFieldD4 = _question$issueFieldD3.schema) === null || _question$issueFieldD4 === void 0 ? void 0 : _question$issueFieldD4.system) === $91601312dc4b477f$export$65f164d21923031;
    };
});
parcelRegister("djQya", function(module, exports) {
    $parcel$export(module.exports, "getRichTextValidation", ()=>$9b25d012193ba90d$export$a4a4282c6e45fe75);
    $parcel$export(module.exports, "getTextValidation", ()=>$9b25d012193ba90d$export$6d44ff6f0b04b047);
    $parcel$export(module.exports, "getNumberValidation", ()=>$9b25d012193ba90d$export$26fbcce145c8b4e4);
    $parcel$export(module.exports, "getDateValidation", ()=>$9b25d012193ba90d$export$8d4b85d34923a80b);
    $parcel$export(module.exports, "getTimeValidation", ()=>$9b25d012193ba90d$export$a226e2ebf33a3dd5);
    $parcel$export(module.exports, "getDateTimeValidation", ()=>$9b25d012193ba90d$export$1ff6abd4f0e07282);
    $parcel$export(module.exports, "getChoiceValidation", ()=>$9b25d012193ba90d$export$9ec08da1d33bbc5e);
    $parcel$export(module.exports, "getUserPickerValidation", ()=>$9b25d012193ba90d$export$6f9eb7b39b2f37de);
    $parcel$export(module.exports, "getAttachmentValidation", ()=>$9b25d012193ba90d$export$1375a2241da0cd1);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fd9ep = parcelRequire("fd9ep");
    var $8ELPZ = parcelRequire("8ELPZ");
    var $hYNZx;
    var $dN5CS;
    var $VSDnB;
    var $cnwtr;
    var $4aJmI;
    var $6lxfx;
    var $51KJm;
    const $9b25d012193ba90d$var$wikiTransformer = new (0, (0, parcelRequire("dN5CS")).WikiMarkupTransformer)();
    const $9b25d012193ba90d$var$jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    const $9b25d012193ba90d$export$a4a4282c6e45fe75 = (requirements, adf, questionType)=>{
        const pmNode = $9b25d012193ba90d$var$jsonTransformer.parse(adf);
        return $9b25d012193ba90d$export$6d44ff6f0b04b047(requirements, $9b25d012193ba90d$var$wikiTransformer.encode(pmNode), questionType);
    };
    const $9b25d012193ba90d$export$6d44ff6f0b04b047 = (requirements, text, questionType)=>{
        const trimmedText = text.trim();
        let wordCount;
        if (requirements.mnw || requirements.mxw) wordCount = (0, (0, parcelRequire("51KJm")).wordCounter)(trimmedText);
        if (trimmedText.length === 0) {
            if (requirements.rq) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
                }
            ];
        } else {
            if (requirements.mnc && requirements.mnc === requirements.mxc && trimmedText.length !== requirements.mnc) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).ExactChars,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).ExactChars], {
                        values: {
                            mnc: requirements.mnc
                        }
                    }))
                }
            ];
            if (requirements.mnw && requirements.mnw === requirements.mxw && wordCount !== requirements.mnw) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).ExactWords,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).ExactWords], {
                        values: {
                            mnw: requirements.mnw
                        }
                    }))
                }
            ];
            if (requirements.mnc && requirements.mxc && (trimmedText.length < requirements.mnc || trimmedText.length > requirements.mxc)) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).BetweenChars,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).BetweenChars], {
                        values: {
                            mnc: requirements.mnc,
                            mxc: requirements.mxc
                        }
                    }))
                }
            ];
            if (requirements.mnw && requirements.mxw && wordCount && (wordCount < requirements.mnw || wordCount > requirements.mxw)) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).BetweenWords,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).BetweenWords], {
                        values: {
                            mnw: requirements.mnw,
                            mxw: requirements.mxw
                        }
                    }))
                }
            ];
            if (requirements.mnc && trimmedText.length < requirements.mnc) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MinChars,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MinChars], {
                        values: {
                            mnc: requirements.mnc - 1
                        }
                    }))
                }
            ];
            if (requirements.mnw && wordCount && wordCount < requirements.mnw) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MinWords,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MinWords], {
                        values: {
                            mnw: requirements.mnw - 1
                        }
                    }))
                }
            ];
            if (requirements.mxc && trimmedText.length > requirements.mxc) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MaxChars,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MaxChars], {
                        values: {
                            mxc: requirements.mxc + 1
                        }
                    }))
                }
            ];
            if (requirements.mxw && wordCount && wordCount > requirements.mxw) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MaxWords,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).MaxWords], {
                        values: {
                            mxw: requirements.mxw + 1
                        }
                    }))
                }
            ];
            if (requirements.rgx && requirements.rgx.p) try {
                if (!text.match(requirements.rgx.p)) {
                    if (questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl) return [
                        {
                            key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).InvalidUrl,
                            message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).InvalidUrl])
                        }
                    ];
                    if (questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail) return [
                        {
                            key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).InvalidEmail,
                            message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).InvalidEmail])
                        }
                    ];
                    if (requirements.rgx.m) return [
                        {
                            key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexCustomMsg,
                            message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexCustomMsg], {
                                values: {
                                    message: requirements.rgx.m
                                }
                            }))
                        }
                    ];
                    return [
                        {
                            key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexDefaultMsg,
                            message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexDefaultMsg])
                        }
                    ];
                }
            } catch  {
                console.log(`Invalid regex: ${requirements.rgx.p}`);
                return [
                    {
                        key: (0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexInvalidMsg,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).TextValidationErrorMsg).RegexInvalidMsg])
                    }
                ];
            }
        }
    };
    const $9b25d012193ba90d$export$26fbcce145c8b4e4 = (requirements, value)=>{
        if (value.length > 0 && !((0, ($parcel$interopDefault($8ELPZ)))(value) || (0, ($parcel$interopDefault($fd9ep)))(value))) return [
            {
                key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).InvalidNum,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).InvalidNum])
            }
        ];
        const cleanNumber = value.replace(/[\,]/g, '');
        const number = parseFloat(cleanNumber);
        if (!value.length) {
            if (requirements.rq && value.length === 0) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
                }
            ];
        } else {
            if (isNaN(number)) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).InvalidNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).InvalidNum])
                }
            ];
            if (requirements.wh && !Number.isInteger(number)) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).WholeNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).WholeNum])
                }
            ];
            if (requirements.mnn && requirements.mnn === requirements.mxn && number !== requirements.mnn) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).ExactNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).ExactNum], {
                        values: {
                            mnn: requirements.mnn
                        }
                    }))
                }
            ];
            if (requirements.mnn && requirements.mxn && (number < requirements.mnn || number > requirements.mxn)) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).BetweenNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).BetweenNum], {
                        values: {
                            mnn: requirements.mnn,
                            mxn: requirements.mxn
                        }
                    }))
                }
            ];
            if (requirements.mnn && number < requirements.mnn) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).MinNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).MinNum], {
                        values: {
                            mnn: requirements.mnn
                        }
                    }))
                }
            ];
            if (requirements.mxn && number > requirements.mxn) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).MaxNum,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).NumberValidationErrorMsg).MaxNum], {
                        values: {
                            mxn: requirements.mxn
                        }
                    }))
                }
            ];
        }
    };
    const $9b25d012193ba90d$export$8d4b85d34923a80b = (requirements, dateValue)=>{
        let minDate;
        let maxDate;
        let enteredDate;
        if (requirements.mnd) minDate = new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mnd));
        if (requirements.mxd) maxDate = new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mxd));
        const hasExactDateRequirements = requirements.mnd && requirements.mnd === requirements.mxd;
        const hasBetweenDateRequirements = !!requirements.mnd && !!requirements.mxd;
        if (!dateValue && requirements.rq) return [
            {
                key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
            }
        ];
        else {
            enteredDate = new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(dateValue));
            const validationErrors = [];
            if (hasExactDateRequirements && minDate) {
                if (enteredDate.valueOf() !== minDate.valueOf()) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactDate,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactDate], {
                        values: {
                            mnd: minDate
                        }
                    }))
                });
            } else if (hasBetweenDateRequirements && minDate && maxDate) {
                if (enteredDate < minDate || enteredDate > maxDate) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenDate,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenDate], {
                        values: {
                            mnd: minDate,
                            mxd: maxDate
                        }
                    }))
                });
            } else {
                if (requirements.mnd && minDate) {
                    if (enteredDate < minDate) validationErrors.push({
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinDate,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinDate], {
                            values: {
                                mnd: minDate
                            }
                        }))
                    });
                }
                if (requirements.mxd && maxDate) {
                    if (enteredDate > maxDate) validationErrors.push({
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxDate,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxDate], {
                            values: {
                                mxd: maxDate
                            }
                        }))
                    });
                }
            }
            if (validationErrors.length > 0) return validationErrors;
        }
    };
    const $9b25d012193ba90d$export$a226e2ebf33a3dd5 = (requirements, timeValue)=>{
        if (!timeValue && requirements.rq) return [
            {
                key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
            }
        ];
        else if (!!timeValue) {
            const time = new Date(`01/01/1999 ${timeValue}`);
            const validationErrors = [];
            if (isNaN(time.getTime())) validationErrors.push({
                key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).InvalidTime,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).InvalidTime])
            });
            else if (requirements.mnt && requirements.mnt === requirements.mxt) {
                const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
                if (time.getTime() !== minTime.getTime()) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactTime,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactTime], {
                        values: {
                            mnt: minTime
                        }
                    }))
                });
            } else if (requirements.mnt && requirements.mxt) {
                const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
                const maxTime = new Date(`01/01/1999 ${requirements.mxt}`);
                if (time < minTime || time > maxTime) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenTime,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenTime], {
                        values: {
                            mnt: minTime,
                            mxt: maxTime
                        }
                    }))
                });
            } else {
                if (requirements.mnt) {
                    const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
                    if (time < minTime) validationErrors.push({
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinTime,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinTime], {
                            values: {
                                mnt: minTime
                            }
                        }))
                    });
                }
                if (requirements.mxt) {
                    const maxTime = new Date(`01/01/1999 ${requirements.mxt}`);
                    if (time > maxTime) validationErrors.push({
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxTime,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxTime], {
                            values: {
                                mxt: maxTime
                            }
                        }))
                    });
                }
            }
            if (validationErrors.length > 0) return validationErrors;
        }
    };
    const $9b25d012193ba90d$export$1ff6abd4f0e07282 = (requirements, dateTime)=>{
        let minDateTime;
        let maxDateTime;
        let enteredDateTime;
        if (requirements.mnd && requirements.mnt) minDateTime = new Date(`${(0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mnd)} ${requirements.mnt}`);
        if (requirements.mxd && requirements.mxt) maxDateTime = new Date(`${(0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mxd)} ${requirements.mxt}`);
        if (dateTime.date) enteredDateTime = new Date(`${(0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(dateTime.date)} ${dateTime.time}`);
        const hasMinDateTimeRequirements = !!requirements.mnd && !!requirements.mnt;
        const hasMaxDateTimeRequirements = !!requirements.mxd && !!requirements.mxt;
        const hasExactDateTimeRequirements = hasMinDateTimeRequirements && requirements.mnd === requirements.mxd && requirements.mnt === requirements.mxt;
        const hasBetweenDateTimeRequirements = hasMinDateTimeRequirements && hasMaxDateTimeRequirements;
        if (requirements.rq && (!dateTime.date || !dateTime.time)) return [
            {
                key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).RequiredDateTime,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).RequiredDateTime])
            }
        ];
        if (hasExactDateTimeRequirements && minDateTime && enteredDateTime) {
            if (enteredDateTime.valueOf() !== minDateTime.valueOf()) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactDateTime,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).ExactDateTime], {
                        values: {
                            mnd: new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mnd || '')),
                            mnt: new Date(`01/01/1999 ${requirements.mnt}`)
                        }
                    }))
                }
            ];
        } else if (hasBetweenDateTimeRequirements && minDateTime && maxDateTime && enteredDateTime) {
            if (enteredDateTime < minDateTime || enteredDateTime > maxDateTime) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenDateTime,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).BetweenDateTime], {
                        values: {
                            mnd: new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mnd || '')),
                            mnt: new Date(`01/01/1999 ${requirements.mnt}`),
                            mxd: new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mxd || '')),
                            mxt: new Date(`01/01/1999 ${requirements.mxt}`)
                        }
                    }))
                }
            ];
        } else if (hasMinDateTimeRequirements || hasMaxDateTimeRequirements) {
            if (hasMinDateTimeRequirements && minDateTime && enteredDateTime) {
                if (enteredDateTime < minDateTime) return [
                    {
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinDateTime,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MinDateTime], {
                            values: {
                                mnd: new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mnd || '')),
                                mnt: new Date(`01/01/1999 ${requirements.mnt}`)
                            }
                        }))
                    }
                ];
            }
            if (hasMaxDateTimeRequirements && enteredDateTime && maxDateTime) {
                if (enteredDateTime > maxDateTime) return [
                    {
                        key: (0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxDateTime,
                        message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).DateTimeValidationErrorMsg).MaxDateTime], {
                            values: {
                                mxd: new Date((0, (0, parcelRequire("cnwtr")).convertDateFormatToSlashes)(requirements.mxd || '')),
                                mxt: new Date(`01/01/1999 ${requirements.mxt}`)
                            }
                        }))
                    }
                ];
            }
        } else {
            const validationErrors = [];
            const dateValidationErrors = $9b25d012193ba90d$export$8d4b85d34923a80b(requirements, dateTime.date);
            if (dateValidationErrors) validationErrors.push(...dateValidationErrors);
            const timeValidationErrors = $9b25d012193ba90d$export$a226e2ebf33a3dd5(requirements, dateTime.time);
            if (timeValidationErrors) validationErrors.push(...timeValidationErrors);
            if (validationErrors.length > 0) return validationErrors;
        }
    };
    const $9b25d012193ba90d$var$choiceIsSelected = (selectedChoices, choiceId)=>{
        return selectedChoices.includes(choiceId) || selectedChoices.map((id)=>id.split(':')[0]).includes(choiceId.toString()) && (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields');
    };
    const $9b25d012193ba90d$export$9ec08da1d33bbc5e = (requirements, choices, choiceAnswers, asyncRequiredChoice)=>{
        const numChoicesSelected = choiceAnswers.choices.length;
        if (requirements.rq) {
            if (numChoicesSelected === 0) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
                }
            ];
        }
        const validationErrors = [];
        if (numChoicesSelected !== 0) {
            if (requirements.mns && requirements.mns === requirements.mxs) {
                if (numChoicesSelected !== requirements.mns) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).ExactChoices,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).ExactChoices], {
                        values: {
                            mns: requirements.mns
                        }
                    }))
                });
            } else if (requirements.mns && requirements.mxs) {
                if (numChoicesSelected < requirements.mns || numChoicesSelected > requirements.mxs) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).BetweenChoices,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).BetweenChoices], {
                        values: {
                            mns: requirements.mns,
                            mxs: requirements.mxs
                        }
                    }))
                });
            } else {
                if (requirements.mns && numChoicesSelected < requirements.mns) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).MinChoices,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).MinChoices], {
                        values: {
                            mns: requirements.mns
                        }
                    }))
                });
                if (requirements.mxs && numChoicesSelected > requirements.mxs) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).MaxChoices,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).MaxChoices], {
                        values: {
                            mxs: requirements.mxs
                        }
                    }))
                });
            }
            if (requirements.ch) {
                var _requiredChoice$child;
                const requiredChoice = asyncRequiredChoice !== null && asyncRequiredChoice !== void 0 ? asyncRequiredChoice : choices.find((choice)=>choice.id === requirements.ch || requirements.ch && choice.id === requirements.ch.split(':')[0] && (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields'));
                const requiredChildChoice = (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields') ? requiredChoice === null || requiredChoice === void 0 ? void 0 : (_requiredChoice$child = requiredChoice.children) === null || _requiredChoice$child === void 0 ? void 0 : _requiredChoice$child.find((child)=>{
                    var _requirements$ch;
                    return child.id === ((_requirements$ch = requirements.ch) === null || _requirements$ch === void 0 ? void 0 : _requirements$ch.split(':')[1]);
                }) : undefined;
                if (requiredChoice && !$9b25d012193ba90d$var$choiceIsSelected(choiceAnswers.choices, requirements.ch) && (!requirements.ch.includes(':') || requiredChildChoice)) validationErrors.push({
                    key: (0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).ReqChoice,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ChoiceValidationErrorMsg).ReqChoice], {
                        values: {
                            label: requiredChildChoice && (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields') ? `${requiredChoice.label} - ${requiredChildChoice.label}` : requiredChoice.label
                        }
                    }))
                });
            }
        }
        if (validationErrors.length > 0) return validationErrors;
    };
    const $9b25d012193ba90d$export$6f9eb7b39b2f37de = (requirements, userPickerAnswers)=>{
        const numChoicesSelected = userPickerAnswers.length;
        if (requirements.rq) {
            if (numChoicesSelected === 0) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
                }
            ];
        }
        const validationErrors = [];
        if (requirements.mns && requirements.mns === requirements.mxs) {
            if (numChoicesSelected !== requirements.mns) validationErrors.push({
                key: (0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).ExactChoices,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).ExactChoices], {
                    values: {
                        mns: requirements.mns
                    }
                }))
            });
        } else if (requirements.mns && requirements.mxs) {
            if (numChoicesSelected < requirements.mns || numChoicesSelected > requirements.mxs) validationErrors.push({
                key: (0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).BetweenChoices,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).BetweenChoices], {
                    values: {
                        mns: requirements.mns,
                        mxs: requirements.mxs
                    }
                }))
            });
        } else {
            if (requirements.mns && numChoicesSelected < requirements.mns) validationErrors.push({
                key: (0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).MinChoices,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).MinChoices], {
                    values: {
                        mns: requirements.mns
                    }
                }))
            });
            if (requirements.mxs && numChoicesSelected > requirements.mxs) validationErrors.push({
                key: (0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).MaxChoices,
                message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).UserPickerValidationErrorMsg).MaxChoices], {
                    values: {
                        mxs: requirements.mxs
                    }
                }))
            });
        }
        if (validationErrors.length > 0) return validationErrors;
    };
    const $9b25d012193ba90d$export$1375a2241da0cd1 = (requirements, files, questionType)=>{
        if (requirements.rq && questionType === 'at') {
            if (files.length === 0) return [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required,
                    message: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6lxfx")).IntlValidationErrorMessages)[(0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).Required])
                }
            ];
        }
    };
});
parcelRegister("fd9ep", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b12f3b12c8b53ed3$var$isDecimal;
    var $iRYdY = parcelRequire("iRYdY");
    var $b12f3b12c8b53ed3$var$_merge2 = $b12f3b12c8b53ed3$var$_interopRequireDefault($iRYdY);
    var $7oCN8 = parcelRequire("7oCN8");
    var $b12f3b12c8b53ed3$var$_assertString2 = $b12f3b12c8b53ed3$var$_interopRequireDefault($7oCN8);
    var $hTHDP = parcelRequire("hTHDP");
    function $b12f3b12c8b53ed3$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b12f3b12c8b53ed3$var$decimalRegExp(options) {
        var regExp = new RegExp('^[-+]?([0-9]+)?(\\' + $hTHDP.decimal[options.locale] + '[0-9]{' + options.decimal_digits + '})' + (options.force_decimal ? '' : '?') + '$');
        return regExp;
    }
    var $b12f3b12c8b53ed3$var$default_decimal_options = {
        force_decimal: false,
        decimal_digits: '1,',
        locale: 'en-US'
    };
    var $b12f3b12c8b53ed3$var$blacklist = [
        '',
        '-',
        '+'
    ];
    function $b12f3b12c8b53ed3$var$isDecimal(str, options) {
        (0, $b12f3b12c8b53ed3$var$_assertString2.default)(str);
        options = (0, $b12f3b12c8b53ed3$var$_merge2.default)(options, $b12f3b12c8b53ed3$var$default_decimal_options);
        if (options.locale in $hTHDP.decimal) return !$b12f3b12c8b53ed3$var$blacklist.includes(str.replace(/ /g, '')) && $b12f3b12c8b53ed3$var$decimalRegExp(options).test(str);
        throw new Error('Invalid locale \'' + options.locale + '\'');
    }
    module.exports = module.exports['default'];
});
parcelRegister("iRYdY", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $dbcbe48af9e82c0e$var$merge;
    function $dbcbe48af9e82c0e$var$merge() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var defaults = arguments[1];
        for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
        return obj;
    }
    module.exports = module.exports['default'];
});
parcelRegister("7oCN8", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $5628dd7c3b681d30$var$assertString;
    function $5628dd7c3b681d30$var$assertString(input) {
        var isString = typeof input === 'string' || input instanceof String;
        if (!isString) throw new TypeError('This library (validator.js) validates strings only');
    }
    module.exports = module.exports['default'];
});
parcelRegister("hTHDP", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $d0796d009721feb4$var$alpha = module.exports.alpha = {
        'en-US': /^[A-Z]+$/i,
        'bg-BG': /^[А-Я]+$/i,
        'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
        'da-DK': /^[A-ZÆØÅ]+$/i,
        'de-DE': /^[A-ZÄÖÜß]+$/i,
        'el-GR': /^[Α-ω]+$/i,
        'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
        'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
        'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
        'nb-NO': /^[A-ZÆØÅ]+$/i,
        'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
        'nn-NO': /^[A-ZÆØÅ]+$/i,
        'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
        'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
        'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
        'ru-RU': /^[А-ЯЁ]+$/i,
        'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
        'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
        'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
        'sv-SE': /^[A-ZÅÄÖ]+$/i,
        'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
        'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
        ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
    };
    var $d0796d009721feb4$var$alphanumeric = module.exports.alphanumeric = {
        'en-US': /^[0-9A-Z]+$/i,
        'bg-BG': /^[0-9А-Я]+$/i,
        'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
        'da-DK': /^[0-9A-ZÆØÅ]+$/i,
        'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
        'el-GR': /^[0-9Α-ω]+$/i,
        'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
        'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
        'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
        'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
        'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
        'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
        'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
        'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
        'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
        'ru-RU': /^[0-9А-ЯЁ]+$/i,
        'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
        'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
        'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
        'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
        'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
        'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
        ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
    };
    var $d0796d009721feb4$var$decimal = module.exports.decimal = {
        'en-US': '.',
        ar: "\u066B"
    };
    var $d0796d009721feb4$var$englishLocales = module.exports.englishLocales = [
        'AU',
        'GB',
        'HK',
        'IN',
        'NZ',
        'ZA',
        'ZM'
    ];
    for(var $d0796d009721feb4$var$locale, $d0796d009721feb4$var$i = 0; $d0796d009721feb4$var$i < $d0796d009721feb4$var$englishLocales.length; $d0796d009721feb4$var$i++){
        $d0796d009721feb4$var$locale = 'en-' + $d0796d009721feb4$var$englishLocales[$d0796d009721feb4$var$i];
        $d0796d009721feb4$var$alpha[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$alpha['en-US'];
        $d0796d009721feb4$var$alphanumeric[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$alphanumeric['en-US'];
        $d0796d009721feb4$var$decimal[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$decimal['en-US'];
    }
    var $d0796d009721feb4$var$arabicLocales = module.exports.arabicLocales = [
        'AE',
        'BH',
        'DZ',
        'EG',
        'IQ',
        'JO',
        'KW',
        'LB',
        'LY',
        'MA',
        'QM',
        'QA',
        'SA',
        'SD',
        'SY',
        'TN',
        'YE'
    ];
    for(var $d0796d009721feb4$var$_locale, $d0796d009721feb4$var$_i = 0; $d0796d009721feb4$var$_i < $d0796d009721feb4$var$arabicLocales.length; $d0796d009721feb4$var$_i++){
        $d0796d009721feb4$var$_locale = 'ar-' + $d0796d009721feb4$var$arabicLocales[$d0796d009721feb4$var$_i];
        $d0796d009721feb4$var$alpha[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$alpha.ar;
        $d0796d009721feb4$var$alphanumeric[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$alphanumeric.ar;
        $d0796d009721feb4$var$decimal[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$decimal.ar;
    }
    var $d0796d009721feb4$var$dotDecimal = module.exports.dotDecimal = [];
    var $d0796d009721feb4$var$commaDecimal = module.exports.commaDecimal = [
        'bg-BG',
        'cs-CZ',
        'da-DK',
        'de-DE',
        'el-GR',
        'es-ES',
        'fr-FR',
        'it-IT',
        'hu-HU',
        'nb-NO',
        'nn-NO',
        'nl-NL',
        'pl-Pl',
        'pt-PT',
        'ru-RU',
        'sr-RS@latin',
        'sr-RS',
        'sv-SE',
        'tr-TR',
        'uk-UA'
    ];
    for(var $d0796d009721feb4$var$_i2 = 0; $d0796d009721feb4$var$_i2 < $d0796d009721feb4$var$dotDecimal.length; $d0796d009721feb4$var$_i2++)$d0796d009721feb4$var$decimal[$d0796d009721feb4$var$dotDecimal[$d0796d009721feb4$var$_i2]] = $d0796d009721feb4$var$decimal['en-US'];
    for(var $d0796d009721feb4$var$_i3 = 0; $d0796d009721feb4$var$_i3 < $d0796d009721feb4$var$commaDecimal.length; $d0796d009721feb4$var$_i3++)$d0796d009721feb4$var$decimal[$d0796d009721feb4$var$commaDecimal[$d0796d009721feb4$var$_i3]] = ',';
    $d0796d009721feb4$var$alpha['pt-BR'] = $d0796d009721feb4$var$alpha['pt-PT'];
    $d0796d009721feb4$var$alphanumeric['pt-BR'] = $d0796d009721feb4$var$alphanumeric['pt-PT'];
    $d0796d009721feb4$var$decimal['pt-BR'] = $d0796d009721feb4$var$decimal['pt-PT'];
});
parcelRegister("8ELPZ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $64d72ab15b72a9b7$var$isNumeric;
    var $7oCN8 = parcelRequire("7oCN8");
    var $64d72ab15b72a9b7$var$_assertString2 = $64d72ab15b72a9b7$var$_interopRequireDefault($7oCN8);
    function $64d72ab15b72a9b7$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $64d72ab15b72a9b7$var$numeric = /^[-+]?[0-9]+$/;
    function $64d72ab15b72a9b7$var$isNumeric(str) {
        (0, $64d72ab15b72a9b7$var$_assertString2.default)(str);
        return $64d72ab15b72a9b7$var$numeric.test(str);
    }
    module.exports = module.exports['default'];
});
parcelRegister("hYNZx", function(module, exports) {
    $parcel$export(module.exports, "SchemaStage", ()=>$c960adc5c7547145$export$933e6445c497ffd5);
    $parcel$export(module.exports, "JSONTransformer", ()=>$c960adc5c7547145$export$98cb1d9308d0944d);
    var $ajpes = parcelRequire("ajpes");
    var $8vlrc;
    var $cUwVZ;
    var $7kC9H;
    var $29Vii;
    var $8XeG6;
    var $bIGZ7;
    var $7agO8;
    var $g7Cky;
    var $9UDEr;
    var $kOFhM;
    var $fVI2q;
    var $0Cgjx;
    var $c960adc5c7547145$export$933e6445c497ffd5;
    (function(SchemaStage) {
        SchemaStage["FINAL"] = "final";
        SchemaStage["STAGE_0"] = "stage0";
    })($c960adc5c7547145$export$933e6445c497ffd5 || ($c960adc5c7547145$export$933e6445c497ffd5 = {}));
    const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
    const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
    const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
    const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
    const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
    const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
    const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
    const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
    const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
    const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
    const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
    const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
    const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
    const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
    const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
    const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
    const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
    const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
    const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
    const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
    const $c960adc5c7547145$var$filterNull = (subject)=>{
        let output = {
            ...subject
        };
        for(const key in output){
            const current = output[key];
            if (current === null) {
                const { [key]: unusedKey, ...filteredObj } = output;
                output = filteredObj;
            } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
        }
        return output;
    };
    const $c960adc5c7547145$var$createDocFromContent = (content)=>{
        return {
            version: 1,
            type: 'doc',
            content: content || []
        };
    };
    const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
        {
            type: 'paragraph',
            content: []
        }
    ]);
    const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
        const obj = {
            type: node.type.name
        };
        if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
        else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, (0, parcelRequire("bIGZ7")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, (0, parcelRequire("g7Cky")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, (0, parcelRequire("8vlrc")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).tableToJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableCell)(node).attrs;
        else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableHeader)(node).attrs;
        else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, (0, parcelRequire("7kC9H")).toJSON)(node).attrs;
        else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
        if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
        if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
            const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
            const text = obj.attrs?.text ?? '';
            obj.attrs = {
                ...obj.attrs,
                text: !!text ? text : name
            };
        }
        if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
        if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
        if (node.isText) obj.text = node.textContent;
        else node.content.forEach((child)=>{
            obj.content = obj.content || [];
            obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
        });
        if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
        if (node.marks.length) {
            const parsedMarks = node.marks.map((mark)=>{
                if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
                else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
                else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, (0, parcelRequire("8XeG6")).toJSON)(mark);
                else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                    const serialised = (0, (0, parcelRequire("cUwVZ")).toJSON)(mark);
                    return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
                } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                    const fragmentMark = (0, (0, parcelRequire("29Vii")).toJSON)(mark);
                    if (!fragmentMark.attrs.localId) return null;
                    return fragmentMark;
                } else return mark.toJSON();
            }).filter((maybeMark)=>maybeMark !== null);
            obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
            const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
            if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
                ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
            };
        }
        return obj;
    };
    const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
        if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, (0, parcelRequire("fVI2q")).markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
        return false;
    };
    const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
        const nodeAttributes = node.type.spec.attrs;
        const attributes = {
            ...mark.attrs.unsupported,
            ...obj.attrs
        };
        for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
            const attribute = nodeAttributes ? nodeAttributes[key] : null;
            if (attribute) {
                if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                    ...attributes,
                    [key]: mark.attrs.unsupported[key]
                };
            }
        }
        return attributes;
    };
    class $c960adc5c7547145$export$98cb1d9308d0944d {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), mentionMap){
            this.schema = schema;
            this.mentionMap = mentionMap;
        }
        encode(node) {
            const content = [];
            node.content.forEach((child)=>{
                content.push((0, (0, parcelRequire("0Cgjx")).sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
            });
            if (!content || (0, ($parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
            return $c960adc5c7547145$var$createDocFromContent(content);
        }
        internalParse(content, schema) {
            const doc = schema.nodeFromJSON(content);
            doc.check();
            return doc;
        }
        parse(content, stage) {
            if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
            const schema = !!stage ? (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(stage) : this.schema;
            if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
            return this.internalParse(content, schema);
        }
        encodeNode(node) {
            return (0, (0, parcelRequire("0Cgjx")).sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
        }
    }
});
parcelRegister("8vlrc", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$6311d90c8f0b12c7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "toJSON", ()=>$6311d90c8f0b12c7$export$54fd2c36b5cc6731);
    var $kCV8T;
    var $gthjq;
    const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
        return dom.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
        if (dom && dom.classList.contains('codehilite')) return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
        return;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
        const firstChild = dom.firstElementChild;
        if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
        const languageRegex = /(?:^|\s)language-([^\s]+)/;
        const result = languageRegex.exec(className);
        if (result && result[1]) return result[1];
        return;
    };
    const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
        const parent = dom && dom.parentElement;
        if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
        return dom;
    };
    function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
        let code = '';
        node.childNodes.forEach((child)=>{
            if (child.nodeType === Node.TEXT_NODE) code += child.nodeValue;
            else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
                const tagName = child.tagName.toLowerCase();
                if (tagName === 'div' || tagName === 'p') {
                    if (child.previousElementSibling !== null) code += '\n';
                }
                if (tagName === 'br') code += '\n';
                else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
            }
        });
        return code;
    }
    const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("gthjq")).codeBlock)({
        parseDOM: [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    let dom = domNode;
                    const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                    dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                    return {
                        language: language
                    };
                }
            },
            {
                tag: 'div[style]',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                    return false;
                },
                getContent: (domNode, schema)=>{
                    const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                    return code ? (0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(code)) : (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                }
            },
            {
                tag: 'table[style]',
                preserveWhitespace: 'full',
                getAttrs: (dom)=>{
                    if (dom.querySelector('td[class*="blob-code"]')) return {};
                    return false;
                }
            },
            {
                tag: 'div.code-block',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                    if (lineNumber.length > 0) lineNumber.forEach((line)=>line.remove());
                    return {};
                }
            }
        ],
        toDOM (node) {
            return [
                'pre',
                [
                    'code',
                    {
                        'data-language': node.attrs.language
                    },
                    0
                ]
            ];
        }
    });
    const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((memo, key)=>{
                if (key === 'uniqueId') return memo;
                if (key === 'language' && node.attrs.language === null) return memo;
                memo[key] = node.attrs[key];
                return memo;
            }, {})
        });
});
parcelRegister("kCV8T", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$f043ae92c0a873f0$export$ffb0004e005737fa);
    $parcel$export(module.exports, "Mark", ()=>$f043ae92c0a873f0$export$c9d15bcfc6d42044);
    $parcel$export(module.exports, "ReplaceError", ()=>$f043ae92c0a873f0$export$6de0e778727af3f2);
    $parcel$export(module.exports, "Slice", ()=>$f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
    $parcel$export(module.exports, "ResolvedPos", ()=>$f043ae92c0a873f0$export$b2a42f82e59e4b19);
    $parcel$export(module.exports, "NodeRange", ()=>$f043ae92c0a873f0$export$7bc461ceb770fb16);
    $parcel$export(module.exports, "Node", ()=>$f043ae92c0a873f0$export$85c928794f8d04d4);
    $parcel$export(module.exports, "MarkType", ()=>$f043ae92c0a873f0$export$b6a78689043c6521);
    $parcel$export(module.exports, "Schema", ()=>$f043ae92c0a873f0$export$19342e026b58ebb7);
    $parcel$export(module.exports, "DOMParser", ()=>$f043ae92c0a873f0$export$1059c6e7d2ce5669);
    $parcel$export(module.exports, "DOMSerializer", ()=>$f043ae92c0a873f0$export$3476b78f8f5a8b72);
    var $dHeNB;
    function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
        for(let i = 0;; i++){
            if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
            let childA = a.child(i), childB = b.child(i);
            if (childA == childB) {
                pos += childA.nodeSize;
                continue;
            }
            if (!childA.sameMarkup(childB)) return pos;
            if (childA.isText && childA.text != childB.text) {
                for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
                return pos;
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
                if (inner != null) return inner;
            }
            pos += childA.nodeSize;
        }
    }
    function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
        for(let iA = a.childCount, iB = b.childCount;;){
            if (iA == 0 || iB == 0) return iA == iB ? null : {
                a: posA,
                b: posB
            };
            let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
            if (childA == childB) {
                posA -= size;
                posB -= size;
                continue;
            }
            if (!childA.sameMarkup(childB)) return {
                a: posA,
                b: posB
            };
            if (childA.isText && childA.text != childB.text) {
                let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
                while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                    same++;
                    posA--;
                    posB--;
                }
                return {
                    a: posA,
                    b: posB
                };
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
                if (inner) return inner;
            }
            posA -= size;
            posB -= size;
        }
    }
    class $f043ae92c0a873f0$export$ffb0004e005737fa {
        constructor(content, size){
            this.content = content;
            this.size = size || 0;
            if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
        }
        nodesBetween(from, to, f, nodeStart = 0, parent) {
            for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                    let start = pos + 1;
                    child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
                }
                pos = end;
            }
        }
        descendants(f) {
            this.nodesBetween(0, this.size, f);
        }
        textBetween(from, to, blockSeparator, leafText) {
            let text = "", first = true;
            this.nodesBetween(from, to, (node, pos)=>{
                let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
                if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                    if (first) first = false;
                    else text += blockSeparator;
                }
                text += nodeText;
            }, 0);
            return text;
        }
        append(other) {
            if (!other.size) return this;
            if (!this.size) return other;
            let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
            if (last.isText && last.sameMarkup(first)) {
                content[content.length - 1] = last.withText(last.text + first.text);
                i = 1;
            }
            for(; i < other.content.length; i++)content.push(other.content[i]);
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
        }
        cut(from, to = this.size) {
            if (from == 0 && to == this.size) return this;
            let result = [], size = 0;
            if (to > from) for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
        }
        cutByIndex(from, to) {
            if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (from == 0 && to == this.content.length) return this;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
        }
        replaceChild(index, node) {
            let current = this.content[index];
            if (current == node) return this;
            let copy = this.content.slice();
            let size = this.size + node.nodeSize - current.nodeSize;
            copy[index] = node;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
        }
        addToStart(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                node
            ].concat(this.content), this.size + node.nodeSize);
        }
        addToEnd(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
        }
        eq(other) {
            if (this.content.length != other.content.length) return false;
            for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
            return true;
        }
        get firstChild() {
            return this.content.length ? this.content[0] : null;
        }
        get lastChild() {
            return this.content.length ? this.content[this.content.length - 1] : null;
        }
        get childCount() {
            return this.content.length;
        }
        child(index) {
            let found = this.content[index];
            if (!found) throw new RangeError("Index " + index + " out of range for " + this);
            return found;
        }
        maybeChild(index) {
            return this.content[index] || null;
        }
        forEach(f) {
            for(let i = 0, p = 0; i < this.content.length; i++){
                let child = this.content[i];
                f(child, p, i);
                p += child.nodeSize;
            }
        }
        findDiffStart(other, pos = 0) {
            return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
        }
        findDiffEnd(other, pos = this.size, otherPos = other.size) {
            return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
        }
        findIndex(pos, round = -1) {
            if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
            if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
            if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
            for(let i = 0, curPos = 0;; i++){
                let cur = this.child(i), end = curPos + cur.nodeSize;
                if (end >= pos) {
                    if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                    return $f043ae92c0a873f0$var$retIndex(i, curPos);
                }
                curPos = end;
            }
        }
        toString() {
            return "<" + this.toStringInner() + ">";
        }
        toStringInner() {
            return this.content.join(", ");
        }
        toJSON() {
            return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
        }
        static fromJSON(schema, value) {
            if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
        }
        static fromArray(array) {
            if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            let joined, size = 0;
            for(let i = 0; i < array.length; i++){
                let node = array[i];
                size += node.nodeSize;
                if (i && node.isText && array[i - 1].sameMarkup(node)) {
                    if (!joined) joined = array.slice(0, i);
                    joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
                } else if (joined) joined.push(node);
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
        }
        static from(nodes) {
            if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
            if (Array.isArray(nodes)) return this.fromArray(nodes);
            if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                nodes
            ], nodes.nodeSize);
            throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
        }
    }
    $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
    const $f043ae92c0a873f0$var$found = {
        index: 0,
        offset: 0
    };
    function $f043ae92c0a873f0$var$retIndex(index, offset) {
        $f043ae92c0a873f0$var$found.index = index;
        $f043ae92c0a873f0$var$found.offset = offset;
        return $f043ae92c0a873f0$var$found;
    }
    function $f043ae92c0a873f0$var$compareDeep(a, b) {
        if (a === b) return true;
        if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
        let array = Array.isArray(a);
        if (Array.isArray(b) != array) return false;
        if (array) {
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
        } else {
            for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
            for(let p in b)if (!(p in a)) return false;
        }
        return true;
    }
    class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
        constructor(type, attrs){
            this.type = type;
            this.attrs = attrs;
        }
        addToSet(set) {
            let copy, placed = false;
            for(let i = 0; i < set.length; i++){
                let other = set[i];
                if (this.eq(other)) return set;
                if (this.type.excludes(other.type)) {
                    if (!copy) copy = set.slice(0, i);
                } else if (other.type.excludes(this.type)) return set;
                else {
                    if (!placed && other.type.rank > this.type.rank) {
                        if (!copy) copy = set.slice(0, i);
                        copy.push(this);
                        placed = true;
                    }
                    if (copy) copy.push(other);
                }
            }
            if (!copy) copy = set.slice();
            if (!placed) copy.push(this);
            return copy;
        }
        removeFromSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
            return false;
        }
        eq(other) {
            return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
            let type = schema.marks[json.type];
            if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
            let mark = type.create(json.attrs);
            type.checkAttrs(mark.attrs);
            return mark;
        }
        static sameSet(a, b) {
            if (a == b) return true;
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
            return true;
        }
        static setFrom(marks) {
            if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
                marks
            ];
            let copy = marks.slice();
            copy.sort((a, b)=>a.type.rank - b.type.rank);
            return copy;
        }
    }
    $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
    class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
    }
    class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
        constructor(content, openStart, openEnd){
            this.content = content;
            this.openStart = openStart;
            this.openEnd = openEnd;
        }
        get size() {
            return this.content.size - this.openStart - this.openEnd;
        }
        insertAt(pos, fragment) {
            let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
            return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
        }
        removeBetween(from, to) {
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
        }
        eq(other) {
            return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
        }
        toString() {
            return this.content + "(" + this.openStart + "," + this.openEnd + ")";
        }
        toJSON() {
            if (!this.content.size) return null;
            let json = {
                content: this.content.toJSON()
            };
            if (this.openStart > 0) json.openStart = this.openStart;
            if (this.openEnd > 0) json.openEnd = this.openEnd;
            return json;
        }
        static fromJSON(schema, json) {
            if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
            if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
        }
        static maxOpen(fragment, openIsolating = true) {
            let openStart = 0, openEnd = 0;
            for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
            for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
        }
    }
    $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
    function $f043ae92c0a873f0$var$removeRange(content, from, to) {
        let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
        let { index: indexTo, offset: offsetTo } = content.findIndex(to);
        if (offset == from || child.isText) {
            if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
            return content.cut(0, from).append(content.cut(to));
        }
        if (index != indexTo) throw new RangeError("Removing non-flat range");
        return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
    }
    function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
        let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
        if (offset == dist || child.isText) {
            if (parent && !parent.canReplace(index, index, insert)) return null;
            return content.cut(0, dist).append(insert).append(content.cut(dist));
        }
        let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
        return inner && content.replaceChild(index, child.copy(inner));
    }
    function $f043ae92c0a873f0$var$replace($from, $to, slice) {
        if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
        if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
        return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
    }
    function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
        let index = $from.index(depth), node = $from.node(depth);
        if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
            let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
            return node.copy(node.content.replaceChild(index, inner));
        } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
        else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
            let parent = $from.parent, content = parent.content;
            return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
        } else {
            let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
            return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
        }
    }
    function $f043ae92c0a873f0$var$checkJoin(main, sub) {
        if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
    }
    function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
        let node = $before.node(depth);
        $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
        return node;
    }
    function $f043ae92c0a873f0$var$addNode(child, target) {
        let last = target.length - 1;
        if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
        else target.push(child);
    }
    function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
        let node = ($end || $start).node(depth);
        let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
        if ($start) {
            startIndex = $start.index(depth);
            if ($start.depth > depth) startIndex++;
            else if ($start.textOffset) {
                $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
                startIndex++;
            }
        }
        for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
        if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
    }
    function $f043ae92c0a873f0$var$close(node, content) {
        node.type.checkContent(content);
        return node.copy(content);
    }
    function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
        let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
        let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
            $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
        } else {
            if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
            $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
            if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if ($from.depth > depth) {
            let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
        let extra = $along.depth - slice.openStart, parent = $along.node(extra);
        let node = parent.copy(slice.content);
        for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
        return {
            start: node.resolveNoCache(slice.openStart + extra),
            end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
        };
    }
    class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
        constructor(pos, path, parentOffset){
            this.pos = pos;
            this.path = path;
            this.parentOffset = parentOffset;
            this.depth = path.length / 3 - 1;
        }
        resolveDepth(val) {
            if (val == null) return this.depth;
            if (val < 0) return this.depth + val;
            return val;
        }
        get parent() {
            return this.node(this.depth);
        }
        get doc() {
            return this.node(0);
        }
        node(depth) {
            return this.path[this.resolveDepth(depth) * 3];
        }
        index(depth) {
            return this.path[this.resolveDepth(depth) * 3 + 1];
        }
        indexAfter(depth) {
            depth = this.resolveDepth(depth);
            return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
        }
        start(depth) {
            depth = this.resolveDepth(depth);
            return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        }
        end(depth) {
            depth = this.resolveDepth(depth);
            return this.start(depth) + this.node(depth).content.size;
        }
        before(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position before the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
        }
        after(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position after the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
        }
        get textOffset() {
            return this.pos - this.path[this.path.length - 1];
        }
        get nodeAfter() {
            let parent = this.parent, index = this.index(this.depth);
            if (index == parent.childCount) return null;
            let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
            return dOff ? parent.child(index).cut(dOff) : child;
        }
        get nodeBefore() {
            let index = this.index(this.depth);
            let dOff = this.pos - this.path[this.path.length - 1];
            if (dOff) return this.parent.child(index).cut(0, dOff);
            return index == 0 ? null : this.parent.child(index - 1);
        }
        posAtIndex(index, depth) {
            depth = this.resolveDepth(depth);
            let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
            for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
            return pos;
        }
        marks() {
            let parent = this.parent, index = this.index();
            if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (this.textOffset) return parent.child(index).marks;
            let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
            if (!main) {
                let tmp = main;
                main = other;
                other = tmp;
            }
            let marks = main.marks;
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        marksAcross($end) {
            let after = this.parent.maybeChild(this.index());
            if (!after || !after.isInline) return null;
            let marks = after.marks, next = $end.parent.maybeChild($end.index());
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        sharedDepth(pos) {
            for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
            return 0;
        }
        blockRange(other = this, pred) {
            if (other.pos < this.pos) return other.blockRange(this);
            for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
            return null;
        }
        sameParent(other) {
            return this.pos - this.parentOffset == other.pos - other.parentOffset;
        }
        max(other) {
            return other.pos > this.pos ? other : this;
        }
        min(other) {
            return other.pos < this.pos ? other : this;
        }
        toString() {
            let str = "";
            for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
            return str + ":" + this.parentOffset;
        }
        static resolve(doc, pos) {
            if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
            let path = [];
            let start = 0, parentOffset = pos;
            for(let node = doc;;){
                let { index: index, offset: offset } = node.content.findIndex(parentOffset);
                let rem = parentOffset - offset;
                path.push(node, index, start + offset);
                if (!rem) break;
                node = node.child(index);
                if (node.isText) break;
                parentOffset = rem - 1;
                start += offset + 1;
            }
            return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
        }
        static resolveCached(doc, pos) {
            let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
            if (cache) for(let i = 0; i < cache.elts.length; i++){
                let elt = cache.elts[i];
                if (elt.pos == pos) return elt;
            }
            else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
            let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
            cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
            return result;
        }
    }
    class $f043ae92c0a873f0$var$ResolveCache {
        constructor(){
            this.elts = [];
            this.i = 0;
        }
    }
    const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
    class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
        constructor($from, $to, depth){
            this.$from = $from;
            this.$to = $to;
            this.depth = depth;
        }
        get start() {
            return this.$from.before(this.depth + 1);
        }
        get end() {
            return this.$to.after(this.depth + 1);
        }
        get parent() {
            return this.$from.node(this.depth);
        }
        get startIndex() {
            return this.$from.index(this.depth);
        }
        get endIndex() {
            return this.$to.indexAfter(this.depth);
        }
    }
    const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
    class $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        }
        get nodeSize() {
            return this.isLeaf ? 1 : 2 + this.content.size;
        }
        get childCount() {
            return this.content.childCount;
        }
        child(index) {
            return this.content.child(index);
        }
        maybeChild(index) {
            return this.content.maybeChild(index);
        }
        forEach(f) {
            this.content.forEach(f);
        }
        nodesBetween(from, to, f, startPos = 0) {
            this.content.nodesBetween(from, to, f, startPos, this);
        }
        descendants(f) {
            this.nodesBetween(0, this.content.size, f);
        }
        get textContent() {
            return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
        }
        textBetween(from, to, blockSeparator, leafText) {
            return this.content.textBetween(from, to, blockSeparator, leafText);
        }
        get firstChild() {
            return this.content.firstChild;
        }
        get lastChild() {
            return this.content.lastChild;
        }
        eq(other) {
            return this == other || this.sameMarkup(other) && this.content.eq(other.content);
        }
        sameMarkup(other) {
            return this.hasMarkup(other.type, other.attrs, other.marks);
        }
        hasMarkup(type, attrs, marks) {
            return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
        }
        copy(content = null) {
            if (content == this.content) return this;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
        }
        cut(from, to = this.content.size) {
            if (from == 0 && to == this.content.size) return this;
            return this.copy(this.content.cut(from, to));
        }
        slice(from, to = this.content.size, includeParents = false) {
            if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let $from = this.resolve(from), $to = this.resolve(to);
            let depth = includeParents ? 0 : $from.sharedDepth(to);
            let start = $from.start(depth), node = $from.node(depth);
            let content = node.content.cut($from.pos - start, $to.pos - start);
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
        }
        replace(from, to, slice) {
            return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
        }
        nodeAt(pos) {
            for(let node = this;;){
                let { index: index, offset: offset } = node.content.findIndex(pos);
                node = node.maybeChild(index);
                if (!node) return null;
                if (offset == pos || node.isText) return node;
                pos -= offset + 1;
            }
        }
        childAfter(pos) {
            let { index: index, offset: offset } = this.content.findIndex(pos);
            return {
                node: this.content.maybeChild(index),
                index: index,
                offset: offset
            };
        }
        childBefore(pos) {
            if (pos == 0) return {
                node: null,
                index: 0,
                offset: 0
            };
            let { index: index, offset: offset } = this.content.findIndex(pos);
            if (offset < pos) return {
                node: this.content.child(index),
                index: index,
                offset: offset
            };
            let node = this.content.child(index - 1);
            return {
                node: node,
                index: index - 1,
                offset: offset - node.nodeSize
            };
        }
        resolve(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
        }
        resolveNoCache(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
        }
        rangeHasMark(from, to, type) {
            let found = false;
            if (to > from) this.nodesBetween(from, to, (node)=>{
                if (type.isInSet(node.marks)) found = true;
                return !found;
            });
            return found;
        }
        get isBlock() {
            return this.type.isBlock;
        }
        get isTextblock() {
            return this.type.isTextblock;
        }
        get inlineContent() {
            return this.type.inlineContent;
        }
        get isInline() {
            return this.type.isInline;
        }
        get isText() {
            return this.type.isText;
        }
        get isLeaf() {
            return this.type.isLeaf;
        }
        get isAtom() {
            return this.type.isAtom;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            let name = this.type.name;
            if (this.content.size) name += "(" + this.content.toStringInner() + ")";
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
        }
        contentMatchAt(index) {
            let match = this.type.contentMatch.matchFragment(this.content, 0, index);
            if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
            return match;
        }
        canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
            let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
            let two = one && one.matchFragment(this.content, to);
            if (!two || !two.validEnd) return false;
            for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
            return true;
        }
        canReplaceWith(from, to, type, marks) {
            if (marks && !this.type.allowsMarks(marks)) return false;
            let start = this.contentMatchAt(from).matchType(type);
            let end = start && start.matchFragment(this.content, to);
            return end ? end.validEnd : false;
        }
        canAppend(other) {
            if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
            else return this.type.compatibleContent(other.type);
        }
        check() {
            this.type.checkContent(this.content);
            this.type.checkAttrs(this.attrs);
            let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for(let i = 0; i < this.marks.length; i++){
                let mark = this.marks[i];
                mark.type.checkAttrs(mark.attrs);
                copy = mark.addToSet(copy);
            }
            if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
            this.content.forEach((node)=>node.check());
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            if (this.content.size) obj.content = this.content.toJSON();
            if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Node.fromJSON");
            let marks = undefined;
            if (json.marks) {
                if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
                marks = json.marks.map(schema.markFromJSON);
            }
            if (json.type == "text") {
                if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
                return schema.text(json.text, marks);
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
            let node = schema.nodeType(json.type).create(json.attrs, content, marks);
            node.type.checkAttrs(node.attrs);
            return node;
        }
    }
    $f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
    class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks){
            super(type, attrs, null, marks);
            if (!content) throw new RangeError("Empty text nodes are not allowed");
            this.text = content;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
        }
        get textContent() {
            return this.text;
        }
        textBetween(from, to) {
            return this.text.slice(from, to);
        }
        get nodeSize() {
            return this.text.length;
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
        }
        withText(text) {
            if (text == this.text) return this;
            return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
        }
        cut(from = 0, to = this.text.length) {
            if (from == 0 && to == this.text.length) return this;
            return this.withText(this.text.slice(from, to));
        }
        eq(other) {
            return this.sameMarkup(other) && this.text == other.text;
        }
        toJSON() {
            let base = super.toJSON();
            base.text = this.text;
            return base;
        }
    }
    function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
        for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
        return str;
    }
    class $f043ae92c0a873f0$export$364ed450558d7ec4 {
        constructor(validEnd){
            this.validEnd = validEnd;
            this.next = [];
            this.wrapCache = [];
        }
        static parse(string, nodeTypes) {
            let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
            if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (stream.next) stream.err("Unexpected trailing text");
            let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
            $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
            return match;
        }
        matchType(type) {
            for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
            return null;
        }
        matchFragment(frag, start = 0, end = frag.childCount) {
            let cur = this;
            for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
            return cur;
        }
        get inlineContent() {
            return this.next.length != 0 && this.next[0].type.isInline;
        }
        get defaultType() {
            for(let i = 0; i < this.next.length; i++){
                let { type: type } = this.next[i];
                if (!(type.isText || type.hasRequiredAttrs())) return type;
            }
            return null;
        }
        compatible(other) {
            for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
            return false;
        }
        fillBefore(after, toEnd = false, startIndex = 0) {
            let seen = [
                this
            ];
            function search(match, types) {
                let finished = match.matchFragment(after, startIndex);
                if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                        seen.push(next);
                        let found = search(next, types.concat(type));
                        if (found) return found;
                    }
                }
                return null;
            }
            return search(this, []);
        }
        findWrapping(target) {
            for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
            let computed = this.computeWrapping(target);
            this.wrapCache.push(target, computed);
            return computed;
        }
        computeWrapping(target) {
            let seen = Object.create(null), active = [
                {
                    match: this,
                    type: null,
                    via: null
                }
            ];
            while(active.length){
                let current = active.shift(), match = current.match;
                if (match.matchType(target)) {
                    let result = [];
                    for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                    return result.reverse();
                }
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                        active.push({
                            match: type.contentMatch,
                            type: type,
                            via: current
                        });
                        seen[type.name] = true;
                    }
                }
            }
            return null;
        }
        get edgeCount() {
            return this.next.length;
        }
        edge(n) {
            if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
            return this.next[n];
        }
        toString() {
            let seen = [];
            function scan(m) {
                seen.push(m);
                for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
            }
            scan(this);
            return seen.map((m, i)=>{
                let out = i + (m.validEnd ? "*" : " ") + " ";
                for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
                return out;
            }).join("\n");
        }
    }
    $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
    class $f043ae92c0a873f0$var$TokenStream {
        constructor(string, nodeTypes){
            this.string = string;
            this.nodeTypes = nodeTypes;
            this.inline = null;
            this.pos = 0;
            this.tokens = string.split(/\s*(?=\b|\W|$)/);
            if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
            if (this.tokens[0] == "") this.tokens.shift();
        }
        get next() {
            return this.tokens[this.pos];
        }
        eat(tok) {
            return this.next == tok && (this.pos++ || true);
        }
        err(str) {
            throw new SyntaxError(str + " (in content expression '" + this.string + "')");
        }
    }
    function $f043ae92c0a873f0$var$parseExpr(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
        while (stream.eat("|"))
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSeq(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
        while (stream.next && stream.next != ")" && stream.next != "|")
        return exprs.length == 1 ? exprs[0] : {
            type: "seq",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
        let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
        for(;;){
            if (stream.eat("+")) expr = {
                type: "plus",
                expr: expr
            };
            else if (stream.eat("*")) expr = {
                type: "star",
                expr: expr
            };
            else if (stream.eat("?")) expr = {
                type: "opt",
                expr: expr
            };
            else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
            else break;
        }
        return expr;
    }
    function $f043ae92c0a873f0$var$parseNum(stream) {
        if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
        let result = Number(stream.next);
        stream.pos++;
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
        let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
        if (stream.eat(",")) {
            if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
            else max = -1;
        }
        if (!stream.eat("}")) stream.err("Unclosed braced range");
        return {
            type: "range",
            min: min,
            max: max,
            expr: expr
        };
    }
    function $f043ae92c0a873f0$var$resolveName(stream, name) {
        let types = stream.nodeTypes, type = types[name];
        if (type) return [
            type
        ];
        let result = [];
        for(let typeName in types){
            let type = types[typeName];
            if (type.groups.indexOf(name) > -1) result.push(type);
        }
        if (result.length == 0) stream.err("No node type or group '" + name + "' found");
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprAtom(stream) {
        if (stream.eat("(")) {
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (!stream.eat(")")) stream.err("Missing closing paren");
            return expr;
        } else if (!/\W/.test(stream.next)) {
            let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
                if (stream.inline == null) stream.inline = type.isInline;
                else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
                return {
                    type: "name",
                    value: type
                };
            });
            stream.pos++;
            return exprs.length == 1 ? exprs[0] : {
                type: "choice",
                exprs: exprs
            };
        } else stream.err("Unexpected token '" + stream.next + "'");
    }
    function $f043ae92c0a873f0$var$nfa(expr) {
        let nfa = [
            []
        ];
        connect(compile(expr, 0), node());
        return nfa;
        function node() {
            return nfa.push([]) - 1;
        }
        function edge(from, to, term) {
            let edge = {
                term: term,
                to: to
            };
            nfa[from].push(edge);
            return edge;
        }
        function connect(edges, to) {
            edges.forEach((edge)=>edge.to = to);
        }
        function compile(expr, from) {
            if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
            else if (expr.type == "seq") for(let i = 0;; i++){
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1) return next;
                connect(next, from = node());
            }
            else if (expr.type == "star") {
                let loop = node();
                edge(from, loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "plus") {
                let loop = node();
                connect(compile(expr.expr, from), loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "opt") return [
                edge(from)
            ].concat(compile(expr.expr, from));
            else if (expr.type == "range") {
                let cur = from;
                for(let i = 0; i < expr.min; i++){
                    let next = node();
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                if (expr.max == -1) connect(compile(expr.expr, cur), cur);
                else for(let i = expr.min; i < expr.max; i++){
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                return [
                    edge(cur)
                ];
            } else if (expr.type == "name") return [
                edge(from, undefined, expr.value)
            ];
            else throw new Error("Unknown expr type");
        }
    }
    function $f043ae92c0a873f0$var$cmp(a, b) {
        return b - a;
    }
    function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
        let result = [];
        scan(node);
        return result.sort($f043ae92c0a873f0$var$cmp);
        function scan(node) {
            let edges = nfa[node];
            if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
            result.push(node);
            for(let i = 0; i < edges.length; i++){
                let { term: term, to: to } = edges[i];
                if (!term && result.indexOf(to) == -1) scan(to);
            }
        }
    }
    function $f043ae92c0a873f0$var$dfa(nfa) {
        let labeled = Object.create(null);
        return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
        function explore(states) {
            let out = [];
            states.forEach((node)=>{
                nfa[node].forEach(({ term: term, to: to })=>{
                    if (!term) return;
                    let set;
                    for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                    $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                        if (!set) out.push([
                            term,
                            set = []
                        ]);
                        if (set.indexOf(node) == -1) set.push(node);
                    });
                });
            });
            let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
            for(let i = 0; i < out.length; i++){
                let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
                state.next.push({
                    type: out[i][0],
                    next: labeled[states.join(",")] || explore(states)
                });
            }
            return state;
        }
    }
    function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
        for(let i = 0, work = [
            match
        ]; i < work.length; i++){
            let state = work[i], dead = !state.validEnd, nodes = [];
            for(let j = 0; j < state.next.length; j++){
                let { type: type, next: next } = state.next[j];
                nodes.push(type.name);
                if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
                if (work.indexOf(next) == -1) work.push(next);
            }
            if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
        }
    }
    function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
        let defaults = Object.create(null);
        for(let attrName in attrs){
            let attr = attrs[attrName];
            if (!attr.hasDefault) return null;
            defaults[attrName] = attr.default;
        }
        return defaults;
    }
    function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
        let built = Object.create(null);
        for(let name in attrs){
            let given = value && value[name];
            if (given === undefined) {
                let attr = attrs[name];
                if (attr.hasDefault) given = attr.default;
                else throw new RangeError("No value supplied for attribute " + name);
            }
            built[name] = given;
        }
        return built;
    }
    function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
        for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
        for(let name in attrs){
            let attr = attrs[name];
            if (attr.validate) attr.validate(values[name]);
        }
    }
    function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
        let result = Object.create(null);
        if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
        return result;
    }
    class $f043ae92c0a873f0$export$f06e977173f1857c {
        constructor(name, schema, spec){
            this.name = name;
            this.schema = schema;
            this.spec = spec;
            this.markSet = null;
            this.groups = spec.group ? spec.group.split(" ") : [];
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.contentMatch = null;
            this.inlineContent = null;
            this.isBlock = !(spec.inline || name == "text");
            this.isText = name == "text";
        }
        get isInline() {
            return !this.isBlock;
        }
        get isTextblock() {
            return this.isBlock && this.inlineContent;
        }
        get isLeaf() {
            return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        }
        get isAtom() {
            return this.isLeaf || !!this.spec.atom;
        }
        get whitespace() {
            return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
        }
        hasRequiredAttrs() {
            for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
            return false;
        }
        compatibleContent(other) {
            return this == other || this.contentMatch.compatible(other.contentMatch);
        }
        computeAttrs(attrs) {
            if (!attrs && this.defaultAttrs) return this.defaultAttrs;
            else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
        }
        create(attrs = null, content, marks) {
            if (this.isText) throw new Error("NodeType.create can't construct text nodes");
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createChecked(attrs = null, content, marks) {
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            this.checkContent(content);
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createAndFill(attrs = null, content, marks) {
            attrs = this.computeAttrs(attrs);
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            if (content.size) {
                let before = this.contentMatch.fillBefore(content);
                if (!before) return null;
                content = before.append(content);
            }
            let matched = this.contentMatch.matchFragment(content);
            let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
            if (!after) return null;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        validContent(content) {
            let result = this.contentMatch.matchFragment(content);
            if (!result || !result.validEnd) return false;
            for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
            return true;
        }
        checkContent(content) {
            if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
        }
        allowsMarkType(markType) {
            return this.markSet == null || this.markSet.indexOf(markType) > -1;
        }
        allowsMarks(marks) {
            if (this.markSet == null) return true;
            for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
            return true;
        }
        allowedMarks(marks) {
            if (this.markSet == null) return marks;
            let copy;
            for(let i = 0; i < marks.length; i++){
                if (!this.allowsMarkType(marks[i].type)) {
                    if (!copy) copy = marks.slice(0, i);
                } else if (copy) copy.push(marks[i]);
            }
            return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        }
        static compile(nodes, schema) {
            let result = Object.create(null);
            nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
            let topType = schema.spec.topNode || "doc";
            if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
            if (!result.text) throw new RangeError("Every schema needs a 'text' type");
            for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
            return result;
        }
    }
    function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
        let types = type.split("|");
        return (value)=>{
            let name = value === null ? "null" : typeof value;
            if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
        };
    }
    class $f043ae92c0a873f0$var$Attribute {
        constructor(typeName, attrName, options){
            this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
            this.default = options.default;
            this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
        }
        get isRequired() {
            return !this.hasDefault;
        }
    }
    class $f043ae92c0a873f0$export$b6a78689043c6521 {
        constructor(name, rank, schema, spec){
            this.name = name;
            this.rank = rank;
            this.schema = schema;
            this.spec = spec;
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.excluded = null;
            let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
        }
        create(attrs = null) {
            if (!attrs && this.instance) return this.instance;
            return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
        }
        static compile(marks, schema) {
            let result = Object.create(null), rank = 0;
            marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
            return result;
        }
        removeFromSet(set) {
            for(var i = 0; i < set.length; i++)if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
        }
        excludes(other) {
            return this.excluded.indexOf(other) > -1;
        }
    }
    class $f043ae92c0a873f0$export$19342e026b58ebb7 {
        constructor(spec){
            this.linebreakReplacement = null;
            this.cached = Object.create(null);
            let instanceSpec = this.spec = {};
            for(let prop in spec)instanceSpec[prop] = spec[prop];
            instanceSpec.nodes = (0, (0, parcelRequire("dHeNB")).default).from(spec.nodes), instanceSpec.marks = (0, (0, parcelRequire("dHeNB")).default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
            this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
            let contentExprCache = Object.create(null);
            for(let prop in this.nodes){
                if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
                let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
                type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
                type.inlineContent = type.contentMatch.inlineContent;
                if (type.spec.linebreakReplacement) {
                    if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                    if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                    this.linebreakReplacement = type;
                }
                type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
            }
            for(let prop in this.marks){
                let type = this.marks[prop], excl = type.spec.excludes;
                type.excluded = excl == null ? [
                    type
                ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
            }
            this.nodeFromJSON = this.nodeFromJSON.bind(this);
            this.markFromJSON = this.markFromJSON.bind(this);
            this.topNodeType = this.nodes[this.spec.topNode || "doc"];
            this.cached.wrappings = Object.create(null);
        }
        node(type, attrs = null, content, marks) {
            if (typeof type == "string") type = this.nodeType(type);
            else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
            else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
            return type.createChecked(attrs, content, marks);
        }
        text(text, marks) {
            let type = this.nodes.text;
            return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        mark(type, attrs) {
            if (typeof type == "string") type = this.marks[type];
            return type.create(attrs);
        }
        nodeFromJSON(json) {
            return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
        }
        markFromJSON(json) {
            return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
        }
        nodeType(name) {
            let found = this.nodes[name];
            if (!found) throw new RangeError("Unknown node type: " + name);
            return found;
        }
    }
    function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
        let found = [];
        for(let i = 0; i < marks.length; i++){
            let name = marks[i], mark = schema.marks[name], ok = mark;
            if (mark) found.push(mark);
            else for(let prop in schema.marks){
                let mark = schema.marks[prop];
                if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
            }
            if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
        }
        return found;
    }
    function $f043ae92c0a873f0$var$isTagRule(rule) {
        return rule.tag != null;
    }
    function $f043ae92c0a873f0$var$isStyleRule(rule) {
        return rule.style != null;
    }
    class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
        constructor(schema, rules){
            this.schema = schema;
            this.rules = rules;
            this.tags = [];
            this.styles = [];
            let matchedStyles = this.matchedStyles = [];
            rules.forEach((rule)=>{
                if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
                else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                    let prop = /[^=]*/.exec(rule.style)[0];
                    if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                    this.styles.push(rule);
                }
            });
            this.normalizeLists = !this.tags.some((r)=>{
                if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
                let node = schema.nodes[r.node];
                return node.contentMatch.matchType(node);
            });
        }
        parse(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return context.finish();
        }
        parseSlice(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
        }
        matchTag(dom, context, after) {
            for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
                let rule = this.tags[i];
                if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                    if (rule.getAttrs) {
                        let result = rule.getAttrs(dom);
                        if (result === false) continue;
                        rule.attrs = result || undefined;
                    }
                    return rule;
                }
            }
        }
        matchStyle(prop, value, context, after) {
            for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
                let rule = this.styles[i], style = rule.style;
                if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
                if (rule.getAttrs) {
                    let result = rule.getAttrs(value);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
        static schemaRules(schema) {
            let result = [];
            function insert(rule) {
                let priority = rule.priority == null ? 50 : rule.priority, i = 0;
                for(; i < result.length; i++){
                    let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                    if (nextPriority < priority) break;
                }
                result.splice(i, 0, rule);
            }
            for(let name in schema.marks){
                let rules = schema.marks[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
                });
            }
            for(let name in schema.nodes){
                let rules = schema.nodes[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
                });
            }
            return result;
        }
        static fromSchema(schema) {
            return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
        }
    }
    const $f043ae92c0a873f0$var$blockTags = {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        canvas: true,
        dd: true,
        div: true,
        dl: true,
        fieldset: true,
        figcaption: true,
        figure: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        li: true,
        noscript: true,
        ol: true,
        output: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        tfoot: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$ignoreTags = {
        head: true,
        noscript: true,
        object: true,
        script: true,
        style: true,
        title: true
    };
    const $f043ae92c0a873f0$var$listTags = {
        ol: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
    function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
        if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
        return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
    }
    class $f043ae92c0a873f0$var$NodeContext {
        constructor(type, attrs, marks, solid, match, options){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.solid = solid;
            this.options = options;
            this.content = [];
            this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
        }
        findWrapping(node) {
            if (!this.match) {
                if (!this.type) return [];
                let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
                if (fill) this.match = this.type.contentMatch.matchFragment(fill);
                else {
                    let start = this.type.contentMatch, wrap;
                    if (wrap = start.findWrapping(node.type)) {
                        this.match = start;
                        return wrap;
                    } else return null;
                }
            }
            return this.match.findWrapping(node.type);
        }
        finish(openEnd) {
            if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                let last = this.content[this.content.length - 1], m;
                if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                    let text = last;
                    if (last.text.length == m[0].length) this.content.pop();
                    else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
                }
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
            if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
            return this.type ? this.type.create(this.attrs, content, this.marks) : content;
        }
        inlineContext(node) {
            if (this.type) return this.type.inlineContent;
            if (this.content.length) return this.content[0].isInline;
            return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
        }
    }
    class $f043ae92c0a873f0$var$ParseContext {
        constructor(parser, options, isOpen){
            this.parser = parser;
            this.options = options;
            this.isOpen = isOpen;
            this.open = 0;
            let topNode = options.topNode, topContext;
            let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
            if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
            else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            this.nodes = [
                topContext
            ];
            this.find = options.findPositions;
            this.needsBlock = false;
        }
        get top() {
            return this.nodes[this.open];
        }
        addDOM(dom, marks) {
            if (dom.nodeType == 3) this.addTextNode(dom, marks);
            else if (dom.nodeType == 1) this.addElement(dom, marks);
        }
        addTextNode(dom, marks) {
            let value = dom.nodeValue;
            let top = this.top;
            if (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
                if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                    value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                    if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                        let nodeBefore = top.content[top.content.length - 1];
                        let domNodeBefore = dom.previousSibling;
                        if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                    }
                } else if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
                else value = value.replace(/\r\n?/g, "\n");
                if (value) this.insertNode(this.parser.schema.text(value), marks);
                this.findInText(dom);
            } else this.findInside(dom);
        }
        addElement(dom, marks, matchAfter) {
            let name = dom.nodeName.toLowerCase(), ruleID;
            if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
            let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
            if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
                this.findInside(dom);
                this.ignoreFallback(dom, marks);
            } else if (!rule || rule.skip || rule.closeParent) {
                if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
                else if (rule && rule.skip.nodeType) dom = rule.skip;
                let sync, top = this.top, oldNeedsBlock = this.needsBlock;
                if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                    if (top.content.length && top.content[0].isInline && this.open) {
                        this.open--;
                        top = this.top;
                    }
                    sync = true;
                    if (!top.type) this.needsBlock = true;
                } else if (!dom.firstChild) {
                    this.leafFallback(dom, marks);
                    return;
                }
                let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
                if (innerMarks) this.addAll(dom, innerMarks);
                if (sync) this.sync(top);
                this.needsBlock = oldNeedsBlock;
            } else {
                let innerMarks = this.readStyles(dom, marks);
                if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
            }
        }
        leafFallback(dom, marks) {
            if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
        }
        ignoreFallback(dom, marks) {
            if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
        }
        readStyles(dom, marks) {
            let styles = dom.style;
            if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value) for(let after = undefined;;){
                    let rule = this.parser.matchStyle(name, value, this, after);
                    if (!rule) break;
                    if (rule.ignore) return null;
                    if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                    else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                    if (rule.consuming === false) after = rule;
                    else break;
                }
            }
            return marks;
        }
        addElementByRule(dom, rule, marks, continueAfter) {
            let sync, nodeType;
            if (rule.node) {
                nodeType = this.parser.schema.nodes[rule.node];
                if (!nodeType.isLeaf) {
                    let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                    if (inner) {
                        sync = true;
                        marks = inner;
                    }
                } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
            } else {
                let markType = this.parser.schema.marks[rule.mark];
                marks = marks.concat(markType.create(rule.attrs));
            }
            let startIn = this.top;
            if (nodeType && nodeType.isLeaf) this.findInside(dom);
            else if (continueAfter) this.addElement(dom, marks, continueAfter);
            else if (rule.getContent) {
                this.findInside(dom);
                rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
            } else {
                let contentDOM = dom;
                if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
                else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
                else if (rule.contentElement) contentDOM = rule.contentElement;
                this.findAround(dom, contentDOM, true);
                this.addAll(contentDOM, marks);
            }
            if (sync && this.sync(startIn)) this.open--;
        }
        addAll(parent, marks, startIndex, endIndex) {
            let index = startIndex || 0;
            for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
                this.findAtPoint(parent, index);
                this.addDOM(dom, marks);
            }
            this.findAtPoint(parent, index);
        }
        findPlace(node, marks) {
            let route, sync;
            for(let depth = this.open; depth >= 0; depth--){
                let cx = this.nodes[depth];
                let found = cx.findWrapping(node);
                if (found && (!route || route.length > found.length)) {
                    route = found;
                    sync = cx;
                    if (!found.length) break;
                }
                if (cx.solid) break;
            }
            if (!route) return null;
            this.sync(sync);
            for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
            return marks;
        }
        insertNode(node, marks) {
            if (node.isInline && this.needsBlock && !this.top.type) {
                let block = this.textblockFromContext();
                if (block) marks = this.enterInner(block, null, marks);
            }
            let innerMarks = this.findPlace(node, marks);
            if (innerMarks) {
                this.closeExtra();
                let top = this.top;
                if (top.match) top.match = top.match.matchType(node.type);
                let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
                for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
                top.content.push(node.mark(nodeMarks));
                return true;
            }
            return false;
        }
        enter(type, attrs, marks, preserveWS) {
            let innerMarks = this.findPlace(type.create(attrs), marks);
            if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
            return innerMarks;
        }
        enterInner(type, attrs, marks, solid = false, preserveWS) {
            this.closeExtra();
            let top = this.top;
            top.match = top.match && top.match.matchType(type);
            let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
            if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
            let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            marks = marks.filter((m)=>{
                if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                    applyMarks = m.addToSet(applyMarks);
                    return false;
                }
                return true;
            });
            this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
            this.open++;
            return marks;
        }
        closeExtra(openEnd = false) {
            let i = this.nodes.length - 1;
            if (i > this.open) {
                for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
                this.nodes.length = this.open + 1;
            }
        }
        finish() {
            this.open = 0;
            this.closeExtra(this.isOpen);
            return this.nodes[0].finish(this.isOpen || this.options.topOpen);
        }
        sync(to) {
            for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            return false;
        }
        get currentPos() {
            this.closeExtra();
            let pos = 0;
            for(let i = this.open; i >= 0; i--){
                let content = this.nodes[i].content;
                for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
                if (i) pos++;
            }
            return pos;
        }
        findAtPoint(parent, offset) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
            }
        }
        findInside(parent) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
            }
        }
        findAround(parent, content, before) {
            if (parent != content && this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
                }
            }
        }
        findInText(textNode) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
        }
        matchesContext(context) {
            if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
            let parts = context.split("/");
            let option = this.options.context;
            let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
            let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
            let match = (i, depth)=>{
                for(; i >= 0; i--){
                    let part = parts[i];
                    if (part == "") {
                        if (i == parts.length - 1 || i == 0) continue;
                        for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                        return false;
                    } else {
                        let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                        if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                        depth--;
                    }
                }
                return true;
            };
            return match(parts.length - 1, this.open);
        }
        textblockFromContext() {
            let $context = this.options.context;
            if ($context) for(let d = $context.depth; d >= 0; d--){
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
            }
            for(let name in this.parser.schema.nodes){
                let type = this.parser.schema.nodes[name];
                if (type.isTextblock && type.defaultAttrs) return type;
            }
        }
    }
    function $f043ae92c0a873f0$var$normalizeList(dom) {
        for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
            let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
            if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
                prevItem.appendChild(child);
                child = prevItem;
            } else if (name == "li") prevItem = child;
            else if (name) prevItem = null;
        }
    }
    function $f043ae92c0a873f0$var$matches(dom, selector) {
        return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
    }
    function $f043ae92c0a873f0$var$copy(obj) {
        let copy = {};
        for(let prop in obj)copy[prop] = obj[prop];
        return copy;
    }
    function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
        let nodes = nodeType.schema.nodes;
        for(let name in nodes){
            let parent = nodes[name];
            if (!parent.allowsMarkType(markType)) continue;
            let seen = [], scan = (match)=>{
                seen.push(match);
                for(let i = 0; i < match.edgeCount; i++){
                    let { type: type, next: next } = match.edge(i);
                    if (type == nodeType) return true;
                    if (seen.indexOf(next) < 0 && scan(next)) return true;
                }
            };
            if (scan(parent.contentMatch)) return true;
        }
    }
    class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
        constructor(nodes, marks){
            this.nodes = nodes;
            this.marks = marks;
        }
        serializeFragment(fragment, options = {}, target) {
            if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
            let top = target, active = [];
            fragment.forEach((node)=>{
                if (active.length || node.marks.length) {
                    let keep = 0, rendered = 0;
                    while(keep < active.length && rendered < node.marks.length){
                        let next = node.marks[rendered];
                        if (!this.marks[next.type.name]) {
                            rendered++;
                            continue;
                        }
                        if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                        keep++;
                        rendered++;
                    }
                    while(keep < active.length)top = active.pop()[1];
                    while(rendered < node.marks.length){
                        let add = node.marks[rendered++];
                        let markDOM = this.serializeMark(add, node.isInline, options);
                        if (markDOM) {
                            active.push([
                                add,
                                top
                            ]);
                            top.appendChild(markDOM.dom);
                            top = markDOM.contentDOM || markDOM.dom;
                        }
                    }
                }
                top.appendChild(this.serializeNodeInner(node, options));
            });
            return target;
        }
        serializeNodeInner(node, options) {
            let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
            if (contentDOM) {
                if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
                this.serializeFragment(node.content, options, contentDOM);
            }
            return dom;
        }
        serializeNode(node, options = {}) {
            let dom = this.serializeNodeInner(node, options);
            for(let i = node.marks.length - 1; i >= 0; i--){
                let wrap = this.serializeMark(node.marks[i], node.isInline, options);
                if (wrap) {
                    (wrap.contentDOM || wrap.dom).appendChild(dom);
                    dom = wrap.dom;
                }
            }
            return dom;
        }
        serializeMark(mark, inline, options = {}) {
            let toDOM = this.marks[mark.type.name];
            return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
        }
        static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
            return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
        }
        static fromSchema(schema) {
            return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
        }
        static nodesFromSchema(schema) {
            let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
            if (!result.text) result.text = (node)=>node.text;
            return result;
        }
        static marksFromSchema(schema) {
            return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
        }
    }
    function $f043ae92c0a873f0$var$gatherToDOM(obj) {
        let result = {};
        for(let name in obj){
            let toDOM = obj[name].spec.toDOM;
            if (toDOM) result[name] = toDOM;
        }
        return result;
    }
    function $f043ae92c0a873f0$var$doc(options) {
        return options.document || window.document;
    }
    const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
    function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
        let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
        if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
        return value;
    }
    function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
        let result = null;
        function scan(value) {
            if (value && typeof value == "object") {
                if (Array.isArray(value)) {
                    if (typeof value[0] == "string") {
                        if (!result) result = [];
                        result.push(value);
                    } else for(let i = 0; i < value.length; i++)scan(value[i]);
                } else for(let prop in value)scan(value[prop]);
            }
        }
        scan(attrs);
        return result;
    }
    function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], suspicious;
        if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
        if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
        let space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
});
parcelRegister("dHeNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
    function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
        this.content = content;
    }
    $9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
        constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
        find: function(key) {
            for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
            return -1;
        },
        get: function(key) {
            var found = this.find(key);
            return found == -1 ? undefined : this.content[found + 1];
        },
        update: function(key, value, newKey) {
            var self = newKey && newKey != key ? this.remove(newKey) : this;
            var found = self.find(key), content = self.content.slice();
            if (found == -1) content.push(newKey || key, value);
            else {
                content[found + 1] = value;
                if (newKey) content[found] = newKey;
            }
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        remove: function(key) {
            var found = this.find(key);
            if (found == -1) return this;
            var content = this.content.slice();
            content.splice(found, 2);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addToStart: function(key, value) {
            return new $9f8ac547b0b2e1f8$var$OrderedMap([
                key,
                value
            ].concat(this.remove(key).content));
        },
        addToEnd: function(key, value) {
            var content = this.remove(key).content.slice();
            content.push(key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addBefore: function(place, key, value) {
            var without = this.remove(key), content = without.content.slice();
            var found = without.find(place);
            content.splice(found == -1 ? content.length : found, 0, key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        forEach: function(f) {
            for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
        },
        prepend: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
        },
        append: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
        },
        subtract: function(map) {
            var result = this;
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
            return result;
        },
        toObject: function() {
            var result = {};
            this.forEach(function(key, value) {
                result[key] = value;
            });
            return result;
        },
        get size () {
            return this.content.length >> 1;
        }
    };
    $9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
        if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
        var content = [];
        if (value) for(var prop in value)content.push(prop, value[prop]);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    };
    var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;
});
parcelRegister("gthjq", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$bfdcc8a4590754dc$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "blockquote", ()=>$bfdcc8a4590754dc$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteLegacy", ()=>$bfdcc8a4590754dc$export$199922e5af8e9a6);
    $parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", ()=>$bfdcc8a4590754dc$export$a91509d1c739c16f);
    $parcel$export(module.exports, "bodiedExtension", ()=>$bfdcc8a4590754dc$export$27903d543b563e39);
    $parcel$export(module.exports, "bulletList", ()=>$bfdcc8a4590754dc$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "caption", ()=>$bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "codeBlock", ()=>$bfdcc8a4590754dc$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$bfdcc8a4590754dc$export$daf889beb5092f95);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$bfdcc8a4590754dc$export$e6e4878f43c27cab);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$bfdcc8a4590754dc$export$3e6d667072febc87);
    $parcel$export(module.exports, "date", ()=>$bfdcc8a4590754dc$export$324d90190a8b822a);
    $parcel$export(module.exports, "decisionItem", ()=>$bfdcc8a4590754dc$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$bfdcc8a4590754dc$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "doc", ()=>$bfdcc8a4590754dc$export$2a111da947c407d2);
    $parcel$export(module.exports, "embedCard", ()=>$bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "emoji", ()=>$bfdcc8a4590754dc$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "expand", ()=>$bfdcc8a4590754dc$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithoutNestedExpand", ()=>$bfdcc8a4590754dc$export$63c0f3992661097b);
    $parcel$export(module.exports, "extension", ()=>$bfdcc8a4590754dc$export$1b45514b112dd749);
    $parcel$export(module.exports, "extensionFrameStage0", ()=>$bfdcc8a4590754dc$export$b555be60c7703afb);
    $parcel$export(module.exports, "hardBreak", ()=>$bfdcc8a4590754dc$export$371da9dd35aba193);
    $parcel$export(module.exports, "heading", ()=>$bfdcc8a4590754dc$export$46e4a324ac90507f);
    $parcel$export(module.exports, "image", ()=>$bfdcc8a4590754dc$export$5c452ff88e35e47d);
    $parcel$export(module.exports, "inlineCard", ()=>$bfdcc8a4590754dc$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "inlineExtensionWithMarks", ()=>$bfdcc8a4590754dc$export$b3b1e36c2105006d);
    $parcel$export(module.exports, "layoutColumn", ()=>$bfdcc8a4590754dc$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionFull", ()=>$bfdcc8a4590754dc$export$cdae19acb0a520fd);
    $parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", ()=>$bfdcc8a4590754dc$export$206007566ca0aca5);
    $parcel$export(module.exports, "listItem", ()=>$bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithNestedDecisionStage0", ()=>$bfdcc8a4590754dc$export$df876f0305235056);
    $parcel$export(module.exports, "media", ()=>$bfdcc8a4590754dc$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "mediaGroup", ()=>$bfdcc8a4590754dc$export$2855e964765eac9);
    $parcel$export(module.exports, "mediaInline", ()=>$bfdcc8a4590754dc$export$38bab695e3f720f1);
    $parcel$export(module.exports, "mediaSingle", ()=>$bfdcc8a4590754dc$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleCaption", ()=>$bfdcc8a4590754dc$export$8d067f22dc2d1254);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$bfdcc8a4590754dc$export$7e767666f2ce108a);
    $parcel$export(module.exports, "mediaSingleWidthType", ()=>$bfdcc8a4590754dc$export$4bd9a38995f6bf50);
    $parcel$export(module.exports, "mention", ()=>$bfdcc8a4590754dc$export$db83999c14438df4);
    $parcel$export(module.exports, "multiBodiedExtensionStage0", ()=>$bfdcc8a4590754dc$export$750e45819f66d9d0);
    $parcel$export(module.exports, "nestedExpand", ()=>$bfdcc8a4590754dc$export$63cadbf5f4296627);
    $parcel$export(module.exports, "orderedList", ()=>$bfdcc8a4590754dc$export$a5dc81035676e7a);
    $parcel$export(module.exports, "panel", ()=>$bfdcc8a4590754dc$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panelWithNestedBlockquoteStage0", ()=>$bfdcc8a4590754dc$export$a1cf9918ad22c7e9);
    $parcel$export(module.exports, "paragraph", ()=>$bfdcc8a4590754dc$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "placeholder", ()=>$bfdcc8a4590754dc$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "rule", ()=>$bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "status", ()=>$bfdcc8a4590754dc$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "table", ()=>$bfdcc8a4590754dc$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$bfdcc8a4590754dc$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableCell", ()=>$bfdcc8a4590754dc$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$bfdcc8a4590754dc$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeader", ()=>$bfdcc8a4590754dc$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$bfdcc8a4590754dc$export$2a5a518232fa1a97);
    $parcel$export(module.exports, "tableRow", ()=>$bfdcc8a4590754dc$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$bfdcc8a4590754dc$export$7d657479499397);
    $parcel$export(module.exports, "taskItem", ()=>$bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$bfdcc8a4590754dc$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "text", ()=>$bfdcc8a4590754dc$export$6f093cfa640b7166);
    $parcel$export(module.exports, "unsupportedBlock", ()=>$bfdcc8a4590754dc$export$44b79b0979d0f0f7);
    $parcel$export(module.exports, "unsupportedInline", ()=>$bfdcc8a4590754dc$export$310ebe0d80122e9b);
    var $f0ccE;
    const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: null
            },
            datasource: {
                default: null
            },
            width: {
                default: null
            },
            layout: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: false
    });
    const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
        marks: '_',
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(text | unsupportedInline)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$62a75647a293fbec = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            issueKey: {
                default: ''
            },
            macroId: {
                default: null
            },
            schemaVersion: {
                default: null
            },
            server: {
                default: null
            },
            serverId: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'DECIDED'
            }
        },
        defining: true
    });
    const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(decisionItem | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | layoutSection | blockRootOnly)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
    });
    const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: ''
            },
            layout: {
                default: 'center'
            },
            width: {
                default: 100
            },
            originalHeight: {
                default: null
            },
            originalWidth: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$111717af0897b759 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        attrs: {},
        selectable: false,
        definingAsContext: false,
        definingForContent: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: '\n'
            }
        },
        selectable: false,
        linebreakReplacement: true
    });
    const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            src: {
                default: ''
            },
            alt: {
                default: ''
            },
            title: {
                default: null
            }
        },
        draggable: true
    });
    const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
        attrs: {
            width: {
                default: undefined
            }
        },
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){2,3}',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            columnRuleStyle: {
                default: null
            }
        },
        isolating: true
    });
    const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$df876f0305235056 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            type: {
                default: 'file'
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            height: {
                default: null
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            __contextId: {
                default: null
            },
            __displayType: {
                default: null
            },
            __external: {
                default: false
            },
            __fileMimeType: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            url: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(media | unsupportedBlock)+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {},
        selectable: false
    });
    const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            type: {
                default: 'file'
            },
            url: {
                default: null
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            height: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __fileMimeType: {
                default: null
            },
            __displayType: {
                default: null
            },
            __contextId: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            __external: {
                default: false
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true,
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
    });
    const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: true,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'extensionFrame+',
        marks: 'unsupportedNodeAttribute unsupportedMark',
        group: 'blockRootOnly',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        definingAsContext: true
    });
    const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            order: {
                default: 1
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a1cf9918ad22c7e9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: '',
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block'
    });
    const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$7d657479499397 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'TODO'
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
});
parcelRegister("f0ccE", function(module, exports) {
    $parcel$export(module.exports, "createPMNodeSpecFactory", ()=>$aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
    $parcel$export(module.exports, "createPMMarkSpecFactory", ()=>$aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
    const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...nodeSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
    const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...markSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
});
parcelRegister("cUwVZ", function(module, exports) {
    $parcel$export(module.exports, "dataConsumer", ()=>$966443126bdc8969$export$3024f02c495408d6);
    $parcel$export(module.exports, "toJSON", ()=>$966443126bdc8969$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
        const sources = (0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
        try {
            return sources ? {
                sources: JSON.parse(sources)
            } : false;
        } catch  {
            return false;
        }
    };
    const $966443126bdc8969$export$3024f02c495408d6 = (0, (0, parcelRequire("2fTAU")).dataConsumer)({
        parseDOM: [
            {
                tag: '[data-mark-type="dataConsumer"]',
                getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'dataConsumer',
                    'data-sources': JSON.stringify(mark.attrs.sources)
                }
            ];
        }
    });
    const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
                return {
                    ...acc,
                    [key]: mark.attrs[key]
                };
            }, {})
        };
    };
});
parcelRegister("2fTAU", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>$1a481b607696d815$export$8e53000a4ec837);
    $parcel$export(module.exports, "annotation", ()=>$1a481b607696d815$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "backgroundColor", ()=>$1a481b607696d815$export$8c5a050822fd698c);
    $parcel$export(module.exports, "border", ()=>$1a481b607696d815$export$1edee58a52776cd9);
    $parcel$export(module.exports, "breakout", ()=>$1a481b607696d815$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "code", ()=>$1a481b607696d815$export$6565f9f03506010b);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$1a481b607696d815$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "dataConsumer", ()=>$1a481b607696d815$export$3024f02c495408d6);
    $parcel$export(module.exports, "em", ()=>$1a481b607696d815$export$c63c6f932822f543);
    $parcel$export(module.exports, "fragment", ()=>$1a481b607696d815$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "indentation", ()=>$1a481b607696d815$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "link", ()=>$1a481b607696d815$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "strike", ()=>$1a481b607696d815$export$4899a95d70ec5056);
    $parcel$export(module.exports, "strong", ()=>$1a481b607696d815$export$59ae2c325a998f89);
    $parcel$export(module.exports, "subsup", ()=>$1a481b607696d815$export$b3401ee80eb31041);
    $parcel$export(module.exports, "textColor", ()=>$1a481b607696d815$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "typeAheadQuery", ()=>$1a481b607696d815$export$20af3dabbb5538df);
    $parcel$export(module.exports, "underline", ()=>$1a481b607696d815$export$425327af25286e5e);
    $parcel$export(module.exports, "unsupportedMark", ()=>$1a481b607696d815$export$30d78d5eb6719bb8);
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$1a481b607696d815$export$a316dc07ff5182a2);
    var $f0ccE;
    const $1a481b607696d815$export$8e53000a4ec837 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            align: {}
        },
        excludes: 'alignment indentation',
        group: 'alignment'
    });
    const $1a481b607696d815$export$8512c9afa7b24c3b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            id: {
                default: ''
            },
            annotationType: {
                default: 'inlineComment'
            }
        },
        inclusive: true,
        excludes: '',
        group: 'annotation'
    });
    const $1a481b607696d815$export$8c5a050822fd698c = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        excludes: 'color',
        group: 'color'
    });
    const $1a481b607696d815$export$1edee58a52776cd9 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            size: {},
            color: {}
        },
        inclusive: false
    });
    const $1a481b607696d815$export$89015c65f1c75e3f = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            mode: {
                default: 'wide'
            },
            width: {
                default: null
            }
        },
        inclusive: false,
        spanning: false
    });
    const $1a481b607696d815$export$6565f9f03506010b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        excludes: 'fontStyle link searchQuery color'
    });
    const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            reference: {
                default: ''
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$3024f02c495408d6 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            sources: {
                default: []
            }
        }
    });
    const $1a481b607696d815$export$c63c6f932822f543 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$f00aeb236b6f05af = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            localId: {
                default: ''
            },
            name: {
                default: null
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$480c699bd4ec0d86 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            level: {}
        },
        excludes: 'indentation alignment',
        group: 'indentation'
    });
    const $1a481b607696d815$export$9c30223ca0a664fb = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            href: {},
            __confluenceMetadata: {
                default: null
            }
        },
        inclusive: false,
        excludes: 'link',
        group: 'link'
    });
    const $1a481b607696d815$export$4899a95d70ec5056 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$59ae2c325a998f89 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$b3401ee80eb31041 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            type: {
                default: 'sub'
            }
        },
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$32f78bffcd82ff28 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        group: 'color'
    });
    const $1a481b607696d815$export$20af3dabbb5538df = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            trigger: {
                default: ''
            }
        },
        inclusive: true,
        group: 'searchQuery'
    });
    const $1a481b607696d815$export$425327af25286e5e = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            originalValue: {}
        },
        excludes: ''
    });
    const $1a481b607696d815$export$a316dc07ff5182a2 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            unsupported: {},
            type: {}
        }
    });
});
parcelRegister("6VXbJ", function(module, exports) {
    $parcel$export(module.exports, "isDOMElement", ()=>$50c5fa8010b73128$export$c296e2d4365c37a5);
    const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
});
parcelRegister("7kC9H", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$5567ff8f3f52f7a8$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>$5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
    $parcel$export(module.exports, "toJSON", ()=>$5567ff8f3f52f7a8$export$54fd2c36b5cc6731);
    var $gthjq;
    function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
        parseDOM: [
            {
                context: 'table//',
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'expand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'expand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, (0, parcelRequire("gthjq")).expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, (0, parcelRequire("gthjq")).expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("29Vii", function(module, exports) {
    $parcel$export(module.exports, "fragment", ()=>$1928dd6d160b68a9$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "toJSON", ()=>$1928dd6d160b68a9$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
        var _maybeValue$getAttrib;
        if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue)) return false;
        const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
        const localId = maybeValue.getAttribute('data-localId');
        if (!localId) return false;
        return {
            localId: localId,
            name: name
        };
    };
    const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, (0, parcelRequire("2fTAU")).fragment)({
        parseDOM: [
            {
                tag: '[data-mark-type="fragment"]',
                getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'fragment',
                    'data-name': mark.attrs.name,
                    'data-localId': mark.attrs.localId
                }
            ];
        }
    });
    const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: {
                localId: mark.attrs.localId,
                ...mark.attrs.name ? {
                    name: mark.attrs.name
                } : {}
            }
        };
    };
});
parcelRegister("8XeG6", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$684f383282dda449$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "toJSON", ()=>$684f383282dda449$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $iZOJ9;
    const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
            const dom = domNode;
            const href = dom.getAttribute(attribute) || '';
            const attrs = {
                __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
            };
            if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(href)) return false;
            if ((0, (0, parcelRequire("iZOJ9")).isRootRelative)(href)) {
                attrs.href = href;
                return attrs;
            }
            attrs.href = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)(href);
            return attrs;
        };
    const $684f383282dda449$export$9c30223ca0a664fb = (0, (0, parcelRequire("2fTAU")).link)({
        parseDOM: [
            {
                tag: '[data-block-link]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
                contentElement: (node)=>{
                    const clone = node.cloneNode(true);
                    clone.removeAttribute('data-block-link');
                    clone.setAttribute('data-skip-paste', 'true');
                    const wrapper = document.createElement('div');
                    wrapper.appendChild(clone);
                    return wrapper;
                }
            },
            {
                tag: 'a[href]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
            }
        ],
        toDOM (node, isInline) {
            const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
                if (key === '__confluenceMetadata') {
                    if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
                } else if (key === 'href') attrs[key] = (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
                else attrs[key] = node.attrs[key];
                return attrs;
            }, {});
            if (isInline) return [
                'a',
                attrs
            ];
            return [
                'a',
                {
                    ...attrs,
                    ['data-block-link']: 'true',
                    class: 'blockLink'
                },
                0
            ];
        }
    });
    const $684f383282dda449$var$OPTIONAL_ATTRS = [
        'title',
        'id',
        'collection',
        'occurrenceKey',
        '__confluenceMetadata'
    ];
    const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
                if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
                return attrs;
            }, {})
        });
});
parcelRegister("iZOJ9", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$dd4545da25e52dce$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "linkify", ()=>$dd4545da25e52dce$export$8ccbde94d5c7f8e7);
    $parcel$export(module.exports, "linkifyMatch", ()=>$dd4545da25e52dce$export$6f7d7761b97f967);
    $parcel$export(module.exports, "getLinkMatch", ()=>$dd4545da25e52dce$export$ce9ae45aed3e4ec);
    $parcel$export(module.exports, "normalizeUrl", ()=>$dd4545da25e52dce$export$6535eb414fa2c8b6);
    $parcel$export(module.exports, "isRootRelative", ()=>$dd4545da25e52dce$export$23579274a7a24f7b);
    var $i6xkD = parcelRequire("i6xkD");
    const $dd4545da25e52dce$var$whitelistedURLPatterns = [
        /^https?:\/\//im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\//im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:/im,
        /^facetime:/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^sourcetree:\/\//im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^#/im
    ];
    const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        if (urlTrimmed.length === 0) return true;
        return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, ($parcel$interopDefault($i6xkD)))();
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
    const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
        validate: /[^\s]+/
    };
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
    const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
    const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
        if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
        const matches = [];
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
        if (!str) return null;
        let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
        if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
        return match && match[0];
    }
    function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
        const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
        return match && match.url || '';
    }
    function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
        return url.startsWith('/') || url === '#top' || url === '#';
    }
});
parcelRegister("i6xkD", function(module, exports) {
    'use strict';
    function $d2e2a485107d561a$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $d2e2a485107d561a$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $d2e2a485107d561a$var$isString(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object String]';
    }
    function $d2e2a485107d561a$var$isObject(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
    }
    function $d2e2a485107d561a$var$isRegExp(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
    }
    function $d2e2a485107d561a$var$isFunction(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
    }
    function $d2e2a485107d561a$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $d2e2a485107d561a$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $d2e2a485107d561a$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $d2e2a485107d561a$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $d2e2a485107d561a$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $d2e2a485107d561a$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $d2e2a485107d561a$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $d2e2a485107d561a$var$compile(self) {
        var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($d2e2a485107d561a$var$isObject(val)) {
                if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
                else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($d2e2a485107d561a$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $d2e2a485107d561a$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($d2e2a485107d561a$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
        $d2e2a485107d561a$var$resetScanCache(self);
    }
    function $d2e2a485107d561a$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $d2e2a485107d561a$var$createMatch(self, shift) {
        var match = new $d2e2a485107d561a$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $d2e2a485107d561a$var$compile(this);
    }
    $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $d2e2a485107d561a$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $d2e2a485107d561a$var$LinkifyIt;
});
parcelRegister("9mKTr", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,3}[a-zA-Z0-9%/]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("b9ep3", function(module, exports) {
    module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
});
parcelRegister("23ErL", function(module, exports) {
    module.exports = /[\0-\x1F\x7F-\x9F]/;
});
parcelRegister("oRY4m", function(module, exports) {
    module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
});
parcelRegister("9bBmm", function(module, exports) {
    module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
});
parcelRegister("bIGZ7", function(module, exports) {
    $parcel$export(module.exports, "mediaSingleSpec", ()=>$888525ada96954d1$export$5a1e124099b60c6b);
    $parcel$export(module.exports, "mediaSingle", ()=>$888525ada96954d1$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>$888525ada96954d1$export$d35e6c006d4abdfb);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>$888525ada96954d1$export$9c58e19811ce4cf5);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$888525ada96954d1$export$7e767666f2ce108a);
    $parcel$export(module.exports, "toJSON", ()=>$888525ada96954d1$export$54fd2c36b5cc6731);
    var $ITAJ1;
    var $6VXbJ;
    var $gthjq;
    const $888525ada96954d1$export$bb3fe706be61f640 = {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        }
    };
    const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
        const getAttrs = (dom)=>{
            if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(dom)) return {
                layout: 'center'
            };
            const layout = dom.getAttribute('data-layout') || 'center';
            const width = Number(dom.getAttribute('data-width')) || null;
            const widthType = dom.getAttribute('data-width-type');
            if (withExtendedWidthTypes) return {
                layout: layout,
                width: width,
                widthType: widthType
            };
            else if (widthType === (0, (0, parcelRequire("ITAJ1")).WidthType).PIXEL) return {
                layout: layout
            };
            else return {
                layout: layout,
                width: width
            };
        };
        const getAttrsFromNode = (node)=>{
            const { layout: layout, width: width } = node.attrs;
            const attrs = {
                'data-node-type': 'mediaSingle',
                'data-layout': layout,
                'data-width': ''
            };
            if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
            if (withExtendedWidthTypes && node.attrs.widthType) {
                const { widthType: widthType } = node.attrs;
                return {
                    ...attrs,
                    'data-width-type': widthType || (0, (0, parcelRequire("ITAJ1")).WidthType).PERCENTAGE
                };
            }
            return attrs;
        };
        if (withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleFull)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (withExtendedWidthTypes && !withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleWidthType)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (!withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleCaption)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        return (0, (0, parcelRequire("gthjq")).mediaSingle)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
    };
    const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if (node.attrs[key] !== null) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("ITAJ1", function(module, exports) {
    $parcel$export(module.exports, "WidthType", ()=>$086f3b754fef02e1$export$4d41558722ac7eed);
    let $086f3b754fef02e1$export$4d41558722ac7eed = function(WidthType) {
        WidthType["PIXEL"] = "pixel";
        WidthType["PERCENTAGE"] = "percentage";
        return WidthType;
    }({});
});
parcelRegister("7agO8", function(module, exports) {
    $parcel$export(module.exports, "createMediaSpec", ()=>$5376813d9b4ea07d$export$35bdbf5bc8caa677);
    $parcel$export(module.exports, "copyPrivateAttributes", ()=>$5376813d9b4ea07d$export$111130fa8968d741);
    $parcel$export(module.exports, "media", ()=>$5376813d9b4ea07d$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "toJSON", ()=>$5376813d9b4ea07d$export$54fd2c36b5cc6731);
    var $51H8P;
    var $gthjq;
    const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, (0, parcelRequire("gthjq")).media)({}).attrs;
    const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
        const domNodeType = inline ? 'span' : 'div';
        const nodeName = inline ? 'mediaInline' : 'media';
        const parseDOM = [
            {
                tag: `${domNodeType}[data-node-type="${nodeName}"]`,
                getAttrs: (dom)=>{
                    const attrs = {};
                    if (attributes) Object.keys(attributes).forEach((k)=>{
                        const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                        const value = dom.getAttribute(`data-${key}`) || '';
                        if (value) attrs[k] = value;
                    });
                    if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                    const width = Number(attrs.width);
                    if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                    const height = Number(attrs.height);
                    if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                    return attrs;
                }
            },
            {
                tag: 'img[src^="data:image"]',
                ignore: true
            }
        ];
        const toDOM = (node)=>{
            const attrs = {
                'data-id': node.attrs.id,
                'data-node-type': `${nodeName}`,
                'data-type': node.attrs.type,
                'data-collection': node.attrs.collection,
                'data-occurrence-key': node.attrs.occurrenceKey,
                'data-width': node.attrs.width,
                'data-height': node.attrs.height,
                'data-url': node.attrs.url,
                'data-alt': node.attrs.alt,
                title: 'Attachment',
                style: `display: inline-block; border-radius: 3px; background: ${(0, (0, parcelRequire("51H8P")).N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
            };
            $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
            return [
                `${domNodeType}`,
                attrs
            ];
        };
        if (inline) return (0, (0, parcelRequire("gthjq")).mediaInline)({
            parseDOM: parseDOM,
            toDOM: toDOM
        });
        return (0, (0, parcelRequire("gthjq")).media)({
            parseDOM: [
                ...parseDOM,
                {
                    tag: 'img:not(.smart-link-icon)',
                    getAttrs: (dom)=>{
                        return {
                            type: 'external',
                            url: dom.getAttribute('src') || '',
                            alt: dom.getAttribute('alt') || ''
                        };
                    }
                }
            ],
            toDOM: toDOM
        });
    };
    const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
    const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
    const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
        if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const $5376813d9b4ea07d$var$optionalAttributes = [
        'occurrenceKey',
        'width',
        'height',
        'url',
        'alt'
    ];
    const $5376813d9b4ea07d$var$externalOnlyAttributes = [
        'type',
        'url',
        'width',
        'height',
        'alt'
    ];
    const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
                if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
                if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
                if ([
                    'width',
                    'height'
                ].indexOf(key) !== -1) {
                    obj[key] = Number(node.attrs[key]);
                    return obj;
                }
                obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("51H8P", function(module, exports) {
    $parcel$export(module.exports, "R50", ()=>$3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
    $parcel$export(module.exports, "R75", ()=>$3a8e82bcbd673dd1$export$b34b069eff244586);
    $parcel$export(module.exports, "R100", ()=>$3a8e82bcbd673dd1$export$be802dd0d8b57f35);
    $parcel$export(module.exports, "R300", ()=>$3a8e82bcbd673dd1$export$4a7404f376229999);
    $parcel$export(module.exports, "R400", ()=>$3a8e82bcbd673dd1$export$2010d0fb4295b346);
    $parcel$export(module.exports, "R500", ()=>$3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
    $parcel$export(module.exports, "Y50", ()=>$3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
    $parcel$export(module.exports, "Y75", ()=>$3a8e82bcbd673dd1$export$41060a744ab0b7ae);
    $parcel$export(module.exports, "Y200", ()=>$3a8e82bcbd673dd1$export$5aae31392d72caaa);
    $parcel$export(module.exports, "Y400", ()=>$3a8e82bcbd673dd1$export$59619663aa6500fb);
    $parcel$export(module.exports, "G50", ()=>$3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
    $parcel$export(module.exports, "G75", ()=>$3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
    $parcel$export(module.exports, "G200", ()=>$3a8e82bcbd673dd1$export$747d86715d4175de);
    $parcel$export(module.exports, "G300", ()=>$3a8e82bcbd673dd1$export$940e1f69e873f202);
    $parcel$export(module.exports, "G400", ()=>$3a8e82bcbd673dd1$export$a49394138f7b8e85);
    $parcel$export(module.exports, "G500", ()=>$3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
    $parcel$export(module.exports, "B50", ()=>$3a8e82bcbd673dd1$export$226de0355ed012f8);
    $parcel$export(module.exports, "B75", ()=>$3a8e82bcbd673dd1$export$8c13c2ee36917869);
    $parcel$export(module.exports, "B100", ()=>$3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
    $parcel$export(module.exports, "B400", ()=>$3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
    $parcel$export(module.exports, "B500", ()=>$3a8e82bcbd673dd1$export$a6ee3d71bc067634);
    $parcel$export(module.exports, "L200", ()=>$3a8e82bcbd673dd1$export$f72948ef771f6f15);
    $parcel$export(module.exports, "N0", ()=>$3a8e82bcbd673dd1$export$29a4f05edc054374);
    $parcel$export(module.exports, "N20", ()=>$3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
    $parcel$export(module.exports, "N30", ()=>$3a8e82bcbd673dd1$export$3e51e8f1440314ba);
    $parcel$export(module.exports, "N40", ()=>$3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
    $parcel$export(module.exports, "N50", ()=>$3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
    $parcel$export(module.exports, "N60", ()=>$3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
    $parcel$export(module.exports, "N80", ()=>$3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
    $parcel$export(module.exports, "N200", ()=>$3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
    $parcel$export(module.exports, "N300", ()=>$3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
    $parcel$export(module.exports, "Neutral300", ()=>$3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
    $parcel$export(module.exports, "N300A", ()=>$3a8e82bcbd673dd1$export$13609db0e6812ab8);
    $parcel$export(module.exports, "N500", ()=>$3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
    $parcel$export(module.exports, "N600", ()=>$3a8e82bcbd673dd1$export$7090862dc3038a9f);
    $parcel$export(module.exports, "N800", ()=>$3a8e82bcbd673dd1$export$7d61b15e0da132af);
    $parcel$export(module.exports, "N1000", ()=>$3a8e82bcbd673dd1$export$f78789c8b01753cd);
    $parcel$export(module.exports, "M200", ()=>$3a8e82bcbd673dd1$export$a19f0c33186f7767);
    $parcel$export(module.exports, "O200", ()=>$3a8e82bcbd673dd1$export$51716a84e62e022c);
    $parcel$export(module.exports, "P50", ()=>$3a8e82bcbd673dd1$export$363e4475840015bb);
    $parcel$export(module.exports, "P75", ()=>$3a8e82bcbd673dd1$export$4b0a4417ed59760f);
    $parcel$export(module.exports, "P100", ()=>$3a8e82bcbd673dd1$export$6011520a64d9a187);
    $parcel$export(module.exports, "P200", ()=>$3a8e82bcbd673dd1$export$a7175d4e9206bc80);
    $parcel$export(module.exports, "P300", ()=>$3a8e82bcbd673dd1$export$b48405b95304b5a1);
    $parcel$export(module.exports, "P500", ()=>$3a8e82bcbd673dd1$export$147899de772240ec);
    $parcel$export(module.exports, "T50", ()=>$3a8e82bcbd673dd1$export$2cf711fe14c66f06);
    $parcel$export(module.exports, "T75", ()=>$3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
    $parcel$export(module.exports, "T100", ()=>$3a8e82bcbd673dd1$export$776c9c497ef08533);
    $parcel$export(module.exports, "T200", ()=>$3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
    $parcel$export(module.exports, "T300", ()=>$3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
    $parcel$export(module.exports, "T500", ()=>$3a8e82bcbd673dd1$export$6036577f95c3877e);
    $parcel$export(module.exports, "normalizeHexColor", ()=>$3a8e82bcbd673dd1$export$b61655071712e690);
    $parcel$export(module.exports, "isHex", ()=>$3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
    $parcel$export(module.exports, "isRgb", ()=>$3a8e82bcbd673dd1$export$e698776ec826343);
    $parcel$export(module.exports, "rgbToHex", ()=>$3a8e82bcbd673dd1$export$34d09c4a771c46ef);
    $parcel$export(module.exports, "hexToRgb", ()=>$3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
    $parcel$export(module.exports, "hexToRgba", ()=>$3a8e82bcbd673dd1$export$9665a07d9187b414);
    var $3nnJa = parcelRequire("3nnJa");
    const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
    const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
    const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
    const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
    const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
    const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
    const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
    const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
    const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
    const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
    const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
    const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
    const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
    const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
    const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
    const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
    const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
    const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
    const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
    const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
    const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
    const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
    const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
    const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
    const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
    const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
    const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
    const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
    const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
    const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
    const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
    const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
    const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
    const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
    const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
    const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
    const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
    const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
    const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
    const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
    const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
    const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
    const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
    const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
    const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
    const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
    const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
    const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
    const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
    const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
    const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
    const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
    const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
    const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
    function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
        if (!color) return null;
        color = color.trim().toLowerCase();
        if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) {
            if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
        } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
        else {
            if (color === 'default') return null;
            else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
            else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
            else return null;
        }
        if (color === defaultColor) return null;
        return color;
    }
    function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
        if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
        let colorBits = color.substring(1).split('');
        if (colorBits.length === 3) colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2]
        ];
        const rgb = Number(`0x${colorBits.join('')}`);
        return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
    }
    function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
        const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
        if (!color) return null;
        const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
        return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
    }
    function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
        const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
        if (matches && matches.length >= 3) {
            const [red, green, blue] = matches.map(Number);
            return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
        }
        return null;
    }
    function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
        return /rgba?\(/.test(color);
    }
    function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
        return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
    }
});
parcelRegister("3nnJa", function(module, exports) {
    module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");
});
parcelRegister("g7Cky", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$bbcb0873d657d42d$export$db83999c14438df4);
    $parcel$export(module.exports, "toJSON", ()=>$bbcb0873d657d42d$export$54fd2c36b5cc6731);
    var $9IGaJ;
    var $gthjq;
    let $bbcb0873d657d42d$export$abebb208988c258 = function(USER_TYPES) {
        USER_TYPES["DEFAULT"] = "DEFAULT";
        USER_TYPES["SPECIAL"] = "SPECIAL";
        USER_TYPES["APP"] = "APP";
        return USER_TYPES;
    }({});
    const $bbcb0873d657d42d$export$db83999c14438df4 = (0, (0, parcelRequire("gthjq")).mention)({
        parseDOM: [
            {
                tag: 'span[data-mention-id]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                        text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                        accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    };
                    const userType = dom.getAttribute('data-user-type');
                    if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
            const attrs = {
                'data-mention-id': id,
                'data-access-level': accessLevel,
                contenteditable: 'false'
            };
            if (localId) attrs['data-local-id'] = localId;
            if (userType) attrs['data-user-type'] = userType;
            return [
                'span',
                attrs,
                text
            ];
        }
    });
    const $bbcb0873d657d42d$var$isOptional = (key)=>{
        return [
            'userType',
            'localId'
        ].indexOf(key) > -1;
    };
    const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("9IGaJ", function(module, exports) {
    $parcel$export(module.exports, "generateUuid", ()=>$7138efa2a0163ee8$export$1c3aefb711c3a4cc);
    $parcel$export(module.exports, "uuid", ()=>$7138efa2a0163ee8$export$31b40729666a4ae0);
    const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    let $7138efa2a0163ee8$var$staticValue = false;
    const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
        setStatic (value) {
            $7138efa2a0163ee8$var$staticValue = value;
        },
        generate () {
            return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
        }
    };
});
parcelRegister("9UDEr", function(module, exports) {
    $parcel$export(module.exports, "tablePrefixSelector", ()=>$737819f27951a815$export$9cfceb893b24742a);
    $parcel$export(module.exports, "tableCellSelector", ()=>$737819f27951a815$export$69cb4c3f80383763);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>$737819f27951a815$export$7b07d37d879c957f);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>$737819f27951a815$export$8dd42a84cd52da07);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>$737819f27951a815$export$5e26a5c19f0865d8);
    $parcel$export(module.exports, "getCellAttrs", ()=>$737819f27951a815$export$43977bde391e007);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>$737819f27951a815$export$363c8dda799bfe9c);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>$737819f27951a815$export$8cc2833b5b349a1e);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>$737819f27951a815$export$219b7f492ad209f8);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>$737819f27951a815$export$95e9c925fbf01d1c);
    $parcel$export(module.exports, "table", ()=>$737819f27951a815$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>$737819f27951a815$export$90e634fbace1f0c4);
    $parcel$export(module.exports, "tableStage0", ()=>$737819f27951a815$export$3862de5c8c9098cf);
    $parcel$export(module.exports, "tableToJSON", ()=>$737819f27951a815$export$1f92a2f429e06fa8);
    $parcel$export(module.exports, "tableRow", ()=>$737819f27951a815$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableCell", ()=>$737819f27951a815$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "toJSONTableCell", ()=>$737819f27951a815$export$2ac34c099660f1a8);
    $parcel$export(module.exports, "tableHeader", ()=>$737819f27951a815$export$48884d2a5190dc73);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>$737819f27951a815$export$2af48797a1010bb1);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$737819f27951a815$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$737819f27951a815$export$7d657479499397);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$737819f27951a815$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$737819f27951a815$export$2a5a518232fa1a97);
    var $daes7;
    var $51H8P;
    var $9IGaJ;
    var $87j2U;
    var $gthjq;
    const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
    const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
    const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
    const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
    const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
    const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, (0, parcelRequire("51H8P")).N20).toLocaleLowerCase();
    const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
        const widthAttr = dom.getAttribute('data-colwidth');
        const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
        const colspan = Number(dom.getAttribute('colspan') || 1);
        let { backgroundColor: backgroundColor } = dom.style;
        const dataCellBackground = dom.getAttribute('data-cell-background');
        const dataCellBackgroundHexCode = dataCellBackground && (0, (0, parcelRequire("51H8P")).isHex)(dataCellBackground) ? dataCellBackground : undefined;
        if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
        else if (backgroundColor && (0, (0, parcelRequire("51H8P")).isRgb)(backgroundColor)) {
            const result = (0, (0, parcelRequire("51H8P")).rgbToHex)(backgroundColor);
            if (result !== null) backgroundColor = result;
        }
        const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
        return {
            colspan: colspan,
            rowspan: Number(dom.getAttribute('rowspan') || 1),
            colwidth: width && width.length === colspan ? width : null,
            background: backgroundHexCode
        };
    };
    let $737819f27951a815$var$testGlobalTheme;
    const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
        $737819f27951a815$var$testGlobalTheme = theme;
    };
    const $737819f27951a815$var$getGlobalTheme = ()=>{
        if ($737819f27951a815$var$testGlobalTheme) return {
            colorMode: $737819f27951a815$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
    const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
        const attrs = {};
        const nodeType = node.type.name;
        if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
        if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
        if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
        if (node.attrs.background) {
            const { background: background } = node.attrs;
            const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
            if (ignored) attrs.style = '';
            else {
                const color = (0, (0, parcelRequire("51H8P")).isRgb)(background) && (0, (0, parcelRequire("51H8P")).rgbToHex)(background) ? (0, (0, parcelRequire("51H8P")).rgbToHex)(background) : background;
                const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorBackgroundPaletteRawValue)(color);
                if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
                else if ($737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
                else if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') attrs.style = `background-color: ${(0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(color)};`;
                else attrs.style = `background-color: ${background};`;
                if (color) attrs['data-cell-background'] = color;
                attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
            }
        }
        if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
        else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
        return attrs;
    };
    const $737819f27951a815$export$219b7f492ad209f8 = new Map();
    const $737819f27951a815$export$95e9c925fbf01d1c = (0, (0, parcelRequire("51H8P")).hexToRgba)((0, (0, parcelRequire("51H8P")).N800), 0.12) || (0, (0, parcelRequire("51H8P")).N0);
    const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
    [
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B50),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T50),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G50),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y50),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R50),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N20),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P75),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N60),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T100),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G200),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Dark yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R100),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P100),
            'Dark purple'
        ]
    ].forEach(([colorValue, colorName])=>{
        $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
        $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    });
    const $737819f27951a815$var$tableNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    };
    const $737819f27951a815$var$createTableSpec = ()=>(0, (0, parcelRequire("gthjq")).table)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
    const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
    const $737819f27951a815$var$tableRowNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'tr'
            }
        ],
        toDOM () {
            return [
                'tr',
                0
            ];
        }
    };
    const $737819f27951a815$export$ce666bf02318c957 = (0, (0, parcelRequire("gthjq")).tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$var$cellAttrs = {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    };
    const $737819f27951a815$var$tableCellNodeSpecOptions = {
        parseDOM: [
            {
                tag: '.ak-renderer-table-number-column',
                ignore: true
            },
            {
                tag: 'td',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
            }
        ],
        toDOM: (node)=>[
                'td',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$e1e720e5f4603e6a = (0, (0, parcelRequire("gthjq")).tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
    const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'th',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                        background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                    })
            }
        ],
        toDOM: (node)=>[
                'th',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$48884d2a5190dc73 = (0, (0, parcelRequire("gthjq")).tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
    const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
    const $737819f27951a815$export$ce086a560a1d05f5 = (0, (0, parcelRequire("gthjq")).tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$7d657479499397 = (0, (0, parcelRequire("gthjq")).tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$export$abf39ca178940ff3 = (0, (0, parcelRequire("gthjq")).tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2a5a518232fa1a97 = (0, (0, parcelRequire("gthjq")).tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);
});
parcelRegister("daes7", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBorderPaletteColor", ()=>$99576b847e5fbb17$export$bad3c41dd33cb4bc);
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$99576b847e5fbb17$export$9c2f408d391feb93);
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$99576b847e5fbb17$export$8b58ff1b36bb75e0);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$99576b847e5fbb17$export$a270511a0e7fd61a);
    function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
        return $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
        '#091E4224': 'var(--ds-border, #091E4224)',
        '#758195': 'var(--ds-border-bold, #758195)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
        return $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$57fa5089caad992 = {
        '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
        '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
        '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
        '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
        '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
        '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
        '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
        '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
        '#006644': 'var(--ds-text-accent-green, #006644)',
        '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
        '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
        '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
        '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
        '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
        '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
        '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
        '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
        '#403294': 'var(--ds-text-accent-purple, #403294)',
        '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
        '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
        return $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$12a518ff137dd389 = {
        '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
        '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
        '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
        '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
        '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
        '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
    };
    function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
        const tokenData = $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $99576b847e5fbb17$export$2462741d70e6a62f = {
        '#DEEBFF': {
            getValue: ()=>'#DEEBFF',
            token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
        },
        '#B3D4FF': {
            getValue: ()=>'#B3D4FF',
            token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
        },
        '#4C9AFF': {
            getValue: ()=>'#4C9AFF',
            token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
        },
        '#E6FCFF': {
            getValue: ()=>'#E6FCFF',
            token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
        },
        '#B3F5FF': {
            getValue: ()=>'#B3F5FF',
            token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
        },
        '#79E2F2': {
            getValue: ()=>'#79E2F2',
            token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
        },
        '#E3FCEF': {
            getValue: ()=>'#E3FCEF',
            token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
        },
        '#ABF5D1': {
            getValue: ()=>'#ABF5D1',
            token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
        },
        '#57D9A3': {
            getValue: ()=>'#57D9A3',
            token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
        },
        '#FFFAE6': {
            getValue: ()=>'#FFFAE6',
            token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
        },
        '#FFF0B3': {
            getValue: ()=>'#FFF0B3',
            token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
        },
        '#FFC400': {
            getValue: ()=>'#FFC400',
            token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
        },
        '#FFEBE6': {
            getValue: ()=>'#FFEBE6',
            token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
        },
        '#FFBDAD': {
            getValue: ()=>'#FFBDAD',
            token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
        },
        '#FF8F73': {
            getValue: ()=>'#FF8F73',
            token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
        },
        '#EAE6FF': {
            getValue: ()=>'#EAE6FF',
            token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
        },
        '#C0B6F2': {
            getValue: ()=>'#C0B6F2',
            token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
        },
        '#998DD9': {
            getValue: ()=>'#998DD9',
            token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
        },
        '#FFFFFF': {
            getValue: ()=>'#FFFFFF',
            token: 'var(--ds-surface, #FFFFFF)'
        },
        '#F4F5F7': {
            getValue: ()=>'#F4F5F7',
            token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
        },
        '#B3BAC5': {
            getValue: ()=>'#B3BAC5',
            token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
        }
    };
});
parcelRegister("87j2U", function(module, exports) {
    $parcel$export(module.exports, "getDarkModeLCHColor", ()=>$5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
    const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
        const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
    const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
    const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
        return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
    };
    const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return 0;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        return lch.l;
    };
    const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
        const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
        const newLightness = Math.abs(100 - lightness);
        return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
    };
});
parcelRegister("kOFhM", function(module, exports) {
    $parcel$export(module.exports, "defaultSchemaConfig", ()=>$f27880a8173018db$export$e4e3ac1fa64862db);
    $parcel$export(module.exports, "getSchemaBasedOnStage", ()=>$f27880a8173018db$export$fd147e7d448dea03);
    $parcel$export(module.exports, "defaultSchema", ()=>$f27880a8173018db$export$1db618b7b2275ea1);
    var $8QpSo;
    var $aXBFx;
    var $7kC9H;
    var $47jug;
    var $gZoER;
    var $2FIVU;
    var $bFtEE;
    var $9UDEr;
    var $kBho7;
    const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
        const defaultSchemaConfig = {
            nodes: [
                'doc',
                'paragraph',
                'text',
                'bulletList',
                'orderedList',
                'listItem',
                'heading',
                'blockquote',
                'codeBlock',
                'panel',
                'rule',
                'image',
                'caption',
                'mention',
                'media',
                'mediaGroup',
                'mediaSingle',
                'mediaInline',
                'confluenceUnsupportedBlock',
                'confluenceUnsupportedInline',
                'confluenceJiraIssue',
                'expand',
                'nestedExpand',
                'extension',
                'inlineExtension',
                'bodiedExtension',
                'hardBreak',
                'emoji',
                'table',
                'tableCell',
                'tableHeader',
                'tableRow',
                'decisionList',
                'decisionItem',
                'taskList',
                'taskItem',
                'unknownBlock',
                'date',
                'status',
                'placeholder',
                'layoutSection',
                'layoutColumn',
                'inlineCard',
                'blockCard',
                'embedCard',
                'unsupportedBlock',
                'unsupportedInline'
            ],
            marks: [
                'link',
                'em',
                'strong',
                'strike',
                'subsup',
                'underline',
                'code',
                'textColor',
                'backgroundColor',
                'confluenceInlineComment',
                'breakout',
                'alignment',
                'indentation',
                'annotation',
                'dataConsumer',
                'border',
                'unsupportedMark',
                'unsupportedNodeAttribute',
                'typeAheadQuery',
                'fragment'
            ]
        };
        return defaultSchemaConfig;
    };
    const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
    const $f27880a8173018db$export$fd147e7d448dea03 = (0, (0, parcelRequire("8QpSo")).default)((stage = 'final')=>{
        const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
        if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
            layoutSection: (0, (0, parcelRequire("gZoER")).layoutSectionWithSingleColumn),
            multiBodiedExtension: (0, (0, parcelRequire("47jug")).multiBodiedExtension),
            extensionFrame: (0, (0, parcelRequire("47jug")).extensionFrame),
            expand: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand),
            blockquote: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia),
            listItem: (0, (0, parcelRequire("2FIVU")).listItemWithDecisionStage0),
            panel: (0, (0, parcelRequire("bFtEE")).panelWithBlockquoteStage0)(true),
            table: (0, (0, parcelRequire("9UDEr")).tableWithNestedTable),
            tableRow: (0, (0, parcelRequire("9UDEr")).tableRowWithNestedTable),
            tableCell: (0, (0, parcelRequire("9UDEr")).tableCellWithNestedTable),
            tableHeader: (0, (0, parcelRequire("9UDEr")).tableHeaderWithNestedTable)
        };
        return (0, (0, parcelRequire("kBho7")).createSchema)(defaultSchemaConfig);
    });
    const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();
});
parcelRegister("aXBFx", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$7faca2534e4894a0$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>$7faca2534e4894a0$export$c4d50234112df933);
    $parcel$export(module.exports, "blockquoteWithList", ()=>$7faca2534e4894a0$export$9b4686c4b9672643);
    var $gthjq;
    const $7faca2534e4894a0$var$nodeSpecOptions = {
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    };
    const $7faca2534e4894a0$export$67dc04e652a298ca = (0, (0, parcelRequire("gthjq")).blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$c4d50234112df933 = (0, (0, parcelRequire("gthjq")).blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, (0, parcelRequire("gthjq")).blockquoteWithoutNestedCodeblockOrMedia)({
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    });
});
parcelRegister("47jug", function(module, exports) {
    $parcel$export(module.exports, "extensionFrame", ()=>$2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$2ff6ee9baaedd4b6$export$c3c04d555a8b9013);
    var $CWpyq;
    var $gthjq;
    const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, (0, parcelRequire("gthjq")).extensionFrameStage0)({
        parseDOM: [
            {
                context: 'extensionFrame//',
                tag: 'div[data-extension-frame]',
                skip: true
            },
            {
                tag: 'div[data-extension-frame]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-extension-frame': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, (0, parcelRequire("gthjq")).multiBodiedExtensionStage0)({
        parseDOM: [
            {
                context: 'multiBodiedExtension//',
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'multi-bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("CWpyq", function(module, exports) {
    $parcel$export(module.exports, "getExtensionAttrs", ()=>$0750dbf71b86cced$export$1765e2758fc47004);
    const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
        return !!name && [
            'default',
            'wide',
            'full-width'
        ].includes(name);
    };
    const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
        const extensionType = dom.getAttribute('data-extension-type');
        const extensionKey = dom.getAttribute('data-extension-key');
        if (!extensionType || !extensionKey) return false;
        const attrs = {
            extensionType: extensionType,
            extensionKey: extensionKey,
            text: dom.getAttribute('data-text') || undefined,
            parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
            localId: dom.getAttribute('data-local-id') || undefined
        };
        if (!isInline) {
            const rawLayout = dom.getAttribute('data-layout');
            attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
        }
        return attrs;
    };
});
parcelRegister("gZoER", function(module, exports) {
    $parcel$export(module.exports, "layoutSection", ()=>$c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>$c5e57867b1f8b9c7$export$4f9d8f623ff17117);
    var $gthjq;
    const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("gthjq")).layoutSection)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, (0, parcelRequire("gthjq")).layoutSectionFull)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, (0, parcelRequire("gthjq")).layoutSectionWithSingleColumnStage0)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]',
                getAttrs: (dom)=>{
                    const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                    return columnRuleStyle ? {
                        columnRuleStyle: columnRuleStyle
                    } : {};
                }
            }
        ],
        toDOM (node) {
            const { columnRuleStyle: columnRuleStyle } = node.attrs;
            const attrs = {
                'data-layout-section': 'true',
                'data-column-rule-style': columnRuleStyle || undefined
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("2FIVU", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$1f2243de0d109562$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithTask", ()=>$1f2243de0d109562$export$58dca2f0678302a4);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>$1f2243de0d109562$export$b2cd54d5ce935ddb);
    var $gthjq;
    const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("gthjq")).listItem)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
    const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
    const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, (0, parcelRequire("gthjq")).listItemWithNestedDecisionStage0)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
});
parcelRegister("bFtEE", function(module, exports) {
    $parcel$export(module.exports, "PanelType", ()=>$87ea86de426496d8$export$969277cf61e5a7aa);
    $parcel$export(module.exports, "extendedPanel", ()=>$87ea86de426496d8$export$ce20b13564211141);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>$87ea86de426496d8$export$1f8c55a804c909c7);
    var $gthjq;
    let $87ea86de426496d8$export$969277cf61e5a7aa = function(PanelType) {
        PanelType["INFO"] = "info";
        PanelType["NOTE"] = "note";
        PanelType["TIP"] = "tip";
        PanelType["WARNING"] = "warning";
        PanelType["ERROR"] = "error";
        PanelType["SUCCESS"] = "success";
        PanelType["CUSTOM"] = "custom";
        return PanelType;
    }({});
    const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
        const attrs = {
            'data-panel-type': nodeAttrs.panelType,
            'data-panel-icon': nodeAttrs.panelIcon,
            'data-panel-icon-id': nodeAttrs.panelIconId,
            'data-panel-icon-text': nodeAttrs.panelIconText,
            'data-panel-color': nodeAttrs.panelColor
        };
        return attrs;
    };
    const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
        let parseDOMAttrs = {
            panelType: dom.getAttribute('data-panel-type')
        };
        if (allowCustomPanel) parseDOMAttrs = {
            ...parseDOMAttrs,
            panelIcon: dom.getAttribute('data-panel-icon'),
            panelIconId: dom.getAttribute('data-panel-icon-id'),
            panelIconText: dom.getAttribute('data-panel-icon-text'),
            panelColor: dom.getAttribute('data-panel-color')
        };
        else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
        return parseDOMAttrs;
    };
    const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panel)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
    const $87ea86de426496d8$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panelWithNestedBlockquoteStage0)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
});
parcelRegister("kBho7", function(module, exports) {
    $parcel$export(module.exports, "createSchema", ()=>$eff4c0443be4d23b$export$5f4ce795563f4211);
    var $kCV8T;
    var $aeGrH;
    var $88i6h;
    var $8jJss;
    var $14Vqw;
    var $zceQE;
    var $lcXoV;
    var $71k4W;
    var $cUwVZ;
    var $l3Tmi;
    var $29Vii;
    var $fK6mK;
    var $8XeG6;
    var $aUhe2;
    var $hhtT8;
    var $4NwJJ;
    var $c9aa1;
    var $dtyqo;
    var $8EAPB;
    var $jxVez;
    var $lVmBd;
    var $21PS7;
    var $aXBFx;
    var $5AxYU;
    var $kjhhp;
    var $5JeV5;
    var $8vlrc;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $b2VmY;
    var $Khvpb;
    var $8gSD8;
    var $xjCuM;
    var $kshOv;
    var $7DoMR;
    var $7kC9H;
    var $bFtEE;
    var $hhN5g;
    var $47jug;
    var $jnMM2;
    var $lRTZM;
    var $7lRBh;
    var $cCBEe;
    var $5BOuQ;
    var $4EbxI;
    var $gZoER;
    var $2FIVU;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $g7Cky;
    var $dx5eC;
    var $dwptW;
    var $abme3;
    var $dgJoa;
    var $M4hHz;
    var $18bvk;
    var $9UDEr;
    var $iThOL;
    var $43mJF;
    var $3DR6L;
    var $9X587;
    var $d1d6m;
    var $6kr5W;
    function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
        if (!config) return {};
        const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
            if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
            return items;
        }, {});
        return Object.keys(customSpecs).reduce((items, name)=>{
            if (items[name]) return items;
            items[name] = customSpecs[name];
            return items;
        }, items);
    }
    function $eff4c0443be4d23b$var$groupDeclaration(name) {
        return {
            name: `__${name}GroupDeclaration`,
            spec: {
                group: name
            }
        };
    }
    const $eff4c0443be4d23b$var$markGroupDeclarations = [
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
    ];
    const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
    const $eff4c0443be4d23b$var$nodesInOrder = [
        {
            name: 'doc',
            spec: (0, (0, parcelRequire("xjCuM")).doc)
        },
        {
            name: 'paragraph',
            spec: (0, (0, parcelRequire("abme3")).paragraph)
        },
        {
            name: 'text',
            spec: (0, (0, parcelRequire("3DR6L")).text)
        },
        {
            name: 'bulletList',
            spec: (0, (0, parcelRequire("kjhhp")).bulletList)
        },
        {
            name: 'orderedList',
            spec: (0, (0, parcelRequire("dwptW")).orderedListWithOrder)
        },
        {
            name: 'listItem',
            spec: (0, (0, parcelRequire("2FIVU")).listItemWithTask)
        },
        {
            name: 'heading',
            spec: (0, (0, parcelRequire("lRTZM")).heading)
        },
        {
            name: 'blockquote',
            spec: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia)
        },
        {
            name: 'codeBlock',
            spec: (0, (0, parcelRequire("8vlrc")).codeBlock)
        },
        {
            name: 'panel',
            spec: (0, (0, parcelRequire("bFtEE")).extendedPanel)(true)
        },
        {
            name: 'rule',
            spec: (0, (0, parcelRequire("M4hHz")).rule)
        },
        {
            name: 'image',
            spec: (0, (0, parcelRequire("7lRBh")).image)
        },
        {
            name: 'mention',
            spec: (0, (0, parcelRequire("g7Cky")).mention)
        },
        {
            name: 'caption',
            spec: (0, (0, parcelRequire("5JeV5")).caption)
        },
        {
            name: 'media',
            spec: (0, (0, parcelRequire("7agO8")).media)
        },
        {
            name: 'mediaGroup',
            spec: (0, (0, parcelRequire("92lix")).mediaGroup)
        },
        {
            name: 'mediaSingle',
            spec: (0, (0, parcelRequire("bIGZ7")).mediaSingleFull)
        },
        {
            name: 'mediaInline',
            spec: (0, (0, parcelRequire("7Xgp3")).mediaInline)
        },
        {
            name: 'placeholder',
            spec: (0, (0, parcelRequire("dgJoa")).placeholder)
        },
        {
            name: 'layoutSection',
            spec: (0, (0, parcelRequire("gZoER")).layoutSection)
        },
        {
            name: 'layoutColumn',
            spec: (0, (0, parcelRequire("4EbxI")).layoutColumn)
        },
        {
            name: 'hardBreak',
            spec: (0, (0, parcelRequire("jnMM2")).hardBreak)
        },
        {
            name: 'emoji',
            spec: (0, (0, parcelRequire("7DoMR")).emoji)
        },
        {
            name: 'table',
            spec: (0, (0, parcelRequire("9UDEr")).table)
        },
        {
            name: 'tableCell',
            spec: (0, (0, parcelRequire("9UDEr")).tableCell)
        },
        {
            name: 'tableRow',
            spec: (0, (0, parcelRequire("9UDEr")).tableRow)
        },
        {
            name: 'tableHeader',
            spec: (0, (0, parcelRequire("9UDEr")).tableHeader)
        },
        {
            name: 'confluenceJiraIssue',
            spec: (0, (0, parcelRequire("6bbHe")).confluenceJiraIssue)
        },
        {
            name: 'confluenceUnsupportedInline',
            spec: (0, (0, parcelRequire("bd7A9")).confluenceUnsupportedInline)
        },
        {
            name: 'confluenceUnsupportedBlock',
            spec: (0, (0, parcelRequire("5y0tR")).confluenceUnsupportedBlock)
        },
        {
            name: 'decisionList',
            spec: (0, (0, parcelRequire("8gSD8")).decisionList)
        },
        {
            name: 'decisionItem',
            spec: (0, (0, parcelRequire("Khvpb")).decisionItem)
        },
        {
            name: 'taskList',
            spec: (0, (0, parcelRequire("43mJF")).taskList)
        },
        {
            name: 'taskItem',
            spec: (0, (0, parcelRequire("iThOL")).taskItem)
        },
        {
            name: 'date',
            spec: (0, (0, parcelRequire("b2VmY")).date)
        },
        {
            name: 'status',
            spec: (0, (0, parcelRequire("18bvk")).status)
        },
        {
            name: 'expand',
            spec: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand)
        },
        {
            name: 'nestedExpand',
            spec: (0, (0, parcelRequire("dx5eC")).nestedExpand)
        },
        {
            name: 'extension',
            spec: (0, (0, parcelRequire("hhN5g")).extension)
        },
        {
            name: 'inlineExtension',
            spec: (0, (0, parcelRequire("5BOuQ")).inlineExtension)
        },
        {
            name: 'bodiedExtension',
            spec: (0, (0, parcelRequire("5AxYU")).bodiedExtension)
        },
        {
            name: 'multiBodiedExtension',
            spec: (0, (0, parcelRequire("47jug")).multiBodiedExtension)
        },
        {
            name: 'extensionFrame',
            spec: (0, (0, parcelRequire("47jug")).extensionFrame)
        },
        {
            name: 'inlineCard',
            spec: (0, (0, parcelRequire("cCBEe")).inlineCard)
        },
        {
            name: 'blockCard',
            spec: (0, (0, parcelRequire("21PS7")).blockCard)
        },
        {
            name: 'embedCard',
            spec: (0, (0, parcelRequire("kshOv")).embedCard)
        },
        {
            name: 'unknownBlock',
            spec: (0, (0, parcelRequire("9X587")).default)
        },
        {
            name: 'unsupportedBlock',
            spec: (0, (0, parcelRequire("d1d6m")).unsupportedBlock)
        },
        {
            name: 'unsupportedInline',
            spec: (0, (0, parcelRequire("6kr5W")).unsupportedInline)
        }
    ];
    const $eff4c0443be4d23b$var$marksInOrder = [
        {
            name: 'link',
            spec: (0, (0, parcelRequire("8XeG6")).link)
        },
        {
            name: 'em',
            spec: (0, (0, parcelRequire("l3Tmi")).em)
        },
        {
            name: 'strong',
            spec: (0, (0, parcelRequire("hhtT8")).strong)
        },
        {
            name: 'textColor',
            spec: (0, (0, parcelRequire("c9aa1")).textColor)
        },
        {
            name: 'backgroundColor',
            spec: (0, (0, parcelRequire("8jJss")).backgroundColor)
        },
        {
            name: 'strike',
            spec: (0, (0, parcelRequire("aUhe2")).strike)
        },
        {
            name: 'subsup',
            spec: (0, (0, parcelRequire("4NwJJ")).subsup)
        },
        {
            name: 'underline',
            spec: (0, (0, parcelRequire("8EAPB")).underline)
        },
        {
            name: 'code',
            spec: (0, (0, parcelRequire("lcXoV")).code)
        },
        {
            name: 'typeAheadQuery',
            spec: (0, (0, parcelRequire("dtyqo")).typeAheadQuery)
        },
        {
            name: 'alignment',
            spec: (0, (0, parcelRequire("aeGrH")).alignment)
        },
        {
            name: 'annotation',
            spec: (0, (0, parcelRequire("88i6h")).annotation)
        },
        {
            name: 'confluenceInlineComment',
            spec: (0, (0, parcelRequire("71k4W")).confluenceInlineComment)
        },
        ...$eff4c0443be4d23b$var$markGroupDeclarations,
        {
            name: 'breakout',
            spec: (0, (0, parcelRequire("zceQE")).breakout)
        },
        {
            name: 'dataConsumer',
            spec: (0, (0, parcelRequire("cUwVZ")).dataConsumer)
        },
        {
            name: 'fragment',
            spec: (0, (0, parcelRequire("29Vii")).fragment)
        },
        {
            name: 'indentation',
            spec: (0, (0, parcelRequire("fK6mK")).indentation)
        },
        {
            name: 'border',
            spec: (0, (0, parcelRequire("14Vqw")).border)
        },
        {
            name: 'unsupportedMark',
            spec: (0, (0, parcelRequire("jxVez")).unsupportedMark)
        },
        {
            name: 'unsupportedNodeAttribute',
            spec: (0, (0, parcelRequire("lVmBd")).unsupportedNodeAttribute)
        }
    ];
    function $eff4c0443be4d23b$export$2d0c32a809131488() {
        const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        return {
            nodes: nodes,
            marks: marks
        };
    }
    function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
        const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
        const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
        const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
        let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
        const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
        nodes = $eff4c0443be4d23b$export$daf54fed04c8fb77(nodes, marks);
        return new (0, (0, parcelRequire("kCV8T")).Schema)({
            nodes: nodes,
            marks: marks
        });
    }
    function $eff4c0443be4d23b$export$daf54fed04c8fb77(nodes, supportedMarks) {
        const nodeNames = Object.keys(nodes);
        nodeNames.forEach((nodeKey)=>{
            const nodeSpec = {
                ...nodes[nodeKey]
            };
            if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
            if (nodeSpec.content) nodeSpec.content = $eff4c0443be4d23b$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
            nodes[nodeKey] = nodeSpec;
        });
        return nodes;
    }
    function $eff4c0443be4d23b$export$9cb535b0ed27c9c(nodes, rawContent) {
        const content = rawContent.replace(/\W/g, ' ');
        const contentKeys = content.split(' ');
        const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$eff4c0443be4d23b$var$isContentSupported(nodes, contentKey));
        return unsupportedContentKeys.reduce((newContent, nodeName)=>$eff4c0443be4d23b$var$sanitizedContent(newContent, nodeName), rawContent);
    }
    function $eff4c0443be4d23b$var$sanitizedContent(content, invalidContent) {
        if (!invalidContent.length) return content || '';
        if (!content || !content.match(/\w/)) return '';
        const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
        return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
    }
    function $eff4c0443be4d23b$var$isContentSupported(nodes, contentKey) {
        const nodeKeys = Object.keys(nodes);
        if (nodeKeys.indexOf(contentKey) > -1) return true;
        for(const supportedKey in nodes){
            const nodeSpec = nodes[supportedKey];
            if (nodeSpec && nodeSpec.group === contentKey) return true;
        }
        return false;
    }
    const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;
});
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';
parcelRegister("aeGrH", function(module, exports) {
    $parcel$export(module.exports, "alignmentPositionMap", ()=>$773c2309706a915e$export$be9cf49015769bbd);
    $parcel$export(module.exports, "alignment", ()=>$773c2309706a915e$export$8e53000a4ec837);
    var $2fTAU;
    const $773c2309706a915e$export$be9cf49015769bbd = {
        end: 'right',
        right: 'end',
        center: 'center'
    };
    const $773c2309706a915e$export$8e53000a4ec837 = (0, (0, parcelRequire("2fTAU")).alignment)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-block-mark',
                getAttrs: (dom)=>{
                    const align = dom.getAttribute('data-align');
                    return align ? {
                        align: align
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                    'data-align': mark.attrs.align
                },
                0
            ];
        }
    });
});
parcelRegister("88i6h", function(module, exports) {
    $parcel$export(module.exports, "AnnotationTypes", ()=>$5ebd1c6c912098fc$export$94aa2fc69ad33d19);
    $parcel$export(module.exports, "AnnotationMarkStates", ()=>$5ebd1c6c912098fc$export$4bab14797673da9f);
    $parcel$export(module.exports, "buildDataAttributes", ()=>$5ebd1c6c912098fc$export$93a98caa8bc6cb07);
    $parcel$export(module.exports, "annotation", ()=>$5ebd1c6c912098fc$export$8512c9afa7b24c3b);
    var $2fTAU;
    let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = function(AnnotationTypes) {
        AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
        return AnnotationTypes;
    }({});
    let $5ebd1c6c912098fc$export$4bab14797673da9f = function(AnnotationMarkStates) {
        AnnotationMarkStates["RESOLVED"] = "resolved";
        AnnotationMarkStates["ACTIVE"] = "active";
        return AnnotationMarkStates;
    }({});
    function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
        const data = {
            'data-mark-type': 'annotation',
            'data-mark-annotation-type': annotationType,
            'data-id': id
        };
        if (state) return {
            ...data,
            'data-mark-annotation-state': state
        };
        return data;
    }
    const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, (0, parcelRequire("2fTAU")).annotation)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="annotation"]',
                mark: 'annotation',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-id'),
                        annotationType: dom.getAttribute('data-mark-annotation-type')
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'class': 'fabric-editor-annotation',
                    ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                        id: node.attrs.id,
                        annotationType: node.attrs.annotationType
                    })
                },
                0
            ];
        }
    });
});
parcelRegister("8jJss", function(module, exports) {
    $parcel$export(module.exports, "backgroundColor", ()=>$60e35c16db44f137$export$8c5a050822fd698c);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $c9aa1;
    var $87j2U;
    const $60e35c16db44f137$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).Neutral300),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T200),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).L200),
            'Lime'
        ],
        [
            (0, (0, parcelRequire("51H8P")).O200),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).M200),
            'Magenta'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P200),
            'Purple'
        ]
    ];
    const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
    $60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
    const $60e35c16db44f137$export$8c5a050822fd698c = (0, (0, parcelRequire("2fTAU")).backgroundColor)({
        parseDOM: [
            {
                style: 'background-color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-background-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.backgroundCustomColor;
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ((0, (0, parcelRequire("c9aa1")).getGlobalTheme)().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-background-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-background-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("c9aa1", function(module, exports) {
    $parcel$export(module.exports, "colorPalette", ()=>$8d7e34fd69d04bb8$export$569885e57444f84a);
    $parcel$export(module.exports, "getGlobalTheme", ()=>$8d7e34fd69d04bb8$export$813ecdf77207a053);
    $parcel$export(module.exports, "textColor", ()=>$8d7e34fd69d04bb8$export$32f78bffcd82ff28);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $87j2U;
    const $8d7e34fd69d04bb8$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).B500),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T500),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G500),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y400),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R500),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P500),
            'Dark purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N80),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T300),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G300),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R300),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P300),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ]
    ];
    const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
    const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
    $8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
    let $8d7e34fd69d04bb8$var$testGlobalTheme;
    const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
        $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
    };
    const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
        if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
            colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, (0, parcelRequire("2fTAU")).textColor)({
        parseDOM: [
            {
                style: 'color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-text-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.textCustomColor;
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-text-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-text-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("14Vqw", function(module, exports) {
    $parcel$export(module.exports, "borderColorPalette", ()=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7);
    $parcel$export(module.exports, "border", ()=>$0c92b5eb9dbe9377$export$1edee58a52776cd9);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).N300A),
            'Subtle gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N600),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N1000),
            'Bold gray'
        ]
    ];
    const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
    $0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
    const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, (0, parcelRequire("2fTAU")).border)({
        parseDOM: [
            {
                tag: '[data-mark-type="border"]',
                getAttrs: (domNode)=>{
                    var _dom$getAttribute, _dom$getAttribute2;
                    const dom = domNode;
                    const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                    const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                    return {
                        size: size > 3 ? 3 : size < 1 ? false : size,
                        color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                    };
                }
            }
        ],
        toDOM (mark, isInline) {
            const wrapperStyle = isInline ? 'span' : 'div';
            const paletteColorValue = (0, (0, parcelRequire("daes7")).hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'border',
                    'data-color': mark.attrs.color,
                    'data-size': mark.attrs.size,
                    style: `--custom-palette-color: ${paletteColorValue}`
                }
            ];
        }
    });
});
parcelRegister("zceQE", function(module, exports) {
    $parcel$export(module.exports, "breakout", ()=>$069cc34ec2ef025e$export$89015c65f1c75e3f);
    var $2fTAU;
    const $069cc34ec2ef025e$var$allowedTypes = [
        'wide',
        'full-width'
    ];
    const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, (0, parcelRequire("2fTAU")).breakout)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-breakout-mark',
                getAttrs (dom) {
                    const mode = dom.getAttribute('data-mode');
                    const width = dom.getAttribute('data-width');
                    return {
                        mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                        width: width ? parseInt(width) : null
                    };
                }
            }
        ],
        toDOM (mark) {
            var _mark$attrs;
            return [
                'div',
                {
                    class: 'fabric-editor-breakout-mark',
                    'data-mode': mark.attrs.mode,
                    'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
                },
                0
            ];
        }
    });
});
parcelRegister("lcXoV", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$f708cbc93f02b120$export$6565f9f03506010b);
    var $2fTAU;
    const $f708cbc93f02b120$export$6565f9f03506010b = (0, (0, parcelRequire("2fTAU")).code)({
        parseDOM: [
            {
                tag: 'span.code',
                preserveWhitespace: true
            },
            {
                tag: 'code',
                preserveWhitespace: true
            },
            {
                tag: 'tt',
                preserveWhitespace: true
            },
            {
                tag: 'span',
                preserveWhitespace: true,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre') return {};
                    if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                    return false;
                }
            }
        ],
        toDOM () {
            return [
                'span',
                {
                    class: 'code',
                    spellcheck: 'false'
                }
            ];
        }
    });
});
parcelRegister("71k4W", function(module, exports) {
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$51c833981031ae17$export$f3b72f8fc4684ecd);
    var $2fTAU;
    const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("2fTAU")).confluenceInlineComment)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="confluenceInlineComment"]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-mark-type': 'confluenceInlineComment',
                    'data-reference': node.attrs.reference
                }
            ];
        }
    });
});
parcelRegister("l3Tmi", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$f554d1dac524ac83$export$c63c6f932822f543);
    var $2fTAU;
    const $f554d1dac524ac83$var$emDOM = [
        'em'
    ];
    const $f554d1dac524ac83$export$c63c6f932822f543 = (0, (0, parcelRequire("2fTAU")).em)({
        parseDOM: [
            {
                tag: 'i'
            },
            {
                tag: 'em'
            },
            {
                style: 'font-style=italic'
            }
        ],
        toDOM () {
            return $f554d1dac524ac83$var$emDOM;
        }
    });
});
parcelRegister("fK6mK", function(module, exports) {
    $parcel$export(module.exports, "indentation", ()=>$b760170dcfe13435$export$480c699bd4ec0d86);
    var $2fTAU;
    const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, (0, parcelRequire("2fTAU")).indentation)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-indentation-mark',
                getAttrs (dom) {
                    const level = +(dom.getAttribute('data-level') || '0');
                    return {
                        level: level > 6 ? 6 : level < 1 ? false : level
                    };
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                    'data-level': mark.attrs.level
                },
                0
            ];
        }
    });
});
parcelRegister("aUhe2", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$7f0c7ef7d4ef76e7$export$4899a95d70ec5056);
    var $2fTAU;
    const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, (0, parcelRequire("2fTAU")).strike)({
        parseDOM: [
            {
                tag: 'strike'
            },
            {
                tag: 's'
            },
            {
                tag: 'del'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'line-through' && null
            }
        ],
        toDOM () {
            return [
                's'
            ];
        }
    });
});
parcelRegister("hhtT8", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$c94b3560d4129743$export$59ae2c325a998f89);
    var $2fTAU;
    const $c94b3560d4129743$var$strongDOM = [
        'strong'
    ];
    const $c94b3560d4129743$export$59ae2c325a998f89 = (0, (0, parcelRequire("2fTAU")).strong)({
        parseDOM: [
            {
                tag: 'strong'
            },
            {
                tag: 'b',
                getAttrs (node) {
                    const element = node;
                    return element.style.fontWeight !== 'normal' && null;
                }
            },
            {
                tag: 'span',
                getAttrs (node) {
                    const element = node;
                    const { fontWeight: fontWeight } = element.style;
                    return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
                }
            }
        ],
        toDOM () {
            return $c94b3560d4129743$var$strongDOM;
        }
    });
});
parcelRegister("4NwJJ", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$37e521d9accf6615$export$b3401ee80eb31041);
    var $2fTAU;
    function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
        if (node === 'sub') return {
            type: 'sub'
        };
        if (node === 'super') return {
            type: 'sup'
        };
        return false;
    }
    const $37e521d9accf6615$export$b3401ee80eb31041 = (0, (0, parcelRequire("2fTAU")).subsup)({
        parseDOM: [
            {
                tag: 'sub',
                attrs: {
                    type: 'sub'
                }
            },
            {
                tag: 'sup',
                attrs: {
                    type: 'sup'
                }
            },
            {
                style: 'vertical-align=super',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            },
            {
                style: 'vertical-align=sub',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            }
        ],
        toDOM (mark) {
            return [
                mark.attrs.type
            ];
        }
    });
});
parcelRegister("dtyqo", function(module, exports) {
    $parcel$export(module.exports, "typeAheadQuery", ()=>$9cf8afcff83743a0$export$20af3dabbb5538df);
    var $2fTAU;
    var $51H8P;
    const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, (0, parcelRequire("2fTAU")).typeAheadQuery)({
        parseDOM: [
            {
                tag: 'span[data-type-ahead-query]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-type-ahead-query': 'true',
                    'data-trigger': node.attrs.trigger,
                    style: `color: ${(0, (0, parcelRequire("51H8P")).B400)}`
                }
            ];
        }
    });
});
parcelRegister("8EAPB", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$64cea1116bb0e8f8$export$425327af25286e5e);
    var $2fTAU;
    const $64cea1116bb0e8f8$export$425327af25286e5e = (0, (0, parcelRequire("2fTAU")).underline)({
        parseDOM: [
            {
                tag: 'u'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'underline' && null
            }
        ],
        toDOM () {
            return [
                'u'
            ];
        }
    });
});
parcelRegister("jxVez", function(module, exports) {
    $parcel$export(module.exports, "unsupportedMark", ()=>$e3ad7edb6364f3b2$export$30d78d5eb6719bb8);
    var $2fTAU;
    const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("2fTAU")).unsupportedMark)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("lVmBd", function(module, exports) {
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$ff60739479aa7be3$export$a316dc07ff5182a2);
    var $2fTAU;
    const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, (0, parcelRequire("2fTAU")).unsupportedNodeAttribute)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("21PS7", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$17a3e9738ed289c7$export$c4c2f833baaebdb8);
    var $gthjq;
    const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
        const anchor = dom;
        const data = anchor.getAttribute('data-card-data');
        const datasource = anchor.getAttribute('data-datasource');
        return {
            data: data ? JSON.parse(data) : undefined,
            layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
            width: Number(dom.getAttribute('data-width')) || undefined,
            datasource: datasource ? JSON.parse(datasource) : undefined
        };
    };
    const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("gthjq")).blockCard)({
        parseDOM: [
            {
                tag: 'a[data-block-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('href') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            },
            {
                tag: 'div[data-block-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('data-card-url') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                href: url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`
            };
            return [
                'a',
                attrs,
                (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
            ];
        }
    });
});
parcelRegister("5AxYU", function(module, exports) {
    $parcel$export(module.exports, "bodiedExtension", ()=>$411aac89e34c8741$export$27903d543b563e39);
    var $CWpyq;
    var $gthjq;
    const $411aac89e34c8741$export$27903d543b563e39 = (0, (0, parcelRequire("gthjq")).bodiedExtension)({
        parseDOM: [
            {
                context: 'bodiedExtension//',
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("kjhhp", function(module, exports) {
    $parcel$export(module.exports, "bulletListSelector", ()=>$ec92fc66e86ee824$export$5f25a39efab3b58b);
    $parcel$export(module.exports, "bulletList", ()=>$ec92fc66e86ee824$export$a140c94e5ea26bee);
    var $gthjq;
    const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
    const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, (0, parcelRequire("gthjq")).bulletList)({
        parseDOM: [
            {
                tag: 'ul'
            }
        ],
        toDOM () {
            const attrs = {
                class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
            };
            return [
                'ul',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("5JeV5", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);
    var $gthjq;
    const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("gthjq")).caption)({
        parseDOM: [
            {
                tag: 'figcaption[data-caption]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-caption': 'true'
            };
            return [
                'figcaption',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("6bbHe", function(module, exports) {
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$47fcd7cf328a46ad$export$daf889beb5092f95);
    var $gthjq;
    const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
    const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, (0, parcelRequire("gthjq")).confluenceJiraIssue)({
        parseDOM: [
            {
                tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        issueKey: dom.textContent,
                        macroId: dom.dataset && dom.dataset.macroId,
                        schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                        server: dom.dataset && dom.dataset.server,
                        serverId: dom.dataset && dom.dataset.serverId
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': $47fcd7cf328a46ad$var$name,
                'data-macro-id': node.attrs.macroId,
                'data-schema-version': node.attrs.schemaVersion,
                'data-server': node.attrs.server,
                'data-server-id': node.attrs.serverId,
                'data-jira-issue': node.attrs.issueKey
            };
            return [
                'span',
                attrs,
                node.attrs.issueKey
            ];
        }
    });
});
parcelRegister("5y0tR", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$40a0802970c8dfd0$export$e6e4878f43c27cab);
    var $gthjq;
    const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
    const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedBlock)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $40a0802970c8dfd0$var$name,
                'data-confluence-unsupported': 'block',
                'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("bd7A9", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$8296ca40a4ed2ee7$export$3e6d667072febc87);
    var $gthjq;
    const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
    const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedInline)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $8296ca40a4ed2ee7$var$name,
                'data-confluence-unsupported': 'inline',
                'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("b2VmY", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$80ac620012a63cc1$export$324d90190a8b822a);
    var $gthjq;
    const $80ac620012a63cc1$export$324d90190a8b822a = (0, (0, parcelRequire("gthjq")).date)({
        parseDOM: [
            {
                tag: 'span[data-node-type="date"]',
                getAttrs: (dom)=>({
                        timestamp: dom.getAttribute('data-timestamp')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'date',
                'data-timestamp': node.attrs.timestamp
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("Khvpb", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$08b1e03a19cbdc24$export$6959e16eeff859b4);
    var $9IGaJ;
    var $gthjq;
    const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, (0, parcelRequire("gthjq")).decisionItem)({
        parseDOM: [
            {
                tag: 'li[data-decision-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-decision-state')
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state
            };
            return [
                'li',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("8gSD8", function(module, exports) {
    $parcel$export(module.exports, "decisionListSelector", ()=>$605a31c9af2a8977$export$a5393ce68c2ff601);
    $parcel$export(module.exports, "decisionList", ()=>$605a31c9af2a8977$export$62d45a65fb43d95e);
    var $9IGaJ;
    var $gthjq;
    const $605a31c9af2a8977$var$name = 'decisionList';
    const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
    const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, (0, parcelRequire("gthjq")).decisionList)({
        parseDOM: [
            {
                tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $605a31c9af2a8977$var$name,
                'data-decision-list-local-id': localId || 'local-decision-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("xjCuM", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$06424d48e92613a9$export$2a111da947c407d2);
    var $gthjq;
    const $06424d48e92613a9$export$2a111da947c407d2 = (0, (0, parcelRequire("gthjq")).doc)({});
});
parcelRegister("kshOv", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$ee443d93678dbe0b$export$be4283d9a1cb1ff6);
    var $gthjq;
    const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("gthjq")).embedCard)({
        parseDOM: [
            {
                tag: 'div[data-embed-card]',
                getAttrs: (dom)=>({
                        url: dom.getAttribute('data-card-url'),
                        layout: dom.getAttribute('data-layout') || 'center',
                        width: Number(dom.getAttribute('data-width')) || null,
                        originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                        originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                    })
            }
        ],
        toDOM (node) {
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("7DoMR", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$58ef6723e99e5604$export$a19185d1233fc4b2);
    var $4pzsz;
    var $gthjq;
    const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, (0, parcelRequire("gthjq")).emoji)({
        parseDOM: [
            {
                tag: 'div.ak-editor-panel__icon span',
                ignore: true
            },
            {
                tag: 'span[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            },
            {
                tag: 'img[data-emoticon-name]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
            },
            {
                tag: 'img[data-hipchat-emoticon]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
            },
            {
                tag: 'img.emoji[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            }
        ],
        toDOM (node) {
            const { shortName: shortName, id: id, text: text } = node.attrs;
            const attrs = {
                'data-emoji-short-name': shortName,
                'data-emoji-id': id,
                'data-emoji-text': text,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("4pzsz", function(module, exports) {
    $parcel$export(module.exports, "acNameToEmoji", ()=>$336500cbd1ca0f10$export$f61e93bda2a8b420);
    $parcel$export(module.exports, "acShortcutToEmoji", ()=>$336500cbd1ca0f10$export$441f8b58f5790a68);
    $parcel$export(module.exports, "getEmojiAcName", ()=>$336500cbd1ca0f10$export$880a2465992fbbe);
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
    const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
    const $336500cbd1ca0f10$var$acNameToEmojiMap = {
        smile: [
            '1f642',
            ':slight_smile:',
            '\uD83D\uDE42'
        ],
        sad: [
            '1f641',
            ':slight_frown:',
            '\uD83D\uDE41'
        ],
        cheeky: [
            '1f61b',
            ':stuck_out_tongue:',
            '\uD83D\uDE1B'
        ],
        laugh: [
            '1f600',
            ':grinning:',
            '\uD83D\uDE00'
        ],
        wink: [
            '1f609',
            ':wink:',
            '\uD83D\uDE09'
        ],
        information: [
            '2139',
            ':information_source:',
            '\u2139'
        ],
        tick: [
            '2705',
            ':white_check_mark:',
            '\u2705'
        ],
        cross: [
            '274c',
            ':x:',
            '\u274C'
        ],
        warning: [
            '26a0',
            ':warning:',
            '\u26A0'
        ],
        plus: [
            '2795',
            ':heavy_plus_sign:',
            '\u2795'
        ],
        minus: [
            '2796',
            ':heavy_minus_sign:',
            '\u2796'
        ],
        question: [
            '2753',
            ':question:',
            '\u003F'
        ],
        'thumbs-up': [
            '1f44d',
            ':thumbsup:',
            '\uD83D\uDC4D'
        ],
        'thumbs-down': [
            '1f44e',
            ':thumbsdown:',
            '\uD83D\uDC4E'
        ],
        'light-on': [
            '1f4a1',
            ':bulb:',
            '\uD83D\uDCA1'
        ],
        'yellow-star': [
            '2b50',
            ':star:',
            '\uD83D\uDC9B'
        ],
        'light-off': [
            '1f6ab',
            ':no_entry_sign:',
            '\uD83D\uDEAB'
        ],
        'red-star': [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'green-star': [
            '1f49a',
            ':green_heart:',
            '\uD83D\uDC9A'
        ],
        'blue-star': [
            '1f499',
            ':blue_heart:',
            '\uD83D\uDC99'
        ],
        heart: [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'broken-heart': [
            '1f494',
            ':broken_heart:',
            '\uD83D\uDC94'
        ]
    };
    function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
        const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
        return emojiData ? {
            id: emojiData[0],
            shortName: emojiData[1],
            text: emojiData[2]
        } : {
            id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
            shortName: `:${acName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
        const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
        return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
    }
    function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
        return {
            id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
            shortName: `:${hipchatEmoticonShortName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
        return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
    }
    function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
        if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
            const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
            if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
        }
        return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
    }
});
parcelRegister("hhN5g", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$c95a1940f4fa6aee$export$1b45514b112dd749);
    var $CWpyq;
    var $gthjq;
    const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, (0, parcelRequire("gthjq")).extension)({
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("jnMM2", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$e1c5ffc4cc369fdc$export$371da9dd35aba193);
    var $gthjq;
    const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, (0, parcelRequire("gthjq")).hardBreak)({
        parseDOM: [
            {
                tag: 'br'
            }
        ],
        toDOM () {
            return [
                'br'
            ];
        }
    });
});
parcelRegister("lRTZM", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$feb9fbb7aabe0cc7$export$46e4a324ac90507f);
    var $gthjq;
    const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
            var _heading$attrs, _heading$attrs$localI;
            return {
                level: level,
                localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
            };
        };
    const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, (0, parcelRequire("gthjq")).heading)({
        parseDOM: [
            {
                tag: 'h1',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
            },
            {
                tag: 'h2',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
            },
            {
                tag: 'h3',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
            },
            {
                tag: 'h4',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
            },
            {
                tag: 'h5',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
            },
            {
                tag: 'h6',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
            }
        ],
        toDOM (node) {
            const { level: level, localId: localId } = node.attrs;
            const name = 'h' + level;
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("7lRBh", function(module, exports) {
    $parcel$export(module.exports, "image", ()=>$55a4127c569d3934$export$5c452ff88e35e47d);
    var $gthjq;
    const $55a4127c569d3934$export$5c452ff88e35e47d = (0, (0, parcelRequire("gthjq")).image)({
        parseDOM: [
            {
                tag: 'img[src^="data:image/"]',
                ignore: true
            },
            {
                tag: 'img[src]',
                getAttrs (domNode) {
                    const dom = domNode;
                    return {
                        src: dom.getAttribute('src'),
                        alt: dom.getAttribute('alt'),
                        title: dom.getAttribute('title')
                    };
                }
            }
        ],
        toDOM (node) {
            return [
                'img',
                node.attrs
            ];
        }
    });
});
parcelRegister("cCBEe", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$93063cb7956d3766$export$cbf8224b64e0d942);
    var $gthjq;
    const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, (0, parcelRequire("gthjq")).inlineCard)({
        parseDOM: [
            {
                tag: 'a[data-inline-card], span[data-inline-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                        data: data ? JSON.parse(data) : null
                    };
                }
            },
            {
                tag: 'div[data-inline-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('data-card-url'),
                        data: data ? JSON.parse(data) : null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
            };
            if (node.attrs.url) return [
                'a',
                attrs,
                node.attrs.url
            ];
            else return [
                'a',
                attrs
            ];
        }
    });
});
parcelRegister("5BOuQ", function(module, exports) {
    $parcel$export(module.exports, "inlineExtension", ()=>$4157940155363fee$export$16b353b2649bd8d9);
    var $CWpyq;
    var $gthjq;
    const $4157940155363fee$export$16b353b2649bd8d9 = (0, (0, parcelRequire("gthjq")).inlineExtensionWithMarks)({
        parseDOM: [
            {
                tag: 'span[data-extension-type]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode, true)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-local-id:': node.attrs.localId,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("4EbxI", function(module, exports) {
    $parcel$export(module.exports, "layoutColumn", ()=>$3623d9fd8951cfd2$export$ab76e7c03cd6f650);
    var $gthjq;
    const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("gthjq")).layoutColumn)({
        parseDOM: [
            {
                context: 'layoutColumn//',
                tag: 'div[data-layout-column]',
                skip: true
            },
            {
                tag: 'div[data-layout-column]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        width: Number(dom.getAttribute('data-column-width')) || undefined
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-layout-column': 'true'
            };
            const { width: width } = node.attrs;
            if (width) {
                attrs['style'] = `flex-basis: ${width}%`;
                attrs['data-column-width'] = `${width}`;
            }
            const contentAttrs = {
                'data-layout-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
});
parcelRegister("92lix", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$6944d24b2c8b0dd9$export$2855e964765eac9);
    var $gthjq;
    const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, (0, parcelRequire("gthjq")).mediaGroup)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaGroup"]'
            },
            {
                tag: 'div[class="MediaGroup"]'
            }
        ],
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    });
});
parcelRegister("7Xgp3", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$5caac46433adf3f0$export$38bab695e3f720f1);
    var $7agO8;
    var $gthjq;
    const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, (0, parcelRequire("7agO8")).createMediaSpec)((0, (0, parcelRequire("gthjq")).mediaInline)({}).attrs, true);
});
parcelRegister("dx5eC", function(module, exports) {
    $parcel$export(module.exports, "nestedExpand", ()=>$9da26af350402964$export$63cadbf5f4296627);
    var $gthjq;
    function $9da26af350402964$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $9da26af350402964$export$63cadbf5f4296627 = (0, (0, parcelRequire("gthjq")).nestedExpand)({
        parseDOM: [
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'nestedExpand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("dwptW", function(module, exports) {
    $parcel$export(module.exports, "orderedListSelector", ()=>$9d8207b1e6c47527$export$4e7125c7ff595be5);
    $parcel$export(module.exports, "orderedList", ()=>$9d8207b1e6c47527$export$a5dc81035676e7a);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>$9d8207b1e6c47527$export$b9ab759e8298198f);
    var $gthjq;
    const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
    const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol'
            }
        ],
        toDOM () {
            const attrs = {
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
    const $9d8207b1e6c47527$var$resolveStart = (start)=>{
        const num = Number(start);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const startDOMAttr = dom.getAttribute('start');
                    if (startDOMAttr) {
                        const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                        if (typeof start === 'number') return {
                            order: start
                        };
                    }
                    return null;
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
            const attrs = {
                start: typeof start === 'number' ? String(start) : undefined,
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("abme3", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$769c2c0b195d79f6$export$9c206ddddb32a9b);
    var $gthjq;
    const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, (0, parcelRequire("gthjq")).paragraph)({
        parseDOM: [
            {
                tag: 'p',
                getAttrs: (domNode)=>{
                    var _paragraph$attrs, _paragraph$attrs$loca;
                    const dom = domNode;
                    const attrs = {
                        localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const name = 'p';
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("dgJoa", function(module, exports) {
    $parcel$export(module.exports, "placeholder", ()=>$9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);
    var $gthjq;
    const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("gthjq")).placeholder)({
        parseDOM: [
            {
                tag: 'span[data-placeholder]',
                getAttrs: (dom)=>({
                        text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                    })
            }
        ],
        toDOM (node) {
            const { text: text } = node.attrs;
            const attrs = {
                'data-placeholder': text,
                contenteditable: 'true'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("M4hHz", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$0907ce9fea0294ca$export$fbeb3a3956e8a3c7);
    var $gthjq;
    const $0907ce9fea0294ca$var$hrDOM = [
        'hr'
    ];
    const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("gthjq")).rule)({
        parseDOM: [
            {
                tag: 'hr'
            }
        ],
        toDOM () {
            return $0907ce9fea0294ca$var$hrDOM;
        }
    });
});
parcelRegister("18bvk", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$0d2f764e7fea7c00$export$471f7ae5c4103ae1);
    var $9IGaJ;
    var $gthjq;
    const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("gthjq")).status)({
        parseDOM: [
            {
                tag: 'span[data-node-type="status"]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        text: dom.textContent.replace(/\n/, '').trim(),
                        color: dom.getAttribute('data-color'),
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        style: dom.getAttribute('data-style')
                    };
                }
            }
        ],
        toDOM (node) {
            const { text: text, color: color, localId: localId, style: style } = node.attrs;
            const attrs = {
                'data-node-type': 'status',
                'data-color': color,
                'data-local-id': localId,
                'data-style': style,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("iThOL", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);
    var $9IGaJ;
    var $gthjq;
    const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("gthjq")).taskItem)({
        parseDOM: [
            {
                tag: 'div[data-task-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-task-state') || 'TODO'
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-task-local-id': localId || 'local-task',
                'data-task-state': state || 'TODO'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("43mJF", function(module, exports) {
    $parcel$export(module.exports, "taskListSelector", ()=>$2f3914100d01687b$export$c0ec71adb7a18fb2);
    $parcel$export(module.exports, "taskList", ()=>$2f3914100d01687b$export$375b6afcc5f4d291);
    var $9IGaJ;
    var $gthjq;
    const $2f3914100d01687b$var$name = 'actionList';
    const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
    const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, (0, parcelRequire("gthjq")).taskList)({
        parseDOM: [
            {
                tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $2f3914100d01687b$var$name,
                'data-task-list-local-id': localId || 'local-task-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("3DR6L", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$2a6e35cab1a01b8e$export$6f093cfa640b7166);
    var $gthjq;
    const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, (0, parcelRequire("gthjq")).text)({
        toDebugString: ()=>'text_node'
    });
});
parcelRegister("9X587", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01deabc8204e5493$export$2e2bcd8739ae039);
    const $01deabc8204e5493$var$name = 'unknownBlock';
    var $01deabc8204e5493$export$2e2bcd8739ae039 = {
        group: 'block',
        content: 'inline+',
        marks: '_',
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': $01deabc8204e5493$var$name
                },
                0
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
            }
        ]
    };
});
parcelRegister("d1d6m", function(module, exports) {
    $parcel$export(module.exports, "unsupportedBlock", ()=>$97a5880db351ce36$export$44b79b0979d0f0f7);
    var $gthjq;
    const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("gthjq")).unsupportedBlock)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedBlock"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedBlock',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("6kr5W", function(module, exports) {
    $parcel$export(module.exports, "unsupportedInline", ()=>$49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);
    var $gthjq;
    const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, (0, parcelRequire("gthjq")).unsupportedInline)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedInline"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedInline',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'span',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("fVI2q", function(module, exports) {
    $parcel$export(module.exports, "markOverrideRuleFor", ()=>$7f7cf8cf5d94f891$export$28e4e3c024cce988);
    const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return true;
        }
    };
    const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return false;
        }
    };
    const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
        switch(type){
            case 'link':
            case 'em':
            case 'strong':
            case 'strike':
            case 'subsup':
            case 'underline':
            case 'code':
            case 'textColor':
            case 'backgroundColor':
            case 'confluenceInlineComment':
            case 'breakout':
            case 'alignment':
            case 'indentation':
            case 'border':
                return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
            default:
                return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
        }
    };
});
parcelRegister("0Cgjx", function(module, exports) {
    $parcel$export(module.exports, "sanitizeNode", ()=>$45db1c8142107da9$export$48b382180baf8e88);
    var $aSk3Q;
    var $l1C1k;
    var $VSDnB;
    var $hRZSy;
    const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
    function $45db1c8142107da9$export$48b382180baf8e88(json) {
        const sanitizedJSON = (0, (0, parcelRequire("l1C1k")).traverse)(json, {
            text: (node)=>{
                if (!node || !Array.isArray(node.marks)) return node;
                return {
                    ...node,
                    marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
                };
            },
            status: (node)=>{
                if (node.attrs && !!node.attrs.text) return (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks)(node);
                return false;
            },
            caption: (node)=>{
                if (node.content) return node;
                return false;
            },
            tableCell: (node)=>{
                if ($45db1c8142107da9$var$hasNestedTable(node) && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("aSk3Q")).transformNestedTableNodeOutgoingDocument)(node);
            },
            tableHeader: (node)=>{
                if ($45db1c8142107da9$var$hasNestedTable(node) && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("aSk3Q")).transformNestedTableNodeOutgoingDocument)(node);
            },
            emoji: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            mention: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            date: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            hardBreak: (0, (0, parcelRequire("hRZSy")).removeMarks),
            inlineCard: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks)
        });
        return sanitizedJSON;
    }
});
parcelRegister("aSk3Q", function(module, exports) {
    $parcel$export(module.exports, "transformNestedTablesIncomingDocument", ()=>$2dd8f1bba9a54435$export$18544d0b5f43e4a1);
    $parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", ()=>$2dd8f1bba9a54435$export$8a334a7d9fe120ec);
    var $l1C1k;
    var $gxbjN;
    const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.nesting', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
    const $2dd8f1bba9a54435$var$isNestedTableExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
    const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
        if (!nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent) return false;
        try {
            return JSON.parse(nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent.value);
        } catch (e) {
            throw new Error('Failed to parse nested table content');
        }
    };
    const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            extension: (node)=>{
                if ($2dd8f1bba9a54435$var$isNestedTableExtension(node)) {
                    isTransformed = true;
                    return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
    const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>({
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                if (childNode?.type === 'table') return (0, (0, parcelRequire("gxbjN")).extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        macroParams: {
                            nestedContent: {
                                value: JSON.stringify(childNode)
                            }
                        }
                    }
                });
                return childNode;
            })
        });
});
parcelRegister("l1C1k", function(module, exports) {
    $parcel$export(module.exports, "traverse", ()=>$b903aab814d8ed47$export$df3f009e3d155b20);
    function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
        return true;
    }
    function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
        if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
        return $b903aab814d8ed47$var$traverseNode(adf, {
            node: undefined
        }, visitors, 0, 0);
    }
    function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
        const visitor = visitors[adfNode.type] || visitors['any'];
        let newNode = {
            ...adfNode
        };
        if (visitor) {
            const processedNode = visitor({
                ...newNode
            }, parent, index, depth);
            if (processedNode === false) return false;
            newNode = processedNode || adfNode;
        }
        if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
            if (!node) return acc;
            const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
                node: newNode,
                parent: parent
            }, visitors, idx, depth + 1);
            if (processedNode !== false) acc.push(processedNode);
            return acc;
        }, []);
        return newNode;
    }
});
parcelRegister("gxbjN", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$ec4576859225619a$export$1b45514b112dd749);
    const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
            type: 'extension',
            attrs: attrs
        });
});
parcelRegister("hRZSy", function(module, exports) {
    $parcel$export(module.exports, "removeMarks", ()=>$7e7bed7752b3d3e8$export$9bf001d8ef76e497);
    $parcel$export(module.exports, "removeNonAnnotationMarks", ()=>$7e7bed7752b3d3e8$export$8cae9126fc577085);
    function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
        let newNode = {
            ...node
        };
        delete newNode.marks;
        return newNode;
    }
    function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
        let newNode = {
            ...node
        };
        if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
        return newNode;
    }
});
parcelRegister("dN5CS", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "WikiMarkupTransformer", ()=>$4011ad83704160d6$export$caaa00407b56b900);
    $parcel$export(module.exports, "default", ()=>$4011ad83704160d6$export$2e2bcd8739ae039);
    var $kOFhM;
    var $lxtC7;
    var $djcbG;
    var $bOMPB;
    class $4011ad83704160d6$export$caaa00407b56b900 {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema)){
            this.schema = schema;
        }
        sanitizeWikiMarkup(wikiMarkup) {
            return wikiMarkup.replace(/\0/g, '');
        }
        encode(node, context) {
            const wikiMarkup = (0, (0, parcelRequire("lxtC7")).encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            return sanitizedWikiMarkup;
        }
        parse(wikiMarkup, context) {
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            const tree = new (0, (0, parcelRequire("djcbG")).default)(this.schema, sanitizedWikiMarkup);
            return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
        }
        buildContext(context) {
            return context ? {
                ...context,
                issueKeyRegex: context.conversion ? (0, (0, parcelRequire("bOMPB")).buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
            } : {};
        }
    }
    const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
        if (!context || !context.conversion || !context.conversion.mentionConversion) return context;
        const mentionConversion = {};
        for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
        context.conversion.mentionConversion = mentionConversion;
        return context;
    };
    var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;
});
parcelRegister("lxtC7", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$f10f1fd2bcfd2732$export$c564cdbbe6da493);
    var $03QYI;
    var $6ises;
    var $hgytR;
    var $b6sEJ;
    var $73kPn;
    var $1B6CN;
    var $8UMD2;
    var $fIzNZ;
    var $eTlm6;
    var $6obXI;
    var $h9tzi;
    var $abXFq;
    var $flJtr;
    var $czgKo;
    var $acqkf;
    var $1Nefo;
    var $69N10;
    var $12A17;
    var $bsbI5;
    const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
        blockquote: (0, parcelRequire("03QYI")).blockquote,
        bulletList: (0, parcelRequire("6ises")).bulletList,
        taskList: (0, parcelRequire("hgytR")).taskList,
        decisionList: (0, parcelRequire("b6sEJ")).decisionList,
        codeBlock: (0, parcelRequire("73kPn")).codeBlock,
        doc: (0, parcelRequire("1B6CN")).doc,
        heading: (0, parcelRequire("fIzNZ")).heading,
        caption: (0, parcelRequire("bsbI5")).caption,
        mediaGroup: (0, parcelRequire("eTlm6")).mediaGroup,
        mediaInline: (0, parcelRequire("6obXI")).mediaInline,
        mediaSingle: (0, (0, parcelRequire("eTlm6")).mediaGroup),
        orderedList: (0, parcelRequire("h9tzi")).orderedList,
        panel: (0, parcelRequire("abXFq")).panel,
        paragraph: (0, parcelRequire("flJtr")).paragraph,
        rule: (0, parcelRequire("czgKo")).rule,
        table: (0, parcelRequire("acqkf")).table,
        blockCard: (0, parcelRequire("69N10")).blockCard,
        embedCard: (0, parcelRequire("12A17")).embedCard,
        expand: (0, parcelRequire("8UMD2")).expand
    };
    function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
        const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
        try {
            if (encoder) return encoder(node, {
                context: context
            });
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        } catch (err) {
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        }
    }
});
parcelRegister("03QYI", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$f393e710d4117486$export$67dc04e652a298ca);
    var $lxtC7;
    const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return `{quote}${result.join('\n\n')}{quote}`;
    };
});
parcelRegister("6ises", function(module, exports) {
    $parcel$export(module.exports, "bulletList", ()=>$92e38ddcaccbcaf0$export$a140c94e5ea26bee);
    var $bxtEu;
    const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("bxtEu")).listItem)(item, '*', context));
        });
        return result.join('\n');
    };
});
parcelRegister("bxtEu", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$b39a87ae4fdec39c$export$76c7e83ecc9cdf05);
    var $lxtC7;
    var $flJtr;
    var $1Nefo;
    var $73kPn;
    var $eTlm6;
    var $6obXI;
    const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
        const result = [];
        let contentBuffer = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'paragraph':
                    contentBuffer.push((0, (0, parcelRequire("flJtr")).paragraph)(n, {
                        context: context
                    }));
                    break;
                case 'bulletList':
                case 'orderedList':
                    {
                        if (contentBuffer.length) {
                            result.push(`${prefix} ${contentBuffer.join('\n')}`);
                            contentBuffer = [];
                        }
                        const nestedList = (0, (0, parcelRequire("lxtC7")).encode)(n, context).split('\n').map((line)=>{
                            if ([
                                '#',
                                '*'
                            ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                            return line;
                        }).join('\n');
                        result.push(nestedList);
                        break;
                    }
                case 'codeBlock':
                    contentBuffer.push((0, (0, parcelRequire("73kPn")).codeBlock)(n));
                    break;
                case 'mediaInline':
                    contentBuffer.push((0, (0, parcelRequire("6obXI")).mediaInline)(n, {
                        context: context
                    }));
                    break;
                case 'mediaSingle':
                    contentBuffer.push((0, (0, parcelRequire("eTlm6")).mediaGroup)(n, {
                        context: context
                    }));
                    break;
                default:
                    contentBuffer.push((0, (0, parcelRequire("1Nefo")).unknown)(n));
            }
        });
        if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
        return result.join('\n');
    };
});
parcelRegister("flJtr", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$3fb83d21e304518d$export$9c206ddddb32a9b);
    var $bK2QZ;
    const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("bK2QZ", function(module, exports) {
    $parcel$export(module.exports, "inlines", ()=>$d36b73d9ad63ab63$export$96c94bfc00b85760);
    var $91ILy;
    var $e34Iq;
    var $6obXI;
    var $7GCbZ;
    var $6ayzl;
    var $5IuwX;
    var $1HDja;
    var $1Nefo;
    var $c08Yp;
    const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
        emoji: (0, parcelRequire("91ILy")).emoji,
        hardBreak: (0, parcelRequire("e34Iq")).hardBreak,
        mediaInline: (0, parcelRequire("6obXI")).mediaInline,
        mention: (0, parcelRequire("7GCbZ")).mention,
        text: (0, parcelRequire("6ayzl")).text,
        inlineCard: (0, parcelRequire("5IuwX")).inlineCard,
        status: (0, parcelRequire("1HDja")).status,
        date: (0, parcelRequire("c08Yp")).date
    };
    const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
        const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
        if (encoder) return encoder(node, opts);
        return (0, (0, parcelRequire("1Nefo")).unknown)(node);
    };
});
parcelRegister("91ILy", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$15d1256cf1644afa$export$a19185d1233fc4b2);
    var $g5UJK;
    var $1Nefo;
    const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
        const value = (0, (0, parcelRequire("g5UJK")).mapping)[node.attrs.id];
        if (value) return value;
        if (node.attrs.shortName) return node.attrs.shortName;
        return (0, (0, parcelRequire("1Nefo")).unknown)(node);
    };
});
parcelRegister("g5UJK", function(module, exports) {
    $parcel$export(module.exports, "mapping", ()=>$c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
    const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
        '1f600': "\uD83D\uDE00",
        '1f603': "\uD83D\uDE03",
        '1f604': "\uD83D\uDE04",
        '1f601': "\uD83D\uDE01",
        '1f606': "\uD83D\uDE06",
        '1f605': "\uD83D\uDE05",
        '1f602': "\uD83D\uDE02",
        '1f923': "\uD83E\uDD23",
        '263a': "\u263A\uFE0F",
        '1f60a': "\uD83D\uDE0A",
        '1f607': "\uD83D\uDE07",
        '1f642': "\uD83D\uDE42",
        '1f643': "\uD83D\uDE43",
        '1f609': "\uD83D\uDE09",
        '1f60c': "\uD83D\uDE0C",
        '1f60d': "\uD83D\uDE0D",
        '1f618': "\uD83D\uDE18",
        '1f617': "\uD83D\uDE17",
        '1f619': "\uD83D\uDE19",
        '1f61a': "\uD83D\uDE1A",
        '1f60b': "\uD83D\uDE0B",
        '1f61c': "\uD83D\uDE1C",
        '1f61d': "\uD83D\uDE1D",
        '1f61b': "\uD83D\uDE1B",
        '1f911': "\uD83E\uDD11",
        '1f917': "\uD83E\uDD17",
        '1f913': "\uD83E\uDD13",
        '1f60e': "\uD83D\uDE0E",
        '1f921': "\uD83E\uDD21",
        '1f920': "\uD83E\uDD20",
        '1f60f': "\uD83D\uDE0F",
        '1f612': "\uD83D\uDE12",
        '1f61e': "\uD83D\uDE1E",
        '1f614': "\uD83D\uDE14",
        '1f61f': "\uD83D\uDE1F",
        '1f615': "\uD83D\uDE15",
        '1f641': "\uD83D\uDE41",
        '2639': "\u2639\uFE0F",
        '1f623': "\uD83D\uDE23",
        '1f616': "\uD83D\uDE16",
        '1f62b': "\uD83D\uDE2B",
        '1f629': "\uD83D\uDE29",
        '1f624': "\uD83D\uDE24",
        '1f620': "\uD83D\uDE20",
        '1f621': "\uD83D\uDE21",
        '1f636': "\uD83D\uDE36",
        '1f610': "\uD83D\uDE10",
        '1f611': "\uD83D\uDE11",
        '1f62f': "\uD83D\uDE2F",
        '1f626': "\uD83D\uDE26",
        '1f627': "\uD83D\uDE27",
        '1f62e': "\uD83D\uDE2E",
        '1f632': "\uD83D\uDE32",
        '1f635': "\uD83D\uDE35",
        '1f633': "\uD83D\uDE33",
        '1f631': "\uD83D\uDE31",
        '1f628': "\uD83D\uDE28",
        '1f630': "\uD83D\uDE30",
        '1f622': "\uD83D\uDE22",
        '1f625': "\uD83D\uDE25",
        '1f924': "\uD83E\uDD24",
        '1f62d': "\uD83D\uDE2D",
        '1f613': "\uD83D\uDE13",
        '1f62a': "\uD83D\uDE2A",
        '1f634': "\uD83D\uDE34",
        '1f644': "\uD83D\uDE44",
        '1f914': "\uD83E\uDD14",
        '1f925': "\uD83E\uDD25",
        '1f62c': "\uD83D\uDE2C",
        '1f910': "\uD83E\uDD10",
        '1f922': "\uD83E\uDD22",
        '1f927': "\uD83E\uDD27",
        '1f637': "\uD83D\uDE37",
        '1f912': "\uD83E\uDD12",
        '1f915': "\uD83E\uDD15",
        '1f608': "\uD83D\uDE08",
        '1f47f': "\uD83D\uDC7F",
        '1f479': "\uD83D\uDC79",
        '1f47a': "\uD83D\uDC7A",
        '1f4a9': "\uD83D\uDCA9",
        '1f47b': "\uD83D\uDC7B",
        '1f480': "\uD83D\uDC80",
        '2620': "\u2620\uFE0F",
        '1f47d': "\uD83D\uDC7D",
        '1f47e': "\uD83D\uDC7E",
        '1f916': "\uD83E\uDD16",
        '1f383': "\uD83C\uDF83",
        '1f63a': "\uD83D\uDE3A",
        '1f638': "\uD83D\uDE38",
        '1f639': "\uD83D\uDE39",
        '1f63b': "\uD83D\uDE3B",
        '1f63c': "\uD83D\uDE3C",
        '1f63d': "\uD83D\uDE3D",
        '1f640': "\uD83D\uDE40",
        '1f63f': "\uD83D\uDE3F",
        '1f63e': "\uD83D\uDE3E",
        '1f450': "\uD83D\uDC50",
        '1f64c': "\uD83D\uDE4C",
        '1f44f': "\uD83D\uDC4F",
        '1f64f': "\uD83D\uDE4F",
        '1f91d': "\uD83E\uDD1D",
        '1f44d': "\uD83D\uDC4D",
        '1f44e': "\uD83D\uDC4E",
        '1f44a': "\uD83D\uDC4A",
        '270a': "\u270A",
        '1f91b': "\uD83E\uDD1B",
        '1f91c': "\uD83E\uDD1C",
        '1f91e': "\uD83E\uDD1E",
        '270c': "\u270C\uFE0F",
        '1f918': "\uD83E\uDD18",
        '1f44c': "\uD83D\uDC4C",
        '1f448': "\uD83D\uDC48",
        '1f449': "\uD83D\uDC49",
        '1f446': "\uD83D\uDC46",
        '1f447': "\uD83D\uDC47",
        '261d': "\u261D\uFE0F",
        '270b': "\u270B",
        '1f91a': "\uD83E\uDD1A",
        '1f590': "\uD83D\uDD90\uFE0F",
        '1f596': "\uD83D\uDD96",
        '1f44b': "\uD83D\uDC4B",
        '1f919': "\uD83E\uDD19",
        '1f4aa': "\uD83D\uDCAA",
        '1f595': "\uD83D\uDD95",
        '270d': "\u270D\uFE0F",
        '1f933': "\uD83E\uDD33",
        '1f485': "\uD83D\uDC85",
        '1f48d': "\uD83D\uDC8D",
        '1f484': "\uD83D\uDC84",
        '1f48b': "\uD83D\uDC8B",
        '1f444': "\uD83D\uDC44",
        '1f445': "\uD83D\uDC45",
        '1f442': "\uD83D\uDC42",
        '1f443': "\uD83D\uDC43",
        '1f463': "\uD83D\uDC63",
        '1f441': "\uD83D\uDC41\uFE0F",
        '1f440': "\uD83D\uDC40",
        '1f5e3': "\uD83D\uDDE3\uFE0F",
        '1f464': "\uD83D\uDC64",
        '1f465': "\uD83D\uDC65",
        '1f476': "\uD83D\uDC76",
        '1f466': "\uD83D\uDC66",
        '1f467': "\uD83D\uDC67",
        '1f468': "\uD83D\uDC68",
        '1f469': "\uD83D\uDC69",
        '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
        '1f471': "\uD83D\uDC71",
        '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
        '1f474': "\uD83D\uDC74",
        '1f475': "\uD83D\uDC75",
        '1f472': "\uD83D\uDC72",
        '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
        '1f473': "\uD83D\uDC73",
        '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
        '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
        '1f46e': "\uD83D\uDC6E",
        '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
        '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
        '1f477': "\uD83D\uDC77",
        '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
        '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
        '1f482': "\uD83D\uDC82",
        '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
        '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
        '1f575': "\uD83D\uDD75\uFE0F",
        '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
        '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
        '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
        '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
        '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
        '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
        '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
        '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
        '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
        '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
        '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
        '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
        '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
        '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
        '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
        '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
        '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
        '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
        '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
        '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
        '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
        '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
        '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
        '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
        '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
        '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
        '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
        '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
        '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
        '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
        '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
        '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
        '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
        '1f936': "\uD83E\uDD36",
        '1f385': "\uD83C\uDF85",
        '1f478': "\uD83D\uDC78",
        '1f934': "\uD83E\uDD34",
        '1f470': "\uD83D\uDC70",
        '1f935': "\uD83E\uDD35",
        '1f47c': "\uD83D\uDC7C",
        '1f930': "\uD83E\uDD30",
        '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
        '1f647': "\uD83D\uDE47",
        '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
        '1f481': "\uD83D\uDC81",
        '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
        '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
        '1f645': "\uD83D\uDE45",
        '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
        '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
        '1f646': "\uD83D\uDE46",
        '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
        '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
        '1f64b': "\uD83D\uDE4B",
        '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
        '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
        '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
        '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
        '1f926': "\uD83E\uDD26",
        '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
        '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
        '1f937': "\uD83E\uDD37",
        '1f64e': "\uD83D\uDE4E",
        '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
        '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
        '1f64d': "\uD83D\uDE4D",
        '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
        '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
        '1f487': "\uD83D\uDC87",
        '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
        '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
        '1f486': "\uD83D\uDC86",
        '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
        '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
        '1f574': "\uD83D\uDD74\uFE0F",
        '1f483': "\uD83D\uDC83",
        '1f57a': "\uD83D\uDD7A",
        '1f46f': "\uD83D\uDC6F",
        '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
        '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
        '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
        '1f6b6': "\uD83D\uDEB6",
        '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
        '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
        '1f3c3': "\uD83C\uDFC3",
        '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
        '1f46b': "\uD83D\uDC6B",
        '1f46d': "\uD83D\uDC6D",
        '1f46c': "\uD83D\uDC6C",
        '1f491': "\uD83D\uDC91",
        '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f48f': "\uD83D\uDC8F",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f46a': "\uD83D\uDC6A",
        '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f45a': "\uD83D\uDC5A",
        '1f455': "\uD83D\uDC55",
        '1f456': "\uD83D\uDC56",
        '1f454': "\uD83D\uDC54",
        '1f457': "\uD83D\uDC57",
        '1f459': "\uD83D\uDC59",
        '1f458': "\uD83D\uDC58",
        '1f460': "\uD83D\uDC60",
        '1f461': "\uD83D\uDC61",
        '1f462': "\uD83D\uDC62",
        '1f45e': "\uD83D\uDC5E",
        '1f45f': "\uD83D\uDC5F",
        '1f452': "\uD83D\uDC52",
        '1f3a9': "\uD83C\uDFA9",
        '1f393': "\uD83C\uDF93",
        '1f451': "\uD83D\uDC51",
        '26d1': "\u26D1\uFE0F",
        '1f392': "\uD83C\uDF92",
        '1f45d': "\uD83D\uDC5D",
        '1f45b': "\uD83D\uDC5B",
        '1f45c': "\uD83D\uDC5C",
        '1f4bc': "\uD83D\uDCBC",
        '1f453': "\uD83D\uDC53",
        '1f576': "\uD83D\uDD76\uFE0F",
        '1f302': "\uD83C\uDF02",
        '2602': "\u2602\uFE0F",
        '1f436': "\uD83D\uDC36",
        '1f431': "\uD83D\uDC31",
        '1f42d': "\uD83D\uDC2D",
        '1f439': "\uD83D\uDC39",
        '1f430': "\uD83D\uDC30",
        '1f98a': "\uD83E\uDD8A",
        '1f43b': "\uD83D\uDC3B",
        '1f43c': "\uD83D\uDC3C",
        '1f428': "\uD83D\uDC28",
        '1f42f': "\uD83D\uDC2F",
        '1f981': "\uD83E\uDD81",
        '1f42e': "\uD83D\uDC2E",
        '1f437': "\uD83D\uDC37",
        '1f43d': "\uD83D\uDC3D",
        '1f438': "\uD83D\uDC38",
        '1f435': "\uD83D\uDC35",
        '1f648': "\uD83D\uDE48",
        '1f649': "\uD83D\uDE49",
        '1f64a': "\uD83D\uDE4A",
        '1f412': "\uD83D\uDC12",
        '1f414': "\uD83D\uDC14",
        '1f427': "\uD83D\uDC27",
        '1f426': "\uD83D\uDC26",
        '1f424': "\uD83D\uDC24",
        '1f423': "\uD83D\uDC23",
        '1f425': "\uD83D\uDC25",
        '1f986': "\uD83E\uDD86",
        '1f985': "\uD83E\uDD85",
        '1f989': "\uD83E\uDD89",
        '1f987': "\uD83E\uDD87",
        '1f43a': "\uD83D\uDC3A",
        '1f417': "\uD83D\uDC17",
        '1f434': "\uD83D\uDC34",
        '1f984': "\uD83E\uDD84",
        '1f41d': "\uD83D\uDC1D",
        '1f41b': "\uD83D\uDC1B",
        '1f98b': "\uD83E\uDD8B",
        '1f40c': "\uD83D\uDC0C",
        '1f41a': "\uD83D\uDC1A",
        '1f41e': "\uD83D\uDC1E",
        '1f41c': "\uD83D\uDC1C",
        '1f577': "\uD83D\uDD77\uFE0F",
        '1f578': "\uD83D\uDD78\uFE0F",
        '1f422': "\uD83D\uDC22",
        '1f40d': "\uD83D\uDC0D",
        '1f98e': "\uD83E\uDD8E",
        '1f982': "\uD83E\uDD82",
        '1f980': "\uD83E\uDD80",
        '1f991': "\uD83E\uDD91",
        '1f419': "\uD83D\uDC19",
        '1f990': "\uD83E\uDD90",
        '1f420': "\uD83D\uDC20",
        '1f41f': "\uD83D\uDC1F",
        '1f421': "\uD83D\uDC21",
        '1f42c': "\uD83D\uDC2C",
        '1f988': "\uD83E\uDD88",
        '1f433': "\uD83D\uDC33",
        '1f40b': "\uD83D\uDC0B",
        '1f40a': "\uD83D\uDC0A",
        '1f406': "\uD83D\uDC06",
        '1f405': "\uD83D\uDC05",
        '1f403': "\uD83D\uDC03",
        '1f402': "\uD83D\uDC02",
        '1f404': "\uD83D\uDC04",
        '1f98c': "\uD83E\uDD8C",
        '1f42a': "\uD83D\uDC2A",
        '1f42b': "\uD83D\uDC2B",
        '1f418': "\uD83D\uDC18",
        '1f98f': "\uD83E\uDD8F",
        '1f98d': "\uD83E\uDD8D",
        '1f40e': "\uD83D\uDC0E",
        '1f416': "\uD83D\uDC16",
        '1f410': "\uD83D\uDC10",
        '1f40f': "\uD83D\uDC0F",
        '1f411': "\uD83D\uDC11",
        '1f415': "\uD83D\uDC15",
        '1f429': "\uD83D\uDC29",
        '1f408': "\uD83D\uDC08",
        '1f413': "\uD83D\uDC13",
        '1f983': "\uD83E\uDD83",
        '1f54a': "\uD83D\uDD4A\uFE0F",
        '1f407': "\uD83D\uDC07",
        '1f401': "\uD83D\uDC01",
        '1f400': "\uD83D\uDC00",
        '1f43f': "\uD83D\uDC3F\uFE0F",
        '1f43e': "\uD83D\uDC3E",
        '1f409': "\uD83D\uDC09",
        '1f432': "\uD83D\uDC32",
        '1f335': "\uD83C\uDF35",
        '1f384': "\uD83C\uDF84",
        '1f332': "\uD83C\uDF32",
        '1f333': "\uD83C\uDF33",
        '1f334': "\uD83C\uDF34",
        '1f331': "\uD83C\uDF31",
        '1f33f': "\uD83C\uDF3F",
        '2618': "\u2618\uFE0F",
        '1f340': "\uD83C\uDF40",
        '1f38d': "\uD83C\uDF8D",
        '1f38b': "\uD83C\uDF8B",
        '1f343': "\uD83C\uDF43",
        '1f342': "\uD83C\uDF42",
        '1f341': "\uD83C\uDF41",
        '1f344': "\uD83C\uDF44",
        '1f33e': "\uD83C\uDF3E",
        '1f490': "\uD83D\uDC90",
        '1f337': "\uD83C\uDF37",
        '1f339': "\uD83C\uDF39",
        '1f940': "\uD83E\uDD40",
        '1f33b': "\uD83C\uDF3B",
        '1f33c': "\uD83C\uDF3C",
        '1f338': "\uD83C\uDF38",
        '1f33a': "\uD83C\uDF3A",
        '1f30e': "\uD83C\uDF0E",
        '1f30d': "\uD83C\uDF0D",
        '1f30f': "\uD83C\uDF0F",
        '1f315': "\uD83C\uDF15",
        '1f316': "\uD83C\uDF16",
        '1f317': "\uD83C\uDF17",
        '1f318': "\uD83C\uDF18",
        '1f311': "\uD83C\uDF11",
        '1f312': "\uD83C\uDF12",
        '1f313': "\uD83C\uDF13",
        '1f314': "\uD83C\uDF14",
        '1f31a': "\uD83C\uDF1A",
        '1f31d': "\uD83C\uDF1D",
        '1f31e': "\uD83C\uDF1E",
        '1f31b': "\uD83C\uDF1B",
        '1f31c': "\uD83C\uDF1C",
        '1f319': "\uD83C\uDF19",
        '1f4ab': "\uD83D\uDCAB",
        '2b50': "\u2B50",
        '1f31f': "\uD83C\uDF1F",
        '2728': "\u2728",
        '26a1': "\u26A1",
        '1f525': "\uD83D\uDD25",
        '1f4a5': "\uD83D\uDCA5",
        '2604': "\u2604\uFE0F",
        '2600': "\u2600\uFE0F",
        '1f324': "\uD83C\uDF24\uFE0F",
        '26c5': "\u26C5",
        '1f325': "\uD83C\uDF25\uFE0F",
        '1f326': "\uD83C\uDF26\uFE0F",
        '1f308': "\uD83C\uDF08",
        '2601': "\u2601\uFE0F",
        '1f327': "\uD83C\uDF27\uFE0F",
        '26c8': "\u26C8\uFE0F",
        '1f329': "\uD83C\uDF29\uFE0F",
        '1f328': "\uD83C\uDF28\uFE0F",
        '2603': "\u2603\uFE0F",
        '26c4': "\u26C4",
        '2744': "\u2744\uFE0F",
        '1f32c': "\uD83C\uDF2C\uFE0F",
        '1f4a8': "\uD83D\uDCA8",
        '1f32a': "\uD83C\uDF2A\uFE0F",
        '1f32b': "\uD83C\uDF2B\uFE0F",
        '1f30a': "\uD83C\uDF0A",
        '1f4a7': "\uD83D\uDCA7",
        '1f4a6': "\uD83D\uDCA6",
        '2614': "\u2614",
        '1f992': "\uD83E\uDD92",
        '1f993': "\uD83E\uDD93",
        '1f994': "\uD83E\uDD94",
        '1f995': "\uD83E\uDD95",
        '1f996': "\uD83E\uDD96",
        '1f997': "\uD83E\uDD97",
        '1f34f': "\uD83C\uDF4F",
        '1f34e': "\uD83C\uDF4E",
        '1f350': "\uD83C\uDF50",
        '1f34a': "\uD83C\uDF4A",
        '1f34b': "\uD83C\uDF4B",
        '1f34c': "\uD83C\uDF4C",
        '1f349': "\uD83C\uDF49",
        '1f347': "\uD83C\uDF47",
        '1f353': "\uD83C\uDF53",
        '1f348': "\uD83C\uDF48",
        '1f352': "\uD83C\uDF52",
        '1f351': "\uD83C\uDF51",
        '1f34d': "\uD83C\uDF4D",
        '1f95d': "\uD83E\uDD5D",
        '1f951': "\uD83E\uDD51",
        '1f345': "\uD83C\uDF45",
        '1f346': "\uD83C\uDF46",
        '1f952': "\uD83E\uDD52",
        '1f955': "\uD83E\uDD55",
        '1f33d': "\uD83C\uDF3D",
        '1f336': "\uD83C\uDF36\uFE0F",
        '1f954': "\uD83E\uDD54",
        '1f360': "\uD83C\uDF60",
        '1f330': "\uD83C\uDF30",
        '1f95c': "\uD83E\uDD5C",
        '1f36f': "\uD83C\uDF6F",
        '1f950': "\uD83E\uDD50",
        '1f35e': "\uD83C\uDF5E",
        '1f956': "\uD83E\uDD56",
        '1f9c0': "\uD83E\uDDC0",
        '1f95a': "\uD83E\uDD5A",
        '1f373': "\uD83C\uDF73",
        '1f953': "\uD83E\uDD53",
        '1f95e': "\uD83E\uDD5E",
        '1f364': "\uD83C\uDF64",
        '1f357': "\uD83C\uDF57",
        '1f356': "\uD83C\uDF56",
        '1f355': "\uD83C\uDF55",
        '1f32d': "\uD83C\uDF2D",
        '1f354': "\uD83C\uDF54",
        '1f35f': "\uD83C\uDF5F",
        '1f959': "\uD83E\uDD59",
        '1f32e': "\uD83C\uDF2E",
        '1f32f': "\uD83C\uDF2F",
        '1f957': "\uD83E\uDD57",
        '1f958': "\uD83E\uDD58",
        '1f35d': "\uD83C\uDF5D",
        '1f35c': "\uD83C\uDF5C",
        '1f372': "\uD83C\uDF72",
        '1f365': "\uD83C\uDF65",
        '1f363': "\uD83C\uDF63",
        '1f371': "\uD83C\uDF71",
        '1f35b': "\uD83C\uDF5B",
        '1f359': "\uD83C\uDF59",
        '1f35a': "\uD83C\uDF5A",
        '1f358': "\uD83C\uDF58",
        '1f362': "\uD83C\uDF62",
        '1f361': "\uD83C\uDF61",
        '1f367': "\uD83C\uDF67",
        '1f368': "\uD83C\uDF68",
        '1f366': "\uD83C\uDF66",
        '1f370': "\uD83C\uDF70",
        '1f382': "\uD83C\uDF82",
        '1f36e': "\uD83C\uDF6E",
        '1f36d': "\uD83C\uDF6D",
        '1f36c': "\uD83C\uDF6C",
        '1f36b': "\uD83C\uDF6B",
        '1f37f': "\uD83C\uDF7F",
        '1f369': "\uD83C\uDF69",
        '1f36a': "\uD83C\uDF6A",
        '1f95b': "\uD83E\uDD5B",
        '1f37c': "\uD83C\uDF7C",
        '2615': "\u2615",
        '1f375': "\uD83C\uDF75",
        '1f376': "\uD83C\uDF76",
        '1f37a': "\uD83C\uDF7A",
        '1f37b': "\uD83C\uDF7B",
        '1f942': "\uD83E\uDD42",
        '1f377': "\uD83C\uDF77",
        '1f943': "\uD83E\uDD43",
        '1f378': "\uD83C\uDF78",
        '1f379': "\uD83C\uDF79",
        '1f37e': "\uD83C\uDF7E",
        '1f944': "\uD83E\uDD44",
        '1f374': "\uD83C\uDF74",
        '1f37d': "\uD83C\uDF7D\uFE0F",
        '1f95f': "\uD83E\uDD5F",
        '1f960': "\uD83E\uDD60",
        '1f961': "\uD83E\uDD61",
        '1f962': "\uD83E\uDD62",
        '1f963': "\uD83E\uDD63",
        '1f964': "\uD83E\uDD64",
        '1f965': "\uD83E\uDD65",
        '1f966': "\uD83E\uDD66",
        '1f967': "\uD83E\uDD67",
        '1f968': "\uD83E\uDD68",
        '1f969': "\uD83E\uDD69",
        '1f96a': "\uD83E\uDD6A",
        '1f96b': "\uD83E\uDD6B",
        '26bd': "\u26BD",
        '1f3c0': "\uD83C\uDFC0",
        '1f3c8': "\uD83C\uDFC8",
        '26be': "\u26BE",
        '1f3be': "\uD83C\uDFBE",
        '1f3d0': "\uD83C\uDFD0",
        '1f3c9': "\uD83C\uDFC9",
        '1f3b1': "\uD83C\uDFB1",
        '1f3d3': "\uD83C\uDFD3",
        '1f3f8': "\uD83C\uDFF8",
        '1f945': "\uD83E\uDD45",
        '1f3d2': "\uD83C\uDFD2",
        '1f3d1': "\uD83C\uDFD1",
        '1f3cf': "\uD83C\uDFCF",
        '26f3': "\u26F3",
        '1f3f9': "\uD83C\uDFF9",
        '1f3a3': "\uD83C\uDFA3",
        '1f94a': "\uD83E\uDD4A",
        '1f94b': "\uD83E\uDD4B",
        '26f8': "\u26F8\uFE0F",
        '1f3bf': "\uD83C\uDFBF",
        '26f7': "\u26F7\uFE0F",
        '1f3c2': "\uD83C\uDFC2",
        '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
        '1f3cb': "\uD83C\uDFCB\uFE0F",
        '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
        '1f93a': "\uD83E\uDD3A",
        '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
        '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
        '1f93c': "\uD83E\uDD3C",
        '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
        '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
        '1f938': "\uD83E\uDD38",
        '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
        '26f9': "\u26F9\uFE0F",
        '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
        '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
        '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
        '1f93e': "\uD83E\uDD3E",
        '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
        '1f3cc': "\uD83C\uDFCC\uFE0F",
        '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
        '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
        '1f3c4': "\uD83C\uDFC4",
        '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
        '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
        '1f3ca': "\uD83C\uDFCA",
        '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
        '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
        '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
        '1f93d': "\uD83E\uDD3D",
        '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
        '1f6a3': "\uD83D\uDEA3",
        '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
        '1f3c7': "\uD83C\uDFC7",
        '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
        '1f6b4': "\uD83D\uDEB4",
        '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
        '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
        '1f6b5': "\uD83D\uDEB5",
        '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
        '1f3bd': "\uD83C\uDFBD",
        '1f3c5': "\uD83C\uDFC5",
        '1f396': "\uD83C\uDF96\uFE0F",
        '1f947': "\uD83E\uDD47",
        '1f948': "\uD83E\uDD48",
        '1f949': "\uD83E\uDD49",
        '1f3c6': "\uD83C\uDFC6",
        '1f3f5': "\uD83C\uDFF5\uFE0F",
        '1f397': "\uD83C\uDF97\uFE0F",
        '1f3ab': "\uD83C\uDFAB",
        '1f39f': "\uD83C\uDF9F\uFE0F",
        '1f3aa': "\uD83C\uDFAA",
        '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
        '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
        '1f939': "\uD83E\uDD39",
        '1f3ad': "\uD83C\uDFAD",
        '1f3a8': "\uD83C\uDFA8",
        '1f3ac': "\uD83C\uDFAC",
        '1f3a4': "\uD83C\uDFA4",
        '1f3a7': "\uD83C\uDFA7",
        '1f3bc': "\uD83C\uDFBC",
        '1f3b9': "\uD83C\uDFB9",
        '1f941': "\uD83E\uDD41",
        '1f3b7': "\uD83C\uDFB7",
        '1f3ba': "\uD83C\uDFBA",
        '1f3b8': "\uD83C\uDFB8",
        '1f3bb': "\uD83C\uDFBB",
        '1f3b2': "\uD83C\uDFB2",
        '1f3af': "\uD83C\uDFAF",
        '1f3b3': "\uD83C\uDFB3",
        '1f3ae': "\uD83C\uDFAE",
        '1f3b0': "\uD83C\uDFB0",
        '1f6f7': "\uD83D\uDEF7",
        '1f931': "\uD83E\uDD31",
        '1f94c': "\uD83E\uDD4C",
        '1f9d6': "\uD83E\uDDD6",
        '1f9d7': "\uD83E\uDDD7",
        '1f9d8': "\uD83E\uDDD8",
        '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
        '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
        '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
        '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
        '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
        '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
        '1f697': "\uD83D\uDE97",
        '1f695': "\uD83D\uDE95",
        '1f699': "\uD83D\uDE99",
        '1f68c': "\uD83D\uDE8C",
        '1f68e': "\uD83D\uDE8E",
        '1f3ce': "\uD83C\uDFCE\uFE0F",
        '1f693': "\uD83D\uDE93",
        '1f691': "\uD83D\uDE91",
        '1f692': "\uD83D\uDE92",
        '1f690': "\uD83D\uDE90",
        '1f69a': "\uD83D\uDE9A",
        '1f69b': "\uD83D\uDE9B",
        '1f69c': "\uD83D\uDE9C",
        '1f6f4': "\uD83D\uDEF4",
        '1f6b2': "\uD83D\uDEB2",
        '1f6f5': "\uD83D\uDEF5",
        '1f3cd': "\uD83C\uDFCD\uFE0F",
        '1f6a8': "\uD83D\uDEA8",
        '1f694': "\uD83D\uDE94",
        '1f68d': "\uD83D\uDE8D",
        '1f698': "\uD83D\uDE98",
        '1f696': "\uD83D\uDE96",
        '1f6a1': "\uD83D\uDEA1",
        '1f6a0': "\uD83D\uDEA0",
        '1f69f': "\uD83D\uDE9F",
        '1f683': "\uD83D\uDE83",
        '1f68b': "\uD83D\uDE8B",
        '1f69e': "\uD83D\uDE9E",
        '1f69d': "\uD83D\uDE9D",
        '1f684': "\uD83D\uDE84",
        '1f685': "\uD83D\uDE85",
        '1f688': "\uD83D\uDE88",
        '1f682': "\uD83D\uDE82",
        '1f686': "\uD83D\uDE86",
        '1f687': "\uD83D\uDE87",
        '1f68a': "\uD83D\uDE8A",
        '1f689': "\uD83D\uDE89",
        '1f681': "\uD83D\uDE81",
        '1f6e9': "\uD83D\uDEE9\uFE0F",
        '2708': "\u2708\uFE0F",
        '1f6eb': "\uD83D\uDEEB",
        '1f6ec': "\uD83D\uDEEC",
        '1f680': "\uD83D\uDE80",
        '1f6f0': "\uD83D\uDEF0\uFE0F",
        '1f4ba': "\uD83D\uDCBA",
        '1f6f6': "\uD83D\uDEF6",
        '26f5': "\u26F5",
        '1f6e5': "\uD83D\uDEE5\uFE0F",
        '1f6a4': "\uD83D\uDEA4",
        '1f6f3': "\uD83D\uDEF3\uFE0F",
        '26f4': "\u26F4\uFE0F",
        '1f6a2': "\uD83D\uDEA2",
        '2693': "\u2693",
        '1f6a7': "\uD83D\uDEA7",
        '26fd': "\u26FD",
        '1f68f': "\uD83D\uDE8F",
        '1f6a6': "\uD83D\uDEA6",
        '1f6a5': "\uD83D\uDEA5",
        '1f5fa': "\uD83D\uDDFA\uFE0F",
        '1f5ff': "\uD83D\uDDFF",
        '1f5fd': "\uD83D\uDDFD",
        '26f2': "\u26F2",
        '1f5fc': "\uD83D\uDDFC",
        '1f3f0': "\uD83C\uDFF0",
        '1f3ef': "\uD83C\uDFEF",
        '1f3df': "\uD83C\uDFDF\uFE0F",
        '1f3a1': "\uD83C\uDFA1",
        '1f3a2': "\uD83C\uDFA2",
        '1f3a0': "\uD83C\uDFA0",
        '26f1': "\u26F1\uFE0F",
        '1f3d6': "\uD83C\uDFD6\uFE0F",
        '1f3dd': "\uD83C\uDFDD\uFE0F",
        '26f0': "\u26F0\uFE0F",
        '1f3d4': "\uD83C\uDFD4\uFE0F",
        '1f5fb': "\uD83D\uDDFB",
        '1f30b': "\uD83C\uDF0B",
        '1f3dc': "\uD83C\uDFDC\uFE0F",
        '1f3d5': "\uD83C\uDFD5\uFE0F",
        '26fa': "\u26FA",
        '1f6e4': "\uD83D\uDEE4\uFE0F",
        '1f6e3': "\uD83D\uDEE3\uFE0F",
        '1f3d7': "\uD83C\uDFD7\uFE0F",
        '1f3ed': "\uD83C\uDFED",
        '1f3e0': "\uD83C\uDFE0",
        '1f3e1': "\uD83C\uDFE1",
        '1f3d8': "\uD83C\uDFD8\uFE0F",
        '1f3da': "\uD83C\uDFDA\uFE0F",
        '1f3e2': "\uD83C\uDFE2",
        '1f3ec': "\uD83C\uDFEC",
        '1f3e3': "\uD83C\uDFE3",
        '1f3e4': "\uD83C\uDFE4",
        '1f3e5': "\uD83C\uDFE5",
        '1f3e6': "\uD83C\uDFE6",
        '1f3e8': "\uD83C\uDFE8",
        '1f3ea': "\uD83C\uDFEA",
        '1f3eb': "\uD83C\uDFEB",
        '1f3e9': "\uD83C\uDFE9",
        '1f492': "\uD83D\uDC92",
        '1f3db': "\uD83C\uDFDB\uFE0F",
        '26ea': "\u26EA",
        '1f54c': "\uD83D\uDD4C",
        '1f54d': "\uD83D\uDD4D",
        '1f54b': "\uD83D\uDD4B",
        '26e9': "\u26E9\uFE0F",
        '1f5fe': "\uD83D\uDDFE",
        '1f391': "\uD83C\uDF91",
        '1f3de': "\uD83C\uDFDE\uFE0F",
        '1f305': "\uD83C\uDF05",
        '1f304': "\uD83C\uDF04",
        '1f320': "\uD83C\uDF20",
        '1f387': "\uD83C\uDF87",
        '1f386': "\uD83C\uDF86",
        '1f307': "\uD83C\uDF07",
        '1f306': "\uD83C\uDF06",
        '1f3d9': "\uD83C\uDFD9\uFE0F",
        '1f303': "\uD83C\uDF03",
        '1f30c': "\uD83C\uDF0C",
        '1f309': "\uD83C\uDF09",
        '1f301': "\uD83C\uDF01",
        '1f6f8': "\uD83D\uDEF8",
        '231a': "\u231A",
        '1f4f1': "\uD83D\uDCF1",
        '1f4f2': "\uD83D\uDCF2",
        '1f4bb': "\uD83D\uDCBB",
        '2328': "\u2328\uFE0F",
        '1f5a5': "\uD83D\uDDA5\uFE0F",
        '1f5a8': "\uD83D\uDDA8\uFE0F",
        '1f5b1': "\uD83D\uDDB1\uFE0F",
        '1f5b2': "\uD83D\uDDB2\uFE0F",
        '1f579': "\uD83D\uDD79\uFE0F",
        '1f5dc': "\uD83D\uDDDC\uFE0F",
        '1f4bd': "\uD83D\uDCBD",
        '1f4be': "\uD83D\uDCBE",
        '1f4bf': "\uD83D\uDCBF",
        '1f4c0': "\uD83D\uDCC0",
        '1f4fc': "\uD83D\uDCFC",
        '1f4f7': "\uD83D\uDCF7",
        '1f4f8': "\uD83D\uDCF8",
        '1f4f9': "\uD83D\uDCF9",
        '1f3a5': "\uD83C\uDFA5",
        '1f4fd': "\uD83D\uDCFD\uFE0F",
        '1f39e': "\uD83C\uDF9E\uFE0F",
        '1f4de': "\uD83D\uDCDE",
        '260e': "\u260E\uFE0F",
        '1f4df': "\uD83D\uDCDF",
        '1f4e0': "\uD83D\uDCE0",
        '1f4fa': "\uD83D\uDCFA",
        '1f4fb': "\uD83D\uDCFB",
        '1f399': "\uD83C\uDF99\uFE0F",
        '1f39a': "\uD83C\uDF9A\uFE0F",
        '1f39b': "\uD83C\uDF9B\uFE0F",
        '23f1': "\u23F1\uFE0F",
        '23f2': "\u23F2\uFE0F",
        '23f0': "\u23F0",
        '1f570': "\uD83D\uDD70\uFE0F",
        '231b': "\u231B",
        '23f3': "\u23F3",
        '1f4e1': "\uD83D\uDCE1",
        '1f50b': "\uD83D\uDD0B",
        '1f50c': "\uD83D\uDD0C",
        '1f4a1': "\uD83D\uDCA1",
        '1f526': "\uD83D\uDD26",
        '1f56f': "\uD83D\uDD6F\uFE0F",
        '1f5d1': "\uD83D\uDDD1\uFE0F",
        '1f6e2': "\uD83D\uDEE2\uFE0F",
        '1f4b8': "\uD83D\uDCB8",
        '1f4b5': "\uD83D\uDCB5",
        '1f4b4': "\uD83D\uDCB4",
        '1f4b6': "\uD83D\uDCB6",
        '1f4b7': "\uD83D\uDCB7",
        '1f4b0': "\uD83D\uDCB0",
        '1f4b3': "\uD83D\uDCB3",
        '1f48e': "\uD83D\uDC8E",
        '2696': "\u2696\uFE0F",
        '1f527': "\uD83D\uDD27",
        '1f528': "\uD83D\uDD28",
        '2692': "\u2692\uFE0F",
        '1f6e0': "\uD83D\uDEE0\uFE0F",
        '26cf': "\u26CF\uFE0F",
        '1f529': "\uD83D\uDD29",
        '2699': "\u2699\uFE0F",
        '26d3': "\u26D3\uFE0F",
        '1f52b': "\uD83D\uDD2B",
        '1f4a3': "\uD83D\uDCA3",
        '1f52a': "\uD83D\uDD2A",
        '1f5e1': "\uD83D\uDDE1\uFE0F",
        '2694': "\u2694\uFE0F",
        '1f6e1': "\uD83D\uDEE1\uFE0F",
        '1f6ac': "\uD83D\uDEAC",
        '26b0': "\u26B0\uFE0F",
        '26b1': "\u26B1\uFE0F",
        '1f3fa': "\uD83C\uDFFA",
        '1f52e': "\uD83D\uDD2E",
        '1f4ff': "\uD83D\uDCFF",
        '1f488': "\uD83D\uDC88",
        '2697': "\u2697\uFE0F",
        '1f52d': "\uD83D\uDD2D",
        '1f52c': "\uD83D\uDD2C",
        '1f573': "\uD83D\uDD73\uFE0F",
        '1f48a': "\uD83D\uDC8A",
        '1f489': "\uD83D\uDC89",
        '1f321': "\uD83C\uDF21\uFE0F",
        '1f6bd': "\uD83D\uDEBD",
        '1f6b0': "\uD83D\uDEB0",
        '1f6bf': "\uD83D\uDEBF",
        '1f6c1': "\uD83D\uDEC1",
        '1f6c0': "\uD83D\uDEC0",
        '1f6ce': "\uD83D\uDECE\uFE0F",
        '1f511': "\uD83D\uDD11",
        '1f5dd': "\uD83D\uDDDD\uFE0F",
        '1f6aa': "\uD83D\uDEAA",
        '1f6cb': "\uD83D\uDECB\uFE0F",
        '1f6cf': "\uD83D\uDECF\uFE0F",
        '1f6cc': "\uD83D\uDECC",
        '1f5bc': "\uD83D\uDDBC\uFE0F",
        '1f6cd': "\uD83D\uDECD\uFE0F",
        '1f6d2': "\uD83D\uDED2",
        '1f381': "\uD83C\uDF81",
        '1f388': "\uD83C\uDF88",
        '1f38f': "\uD83C\uDF8F",
        '1f380': "\uD83C\uDF80",
        '1f38a': "\uD83C\uDF8A",
        '1f389': "\uD83C\uDF89",
        '1f38e': "\uD83C\uDF8E",
        '1f3ee': "\uD83C\uDFEE",
        '1f390': "\uD83C\uDF90",
        '2709': "\u2709\uFE0F",
        '1f4e9': "\uD83D\uDCE9",
        '1f4e8': "\uD83D\uDCE8",
        '1f4e7': "\uD83D\uDCE7",
        '1f48c': "\uD83D\uDC8C",
        '1f4e5': "\uD83D\uDCE5",
        '1f4e4': "\uD83D\uDCE4",
        '1f4e6': "\uD83D\uDCE6",
        '1f3f7': "\uD83C\uDFF7\uFE0F",
        '1f4ea': "\uD83D\uDCEA",
        '1f4eb': "\uD83D\uDCEB",
        '1f4ec': "\uD83D\uDCEC",
        '1f4ed': "\uD83D\uDCED",
        '1f4ee': "\uD83D\uDCEE",
        '1f4ef': "\uD83D\uDCEF",
        '1f4dc': "\uD83D\uDCDC",
        '1f4c3': "\uD83D\uDCC3",
        '1f4c4': "\uD83D\uDCC4",
        '1f4d1': "\uD83D\uDCD1",
        '1f4ca': "\uD83D\uDCCA",
        '1f4c8': "\uD83D\uDCC8",
        '1f4c9': "\uD83D\uDCC9",
        '1f5d2': "\uD83D\uDDD2\uFE0F",
        '1f5d3': "\uD83D\uDDD3\uFE0F",
        '1f4c6': "\uD83D\uDCC6",
        '1f4c5': "\uD83D\uDCC5",
        '1f4c7': "\uD83D\uDCC7",
        '1f5c3': "\uD83D\uDDC3\uFE0F",
        '1f5f3': "\uD83D\uDDF3\uFE0F",
        '1f5c4': "\uD83D\uDDC4\uFE0F",
        '1f4cb': "\uD83D\uDCCB",
        '1f4c1': "\uD83D\uDCC1",
        '1f4c2': "\uD83D\uDCC2",
        '1f5c2': "\uD83D\uDDC2\uFE0F",
        '1f5de': "\uD83D\uDDDE\uFE0F",
        '1f4f0': "\uD83D\uDCF0",
        '1f4d3': "\uD83D\uDCD3",
        '1f4d4': "\uD83D\uDCD4",
        '1f4d2': "\uD83D\uDCD2",
        '1f4d5': "\uD83D\uDCD5",
        '1f4d7': "\uD83D\uDCD7",
        '1f4d8': "\uD83D\uDCD8",
        '1f4d9': "\uD83D\uDCD9",
        '1f4da': "\uD83D\uDCDA",
        '1f4d6': "\uD83D\uDCD6",
        '1f516': "\uD83D\uDD16",
        '1f517': "\uD83D\uDD17",
        '1f4ce': "\uD83D\uDCCE",
        '1f587': "\uD83D\uDD87\uFE0F",
        '1f4d0': "\uD83D\uDCD0",
        '1f4cf': "\uD83D\uDCCF",
        '1f4cc': "\uD83D\uDCCC",
        '1f4cd': "\uD83D\uDCCD",
        '2702': "\u2702\uFE0F",
        '1f58a': "\uD83D\uDD8A\uFE0F",
        '1f58b': "\uD83D\uDD8B\uFE0F",
        '2712': "\u2712\uFE0F",
        '1f58c': "\uD83D\uDD8C\uFE0F",
        '1f58d': "\uD83D\uDD8D\uFE0F",
        '1f4dd': "\uD83D\uDCDD",
        '270f': "\u270F\uFE0F",
        '1f50d': "\uD83D\uDD0D",
        '1f50e': "\uD83D\uDD0E",
        '1f50f': "\uD83D\uDD0F",
        '1f510': "\uD83D\uDD10",
        '1f512': "\uD83D\uDD12",
        '1f513': "\uD83D\uDD13",
        '1f9e1': "\uD83E\uDDE1",
        '2764': "\u2764\uFE0F",
        '1f49b': "\uD83D\uDC9B",
        '1f49a': "\uD83D\uDC9A",
        '1f499': "\uD83D\uDC99",
        '1f49c': "\uD83D\uDC9C",
        '1f5a4': "\uD83D\uDDA4",
        '1f494': "\uD83D\uDC94",
        '2763': "\u2763\uFE0F",
        '1f495': "\uD83D\uDC95",
        '1f49e': "\uD83D\uDC9E",
        '1f493': "\uD83D\uDC93",
        '1f497': "\uD83D\uDC97",
        '1f496': "\uD83D\uDC96",
        '1f498': "\uD83D\uDC98",
        '1f49d': "\uD83D\uDC9D",
        '1f49f': "\uD83D\uDC9F",
        '262e': "\u262E\uFE0F",
        '271d': "\u271D\uFE0F",
        '262a': "\u262A\uFE0F",
        '1f549': "\uD83D\uDD49\uFE0F",
        '2638': "\u2638\uFE0F",
        '2721': "\u2721\uFE0F",
        '1f52f': "\uD83D\uDD2F",
        '1f54e': "\uD83D\uDD4E",
        '262f': "\u262F\uFE0F",
        '2626': "\u2626\uFE0F",
        '1f6d0': "\uD83D\uDED0",
        '26ce': "\u26CE",
        '2648': "\u2648",
        '2649': "\u2649",
        '264a': "\u264A",
        '264b': "\u264B",
        '264c': "\u264C",
        '264d': "\u264D",
        '264e': "\u264E",
        '264f': "\u264F",
        '2650': "\u2650",
        '2651': "\u2651",
        '2652': "\u2652",
        '2653': "\u2653",
        '1f194': "\uD83C\uDD94",
        '269b': "\u269B\uFE0F",
        '1f251': "\uD83C\uDE51",
        '2622': "\u2622\uFE0F",
        '2623': "\u2623\uFE0F",
        '1f4f4': "\uD83D\uDCF4",
        '1f4f3': "\uD83D\uDCF3",
        '1f236': "\uD83C\uDE36",
        '1f21a': "\uD83C\uDE1A",
        '1f238': "\uD83C\uDE38",
        '1f23a': "\uD83C\uDE3A",
        '1f237': "\uD83C\uDE37\uFE0F",
        '2734': "\u2734\uFE0F",
        '1f19a': "\uD83C\uDD9A",
        '1f4ae': "\uD83D\uDCAE",
        '1f250': "\uD83C\uDE50",
        '3299': "\u3299\uFE0F",
        '3297': "\u3297\uFE0F",
        '1f234': "\uD83C\uDE34",
        '1f235': "\uD83C\uDE35",
        '1f239': "\uD83C\uDE39",
        '1f232': "\uD83C\uDE32",
        '1f170': "\uD83C\uDD70\uFE0F",
        '1f171': "\uD83C\uDD71\uFE0F",
        '1f18e': "\uD83C\uDD8E",
        '1f191': "\uD83C\uDD91",
        '1f17e': "\uD83C\uDD7E\uFE0F",
        '1f198': "\uD83C\uDD98",
        '274c': "\u274C",
        '2b55': "\u2B55",
        '1f6d1': "\uD83D\uDED1",
        '26d4': "\u26D4",
        '1f4db': "\uD83D\uDCDB",
        '1f6ab': "\uD83D\uDEAB",
        '1f4af': "\uD83D\uDCAF",
        '1f4a2': "\uD83D\uDCA2",
        '2668': "\u2668\uFE0F",
        '1f6b7': "\uD83D\uDEB7",
        '1f6af': "\uD83D\uDEAF",
        '1f6b3': "\uD83D\uDEB3",
        '1f6b1': "\uD83D\uDEB1",
        '1f51e': "\uD83D\uDD1E",
        '1f4f5': "\uD83D\uDCF5",
        '1f6ad': "\uD83D\uDEAD",
        '2757': "\u2757",
        '2755': "\u2755",
        '2753': "\u2753",
        '2754': "\u2754",
        '203c': "\u203C\uFE0F",
        '2049': "\u2049\uFE0F",
        '1f505': "\uD83D\uDD05",
        '1f506': "\uD83D\uDD06",
        '303d': "\u303D\uFE0F",
        '26a0': "\u26A0\uFE0F",
        '1f6b8': "\uD83D\uDEB8",
        '1f531': "\uD83D\uDD31",
        '269c': "\u269C\uFE0F",
        '1f530': "\uD83D\uDD30",
        '267b': "\u267B\uFE0F",
        '2705': "\u2705",
        '1f22f': "\uD83C\uDE2F",
        '1f4b9': "\uD83D\uDCB9",
        '2747': "\u2747\uFE0F",
        '2733': "\u2733\uFE0F",
        '274e': "\u274E",
        '1f310': "\uD83C\uDF10",
        '1f4a0': "\uD83D\uDCA0",
        '24c2': "\u24C2\uFE0F",
        '1f300': "\uD83C\uDF00",
        '1f4a4': "\uD83D\uDCA4",
        '1f3e7': "\uD83C\uDFE7",
        '1f6be': "\uD83D\uDEBE",
        '267f': "\u267F",
        '1f17f': "\uD83C\uDD7F\uFE0F",
        '1f233': "\uD83C\uDE33",
        '1f202': "\uD83C\uDE02\uFE0F",
        '1f6c2': "\uD83D\uDEC2",
        '1f6c3': "\uD83D\uDEC3",
        '1f6c4': "\uD83D\uDEC4",
        '1f6c5': "\uD83D\uDEC5",
        '1f6b9': "\uD83D\uDEB9",
        '1f6ba': "\uD83D\uDEBA",
        '1f6bc': "\uD83D\uDEBC",
        '1f6bb': "\uD83D\uDEBB",
        '1f6ae': "\uD83D\uDEAE",
        '1f3a6': "\uD83C\uDFA6",
        '1f4f6': "\uD83D\uDCF6",
        '1f201': "\uD83C\uDE01",
        '1f523': "\uD83D\uDD23",
        '2139': "\u2139\uFE0F",
        '1f524': "\uD83D\uDD24",
        '1f521': "\uD83D\uDD21",
        '1f520': "\uD83D\uDD20",
        '1f196': "\uD83C\uDD96",
        '1f197': "\uD83C\uDD97",
        '1f199': "\uD83C\uDD99",
        '1f192': "\uD83C\uDD92",
        '1f195': "\uD83C\uDD95",
        '1f193': "\uD83C\uDD93",
        '30-20e3': "0\uFE0F\u20E3",
        '31-20e3': "1\uFE0F\u20E3",
        '32-20e3': "2\uFE0F\u20E3",
        '33-20e3': "3\uFE0F\u20E3",
        '34-20e3': "4\uFE0F\u20E3",
        '35-20e3': "5\uFE0F\u20E3",
        '36-20e3': "6\uFE0F\u20E3",
        '37-20e3': "7\uFE0F\u20E3",
        '38-20e3': "8\uFE0F\u20E3",
        '39-20e3': "9\uFE0F\u20E3",
        '1f51f': "\uD83D\uDD1F",
        '1f522': "\uD83D\uDD22",
        '23-20e3': "#\uFE0F\u20E3",
        '2a-20e3': "*\uFE0F\u20E3",
        '25b6': "\u25B6\uFE0F",
        '23f8': "\u23F8\uFE0F",
        '23ef': "\u23EF\uFE0F",
        '23f9': "\u23F9\uFE0F",
        '23fa': "\u23FA\uFE0F",
        '23cf': "\u23CF\uFE0F",
        '23ed': "\u23ED\uFE0F",
        '23ee': "\u23EE\uFE0F",
        '23e9': "\u23E9",
        '23ea': "\u23EA",
        '23eb': "\u23EB",
        '23ec': "\u23EC",
        '25c0': "\u25C0\uFE0F",
        '1f53c': "\uD83D\uDD3C",
        '1f53d': "\uD83D\uDD3D",
        '27a1': "\u27A1\uFE0F",
        '2b05': "\u2B05\uFE0F",
        '2b06': "\u2B06\uFE0F",
        '2b07': "\u2B07\uFE0F",
        '2197': "\u2197\uFE0F",
        '2198': "\u2198\uFE0F",
        '2199': "\u2199\uFE0F",
        '2196': "\u2196\uFE0F",
        '2195': "\u2195\uFE0F",
        '2194': "\u2194\uFE0F",
        '21aa': "\u21AA\uFE0F",
        '21a9': "\u21A9\uFE0F",
        '2934': "\u2934\uFE0F",
        '2935': "\u2935\uFE0F",
        '1f500': "\uD83D\uDD00",
        '1f501': "\uD83D\uDD01",
        '1f502': "\uD83D\uDD02",
        '1f504': "\uD83D\uDD04",
        '1f503': "\uD83D\uDD03",
        '1f3b5': "\uD83C\uDFB5",
        '1f3b6': "\uD83C\uDFB6",
        '2795': "\u2795",
        '2796': "\u2796",
        '2797': "\u2797",
        '2716': "\u2716\uFE0F",
        '1f4b2': "\uD83D\uDCB2",
        '1f4b1': "\uD83D\uDCB1",
        '2122': "\u2122\uFE0F",
        a9: "\xa9\uFE0F",
        ae: "\xae\uFE0F",
        '3030': "\u3030\uFE0F",
        '27b0': "\u27B0",
        '27bf': "\u27BF",
        '1f51a': "\uD83D\uDD1A",
        '1f519': "\uD83D\uDD19",
        '1f51b': "\uD83D\uDD1B",
        '1f51d': "\uD83D\uDD1D",
        '1f51c': "\uD83D\uDD1C",
        '2714': "\u2714\uFE0F",
        '2611': "\u2611\uFE0F",
        '1f518': "\uD83D\uDD18",
        '26aa': "\u26AA",
        '26ab': "\u26AB",
        '1f534': "\uD83D\uDD34",
        '1f535': "\uD83D\uDD35",
        '1f53a': "\uD83D\uDD3A",
        '1f53b': "\uD83D\uDD3B",
        '1f538': "\uD83D\uDD38",
        '1f539': "\uD83D\uDD39",
        '1f536': "\uD83D\uDD36",
        '1f537': "\uD83D\uDD37",
        '1f533': "\uD83D\uDD33",
        '1f532': "\uD83D\uDD32",
        '25aa': "\u25AA\uFE0F",
        '25ab': "\u25AB\uFE0F",
        '25fe': "\u25FE",
        '25fd': "\u25FD",
        '25fc': "\u25FC\uFE0F",
        '25fb': "\u25FB\uFE0F",
        '2b1b': "\u2B1B",
        '2b1c': "\u2B1C",
        '1f508': "\uD83D\uDD08",
        '1f507': "\uD83D\uDD07",
        '1f509': "\uD83D\uDD09",
        '1f50a': "\uD83D\uDD0A",
        '1f514': "\uD83D\uDD14",
        '1f515': "\uD83D\uDD15",
        '1f4e3': "\uD83D\uDCE3",
        '1f4e2': "\uD83D\uDCE2",
        '1f5e8': "\uD83D\uDDE8\uFE0F",
        '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
        '1f4ac': "\uD83D\uDCAC",
        '1f4ad': "\uD83D\uDCAD",
        '1f5ef': "\uD83D\uDDEF\uFE0F",
        '2660': "\u2660\uFE0F",
        '2663': "\u2663\uFE0F",
        '2665': "\u2665\uFE0F",
        '2666': "\u2666\uFE0F",
        '1f0cf': "\uD83C\uDCCF",
        '1f3b4': "\uD83C\uDFB4",
        '1f004': "\uD83C\uDC04",
        '1f550': "\uD83D\uDD50",
        '1f551': "\uD83D\uDD51",
        '1f552': "\uD83D\uDD52",
        '1f553': "\uD83D\uDD53",
        '1f554': "\uD83D\uDD54",
        '1f555': "\uD83D\uDD55",
        '1f556': "\uD83D\uDD56",
        '1f557': "\uD83D\uDD57",
        '1f558': "\uD83D\uDD58",
        '1f559': "\uD83D\uDD59",
        '1f55a': "\uD83D\uDD5A",
        '1f55b': "\uD83D\uDD5B",
        '1f55c': "\uD83D\uDD5C",
        '1f55d': "\uD83D\uDD5D",
        '1f55e': "\uD83D\uDD5E",
        '1f55f': "\uD83D\uDD5F",
        '1f560': "\uD83D\uDD60",
        '1f561': "\uD83D\uDD61",
        '1f562': "\uD83D\uDD62",
        '1f563': "\uD83D\uDD63",
        '1f564': "\uD83D\uDD64",
        '1f565': "\uD83D\uDD65",
        '1f566': "\uD83D\uDD66",
        '1f567': "\uD83D\uDD67",
        '1f3f3': "\uD83C\uDFF3\uFE0F",
        '1f3f4': "\uD83C\uDFF4",
        '1f3c1': "\uD83C\uDFC1",
        '1f6a9': "\uD83D\uDEA9",
        '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
        '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
        '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
        '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
        '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
        '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
        '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
        '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
        '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
        '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
        '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
        '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
        '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
        '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
        '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
        '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
        '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
        '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
        '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
        '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
        '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
        '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
        '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
        '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
        '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
        '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
        '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
        '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
        '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
        '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
        '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
        '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
        '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
        '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
        '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
        '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
        '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
        '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
        '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
        '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
        '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
        '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
        '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
        '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
        '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
        '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
        '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
        '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
        '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
        '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
        '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
        '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
        '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
        '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
        '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
        '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
        '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
        '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
        '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
        '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
        '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
        '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
        '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
        '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
        '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
        '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
        '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
        '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
        '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
        '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
        '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
        '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
        '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
        '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
        '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
        '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
        '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
        '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
        '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
        '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
        '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
        '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
        '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
        '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
        '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
        '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
        '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
        '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
        '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
        '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
        '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
        '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
        '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
        '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
        '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
        '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
        '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
        '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
        '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
        '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
        '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
        '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
        '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
        '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
        '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
        '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
        '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
        '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
        '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
        '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
        '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
        '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
        '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
        '1f38c': "\uD83C\uDF8C",
        '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
        '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
        '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
        '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
        '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
        '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
        '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
        '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
        '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
        '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
        '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
        '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
        '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
        '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
        '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
        '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
        '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
        '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
        '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
        '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
        '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
        '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
        '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
        '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
        '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
        '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
        '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
        '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
        '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
        '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
        '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
        '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
        '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
        '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
        '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
        '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
        '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
        '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
        '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
        '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
        '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
        '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
        '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
        '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
        '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
        '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
        '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
        '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
        '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
        '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
        '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
        '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
        '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
        '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
        '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
        '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
        '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
        '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
        '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
        '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
        '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
        '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
        '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
        '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
        '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
        '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
        '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
        '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
        '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
        '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
        '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
        '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
        '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
        '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
        '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
        '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
        '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
        '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
        '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
        '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
        '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
        '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
        '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
        '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
        '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
        '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
        '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
        '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
        '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
        '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
        '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
        '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
        '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
        '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
        '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
        '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
        '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
        '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
        '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
        '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
        '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
        '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
        '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
        '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
        '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
        '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
        '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
        '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
        '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
        '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
        '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
        '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
        '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
        '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
        '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
        '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
        '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
        '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
        '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
        '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
        '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
        '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
        '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
        '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
        '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
        '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
        '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
        '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
        '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
        '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
        '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
        '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
        '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
        '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
        '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
        '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
        '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
        '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
        '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
        '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
        '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
        '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
        '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
        '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
        '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
        '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
        '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
        '1f1ff': "\uD83C\uDDFF",
        '1f1fe': "\uD83C\uDDFE",
        '1f1fd': "\uD83C\uDDFD",
        '1f3fb': "\uD83C\uDFFB",
        '1f3fc': "\uD83C\uDFFC",
        '1f3fd': "\uD83C\uDFFD",
        '1f3fe': "\uD83C\uDFFE",
        '1f3ff': "\uD83C\uDFFF",
        '1f1fc': "\uD83C\uDDFC",
        '1f1fb': "\uD83C\uDDFB",
        '1f1fa': "\uD83C\uDDFA",
        '1f1f9': "\uD83C\uDDF9",
        '1f1f8': "\uD83C\uDDF8",
        '1f1f7': "\uD83C\uDDF7",
        '1f1f6': "\uD83C\uDDF6",
        '1f1f5': "\uD83C\uDDF5",
        '1f1f4': "\uD83C\uDDF4",
        '1f1f3': "\uD83C\uDDF3",
        '1f1f2': "\uD83C\uDDF2",
        '1f1f1': "\uD83C\uDDF1",
        '1f1f0': "\uD83C\uDDF0",
        '1f1ef': "\uD83C\uDDEF",
        '1f1ee': "\uD83C\uDDEE",
        '1f1ed': "\uD83C\uDDED",
        '1f1ec': "\uD83C\uDDEC",
        '1f1eb': "\uD83C\uDDEB",
        '1f1ea': "\uD83C\uDDEA",
        '1f1e9': "\uD83C\uDDE9",
        '1f1e8': "\uD83C\uDDE8",
        '1f1e7': "\uD83C\uDDE7",
        '1f1e6': "\uD83C\uDDE6",
        '2640': "\u2640\uFE0F",
        '2642': "\u2642\uFE0F",
        '2695': "\u2695\uFE0F",
        '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f928': "\uD83E\uDD28",
        '1f929': "\uD83E\uDD29",
        '1f92a': "\uD83E\uDD2A",
        '1f92b': "\uD83E\uDD2B",
        '1f92c': "\uD83E\uDD2C",
        '1f92d': "\uD83E\uDD2D",
        '1f92e': "\uD83E\uDD2E",
        '1f92f': "\uD83E\uDD2F",
        '1f9d0': "\uD83E\uDDD0",
        '1f9d1': "\uD83E\uDDD1",
        '1f9d2': "\uD83E\uDDD2",
        '1f9d3': "\uD83E\uDDD3",
        '1f9d4': "\uD83E\uDDD4",
        '1f9d5': "\uD83E\uDDD5",
        '1f9e0': "\uD83E\uDDE0",
        '1f9e2': "\uD83E\uDDE2",
        '1f9d9': "\uD83E\uDDD9",
        '1f9da': "\uD83E\uDDDA",
        '1f9db': "\uD83E\uDDDB",
        '1f9dc': "\uD83E\uDDDC",
        '1f9dd': "\uD83E\uDDDD",
        '1f9de': "\uD83E\uDDDE",
        '1f9df': "\uD83E\uDDDF",
        '1f9e3': "\uD83E\uDDE3",
        '1f9e4': "\uD83E\uDDE4",
        '1f9e5': "\uD83E\uDDE5",
        '1f9e6': "\uD83E\uDDE6",
        '1f91f': "\uD83E\uDD1F",
        '1f932': "\uD83E\uDD32",
        '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
        '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
        '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
        '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
        '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
        '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
        '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
        '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
        '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
        '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
        '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
        '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
        '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
        '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
        'atlassian-check_mark': '(/)',
        'atlassian-cross_mark': '(x)',
        'atlassian-plus': '(+)',
        'atlassian-minus': '(-)',
        'atlassian-light_bulb_on': '(on)',
        'atlassian-light_bulb_off': '(off)',
        'atlassian-flag_on': '(flag)',
        'atlassian-flag_off': '(flagoff)',
        'atlassian-warning': '(!)',
        'atlassian-question_mark': '(?)',
        'atlassian-info': '(i)',
        'atlassian-yellow_star': '(*y)',
        'atlassian-blue_star': '(*b)',
        'atlassian-green_star': '(*g)',
        'atlassian-red_star': '(*r)'
    };
});
parcelRegister("1Nefo", function(module, exports) {
    $parcel$export(module.exports, "unknown", ()=>$6e7c0aa132a04ffb$export$19282c40b967aec6);
    var $hYNZx;
    const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
        const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
        return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
    };
});
parcelRegister("e34Iq", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$0b90673427e9e36d$export$371da9dd35aba193);
    const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
        return '\n';
    };
});
parcelRegister("6obXI", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$b266c76290bae2fd$export$38bab695e3f720f1);
    const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
        let fileName;
        fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        return `[^${fileName}]`;
    };
});
parcelRegister("7GCbZ", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$276f00c4f54975e4$export$db83999c14438df4);
    const $276f00c4f54975e4$var$PREFIX = 'accountid:';
    const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
    const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
    const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
        if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
        const mentionKey = node.attrs.id.toLowerCase();
        const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
        return `[~${content}]`;
    };
});
parcelRegister("6ayzl", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$774ee87c38efef1c$export$6f093cfa640b7166);
    var $cG4PY;
    var $4yZSi;
    var $aDTWq;
    var $gdFeW;
    var $jo5YT;
    var $9fwgI;
    var $eKxrE;
    var $1x55I;
    var $8tKGr;
    const $774ee87c38efef1c$var$markEncoderMapping = new Map([
        [
            'em',
            (0, (0, parcelRequire("gdFeW")).em)
        ],
        [
            'strike',
            (0, (0, parcelRequire("9fwgI")).strike)
        ],
        [
            'strong',
            (0, (0, parcelRequire("eKxrE")).strong)
        ],
        [
            'subsup',
            (0, (0, parcelRequire("1x55I")).subsup)
        ],
        [
            'underline',
            (0, (0, parcelRequire("8tKGr")).underline)
        ],
        [
            'textColor',
            (0, (0, parcelRequire("aDTWq")).textColor)
        ],
        [
            'link',
            (0, (0, parcelRequire("jo5YT")).link)
        ],
        [
            'code',
            (0, (0, parcelRequire("4yZSi")).code)
        ]
    ]);
    const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)';
    const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)';
    const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])';
    const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
        return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
    };
    function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
        const pattern = [
            $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
            ...(0, (0, parcelRequire("cG4PY")).macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
        ].join('|');
        return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2').replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
    }
    const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
        let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
        $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
            const mark = node.marks.find((m)=>m.type.name === markName);
            if (mark) result = encoder(result, mark.attrs);
        });
        return result;
    };
});
parcelRegister("cG4PY", function(module, exports) {
    $parcel$export(module.exports, "macroKeywordTokenMap", ()=>$87fdd6b952f97dba$export$afcd7edeca61ca93);
    $parcel$export(module.exports, "parseMacroKeyword", ()=>$87fdd6b952f97dba$export$39c29c0b4f759e52);
    $parcel$export(module.exports, "parseOtherKeyword", ()=>$87fdd6b952f97dba$export$ce89e528658ee2ac);
    $parcel$export(module.exports, "parseLeadingKeyword", ()=>$87fdd6b952f97dba$export$68162fc57528b560);
    $parcel$export(module.exports, "parseIssueKeyword", ()=>$87fdd6b952f97dba$export$bcec6d03770b152c);
    var $kSL4h;
    var $ayQVO;
    const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ADF_MACRO,
            regex: /^{adf/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ANCHOR_MACRO,
            regex: /^{anchor/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).CODE_MACRO,
            regex: /^{code/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE_MACRO,
            regex: /^{quote/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).NOFORMAT_MACRO,
            regex: /^{noformat/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).PANEL_MACRO,
            regex: /^{panel/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO,
            regex: /^{color/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).LOREM_MACRO,
            regex: /^{loremipsum/i
        }
    ];
    const $87fdd6b952f97dba$var$keywordTokenMap = {
        '[': (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT,
        http: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        ftp: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        jamfselfservice: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        irc: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        mailto: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        '\\\\': (0, (0, parcelRequire("kSL4h")).TokenType).FORCE_LINE_BREAK,
        '\r': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '\n': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '\r\n': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '!': (0, (0, parcelRequire("kSL4h")).TokenType).MEDIA,
        '----': (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
        '---': (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
        '--': (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
        '{-}': (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
        '{+}': (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
        '{*}': (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
        '{^}': (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
        '{~}': (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
        '{_}': (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
        '{{{}': (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
        '{??}': (0, (0, parcelRequire("kSL4h")).TokenType).CITATION,
        '-': (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
        '+': (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
        '*': (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
        '^': (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
        '~': (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
        _: (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
        '{{': (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
        '??': (0, (0, parcelRequire("kSL4h")).TokenType).CITATION
    };
    const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
    function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
        for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
            const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
        for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
            if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
                type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
            };
        }
        const char = input.charAt(0);
        if ([
            ':',
            '(',
            ';'
        ].indexOf(char) !== -1) return {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).EMOJI
        };
        return null;
    }
    const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE,
            regex: /^bq\./
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).HEADING,
            regex: /^h[1-6]\./
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            regex: /^-{4,5}(\s|$)/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            regex: /^-{3}\s/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            regex: /^-{2}\s/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            regex: new RegExp(`^([*#]{1,${(0, (0, parcelRequire("ayQVO")).MAX_LIST_DEPTH)}}|-) `)
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            regex: /^\|{1,2}/
        }
    ];
    function $87fdd6b952f97dba$export$68162fc57528b560(input) {
        for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
            const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
        if (issueKeyRegex && issueKeyRegex.test(input)) return {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        };
        return null;
    }
});
parcelRegister("kSL4h", function(module, exports) {
    $parcel$export(module.exports, "TokenType", ()=>$160d182608400c84$export$f435f793048e7a0f);
    $parcel$export(module.exports, "parseToken", ()=>$160d182608400c84$export$af8f4e8328578827);
    var $4Foyv;
    var $30Un5;
    var $coK8g;
    var $5RdHN;
    var $55t1E;
    var $jor5q;
    var $hZ14o;
    var $6xaH8;
    var $jMpI6;
    var $iDsRr;
    var $7tIdE;
    var $1MGc3;
    var $ayQVO;
    var $kPrK8;
    var $4ZFIG;
    var $91y57;
    var $1Mtv8;
    var $77w3e;
    var $lf0Nr;
    var $4s89q;
    var $ir9MO;
    var $7E14k;
    var $9MeiU;
    var $f50H1;
    var $bSil4;
    var $4Dfwq;
    var $cjZPi;
    var $8tGpW;
    var $lyI5i;
    var $bOMPB;
    var $160d182608400c84$export$f435f793048e7a0f;
    (function(TokenType) {
        TokenType["ADF_MACRO"] = "ADF_MACRO";
        TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
        TokenType["CODE_MACRO"] = "CODE_MACRO";
        TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
        TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
        TokenType["PANEL_MACRO"] = "PANEL_MACRO";
        TokenType["COLOR_MACRO"] = "COLOR_MACRO";
        TokenType["LOREM_MACRO"] = "LOREM_MACRO";
        TokenType["QUOTE"] = "QUOTE";
        TokenType["STRING"] = "STRING";
        TokenType["ISSUE_KEY"] = "ISSUE_KEY";
        TokenType["LINK_FORMAT"] = "LINK_FORMAT";
        TokenType["LINK_TEXT"] = "LINK_TEXT";
        TokenType["MEDIA"] = "MEDIA";
        TokenType["HEADING"] = "HEADING";
        TokenType["LIST"] = "LIST";
        TokenType["TABLE"] = "TABLE";
        TokenType["RULER"] = "RULER";
        TokenType["HARD_BREAK"] = "HARD_BREAK";
        TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
        TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
        TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
        TokenType["STRONG"] = "STRONG";
        TokenType["MONOSPACE"] = "MONOSPACE";
        TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
        TokenType["SUBSCRIPT"] = "SUBSCRIPT";
        TokenType["EMPHASIS"] = "EMPHASIS";
        TokenType["CITATION"] = "CITATION";
        TokenType["DELETED"] = "DELETED";
        TokenType["INSERTED"] = "INSERTED";
        TokenType["EMOJI"] = "EMOJI";
        TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    })($160d182608400c84$export$f435f793048e7a0f || ($160d182608400c84$export$f435f793048e7a0f = {}));
    const $160d182608400c84$var$tokenToTokenParserMapping = {
        ["DOUBLE_DASH_SYMBOL"]: (0, (0, parcelRequire("55t1E")).doubleDashSymbol),
        ["TRIPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("ir9MO")).tripleDashSymbol),
        ["QUADRUPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("4ZFIG")).quadrupleDashSymbol),
        ["RULER"]: (0, (0, parcelRequire("91y57")).ruler),
        ["STRONG"]: (0, (0, parcelRequire("1Mtv8")).strong),
        ["MONOSPACE"]: (0, (0, parcelRequire("kPrK8")).monospace),
        ["SUPERSCRIPT"]: (0, (0, parcelRequire("lf0Nr")).superscript),
        ["SUBSCRIPT"]: (0, (0, parcelRequire("77w3e")).subscript),
        ["EMPHASIS"]: (0, (0, parcelRequire("hZ14o")).emphasis),
        ["CITATION"]: (0, (0, parcelRequire("coK8g")).citation),
        ["DELETED"]: (0, (0, parcelRequire("5RdHN")).deleted),
        ["INSERTED"]: (0, (0, parcelRequire("iDsRr")).inserted),
        ["HARD_BREAK"]: (0, (0, parcelRequire("6xaH8")).hardbreak),
        ["LINK_FORMAT"]: (0, (0, parcelRequire("7tIdE")).linkFormat),
        ["LINK_TEXT"]: (0, (0, parcelRequire("1MGc3")).linkText),
        ["HEADING"]: (0, (0, parcelRequire("jMpI6")).heading),
        ["MEDIA"]: (0, (0, parcelRequire("4Foyv")).media),
        ["LIST"]: (0, (0, parcelRequire("ayQVO")).list),
        ["QUOTE"]: (0, (0, parcelRequire("30Un5")).blockquote),
        ["TABLE"]: (0, (0, parcelRequire("4s89q")).table),
        ["EMOJI"]: (0, (0, parcelRequire("jor5q")).emoji),
        ["ADF_MACRO"]: (0, (0, parcelRequire("9MeiU")).adfMacro),
        ["ANCHOR_MACRO"]: (0, (0, parcelRequire("f50H1")).anchorMacro),
        ["CODE_MACRO"]: (0, (0, parcelRequire("bSil4")).codeMacro),
        ["QUOTE_MACRO"]: (0, (0, parcelRequire("4Dfwq")).quoteMacro),
        ["NOFORMAT_MACRO"]: (0, (0, parcelRequire("8tGpW")).noformatMacro),
        ["PANEL_MACRO"]: (0, (0, parcelRequire("7E14k")).panelMacro),
        ["COLOR_MACRO"]: (0, (0, parcelRequire("cjZPi")).colorMacro),
        ["FORCE_LINE_BREAK"]: (0, (0, parcelRequire("lyI5i")).forceLineBreak),
        ["ISSUE_KEY"]: (0, (0, parcelRequire("bOMPB")).issueKey)
    };
    function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
        const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
        if (tokenParser) try {
            return tokenParser({
                input: input,
                position: position,
                schema: schema,
                context: context
            });
        } catch (err) {
            if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
            return $160d182608400c84$var$fallback(input, position);
        }
        return $160d182608400c84$var$fallback(input, position);
    }
    function $160d182608400c84$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("4Foyv", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$8b246e16d82e8dde$export$987d49ffe1b0900f);
    var $4V377;
    var $4ZUg7;
    var $eyO0H;
    const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
        const rawContentProcessor = (raw, length)=>{
            const [rawContent, rawAttrs = ''] = raw.split('|');
            const node = (0, (0, parcelRequire("4V377")).default)(schema, rawContent, (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs, ','), context);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        };
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: '!',
            closing: '!',
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4V377", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2106e5f40786af56$export$2e2bcd8739ae039);
    var $1MGc3;
    const $2106e5f40786af56$var$defaultWidth = 200;
    const $2106e5f40786af56$var$defaultHeight = 183;
    const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
        if (upper !== undefined) input = input <= upper ? input : upper;
        if (lower !== undefined) input = input >= lower ? input : lower;
        return input;
    };
    function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const { link: link } = schema.marks;
        const mediaMarks = [];
        let mediaNodeAttrs = {};
        if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
        if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
        const mediaSingleAttrs = {
            layout: 'center'
        };
        if (attrs.width && attrs.width.endsWith('%')) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
            mediaNodeAttrs = {};
        } else {
            if (attrs.width) {
                const parsed = parseInt(attrs.width, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
            }
            if (attrs.height) {
                const parsed = parseInt(attrs.height, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
            }
        }
        if (attrs.href) {
            const href = attrs.href.replace(/^"(.+)"$/, '$1');
            mediaMarks.push(link.create({
                href: href
            }));
        }
        if (attrs.alt) {
            const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
            mediaNodeAttrs.alt = altText;
        }
        if (filename.match((0, (0, parcelRequire("1MGc3")).LINK_TEXT_REGEXP))) {
            const externalMediaNode = media.createChecked({
                type: 'external',
                url: filename,
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
        } else {
            const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
            const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
            const mediaNode = media.createChecked({
                id: id,
                type: 'file',
                collection: collection || '',
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
        }
    }
});
parcelRegister("1MGc3", function(module, exports) {
    $parcel$export(module.exports, "LINK_TEXT_REGEXP", ()=>$49f89f13b4b7c481$export$f69d1dce349473aa);
    $parcel$export(module.exports, "linkText", ()=>$49f89f13b4b7c481$export$cb7bcf09a05b7705);
    var $iZOJ9;
    var $iqYHB;
    const $49f89f13b4b7c481$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
    const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
        let matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
        if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
        const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
        const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
        const url = (0, (0, parcelRequire("iqYHB")).decode)($49f89f13b4b7c481$var$unescape(match[0]));
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
        const mark = schema.marks.link.create({
            href: url
        });
        const textNode = schema.text(textRepresentation, [
            mark
        ]);
        return {
            type: 'pmnode',
            nodes: [
                textNode
            ],
            length: match[0].length
        };
    };
    function $49f89f13b4b7c481$var$unescape(url) {
        let result = '';
        for(let i = 0; i < url.length; i++){
            const char = url[i];
            if (char !== '\\') {
                result += char;
                continue;
            }
            const nextChar = url[i + 1];
            if (nextChar) {
                result += nextChar;
                i++;
            }
        }
        return result;
    }
    function $49f89f13b4b7c481$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
    function $49f89f13b4b7c481$var$trimBadEndChar(input) {
        return [
            input[0].replace(/[.,>)\];}"\'!]*$/, ''),
            input[1],
            input[2].replace(/[.,>)\];}"\'!]*$/, '')
        ];
    }
});
parcelRegister("iqYHB", function(module, exports) {
    $parcel$export(module.exports, "decode", ()=>$c6b4ec3136742c55$export$2f872c0f2117be69);
    function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
        if (typeof URL === 'function') {
            const decoded = new URL(raw);
            if (decoded.href) return decoded.href;
        }
        const anchor = document.createElement('a');
        anchor.href = raw;
        return anchor.href;
    }
});
parcelRegister("4ZUg7", function(module, exports) {
    $parcel$export(module.exports, "parseAttrs", ()=>$972abf9f01734b21$export$e1a9355cfd8f6c64);
    function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
        const output = {};
        if (!str) return output;
        const attributesStr = str.split(sep);
        attributesStr.forEach((attributeStr)=>{
            const [key, ...value] = attributeStr.split('=');
            if (!output[key]) output[key] = value.join('=');
        });
        return output;
    }
});
parcelRegister("eyO0H", function(module, exports) {
    $parcel$export(module.exports, "commonFormatter", ()=>$dee2bdf3f1017b16$export$a71d57024d3da1c5);
    var $kSL4h;
    var $7tIdE;
    var $eWAZI;
    var $cG4PY;
    var $kSL4h;
    var $2weJO;
    const $dee2bdf3f1017b16$var$processState = {
        START: 0,
        BUFFER: 1,
        END: 2,
        INLINE_MACRO: 3,
        LINK_FORMAT: 4,
        ESCAPE: 5
    };
    function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
        let index = position;
        let state = $dee2bdf3f1017b16$var$processState.START;
        let buffer = [];
        const openingSymbolLength = opt.opening.length;
        const closingSymbolLength = opt.closing.length;
        const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
        const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
        while(index < input.length){
            const char = input.charAt(index);
            const twoChar = input.substr(index, 2);
            const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
            switch(state){
                case $dee2bdf3f1017b16$var$processState.START:
                    {
                        if (position > 0) {
                            const charBeforeOpening = input.charAt(position - 1);
                            if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                        }
                        const charAfterOpening = input.charAt(index + openingSymbolLength);
                        if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        index += openingSymbolLength;
                        continue;
                    }
                case $dee2bdf3f1017b16$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(index));
                        if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                        if (charsMatchClosingSymbol === opt.closing) {
                            state = $dee2bdf3f1017b16$var$processState.END;
                            continue;
                        } else if (twoChar === '{{') {
                            buffer.push(twoChar);
                            index += 2;
                            continue;
                        } else if (char === '{') {
                            state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                            continue;
                        } else if (char === '[') {
                            state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                            continue;
                        } else if (char === '\\') {
                            state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $dee2bdf3f1017b16$var$processState.END:
                    index += closingSymbolLength;
                    if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (index < input.length) {
                        const charAfterEnd = input.charAt(index);
                        if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                            buffer.push(charsMatchClosingSymbol);
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        }
                    }
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    return opt.rawContentProcessor(buffer.join(''), index - position);
                case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, {});
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else if (match.type === (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO) {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    }
                case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                    {
                        const token = (0, (0, parcelRequire("7tIdE")).linkFormat)({
                            input: input,
                            schema: schema,
                            position: index,
                            context: {}
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        }
                        return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    }
                case $dee2bdf3f1017b16$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("2weJO")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
    }
    function $dee2bdf3f1017b16$var$fallback(input, position, length) {
        return {
            type: 'text',
            text: input.substr(position, length),
            length: length
        };
    }
});
parcelRegister("7tIdE", function(module, exports) {
    $parcel$export(module.exports, "linkFormat", ()=>$0412731f8f85cc95$export$e1f888a4b6f2ee53);
    var $kSL4h;
    var $29zBb;
    var $9jjzg;
    var $gGleW;
    const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
    const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT
        ];
        if (!match) return $0412731f8f85cc95$var$fallback();
        const content = (0, (0, parcelRequire("gGleW")).parseContentLink)(match[1]);
        const resolvedLink = (0, (0, parcelRequire("9jjzg")).resolveLink)(content, schema, context);
        if (resolvedLink) return resolvedLink;
        const nodes = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: match[0]
        });
        return {
            type: 'pmnode',
            nodes: nodes,
            length: match[0].length
        };
    };
    function $0412731f8f85cc95$var$fallback() {
        return {
            type: 'text',
            text: '[',
            length: 1
        };
    }
});
parcelRegister("29zBb", function(module, exports) {
    $parcel$export(module.exports, "parseString", ()=>$e7a948cf285a18ed$export$960addfb9e5a0cde);
    var $04cDS;
    var $cG4PY;
    var $kSL4h;
    var $eWAZI;
    var $2weJO;
    var $20lXC;
    const $e7a948cf285a18ed$var$processState = {
        NEWLINE: 0,
        BUFFER: 1,
        TOKEN: 2,
        ESCAPE: 3
    };
    function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
        let index = 0;
        let state = $e7a948cf285a18ed$var$processState.NEWLINE;
        let buffer = [];
        let tokenType = (0, (0, parcelRequire("kSL4h")).TokenType).STRING;
        let newLines = [];
        const output = [];
        let inlineNodes = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $e7a948cf285a18ed$var$processState.NEWLINE:
                    {
                        const substring = input.substring(index);
                        const length = (0, (0, parcelRequire("eWAZI")).parseWhitespaceOnly)(substring);
                        if (length) {
                            index += length;
                            if (includeLeadingSpace) buffer.push(char);
                            continue;
                        }
                        const match = (0, (0, parcelRequire("cG4PY")).parseLeadingKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $e7a948cf285a18ed$var$processState.TOKEN;
                            continue;
                        } else {
                            state = $e7a948cf285a18ed$var$processState.BUFFER;
                            continue;
                        }
                    }
                case $e7a948cf285a18ed$var$processState.BUFFER:
                    {
                        const substring = input.substring(index);
                        let match = null;
                        if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring);
                        else match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $e7a948cf285a18ed$var$processState.TOKEN;
                            continue;
                        }
                        if (char === '\\') {
                            state = $e7a948cf285a18ed$var$processState.ESCAPE;
                            continue;
                        }
                        buffer.push(char);
                        break;
                    }
                case $e7a948cf285a18ed$var$processState.TOKEN:
                    {
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, tokenType, index, schema, context);
                        if (token.type === 'text') buffer.push(token.text);
                        else if (token.type === 'pmnode') {
                            if (newLines.length >= 2 && (tokenType !== (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK || buffer.length > 0)) {
                                output.push(...(0, (0, parcelRequire("20lXC")).normalizePMNodes)(inlineNodes, schema));
                                inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                    ...newLines
                                ] : [];
                                newLines = [];
                            }
                            if (inlineNodes.length === 0) newLines = [];
                            if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                                inlineNodes.push(...newLines);
                                newLines = [];
                            }
                            inlineNodes.push(...(0, (0, parcelRequire("04cDS")).createTextNode)(buffer.join(''), schema));
                            if (tokenType === (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK) newLines.push(...token.nodes);
                            else {
                                inlineNodes.push(...token.nodes);
                                if (token.nodes.length > 0) newLines = [];
                            }
                            buffer = [];
                        }
                        index += token.length;
                        if (tokenType === (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                        else state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                case $e7a948cf285a18ed$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("2weJO")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        const bufferedStr = buffer.join('');
        if (bufferedStr.length > 0) {
            if (newLines.length >= 2) {
                output.push(...(0, (0, parcelRequire("20lXC")).normalizePMNodes)(inlineNodes, schema));
                inlineNodes = [];
                newLines = [];
            }
            if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
            inlineNodes.push(...(0, (0, parcelRequire("04cDS")).createTextNode)(bufferedStr, schema));
        }
        return [
            ...output,
            ...inlineNodes
        ];
    }
    function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
        if (currentNodes.length === 0) return false;
        if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
        if (buffer.length === 0) {
            if (nextNodes.length === 0) return false;
            if (nextNodes[0]?.type.name === 'hardBreak') return false;
            if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
        }
        return true;
    }
    function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
        return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
    }
});
parcelRegister("04cDS", function(module, exports) {
    $parcel$export(module.exports, "createTextNode", ()=>$e67b0538295ca231$export$b2ce9ad90858ed7a);
    function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
        if (input === '') return [];
        const node = schema.text(input, marks || []);
        return [
            node
        ];
    }
});
parcelRegister("eWAZI", function(module, exports) {
    $parcel$export(module.exports, "parseNewlineOnly", ()=>$b3a19bb1e901f2d4$export$1b7a83d725c8acf);
    $parcel$export(module.exports, "parseWhitespaceOnly", ()=>$b3a19bb1e901f2d4$export$9c597b035e16623b);
    function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
        const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
        if (newlineLength) return newlineLength;
        const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
        if (whitespaceLength) return whitespaceLength;
        return 0;
    }
    function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\t' || char === ' ') index++;
        return index;
    }
    function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\r') {
            index++;
            if (input.charAt(index) === '\n') index++;
        } else if (char === '\n') index++;
        return index;
    }
});
parcelRegister("2weJO", function(module, exports) {
    $parcel$export(module.exports, "escapeHandler", ()=>$35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
    const $35d0c4c2d3000f41$var$escapedChar = [
        '-',
        '#',
        '*',
        '_',
        '+',
        '?',
        '^',
        '~',
        '|',
        '%',
        '{',
        '}',
        '[',
        ']',
        '(',
        ')',
        '!',
        '@'
    ];
    function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
        let buffer = [];
        const char = input.charAt(position);
        const prevChar = input.charAt(position - 1);
        const nextChar = input.charAt(position + 1);
        if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') buffer.push(char);
        buffer.push(nextChar);
        return {
            type: 'text',
            text: buffer.join(''),
            length: 2
        };
    }
});
parcelRegister("20lXC", function(module, exports) {
    $parcel$export(module.exports, "normalizePMNodes", ()=>$50669f552f016dd9$export$e21f6b7efdaf8b5d);
    var $4UJvN;
    function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
        return [
            $50669f552f016dd9$var$normalizeMediaGroups,
            $50669f552f016dd9$export$2cef2a4c047f9887,
            $50669f552f016dd9$export$cd936b894f116ed8
        ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
    }
    function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
        const output = [];
        for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
        else output.push(node);
        return output;
    }
    function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
        const output = [];
        let inlineNodeBuffer = [];
        for (const node of nodes){
            if (!node.isBlock) {
                inlineNodeBuffer.push(node);
                continue;
            }
            if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("4UJvN")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
            inlineNodeBuffer = [];
            output.push(node);
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("4UJvN")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        if (output.length === 0) return [
            (0, (0, parcelRequire("4UJvN")).createEmptyParagraphNode)(schema)
        ];
        return output;
    }
    function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
        const output = [];
        let mediaGroupBuffer = [];
        let separatorBuffer = [];
        for (const n of nodes){
            if (n.type.name === 'mediaGroup' && n.childCount === 1) {
                mediaGroupBuffer.push(n);
                separatorBuffer = [];
                continue;
            }
            if (mediaGroupBuffer.length > 0) {
                if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                    output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                    output.push(...separatorBuffer);
                    output.push(n);
                    mediaGroupBuffer = [];
                    separatorBuffer = [];
                } else separatorBuffer.push(n);
                continue;
            }
            output.push(n);
        }
        if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
        output.push(...separatorBuffer);
        return output;
    }
    function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
        const { mediaGroup: mediaGroup } = schema.nodes;
        const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
        return mediaGroup.createChecked({}, mediaNodes);
    }
    function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
        return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
    }
    function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
        return n.type.name === 'mediaGroup' && n.childCount > 1;
    }
    function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
        return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
    }
    function $50669f552f016dd9$var$isEmptyTextNode(n) {
        return n.textContent !== undefined && n.textContent.trim().length === 0;
    }
    function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
        return input.trim().length === 0;
    }
    function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
        const { expand: expand } = schema.nodes;
        return expand.createChecked(node.attrs, node.content);
    }
});
parcelRegister("4UJvN", function(module, exports) {
    $parcel$export(module.exports, "createEmptyParagraphNode", ()=>$4ae1f625ac901e34$export$e930a5cfe8596ea0);
    $parcel$export(module.exports, "createParagraphNodeFromInlineNodes", ()=>$4ae1f625ac901e34$export$f0eaed48ea684567);
    function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
        const { paragraph: paragraph } = schema.nodes;
        return paragraph.createChecked({}, []);
    }
    function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
        const { paragraph: paragraph } = schema.nodes;
        const result = [];
        const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
        if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
        return result;
    }
});
parcelRegister("9jjzg", function(module, exports) {
    $parcel$export(module.exports, "resolveLink", ()=>$c08b1d888f635e2c$export$c2baa561eb017101);
    var $30RSK;
    var $lRYXZ;
    var $b0Iw2;
    var $k1MiS;
    const $c08b1d888f635e2c$var$linkResolverStrategies = [
        (0, (0, parcelRequire("lRYXZ")).attachmentLinkResolver),
        (0, (0, parcelRequire("30RSK")).mentionLinkResolver),
        (0, (0, parcelRequire("k1MiS")).issueLinkResolver),
        (0, (0, parcelRequire("b0Iw2")).urlLinkResolver)
    ];
    function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
        const length = link.originalLinkText.length + 2;
        for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
            const resolvedLink = resolver(link, schema, context);
            if (resolvedLink) return {
                length: length,
                nodes: resolvedLink,
                type: 'pmnode'
            };
        }
        return undefined;
    }
});
parcelRegister("30RSK", function(module, exports) {
    $parcel$export(module.exports, "mentionLinkResolver", ()=>$bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
    function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
        if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
            schema.nodes.paragraph.createChecked({}, [
                schema.nodes.text.create({})
            ])
        ];
        if (link.notLinkBody.startsWith('~')) {
            const mentionText = link.notLinkBody.substring(1);
            const mentionKey = mentionText.toLowerCase();
            const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
            return [
                schema.nodes.mention.createChecked({
                    id: id
                })
            ];
        }
        return;
    }
});
parcelRegister("lRYXZ", function(module, exports) {
    $parcel$export(module.exports, "attachmentLinkResolver", ()=>$2514090e6b8dffff$export$ce918f41a76b8445);
    var $4vpto;
    function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
        if (link.attachmentName) return [
            (0, (0, parcelRequire("4vpto")).default)(schema, link.attachmentName, context)
        ];
        return;
    }
});
parcelRegister("4vpto", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$904a1bc635a5ad9a$export$2e2bcd8739ae039);
    function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
        const { media: media, mediaGroup: mediaGroup } = schema.nodes;
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || ''
        });
        return mediaGroup.createChecked({}, mediaNode);
    }
});
parcelRegister("b0Iw2", function(module, exports) {
    $parcel$export(module.exports, "urlLinkResolver", ()=>$e20b005b86e07eab$export$b737d556d2167f9);
    var $kSL4h;
    var $iZOJ9;
    var $29zBb;
    var $gxAE9;
    function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
        const output = [];
        const url = link.notLinkBody;
        const textRepresentation = link.linkBody || link.notLinkBody;
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return;
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        ];
        const rawContent = (0, (0, parcelRequire("29zBb")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: textRepresentation.replace(/^mailto:/, '')
        });
        const decoratedContent = rawContent.map((n)=>{
            const mark = schema.marks.link.create({
                href: url
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'link',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        output.push(...decoratedContent);
        if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
            const mark = schema.marks.link.create({
                href: url
            });
            const linkTextNode = schema.text(textRepresentation, [
                mark
            ]);
            output.push(linkTextNode);
        }
        return output;
    }
    function $e20b005b86e07eab$var$hasTextNode(nodes) {
        return nodes.find((n)=>{
            return n.type.name === 'text';
        });
    }
});
parcelRegister("gxAE9", function(module, exports) {
    $parcel$export(module.exports, "hasAnyOfMarks", ()=>$fd57502cc274f1df$export$30c14ec359b8cbf0);
    $parcel$export(module.exports, "isDigit", ()=>$fd57502cc274f1df$export$727d9dbc4fbb948f);
    $parcel$export(module.exports, "isBlank", ()=>$fd57502cc274f1df$export$7ee701e290d9865);
    $parcel$export(module.exports, "isNotBlank", ()=>$fd57502cc274f1df$export$4d9e7a1c098df5e2);
    $parcel$export(module.exports, "getSurroundingSymbols", ()=>$fd57502cc274f1df$export$ddec3d40bf5e3693);
    $parcel$export(module.exports, "StringBuffer", ()=>$fd57502cc274f1df$export$83347051c3437dc9);
    function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
        return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
    }
    function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
        return !!value.match(/^\d$/);
    }
    function $fd57502cc274f1df$export$7ee701e290d9865(value) {
        return value === null || value.trim() === '';
    }
    function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
        return !$fd57502cc274f1df$export$7ee701e290d9865(value);
    }
    const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
        const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
        const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
        const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
        return {
            openingSymbol: openingSymbol,
            closingSymbol: closingSymbol
        };
    };
    class $fd57502cc274f1df$export$83347051c3437dc9 {
        constructor(buffer = ''){
            this.buffer = buffer;
        }
        indexOf(value) {
            return this.buffer.indexOf(value);
        }
        lastIndexOf(value) {
            return this.buffer.lastIndexOf(value);
        }
        charAt(index) {
            return this.buffer.charAt(index);
        }
        length() {
            return this.buffer.length;
        }
        delete(start, end) {
            this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
        }
        append(value) {
            this.buffer += value;
        }
        substring(start, end) {
            return this.buffer.substring(start, end);
        }
        deleteCharAt(index) {
            this.delete(index, index + 1);
        }
        toString() {
            return this.buffer;
        }
    }
});
parcelRegister("k1MiS", function(module, exports) {
    $parcel$export(module.exports, "issueLinkResolver", ()=>$7a9a102a7215e3d4$export$f40ed0efa65d4e8);
    var $bOMPB;
    function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
        const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
        if (linkTitle === 'smart-card' || linkTitle === 'block-link') return [
            schema.nodes.blockCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-link') return [
            schema.nodes.inlineCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-embed') return [
            schema.nodes.embedCard.createChecked({
                url: notLinkBody
            })
        ];
        const issue = (0, (0, parcelRequire("bOMPB")).getIssue)(context, originalLinkText);
        if (issue) return (0, (0, parcelRequire("bOMPB")).buildInlineCard)(schema, issue);
        return undefined;
    }
});
parcelRegister("bOMPB", function(module, exports) {
    $parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", ()=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
    $parcel$export(module.exports, "issueKey", ()=>$ce5ca7baa00e39d0$export$a0d841e329cebd91);
    $parcel$export(module.exports, "getIssue", ()=>$ce5ca7baa00e39d0$export$34403cb88b30d33b);
    $parcel$export(module.exports, "buildInlineCard", ()=>$ce5ca7baa00e39d0$export$cdebb4bc59c595a);
    $parcel$export(module.exports, "buildIssueKeyRegex", ()=>$ce5ca7baa00e39d0$export$cd8701ad7512efee);
    var $gxAE9;
    const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
    const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
        if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const match = input.substring(position).match(context.issueKeyRegex);
        if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
        if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const charBefore = input.charAt(position - 1);
        const charAfter = input.charAt(position + issue.key.length);
        if ((0, (0, parcelRequire("gxAE9")).isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, (0, parcelRequire("gxAE9")).isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
        return {
            type: 'pmnode',
            nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
            length: match[0].length
        };
    };
    const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        });
    const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
            key: key,
            url: context.conversion.inlineCardConversion[key]
        } : null;
    const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
        return [
            schema.nodes.inlineCard.createChecked({
                url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
            })
        ];
    };
    const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
    const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
    const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
        if (!inlineCardConversion) return undefined;
        const pattern = Object.keys(inlineCardConversion).join('|');
        if (!pattern) return undefined;
        return new RegExp(`^(${pattern})`);
    };
});
parcelRegister("gGleW", function(module, exports) {
    $parcel$export(module.exports, "parseContentLink", ()=>$57e1d7866034b37b$export$3a250a08d37b0eae);
    var $gxAE9;
    function $57e1d7866034b37b$var$trimIfPossible(s) {
        if (s === null) return null;
        return s.trim();
    }
    function $57e1d7866034b37b$var$extractLinkBody(buffer) {
        const indexOfBang = buffer.indexOf('!');
        const indexOfPipe = buffer.indexOf('|');
        const lastIndexOfBang = buffer.lastIndexOf('!');
        const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
        if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
        const body = new (0, (0, parcelRequire("gxAE9")).StringBuffer)();
        let inEscape = false;
        for(let i = 0; i < buffer.length(); i++){
            const c = buffer.charAt(i);
            if (c === '!') inEscape = !inEscape;
            if (c === '|' && !inEscape) {
                buffer.delete(0, i + 1);
                return body.toString();
            }
            body.append(c);
        }
        return null;
    }
    function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
        if (buffer.length() === 0) return null;
        return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
    }
    function $57e1d7866034b37b$var$divideAfter(buffer, index) {
        if (typeof index === 'string') index = buffer.indexOf(index);
        if (index < 0) return null;
        else if (index === buffer.length() - 1) {
            buffer.deleteCharAt(buffer.length() - 1);
            return null;
        } else {
            const body = buffer.substring(index + 1);
            buffer.delete(index, buffer.length());
            return body;
        }
    }
    function $57e1d7866034b37b$var$divideOn(buffer, divider) {
        if (buffer.length() === 0) return null;
        const i = buffer.indexOf(divider);
        if (i < 0) return null;
        else if (i === 0) {
            buffer.deleteCharAt(0);
            return null;
        } else {
            const body = buffer.substring(0, i);
            buffer.delete(0, i + 1);
            return body;
        }
    }
    function $57e1d7866034b37b$var$extractNumber(buf) {
        const digits = new (0, (0, parcelRequire("gxAE9")).StringBuffer)();
        let i = 0;
        for(; i < buf.length() && (0, (0, parcelRequire("gxAE9")).isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
        if (i > 0) buf.delete(0, i);
        try {
            return parseInt(digits.toString(), 10);
        } catch (e) {
            return 0;
        }
    }
    function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
        const originalLinkText = linkText;
        if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
        const buf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(linkText);
        const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
        const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
        const notLinkBody = buf.toString().trim();
        return {
            originalLinkText: originalLinkText,
            linkBody: linkBody,
            linkTitle: linkTitle,
            notLinkBody: notLinkBody
        };
    }
    function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
        if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
        const { notLinkBody: notLinkBody } = link;
        let shortcutName = null;
        let shortcutValue = null;
        let spaceKey = null;
        let attachmentName = null;
        let anchor = null;
        let destinationTitle = '';
        let contentId = 0;
        if (!notLinkBody.startsWith('~')) {
            const shortcutBuf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(notLinkBody);
            shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
            if ((0, (0, parcelRequire("gxAE9")).isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
        }
        const buf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(notLinkBody);
        if ((0, (0, parcelRequire("gxAE9")).isBlank)(shortcutName)) {
            spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
            if (buf.indexOf('$') === 0) {
                buf.deleteCharAt(0);
                contentId = $57e1d7866034b37b$var$extractNumber(buf);
                if (contentId === 0) return {
                    ...link,
                    shortcutName: shortcutName,
                    shortcutValue: shortcutValue,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    attachmentName: attachmentName,
                    anchor: anchor,
                    destinationTitle: destinationTitle
                };
            }
            attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
            anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
        }
        if (contentId === 0) destinationTitle = buf.toString().trim();
        return {
            ...link,
            shortcutName: shortcutName,
            shortcutValue: shortcutValue,
            spaceKey: spaceKey,
            contentId: contentId,
            attachmentName: attachmentName,
            anchor: anchor,
            destinationTitle: destinationTitle
        };
    }
});
parcelRegister("30Un5", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$0c863b8155c1a336$export$67dc04e652a298ca);
    var $4Dfwq;
    const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
    const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
        if (!match) return $0c863b8155c1a336$var$fallback(input, position);
        const [, rawContent] = match;
        return (0, (0, parcelRequire("4Dfwq")).rawContentProcessor)('', rawContent, match[0].length, schema, context);
    };
    function $0c863b8155c1a336$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("4Dfwq", function(module, exports) {
    $parcel$export(module.exports, "quoteMacro", ()=>$0723b4b23edf777c$export$8f9545cee64b3251);
    $parcel$export(module.exports, "rawContentProcessor", ()=>$0723b4b23edf777c$export$c2a5e4612254bfa);
    var $3JW2n;
    var $gxAE9;
    var $20lXC;
    var $29zBb;
    const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'quote',
            paired: true,
            rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
            context: context
        });
    };
    const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
        if (!rawContent.length) {
            const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
            return {
                type: 'pmnode',
                nodes: [
                    emptyQuote
                ],
                length: length
            };
        }
        const parsedContent = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("20lXC")).normalizePMNodes)(parsedContent, schema);
        return {
            type: 'pmnode',
            nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
            length: length
        };
    };
    function $0723b4b23edf777c$var$emptyBlockquote(schema) {
        const p = schema.nodes.paragraph.createChecked({}, []);
        return schema.nodes.blockquote.createChecked({}, p);
    }
    function $0723b4b23edf777c$var$sanitize(nodes, schema) {
        const output = [];
        let contentBuffer = [];
        for (const n of nodes)switch(n.type.name){
            case 'paragraph':
            case 'bulletList':
            case 'orderedList':
            case 'codeBlock':
            case 'mediaSingle':
            case 'mediaGroup':
                contentBuffer.push(n);
                break;
            case 'heading':
                contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
                break;
            default:
                if (contentBuffer.length) {
                    const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                    output.push(blockquote);
                    contentBuffer = [];
                }
                output.push(n);
        }
        if (contentBuffer.length) {
            const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
            output.push(blockquote);
        }
        return output;
    }
    function $0723b4b23edf777c$var$transformHeading(heading, schema) {
        const contentBuffer = [];
        heading.content.forEach((n)=>{
            const strong = schema.marks.strong.create();
            const italic = schema.marks.em.create();
            const gray = schema.marks.textColor.create({
                color: '#97a0af'
            });
            if (n.type.name === 'text') {
                if (n.text && heading.attrs.level === 1) n.text = n.text.toUpperCase();
                if (heading.attrs.level <= 4 && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'strong',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    strong
                ]);
                if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'em',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    italic
                ]);
                if (heading.attrs.level > 3 && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'textColor',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    gray
                ]);
            }
            contentBuffer.push(n);
        });
        return schema.nodes.paragraph.createChecked({}, contentBuffer);
    }
});
parcelRegister("3JW2n", function(module, exports) {
    $parcel$export(module.exports, "commonMacro", ()=>$108725731ca4984f$export$b6a12943ac1bb1ba);
    function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
        const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
        const matchOpening = input.match(opening);
        if (!matchOpening) return $108725731ca4984f$var$fallback(input);
        const [, name, rawAttrs] = matchOpening;
        const openingLength = matchOpening[0].length;
        if (!opt.paired) return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
        const closing = new RegExp(`\{${name}\}`);
        const matchClosing = closing.exec(input.substring(openingLength));
        let rawContent = '';
        if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
        const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
        return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
    }
    function $108725731ca4984f$var$fallback(input) {
        return {
            type: 'text',
            text: input.substr(0, 1),
            length: 1
        };
    }
});
parcelRegister("coK8g", function(module, exports) {
    $parcel$export(module.exports, "citation", ()=>$624cf9f0f9a0e4f4$export$258632c953c109e9);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        ];
        const contentDecorator = (n, index)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) {
                if (index === 0) n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
                return n.mark([
                    ...n.marks,
                    mark
                ]);
            }
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '??', '??');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";
parcelRegister("5RdHN", function(module, exports) {
    $parcel$export(module.exports, "deleted", ()=>$b9ac580681c978af$export$bccbf0c716f226f4);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.strike.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'strike',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '-', '-');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("55t1E", function(module, exports) {
    $parcel$export(module.exports, "doubleDashSymbol", ()=>$74a06c4540bbf40b$export$65e3ca7c95899a2d);
    var $1rQjR;
    const $74a06c4540bbf40b$var$token = {
        type: 'text',
        text: '\u2013',
        length: 2
    };
    const $74a06c4540bbf40b$var$fallback = {
        ...$74a06c4540bbf40b$var$token,
        text: '--'
    };
    const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, (0, parcelRequire("1rQjR")).createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);
});
parcelRegister("1rQjR", function(module, exports) {
    $parcel$export(module.exports, "createDashTokenParser", ()=>$75f433a8b52a8173$export$d43b58865d429e3c);
    const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
            if (position > 0) {
                const charBeforeToken = input.charAt(position - 1);
                if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
            }
            if (position + token.length < input.length) {
                const charAfterToken = input.charAt(position + token.length);
                if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
            }
            return token;
        };
    const $75f433a8b52a8173$var$isSpace = (char)=>{
        return /\s/.test(char);
    };
});
parcelRegister("jor5q", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$487b5ddb28312972$export$a19185d1233fc4b2);
    const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
    const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
        const substring = input.substring(position);
        for(let i = 2; i <= 9 && i <= substring.length; ++i){
            const candidateText = substring.substring(0, i);
            const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
            if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
                type: 'pmnode',
                nodes: [
                    schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
                ],
                length: i
            };
        }
        return {
            type: 'text',
            text: substring.substr(0, 1),
            length: 1
        };
    };
    const $487b5ddb28312972$export$797c048dfde076a1 = {
        '1f642': {
            id: '1f642',
            shortName: ':slight_smile:',
            text: "\uD83D\uDE42"
        },
        '1f61e': {
            id: '1f61e',
            shortName: ':disappointed:',
            text: "\uD83D\uDE1E"
        },
        '1f61b': {
            id: '1f61b',
            shortName: ':stuck_out_tongue:',
            text: "\uD83D\uDE1B"
        },
        '1f603': {
            id: '1f603',
            shortName: ':smiley:',
            text: "\uD83D\uDE03"
        },
        '1f609': {
            id: '1f609',
            shortName: ':wink:',
            text: "\uD83D\uDE09"
        },
        '1f44d': {
            id: '1f44d',
            shortName: ':thumbsup:',
            text: "\uD83D\uDC4D"
        },
        '1f44e': {
            id: '1f44e',
            shortName: ':thumbsdown:',
            text: "\uD83D\uDC4E"
        },
        'atlassian-info': {
            id: 'atlassian-info',
            shortName: ':info:',
            text: ':info:'
        },
        'atlassian-check_mark': {
            id: 'atlassian-check_mark',
            shortName: ':check_mark:',
            text: ':check_mark:'
        },
        'atlassian-cross_mark': {
            id: 'atlassian-cross_mark',
            shortName: ':cross_mark:',
            text: ':cross_mark:'
        },
        'atlassian-warning': {
            id: 'atlassian-warning',
            shortName: ':warning:',
            text: ':warning:'
        },
        'atlassian-plus': {
            id: 'atlassian-plus',
            shortName: ':plus:',
            text: ':plus:'
        },
        'atlassian-minus': {
            id: 'atlassian-minus',
            shortName: ':minus:',
            text: ':minus:'
        },
        'atlassian-question_mark': {
            id: 'atlassian-question_mark',
            shortName: ':question:',
            text: ':question:'
        },
        'atlassian-light_bulb_on': {
            id: 'atlassian-light_bulb_on',
            shortName: ':light_bulb_on:',
            text: ':light_bulb_on:'
        },
        'atlassian-light_bulb_off': {
            id: 'atlassian-light_bulb_off',
            shortName: ':light_bulb_off:',
            text: ':light_bulb_off:'
        },
        'atlassian-yellow_star': {
            id: 'atlassian-yellow_star',
            shortName: ':yellow_star:',
            text: ':yellow_star:'
        },
        'atlassian-red_star': {
            id: 'atlassian-red_star',
            shortName: ':red_star:',
            text: ':red_star:'
        },
        'atlassian-green_star': {
            id: 'atlassian-green_star',
            shortName: ':green_star:',
            text: ':green_star:'
        },
        'atlassian-blue_star': {
            id: 'atlassian-blue_star',
            shortName: ':blue_star:',
            text: ':blue_star:'
        },
        'atlassian-flag_on': {
            id: 'atlassian-flag_on',
            shortName: ':flag_on:',
            text: ':flag_on:'
        },
        'atlassian-flag_off': {
            id: 'atlassian-flag_off',
            shortName: ':flag_off:',
            text: ':flag_off:'
        }
    };
    const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
        ':)': '1f642',
        ':-)': '1f642',
        ':(': '1f61e',
        ':-(': '1f61e',
        ':P': '1f61b',
        ':-P': '1f61b',
        ':p': '1f61b',
        ':-p': '1f61b',
        ':D': '1f603',
        ':-D': '1f603',
        ';)': '1f609',
        ';-)': '1f609',
        '(y)': '1f44d',
        '(n)': '1f44e',
        '(i)': 'atlassian-info',
        '(/)': 'atlassian-check_mark',
        '(x)': 'atlassian-cross_mark',
        '(!)': 'atlassian-warning',
        '(+)': 'atlassian-plus',
        '(-)': 'atlassian-minus',
        '(?)': 'atlassian-question_mark',
        '(on)': 'atlassian-light_bulb_on',
        '(off)': 'atlassian-light_bulb_off',
        '(*)': 'atlassian-yellow_star',
        '(*y)': 'atlassian-yellow_star',
        '(*r)': 'atlassian-red_star',
        '(*g)': 'atlassian-green_star',
        '(*b)': 'atlassian-blue_star',
        '(flag)': 'atlassian-flag_on',
        '(flagoff)': 'atlassian-flag_off'
    };
});
parcelRegister("hZ14o", function(module, exports) {
    $parcel$export(module.exports, "emphasis", ()=>$5100d4ec4f1b4884$export$bef81ba411953b51);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '_', '_');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("6xaH8", function(module, exports) {
    $parcel$export(module.exports, "hardbreak", ()=>$bc70e1090faff3e6$export$ac55bb44695749c1);
    var $eWAZI;
    const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(position));
        if (length === 0) return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
        return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: length
        };
    };
});
parcelRegister("jMpI6", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$ed15d3e22c065f91$export$46e4a324ac90507f);
    var $29zBb;
    var $kSL4h;
    const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
    const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL
        ];
        const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
        if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
        const level = parseInt(match[1], 10);
        const content = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            ignoreTokenTypes: ignoreTokenTypes,
            context: context,
            input: match[2]
        });
        try {
            const headingNode = schema.nodes.heading.createChecked({
                level: level
            }, content);
            return {
                type: 'pmnode',
                nodes: [
                    headingNode
                ],
                length: match[0].length
            };
        } catch (err) {
            return {
                type: 'text',
                text: '',
                length: 4
            };
        }
    };
    function $ed15d3e22c065f91$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("iDsRr", function(module, exports) {
    $parcel$export(module.exports, "inserted", ()=>$33f79eddf582429a$export$744ba74fb86b8ca7);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.underline.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'underline',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '+', '+');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("ayQVO", function(module, exports) {
    $parcel$export(module.exports, "MAX_LIST_DEPTH", ()=>$4813b87fbe6448cc$export$d2a2f0ec33d903e1);
    $parcel$export(module.exports, "list", ()=>$4813b87fbe6448cc$export$8837f4fc672e936d);
    var $hnQWb;
    var $29zBb;
    var $20lXC;
    var $cG4PY;
    var $kSL4h;
    var $eWAZI;
    var $gxAE9;
    const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
    const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
    const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
    const $4813b87fbe6448cc$var$processState = {
        NEW_LINE: 0,
        BUFFER: 1,
        END: 2,
        MACRO: 3
    };
    const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        let index = position;
        let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
        let buffer = [];
        let lastListSymbols = null;
        let builder = null;
        let contentBuffer = [];
        const output = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $4813b87fbe6448cc$var$processState.NEW_LINE:
                    {
                        const substring = input.substring(index);
                        const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                        if (listMatch) {
                            const [, symbols] = listMatch;
                            const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                            if (rulerMatch) {
                                const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                                const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                                if (emptyLineMatch) {
                                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                                    continue;
                                }
                            }
                            if (!builder) {
                                builder = new (0, (0, parcelRequire("hnQWb")).ListBuilder)(schema, symbols);
                                lastListSymbols = symbols;
                            } else {
                                if (buffer.length > 0) {
                                    const content = (0, (0, parcelRequire("29zBb")).parseString)({
                                        ignoreTokenTypes: ignoreTokenTypes,
                                        schema: schema,
                                        context: context,
                                        input: buffer.join(''),
                                        includeLeadingSpace: true
                                    });
                                    contentBuffer.push(...content);
                                    builder.add([
                                        {
                                            style: lastListSymbols,
                                            content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                                        }
                                    ]);
                                    buffer = [];
                                    contentBuffer = [];
                                }
                                lastListSymbols = symbols;
                                const type = (0, (0, parcelRequire("hnQWb")).getType)(symbols);
                                if (type !== builder.type && symbols.length === 1) {
                                    output.push(...builder.buildPMNode());
                                    builder = new (0, (0, parcelRequire("hnQWb")).ListBuilder)(schema, symbols);
                                }
                            }
                            index += listMatch[0].length;
                        }
                        const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            state = $4813b87fbe6448cc$var$processState.END;
                            continue;
                        }
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        continue;
                    }
                case $4813b87fbe6448cc$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(index));
                        if (length) {
                            buffer.push(input.substr(index, length));
                            state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                            index += length;
                            continue;
                        }
                        if (char === '{') {
                            state = $4813b87fbe6448cc$var$processState.MACRO;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $4813b87fbe6448cc$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $4813b87fbe6448cc$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        continue;
                    }
                case $4813b87fbe6448cc$var$processState.END:
                    if (!builder) return $4813b87fbe6448cc$var$fallback(input, position);
                    if (buffer.length > 0) {
                        const content = (0, (0, parcelRequire("29zBb")).parseString)({
                            ignoreTokenTypes: ignoreTokenTypes,
                            schema: schema,
                            context: context,
                            input: buffer.join(''),
                            includeLeadingSpace: true
                        });
                        contentBuffer.push(...content);
                    }
                    builder.add([
                        {
                            style: lastListSymbols,
                            content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                        }
                    ]);
                    output.push(...builder.buildPMNode());
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
            }
            index++;
        }
        if (buffer.length > 0) {
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: buffer.join(''),
                includeLeadingSpace: true
            });
            contentBuffer.push(...content);
        }
        if (builder) {
            builder.add([
                {
                    style: lastListSymbols,
                    content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                }
            ]);
            output.push(...builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
        return nodes.reduce((result, curr)=>{
            switch(curr.type.name){
                case 'blockquote':
                    curr.content.forEach((n)=>{
                        result.push(n);
                    });
                    break;
                case 'heading':
                    {
                        const contentBuffer = [];
                        curr.content.forEach((n)=>{
                            const mark = schema.marks.strong.create();
                            if (n.type.name === 'text') {
                                if (n.text) n.text = n.text.toUpperCase();
                                if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                                    'strong',
                                    'code'
                                ])) contentBuffer.push(n.mark([
                                    ...n.marks,
                                    mark
                                ]));
                                else contentBuffer.push(n);
                            } else contentBuffer.push(n);
                        });
                        const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                        result.push(p);
                        break;
                    }
                default:
                    result.push(curr);
            }
            return result;
        }, []);
    }
    function $4813b87fbe6448cc$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("hnQWb", function(module, exports) {
    $parcel$export(module.exports, "getType", ()=>$3303253e6091964c$export$e2b5c5db9e2009fd);
    $parcel$export(module.exports, "ListBuilder", ()=>$3303253e6091964c$export$876cfa3161bef296);
    const $3303253e6091964c$var$supportedContentType = [
        'paragraph',
        'orderedList',
        'bulletList',
        'mediaSingle',
        'codeBlock'
    ];
    function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
        return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
    }
    class $3303253e6091964c$export$876cfa3161bef296 {
        constructor(schema, bullets){
            this.parseList = (list)=>{
                const listNode = this.schema.nodes[list.type];
                const output = [];
                let listItemsBuffer = [];
                for(let i = 0; i < list.children.length; i++){
                    const parsedContent = this.parseListItem(list.children[i]);
                    for(let j = 0; j < parsedContent.length; j++){
                        const parsedNode = parsedContent[j];
                        if (parsedNode.type.name === 'listItem') {
                            listItemsBuffer.push(parsedNode);
                            continue;
                        }
                        if (listItemsBuffer.length) {
                            const list = listNode.createChecked({}, listItemsBuffer);
                            output.push(list);
                        }
                        output.push(parsedNode);
                        listItemsBuffer = [];
                    }
                }
                if (listItemsBuffer.length) {
                    const list = listNode.createChecked({}, listItemsBuffer);
                    output.push(list);
                }
                return output;
            };
            this.parseListItem = (item)=>{
                const output = [];
                if (!item.content) item.content = [];
                const parsedChildren = item.children.reduce((result, list)=>{
                    const parsedList = this.parseList(list);
                    result.push(...parsedList);
                    return result;
                }, []);
                item.content.push(...parsedChildren);
                let contentBuffer = [];
                for(let i = 0; i < item.content.length; i++){
                    const pmNode = item.content[i];
                    if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                    if (this.isParagraphEmptyTextNode(pmNode)) continue;
                    if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                        const listItem = this.createListItem(contentBuffer, this.schema);
                        output.push(listItem);
                        output.push(pmNode);
                        contentBuffer = [];
                        continue;
                    }
                    contentBuffer.push(pmNode);
                }
                if (contentBuffer.length) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                }
                return output;
            };
            this.schema = schema;
            this.root = {
                children: [],
                type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
            };
            this.lastDepth = 1;
            this.lastList = this.root;
        }
        get type() {
            return this.root.type;
        }
        add(items) {
            for (const item of items){
                const { style: style, content: content } = item;
                if (style === null) {
                    this.appendToLastItem(content);
                    continue;
                }
                const depth = style.length;
                const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
                if (depth > this.lastDepth) {
                    this.createNest(depth - this.lastDepth, type);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                } else if (depth === this.lastDepth) this.lastList = this.addListItem(type, content);
                else {
                    this.lastList = this.findAncestor(this.lastDepth - depth);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                }
            }
        }
        buildPMNode() {
            return this.parseList(this.root);
        }
        isParagraphEmptyTextNode(node) {
            if (node.type.name !== 'paragraph' || !node.childCount) return false;
            for(let i = 0; i < node.childCount; i++){
                const n = node.content.child(i);
                if (n.type.name !== 'text') return false;
                else if (n.textContent.trim() !== '') return false;
            }
            return true;
        }
        createListItem(content, schema) {
            if (content.length === 0 || [
                'paragraph',
                'mediaSingle'
            ].indexOf(content[0].type.name) === -1) content.unshift(this.schema.nodes.paragraph.createChecked());
            return schema.nodes.listItem.createChecked({}, content);
        }
        addListItem(type, content) {
            let list = this.lastList;
            if (list.type !== type) {
                const parent = list.parent;
                const newList = {
                    children: [],
                    type: type,
                    parent: parent
                };
                parent.children.push(newList);
                this.lastList = list = newList;
            }
            const listItem = {
                content: content,
                parent: list,
                children: []
            };
            list.children = [
                ...list.children,
                listItem
            ];
            return list;
        }
        appendToLastItem(content) {
            const { children: children } = this.lastList;
            const lastItem = children[children.length - 1];
            lastItem.content.push(...content);
        }
        createNest(depth, type) {
            while(depth-- > 0){
                if (this.lastList.children.length === 0) {
                    const listItem = {
                        parent: this.lastList,
                        children: []
                    };
                    this.lastList.children = [
                        listItem
                    ];
                }
                const nextItem = this.lastList.children[this.lastList.children.length - 1];
                nextItem.children = [
                    {
                        children: [],
                        parent: nextItem,
                        type: type
                    }
                ];
                this.lastList = nextItem.children[0];
            }
        }
        findAncestor(depth) {
            let list = this.lastList;
            while(depth-- > 0 && list.parent){
                const listItem = list.parent;
                if (listItem && listItem.parent) list = listItem.parent;
            }
            return list;
        }
    }
});
parcelRegister("kPrK8", function(module, exports) {
    $parcel$export(module.exports, "monospace", ()=>$7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).ADF_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).ANCHOR_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).CODE_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).NOFORMAT_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).PANEL_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).LOREM_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE,
            (0, (0, parcelRequire("kSL4h")).TokenType).STRING,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).MEDIA,
            (0, (0, parcelRequire("kSL4h")).TokenType).HEADING,
            (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
            (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
            (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
            (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
            (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
            (0, (0, parcelRequire("kSL4h")).TokenType).CITATION,
            (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
            (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
            (0, (0, parcelRequire("kSL4h")).TokenType).EMOJI,
            (0, (0, parcelRequire("kSL4h")).TokenType).FORCE_LINE_BREAK
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.code.create();
            if (n.type.name === 'text' && n.marks.length) return n;
            return n.mark([
                mark
            ]);
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '{{', '}}');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4ZFIG", function(module, exports) {
    $parcel$export(module.exports, "quadrupleDashSymbol", ()=>$819171e80205fd1c$export$95a7907a71f31921);
    const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
    const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
        const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
        if (!match) return {
            type: 'text',
            text: '----',
            length: 4
        };
        return {
            type: 'text',
            text: input.substr(position, match[0].length),
            length: match[0].length
        };
    };
});
parcelRegister("91y57", function(module, exports) {
    $parcel$export(module.exports, "ruler", ()=>$cf2c039554fba6e4$export$f9adada2013e846e);
    var $i8dZb;
    const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
    const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
        const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: (0, (0, parcelRequire("i8dZb")).createRuleNode)(schema),
            length: match[0].length
        };
        return {
            type: 'text',
            text: input.substring(position, 1),
            length: 1
        };
    };
});
parcelRegister("i8dZb", function(module, exports) {
    $parcel$export(module.exports, "createRuleNode", ()=>$d0cc271b2b6d9a56$export$4267f2e5716b018a);
    const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
    function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
        const { paragraph: paragraph, rule: rule } = schema.nodes;
        if (containerNodeType) {
            const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
            return paragraph.createChecked({}, textNode);
        } else return rule.createChecked();
    }
    function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
        const { rule: rule } = schema.nodes;
        const ruleNode = rule.createChecked();
        return [
            ruleNode
        ];
    }
});
parcelRegister("1Mtv8", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$da489456937eda28$export$59ae2c325a998f89);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (pmNode)=>{
            const mark = schema.marks.strong.create();
            if (pmNode.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(pmNode, [
                'strong',
                'code'
            ])) return pmNode.mark([
                ...pmNode.marks,
                mark
            ]);
            return pmNode;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '*', '*');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("77w3e", function(module, exports) {
    $parcel$export(module.exports, "subscript", ()=>$af8d85604a001a66$export$bc5390e4688d2822);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sub'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '~', '~');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("lf0Nr", function(module, exports) {
    $parcel$export(module.exports, "superscript", ()=>$6f4f331694cf9bb6$export$b4aab94a5fcfcead);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sup'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '^', '^');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4s89q", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$8c7a9474c5649f43$export$9852986a3ec5f6a0);
    var $48GZN;
    var $29zBb;
    var $20lXC;
    var $7tIdE;
    var $4Foyv;
    var $jor5q;
    var $kSL4h;
    var $eWAZI;
    var $cG4PY;
    var $gxAE9;
    const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
    const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $8c7a9474c5649f43$var$processState = {
        END_TABLE: 2,
        BUFFER: 4,
        CLOSE_ROW: 5,
        NEW_ROW: 6,
        LINE_BREAK: 7,
        LINK: 8,
        MEDIA: 9,
        MACRO: 10,
        EMOJI: 11
    };
    const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER
        ];
        const output = [];
        let index = position;
        let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
        let buffer = [];
        let cellsBuffer = [];
        let cellStyle = '';
        let builder = null;
        while(index < input.length){
            const char = input.charAt(index);
            const substring = input.substring(index);
            switch(currentState){
                case $8c7a9474c5649f43$var$processState.NEW_ROW:
                    {
                        const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                        if (tableMatch) {
                            if (!builder) builder = new (0, (0, parcelRequire("48GZN")).TableBuilder)(schema);
                            index += tableMatch[1].length;
                            cellStyle = tableMatch[2];
                            index += tableMatch[2].length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        }
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                    {
                        const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                            currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                            continue;
                        }
                        const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                        if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(substring);
                        if (length) {
                            const endIndex = index;
                            const startIndex = input.lastIndexOf('|', endIndex) + 1;
                            const charsBefore = input.substring(startIndex, endIndex);
                            if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                            else {
                                currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                                buffer.push(input.substr(index, length));
                            }
                            index += length;
                            continue;
                        }
                        switch(char){
                            case '|':
                                {
                                    $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                    buffer = [];
                                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                    if (cellMatch) {
                                        cellStyle = cellMatch[2];
                                        index += cellMatch[2].length;
                                        continue;
                                    }
                                    break;
                                }
                            case ':':
                            case ';':
                            case '(':
                                currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                                continue;
                            case '[':
                                currentState = $8c7a9474c5649f43$var$processState.LINK;
                                continue;
                            case '!':
                                currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                                continue;
                            case '{':
                                currentState = $8c7a9474c5649f43$var$processState.MACRO;
                                continue;
                            default:
                                buffer.push(char);
                                index++;
                                continue;
                        }
                        break;
                    }
                case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                    {
                        const bufferOutput = buffer.join('');
                        if (bufferOutput.trim().length > 0) {
                            $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                            buffer = [];
                        }
                        if (builder) {
                            builder.add(cellsBuffer);
                            cellsBuffer = [];
                        }
                        currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.END_TABLE:
                    if (builder) {
                        if (cellsBuffer.length) builder.add(cellsBuffer);
                        output.push(builder.buildPMNode());
                    }
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
                case $8c7a9474c5649f43$var$processState.MEDIA:
                    {
                        const token = (0, (0, parcelRequire("4Foyv")).media)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.EMOJI:
                    {
                        const token = (0, (0, parcelRequire("jor5q")).emoji)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.LINK:
                    {
                        const token = (0, (0, parcelRequire("7tIdE")).linkFormat)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        }
                        break;
                    }
                case $8c7a9474c5649f43$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
            }
            index++;
        }
        const bufferOutput = buffer.join('');
        if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
        if (builder) {
            if (cellsBuffer.length) builder.add(cellsBuffer);
            output.push(builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
        if (buffer.length) {
            let contentNode = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: buffer
            });
            if (style === '||') contentNode = contentNode.map((e)=>{
                return $8c7a9474c5649f43$var$createTableHeader(e, schema);
            });
            cellsBuffer.push({
                style: style,
                content: (0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentNode, schema)
            });
        }
    }
    function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
        const mark = schema.marks.strong.create();
        return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
    }
    function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
        if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
        for(let i = 0; i < node.content.childCount; i++){
            const child = node.content.child(i);
            const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
            const updatedContent = node.content.replaceChild(i, markedChild);
            node = node.copy(updatedContent);
        }
        return node;
    }
    function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
        if (node.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(node, [
            'strong',
            'code'
        ])) {
            const newNode = node.mark([
                ...node.marks,
                mark
            ]);
            return newNode;
        }
        return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
    }
});
parcelRegister("48GZN", function(module, exports) {
    $parcel$export(module.exports, "TableBuilder", ()=>$75a71ab9390c3135$export$9e18c07f56f31a89);
    function $75a71ab9390c3135$var$getType(style) {
        return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
    }
    class $75a71ab9390c3135$export$9e18c07f56f31a89 {
        constructor(schema){
            this.emptyTableCell = ()=>{
                const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
                return tableCell.createChecked({}, paragraph.createChecked());
            };
            this.emptyTableRow = ()=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, this.emptyTableCell());
            };
            this.buildTableNode = ()=>{
                const { root: root } = this;
                const { table: table } = this.schema.nodes;
                const content = root.rows.map(this.buildTableRowNode);
                if (content.length === 0) content.push(this.emptyTableRow());
                return table.createChecked({}, content);
            };
            this.buildTableRowNode = (row)=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
            };
            this.buildTableCellNode = (cell)=>{
                const { type: type, content: content } = cell;
                if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
                const cellNode = this.schema.nodes[type];
                return cellNode.createChecked({}, content);
            };
            this.schema = schema;
            this.root = {
                rows: []
            };
        }
        get type() {
            return 'table';
        }
        add(cells) {
            if (!cells.length) return;
            let index = 0;
            for (const cell of cells){
                const { content: content, style: style } = cell;
                const cellType = $75a71ab9390c3135$var$getType(style);
                if (index === 0) this.addRow();
                const newCell = {
                    type: cellType,
                    content: content
                };
                this.lastRow.cells.push(newCell);
                index += 1;
            }
        }
        buildPMNode() {
            return this.buildTableNode();
        }
        addRow() {
            const { rows: rows } = this.root;
            const row = {
                cells: []
            };
            rows.push(row);
            this.lastRow = row;
        }
    }
});
parcelRegister("ir9MO", function(module, exports) {
    $parcel$export(module.exports, "tripleDashSymbol", ()=>$0a377f498827084a$export$edbcd749367de060);
    var $1rQjR;
    const $0a377f498827084a$var$token = {
        type: 'text',
        text: '\u2014',
        length: 3
    };
    const $0a377f498827084a$var$fallback = {
        ...$0a377f498827084a$var$token,
        text: '---'
    };
    const $0a377f498827084a$export$edbcd749367de060 = (0, (0, parcelRequire("1rQjR")).createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);
});
parcelRegister("7E14k", function(module, exports) {
    $parcel$export(module.exports, "panelMacro", ()=>$fa58ef1a18570456$export$5d7bf7e31a674541);
    var $3JW2n;
    var $29zBb;
    var $4ZUg7;
    var $20lXC;
    var $fQoRM;
    var $1agyv;
    const $fa58ef1a18570456$var$allowedNodeType = [
        'paragraph',
        'heading',
        'orderedList',
        'bulletList'
    ];
    const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'panel',
            paired: true,
            context: context,
            rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
        });
    };
    const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const output = [];
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const nodeAttrs = {
            ...parsedAttrs,
            panelType: (0, (0, parcelRequire("fQoRM")).getPanelType)(parsedAttrs)
        };
        const parsedContent = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("20lXC")).normalizePMNodes)(parsedContent, schema);
        let contentBuffer = parsedAttrs.title ? [
            (0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema)
        ] : [];
        for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
        else {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
            contentBuffer = [];
            output.push(panelNode);
            output.push(n);
        }
        if (contentBuffer.length > 0) {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
            output.push(panelNode);
        }
        return {
            type: 'pmnode',
            nodes: output.length ? output : [
                $fa58ef1a18570456$var$emptyPanel(schema)
            ],
            length: length
        };
    };
    function $fa58ef1a18570456$var$emptyPanel(schema) {
        const p = schema.nodes.paragraph.createChecked();
        return schema.nodes.panel.createChecked({}, p);
    }
});
parcelRegister("fQoRM", function(module, exports) {
    $parcel$export(module.exports, "getPanelType", ()=>$afb9d2bd4cb626dc$export$fa00fa3d6c22a747);
    var $4PfBJ;
    const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
        hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
        prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
    };
    const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
        info: {
            r: 222,
            g: 235,
            b: 255
        },
        note: {
            r: 234,
            g: 230,
            b: 255
        },
        success: {
            r: 227,
            g: 252,
            b: 239
        },
        warning: {
            r: 255,
            g: 250,
            b: 230
        },
        error: {
            r: 255,
            g: 235,
            b: 230
        }
    };
    function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
        const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
        if (!rgb) return 'info';
        let mapTo = 'info';
        let smallestDistance = Infinity;
        Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
            const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                mapTo = panelType;
            }
        });
        return mapTo;
    }
    function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
        return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
    }
    function $afb9d2bd4cb626dc$var$generateRgb(color) {
        switch(true){
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
                return $afb9d2bd4cb626dc$var$parseHex(color);
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
                return $afb9d2bd4cb626dc$var$parseRgb(color);
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
                return $afb9d2bd4cb626dc$var$parsePrgb(color);
            default:
                return $afb9d2bd4cb626dc$var$parseColorName(color);
        }
    }
    function $afb9d2bd4cb626dc$var$parseHex(hex) {
        hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
            return r + r + g + g + b + b;
        });
        const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
        const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
        return result ? {
            r: parseInt(result[1], 10),
            g: parseInt(result[2], 10),
            b: parseInt(result[3], 10)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
        const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
        return result ? {
            r: Math.floor(255 * parseInt(result[1], 10) / 100),
            g: Math.floor(255 * parseInt(result[2], 10) / 100),
            b: Math.floor(255 * parseInt(result[4], 10) / 100)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parseColorName(color) {
        return (0, (0, parcelRequire("4PfBJ")).default)[color];
    }
});
parcelRegister("4PfBJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
    const $fe6de0fe9d8acfe8$var$mapping = {
        crimson: {
            r: 220,
            g: 20,
            b: 60
        },
        lightpink: {
            r: 255,
            g: 182,
            b: 193
        },
        pink: {
            r: 255,
            g: 192,
            b: 203
        },
        palevioletred: {
            r: 219,
            g: 112,
            b: 147
        },
        lavenderblush: {
            r: 255,
            g: 240,
            b: 245
        },
        hotpink: {
            r: 255,
            g: 105,
            b: 180
        },
        deeppink: {
            r: 255,
            g: 20,
            b: 147
        },
        mediumvioletred: {
            r: 199,
            g: 21,
            b: 133
        },
        orchid: {
            r: 218,
            g: 112,
            b: 214
        },
        thistle: {
            r: 216,
            g: 191,
            b: 216
        },
        plum: {
            r: 221,
            g: 160,
            b: 221
        },
        violet: {
            r: 238,
            g: 130,
            b: 238
        },
        fuchsia: {
            r: 255,
            g: 0,
            b: 255
        },
        darkmagenta: {
            r: 139,
            g: 0,
            b: 139
        },
        purple: {
            r: 128,
            g: 0,
            b: 128
        },
        mediumorchid: {
            r: 186,
            g: 85,
            b: 211
        },
        darkviolet: {
            r: 148,
            g: 0,
            b: 211
        },
        darkorchid: {
            r: 153,
            g: 50,
            b: 204
        },
        indigo: {
            r: 75,
            g: 0,
            b: 130
        },
        blueviolet: {
            r: 138,
            g: 43,
            b: 226
        },
        mediumpurple: {
            r: 147,
            g: 112,
            b: 219
        },
        darkslateblue: {
            r: 72,
            g: 61,
            b: 139
        },
        mediumslateblue: {
            r: 123,
            g: 104,
            b: 238
        },
        slateblue: {
            r: 106,
            g: 90,
            b: 205
        },
        ghostwhite: {
            r: 248,
            g: 248,
            b: 255
        },
        lavender: {
            r: 230,
            g: 230,
            b: 250
        },
        blue: {
            r: 0,
            g: 0,
            b: 255
        },
        mediumblue: {
            r: 0,
            g: 0,
            b: 205
        },
        darkblue: {
            r: 0,
            g: 0,
            b: 139
        },
        navy: {
            r: 0,
            g: 0,
            b: 128
        },
        midnightblue: {
            r: 25,
            g: 25,
            b: 112
        },
        royalblue: {
            r: 65,
            g: 105,
            b: 225
        },
        cornflowerblue: {
            r: 100,
            g: 149,
            b: 237
        },
        lightsteelblue: {
            r: 176,
            g: 196,
            b: 222
        },
        lightslategray: {
            r: 119,
            g: 136,
            b: 153
        },
        slategray: {
            r: 112,
            g: 128,
            b: 144
        },
        dodgerblue: {
            r: 30,
            g: 144,
            b: 255
        },
        aliceblue: {
            r: 240,
            g: 248,
            b: 255
        },
        steelblue: {
            r: 70,
            g: 130,
            b: 180
        },
        lightskyblue: {
            r: 135,
            g: 206,
            b: 250
        },
        skyblue: {
            r: 135,
            g: 206,
            b: 235
        },
        deepskyblue: {
            r: 0,
            g: 191,
            b: 255
        },
        lightblue: {
            r: 173,
            g: 216,
            b: 230
        },
        powderblue: {
            r: 176,
            g: 224,
            b: 230
        },
        cadetblue: {
            r: 95,
            g: 158,
            b: 160
        },
        darkturquoise: {
            r: 0,
            g: 206,
            b: 209
        },
        azure: {
            r: 240,
            g: 255,
            b: 255
        },
        lightcyan: {
            r: 224,
            g: 255,
            b: 255
        },
        paleturquoise: {
            r: 174,
            g: 238,
            b: 238
        },
        darkslategray: {
            r: 47,
            g: 79,
            b: 79
        },
        aqua: {
            r: 0,
            g: 255,
            b: 255
        },
        darkcyan: {
            r: 0,
            g: 139,
            b: 139
        },
        teal: {
            r: 0,
            g: 128,
            b: 128
        },
        mediumturquoise: {
            r: 72,
            g: 209,
            b: 204
        },
        lightseagreen: {
            r: 32,
            g: 178,
            b: 170
        },
        turquoise: {
            r: 64,
            g: 224,
            b: 208
        },
        aquamarine: {
            r: 127,
            g: 255,
            b: 212
        },
        mediumaquamarine: {
            r: 102,
            g: 205,
            b: 170
        },
        mediumspringgreen: {
            r: 0,
            g: 250,
            b: 154
        },
        mintcream: {
            r: 245,
            g: 255,
            b: 250
        },
        springgreen: {
            r: 0,
            g: 255,
            b: 127
        },
        mediumseagreen: {
            r: 60,
            g: 179,
            b: 113
        },
        seagreen: {
            r: 46,
            g: 139,
            b: 87
        },
        honeydew: {
            r: 240,
            g: 255,
            b: 240
        },
        darkseagreen: {
            r: 143,
            g: 188,
            b: 143
        },
        palegreen: {
            r: 152,
            g: 251,
            b: 152
        },
        lightgreen: {
            r: 144,
            g: 238,
            b: 144
        },
        limegreen: {
            r: 50,
            g: 205,
            b: 50
        },
        forestgreen: {
            r: 34,
            g: 139,
            b: 34
        },
        lime: {
            r: 0,
            g: 255,
            b: 0
        },
        green: {
            r: 0,
            g: 128,
            b: 0
        },
        darkgreen: {
            r: 0,
            g: 100,
            b: 0
        },
        lawngreen: {
            r: 124,
            g: 252,
            b: 0
        },
        chartreuse: {
            r: 127,
            g: 255,
            b: 0
        },
        greenyellow: {
            r: 173,
            g: 255,
            b: 47
        },
        darkolivegreen: {
            r: 85,
            g: 107,
            b: 47
        },
        olivedrab: {
            r: 107,
            g: 142,
            b: 35
        },
        yellowgreen: {
            r: 154,
            g: 205,
            b: 50
        },
        ivory: {
            r: 255,
            g: 255,
            b: 240
        },
        beige: {
            r: 245,
            g: 245,
            b: 220
        },
        lightyellow: {
            r: 255,
            g: 255,
            b: 224
        },
        lightgoldenrodyellow: {
            r: 250,
            g: 250,
            b: 210
        },
        yellow: {
            r: 255,
            g: 255,
            b: 0
        },
        olive: {
            r: 128,
            g: 128,
            b: 0
        },
        darkkhaki: {
            r: 189,
            g: 183,
            b: 107
        },
        khaki: {
            r: 240,
            g: 230,
            b: 140
        },
        palegoldenrod: {
            r: 238,
            g: 232,
            b: 170
        },
        lemonchiffon: {
            r: 255,
            g: 250,
            b: 205
        },
        gold: {
            r: 255,
            g: 215,
            b: 0
        },
        cornsilk: {
            r: 255,
            g: 248,
            b: 220
        },
        goldenrod: {
            r: 218,
            g: 165,
            b: 32
        },
        darkgoldenrod: {
            r: 184,
            g: 134,
            b: 11
        },
        orange: {
            r: 255,
            g: 128,
            b: 0
        },
        floralwhite: {
            r: 255,
            g: 250,
            b: 240
        },
        oldlace: {
            r: 253,
            g: 245,
            b: 230
        },
        wheat: {
            r: 245,
            g: 222,
            b: 179
        },
        moccasin: {
            r: 255,
            g: 228,
            b: 181
        },
        papayawhip: {
            r: 255,
            g: 239,
            b: 213
        },
        blanchedalmond: {
            r: 255,
            g: 235,
            b: 205
        },
        navajowhite: {
            r: 255,
            g: 222,
            b: 173
        },
        tan: {
            r: 210,
            g: 180,
            b: 140
        },
        antiquewhite: {
            r: 250,
            g: 235,
            b: 215
        },
        burlywood: {
            r: 222,
            g: 184,
            b: 135
        },
        bisque: {
            r: 255,
            g: 228,
            b: 196
        },
        darkorange: {
            r: 255,
            g: 140,
            b: 0
        },
        peru: {
            r: 205,
            g: 133,
            b: 63
        },
        linen: {
            r: 250,
            g: 240,
            b: 230
        },
        peachpuff: {
            r: 255,
            g: 218,
            b: 185
        },
        seashell: {
            r: 255,
            g: 245,
            b: 238
        },
        sandybrown: {
            r: 244,
            g: 164,
            b: 96
        },
        chocolate: {
            r: 210,
            g: 105,
            b: 30
        },
        saddlebrown: {
            r: 139,
            g: 69,
            b: 19
        },
        sienna: {
            r: 160,
            g: 82,
            b: 45
        },
        lightsalmon: {
            r: 255,
            g: 160,
            b: 122
        },
        coral: {
            r: 255,
            g: 127,
            b: 80
        },
        orangered: {
            r: 255,
            g: 69,
            b: 0
        },
        darksalmon: {
            r: 233,
            g: 150,
            b: 122
        },
        tomato: {
            r: 255,
            g: 99,
            b: 71
        },
        salmon: {
            r: 250,
            g: 128,
            b: 114
        },
        mistyrose: {
            r: 255,
            g: 228,
            b: 225
        },
        snow: {
            r: 255,
            g: 250,
            b: 250
        },
        rosybrown: {
            r: 188,
            g: 143,
            b: 143
        },
        lightcoral: {
            r: 240,
            g: 128,
            b: 128
        },
        indianred: {
            r: 205,
            g: 92,
            b: 92
        },
        brown: {
            r: 165,
            g: 42,
            b: 42
        },
        firebrick: {
            r: 178,
            g: 34,
            b: 34
        },
        red: {
            r: 255,
            g: 0,
            b: 0
        },
        darkred: {
            r: 139,
            g: 0,
            b: 0
        },
        maroon: {
            r: 128,
            g: 0,
            b: 0
        },
        white: {
            r: 255,
            g: 255,
            b: 255
        },
        gainsboro: {
            r: 220,
            g: 220,
            b: 220
        },
        lightgray: {
            r: 211,
            g: 211,
            b: 211
        },
        silver: {
            r: 192,
            g: 192,
            b: 192
        },
        darkgray: {
            r: 169,
            g: 169,
            b: 169
        },
        gray: {
            r: 128,
            g: 128,
            b: 128
        },
        dimgray: {
            r: 105,
            g: 105,
            b: 105
        },
        black: {
            r: 0,
            g: 0,
            b: 0
        },
        whitesmoke: {
            r: 245,
            g: 245,
            b: 245
        }
    };
    var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;
});
parcelRegister("1agyv", function(module, exports) {
    $parcel$export(module.exports, "title", ()=>$9eccd901f1df184b$export$fb184b623420d9be);
    function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
        const mark = schema.marks.strong.create();
        const title = schema.text(text, [
            mark
        ]);
        return schema.nodes.paragraph.createChecked({}, [
            title
        ]);
    }
});
parcelRegister("9MeiU", function(module, exports) {
    $parcel$export(module.exports, "adfMacro", ()=>$39fb2727ee273b16$export$8fb4b58db8f664fb);
    var $3JW2n;
    const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'adf',
            paired: true,
            context: context,
            rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
        });
    };
    const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
        try {
            const json = JSON.parse(rawContent);
            const node = schema.nodeFromJSON(json);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        } catch (_e) {
            const textContent = `Invalid ADF Macro: ${rawContent}`;
            const textNode = rawContent.length ? schema.text(textContent) : undefined;
            const { codeBlock: codeBlock } = schema.nodes;
            const node = codeBlock.create({
                language: undefined
            }, textNode);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        }
    };
});
parcelRegister("f50H1", function(module, exports) {
    $parcel$export(module.exports, "anchorMacro", ()=>$4b331e3d410cf176$export$e660dadc21580fa2);
    var $3JW2n;
    const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'anchor',
            paired: false,
            context: context,
            rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
        });
    };
    const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
        return {
            type: 'text',
            text: '',
            length: length
        };
    };
});
parcelRegister("bSil4", function(module, exports) {
    $parcel$export(module.exports, "codeMacro", ()=>$38ee74463de0ec95$export$db6c131ac26c7700);
    var $3JW2n;
    var $4ZUg7;
    var $1agyv;
    const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
        'abap',
        'actionscript',
        'ada',
        'arduino',
        'autoit',
        'c',
        'c++',
        'clojure',
        'coffeescript',
        'csharp',
        'css',
        'cuda',
        'd',
        'dart',
        'delphi',
        'elixir',
        'erlang',
        'fortran',
        'foxpro',
        'go',
        'groovy',
        'haskell',
        'haxe',
        'html',
        'java',
        'javascript',
        'json',
        'julia',
        'kotlin',
        'latex',
        'livescript',
        'lua',
        'mathematica',
        'matlab',
        'objective-c',
        'objective-j',
        'objectpascal',
        'ocaml',
        'octave',
        'perl',
        'php',
        'powershell',
        'prolog',
        'puppet',
        'python',
        'qml',
        'r',
        'racket',
        'restructuredtext',
        'ruby',
        'rust',
        'sass',
        'scala',
        'scheme',
        'shell',
        'smalltalk',
        'sql',
        'standardml',
        'swift',
        'tcl',
        'tex',
        'typescript',
        'vala',
        'vbnet',
        'verilog',
        'vhdl',
        'xml',
        'xquery'
    ];
    const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'code',
            paired: true,
            context: context,
            rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
        });
    };
    const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema));
        const nodeAttrs = {
            ...parsedAttrs,
            language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
        };
        output.push(codeBlock.createChecked(nodeAttrs, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
    function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
        const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
        for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
            if (keys.indexOf(language) !== -1) return language;
        }
        if (keys.indexOf('objc') !== -1) return 'objective-c';
        return 'java';
    }
});
parcelRegister("cjZPi", function(module, exports) {
    $parcel$export(module.exports, "colorMacro", ()=>$2374771f8fbda9ef$export$b557be495948d995);
    var $kSL4h;
    var $3JW2n;
    var $4ZUg7;
    var $29zBb;
    var $7p5zM;
    var $gxAE9;
    const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'color',
            paired: true,
            context: context,
            rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
        });
    };
    const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const content = (0, (0, parcelRequire("29zBb")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: rawContent
        });
        const decoratedContent = content.map((n)=>{
            const mark = schema.marks.textColor.create({
                color: (0, (0, parcelRequire("7p5zM")).getEditorColor)(parsedAttrs) || '#000000'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
});
parcelRegister("7p5zM", function(module, exports) {
    $parcel$export(module.exports, "getEditorColor", ()=>$dace0eb9654d7c1b$export$c0cfc6f23e0b7578);
    var $51H8P;
    function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
        const keys = Object.keys(attrs);
        return (0, (0, parcelRequire("51H8P")).normalizeHexColor)(keys[0]);
    }
});
parcelRegister("8tGpW", function(module, exports) {
    $parcel$export(module.exports, "noformatMacro", ()=>$7fe042bf55811a5b$export$9199752eb9b2d5b4);
    var $3JW2n;
    var $4ZUg7;
    var $1agyv;
    const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'noformat',
            paired: true,
            context: context,
            rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
        });
    };
    const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema));
        output.push(codeBlock.createChecked({}, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
});
parcelRegister("lyI5i", function(module, exports) {
    $parcel$export(module.exports, "forceLineBreak", ()=>$90e9f72be02de2ac$export$2de3d7fd25cbc36);
    const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
    const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
        if (position > 0) {
            const charBefore = input.charAt(position - 1);
            if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
        }
        const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: 2
        };
        return $90e9f72be02de2ac$var$fallback(input, position);
    };
    function $90e9f72be02de2ac$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 2),
            length: 2
        };
    }
});
parcelRegister("4yZSi", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$e115b67b9a7c1782$export$6565f9f03506010b);
    const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
        return `{{${text}}}`;
    };
});
parcelRegister("aDTWq", function(module, exports) {
    $parcel$export(module.exports, "textColor", ()=>$ef3e88b1064ccc35$export$32f78bffcd82ff28);
    const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
        return `{color:${attrs.color}}${text}{color}`;
    };
});
parcelRegister("gdFeW", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$e431017de2633455$export$c63c6f932822f543);
    var $3ovek;
    const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
        if (text.startsWith("\u2014 ")) return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text.substring(2), '??');
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '_');
    };
});
parcelRegister("3ovek", function(module, exports) {
    $parcel$export(module.exports, "baseMarkPattern", ()=>$7f6f940a63ef31a6$export$3d8aed7830783c75);
    const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
        if (/^\s*$/.test(text)) return text;
        return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
    };
});
parcelRegister("jo5YT", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$5614ddd827a3bd70$export$9c30223ca0a664fb);
    const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
        return `[${text}|${attrs.href}]`;
    };
});
parcelRegister("9fwgI", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$486b01102f007d8c$export$4899a95d70ec5056);
    var $3ovek;
    const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '-');
    };
});
parcelRegister("eKxrE", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$5f94e33f4e7efc4b$export$59ae2c325a998f89);
    var $3ovek;
    const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '*');
    };
});
parcelRegister("1x55I", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$de8ae0bb6a3c8a22$export$b3401ee80eb31041);
    var $3ovek;
    const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
        if (attrs.type === 'sub') return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '~');
        else return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '^');
    };
});
parcelRegister("8tKGr", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$bb8b641056119651$export$425327af25286e5e);
    var $3ovek;
    const $bb8b641056119651$export$425327af25286e5e = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '+');
    };
});
parcelRegister("5IuwX", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$c6769d560338119d$export$cbf8224b64e0d942);
    var $1Nefo;
    var $bOMPB;
    const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        const match = node.attrs.url.match((0, (0, parcelRequire("bOMPB")).INLINE_CARD_FROM_TEXT_STAMP));
        if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
        return `[${match[2]}]`;
    };
});
parcelRegister("1HDja", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$d0c82c4f36685012$export$471f7ae5c4103ae1);
    var $aDTWq;
    const $d0c82c4f36685012$var$color = {
        grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
        purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
        blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
        red: (0, $829f609a65d26a98$export$4a7404f376229999),
        yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
        green: (0, $829f609a65d26a98$export$940e1f69e873f202)
    };
    const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
        const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
        const newAttrs = {
            ...node.attrs
        };
        if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
        else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
        return (0, (0, parcelRequire("aDTWq")).textColor)(text, newAttrs);
    };
});
parcelRegister("c08Yp", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$61a6161cda09885d$export$324d90190a8b822a);
    const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
        const addLeadingZero = (val)=>{
            if (val < 10) return `0${val}`;
            return val;
        };
        const result = new Date(Number(node.attrs.timestamp));
        return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
    };
});
parcelRegister("73kPn", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$ef6a5d3a665df695$export$7bb0d5c671655cc4);
    var $bK2QZ;
    const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
        'actionscript',
        'ada',
        'applescript',
        'bash',
        'c',
        'c#',
        'c++',
        'cpp',
        'css',
        'erlang',
        'go',
        'groovy',
        'haskell',
        'html',
        'java',
        'javascript',
        'js',
        'json',
        'lua',
        'none',
        'nyan',
        'objc',
        'perl',
        'php',
        'python',
        'r',
        'rainbow',
        'ruby',
        'scala',
        'sh',
        'sql',
        'swift',
        'visualbasic',
        'xml',
        'yaml'
    ];
    const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                parent: node
            });
        });
        if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
        else return `{noformat}${result}{noformat}`;
    };
});
parcelRegister("eTlm6", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$b3a3fb1c58065f07$export$2855e964765eac9);
    var $bsbI5;
    var $48ot6;
    var $1Nefo;
    const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
        const result = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'media':
                    result.push((0, (0, parcelRequire("48ot6")).media)(n, {
                        ...opts,
                        parent: node
                    }));
                    break;
                case 'caption':
                    result.push((0, (0, parcelRequire("bsbI5")).caption)(n, opts));
                    break;
                default:
                    result.push((0, (0, parcelRequire("1Nefo")).unknown)(n));
                    break;
            }
        });
        return result.join('\n');
    };
});
parcelRegister("bsbI5", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);
    var $bK2QZ;
    const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("48ot6", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$df984bb2074676e8$export$987d49ffe1b0900f);
    const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
        let wikiAttrs = [];
        if (parent && parent.attrs.width) wikiAttrs.push(`width=${parent.attrs.width}%`);
        else {
            if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
            if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
        }
        if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
        if (node.marks.length) {
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
        }
        let fileName;
        if (node.attrs.type === 'external') fileName = node.attrs.url;
        else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
        if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
        return `!${fileName}|thumbnail!`;
    };
});
parcelRegister("hgytR", function(module, exports) {
    $parcel$export(module.exports, "taskList", ()=>$1fb2a139f9f264bf$export$375b6afcc5f4d291);
    var $4kMeo;
    const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
        const result = [];
        node.forEach((item)=>{
            if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
            else result.push((0, (0, parcelRequire("4kMeo")).taskItem)(item, depth));
        });
        return result.join('\n');
    };
    const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
        return $1fb2a139f9f264bf$var$nestedNode(node);
    };
});
parcelRegister("4kMeo", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$b96ea7b246afcc42$export$6d8b0ef52e2e6390);
    var $bK2QZ;
    const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            const prefix = Array(nestedLevel).fill('*').join('');
            if (node.attrs.state === 'DONE') result += `${prefix} -${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}-`;
            else result += `${prefix} ${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("b6sEJ", function(module, exports) {
    $parcel$export(module.exports, "decisionList", ()=>$9054c6d3a6a22504$export$62d45a65fb43d95e);
    var $h0oA4;
    const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("h0oA4")).decisionItem)(item));
        });
        return result.join('\n');
    };
});
parcelRegister("h0oA4", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$6209b59f60b56dcd$export$6959e16eeff859b4);
    var $bK2QZ;
    const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += `* <> ${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("1B6CN", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$5ce407caf0707589$export$2a111da947c407d2);
    var $lxtC7;
    const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return result.join('\n\n');
    };
});
parcelRegister("8UMD2", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$dcda58106fc3b9ff$export$9f77e0932fb78f72);
    var $lxtC7;
    const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
        const result = [
            `*${node.attrs.title}*`,
            ''
        ];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return result.join('\n');
    };
});
parcelRegister("fIzNZ", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$2a94cb79881b69b7$export$46e4a324ac90507f);
    var $bK2QZ;
    const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n);
        });
        return `h${node.attrs.level}. ${result}`;
    };
});
parcelRegister("h9tzi", function(module, exports) {
    $parcel$export(module.exports, "orderedList", ()=>$c2a8fd1ebb40e986$export$a5dc81035676e7a);
    var $bxtEu;
    const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("bxtEu")).listItem)(item, '#', context));
        });
        return result.join('\n');
    };
});
parcelRegister("abXFq", function(module, exports) {
    $parcel$export(module.exports, "panel", ()=>$d8008c2d580ced87$export$21f42ab9b6679f44);
    var $lxtC7;
    const $d8008c2d580ced87$var$panelTypeColorMapping = {
        info: '#deebff',
        note: '#eae6ff',
        success: '#e3fcef',
        warning: '#fffae6',
        error: '#ffebe6'
    };
    const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
    };
});
parcelRegister("czgKo", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
    const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
        return '----';
    };
});
parcelRegister("acqkf", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$6deed74ceb5bf80f$export$9852986a3ec5f6a0);
    var $lxtC7;
    var $1Nefo;
    const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
        try {
            const result = [];
            node.forEach((n)=>{
                result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
            });
            return result.join('\n');
        } catch (err) {
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        }
    };
    const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
        let result = '';
        let separator = '|';
        node.forEach((n)=>{
            if (n.type.name === 'tableHeader') separator = '||';
            else separator = '|';
            result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
        });
        return `${result}${separator}`;
    };
    const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
        if ($6deed74ceb5bf80f$var$hasMergedCell(node)) throw new Error('Advanced feature of table is not supported');
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        const output = result.join('\n').trim();
        return output === '' ? ' ' : output;
    };
    const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
        if (!node.attrs) return false;
        if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
        if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
        return false;
    };
});
parcelRegister("69N10", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$0c06383b3aca4143$export$c4c2f833baaebdb8);
    var $1Nefo;
    const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
    };
});
parcelRegister("12A17", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$c9c7f4b278041854$export$be4283d9a1cb1ff6);
    var $1Nefo;
    const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
    };
});
parcelRegister("djcbG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74f62fc9e2776603$export$2e2bcd8739ae039);
    var $29zBb;
    var $20lXC;
    class $74f62fc9e2776603$export$2e2bcd8739ae039 {
        constructor(schema, wikiMarkup){
            this.schema = schema;
            this.wikiMarkup = wikiMarkup;
        }
        getProseMirrorModel(context) {
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                context: context,
                ignoreTokenTypes: [],
                input: this.wikiMarkup,
                schema: this.schema
            });
            return this.schema.nodes.doc.createChecked({}, (0, (0, parcelRequire("20lXC")).normalizePMNodes)(content, this.schema, 'doc'));
        }
    }
});
parcelRegister("cnwtr", function(module, exports) {
    $parcel$export(module.exports, "debounce", ()=>$9030d2a8015fc5dc$export$61fc7d43ac8f84b0);
    $parcel$export(module.exports, "convertDateFormatToSlashes", ()=>$9030d2a8015fc5dc$export$9ed21541b7ef1a9f);
    const $9030d2a8015fc5dc$export$9a1adf421b69c6a = (x)=>{
        return !!x;
    };
    const $9030d2a8015fc5dc$export$f44a717c401a878a = ()=>{
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    };
    const $9030d2a8015fc5dc$export$61fc7d43ac8f84b0 = (func, wait, immediate)=>{
        var timeout;
        return function() {
            const context = this;
            const args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    const $9030d2a8015fc5dc$export$9ed21541b7ef1a9f = (date)=>{
        return date.replace(/-/g, '/');
    };
});
parcelRegister("6lxfx", function(module, exports) {
    $parcel$export(module.exports, "ValidationErrorMsg", ()=>$49ee7ee62244437f$export$918e8d988e50ccc0);
    $parcel$export(module.exports, "NumberValidationErrorMsg", ()=>$49ee7ee62244437f$export$29e4a6c62db1e0ba);
    $parcel$export(module.exports, "TextValidationErrorMsg", ()=>$49ee7ee62244437f$export$66fb68ff0427090f);
    $parcel$export(module.exports, "DateTimeValidationErrorMsg", ()=>$49ee7ee62244437f$export$ae02ba97d418070);
    $parcel$export(module.exports, "ChoiceValidationErrorMsg", ()=>$49ee7ee62244437f$export$c8f7f52f47b04c93);
    $parcel$export(module.exports, "UserPickerValidationErrorMsg", ()=>$49ee7ee62244437f$export$ef5d979bfd00ccfc);
    $parcel$export(module.exports, "IntlValidationErrorMessages", ()=>$49ee7ee62244437f$export$40d5a30c6400de7b);
    var $7VHMR;
    let $49ee7ee62244437f$export$918e8d988e50ccc0 = function(ValidationErrorMsg) {
        ValidationErrorMsg["Required"] = "Required";
        ValidationErrorMsg["FormSave"] = "FormSave";
        return ValidationErrorMsg;
    }({});
    let $49ee7ee62244437f$export$29e4a6c62db1e0ba = function(NumberValidationErrorMsg) {
        NumberValidationErrorMsg["WholeNum"] = "WholeNum";
        NumberValidationErrorMsg["MinNum"] = "MinNum";
        NumberValidationErrorMsg["MaxNum"] = "MaxNum";
        NumberValidationErrorMsg["BetweenNum"] = "BetweenNum";
        NumberValidationErrorMsg["ExactNum"] = "ExactNum";
        NumberValidationErrorMsg["InvalidNum"] = "InvalidNum";
        return NumberValidationErrorMsg;
    }({});
    let $49ee7ee62244437f$export$66fb68ff0427090f = function(TextValidationErrorMsg) {
        TextValidationErrorMsg["MinChars"] = "MinChars";
        TextValidationErrorMsg["MaxChars"] = "MaxChars";
        TextValidationErrorMsg["BetweenChars"] = "BetweenChars";
        TextValidationErrorMsg["ExactChars"] = "ExactChars";
        TextValidationErrorMsg["MinWords"] = "MinWords";
        TextValidationErrorMsg["MaxWords"] = "MaxWords";
        TextValidationErrorMsg["BetweenWords"] = "BetweenWords";
        TextValidationErrorMsg["ExactWords"] = "ExactWords";
        TextValidationErrorMsg["RegexCustomMsg"] = "RegexCustomMsg";
        TextValidationErrorMsg["RegexDefaultMsg"] = "RegexDefaultMSg";
        TextValidationErrorMsg["RegexInvalidMsg"] = "RegexInvalidMsg";
        TextValidationErrorMsg["InvalidEmail"] = "InvalidEmail";
        TextValidationErrorMsg["InvalidUrl"] = "InvalidUrl";
        return TextValidationErrorMsg;
    }({});
    let $49ee7ee62244437f$export$ae02ba97d418070 = function(DateTimeValidationErrorMsg) {
        DateTimeValidationErrorMsg["MinDate"] = "MinDate";
        DateTimeValidationErrorMsg["MaxDate"] = "MaxDate";
        DateTimeValidationErrorMsg["BetweenDate"] = "BetweenDate";
        DateTimeValidationErrorMsg["ExactDate"] = "ExactDate";
        DateTimeValidationErrorMsg["MinTime"] = "MinTime";
        DateTimeValidationErrorMsg["MaxTime"] = "MaxTime";
        DateTimeValidationErrorMsg["BetweenTime"] = "BetweenTime";
        DateTimeValidationErrorMsg["ExactTime"] = "ExactTime";
        DateTimeValidationErrorMsg["InvalidTime"] = "InvalidTime";
        DateTimeValidationErrorMsg["RequiredDateTime"] = "RequiredDateTime";
        DateTimeValidationErrorMsg["MinDateTime"] = "MinDateTime";
        DateTimeValidationErrorMsg["MaxDateTime"] = "MaxDateTime";
        DateTimeValidationErrorMsg["ExactDateTime"] = "ExactDateTime";
        DateTimeValidationErrorMsg["BetweenDateTime"] = "BetweenDateTime";
        return DateTimeValidationErrorMsg;
    }({});
    let $49ee7ee62244437f$export$c8f7f52f47b04c93 = function(ChoiceValidationErrorMsg) {
        ChoiceValidationErrorMsg["MinChoices"] = "MinChoices";
        ChoiceValidationErrorMsg["MaxChoices"] = "MaxChoices";
        ChoiceValidationErrorMsg["ReqChoice"] = "ReqChoice";
        ChoiceValidationErrorMsg["ExactChoices"] = "ExactChoices";
        ChoiceValidationErrorMsg["BetweenChoices"] = "BetweenChoices";
        return ChoiceValidationErrorMsg;
    }({});
    let $49ee7ee62244437f$export$ef5d979bfd00ccfc = function(UserPickerValidationErrorMsg) {
        UserPickerValidationErrorMsg["MinChoices"] = "UpMinChoices";
        UserPickerValidationErrorMsg["MaxChoices"] = "UpMaxChoices";
        UserPickerValidationErrorMsg["ExactChoices"] = "UpExactChoices";
        UserPickerValidationErrorMsg["BetweenChoices"] = "UpBetweenChoices";
        return UserPickerValidationErrorMsg;
    }({});
    const $49ee7ee62244437f$export$40d5a30c6400de7b = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$49ee7ee62244437f$export$918e8d988e50ccc0.Required]: {
            id: 'form-system.validationErrorMsg.Required',
            defaultMessage: 'This field is required.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.MinChars]: {
            id: 'form-system.validationErrorMsg.text.MinChars',
            defaultMessage: 'Must be more than {mnc, plural, one {# character} other {# characters}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.MinWords]: {
            id: 'form-system.validationErrorMsg.text.MinWords',
            defaultMessage: 'Must be more than {mnw, plural, one {# word} other {# words}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.MaxChars]: {
            id: 'form-system.validationErrorMsg.text.MaxChars',
            defaultMessage: 'Must be less than {mxc, plural, one {# character} other {# characters}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.MaxWords]: {
            id: 'form-system.validationErrorMsg.text.MaxWords',
            defaultMessage: 'Must be less than {mxw, plural, one {# word} other {# words}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.BetweenChars]: {
            id: 'form-system.validationErrorMsg.text.BetweenChars',
            defaultMessage: 'Must be between {mnc} and {mxc, plural, one {# character} other {# characters}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.ExactChars]: {
            id: 'form-system.validationErrorMsg.text.ExactChars',
            defaultMessage: 'Must be exactly {mnc, plural, one {# character} other {# characters}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.BetweenWords]: {
            id: 'form-system.validationErrorMsg.text.BetweenWords',
            defaultMessage: 'Must be between {mnw} and {mxw, plural, one {# word} other {# words}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.ExactWords]: {
            id: 'form-system.validationErrorMsg.text.ExactWords',
            defaultMessage: 'Must be exactly {mnw, plural, one {# word} other {# words}}.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.RegexCustomMsg]: {
            id: 'form-system.validationErrorMsg.text.RegexCustomMsg',
            defaultMessage: '{message}'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.RegexDefaultMsg]: {
            id: 'form-system.validationErrorMsg.text.RegexDefaultMsg',
            defaultMessage: 'Response does not match required pattern.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.RegexInvalidMsg]: {
            id: 'form-system.validationErrorMsg.text.RegexInvalidMsg',
            defaultMessage: 'The regex pattern on this field is invalid. Answer unable to be validated.'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.InvalidEmail]: {
            id: 'form-system.validationErrorMsg.text.InvalidEmail',
            defaultMessage: 'Must be an email address'
        },
        [$49ee7ee62244437f$export$66fb68ff0427090f.InvalidUrl]: {
            id: 'form-system.validationErrorMsg.text.InvalidUrl',
            defaultMessage: 'Must be a valid URL e.g. https://www.google.com/images'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.InvalidNum]: {
            id: 'form-system.validationErrorMsg.number.InvalidNum',
            defaultMessage: 'Please enter a valid number.'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.WholeNum]: {
            id: 'form-system.validationErrorMsg.number.WholeNum',
            defaultMessage: 'Must be a whole number.'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.MinNum]: {
            id: 'form-system.validationErrorMsg.number.MinNum',
            defaultMessage: 'Must be more than or equal to {mnn}.'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.MaxNum]: {
            id: 'form-system.validationErrorMsg.number.MaxNum',
            defaultMessage: 'Must be less than or equal to {mxn}.'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.BetweenNum]: {
            id: 'form-system.validationErrorMsg.number.BetweenNum',
            defaultMessage: 'Must be between {mnn} and {mxn}.'
        },
        [$49ee7ee62244437f$export$29e4a6c62db1e0ba.ExactNum]: {
            id: 'form-system.validationErrorMsg.number.ExactNum',
            defaultMessage: 'Must be exactly {mnn}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.RequiredDateTime]: {
            id: 'form-system.validationErrorMsg.datetime.RequiredDateTime',
            defaultMessage: 'This field is required. Please specify a date and time.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.ExactDateTime]: {
            id: 'form-system.validationErrorMsg.datetime.ExactDateTime',
            defaultMessage: 'The date and time must be exactly the {mnd, date, medium} at {mnt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.BetweenDateTime]: {
            id: 'form-system.validationErrorMsg.datetime.BetweenDateTime',
            defaultMessage: 'The date and time must be between the {mnd, date, medium} at {mnt, time, short} and the {mxd, date, medium} at {mxt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MinDateTime]: {
            id: 'form-system.validationErrorMsg.datetime.MinDateTime',
            defaultMessage: 'The date and time must be on or after the {mnd, date, medium} at {mnt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MaxDateTime]: {
            id: 'form-system.validationErrorMsg.datetime.MaxDateTime',
            defaultMessage: 'The date and time must be on or before the {mxd, date, medium} at {mxt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MinDate]: {
            id: 'form-system.validationErrorMsg.datetime.MinDate',
            defaultMessage: 'The date must be on or after {mnd, date, medium}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MaxDate]: {
            id: 'form-system.validationErrorMsg.datetime.MaxDate',
            defaultMessage: 'The date must be on or before {mxd, date, medium}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.BetweenDate]: {
            id: 'form-system.validationErrorMsg.datetime.BetweenDate',
            defaultMessage: 'The date must be between {mnd, date, medium} and {mxd, date, medium}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.ExactDate]: {
            id: 'form-system.validationErrorMsg.datetime.ExactDate',
            defaultMessage: 'The date must be exactly {mnd, date, medium}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MinTime]: {
            id: 'form-system.validationErrorMsg.datetime.MinTime',
            defaultMessage: 'The time must be at or after {mnt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.MaxTime]: {
            id: 'form-system.validationErrorMsg.datetime.MaxTime',
            defaultMessage: 'The time must be at or before {mxt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.BetweenTime]: {
            id: 'form-system.validationErrorMsg.datetime.BetweenTime',
            defaultMessage: 'The time must be between {mnt, time, short} and {mxt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.ExactTime]: {
            id: 'form-system.validationErrorMsg.datetime.ExactTime',
            defaultMessage: 'The time must be exactly {mnt, time, short}.'
        },
        [$49ee7ee62244437f$export$ae02ba97d418070.InvalidTime]: {
            id: 'form-system.validationErrorMsg.datetime.InvalidTime',
            defaultMessage: 'The time is invalid.'
        },
        [$49ee7ee62244437f$export$c8f7f52f47b04c93.ExactChoices]: {
            id: 'form-system.validationErrorMsg.choice.ExactChoices',
            defaultMessage: 'Choose exactly {mns}.'
        },
        [$49ee7ee62244437f$export$c8f7f52f47b04c93.BetweenChoices]: {
            id: 'form-system.validationErrorMsg.choice.BetweenChoices',
            defaultMessage: 'Choose between {mns} and {mxs}.'
        },
        [$49ee7ee62244437f$export$c8f7f52f47b04c93.MinChoices]: {
            id: 'form-system.validationErrorMsg.choice.MinChoices',
            defaultMessage: 'Choose at least {mns}.'
        },
        [$49ee7ee62244437f$export$c8f7f52f47b04c93.MaxChoices]: {
            id: 'form-system.validationErrorMsg.choice.MaxChoices',
            defaultMessage: 'Choose no more than {mxs}.'
        },
        [$49ee7ee62244437f$export$c8f7f52f47b04c93.ReqChoice]: {
            id: 'form-system.validationErrorMsg.choice.ReqChoice',
            defaultMessage: "The \u2018{label}\u2019 choice is required."
        },
        [$49ee7ee62244437f$export$ef5d979bfd00ccfc.ExactChoices]: {
            id: 'form-system.validationErrorMsg.userpicker.ExactChoices',
            defaultMessage: 'Choose exactly {mns, plural, one {# user} other {# users}}.'
        },
        [$49ee7ee62244437f$export$ef5d979bfd00ccfc.BetweenChoices]: {
            id: 'form-system.validationErrorMsg.userpicker.BetweenChoices',
            defaultMessage: 'Choose between {mns} and {mxs, plural, one {# user} other{# users}}.'
        },
        [$49ee7ee62244437f$export$ef5d979bfd00ccfc.MinChoices]: {
            id: 'form-system.validationErrorMsg.userpicker.MinChoices',
            defaultMessage: 'Choose at least {mns, plural, one {# user} other {# users}}.'
        },
        [$49ee7ee62244437f$export$ef5d979bfd00ccfc.MaxChoices]: {
            id: 'form-system.validationErrorMsg.userpicker.MaxChoices',
            defaultMessage: 'Choose no more than {mxs, plural, one {# user} other {# users}}.'
        }
    });
});
parcelRegister("51KJm", function(module, exports) {
    $parcel$export(module.exports, "wordCounter", ()=>$3a914b7ad8a24eb7$export$85cf3a3ba4c43fc4);
    const $3a914b7ad8a24eb7$export$85cf3a3ba4c43fc4 = (text)=>{
        const filteredWords = text.trim().replace(/['";:,.?¿\-!¡]+/g, '');
        return filteredWords ? (filteredWords.match(/\S+/g) || []).length : 0;
    };
});
parcelRegister("iuiC7", function(module, exports) {
    $parcel$export(module.exports, "copyToClipboard", ()=>$d75977a50346d087$export$2cdf1b96a9f86d16);
    const $d75977a50346d087$export$2cdf1b96a9f86d16 = (textToCopy)=>{
        const el = document.createElement('textarea');
        el.value = textToCopy;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };
});
parcelRegister("2ygsB", function(module, exports) {
    $parcel$export(module.exports, "getFormValidationResultMessage", ()=>$1dbb8668e157aa4e$export$c339ebc2b4e9dd65);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7nnPp;
    var $3KrJl;
    var $9tz67;
    var $36aUB;
    var $3tHng;
    const $1dbb8668e157aa4e$export$c339ebc2b4e9dd65 = (apiError, project, formDetails, intl, push, showFlag, createAnalyticsEvent, userIsProjectAdmin, showFormLoadingFailedFlag = true)=>{
        if ($1dbb8668e157aa4e$var$isUnknownApiError(apiError) && apiError.status === 409) {
            const message = (0, (0, parcelRequire("36aUB")).getMessage)(apiError.responseJson, formDetails, project.key, (0, (0, parcelRequire("9tz67")).projectTypeLowerCase)(project), project.simplified, formDetails.projectFormId, intl, push, createAnalyticsEvent, userIsProjectAdmin);
            if (message) return message;
        }
        if (showFormLoadingFailedFlag) showFlag({
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: "error",
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
            }),
            id: 'form-load-error',
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("3tHng")).messages).formLoadingFailedFlagTitle),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("3tHng")).messages).formLoadingFailedFlagDescription)
        });
        return undefined;
    };
    const $1dbb8668e157aa4e$var$isUnknownApiError = (apiError)=>apiError.error === (0, (0, parcelRequire("3KrJl")).ApiErrorType).unknown;
});
parcelRegister("9tz67", function(module, exports) {
    $parcel$export(module.exports, "projectTypeLowerCase", ()=>$6e620c255f0d1482$export$9712b2407fd467fd);
    const $6e620c255f0d1482$export$9712b2407fd467fd = (project)=>project.projectType.toLowerCase();
});
parcelRegister("36aUB", function(module, exports) {
    $parcel$export(module.exports, "getMessage", ()=>$241a658b2e4c09a8$export$2e51780da3c3a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $h8yj2;
    var $jEJ4d;
    var $erWXD;
    var $7avZ4;
    const $241a658b2e4c09a8$export$2e51780da3c3a61 = (formValidationResult, formDetails, projectKey, projectType, isSimplifiedProject, templateFormId, intl, push, createAnalyticsEvent, userIsProjectAdmin = false)=>{
        let title;
        let description;
        let analyticsReason;
        const actions = [];
        if (userIsProjectAdmin) actions.push({
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7avZ4")).messages).conflictEditFormLinkLabelForProjectAdmin),
            onClick: ()=>push((0, (0, parcelRequire("jEJ4d")).formBuilderUrl)(projectKey, projectType, isSimplifiedProject, templateFormId))
        });
        if (formValidationResult.missing.length > 0) {
            var _formDetails$requestT, _formDetails$requestT2;
            const field = formValidationResult.missing[0];
            title = intl.formatMessage((0, (0, parcelRequire("7avZ4")).messages).conflictMissingTitle);
            description = intl.formatMessage(userIsProjectAdmin ? (0, (0, parcelRequire("7avZ4")).messages).conflictMissingDescriptionForProjectAdmin : (0, (0, parcelRequire("7avZ4")).messages).conflictMissingDescriptionForNonProjectAdmin, {
                jiraFieldName: field.jiraFieldName,
                typeName: (_formDetails$requestT = (_formDetails$requestT2 = formDetails.requestType) === null || _formDetails$requestT2 === void 0 ? void 0 : _formDetails$requestT2.name) !== null && _formDetails$requestT !== void 0 ? _formDetails$requestT : formDetails.issueType.name
            });
            analyticsReason = 'missing';
        } else if (formValidationResult.isConditionallyShown.length > 0) {
            var _formDetails$requestT3, _formDetails$requestT4;
            const field = formValidationResult.isConditionallyShown[0];
            title = intl.formatMessage((0, (0, parcelRequire("7avZ4")).messages).conflictIsConditionalTitle);
            description = intl.formatMessage(userIsProjectAdmin ? (0, (0, parcelRequire("7avZ4")).messages).conflictIsConditionalDescriptionForProjectAdmin : (0, (0, parcelRequire("7avZ4")).messages).conflictIsConditionalDescriptionForNonProjectAdmin, {
                formFieldName: field.proFormaQuestionLabel,
                jiraFieldName: field.jiraFieldName,
                typeName: (_formDetails$requestT3 = (_formDetails$requestT4 = formDetails.requestType) === null || _formDetails$requestT4 === void 0 ? void 0 : _formDetails$requestT4.name) !== null && _formDetails$requestT3 !== void 0 ? _formDetails$requestT3 : formDetails.issueType.name
            });
            analyticsReason = 'isConditionallyShown';
            if (userIsProjectAdmin) {
                let href;
                if (formValidationResult.requestTypeId !== undefined) href = (0, (0, parcelRequire("jEJ4d")).requestTypeConfigurationUrl)(projectKey, projectType, isSimplifiedProject, formValidationResult.requestTypeId);
                else if (formValidationResult.issueTypeId !== undefined) href = (0, (0, parcelRequire("jEJ4d")).issueTypeConfigurationUrl)(projectKey, projectType, isSimplifiedProject, formValidationResult.issueTypeId);
                actions.unshift({
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7avZ4")).messages).conflictIsConditionalActionForProjectAdmin),
                    href: href
                });
            }
        } else if (formValidationResult.needToBeMandatory.length > 0) {
            var _formDetails$requestT5, _formDetails$requestT6;
            const field = formValidationResult.needToBeMandatory[0];
            title = intl.formatMessage((0, (0, parcelRequire("7avZ4")).messages).conflictNeedsToBeMandatoryTitle);
            description = intl.formatMessage(userIsProjectAdmin ? (0, (0, parcelRequire("7avZ4")).messages).conflictNeedsToBeMandatoryDescriptionForProjectAdmin : (0, (0, parcelRequire("7avZ4")).messages).conflictNeedsToBeMandatoryDescriptionForNonProjectAdmin, {
                formFieldName: field.proFormaQuestionLabel,
                jiraFieldName: field.jiraFieldName,
                typeName: (_formDetails$requestT5 = (_formDetails$requestT6 = formDetails.requestType) === null || _formDetails$requestT6 === void 0 ? void 0 : _formDetails$requestT6.name) !== null && _formDetails$requestT5 !== void 0 ? _formDetails$requestT5 : formDetails.issueType.name
            });
            analyticsReason = 'needToBeMandatory';
        }
        if (title && description) {
            (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM_VALIDATION} ${(0, (0, parcelRequire("erWXD")).Action).STOPPED}`, {
                stopReason: analyticsReason
            });
            return {
                title: title,
                description: description,
                actions: actions
            };
        }
        return undefined;
    };
});
parcelRegister("jEJ4d", function(module, exports) {
    $parcel$export(module.exports, "formBuilderUrl", ()=>$e4f4b61a8e5cbfd2$export$ad30c51ac4428192);
    $parcel$export(module.exports, "issueTypeConfigurationUrl", ()=>$e4f4b61a8e5cbfd2$export$4df82e888846b540);
    $parcel$export(module.exports, "requestTypeConfigurationUrl", ()=>$e4f4b61a8e5cbfd2$export$3f95454ff3705b58);
    const $e4f4b61a8e5cbfd2$var$productSegmentsFn = (projectType, isSimplifiedProject)=>{
        return projectType === 'business' ? 'core' : projectType === 'service_desk' ? 'servicedesk' : isSimplifiedProject ? 'software' : 'software/c';
    };
    const $e4f4b61a8e5cbfd2$export$ad30c51ac4428192 = (projectKey, projectType, isSimplifiedProject, templateFormId)=>{
        const productSegments = $e4f4b61a8e5cbfd2$var$productSegmentsFn(projectType, isSimplifiedProject);
        return `/jira/${productSegments}/projects/${projectKey}/settings/forms/form/${templateFormId}/edit`;
    };
    const $e4f4b61a8e5cbfd2$export$4df82e888846b540 = (projectKey, projectType, isSimplifiedProject, issueTypeId)=>{
        if (!isSimplifiedProject) return `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}`;
        const productSegments = $e4f4b61a8e5cbfd2$var$productSegmentsFn(projectType, isSimplifiedProject);
        return `/jira/${productSegments}/projects/${projectKey}/settings/issuetypes/${issueTypeId}`;
    };
    const $e4f4b61a8e5cbfd2$export$3f95454ff3705b58 = (projectKey, projectType, isSimplifiedProject, requestTypeId)=>{
        if (projectType !== 'service_desk' || isSimplifiedProject) throw Error(`Request type configuration does not exist for '${projectType}' ${isSimplifiedProject ? 'simplified ' : ''}projects.`);
        return `/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}`;
    };
});
parcelRegister("7avZ4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$538246ef3430e639$export$defe85febe8b728c);
    var $7VHMR;
    const $538246ef3430e639$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        conflictEditFormLinkLabelForProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-edit-form-link-label-for-project-admin',
            defaultMessage: 'Edit form',
            description: 'The Issue Forms conflict edit form link label for a project admin.'
        },
        conflictIsConditionalActionForProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-action-for-project-admin',
            defaultMessage: 'Edit request form',
            description: 'The Issue Forms conflict edit type link label for a project admin.'
        },
        conflictIsConditionalDescriptionForNonProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-non-project-admin',
            defaultMessage: "Ask your admin to move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
            description: 'The description when we need to display a conflict for a conditionally displayed required Jira field in Issue Forms.'
        },
        conflictIsConditionalDescriptionForProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-description-for-project-admin',
            defaultMessage: "Move the <strong>{formFieldName}</strong> field out of the conditional section, or remove the \u2018required\u2019 status from its linked <strong>{jiraFieldName}</strong> Jira field on the <strong>{typeName}</strong> request form.",
            description: 'The description when we need to display a conflict for a conditionally displayed required Jira field in Issue Forms.'
        },
        conflictIsConditionalTitle: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-is-conditional-title',
            defaultMessage: "\u2018Required\u2019 field in conditional section",
            description: 'The title when we need to display a conflict for a conditionally displayed required Jira field in Issue Forms.'
        },
        conflictMissingDescriptionForNonProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-non-project-admin',
            defaultMessage: 'Ask your admin to link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
            description: 'The description when we need to display a conflict for a missing required Jira field in Issue Forms.'
        },
        conflictMissingDescriptionForProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-description-for-project-admin',
            defaultMessage: 'Link a field in this form with the <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form.',
            description: 'The description when we need to display a conflict for a missing required Jira field in Issue Forms.'
        },
        conflictMissingTitle: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-missing-title',
            defaultMessage: "\u2018Required\u2019 field is not linked",
            description: 'The title when we need to display a conflict for a missing required Jira field in Issue Forms.'
        },
        conflictNeedsToBeMandatoryDescriptionForNonProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-non-project-admin',
            defaultMessage: "Ask your admin to mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form. ",
            description: 'The description when we need to display a conflict for a required Jira field that needs to be mandatory in Issue Forms.'
        },
        conflictNeedsToBeMandatoryDescriptionForProjectAdmin: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-description-for-project-admin',
            defaultMessage: "Mark the <strong>{formFieldName}</strong> field in this form as \u2018required\u2019, to match its linked <strong>{jiraFieldName}</strong> Jira field in the <strong>{typeName}</strong> request form. ",
            description: 'The description when we need to display a conflict for a required Jira field that needs to be mandatory in Issue Forms.'
        },
        conflictNeedsToBeMandatoryTitle: {
            id: 'proforma-jira-issue-forms.common.utils.form-validation-result-message.conflict-needs-to-be-mandatory-title',
            defaultMessage: "\u2018Required\u2019 field does not match",
            description: 'The title when we need to display a conflict for a required Jira field that needs to be mandatory in Issue Forms.'
        }
    });
});
parcelRegister("3tHng", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2885b9bfff98b802$export$defe85febe8b728c);
    var $7VHMR;
    const $2885b9bfff98b802$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        formLoadingFailedFlagDescription: {
            id: 'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-description',
            defaultMessage: 'Refresh the page and try again.',
            description: 'Flag description displayed when loading the form failed in ProForma Issue Forms.'
        },
        formLoadingFailedFlagTitle: {
            id: 'proforma-jira-issue-forms.common.utils.process-form-load-error.form-loading-failed-flag-title',
            defaultMessage: "We couldn\u2019t load your form",
            description: 'Flag title displayed when loading the form failed in ProForma Issue Forms.'
        }
    });
});
parcelRegister("jVT9j", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e82e1eae0a3b3945$export$defe85febe8b728c);
    var $7VHMR;
    const $e82e1eae0a3b3945$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createAnotherLabel: {
            id: 'proforma-jira-issue-forms.common.ui.footer.create-another-label',
            defaultMessage: 'Create another issue',
            description: 'The "create another" checkbox label for ProForma Issue Forms.'
        },
        createButtonLabel: {
            id: 'proforma-jira-issue-forms.common.ui.footer.create-button-label',
            defaultMessage: 'Create',
            description: 'The create button label for ProForma Issue Forms.'
        },
        failedCreatingFlagDescription: {
            id: 'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-description',
            defaultMessage: 'Please try again later.',
            description: 'Flag description displayed when the issue failed creating in ProForma Issue Forms due to an unknown error.'
        },
        failedCreatingWithSaveErrorsFlagDescription: {
            id: 'proforma-jira-issue-forms.common.ui.footer.failed-creating-with-save-errors-flag-description',
            defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
            description: 'Flag description displayed when the issue failed creating in ProForma Issue Forms due to invalid form answers.'
        },
        failedCreatingFlagTitle: {
            id: 'proforma-jira-issue-forms.common.ui.footer.failed-creating-flag-title',
            defaultMessage: "We couldn\u2019t create your issue.",
            description: 'Flag title displayed when the issue failed creating in ProForma Issue Forms.'
        },
        successfullyCreatedFlagCopyLinkAction: {
            id: 'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-copy-link-action',
            defaultMessage: 'Copy link',
            description: 'Flag copy link action displayed when the issue is successfully created in ProForma Issue Forms.'
        },
        successfullyCreatedFlagTitle: {
            id: 'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-title',
            defaultMessage: 'You\u2019ve created "{issueKey}" issue.',
            description: 'Flag title displayed when the issue is successfully created in ProForma Issue Forms.'
        },
        successfullyCreatedFlagViewIssueAction: {
            id: 'proforma-jira-issue-forms.common.ui.footer.successfully-created-flag-view-issue-action',
            defaultMessage: 'View issue',
            description: 'Flag view issue action displayed when the issue is successfully created in ProForma Issue Forms.'
        }
    });
});
parcelRegister("hRCZb", function(module, exports) {
    $parcel$export(module.exports, "IssueFormsFooter", ()=>$d015a0a8c6b4298a$export$15ee8075cdb749dd);
    $parcel$export(module.exports, "IssueFormsFooterLeftWrapper", ()=>$d015a0a8c6b4298a$export$d01d1ff90410d087);
    $parcel$export(module.exports, "IssueFormsFooterWrapper", ()=>$d015a0a8c6b4298a$export$69639aef55e118a5);
    var $dAHxw = parcelRequire("dAHxw");
    const $d015a0a8c6b4298a$export$15ee8075cdb749dd = (0, $dAHxw.default).div({
        display: 'flex',
        flexGrow: 1,
        maxWidth: '800px',
        marginLeft: "var(--ds-space-200, 16px)",
        marginRight: "var(--ds-space-200, 16px)"
    });
    const $d015a0a8c6b4298a$export$d01d1ff90410d087 = (0, $dAHxw.default).div({
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        marginRight: "var(--ds-space-200, 16px)"
    });
    const $d015a0a8c6b4298a$export$69639aef55e118a5 = (0, $dAHxw.default).div({
        borderTop: `1px solid ${"var(--ds-border, #dfe1e5)"}`,
        display: 'flex',
        flex: 'none',
        justifyContent: 'center',
        marginBottom: "var(--ds-space-250, 20px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });
});
parcelRegister("gBWfu", function(module, exports) {
    $parcel$export(module.exports, "FormValidationMessage", ()=>$c17d4911492fb94d$export$cf8374403d667bd5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lVJAU;
    var $92Z2l;
    var $ctz0s;
    const $c17d4911492fb94d$export$cf8374403d667bd5 = ({ formValidationResultMessage: formValidationResultMessage })=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            title: formValidationResultMessage.title,
            appearance: "error",
            actions: formValidationResultMessage.actions.map((action)=>{
                var _action$onClick;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                    onClick: (_action$onClick = action.onClick) !== null && _action$onClick !== void 0 ? _action$onClick : ()=>action.href && push(action.href)
                }, action.content);
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formValidationResultMessage.description));
    };
});
parcelRegister("ctz0s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e844da07d79ea04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    const $2e844da07d79ea04$var$SectionMessageAction = (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
        return onClick || href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
    $2e844da07d79ea04$var$SectionMessageAction.displayName = 'SectionMessageAction';
    var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;
});
parcelRegister("lzGq6", function(module, exports) {
    $parcel$export(module.exports, "FormWithName", ()=>$fb4dc5969c024b1e$export$5e98082f9fd9b35a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8iale;
    var $99yBG;
    const $fb4dc5969c024b1e$export$5e98082f9fd9b35a = ({ formStore: formStore })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "proforma-jira-issue-forms.ui.issue-forms.render-form"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99yBG")).FormNameWrapper), null, formStore.formName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8iale")).RenderForm), {
            formStore: formStore,
            displayMode: (0, (0, parcelRequire("8iale")).DisplayMode).Edit
        }));
});
parcelRegister("8iale", function(module, exports) {
    $parcel$export(module.exports, "DisplayMode", ()=>$609806bf29c81d8d$export$4b7264771109adb6);
    $parcel$export(module.exports, "RenderForm", ()=>$609806bf29c81d8d$export$9c83347a04dcbf4e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $ajpes = parcelRequire("ajpes");
    var $alnGD = parcelRequire("alnGD");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $ousew;
    var $koVbs;
    var $7cFR3;
    var $8dO33;
    var $f5oqj;
    var $agcXw;
    var $erWXD;
    var $ce4pa;
    var $dlLGv;
    var $iu3cq;
    var $c75hs;
    var $dwM46;
    var $31xp0;
    var $a9AOh;
    var $8iiJB;
    let $609806bf29c81d8d$export$4b7264771109adb6 = function(DisplayMode) {
        DisplayMode["View"] = "view";
        DisplayMode["Edit"] = "edit";
        DisplayMode["Preview"] = "preview";
        DisplayMode["Translate"] = "translate";
        return DisplayMode;
    }({});
    const $609806bf29c81d8d$var$environment = window.location.hostname === 'localhost' ? 'staging' : undefined;
    const $609806bf29c81d8d$var$smartCardClient = new (0, (0, parcelRequire("7cFR3")).default)($609806bf29c81d8d$var$environment);
    const $609806bf29c81d8d$var$formExtensionFn = (intl, formStoreRef, displayModeRef, blockFormSubmission, linkedFieldNames, QuestionRenderer, questionTypeRendererMap)=>{
        return (ext)=>{
            const formStore = formStoreRef.current;
            if (ext.extensionKey === 'question') {
                var _ext$parameters, _ref, _ref2, _formStore$translated;
                const questionId = (_ext$parameters = ext.parameters) === null || _ext$parameters === void 0 ? void 0 : _ext$parameters.id;
                const questionStore = questionId !== undefined && formStore.questions.find((question)=>question.id === questionId);
                if (!questionStore) {
                    console.error(`Could not find the question store with ID ${questionId}:`, ext);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
                }
                const displayLocale = (_ref = (_ref2 = (_formStore$translated = formStore.translatedLocale) !== null && _formStore$translated !== void 0 ? _formStore$translated : formStore.primaryLocale) !== null && _ref2 !== void 0 ? _ref2 : formStore.language) !== null && _ref !== void 0 ? _ref : intl.locale;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlLGv")).PackageIntlProvider), {
                    locale: displayLocale
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a9AOh")).RenderQuestion), {
                    questionStore: questionStore,
                    displayMode: displayModeRef.current,
                    formStore: formStore,
                    blockFormSubmission: blockFormSubmission,
                    linkedFieldNames: linkedFieldNames,
                    QuestionRenderer: QuestionRenderer,
                    questionTypeRendererMap: questionTypeRendererMap
                }));
            }
            if (ext.extensionKey === 'html') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dwM46")).HtmlExtension), {
                extensionId: ext.parameters.id,
                htmlContent: ext.parameters.htmlContent || ''
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        };
    };
    const $609806bf29c81d8d$export$fc6800ebf988f90 = (linkedSummaryQuestionId, formLayout)=>{
        var _formLayout$some;
        return (_formLayout$some = formLayout === null || formLayout === void 0 ? void 0 : formLayout.some((layout)=>layout.content.some((content)=>{
                var _content$attrs, _content$attrs$parame;
                return content.type === 'extension' && ((_content$attrs = content.attrs) === null || _content$attrs === void 0 ? void 0 : (_content$attrs$parame = _content$attrs.parameters) === null || _content$attrs$parame === void 0 ? void 0 : _content$attrs$parame.id) === linkedSummaryQuestionId;
            }))) !== null && _formLayout$some !== void 0 ? _formLayout$some : false;
    };
    const $609806bf29c81d8d$export$9c83347a04dcbf4e = (0, (0, parcelRequire("dlLGv")).withPackageIntlProvider)((0, $jJXgM.observer)(({ formStore: formStore, showHiddenSections: showHiddenSections, displayMode: displayMode, backgroundColor: backgroundColor, ufoExperience: ufoExperience, blockFormSubmission: blockFormSubmission, linkedFieldNames: linkedFieldNames, QuestionRenderer: QuestionRenderer, questionTypeRendererMap: questionTypeRendererMap, nodeComponents: nodeComponents })=>{
        var _formStore$layout, _ref3, _ref4, _formStore$translated2, _formStore$language;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const formStoreRef = (0, $5uXOq.useRef)(formStore);
        if (formStoreRef.current !== formStore) formStoreRef.current = formStore;
        const displayModeRef = (0, $5uXOq.useRef)(displayMode);
        if (displayModeRef.current !== displayMode) displayModeRef.current = displayMode;
        const { mediaReadTokenRefresh: mediaReadTokenRefresh } = (0, (0, parcelRequire("iu3cq")).useMediaContext)();
        const [attachmentIdsCache, setAttachmentIdsCache] = (0, $5uXOq.useState)(new Set());
        (0, $5uXOq.useEffect)(()=>{
            let mediaTokenRefreshTimeoutId;
            if (!(0, ($parcel$interopDefault($ajpes)))(attachmentIdsCache, formStore.attachmentIds)) {
                setAttachmentIdsCache(new Set([
                    ...formStore.attachmentIds
                ]));
                if (formStore.attachmentIds.size > 0 && mediaReadTokenRefresh) mediaTokenRefreshTimeoutId = setTimeout(()=>mediaReadTokenRefresh(), 1000);
            }
            return ()=>{
                if (mediaTokenRefreshTimeoutId) clearInterval(mediaTokenRefreshTimeoutId);
            };
        }, [
            formStore.attachmentIds,
            mediaReadTokenRefresh
        ]);
        (0, (0, parcelRequire("c75hs")).useEmitAttachmentMetrics)(formStore, displayMode !== $609806bf29c81d8d$export$4b7264771109adb6.Edit);
        (0, $5uXOq.useEffect)(()=>{
            blockFormSubmission && blockFormSubmission(formStore.isUploadingMedia);
        }, [
            blockFormSubmission,
            formStore.isUploadingMedia
        ]);
        const formSections = (_formStore$layout = formStore.layout) === null || _formStore$layout === void 0 ? void 0 : _formStore$layout.map((sectionLayout, index)=>{
            const sectionId = index.toString();
            if (showHiddenSections === undefined && !formStore.visibleSections.includes(sectionId)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
            const formSection = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
                key: sectionId,
                document: (0, $alnGD.toJS)(sectionLayout),
                extensionHandlers: {
                    'com.thinktilt.proforma': $609806bf29c81d8d$var$formExtensionFn(intl, formStoreRef, displayModeRef, blockFormSubmission, linkedFieldNames, QuestionRenderer, questionTypeRendererMap)
                },
                eventHandlers: (0, (0, parcelRequire("31xp0")).rendererEventHandlers),
                nodeComponents: nodeComponents,
                adfStage: "stage0"
            });
            if (showHiddenSections && !formStore.visibleSections.includes(sectionId)) return (0, ($parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionWrapperStyles, {
                key: sectionId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, formSection), (0, ($parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionOverlayStyles, {
                hiddenSectionTheme: showHiddenSections
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionMessageStyles, {
                hiddenSectionTheme: showHiddenSections
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8iiJB")).IntlViewFormMessages)[(0, (0, parcelRequire("8iiJB")).ViewFormMessage).HiddenSection]))));
            return formSection;
        });
        const linkedSummaryQuestionId = formStore === null || formStore === void 0 ? void 0 : formStore.questions.find((question)=>question.formQuestion.jiraField === 'summary');
        const displayLocale = (_ref3 = (_ref4 = (_formStore$translated2 = formStore.translatedLocale) !== null && _formStore$translated2 !== void 0 ? _formStore$translated2 : formStore.primaryLocale) !== null && _ref4 !== void 0 ? _ref4 : formStore.language) !== null && _ref3 !== void 0 ? _ref3 : intl.locale;
        const form = (0, ($parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$FormContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$FormStyles, {
            backgroundColor: backgroundColor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), {
            client: $609806bf29c81d8d$var$smartCardClient
        }, formSections)), !!ufoExperience && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ce4pa")).ExperienceSuccess), {
            experience: ufoExperience
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agcXw")).FireUIAnalytics), {
            actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).FORM,
            action: (0, (0, parcelRequire("erWXD")).Action).VIEWED,
            actionSubjectId: "proformaRenderForm",
            attributes: {
                ...formStore.analyticsAttributes,
                hasLinkedSummary: !!linkedSummaryQuestionId,
                summaryOnTopLevel: linkedSummaryQuestionId ? $609806bf29c81d8d$export$fc6800ebf988f90(linkedSummaryQuestionId.id, formStore === null || formStore === void 0 ? void 0 : formStore.layout) : false,
                translationDetails: {
                    legacyLanguage: (_formStore$language = formStore.language) === null || _formStore$language === void 0 ? void 0 : _formStore$language.replace('_', '-'),
                    localeMatched: displayLocale === intl.locale,
                    primaryLocale: formStore.primaryLocale,
                    translated: formStore.translatedLocale !== formStore.primaryLocale,
                    translatedLocale: formStore.translatedLocale,
                    translationsApplied: formStore.translatedLocale !== undefined,
                    userLocale: intl.locale
                }
            }
        }));
        if (displayLocale !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlLGv")).PackageIntlProvider), {
            locale: displayLocale
        }, form);
        return form;
    }));
    const $609806bf29c81d8d$var$FormContainer = (0, $dAHxw.default).div({
        height: 'auto',
        overflow: 'visible'
    });
    const $609806bf29c81d8d$var$FormStyles = (0, $dAHxw.default).div(({ backgroundColor: backgroundColor })=>({
            backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "var(--ds-surface, white)",
            padding: "var(--ds-space-100, 8px)",
            '& .ak-renderer-extension-overflow-container': {
                overflow: 'unset !important'
            },
            '& .pm-table-container': {
                zIndex: 'auto !important'
            }
        }));
    const $609806bf29c81d8d$var$SectionWrapperStyles = (0, $dAHxw.default).div({
        position: 'relative',
        padding: "var(--ds-space-050, 4px)"
    });
    const $609806bf29c81d8d$var$SectionOverlayStyles = (0, $dAHxw.default).div(({ hiddenSectionTheme: hiddenSectionTheme })=>({
            height: '100%',
            width: '100%',
            backgroundColor: hiddenSectionTheme === 'dark' ? "var(--ds-background-disabled, rgba(108, 121, 143, 0.1))" : undefined,
            top: 0,
            left: 0,
            position: 'absolute',
            borderRadius: "var(--ds-border-radius, 3px)",
            textAlign: 'center',
            pointerEvents: 'none'
        }));
    const $609806bf29c81d8d$var$SectionMessageStyles = (0, $dAHxw.default).h4(({ hiddenSectionTheme: hiddenSectionTheme })=>({
            padding: "var(--ds-space-100, 8px)",
            color: hiddenSectionTheme === 'light' ? "var(--ds-text, #091E42)" : "var(--ds-text, #172b4d)",
            backgroundColor: hiddenSectionTheme === 'light' ? "var(--ds-background-accent-gray-subtler, #DFE1E6)" : "var(--ds-surface, white)",
            display: 'inline-block',
            position: 'relative',
            top: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius-200, 8px)"
        }));
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`);
            this.kind = kind;
            this.hostname = hostname;
            this.message = message;
            this.type = type;
            this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("f5oqj", function(module, exports) {
    $parcel$export(module.exports, "defaultNodeComponents", ()=>$3de1eca32602d427$export$ee31295d51950741);
    $parcel$export(module.exports, "default", ()=>$3de1eca32602d427$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $kOFhM;
    var $dGzaM;
    var $9S8fM;
    var $gmhCD = parcelRequire("gmhCD");
    var $9Iju4;
    var $fIJEx;
    var $iiXGq;
    var $4ceoy;
    var $2DpUZ;
    var $iN9lO;
    var $4NUlu;
    var $fc6h8;
    var $ap7h6;
    var $gE8f9;
    var $kFiBa;
    var $VSDnB;
    var $4zXba;
    var $iHYdz;
    var $dWAZk = parcelRequire("dWAZk");
    var $1PVpv = parcelRequire("1PVpv");
    var $bXrHm = parcelRequire("bXrHm");
    var $9gOVJ;
    var $12yAL;
    var $OxITw;
    var $3lRy2;
    var $gkwXh;
    var $knXBU;
    var $TM1uy;
    var $4BsEy;
    var $jUVor;
    var $fCNtA;
    var $1pTqN;
    var $4YrGg;
    var $3kKuL;
    var $K5Jsy;
    var $TPpI8;
    var $dyURG;
    var $8QpSo;
    var $8Eu7T;
    var $1urn6;
    var $gJX6d;
    var $kgV4b;
    function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
    const $3de1eca32602d427$export$1b622068be977101 = 3000;
    const $3de1eca32602d427$var$packageName = "platform-pkg";
    const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
    const $3de1eca32602d427$var$setAsQueryContainerStyles = {
        name: "isqlwl",
        styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
    };
    const $3de1eca32602d427$export$ee31295d51950741 = (0, (0, parcelRequire("gJX6d")).nodeToReact);
    class $3de1eca32602d427$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props);
            this.renderedMeasurementDistortedDurationMonitor = (0, (0, parcelRequire("ap7h6")).getDistortedDurationMonitor)();
            this.createRendererContext = (0, (0, parcelRequire("8QpSo")).default)((featureFlags, isTopLevelRenderer)=>{
                const normalizedFeatureFlags = (0, (0, parcelRequire("4zXba")).normalizeFeatureFlags)(featureFlags);
                return {
                    featureFlags: normalizedFeatureFlags,
                    isTopLevelRenderer: isTopLevelRenderer === undefined
                };
            });
            this.fireAnalyticsEvent = (event)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) {
                    const channel = (0, $dWAZk.FabricChannel).editor;
                    createAnalyticsEvent(event).fire(channel);
                }
            };
            this.getSchema = (0, (0, parcelRequire("8QpSo")).default)((schema, adfStage)=>{
                if (schema) return schema;
                return (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(adfStage);
            });
            this.onMouseDownEditView = ()=>{
                const windowSelection = window.getSelection();
                this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
            };
            this.handleMouseTripleClickInTables = (event)=>{
                if ((0, (0, parcelRequire("gE8f9")).browser).ios || (0, (0, parcelRequire("gE8f9")).browser).android) return;
                const badBrowser = (0, (0, parcelRequire("gE8f9")).browser).chrome || (0, (0, parcelRequire("gE8f9")).browser).safari;
                const tripleClick = event.detail >= 3;
                if (!(badBrowser && tripleClick)) return;
                const selection = window.getSelection();
                if (!selection) return;
                const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
                const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
                if (!rangeSelection) return;
                const target = event.target;
                const tableCell = target.closest('td,th');
                const clickedInCell = Boolean(tableCell);
                if (!clickedInCell) return;
                const anchorInCell = tableCell.contains(anchorNode);
                const focusInCell = tableCell.contains(focusNode);
                const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
                if (!selectionStartsOrEndsOutsideClickedCell) return;
                const elementToSelect = anchorInCell ? anchorNode.parentElement?.closest('div,p') : focusInCell ? focusNode.parentElement?.closest('div,p') : tableCell;
                if (elementToSelect) selection.selectAllChildren(elementToSelect);
            };
            this.providerFactory = props.dataProviders || new (0, (0, parcelRequire("dGzaM")).default)();
            this.serializer = new (0, (0, parcelRequire("9gOVJ")).default)(this.deriveSerializerProps(props));
            this.editorRef = props.innerRef || (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.id = (0, ($parcel$interopDefault($bXrHm)))();
            (0, (0, parcelRequire("iN9lO")).startMeasure)(`Renderer Render Time: ${this.id}`);
        }
        anchorLinkAnalytics() {
            const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
            const { disableHeadingIDs: disableHeadingIDs } = this.props;
            if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
                const anchorLinkElement = document.getElementById(hash);
                if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANCHOR_LINK,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                });
            }
        }
        componentDidMount() {
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).STARTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            });
            this.rafID = requestAnimationFrame(()=>{
                (0, (0, parcelRequire("iN9lO")).stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                    const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, (0, parcelRequire("fc6h8")).shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).RENDERED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                            duration: duration,
                            distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, (0, parcelRequire("kFiBa")).getResponseEndTime)(),
                            nodes: (0, (0, parcelRequire("kgV4b")).countNodes)(this.props.document),
                            severity: severity
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                    this.renderedMeasurementDistortedDurationMonitor.cleanup();
                    delete this.renderedMeasurementDistortedDurationMonitor;
                });
                this.anchorLinkAnalytics();
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const nextMedia = nextProps.media || {};
            const media = this.props.media || {};
            if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, (0, parcelRequire("9gOVJ")).default)(this.deriveSerializerProps(nextProps));
        }
        deriveSerializerProps(props) {
            const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
            const { annotationProvider: annotationProvider } = props;
            const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
            const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
            return {
                startPos: props.startPos,
                providers: this.providerFactory,
                eventHandlers: props.eventHandlers,
                extensionHandlers: props.extensionHandlers,
                portal: props.portal,
                objectContext: {
                    adDoc: props.document,
                    schema: props.schema,
                    ...props.rendererContext
                },
                appearance: props.appearance,
                disableHeadingIDs: props.disableHeadingIDs,
                disableActions: props.disableActions,
                allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
                allowColumnSorting: props.allowColumnSorting,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                shouldOpenMediaViewer: props.shouldOpenMediaViewer,
                allowAltTextOnImages: props.allowAltTextOnImages,
                stickyHeaders: stickyHeaders,
                allowMediaLinking: props.media && props.media.allowLinking,
                surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
                media: props.media,
                emojiResourceConfig: props.emojiResourceConfig,
                smartLinks: props.smartLinks,
                allowCopyToClipboard: props.allowCopyToClipboard,
                allowWrapCodeBlock: props.allowWrapCodeBlock,
                allowCustomPanels: props.allowCustomPanels,
                allowAnnotations: props.allowAnnotations,
                allowSelectAllTrap: props.allowSelectAllTrap,
                allowPlaceholderText: props.allowPlaceholderText,
                nodeComponents: props.nodeComponents,
                allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
                isInsideOfInlineExtension: props.isInsideOfInlineExtension,
                textHighlighter: props.UNSTABLE_textHighlighter,
                allowTableAlignment: props.UNSTABLE_allowTableAlignment,
                allowTableResizing: props.UNSTABLE_allowTableResizing
            };
        }
        render() {
            const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
            const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
            const allowNestedHeaderLinks = (0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
            const handleWrapperOnClick = (event)=>{
                const targetElement = event.target;
                this.handleMouseTripleClickInTables(event);
                if (!this.props.eventHandlers?.onUnhandledClick) return;
                if (!(targetElement instanceof window.Element)) return;
                const rendererWrapper = event.currentTarget;
                const isInteractiveElementInTree = (0, (0, parcelRequire("K5Jsy")).findInTree)(targetElement, rendererWrapper, (0, (0, parcelRequire("TPpI8")).isInteractiveElement));
                if (isInteractiveElementInTree) return;
                const windowSelection = window.getSelection();
                const selection = windowSelection !== null ? windowSelection.toString() : undefined;
                const hasSelection = selection && selection.length !== 0;
                const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
                const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
                if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
            };
            try {
                const schema = this.getSchema(this.props.schema, this.props.adfStage);
                const { result: result, stat: stat, pmDoc: pmDoc } = (0, (0, parcelRequire("12yAL")).renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats);
                if (onComplete) onComplete(stat);
                const rendererOutput = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dyURG")).RendererContextProvider), {
                    value: rendererContext
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1pTqN")).ActiveHeaderIdProvider), {
                    value: (0, (0, parcelRequire("3kKuL")).getActiveHeadingId)(allowHeadingAnchorLinks)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("TM1uy")).default).Provider, {
                    value: {
                        fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                    }
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4BsEy")).Provider), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9S8fM")).ProviderFactoryProvider), {
                    value: this.providerFactory
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    allowColumnSorting: allowColumnSorting,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowCustomPanels: allowCustomPanels,
                    allowPlaceholderText: allowPlaceholderText,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    innerRef: this.editorRef,
                    onClick: handleWrapperOnClick,
                    onMouseDown: this.onMouseDownEditView,
                    ssr: media?.ssr,
                    isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, enableSsrInlineScripts ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUVor")).BreakoutSSRInlineScript), null) : null, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
                    doc: pmDoc,
                    schema: schema,
                    onAnalyticsEvent: this.fireAnalyticsEvent
                }, result)))))));
                let rendererResult = truncated ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3lRy2")).TruncatedWrapper), {
                    height: maxHeight,
                    fadeHeight: fadeOutHeight
                }, rendererOutput) : rendererOutput;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, rendererResult);
            } catch (e) {
                if (onError) onError(e);
                return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowPlaceholderText: allowPlaceholderText,
                    allowColumnSorting: allowColumnSorting,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    onClick: handleWrapperOnClick,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iiXGq")).default), null));
            }
        }
        componentWillUnmount() {
            const { dataProviders: dataProviders } = this.props;
            if (this.rafID) window.cancelAnimationFrame(this.rafID);
            if (!dataProviders) this.providerFactory.destroy();
        }
    }
    function $3de1eca32602d427$export$88530751e3977073(props) {
        const { startPos: startPos } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("4YrGg")).AnnotationsPositionContext));
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("dyURG")).useRendererContext)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$5161b00bb85c4267, {
            ...props,
            startPos: startPos,
            isTopLevelRenderer: isTopLevelRenderer
        }));
    }
    const $3de1eca32602d427$export$af81ffb59b6ef0dd = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
            data: {
                appearance: (0, (0, parcelRequire("4NUlu")).getAnalyticsAppearance)(props.appearance),
                packageName: $3de1eca32602d427$var$packageName,
                packageVersion: $3de1eca32602d427$var$packageVersion,
                componentName: 'renderer',
                editorSessionId: (0, ($parcel$interopDefault($bXrHm)))()
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2DpUZ")).WithCreateAnalyticsEvent), {
            render: (createAnalyticsEvent)=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Eu7T")).ErrorBoundary), {
                    component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                    rethrowError: true,
                    fallbackComponent: null,
                    createAnalyticsEvent: createAnalyticsEvent
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fIJEx")).IntlErrorBoundary), null, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$88530751e3977073, {
                    ...props,
                    createAnalyticsEvent: createAnalyticsEvent
                })));
            }
        })));
    const $3de1eca32602d427$var$RendererWrapper = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        const createTelepointer = ()=>{
            const telepointer = document.createElement('span');
            telepointer.textContent = '\u200b';
            telepointer.id = (0, (0, parcelRequire("OxITw")).TELEPOINTER_ID);
            return telepointer;
        };
        const initialUpdate = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
                const renderer = innerRef.current.querySelector('.ak-renderer-document');
                if (initialUpdate.current) {
                    const lastChild = renderer.lastChild;
                    lastChild && lastChild.appendChild(createTelepointer());
                }
                const mutateTelepointer = (mutations)=>{
                    mutations.forEach((mutation)=>{
                        if (initialUpdate.current) {
                            const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("OxITw")).TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            const lastChild = renderer.lastChild;
                            lastChild && lastChild.appendChild(createTelepointer());
                            initialUpdate.current = false;
                        }
                        if (mutation.type === 'characterData') {
                            const parentNode = mutation.target.parentElement;
                            if (parentNode) {
                                const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("OxITw")).TELEPOINTER_ID)}`);
                                if (oldTelepointer) oldTelepointer.remove();
                                parentNode.appendChild(createTelepointer());
                            }
                        }
                    });
                };
                const observer = new MutationObserver(mutateTelepointer);
                observer.observe(innerRef.current, {
                    characterData: true,
                    attributes: false,
                    childList: true,
                    subtree: true
                });
                return ()=>observer.disconnect();
            }
        }, [
            innerRef,
            addTelepointer
        ]);
        const renderer = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthProvider), {
            className: `ak-renderer-wrapper is-${appearance}`,
            "data-appearance": appearance,
            shouldCheckExistingValue: isInsideOfInlineExtension
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Iju4")).BaseTheme), {
            baseFontSize: appearance && appearance !== 'comment' ? (0, (0, parcelRequire("iHYdz")).akEditorFullPageDefaultFontSize) : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1urn6")).EditorMediaClientProvider), {
            ssr: ssr
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            onClick: onClick,
            onMouseDown: onMouseDown,
            css: (0, (0, parcelRequire("OxITw")).rendererStyles)({
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: !!allowColumnSorting,
                useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
                allowAnnotations: props.allowAnnotations,
                allowTableResizing: allowTableResizing
            })
        }, children))));
        return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && isTopLevelRenderer && (0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing') ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3de1eca32602d427$var$setAsQueryContainerStyles
        }, renderer) : renderer;
    });
    const $3de1eca32602d427$var$RootRendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
        const rootRendererContextValue = (0, ($parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const rendererRef = (0, $5uXOq.useRef)(null);
        let _doc;
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) _doc = rootRendererContextValue.doc;
        else _doc = doc;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
            else actions._privateUnregisterRenderer();
            return ()=>actions._privateUnregisterRenderer();
        }, [
            actions,
            schema,
            _doc,
            onAnalyticsEvent
        ]);
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
            value: {
                doc: _doc
            }
        }, children);
        return children;
    }
    const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
        const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
        const localRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const innerRef = props.innerRef || localRef;
        if (!allowAnnotations) return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fCNtA")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4YrGg")).AnnotationsWrapper), {
            rendererRef: innerRef,
            adfDocument: adfDocument,
            annotationProvider: props.annotationProvider,
            isNestedRender: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props,
            featureFlags: props.featureFlags
        })));
    };
    var $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;
});
parcelRegister("dGzaM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$586c606cb83743fd$export$2e2bcd8739ae039);
    function $586c606cb83743fd$var$isUndefined(x) {
        return x === undefined;
    }
    class $586c606cb83743fd$export$2e2bcd8739ae039 {
        static create(providers) {
            const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
            const keys = Object.keys(providers);
            keys.forEach((name)=>{
                providerFactory.setProvider(name, providers[name]);
            });
            return providerFactory;
        }
        destroy() {
            this.providers.clear();
            this.subscribers.clear();
        }
        isEmpty() {
            return !this.providers.size && !this.subscribers.size;
        }
        setProvider(name, provider) {
            if (this.providers.get(name) === provider) return;
            if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
            else this.providers.delete(name);
            this.notifyUpdated(name, provider);
        }
        removeProvider(name) {
            this.providers.delete(name);
            this.notifyUpdated(name);
        }
        subscribe(name, handler) {
            const handlers = this.subscribers.get(name) || [];
            handlers.push(handler);
            this.subscribers.set(name, handlers);
            const provider = this.providers.get(name);
            if (provider) handler(name, provider);
            return provider;
        }
        unsubscribe(name, handler) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            const index = handlers.indexOf(handler);
            if (index !== -1) handlers.splice(index, 1);
            if (handlers.length === 0) this.subscribers.delete(name);
            else this.subscribers.set(name, handlers);
        }
        unsubscribeAll(name) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            this.subscribers.delete(name);
        }
        hasProvider(name) {
            return this.providers.has(name);
        }
        notifyUpdated(name, provider) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            handlers.forEach((handler)=>{
                handler(name, provider);
            });
        }
        constructor(){
            this.providers = new Map();
            this.subscribers = new Map();
        }
    }
});
parcelRegister("9S8fM", function(module, exports) {
    $parcel$export(module.exports, "ProviderFactoryProvider", ()=>$d1ee541d73df1fcd$export$617c134b25cc4265);
    $parcel$export(module.exports, "useProvider", ()=>$d1ee541d73df1fcd$export$693cdb10cec23617);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGzaM;
    const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("dGzaM")).default)());
    const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
    const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
    const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
        const [provider, setProvider] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const providerHandler = (_, provider)=>{
                setProvider(provider);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        }, [
            name,
            providerFactory
        ]);
        return provider;
    };
});
parcelRegister("gmhCD", function(module, exports) {
    $parcel$export(module.exports, "editorExperiment", ()=>$a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
    var $5IPCv;
    var $hdkTE = parcelRequire("hdkTE");
    var $a0Psj = parcelRequire("a0Psj");
    function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
        exposure: false
    }) {
        const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
        if ((0, $a0Psj._overrides)[experimentName] !== undefined) return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
        if (!(0, $a0Psj._product)) return experimentConfig.defaultValue === expectedExperimentValue;
        const experimentKey = experimentConfig.productKeys?.[0, $a0Psj._product];
        if (!experimentKey) return (0, $hdkTE.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
        const experimentValue = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
            typeGuard: experimentConfig.typeGuard,
            fireExperimentExposure: options.exposure
        });
        return expectedExperimentValue === experimentValue;
    }
});
parcelRegister("hdkTE", function(module, exports) {
    $parcel$export(module.exports, "editorExperimentsConfig", ()=>$7a273b3c03491c92$export$6cbb856f286b07ef);
    var $9qwvi = parcelRequire("9qwvi");
    const $7a273b3c03491c92$export$6cbb856f286b07ef = {
        'example-boolean': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_boolean'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'example-multivariate': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_multivariate'
            },
            param: 'variant',
            typeGuard: (0, $9qwvi.oneOf)([
                'one',
                'two',
                'three'
            ]),
            defaultValue: 'one'
        },
        'test-new-experiments-package': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package',
                jira: 'jira_editor_experiment_test_new_package'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'basic-text-transformations': {
            productKeys: {
                confluence: 'platform_editor_basic_text_transformations'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'dnd-input-performance-optimisation': {
            productKeys: {
                confluence: 'platform_editor_dnd_input_performance_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'element-level-templates': {
            productKeys: {
                confluence: 'platform_editor_element_level_templates'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'add-media-from-url': {
            productKeys: {
                confluence: 'platform_editor_add_media_from_url'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_drag_and_drop_nested'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'table-nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_elements_dnd_nested_table'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'insert-menu-in-right-rail': {
            productKeys: {
                confluence: 'platform_editor_insert_menu_in_right_rail'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_empty_line_prompt: {
            productKeys: {
                confluence: 'platform_editor_empty_line_prompt'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        support_table_in_comment: {
            productKeys: {
                confluence: 'platform_editor_support_table_in_comment_exp'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_exp_lazy_node_views: {
            productKeys: {
                confluence: 'platform_editor_exp_lazy_node_views'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_ai_button_block_elements: {
            productKeys: {
                confluence: 'platform_editor_ai_ai_button_block_elements'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_renderer_table_sticky_scrollbar: {
            productKeys: {
                confluence: 'platform_renderer_table_sticky_scrollbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nest-media-and-codeblock-in-quote': {
            productKeys: {
                confluence: 'platform_editor_nest_media_and_codeblock_in_quotes'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nested-expand-in-expand': {
            productKeys: {
                confluence: 'platform_editor_nest_nested_expand_in_expand'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_command_palette_post_ga: {
            productKeys: {
                confluence: 'platform_editor_ai_command_palette_post_ga'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_editor_table_use_shared_state_hook: {
            productKeys: {
                confluence: 'platform_editor_table_use_shared_state_hook'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_multi_prompts': {
            productKeys: {
                confluence: 'editor_ai_-_multi_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_additional_editor_prompts: {
            productKeys: {
                confluence: 'platform_editor_ai_additional_editor_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        comment_on_bodied_extensions: {
            productKeys: {
                confluence: 'platform_editor_comment_on_bodied_extensions'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'optimised-apply-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_dnd_apply_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_1p_placeholder_hints: {
            productKeys: {
                confluence: 'platform_editor_ai_1p_placeholder_hints'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'example-placeholders',
                'tip-placeholders'
            ]),
            defaultValue: 'control'
        },
        advanced_layouts: {
            productKeys: {
                confluence: 'platform_editor_advanced_layouts'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_live_pages_ai_definitions: {
            productKeys: {
                confluence: 'platform_editor_live_pages_ai_definitions'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        support_table_in_comment_jira: {
            productKeys: {
                jira: 'platform_editor_support_table_in_comment_jira'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        comment_on_inline_node_spotlight: {
            productKeys: {
                confluence: 'platform_editor_comment_on_inline_node_spotlight'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_proactive_ai_model_variations': {
            productKeys: {
                confluence: 'editor_ai_-_proactive_ai_model_variations'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'skip_grammar'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_refine_response_button: {
            productKeys: {
                confluence: 'platform_editor_ai_refine_response_button'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_proactive_ai_spelling_and_grammar': {
            productKeys: {
                confluence: 'editor_ai_-_proactive_ai_spelling_and_grammar'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'default-off',
                'default-on'
            ]),
            defaultValue: 'control'
        },
        'platform_editor_ai-prompts-placeholder': {
            productKeys: {
                confluence: 'platform_editor_ai-prompts-placeholder'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        'editor_ai_-_gpt4_experiment': {
            productKeys: {
                confluence: 'editor_ai_-_gpt4_experiment'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'einstein'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_facepile: {
            productKeys: {
                confluence: 'platform_editor_ai_facepile'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_change_tone_floating_toolbar: {
            productKeys: {
                confluence: 'platform_editor_ai_change_tone_floating_toolbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_response_history: {
            productKeys: {
                confluence: 'platform_editor_ai_response_history'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        }
    };
});
parcelRegister("9qwvi", function(module, exports) {
    $parcel$export(module.exports, "isBoolean", ()=>$41035ee8947774ef$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "oneOf", ()=>$41035ee8947774ef$export$a9a18ae5ba42aeab);
    function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
        return typeof value === 'boolean';
    }
    function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
        function typeGuard(value) {
            return values.includes(value);
        }
        if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
        return typeGuard;
    }
    const $41035ee8947774ef$var$IS_TESTING_ENV = false;
});
parcelRegister("a0Psj", function(module, exports) {
    $parcel$export(module.exports, "_overrides", ()=>$ae2371e90434836c$export$e5d73bf4f8e2ae96);
    $parcel$export(module.exports, "_product", ()=>$ae2371e90434836c$export$cf7305fc65acbf0d);
    $parcel$export(module.exports, "setupEditorExperiments", ()=>$ae2371e90434836c$export$1c2b6dbf79eb3560);
    var $hdkTE = parcelRequire("hdkTE");
    let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
    let $ae2371e90434836c$export$cf7305fc65acbf0d;
    function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, overrides) {
        if (overrides) {
            overrides = Object.entries(overrides).reduce((acc, [key, value])=>{
                const config = (0, $hdkTE.editorExperimentsConfig)[key];
                if (config) acc = {
                    ...acc,
                    [key]: config.typeGuard(value) ? value : config.defaultValue
                };
                return acc;
            }, {});
            $ae2371e90434836c$export$e5d73bf4f8e2ae96 = overrides;
        }
        $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    }
});
parcelRegister("9Iju4", function(module, exports) {
    $parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", ()=>$b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
    $parcel$export(module.exports, "BaseTheme", ()=>$b0fd15d81ba0fb5a$export$a1a213d350ca51ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0wej;
    var $iHYdz;
    var $4ceoy;
    function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
        switch(breakpoint){
            case 'M':
            case 'L':
                return 760;
            default:
                return 680;
        }
    }
    function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
        const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
                baseFontSize: baseFontSize || 14,
                layoutMaxWidth: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth)
            }), [
            baseFontSize
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0wej")).a), {
            theme: memoizedTheme
        }, children);
    }
    function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ breakpoint: breakpoint })=>(0, ($parcel$interopDefault($5uXOq))).createElement($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)));
    }
});
parcelRegister("iHYdz", function(module, exports) {
    $parcel$export(module.exports, "akEditorFullPageDefaultFontSize", ()=>$01f0a5ace820da37$export$fe6b0b821a0e9067);
    $parcel$export(module.exports, "akEditorCodeFontFamily", ()=>$01f0a5ace820da37$export$9a7c520c39e1f0aa);
    $parcel$export(module.exports, "akEditorSubtleAccent", ()=>$01f0a5ace820da37$export$1d762aef048d30f9);
    $parcel$export(module.exports, "akEditorBlockquoteBorderColor", ()=>$01f0a5ace820da37$export$a7a75e50ae62d0a8);
    $parcel$export(module.exports, "akEditorDeleteBackground", ()=>$01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
    $parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", ()=>$01f0a5ace820da37$export$8f7d2d784079e274);
    $parcel$export(module.exports, "akEditorDeleteBorder", ()=>$01f0a5ace820da37$export$3c108a6bc41bb5f2);
    $parcel$export(module.exports, "akEditorDeleteIconColor", ()=>$01f0a5ace820da37$export$bf3aaa2106c119fd);
    $parcel$export(module.exports, "akEditorCustomIconSize", ()=>$01f0a5ace820da37$export$d2715266dd4a1fd1);
    $parcel$export(module.exports, "akEditorSelectedBorderColor", ()=>$01f0a5ace820da37$export$cf524c1b49838a49);
    $parcel$export(module.exports, "akEditorSelectedBorderSize", ()=>$01f0a5ace820da37$export$8dac549e32469ac4);
    $parcel$export(module.exports, "akEditorSelectedBorder", ()=>$01f0a5ace820da37$export$6e1e1996c4e8cc51);
    $parcel$export(module.exports, "akEditorSelectedBoxShadow", ()=>$01f0a5ace820da37$export$b6a59ac3a19b6343);
    $parcel$export(module.exports, "akEditorSelectedBorderBoldSize", ()=>$01f0a5ace820da37$export$befaaae517e3d864);
    $parcel$export(module.exports, "akEditorUnitZIndex", ()=>$01f0a5ace820da37$export$f35cc48f3398ab79);
    $parcel$export(module.exports, "akEditorShadowZIndex", ()=>$01f0a5ace820da37$export$b46cda584c619451);
    $parcel$export(module.exports, "akEditorStickyHeaderZIndex", ()=>$01f0a5ace820da37$export$6bed85de54b5de42);
    $parcel$export(module.exports, "akEditorSmallZIndex", ()=>$01f0a5ace820da37$export$321ddd2f049dd12);
    $parcel$export(module.exports, "akEditorGridLineZIndex", ()=>$01f0a5ace820da37$export$daeac9b8422ac3c2);
    $parcel$export(module.exports, "akEditorMenuZIndex", ()=>$01f0a5ace820da37$export$501d46e11ed5bf73);
    $parcel$export(module.exports, "akEditorFloatingPanelZIndex", ()=>$01f0a5ace820da37$export$6817b4b6a5ef78f1);
    $parcel$export(module.exports, "akEditorFloatingDialogZIndex", ()=>$01f0a5ace820da37$export$93768eb72dec48ce);
    $parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", ()=>$01f0a5ace820da37$export$c0aec4e0896849a0);
    $parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", ()=>$01f0a5ace820da37$export$5886f057e4f21fe4);
    $parcel$export(module.exports, "akEditorTableToolbarSize", ()=>$01f0a5ace820da37$export$6e85faa46d537a3f);
    $parcel$export(module.exports, "akEditorTableBorder", ()=>$01f0a5ace820da37$export$36ba77fba4a62d5f);
    $parcel$export(module.exports, "akEditorTableToolbar", ()=>$01f0a5ace820da37$export$640eef769748f78f);
    $parcel$export(module.exports, "akEditorTableHeaderCellBackground", ()=>$01f0a5ace820da37$export$4c6f61fb4b9ae93);
    $parcel$export(module.exports, "akEditorTableBorderSelected", ()=>$01f0a5ace820da37$export$f7bbcec54ff5bc47);
    $parcel$export(module.exports, "akEditorFullPageMaxWidth", ()=>$01f0a5ace820da37$export$fad19f16d3f953a3);
    $parcel$export(module.exports, "akEditorDefaultLayoutWidth", ()=>$01f0a5ace820da37$export$9db045950eedb49f);
    $parcel$export(module.exports, "akEditorWideLayoutWidth", ()=>$01f0a5ace820da37$export$74c442132af16a);
    $parcel$export(module.exports, "akEditorFullWidthLayoutWidth", ()=>$01f0a5ace820da37$export$f580e3d28d0986de);
    $parcel$export(module.exports, "akEditorTableNumberColumnWidth", ()=>$01f0a5ace820da37$export$37df10057d36a0e5);
    $parcel$export(module.exports, "akEditorBreakoutPadding", ()=>$01f0a5ace820da37$export$437293c5e9fc2703);
    $parcel$export(module.exports, "akEditorGutterPadding", ()=>$01f0a5ace820da37$export$6e0f4d52efd3d2d);
    $parcel$export(module.exports, "akEditorGutterPaddingDynamic", ()=>$01f0a5ace820da37$export$f222e0c7a2dc5324);
    $parcel$export(module.exports, "akEditorMobileBreakoutPoint", ()=>$01f0a5ace820da37$export$efe8561bbd3f74d2);
    $parcel$export(module.exports, "akEditorTableCellMinWidth", ()=>$01f0a5ace820da37$export$e4d39a9e8607c1d3);
    $parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", ()=>$01f0a5ace820da37$export$43946f2400ab6f1f);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", ()=>$01f0a5ace820da37$export$558438ae7fd4b8ce);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", ()=>$01f0a5ace820da37$export$6beb98d32d4ca149);
    $parcel$export(module.exports, "akEditorSwoopCubicBezier", ()=>$01f0a5ace820da37$export$3b24948cd5dbb087);
    $parcel$export(module.exports, "gridMediumMaxWidth", ()=>$01f0a5ace820da37$export$5edb4f38c3eacb1a);
    $parcel$export(module.exports, "breakoutWideScaleRatio", ()=>$01f0a5ace820da37$export$e60820063058ed59);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", ()=>$01f0a5ace820da37$export$60da500206e2ceec);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", ()=>$01f0a5ace820da37$export$c0e6648ae1bb2fac);
    $parcel$export(module.exports, "akRichMediaResizeZIndex", ()=>$01f0a5ace820da37$export$fb15fade89f67217);
    $parcel$export(module.exports, "akLayoutGutterOffset", ()=>$01f0a5ace820da37$export$847030921e9d5a40);
    $parcel$export(module.exports, "akEditorLineHeight", ()=>$01f0a5ace820da37$export$40eb41ab799f0329);
    $parcel$export(module.exports, "akEditorToolbarKeylineHeight", ()=>$01f0a5ace820da37$export$d29cb2c31fcbb7c5);
    $parcel$export(module.exports, "akEditorContextPanelWidth", ()=>$01f0a5ace820da37$export$688a6dc01e760755);
    $parcel$export(module.exports, "akEditorTableCellBlanketSelected", ()=>$01f0a5ace820da37$export$e736f2caf3b39eb3);
    $parcel$export(module.exports, "akEditorTableCellBlanketDeleted", ()=>$01f0a5ace820da37$export$de3cef07cda55645);
    $parcel$export(module.exports, "akEditorWrappedNodeZIndex", ()=>$01f0a5ace820da37$export$e88f6c898960b391);
    $parcel$export(module.exports, "layoutBreakpointWidth", ()=>$01f0a5ace820da37$export$e5c605f2b2a12b00);
    $parcel$export(module.exports, "blockNodesVerticalMargin", ()=>$01f0a5ace820da37$export$1d0d506416d457f1);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", ()=>$01f0a5ace820da37$export$e683ef42725d1713);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", ()=>$01f0a5ace820da37$export$226c784ba04bd04b);
    $parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", ()=>$01f0a5ace820da37$export$214ff00e5618d86c);
    $parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", ()=>$01f0a5ace820da37$export$d7726a000ae2d7c);
    $parcel$export(module.exports, "akEditorSelectedNodeClassName", ()=>$01f0a5ace820da37$export$a02a3f1515c2e21a);
    $parcel$export(module.exports, "editorFontSize", ()=>$01f0a5ace820da37$export$58a725ff69bda73a);
    $parcel$export(module.exports, "relativeFontSizeToBase16", ()=>$01f0a5ace820da37$export$59733a9f61449b25);
    $parcel$export(module.exports, "akEditorMobileMaxWidth", ()=>$01f0a5ace820da37$export$9369fd010fa0ddd6);
    $parcel$export(module.exports, "avatarColors", ()=>$01f0a5ace820da37$export$312e1e71424c4aa1);
    var $VSDnB;
    const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
    const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
    const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
    const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
    const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
    const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)';
    const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
    const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
    const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
    const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
    const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
    const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
    const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
    const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
    const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
    const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
    const $01f0a5ace820da37$export$b46cda584c619451 = 2;
    const $01f0a5ace820da37$export$6bed85de54b5de42 = 11;
    const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
    const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
    const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
    const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
    const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
    const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
    const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
    const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
    const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
    const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
    const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
    const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
    const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
    const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
    const $01f0a5ace820da37$export$9db045950eedb49f = 760;
    const $01f0a5ace820da37$export$74c442132af16a = 960;
    const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
    const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
    const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
    const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
    const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
    const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_core_increase_full_page_guttering') ? 52 : 32;
    const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
    const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
    const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
    const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
    const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
    const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
    const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
    const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
    const $01f0a5ace820da37$export$60da500206e2ceec = 905;
    const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011;
    const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
    const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
    const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
    const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
    const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
    const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
    const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
    const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
    const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2;
    const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
        SMALL: 550,
        MEDIUM: 760
    };
    const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
    const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
    const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
    const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
    const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
    const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
    const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? "var(--ds-space-500, 40px)" : '56px';
    const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
    const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
    const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
                theme: theme
            }) * multiplier;
    const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
        if (typeof px === 'string') px = parseInt(px);
        if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
        return `${px / 16}rem`;
    };
    const $01f0a5ace820da37$export$96b72b7f243fa693 = {
        laptopHiDPI: {
            width: 1440,
            height: 900
        },
        laptopMDPI: {
            width: 1280,
            height: 800
        },
        tabletL: {
            width: 1024,
            height: 1366
        },
        tabletS: {
            width: 768,
            height: 1024
        },
        mobileM: {
            width: 414,
            height: 736
        },
        mobileS: {
            width: 375,
            height: 667
        },
        mobileXS: {
            width: 320,
            height: 568
        }
    };
    const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
    const $01f0a5ace820da37$export$846a716e9e69a8df = [
        [
            'White',
            '#000000'
        ],
        [
            'Light blue',
            '#0C294F'
        ],
        [
            'Light teal',
            '#0C343B'
        ],
        [
            'Light green',
            '#052E21'
        ],
        [
            'Light yellow',
            '#484123'
        ],
        [
            'Light red',
            '#441C13'
        ],
        [
            'Light purple',
            '#282249'
        ],
        [
            'Light gray',
            '#202328'
        ],
        [
            'Blue',
            '#0B3165'
        ],
        [
            'Teal',
            '#044853'
        ],
        [
            'Green',
            '#053927'
        ],
        [
            'Yellow',
            '#6F5C25'
        ],
        [
            'Red',
            '#582013'
        ],
        [
            'Purple',
            '#3E327B'
        ],
        [
            'Gray',
            '#475262'
        ],
        [
            'Dark blue',
            '#003884'
        ],
        [
            'Dark teal',
            '#055866'
        ],
        [
            'Dark green',
            '#044932'
        ],
        [
            'Dark yellow',
            '#82641C'
        ],
        [
            'Dark red',
            '#6B2A19'
        ],
        [
            'Dark purple',
            '#4D38B2'
        ]
    ].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
    function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
        return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
    }
    const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
        "var(--ds-icon-accent-red, #C9372C)",
        "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
        "var(--ds-icon-accent-magenta, #CD519D)",
        "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
        "var(--ds-icon-accent-orange, #E56910)",
        "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
        "var(--ds-icon-accent-green, #22A06B)",
        "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
        "var(--ds-icon-accent-blue, #1D7AFC)",
        "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
        "var(--ds-icon-accent-teal, #2898BD)",
        "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
        "var(--ds-icon-accent-lime, #6A9A23)",
        "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
        "var(--ds-icon-accent-purple, #8270DB)",
        "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
        "var(--ds-icon-accent-gray, #758195)",
        "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        "var(--ds-icon-accent-yellow, #B38600)",
        "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
        "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
    ];
    const $01f0a5ace820da37$export$42608c013398a830 = [
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
        }
    ];
});
parcelRegister("4ceoy", function(module, exports) {
    $parcel$export(module.exports, "getBreakpoint", ()=>$a2904bcfe480568e$export$1eb095b00b926404);
    $parcel$export(module.exports, "createWidthContext", ()=>$a2904bcfe480568e$export$31a4966bffb9ac98);
    $parcel$export(module.exports, "WidthContext", ()=>$a2904bcfe480568e$export$27e39f636459b9f);
    $parcel$export(module.exports, "WidthConsumer", ()=>$a2904bcfe480568e$export$5d8538aa831b6ebb);
    $parcel$export(module.exports, "WidthProvider", ()=>$a2904bcfe480568e$export$7921e18173e8c666);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8QpSo;
    var $7nRxN;
    var $gJlZe;
    var $1v3g5;
    function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a2904bcfe480568e$var$styles = {
        name: "pw7jst",
        styles: "position:relative;width:100%"
    };
    const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
    function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
        const MAX_S = 1266;
        const MAX_M = 2146;
        if (width >= MAX_S && width < MAX_M) return 'M';
        else if (width >= MAX_M) return 'L';
        return 'S';
    }
    function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
        return {
            width: width,
            breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
        };
    }
    const $a2904bcfe480568e$export$27e39f636459b9f = (0, ($parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
    const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
    const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return (0, (0, parcelRequire("1v3g5")).isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
    });
    const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
        const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
        const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
        const widthRef = (0, $5uXOq.useRef)(width);
        const isMountedRef = (0, $5uXOq.useRef)(true);
        const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
            width
        ]);
        const updateWidth = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("7nRxN")).default)((nextWidth)=>{
                const currentWidth = widthRef.current || 0;
                if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
                if (!isMountedRef.current) return;
                setWidth(nextWidth);
            });
        }, []);
        const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
        (0, ($parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
            };
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $a2904bcfe480568e$var$styles,
            className: className
        }, !skipWidthDetection && (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gJlZe")).WidthObserver), {
            setWidth: updateWidth,
            offscreen: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($a2904bcfe480568e$var$Provider, {
            value: providerValue
        }, children)), skipWidthDetection && children);
    };
});
parcelRegister("1v3g5", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$161da1f5bf80dbfb$export$48d7c418edadb60c);
    var $6cAn5 = parcelRequire("6cAn5");
    function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
        try {
            return Boolean(typeof document === 'undefined' || typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("fIJEx", function(module, exports) {
    $parcel$export(module.exports, "IntlErrorBoundary", ()=>$f1eccfecc1c43fb5$export$7df0749115d18d19);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
    const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
    class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch(error, errorInfo) {
            if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
                missingIntlProviderInAncestry: true
            });
            else throw error;
        }
        render() {
            if (this.state.missingIntlProviderInAncestry) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: "en"
            }, this.props.children);
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                missingIntlProviderInAncestry: false
            };
        }
    }
});
parcelRegister("iiXGq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94120525d10931b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $iHYdz;
    var $eJS47;
    var $3bDjY;
    var $gkwXh;
    var $7R1zM;
    var $d54NZ;
    var $9tFGn;
    const $94120525d10931b9$var$blockNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'flex',
        fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
        margin: `${"var(--ds-space-100, 8px)"} 0`,
        minHeight: '24px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center',
        verticalAlign: 'text-bottom',
        minWidth: '120px',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("9tFGn")).getUnsupportedContent)((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedBlockContent, (0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("d54NZ")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $94120525d10931b9$var$blockNodeStyle,
            className: "unsupported"
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            label: "?",
            size: "small"
        })))));
    };
    var $94120525d10931b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($94120525d10931b9$var$UnsupportedBlockNode);
});
parcelRegister("gkwXh", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$97c56ca7515fdb59$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$97c56ca7515fdb59$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "INPUT_METHOD", ()=>$97c56ca7515fdb59$export$85f107b1fcc9d96f);
    $parcel$export(module.exports, "INSERT_MEDIA_VIA", ()=>$97c56ca7515fdb59$export$9b31fa32ae3f8051);
    $parcel$export(module.exports, "TRIGGER_METHOD", ()=>$97c56ca7515fdb59$export$81a8b7dba1aa8f75);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$97c56ca7515fdb59$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$97c56ca7515fdb59$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "CONTENT_COMPONENT", ()=>$97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
    var $97c56ca7515fdb59$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($97c56ca7515fdb59$export$76a2e4c433c23bb9 || ($97c56ca7515fdb59$export$76a2e4c433c23bb9 = {}));
    var $97c56ca7515fdb59$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["ACTIVATED"] = "activated";
        ACTION["ADDED"] = "added";
        ACTION["BROWSER_FREEZE"] = "browserFreeze";
        ACTION["CANCELLED"] = "cancelled";
        ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
        ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
        ACTION["CHANGED_ICON"] = "changedIcon";
        ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
        ACTION["CHANGED_LAYOUT"] = "changedLayout";
        ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
        ACTION["CHANGED_TYPE"] = "changedType";
        ACTION["CHANGED_URL"] = "changedUrl";
        ACTION["CLEARED"] = "cleared";
        ACTION["CLICKED"] = "clicked";
        ACTION["CLOSED"] = "closed";
        ACTION["COMMITTED"] = "committed";
        ACTION["CONNECTED_NODES"] = "connectedNodes";
        ACTION["CONVERTED"] = "converted";
        ACTION["COPIED"] = "copied";
        ACTION["CUT"] = "cut";
        ACTION["DEACTIVATED"] = "deactivated";
        ACTION["DECREMENTED"] = "decremented";
        ACTION["DELETED"] = "deleted";
        ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
        ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
        ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
        ACTION["DISMISSED"] = "dismissed";
        ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
        ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
        ACTION["DOUBLE_CLICKED"] = "doubleClicked";
        ACTION["DRAGGED"] = "dragged";
        ACTION["EDITED"] = "edited";
        ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
        ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
        ACTION["EDITOR_MOUNTED"] = "mounted";
        ACTION["EDITOR_TTI"] = "tti";
        ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
        ACTION["RE_RENDERED"] = "reRendered";
        ACTION["ENTERED"] = "entered";
        ACTION["ERRORED"] = "errored";
        ACTION["EXPOSED"] = "exposed";
        ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
        ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
        ACTION["FIND_PERFORMED"] = "findPerformed";
        ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
        ACTION["FORMATTED"] = "formatted";
        ACTION["HELP_OPENED"] = "helpOpened";
        ACTION["HIGHLIGHTED"] = "highlighted";
        ACTION["INCREMENTED"] = "incremented";
        ACTION["INDENTED"] = "indented";
        ACTION["INITIALISED"] = "initialised";
        ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
        ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
        ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
        ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
        ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
        ACTION["INSERTED"] = "inserted";
        ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
        ACTION["INVOKED"] = "invoked";
        ACTION["GOT_CONNECTIONS"] = "gotConnections";
        ACTION["LANGUAGE_SELECTED"] = "languageSelected";
        ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
        ACTION["MATCHED"] = "matched";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
        ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
        ACTION["OPENED"] = "opened";
        ACTION["OUTDENTED"] = "outdented";
        ACTION["PASTED"] = "pasted";
        ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
        ACTION["PASTED_TIMED"] = "pastedTimed";
        ACTION["PRESSED"] = "pressed";
        ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
        ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
        ACTION["REPLACED_ALL"] = "replacedAll";
        ACTION["REPLACED_ONE"] = "replacedOne";
        ACTION["RESOLVED"] = "resolved";
        ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
        ACTION["SELECTED"] = "selected";
        ACTION["SHOWN"] = "shown";
        ACTION["SLOW_INPUT"] = "slowInput";
        ACTION["STARTED"] = "started";
        ACTION["STOPPED"] = "stopped";
        ACTION["SUBSTITUTED"] = "autoSubstituted";
        ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
        ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
        ACTION["SYNCHRONY_ERROR"] = "synchronyError";
        ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
        ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
        ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
        ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
        ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
        ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
        ACTION["TYPING_FINISHED"] = "typingFinished";
        ACTION["TYPING_STARTED"] = "typingStarted";
        ACTION["UNLINK"] = "unlinked";
        ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
        ACTION["UPDATED"] = "updated";
        ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
        ACTION["UPDATED_SOURCE"] = "updatedSource";
        ACTION["UPDATED_TARGET"] = "updatedTarget";
        ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
        ACTION["RENDERED"] = "rendered";
        ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
        ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
        ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
        ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
        ACTION["REMOVE_ICON"] = "removedIcon";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaughtV2";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["STEPS_TRACKED"] = "stepsTracked";
        ACTION["STEPS_FILTERED"] = "stepsFiltered";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
        ACTION["RECORD_VIDEO"] = "recordVideo";
        ACTION["INSERT_VIDEO"] = "insertVideo";
        ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
        ACTION["ADD_CHILD"] = "addChild";
        ACTION["CHANGE_ACTIVE"] = "changeActive";
        ACTION["REMOVE_CHILD"] = "removeChild";
        ACTION["UPDATE_PARAMETERS"] = "updateParameters";
        ACTION["GET_CHILDERN"] = "getChildern";
        ACTION["MOVED"] = "moved";
        ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
        ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
        ACTION["UPLOAD_FAILED"] = "uploadFailed";
        ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    })($97c56ca7515fdb59$export$9523889e0a5da4ba || ($97c56ca7515fdb59$export$9523889e0a5da4ba = {}));
    var $97c56ca7515fdb59$export$85f107b1fcc9d96f;
    (function(INPUT_METHOD) {
        INPUT_METHOD["ASCII"] = "ascii";
        INPUT_METHOD["AUTO"] = "auto";
        INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
        INPUT_METHOD["BUTTON"] = "button";
        INPUT_METHOD["BLUR"] = "blur";
        INPUT_METHOD["CARD"] = "card";
        INPUT_METHOD["CLIPBOARD"] = "clipboard";
        INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
        INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
        INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
        INPUT_METHOD["DRAG"] = "drag";
        INPUT_METHOD["EXTERNAL"] = "external";
        INPUT_METHOD["EXTENSION_API"] = "extensionApi";
        INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
        INPUT_METHOD["FORMATTING"] = "autoformatting";
        INPUT_METHOD["INSERT_MENU"] = "insertMenu";
        INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
        INPUT_METHOD["KEYBOARD"] = "keyboard";
        INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
        INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
        INPUT_METHOD["MANUAL"] = "manual";
        INPUT_METHOD["PICKER"] = "picker";
        INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
        INPUT_METHOD["PREFILL"] = "prefill";
        INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
        INPUT_METHOD["SHORTCUT"] = "shortcut";
        INPUT_METHOD["TOOLBAR"] = "toolbar";
        INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
        INPUT_METHOD["DATASOURCE"] = "datasource_config";
        INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
        INPUT_METHOD["MOUSE"] = "mouse";
        INPUT_METHOD["BROWSER"] = "browser";
        INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    })($97c56ca7515fdb59$export$85f107b1fcc9d96f || ($97c56ca7515fdb59$export$85f107b1fcc9d96f = {}));
    var $97c56ca7515fdb59$export$9b31fa32ae3f8051;
    (function(INSERT_MEDIA_VIA) {
        INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
        INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
        INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    })($97c56ca7515fdb59$export$9b31fa32ae3f8051 || ($97c56ca7515fdb59$export$9b31fa32ae3f8051 = {}));
    var $97c56ca7515fdb59$export$81a8b7dba1aa8f75;
    (function(TRIGGER_METHOD) {
        TRIGGER_METHOD["BUTTON"] = "button";
        TRIGGER_METHOD["KEYBOARD"] = "keyboard";
        TRIGGER_METHOD["SHORTCUT"] = "shortcut";
        TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    })($97c56ca7515fdb59$export$81a8b7dba1aa8f75 || ($97c56ca7515fdb59$export$81a8b7dba1aa8f75 = {}));
    var $97c56ca7515fdb59$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["COLLAB"] = "collab";
        ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
        ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
        ACTION_SUBJECT["DATE"] = "date";
        ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
        ACTION_SUBJECT["DOCUMENT"] = "document";
        ACTION_SUBJECT["EDITOR"] = "editor";
        ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
        ACTION_SUBJECT["EMBEDS"] = "embeds";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["EXTENSION"] = "extension";
        ACTION_SUBJECT["FEATURE"] = "feature";
        ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
        ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
        ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
        ACTION_SUBJECT["HELP"] = "help";
        ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
        ACTION_SUBJECT["LAYOUT"] = "layout";
        ACTION_SUBJECT["LIST"] = "list";
        ACTION_SUBJECT["MEDIA"] = "media";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["MENTION"] = "mention";
        ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["PANEL"] = "panel";
        ACTION_SUBJECT["PICKER"] = "picker";
        ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
        ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
        ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
        ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT["SELECTION"] = "selection";
        ACTION_SUBJECT["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
        ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
        ACTION_SUBJECT["TEXT"] = "text";
        ACTION_SUBJECT["TOOLBAR"] = "toolbar";
        ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
        ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
        ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
        ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["TOOLTIP"] = "tooltip";
        ACTION_SUBJECT["LOOM"] = "loom";
        ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
        ACTION_SUBJECT["DRAG"] = "drag";
        ACTION_SUBJECT["ELEMENT"] = "element";
        ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
        ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
        ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
        ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
        ACTION_SUBJECT["DECORATION"] = "decoration";
    })($97c56ca7515fdb59$export$7525482b5931e326 || ($97c56ca7515fdb59$export$7525482b5931e326 = {}));
    var $97c56ca7515fdb59$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["ACTION"] = "action";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
        ACTION_SUBJECT_ID["ALL"] = "all";
        ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
        ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
        ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
        ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["BORDER"] = "border";
        ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
        ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
        ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
        ACTION_SUBJECT_ID["CANCEL"] = "cancel";
        ACTION_SUBJECT_ID["CAPTION"] = "caption";
        ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
        ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
        ACTION_SUBJECT_ID["CELL"] = "cell";
        ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
        ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
        ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
        ACTION_SUBJECT_ID["DATE"] = "date";
        ACTION_SUBJECT_ID["DATE_DAY"] = "day";
        ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
        ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
        ACTION_SUBJECT_ID["DECISION"] = "decision";
        ACTION_SUBJECT_ID["DIVIDER"] = "divider";
        ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
        ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
        ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
        ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
        ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
        ACTION_SUBJECT_ID["EMOJI"] = "emoji";
        ACTION_SUBJECT_ID["EXPAND"] = "expand";
        ACTION_SUBJECT_ID["EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
        ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
        ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
        ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
        ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
        ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
        ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
        ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
        ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
        ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
        ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
        ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
        ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
        ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
        ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
        ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
        ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
        ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
        ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
        ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
        ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["LAYOUT"] = "layout";
        ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
        ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
        ACTION_SUBJECT_ID["MEDIA"] = "media";
        ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
        ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
        ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
        ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["MENTION"] = "mention";
        ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
        ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["NODE"] = "node";
        ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
        ACTION_SUBJECT_ID["PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
        ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
        ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
        ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
        ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
        ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
        ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
        ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
        ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
        ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
        ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
        ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
        ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
        ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
        ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
        ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
        ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
        ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
        ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
        ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
        ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
        ACTION_SUBJECT_ID["PUNC"] = "punctuation";
        ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
        ACTION_SUBJECT_ID["RANGE"] = "range";
        ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
        ACTION_SUBJECT_ID["RESIZED"] = "resized";
        ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
        ACTION_SUBJECT_ID["SAVE"] = "save";
        ACTION_SUBJECT_ID["SECTION"] = "section";
        ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
        ACTION_SUBJECT_ID["STATUS"] = "status";
        ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
        ACTION_SUBJECT_ID["TABLE"] = "table";
        ACTION_SUBJECT_ID["TEXT"] = "text";
        ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
        ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
        ACTION_SUBJECT_ID["UNLINK"] = "unlink";
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
        ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
        ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
        ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
        ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
        ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    })($97c56ca7515fdb59$export$9957974f8b4d8f74 || ($97c56ca7515fdb59$export$9957974f8b4d8f74 = {}));
    var $97c56ca7515fdb59$export$75ef928acd21e35b;
    (function(FLOATING_CONTROLS_TITLE) {
        FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
        FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
        FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
        FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
        FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
        FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
        FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    })($97c56ca7515fdb59$export$75ef928acd21e35b || ($97c56ca7515fdb59$export$75ef928acd21e35b = {}));
    var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7;
    (function(CONTENT_COMPONENT) {
        CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
        CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
        CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    })($97c56ca7515fdb59$export$9f0b2adf3cfd71b7 || ($97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = {}));
});
parcelRegister("7R1zM", function(module, exports) {
    $parcel$export(module.exports, "unsupportedContentMessages", ()=>$757d518931aaa671$export$32ec96484dd3ba39);
    var $7VHMR;
    const $757d518931aaa671$export$32ec96484dd3ba39 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unsupportedInlineContent: {
            id: 'fabric.editor.unsupportedInlineContent',
            defaultMessage: 'Unsupported content',
            description: 'Unsupported content'
        },
        unsupportedBlockContent: {
            id: 'fabric.editor.unsupportedBlockContent',
            defaultMessage: 'This editor does not support displaying this content',
            description: 'This editor does not support displaying this content'
        },
        unsupportedContentTooltip: {
            id: 'fabric.editor.unsupportedContentTooltip',
            defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
            description: 'Content is not available in this editor, this will be preserved when you edit and save'
        }
    });
});
parcelRegister("d54NZ", function(module, exports) {
    $parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", ()=>$850930d0b79c2a61$export$d343369b8f25914);
    $parcel$export(module.exports, "fireUnsupportedEvent", ()=>$850930d0b79c2a61$export$e1051b410945e4d4);
    $parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", ()=>$850930d0b79c2a61$export$3a34598135e7219b);
    var $gkwXh;
    const $850930d0b79c2a61$var$whitelistedAttributes = [
        'align',
        'annotationType',
        'extensionKey',
        'extensionType',
        'layout',
        'type',
        'localId',
        'mode',
        'language',
        'timestamp',
        'state',
        'originalWidth',
        'originalHeight',
        'height',
        'width',
        'shortName',
        'level',
        'userType',
        'order',
        'panelType',
        'color',
        'style',
        'isNumberColumnEnabled',
        'colspan',
        'rowspan',
        'colwidth',
        'background'
    ];
    function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
        const { name: name } = node.type;
        return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
    }
    const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
        let sanitizedMarks = [];
        marks.forEach((mark)=>{
            if (mark.attrs) {
                const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
                sanitizedMarks.push({
                    ...mark,
                    attrs: attrs
                });
            } else sanitizedMarks.push({
                ...mark
            });
        });
        return sanitizedMarks;
    };
    const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
        let sanitizedAttrs = Object.assign({}, attrs);
        Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
            sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
        });
        return sanitizedAttrs;
    };
    const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        dispatchAnalyticsEvent({
            action: action,
            actionSubjectId: unsupportedContentType,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TOOLTIP,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI,
            attributes: {
                unsupportedNodeType: originalNodeType
            }
        });
    };
    const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
        const { type: nodeType, marks: nodeMarks } = node;
        const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
        const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
        const parentType = ancestorHierarchy.split(' ').pop() || '';
        if (nodeMarks.length) nodeMarks.forEach((mark)=>{
            if (mark.type === unsupportedMark) {
                const { originalValue: originalValue } = mark.attrs || {};
                const { type: type } = originalValue || {};
                const unsupportedNode = {
                    type: type || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: originalValue.attrs || {}
                };
                $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
            } else if (mark.type === unsupportedNodeAttribute) {
                const { unsupported: unsupported } = mark.attrs || {};
                const unsupportedNodeAttribute = {
                    type: nodeType.name || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: unsupported || {}
                };
                $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
            }
        });
        if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
            const { originalValue: originalValue } = node.attrs || {};
            const { marks: marks } = originalValue || [];
            const { attrs: attrs } = originalValue || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: marks || [],
                attrs: attrs || {}
            };
            const actionSubjectId = nodeType === unsupportedInline ? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
        } else node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
    };
    const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
        const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
        const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
        const sanitizedUnsupportedNode = {
            type: unsupportedNode.type,
            ancestry: unsupportedNode.ancestry,
            parentType: unsupportedNode.parentType,
            attrs: sanitizedAttrs,
            marks: sanitizedMarks
        };
        const payload = {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: actionSubjectId,
            attributes: {
                unsupportedNode: sanitizedUnsupportedNode,
                ...!!errorCode && {
                    errorCode: errorCode
                }
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
        dispatchAnalyticsEvent(payload);
    };
    const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
    };
});
parcelRegister("9tFGn", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContent", ()=>$3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
    function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
        let defaultLocale = 'en';
        let canTranslateToLocale = true;
        let locale = intl ? intl.locale : defaultLocale;
        let finalMessage = message.defaultMessage;
        if (node && locale.startsWith(defaultLocale)) {
            const { originalValue: originalValue } = node.attrs;
            if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
                finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
                canTranslateToLocale = false;
            } else if (originalValue.type) {
                finalMessage = `${prefix} ${originalValue.type}`;
                canTranslateToLocale = false;
            }
        }
        if (intl && canTranslateToLocale) return intl.formatMessage(message);
        return finalMessage;
    }
});
parcelRegister("2DpUZ", function(module, exports) {
    $parcel$export(module.exports, "WithCreateAnalyticsEvent", ()=>$10143a74d71d9da7$export$9ac3d19711324187);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    const $10143a74d71d9da7$export$9ac3d19711324187 = (0, (0, parcelRequire("cb25w")).default)()(class WithCreateAnalyticsEvent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return render(createAnalyticsEvent);
        }
    });
});
parcelRegister("iN9lO", function(module, exports) {
    $parcel$export(module.exports, "startMeasure", ()=>$420059dd531814dc$export$b62aa2130c86b59b);
    $parcel$export(module.exports, "stopMeasure", ()=>$420059dd531814dc$export$37c25be427bec097);
    $parcel$export(module.exports, "clearMeasure", ()=>$420059dd531814dc$export$6f766653554dac02);
    var $b7gJe;
    const $420059dd531814dc$var$measureMap = new Map();
    function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::start`);
        $420059dd531814dc$var$measureMap.set(measureName, performance.now());
    }
    function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::end`);
        const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
        try {
            performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
        } catch (error) {} finally{
            if (onMeasureComplete) {
                const entry = performance.getEntriesByName(measureName).pop();
                if (entry) onMeasureComplete(entry.duration, entry.startTime);
                else if (start) onMeasureComplete(performance.now() - start, start);
            }
            $420059dd531814dc$export$6f766653554dac02(measureName);
        }
    }
    function $420059dd531814dc$export$6f766653554dac02(measureName) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        $420059dd531814dc$var$measureMap.delete(measureName);
        performance.clearMarks(`${measureName}::start`);
        performance.clearMarks(`${measureName}::end`);
        performance.clearMeasures(measureName);
    }
});
parcelRegister("b7gJe", function(module, exports) {
    $parcel$export(module.exports, "isPerformanceAPIAvailable", ()=>$da51e67df7144cd5$export$b5717a625dd4a3eb);
    $parcel$export(module.exports, "isPerformanceObserverAvailable", ()=>$da51e67df7144cd5$export$48995af1e77d8643);
    let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
    function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
        if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType',
            'now'
        ].every((api)=>!!performance[api]);
        return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
    }
    function $da51e67df7144cd5$export$48995af1e77d8643() {
        return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
    }
    function $da51e67df7144cd5$export$4370ec0f52022f66() {
        return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
    }
});
parcelRegister("4NUlu", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAppearance", ()=>$d9ce436f8d702318$export$be87849653b93e6b);
    $parcel$export(module.exports, "getAnalyticsEditorAppearance", ()=>$d9ce436f8d702318$export$31ae53e002edded0);
    $parcel$export(module.exports, "getAnalyticsEventSeverity", ()=>$d9ce436f8d702318$export$f8edd689e8b20f3a);
    $parcel$export(module.exports, "analyticsEventKey", ()=>$d9ce436f8d702318$export$288273ee3e3b6132);
    var $d93fQ = parcelRequire("d93fQ");
    const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
        switch(appearance){
            case 'full-page':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
            case 'full-width':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
            case 'comment':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
            case 'chromeless':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
            case 'mobile':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        }
    };
    const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
    const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
        if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
        if (duration > degradedThreshold) return "blocking";
        return "normal";
    };
    var $d9ce436f8d702318$export$6a6bef12562cd865;
    (function(SEVERITY) {
        SEVERITY["NORMAL"] = "normal";
        SEVERITY["DEGRADED"] = "degraded";
        SEVERITY["BLOCKING"] = "blocking";
    })($d9ce436f8d702318$export$6a6bef12562cd865 || ($d9ce436f8d702318$export$6a6bef12562cd865 = {}));
    const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
});
parcelRegister("fc6h8", function(module, exports) {
    $parcel$export(module.exports, "shouldForceTracking", ()=>$d5e5ded83470406e$export$5b59d3e9e22dbdc6);
    const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
        try {
            const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
            return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
        } catch (err) {
            console.warn(err);
            return false;
        }
    };
});
parcelRegister("ap7h6", function(module, exports) {
    $parcel$export(module.exports, "getDistortedDurationMonitor", ()=>$3e05ce213e57560b$export$70f7d127254a90c);
    $parcel$export(module.exports, "measureRender", ()=>$3e05ce213e57560b$export$267ed650a5d21ae6);
    var $b7gJe;
    const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
        if (typeof document === 'undefined') return {
            distortedDuration: false,
            cleanup () {}
        };
        let distortedDuration = document.visibilityState !== 'visible';
        function handleVisibilityChange() {
            if (document.visibilityState !== 'visible') distortedDuration = true;
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return {
            distortedDuration: distortedDuration,
            cleanup () {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        };
    };
    function $3e05ce213e57560b$export$267ed650a5d21ae6(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        const startMark = `[START]: ${measureName}`;
        const endMark = `[END]: ${measureName}`;
        const startTime = performance.now();
        performance.mark(startMark);
        let distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                performance.mark(endMark);
                distortedDurationMonitor.cleanup();
                const duration = performance.now() - startTime;
                try {
                    performance.measure(measureName, startMark, endMark);
                    const entry = performance.getEntriesByName(measureName).pop();
                    if (!entry) onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                    else onMeasureComplete({
                        duration: entry.duration,
                        startTime: entry.startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                } catch (e) {
                    onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                }
                performance.clearMeasures(measureName);
                performance.clearMarks(startMark);
                performance.clearMarks(endMark);
            });
        });
    }
});
parcelRegister("gE8f9", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$6911d91f679e4e6c$export$3f2684e5d7cb1006);
    const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = navigator.userAgentData?.platform === 'Windows' || /Windows|Win\d+/i.test(navigator.userAgent);
        let ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
});
parcelRegister("kFiBa", function(module, exports) {
    $parcel$export(module.exports, "getResponseEndTime", ()=>$9d05c46136d117ff$export$92d097a1155bbe27);
    var $b7gJe;
    function $9d05c46136d117ff$export$92d097a1155bbe27() {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        const nav = performance.getEntriesByType('navigation')[0];
        if (nav) return nav.responseEnd;
        return;
    }
});
parcelRegister("4zXba", function(module, exports) {
    $parcel$export(module.exports, "normalizeFeatureFlags", ()=>$e819a2725d93345d$export$f1485fc4974593c0);
    $parcel$export(module.exports, "getEnabledFeatureFlagKeys", ()=>$e819a2725d93345d$export$6d018dd0f6cbebcb);
    var $e4eHl = parcelRequire("e4eHl");
    var $3T6Xo = parcelRequire("3T6Xo");
    const $e819a2725d93345d$var$EMPTY = {};
    function $e819a2725d93345d$var$isObjectFlagKey(key, value, objectFlagKeys) {
        return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
    }
    function $e819a2725d93345d$var$isValidJSONObject(value) {
        try {
            let result = JSON.parse(value);
            if (typeof result === 'object' && result !== null) return true;
            return false;
        } catch (err) {
            return false;
        }
    }
    function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
        if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
        return Object.entries(rawFeatureFlags).filter((e)=>{
            if (typeof e[1] === 'boolean') return true;
            if ($e819a2725d93345d$var$isObjectFlagKey((0, ($parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
            return false;
        }).filter(([key])=>(0, ($parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
                (0, ($parcel$interopDefault($e4eHl)))(key),
                value
            ]).reduce((flags, [key, value])=>{
            if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
            if (typeof value === 'boolean') flags[key] = value;
            return flags;
        }, {});
    }
    function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
        return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
    }
});
parcelRegister("9gOVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a549b54270369c2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCV8T;
    var $gmhCD = parcelRequire("gmhCD");
    var $3kKuL;
    parcelRequire("gJX6d");
    var $5KNWO;
    var $gJX6d;
    var $5BLIh;
    var $cKKwC;
    var $GDkvY;
    var $eQNWQ;
    var $5or39;
    var $K5Jsy;
    var $5r0mK = parcelRequire("5r0mK");
    var $bzwTW;
    var $bVGKe;
    var $h5tvG;
    var $3VpWO;
    function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
        return marksAndNodes.reduce((acc, markOrNode)=>{
            const prev = acc.length && acc[acc.length - 1] || null;
            if (markOrNode.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && prev && prev.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && Array.isArray(prev.content) && (0, (0, parcelRequire("eQNWQ")).isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
            else acc.push(markOrNode);
            return acc;
        }, []);
    }
    class $a549b54270369c2c$export$2e2bcd8739ae039 {
        constructor(init){
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.allowCopyToClipboard = false;
            this.allowWrapCodeBlock = false;
            this.allowPlaceholderText = true;
            this.allowCustomPanels = false;
            this.surroundTextNodesWithTextWrapper = false;
            this.allowAnnotations = false;
            this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
                const pos = this.startPos;
                const currentPath = parentInfo && parentInfo.path || [];
                const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
                const nodeKey = `${node.type.name}__${this.startPos}`;
                const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, (0, parcelRequire("gJX6d")).toReact)(node, {
                    allowSelectAllTrap: this.allowSelectAllTrap,
                    allowWindowedCodeBlock: this.allowWindowedCodeBlock
                }, this.nodeComponents), nodeKey, {
                    parentIsIncompleteTask: parentIsIncompleteTask,
                    path: [
                        ...currentPath,
                        node
                    ],
                    pos: this.startPos
                });
                this.startPos = pos + node.nodeSize;
                const marks = node.marks ? [
                    ...node.marks
                ] : [];
                const isMedia = node.type.name === 'media';
                const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
                const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
                return marks.reduceRight((content, mark)=>{
                    if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                    return this.renderMark((0, (0, parcelRequire("GDkvY")).toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
                }, serializedContent);
            };
            this.withMediaMarkProps = (node, mark, defaultProps)=>{
                if (mark.type.name === 'link' && node.type.name === 'media') return {
                    ...defaultProps,
                    isMediaLink: true
                };
                if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                    ...defaultProps,
                    isMediaInline: true
                };
                return defaultProps;
            };
            this.getUnsupportedContentProps = (node)=>{
                return {
                    node: node,
                    dispatchAnalyticsEvent: this.fireAnalyticsEvent
                };
            };
            this.getAnnotationMarkProps = (mark, marksParentPath)=>{
                const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                    if ((0, (0, parcelRequire("cKKwC")).isAnnotationMark)(parent)) return [
                        ...acc,
                        parent.attrs.id
                    ];
                    return acc;
                }, []);
                return {
                    id: mark.attrs.id,
                    annotationType: mark.attrs.annotationType,
                    annotationParentIds: annotationParentIds,
                    allowAnnotations: this.allowAnnotations,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
            };
            this.getMarkProps = (mark, marksParentPath, node)=>{
                if ((0, (0, parcelRequire("cKKwC")).isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
                const { key: key, ...otherAttrs } = mark.attrs;
                const extraProps = {
                    isInline: node?.isInline
                };
                const markSpecificProps = (0, (0, parcelRequire("bVGKe")).isCodeMark)(mark) ? {
                    codeBidiWarningTooltipEnabled: false
                } : {};
                const props = {
                    eventHandlers: this.eventHandlers,
                    fireAnalyticsEvent: this.fireAnalyticsEvent,
                    markKey: key,
                    ...otherAttrs,
                    ...extraProps,
                    ...markSpecificProps,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
                return props;
            };
            if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
                this.initStartPos = init.startPos || 1;
                this.startPos = init.startPos || 1;
            } else {
                this.initStartPos = 1;
                this.startPos = 1;
            }
            this.providers = init.providers;
            this.eventHandlers = init.eventHandlers;
            this.extensionHandlers = init.extensionHandlers;
            this.portal = init.portal;
            this.rendererContext = init.objectContext;
            this.appearance = init.appearance;
            this.disableHeadingIDs = init.disableHeadingIDs;
            this.disableActions = init.disableActions;
            this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
            this.allowCopyToClipboard = init.allowCopyToClipboard;
            this.allowWrapCodeBlock = init.allowWrapCodeBlock;
            this.allowPlaceholderText = init.allowPlaceholderText;
            this.allowCustomPanels = init.allowCustomPanels;
            this.allowColumnSorting = init.allowColumnSorting;
            this.fireAnalyticsEvent = init.fireAnalyticsEvent;
            this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
            this.allowAltTextOnImages = init.allowAltTextOnImages;
            this.stickyHeaders = init.stickyHeaders;
            this.allowMediaLinking = init.allowMediaLinking;
            this.allowAnnotations = Boolean(init.allowAnnotations);
            this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
            this.media = init.media;
            this.emojiResourceConfig = init.emojiResourceConfig;
            this.smartLinks = init.smartLinks;
            this.allowSelectAllTrap = init.allowSelectAllTrap;
            this.nodeComponents = init.nodeComponents;
            this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
            this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
            this.textHighlighter = init.textHighlighter;
            this.allowTableAlignment = init.allowTableAlignment;
            this.allowTableResizing = init.allowTableResizing;
        }
        resetState() {
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.startPos = this.initStartPos;
        }
        getNodeProps(node, parentInfo) {
            const path = parentInfo ? parentInfo.path : undefined;
            switch(node.type.name){
                case 'date':
                    return this.getDateProps(node, parentInfo, path);
                case 'hardBreak':
                    return this.getHardBreakProps(node, path);
                case 'heading':
                    return this.getHeadingProps(node, path);
                case 'media':
                    return this.getMediaProps(node, path);
                case 'emoji':
                    return this.getEmojiProps(node);
                case 'mediaGroup':
                    return this.getMediaGroupProps(node);
                case 'mediaInline':
                    return this.getMediaInlineProps(node);
                case 'mediaSingle':
                    return this.getMediaSingleProps(node, path);
                case 'table':
                    return this.getTableProps(node, path);
                case 'tableHeader':
                case 'tableRow':
                    return this.getTableChildrenProps(node);
                case 'taskItem':
                    return this.getTaskItemProps(node, path);
                case 'embedCard':
                    return this.getEmbedCardProps(node, path);
                case 'blockCard':
                    return this.getBlockCardProps(node, path);
                case 'expand':
                    return this.getExpandProps(node, path);
                case 'unsupportedBlock':
                case 'unsupportedInline':
                    return this.getUnsupportedContentProps(node);
                case 'codeBlock':
                    return this.getCodeBlockProps(node);
                case 'panel':
                    return this.getPanelProps(node);
                default:
                    return this.getProps(node, path);
            }
        }
        serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, (0, parcelRequire("5KNWO")).DocWithSelectAllTrap) : (0, (0, parcelRequire("5KNWO")).default), key = 'root-0', parentInfo) {
            if (key === 'root-0') this.resetState();
            return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
                if ((0, (0, parcelRequire("gJX6d")).isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                    index: index,
                    parentInfo: parentInfo
                });
                return this.serializeFragmentChild(node, {
                    index: index,
                    parentInfo: parentInfo
                });
            }));
        }
        serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
            const currentPath = parentInfo && parentInfo.path || [];
            const nodePosition = parentInfo && parentInfo.pos || 1;
            return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
                return this.serializeMark({
                    mark: mark,
                    parentNode: {
                        path: currentPath,
                        pos: nodePosition
                    },
                    parentMark: {
                        path: [
                            mark
                        ]
                    }
                });
            });
        }
        serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
            if (!(0, (0, parcelRequire("gJX6d")).isTextNode)(mark)) {
                const serializeContent = (childMark, index)=>this.serializeMark({
                        mark: childMark,
                        parentNode: parentNode,
                        parentMark: {
                            path: [
                                ...parentMark.path,
                                childMark
                            ]
                        }
                    });
                const content = (mark.content || []).map(serializeContent);
                const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
                return this.renderMark((0, (0, parcelRequire("GDkvY")).toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
            }
            const startPos = this.startPos;
            const endPos = startPos + mark.nodeSize;
            this.startPos = endPos;
            const textKey = `text-wrapper_${this.startPos}`;
            if (this.surroundTextNodesWithTextWrapper) {
                const parentDepth = Math.max(parentNode.path.length - 1, 0);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5BLIh")).default), {
                    key: textKey,
                    startPos: startPos + parentDepth,
                    endPos: endPos + parentDepth,
                    textHighlighter: this.textHighlighter,
                    marks: mark.marks
                }, mark.text);
            }
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(mark.text, this.textHighlighter);
            return (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
        }
        renderNode(NodeComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(NodeComponent, {
                key: key,
                ...props
            }, content);
        }
        renderMark(MarkComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(MarkComponent, {
                key: key,
                ...props
            }, content);
        }
        getTableChildrenProps(node) {
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting
            };
        }
        getTableProps(node, path = []) {
            const stickyHeaders = !(0, (0, parcelRequire("bzwTW")).insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            const isInsideMultiBodiedExtension = (0, (0, parcelRequire("bzwTW")).insideMultiBodiedExtension)(path, node.type.schema);
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting,
                columnWidths: (0, (0, parcelRequire("5or39")).calcTableColumnWidths)(node),
                tableNode: node,
                stickyHeaders: stickyHeaders,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
                allowTableAlignment: this.allowTableAlignment,
                allowTableResizing: this.allowTableResizing
            };
        }
        getDateProps(node, parentInfo, path = []) {
            return {
                timestamp: node.attrs && node.attrs.timestamp,
                parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
                dataAttributes: {
                    'data-renderer-start-pos': this.startPos + path.length
                }
            };
        }
        getMediaSingleProps(node, path = []) {
            const { marks: { link: link } } = node.type.schema;
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            const isLinkMark = (mark)=>mark.type === link;
            const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
            return {
                ...this.getProps(node, path),
                isInsideOfBlockNode: isInsideOfBlockNode,
                childHasLink: childHasLink,
                allowCaptions: this.media && this.media.allowCaptions,
                featureFlags: this.media && this.media.featureFlags
            };
        }
        getMediaProps(node, path = []) {
            const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
            const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
            const isAnnotationMark = (mark)=>mark.type === annotation;
            const isLinkMark = (mark)=>mark.type === link;
            const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
            return {
                ...this.getProps(node, path),
                marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
                isLinkMark: isLinkMark,
                isBorderMark: isBorderMark,
                isAnnotationMark: isAnnotationMark,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                ssr: this.media?.ssr,
                allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
            };
        }
        getEmojiProps(node) {
            return {
                ...this.getProps(node),
                resourceConfig: this.emojiResourceConfig
            };
        }
        getEmbedCardProps(node, path = []) {
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            return {
                ...this.getProps(node),
                isInsideOfBlockNode: isInsideOfBlockNode
            };
        }
        getBlockCardProps(node, path = []) {
            return {
                ...this.getProps(node),
                isNodeNested: path.length > 0
            };
        }
        getMediaGroupProps(node) {
            return {
                ...this.getProps(node),
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                enableDownloadButton: this.media?.enableDownloadButton,
                ssr: this.media?.ssr
            };
        }
        getMediaInlineProps(node) {
            return {
                ...this.getProps(node),
                ssr: this.media?.ssr
            };
        }
        getTaskItemProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                disabled: this.disableActions
            };
        }
        getHardBreakProps(node, path = []) {
            let forceNewLine = false;
            const parentNode = path.length > 0 ? path[path.length - 1] : null;
            if (parentNode && parentNode.lastChild === node) forceNewLine = true;
            return {
                ...this.getProps(node),
                forceNewLine: forceNewLine
            };
        }
        getCodeBlockProps(node) {
            const codeBidiWarningTooltipEnabled = false;
            return {
                ...this.getProps(node),
                text: node.textContent,
                codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
            };
        }
        getPanelProps(node) {
            return {
                ...this.getProps(node),
                allowCustomPanels: this.allowCustomPanels
            };
        }
        getProps(node, path = []) {
            const startPos = this.startPos + path.length;
            return {
                text: node.text,
                providers: this.providers,
                eventHandlers: this.eventHandlers,
                extensionHandlers: this.extensionHandlers,
                portal: this.portal,
                rendererContext: this.rendererContext,
                serializer: this,
                content: node.content ? node.content.toJSON() : undefined,
                allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
                allowCopyToClipboard: this.allowCopyToClipboard,
                allowWrapCodeBlock: this.allowWrapCodeBlock,
                allowPlaceholderText: this.allowPlaceholderText,
                rendererAppearance: this.appearance,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                nodeType: node.type.name,
                marks: node.marks,
                smartLinks: this.smartLinks,
                isInsideOfInlineExtension: this.isInsideOfInlineExtension,
                dataAttributes: {
                    'data-renderer-start-pos': startPos
                },
                startPos: startPos,
                path: path,
                ...node.attrs
            };
        }
        headingAnchorSupported(path = []) {
            const isImmediateParent = (path, nodeName)=>{
                return path.length > 0 && path[path.length - 1].type.name === nodeName;
            };
            return (0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
        }
        getHeadingProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                content: node.content ? node.content.toJSON() : undefined,
                headingId: this.getHeadingId(node, this.headingIds),
                showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
            };
        }
        getExpandProps(node, path = []) {
            if (!(0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
            const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
            return {
                ...this.getProps(node),
                nestedHeaderIds: nestedHeaderIds
            };
        }
        getHeadingId(node, headingIds) {
            if (this.disableHeadingIDs || !node.content.size) return;
            const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, (0, parcelRequire("K5Jsy")).getText)(node) || ''), '').trim().replace(/\s/g, '-');
            if (!nodeContent) return;
            return this.getUniqueHeadingId(nodeContent, headingIds);
        }
        getUniqueHeadingId(baseId, headingIds, counter = 0) {
            if (counter === 0 && headingIds.indexOf(baseId) === -1) {
                headingIds.push(baseId);
                return baseId;
            } else if (counter !== 0) {
                const headingId = `${baseId}.${counter}`;
                if (headingIds.indexOf(headingId) === -1) {
                    headingIds.push(headingId);
                    return headingId;
                }
            }
            return this.getUniqueHeadingId(baseId, headingIds, ++counter);
        }
        static getChildNodes(fragment) {
            const children = [];
            fragment.forEach((node)=>{
                children.push(node);
            });
            return (0, (0, parcelRequire("gJX6d")).mergeTextNodes)(children);
        }
        static getMarks(node) {
            if (!node.marks || node.marks.length === 0) return [];
            return (0, (0, parcelRequire("eQNWQ")).getMarksByOrder)(node.marks);
        }
        static buildMarkStructure(content) {
            return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
                const nodeMarks = this.getMarks(node);
                if (nodeMarks.length === 0) return node;
                return nodeMarks.reverse().reduce((acc, mark)=>{
                    const { eq: eq } = mark;
                    return {
                        ...mark,
                        eq: eq,
                        content: [
                            acc
                        ]
                    };
                }, node);
            }));
        }
        static fromSchema(_, init) {
            return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
        }
    }
});
parcelRegister("3kKuL", function(module, exports) {
    $parcel$export(module.exports, "isNestedHeaderLinksEnabled", ()=>$e845fca6b21fd822$export$7aa7587d1ce9583c);
    $parcel$export(module.exports, "getActiveHeadingId", ()=>$e845fca6b21fd822$export$acb253d79d72af92);
    function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
        if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
        const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
        return !!allowNestedHeaderLinks;
    }
    function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
        if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
        return allowHeadingAnchorLinks.activeHeadingId;
    }
});
parcelRegister("gJX6d", function(module, exports) {
    $parcel$export(module.exports, "InlineCard", ()=>$2b5167c1d6aa176d$export$aff6291803939b05);
    $parcel$export(module.exports, "nodeToReact", ()=>$2b5167c1d6aa176d$export$3931063f6a5f290e);
    $parcel$export(module.exports, "toReact", ()=>$2b5167c1d6aa176d$export$d4334b129116aad7);
    $parcel$export(module.exports, "mergeTextNodes", ()=>$2b5167c1d6aa176d$export$8045509d14b5046f);
    $parcel$export(module.exports, "isTextWrapper", ()=>$2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
    $parcel$export(module.exports, "isTextNode", ()=>$2b5167c1d6aa176d$export$ccbedd67ef6e9417);
    $parcel$export(module.exports, "Doc", ()=>(parcelRequire("5KNWO")).default);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>(parcelRequire("5KNWO")).DocWithSelectAllTrap);
    var $4qBtX = parcelRequire("4qBtX");
    var $atrOQ;
    var $4dtZR;
    var $bQeYo;
    var $cOnYv;
    var $cWRvh;
    var $5KNWO;
    var $i8Zwf;
    var $lKIDi;
    var $7AttJ;
    var $112O7;
    var $ieJGA;
    var $3RqVz;
    var $qjsNK;
    var $jHa9U;
    var $6svWT;
    var $9FXQX;
    var $hqBb9;
    var $ixoQV;
    var $dkc63;
    var $cWojJ;
    var $i4Lgj;
    var $gfMkN;
    var $iiXGq;
    var $9kpKZ;
    const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8BH8p")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6seAF")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("xgpzA")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("vMisH")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("i873P")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("lOJRn")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6tOdT")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("hC3g2")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("j2dSX")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("7F34O")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("d129d")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("lVGRg")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("2Rdcz")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("2z3Jr")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("RmF2p")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("d6mGh")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("lFguI")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("h4pi8")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("dZ3Pj")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
        blockquote: (0, (0, parcelRequire("atrOQ")).default),
        bulletList: (0, (0, parcelRequire("cWRvh")).default),
        blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
        caption: (0, (0, parcelRequire("jHa9U")).default),
        date: $2b5167c1d6aa176d$export$6341f9a885713487,
        decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
        decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
        doc: (0, (0, parcelRequire("5KNWO")).default),
        emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
        extension: (0, (0, parcelRequire("i8Zwf")).default),
        bodiedExtension: (0, (0, parcelRequire("4dtZR")).default),
        multiBodiedExtension: (0, (0, parcelRequire("bQeYo")).default),
        extensionFrame: (0, (0, parcelRequire("cOnYv")).default),
        hardBreak: (0, (0, parcelRequire("lKIDi")).default),
        heading: (0, (0, parcelRequire("7AttJ")).default),
        inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
        inlineExtension: (0, (0, parcelRequire("112O7")).default),
        layoutSection: (0, (0, parcelRequire("ieJGA")).default),
        layoutColumn: (0, (0, parcelRequire("3RqVz")).default),
        listItem: (0, (0, parcelRequire("qjsNK")).default),
        media: $2b5167c1d6aa176d$export$7fc53215244aec38,
        mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
        mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
        mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
        mention: $2b5167c1d6aa176d$export$e891316fea657d90,
        orderedList: (0, (0, parcelRequire("6svWT")).default),
        panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
        paragraph: (0, (0, parcelRequire("9FXQX")).default),
        placeholder: (0, (0, parcelRequire("hqBb9")).default),
        rule: (0, (0, parcelRequire("ixoQV")).default),
        status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
        taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
        taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
        table: (0, (0, parcelRequire("dkc63")).default),
        tableCell: (0, (0, parcelRequire("cWojJ")).TableCell),
        tableHeader: (0, (0, parcelRequire("cWojJ")).TableHeader),
        tableRow: (0, (0, parcelRequire("i4Lgj")).default),
        unknownBlock: (0, (0, parcelRequire("gfMkN")).default),
        unsupportedBlock: (0, (0, parcelRequire("iiXGq")).default),
        unsupportedInline: (0, (0, parcelRequire("9kpKZ")).default),
        expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
        nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
        embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
    };
    const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
        if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, (0, parcelRequire("5KNWO")).DocWithSelectAllTrap;
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
            return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
        }
        const nodes = {
            ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
            ...nodeComponents
        };
        return nodes[node.type.name];
    };
    const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
        return nodes.reduce((acc, current)=>{
            if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
                acc.push(current);
                return acc;
            }
            if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
                const textWrapper = acc[acc.length - 1];
                textWrapper.content.push(current);
                textWrapper.nodeSize += current.nodeSize;
            } else acc.push({
                type: {
                    name: 'textWrapper'
                },
                content: [
                    current
                ],
                nodeSize: current.nodeSize
            });
            return acc;
        }, []);
    };
    const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
        return type === 'text';
    };
    const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
        return node.type.name === 'textWrapper';
    };
    function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
        return node.type.name === 'text';
    }
    const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
    const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
        if (doc.childCount !== 1) return false;
        const parentNodes = [];
        doc.forEach((child)=>parentNodes.push(child));
        const node = parentNodes[0];
        return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
    };
    const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
        const content = [];
        if (pnode.childCount > 7) return false;
        pnode.forEach((child)=>content.push(child));
        let emojiCount = 0;
        for(let i = 0; i < content.length; ++i){
            const node = content[i];
            switch(node.type.name){
                case 'text':
                    if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                    continue;
                case 'emoji':
                    if (++emojiCount > 3) return false;
                    continue;
                default:
                    return false;
            }
        }
        return emojiCount > 0;
    };
});
parcelRegister("atrOQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d51d57a125840f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("blockquote", null, props.children);
    }
});
parcelRegister("4dtZR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9e9d2beaec6b895$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $i8Zwf;
    var $8Eu7T;
    var $fAZXL;
    var $cWCI0;
    var $gkwXh;
    var $4YrGg;
    const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Eu7T")).ErrorBoundary), {
            component: (0, (0, parcelRequire("cWCI0")).ACTION_SUBJECT).RENDERER,
            componentId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EXTENSION_BODIED,
            createAnalyticsEvent: createAnalyticsEvent,
            additionalInfo: `${extensionType}: ${extensionKey} `
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YrGg")).AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "bodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("i8Zwf")).renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                }, removeOverflow);
            } catch (e) {}
            return (0, (0, parcelRequire("i8Zwf")).renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        })));
    };
    var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;
});
parcelRegister("i8Zwf", function(module, exports) {
    $parcel$export(module.exports, "renderExtension", ()=>$1a97cbb70a611ae8$export$b7482bdc8aff85e4);
    $parcel$export(module.exports, "default", ()=>$1a97cbb70a611ae8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fAZXL;
    var $ajc8Z;
    var $4ceoy;
    var $eOOFp;
    var $l8Gxi;
    const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const { isTopLevel: isTopLevel = true } = options || {};
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: options.handleRef,
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: overflowContainerClass
            }, content)));
    };
    const $1a97cbb70a611ae8$var$Extension = (props)=>{
        const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "extension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                });
            } catch (e) {}
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        });
    };
    var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ajc8Z")).default)($1a97cbb70a611ae8$var$Extension, {
        overflowSelector: `.${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    });
});
parcelRegister("fAZXL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45cce7a6859f4709$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $gnH2s;
    var $9Egzu;
    var $2vGdQ;
    const $45cce7a6859f4709$var$inlineExtensionStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
        margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
        '& .rich-media-item': {
            maxWidth: '100%'
        }
    });
    function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
        const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
        const isMounted = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        const localGetNodeRenderer = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>(0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("gnH2s")).getNodeRenderer)), []);
        const [extensionProvider, setExtensionProvider] = (0, ($parcel$interopDefault($5uXOq))).useState(null);
        const handleProvider = (0, ($parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
            providerPromise && providerPromise.then((provider)=>{
                if (isMounted.current) setExtensionProvider(provider);
            });
        }, []);
        const renderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
            const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const node = {
                type: type,
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content || text,
                localId: localId,
                fragmentLocalId: fragmentLocalId
            };
            let result = null;
            try {
                if (extensionHandlers && extensionHandlers[extensionType]) {
                    const render = (0, (0, parcelRequire("2vGdQ")).getExtensionRenderer)(extensionHandlers[extensionType]);
                    result = render(node, rendererContext.adDoc);
                }
                if (!result && extensionProvider) {
                    const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                    if (node.type === 'multiBodiedExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node,
                        actions: actions
                    });
                    else if (node.type === 'inlineExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    });
                }
            } catch (e) {}
            return children({
                result: result
            });
        }, [
            actions,
            children,
            content,
            extensionHandlers,
            extensionKey,
            extensionType,
            localGetNodeRenderer,
            localId,
            marks,
            parameters,
            rendererContext?.adDoc,
            text,
            type
        ]);
        const setupAndRenderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((providers)=>{
            if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
            return renderExtensionNode(extensionProvider);
        }, [
            extensionProvider,
            handleProvider,
            renderExtensionNode
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, []);
        if (!props.providers) return setupAndRenderExtensionNode({});
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Egzu")).WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: props.providers,
            renderNode: setupAndRenderExtensionNode
        });
    }
    const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: "inline-extension-renderer",
            css: $45cce7a6859f4709$var$inlineExtensionStyle
        }, children));
    };
});
parcelRegister("gnH2s", function(module, exports) {
    $parcel$export(module.exports, "getExtensionModuleNode", ()=>$36d4284a17bc60a0$export$82dd45c2db936caf);
    $parcel$export(module.exports, "getExtensionModuleNodePrivateProps", ()=>$36d4284a17bc60a0$export$426f8efd8690d8aa);
    $parcel$export(module.exports, "getNodeRenderer", ()=>$36d4284a17bc60a0$export$67a7d49db68d30a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $izxHQ;
    async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
        const [extKey, nodeKey] = (0, (0, parcelRequire("izxHQ")).getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const manifest = await extensionProvider.getExtension(extensionType, extKey);
        if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
        if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
        const node = manifest.modules.nodes[nodeKey];
        if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
        return node;
    }
    async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
        const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
        return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
            acc[key] = moduleNode[key];
            return acc;
        }, {});
    }
    function $36d4284a17bc60a0$var$ExtensionLoading(props) {
        if (props.error || props.timedOut) {
            console.error('Error rendering extension', props.error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "Error loading the extension!");
        } else return null;
    }
    function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>{
                return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, (0, parcelRequire("izxHQ")).resolveImport)(node.render()));
            },
            loading: $36d4284a17bc60a0$var$ExtensionLoading
        });
    }
});
parcelRegister("izxHQ", function(module, exports) {
    $parcel$export(module.exports, "getExtensionKeyAndNodeKey", ()=>$23c4e3f9598df846$export$8a49818572e1d105);
    $parcel$export(module.exports, "buildAction", ()=>$23c4e3f9598df846$export$bb33bcdd9a10a608);
    $parcel$export(module.exports, "resolveImport", ()=>$23c4e3f9598df846$export$d69c9b451c47653b);
    const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
    const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
        if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
            extensionKey,
            'default'
        ];
        const [extKey, nodeKey = 'default'] = extensionKey.split(':');
        return [
            extKey,
            nodeKey
        ];
    };
    const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
        if (!nodeKey || nodeKey === 'default') return extensionKey;
        return `${extensionKey}:${nodeKey}`;
    };
    function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
        if (typeof action === 'function') return action;
        if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
    }
    const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
        const importedModule = await importPromise;
        return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
    };
    function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
        if (!manifest.modules.nodes) return;
        const node = manifest.modules.nodes[action.key];
        const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
        const extension = {
            type: node.type,
            attrs: {
                extensionType: manifest.type,
                extensionKey: extensionKey,
                parameters: action.parameters
            }
        };
        if (node.type === 'bodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'paragraph',
                    content: []
                }
            ]
        };
        else if (node.type === 'multiBodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'extensionFrame',
                    content: [
                        {
                            type: 'paragraph',
                            content: []
                        }
                    ]
                }
            ]
        };
        return extension;
    }
});
parcelRegister("9Egzu", function(module, exports) {
    $parcel$export(module.exports, "WithProviders", ()=>$76144329c6f313cf$export$d498ee8be33e096f);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
        static{
            this.displayName = 'WithProviders';
        }
        constructor(props){
            super(props);
            this.mounted = false;
            this.handleProviderIfMounted = (name, provider)=>{
                if (!this.mounted) return;
                this.handleProvider(name, provider);
            };
            this.handleProvider = (name, provider)=>{
                this.setState(({ providers: providers })=>{
                    return {
                        providers: {
                            ...providers,
                            [name]: provider
                        }
                    };
                });
            };
            this.mounted = false;
            const providers = {};
            this.props.providers.forEach((name)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) {
                    const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
                    providers[name] = providerPromise;
                } else providers[name] = undefined;
            });
            this.state = {
                providers: providers
            };
        }
        componentDidMount() {
            this.mounted = true;
        }
        UNSAFE_componentWillMount() {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) {
                const { providers: providers, providerFactory: providerFactory } = this.props;
                providers.forEach((name)=>{
                    providerFactory.subscribe(name, this.handleProvider);
                });
            }
        }
        componentWillUnmount() {
            const { providers: providers, providerFactory: providerFactory } = this.props;
            providers.forEach((name)=>{
                providerFactory.unsubscribe(name, this.handleProvider);
            });
        }
        render() {
            const { state: state, props: props } = this;
            const { renderNode: renderNode } = props;
            return renderNode(state.providers);
        }
    }
});
parcelRegister("2vGdQ", function(module, exports) {
    $parcel$export(module.exports, "getExtensionRenderer", ()=>$f7ce50c6d2d400b7$export$9214452ef07eda7);
    function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
        if (typeof extensionHandler === 'object') return extensionHandler.render;
        else return extensionHandler;
    }
});
parcelRegister("ajc8Z", function(module, exports) {
    $parcel$export(module.exports, "shadowClassNames", ()=>$0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
    $parcel$export(module.exports, "default", ()=>$0d6cb6e0383d0ba0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bbl9Y;
    const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
        RIGHT_SHADOW: 'right-shadow',
        LEFT_SHADOW: 'left-shadow'
    };
    function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
        return class OverflowShadow extends (0, ($parcel$interopDefault($5uXOq))).Component {
            componentWillUnmount() {
                if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
                if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
                this.updateShadows();
            }
            componentDidUpdate() {
                if (!options.useShadowObserver) this.updateShadows();
            }
            initShadowObserver() {
                if (this.shadowObserver || !this.overflowContainer) return;
                this.shadowObserver = new (0, (0, parcelRequire("bbl9Y")).ShadowObserver)({
                    scrollContainer: this.overflowContainer,
                    onUpdateShadows: (shadowStates)=>{
                        this.setState((prevState)=>{
                            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                            if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                                showLeftShadow: showLeftShadow,
                                showRightShadow: showRightShadow
                            };
                            return null;
                        });
                    }
                });
            }
            render() {
                const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
                let classNames = [
                    showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                    showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                    options.useShadowObserver && (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SHADOW_CONTAINER
                ].filter(Boolean).join(' ');
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    handleRef: this.handleContainer,
                    shadowClassNames: classNames,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.overflowContainerWidth = 0;
                this.state = {
                    showLeftShadow: false,
                    showRightShadow: false
                };
                this.handleScroll = (event)=>{
                    if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                    this.updateShadows();
                };
                this.updateShadows = ()=>{
                    if (options.useShadowObserver) return;
                    this.setState((prevState)=>{
                        if (!this.overflowContainer) return;
                        const diff = this.calcOverflowDiff();
                        const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                        const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                };
                this.showLeftShadow = (overflowContainer)=>{
                    return !!overflowContainer && overflowContainer.scrollLeft > 0;
                };
                this.calcOverflowDiff = ()=>{
                    if (!this.overflowContainer) return 0;
                    this.diff = this.calcScrollableWidth();
                    return this.diff - this.overflowContainer.offsetWidth;
                };
                this.calcScrollableWidth = ()=>{
                    if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                    if (!this.scrollable) return 0;
                    let width = 0;
                    for(let i = 0; i < this.scrollable.length; i++){
                        const scrollableElement = this.scrollable[i];
                        width += scrollableElement.scrollWidth;
                    }
                    return width;
                };
                this.handleContainer = (container)=>{
                    if (!container || this.container) return;
                    this.container = container;
                    this.overflowContainer = container.querySelector(options.overflowSelector);
                    if (!this.overflowContainer) this.overflowContainer = container;
                    if (options.useShadowObserver) {
                        this.initShadowObserver();
                        return;
                    }
                    this.updateShadows();
                    this.overflowContainer.addEventListener('scroll', this.handleScroll);
                };
            }
        };
    }
});
parcelRegister("bbl9Y", function(module, exports) {
    $parcel$export(module.exports, "shadowObserverClassNames", ()=>$cd027df5593f4e8b$export$1cbe0bb16052178d);
    $parcel$export(module.exports, "ShadowObserver", ()=>$cd027df5593f4e8b$export$51a5b28e4fb2dba2);
    var $cd027df5593f4e8b$export$ebeea2fe2e93862e;
    (function(ShadowKeys) {
        ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
        ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    })($cd027df5593f4e8b$export$ebeea2fe2e93862e || ($cd027df5593f4e8b$export$ebeea2fe2e93862e = {}));
    const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
        SENTINEL_LEFT: 'sentinel-left',
        SENTINEL_RIGHT: 'sentinel-right',
        SHADOW_CONTAINER: 'with-shadow-observer'
    };
    const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
        return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
    };
    const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
        return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
    };
    class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
        constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
            this.sentinels = {};
            this.shadowStates = {
                ["showLeftShadow"]: false,
                ["showRightShadow"]: false
            };
            this.init = ()=>{
                if (!this.scrollContainer || this.intersectionObserver) return;
                this.sentinels.right = document.createElement('div');
                this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
                this.scrollContainer.appendChild(this.sentinels.right);
                this.sentinels.left = document.createElement('div');
                this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
                this.scrollContainer.prepend(this.sentinels.left);
                this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                    entries.forEach(this.onIntersect);
                }, {
                    root: this.scrollContainer,
                    rootMargin: '1px'
                });
                this.intersectionObserver.observe(this.sentinels.left);
                this.intersectionObserver.observe(this.sentinels.right);
            };
            this.onIntersect = (entry)=>{
                this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                    if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                    if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                    this.onUpdateShadows(this.shadowStates);
                });
            };
            this.scrollContainer = scrollContainer;
            this.onUpdateShadows = onUpdateShadows;
            this.init();
        }
        dispose() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = undefined;
                this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
            }
        }
    }
});
parcelRegister("eOOFp", function(module, exports) {
    $parcel$export(module.exports, "breakoutConsts", ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c);
    $parcel$export(module.exports, "absoluteBreakoutWidth", ()=>$081c5ce54850cd88$export$b34ea040d1533a3);
    $parcel$export(module.exports, "calcWideWidth", ()=>$081c5ce54850cd88$export$86325001fe8f3adc);
    $parcel$export(module.exports, "calcBreakoutWidth", ()=>$081c5ce54850cd88$export$5f4502874a28dfce);
    $parcel$export(module.exports, "calcBreakoutWithCustomWidth", ()=>$081c5ce54850cd88$export$ccc0a02edddeed39);
    $parcel$export(module.exports, "calculateBreakoutStyles", ()=>$081c5ce54850cd88$export$c377853ecdd53e5b);
    $parcel$export(module.exports, "calcBreakoutWidthPx", ()=>$081c5ce54850cd88$export$586300c53bd298dd);
    $parcel$export(module.exports, "getNextBreakoutMode", ()=>$081c5ce54850cd88$export$7eb758567e6644fd);
    $parcel$export(module.exports, "getTitle", ()=>$081c5ce54850cd88$export$70d1bf7729efff40);
    var $iHYdz;
    var $8DYpW;
    var $9Iju4;
    var $4ceoy;
    var $eQcNy;
    const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
        padding: (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding),
        defaultLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth),
        wideScaleRatio: (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio),
        fullWidthLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth),
        wideLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth),
        mapBreakpointToLayoutMaxWidth: (0, parcelRequire("9Iju4")).mapBreakpointToLayoutMaxWidth,
        getBreakpoint: (0, parcelRequire("4ceoy")).getBreakpoint,
        calcBreakoutWidth: (layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    let wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
        calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
        calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
            const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
    };
    const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
        const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
        if (breakoutWidth.endsWith('%')) switch(layout){
            case 'full-width':
                return 0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth;
            default:
                return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        }
        return parseInt(breakoutWidth, 10);
    };
    const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
    const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
    const $081c5ce54850cd88$export$ccc0a02edddeed39 = (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$5f4502874a28dfce(mode, editorContainerWidth);
    };
    function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
        const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
        const breakoutWidthPx = (0, (0, parcelRequire("eQcNy")).parsePx)(breakoutWidth);
        if (!widthStateLineLength) return {
            type: 'line-length-unknown',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            display: 'flex',
            justifyContent: 'center',
            transform: 'none',
            transition: `min-width 0.5s ${0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier}`
        };
        return {
            type: 'line-length-known',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            transition: `min-width 0.5s ${0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier}`,
            transform: `translateX(-50%)`,
            marginLeft: `50%`
        };
    }
    function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
        return (0, (0, parcelRequire("eQcNy")).parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
    }
    const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
        if (currentMode === 'full-width') return 'center';
        else if (currentMode === 'wide') return 'full-width';
        return 'wide';
    };
    const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
        switch(layout){
            case 'full-width':
                return (0, (0, parcelRequire("8DYpW")).default).layoutFixedWidth;
            case 'wide':
                return (0, (0, parcelRequire("8DYpW")).default).layoutFullWidth;
            default:
                return (0, (0, parcelRequire("8DYpW")).default).layoutWide;
        }
    };
});
parcelRegister("8DYpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb832a3bfaa1d66d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $l9HLU;
    var $8cp3a;
    var $9NKqk;
    var $fJyLQ;
    var $gSYO9;
    var $jDuvE;
    var $lQKNV;
    var $2i4K4;
    var $eX53M;
    var $80CM7;
    var $kXnoC;
    var $eDTMN;
    var $2V0EL;
    var $kFJBG;
    var $7S9ZN;
    var $6OcHr;
    var $dbepQ;
    var $kANLZ;
    var $kmmxF;
    var $80TXs;
    var $9QBHe;
    var $kAM3u;
    var $6lWmZ;
    var $ixwvf;
    var $fJm1A;
    var $ecAvy;
    var $7ywdr;
    var $1ElKj;
    var $3AEXe;
    var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        layoutFixedWidth: {
            id: 'fabric.editor.layoutFixedWidth',
            defaultMessage: 'Back to center',
            description: 'Display your element (image, table, extension, etc) as standard width'
        },
        layoutWide: {
            id: 'fabric.editor.layoutWide',
            defaultMessage: 'Go wide',
            description: 'Display your element (image, table, extension, etc) wider than normal'
        },
        layoutFullWidth: {
            id: 'fabric.editor.layoutFullWidth',
            defaultMessage: 'Go full width',
            description: 'Display your element (image, table, extension, etc) as full width'
        },
        alignImageRight: {
            id: 'fabric.editor.alignImageRight',
            defaultMessage: 'Align right',
            description: 'Aligns image to the right'
        },
        alignImageCenter: {
            id: 'fabric.editor.alignImageCenter',
            defaultMessage: 'Align center',
            description: 'Aligns image to the center'
        },
        alignImageLeft: {
            id: 'fabric.editor.alignImageLeft',
            defaultMessage: 'Align left',
            description: 'Aligns image to the left'
        },
        remove: {
            id: 'fabric.editor.remove',
            defaultMessage: 'Remove',
            description: 'Delete the element (image, panel, table, etc.) from your document'
        },
        removeEmoji: {
            id: 'fabric.editor.removeEmoji',
            defaultMessage: 'Remove emoji',
            description: 'Remove the emoji panel icon from custom panel'
        },
        visit: {
            id: 'fabric.editor.visit',
            defaultMessage: 'Open link in a new window',
            description: 'Open the link in a new window'
        },
        inviteToEditButtonTitle: {
            id: 'fabric.editor.editMode.inviteToEditButton.title',
            defaultMessage: 'Invite to edit',
            description: 'Invite another user to edit the current document'
        },
        saveButton: {
            id: 'fabric.editor.saveButton',
            defaultMessage: 'Save',
            description: 'Submit and save a comment or document'
        },
        cancelButton: {
            id: 'fabric.editor.cancelButton',
            defaultMessage: 'Cancel',
            description: 'Discard the current comment or document'
        },
        taskList: {
            id: 'fabric.editor.tooltip.taskList',
            defaultMessage: 'an action item',
            description: 'an action item in the Editor'
        },
        bulletList: {
            id: 'fabric.editor.tooltip.bulletList',
            defaultMessage: 'a list',
            description: 'a list item in the Editor'
        },
        nestedExpand: {
            id: 'fabric.editor.tooltip.nestedExpand',
            defaultMessage: 'a nested expand',
            description: 'expand node which is nested'
        },
        decisionList: {
            id: 'fabric.editor.tooltip.decisionList',
            defaultMessage: 'a decision list',
            description: 'a list of decisions'
        },
        defaultBlockNode: {
            id: 'fabric.editor.tooltip.defaultBlockNode',
            defaultMessage: 'a block node',
            description: 'a block node element'
        },
        panel: {
            id: 'fabric.editor.tooltip.blockPanel',
            defaultMessage: 'a panel',
            description: 'Panel node in the Editor'
        },
        blockquote: {
            id: 'fabric.editor.blockquote',
            defaultMessage: 'a quote',
            description: 'a quote node'
        },
        timeUpdated: {
            id: 'fabric.editor.time.updated',
            defaultMessage: 'Updated',
            description: 'Time last updated'
        },
        timeViewed: {
            id: 'fabric.editor.time.viewed',
            defaultMessage: 'Viewed',
            description: 'Time last viewed'
        },
        timeAgo: {
            id: 'fabric.editor.time.ago',
            defaultMessage: 'ago',
            description: 'Some time ago'
        },
        copyToClipboard: {
            id: 'fabric.editor.copyToClipboard',
            defaultMessage: 'Copy',
            description: 'Copy the whole content of the element to your clipboard'
        },
        copiedToClipboard: {
            id: 'fabric.editor.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the whole content of the element to clipboard'
        }
    });
});
parcelRegister("l9HLU", function(module, exports) {
    $parcel$export(module.exports, "alignmentMessages", ()=>$c0194801a7a2c28d$export$5229ffea355cfdf6);
    var $7VHMR;
    const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        alignment: {
            id: 'fabric.editor.alignment',
            defaultMessage: 'Text alignment',
            description: 'Opens drop down menu of options to configure text alignment'
        },
        alignLeft: {
            id: 'fabric.editor.alignLeft',
            defaultMessage: 'Align left',
            description: 'label stating that text is aligned left'
        },
        alignCenter: {
            id: 'fabric.editor.alignCenter',
            defaultMessage: 'Align center',
            description: 'label stating that text is aligned center'
        },
        alignRight: {
            id: 'fabric.editor.alignRight',
            defaultMessage: 'Align right',
            description: 'label stating that text is aligned right'
        }
    });
});
parcelRegister("8cp3a", function(module, exports) {
    $parcel$export(module.exports, "annotationMessages", ()=>$0f161f19f888f3d2$export$ff612ca71703201d);
    var $7VHMR;
    const $0f161f19f888f3d2$export$ff612ca71703201d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createComment: {
            id: 'fabric.editor.createComment',
            defaultMessage: 'Comment',
            description: 'Create/add an inline comment based on the users selection'
        },
        createCommentInvalid: {
            id: 'fabric.editor.createCommentInvalid',
            defaultMessage: 'You can only comment on text and headings',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        createCommentDisabled: {
            id: 'fabric.editor.createCommentDisabled',
            defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        toolbar: {
            id: 'fabric.editor.annotationToolbar',
            defaultMessage: 'Annotation toolbar',
            description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
        },
        createCommentOnInlineNodeSpotlightBody: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
            defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
            description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
        },
        createCommentOnInlineNodeSpotlightAction: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
            defaultMessage: 'Got it',
            description: 'The content of the action button that closes the spotlight'
        }
    });
});
parcelRegister("9NKqk", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f845f8650b83fa4e$export$defe85febe8b728c);
    var $7VHMR;
    const $f845f8650b83fa4e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        normal: {
            id: 'fabric.editor.normal',
            defaultMessage: 'Normal text',
            description: 'This is the default text style'
        },
        heading1: {
            id: 'fabric.editor.heading1',
            defaultMessage: 'Heading 1',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading1Description: {
            id: 'fabric.editor.heading1Description',
            defaultMessage: 'Use this for a top level heading',
            description: 'Description of the main heading, heading 1'
        },
        heading2: {
            id: 'fabric.editor.heading2',
            defaultMessage: 'Heading 2',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading2Description: {
            id: 'fabric.editor.heading2Description',
            defaultMessage: 'Use this for key sections',
            description: 'Description of a subtitle heading or secondary heading'
        },
        heading3: {
            id: 'fabric.editor.heading3',
            defaultMessage: 'Heading 3',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading3Description: {
            id: 'fabric.editor.heading3Description',
            defaultMessage: 'Use this for sub sections and group headings',
            description: ''
        },
        heading4: {
            id: 'fabric.editor.heading4',
            defaultMessage: 'Heading 4',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading4Description: {
            id: 'fabric.editor.heading4Description',
            defaultMessage: 'Use this for deep headings',
            description: ''
        },
        heading5: {
            id: 'fabric.editor.heading5',
            defaultMessage: 'Heading 5',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading5Description: {
            id: 'fabric.editor.heading5Description',
            defaultMessage: 'Use this for grouping list items',
            description: ''
        },
        heading6: {
            id: 'fabric.editor.heading6',
            defaultMessage: 'Heading 6',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading6Description: {
            id: 'fabric.editor.heading6Description',
            defaultMessage: 'Use this for low level headings',
            description: ''
        },
        blockquote: {
            id: 'fabric.editor.blockquote2',
            defaultMessage: 'Quote',
            description: 'Quote some text'
        },
        blockquoteDescription: {
            id: 'fabric.editor.blockquote.description',
            defaultMessage: 'Insert a quote or citation',
            description: 'Quote some text'
        },
        codeblock: {
            id: 'fabric.editor.codeblock',
            defaultMessage: 'Code snippet',
            description: 'Insert a snippet/segment of code (code block)'
        },
        codeblockDescription: {
            id: 'fabric.editor.codeblock.description',
            defaultMessage: 'Display code with syntax highlighting',
            description: 'Insert a snippet/segment of code (code block)'
        },
        infoPanel: {
            id: 'fabric.editor.infoPanel',
            defaultMessage: 'Info panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        infoPanelDescription: {
            id: 'fabric.editor.infoPanel.description',
            defaultMessage: 'Highlight information in a colored panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        notePanel: {
            id: 'fabric.editor.notePanel',
            defaultMessage: 'Note panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        notePanelDescription: {
            id: 'fabric.editor.notePanel.description',
            defaultMessage: 'Add a note in a colored panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        successPanel: {
            id: 'fabric.editor.successPanel',
            defaultMessage: 'Success panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        successPanelDescription: {
            id: 'fabric.editor.successPanel.description',
            defaultMessage: 'Add tips in a colored panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        warningPanel: {
            id: 'fabric.editor.warningPanel',
            defaultMessage: 'Warning panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        warningPanelDescription: {
            id: 'fabric.editor.warningPanel.description',
            defaultMessage: 'Add a note of caution in a colored panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        errorPanel: {
            id: 'fabric.editor.errorPanel',
            defaultMessage: 'Error panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        errorPanelDescription: {
            id: 'fabric.editor.errorPanel.description',
            defaultMessage: 'Call out errors in a colored panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        customPanel: {
            id: 'fabric.editor.customPanel',
            defaultMessage: 'Custom panel',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color'
        },
        customPanelDescription: {
            id: 'fabric.editor.customPanel.description',
            defaultMessage: 'Add a note with an emoji and colored background',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color '
        },
        panel: {
            id: 'fabric.editor.panel',
            defaultMessage: 'Panel',
            description: 'Visually distinguishes your text by adding a panel'
        },
        other: {
            id: 'fabric.editor.other',
            defaultMessage: 'Others...',
            description: 'Other text formatting'
        }
    });
});
parcelRegister("fJyLQ", function(module, exports) {
    $parcel$export(module.exports, "codeBidiWarningMessages", ()=>$bc1b61e25b99393f$export$42bb270d1224182);
    var $7VHMR;
    const $bc1b61e25b99393f$export$42bb270d1224182 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'fabric.editor.codeBidiWarningLabel',
            defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
            description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
        }
    });
});
parcelRegister("gSYO9", function(module, exports) {
    $parcel$export(module.exports, "linkMessages", ()=>$6ccabeb0d4490fe2$export$4ce3884394d6d9);
    var $7VHMR;
    const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openLink: {
            id: 'fabric.editor.openLink',
            defaultMessage: 'Open link in a new tab',
            description: 'Opens the link in a new tab'
        }
    });
});
parcelRegister("jDuvE", function(module, exports) {
    $parcel$export(module.exports, "linkToolbarMessages", ()=>$8ffd20c106600435$export$2d7676d841c8ae9);
    var $7VHMR;
    const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addLink: {
            id: 'fabric.editor.mediaAddLink',
            defaultMessage: 'Add link',
            description: 'Add link'
        },
        unableToOpenLink: {
            id: 'fabric.editor.unableToOpenLink',
            defaultMessage: 'Unable to open this link',
            description: 'Unable to open this link'
        },
        unlink: {
            id: 'fabric.editor.unlink',
            defaultMessage: 'Unlink',
            description: 'Removes the hyperlink but keeps your text.'
        },
        editDatasourceStandalone: {
            id: 'fabric.editor.editDatasourceStandalone',
            defaultMessage: 'Edit',
            description: 'A standalone edit button to edit the datasource via a config modal'
        },
        editDatasourceStandaloneTooltip: {
            id: 'fabric.editor.editDatasourceStandaloneTooltip',
            defaultMessage: 'Edit search query',
            description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
        },
        editLink: {
            id: 'fabric.editor.editLink',
            defaultMessage: 'Edit link',
            description: 'Edit the link, update display text'
        },
        placeholder: {
            id: 'fabric.editor.hyperlinkToolbarPlaceholder',
            defaultMessage: 'Paste or search for link',
            description: 'Paste or search for link'
        },
        linkPlaceholder: {
            id: 'fabric.editor.linkPlaceholder',
            defaultMessage: 'Paste link',
            description: 'Create a new link by pasting a URL.'
        },
        linkAddress: {
            id: 'fabric.editor.linkAddress',
            defaultMessage: 'Link address',
            description: 'Insert the address of the link'
        },
        invalidLink: {
            id: 'fabric.editor.invalidLink',
            defaultMessage: 'Please enter a valid link.',
            description: 'Please enter a valid link.'
        },
        emptyLink: {
            id: 'fabric.editor.emptyLink',
            defaultMessage: 'Please enter a link.',
            description: 'Please enter a link.'
        },
        settingsLink: {
            id: 'fabric.editor.settingsLinks',
            defaultMessage: 'Go to Link Preferences',
            description: 'Go to Link Preferences'
        },
        editDatasource: {
            id: 'fabric.editor.edit.datasource',
            defaultMessage: 'Edit search query',
            description: 'Datasource toolbar edit button'
        },
        searchInput: {
            id: 'fabric.editor.edit.searchInput',
            defaultMessage: 'Add a link',
            description: 'Label for the search media input'
        }
    });
});
parcelRegister("lQKNV", function(module, exports) {
    $parcel$export(module.exports, "codeBlockButtonMessages", ()=>$20d0fb06aaa96548$export$74e304339778e94d);
    var $7VHMR;
    const $20d0fb06aaa96548$export$74e304339778e94d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
            defaultMessage: 'Copy as text',
            description: 'Copy the content of the code block as text to your clipboard'
        },
        copiedCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the content of the code block as text to clipboard'
        },
        wrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
            defaultMessage: 'Turn on wrap',
            description: 'Wrap the content of the code block'
        },
        unwrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
            defaultMessage: 'Turn off wrap',
            description: 'Wrap the content of the code block'
        },
        selectLanguage: {
            id: 'fabric.editor.selectLanguage',
            defaultMessage: 'Select language',
            description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
        }
    });
});
parcelRegister("2i4K4", function(module, exports) {
    $parcel$export(module.exports, "toolbarInsertBlockMessages", ()=>$4423ee10317a70cf$export$70c8a7203d95247);
    var $7VHMR;
    const $4423ee10317a70cf$export$70c8a7203d95247 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        action: {
            id: 'fabric.editor.action',
            defaultMessage: 'Action item',
            description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
        },
        actionDescription: {
            id: 'fabric.editor.action.description',
            defaultMessage: 'Create and assign action items',
            description: ''
        },
        closeInsertRightRail: {
            id: 'fabric.editor.insertRightRail.close',
            defaultMessage: 'Close',
            description: 'Close button label'
        },
        link: {
            id: 'fabric.editor.link',
            defaultMessage: 'Link',
            description: 'Insert a hyperlink'
        },
        linkDescription: {
            id: 'fabric.editor.link.description',
            defaultMessage: 'Insert a link',
            description: 'Insert a hyperlink'
        },
        mediaFiles: {
            id: 'fabric.editor.mediaFiles',
            defaultMessage: 'Image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        addMediaFiles: {
            id: 'fabric.editor.addMediaFiles',
            defaultMessage: 'Add image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        insertRightRailTitle: {
            id: 'fabric.editor.insertRightRail.title',
            defaultMessage: 'Insert',
            description: 'Insert a node into the document'
        },
        mediaFilesDescription: {
            id: 'fabric.editor.mediaFiles.description',
            defaultMessage: 'Add images and other files to your page',
            description: 'Insert one or more files or images'
        },
        image: {
            id: 'fabric.editor.image',
            defaultMessage: 'Image',
            description: 'Insert an image.'
        },
        mention: {
            id: 'fabric.editor.mention',
            defaultMessage: 'Mention',
            description: 'Reference another person in your document'
        },
        mentionDescription: {
            id: 'fabric.editor.mention.description',
            defaultMessage: 'Mention someone to send them a notification',
            description: 'Reference another person in your document'
        },
        emoji: {
            id: 'fabric.editor.emoji',
            defaultMessage: 'Emoji',
            description: 'Insert an emoticon or smiley :-)'
        },
        emojiDescription: {
            id: 'fabric.editor.emoji.description',
            defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
            description: 'Insert an emoticon or smiley :-)'
        },
        table: {
            id: 'fabric.editor.table',
            defaultMessage: 'Table',
            description: 'Inserts a table in the document'
        },
        tableDescription: {
            id: 'fabric.editor.table.description',
            defaultMessage: 'Insert a table',
            description: 'Inserts a table in the document'
        },
        tableSelector: {
            id: 'fabric.editor.tableSelector',
            defaultMessage: 'Table size',
            description: 'Opens a table selector that lets you insert a table of custom size'
        },
        tableSelectorDescription: {
            id: 'fabric.editor.tableSelector.description',
            defaultMessage: 'Add a table using popup to select a custom size',
            description: 'Opens a table selector that lets you insert a table of a custom size'
        },
        tableSizeSelectorButton: {
            id: 'fabric.editor.tableSizeSelectorButton',
            defaultMessage: '{numberOfColumns} by {numberOfRows}',
            description: 'Creates a table of custom size'
        },
        tableSizeSelectorPopup: {
            id: 'fabric.editor.tableSizeSelectorPopup',
            defaultMessage: 'Table size selector',
            description: 'Table selector popup to create table of custom size'
        },
        expand: {
            id: 'fabric.editor.expand',
            defaultMessage: 'Expand',
            description: 'Inserts an expand in the document'
        },
        expandDescription: {
            id: 'fabric.editor.expand.description',
            defaultMessage: 'Insert an expand',
            description: 'Inserts an expand in the document'
        },
        decision: {
            id: 'fabric.editor.decision',
            defaultMessage: 'Decision',
            description: "Capture a decision you\u2019ve made"
        },
        decisionDescription: {
            id: 'fabric.editor.decision.description',
            defaultMessage: "Capture decisions so they\u2019re easy to track",
            description: "Capture a decision you\u2019ve made"
        },
        feedbackDialog: {
            id: 'fabric.editor.feedbackDialog',
            defaultMessage: 'Give feedback',
            description: 'Open the feedback dialog from editor'
        },
        feedbackDialogDescription: {
            id: 'fabric.editor.feedbackDialog.description',
            defaultMessage: 'Tell us about your experience using the new editor',
            description: 'Description for feedback option under quick insert dropdown'
        },
        horizontalRule: {
            id: 'fabric.editor.horizontalRule',
            defaultMessage: 'Divider',
            description: 'A horizontal rule or divider'
        },
        horizontalRuleDescription: {
            id: 'fabric.editor.horizontalRule.description',
            defaultMessage: 'Separate content with a horizontal line',
            description: 'A horizontal rule or divider'
        },
        date: {
            id: 'fabric.editor.date',
            defaultMessage: 'Date',
            description: 'Opens a date picker that lets you select a date'
        },
        dateDescription: {
            id: 'fabric.editor.date.description',
            defaultMessage: 'Add a date using a calendar',
            description: 'Opens a date picker that lets you select a date'
        },
        placeholderText: {
            id: 'fabric.editor.placeholderText',
            defaultMessage: 'Placeholder text',
            description: 'Inserts a text placeholder into the page'
        },
        placeholderTextDescription: {
            id: 'fabric.editor.placeholderText.description',
            defaultMessage: 'Insert a text placeholder into the page',
            description: 'Inserts a text placeholder into the page'
        },
        columns: {
            id: 'fabric.editor.columns',
            defaultMessage: 'Layouts',
            description: 'Create a multi column section or layout'
        },
        columnsDescription: {
            id: 'fabric.editor.columns.description',
            defaultMessage: 'Structure your page using sections',
            description: 'Create a multi column section or layout'
        },
        status: {
            id: 'fabric.editor.status',
            defaultMessage: 'Status',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        statusDescription: {
            id: 'fabric.editor.status.description',
            defaultMessage: 'Add a custom status label',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        viewMore: {
            id: 'fabric.editor.viewMore',
            defaultMessage: 'View more',
            description: ''
        },
        insertMenu: {
            id: 'fabric.editor.insertMenu',
            defaultMessage: 'Insert elements',
            description: 'Opens a menu of additional items that can be inserted into your document.'
        },
        help: {
            id: 'fabric.editor.help',
            defaultMessage: 'Help',
            description: 'Opens up the help dialog'
        },
        helpDescription: {
            id: 'fabric.editor.help.description',
            defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
            description: 'Browse all the keyboard shortcuts and markdown options'
        },
        recordVideo: {
            id: 'fabric.editor.recordVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideo: {
            id: 'fabric.editor.addLoomVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideoComment: {
            id: 'fabric.editor.addLoomVideoComment',
            defaultMessage: 'Record a Loom video comment',
            description: 'Record a Loom video comment'
        },
        recordVideoDescription: {
            id: 'fabric.editor.recordVideo.description',
            defaultMessage: 'Record and share your screen and thoughts',
            description: 'Record and share your screen and thoughts'
        },
        recordLoomShortTitle: {
            id: 'fabric.editor.recordLoomShortTitle',
            defaultMessage: 'Record',
            description: 'Record'
        },
        turnInto: {
            id: 'fabric.editor.turnInto',
            defaultMessage: 'Turn into',
            description: 'Turn selected texts into another element containing those texts'
        }
    });
});
parcelRegister("eX53M", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        wrapLeft: {
            id: 'fabric.editor.wrapLeft',
            defaultMessage: 'Wrap left',
            description: 'Aligns your image to the left and wraps text around it.'
        },
        wrapRight: {
            id: 'fabric.editor.wrapRight',
            defaultMessage: 'Wrap right',
            description: 'Aligns your image to the right and wraps text around it.'
        },
        changeToMediaSingle: {
            id: 'fabric.editor.media_change_mediasingle',
            defaultMessage: 'Original size',
            description: 'In the context of a media inline image, it allows the user to convert it to media single'
        },
        changeToMediaInlineImage: {
            id: 'fabric.editor.media_change_mediainline_default',
            defaultMessage: 'Inline',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
        },
        changeToMediaInlineImageCaptionWarning: {
            id: 'fabric.editor.media_change_mediainline_caption_warn',
            defaultMessage: 'Inline (caption will be removed)',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
        }
    });
});
parcelRegister("80CM7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$402c787ddf19f01c$export$defe85febe8b728c);
    var $7VHMR;
    const $402c787ddf19f01c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        url: {
            id: 'fabric.editor.url',
            defaultMessage: 'Display URL',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        block: {
            id: 'fabric.editor.displayBlock',
            defaultMessage: 'Display card',
            description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
        },
        inline: {
            id: 'fabric.editor.displayInline',
            defaultMessage: 'Display inline',
            description: 'Display link with the title only.'
        },
        embed: {
            id: 'fabric.editor.displayEmbed',
            defaultMessage: 'Display embed',
            description: 'Display link as an embedded object'
        },
        link: {
            id: 'fabric.editor.displayLink',
            defaultMessage: 'Display as text',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        card: {
            id: 'fabric.editor.cardFloatingControls',
            defaultMessage: 'Card options',
            description: 'Options to change card type'
        },
        blockCardUnavailable: {
            id: 'fabric.editor.blockCardUnavailable',
            defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
            description: 'Warning message to show the user that this node cannot change its view'
        },
        displayOptionUnavailableInParentNode: {
            id: 'fabric.editor.displayOptionUnavailableInParentNode',
            defaultMessage: "This display option isn't available inside {node}",
            description: 'Warning message to show the user that this node option is not available inside a parent node type'
        },
        urlTitle: {
            id: 'fabric.editor.urlTitle',
            defaultMessage: 'URL',
            description: 'Title for option to convert the card to become a regular text-based hyperlink.'
        },
        blockTitle: {
            id: 'fabric.editor.blockTitle',
            defaultMessage: 'Card',
            description: 'Title for option to display link in the card view.'
        },
        inlineTitle: {
            id: 'fabric.editor.inlineTitle',
            defaultMessage: 'Inline',
            description: 'Title for option to display link in the inline view.'
        },
        embedTitle: {
            id: 'fabric.editor.embedTitle',
            defaultMessage: 'Embed',
            description: 'Title for option to display link as an embedded object.'
        },
        urlDescription: {
            id: 'fabric.editor.urlDescription',
            defaultMessage: 'Display link as URL',
            description: 'Description for option to convert the card to become a regular text-based hyperlink.'
        },
        blockDescription: {
            id: 'fabric.editor.blockDescription',
            defaultMessage: 'Display more information about a link, including a summary and actions',
            description: 'Description for option to display link in the card view.'
        },
        inlineDescription: {
            id: 'fabric.editor.inlineDescription',
            defaultMessage: 'Display link as inline text',
            description: 'Description for option to display link in the inline view.'
        },
        embedDescription: {
            id: 'fabric.editor.ecombedDescription',
            defaultMessage: 'Display an interactive preview of a link',
            description: 'Description for option to display link as an embedded object.'
        },
        editDropdownExpandIconLabel: {
            id: 'fabric.editor.editDropdownExpandIconLabel',
            defaultMessage: 'Expand dropdown menu',
            description: 'Text of an icon to expand the dropdown'
        },
        editDropdownTriggerTitle: {
            id: 'fabric.editor.editDropdownTriggerTitle',
            defaultMessage: 'Edit',
            description: 'Text of a button to trigger opening an edit dropdown'
        },
        editDropdownEditLinkTitle: {
            id: 'fabric.editor.editDropdownEditLinkTitle',
            defaultMessage: 'Edit link',
            description: 'Edit dropdown edit link button text'
        },
        editDropdownEditDatasourceTitle: {
            id: 'fabric.editor.editDropdownEditDatasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Edit dropdown edit datasource button text'
        },
        datasourceTitle: {
            id: 'fabric.editor.datasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Tooltip of button to edit a card into a datasource'
        },
        datasourceAppearanceTitle: {
            id: 'fabric.editor.datasourceAppearanceTitle',
            defaultMessage: 'List',
            description: 'Tooltip of button to change to datasource appearance'
        },
        datasourceJiraIssue: {
            id: 'fabric.editor.datasource.jiraIssue',
            defaultMessage: 'Jira Issues',
            description: 'Insert a jira datasource table'
        },
        datasourceJiraIssueDescription: {
            id: 'fabric.editor.datasource.jiraIssue.description',
            defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
            description: 'Insert a jira datasource table'
        },
        datasourceAssetsObjectsGeneralAvailability: {
            id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
            defaultMessage: 'Assets',
            description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
        },
        datasourceAssetsObjectsDescription: {
            id: 'fabric.editor.datasource.assetsObjects.description',
            defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
        },
        inlineOverlay: {
            id: 'fabric.editor.inlineOverlay',
            defaultMessage: 'Configure',
            description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
        },
        inlineConfigureLink: {
            id: 'fabric.editor.inlineConfigureLink',
            defaultMessage: 'Configure link',
            description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
        },
        inlineGoToLink: {
            id: 'fabric.editor.inlineGoToLink',
            defaultMessage: 'Go to link',
            description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
        },
        datasourceConfluenceSearch: {
            id: 'fabric.editor.datasource.confluenceSearch',
            defaultMessage: 'Insert Confluence list',
            description: 'Title shown for Confluence Search datasource on QuickInsert options'
        },
        datasourceConfluenceSearchDescription: {
            id: 'fabric.editor.datasource.confluenceSearch.description',
            defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
        }
    });
});
parcelRegister("kXnoC", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$19e3f2f865259995$export$defe85febe8b728c);
    var $7VHMR;
    const $19e3f2f865259995$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toolbarLabel: {
            id: 'fabric.editor.toolbarLabel',
            defaultMessage: 'Editor',
            description: 'Label for the ARIA region landmark'
        },
        pageActionsLabel: {
            id: 'fabric.editor.pageActionsLabel',
            defaultMessage: 'Page actions',
            description: 'Label for the ARIA region landmark'
        },
        editableContentLabel: {
            id: 'fabric.editor.editableContentLabel',
            defaultMessage: 'Editable content',
            description: 'Label for the ARIA region landmark'
        }
    });
});
parcelRegister("eDTMN", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$ec9866e02d0168cb$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        underline: {
            id: 'fabric.editor.underline',
            defaultMessage: 'Underline',
            description: 'Whether the text selection has underlined text'
        },
        strike: {
            id: 'fabric.editor.strike',
            defaultMessage: 'Strikethrough',
            description: 'Whether the text selection has crossed out text'
        },
        code: {
            id: 'fabric.editor.code',
            defaultMessage: 'Code',
            description: 'Whether the text selection has monospaced/code font'
        },
        codeOn: {
            id: 'fabric.editor.code.on',
            defaultMessage: '{textFormattingOff}, Code On',
            description: 'Reports that code formatting has been turned on'
        },
        subscript: {
            id: 'fabric.editor.subscript',
            defaultMessage: 'Subscript',
            description: 'Whether the text selection is written below the line in a slightly smaller size'
        },
        subscriptOffSuperscriptOn: {
            id: 'fabric.editor.subscript.off.superscript.on',
            defaultMessage: 'Subscript Off, Superscript On',
            description: 'Reports text formatting in case when subscript off and superscript on'
        },
        superscript: {
            id: 'fabric.editor.superscript',
            defaultMessage: 'Superscript',
            description: 'Whether the text selection is written above the line in a slightly smaller size'
        },
        superscriptOffSubscriptOn: {
            id: 'fabric.editor.superscript.off.subscript.on',
            defaultMessage: 'Superscript Off, Subscript On',
            description: 'Describe text formatting in case when Superscript Off and Subscript on'
        },
        clearFormatting: {
            id: 'fabric.editor.clearFormatting',
            defaultMessage: 'Clear formatting',
            description: 'Remove all rich text formatting from the selected text'
        },
        moreFormatting: {
            id: 'fabric.editor.moreFormatting',
            defaultMessage: 'More formatting',
            description: 'Clicking this will show a menu with additional formatting options'
        },
        textFormatting: {
            id: 'fabric.editor.textFormatting',
            defaultMessage: 'Text formatting',
            description: 'Aria label for the wrapper of text format buttons'
        },
        bold: {
            id: 'fabric.editor.bold',
            defaultMessage: 'Bold',
            description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
        },
        italic: {
            id: 'fabric.editor.italic',
            defaultMessage: 'Italic',
            description: 'This refers to italics or emphasized formatting.'
        },
        on: {
            id: 'fabric.editor.on',
            defaultMessage: '{formattingType} On',
            description: 'Reports that text formatting has been turned on'
        },
        off: {
            id: 'fabric.editor.off',
            defaultMessage: '{formattingType} Off',
            description: 'Reports that text formatting has been turned off'
        },
        textStyles: {
            id: 'fabric.editor.textStyles',
            defaultMessage: '{blockTypeName} Text styles',
            description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
        },
        textStylesTooltip: {
            id: 'fabric.editor.textStylesTooltip',
            defaultMessage: 'Text styles',
            description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
        },
        textFormattingOff: {
            id: 'fabric.editor.text.formatting.off',
            defaultMessage: 'Text formatting Off',
            description: 'Reports that text formatting has been turned off'
        },
        navigateToEditorToolbar: {
            id: 'fabric.editor.navigate.toolbar.editor',
            defaultMessage: 'Navigate to editor toolbar',
            description: 'Navigate to the main editor toolbar.'
        },
        navigateToFloatingToolbar: {
            id: 'fabric.editor.navigate.toolbar.floating',
            defaultMessage: 'Navigate to floating toolbar',
            description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
        }
    });
});
parcelRegister("2V0EL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bcecf16097bd0035$export$defe85febe8b728c);
    var $7VHMR;
    const $bcecf16097bd0035$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tableOptions: {
            id: 'fabric.editor.tableOptions',
            defaultMessage: 'Table options',
            description: 'Opens a menu with additional table options'
        },
        tableSizeIncreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
            defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
        },
        tableSizeDecreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
            defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
        },
        headerRow: {
            id: 'fabric.editor.headerRow',
            defaultMessage: 'Header row',
            description: 'Marks the first table row as a header row'
        },
        headerColumn: {
            id: 'fabric.editor.headerColumn',
            defaultMessage: 'Header column',
            description: 'Marks the first table column as a header row'
        },
        numberedColumn: {
            id: 'fabric.editor.numberedColumn',
            defaultMessage: 'Numbered column',
            description: 'Adds an auto-numbering column to your table'
        },
        collapseTable: {
            id: 'fabric.editor.collapseTable',
            defaultMessage: 'Collapse table',
            description: 'Wraps table in an expand'
        },
        resizeTable: {
            id: 'fabric.editor.tables.resizeTable',
            defaultMessage: 'Resize table',
            description: 'Tooltip displayed on custom table width resize hande'
        },
        insertColumn: {
            id: 'fabric.editor.insertColumn',
            defaultMessage: 'Insert column right',
            description: 'Inserts a new column to the right of selected column.'
        },
        addColumnLeft: {
            id: 'fabric.editor.addColumnLeft',
            defaultMessage: 'Add column left',
            description: 'Adds a new column to the left of selected column.'
        },
        addColumnRight: {
            id: 'fabric.editor.addColumnRight',
            defaultMessage: 'Add column right',
            description: 'Adds a new column to the right of selected column.'
        },
        insertColumnDrag: {
            id: 'fabric.editor.insertColumnDrag',
            defaultMessage: 'Insert column',
            description: 'Inserts a new column to the right of selected column.'
        },
        removeColumns: {
            id: 'fabric.editor.removeColumns',
            defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
            description: 'Deletes a table column.'
        },
        insertRow: {
            id: 'fabric.editor.insertRow',
            defaultMessage: 'Insert row below',
            description: 'Inserts a new row below the selected row.'
        },
        addRowAbove: {
            id: 'fabric.editor.addRowAbove',
            defaultMessage: 'Add row above',
            description: 'Adds a new row above the selected row.'
        },
        addRowBelow: {
            id: 'fabric.editor.addRowBelow',
            defaultMessage: 'Add row below',
            description: 'Adds a new row below the selected row.'
        },
        moveColumnLeft: {
            id: 'fabric.editor.moveColumnLeft',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
            description: 'Moves a column or columns to the left.'
        },
        moveColumnRight: {
            id: 'fabric.editor.moveColumnRight',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
            description: 'Moves a column or columns to the right.'
        },
        moveRowUp: {
            id: 'fabric.editor.moveRowUp',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
            description: 'Moves a row or selected rows up.'
        },
        moveRowDown: {
            id: 'fabric.editor.moveDownDown',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
            description: 'Moves a row or selected rows down.'
        },
        insertRowDrag: {
            id: 'fabric.editor.insertRowDrag',
            defaultMessage: 'Insert row',
            description: 'Inserts a new row below the selected row.'
        },
        removeRows: {
            id: 'fabric.editor.removeRows',
            defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
            description: 'Deletes a table row.'
        },
        rowNumbers: {
            id: 'fabrid.editor.rowNumbers',
            defaultMessage: 'Row numbers',
            desciption: 'Adds a number to each row except header row'
        },
        rowsAreInserted: {
            id: 'fabric.editor.rowsAreInserted',
            defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
            description: 'Assistive message following the insertion of row(s)'
        },
        rowsAreRemoved: {
            id: 'fabric.editor.rowsAreRemoved',
            defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
            description: 'Assistive message following the removal of row(s)'
        },
        rowSelected: {
            id: 'fabric.editor.rowSelected',
            defaultMessage: 'Row {index} of {total} selected',
            description: 'Assistive message following the selection of a row'
        },
        rowMovedUp: {
            id: 'fabric.editor.rowMovedUp',
            defaultMessage: 'Row moved up to {index} of {total}',
            description: 'Assistive message following the upward movement of a row'
        },
        rowMovedDown: {
            id: 'fabric.editor.rowMovedDown',
            defaultMessage: 'Row moved down to {index} of {total}',
            description: 'Assistive message following the downward movement of a row'
        },
        columnsAreInserted: {
            id: 'fabric.editor.columnsAreInserted',
            defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
            description: 'Assistive message following the insertion of column(s)'
        },
        columnsAreRemoved: {
            id: 'fabric.editor.columnsAreRemoved',
            defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
            description: 'Assistive message following the removal of column(s)'
        },
        columnSelected: {
            id: 'fabric.editor.columnSelected',
            defaultMessage: 'Column {index} of {total} selected',
            description: 'Assistive message following the selection of a column'
        },
        columnMovedLeft: {
            id: 'fabric.editor.columnMovedLeft',
            defaultMessage: 'Column moved left to {index} of {total}',
            description: 'Assistive message following the left movement of a column'
        },
        columnMovedRight: {
            id: 'fabric.editor.columnMovedRight',
            defaultMessage: 'Column moved right to {index} of {total}',
            description: 'Assistive message following the right movement of a column'
        },
        cellOptions: {
            id: 'fabric.editor.cellOptions',
            defaultMessage: 'Cell options',
            description: 'Opens a menu with options for the current table cell.'
        },
        confirmDeleteLinkedModalOKButton: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
            defaultMessage: 'Delete',
            description: 'Action button label for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessage: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
            defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
            description: 'Message for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessagePrefix: {
            id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
            defaultMessage: 'Deleting',
            description: 'prefix for confirmation dialog text'
        },
        confirmModalCheckboxLabel: {
            id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
            defaultMessage: 'Also delete connected elements',
            description: 'checkbox label text'
        },
        deleteElementTitle: {
            id: 'fabric.editor.extension.deleteElementTitle',
            defaultMessage: 'Delete element',
            description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
        },
        unnamedSource: {
            id: 'fabric.editor.extension.sourceNoTitledName',
            defaultMessage: 'this element',
            description: 'The current element without preset name been selected'
        },
        adjustColumns: {
            id: 'fabric.editor.tables.adjustColumn',
            defaultMessage: 'Adjust column',
            description: 'Tooltip displayed on table column resize handle'
        },
        cornerControl: {
            id: 'fabric.editor.cornerControl',
            defaultMessage: 'Highlight table',
            description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
        },
        cellBackground: {
            id: 'fabric.editor.cellBackground',
            defaultMessage: 'Cell background',
            description: 'Change the background color of a table cell.'
        },
        backgroundColor: {
            id: 'fabric.editor.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Change the background color of a table cell.'
        },
        mergeCells: {
            id: 'fabric.editor.mergeCells',
            defaultMessage: 'Merge cells',
            description: 'Merge tables cells together.'
        },
        splitCell: {
            id: 'fabric.editor.splitCell',
            defaultMessage: 'Split cell',
            description: 'Split a merged table cell.'
        },
        clearCells: {
            id: 'fabric.editor.clearCells',
            defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
            description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
        },
        sortColumnASC: {
            id: 'fabric.editor.sortColumnASC',
            defaultMessage: "Sort column A \u2192 Z",
            description: 'Sort column in ascending order'
        },
        sortColumnDESC: {
            id: 'fabric.editor.sortColumnDESC',
            defaultMessage: "Sort column Z \u2192 A",
            description: 'Sort column in descending order'
        },
        sortColumnIncreasing: {
            id: 'fabric.editor.sortColumnIncreasing',
            defaultMessage: 'Sort increasing',
            description: 'Sort column in ascending order'
        },
        sortColumnDecreasing: {
            id: 'fabric.editor.sortColumnDecreasing',
            defaultMessage: 'Sort decreasing',
            description: 'Sort column in descending order'
        },
        canNotSortTable: {
            id: 'fabric.editor.canNotSortTable',
            defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
            description: `Split your cells to enable this feature`
        },
        distributeColumns: {
            id: 'fabric.editor.distributeColumns',
            defaultMessage: `Distribute columns`,
            description: `Distribute widths between selected columns`
        },
        lockColumnWidths: {
            id: 'fabric.editor.lockColumns',
            defaultMessage: 'Fixed column widths',
            description: 'Toggle button to enable fixed column widths'
        },
        rowControl: {
            id: 'fabric.editor.rowControl',
            defaultMessage: 'Highlight row',
            description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
        },
        rowDragHandle: {
            id: 'fabric.editor.rowDragHandle',
            defaultMessage: 'Row options',
            description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
        },
        columnDragHandle: {
            id: 'fabric.editor.columnDragHandle',
            defaultMessage: 'Column options',
            description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
        },
        fullWidthLabel: {
            id: 'fabric.editor.tableFullWidthLabel',
            defaultMessage: 'Full-width',
            description: 'Trigger table width to full-width mode'
        },
        startedColumnResize: {
            id: 'fabric.editor.tables.startedColumnResize',
            defaultMessage: 'Started column resize',
            description: 'Screen Reader announces when the user engages the column resizer'
        },
        focusedOtherResize: {
            id: 'fabric.editor.tables.otherResize',
            defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
            description: 'Screen Reader announces when the user switches to the left or right column resizer'
        },
        changedColumnWidth: {
            id: 'fabric.editor.tables.columnWidth',
            defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
            description: 'Screen Reader announces when the user modifies the column width'
        },
        columnResizeStop: {
            id: 'fabric.editor.tables.resizeStop',
            defaultMessage: 'Stopped resize',
            description: 'Screen Reader announces when the user discontinues the resizing operation'
        },
        columnResizeOverflow: {
            id: 'fabric.editor.tables.columnResizeOverflow',
            defaultMessage: 'You can only resize this column while the table has a scroll bar.',
            description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
        },
        columnResizeLast: {
            id: 'fabric.editor.tables.columnResizeLast',
            defaultMessage: 'You can only resize this column to the left.',
            description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
        },
        tableAlignmentOptions: {
            id: 'fabric.editor.tableAlignmentOptions',
            defaultMessage: 'Alignment options',
            description: 'Opens a menu with additional table alignment options'
        },
        alignTableCenter: {
            id: 'fabric.editor.alignTableCenter',
            defaultMessage: 'Align center',
            description: 'Aligns table to the center'
        },
        alignTableLeft: {
            id: 'fabric.editor.alignTableLeft',
            defaultMessage: 'Align left',
            description: 'Aligns table to the left'
        }
    });
});
parcelRegister("kFJBG", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a872fd5a03f73724$export$defe85febe8b728c);
    var $7VHMR;
    const $a872fd5a03f73724$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unorderedList: {
            id: 'fabric.editor.unorderedList',
            defaultMessage: 'Bullet list',
            description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
        },
        unorderedListDescription: {
            id: 'fabric.editor.unorderedList.description',
            defaultMessage: 'Create an unordered list',
            description: ''
        },
        orderedList: {
            id: 'fabric.editor.orderedList',
            defaultMessage: 'Numbered list',
            description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
        },
        orderedListDescription: {
            id: 'fabric.editor.orderedList.description',
            defaultMessage: 'Create an ordered list',
            description: ''
        },
        lists: {
            id: 'fabric.editor.lists',
            defaultMessage: 'Lists',
            description: 'Menu shows ordered/bullet list and unordered/numbered lists'
        },
        listsFormat: {
            id: 'fabric.editor.listsFormat',
            defaultMessage: 'List formatting',
            description: 'Aria label for the wrapper of list buttons'
        }
    });
});
parcelRegister("7S9ZN", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9078664297972b18$export$defe85febe8b728c);
    var $7VHMR;
    const $9078664297972b18$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        undo: {
            id: 'fabric.editor.undo',
            defaultMessage: 'Undo',
            description: 'Undo the previously performed action.'
        },
        redo: {
            id: 'fabric.editor.redo',
            defaultMessage: 'Redo',
            description: 'Redo the previously undone action.'
        }
    });
});
parcelRegister("6OcHr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b883afcc2fb8665e$export$defe85febe8b728c);
    var $7VHMR;
    const $b883afcc2fb8665e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.statusPlaceholder',
            defaultMessage: 'Set a status',
            description: 'Placeholder description for an empty (new) status item in the editor'
        },
        editText: {
            id: 'fabric.editor.editStatusText',
            defaultMessage: 'Edit Status',
            description: 'Title for the input that changes the status text'
        },
        editColor: {
            id: 'fabric.editor.editStatusColor',
            defaultMessage: 'Edit Status Color',
            description: 'Title for the color picker that changes the status color'
        }
    });
});
parcelRegister("dbepQ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$19b9098ff265842b$export$defe85febe8b728c);
    var $7VHMR;
    const $19b9098ff265842b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editText: {
            id: 'fabric.editor.editDateText',
            defaultMessage: 'Edit Date',
            description: 'Title for the input that changes the date'
        },
        invalidDateError: {
            id: 'fabric.editor.invalidDateError',
            defaultMessage: 'Enter a valid date',
            description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
        },
        onKeyUpDownText: {
            id: 'fabric.editor.upDown',
            defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
            description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
        }
    });
});
parcelRegister("kANLZ", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$2ae4030e88533f57$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        singleColumn: {
            id: 'fabric.editor.single',
            defaultMessage: 'Single column layout',
            description: 'Layout with one single column'
        },
        twoColumns: {
            id: 'fabric.editor.twoColumns',
            defaultMessage: 'Two columns layout',
            description: 'Layout with two columns of equal width'
        },
        threeColumns: {
            id: 'fabric.editor.threeColumns',
            defaultMessage: 'Three columns layout',
            description: 'Layout with three columns of equal width'
        },
        fourColumns: {
            id: 'fabric.editor.fourColumns',
            defaultMessage: 'Four columns layout',
            description: 'Layout with four columns of equal width'
        },
        fiveColumns: {
            id: 'fabric.editor.fiveColumns',
            defaultMessage: 'Five columns layout',
            description: 'Layout with five columns of equal width'
        },
        rightSidebar: {
            id: 'fabric.editor.rightSidebar',
            defaultMessage: 'Right sidebar layout',
            description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
        },
        leftSidebar: {
            id: 'fabric.editor.leftSidebar',
            defaultMessage: 'Left sidebar layout',
            description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
        },
        threeColumnsWithSidebars: {
            id: 'fabric.editor.threeColumnsWithSidebars',
            defaultMessage: 'Three columns with sidebars layout',
            description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
        },
        floatingToolbarRadioGroupAriaLabel: {
            id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
            defaultMessage: 'Layout options',
            description: "a floating toolbar radiogroup's aria label"
        },
        layoutPlaceholder: {
            id: 'fabric.editor.layout.placeholder',
            defaultMessage: 'Add content',
            description: 'Add placeholder text for empty layout'
        },
        columnOption: {
            id: 'fabric.editor.layout.columnOption',
            defaultMessage: '{count, plural, one {-column} other {{count}-columns}}',
            description: 'column option text for layout'
        }
    });
});
parcelRegister("kmmxF", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e4735e0a5cdca6f9$export$defe85febe8b728c);
    var $7VHMR;
    const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        indent: {
            id: 'fabric.editor.indent',
            defaultMessage: 'Indent',
            description: 'Indent a list item, paragraph or heading'
        },
        outdent: {
            id: 'fabric.editor.outdent',
            defaultMessage: 'Outdent',
            description: 'Outdent a list item, paragraph or heading'
        }
    });
});
parcelRegister("80TXs", function(module, exports) {
    $parcel$export(module.exports, "avatarGroupMessages", ()=>$cedd04a0024a64f8$export$8a0e7c3f8f5b8868);
    var $7VHMR;
    const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editors: {
            id: 'fabric.editor.editors',
            defaultMessage: 'Editors',
            description: 'classifying the people that are currently editing the document'
        }
    });
});
parcelRegister("9QBHe", function(module, exports) {
    $parcel$export(module.exports, "findReplaceMessages", ()=>$b943fdad34912591$export$b46a930e1a386b2e);
    var $7VHMR;
    const $b943fdad34912591$export$b46a930e1a386b2e = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        find: {
            id: 'fabric.editor.find',
            defaultMessage: 'Find',
            description: 'The word or phrase to search for on the document'
        },
        matchCase: {
            id: 'fabric.editor.matchCase',
            defaultMessage: 'Match case',
            description: 'Toggle whether should also match case when searching for text'
        },
        findNext: {
            id: 'fabric.editor.findNext',
            defaultMessage: 'Find next',
            description: 'Locate the next occurrence of the word or phrase that was searched for'
        },
        findPrevious: {
            id: 'fabric.editor.findPrevious',
            defaultMessage: 'Find previous',
            description: 'Locate the previous occurrence of the word or phrase that was searched for'
        },
        closeFindReplaceDialog: {
            id: 'fabric.editor.closeFindReplaceDialog',
            defaultMessage: 'Close',
            description: 'Cancel search and close the "Find and Replace" dialog'
        },
        noResultsFound: {
            id: 'fabric.editor.noResultsFound',
            defaultMessage: 'No results',
            description: 'No matches were found for the word or phrase that was searched for'
        },
        resultsCount: {
            id: 'fabric.editor.resultsCount',
            description: 'Text for selected search match position and total results count',
            defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
        },
        findReplaceToolbarButton: {
            id: 'fabric.editor.findReplaceToolbarButton',
            defaultMessage: 'Find and replace',
            description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
        },
        replaceWith: {
            id: 'fabric.editor.replaceWith',
            defaultMessage: 'Replace with',
            description: 'The value that will replace the word or phrase that was searched for'
        },
        replace: {
            id: 'fabric.editor.replace',
            defaultMessage: 'Replace',
            description: 'Replace only the currently selected instance of the word or phrase'
        },
        replaceAll: {
            id: 'fabric.editor.replaceAll',
            defaultMessage: 'Replace all',
            description: 'Replace all instances of the word or phrase throughout the entire document'
        },
        replaceSuccess: {
            id: 'fabric.editor.replaceSuccess',
            defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
            description: 'Text when replacement succesfully done'
        }
    });
});
parcelRegister("kAM3u", function(module, exports) {
    $parcel$export(module.exports, "textColorMessages", ()=>$147c4cd461faf1fe$export$effb4ee8b6f74abe);
    var $7VHMR;
    const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        textColor: {
            id: 'fabric.editor.textColor',
            defaultMessage: '{selectedColorName} Text color',
            description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
        },
        textColorTooltip: {
            id: 'fabric.editor.textColorTooltip',
            defaultMessage: 'Text color',
            description: 'Toolip of menu that provides access to various colors of text.'
        }
    });
});
parcelRegister("6lWmZ", function(module, exports) {
    $parcel$export(module.exports, "tasksAndDecisionsMessages", ()=>$65d46911a2519e83$export$273d864e9e6d0b1f);
    var $7VHMR;
    const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        taskPlaceholder: {
            id: 'fabric.editor.taskPlaceholder',
            defaultMessage: "Type your action, use '@' to assign to someone.",
            description: 'Placeholder description for an empty action/task in the editor'
        },
        decisionPlaceholder: {
            id: 'fabric.editor.decisionPlaceholder',
            defaultMessage: "Add a decision\u2026",
            description: 'Placeholder description for an empty decision in the editor'
        },
        editAccessTitle: {
            id: 'fabric.editor.editAccessTitle',
            defaultMessage: 'You need edit access',
            description: 'Title in the popup when we click on action item checkbox without edit permission'
        },
        requestToEditDescription: {
            id: 'fabric.editor.requestToEditDescription',
            defaultMessage: 'When you request access, the page owner will receive a notification.',
            description: 'Description in the popup when we click on action item checkbox without edit permission'
        },
        requestToEdit: {
            id: 'fabric.editor.requestToEdit',
            defaultMessage: 'Request to edit',
            description: 'Button in the popup when we click on action item checkbox without edit permission'
        },
        dismiss: {
            id: 'fabric.editor.requestToEditDismiss',
            defaultMessage: 'Dismiss',
            description: 'Button in the popup when we click on dismiss without edit permission'
        }
    });
});
parcelRegister("ixwvf", function(module, exports) {
    $parcel$export(module.exports, "placeholderTextMessages", ()=>$358e275c47040b0e$export$ee8ab8a034b5a8bd);
    var $7VHMR;
    const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderTextPlaceholder: {
            id: 'fabric.editor.placeholderTextPlaceholder',
            defaultMessage: 'Add placeholder text',
            description: ''
        }
    });
});
parcelRegister("fJm1A", function(module, exports) {
    $parcel$export(module.exports, "pasteOptionsToolbarMessages", ()=>$b0fedd2e9a93e39a$export$703e803e9cb0cea4);
    var $7VHMR;
    const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pasteOptions: {
            id: 'fabric.editor.pasteOptions',
            defaultMessage: 'Paste options',
            description: 'Opens a menu with additional paste options'
        },
        plainText: {
            id: 'fabric.editor.plainText',
            defaultMessage: 'Use plain text',
            description: 'Converts pasted text into plain text'
        },
        markdown: {
            id: 'fabric.editor.useMarkdown',
            defaultMessage: 'Use Markdown',
            description: 'Converts pasted text into Markdown'
        },
        richText: {
            id: 'fabric.editor.richText',
            defaultMessage: 'Use rich text',
            description: 'Converts pasted text into Rich text'
        }
    });
});
parcelRegister("ecAvy", function(module, exports) {
    $parcel$export(module.exports, "panelMessages", ()=>$e955dc2d97d725ff$export$7bb18eb6f9170174);
    var $7VHMR;
    const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        info: {
            id: 'fabric.editor.info',
            defaultMessage: 'Info',
            description: 'Panels provide a way to highlight text. The info panel has a blue background.'
        },
        note: {
            id: 'fabric.editor.note',
            defaultMessage: 'Note',
            description: 'Panels provide a way to highlight text. The note panel has a purple background.'
        },
        success: {
            id: 'fabric.editor.success',
            defaultMessage: 'Success',
            description: 'Panels provide a way to highlight text. The success panel has a green background.'
        },
        warning: {
            id: 'fabric.editor.warning',
            defaultMessage: 'Warning',
            description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
        },
        error: {
            id: 'fabric.editor.error',
            defaultMessage: 'Error',
            description: 'Panels provide a way to highlight text. The error panel has a red background.'
        },
        emoji: {
            id: 'fabric.editor.panel.emoji',
            defaultMessage: 'Add emoji',
            description: 'Select the panel icon'
        },
        backgroundColor: {
            id: 'fabric.editor.panel.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Select the panel background color.'
        },
        panelsGroup: {
            id: 'fabric.editor.panel.panelsGroup',
            defaultMessage: 'Panel Types',
            description: 'aria-label for group of panels the floating toolbar'
        }
    });
});
parcelRegister("7ywdr", function(module, exports) {
    $parcel$export(module.exports, "mentionMessages", ()=>$a3d6d16f96d339d5$export$33aafd5ccbbbd00a);
    var $7VHMR;
    const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteItemTitle: {
            id: 'fabric.editor.inviteItem.title',
            defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
            description: 'Title of the invite teammate item in typeahead plugin'
        },
        mentionsAddLabel: {
            id: 'fabric.editor.mentionsAddLabel',
            defaultMessage: 'add-icon',
            description: 'icon label to describe adding a new mention'
        },
        mentionsIconLabel: {
            id: 'fabric.editor.mentionsIconLabel',
            defaultMessage: 'Mention',
            description: 'icon label to describe the mention icon'
        },
        mentionsNodeLabel: {
            id: 'fabric.editor.mentionNode.label',
            defaultMessage: 'Tagged user',
            description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
        }
    });
});
parcelRegister("1ElKj", function(module, exports) {
    $parcel$export(module.exports, "helpDialogMessages", ()=>$691908dbd48d7aae$export$83c85447c71428ba);
    var $7VHMR;
    const $691908dbd48d7aae$export$83c85447c71428ba = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editorHelp: {
            id: 'fabric.editor.editorHelp',
            defaultMessage: 'Editor help',
            description: 'Title of editor help dialog.'
        },
        helpDialogTips: {
            id: 'fabric.editor.helpDialogTips',
            defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
            description: 'Hint about how to open a dialog quickly using a shortcut.'
        },
        keyboardShortcuts: {
            id: 'fabric.editor.keyboardShortcuts',
            defaultMessage: 'Keyboard shortcuts',
            description: ''
        },
        markdown: {
            id: 'fabric.editor.markdown',
            defaultMessage: 'Markdown',
            description: 'It is a name of popular markup language.'
        },
        pastePlainText: {
            id: 'fabric.editor.pastePlainText',
            defaultMessage: 'Paste plain text',
            description: ''
        },
        CheckUncheckActionItem: {
            id: 'fabric.editor.checkUncheckActionItem',
            defaultMessage: 'Toggle action item',
            description: 'For Check/Uncheck Action item use shortcut'
        },
        InsertTableColumn: {
            id: 'fabric.editor.insertTableColumn',
            defaultMessage: 'Insert table column',
            description: 'For insert table column'
        },
        InsertTableRow: {
            id: 'fabric.editor.insertTableRow',
            defaultMessage: 'Insert table row',
            description: 'For insert table row'
        },
        altText: {
            id: 'fabric.editor.altText',
            defaultMessage: 'Alt text',
            description: 'Alternative text for image.'
        },
        selectTableRow: {
            id: 'fabric.editor.selectTableRow',
            defaultMessage: 'Select table row',
            description: 'Hint for selecting a table row using a shortcut'
        },
        selectTableColumn: {
            id: 'fabric.editor.selectTableColumn',
            defaultMessage: 'Select table column',
            description: 'Hint for selecting a table column using a shortcut'
        },
        selectColumnResize: {
            id: 'fabric.editor.selectColumnResize',
            defaultMessage: 'Select column resize',
            description: 'Hint for selecting a column resize a shortcut'
        },
        increaseSize: {
            id: 'fabric.editor.increaseSize',
            defaultMessage: 'Increase table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
        },
        decreaseSize: {
            id: 'fabric.editor.decreaseSize',
            defaultMessage: 'Decrease table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
        },
        openCellOptions: {
            id: 'fabric.editor.openCellOptions',
            defaultMessage: 'Open cell options',
            description: 'Keyboard shortcut to open cell options.'
        },
        focusTableResizeHandle: {
            id: 'fabric.editor.focusTableResizeHandle',
            defaultMessage: 'Focus table resize handle',
            description: 'Focus table resize handle'
        },
        closeHelpDialog: {
            id: 'fabric.editor.closeHelpDialog',
            defaultMessage: 'Close help dialog',
            description: ''
        },
        quickInsert: {
            id: 'fabric.editor.quickInsert',
            defaultMessage: 'Quick insert',
            description: 'Name of a feature, which let you insert items quickly.'
        },
        highlightColor: {
            id: 'fabric.editor.highlightColor',
            defaultMessage: 'Toggle highlight color palette',
            description: 'Keyboard shortcut to toggle highlight color palette.'
        }
    });
});
parcelRegister("3AEXe", function(module, exports) {
    $parcel$export(module.exports, "mediaInsertMessages", ()=>$a755ba82139b4a7d$export$7eb9dc59242bbc45);
    var $7VHMR;
    const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadPreview: {
            id: 'fabric.editor.media.insert.loadPreview',
            defaultMessage: 'Load preview',
            description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
        },
        insert: {
            id: 'fabric.editor.media.insert.insert',
            defaultMessage: 'Insert',
            description: 'Text on the modal action button that inserts the linked media file into the editor document'
        },
        pasteLinkToUpload: {
            id: 'fabric.editor.media.insert.pasteLinkToUpload',
            defaultMessage: 'Paste link to upload',
            description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
        },
        cancel: {
            id: 'fabric.editor.media.insert.cancel',
            defaultMessage: 'Cancel',
            description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
        },
        fromUrlErrorMessage: {
            id: 'fabric.editor.media.insert.fromUrlErrorMessage',
            defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
            description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
        },
        fromUrlWarning: {
            id: 'fabric.editor.media.insert.fromUrlWarning',
            defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
            description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
        },
        localFileNetworkErrorMessage: {
            id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
            defaultMessage: 'File upload error. Check file path or network.',
            description: 'Error message displayed when a network error occurs during file upload'
        },
        localFileErrorMessage: {
            id: 'fabric.editor.media.insert.localFileErrorMessage',
            defaultMessage: "This file couldn\u2019t be uploaded.",
            description: 'Generic catch-all error message displayed when file upload fails'
        },
        mediaAlt: {
            id: 'fabric.editor.media.insert.mediaAlt',
            defaultMessage: 'Preview for uploaded image or video file',
            description: 'Alt text describing a preview of an image uploaded.'
        },
        upload: {
            id: 'fabric.editor.media.insert.upload',
            defaultMessage: 'Upload',
            description: 'Text on a button that opens a file picker dialog to upload a media file'
        },
        linkTabTitle: {
            id: 'fabric.editor.media.insert.linkTabTitle',
            defaultMessage: 'Link',
            description: 'Title of the navigation tab that allows users to insert media from a URL or link'
        },
        fileTabTitle: {
            id: 'fabric.editor.media.insert.fileTabTitle',
            defaultMessage: 'File',
            description: 'Title of the navigation tab that allows users to upload local media files'
        },
        mediaPickerPopupAriaLabel: {
            id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
            defaultMessage: 'Media picker',
            description: 'Accessibility label for the media picker popup'
        },
        invalidUrlErrorMessage: {
            id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
            defaultMessage: 'Invalid link',
            description: 'Error message displayed when a user tries to insert media from an invalid URL'
        }
    });
});
parcelRegister("eQcNy", function(module, exports) {
    $parcel$export(module.exports, "walkUpTreeUntil", ()=>$ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
    $parcel$export(module.exports, "unwrap", ()=>$ab609be3c0cbf6e9$export$debb760848ca95a);
    $parcel$export(module.exports, "removeNestedEmptyEls", ()=>$ab609be3c0cbf6e9$export$5b66dc78851adb5e);
    $parcel$export(module.exports, "containsClassName", ()=>$ab609be3c0cbf6e9$export$c8913a477cc44663);
    $parcel$export(module.exports, "closest", ()=>$ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
    $parcel$export(module.exports, "closestElement", ()=>$ab609be3c0cbf6e9$export$d508bcfb7f019487);
    $parcel$export(module.exports, "parsePx", ()=>$ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
    $parcel$export(module.exports, "maphElem", ()=>$ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
    function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
        let rootElement = element;
        while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
        return rootElement;
    }
    function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
        const docsFragment = document.createDocumentFragment();
        Array.from(wrapped.children).forEach((child)=>{
            docsFragment.appendChild(child);
        });
        parent.replaceChild(docsFragment, wrapped);
    }
    function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
        while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
            const parentEl = el.parentElement;
            parentEl.removeChild(el);
            el = parentEl;
        }
    }
    const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
        if (!node) return false;
        if (node.classList && node.classList.contains) return node.classList.contains(className);
        if (!node.className) return false;
        const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
        return classNames.split(' ').indexOf(className) !== -1;
    };
    function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
        if (!node) return null;
        let el = node;
        if (!document.documentElement || !document.documentElement.contains(el)) return null;
        if (el.closest) return el.closest(s);
        do {
            const matchfn = el.matches ? el.matches : el.msMatchesSelector;
            if (matchfn && matchfn.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        }while (el !== null && el.nodeType === 1)
        return null;
    }
    function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
        return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
    }
    function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
        if (!pxStr.endsWith('px')) return undefined;
        const maybeNumber = parseInt(pxStr, 10);
        return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
    }
    function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
        const array = [];
        for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
        return array;
    }
    function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
        return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
    }
});
parcelRegister("l8Gxi", function(module, exports) {
    $parcel$export(module.exports, "RendererCssClassName", ()=>$ca55565f908e8e5d$export$91f3bbbf974496e2);
    const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
    const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
        DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
        EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
        EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
        EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
        NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
        SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
        SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
        SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
        SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
    };
});
parcelRegister("8Eu7T", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$19f8e43ef61748ed$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $dWAZk = parcelRequire("dWAZk");
    var $1KzE6;
    var $knXBU;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $19f8e43ef61748ed$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        fireAnalyticsEvent(event) {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $dWAZk.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }
        hasFallback() {
            return typeof this.props.fallbackComponent !== 'undefined';
        }
        shouldRecover() {
            return this.hasFallback() && this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            const additionalInfo = this.props.additionalInfo ?? '';
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CRASHED,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`,
                    componentStack: errorInfo?.componentStack || undefined,
                    errorRethrown: Boolean(this.props.rethrowError)
                }
            });
            (0, (0, parcelRequire("1KzE6")).logException)(error, {
                location: 'renderer'
            });
            const pattern = /Failed to execute.*on 'Node'.*/;
            const matchesPattern = pattern.test(error.message);
            if (matchesPattern) {
                this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CAUGHT_DOM_ERROR,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        errorMessage: `${additionalInfo}${error?.message}`
                    }
                });
                this.setState(()=>({
                        domError: true
                    }));
            }
            if (this.hasFallback()) this.setState({
                errorCaptured: true
            }, ()=>{
                if (this.props.rethrowError) throw error;
            });
        }
        render() {
            if (this.state.domError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: (0, ($parcel$interopDefault($7Jxgt)))()
            }, this.props.children);
            if (this.shouldRecover()) return this.props.fallbackComponent;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                errorCaptured: false,
                domError: false
            };
        }
    }
});
parcelRegister("1KzE6", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$8cb678cf4830ec10$export$f86b2a1a2ce291b3);
    var $8eFcy;
    const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
    const $8cb678cf4830ec10$var$packageName = 'editor-common';
    const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
    const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
        if (data.request) delete data.request.url;
        return data;
    };
    const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
        try {
            const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("hv9fq"));
            const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("2dUbL"));
            const sentryOptions = {
                dsn: (0, (0, parcelRequire("8eFcy")).isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
                release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
                environment: undefined ?? 'unknown',
                ignoreErrors: [
                    /^network error/i,
                    /^network failure/i,
                    'TypeError: Failed to fetch',
                    'ResizeObserver loop limit exceeded',
                    /ResizeObserver loop completed with undelivered notifications/
                ],
                autoSessionTracking: false,
                integrations: (_integrations)=>[
                        ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                        new ExtraErrorData()
                    ],
                beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
            };
            const client = new BrowserClient(sentryOptions);
            const hub = getCurrentHub();
            hub.bindClient(client);
            hub.withScope((scope)=>{
                scope.setTags({
                    'jira-bundler': window.BUNDLER_VERSION,
                    'jira-variant': window.BUILD_VARIANT,
                    'jira-release': window.BUILD_KEY,
                    'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                    ...tags
                });
                scope.clearBreadcrumbs();
                hub.captureException(error);
            });
            return client.close();
        } catch (_error) {}
    };
});
parcelRegister("8eFcy", function(module, exports) {
    $parcel$export(module.exports, "isFedRamp", ()=>$1a8a754a294d51a4$export$64d6499adf9b2e51);
    const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
    function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
        const global = globalThis;
        const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
        const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
        return matches ? matches.length > 0 : false;
    }
});
parcelRegister("hv9fq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("56SDo").then(()=>parcelRequire('hFoxV'));
});
parcelRegister("2dUbL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a12Xb").then(()=>parcelRequire('1dEW4'));
});
parcelRegister("knXBU", function(module, exports) {
    $parcel$export(module.exports, "PLATFORM", ()=>$11894d4d5d86b4b1$export$88c4881e092abcaf);
    $parcel$export(module.exports, "MODE", ()=>$11894d4d5d86b4b1$export$e48589d9e4824227);
    var $11894d4d5d86b4b1$export$88c4881e092abcaf;
    (function(PLATFORM) {
        PLATFORM["NATIVE"] = "mobileNative";
        PLATFORM["HYBRID"] = "mobileHybrid";
        PLATFORM["WEB"] = "web";
    })($11894d4d5d86b4b1$export$88c4881e092abcaf || ($11894d4d5d86b4b1$export$88c4881e092abcaf = {}));
    var $11894d4d5d86b4b1$export$e48589d9e4824227;
    (function(MODE) {
        MODE["RENDERER"] = "renderer";
        MODE["EDITOR"] = "editor";
    })($11894d4d5d86b4b1$export$e48589d9e4824227 || ($11894d4d5d86b4b1$export$e48589d9e4824227 = {}));
    var $11894d4d5d86b4b1$var$RESOLVE_METHOD;
    (function(RESOLVE_METHOD) {
        RESOLVE_METHOD["COMPONENT"] = "component";
        RESOLVE_METHOD["CONSUMER"] = "consumer";
        RESOLVE_METHOD["ORPHANED"] = "orphaned";
    })($11894d4d5d86b4b1$var$RESOLVE_METHOD || ($11894d4d5d86b4b1$var$RESOLVE_METHOD = {}));
});
parcelRegister("cWCI0", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$78ed418dcea0e38c$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$78ed418dcea0e38c$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$78ed418dcea0e38c$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$78ed418dcea0e38c$export$9957974f8b4d8f74);
    var $78ed418dcea0e38c$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($78ed418dcea0e38c$export$76a2e4c433c23bb9 || ($78ed418dcea0e38c$export$76a2e4c433c23bb9 = {}));
    var $78ed418dcea0e38c$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["STARTED"] = "started";
        ACTION["RENDERED"] = "rendered";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaught";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["CLICKED"] = "clicked";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["INSERTED"] = "inserted";
        ACTION["OPENED"] = "opened";
        ACTION["CLOSED"] = "closed";
        ACTION["DELETED"] = "deleted";
        ACTION["EDITED"] = "edited";
        ACTION["RESOLVED"] = "resolved";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    })($78ed418dcea0e38c$export$9523889e0a5da4ba || ($78ed418dcea0e38c$export$9523889e0a5da4ba = {}));
    var $78ed418dcea0e38c$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["MEDIA"] = "media";
    })($78ed418dcea0e38c$export$7525482b5931e326 || ($78ed418dcea0e38c$export$7525482b5931e326 = {}));
    var $78ed418dcea0e38c$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    })($78ed418dcea0e38c$export$9957974f8b4d8f74 || ($78ed418dcea0e38c$export$9957974f8b4d8f74 = {}));
});
parcelRegister("4YrGg", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsPositionContext", ()=>$5dd0541565473935$export$8c8c3e12db6c0591);
    $parcel$export(module.exports, "AnnotationsWrapper", ()=>$5dd0541565473935$export$cef0157dd42cbb3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $eka68;
    var $8Mz83;
    var $iYAgE;
    var $joddd;
    var $1oOiu;
    var $2NMNM;
    var $2EsbE;
    var $kuusl;
    var $4dDLS;
    var $5uoEK;
    const $5dd0541565473935$var$LoadAnnotations = (0, ($parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        (0, (0, parcelRequire("joddd")).useLoadAnnotations)({
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        });
        return null;
    });
    const $5dd0541565473935$export$8c8c3e12db6c0591 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        startPos: 1
    });
    const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
        const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
        const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
        const inlineCommentAnnotationsState = (0, (0, parcelRequire("1oOiu")).useAnnotationStateByTypeEvent)({
            type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT,
            updateSubscriber: updateSubscriber || null
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).ProvidersContext).Provider, {
            value: annotationProvider
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext).Provider, {
            value: inlineCommentAnnotationsState
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EsbE")).AnnotationRangeProvider), {
            allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kuusl")).AnnotationHoverContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Mz83")).AnnotationsContextWrapper), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5dd0541565473935$var$LoadAnnotations, {
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eka68")).AnnotationView), {
            isNestedRender: isNestedRender,
            createAnalyticsEvent: createAnalyticsEvent
        }), children)))));
    };
});
parcelRegister("eka68", function(module, exports) {
    $parcel$export(module.exports, "AnnotationView", ()=>$38b360e678e45e5a$export$41cd4a02859c2806);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    var $1oOiu;
    var $fCNtA;
    const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        const actionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const inlineCommentProvider = providers && providers.inlineComment;
        const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
        const viewComponentProps = (0, (0, parcelRequire("1oOiu")).useAnnotationClickEvent)({
            updateSubscriber: updateSubscriber,
            createAnalyticsEvent: props.createAnalyticsEvent,
            isNestedRender: props.isNestedRender
        });
        const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
        const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
            actionContext
        ]);
        const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
            actionContext
        ]);
        if (ViewComponent && viewComponentProps) {
            const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ViewComponent, {
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                getInlineNodeTypes: getInlineNodeTypes
            });
        }
        return null;
    };
});
parcelRegister("iYAgE", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsDraftContext", ()=>$1cf3b601714e6f28$export$365d1799d81a236d);
    $parcel$export(module.exports, "ProvidersContext", ()=>$1cf3b601714e6f28$export$6a26b015ac619737);
    $parcel$export(module.exports, "InlineCommentsStateContext", ()=>$1cf3b601714e6f28$export$aafe46a36ef535ba);
    $parcel$export(module.exports, "AnnotationsDraftContextWrapper", ()=>$1cf3b601714e6f28$export$153126608e00390);
    var $5uXOq = parcelRequire("5uXOq");
    const $1cf3b601714e6f28$export$365d1799d81a236d = (0, $5uXOq.createContext)(null);
    const $1cf3b601714e6f28$export$6a26b015ac619737 = (0, $5uXOq.createContext)(null);
    const $1cf3b601714e6f28$export$aafe46a36ef535ba = (0, $5uXOq.createContext)({});
    class $1cf3b601714e6f28$export$153126608e00390 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            const { position: position } = this.state;
            const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
            const clearAnnotationDraft = this.clearAnnotationDraft;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
                value: position
            }, children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                position: null
            };
            this.applyAnnotationDraftAt = (nextPosition)=>{
                const { setDraftRange: setDraftRange } = this.props;
                setDraftRange();
                this.setState({
                    position: nextPosition
                });
            };
            this.clearAnnotationDraft = ()=>{
                const { clearDraftRange: clearDraftRange } = this.props;
                clearDraftRange();
                this.setState({
                    position: null
                });
            };
        }
    }
});
parcelRegister("1oOiu", function(module, exports) {
    $parcel$export(module.exports, "useAnnotationStateByTypeEvent", ()=>$477334c02b9da473$export$95f9f9045e92d283);
    $parcel$export(module.exports, "useHasFocusEvent", ()=>$477334c02b9da473$export$48f5d7f6702be07c);
    $parcel$export(module.exports, "useAnnotationClickEvent", ()=>$477334c02b9da473$export$26cf539704e444c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dEtqo;
    var $5IPCv;
    var $88i6h;
    var $gkwXh;
    var $dWAZk = parcelRequire("dWAZk");
    const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
        const [states, setStates] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                if (!payload) return;
                const nextStates = Object.values(payload).reduce((acc, curr)=>{
                    if (curr.id && curr.annotationType === type) {
                        const isEmpty = curr.state === null || curr.state === undefined;
                        return {
                            ...acc,
                            [curr.id]: !isEmpty ? curr.state : states[curr.id]
                        };
                    }
                    return acc;
                }, {});
                setStates({
                    ...states,
                    ...nextStates
                });
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }, [
            states,
            type,
            updateSubscriber
        ]);
        return states;
    };
    const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
        const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                setHasFocus(payload && payload.annotationId === id);
            };
            const removeFocus = ()=>{
                setHasFocus(false);
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            };
        }, [
            id,
            updateSubscriber,
            isInlineCommentsKbAccessible
        ]);
        return hasFocus;
    };
    const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
        const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
        const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber || isNestedRender) return;
            const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
                const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                        id: id,
                        type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
                    }));
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: annotationsByType.length || 0,
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
                setAnnotationClickEvent({
                    annotations: annotationsByType,
                    clickElementTarget: eventTarget
                });
            };
            const deselectCb = ()=>{
                setAnnotationClickEvent({
                    annotations: [],
                    clickElementTarget: undefined
                });
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }, [
            updateSubscriber,
            createAnalyticsEvent,
            isInlineCommentsKbAccessible,
            isNestedRender
        ]);
        return annotationClickEvent;
    };
});
parcelRegister("dEtqo", function(module, exports) {
    $parcel$export(module.exports, "AnnotationUpdateEvent", ()=>$916fd31c0363f129$export$c1c4b33b4e7b1c70);
    var $6Oghe = parcelRequire("6Oghe");
    var $916fd31c0363f129$export$c1c4b33b4e7b1c70;
    (function(AnnotationUpdateEvent) {
        AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
        AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
        AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    })($916fd31c0363f129$export$c1c4b33b4e7b1c70 || ($916fd31c0363f129$export$c1c4b33b4e7b1c70 = {}));
    class $916fd31c0363f129$export$7cc60aa9ef845515 {
        emit(event, params) {
            if (typeof params === 'undefined') return this.emitter.emit(event);
            return this.emitter.emit(event, params);
        }
        on(event, listener) {
            return this.emitter.on(event, listener);
        }
        off(event, listener) {
            return this.emitter.removeListener(event, listener);
        }
        listeners(event) {
            return this.emitter.listeners(event);
        }
        constructor(){
            this.emitter = new (0, ($parcel$interopDefault($6Oghe)))();
        }
    }
});
parcelRegister("6Oghe", function(module, exports) {
    'use strict';
    var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
    var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var $4f5409da028b4771$var$ReflectOwnKeys;
    if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
    else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function $4f5409da028b4771$var$EventEmitter() {
        $4f5409da028b4771$var$EventEmitter.init.call(this);
    }
    module.exports = $4f5409da028b4771$var$EventEmitter;
    module.exports.once = $4f5409da028b4771$var$once;
    $4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
    $4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
    $4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
    $4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
    var $4f5409da028b4771$var$defaultMaxListeners = 10;
    function $4f5409da028b4771$var$checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return $4f5409da028b4771$var$defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            $4f5409da028b4771$var$defaultMaxListeners = arg;
        }
    });
    $4f5409da028b4771$var$EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function $4f5409da028b4771$var$_getMaxListeners(that) {
        if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $4f5409da028b4771$var$_getMaxListeners(this);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err;
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
            for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        $4f5409da028b4771$var$checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = $4f5409da028b4771$var$_getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $4f5409da028b4771$var$ProcessEmitWarning(w);
            }
        }
        return target;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, false);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
    $4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, true);
    };
    function $4f5409da028b4771$var$onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        $4f5409da028b4771$var$checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else $4f5409da028b4771$var$spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
    $4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
    }
    $4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, true);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, false);
    };
    $4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
    function $4f5409da028b4771$var$listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
    };
    function $4f5409da028b4771$var$arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function $4f5409da028b4771$var$spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function $4f5409da028b4771$var$unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function $4f5409da028b4771$var$once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
});
parcelRegister("fCNtA", function(module, exports) {
    $parcel$export(module.exports, "RendererContext", ()=>$7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
    $parcel$export(module.exports, "RendererActionsContext", ()=>$7e61ed70df2336e9$export$66feffbad722f9d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $6pY1y;
    const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("6pY1y")).default)());
    function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
        const actions = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("6pY1y")).default)(true), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
            value: context || actions
        }, (0, ($parcel$interopDefault($5uXOq))).Children.only(children));
    }
    const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;
});
parcelRegister("6pY1y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e7850a7dc1aaf7e$export$2e2bcd8739ae039);
    var $hYNZx;
    var $h03xs;
    var $88i6h;
    var $gZGBX;
    var $eS2Dn;
    var $cMPbW;
    var $gkwXh;
    var $hAPWV;
    var $4apTl;
    var $VSDnB;
    class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
        constructor(initFromContext = false){
            this.initFromContext = false;
            this.initFromContext = initFromContext;
            this.transformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
        }
        _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
            if (!this.initFromContext) return;
            else if (!this.ref) this.ref = ref;
            else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
            this.doc = doc;
            this.schema = schema;
            this.onAnalyticsEvent = onAnalyticsEvent;
        }
        _privateUnregisterRenderer() {
            this.doc = undefined;
            this.ref = undefined;
            this.schema = undefined;
        }
        _privateValidatePositionsForAnnotation(from, to) {
            if (!this.doc || !this.schema) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('forbid_comments_on_empty_newlines')) {
                const currentSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(this.doc, from, to);
                if ((0, (0, parcelRequire("h03xs")).isEmptyTextSelection)(currentSelection, this.schema)) return false;
            }
            return (0, (0, parcelRequire("h03xs")).canApplyAnnotationOnRange)({
                from: from,
                to: to
            }, this.doc, this.schema);
        }
        deleteAnnotation(annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const mark = this.schema.marks.annotation.create({
                id: annotationId,
                annotationType: annotationType
            });
            let from;
            let to;
            let nodePos;
            let step;
            this.doc.descendants((node, pos)=>{
                const found = mark.isInSet(node.marks);
                if (found && node.type.name === 'media') nodePos = pos;
                if (found && !from) {
                    from = pos;
                    to = pos + node.nodeSize;
                } else if (found && from) to = pos + node.nodeSize;
                return true;
            });
            if (nodePos !== undefined) step = new (0, (0, parcelRequire("eS2Dn")).RemoveNodeMarkStep)(nodePos, mark);
            else {
                if (from === undefined || to === undefined) return false;
                step = new (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep)(from, to, mark);
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (this.onAnalyticsEvent) {
                const payload = {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).DELETED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        inlineNodeNames: step instanceof (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep) ? (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                            pos: {
                                from: from,
                                to: to
                            },
                            actions: this
                        }) : undefined
                    }
                };
                this.onAnalyticsEvent(payload);
            }
            if (!failed && doc) return {
                step: step,
                doc: this.transformer.encode(doc)
            };
            return false;
        }
        annotate(range, annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos) return false;
            const { from: from, to: to } = pos;
            const validPositions = this._privateValidatePositionsForAnnotation(from, to);
            if (!validPositions) return false;
            return this.applyAnnotation(pos, {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            });
        }
        isValidAnnotationRange(range) {
            if (!range) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (this.isRendererWithinRange(range)) return false;
            }
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        isRangeAnnotatable(range) {
            try {
                if (!range) return false;
                const { startContainer: startContainer, endContainer: endContainer } = range;
                if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
                return this.isValidAnnotationRange(range);
            } catch  {
                return false;
            }
        }
        isRendererWithinRange(range) {
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
            return false;
        }
        isValidAnnotationPosition(pos) {
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        getPositionFromRange(range) {
            if (!this.doc || !this.schema || !range) return false;
            return (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
        }
        getAnnotationMarks() {
            const { schema: schema, doc: doc } = this;
            if (!schema || !doc) return [];
            const { marks: { annotation: annotationMarkType } } = schema;
            if (!annotationMarkType) return [];
            const marks = [];
            doc.descendants((node)=>{
                const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
                if (!annotationsMark || !annotationsMark.length) return true;
                marks.push(...annotationsMark);
                return false;
            });
            const uniqueMarks = new Map();
            marks.forEach((m)=>{
                uniqueMarks.set(m.attrs.id, m);
            });
            return Array.from(uniqueMarks.values());
        }
        getAnnotationsByPosition(range) {
            if (!this.doc || !this.schema) return [];
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos || !this.doc) return [];
            return (0, (0, parcelRequire("h03xs")).getAnnotationIdsFromRange)(pos, this.doc, this.schema);
        }
        applyAnnotation(pos, annotation) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const { annotationId: annotationId, annotationType: annotationType } = annotation;
            let step;
            let targetNodeType;
            const beforeNodePos = from;
            const possibleNode = this.doc.nodeAt(beforeNodePos);
            if (possibleNode?.type.name === 'media') {
                targetNodeType = 'media';
                step = new (0, (0, parcelRequire("eS2Dn")).AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                    id: annotationId,
                    type: annotationType
                }));
            } else {
                const resolvedNode = this.doc.resolve(from).node();
                targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
                step = (0, (0, parcelRequire("cMPbW")).createAnnotationStep)(from, to, {
                    annotationId: annotationId,
                    annotationType: annotationType,
                    schema: this.schema
                });
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (failed || !doc) return false;
            const originalSelection = doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("hAPWV")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                step: step,
                doc: this.transformer.encode(doc),
                inlineNodeTypes: (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    actions: this,
                    pos: {
                        from: from,
                        to: to
                    }
                }),
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos,
                targetNodeType: targetNodeType
            };
        }
        generateAnnotationIndexMatch(pos) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const originalSelection = this.doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("hAPWV")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos
            };
        }
        getInlineNodeTypes(annotationId) {
            if (!this.doc || !this.schema) return [];
            return (0, (0, parcelRequire("h03xs")).getAnnotationInlineNodeTypes)({
                doc: this.doc,
                schema: this.schema
            }, annotationId);
        }
    }
});
parcelRegister("h03xs", function(module, exports) {
    $parcel$export(module.exports, "canApplyAnnotationOnRange", ()=>$ccb20202dc8fa865$export$77ddf8216f9eb904);
    $parcel$export(module.exports, "getAnnotationIdsFromRange", ()=>$ccb20202dc8fa865$export$badbcc229c848aec);
    $parcel$export(module.exports, "hasAnnotationMark", ()=>$ccb20202dc8fa865$export$5fe1412b20386053);
    $parcel$export(module.exports, "containsAnyAnnotations", ()=>$ccb20202dc8fa865$export$1976770b876b2728);
    $parcel$export(module.exports, "getRangeInlineNodeNames", ()=>$ccb20202dc8fa865$export$35054451202ed5d9);
    $parcel$export(module.exports, "getAnnotationInlineNodeTypes", ()=>$ccb20202dc8fa865$export$8261bc1f662f3f6e);
    $parcel$export(module.exports, "getAnnotationMarksForPos", ()=>$ccb20202dc8fa865$export$bb1945a828f2864b);
    $parcel$export(module.exports, "isEmptyTextSelection", ()=>$ccb20202dc8fa865$export$2efbc6d84ea0fbec);
    var $88i6h;
    var $VSDnB;
    const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
        let foundInvalid = false;
        doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
            if (schema.nodes.hardBreak === node.type) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                    foundInvalid = true;
                    return false;
                }
            } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
            return true;
        });
        return !foundInvalid;
    };
    const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        let annotations = new Set();
        doc.nodesBetween(from, to, (node)=>{
            if (!node.marks) return true;
            node.marks.forEach((mark)=>{
                if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
            });
            return true;
        });
        return Array.from(annotations);
    };
    function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
        const { schema: { marks: { annotation: annotationMark } } } = state;
        return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
    }
    function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
        if (!slice.content.size) return false;
        let hasAnnotation = false;
        slice.content.forEach((node)=>{
            hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
            if (hasAnnotation) return true;
            node.descendants((node)=>{
                if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                    hasAnnotation = true;
                    return false;
                }
                return true;
            });
        });
        return hasAnnotation;
    }
    function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        let nodeNames = new Set();
        try {
            doc.nodesBetween(pos.from, pos.to, (node)=>{
                if (node.isInline) nodeNames.add(node.type.name);
            });
            const sortedNames = [
                ...nodeNames
            ].sort();
            return sortedNames;
        } catch  {
            return undefined;
        }
    }
    function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const mark = state.schema.marks.annotation.create({
            id: annotationId,
            annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
        });
        const inlineNodeNames = new Set();
        state.doc.descendants((node, pos)=>{
            if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
            return true;
        });
        return [
            ...inlineNodeNames
        ].sort();
    }
    function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
        const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
        return annotationMarks;
    }
    function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
        const { text: text, paragraph: paragraph } = schema.nodes;
        let hasContent = false;
        selection.content().content.descendants((node)=>{
            if (node.type === paragraph && !node.content.size) return false;
            if (node.type !== text || !node.textContent) hasContent = true;
            return !hasContent;
        });
        return !hasContent;
    }
});
parcelRegister("gZGBX", function(module, exports) {
    $parcel$export(module.exports, "Selection", ()=>$c5f36586ce432e9f$export$52baac22726c72bf);
    $parcel$export(module.exports, "SelectionRange", ()=>$c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
    $parcel$export(module.exports, "TextSelection", ()=>$c5f36586ce432e9f$export$c2b25f346d19bcbb);
    $parcel$export(module.exports, "AllSelection", ()=>$c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    $parcel$export(module.exports, "NodeSelection", ()=>$c5f36586ce432e9f$export$e2940151ac854c0b);
    $parcel$export(module.exports, "Transaction", ()=>$c5f36586ce432e9f$export$febc5573c75cefb0);
    $parcel$export(module.exports, "EditorState", ()=>$c5f36586ce432e9f$export$afa855cbfaff27f2);
    $parcel$export(module.exports, "Plugin", ()=>$c5f36586ce432e9f$export$901cf72dabf2112a);
    $parcel$export(module.exports, "PluginKey", ()=>$c5f36586ce432e9f$export$1692d8b0e89cecc3);
    var $kCV8T;
    var $eS2Dn;
    const $c5f36586ce432e9f$var$classesById = Object.create(null);
    class $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head, ranges){
            this.$anchor = $anchor;
            this.$head = $head;
            this.ranges = ranges || [
                new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
            ];
        }
        get anchor() {
            return this.$anchor.pos;
        }
        get head() {
            return this.$head.pos;
        }
        get from() {
            return this.$from.pos;
        }
        get to() {
            return this.$to.pos;
        }
        get $from() {
            return this.ranges[0].$from;
        }
        get $to() {
            return this.ranges[0].$to;
        }
        get empty() {
            let ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
            return true;
        }
        content() {
            return this.$from.doc.slice(this.from, this.to, true);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let lastNode = content.content.lastChild, lastParent = null;
            for(let i = 0; i < content.openEnd; i++){
                lastParent = lastNode;
                lastNode = lastNode.lastChild;
            }
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, (0, parcelRequire("kCV8T")).Slice).empty : content);
                if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
            }
        }
        replaceWith(tr, node) {
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                let from = mapping.map($from.pos), to = mapping.map($to.pos);
                if (i) tr.deleteRange(from, to);
                else {
                    tr.replaceRangeWith(from, to, node);
                    $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
                }
            }
        }
        static findFrom($pos, dir, textOnly = false) {
            let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
            if (inner) return inner;
            for(let depth = $pos.depth - 1; depth >= 0; depth--){
                let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
                if (found) return found;
            }
            return null;
        }
        static near($pos, bias = 1) {
            return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
        }
        static atStart(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static atEnd(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static fromJSON(doc, json) {
            if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
            let cls = $c5f36586ce432e9f$var$classesById[json.type];
            if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
            return cls.fromJSON(doc, json);
        }
        static jsonID(id, selectionClass) {
            if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
            $c5f36586ce432e9f$var$classesById[id] = selectionClass;
            selectionClass.prototype.jsonID = id;
            return selectionClass;
        }
        getBookmark() {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
    class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
        constructor($from, $to){
            this.$from = $from;
            this.$to = $to;
        }
    }
    let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
    function $c5f36586ce432e9f$var$checkTextSelection($pos) {
        if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
            $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
            console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
        }
    }
    class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head = $anchor){
            $c5f36586ce432e9f$var$checkTextSelection($anchor);
            $c5f36586ce432e9f$var$checkTextSelection($head);
            super($anchor, $head);
        }
        get $cursor() {
            return this.$anchor.pos == this.$head.pos ? this.$head : null;
        }
        map(doc, mapping) {
            let $head = doc.resolve(mapping.map(this.head));
            if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
            let $anchor = doc.resolve(mapping.map(this.anchor));
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            super.replace(tr, content);
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                let marks = this.$from.marksAcross(this.$to);
                if (marks) tr.ensureMarks(marks);
            }
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
        }
        toJSON() {
            return {
                type: "text",
                anchor: this.anchor,
                head: this.head
            };
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
        }
        static create(doc, anchor, head = anchor) {
            let $anchor = doc.resolve(anchor);
            return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
        }
        static between($anchor, $head, bias) {
            let dPos = $anchor.pos - $head.pos;
            if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
            if (!$head.parent.inlineContent) {
                let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
                if (found) $head = found.$head;
                else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
            }
            if (!$anchor.parent.inlineContent) {
                if (dPos == 0) $anchor = $head;
                else {
                    $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                    if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
                }
            }
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
    class $c5f36586ce432e9f$var$TextBookmark {
        constructor(anchor, head){
            this.anchor = anchor;
            this.head = head;
        }
        map(mapping) {
            return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
        }
        resolve(doc) {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
        }
    }
    class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($pos){
            let node = $pos.nodeAfter;
            let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
            super($pos, $end);
            this.node = node;
        }
        map(doc, mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            let $pos = doc.resolve(pos);
            if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
            return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        }
        content() {
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(this.node), 0, 0);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
        }
        toJSON() {
            return {
                type: "node",
                anchor: this.anchor
            };
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
        }
        static create(doc, from) {
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
        }
        static isSelectable(node) {
            return !node.isText && node.type.spec.selectable !== false;
        }
    }
    $c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
    class $c5f36586ce432e9f$var$NodeBookmark {
        constructor(anchor){
            this.anchor = anchor;
        }
        map(mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
        }
        resolve(doc) {
            let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
            if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
            return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        }
    }
    class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor(doc){
            super(doc.resolve(0), doc.resolve(doc.content.size));
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                tr.delete(0, tr.doc.content.size);
                let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
                if (!sel.eq(tr.selection)) tr.setSelection(sel);
            } else super.replace(tr, content);
        }
        toJSON() {
            return {
                type: "all"
            };
        }
        static fromJSON(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        map(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
        }
        getBookmark() {
            return $c5f36586ce432e9f$var$AllBookmark;
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    const $c5f36586ce432e9f$var$AllBookmark = {
        map () {
            return this;
        },
        resolve (doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
    };
    function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
        if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
        for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
            let child = node.child(i);
            if (!child.isAtom) {
                let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
                if (inner) return inner;
            } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
            pos += child.nodeSize * dir;
        }
        return null;
    }
    function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
        let last = tr.steps.length - 1;
        if (last < startLen) return;
        let step = tr.steps[last];
        if (!(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return;
        let map = tr.mapping.maps[last], end;
        map.forEach((_from, _to, _newFrom, newTo)=>{
            if (end == null) end = newTo;
        });
        tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
    }
    const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
    class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, (0, parcelRequire("eS2Dn")).Transform) {
        constructor(state){
            super(state.doc);
            this.curSelectionFor = 0;
            this.updated = 0;
            this.meta = Object.create(null);
            this.time = Date.now();
            this.curSelection = state.selection;
            this.storedMarks = state.storedMarks;
        }
        get selection() {
            if (this.curSelectionFor < this.steps.length) {
                this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
                this.curSelectionFor = this.steps.length;
            }
            return this.curSelection;
        }
        setSelection(selection) {
            if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
            this.curSelection = selection;
            this.curSelectionFor = this.steps.length;
            this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
            return this;
        }
        get selectionSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
        }
        setStoredMarks(marks) {
            this.storedMarks = marks;
            this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
            return this;
        }
        ensureMarks(marks) {
            if (!(0, (0, parcelRequire("kCV8T")).Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
            return this;
        }
        addStoredMark(mark) {
            return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
        }
        removeStoredMark(mark) {
            return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
        }
        get storedMarksSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
        }
        addStep(step, doc) {
            super.addStep(step, doc);
            this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
        }
        setTime(time) {
            this.time = time;
            return this;
        }
        replaceSelection(slice) {
            this.selection.replace(this, slice);
            return this;
        }
        replaceSelectionWith(node, inheritMarks = true) {
            let selection = this.selection;
            if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, (0, parcelRequire("kCV8T")).Mark).none));
            selection.replaceWith(this, node);
            return this;
        }
        deleteSelection() {
            this.selection.replace(this);
            return this;
        }
        insertText(text, from, to) {
            let schema = this.doc.type.schema;
            if (from == null) {
                if (!text) return this.deleteSelection();
                return this.replaceSelectionWith(schema.text(text), true);
            } else {
                if (to == null) to = from;
                to = to == null ? from : to;
                if (!text) return this.deleteRange(from, to);
                let marks = this.storedMarks;
                if (!marks) {
                    let $from = this.doc.resolve(from);
                    marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
                }
                this.replaceRangeWith(from, to, schema.text(text, marks));
                if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
                return this;
            }
        }
        setMeta(key, value) {
            this.meta[typeof key == "string" ? key : key.key] = value;
            return this;
        }
        getMeta(key) {
            return this.meta[typeof key == "string" ? key : key.key];
        }
        get isGeneric() {
            for(let _ in this.meta)return false;
            return true;
        }
        scrollIntoView() {
            this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
            return this;
        }
        get scrolledIntoView() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
        }
    }
    function $c5f36586ce432e9f$var$bind(f, self) {
        return !self || !f ? f : f.bind(self);
    }
    class $c5f36586ce432e9f$var$FieldDesc {
        constructor(name, desc, self){
            this.name = name;
            this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
            this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
        }
    }
    const $c5f36586ce432e9f$var$baseFields = [
        new $c5f36586ce432e9f$var$FieldDesc("doc", {
            init (config) {
                return config.doc || config.schema.topNodeType.createAndFill();
            },
            apply (tr) {
                return tr.doc;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("selection", {
            init (config, instance) {
                return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
            },
            apply (tr) {
                return tr.selection;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
            init (config) {
                return config.storedMarks || null;
            },
            apply (tr, _marks, _old, state) {
                return state.selection.$cursor ? tr.storedMarks : null;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
            init () {
                return 0;
            },
            apply (tr, prev) {
                return tr.scrolledIntoView ? prev + 1 : prev;
            }
        })
    ];
    class $c5f36586ce432e9f$var$Configuration {
        constructor(schema, plugins){
            this.schema = schema;
            this.plugins = [];
            this.pluginsByKey = Object.create(null);
            this.fields = $c5f36586ce432e9f$var$baseFields.slice();
            if (plugins) plugins.forEach((plugin)=>{
                if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
        }
    }
    class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
        constructor(config){
            this.config = config;
        }
        get schema() {
            return this.config.schema;
        }
        get plugins() {
            return this.config.plugins;
        }
        apply(tr) {
            return this.applyTransaction(tr).state;
        }
        filterTransaction(tr, ignore = -1) {
            for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
            }
            return true;
        }
        applyTransaction(rootTr) {
            if (!this.filterTransaction(rootTr)) return {
                state: this,
                transactions: []
            };
            let trs = [
                rootTr
            ], newState = this.applyInner(rootTr), seen = null;
            for(;;){
                let haveNew = false;
                for(let i = 0; i < this.config.plugins.length; i++){
                    let plugin = this.config.plugins[i];
                    if (plugin.spec.appendTransaction) {
                        let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                        let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                        if (tr && newState.filterTransaction(tr, i)) {
                            tr.setMeta("appendedTransaction", rootTr);
                            if (!seen) {
                                seen = [];
                                for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                    state: newState,
                                    n: trs.length
                                } : {
                                    state: this,
                                    n: 0
                                });
                            }
                            trs.push(tr);
                            newState = newState.applyInner(tr);
                            haveNew = true;
                        }
                        if (seen) seen[i] = {
                            state: newState,
                            n: trs.length
                        };
                    }
                }
                if (!haveNew) return {
                    state: newState,
                    transactions: trs
                };
            }
        }
        applyInner(tr) {
            if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
            let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
            for(let i = 0; i < fields.length; i++){
                let field = fields[i];
                newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
            }
            return newInstance;
        }
        get tr() {
            return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
        }
        static create(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
            return instance;
        }
        reconfigure(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
            let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < fields.length; i++){
                let name = fields[i].name;
                instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
            }
            return instance;
        }
        toJSON(pluginFields) {
            let result = {
                doc: this.doc.toJSON(),
                selection: this.selection.toJSON()
            };
            if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
            if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
                if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
            return result;
        }
        static fromJSON(config, json, pluginFields) {
            if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
            if (!config.schema) throw new RangeError("Required config field 'schema' missing");
            let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            $config.fields.forEach((field)=>{
                if (field.name == "doc") instance.doc = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(config.schema, json.doc);
                else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
                else if (field.name == "storedMarks") {
                    if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
                } else {
                    if (pluginFields) for(let prop in pluginFields){
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                    instance[field.name] = field.init(config, instance);
                }
            });
            return instance;
        }
    }
    function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
        for(let prop in obj){
            let val = obj[prop];
            if (val instanceof Function) val = val.bind(self);
            else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
            target[prop] = val;
        }
        return target;
    }
    class $c5f36586ce432e9f$export$901cf72dabf2112a {
        constructor(spec){
            this.spec = spec;
            this.props = {};
            if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
            this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
        }
        getState(state) {
            return state[this.key];
        }
    }
    const $c5f36586ce432e9f$var$keys = Object.create(null);
    function $c5f36586ce432e9f$var$createKey(name) {
        if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
        $c5f36586ce432e9f$var$keys[name] = 0;
        return name + "$";
    }
    class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
        constructor(name = "key"){
            this.key = $c5f36586ce432e9f$var$createKey(name);
        }
        get(state) {
            return state.config.pluginsByKey[this.key];
        }
        getState(state) {
            return state[this.key];
        }
    }
});
parcelRegister("eS2Dn", function(module, exports) {
    $parcel$export(module.exports, "StepMap", ()=>$ad3826e817ebec37$export$c53d01c3ab9721b3);
    $parcel$export(module.exports, "Mapping", ()=>$ad3826e817ebec37$export$f5f785078011b62);
    $parcel$export(module.exports, "Step", ()=>$ad3826e817ebec37$export$fd55ce593607084a);
    $parcel$export(module.exports, "StepResult", ()=>$ad3826e817ebec37$export$8ebf1578a4199c09);
    $parcel$export(module.exports, "AddMarkStep", ()=>$ad3826e817ebec37$export$d24ba56b0e3464a9);
    $parcel$export(module.exports, "RemoveMarkStep", ()=>$ad3826e817ebec37$export$94150db1311f67a9);
    $parcel$export(module.exports, "AddNodeMarkStep", ()=>$ad3826e817ebec37$export$adefd16c402fee4e);
    $parcel$export(module.exports, "RemoveNodeMarkStep", ()=>$ad3826e817ebec37$export$fdf7d1dc10724da2);
    $parcel$export(module.exports, "ReplaceStep", ()=>$ad3826e817ebec37$export$5c860b2e74034756);
    $parcel$export(module.exports, "ReplaceAroundStep", ()=>$ad3826e817ebec37$export$444ba800d6024a98);
    $parcel$export(module.exports, "liftTarget", ()=>$ad3826e817ebec37$export$f1508b72cc76a09e);
    $parcel$export(module.exports, "findWrapping", ()=>$ad3826e817ebec37$export$118cb9a83e81ba37);
    $parcel$export(module.exports, "canSplit", ()=>$ad3826e817ebec37$export$5aaf008897aef029);
    $parcel$export(module.exports, "canJoin", ()=>$ad3826e817ebec37$export$f15f89fd9d8cc98a);
    $parcel$export(module.exports, "joinPoint", ()=>$ad3826e817ebec37$export$41b1d4cb5ceb3147);
    $parcel$export(module.exports, "insertPoint", ()=>$ad3826e817ebec37$export$64cb316d02de1dd1);
    $parcel$export(module.exports, "dropPoint", ()=>$ad3826e817ebec37$export$2819d598d048fc9c);
    $parcel$export(module.exports, "replaceStep", ()=>$ad3826e817ebec37$export$ed6ac67359824afd);
    $parcel$export(module.exports, "AttrStep", ()=>$ad3826e817ebec37$export$626399c38172f669);
    $parcel$export(module.exports, "DocAttrStep", ()=>$ad3826e817ebec37$export$f50707b396300ac9);
    $parcel$export(module.exports, "Transform", ()=>$ad3826e817ebec37$export$563a914cafbdc389);
    var $kCV8T;
    const $ad3826e817ebec37$var$lower16 = 0xffff;
    const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
    function $ad3826e817ebec37$var$makeRecover(index, offset) {
        return index + offset * $ad3826e817ebec37$var$factor16;
    }
    function $ad3826e817ebec37$var$recoverIndex(value) {
        return value & $ad3826e817ebec37$var$lower16;
    }
    function $ad3826e817ebec37$var$recoverOffset(value) {
        return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
    }
    const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
    class $ad3826e817ebec37$export$c77c9be41668e9b4 {
        constructor(pos, delInfo, recover){
            this.pos = pos;
            this.delInfo = delInfo;
            this.recover = recover;
        }
        get deleted() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
        }
        get deletedBefore() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAfter() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAcross() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
        }
    }
    class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
        constructor(ranges, inverted = false){
            this.ranges = ranges;
            this.inverted = inverted;
            if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        recover(value) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
            if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
            return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        map(pos, assoc = 1) {
            return this._map(pos, assoc, true);
        }
        _map(pos, assoc, simple) {
            let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
                if (pos <= end) {
                    let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                    let result = start + diff + (side < 0 ? 0 : newSize);
                    if (simple) return result;
                    let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                    let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                    if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                    return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
                }
                diff += newSize - oldSize;
            }
            return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
        }
        touches(pos, recover) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
                if (pos <= end && i == index * 3) return true;
                diff += this.ranges[i + newIndex] - oldSize;
            }
            return false;
        }
        forEach(f) {
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
                f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
                diff += newSize - oldSize;
            }
        }
        invert() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
        }
        toString() {
            return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
        }
        static offset(n) {
            return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
                0,
                -n,
                0
            ] : [
                0,
                0,
                n
            ]);
        }
    }
    $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
    class $ad3826e817ebec37$export$f5f785078011b62 {
        constructor(maps = [], mirror, from = 0, to = maps.length){
            this.maps = maps;
            this.mirror = mirror;
            this.from = from;
            this.to = to;
        }
        slice(from = 0, to = this.maps.length) {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
        }
        copy() {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
        }
        appendMap(map, mirrors) {
            this.to = this.maps.push(map);
            if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
        }
        appendMapping(mapping) {
            for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
            }
        }
        getMirror(n) {
            if (this.mirror) {
                for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
            }
        }
        setMirror(n, m) {
            if (!this.mirror) this.mirror = [];
            this.mirror.push(n, m);
        }
        appendMappingInverted(mapping) {
            for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
            }
        }
        invert() {
            let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
            inverse.appendMappingInverted(this);
            return inverse;
        }
        map(pos, assoc = 1) {
            if (this.mirror) return this._map(pos, assoc, true);
            for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
            return pos;
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        _map(pos, assoc, simple) {
            let delInfo = 0;
            for(let i = this.from; i < this.to; i++){
                let map = this.maps[i], result = map.mapResult(pos, assoc);
                if (result.recover != null) {
                    let corr = this.getMirror(i);
                    if (corr != null && corr > i && corr < this.to) {
                        i = corr;
                        pos = this.maps[corr].recover(result.recover);
                        continue;
                    }
                }
                delInfo |= result.delInfo;
                pos = result.pos;
            }
            return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
        }
    }
    const $ad3826e817ebec37$var$stepsByID = Object.create(null);
    class $ad3826e817ebec37$export$fd55ce593607084a {
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        merge(other) {
            return null;
        }
        static fromJSON(schema, json) {
            if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
            let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
            if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
            return type.fromJSON(schema, json);
        }
        static jsonID(id, stepClass) {
            if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
            $ad3826e817ebec37$var$stepsByID[id] = stepClass;
            stepClass.prototype.jsonID = id;
            return stepClass;
        }
    }
    class $ad3826e817ebec37$export$8ebf1578a4199c09 {
        constructor(doc, failed){
            this.doc = doc;
            this.failed = failed;
        }
        static ok(doc) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
        }
        static fail(message) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
        }
        static fromReplace(doc, from, to, slice) {
            try {
                return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("kCV8T")).ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
                throw e;
            }
        }
    }
    function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
        let mapped = [];
        for(let i = 0; i < fragment.childCount; i++){
            let child = fragment.child(i);
            if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
            if (child.isInline) child = f(child, parent, i);
            mapped.push(child);
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(mapped);
    }
    class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
            let parent = $from.node($from.sharedDepth(this.to));
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
                if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
                return node.mark(this.mark.addToSet(node.marks));
            }, parent), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "addMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
    class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to);
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
                return node.mark(this.mark.removeFromSet(node.marks));
            }, doc), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "removeMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
    class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (node) {
                let newSet = this.mark.addToSet(node.marks);
                if (newSet.length == node.marks.length) {
                    for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                    return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
                }
            }
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "addNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
    class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node || !this.mark.isInSet(node.marks)) return this;
            return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "removeNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
    class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, slice, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.slice = slice;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.to - this.from,
                this.slice.size
            ]);
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deletedAcross && to.deletedAcross) return null;
            return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
        }
        merge(other) {
            if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
            if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
            } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
            } else return null;
        }
        toJSON() {
            let json = {
                stepType: "replace",
                from: this.from,
                to: this.to
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
            return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
    class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, gapFrom, gapTo, slice, insert, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.gapFrom = gapFrom;
            this.gapTo = gapTo;
            this.slice = slice;
            this.insert = insert;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
            let gap = doc.slice(this.gapFrom, this.gapTo);
            if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
            let inserted = this.slice.insertAt(this.insert, gap.content);
            if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.gapFrom - this.from,
                this.insert,
                this.gapTo,
                this.to - this.gapTo,
                this.slice.size - this.insert
            ]);
        }
        invert(doc) {
            let gap = this.gapTo - this.gapFrom;
            return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
            let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
            if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
            return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
        }
        toJSON() {
            let json = {
                stepType: "replaceAround",
                from: this.from,
                to: this.to,
                gapFrom: this.gapFrom,
                gapTo: this.gapTo,
                insert: this.insert
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
            return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
    function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
        let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
        while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
            depth--;
            dist--;
        }
        if (dist > 0) {
            let next = $from.node(depth).maybeChild($from.indexAfter(depth));
            while(dist > 0){
                if (!next || next.isLeaf) return true;
                next = next.firstChild;
                dist--;
            }
        }
        return false;
    }
    function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
        let removed = [], added = [];
        let removing, adding;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.isInline) return;
            let marks = node.marks;
            if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
                let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
                let newSet = mark.addToSet(marks);
                for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                    else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
                }
                if (adding && adding.to == start) adding.to = end;
                else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
            }
        });
        removed.forEach((s)=>tr.step(s));
        added.forEach((s)=>tr.step(s));
    }
    function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
        let matched = [], step = 0;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isInline) return;
            step++;
            let toRemove = null;
            if (mark instanceof (0, (0, parcelRequire("kCV8T")).MarkType)) {
                let set = node.marks, found;
                while(found = mark.isInSet(set)){
                    (toRemove || (toRemove = [])).push(found);
                    set = found.removeFromSet(set);
                }
            } else if (mark) {
                if (mark.isInSet(node.marks)) toRemove = [
                    mark
                ];
            } else toRemove = node.marks;
            if (toRemove && toRemove.length) {
                let end = Math.min(pos + node.nodeSize, to);
                for(let i = 0; i < toRemove.length; i++){
                    let style = toRemove[i], found;
                    for(let j = 0; j < matched.length; j++){
                        let m = matched[j];
                        if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                    }
                    if (found) {
                        found.to = end;
                        found.step = step;
                    } else matched.push({
                        style: style,
                        from: Math.max(pos, from),
                        to: end,
                        step: step
                    });
                }
            }
        });
        matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
    }
    function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
        let node = tr.doc.nodeAt(pos);
        let replSteps = [], cur = pos + 1;
        for(let i = 0; i < node.childCount; i++){
            let child = node.child(i), end = cur + child.nodeSize;
            let allowed = match.matchType(child.type);
            if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, (0, parcelRequire("kCV8T")).Slice).empty));
            else {
                match = allowed;
                for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
                if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                    let m, newline = /\r?\n|\r/g, slice;
                    while(m = newline.exec(child.text)){
                        if (!slice) slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                        replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                    }
                }
            }
            cur = end;
        }
        if (!match.validEnd) {
            let fill = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            tr.replace(cur, cur, new (0, (0, parcelRequire("kCV8T")).Slice)(fill, 0, 0));
        }
        for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
    }
    function $ad3826e817ebec37$var$canCut(node, start, end) {
        return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
    }
    function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
        let parent = range.parent;
        let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
        for(let depth = range.depth;; --depth){
            let node = range.$from.node(depth);
            let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
            if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
            if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
        }
        return null;
    }
    function $ad3826e817ebec37$var$lift(tr, range, target) {
        let { $from: $from, $to: $to, depth: depth } = range;
        let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
        let start = gapStart, end = gapEnd;
        let before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openStart = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(d).copy(before));
            openStart++;
        } else start--;
        let after = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openEnd = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from($to.node(d).copy(after));
            openEnd++;
        } else end++;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
    }
    function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
        let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
        let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
        if (!inner) return null;
        return around.map($ad3826e817ebec37$var$withAttrs).concat({
            type: nodeType,
            attrs: attrs
        }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
    }
    function $ad3826e817ebec37$var$withAttrs(type) {
        return {
            type: type,
            attrs: null
        };
    }
    function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let around = parent.contentMatchAt(startIndex).findWrapping(type);
        if (!around) return null;
        let outer = around.length ? around[0] : type;
        return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
    }
    function $ad3826e817ebec37$var$findWrappingInside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let inner = parent.child(startIndex);
        let inside = type.contentMatch.findWrapping(inner.type);
        if (!inside) return null;
        let lastType = inside.length ? inside[inside.length - 1] : type;
        let innerMatch = lastType.contentMatch;
        for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
        if (!innerMatch || !innerMatch.validEnd) return null;
        return inside;
    }
    function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
        let content = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let i = wrappers.length - 1; i >= 0; i--){
            if (content.size) {
                let match = wrappers[i].type.contentMatch.matchFragment(content);
                if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
            }
            content = (0, (0, parcelRequire("kCV8T")).Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
        }
        let start = range.start, end = range.end;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, (0, parcelRequire("kCV8T")).Slice)(content, 0, 0), wrappers.length, true));
    }
    function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
        if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
        let mapFrom = tr.steps.length;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
            if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
                let convertNewlines = null;
                if (type.schema.linebreakReplacement) {
                    let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                    if (pre && !supportLinebreak) convertNewlines = false;
                    else if (!pre && supportLinebreak) convertNewlines = true;
                }
                if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
                $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
                let mapping = tr.mapping.slice(mapFrom);
                let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
                tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
                if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
                return false;
            }
        });
    }
    function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.isText) {
                let m, newline = /\r?\n|\r/g;
                while(m = newline.exec(child.text)){
                    let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                    tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
                }
            }
        });
    }
    function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.type == child.type.schema.linebreakReplacement) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
                tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
            }
        });
    }
    function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, type);
    }
    function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
        let node = tr.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at given position");
        if (!type) type = node.type;
        let newNode = type.create(attrs, null, marks || node.marks);
        if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
        if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(newNode), 0, 0), 1, true));
    }
    function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
        let $pos = doc.resolve(pos), base = $pos.depth - depth;
        let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
        if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
        for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
            let node = $pos.node(d), index = $pos.index(d);
            if (node.type.spec.isolating) return false;
            let rest = node.content.cutByIndex(index, node.childCount);
            let overrideChild = typesAfter && typesAfter[i + 1];
            if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
            let after = typesAfter && typesAfter[i] || node;
            if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
        }
        let index = $pos.indexAfter(base);
        let baseType = typesAfter && typesAfter[0];
        return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
    }
    function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
        let $pos = tr.doc.resolve(pos), before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, after = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($pos.node(d).copy(before));
            let typeAfter = typesAfter && typesAfter[i];
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
        }
        tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), depth, depth), true));
    }
    function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
    }
    function $ad3826e817ebec37$var$joinable(a, b) {
        return !!(a && b && !a.isLeaf && a.canAppend(b));
    }
    function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
        let $pos = doc.resolve(pos);
        for(let d = $pos.depth;; d--){
            let before, after, index = $pos.index(d);
            if (d == $pos.depth) {
                before = $pos.nodeBefore;
                after = $pos.nodeAfter;
            } else if (dir > 0) {
                before = $pos.node(d + 1);
                index++;
                after = $pos.node(d).maybeChild(index);
            } else {
                before = $pos.node(d).maybeChild(index - 1);
                after = $pos.node(d + 1);
            }
            if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
            if (d == 0) break;
            pos = dir < 0 ? $pos.before(d) : $pos.after(d);
        }
    }
    function $ad3826e817ebec37$var$join(tr, pos, depth) {
        let step = new $ad3826e817ebec37$export$5c860b2e74034756(pos - depth, pos + depth, (0, (0, parcelRequire("kCV8T")).Slice).empty, true);
        tr.step(step);
    }
    function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
        let $pos = doc.resolve(pos);
        if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
        if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
            if (index > 0) return null;
        }
        if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
            if (index < $pos.node(d).childCount) return null;
        }
        return null;
    }
    function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
        let $pos = doc.resolve(pos);
        if (!slice.content.size) return pos;
        let content = slice.content;
        for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
        for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
        return null;
    }
    function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
        if (from == to && !slice.size) return null;
        let $from = doc.resolve(from), $to = doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
        return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
    }
    function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
        return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
    }
    class $ad3826e817ebec37$var$Fitter {
        constructor($from, $to, unplaced){
            this.$from = $from;
            this.$to = $to;
            this.unplaced = unplaced;
            this.frontier = [];
            this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
            for(let i = 0; i <= $from.depth; i++){
                let node = $from.node(i);
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt($from.indexAfter(i))
                });
            }
            for(let i = $from.depth; i > 0; i--)this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(i).copy(this.placed));
        }
        get depth() {
            return this.frontier.length - 1;
        }
        fit() {
            while(this.unplaced.size){
                let fit = this.findFittable();
                if (fit) this.placeNodes(fit);
                else this.openMore() || this.dropNode();
            }
            let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
            let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
            if (!$to) return null;
            let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
            while(openStart && openEnd && content.childCount == 1){
                content = content.firstChild.content;
                openStart--;
                openEnd--;
            }
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd);
            if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
            if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
            return null;
        }
        findFittable() {
            let startDepth = this.unplaced.openStart;
            for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
                let node = cur.firstChild;
                if (cur.childCount > 1) openEnd = 0;
                if (node.type.spec.isolating && openEnd <= d) {
                    startDepth = d;
                    break;
                }
                cur = node.content;
            }
            for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                } else fragment = this.unplaced.content;
                let first = fragment.firstChild;
                for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                    let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        inject: inject
                    };
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        wrap: wrap
                    };
                    if (parent && match.matchType(parent.type)) break;
                }
            }
        }
        openMore() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (!inner.childCount || inner.firstChild.isLeaf) return false;
            this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
            return true;
        }
        dropNode() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (inner.childCount <= 1 && openStart > 0) {
                let openAtEnd = content.size - openStart <= openStart + inner.size;
                this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
            } else this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
        placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
            while(this.depth > frontierDepth)this.closeFrontierNode();
            if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
            let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
            let openStart = slice.openStart - sliceDepth;
            let taken = 0, add = [];
            let { match: match, type: type } = this.frontier[frontierDepth];
            if (inject) {
                for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
                match = match.matchFragment(inject);
            }
            let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
            while(taken < fragment.childCount){
                let next = fragment.child(taken), matches = match.matchType(next.type);
                if (!matches) break;
                taken++;
                if (taken > 1 || openStart == 0 || next.content.size) {
                    match = matches;
                    add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
                }
            }
            let toEnd = taken == fragment.childCount;
            if (!toEnd) openEndCount = -1;
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, (0, parcelRequire("kCV8T")).Fragment).from(add));
            this.frontier[frontierDepth].match = match;
            if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
            for(let i = 0, cur = fragment; i < openEndCount; i++){
                let node = cur.lastChild;
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt(node.childCount)
                });
                cur = node.content;
            }
            this.unplaced = !toEnd ? new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
        }
        mustMoveInline() {
            if (!this.$to.parent.isTextblock) return -1;
            let top = this.frontier[this.depth], level;
            if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
            let { depth: depth } = this.$to, after = this.$to.after(depth);
            while(depth > 1 && after == this.$to.end(--depth))++after;
            return after;
        }
        findCloseLevel($to) {
            scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
                let { match: match, type: type } = this.frontier[i];
                let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
                let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
                if (!fit) continue;
                for(let d = i - 1; d >= 0; d--){
                    let { match: match, type: type } = this.frontier[d];
                    let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                    if (!matches || matches.childCount) continue scan;
                }
                return {
                    depth: i,
                    fit: fit,
                    move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
                };
            }
        }
        close($to) {
            let close = this.findCloseLevel($to);
            if (!close) return null;
            while(this.depth > close.depth)this.closeFrontierNode();
            if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
            $to = close.move;
            for(let d = close.depth + 1; d <= $to.depth; d++){
                let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
                this.openFrontierNode(node.type, node.attrs, add);
            }
            return $to;
        }
        openFrontierNode(type, attrs = null, content) {
            let top = this.frontier[this.depth];
            top.match = top.match.matchType(type);
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrs, content)));
            this.frontier.push({
                type: type,
                match: type.contentMatch
            });
        }
        closeFrontierNode() {
            let open = this.frontier.pop();
            let add = open.match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
        }
    }
    function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
        if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
        return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
    }
    function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
        if (depth == 0) return fragment.append(content);
        return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
    }
    function $ad3826e817ebec37$var$contentAt(fragment, depth) {
        for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
        return fragment;
    }
    function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
        if (openStart <= 0) return node;
        let frag = node.content;
        if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
        if (openStart > 0) {
            frag = node.type.contentMatch.fillBefore(frag).append(frag);
            if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return node.copy(frag);
    }
    function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
        let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
        if (index == node.childCount && !type.compatibleContent(node.type)) return null;
        let fit = match.fillBefore(node.content, true, index);
        return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
    }
    function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
        for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
        return false;
    }
    function $ad3826e817ebec37$var$definesContent(type) {
        return type.spec.defining || type.spec.definingForContent;
    }
    function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
        if (!slice.size) return tr.deleteRange(from, to);
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
        let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
        if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
        let preferredTarget = -($from.depth + 1);
        targetDepths.unshift(preferredTarget);
        for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
            let spec = $from.node(d).type.spec;
            if (spec.defining || spec.definingAsContext || spec.isolating) break;
            if (targetDepths.indexOf(d) > -1) preferredTarget = d;
            else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
        }
        let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
        let leftNodes = [], preferredDepth = slice.openStart;
        for(let content = slice.content, i = 0;; i++){
            let node = content.firstChild;
            leftNodes.push(node);
            if (i == slice.openStart) break;
            content = node.content;
        }
        for(let d = preferredDepth - 1; d >= 0; d--){
            let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
            if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
            else if (def || !leftNode.type.isTextblock) break;
        }
        for(let j = slice.openStart; j >= 0; j--){
            let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
            let insert = leftNodes[openDepth];
            if (!insert) continue;
            for(let i = 0; i < targetDepths.length; i++){
                let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
                if (targetDepth < 0) {
                    expand = false;
                    targetDepth = -targetDepth;
                }
                let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
                if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
            }
        }
        let startSteps = tr.steps.length;
        for(let i = targetDepths.length - 1; i >= 0; i--){
            tr.replace(from, to, slice);
            if (tr.steps.length > startSteps) break;
            let depth = targetDepths[i];
            if (depth < 0) continue;
            from = $from.before(depth);
            to = $to.after(depth);
        }
    }
    function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
        if (depth < oldOpen) {
            let first = fragment.firstChild;
            fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
        }
        if (depth > newOpen) {
            let match = parent.contentMatchAt(0);
            let start = match.fillBefore(fragment).append(fragment);
            fragment = start.append(match.matchFragment(start).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return fragment;
    }
    function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
        if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
            let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
            if (point != null) from = to = point;
        }
        tr.replaceRange(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(node), 0, 0));
    }
    function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
        for(let i = 0; i < covered.length; i++){
            let depth = covered[i], last = i == covered.length - 1;
            if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
            if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
        }
        for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
            if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
        }
        tr.delete(from, to);
    }
    function $ad3826e817ebec37$var$coveredDepths($from, $to) {
        let result = [], minDepth = Math.min($from.depth, $to.depth);
        for(let d = minDepth; d >= 0; d--){
            let start = $from.start(d);
            if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
            if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
        }
        return result;
    }
    class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, attr, value){
            super();
            this.pos = pos;
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
            let attrs = Object.create(null);
            for(let name in node.attrs)attrs[name] = node.attrs[name];
            attrs[this.attr] = this.value;
            let updated = node.type.create(attrs, null, node.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
        }
        toJSON() {
            return {
                stepType: "attr",
                pos: this.pos,
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
            return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
    class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(attr, value){
            super();
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let attrs = Object.create(null);
            for(let name in doc.attrs)attrs[name] = doc.attrs[name];
            attrs[this.attr] = this.value;
            let updated = doc.type.create(attrs, doc.content, doc.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
        }
        map(mapping) {
            return this;
        }
        toJSON() {
            return {
                stepType: "docAttr",
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
            return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
    let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
        let err = Error.call(this, message);
        err.__proto__ = TransformError.prototype;
        return err;
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
    class $ad3826e817ebec37$export$563a914cafbdc389 {
        constructor(doc){
            this.doc = doc;
            this.steps = [];
            this.docs = [];
            this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
        }
        get before() {
            return this.docs.length ? this.docs[0] : this.doc;
        }
        step(step) {
            let result = this.maybeStep(step);
            if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
            return this;
        }
        maybeStep(step) {
            let result = step.apply(this.doc);
            if (!result.failed) this.addStep(step, result.doc);
            return result;
        }
        get docChanged() {
            return this.steps.length > 0;
        }
        addStep(step, doc) {
            this.docs.push(this.doc);
            this.steps.push(step);
            this.mapping.appendMap(step.getMap());
            this.doc = doc;
        }
        replace(from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
            if (step) this.step(step);
            return this;
        }
        replaceWith(from, to, content) {
            return this.replace(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(content), 0, 0));
        }
        delete(from, to) {
            return this.replace(from, to, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
        insert(pos, content) {
            return this.replaceWith(pos, pos, content);
        }
        replaceRange(from, to, slice) {
            $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
            return this;
        }
        replaceRangeWith(from, to, node) {
            $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
            return this;
        }
        deleteRange(from, to) {
            $ad3826e817ebec37$var$deleteRange(this, from, to);
            return this;
        }
        lift(range, target) {
            $ad3826e817ebec37$var$lift(this, range, target);
            return this;
        }
        join(pos, depth = 1) {
            $ad3826e817ebec37$var$join(this, pos, depth);
            return this;
        }
        wrap(range, wrappers) {
            $ad3826e817ebec37$var$wrap(this, range, wrappers);
            return this;
        }
        setBlockType(from, to = from, type, attrs = null) {
            $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
            return this;
        }
        setNodeMarkup(pos, type, attrs = null, marks) {
            $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
            return this;
        }
        setNodeAttribute(pos, attr, value) {
            this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
            return this;
        }
        setDocAttribute(attr, value) {
            this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
            return this;
        }
        addNodeMark(pos, mark) {
            this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
            return this;
        }
        removeNodeMark(pos, mark) {
            if (!(mark instanceof (0, (0, parcelRequire("kCV8T")).Mark))) {
                let node = this.doc.nodeAt(pos);
                if (!node) throw new RangeError("No node at position " + pos);
                mark = mark.isInSet(node.marks);
                if (!mark) return this;
            }
            this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
            return this;
        }
        split(pos, depth = 1, typesAfter) {
            $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
            return this;
        }
        addMark(from, to, mark) {
            $ad3826e817ebec37$var$addMark(this, from, to, mark);
            return this;
        }
        removeMark(from, to, mark) {
            $ad3826e817ebec37$var$removeMark(this, from, to, mark);
            return this;
        }
        clearIncompatible(pos, parentType, match) {
            $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
            return this;
        }
    }
});
parcelRegister("cMPbW", function(module, exports) {
    $parcel$export(module.exports, "isRoot", ()=>$c9441534493a403f$export$e3140dc7d0c35e48);
    $parcel$export(module.exports, "getPosFromRange", ()=>$c9441534493a403f$export$243cdddc5b21d8c1);
    $parcel$export(module.exports, "createAnnotationStep", ()=>$c9441534493a403f$export$74899f7e5acb5cd3);
    var $VSDnB;
    var $eS2Dn;
    function $c9441534493a403f$var$getStartPos(element) {
        return parseInt(element.dataset.rendererStartPos || '-1', 10);
    }
    const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
    function $c9441534493a403f$var$isPositionPointer(element) {
        return $c9441534493a403f$var$getStartPos(element) > -1;
    }
    function $c9441534493a403f$var$findParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
        if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
        return $c9441534493a403f$var$findParent(parentElement);
    }
    function $c9441534493a403f$var$findMediaParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
        if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
        return $c9441534493a403f$var$findMediaParent(parentElement);
    }
    function $c9441534493a403f$var$findParentBeforePointer(element) {
        const { parentElement: parentElement } = element;
        if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
        if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
        return $c9441534493a403f$var$findParentBeforePointer(parentElement);
    }
    function $c9441534493a403f$var$isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    }
    function $c9441534493a403f$var$isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    }
    function $c9441534493a403f$var$isHighlightTextNode(node) {
        return !!node?.dataset?.highlighted;
    }
    function $c9441534493a403f$var$isNodeInlineMark(node) {
        return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    }
    function $c9441534493a403f$var$isElementInlineMark(element) {
        return !!element && Boolean(element.dataset.rendererMark);
    }
    function $c9441534493a403f$var$isNodeInlineTextMark(node) {
        if (node === null) return false;
        const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
        if (!isInlineMark) return false;
        if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
        return true;
    }
    function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
        if ($c9441534493a403f$var$isElementNode(node)) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.dataset.annotationInlineNode === 'true') return true;
            } else {
                if (node.dataset.inlineCard === 'true') return true;
            }
            return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
        }
        return false;
    }
    function $c9441534493a403f$var$resolveNodePos(node) {
        let resolvedPos = 0;
        let prev = node.previousSibling;
        while(prev){
            if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
            else if (prev) {
                if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                    if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                    else resolvedPos += 1;
                } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            }
            prev = prev.previousSibling;
        }
        return resolvedPos;
    }
    function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
        return !!element && element.classList.contains('ak-renderer-document');
    }
    function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
        if (!node) return false;
        if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
            const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
            const potentialParent = (0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
            if (startPosAncestor?.hasAttribute(potentialParent)) {
                if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
                else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
            }
        }
        if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
            if (findEnd) {
                let count = $c9441534493a403f$var$getStartPos(node);
                const children = node.childNodes;
                for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
                return count;
            }
            return $c9441534493a403f$var$getStartPos(node) + offset;
        }
        const parent = $c9441534493a403f$var$findParent(node);
        if (!parent) return false;
        let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
        let current = node;
        if (current.parentElement && current.parentElement !== parent) {
            const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                    current = current.parentElement;
                    offset = 0;
                }
            } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
            resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
            while(current && current.parentElement !== parent){
                current = current.parentNode;
                if (current) {
                    const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                    resolvedPos += nodePos;
                }
            }
        } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        return resolvedPos + offset;
    }
    function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
        const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
        const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
        const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
        if (isMediaOrMediaSingle) {
            let pos;
            const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
            if (pos !== undefined) return {
                from: pos,
                to: pos
            };
        }
        const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
        const findEnd = true;
        const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
        if (from === false || to === false) return false;
        return {
            from: from,
            to: to
        };
    }
    function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
        return new (0, (0, parcelRequire("eS2Dn")).AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
            id: opts.annotationId,
            annotationType: opts.annotationType
        }));
    }
});
parcelRegister("hAPWV", function(module, exports) {
    $parcel$export(module.exports, "getIndexMatch", ()=>$8b6d6fb20e026dde$export$fb7dab895a0d310e);
    function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
        let textContent = '';
        let matchIndex = 0;
        let numMatches = 0;
        let blockNodePos;
        doc.descendants((node, pos)=>{
            const nodeType = node.type;
            const { media: media } = schema.nodes;
            if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) return true;
            const nodeStart = pos;
            const nodeEnd = nodeStart + node.nodeSize;
            if (startIndex >= nodeStart && startIndex <= nodeEnd) {
                if (nodeType === media) blockNodePos = pos;
                textContent += doc.textBetween(nodeStart, startIndex - 1);
                matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
                textContent += doc.textBetween(startIndex, nodeEnd);
            } else textContent += node.textContent;
            return true;
        });
        numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
        return {
            numMatches: numMatches,
            matchIndex: matchIndex,
            textContent: textContent,
            blockNodePos: blockNodePos
        };
    }
    function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
        if (searchString === '' || query === '') return 0;
        const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
        return (searchString.match(reg) || []).length;
    }
});
parcelRegister("4apTl", function(module, exports) {
    $parcel$export(module.exports, "getRendererRangeInlineNodeNames", ()=>$3b0115c3167e4664$export$b0ea72d31617ccea);
    var $h03xs;
    var $VSDnB;
    function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const { doc: doc } = actions;
        if (!pos || !doc) return undefined;
        const inlineNodeNames = (0, (0, parcelRequire("h03xs")).getRangeInlineNodeNames)({
            doc: doc,
            pos: pos
        });
        return inlineNodeNames;
    }
});
parcelRegister("8Mz83", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsContextWrapper", ()=>$68c25c02b6872087$export$787af8a111ff3c03);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    var $6MIvG;
    var $iatcV;
    var $2EsbE;
    const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        const { range: range, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
        const inlineCommentProvider = providers && providers.inlineComment;
        const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
        const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
        const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            setDraftRange(range, type);
        }, [
            range,
            setDraftRange,
            type
        ]);
        const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            clearDraftRange(type);
        }, [
            type,
            clearDraftRange
        ]);
        const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children, !!hoverComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MIvG")).RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                component: hoverComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }), !!selectionComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iatcV")).SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                selectionComponent: selectionComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }, [
            hoverComponent,
            selectionComponent,
            children,
            rendererRef,
            createAnalyticsEvent
        ]);
        if (!selectionComponent && !hoverComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).AnnotationsDraftContextWrapper), {
            setDraftRange: setRangeForDraft,
            clearDraftRange: clearRangeForDraft
        }, render);
    };
});
parcelRegister("6MIvG", function(module, exports) {
    $parcel$export(module.exports, "RangeValidator", ()=>$38d3fe2fadcf735b$export$6d8376a902cb8aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7g31n;
    var $fCNtA;
    var $2EsbE;
    var $kuusl;
    const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
        const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const { clearHoverRange: clearHoverRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { range: range, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        const { isWithinRange: isWithinRange } = (0, (0, parcelRequire("kuusl")).useAnnotationHoverContext)();
        if (!range || type !== 'hover') return null;
        const documentPosition = actions.getPositionFromRange(range);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7g31n")).Mounter), {
            isWithinRange: isWithinRange,
            range: range,
            wrapperDOM: rendererRef,
            component: component,
            onClose: clearHoverRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: true,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("7g31n", function(module, exports) {
    $parcel$export(module.exports, "Mounter", ()=>$3da53cae08f8e9e6$export$2109cd350bcf6eda);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $fVTp8;
    var $dWAZk = parcelRequire("dWAZk");
    var $gkwXh;
    var $fCNtA;
    const $3da53cae08f8e9e6$export$2109cd350bcf6eda = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
        }, [
            isAnnotationAllowed,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {},
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }).fire((0, $dWAZk.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("fVTp8")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {}
            }).fire((0, $dWAZk.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            isWithinRange: isWithinRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback
        });
    });
});
parcelRegister("fVTp8", function(module, exports) {
    $parcel$export(module.exports, "dataAttributes", ()=>$c2a45e53becb69f1$export$15d6ddc168d35719);
    $parcel$export(module.exports, "updateWindowSelectionAroundDraft", ()=>$c2a45e53becb69f1$export$e14699d956e87e73);
    const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
        return {
            ['data-annotation-draft-mark']: true,
            ['data-draft-start-at']: from,
            ['data-draft-end-at']: to
        };
    };
    const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
        const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
        return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
    };
    const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
        const sel = window.getSelection();
        if (!sel) return false;
        const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
        if (!draftNodes || draftNodes.length === 0) return false;
        sel.removeAllRanges();
        const range = document.createRange();
        range.setStart(draftNodes[0], 0);
        range.setEndAfter(draftNodes[draftNodes.length - 1]);
        sel.addRange(range);
        return true;
    };
});
parcelRegister("2EsbE", function(module, exports) {
    $parcel$export(module.exports, "AnnotationRangeProvider", ()=>$7c7af48337b91c7a$export$30384a6aedd19fee);
    $parcel$export(module.exports, "useAnnotationRangeState", ()=>$7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
    $parcel$export(module.exports, "useAnnotationRangeDispatch", ()=>$7c7af48337b91c7a$export$708fc397e2b6f08d);
    var $5uXOq = parcelRequire("5uXOq");
    function $7c7af48337b91c7a$var$reducer(state, action) {
        switch(action.type){
            case 'clear':
                if (!!state.range || !!state.type) return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'clearSelection':
                if (state.type === 'selection') return {
                    ...state,
                    range: null,
                    type: null
                };
                return state;
            case 'clearDraftSelection':
                if (state.type === 'selection') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearDraftHover':
                if (state.type === 'hover') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearHover':
                if (state.type === 'hover') return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'setSelection':
                if (state.range !== action.range || state.type !== 'selection') return {
                    ...state,
                    range: action.range,
                    type: 'selection'
                };
                return state;
            case 'setHover':
                if (state.range !== action.range || state.type !== 'hover') return {
                    ...state,
                    range: action.range,
                    type: 'hover'
                };
                return state;
            case 'setDraftSelection':
                if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                    range: null,
                    draftRange: action.draftRange,
                    type: null
                };
                return state;
            case 'setDraftHover':
                if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                    ...state,
                    draftRange: action.draftRange
                };
                return state;
        }
    }
    const $7c7af48337b91c7a$var$AnnotationRangeStateContext = (0, $5uXOq.createContext)({
        range: null,
        draftRange: null,
        type: null
    });
    const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = (0, $5uXOq.createContext)({
        clearRange: ()=>{},
        clearSelectionRange: ()=>{},
        clearDraftRange: ()=>{},
        clearHoverRange: ()=>{},
        setRange: ()=>{},
        setDraftRange: ()=>{}
    });
    const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
        const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, {
            range: null,
            draftRange: null,
            type: null
        });
        const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clear'
            }), []);
        const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearSelection'
            }), []);
        const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'clearDraftHover'
                });
                return;
            }
            dispatch({
                type: 'clearDraftSelection'
            });
        }, []);
        const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearHover'
            }), []);
        const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
                type: 'setSelection',
                range: range
            }), []);
        const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'setDraftHover',
                    draftRange: range
                });
                return;
            }
            dispatch({
                type: 'setDraftSelection',
                draftRange: range
            });
        }, []);
        const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
            const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
            if (!mediaNode) return;
            const range = document.createRange();
            range.setStartBefore(mediaNode);
            range.setEndAfter(mediaNode);
            dispatch({
                type: 'setHover',
                range: range
            });
        }, []);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                range: range,
                draftRange: draftRange,
                type: type
            }), [
            range,
            draftRange,
            type
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                clearRange: clearRange,
                clearSelectionRange: clearSelectionRange,
                clearDraftRange: clearDraftRange,
                clearHoverRange: clearHoverRange,
                setRange: setRange,
                setDraftRange: setDraftRange,
                setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
            }), [
            allowCommentsOnMedia,
            clearRange,
            clearSelectionRange,
            clearDraftRange,
            clearHoverRange,
            setRange,
            setDraftRange,
            setHoverTarget
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
        return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
    };
    const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
        return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
    };
});
parcelRegister("kuusl", function(module, exports) {
    $parcel$export(module.exports, "AnnotationHoverContext", ()=>$b758d405b6d3becf$export$b3db0feb20552fc3);
    $parcel$export(module.exports, "useAnnotationHoverContext", ()=>$b758d405b6d3becf$export$a02bfcbbbf920306);
    $parcel$export(module.exports, "useAnnotationHoverDispatch", ()=>$b758d405b6d3becf$export$c288883964405c82);
    var $5uXOq = parcelRequire("5uXOq");
    const $b758d405b6d3becf$var$AnnotationHoverStateContext = (0, $5uXOq.createContext)({
        isWithinRange: false
    });
    const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = (0, $5uXOq.createContext)({
        cancelTimeout: ()=>{},
        initiateTimeout: ()=>{},
        setIsWithinRange: ()=>{}
    });
    const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
        const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
        const timeoutHandler = (0, $5uXOq.useRef)();
        const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
            if (timeoutHandler) clearTimeout(timeoutHandler.current);
        }, [
            timeoutHandler
        ]);
        const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
            if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
                setIsWithinRange(false);
            }, 500);
        }, [
            isWithinRange
        ]);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                isWithinRange: isWithinRange
            }), [
            isWithinRange
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                cancelTimeout: cancelTimeout,
                initiateTimeout: initiateTimeout,
                setIsWithinRange: setIsWithinRange
            }), [
            cancelTimeout,
            initiateTimeout,
            setIsWithinRange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
        return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
    };
    const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
        return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
    };
});
parcelRegister("iatcV", function(module, exports) {
    $parcel$export(module.exports, "SelectionRangeValidator", ()=>$d73a3647df6a8131$export$74435b85e23b84d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $jWe7H;
    var $bZQ2Q;
    var $fCNtA;
    const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
        const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const [range, draftRange, clearRange] = (0, (0, parcelRequire("jWe7H")).useUserSelectionRange)({
            rendererRef: rendererRef
        });
        if (!range && !draftRange) return null;
        const documentPosition = actions.getPositionFromRange(range);
        let isAnnotationAllowedOnRange = false;
        try {
            isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
        } catch  {
            isAnnotationAllowedOnRange = false;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZQ2Q")).SelectionInlineCommentMounter), {
            range: range,
            draftRange: draftRange,
            wrapperDOM: rendererRef,
            component: selectionComponent,
            onClose: clearRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: isAnnotationAllowedOnRange,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("jWe7H", function(module, exports) {
    $parcel$export(module.exports, "useUserSelectionRange", ()=>$cd0f4805a1ba9aff$export$47201332e612f5a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $2EsbE;
    var $jqO24;
    var $cMPbW;
    const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
        const { rendererRef: { current: rendererDOM } } = props;
        const selectionTimeoutRef = (0, $5uXOq.useRef)();
        const { clearRange: clearRange, setRange: setRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { range: range, draftRange: draftRange, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        (0, $5uXOq.useEffect)(()=>{
            if (!document || !rendererDOM) return;
            const onSelectionChange = (event)=>{
                if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
                selectionTimeoutRef.current = setTimeout(()=>{
                    const sel = document.getSelection();
                    if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                    const _range = sel.getRangeAt(0);
                    if (rendererDOM && (0, (0, parcelRequire("jqO24")).isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_allow_annotation_triple_click')) {
                            const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                            const parentNode = startContainer.parentNode;
                            const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                            if (isTripleClick && (0, (0, parcelRequire("cMPbW")).isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P') {
                                const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                                _range.setEnd(lastChild, lastChild.length || 0);
                            }
                        }
                        setRange(_range.cloneRange());
                    }
                }, 250);
            };
            document.addEventListener('selectionchange', onSelectionChange);
            return ()=>{
                document.removeEventListener('selectionchange', onSelectionChange);
                clearRange();
            };
        }, [
            rendererDOM,
            setRange,
            clearRange
        ]);
        return [
            type === 'selection' ? range : null,
            draftRange,
            clearRange
        ];
    };
});
parcelRegister("jqO24", function(module, exports) {
    $parcel$export(module.exports, "isRangeInsideOfRendererContainer", ()=>$8373eb69e5c4287b$export$90ee8f2d9317f430);
    const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
        const sourceRange = document.createRange();
        sourceRange.selectNode(rendererDOM);
        const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
        const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
        const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
        return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
    };
});
parcelRegister("bZQ2Q", function(module, exports) {
    $parcel$export(module.exports, "SelectionInlineCommentMounter", ()=>$7e4c7bbc0d380e24$export$ca7741472ed8ba00);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $VSDnB;
    var $fVTp8;
    var $dWAZk = parcelRequire("dWAZk");
    var $gkwXh;
    var $4apTl;
    var $fCNtA;
    const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('annotations_defensive_node_name_calculations')) {
                if (!actions.isRangeAnnotatable(range)) return undefined;
                return (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
            } else {
                if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
                if (actions.isValidAnnotationRange(range)) return (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
                else return undefined;
            }
        }, [
            documentPosition,
            actions,
            range
        ]);
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation) return false;
            const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
            if (!isCreateAllowedOnPosition) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            actions,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {
                        inlineNodeNames: inlineNodeTypes
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }).fire((0, $dWAZk.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length,
                        inlineNodeNames: inlineNodeTypes
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("fVTp8")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range,
            inlineNodeTypes
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            draftRange: draftRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback,
            inlineNodeTypes: inlineNodeTypes
        });
    });
});
parcelRegister("joddd", function(module, exports) {
    $parcel$export(module.exports, "useLoadAnnotations", ()=>$9aa08f3110a2b008$export$39f7c1a861a0d41c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dEtqo;
    var $iYAgE;
    var $fCNtA;
    const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        (0, $5uXOq.useEffect)(()=>{
            if (!providers) return;
            const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
            const annotations = actions.getAnnotationMarks();
            if (!annotations.length) {
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: 0
                });
                return;
            }
            const ids = annotations.map((mark)=>mark.attrs.id);
            const cb = (data)=>{
                if (!updateSubscriberInlineComment) return;
                const payload = data.reduce((acc, value)=>({
                        ...acc,
                        [value.id]: value
                    }), {});
                updateSubscriberInlineComment.emit((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
                });
            };
            inlineCommentGetState(ids, isNestedRender).then(cb);
        }, [
            actions,
            providers,
            adfDocument,
            isNestedRender,
            onLoadComplete
        ]);
    };
});
parcelRegister("4dDLS", function(module, exports) {
    $parcel$export(module.exports, "TextWithAnnotationDraft", ()=>$3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dLpur;
    var $iYAgE;
    var $i9Z2i;
    var $b60W1;
    var $fVTp8;
    var $5Lu5s;
    var $h5tvG;
    var $3VpWO;
    const $3c5c154ced085d7f$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().common, (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().focus);
    const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("mark", {
            "data-renderer-mark": true,
            ...(0, (0, parcelRequire("fVTp8")).dataAttributes)(draftPosition),
            css: $3c5c154ced085d7f$var$markStyles
        }, children);
    };
    const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).START) return 0;
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).END) return fragmentCount - 1;
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
        return -1;
    };
    const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
        const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
        return texts.map((value, index)=>{
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(value, textHighlighter);
            if (annotateIndex === index) return (0, (0, parcelRequire("f8Sb3")).jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
                key: index,
                draftPosition: draftPosition
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        });
    };
    const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
        const textPosition = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                start: startPos,
                end: endPos
            }), [
            endPos,
            startPos
        ]);
        const nextDraftPosition = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("iYAgE")).AnnotationsDraftContext));
        const shouldApplyAnnotationAt = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!nextDraftPosition) return false;
            return (0, (0, parcelRequire("b60W1")).calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
        }, [
            nextDraftPosition,
            textPosition
        ]);
        const textString = (0, (0, parcelRequire("i9Z2i")).findTextString)(children);
        if (!textString) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children);
        if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        if (shouldApplyAnnotationAt === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).AROUND_TEXT) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
                key: 0,
                draftPosition: nextDraftPosition
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const offsets = (0, (0, parcelRequire("i9Z2i")).calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
        const texts = (0, (0, parcelRequire("i9Z2i")).splitText)(textString, offsets);
        if (!texts) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const components = $3c5c154ced085d7f$export$b756d37afc321d72({
            texts: texts,
            shouldApplyAnnotationAt: shouldApplyAnnotationAt,
            draftPosition: nextDraftPosition,
            textHighlighter: textHighlighter,
            marks: marks
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, components);
    };
});
parcelRegister("dLpur", function(module, exports) {
    $parcel$export(module.exports, "InsertDraftPosition", ()=>$0808a380eaa6574c$export$c1bd4813440b4505);
    var $0808a380eaa6574c$export$c1bd4813440b4505;
    (function(InsertDraftPosition) {
        InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
        InsertDraftPosition["START"] = "START";
        InsertDraftPosition["END"] = "END";
        InsertDraftPosition["INSIDE"] = "INSIDE";
    })($0808a380eaa6574c$export$c1bd4813440b4505 || ($0808a380eaa6574c$export$c1bd4813440b4505 = {}));
});
parcelRegister("i9Z2i", function(module, exports) {
    $parcel$export(module.exports, "findTextString", ()=>$b2e5f988c70f5313$export$a9795c84b22a1f06);
    $parcel$export(module.exports, "splitText", ()=>$b2e5f988c70f5313$export$2878cc467c8be8fe);
    $parcel$export(module.exports, "calcTextSplitOffset", ()=>$b2e5f988c70f5313$export$1059bfc467f4f55d);
    var $5uXOq = parcelRequire("5uXOq");
    const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
        let result = null;
        const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
        for (const childNode of children){
            if (result) break;
            else if (typeof childNode === 'string') result = childNode;
            else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
        }
        return result;
    };
    function $b2e5f988c70f5313$var$isReactElement(child) {
        return !!child.type;
    }
    const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
        if (endOffset > text.length || endOffset - startOffset <= 0) return null;
        return [
            text.slice(0, startOffset),
            text.slice(startOffset, endOffset),
            text.slice(endOffset)
        ].filter(Boolean);
    };
    const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
        const { start: start, end: end } = textPosition;
        const startOffset = Math.max(position.from - start, 0);
        const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
        return {
            startOffset: startOffset,
            endOffset: endOffset
        };
    };
});
parcelRegister("b60W1", function(module, exports) {
    $parcel$export(module.exports, "calcInsertDraftPositionOnText", ()=>$cc6d6765c9b34830$export$b1baddbd5f289877);
    var $dLpur;
    const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
        const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
        if (isRangePositionAroundText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).AROUND_TEXT;
        const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
        if (isRangePositionInsideText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).INSIDE;
        const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
        if (isRangePositionStartingAtText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).END;
        const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
        if (isRangePositionEndingAtText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).START;
        return false;
    };
});
parcelRegister("5Lu5s", function(module, exports) {
    $parcel$export(module.exports, "AnnotationSharedClassNames", ()=>$973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
    $parcel$export(module.exports, "BlockAnnotationSharedClassNames", ()=>$973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
    $parcel$export(module.exports, "AnnotationSharedCSSByState", ()=>$973d0f0bfe5e36b9$export$261ebe180da42726);
    $parcel$export(module.exports, "annotationSharedStyles", ()=>$973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
    var $f8Sb3;
    var $VSDnB;
    function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
    const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
        focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
        blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
        draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`
    };
    const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
    const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
        focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
        blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
        draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
    };
    var $973d0f0bfe5e36b9$var$_ref = {
        name: "kh65d",
        styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
    };
    var $973d0f0bfe5e36b9$var$_ref2 = {
        name: "buc4yh",
        styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
    };
    const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return {
            common: {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                '&:has(.card), &:has([data-inline-card])': (0, (0, parcelRequire("VSDnB")).fg)('annotations_align_editor_and_renderer_styles') ? {
                    padding: '5px 0 3px 0'
                } : {
                    paddingTop: '4px',
                    border: 'none',
                    boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
                },
                '&:has(.date-lozenger-container)': {
                    paddingTop: '2px'
                }
            },
            focus: $973d0f0bfe5e36b9$var$_ref2,
            blur: $973d0f0bfe5e36b9$var$_ref
        };
        else return {
            focus: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                cursor: 'pointer'
            }),
            blur: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                cursor: 'pointer'
            })
        };
    };
    const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}") : (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");
});
parcelRegister("h5tvG", function(module, exports) {
    $parcel$export(module.exports, "segmentText", ()=>$63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
    function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
        if (!highlighter || !text) return [
            {
                type: 'plain',
                text: text ?? ''
            }
        ];
        const segments = [];
        let pos = 0;
        try {
            const markTextSegmentMatches = text.matchAll(highlighter.pattern);
            for (const markTextMatch of markTextSegmentMatches){
                if (markTextMatch.index !== 0) segments.push({
                    type: 'plain',
                    text: text.substring(pos, markTextMatch.index)
                });
                segments.push({
                    type: 'match',
                    text: markTextMatch[0],
                    groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
                });
                pos = markTextMatch.index + markTextMatch[0].length;
            }
            if (pos < text.length) segments.push({
                type: 'plain',
                text: text.substring(pos)
            });
            return segments;
        } catch (_e) {}
        return [
            {
                type: 'plain',
                text: text
            }
        ];
    }
});
parcelRegister("3VpWO", function(module, exports) {
    $parcel$export(module.exports, "renderTextSegments", ()=>$eefbbe172cfc7a10$export$8a20fd0614851c5f);
    var $5uXOq = parcelRequire("5uXOq");
    function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
        const Component = textHighlighter?.component;
        const marks = new Set(marksList.map((m)=>m.type.name));
        function renderSegment(segment, idx = 0) {
            if (segment.type === 'plain' || !Component) return segment.text;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-highlighted": true,
                "data-vc": "highlighted-text"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                key: `${segment.text}_${startPos}_${idx}`,
                startPos: startPos + idx
            }, segment.text));
        }
        if (segments.length === 1) return renderSegment(segments[0]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: `text-wrapper_${startPos}`
        }, segments.map(renderSegment));
    }
});
parcelRegister("5uoEK", function(module, exports) {
    $parcel$export(module.exports, "MarkElement", ()=>$97291021c9f24158$export$f3069f755c1eba0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $8u8ms;
    var $1oOiu;
    var $6Oe8V;
    var $3N1TD;
    var $iYAgE;
    var $dEtqo;
    const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
        const updateSubscriber = (0, (0, parcelRequire("3N1TD")).useInlineCommentSubscriberContext)();
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext));
        const hasFocus = (0, (0, parcelRequire("1oOiu")).useHasFocusEvent)({
            id: id,
            updateSubscriber: updateSubscriber
        });
        const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
            dataAttributes
        ]);
        const onClick = (0, $5uXOq.useCallback)((props)=>{
            if (!updateSubscriber) return;
            if (useBlockLevel) return;
            const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
            updateSubscriber.emit((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: annotationIds,
                eventTarget: eventTarget
            });
        }, [
            updateSubscriber,
            useBlockLevel
        ]);
        const activeParentIds = (0, (0, parcelRequire("6Oe8V")).useInlineCommentsFilter)({
            annotationIds: annotationParentIds,
            filter: {
                state: (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8u8ms")).MarkComponent), {
            id: id,
            dataAttributes: dataAttributesMemorized,
            annotationParentIds: activeParentIds,
            onClick: onClick,
            hasFocus: hasFocus,
            state: states[id],
            useBlockLevel: useBlockLevel
        }, children);
    };
});
parcelRegister("8u8ms", function(module, exports) {
    $parcel$export(module.exports, "MarkComponent", ()=>$c95b45af50ffb058$export$4f5a51511304fdd0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5IPCv;
    var $5Lu5s;
    var $88i6h;
    var $VSDnB;
    var $koVbs;
    var $1Bd5P;
    const $c95b45af50ffb058$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE, "']{", (0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().common : '', " ", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().focus, ";}}");
    const $c95b45af50ffb058$var$isMobile = ()=>{
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    const $c95b45af50ffb058$var$accessibilityStyles = (startMarker, endMarker)=>(0, (0, parcelRequire("f8Sb3")).css)({
            '&::before, &::after': {
                clipPath: 'inset(100%)',
                clip: 'rect(1px, 1px, 1px, 1px)',
                height: '1px',
                overflow: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: '1px'
            },
            '&::before': {
                content: `' [${startMarker}] '`
            },
            '&::after': {
                content: `' [${endMarker}] '`
            }
        });
    const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, onClick: onClick, useBlockLevel: useBlockLevel })=>{
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const annotationIds = (0, $5uXOq.useMemo)(()=>[
                ...new Set([
                    ...annotationParentIds,
                    id
                ])
            ], [
            id,
            annotationParentIds
        ]);
        const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
            if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
            if (event.defaultPrevented || state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE) return;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                    if (event.target.closest('[data-mention-id]')) ;
                    else {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            } else event.preventDefault();
            onClick({
                eventTarget: event.target,
                annotationIds: annotationIds
            });
        }, [
            annotationIds,
            onClick,
            state
        ]);
        const onMarkEnter = (evt)=>{
            const focusedElementTag = document.activeElement?.tagName;
            if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
        };
        const overriddenData = !state ? dataAttributes : {
            ...dataAttributes,
            'data-mark-annotation-state': state,
            'data-has-focus': hasFocus
        };
        const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $c95b45af50ffb058$var$isMobile() ? {} : {
            role: 'button',
            tabIndex: 0,
            onKeyDown: onMarkEnter,
            'aria-expanded': hasFocus
        } : {};
        const accessibility = state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE ? {
            'aria-disabled': true
        } : {
            'aria-details': annotationIds.join(', '),
            ...desktopAccessibilityAttributes
        };
        const getAccessibilityStyles = ()=>{
            if ($c95b45af50ffb058$var$isMobile()) return {};
            if (isInlineCommentsKbAccessible && state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).RESOLVED) {
                const startMarker = intl.formatMessage((0, (0, parcelRequire("1Bd5P")).inlineCommentMessages).contentRendererInlineCommentMarkerStart);
                const endMarker = intl.formatMessage((0, (0, parcelRequire("1Bd5P")).inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
                return $c95b45af50ffb058$var$accessibilityStyles(startMarker, endMarker);
            } else return {};
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)(useBlockLevel ? 'div' : 'mark', {
            id: id,
            [(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
            ...accessibility,
            ...overriddenData,
            ...!useBlockLevel && {
                css: [
                    $c95b45af50ffb058$var$markStyles,
                    getAccessibilityStyles()
                ]
            }
        }, children);
    };
});
parcelRegister("1Bd5P", function(module, exports) {
    $parcel$export(module.exports, "headingAnchorLinkMessages", ()=>$bb2bb569629ca076$export$74bada844422036d);
    $parcel$export(module.exports, "tableCellMessages", ()=>$bb2bb569629ca076$export$c79ebc36348824d1);
    $parcel$export(module.exports, "inlineCommentMessages", ()=>$bb2bb569629ca076$export$9f52c375a6ef34fc);
    var $7VHMR;
    const $bb2bb569629ca076$export$74bada844422036d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copyAnchorLink',
            defaultMessage: 'Copy link to heading',
            description: 'Copy heading link to clipboard'
        },
        copiedHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copied',
            defaultMessage: 'Copied!',
            description: 'Copied heading link to clipboard'
        },
        failedToCopyHeadingLink: {
            id: 'fabric.editor.headingLink.failedToCopy',
            defaultMessage: 'Copy failed',
            description: 'failed to copy heading link to clipboard'
        },
        copyAriaLabel: {
            id: 'fabric.editor.headingLink.copyAriaLabel',
            defaultMessage: 'Copy',
            description: 'copy aria label for link icon'
        }
    });
    const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneSortingLabel: {
            id: 'fabric.editor.headingLink.noneSortingLabel',
            defaultMessage: 'none',
            description: 'this table column is not sorted'
        },
        ascSortingLabel: {
            id: 'fabric.editor.headingLink.ascSortingLabel',
            defaultMessage: 'ascending',
            description: 'this table column is sorted in ascending order'
        },
        descSortingLabel: {
            id: 'fabric.editor.headingLink.descSortingLabel',
            defaultMessage: 'descending',
            description: 'this table column is sorted in descending order'
        }
    });
    const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        contentRendererInlineCommentMarkerStart: {
            id: 'fabric.editor.inlineComment.marker.start',
            defaultMessage: 'inline comment start',
            description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
        },
        contentRendererInlineCommentMarkerEnd: {
            id: 'fabric.editor.inlineComment.marker.end',
            defaultMessage: 'inline comment end',
            description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
        }
    });
});
parcelRegister("6Oe8V", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentsFilter", ()=>$588f60613625d184$export$8e7d47f9e38ad4f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext));
        return (0, $5uXOq.useMemo)(()=>{
            return annotationIds.reduce((acc, id)=>{
                if (states && states[id] === stateFilter) return [
                    ...acc,
                    id
                ];
                return acc;
            }, []);
        }, [
            annotationIds,
            states,
            stateFilter
        ]);
    };
});
parcelRegister("3N1TD", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentSubscriberContext", ()=>$861d152b5ce122b2$export$b46737175cffd396);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        if (!providers) return null;
        const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
        return updateSubscriber || null;
    };
});
parcelRegister("bQeYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5dc6f3b113435da$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Zwf;
    var $fAZXL;
    var $edXiX;
    var $4ceoy;
    var $l8Gxi;
    var $eOOFp;
    const $c5dc6f3b113435da$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
        const actions = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return {
                changeActive (index) {
                    return updateActiveChild(index);
                },
                addChild () {
                    return false;
                },
                getChildrenCount () {
                    return children ? children?.length : 0;
                },
                removeChild (index) {
                    return false;
                },
                updateParameters (parameters) {
                    return false;
                },
                getChildren () {
                    return [];
                }
            };
        }, [
            updateActiveChild,
            children
        ]);
        return actions;
    };
    const $c5dc6f3b113435da$var$navigationCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
    const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [] } = props;
        const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const updateActiveChild = (0, ($parcel$interopDefault($5uXOq))).useCallback((index)=>{
            if (typeof index !== 'number') {
                setActiveChildIndex(0);
                return false;
            }
            setActiveChildIndex(index);
            return true;
        }, [
            setActiveChildIndex
        ]);
        const actions = $c5dc6f3b113435da$var$useMultiBodiedExtensionActions({
            updateActiveChild: updateActiveChild,
            children: children
        });
        const containerCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
        const isTopLevel = path.length < 1;
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        function renderMbeContent(width) {
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
                className: "multiBodiedExtension-navigation",
                css: $c5dc6f3b113435da$var$navigationCssExtended,
                "data-testid": "multiBodiedExtension-navigation"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fAZXL")).default), {
                ...props,
                actions: actions,
                type: "multiBodiedExtension"
            }, ({ result: result })=>{
                try {
                    if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("i8Zwf")).renderExtension)(result, layout, {
                        isTopLevel: path.length < 1
                    });
                } catch (e) {}
                return (0, (0, parcelRequire("i8Zwf")).renderExtension)(children, layout, {
                    isTopLevel: path.length < 1
                });
            })), (0, (0, parcelRequire("f8Sb3")).jsx)("article", {
                "data-testid": "multiBodiedExtension--frames",
                className: `multiBodiedExtension--frames`
            }, children));
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            className: "multiBodiedExtension--container",
            css: containerCssExtended,
            "data-testid": "multiBodiedExtension--container",
            "data-active-child-index": activeChildIndex,
            "data-layout": layout
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
    };
    var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;
});
parcelRegister("edXiX", function(module, exports) {
    $parcel$export(module.exports, "removeMarginsAndBorder", ()=>$a5dc814f02ba73ab$export$8df0393dc2d5d656);
    $parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", ()=>$a5dc814f02ba73ab$export$9c7196ca47f67390);
    var $f8Sb3;
    function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a5dc814f02ba73ab$var$mbeExtensionContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        background: 'transparent !important',
        'padding:': {
            left: `${"var(--ds-space-100, 8px)"} !important`,
            right: `${"var(--ds-space-100, 8px)"} !important`
        },
        paddingBottom: "var(--ds-space-100, 8px)",
        '&.remove-padding': {
            paddingBottom: 0
        },
        position: 'relative',
        verticalAlign: 'middle',
        cursor: 'pointer',
        '.multiBodiedExtension-handler-result': {
            marginLeft: "var(--ds-space-100, 8px)"
        },
        ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
            display: 'none',
            background: "var(--ds-surface, white)"
        },
        '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
            "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
                marginTop: 0
            }
        }
    });
    const $a5dc814f02ba73ab$var$mbeNavigation = {
        name: "2ubief",
        styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
    };
    const $a5dc814f02ba73ab$var$extensionFrameContent = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} !important`,
        display: 'block',
        minHeight: '100px',
        background: "var(--ds-surface, white)",
        borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
        borderBottomRightRadius: "var(--ds-border-radius, 3px)",
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        cursor: 'initial',
        '.pm-table-with-controls': {
            marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
            paddingRight: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.bodiedExtensionView-content-wrap': {
            marginTop: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.extensionView-content-wrap': {
            marginTop: `${"var(--ds-space-100, 8px)"} !important`
        }
    });
    const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
        name: "c620zi",
        styles: "margin-left:0;margin-right:0;border:none"
    };
    const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
        mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
        mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
        extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
    };
});
parcelRegister("cOnYv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adf8f8318644b4cb$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $adf8f8318644b4cb$var$containerCSS = {
        name: "ecvjkq",
        styles: "min-height:100px"
    };
    const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $adf8f8318644b4cb$var$containerCSS,
            "data-extension-frame": "true",
            style: {
                flexBasis: `100%`
            }
        }, props.children);
    };
    var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;
});
parcelRegister("cWRvh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b4346c39a86c4f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kjhhp;
    var $503mU;
    function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ul", {
            className: (0, (0, parcelRequire("kjhhp")).bulletListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("503mU")).getListIndentLevel)(props.path) : 1
        }, props.children);
    }
});
parcelRegister("503mU", function(module, exports) {
    $parcel$export(module.exports, "getListIndentLevel", ()=>$95f5719763d590de$export$75aa84e85754623e);
    function $95f5719763d590de$export$75aa84e85754623e(path) {
        let count = 1;
        path.forEach((node)=>{
            if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
        });
        return count;
    }
});
parcelRegister("5KNWO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e507ebac88967e63$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>$e507ebac88967e63$export$41121a410ca2f650);
    var $5uXOq = parcelRequire("5uXOq");
    var $l8Gxi;
    var $bGnBY;
    function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
    function $e507ebac88967e63$export$41121a410ca2f650(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: (0, (0, parcelRequire("bGnBY")).useSelectAllTrap)(),
            className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
});
parcelRegister("bGnBY", function(module, exports) {
    $parcel$export(module.exports, "useSelectAllTrap", ()=>$08249876083d1eac$export$98871b245ee25215);
    var $gkwXh;
    var $5uXOq = parcelRequire("5uXOq");
    var $TM1uy;
    var $lb6Ua;
    var $VSDnB;
    const $08249876083d1eac$export$98871b245ee25215 = ()=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("TM1uy")).default));
        const ref = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const clicked = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const caught = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
        const onKeyDown = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            const el = ref.current;
            if (!el) return;
            const modKey = mac ? e.metaKey : e.ctrlKey;
            if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
            const elementSelection = (0, (0, parcelRequire("lb6Ua")).ElementSelection).fromWindow();
            const isInput = (0, (0, parcelRequire("VSDnB")).fg)('platform-datasources-enable-two-way-sync') ? e.target?.matches?.('input') : false;
            if (elementSelection.eq(caught.current) || isInput) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECT_ALL_ESCAPED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER
                });
                return;
            }
            if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECT_ALL_CAUGHT,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER
                });
                e.preventDefault();
                caught.current = elementSelection.select(el);
            }
        }, [
            mac,
            ref,
            fireAnalyticsEvent,
            clicked,
            caught
        ]);
        const onClick = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            clicked.current = ref.current?.contains(e.target) ?? false;
        }, [
            ref,
            clicked
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            window.addEventListener('keydown', onKeyDown);
            window.addEventListener('click', onClick);
            return ()=>{
                window.removeEventListener('keydown', onKeyDown);
                window.removeEventListener('click', onClick);
            };
        }, [
            onKeyDown,
            onClick
        ]);
        return ref;
    };
});
parcelRegister("TM1uy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64e1e4f8cfab5159$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $64e1e4f8cfab5159$var$AnalyticsContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        fireAnalyticsEvent: (_event)=>null
    });
    var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;
});
parcelRegister("lb6Ua", function(module, exports) {
    $parcel$export(module.exports, "ElementSelection", ()=>$854590065f4073c9$export$6e6724d89f27411);
    class $854590065f4073c9$export$6e6724d89f27411 {
        constructor(selection){
            this.type = selection ? selection.type : 'None';
            if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
        }
        eq(selection) {
            if (!selection) return false;
            if (this.range && selection.range) {
                const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
                const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
                return startMatches && endMatches;
            }
            return this.type === 'None' && selection.type === 'None';
        }
        inside(el) {
            return el.contains(this.range?.commonAncestorContainer ?? null);
        }
        select(el) {
            const range = document.createRange();
            range.selectNodeContents(el);
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
            return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
        }
        static fromWindow(win = window) {
            return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
        }
    }
});
parcelRegister("lKIDi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a311e98fd838fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
        if (forceNewLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("br", null);
    };
    var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;
});
parcelRegister("7AttJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e20de8dc9c3ed0b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rouw;
    var $gkwXh;
    var $TM1uy;
    var $jSk6P;
    const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
        const url = new URL(window.location.href);
        url.search = '';
        url.hash = encodeURIComponent(hash);
        return url.href;
    };
    function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
        if (!marks || !marks.length) return false;
        return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
    }
    function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TM1uy")).default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rouw")).default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                    return (0, (0, parcelRequire("jSk6P")).copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                }
            }));
    }
    function $e20de8dc9c3ed0b1$var$Heading(props) {
        const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
        const HX = `h${props.level}`;
        const showAnchorLink = !!props.showAnchorLink;
        const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
        const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
        const headingIdToUse = invisible ? undefined : headingId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(HX, {
            id: headingIdToUse,
            ...dataAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showAnchorLink && headingId && isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        }), props.children, showAnchorLink && headingId && !isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        })));
    }
    var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;
});
parcelRegister("3rouw", function(module, exports) {
    $parcel$export(module.exports, "HeadingAnchorWrapperClassName", ()=>$b36f5408031b5508$export$3c9cedc52604835d);
    $parcel$export(module.exports, "default", ()=>$b36f5408031b5508$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $458iJ;
    var $3bDjY;
    var $8RXs9;
    var $1Bd5P;
    const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
    const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...rest,
            className: $b36f5408031b5508$export$3c9cedc52604835d,
            ref: ref
        }, children));
    });
    const $b36f5408031b5508$var$copyAnchorButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        outline: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        cursor: 'pointer',
        right: 0
    });
    class $b36f5408031b5508$var$HeadingAnchor extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        componentDidMount() {
            this.resetMessage();
        }
        render() {
            const { tooltipMessage: tooltipMessage } = this.state;
            if (tooltipMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage
            }, this.renderAnchorButton());
            return this.renderAnchorButton();
        }
        constructor(...args){
            super(...args);
            this.state = {
                tooltipMessage: '',
                isClicked: false
            };
            this.setTooltipState = (message, isClicked = false)=>{
                this.setState({
                    tooltipMessage: this.props.intl.formatMessage(message),
                    isClicked: isClicked
                });
            };
            this.getCopyAriaLabel = ()=>{
                const { copyAriaLabel: copyAriaLabel } = (0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages);
                return this.props.intl.formatMessage(copyAriaLabel);
            };
            this.copyToClipboard = async (event)=>{
                const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages);
                event.stopPropagation();
                try {
                    await this.props.onCopyText();
                    this.setTooltipState(copiedHeadingLinkToClipboard, true);
                } catch (e) {
                    this.setTooltipState(failedToCopyHeadingLink);
                }
            };
            this.resetMessage = ()=>{
                this.setTooltipState((0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages).copyHeadingLinkToClipboard);
            };
            this.renderAnchorButton = ()=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                    css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                    onMouseLeave: this.resetMessage,
                    onClick: this.copyToClipboard,
                    "aria-label": this.state.tooltipMessage,
                    type: "button"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("458iJ"))))), {
                    label: this.getCopyAriaLabel(),
                    size: this.props.level > 3 ? 'small' : 'medium',
                    primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }));
            };
        }
    }
    var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($b36f5408031b5508$var$HeadingAnchor);
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("jSk6P", function(module, exports) {
    $parcel$export(module.exports, "copyTextToClipboard", ()=>$2ff51d830678d63e$export$f980440e1ab4537d);
    const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
            const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
            if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
            else reject('Clipboard API is not supported');
        });
});
parcelRegister("112O7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4bc2ade6d275922$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fAZXL;
    const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
        const { text: text } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "inlineExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, result);
            } catch (e) {}
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text || 'inlineExtension');
        });
    };
    var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;
});
parcelRegister("ieJGA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57fd1bc0570bfa35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
        const isAdvancedLayoutsPreRelease2 = (0, $gmhCD.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_pre_release_2');
        return isAdvancedLayoutsPreRelease2 ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "layout-section-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length
        }, props.children)) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true
        }, props.children);
    }
});
parcelRegister("3RqVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93f45378df34617d$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $iEGtv;
    var $4ceoy;
    const $93f45378df34617d$var$layoutColumnClearMarginTopStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("iEGtv")).clearNextSiblingMarginTopStyle), (0, (0, parcelRequire("iEGtv")).clearNextSiblingBlockMarkMarginTopStyle));
    function $93f45378df34617d$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-layout-column": true,
            "data-column-width": props.width,
            style: {
                flexBasis: `${props.width}%`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $93f45378df34617d$var$layoutColumnClearMarginTopStyles
        }), props.children));
    }
});
parcelRegister("iEGtv", function(module, exports) {
    $parcel$export(module.exports, "clearNextSiblingMarginTopStyle", ()=>$1f25160b5efdbc99$export$b15ec88fc1f2e843);
    $parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", ()=>$1f25160b5efdbc99$export$eb3aaa9338936d44);
    var $f8Sb3;
    function $1f25160b5efdbc99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1f25160b5efdbc99$export$b15ec88fc1f2e843 = {
        name: "1f3w791",
        styles: "& + *{margin-top:0 !important;}"
    };
    const $1f25160b5efdbc99$var$textElements = [
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ];
    const $1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors = $1f25160b5efdbc99$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
    const $1f25160b5efdbc99$export$eb3aaa9338936d44 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`${$1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors}`]: {
            marginTop: '0 !important'
        }
    });
});
parcelRegister("qjsNK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccd334ef870d278c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, props.children);
    }
});
parcelRegister("jHa9U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fce9f67e250185e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8hSwr;
    const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8hSwr")).default), {
            hasContent: true,
            dataAttributes: dataAttributes
        }, children);
    };
    var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;
});
parcelRegister("8hSwr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bb2c70aa755b661$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $2AEnW;
    function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5bb2c70aa755b661$var$captionWrapperStyle = {
        name: "1f0iwez",
        styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
    };
    const $5bb2c70aa755b661$var$placeholderStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        position: 'absolute',
        top: 'space.0',
        width: '100%'
    });
    class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
            const showPlaceholder = !selected && !hasContent;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-media-caption": true,
                "data-testid": "media-caption",
                ...dataAttributes,
                css: $5bb2c70aa755b661$var$captionWrapperStyle
            }, showPlaceholder ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $5bb2c70aa755b661$var$placeholderStyle
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("2AEnW")).messages).placeholder))) : null, children);
        }
    }
    var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5bb2c70aa755b661$export$f7feb87190a94c76);
});
parcelRegister("2AEnW", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$aa314c48a072d691$export$defe85febe8b728c);
    var $7VHMR;
    const $aa314c48a072d691$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.captionPlaceholder',
            defaultMessage: 'Add a caption',
            description: 'Placeholder description for an empty (new) caption in the editor'
        }
    });
});
parcelRegister("6svWT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6654d29b704d772$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dwptW;
    var $jlYLw;
    var $uTDrM;
    var $503mU;
    function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
        let extraProps = {};
        const itemCounterDigitsSize = (0, (0, parcelRequire("uTDrM")).getItemCounterDigitsSize)({
            order: props.order,
            itemsCount: props?.content?.length
        });
        if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, (0, parcelRequire("jlYLw")).getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
        if (props.order !== undefined) extraProps.start = (0, (0, parcelRequire("uTDrM")).resolveOrder)(props.order);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ol", {
            className: (0, (0, parcelRequire("dwptW")).orderedListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("503mU")).getListIndentLevel)(props.path) : 1,
            start: props.start,
            ...extraProps
        }, props.children);
    }
});
parcelRegister("jlYLw", function(module, exports) {
    $parcel$export(module.exports, "listItemCounterPadding", ()=>$6a64108c33d9274c$export$bafd6beec0797f87);
    $parcel$export(module.exports, "getOrderedListInlineStyles", ()=>$6a64108c33d9274c$export$6d31fdb1d74cee3e);
    $parcel$export(module.exports, "listsSharedStyles", ()=>$6a64108c33d9274c$export$ea95db02cc29c78f);
    var $f8Sb3;
    var $kjhhp;
    var $dwptW;
    var $gE8f9;
    const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
    var $6a64108c33d9274c$var$CSS_VAR_NAMES;
    (function(CSS_VAR_NAMES) {
        CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    })($6a64108c33d9274c$var$CSS_VAR_NAMES || ($6a64108c33d9274c$var$CSS_VAR_NAMES = {}));
    const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
        let paddingLeft = `2.385ch`;
        if (itemCounterDigitsSize >= 3) {
            const fixedBasePx = 2;
            paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
        }
        return paddingLeft;
    };
    const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
    function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
        const style = {
            ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
        };
        if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
        return style;
    }
    const $6a64108c33d9274c$export$ea95db02cc29c78f = (0, (0, parcelRequire("f8Sb3")).css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, (0, parcelRequire("gE8f9")).browser).gecko ? 'display: inline-block;' : '', ";}}", (0, (0, parcelRequire("dwptW")).orderedListSelector), ",", (0, (0, parcelRequire("kjhhp")).bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");
});
parcelRegister("uTDrM", function(module, exports) {
    $parcel$export(module.exports, "resolveOrder", ()=>$ebe278356715a8a4$export$d445360e2a3c026b);
    $parcel$export(module.exports, "getOrderFromOrderedListNode", ()=>$ebe278356715a8a4$export$cbefb5b89ef0719f);
    $parcel$export(module.exports, "getItemCounterDigitsSize", ()=>$ebe278356715a8a4$export$320582fc14ba1e0f);
    $parcel$export(module.exports, "isListNode", ()=>$ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
    $parcel$export(module.exports, "isParagraphNode", ()=>$ebe278356715a8a4$export$35f600abfe6f0127);
    $parcel$export(module.exports, "isListItemNode", ()=>$ebe278356715a8a4$export$2ddb0a75547407f6);
    $parcel$export(module.exports, "isBulletList", ()=>$ebe278356715a8a4$export$35b2f400604e700);
    const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
    const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
        const num = Number(order);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
        const order = orderedListNode?.attrs?.order;
        return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    };
    const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
        const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
        const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
        const largestCounter = order + (itemsCount - 1);
        return String(largestCounter)?.split('.')?.[0]?.length;
    };
    function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
        return Boolean(node && node.type && [
            'orderedList',
            'bulletList'
        ].includes(node.type.name));
    }
    function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
        return Boolean(node && node.type && 'paragraph' === node.type.name);
    }
    function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
        return Boolean(node && node.type && 'listItem' === node.type.name);
    }
    function $ebe278356715a8a4$export$35b2f400604e700(node) {
        return Boolean(node && node.type && 'bulletList' === node.type.name);
    }
});
parcelRegister("9FXQX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26d2961aa3d14cef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $EGPjg;
    function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("p", dataAttributes, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("EGPjg")).default), null, children)));
    }
});
parcelRegister("EGPjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372a7010ecff9ba7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
        const { children: children } = props;
        const childCount = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).length;
        if (!childCount) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
        return children;
    }
});
parcelRegister("hqBb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$add04eab04996fda$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $add04eab04996fda$export$2e2bcd8739ae039(props) {
        if (props.allowPlaceholderText) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-placeholder": `${props.text}`
        }, props.text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
    }
});
parcelRegister("ixoQV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1bb5022786e53a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("hr", {
            role: "presentation"
        });
    }
});
parcelRegister("dkc63", function(module, exports) {
    $parcel$export(module.exports, "isTableResizingEnabled", ()=>$7478efdfea2a60bf$export$eec82c0a93aa66d9);
    $parcel$export(module.exports, "isStickyScrollbarEnabled", ()=>$7478efdfea2a60bf$export$bdb2dadcb04aad50);
    $parcel$export(module.exports, "default", ()=>$7478efdfea2a60bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6gEe5;
    var $ajc8Z;
    var $4ceoy;
    var $VSDnB;
    var $5vnE9;
    var $5or39;
    var $5J0oM;
    var $9BYlQ;
    var $iHYdz;
    var $fKLIs;
    var $gmhCD = parcelRequire("gmhCD");
    var $OxITw;
    var $cWojJ;
    var $4BsEy;
    var $2aXGN;
    var $a4mor;
    var $kjIja;
    var $eIscD;
    const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, (0, parcelRequire("kjIja")).isFullWidthOrFullPageAppearance)(appearance) || (0, (0, parcelRequire("kjIja")).isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        });
    const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, (0, parcelRequire("kjIja")).isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
            exposure: true
        });
    const $7478efdfea2a60bf$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
        if (!tableOrderStatus || tableOrderStatus.order === (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER) return children;
        const { order: order, columnIndex: columnIndex } = tableOrderStatus;
        const compareNodesInOrder = (0, (0, parcelRequire("5J0oM")).createCompareNodes)({
            getInlineCardTextFromStore (attrs) {
                const { url: url } = attrs;
                if (!url) return null;
                return smartCardStorage.get(url) || null;
            }
        }, order);
        const tableArray = (0, (0, parcelRequire("5or39")).convertProsemirrorTableNodeToArrayOfRows)(tableNode);
        const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
                rowNodes: rowNodes,
                rowReact: children[index]
            }));
        const headerRow = tableArrayWithChildren.shift();
        const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        return sortedTable.map((elem)=>elem.rowReact);
    };
    const $7478efdfea2a60bf$var$hasRowspan = (row)=>{
        let hasRowspan = false;
        row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
        return hasRowspan;
    };
    const $7478efdfea2a60bf$var$getRefTop = (refElement)=>{
        return Math.round(refElement.getBoundingClientRect().top);
    };
    const $7478efdfea2a60bf$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
    const $7478efdfea2a60bf$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
    const $7478efdfea2a60bf$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
        return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
            if (index === 0) return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                tableOrderStatus: tableOrderStatus,
                onSorting: onSorting
            });
            return row;
        });
    };
    const $7478efdfea2a60bf$var$isHeaderRowEnabled = (rows)=>{
        if (!rows.length) return false;
        const { children: children } = rows[0].props;
        if (!children.length) return false;
        if (children.length === 1) return children[0].type === (0, (0, parcelRequire("cWojJ")).TableHeader);
        return children.every((node)=>node.type === (0, (0, parcelRequire("cWojJ")).TableHeader));
    };
    const $7478efdfea2a60bf$var$tableCanBeSticky = (node, children)=>{
        return $7478efdfea2a60bf$var$isHeaderRowEnabled(children) && node && node.firstChild && !$7478efdfea2a60bf$var$hasRowspan(node.firstChild);
    };
    class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.resizeObserver = new ResizeObserver(this.applyResizerChange);
            if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
            if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
            if (this.props.stickyHeaders) {
                this.overflowParent = (0, (0, parcelRequire("2aXGN")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
                this.overflowParent.addEventListener('scroll', this.onScroll);
            }
            if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, (0, parcelRequire("eIscD")).TableStickyScrollbar)(this.wrapperRef.current);
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, (0, parcelRequire("2aXGN")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            else if (!this.props.stickyHeaders && this.overflowParent) {
                this.overflowParent.removeEventListener('scroll', this.onScroll);
                this.overflowParent = null;
            }
            if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
            if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        }
        get pinTop() {
            if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
            return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, (0, parcelRequire("6gEe5")).tableMarginTop) - (0, (0, parcelRequire("2aXGN")).tableStickyPadding);
        }
        get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
            return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
        }
        get stickyTop() {
            switch(this.state.stickyMode){
                case 'pin-bottom':
                    return this.pinTop;
                case 'stick':
                    const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                    if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                        const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                        return offsetTop + overflowParentOffsetTop;
                    } else return offsetTop;
                default:
                    return undefined;
            }
        }
        render() {
            const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
            const { stickyMode: stickyMode } = this.state;
            const lineLengthFixedWidth = (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
            let left;
            let updatedLayout;
            const isRenderWidthValid = !!renderWidth && renderWidth > 0;
            const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, (0, parcelRequire("OxITw")).FullPagePadding}px * 2` : `100cqw`;
            const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
                if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                    isRenderWidthValid ? Math.min((0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth),
                    `min(${(0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
                ];
                else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                    const tableContainerWidth = (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? renderWidth : tableContainerWidth,
                        renderWidthCSS
                    ];
                } else {
                    const tableContainerWidth = (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                        `min(${tableContainerWidth}px, ${renderWidthCSS})`
                    ];
                }
            };
            const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
            const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
            const fullWidthLineLength = isRenderWidthValid ? Math.min((0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth);
            const fullWidthLineLengthCSS = `min(${(0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
            const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
            const isCommentAppearanceAndTableAlignmentEnabled = (0, (0, parcelRequire("kjIja")).isCommentAppearance)(rendererAppearance) && allowTableAlignment;
            const lineLength = (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
            const lineLengthCSS = (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
            const fixTableSSRResizing = (0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing');
            const tableWidthNew = fixTableSSRResizing ? (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode) : tableWidth;
            const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && isTableAlignStart && ((0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
            let leftCSS;
            if (shouldCalculateLeftForAlignment) {
                left = (tableWidth - lineLength) / 2;
                leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
            }
            if (fixTableSSRResizing) {
                if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance)) leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
            } else if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
            const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
            const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
            if (isFullWidth) updatedLayout = 'full-width';
            else if (tableNode?.attrs.width) updatedLayout = 'custom';
            else updatedLayout = layout;
            let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
            if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            let style;
            if (fixTableSSRResizing) style = {
                width: finalTableContainerWidth,
                left: leftCSS ? `calc(${leftCSS})` : undefined,
                marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
            };
            else style = {
                width: finalTableContainerWidth,
                left: left,
                marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                style: style
            }, $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                "data-testid": "sticky-scrollbar-sentinel-top"
            }), stickyHeaders && $7478efdfea2a60bf$var$tableCanBeSticky(tableNode, children) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2aXGN")).StickyTable), {
                isNumberColumnEnabled: isNumberColumnEnabled,
                tableWidth: tableWidth,
                layout: layout,
                renderWidth: renderWidth,
                handleRef: this.props.handleRef,
                shadowClassNames: this.props.shadowClassNames,
                top: this.stickyTop,
                mode: stickyMode,
                innerRef: this.stickyWrapperRef,
                wrapperWidth: this.state.wrapperWidth,
                columnWidths: columnWidths,
                rowHeight: this.state.headerRowHeight,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                allowTableResizing: allowTableResizing
            }, [
                children && children[0]
            ]), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER,
                ref: this.wrapperRef,
                onScroll: this.props.stickyHeaders && this.onWrapperScrolled
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a4mor")).Table), {
                innerRef: this.tableRef,
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }, this.grabFirstRowRef(children))), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                ref: this.stickyScrollbarRef,
                style: {
                    height: "var(--ds-space-250, 20px)",
                    display: fixTableSSRResizing ? 'none' : 'block',
                    width: '100%'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: this.tableRef.current?.clientWidth,
                    height: '100%'
                }
            })), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                "data-testid": "sticky-scrollbar-sentinel-bottom"
            })));
        }
        constructor(...args){
            super(...args);
            this.state = {
                stickyMode: 'none',
                wrapperWidth: 0,
                headerRowHeight: 0
            };
            this.tableRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyHeaderRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyScrollbarRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyWrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.wrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.overflowParent = null;
            this.resizeObserver = null;
            this.applyResizerChange = (entries)=>{
                let wrapperWidth = this.state.wrapperWidth;
                let headerRowHeight = this.state.headerRowHeight;
                for (const entry of entries){
                    if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
                if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                    wrapperWidth: wrapperWidth,
                    headerRowHeight: headerRowHeight
                });
            };
            this.componentWillUnmount = ()=>{
                if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
                if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
                if (this.resizeObserver) this.resizeObserver.disconnect();
                if (this.stickyScrollbar) this.stickyScrollbar.dispose();
            };
            this.getScrollTop = ()=>{
                const { stickyHeaders: stickyHeaders } = this.props;
                const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
                return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
            };
            this.updateSticky = ()=>{
                const tableElem = this.tableRef.current;
                const refElem = this.stickyHeaderRef.current;
                if (!tableElem || !refElem) return;
                const scrollTop = this.getScrollTop() + (0, (0, parcelRequire("2aXGN")).tableStickyPadding);
                const tableTop = $7478efdfea2a60bf$var$getRefTop(tableElem);
                const tableBottom = tableTop + tableElem.clientHeight;
                const shouldSticky = $7478efdfea2a60bf$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
                const shouldPin = $7478efdfea2a60bf$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
                let stickyMode = 'none';
                if (shouldPin) stickyMode = 'pin-bottom';
                else if (shouldSticky) stickyMode = 'stick';
                if (this.state.stickyMode !== stickyMode) this.setState({
                    stickyMode: stickyMode
                });
                this.nextFrame = undefined;
            };
            this.onScroll = ()=>{
                if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
            };
            this.onWrapperScrolled = ()=>{
                if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
                this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
                if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            };
            this.grabFirstRowRef = (children)=>{
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                    if (idx === 0 && (0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        innerRef: this.stickyHeaderRef
                    });
                    return child;
                });
            };
        }
    }
    class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            if (!children) return null;
            let childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            const orderedChildren = (0, (0, parcelRequire("5vnE9")).compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$f2c3aea42b2a048f, this.props, orderedChildren);
        }
        constructor(...args){
            super(...args);
            this.state = {
                tableOrderStatus: undefined
            };
            this.addSortableColumn = (childrenArray)=>{
                const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
                const { tableOrderStatus: tableOrderStatus } = this.state;
                if (allowColumnSorting && $7478efdfea2a60bf$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, (0, parcelRequire("5or39")).hasMergedCell)(tableNode)) return $7478efdfea2a60bf$var$addSortableColumn($7478efdfea2a60bf$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
                return childrenArray;
            };
            this.changeSortOrder = (columnIndex, sortOrder)=>{
                this.setState({
                    tableOrderStatus: {
                        columnIndex: columnIndex,
                        order: sortOrder
                    }
                });
            };
            this.addNumberColumnIndexes = (rows)=>{
                const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
                const headerRowEnabled = $7478efdfea2a60bf$var$isHeaderRowEnabled(rows);
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                    return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                    });
                });
            };
        }
    }
    const $7478efdfea2a60bf$var$TableWithShadows = (0, (0, parcelRequire("ajc8Z")).default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
        overflowSelector: `.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
        useShadowObserver: true
    });
    const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, (0, parcelRequire("OxITw")).FullPagePadding) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        });
    };
    var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("4BsEy")).withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);
});
parcelRegister("6gEe5", function(module, exports) {
    $parcel$export(module.exports, "tableMarginTop", ()=>$356bd8bd1d42bb7c$export$808015ab1dd6897a);
    $parcel$export(module.exports, "tableMarginTopWithControl", ()=>$356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
    $parcel$export(module.exports, "tableMarginSides", ()=>$356bd8bd1d42bb7c$export$a43e30915fab3ccf);
    $parcel$export(module.exports, "tableCellMinWidth", ()=>$356bd8bd1d42bb7c$export$531f77930bf508de);
    $parcel$export(module.exports, "tableNewColumnMinWidth", ()=>$356bd8bd1d42bb7c$export$c60fae4049791eae);
    $parcel$export(module.exports, "tableCellBorderWidth", ()=>$356bd8bd1d42bb7c$export$72aad729077aa0fb);
    $parcel$export(module.exports, "tableCellPadding", ()=>$356bd8bd1d42bb7c$export$e56b8ca552b280f6);
    $parcel$export(module.exports, "TableSharedCssClassName", ()=>$356bd8bd1d42bb7c$export$c096bca5477eb7ad);
    $parcel$export(module.exports, "tableSharedStyle", ()=>$356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
    $parcel$export(module.exports, "calcTableWidth", ()=>$356bd8bd1d42bb7c$export$d7ece4d8beb06815);
    var $f8Sb3;
    var $9UDEr;
    var $iHYdz;
    var $eluMF;
    var $gmhCD = parcelRequire("gmhCD");
    var $gE8f9;
    var $cYeQP;
    var $hgR8Y;
    function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
    const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
    const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
    const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
    const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
    const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
    const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
    const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
    const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
    const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
        TABLE_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-container`,
        TABLE_NODE_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-wrapper`,
        TABLE_LEFT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-left-shadow`,
        TABLE_RIGHT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-right-shadow`,
        TABLE_STICKY_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-shadow`,
        TABLE_STICKY_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-wrapper`,
        TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-container`,
        TABLE_STICKY_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-top`,
        TABLE_STICKY_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-bottom`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
        TABLE_SHADOW_SENTINEL_LEFT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-left`,
        TABLE_SHADOW_SENTINEL_RIGHT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-right`,
        TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, (0, parcelRequire("9UDEr")).tableCellContentDomSelector),
        TABLE_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableCellSelector),
        TABLE_HEADER_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableHeaderSelector),
        TABLE_ROW_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls-wrapper`,
        TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-controls-decoration`,
        TABLE_RESIZER_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resizer-container`
    };
    var $356bd8bd1d42bb7c$var$_ref = {
        name: "qubt66",
        styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
    };
    var $356bd8bd1d42bb7c$var$_ref2 = {
        name: "1fct7qz",
        styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
    };
    const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
    const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("hgR8Y")).tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $gmhCD.editorExperiment)('table-nested-dnd', true) ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, (0, parcelRequire("gE8f9")).browser).gecko || (0, (0, parcelRequire("gE8f9")).browser).ie || (0, (0, parcelRequire("gE8f9")).browser).mac && (0, (0, parcelRequire("gE8f9")).browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
    const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
        switch(layout){
            case 'full-width':
                return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth);
            case 'wide':
                if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth));
                return 0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth;
            default:
                return 'inherit';
        }
    };
});
parcelRegister("eluMF", function(module, exports) {
    $parcel$export(module.exports, "overflowShadow", ()=>$b41fea6975363b1e$export$c5c1e4f4640336fb);
    var $f8Sb3;
    const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
        const width = "var(--ds-space-100, 8px)";
        const leftCoverWidthResolved = leftCoverWidth || width;
        const rightCoverWidthResolved = rightCoverWidth || width;
        return (0, (0, parcelRequire("f8Sb3")).css)();
    };
});
parcelRegister("cYeQP", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockSharedCssClassName", ()=>$dca73d3fed5e4b1b$export$42659c26f026f6ea);
    $parcel$export(module.exports, "codeBlockSharedStyles", ()=>$dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
    $parcel$export(module.exports, "codeBlockInListSafariFix", ()=>$dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
    var $f8Sb3;
    var $iHYdz;
    var $eluMF;
    const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
        CODEBLOCK_CONTAINER: 'code-block',
        CODEBLOCK_START: 'code-block--start',
        CODEBLOCK_END: 'code-block--end',
        CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
        CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
        CODEBLOCK_CONTENT: 'code-content',
        DS_CODEBLOCK: '[data-ds--code--code-block]',
        CODEBLOCK_CONTENT_WRAPPER_FG: 'code-block-content-wrapper--fg',
        CODEBLOCK_CONTENT_FG: 'code-content--fg',
        CODEBLOCK_CONTENT_FG_WRAPPED: 'code-content--fg-wrapped',
        CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped',
        CODEBLOCK_LINE_NUMBER_GUTTER_FG: 'line-number-gutter--fg'
    };
    const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0 0;font-family:", (0, (0, parcelRequire("iHYdz")).akEditorCodeFontFamily), ";min-width:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, "{position:relative;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{flex-shrink:0;text-align:right;background-color:var(--ds-background-neutral, #091E420F);padding:var(--ds-space-100, 8px);position:relative;span{display:block;line-height:0;font-size:0;::before{display:inline-block;content:counter(line);counter-increment:line;color:var(--ds-text-subtlest, #626F86);font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER_FG, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:0px var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);white-space:pre;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
    const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = (0, (0, parcelRequire("f8Sb3")).css)("::before{content:' ';line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em!important;}");
});
parcelRegister("hgR8Y", function(module, exports) {
    $parcel$export(module.exports, "tableCellBackgroundStyleOverride", ()=>$eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
    var $f8Sb3;
    var $9UDEr;
    var $hAs1r;
    const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
        let cssString = '';
        (0, (0, parcelRequire("9UDEr")).tableBackgroundColorNames).forEach((value, key)=>{
            const paletteColorValue = (0, (0, parcelRequire("hAs1r")).hexToEditorBackgroundPaletteColor)(value);
            if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
        });
        return cssString;
    };
    const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>(0, (0, parcelRequire("f8Sb3")).css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());
});
parcelRegister("hAs1r", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", ()=>$3966f91ec47ca318$export$5f6a44a42a4b38c2);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$3966f91ec47ca318$export$a270511a0e7fd61a);
    var $kTHGn;
    function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
        const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.token : undefined;
    }
    function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
        const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $3966f91ec47ca318$export$2462741d70e6a62f = {
        ['#DEEBFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtlest', fallback),
            token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
        },
        ['#B3D4FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtler', fallback),
            token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
        },
        ['#4C9AFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtle', fallback),
            token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
        },
        ['#E6FCFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtlest', fallback),
            token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
        },
        ['#B3F5FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtler', fallback),
            token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
        },
        ['#79E2F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtle', fallback),
            token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
        },
        ['#E3FCEF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtlest', fallback),
            token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
        },
        ['#ABF5D1']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtler', fallback),
            token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
        },
        ['#57D9A3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtle', fallback),
            token: "var(--ds-background-accent-green-subtle, #57D9A3)"
        },
        ['#FFFAE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.yellow.subtlest', fallback),
            token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
        },
        ['#FFF0B3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.yellow.subtler', fallback),
            token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
        },
        ['#FFC400']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.orange.subtle', fallback),
            token: "var(--ds-background-accent-orange-subtle, #FFC400)"
        },
        ['#FFEBE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtlest', fallback),
            token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
        },
        ['#FFBDAD']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtler', fallback),
            token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
        },
        ['#FF8F73']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtle', fallback),
            token: "var(--ds-background-accent-red-subtle, #FF8F73)"
        },
        ['#EAE6FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtlest', fallback),
            token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
        },
        ['#C0B6F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtler', fallback),
            token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
        },
        ['#998DD9']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtle', fallback),
            token: "var(--ds-background-accent-purple-subtle, #998DD9)"
        },
        ['#FFFFFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('elevation.surface', fallback),
            token: "var(--ds-surface, #FFFFFF)"
        },
        ['#F4F5F7']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.gray.subtlest', fallback),
            token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
        },
        ['#B3BAC5']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.gray.subtle', fallback),
            token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
        }
    };
});
parcelRegister("5vnE9", function(module, exports) {
    $parcel$export(module.exports, "compose", ()=>$8cb395a24b5942e2$export$f672e0b6f7222cd7);
    function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
        const allFuncs = [
            func,
            ...funcs
        ];
        return function composed(raw) {
            return allFuncs.reduceRight((memo, func)=>func(memo), raw);
        };
    }
});
parcelRegister("5or39", function(module, exports) {
    $parcel$export(module.exports, "calcTableColumnWidths", ()=>$a59f56ae192d20af$export$98951d3cdcfd364b);
    $parcel$export(module.exports, "hasMergedCell", ()=>$a59f56ae192d20af$export$f9d610bfbb78949b);
    $parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", ()=>$a59f56ae192d20af$export$69fbfaf01f2fd534);
    $parcel$export(module.exports, "isPositionNearTableRow", ()=>$a59f56ae192d20af$export$889a8e446452be16);
    function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
        let tableColumnWidths = [];
        const firstRow = node.firstChild;
        if (firstRow) firstRow.forEach((colNode)=>{
            let colwidth = colNode.attrs.colwidth || [
                0
            ];
            if (colwidth) tableColumnWidths = [
                ...tableColumnWidths,
                ...colwidth
            ];
        });
        return tableColumnWidths;
    }
    function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
        let hasSpan = false;
        tableNode.descendants((node)=>{
            if (node.type.name === 'tableRow') return true;
            const { colspan: colspan, rowspan: rowspan } = node.attrs;
            if (colspan > 1 || rowspan > 1) hasSpan = true;
            return false;
        });
        return hasSpan;
    }
    function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
        const result = [];
        tableNode.forEach((rowNode)=>{
            if (rowNode.type.name === 'tableRow') {
                const row = [];
                rowNode.forEach((n)=>row.push(n));
                result.push(row);
            }
        });
        return result;
    }
    function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
        if (!schema.nodes.tableRow) return false;
        let doc = pos.doc;
        let resolved = pos;
        const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
        while(resolved.depth > 0){
            const siblingType = resolved[sibling]?.type;
            if (siblingType === schema.nodes.tableRow) return true;
            resolved = doc.resolve(resolved[direction]());
        }
        return false;
    }
});
parcelRegister("5J0oM", function(module, exports) {
    $parcel$export(module.exports, "createCompareNodes", ()=>$c09b1d49576acabb$export$49215374a8bec29c);
    var $9BYlQ;
    var $c09b1d49576acabb$export$e2e108cbe2e4f865;
    (function(ContentType) {
        ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
        ContentType[ContentType["TEXT"] = 5] = "TEXT";
        ContentType[ContentType["MENTION"] = 10] = "MENTION";
        ContentType[ContentType["DATE"] = 15] = "DATE";
        ContentType[ContentType["STATUS"] = 20] = "STATUS";
        ContentType[ContentType["LINK"] = 25] = "LINK";
    })($c09b1d49576acabb$export$e2e108cbe2e4f865 || ($c09b1d49576acabb$export$e2e108cbe2e4f865 = {}));
    function $c09b1d49576acabb$var$getLinkMark(node) {
        const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
        return linkMark || null;
    }
    function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
        if (!stringNumber.trim().length) return null;
        const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
        if (Number.isNaN(maybeANumber)) return null;
        return maybeANumber;
    }
    function $c09b1d49576acabb$export$8ebf986086b1866f() {
        const locale = window.navigator.language;
        const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
        const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
        const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
        const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
        return (text)=>{
            if (!text.trim().length) return null;
            const result = text.split(numericPattern);
            const tokens = result.reduce((acc, stringNumber)=>{
                if (!stringNumber?.length) return acc;
                const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
                if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
                else acc.push(stringNumber);
                return acc;
            }, []);
            if (tokens.length === 1) return tokens[0];
            return tokens.join('');
        };
    }
    function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
        const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
        if (linkMark) {
            const value = textNode.text || '';
            return {
                type: 25,
                value: value
            };
        }
        const text = textNode.text || '';
        const normalizedText = normalizeTextParser(text);
        if (typeof normalizedText === 'number') return {
            type: 0,
            value: normalizedText
        };
        return {
            type: 5,
            value: normalizedText ?? text
        };
    }
    function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
        if (!node) return null;
        const firstChild = node.firstChild;
        if (!firstChild) return null;
        switch(firstChild.type.name){
            case 'heading':
            case 'paragraph':
                return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
            case 'inlineCard':
                {
                    const attrs = firstChild.attrs;
                    const maybeTitle = options.getInlineCardTextFromStore(attrs);
                    if (maybeTitle) return {
                        type: 25,
                        value: maybeTitle
                    };
                    const url = attrs.url;
                    return {
                        type: 25,
                        value: url ? url : ''
                    };
                }
            case 'text':
                return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
            case 'status':
                {
                    const text = firstChild.attrs.text;
                    return {
                        type: 20,
                        value: text
                    };
                }
            case 'date':
                {
                    const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                    return {
                        type: 15,
                        value: timestamp
                    };
                }
            case 'mention':
                {
                    const text = firstChild.attrs.text || '';
                    return {
                        type: 10,
                        value: text.toLowerCase()
                    };
                }
            default:
                return null;
        }
    }
    function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
        if (valueA === valueB) return 0;
        if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
            caseFirst: 'upper',
            numeric: true
        });
        return valueA > valueB ? 1 : -1;
    }
    const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC)=>{
        const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
        return (nodeA, nodeB)=>{
            const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
            const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
            if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
            return (order === (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        };
    };
    function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
        if (metaNodeA === metaNodeB) return 0;
        if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
        if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
        return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
    }
});
parcelRegister("9BYlQ", function(module, exports) {
    $parcel$export(module.exports, "SortOrder", ()=>$42ab1316856d1585$export$7ae723045d45777a);
    var $dEtqo;
    var $kXC89;
    var $42ab1316856d1585$export$7ae723045d45777a;
    (function(SortOrder) {
        SortOrder["ASC"] = "asc";
        SortOrder["DESC"] = "desc";
        SortOrder["NO_ORDER"] = "no_order";
    })($42ab1316856d1585$export$7ae723045d45777a || ($42ab1316856d1585$export$7ae723045d45777a = {}));
});
parcelRegister("kXC89", function(module, exports) {
    $parcel$export(module.exports, "ToolbarSize", ()=>$fa36a5395f686390$export$ed55211407a9423);
    $parcel$export(module.exports, "ToolbarWidths", ()=>$fa36a5395f686390$export$423b5e8c92d477b9);
    $parcel$export(module.exports, "ToolbarWidthsNext", ()=>$fa36a5395f686390$export$3f050002d3df641b);
    $parcel$export(module.exports, "ToolbarWidthsFullPage", ()=>$fa36a5395f686390$export$63ca43752be70b90);
    $parcel$export(module.exports, "ToolbarWidthsFullPageNext", ()=>$fa36a5395f686390$export$501a79d885598191);
    var $fa36a5395f686390$export$ed55211407a9423;
    (function(ToolbarSize) {
        ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
        ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
        ToolbarSize[ToolbarSize["L"] = 4] = "L";
        ToolbarSize[ToolbarSize["M"] = 3] = "M";
        ToolbarSize[ToolbarSize["S"] = 2] = "S";
        ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    })($fa36a5395f686390$export$ed55211407a9423 || ($fa36a5395f686390$export$ed55211407a9423 = {}));
    var $fa36a5395f686390$export$423b5e8c92d477b9;
    (function(ToolbarWidths) {
        ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
        ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
        ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
        ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
        ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    })($fa36a5395f686390$export$423b5e8c92d477b9 || ($fa36a5395f686390$export$423b5e8c92d477b9 = {}));
    var $fa36a5395f686390$export$3f050002d3df641b;
    (function(ToolbarWidthsNext) {
        ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
        ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
        ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
        ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
        ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    })($fa36a5395f686390$export$3f050002d3df641b || ($fa36a5395f686390$export$3f050002d3df641b = {}));
    var $fa36a5395f686390$export$63ca43752be70b90;
    (function(ToolbarWidthsFullPage) {
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    })($fa36a5395f686390$export$63ca43752be70b90 || ($fa36a5395f686390$export$63ca43752be70b90 = {}));
    var $fa36a5395f686390$export$501a79d885598191;
    (function(ToolbarWidthsFullPageNext) {
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    })($fa36a5395f686390$export$501a79d885598191 || ($fa36a5395f686390$export$501a79d885598191 = {}));
});
parcelRegister("fKLIs", function(module, exports) {
    $parcel$export(module.exports, "layoutToWidth", ()=>$78b5f00ff26d55fc$export$9b77d38feba5446);
    $parcel$export(module.exports, "getParentNodeWidth", ()=>$78b5f00ff26d55fc$export$d76cc081ce1449a8);
    $parcel$export(module.exports, "getTableContainerWidth", ()=>$78b5f00ff26d55fc$export$3930799be057b305);
    var $5r0mK = parcelRequire("5r0mK");
    var $iHYdz;
    var $bQr2R;
    var $ejmVg;
    var $eOOFp;
    const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
    const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
        default: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth),
        wide: (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth),
        'full-width': (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)
    };
    const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
        if (!pos) return;
        const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
        if (!node) return;
        let layout = node.attrs.layout || 'default';
        const { schema: schema } = state;
        const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
        if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
        let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
        const contextPanelPluginKey = {
            key: 'contextPanelPluginKey$',
            getState: (state)=>{
                return state['contextPanelPluginKey$'];
            }
        };
        if (node.type === schema.nodes.layoutSection) {
            parentWidth += (0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) * 2;
            if (containerWidth.width > (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, (0, parcelRequire("ejmVg")).LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
        }
        switch(node.type){
            case schema.nodes.layoutSection:
                parentWidth -= (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING) * 2;
                break;
            case schema.nodes.bodiedExtension:
                parentWidth -= (0, (0, parcelRequire("bQr2R")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.extensionFrame:
                parentWidth -= (0, (0, parcelRequire("bQr2R")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.expand:
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
                parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
                break;
        }
        parentWidth -= 2;
        return parentWidth;
    };
    const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
        if (tablePos === undefined) return null;
        const $pos = state.doc.resolve(tablePos);
        const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.extensionFrame,
            state.schema.nodes.layoutSection,
            state.schema.nodes.expand
        ]);
        return parent ? parent.node : null;
    };
    const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
        return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("eOOFp")).absoluteBreakoutWidth)(layout, containerWidth.width);
    };
    const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
        if (node?.attrs.width) return node.attrs.width;
        return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
    };
    const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
        return $78b5f00ff26d55fc$export$3930799be057b305(node);
    };
});
parcelRegister("5r0mK", function(module, exports) {
    $parcel$export(module.exports, "removeParentNodeOfType", ()=>$3f4fc20879d21ebe$export$5dd18664fe8bcbde);
    $parcel$export(module.exports, "findParentNodeOfType", ()=>$3f4fc20879d21ebe$export$1a3a74094b9968e);
    $parcel$export(module.exports, "replaceParentNodeOfType", ()=>$3f4fc20879d21ebe$export$b72cc612b642c071);
    $parcel$export(module.exports, "removeSelectedNode", ()=>$3f4fc20879d21ebe$export$7d6e4e6663186878);
    $parcel$export(module.exports, "isNodeSelection", ()=>$3f4fc20879d21ebe$export$a8c1d2c13abf8822);
    $parcel$export(module.exports, "replaceSelectedNode", ()=>$3f4fc20879d21ebe$export$39874bca494f9ba3);
    $parcel$export(module.exports, "setTextSelection", ()=>$3f4fc20879d21ebe$export$1df6d14df6b0b758);
    $parcel$export(module.exports, "safeInsert", ()=>$3f4fc20879d21ebe$export$5fe92db78385e37c);
    $parcel$export(module.exports, "canInsert", ()=>$3f4fc20879d21ebe$export$b4d1262a40ad21d4);
    $parcel$export(module.exports, "removeNodeBefore", ()=>$3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
    $parcel$export(module.exports, "findPositionOfNodeBefore", ()=>$3f4fc20879d21ebe$export$f8088819b1e2c2dc);
    $parcel$export(module.exports, "findParentNode", ()=>$3f4fc20879d21ebe$export$dc159056ffdb4c76);
    $parcel$export(module.exports, "findParentNodeClosestToPos", ()=>$3f4fc20879d21ebe$export$fe09644e3bc6166b);
    $parcel$export(module.exports, "findDomRefAtPos", ()=>$3f4fc20879d21ebe$export$666ce65defe9ad6e);
    $parcel$export(module.exports, "hasParentNode", ()=>$3f4fc20879d21ebe$export$178ecaf80f45fdb6);
    $parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", ()=>$3f4fc20879d21ebe$export$8bf0d019bde85d18);
    $parcel$export(module.exports, "hasParentNodeOfType", ()=>$3f4fc20879d21ebe$export$14f438bb7227ce63);
    $parcel$export(module.exports, "findParentDomRefOfType", ()=>$3f4fc20879d21ebe$export$faeafc1151740116);
    $parcel$export(module.exports, "findSelectedNodeOfType", ()=>$3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
    $parcel$export(module.exports, "flatten", ()=>$3f4fc20879d21ebe$export$bffa455ba8c619a6);
    $parcel$export(module.exports, "findChildren", ()=>$3f4fc20879d21ebe$export$f94ca194e830789c);
    $parcel$export(module.exports, "findChildrenByType", ()=>$3f4fc20879d21ebe$export$96bb9476c7c69f39);
    $parcel$export(module.exports, "contains", ()=>$3f4fc20879d21ebe$export$2344b14b097df817);
    var $gZGBX;
    var $kCV8T;
    var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
            return tr;
        };
    var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
            if (!Array.isArray(nodeType)) nodeType = [
                nodeType
            ];
            for(let i = 0, count = nodeType.length; i < count; i++){
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
                if (parent) {
                    const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                    if (newTr !== tr) return newTr;
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const from = tr.selection.$from.pos;
            const to = tr.selection.$to.pos;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
        }
        return tr;
    };
    var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const { $from: $from, $to: $to } = tr.selection;
                if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, (0, parcelRequire("kCV8T")).Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve($from.pos))));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
            const nextSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(position), dir, true);
            if (nextSelection) return tr.setSelection(nextSelection);
            return tr;
        };
    var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.type && node.type.spec.selectable);
    var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
    var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
        if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve(pos)));
        return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
    };
    var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
            const hasPosition = typeof position === "number";
            const { $from: $from } = tr.selection;
            const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
            const { parent: parent } = $insertPos;
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
                if (oldTr !== tr) return tr;
            }
            if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
                if (oldTr !== tr) {
                    const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? $insertPos.before($insertPos.depth) : $insertPos.pos;
                    return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
                }
            }
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
                tr.insert($insertPos.pos, content);
                const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
            for(let i = $insertPos.depth; i > 0; i--){
                const pos = $insertPos.after(i);
                const $pos = tr.doc.resolve(pos);
                if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                    tr.insert(pos, content);
                    return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
            return tr;
        };
    var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
            if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
                if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, parent.pos)));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
        const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
        if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
        return tr;
    };
    var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
        return selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
    };
    var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
        return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
    };
    var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
        return Object.assign(Object.create(tr), tr).setTime(Date.now());
    };
    var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            const $pos = tr.doc.resolve(position);
            if (!node) return tr;
            if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
                tr = tr.replaceWith(position, position + node.nodeSize, content);
                const start = tr.selection.$from.pos - 1;
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
                return $3f4fc20879d21ebe$var$cloneTr(tr);
            }
            return tr;
        };
    var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
        const node = $pos.node($pos.depth);
        return node && node.type.validContent(content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) ? content : (0, (0, parcelRequire("kCV8T")).Fragment).from(content));
    };
    var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            if (!node) return tr;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
        };
    var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
        const index = $pos.index();
        if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) return $pos.parent.canReplace(index, index, content);
        else if (content instanceof (0, (0, parcelRequire("kCV8T")).Node)) return $pos.parent.canReplaceWith(index, index, content.type);
        return false;
    };
    var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
        return !node || node.type.name === "paragraph" && node.nodeSize === 2;
    };
    var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
            if (validateSameParent && !$from.sameParent($to)) {
                let depth = Math.min($from.depth, $to.depth);
                while(depth >= 0){
                    const fromNode = $from.node(depth);
                    const toNode = $to.node(depth);
                    if (toNode === fromNode) {
                        if (predicate(fromNode)) return {
                            pos: depth > 0 ? $from.before(depth) : 0,
                            start: $from.start(depth),
                            depth: depth,
                            node: fromNode
                        };
                    }
                    depth = depth - 1;
                }
                return;
            }
            return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
        };
    var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    };
    var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
            const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
            if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
        };
    var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
            return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        };
    var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
    };
    var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
            return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
        };
    var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
                const { node: node, $from: $from } = selection;
                if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                    node: node,
                    start: $from.start(),
                    pos: $from.pos,
                    depth: $from.depth
                };
            }
        };
    var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
        const { nodeBefore: nodeBefore } = selection.$from;
        const maybeSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(selection.$from, -1);
        if (maybeSelection && nodeBefore) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
            if (parent) return parent.pos;
            return maybeSelection.$from.pos;
        }
    };
    var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
        const dom = domAtPos(position);
        const node = dom.node.childNodes[dom.offset];
        if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
        if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
        return node;
    };
    var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        const result = [];
        node.descendants((child, pos)=>{
            result.push({
                node: child,
                pos: pos
            });
            if (!descend) return false;
        });
        return result;
    };
    var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        else if (!predicate) throw new Error('Invalid "predicate" parameter');
        return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
    };
    var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
    };
    var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
    };
    var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
    };
    var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
    };
    var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
    };
    var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
    };
    var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
        return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
    };
});
parcelRegister("bQr2R", function(module, exports) {
    $parcel$export(module.exports, "BODIED_EXT_PADDING", ()=>$6a203c68476205e6$export$5ac5087fe1217160);
    $parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", ()=>$6a203c68476205e6$export$91624ec52c59c24c);
    const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
    const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
    const $6a203c68476205e6$export$91624ec52c59c24c = 12;
});
parcelRegister("ejmVg", function(module, exports) {
    $parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", ()=>$16b49a7404f3316f$export$cd04f19842abff0);
    $parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", ()=>$16b49a7404f3316f$export$a1bb91aa2d5fcce8);
    const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
    const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;
});
parcelRegister("OxITw", function(module, exports) {
    $parcel$export(module.exports, "FullPagePadding", ()=>$19a4579e32968c00$export$12fd658e5eef0d79);
    $parcel$export(module.exports, "TELEPOINTER_ID", ()=>$19a4579e32968c00$export$74b525449cc7cbd1);
    $parcel$export(module.exports, "rendererStyles", ()=>$19a4579e32968c00$export$1c4377249312209);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3RZIb;
    var $cSyk1;
    var $9R9Rb;
    var $1xqpZ;
    var $cx4Bg;
    var $kRRtM;
    var $cYeQP;
    var $7Acon;
    var $719f3;
    var $4E5wI;
    var $idytF;
    var $5fBxY;
    var $jlYLw;
    var $ceYEW;
    var $4jyW9;
    var $bv4Ps;
    var $aSoqv;
    var $iJOES;
    var $6gEe5;
    var $1bQ0V;
    var $jRk4M;
    var $fwxzS;
    var $ajc8Z;
    var $bbl9Y;
    var $gE8f9;
    var $iHYdz;
    var $l8Gxi;
    var $3rouw;
    var $2o2hu;
    var $dkc63;
    var $gmhCD = parcelRequire("gmhCD");
    const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
    const $19a4579e32968c00$var$tableShadowWidth = 32;
    const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
    const $19a4579e32968c00$var$telepointerStyles = (colorMode)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("#", $19a4579e32968c00$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:700;width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
    };
    const $19a4579e32968c00$var$getLineHeight = (fontCode)=>(0, (0, parcelRequire("3RZIb")).headingSizes)[fontCode].lineHeight / (0, (0, parcelRequire("3RZIb")).headingSizes)[fontCode].size;
    const $19a4579e32968c00$var$headingSizes = {
        h1: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h700')
        },
        h2: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h600')
        },
        h3: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h500')
        },
        h4: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h400')
        },
        h5: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h300')
        },
        h6: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h100')
        }
    };
    const $19a4579e32968c00$var$headingAnchorStyle = (headingTag)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{position:absolute;height:", $19a4579e32968c00$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
    const $19a4579e32968c00$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowNestedHeaderLinks) return '';
        return (0, (0, parcelRequire("f8Sb3")).css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
    };
    const $19a4579e32968c00$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowColumnSorting) return '';
        let headingsCss = '';
        if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $gmhCD.editorExperiment)('table-nested-dnd', true) ? `${0, (0, parcelRequire("6gEe5")).tableCellPadding}px ${"var(--ds-space-250, 20px)"}` : `${0, (0, parcelRequire("6gEe5")).tableCellPadding}px`, ";border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";}}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
    };
    const $19a4579e32968c00$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
        if (appearance !== 'full-page') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $19a4579e32968c00$export$12fd658e5eef0d79 : 0, "px;");
    };
    const $19a4579e32968c00$var$fullWidthStyles = ({ appearance: appearance })=>{
        if (appearance !== 'full-width') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark,.ak-renderer-extension{width:100%!important;}", (0, (0, parcelRequire("dkc63")).isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
    };
    const $19a4579e32968c00$var$breakoutWidthStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("*:not([data-mark-type='fragment']) .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
    };
    const $19a4579e32968c00$var$getShadowOverrides = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW, "::before{width:", $19a4579e32968c00$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
    };
    function $19a4579e32968c00$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return '';
        if ((0, (0, parcelRequire("VSDnB")).fg)('annotations_align_editor_and_renderer_styles')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& [data-annotation-draft-mark][data-annotation-inline-node]': {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
                borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
                padding: '5px 0 3px 0'
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
                borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
                cursor: 'pointer',
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
            }
        });
    }
    const $19a4579e32968c00$var$tableRowHeight = 44;
    const $19a4579e32968c00$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$19a4579e32968c00$var$tableRowHeight * 3}px;
	 }
	 > .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
    const $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2 = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_pre_release_2');
    const $19a4579e32968c00$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
            const { colorMode: colorMode, typography: typography } = (0, (0, parcelRequire("cSyk1")).default)();
            const themeProps = {
                theme: theme
            };
            const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
            return (0, (0, parcelRequire("f8Sb3")).css)("font-size:", (0, (0, parcelRequire("iHYdz")).editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $19a4579e32968c00$var$fullPageStyles(wrapperProps, themeProps), " ", $19a4579e32968c00$var$fullWidthStyles(wrapperProps), " .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "{", (0, (0, parcelRequire("9R9Rb")).mediaInlineImageStyles), ";}& h1{", $19a4579e32968c00$var$headingAnchorStyle('h1'), ";}& h2{", $19a4579e32968c00$var$headingAnchorStyle('h2'), ";}& h3{", $19a4579e32968c00$var$headingAnchorStyle('h3'), ";}& h4{", $19a4579e32968c00$var$headingAnchorStyle('h4'), ";}& h5{", $19a4579e32968c00$var$headingAnchorStyle('h5'), ";}& h6{", $19a4579e32968c00$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";}", $19a4579e32968c00$var$telepointerStyles(colorMode), " ", (0, (0, parcelRequire("fwxzS")).whitespaceSharedStyles), ";", (0, (0, parcelRequire("kRRtM")).blockquoteSharedStyles), ";", (0, (0, parcelRequire("idytF")).headingsSharedStyles)(typography), ";", (0, (0, parcelRequire("bv4Ps")).ruleSharedStyles)(), ";", (0, (0, parcelRequire("4jyW9")).paragraphSharedStyles)(typography), ";", (0, (0, parcelRequire("jlYLw")).listsSharedStyles), ";", (0, (0, parcelRequire("5fBxY")).indentationSharedStyles), ";", (0, (0, parcelRequire("cx4Bg")).blockMarksSharedStyles), ";", (0, (0, parcelRequire("7Acon")).codeMarkSharedStyles)(), ";", (0, (0, parcelRequire("aSoqv")).shadowSharedStyle), ";", (0, (0, parcelRequire("4E5wI")).dateSharedStyle), ";", (0, (0, parcelRequire("jRk4M")).textColorStyles), ";", (0, (0, parcelRequire("1xqpZ")).backgroundColorStyles)(), ";", (0, (0, parcelRequire("1bQ0V")).tasksAndDecisionsStyles), ";", (0, (0, parcelRequire("iJOES")).smartCardSharedStyles), " ", $19a4579e32968c00$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:", (0, (0, parcelRequire("k5uoT")).fontFamily)(), ";font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)((0, (0, parcelRequire("k5uoT")).fontSize)()), ";font-weight:400;white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$829f609a65d26a98$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-align-start,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-center,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $19a4579e32968c00$var$alignedHeadingAnchorStyle(wrapperProps), (0, (0, parcelRequire("ceYEW")).mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, ">{", $19a4579e32968c00$var$breakoutWidthStyle(), " * .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION, "{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, (0, parcelRequire("6gEe5")).tableSharedStyle)(), " .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, " .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW, "::before{top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop) - 1, "px;height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px);z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";}", $19a4579e32968c00$var$getShadowOverrides(), " ", (0, (0, parcelRequire("dkc63")).isStickyScrollbarEnabled)(appearance) ? $19a4579e32968c00$var$stickyScrollbarStyles : '', " & .", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px);}table{height:1px;", $19a4579e32968c00$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}table tr:first-of-type{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";width:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)((0, (0, parcelRequire("k5uoT")).fontSize)()), ";}.fixed .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $19a4579e32968c00$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, (0, parcelRequire("2o2hu")).getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2() ? (0, (0, parcelRequire("719f3")).columnLayoutResponsiveSharedStyle) : (0, (0, parcelRequire("719f3")).columnLayoutSharedStyle), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:var(--ds-space-400, 32px);}@media screen and (max-width: ", (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, (0, parcelRequire("gE8f9")).browser).safari ? (0, (0, parcelRequire("cYeQP")).codeBlockInListSafariFix) : '', ";}");
        };
    const $19a4579e32968c00$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
        if (codeBlockRenderAsBlock) return '';
        return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
    };
});
parcelRegister("9R9Rb", function(module, exports) {
    $parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", ()=>$c55873fb36219b19$export$dd2e16f83ae6aa78);
    $parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$7ab34e219ce6eef);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$263a8a844c370a89);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$b0d1f1e1fb3c4b46);
    $parcel$export(module.exports, "mediaInlineImageStyles", ()=>$c55873fb36219b19$export$dee15762144889b7);
    $parcel$export(module.exports, "wrapperStyle", ()=>$c55873fb36219b19$export$c4d4f06a25de97f);
    $parcel$export(module.exports, "selectedStyle", ()=>$c55873fb36219b19$export$a7abb1b3dc25813f);
    $parcel$export(module.exports, "interactiveStyle", ()=>$c55873fb36219b19$export$ac950970e139031e);
    $parcel$export(module.exports, "borderStyle", ()=>$c55873fb36219b19$export$4d0a7f76ad443516);
    var $f8Sb3;
    var $dR3f5;
    function $c55873fb36219b19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
    const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
    const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
    const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
    const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>(0, (0, parcelRequire("f8Sb3")).css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
    const $c55873fb36219b19$export$dee15762144889b7 = (0, (0, parcelRequire("f8Sb3")).css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, (0, parcelRequire("dR3f5")).referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h6'], -2), ";}");
    const $c55873fb36219b19$export$c4d4f06a25de97f = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        overflow: 'hidden',
        borderRadius: `${"var(--ds-border-radius, 3px)"}`,
        aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
        maxWidth: '100%'
    });
    const $c55873fb36219b19$export$a7abb1b3dc25813f = (0, (0, parcelRequire("f8Sb3")).css)({
        cursor: 'pointer',
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
        outline: 'none'
    });
    const $c55873fb36219b19$export$ac950970e139031e = {
        name: "e0dnmk",
        styles: "cursor:pointer"
    };
    const $c55873fb36219b19$export$4d0a7f76ad443516 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
        borderStyle: 'solid',
        borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
        borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
        boxSizing: `border-box`
    });
});
parcelRegister("dR3f5", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", ()=>$c9848698b53f0c39$export$d722b7527b1834a8);
    $parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", ()=>$c9848698b53f0c39$export$da894f7669b4e67c);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", ()=>$c9848698b53f0c39$export$286cf28b87ad4b4f);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", ()=>$c9848698b53f0c39$export$64fe09732fb8680);
    $parcel$export(module.exports, "referenceHeights", ()=>$c9848698b53f0c39$export$c1317a9224e4d798);
    const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
    const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
    const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
    const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
    const $c9848698b53f0c39$export$c1317a9224e4d798 = {
        p: 22,
        h1: 36,
        h2: 31,
        h3: 25,
        h4: 23,
        h5: 20,
        h6: 18
    };
});
parcelRegister("1xqpZ", function(module, exports) {
    $parcel$export(module.exports, "backgroundColorStyles", ()=>$31831d84911fc513$export$e4cca17cf56e99d);
    function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $31831d84911fc513$var$_ref = {
        name: "7ixjog",
        styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
    };
    const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
        return $31831d84911fc513$var$_ref;
    };
});
parcelRegister("cx4Bg", function(module, exports) {
    $parcel$export(module.exports, "blockMarksSharedStyles", ()=>$e319ea6be2c09fe0$export$33edc553df878c50);
    function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e319ea6be2c09fe0$export$33edc553df878c50 = {
        name: "1p01ut3",
        styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
    };
});
parcelRegister("kRRtM", function(module, exports) {
    $parcel$export(module.exports, "blockquoteSharedStyles", ()=>$93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
    var $f8Sb3;
    var $iHYdz;
    const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = (0, (0, parcelRequire("f8Sb3")).css)({
        '& blockquote': {
            boxSizing: 'border-box',
            color: 'inherit',
            width: '100%',
            display: 'inline-block',
            paddingLeft: "var(--ds-space-200, 16px)",
            borderLeft: `2px solid ${`var(--ds-border, ${(0, (0, parcelRequire("iHYdz")).akEditorBlockquoteBorderColor)})`}`,
            margin: `${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0 0 0`,
            marginRight: 0,
            "[dir='rtl'] &": {
                paddingLeft: 0,
                paddingRight: "var(--ds-space-200, 16px)"
            },
            '&:first-child': {
                marginTop: 0
            },
            '&::before': {
                content: "''"
            },
            '&::after': {
                content: 'none'
            },
            '& p': {
                display: 'block'
            },
            '& table, & table:last-child': {
                display: 'inline-table'
            },
            '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
                display: 'block'
            }
        }
    });
});
parcelRegister("7Acon", function(module, exports) {
    $parcel$export(module.exports, "codeMarkSharedStyles", ()=>$4ae245bd686f7965$export$ea799c18f699972b);
    var $f8Sb3;
    var $1HkQx;
    const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '.code': {
                '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
                ...(0, (0, parcelRequire("1HkQx")).getCodeStyles)()
            }
        });
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
parcelRegister("719f3", function(module, exports) {
    $parcel$export(module.exports, "columnLayoutSharedStyle", ()=>$2e5d010f6440279f$export$6891a39948814a80);
    $parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", ()=>$2e5d010f6440279f$export$3afcac98e7ca927d);
    var $f8Sb3;
    var $iHYdz;
    const $2e5d010f6440279f$export$6891a39948814a80 = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-layout-section]': {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            '& > *': {
                flex: 1,
                minWidth: 0
            },
            '& > .unsupportedBlockView-content-wrap': {
                minWidth: 'initial'
            },
            [`@media screen and (max-width: ${0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth}px)`]: {
                flexDirection: 'column'
            }
        }
    });
    const $2e5d010f6440279f$export$3afcac98e7ca927d = (0, (0, parcelRequire("f8Sb3")).css)({
        '.layout-section-container': {
            containerType: 'inline-size',
            containerName: 'layout-area',
            '[data-layout-section]': {
                display: 'grid',
                gap: "var(--ds-space-200, 16px)",
                gridTemplateColumns: `repeat(auto-fit, minmax(0, 1fr))`,
                [`@container layout-area (max-width:${(0, (0, parcelRequire("iHYdz")).layoutBreakpointWidth).MEDIUM - 1}px) and (min-width: ${(0, (0, parcelRequire("iHYdz")).layoutBreakpointWidth).SMALL}px)`]: {
                    gridTemplateColumns: `repeat(1, 1fr)`,
                    '&[data-layout-columns="4"], &[data-layout-columns="5"]': {
                        gridTemplateColumns: `repeat(2, 1fr)`,
                        '& > :nth-child(5)': {
                            gridColumn: 'span 2'
                        }
                    }
                },
                [`@container layout-area (width < ${(0, (0, parcelRequire("iHYdz")).layoutBreakpointWidth).SMALL}px)`]: {
                    gridTemplateColumns: `repeat(1, 1fr)`
                }
            }
        }
    });
});
parcelRegister("4E5wI", function(module, exports) {
    $parcel$export(module.exports, "DateSharedCssClassName", ()=>$174371b9df7208d5$export$99cdf122d0bb9f95);
    $parcel$export(module.exports, "dateSharedStyle", ()=>$174371b9df7208d5$export$86f86bd772084bf4);
    var $f8Sb3;
    const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
        DATE_WRAPPER: `date-lozenger-container`,
        DATE_CONTAINER: 'dateView-content-wrap'
    };
    const $174371b9df7208d5$export$86f86bd772084bf4 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
            whiteSpace: 'unset'
        }
    });
});
parcelRegister("idytF", function(module, exports) {
    $parcel$export(module.exports, "headingsSharedStyles", ()=>$152b62c033bbf99a$export$9272613b68afed4b);
    var $f8Sb3;
    var $VSDnB;
    var $04VvC;
    const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_heading_margin_fix') ? {
            '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
                '> h1:first-child': {
                    marginTop: '1.667em'
                },
                ' > h2:first-child': {
                    marginTop: '1.8em'
                },
                '> h3:first-child': {
                    marginTop: '2em'
                },
                '> h4:first-child': {
                    marginTop: '1.357em'
                },
                '> h5:first-child': {
                    marginTop: '1.667em'
                },
                '> h6:first-child': {
                    marginTop: '1.455em'
                }
            },
            '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
                '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                    marginTop: '0'
                }
            }
        } : {};
    const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_typography_ugc')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h1', typographyTheme),
                marginBottom: 0,
                marginTop: '1.667em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h2': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h2', typographyTheme),
                marginTop: '1.8em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h3': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h3', typographyTheme),
                marginTop: '2em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h4': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h4', typographyTheme),
                marginTop: '1.357em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h5': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h5', typographyTheme),
                marginTop: '1.667em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h6': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h6', typographyTheme),
                marginTop: '1.455em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
        });
        else return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                fontSize: `${24 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 28 / 24,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.01em`,
                marginBottom: 0,
                marginTop: '1.667em'
            },
            '& h2': {
                fontSize: `${20 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.2,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.008em`,
                marginTop: '1.8em',
                marginBottom: 0
            },
            '& h3': {
                fontSize: `${16 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.25,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.006em`,
                marginTop: '2em',
                marginBottom: 0
            },
            '& h4': {
                fontSize: `${1}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 14,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.003em`,
                marginTop: '1.357em'
            },
            '& h5': {
                fontSize: `${12 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 12,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                marginTop: '1.667em',
                textTransform: 'none'
            },
            '& h6': {
                fontSize: `${11 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 11,
                color: "var(--ds-text-subtlest, #626F86)",
                fontWeight: "var(--ds-font-weight-bold, 700)",
                marginTop: '1.455em',
                textTransform: 'none'
            },
            ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
        });
    };
});
parcelRegister("04VvC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53f731000984869b$export$2e2bcd8739ae039);
    var $kqZva;
    function $53f731000984869b$var$editorUGCToken(path, typographyTheme) {
        let token;
        switch(typographyTheme){
            case 'typography-modernized':
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokensModernized)[path];
                break;
            case 'typography-refreshed':
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokensRefreshed)[path];
                break;
            default:
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokens)[path];
                break;
        }
        return token;
    }
    var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;
});
parcelRegister("kqZva", function(module, exports) {
    $parcel$export(module.exports, "editorUGCTokens", ()=>$5558cddd9c1ce385$export$4a3637dc6e2ae29e);
    $parcel$export(module.exports, "editorUGCTokensModernized", ()=>$5558cddd9c1ce385$export$95588e746468319e);
    $parcel$export(module.exports, "editorUGCTokensRefreshed", ()=>$5558cddd9c1ce385$export$63adc0ebe3278d31);
    const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
        'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $5558cddd9c1ce385$export$95588e746468319e = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333  "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
});
parcelRegister("5fBxY", function(module, exports) {
    $parcel$export(module.exports, "indentationSharedStyles", ()=>$586c09e19d6f6d26$export$6856b92f564d3de8);
    function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
        name: "1bgz9nd",
        styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
    };
});
parcelRegister("ceYEW", function(module, exports) {
    $parcel$export(module.exports, "richMediaClassName", ()=>$5c06afce66d8efef$export$cfe6da7d522d87bb);
    $parcel$export(module.exports, "mediaSingleSharedStyle", ()=>$5c06afce66d8efef$export$d031611b96ba4cf0);
    $parcel$export(module.exports, "mediaSingleSharedStyleNew", ()=>$5c06afce66d8efef$export$b51dea84d928a378);
    var $f8Sb3;
    var $iHYdz;
    const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
    const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
    const $5c06afce66d8efef$export$d031611b96ba4cf0 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
    const $5c06afce66d8efef$export$b51dea84d928a378 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorWrappedNodeZIndex)
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
});
parcelRegister("4jyW9", function(module, exports) {
    $parcel$export(module.exports, "paragraphSharedStyles", ()=>$0bce92e99beab9a0$export$2f49074d75b0e29f);
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    var $04VvC;
    const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
        return (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_typography_ugc') ? (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.body', typographyTheme),
                marginTop: (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin),
                marginBottom: 0
            }
        }) : (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                fontSize: '1em',
                lineHeight: (0, (0, parcelRequire("iHYdz")).akEditorLineHeight),
                fontWeight: 'normal',
                marginTop: (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin),
                marginBottom: 0,
                letterSpacing: '-0.005em'
            }
        });
    };
});
parcelRegister("bv4Ps", function(module, exports) {
    $parcel$export(module.exports, "ruleSharedStyles", ()=>$f15d364691bf541f$export$329434b3a2da905e);
    var $f8Sb3;
    var $iHYdz;
    const $f15d364691bf541f$export$329434b3a2da905e = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& hr': {
                border: 'none',
                backgroundColor: "var(--ds-border, #091E4224)",
                margin: `${(0, (0, parcelRequire("iHYdz")).akEditorLineHeight)}em 0`,
                height: '2px',
                borderRadius: '1px'
            }
        });
});
parcelRegister("aSoqv", function(module, exports) {
    $parcel$export(module.exports, "shadowSharedStyle", ()=>$0235d3a2f78ffda6$export$985ce3da3286f9ed);
    var $f8Sb3;
    var $iHYdz;
    var $ajc8Z;
    var $bbl9Y;
    const $0235d3a2f78ffda6$var$shadowWidth = 8;
    const $0235d3a2f78ffda6$export$985ce3da3286f9ed = (0, (0, parcelRequire("f8Sb3")).css)({
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::before, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::after, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::before, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorShadowZIndex),
            width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
            content: "''",
            height: 'calc(100%)'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}`]: {
            position: 'relative'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::before`]: {
            background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            top: '0px',
            left: 0,
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            right: '0px',
            top: '0px',
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_LEFT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        },
        [`& .${(0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        }
    });
});
parcelRegister("iJOES", function(module, exports) {
    $parcel$export(module.exports, "SmartCardSharedCssClassName", ()=>$bc13534612fcd0a2$export$4ccd31bf665a88f6);
    $parcel$export(module.exports, "smartCardSharedStyles", ()=>$bc13534612fcd0a2$export$83e107f0a431e184);
    var $iHYdz;
    const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
        INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
        BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
        EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
        DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
        LOADER_WRAPPER: 'loader-wrapper'
    };
    const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
});
parcelRegister("1bQ0V", function(module, exports) {
    $parcel$export(module.exports, "TaskDecisionSharedCssClassName", ()=>$2398d5ed497032ce$export$a7172b75d403a0e4);
    $parcel$export(module.exports, "tasksAndDecisionsStyles", ()=>$2398d5ed497032ce$export$df437277fbc8b4f5);
    var $f8Sb3;
    var $iHYdz;
    const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
        DECISION_CONTAINER: 'decisionItemView-content-wrap',
        TASK_CONTAINER: 'taskItemView-content-wrap',
        TASK_ITEM: 'task-item'
    };
    const $2398d5ed497032ce$export$df437277fbc8b4f5 = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");
});
parcelRegister("jRk4M", function(module, exports) {
    $parcel$export(module.exports, "textColorStyles", ()=>$e9c9f96b9e0ca8df$export$a518ea5d00002b38);
    function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
        name: "1nlqh0j",
        styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
    };
});
parcelRegister("fwxzS", function(module, exports) {
    $parcel$export(module.exports, "whitespaceSharedStyles", ()=>$308dad73f97ce24c$export$c9ce3bfa46d7acba);
    function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
        name: "1s8ykn2",
        styles: "word-wrap:break-word;white-space:pre-wrap"
    };
});
parcelRegister("2o2hu", function(module, exports) {
    $parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", ()=>$67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a);
    $parcel$export(module.exports, "default", ()=>$67d1fb0f1c6fc210$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $iHYdz;
    var $cYeQP;
    var $23OJc;
    var $l8Gxi;
    const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
    const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
        CONTAINER: 'light-weight-code-block'
    };
    const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}");
    };
    const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
        const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
            text
        ]);
        const { renderBidiWarnings: renderBidiWarnings } = (0, (0, parcelRequire("23OJc")).useBidiWarnings)({
            enableWarningTooltip: codeBidiWarningTooltipEnabled
        });
        const classNames = [
            $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
            className
        ].join(' ');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: classNames,
            ref: ref,
            css: [
                (0, (0, parcelRequire("cYeQP")).codeBlockSharedStyles)(),
                $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
        }, textRows.map((_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                key: index
            }))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("code", null, renderBidiWarnings(text))))));
    });
    var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;
});
parcelRegister("23OJc", function(module, exports) {
    $parcel$export(module.exports, "useBidiWarnings", ()=>$807954ab13bca9b8$export$9fb9fe546a188c7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lrHA4;
    var $fJyLQ;
    var $31cgS;
    const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const warningLabel = intl.formatMessage((0, (0, parcelRequire("fJyLQ")).codeBidiWarningMessages).label);
        const renderBidiWarnings = (text)=>{
            return (0, (0, parcelRequire("31cgS")).default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: warningLabel,
                    tooltipEnabled: enableWarningTooltip
                }));
        };
        return {
            renderBidiWarnings: renderBidiWarnings,
            warningLabel: warningLabel
        };
    };
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
parcelRegister("cWojJ", function(module, exports) {
    $parcel$export(module.exports, "TableHeader", ()=>$decaf4f5703baa00$export$f850895b287ef28e);
    $parcel$export(module.exports, "TableCell", ()=>$decaf4f5703baa00$export$1e4baea7053fc0e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $9UDEr;
    var $hxoiH;
    var $9BYlQ;
    var $hAs1r;
    var $hrpWq;
    var $knXBU;
    var $gkwXh;
    var $l8Gxi;
    var $koVbs;
    var $1Bd5P;
    const $decaf4f5703baa00$var$IgnoreSorting = [
        'LABEL',
        'INPUT'
    ];
    const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
        switch(currentSortOrder){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
        }
        return (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
    };
    const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
        const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, (0, parcelRequire("1Bd5P")).tableCellMessages);
        switch(currentSortOrder){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noneSortingLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascSortingLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descSortingLabel);
            default:
                return intl.formatMessage(noneSortingLabel);
        }
    };
    const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
        const attrs = {};
        if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
        if (background) attrs['data-cell-background'] = background;
        return attrs;
    };
    const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
    const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
        const style = {};
        if (background && !background.includes('--ds-background-neutral')) {
            const tokenColor = (0, (0, parcelRequire("hAs1r")).hexToEditorBackgroundPaletteRawValue)(background);
            if (tokenColor) style.backgroundColor = tokenColor;
            else if ($decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
            else if (colorMode === 'dark') style.backgroundColor = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(background);
            else style.backgroundColor = background;
        }
        if (colGroupWidth) {
            style.width = colGroupWidth;
            style.minWidth = colGroupWidth;
        }
        if (offsetTop !== undefined) style.top = offsetTop;
        return style;
    };
    const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
        return function WithCellProps(props) {
            const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
            const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
            const colorName = background ? (0, (0, parcelRequire("9UDEr")).tableBackgroundColorPalette).get(background) : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                rowSpan: rowspan,
                colSpan: colspan,
                style: $decaf4f5703baa00$var$getStyle({
                    background: background,
                    colGroupWidth: colGroupWidth,
                    offsetTop: offsetTop,
                    colorMode: colorMode
                }),
                colorname: colorName,
                onClick: onClick,
                className: className,
                ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
                "aria-sort": ariaSort
            }, children);
        };
    };
    const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
    const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
        return function THWithSortableColumn(props) {
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
            const sortOrderedClassName = sortOrdered === (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
            if (!allowColumnSorting || !isHeaderRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, props);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                ...props,
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
                ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN
            }, children, (0, ($parcel$interopDefault($5uXOq))).createElement("figure", {
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrpWq")).default), {
                isSortingAllowed: !!onSorting,
                sortOrdered: sortOrdered,
                onClick: sort,
                onKeyDown: onKeyPress
            }))));
            function onKeyPress(event) {
                const keys = [
                    ' ',
                    'Enter',
                    'Spacebar'
                ];
                const { tagName: tagName } = event.target;
                if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                    event.preventDefault();
                    sort();
                }
            }
            function sort() {
                const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
                if (onSorting && columnIndex != null) {
                    const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                    onSorting(columnIndex, sortOrder);
                    fireAnalyticsEvent && fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).SORT_COLUMN,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TABLE,
                        attributes: {
                            platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                            mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER,
                            columnIndex: columnIndex,
                            sortOrder: sortOrder
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                    });
                } else fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SORT_COLUMN_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                });
            }
        };
    };
    const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
    const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
    const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;
});
parcelRegister("hrpWq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d33846969f29997f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8RXs9;
    var $VSDnB;
    var $3bDjY;
    var $9BYlQ;
    var $3hakN;
    function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d33846969f29997f$var$annotationRangeFixStyle = {
        name: "oldbq4",
        styles: "user-select:none"
    };
    var $d33846969f29997f$export$c3618f310f725028;
    (function(StatusClassNames) {
        StatusClassNames["ASC"] = "sorting-icon-svg__asc";
        StatusClassNames["DESC"] = "sorting-icon-svg__desc";
        StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
        StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    })($d33846969f29997f$export$c3618f310f725028 || ($d33846969f29997f$export$c3618f310f725028 = {}));
    const $d33846969f29997f$var$buttonStyles = (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
    const $d33846969f29997f$var$iconWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
    const $d33846969f29997f$var$iconStyles = {
        name: "1uj2pwb",
        styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
    };
    const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
        const activated = sortOrdered !== (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
        const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
        if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
            default:
                return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
        }
    };
    const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, (0, parcelRequire("3hakN")).sortingIconMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return '';
    };
    const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, (0, parcelRequire("3hakN")).sortingAriaLabelMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return intl.formatMessage(defaultLabel);
    };
    const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
        const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
        const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
        const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
        const handleClick = ()=>{
            if (isSortingAllowed) onClick();
        };
        const handleKeyDown = (event)=>{
            if (isSortingAllowed) onKeyDown(event);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            delay: 0,
            content: content,
            position: "top"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d33846969f29997f$var$buttonStyles,
            className: buttonClassName,
            role: "button",
            tabIndex: isSortingAllowed ? 0 : -1,
            "aria-label": ariaLabel,
            "aria-disabled": !isSortingAllowed,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d33846969f29997f$var$iconWrapperStyles,
            className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $d33846969f29997f$var$iconStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_allow_annotation_triple_click') && $d33846969f29997f$var$annotationRangeFixStyle
            ]
        }))));
    };
    var $d33846969f29997f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d33846969f29997f$var$SortingIcon);
});
parcelRegister("3hakN", function(module, exports) {
    $parcel$export(module.exports, "sortingIconMessages", ()=>$c1f584a2cfc01515$export$458c50917513cd1a);
    $parcel$export(module.exports, "sortingAriaLabelMessages", ()=>$c1f584a2cfc01515$export$f142573f51a67577);
    var $7VHMR;
    const $c1f584a2cfc01515$export$458c50917513cd1a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.headingLink.noOrderLabel',
            defaultMessage: 'Sort column A to Z',
            description: 'Sort the column in ascending order'
        },
        ascOrderLabel: {
            id: 'fabric.editor.headingLink.ascOrderLabel',
            defaultMessage: 'Sort column Z to A',
            description: 'Sort the column in descending order'
        },
        descOrderLabel: {
            id: 'fabric.editor.headingLink.descOrderLabel',
            defaultMessage: 'Clear sorting',
            description: 'clear the sorting from this column'
        },
        invalidLabel: {
            id: 'fabric.editor.headingLink.invalidLabel',
            defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
            description: 'this sort is invalid for merged cells'
        }
    });
    const $c1f584a2cfc01515$export$f142573f51a67577 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.no',
            defaultMessage: 'No sort applied to the column',
            description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
        },
        ascOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.asc',
            defaultMessage: 'Ascending sort applied',
            description: 'Aria-label for Sort column button when ascending sorting was applied'
        },
        descOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.desc',
            defaultMessage: 'Descending sort applied',
            description: 'Aria-label for Sort column button when descending sorting was applied'
        },
        invalidLabel: {
            id: 'fabric.editor.tableHeader.sorting.invalid',
            defaultMessage: `You can't sort a table with merged cells`,
            description: 'Aria-label for Sort column button when sorting is not possible'
        },
        defaultLabel: {
            id: 'fabric.editor.tableHeader.sorting.default',
            defaultMessage: 'Sort the column',
            description: 'Default aria-label for Sort column button'
        }
    });
});
parcelRegister("4BsEy", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$3b927b61a8274f19$export$2881499e37b75b9a);
    $parcel$export(module.exports, "withSmartCardStorage", ()=>$3b927b61a8274f19$export$65e2d5a272a382b0);
    var $5uXOq = parcelRequire("5uXOq");
    const $3b927b61a8274f19$export$841858b892ce1f4c = (0, ($parcel$interopDefault($5uXOq))).createContext(new Map());
    const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
            value: new Map()
        }, children);
    };
    const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
        return class extends (0, ($parcel$interopDefault($5uXOq))).Component {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, null, (storage)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    }));
            }
        };
    };
});
parcelRegister("2aXGN", function(module, exports) {
    $parcel$export(module.exports, "tableStickyPadding", ()=>$9b3e020198447653$export$3de6413b528017ca);
    $parcel$export(module.exports, "StickyTable", ()=>$9b3e020198447653$export$fd9654fc359d55a3);
    $parcel$export(module.exports, "OverflowParent", ()=>$9b3e020198447653$export$e97bc6692974bd0b);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $6gEe5;
    var $iHYdz;
    var $a4mor;
    var $6cOrl;
    function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9b3e020198447653$export$3de6413b528017ca = 8;
    const $9b3e020198447653$var$modeSpecficStyles = {
        none: {
            name: "eivff4",
            styles: "display:none"
        },
        stick: {
            name: "duudsh",
            styles: "position:fixed"
        },
        'pin-bottom': {
            name: "a4hmbt",
            styles: "position:absolute"
        }
    };
    const $9b3e020198447653$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
        let stickyHeaderZIndex;
        if (allowTableResizing) stickyHeaderZIndex = 13;
        else stickyHeaderZIndex = (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex);
        return (0, (0, parcelRequire("f8Sb3")).css)(typeof top === 'number' && `top: ${top}px;`, {
            width: `${width}px`,
            zIndex: stickyHeaderZIndex,
            [`& .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
                marginTop: 0,
                marginBottom: 0,
                tr: {
                    background: "var(--ds-surface, white)"
                }
            },
            borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
            background: "var(--ds-surface-overlay, white)",
            boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
            "div[data-expanded='false'] &": {
                display: 'none'
            },
            [`& .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
                top: '0px',
                height: '100%'
            },
            "&.fixed-table-div-custom-table-resizing[mode='stick']": {
                zIndex: stickyHeaderZIndex
            }
        });
    };
    const $9b3e020198447653$var$FixedTableDiv = (props)=>{
        const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
        const fixedTableCss = [
            $9b3e020198447653$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ];
        const attrs = {
            mode: mode
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...attrs,
            "data-testid": "sticky-table-fixed",
            className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
            css: fixedTableCss
        }, props.children);
    };
    const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
        let styles;
        if (allowTableResizing) styles = (0, (0, parcelRequire("f8Sb3")).css)({
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'absolute'
        });
        else styles = (0, (0, parcelRequire("f8Sb3")).css)({
            left: left && left < 0 ? left : undefined,
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'relative'
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($9b3e020198447653$var$FixedTableDiv, {
            top: mode === 'stick' ? top : undefined,
            mode: rowHeight > 300 ? 'none' : mode,
            wrapperWidth: wrapperWidth,
            allowTableResizing: allowTableResizing
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
            "data-layout": layout,
            style: {
                width: tableWidth
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
            style: {
                overflow: 'hidden'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a4mor")).Table), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance
        }, (0, (0, parcelRequire("6cOrl")).recursivelyInjectProps)(children, {
            invisible: true
        })))))));
    };
    function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
        let parent = table;
        if (!parent) return null;
        while(parent = parent.parentElement){
            const style = window.getComputedStyle(parent);
            if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
            if (!!defaultScrollRootId && parent.id === defaultScrollRootId) return parent;
        }
        return null;
    }
    class $9b3e020198447653$export$e97bc6692974bd0b {
        constructor(ref){
            this.ref = ref;
            this.ref = ref;
        }
        static fromElement(el, defaultScrollRootId) {
            return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
        }
        get isElement() {
            return this.ref instanceof HTMLElement;
        }
        get id() {
            if (this.ref instanceof HTMLElement) return this.ref.id;
            return '';
        }
        get top() {
            if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
            return 0;
        }
        addEventListener(type, cb, ...args) {
            this.ref.addEventListener(type, cb, ...args);
        }
        removeEventListener(type, cb, ...args) {
            this.ref.removeEventListener(type, cb, ...args);
        }
    }
});
parcelRegister("a4mor", function(module, exports) {
    $parcel$export(module.exports, "Table", ()=>$40c6d2c88bc98a0d$export$54ec01a60f47d33d);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nHPA;
    var $fKLIs;
    var $iHYdz;
    const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = (0, ($parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
        let tableWidth = tableNode ? (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode) : (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
        if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
        if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
        const tableLayout = tableNode?.attrs.layout;
        const tableDisplayMode = tableNode?.attrs.displayMode;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("table", {
            "data-testid": "renderer-table",
            "data-number-column": isNumberColumnEnabled,
            "data-table-width": tableWidth,
            "data-layout": tableLayout,
            "data-table-display-mode": tableDisplayMode,
            ref: innerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3nHPA")).Colgroup), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, children));
    });
});
parcelRegister("3nHPA", function(module, exports) {
    $parcel$export(module.exports, "Colgroup", ()=>$ae0cfecd7422435f$export$89efc2d0ceeaa030);
    var $5uXOq = parcelRequire("5uXOq");
    var $6gEe5;
    var $iHYdz;
    var $gmhCD = parcelRequire("gmhCD");
    var $fKLIs;
    var $VSDnB;
    var $9JDnL;
    var $dyURG;
    const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
    const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
    const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
        const filteredWidths = columnWidths.filter((width)=>width !== 0);
        return !!filteredWidths.length;
    };
    const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
        if (columnWidth === 0) return columnWidth;
        if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, (0, parcelRequire("6gEe5")).tableCellMinWidth));
        return Math.max(columnWidth - (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), zeroWidthColumnsCount ? (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) : (0, (0, parcelRequire("6gEe5")).tableCellMinWidth));
    };
    const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
        const noNumColumnScalePercent = renderWidth / tableWidth;
        const numColumnScalePercent = (renderWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)) / (tableWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth));
        const diffPercent = 1 - noNumColumnScalePercent;
        return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
    };
    const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
    const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        if (!columnWidths) return [];
        const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
        const noOfColumns = columnWidths.length;
        let targetWidths;
        const isRendererNested = isTopLevelRenderer === false && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_nested_table_in_nested_parent_fix');
        const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
        if (allowTableResizing && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableColumnResized) {
            const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
            const defaultColumnWidth = tableWidth / noOfColumns;
            targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
        } else if (!tableColumnResized) return null;
        const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
        const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
        const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
        if (forceScaleForNumColumn) {
            const scalePercentage = +((tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)) / tableContainerWidth);
            const targetMaxWidth = tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth);
            let totalWidthAfterScale = 0;
            const newScaledTargetWidths = columnWidths.map((width)=>{
                const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
                const newWidth = Math.floor(patchedWidth * scalePercentage);
                totalWidthAfterScale += newWidth;
                return newWidth;
            });
            const diff = targetMaxWidth - totalWidthAfterScale;
            targetWidths = newScaledTargetWidths;
            if (diff > 0 || diff < 0 && Math.abs(diff) < (0, (0, parcelRequire("6gEe5")).tableCellMinWidth)) {
                let updated = false;
                targetWidths = targetWidths.map((width)=>{
                    if (!updated && width + diff > (0, (0, parcelRequire("6gEe5")).tableCellMinWidth)) {
                        updated = true;
                        width += diff;
                    }
                    return width;
                });
            }
        }
        targetWidths = targetWidths || columnWidths;
        const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
        let tableWidth = isNumberColumnEnabled ? (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) : 0;
        let minTableWidth = tableWidth;
        let zeroWidthColumnsCount = 0;
        targetWidths.forEach((width)=>{
            if (width) tableWidth += Math.ceil(width);
            else zeroWidthColumnsCount += 1;
            minTableWidth += Math.ceil(width) || (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth);
        });
        let cellMinWidth = 0;
        let scaleDownPercent = 0;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
        const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
        if (zeroWidthColumnsCount > 0) {
            if (minTableWidth > maxTableWidth) {
                const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
                cellMinWidth = minWidth < (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) ? (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) : minWidth;
            }
        } else if (renderWidth < tableWidth && !isTableWidthFixed) {
            const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
            scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
                renderWidth: renderWidth,
                tableWidth: tableWidth,
                maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
                isNumberColumnEnabled: isNumberColumnEnabled
            });
        }
        return targetWidths.map((colWidth)=>{
            const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
            const style = width ? {
                width: `${width}px`
            } : {};
            return style;
        });
    };
    const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("dyURG")).useRendererContext)();
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
        const flags = (0, (0, parcelRequire("9JDnL")).useFeatureFlags)();
        if (!columnWidths) return null;
        const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
            ...props,
            isTopLevelRenderer: isTopLevelRenderer,
            isTableScalingEnabled: !!(flags && 'tablePreserveWidth' in flags && flags.tablePreserveWidth) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
        });
        if (!colStyles) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("colgroup", null, isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("col", {
            style: {
                width: (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)
            },
            "data-test-id": 'num'
        }), colStyles.map((style, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement("col", {
                key: idx,
                style: style
            })));
    };
});
parcelRegister("9JDnL", function(module, exports) {
    $parcel$export(module.exports, "useFeatureFlags", ()=>$7cc75954bd6ebac0$export$90335b3ff08f335);
    var $dyURG;
    const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, (0, parcelRequire("dyURG")).useRendererContext)()?.featureFlags;
});
parcelRegister("dyURG", function(module, exports) {
    $parcel$export(module.exports, "useRendererContext", ()=>$6d8aa882825f4203$export$a906432540ed7ed8);
    $parcel$export(module.exports, "RendererContextProvider", ()=>$6d8aa882825f4203$export$ca5df47902194781);
    var $5uXOq = parcelRequire("5uXOq");
    const $6d8aa882825f4203$var$RendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
    const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;
});
parcelRegister("6cOrl", function(module, exports) {
    $parcel$export(module.exports, "recursivelyInjectProps", ()=>$7a2ba32d880ccda8$export$40e12ce8e0a76b0c);
    var $5uXOq = parcelRequire("5uXOq");
    function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
        return (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
            if (!(0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
            if (child.props.children) child = (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
            });
            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
        });
    }
});
parcelRegister("kjIja", function(module, exports) {
    $parcel$export(module.exports, "isFullWidthAppearance", ()=>$b5d34963b73650ed$export$c0112b8340d4924b);
    $parcel$export(module.exports, "isFullPageAppearance", ()=>$b5d34963b73650ed$export$a64737a81cde10b4);
    $parcel$export(module.exports, "isCommentAppearance", ()=>$b5d34963b73650ed$export$f77d2ff45b2c53ed);
    $parcel$export(module.exports, "isFullWidthOrFullPageAppearance", ()=>$b5d34963b73650ed$export$33331a99fac775a1);
    const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
    const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
    const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
    const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);
});
parcelRegister("eIscD", function(module, exports) {
    $parcel$export(module.exports, "TableStickyScrollbar", ()=>$ea0307076d72d83e$export$8c072780619cfc83);
    var $6gEe5;
    class $ea0307076d72d83e$export$8c072780619cfc83 {
        constructor(wrapper){
            this.sentinels = {};
            this.handleScroll = (event)=>{
                if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
                this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
            };
            this.wrapper = wrapper;
            this.init();
        }
        dispose() {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
            this.deleteIntersectionObserver();
        }
        scrollLeft(left) {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
        }
        init() {
            if (!this.wrapper) return;
            this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
                passive: true
            });
            this.createIntersectionObserver();
        }
        createIntersectionObserver() {
            this.rendererScrollableElement = window.document;
            if (!this.rendererScrollableElement || !this.wrapper) return;
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                if (!this.stickyScrollbarContainerElement) return;
                entries.forEach((entry)=>{
                    const target = entry.target;
                    if (target.classList.contains((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                    if (target.classList.contains((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
                });
            }, {
                root: this.rendererScrollableElement
            });
            this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
            this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
            [
                this.sentinels.bottom,
                this.sentinels.top
            ].forEach((el)=>this.intersectionObserver.observe(el));
        }
        deleteIntersectionObserver() {
            if (this.intersectionObserver) {
                if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
                this.intersectionObserver.disconnect();
            }
        }
        sentinelBottomCallback(entry) {
            const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
            this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
            this.toggle();
        }
        sentinelTopCallback(entry) {
            const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
            this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
            this.toggle();
        }
        toggle() {
            if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
            else this.hide();
        }
        hide() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
        }
        show() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
        }
    }
});
parcelRegister("i4Lgj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d6cf54c99dd1cb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5vnE9;
    var $9BYlQ;
    var $l8Gxi;
    class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, innerRef: innerRef } = this.props;
            const childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                ref: innerRef
            }, this.props.isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN
            }, this.props.index), (0, (0, parcelRequire("5vnE9")).compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
        }
        constructor(...args){
            super(...args);
            this.state = {
                colGroupWidths: []
            };
            this.addSortableColumn = (childrenArray)=>{
                const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
                if (allowColumnSorting) {
                    const isHeaderRow = !rowIndex;
                    childrenArray = childrenArray.map((child, index)=>{
                        if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) {
                            const { tableOrderStatus: tableOrderStatus } = this.props;
                            let sortOrdered = (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
                            if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
                            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                                columnIndex: index,
                                onSorting: this.props.onSorting,
                                sortOrdered: sortOrdered,
                                isHeaderRow: isHeaderRow
                            });
                        }
                    });
                }
                return childrenArray;
            };
            this.addColGroupWidth = (childrenArray)=>{
                if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                    if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        colGroupWidth: this.state.colGroupWidths[index]
                    });
                });
                return childrenArray;
            };
        }
    }
});
parcelRegister("gfMkN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5be854e6b8cbd84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "UnknownBlock"
        }, props.children);
    }
});
parcelRegister("9kpKZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b743bc5ccb58a13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $iHYdz;
    var $eJS47;
    var $3bDjY;
    var $gkwXh;
    var $7R1zM;
    var $d54NZ;
    var $9tFGn;
    const $5b743bc5ccb58a13$var$inlineNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        alignItems: 'center',
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'inline-flex',
        fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        minHeight: '24px',
        padding: `0 ${"var(--ds-space-100, 8px)"}`,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
    });
    const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("9tFGn")).getUnsupportedContent)((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("d54NZ")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5b743bc5ccb58a13$var$inlineNodeStyle
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            label: "?",
            size: "small"
        }))));
    };
    var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);
});
parcelRegister("8BH8p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jv5OL").then(()=>parcelRequire('fyj1u'));
});
parcelRegister("6seAF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("27B3z").then(()=>parcelRequire('bO8HO'));
});
parcelRegister("xgpzA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("wQW1L").then(()=>parcelRequire('iLXzZ'));
});
parcelRegister("vMisH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("hY7zf")
    ]).then(()=>parcelRequire('5Y7e4'));
});
parcelRegister("i873P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7lItE").then(()=>parcelRequire('h2Mqp'));
});
parcelRegister("lOJRn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6OdqE").then(()=>parcelRequire('sFJC1'));
});
parcelRegister("6tOdT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8PYkX").then(()=>parcelRequire('4hMem'));
});
parcelRegister("hC3g2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aetML")
    ]).then(()=>parcelRequire('c3ssB'));
});
parcelRegister("j2dSX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9VCdz")
    ]).then(()=>parcelRequire('hibqv'));
});
parcelRegister("7F34O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h0TDs")
    ]).then(()=>parcelRequire('1lkep'));
});
parcelRegister("d129d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hLGxH")
    ]).then(()=>parcelRequire('fz1ZD'));
});
parcelRegister("lVGRg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("13w3s")
    ]).then(()=>parcelRequire('lD0Zb'));
});
parcelRegister("2Rdcz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("YsZeU")
    ]).then(()=>parcelRequire('gQwn3'));
});
parcelRegister("2z3Jr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2Q2XH")
    ]).then(()=>parcelRequire('aPwmB'));
});
parcelRegister("RmF2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4B3Pp")
    ]).then(()=>parcelRequire('ebIkR'));
});
parcelRegister("d6mGh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("c5BYw")
    ]).then(()=>parcelRequire('74PfD'));
});
parcelRegister("lFguI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QV79").then(()=>parcelRequire('9jt2S'));
});
parcelRegister("h4pi8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iJ6aZ")
    ]).then(()=>parcelRequire('V5Yjo'));
});
parcelRegister("dZ3Pj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcqJ9")
    ]).then(()=>parcelRequire('hA9EZ'));
});
parcelRegister("5BLIh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1269296b575a9fc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4dDLS;
    const $e1269296b575a9fc$var$TextWrapper = (props)=>{
        const { startPos: startPos, endPos: endPos } = props;
        const { children: children } = props;
        if (!children) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dDLS")).TextWithAnnotationDraft), {
            startPos: startPos,
            endPos: endPos,
            textHighlighter: props.textHighlighter,
            marks: props.marks
        }, children);
    };
    var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;
});
parcelRegister("cKKwC", function(module, exports) {
    $parcel$export(module.exports, "isAnnotationMark", ()=>$d006a5118aec07b0$export$855795c145f03402);
    $parcel$export(module.exports, "default", ()=>$d006a5118aec07b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $5uoEK;
    const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
        return mark && mark.type && mark.type.name === 'annotation';
    };
    const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
        const data = {
            ...dataAttributes,
            ...(0, (0, parcelRequire("88i6h")).buildDataAttributes)({
                id: id,
                annotationType: annotationType
            })
        };
        if (allowAnnotations) return isMediaInline ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5uoEK")).MarkElement), {
            id: id,
            dataAttributes: data,
            annotationParentIds: annotationParentIds,
            annotationType: annotationType,
            useBlockLevel: useBlockLevel
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id,
            ...data
        }, children);
    };
    var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;
});
parcelRegister("GDkvY", function(module, exports) {
    $parcel$export(module.exports, "toReact", ()=>$d1627eb50b8d1823$export$d4334b129116aad7);
    var $bVGKe;
    var $lqKi3;
    var $kgK5w;
    var $f14yv;
    var $eVxaj;
    var $gUlHA;
    var $c15YI;
    var $koUAb;
    var $eESZY;
    var $95Yll;
    var $lbdLJ;
    var $9xZ5X;
    var $g5EjF;
    var $acz8Q;
    var $8DQfy;
    var $g9yqu;
    var $cKKwC;
    var $itF0z;
    var $6EeUE;
    const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
        code: (0, (0, parcelRequire("bVGKe")).default),
        em: (0, (0, parcelRequire("lqKi3")).default),
        link: (0, (0, parcelRequire("kgK5w")).default),
        strike: (0, (0, parcelRequire("f14yv")).default),
        strong: (0, (0, parcelRequire("eVxaj")).default),
        subsup: (0, (0, parcelRequire("gUlHA")).default),
        textColor: (0, (0, parcelRequire("c15YI")).default),
        backgroundColor: (0, (0, parcelRequire("koUAb")).default),
        underline: (0, (0, parcelRequire("eESZY")).default),
        annotation: (0, (0, parcelRequire("cKKwC")).default),
        border: (0, (0, parcelRequire("itF0z")).default),
        confluenceInlineComment: (0, (0, parcelRequire("6EeUE")).default),
        breakout: (0, (0, parcelRequire("95Yll")).default),
        alignment: (0, (0, parcelRequire("lbdLJ")).default),
        indentation: (0, (0, parcelRequire("9xZ5X")).default),
        unsupportedMark: (0, (0, parcelRequire("g5EjF")).default),
        unsupportedNodeAttribute: (0, (0, parcelRequire("acz8Q")).default),
        dataConsumer: (0, (0, parcelRequire("8DQfy")).default),
        fragment: (0, (0, parcelRequire("g9yqu")).default)
    };
    const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
        return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
    };
});
parcelRegister("bVGKe", function(module, exports) {
    $parcel$export(module.exports, "isCodeMark", ()=>$caa083dc61fd842d$export$86390c02c110ec2f);
    $parcel$export(module.exports, "default", ()=>$caa083dc61fd842d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $O2UjQ;
    var $fJyLQ;
    const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
        return mark && mark.type && mark.type.name === 'code';
    };
    function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
        const codeBidiWarningLabel = props.intl.formatMessage((0, (0, parcelRequire("fJyLQ")).codeBidiWarningMessages).label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("O2UjQ")).default), {
            className: "code",
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
            ...props.dataAttributes
        }, props.children);
    }
    var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($caa083dc61fd842d$export$7cea6ffa7022e85f);
});
parcelRegister("O2UjQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c9c981a54265bdd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lrHA4;
    var $31cgS;
    var $lBXbx;
    var $1HkQx;
    const $4c9c981a54265bdd$var$styles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(${(0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        lineHeight: 'inherit',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    });
    const $4c9c981a54265bdd$var$Code = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
        const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
        const decoratedChildren = codeBidiWarnings ? (0, (0, parcelRequire("f8Sb3")).jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        }, children) : children;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("code", {
            ref: ref,
            "data-testid": testId,
            css: $4c9c981a54265bdd$var$styles,
            ...otherProps
        }, decoratedChildren));
    }));
    function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
        const replacedChildren = (0, ($parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
            if (typeof childNode === 'string') {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
                const newChildNode = (0, ($parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                    children: (0, (0, parcelRequire("f8Sb3")).jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                        codeBidiWarningLabel: codeBidiWarningLabel,
                        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                    }, childNode.props.children)
                });
                return newChildNode;
            }
            return childNode;
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
    }
    function $4c9c981a54265bdd$var$isReactElement(child) {
        return !!child.type;
    }
    $4c9c981a54265bdd$var$Code.displayName = 'Code';
    var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;
});
parcelRegister("lqKi3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd21faba719ebab1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("em", props.dataAttributes, props.children);
    }
});
parcelRegister("kgK5w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9900830cb94354be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $K5Jsy;
    var $knXBU;
    var $gkwXh;
    var $iHvAB;
    var $daJ0i;
    const $9900830cb94354be$var$anchorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    });
    function $9900830cb94354be$export$2e2bcd8739ae039(props) {
        const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
        const anchorProps = {
            href: href,
            target: target,
            title: href
        };
        if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
        const handler = (0, (0, parcelRequire("K5Jsy")).getEventHandler)(eventHandlers, 'link');
        if (isMediaLink) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, props.children);
        const analyticsData = {
            attributes: {
                location: 'renderer'
            },
            location: 'renderer'
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("daJ0i")).default), {
            data: analyticsData
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iHvAB")).default), {
            css: $9900830cb94354be$var$anchorStyles,
            onClick: (e)=>{
                if (fireAnalyticsEvent) fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VISITED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).LINK,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    }
                });
                if (handler) handler(e, href);
            },
            ...anchorProps,
            ...dataAttributes
        }, props.children));
    }
});
parcelRegister("K5Jsy", function(module, exports) {
    $parcel$export(module.exports, "ADFEncoder", ()=>$75b48ee07210971a$export$bcf771b83128eae7);
    $parcel$export(module.exports, "getText", ()=>$75b48ee07210971a$export$c72d34660a162238);
    $parcel$export(module.exports, "getEventHandler", ()=>$75b48ee07210971a$export$eee20638634729b3);
    $parcel$export(module.exports, "findInTree", ()=>$75b48ee07210971a$export$38b61ebf4950cd39);
    var $kOFhM;
    var $hYNZx;
    function $75b48ee07210971a$var$createEncoder(parser, encoder) {
        return (value)=>encoder.encode(parser.parse(value));
    }
    class $75b48ee07210971a$export$bcf771b83128eae7 {
        constructor(createTransformerWithSchema){
            const transformer = createTransformerWithSchema((0, (0, parcelRequire("kOFhM")).defaultSchema));
            this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, (0, parcelRequire("hYNZx")).JSONTransformer)());
        }
    }
    const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
        return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
    };
    const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
        return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
    };
    function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
        if (element === topElement) return false;
        if (evaluate(element)) return true;
        if (!element.parentElement) return false;
        return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
    }
});
parcelRegister("iHvAB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65e7a399613e0863$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $994MI;
    var $g2eZ6;
    var $66xOO;
    var $hTTxJ;
    var $cI2hq;
    const $65e7a399613e0863$var$PACKAGE_DATA = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        componentName: 'linkUrl'
    };
    const $65e7a399613e0863$var$Link = (0, (0, parcelRequire("g2eZ6")).withLinkClickedEvent)('a');
    const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
        const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, (0, parcelRequire("cI2hq")).useLinkWarningModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("66xOO")).LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($65e7a399613e0863$var$Link, {
            "data-testid": testId,
            href: href,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTTxJ")).default), linkWarningModalProps));
    };
    var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);
});
parcelRegister("g2eZ6", function(module, exports) {
    $parcel$export(module.exports, "fireLinkClickedEvent", ()=>$473b45d487f9fd1b$export$7987de3055fbdcb0);
    $parcel$export(module.exports, "withLinkClickedEvent", ()=>$473b45d487f9fd1b$export$263352d59c0c5966);
    var $5uXOq = parcelRequire("5uXOq");
    var $b6uPu;
    var $4URMI;
    var $fzJZi;
    const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
        [
            undefined,
            'none'
        ],
        [
            0,
            'left'
        ],
        [
            1,
            'middle'
        ],
        [
            2,
            'right'
        ]
    ]);
    const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
        return [
            'alt',
            'ctrl',
            'meta',
            'shift'
        ].filter((key)=>e[`${key}Key`] === true);
    };
    const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
        return el instanceof HTMLElement && el.isContentEditable;
    };
    function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
        const { mac: mac, safari: safari } = (0, (0, parcelRequire("b6uPu")).browser)();
        if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
            'left',
            'middle'
        ].includes(clickType)) return 'contentEditable';
        switch(clickType){
            case 'left':
            case 'keyboard':
                {
                    if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                    if (e.shiftKey) {
                        if (safari) return 'alt';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.ctrlKey) {
                        if (mac) return 'clickThrough';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.altKey) return 'alt';
                    const target = e.currentTarget.getAttribute('target');
                    if (target === '_blank') return 'clickThroughNewTabOrWindow';
                    return 'clickThrough';
                }
            case 'middle':
                return 'clickThroughNewTabOrWindow';
            case 'right':
                return 'contextMenu';
        }
        return 'unknown';
    }
    const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
            action: 'clicked',
            actionSubject: 'link',
            eventType: 'ui',
            attributes: {
                clickType: clickType,
                clickOutcome: clickOutcome,
                keysHeld: keysHeld,
                defaultPrevented: defaultPrevented
            }
        });
    const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
        const isKeyboard = event.nativeEvent.detail === 0;
        const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
        if (!clickType) return;
        const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
        const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
        const defaultPrevented = event.defaultPrevented;
        return $473b45d487f9fd1b$var$linkClickedEvent({
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        });
    };
    const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
            const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
            if (payload) createAnalyticsEvent({
                ...payload,
                ...overrides,
                attributes: {
                    ...payload.attributes,
                    ...overrides?.attributes
                }
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
    const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
        if (typeof WrappedComponent === 'string') return WrappedComponent;
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    };
    function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
        const Component = (props)=>{
            const onClick = (0, (0, parcelRequire("4URMI")).useLinkClicked)(props.onClick);
            const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)(props.onMouseDown);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                onClick: onClick,
                onMouseDown: onMouseDown
            });
        };
        Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
        return Component;
    }
});
parcelRegister("b6uPu", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
    const $7f7209ce5c1e8d08$var$result = {
        mac: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
        let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
    function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
        return $7f7209ce5c1e8d08$var$result;
    }
});
parcelRegister("4URMI", function(module, exports) {
    $parcel$export(module.exports, "useLinkClicked", ()=>$0d5ea96be37e2b5d$export$5993d3ca6c85f774);
    $parcel$export(module.exports, "useMouseDownEvent", ()=>$0d5ea96be37e2b5d$export$df67f318ded0283c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $g2eZ6;
    var $0d5ea96be37e2b5d$export$81a5b494baf0f17c;
    (function(ClickButton) {
        ClickButton[ClickButton["Left"] = 0] = "Left";
        ClickButton[ClickButton["Middle"] = 1] = "Middle";
        ClickButton[ClickButton["Right"] = 2] = "Right";
    })($0d5ea96be37e2b5d$export$81a5b494baf0f17c || ($0d5ea96be37e2b5d$export$81a5b494baf0f17c = {}));
    const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (handler, predicate)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((...args)=>{
            const [event] = args;
            handler?.apply(null, args);
            if (!predicate || predicate?.(event)) (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            handler,
            predicate,
            createAnalyticsEvent
        ]);
    };
    const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
    const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
        return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
    };
});
parcelRegister("fzJZi", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$3b4d25437cc28513$export$85183a312807388d);
    $parcel$export(module.exports, "context", ()=>$3b4d25437cc28513$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "TrackQuickActionType", ()=>$3b4d25437cc28513$export$72af824fa910c33e);
    $parcel$export(module.exports, "TrackQuickActionFailureReason", ()=>$3b4d25437cc28513$export$c89e475f7f7174c2);
    $parcel$export(module.exports, "SmartLinkEvents", ()=>$3b4d25437cc28513$export$b91e0203b928470c);
    $parcel$export(module.exports, "resolvedEvent", ()=>$3b4d25437cc28513$export$e2e1bab8375c3115);
    $parcel$export(module.exports, "unresolvedEvent", ()=>$3b4d25437cc28513$export$331b399cdebbb8d4);
    $parcel$export(module.exports, "invokeSucceededEvent", ()=>$3b4d25437cc28513$export$237caeb1002642ba);
    $parcel$export(module.exports, "invokeFailedEvent", ()=>$3b4d25437cc28513$export$ac488bf3e4c7f93);
    $parcel$export(module.exports, "connectSucceededEvent", ()=>$3b4d25437cc28513$export$5f549b8ba38f19b1);
    $parcel$export(module.exports, "connectFailedEvent", ()=>$3b4d25437cc28513$export$fdfcba182edbb89a);
    $parcel$export(module.exports, "trackAppAccountConnected", ()=>$3b4d25437cc28513$export$27d8deca51e9575c);
    $parcel$export(module.exports, "trackAppAccountAuthStarted", ()=>$3b4d25437cc28513$export$48e92e116e00d94c);
    $parcel$export(module.exports, "trackSmartLinkQuickActionStarted", ()=>$3b4d25437cc28513$export$1c2a74fe02a8031b);
    $parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", ()=>$3b4d25437cc28513$export$afbd6446c1c03a3e);
    $parcel$export(module.exports, "trackSmartLinkQuickActionFailed", ()=>$3b4d25437cc28513$export$2706827739a8c50);
    $parcel$export(module.exports, "trackHoverCardResolutionStarted", ()=>$3b4d25437cc28513$export$daa964b113be9527);
    $parcel$export(module.exports, "uiAuthEvent", ()=>$3b4d25437cc28513$export$5318734335f1d8b8);
    $parcel$export(module.exports, "uiAuthAlternateAccountEvent", ()=>$3b4d25437cc28513$export$14f2ce8523ccb652);
    $parcel$export(module.exports, "uiCardClickedEvent", ()=>$3b4d25437cc28513$export$8b5d1f55370347a1);
    $parcel$export(module.exports, "uiIframeDwelledEvent", ()=>$3b4d25437cc28513$export$6b045396616c2e9f);
    $parcel$export(module.exports, "uiIframeFocusedEvent", ()=>$3b4d25437cc28513$export$93fa3246cf9e3b52);
    $parcel$export(module.exports, "uiActionClickedEvent", ()=>$3b4d25437cc28513$export$e00b9d79d3367530);
    $parcel$export(module.exports, "uiClosedAuthEvent", ()=>$3b4d25437cc28513$export$fe5b1f066ca3365d);
    $parcel$export(module.exports, "screenAuthPopupEvent", ()=>$3b4d25437cc28513$export$69bb595db263d8ef);
    $parcel$export(module.exports, "uiRenderSuccessEvent", ()=>$3b4d25437cc28513$export$bd308326cf1076aa);
    $parcel$export(module.exports, "uiRenderFailedEvent", ()=>$3b4d25437cc28513$export$1543b6391f48a5e2);
    $parcel$export(module.exports, "uiHoverCardViewedEvent", ()=>$3b4d25437cc28513$export$e80a2f97cccab3b1);
    $parcel$export(module.exports, "uiHoverCardDismissedEvent", ()=>$3b4d25437cc28513$export$3d10c6f90bc461d3);
    $parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", ()=>$3b4d25437cc28513$export$ad3275d7dff50d21);
    $parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", ()=>$3b4d25437cc28513$export$925348ae8d2e0bf3);
    $parcel$export(module.exports, "chunkloadFailedEvent", ()=>$3b4d25437cc28513$export$2b6bbed3753f06f9);
    $parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", ()=>$3b4d25437cc28513$export$94c3643533642ab);
    $parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", ()=>$3b4d25437cc28513$export$18dfe458db0b743d);
    $parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", ()=>$3b4d25437cc28513$export$9a352e2e15b3de89);
    $parcel$export(module.exports, "uiServerActionClicked", ()=>$3b4d25437cc28513$export$a66dc699502b5d28);
    var $T540Y;
    var $5vDFA;
    const $3b4d25437cc28513$export$85183a312807388d = 'media';
    const $3b4d25437cc28513$export$a078c61943f9dbbe = {
        componentName: 'smart-cards',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    var $3b4d25437cc28513$export$72af824fa910c33e;
    (function(TrackQuickActionType) {
        TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    })($3b4d25437cc28513$export$72af824fa910c33e || ($3b4d25437cc28513$export$72af824fa910c33e = {}));
    var $3b4d25437cc28513$export$c89e475f7f7174c2;
    (function(TrackQuickActionFailureReason) {
        TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
        TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
        TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    })($3b4d25437cc28513$export$c89e475f7f7174c2 || ($3b4d25437cc28513$export$c89e475f7f7174c2 = {}));
    const $3b4d25437cc28513$export$bbd674aacb40a160 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'Follow',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
    };
    const $3b4d25437cc28513$export$baf70a532f8c6fa6 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
    };
    const $3b4d25437cc28513$var$uiActionSubjectIds = {
        DownloadAction: 'downloadDocument',
        PreviewAction: 'invokePreviewScreen',
        ViewAction: 'shortcutGoToLink',
        StatusAction: 'issueStatusUpdate'
    };
    class $3b4d25437cc28513$export$b91e0203b928470c {
        insertSmartLink(url, type, createAnalyticsEvent) {
            $3b4d25437cc28513$export$2a123f7ee48a122c({
                action: 'inserted',
                actionSubject: 'smartLink',
                eventType: 'track',
                attributes: {
                    type: type
                },
                nonPrivacySafeAttributes: {
                    domainName: url
                }
            }, createAnalyticsEvent);
        }
    }
    const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
        if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
    };
    const $3b4d25437cc28513$export$e2e1bab8375c3115 = (props)=>({
            action: 'resolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...props,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
            action: 'unresolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                id: id,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...definitionId ? {
                    definitionId: definitionId
                } : {},
                ...extensionKey ? {
                    extensionKey: extensionKey
                } : {},
                ...resourceType ? {
                    resourceType: resourceType
                } : {},
                ...destinationSubproduct ? {
                    destinationSubproduct: destinationSubproduct
                } : {},
                ...destinationProduct ? {
                    destinationProduct: destinationProduct
                } : {},
                ...location ? {
                    location: location
                } : {},
                reason: status,
                error: error ? {
                    message: error?.message,
                    kind: error?.kind,
                    type: error?.type
                } : undefined
            }
        });
    const $3b4d25437cc28513$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'resolved') : undefined;
        return {
            action: 'resolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                extensionKey: extensionKey,
                duration: measure?.duration
            }
        };
    };
    const $3b4d25437cc28513$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'errored') : undefined;
        return {
            action: 'unresolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                duration: measure?.duration,
                reason: reason
            }
        };
    };
    const $3b4d25437cc28513$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connectSucceeded',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
            action: 'connectFailed',
            actionSubject: 'smartLink',
            actionSubjectId: reason,
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                reason: reason,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connected',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
            action: 'authStarted',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                location: location
            }
        });
    const $3b4d25437cc28513$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'started',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'success',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'failed',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
            action: 'resolved',
            actionSubject: 'hoverCard',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                display: display
            }
        });
    const $3b4d25437cc28513$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'tryAnotherAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                isModifierKeyPressed: isModifierKeyPressed,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
            action: 'dwelled',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                dwellTime: dwellTime,
                dwellPercentVisible: dwellPercentVisible
            }
        });
    const $3b4d25437cc28513$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
            action: 'focused',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$var$uiActionSubjectIds[actionType],
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                display: display,
                actionType: actionType,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'closed',
            actionSubject: 'consentModal',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'consentModal',
            eventType: 'screen',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
            action: 'renderSuccess',
            actionSubject: 'smartLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display,
                canBeDatasource: canBeDatasource
            }
        });
    const $3b4d25437cc28513$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'smartLink',
            action: 'renderFailed',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'viewed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'dismissed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                hoverTime: hoverTime,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shortcutGoToLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod
            }
        });
    const $3b4d25437cc28513$export$925348ae8d2e0bf3 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'chunkLoadFailed',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$94c3643533642ab = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusLozenge',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$18dfe458db0b743d = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusListItem',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$9a352e2e15b3de89 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusOpenPreview',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
});
parcelRegister("T540Y", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkActionType", ()=>$171ae91e706973ef$export$6324b7946ad663e9);
    $parcel$export(module.exports, "InvokeError", ()=>$171ae91e706973ef$export$d4d72202bff63658);
    var $171ae91e706973ef$export$6324b7946ad663e9;
    (function(SmartLinkActionType) {
        SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
        SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
        SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
        SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    })($171ae91e706973ef$export$6324b7946ad663e9 || ($171ae91e706973ef$export$6324b7946ad663e9 = {}));
    class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
        constructor(message, errorCode){
            super(message);
            this.errorCode = errorCode;
        }
    }
});
parcelRegister("5vDFA", function(module, exports) {
    $parcel$export(module.exports, "clearMarks", ()=>$483ef2a5b4b04745$export$1a717feb4df1a945);
    $parcel$export(module.exports, "clearMeasures", ()=>$483ef2a5b4b04745$export$de42547d395c8271);
    $parcel$export(module.exports, "getMeasure", ()=>$483ef2a5b4b04745$export$d6e97a903ae9a3aa);
    $parcel$export(module.exports, "mark", ()=>$483ef2a5b4b04745$export$bf7f2fce5c1cf636);
    $parcel$export(module.exports, "create", ()=>$483ef2a5b4b04745$export$185802fd694ee1f5);
    const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
    const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
    const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
    const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
            marks.forEach((mark)=>performance.clearMarks(mark.name));
        }
    };
    const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
            measures.forEach((measure)=>performance.clearMeasures(measure.name));
        }
    };
    const $483ef2a5b4b04745$var$getMark = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            const marks = performance.getEntriesByName(name);
            if (marks.length > 0) return marks[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measures = performance.getEntriesByName(name);
            if (measures.length > 0) return measures[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            performance.mark(name);
        }
    };
    const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
            if (!measure) {
                const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
                const endMark = $483ef2a5b4b04745$var$getMark(id, status);
                if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
            }
        }
    };
});
parcelRegister("66xOO", function(module, exports) {
    $parcel$export(module.exports, "LinkAnalyticsContext", ()=>$a51765c35bf0b052$export$9458cdec663b9ff1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
        const displayCategory = display === 'url' ? 'link' : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: source,
                attributes: {
                    displayCategory: displayCategory,
                    display: display,
                    id: id
                }
            }
        }, children);
    };
});
parcelRegister("hTTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ef61591d3052acd$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $8RXs9;
    var $i5FdW;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $7zaVw;
    var $5joKY;
    const $6ef61591d3052acd$var$WarningModal = (props)=>{
        const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            testId: "link-with-safety-warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jgVsb")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).check_this_link))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7QSqG")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("5joKY")).breakWordsCss)
        }, url && unsafeLinkText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages).link_safety_warning_message,
            values: {
                unsafeLinkText: unsafeLinkText,
                a: ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                        href: url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, url)
            }
        }))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("juxqI")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).go_back)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "warning",
            onClick: onContinue,
            autoFocus: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).continue)))));
        return intl ? content : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, content);
    };
    var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6ef61591d3052acd$var$WarningModal, {
        enforceContext: false
    });
});
parcelRegister("7zaVw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a298b78183f16654$export$defe85febe8b728c);
    var $7VHMR;
    const $a298b78183f16654$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actions: {
            id: 'fabric.linking.actions',
            defaultMessage: 'Actions',
            description: ''
        },
        add_account: {
            id: 'fabric.linking.add_account',
            defaultMessage: 'Add account',
            description: 'Allows to add a new account'
        },
        ai_summarize: {
            id: 'fabric.linking.ai_summarize',
            defaultMessage: 'Summarize',
            description: 'Action to summarize link resource content with AI'
        },
        ai_summarized: {
            id: 'fabric.linking.ai_summarized',
            defaultMessage: 'Summarized by Atlassian Intelligence',
            description: 'Shown with the content summarised by AI.'
        },
        ai_summarized_abbreviation: {
            id: 'fabric.linking.ai_summarized_abbreviation',
            defaultMessage: 'Summarized by AI',
            description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
        },
        ai_summarized_info: {
            id: 'fabric.linking.ai_summarized_info',
            defaultMessage: 'Information quality may vary. <a>Learn more</a>',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarized_info_short: {
            id: 'fabric.linking.ai_summarized_info_short',
            defaultMessage: 'Content quality may vary',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarizing: {
            id: 'fabric.linking.ai_summarizing',
            defaultMessage: 'Atlassian Intelligence is working...',
            description: 'Shown when AI summary is summarising the link resource content.'
        },
        ai_summary_error_generic: {
            id: 'fabric.linking.ai_summary_error_generic',
            defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
            description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
        },
        ai_summary_error_acceptable_use_violation: {
            id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
            defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
            description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
        },
        ai_summary_error_hipaa_content_detected: {
            id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
            defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
            description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
        },
        ai_summary_error_exceeding_context_length_error: {
            id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
            defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
            description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
        },
        assigned_to: {
            id: 'fabric.linking.assigned_to',
            defaultMessage: 'Assigned to {context}',
            description: 'Indicates the person or entity that the resource is assigned to.'
        },
        automation_action_title: {
            id: 'fabric.linking.automation-action.title',
            defaultMessage: 'View automation rules...',
            description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
        },
        automation_action_icon_label: {
            id: 'fabric.linking.automation-action.icon.label',
            defaultMessage: 'Automation icon',
            description: 'The label for the automation icon inside of the button opening the automation menu.'
        },
        automation_action_tooltip: {
            id: 'fabric.linking.automation-action.tooltip',
            defaultMessage: 'Select an automation rule to run',
            description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
        },
        automation_action_confluence_page_modal_title: {
            id: 'fabric.linking.automation-action.confluence.page.modal.title',
            defaultMessage: 'Page automations',
            description: 'The title of the automation modal when the SmartLink is a Confluence page'
        },
        automation_action_confluence_page_modal_description: {
            id: 'fabric.linking.automation-action.confluence.page.modal.description',
            defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
            description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
        },
        cancel: {
            id: 'fabric.linking.cancel',
            defaultMessage: 'Cancel',
            description: 'cancel'
        },
        beta: {
            id: 'fabric.linking.beta',
            defaultMessage: 'Beta',
            description: 'Indicates a beta phase of the feature.'
        },
        cannot_connect: {
            id: 'fabric.linking.cannot_connect',
            defaultMessage: "Can't connect, try again",
            description: 'Error for when a provided link is not found.'
        },
        cannot_find_link: {
            id: 'fabric.linking.cannot_find_link',
            defaultMessage: "Can't find link",
            description: 'Error for when a provided link is not found.'
        },
        click_to_join: {
            id: 'fabric.linking.click_to_join',
            defaultMessage: 'Join {context}',
            description: 'Allows the user join the product or service immediately'
        },
        click_to_join_description: {
            id: 'fabric.linking.click_to_join_description',
            defaultMessage: "You've been approved, so you can join {context} right away.",
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        close: {
            id: 'fabric.linking.close',
            defaultMessage: 'Close',
            description: ''
        },
        check_this_link: {
            id: 'fabric.linking.check_this_link',
            defaultMessage: 'Check this link',
            description: 'Link safety warning modal header'
        },
        connect_to: {
            id: 'fabric.linking.connect_to',
            defaultMessage: 'Connect to {name}',
            description: 'Allows the user to connect with different types of external services'
        },
        connect_account_description: {
            id: 'fabric.linking.connect_account_description',
            defaultMessage: "We'll open a new page to help you connect your {name} account",
            description: 'Explains what will happen when the users connects to a new account'
        },
        connect_link_account: {
            id: 'fabric.linking.connect_link_account',
            defaultMessage: 'Connect to preview',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
        },
        connect_link_account_card: {
            id: 'fabric.linking.connect_link_account_card_view',
            defaultMessage: 'Connect',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_link_account_card_name: {
            id: 'fabric.linking.connect_link_account_card_view_name',
            defaultMessage: 'Connect your {context} account',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
        },
        connect_link_account_card_description: {
            id: 'fabric.linking.connect_link_account_card_view_description',
            defaultMessage: 'To show a preview of this link, connect your {context} account.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
        },
        connect_unauthorised_account_action: {
            id: 'fabric.linking.connect_unauthorised_account_action',
            defaultMessage: 'Connect to {context}',
            description: 'Shown on a button to connect user external account to their Atlassian account.'
        },
        connect_unauthorised_account_description: {
            id: 'fabric.linking.connect_unauthorised_account_description',
            defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_unauthorised_account_description_no_provider: {
            id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
            defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
        },
        continue: {
            id: 'fabric.linking.continue',
            defaultMessage: 'Continue',
            description: 'continue'
        },
        copy_url_to_clipboard: {
            id: 'fabric.linking.copy_url_to_clipboard',
            defaultMessage: 'Copy link',
            description: ''
        },
        copied_url_to_clipboard: {
            id: 'fabric.linking.copied_url_to_clipboard',
            defaultMessage: 'Copied!',
            description: 'Url has been copied to the clipboard'
        },
        could_not_load_link: {
            id: 'fabric.linking.couldnt_load_link',
            defaultMessage: "We couldn't load this link for an unknown reason.",
            description: 'Error case for card view - link could not be loaded.'
        },
        created_by: {
            id: 'fabric.linking.created_by',
            defaultMessage: 'Created by {context}',
            description: 'Indicates the person or entity that created the resource.'
        },
        created_on_relative: {
            id: 'fabric.linking.create_on_relative',
            defaultMessage: 'Created {context}',
            description: 'Indicated when entity was created (relative form)'
        },
        created_on_absolute: {
            id: 'fabric.linking.create_on_absolute',
            defaultMessage: 'Created on {context}',
            description: 'Indicated when entity was created (absolute form)'
        },
        delete: {
            id: 'fabric.linking.delete',
            defaultMessage: 'Delete',
            description: 'Allow a user to delete a link'
        },
        download: {
            id: 'fabric.linking.download',
            defaultMessage: 'Download',
            description: ''
        },
        download_description: {
            id: 'fabric.linking.download_description',
            defaultMessage: 'Download this file into your local storage',
            description: 'Description on what Download does'
        },
        download_file: {
            id: 'fabric.linking.download_file',
            defaultMessage: 'Download file',
            description: 'Allow a user to download a file'
        },
        ai_summary_action: {
            id: 'fabric.linking.ai_summary_action',
            defaultMessage: 'Summarize with AI',
            description: 'Allow a user to summarize a link'
        },
        ai_summary_action_description: {
            id: 'fabric.linking.ai_summary_action_description',
            defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
            description: 'Description of what the summarize link with AI action does'
        },
        copy_summary_action: {
            id: 'fabric.linking.copy_summary_action',
            defaultMessage: 'Copy summary',
            description: 'Allow a user to copy a generated summary'
        },
        copy_summary_action_description: {
            id: 'fabric.linking.copy_summary_action_description',
            defaultMessage: 'Copy summary',
            description: 'Description of what the copy summary AI action does'
        },
        copied_summary_action_description: {
            id: 'fabric.linking.copied_summary_action_description',
            defaultMessage: 'Copied summary to clipboard',
            description: 'Confirmation to the user that the summry has been copied'
        },
        edit: {
            id: 'fabric.linking.edit',
            defaultMessage: 'Edit',
            description: 'Allow a user to edit a link'
        },
        follow: {
            id: 'fabric.linking.follow',
            defaultMessage: 'Follow',
            description: 'Click to follow a project.'
        },
        follow_project_description: {
            id: 'fabric.linking.follow_project_description',
            defaultMessage: 'Follow to get notifications on this project',
            description: 'Description on what Follow does'
        },
        follow_project: {
            id: 'fabric.linking.follow_project',
            defaultMessage: 'Follow project',
            description: 'Click to follow a project.'
        },
        follow_project_error: {
            id: 'fabric.linking.follow_project_error',
            defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas project'
        },
        follow_goal_description: {
            id: 'fabric.linking.follow_goal_description',
            defaultMessage: 'Follow this goal to get notifications on updates',
            description: 'Description on what Follow does'
        },
        follow_goal: {
            id: 'fabric.linking.follow_goal',
            defaultMessage: 'Follow goal',
            description: 'Click to follow a project.'
        },
        follow_goal_error: {
            id: 'fabric.linking.follow_goal_error',
            defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas goal'
        },
        go_back: {
            id: 'fabric.linking.go_back',
            defaultMessage: 'Go back',
            description: 'go back'
        },
        invalid_permissions: {
            id: 'fabric.linking.invalid_permissions',
            defaultMessage: 'Restricted content',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        invalid_permissions_description: {
            id: 'fabric.linking.invalid_permissions_description',
            defaultMessage: "You'll need to request access or try a different account to view this preview.",
            description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
        },
        join_to_view: {
            id: 'fabric.linking.join_to_view',
            defaultMessage: 'Join {context} to view this issue',
            description: 'Allows the user join the product or service immediately'
        },
        learn_more_about_smart_links: {
            id: 'fabric.linking.learn_more_about_smart_links',
            defaultMessage: 'Learn more about Smart Links.',
            description: 'An anchor link to redirect user to a page about Smart Links.'
        },
        learn_more_about_connecting_account: {
            id: 'fabric.linking.learn_more_about_connecting_account',
            defaultMessage: 'Learn more about connecting your account to Atlassian products.',
            description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
        },
        loading: {
            id: 'fabric.linking.loading',
            defaultMessage: 'Loading...',
            description: 'Indicates an element on a page is loading.'
        },
        modified_by: {
            id: 'fabric.linking.updated_by',
            defaultMessage: 'Modified by {context}',
            description: 'Indicates the person or entity that modified the resource.'
        },
        modified_on_relative: {
            id: 'fabric.linking.modified_on_relative',
            defaultMessage: 'Updated {context}',
            description: 'Indicated when entity was modified (relative form)'
        },
        modified_on_absolute: {
            id: 'fabric.linking.modified_on_absolute',
            defaultMessage: 'Updated on {context}',
            description: 'Indicated when entity was modified (absolute form)'
        },
        more_actions: {
            id: 'fabric.linking.more_actions',
            defaultMessage: 'More actions',
            description: 'Allows the users to see more link actions'
        },
        open_issue_in_jira: {
            id: 'fabric.linking.open_issue_in_jira',
            defaultMessage: 'Open issue in Jira',
            description: 'Click to open link in Jira'
        },
        open_link_in_a_new_tab: {
            id: 'fabric.linking.open_link_in_a_new_tab',
            defaultMessage: 'Open link in a new tab',
            description: 'Click to open link in a new tab'
        },
        owned_by: {
            id: 'fabric.linking.owned_by',
            defaultMessage: 'Owned by {context}',
            description: 'Indicates the person or entity that owns or maintains the resource.'
        },
        preview_description: {
            id: 'fabric.linking.preview_description',
            defaultMessage: 'Open a full screen preview of this link',
            description: 'Description on what Preview does'
        },
        preview_improved: {
            id: 'fabric.linking.preview_improved',
            defaultMessage: 'Open preview',
            description: 'Click to view a richer view of your content, without needing to navigate to it.'
        },
        preview_close: {
            id: 'fabric.linking.preview_close',
            defaultMessage: 'Close preview',
            description: 'Click to close embed preview modal.'
        },
        preview_max_size: {
            id: 'fabric.linking.preview_max_size',
            defaultMessage: 'View full screen',
            description: 'Click to increase embed preview modal size to a maximum viewing size.'
        },
        preview_min_size: {
            id: 'fabric.linking.preview_min_size',
            defaultMessage: 'Close full screen',
            description: 'Click to decrease embed preview modal size to a minimum viewing size.'
        },
        priority_blocker: {
            id: 'fabric.linking.priority_blocker',
            defaultMessage: 'Blocker',
            description: 'Indicated priority as blocker'
        },
        priority_critical: {
            id: 'fabric.linking.priority_critical',
            defaultMessage: 'Critical',
            description: 'Indicated priority as critical'
        },
        priority_high: {
            id: 'fabric.linking.priority_high',
            defaultMessage: 'High',
            description: 'Indicated priority as high'
        },
        priority_highest: {
            id: 'fabric.linking.priority_highest',
            defaultMessage: 'Highest',
            description: 'Indicated priority as highest'
        },
        priority_low: {
            id: 'fabric.linking.priority_low',
            defaultMessage: 'Low',
            description: 'Indicated priority as low'
        },
        priority_lowest: {
            id: 'fabric.linking.priority_lowest',
            defaultMessage: 'Lowest',
            description: 'Indicated priority as lowest'
        },
        priority_major: {
            id: 'fabric.linking.priority_major',
            defaultMessage: 'Major',
            description: 'Indicated priority as major'
        },
        priority_medium: {
            id: 'fabric.linking.priority_medium',
            defaultMessage: 'Medium',
            description: 'Indicated priority as medium'
        },
        priority_minor: {
            id: 'fabric.linking.priority_minor',
            defaultMessage: 'Minor',
            description: 'Indicated priority as minor'
        },
        priority_trivial: {
            id: 'fabric.linking.priority_trivial',
            defaultMessage: 'Trivial',
            description: 'Indicated priority as trivial'
        },
        priority_undefined: {
            id: 'fabric.linking.priority_undefined',
            defaultMessage: 'Undefined',
            description: 'Indicated priority as unknown'
        },
        forbidden_access: {
            id: 'fabric.linking.forbidden_access',
            defaultMessage: 'Your access is forbidden',
            description: 'Shown when a user does not have access to a resource behind the link.'
        },
        pending_request: {
            id: 'fabric.linking.pending_request',
            defaultMessage: 'Your access request is pending',
            description: 'Shown when a user has requested an access but status is pending.'
        },
        read_time: {
            id: 'fabric.linking.read_time',
            defaultMessage: '{context} min read',
            description: 'Estimated time to read this resource'
        },
        restricted_link: {
            id: 'fabric.linking.restricted_link',
            defaultMessage: 'Restricted link, try another account',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        request_access_to_view: {
            id: 'fabric.linking.request_access_to_view',
            defaultMessage: 'Request access to {context} to view this issue',
            description: 'Allows the user to request access to a product or service'
        },
        request_denied: {
            id: 'fabric.linking.request_denied',
            defaultMessage: 'Your access request was denied',
            description: 'The user had request access but the request was denied by a product or service'
        },
        retry: {
            id: 'fabric.linking.retry',
            defaultMessage: 'Retry',
            description: 'Allows user to perform an action again'
        },
        save: {
            id: 'fabric.linking.save',
            defaultMessage: 'Save',
            description: 'Just the "save" word'
        },
        sent_on_relative: {
            id: 'fabric.linking.sent_on_relative',
            defaultMessage: 'Sent {context}',
            description: 'Indicated when entity was sent (relative form)'
        },
        sent_on_absolute: {
            id: 'fabric.linking.sent_on_absolute',
            defaultMessage: 'Sent on {context}',
            description: 'Indicated when entity was sent (absolute form)'
        },
        status_change_load_error: {
            id: 'fabric.linking.status_change_load_error',
            defaultMessage: "We couldn\u2019t load the statuses and transitions",
            description: 'Informs the user that the loading of status transitions failed'
        },
        status_change_permission_error: {
            id: 'fabric.linking.status_change_permission_error',
            defaultMessage: "You don\u2019t have permission to transition this issue. ",
            description: 'Informs the user that they do not have enough permissions to update a status'
        },
        status_change_update_error: {
            id: 'fabric.linking.status_change_update_error',
            defaultMessage: "We couldn\u2019t update the status",
            description: "Occurs when a user tries to update an issue's status but fails to do so"
        },
        try_again: {
            id: 'fabric.linking.try_again',
            defaultMessage: 'Try again',
            description: 'Allow the user to try an action again'
        },
        try_another_account: {
            id: 'fabric.linking.try_another_account',
            defaultMessage: 'Try another account',
            description: 'Allows the user to try an action again with a different account'
        },
        link_safety_warning_message: {
            id: 'fabric.linking.link_safety_warning_message',
            defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
            description: 'Link safety check warning message'
        },
        unauthorised_account_description: {
            id: 'fabric.linking.unauthorised_account_description',
            defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_description_no_provider: {
            id: 'fabric.linking.unauthorised_account_description_no_provider',
            defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_name: {
            id: 'fabric.linking.unauthorised_account_name',
            defaultMessage: "We can't display private pages from {context}",
            description: 'Shown when a user does not have access to a link.'
        },
        unauthorised_account_name_no_provider: {
            id: 'fabric.linking.unauthorised_account_name_no_provider',
            defaultMessage: "We can't display private pages",
            description: 'Shown when a user does not have access to a link.'
        },
        unassigned: {
            id: 'fabric.linking.unassigned',
            defaultMessage: 'Unassigned',
            description: 'Shown as a tooltip text for a default unassigned fallback avatar'
        },
        unfollow: {
            id: 'fabric.linking.unfollow',
            defaultMessage: 'Unfollow',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_description: {
            id: 'fabric.linking.unfollow_project_description',
            defaultMessage: 'Unfollow to stop receiving project notifications',
            description: 'Description on what Unfollow does'
        },
        unfollow_project: {
            id: 'fabric.linking.unfollow_project',
            defaultMessage: 'Unfollow project',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_error: {
            id: 'fabric.linking.unfollow_project_error',
            defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
        },
        unfollow_goal_description: {
            id: 'fabric.linking.unfollow_goal_description',
            defaultMessage: 'Unfollow to stop receiving notifications for this goal',
            description: 'Description on what Unfollow does'
        },
        unfollow_goal: {
            id: 'fabric.linking.unfollow_goal',
            defaultMessage: 'Unfollow goal',
            description: 'Click to unfollow a project.'
        },
        unfollow_goal_error: {
            id: 'fabric.linking.unfollow_goal_error',
            defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
        },
        unlink_account: {
            id: 'fabric.linking.unlink_account',
            defaultMessage: 'Unlink Account',
            description: 'Allows to remove a connected account from the user'
        },
        view: {
            id: 'fabric.linking.view',
            defaultMessage: 'View',
            description: 'Go through to a piece of content to view it in its original context.'
        },
        viewIn: {
            id: 'fabric.linking.srclink',
            defaultMessage: 'View in',
            description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
        },
        viewOriginal: {
            id: 'fabric.linking.srclinkunknown',
            defaultMessage: 'View Original',
            description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
        },
        default_no_access_title: {
            id: 'fabric.linking.no_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they dont have access to certain content'
        },
        direct_access_title: {
            id: 'fabric.linking.direct_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access_description: {
            id: 'fabric.linking.direct_access_description',
            defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access: {
            id: 'fabric.linking.direct_access',
            defaultMessage: 'Join now',
            description: 'Allows the user join the product or service immediately'
        },
        request_access_description: {
            id: 'fabric.linking.request_access_description',
            defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
            description: 'Informs the user to request access to a product by talking to the website administrator'
        },
        request_access: {
            id: 'fabric.linking.request_access',
            defaultMessage: 'Request access',
            description: 'Allows the user to request access to a product or service'
        },
        request_access_pending_title: {
            id: 'fabric.linking.request_access_pending_title',
            defaultMessage: 'Access to {product} is pending',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_access_pending_description: {
            id: 'fabric.linking.request_access_pending_description',
            defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
            description: 'Informs the user that their request to view this content is pending website administrator approval'
        },
        request_access_pending: {
            id: 'fabric.linking.request_access_pending',
            defaultMessage: 'Pending approval',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_denied_description: {
            id: 'fabric.linking.request_denied_description',
            defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
            description: 'Informs the user that their request to view this content was denied'
        },
        access_exists_description: {
            id: 'fabric.linking.access_exists_description',
            defaultMessage: 'Request access to view this content from {hostname}.',
            description: 'Informs the user to contact the website administrator to request access to a product'
        },
        not_found_description: {
            id: 'fabric.linking.not_found_description',
            defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
            description: 'Error case for when a provided item is not found within the list of items'
        },
        not_found_title: {
            id: 'fabric.linking.not_found_title',
            defaultMessage: "We can't show you this {product} page",
            description: 'Error case for when a provided link is not found'
        },
        forbidden_title: {
            id: 'fabric.linking.forbidden_title',
            defaultMessage: "You don't have access to this content",
            description: 'Informs the user that they do not have access to the linked content.'
        },
        forbidden_description: {
            id: 'fabric.linking.forbidden_description',
            defaultMessage: 'Contact your admin to request access to {hostname}.',
            description: 'Informs the user that they must contact the site administrator for access.'
        },
        related_work_items_not_found: {
            id: 'fabric.linking.related_work_items_not_found',
            defaultMessage: 'This link is not mentioned anywhere else.',
            description: 'Informs the user that there are no related resources for a given url'
        },
        last_mentioned_in: {
            id: 'fabric.linking.last_mentioned_in',
            defaultMessage: 'Last mentioned in',
            description: 'Informs the user about where the resource was last mentioned in'
        },
        related: {
            id: 'fabric.linking.related',
            defaultMessage: 'Related',
            description: 'Informs the user about related resources'
        },
        generic_error_message: {
            id: 'fabric.linking.generic_error_message',
            defaultMessage: 'An error occurred',
            description: 'A generic error message to the user'
        },
        related_links_modal_title: {
            id: 'fabric.linking.related_links_modal_title',
            defaultMessage: 'Recent links',
            description: 'Shown as the title for the related links modal'
        },
        related_links_view_related_urls: {
            id: 'fabric.linking.related_links_view_related_urls.nonfinal',
            defaultMessage: 'View recent links...',
            description: 'Action to view related links to the given resource'
        },
        related_links_found_in: {
            id: 'fabric.linking.related_links_found_in',
            defaultMessage: 'Found In',
            description: 'Informs the user of the resources are found in the given url'
        },
        related_links_not_found: {
            id: 'fabric.linking.related_links_not_found',
            defaultMessage: "We didn't find any links to show here.",
            description: 'Informs the user that there are no related resources for the given url'
        },
        related_links_includes_links_to: {
            id: 'fabric.linking.related_links_includes_links_to',
            defaultMessage: 'Includes Links To',
            description: 'Informs the user of the resources the url links to'
        },
        related_links_modal_error_header: {
            id: 'fabric.linking.related_links_modal_error_header',
            defaultMessage: 'Something went wrong',
            description: 'Title for related links error'
        },
        related_links_modal_error_message: {
            id: 'fabric.linking.related_links_modal_error_message',
            defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
            description: 'Informs the user that there was a problem loading related links'
        },
        related_links_modal_unavailable_header: {
            id: 'fabric.linking.related_links_modal_unavailable_header',
            defaultMessage: 'No recent links',
            description: 'Title for related links being unavailable'
        },
        related_links_modal_unavailable_message: {
            id: 'fabric.linking.related_links_modal_unavailable_message',
            defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
            description: 'Informs the user that related links were not found but may be available in the future'
        }
    });
});
parcelRegister("5joKY", function(module, exports) {
    $parcel$export(module.exports, "breakWordsCss", ()=>$b66aa972276b3574$export$e4dda5b86d39ace5);
    function $b66aa972276b3574$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b66aa972276b3574$export$e4dda5b86d39ace5 = {
        name: "1ujvzzx",
        styles: "white-space:pre-line;word-break:break-all"
    };
});
parcelRegister("cI2hq", function(module, exports) {
    $parcel$export(module.exports, "useLinkWarningModal", ()=>$afd5dc953340b04b$export$32b76c003683c2ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $57Lhk;
    var $fzJZi;
    const $afd5dc953340b04b$var$toUrl = (url, base)=>{
        try {
            return new URL(url, base);
        } catch  {
            return undefined;
        }
    };
    const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
        const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
        const [url, setUrl] = (0, $5uXOq.useState)(null);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const sendWarningModalViewedEvent = ()=>{
            createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'linkSafetyWarningModal',
                eventType: 'screen',
                name: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
        const sendContinueClickedEvent = ()=>{
            createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'linkSafetyWarningModalContinue',
                eventType: 'ui',
                screen: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
        const isLinkSafe = (event, href)=>{
            if (!href) return true;
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            const normalisedUrlFromLinkText = (0, (0, parcelRequire("57Lhk")).normalizeUrl)(linkText);
            if (!normalisedUrlFromLinkText) return true;
            const anchorLinkRegex = new RegExp(/^#/im);
            const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
            const isAnchorLink = anchorLinkRegex.test(href);
            if (isAnchorLink || isLinkTextAnchorLink) return true;
            const relativeLinkRegex = new RegExp(/^\//im);
            const isRelativeHrefLink = relativeLinkRegex.test(href);
            if (isRelativeHrefLink) return true;
            const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
            const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
            if (!hrefUrl || !linkTextUrl) return true;
            const httpProtocols = [
                'http:',
                'https:'
            ];
            let areProtocolsEquivalent;
            if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
                const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
                areProtocolsEquivalent = noUserNameAndPassword;
            } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
            const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
            if (!areEquivalentLinks) return false;
            return true;
        };
        const showSafetyWarningModal = (event, href)=>{
            event.preventDefault();
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            setUnsafeLinkText(linkText);
            href && setUrl(href);
            setIsOpen(true);
            sendWarningModalViewedEvent();
        };
        const onClose = ()=>{
            setIsOpen(false);
            setUnsafeLinkText(null);
            setUrl(null);
        };
        const onContinue = ()=>{
            onClose();
            sendContinueClickedEvent();
            url && window.open(url, '_blank', 'noopener noreferrer');
        };
        return {
            isLinkSafe: isLinkSafe,
            isOpen: isOpen,
            onClose: onClose,
            onContinue: onContinue,
            showSafetyWarningModal: showSafetyWarningModal,
            unsafeLinkText: unsafeLinkText,
            url: url
        };
    };
});
parcelRegister("57Lhk", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$8f5c48f3a9939b0b$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "normalizeUrl", ()=>$8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
    var $e2gHg = parcelRequire("e2gHg");
    const $8f5c48f3a9939b0b$var$linkify = (0, ($parcel$interopDefault($e2gHg)))();
    $8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
    $8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
    $8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
    const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
    $8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
    const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
        /^https?:\/\/[^\s]*$/im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\/[^\s]*$/im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:[^\s]*$/im,
        /^facetime:[^\s]*$/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^foo:/im,
        /^#/im
    ];
    const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
        const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
        return match && match.url || null;
    };
    const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
        if (!str) return null;
        let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
        if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
        return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
    };
    const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
        const matches = [];
        if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
        if (!url) return '';
        const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
        if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
        return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
    }
});
parcelRegister("e2gHg", function(module, exports) {
    'use strict';
    function $a37e3434b26d3f31$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $a37e3434b26d3f31$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $a37e3434b26d3f31$var$isString(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
    }
    function $a37e3434b26d3f31$var$isObject(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
    }
    function $a37e3434b26d3f31$var$isRegExp(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
    }
    function $a37e3434b26d3f31$var$isFunction(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
    }
    function $a37e3434b26d3f31$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $a37e3434b26d3f31$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $a37e3434b26d3f31$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $a37e3434b26d3f31$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $a37e3434b26d3f31$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $a37e3434b26d3f31$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $a37e3434b26d3f31$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $a37e3434b26d3f31$var$compile(self) {
        var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($a37e3434b26d3f31$var$isObject(val)) {
                if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
                else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($a37e3434b26d3f31$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $a37e3434b26d3f31$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($a37e3434b26d3f31$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
        $a37e3434b26d3f31$var$resetScanCache(self);
    }
    function $a37e3434b26d3f31$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $a37e3434b26d3f31$var$createMatch(self, shift) {
        var match = new $a37e3434b26d3f31$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $a37e3434b26d3f31$var$compile(this);
    }
    $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $a37e3434b26d3f31$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $a37e3434b26d3f31$var$LinkifyIt;
});
parcelRegister("d5qnw", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + ';(?!' + re.src_ZCc + ').|' + '\\!+(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("f14yv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31acef3336a9ea7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            style: {
                textDecoration: 'line-through'
            }
        }, props.children));
    }
});
parcelRegister("eVxaj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3356ea5acdd73a43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("strong", props.dataAttributes, props.children);
    }
});
parcelRegister("gUlHA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c264e87eca3a3d05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $c264e87eca3a3d05$var$isSub = (type)=>{
        return type === 'sub';
    };
    function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
        if ($c264e87eca3a3d05$var$isSub(props.type)) return (0, ($parcel$interopDefault($5uXOq))).createElement("sub", props.dataAttributes, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("sup", props.dataAttributes, props.children);
    }
});
parcelRegister("c15YI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8904856eee164f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $lKA8N;
    var $hxoiH;
    function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("lKA8N")).hexToEditorTextPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = (0, (0, parcelRequire("lKA8N")).hexToEditorTextPaletteColor)(props.color) || props.color;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-text-custom-color": props.color,
            className: "fabric-text-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("lKA8N", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$965e3166a7c18c5e$export$9c2f408d391feb93);
    function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
        return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
    }
    const $965e3166a7c18c5e$export$57fa5089caad992 = {
        ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
        ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
        ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
        ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
        ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
        ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
        ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
        ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
        ['#006644']: "var(--ds-text-accent-green, #006644)",
        ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
        ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
        ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
        ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
        ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
        ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
        ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
        ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
        ['#403294']: "var(--ds-text-accent-purple, #403294)",
        ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
        ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
        ['#172B4D']: "var(--ds-text, #172B4D)"
    };
});
parcelRegister("koUAb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d139f843714a421$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $7dikW;
    var $hxoiH;
    function $7d139f843714a421$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("7dikW")).hexToEditorTextBackgroundPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-background-custom-color": props.color,
            className: "fabric-background-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("7dikW", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);
    const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
        ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    };
    function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
        return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
    }
});
parcelRegister("eESZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f8016b636a69d58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("u", props.dataAttributes, props.children);
    }
});
parcelRegister("95Yll", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56f1f5242a99941b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $4ceoy;
    var $eOOFp;
    var $iHYdz;
    var $VSDnB;
    const $56f1f5242a99941b$var$wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0`,
        marginLeft: '50%',
        transform: 'translateX(-50%)'
    });
    function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $56f1f5242a99941b$var$wrapperStyles,
                "data-mode": props.mode,
                style: {
                    width: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(props.mode, width)
                },
                className: "fabric-editor-breakout-mark fabric-editor-block-mark"
            }, props.children));
    }
});
parcelRegister("lbdLJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1b7090399d1e727$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $aeGrH;
    const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
        const styles = props['data-align'] ? (0, (0, parcelRequire("f8Sb3")).css)("text-align:", (0, (0, parcelRequire("aeGrH")).alignmentPositionMap)[props['data-align']], ";") : '';
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles,
            ...props
        }, props.children));
    };
    function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($d1b7090399d1e727$var$MarkWrapper, {
            className: "fabric-editor-block-mark fabric-editor-alignment",
            "data-align": props.align
        }, props.children);
    }
});
parcelRegister("9xZ5X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef073b46e3c6008$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "fabric-editor-block-mark fabric-editor-indentation-mark",
            "data-level": props.level
        }, props.children);
    }
});
parcelRegister("g5EjF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1398622ac205fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("acz8Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04eeed03d14d0e78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("8DQfy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009dff5e97619965$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $009dff5e97619965$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
            "data-mark-type": "dataConsumer",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("g9yqu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ac6eff929f5b91e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-localId": props.localId,
            "data-name": props.name,
            "data-mark-type": "fragment",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("itF0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f200b42408cc462$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
        const borderColor = props.color ?? '';
        const borderSize = props.size ?? 0;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-color": borderColor,
            "data-size": borderSize,
            "data-mark-type": "border"
        }, props.children);
    }
});
parcelRegister("6EeUE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efbb661461ca3406$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { reference: reference, children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": reference
            }, children);
        }
    }
});
parcelRegister("eQNWQ", function(module, exports) {
    $parcel$export(module.exports, "getMarksByOrder", ()=>$7bbfc2d34b0938dd$export$99a33ed044c278ae);
    $parcel$export(module.exports, "isSameMark", ()=>$7bbfc2d34b0938dd$export$b1304404bdc42b7a);
    $parcel$export(module.exports, "getValidDocument", ()=>$7bbfc2d34b0938dd$export$fb80336a7e408cb3);
    $parcel$export(module.exports, "getValidNode", ()=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd);
    var $9IGaJ;
    var $kc0v7;
    var $iZOJ9;
    var $bFtEE;
    var $kOFhM;
    var $VSDnB;
    const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
        FINAL: 'final',
        STAGE_0: 'stage0'
    };
    const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
        'fragment',
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'confluenceInlineComment',
        'annotation',
        'dataConsumer'
    ];
    const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
        return type === 'sub' || type === 'sup';
    };
    const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
        return [
            ...marks
        ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
    };
    const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
        if (!mark || !otherMark) return false;
        return mark.eq(otherMark);
    };
    const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
        if (node.type === 'doc') {
            node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
            return node;
        }
        return null;
    };
    const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
        return nodes.map((node)=>(0, (0, parcelRequire("kc0v7")).inlineNodes).has(node.type) ? {
                type: 'paragraph',
                content: [
                    node
                ]
            } : node);
    };
    const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
    };
    const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
    const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
    const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
    const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const output = [];
        let isPrevLeafNode = false;
        for(let i = 0; i < node.content.length; i++){
            const childNode = node.content[i];
            const isLeafNode = !(childNode.content && childNode.content.length);
            if (i > 0) {
                if (isPrevLeafNode) output.push({
                    type: 'text',
                    text: ' '
                });
                else output.push({
                    type: 'hardBreak'
                });
            }
            if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
            else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
            isPrevLeafNode = isLeafNode;
        }
        return output;
    };
    const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
        const { attrs: attrs = {}, content: content, text: text, type: type } = node;
        if (!content || !content.length) {
            const unknownInlineNode = {
                type: 'text',
                text: text || attrs.text || `[${type}]`
            };
            const { textUrl: textUrl } = attrs;
            if (textUrl && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(textUrl)) unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl
                    }
                }
            ];
            return unknownInlineNode;
        }
        return {
            type: 'unknownBlock',
            content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
        };
    };
    const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
        if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
            const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
            if (validMark) acc.push(validMark);
            return acc;
        }, []);
        return marks;
    };
    const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
        let { content: content } = originalNode;
        const node = {
            attrs: attrs,
            marks: marks,
            text: text,
            type: type
        };
        if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
        if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
        if (type) switch(type){
            case 'doc':
                {
                    const { version: version } = originalNode;
                    if (version && content && content.length) return {
                        type: type,
                        content: content
                    };
                    break;
                }
            case 'codeBlock':
                if (content) content = content.reduce((acc, val)=>{
                    if (val.type === 'text') acc.push({
                        type: val.type,
                        text: val.text
                    });
                    return acc;
                }, []);
                if (attrs && attrs.language) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
                return {
                    type: type,
                    content: content,
                    marks: marks
                };
            case 'date':
                if (attrs && attrs.timestamp) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'status':
                if (attrs && attrs.text && attrs.color) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'emoji':
                if (attrs && attrs.shortName) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'inlineExtension':
            case 'extension':
                if (attrs && attrs.extensionType && attrs.extensionKey) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'inlineCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'blockCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'embedCard':
                if (attrs && (attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'bodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'multiBodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'extensionFrame':
                if (content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'hardBreak':
                return {
                    type: type
                };
            case 'caption':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaInline':
                {
                    let mediaId = '';
                    let mediaCollection = [];
                    if (attrs) {
                        const { id: id, collection: collection } = attrs;
                        mediaId = id;
                        mediaCollection = collection;
                    }
                    if (mediaId && mediaCollection) return {
                        type: type,
                        attrs: attrs,
                        marks: marks
                    };
                    break;
                }
            case 'media':
                {
                    let mediaId = '';
                    let mediaType = '';
                    let mediaCollection = [];
                    let mediaUrl = '';
                    if (attrs) {
                        const { id: id, collection: collection, type: type, url: url } = attrs;
                        mediaId = id;
                        mediaType = type;
                        mediaCollection = collection;
                        mediaUrl = url;
                    }
                    if (mediaType === 'external' && !!mediaUrl) {
                        const mediaAttrs = {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height
                        };
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    } else if (mediaId && mediaType) {
                        const mediaAttrs = {
                            type: mediaType,
                            id: mediaId,
                            collection: mediaCollection
                        };
                        if (attrs.width) mediaAttrs.width = attrs.width;
                        if (attrs.height) mediaAttrs.height = attrs.height;
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    }
                    break;
                }
            case 'mediaGroup':
                if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaSingle':
                {
                    const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                    const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                    if (containsJustMedia || containsMediaAndCaption) return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                    };
                    break;
                }
            case 'mention':
                {
                    let mentionText = '';
                    let mentionId;
                    let mentionAccess;
                    if (attrs) {
                        const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                        mentionText = text || displayName;
                        mentionId = id;
                        mentionAccess = accessLevel;
                    }
                    if (!mentionText) mentionText = text || '@unknown';
                    if (mentionText && mentionId) {
                        const mentionNode = {
                            type: type,
                            attrs: {
                                id: mentionId,
                                text: mentionText,
                                accessLevel: ''
                            },
                            ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                                marks: marks
                            } : {}
                        };
                        if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                        return mentionNode;
                    }
                    break;
                }
            case 'paragraph':
                if (adfStage === 'stage0') {
                    let paragraphNode = {
                        type: type,
                        content: content || []
                    };
                    if (attrs && attrs.localId) paragraphNode.attrs = {
                        localId: attrs.localId
                    };
                    if (marks) paragraphNode.marks = [
                        ...marks
                    ];
                    return paragraphNode;
                }
                return marks ? {
                    type: type,
                    content: content || [],
                    marks: marks
                } : {
                    type: type,
                    content: content || []
                };
            case 'rule':
                return {
                    type: type
                };
            case 'text':
                {
                    let { marks: marks } = node;
                    if (text) return marks ? {
                        type: type,
                        text: text,
                        marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                    } : {
                        type: type,
                        text: text
                    };
                    break;
                }
            case 'heading':
                if (attrs) {
                    const { level: level } = attrs;
                    const between = (x, a, b)=>x >= a && x <= b;
                    if (level && between(level, 1, 6)) {
                        if (adfStage === 'stage0') {
                            let headingNode = {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level
                                }
                            };
                            if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                            if (marks) headingNode.marks = [
                                ...marks
                            ];
                            return headingNode;
                        }
                        return marks ? {
                            type: type,
                            content: content,
                            marks: marks,
                            attrs: {
                                level: level
                            }
                        } : {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                    }
                }
                break;
            case 'bulletList':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'orderedList':
                if (content) return {
                    type: type,
                    content: content,
                    attrs: {
                        order: attrs && attrs.order
                    }
                };
                break;
            case 'listItem':
                if (content) return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
                };
                break;
            case 'blockquote':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'panel':
                if (attrs && content) {
                    const { panelType: panelType } = attrs;
                    if (Object.values((0, (0, parcelRequire("bFtEE")).PanelType)).includes(panelType)) return {
                        type: type,
                        attrs: attrs,
                        content: content
                    };
                }
                break;
            case 'layoutSection':
                if (content) return {
                    type: type,
                    marks: marks,
                    content: content
                };
                break;
            case 'layoutColumn':
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'decisionList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'decisionItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'DECIDED'
                    }
                };
            case 'taskList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'taskItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'TODO'
                    }
                };
            case 'table':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                    if (adfStage === 'stage0') return {
                        type: type,
                        content: content,
                        attrs: {
                            ...attrs,
                            localId: attrs?.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                            width: attrs?.width || null
                        }
                    };
                    return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'tableRow':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                    type: type,
                    content: content
                };
                break;
            case 'tableCell':
            case 'tableHeader':
                if (content) {
                    const cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                        if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                        if (attrs.background) cellAttrs.background = attrs.background;
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                    }
                    return {
                        type: type,
                        content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined
                    };
                }
                break;
            case 'image':
                if (attrs && attrs.src) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'placeholder':
                if (attrs && typeof attrs.text !== 'undefined') return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'expand':
            case 'nestedExpand':
                return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
        }
        return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    };
    const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
        const { attrs: attrs, type: type } = mark;
        if (type) switch(type){
            case 'code':
                return {
                    type: type
                };
            case 'em':
                return {
                    type: type
                };
            case 'link':
                if (attrs) {
                    const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                    let linkHref = href || url;
                    if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                    const linkAttrs = {
                        href: linkHref
                    };
                    if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    if (linkHref && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(linkHref)) return {
                        type: type,
                        attrs: linkAttrs
                    };
                }
                break;
            case 'strike':
                return {
                    type: type
                };
            case 'strong':
                return {
                    type: type
                };
            case 'subsup':
                if (attrs && attrs['type']) {
                    const subSupType = attrs['type'];
                    if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                        type: type,
                        attrs: {
                            type: subSupType
                        }
                    };
                }
                break;
            case 'textColor':
                if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'underline':
                return {
                    type: type
                };
            case 'annotation':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'backgroundColor':
                if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
        }
        if (adfStage === 'stage0') switch(type){
            case 'confluenceInlineComment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'dataConsumer':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'fragment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
        }
        return null;
    };
});
parcelRegister("kc0v7", function(module, exports) {
    $parcel$export(module.exports, "inlineNodes", ()=>$eb355120b38723aa$export$b1f729c6af6f2a6e);
    var $ctVrM;
    const $eb355120b38723aa$var$typedNodes = (0, parcelRequire("ctVrM"));
    const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));
});
parcelRegister("ctVrM", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("7kC9H")).expand);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>(parcelRequire("7kC9H")).expandWithNestedExpand);
    $parcel$export(module.exports, "expandToJSON", ()=>(parcelRequire("7kC9H")).toJSON);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>(parcelRequire("6bbHe")).confluenceJiraIssue);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>(parcelRequire("5y0tR")).confluenceUnsupportedBlock);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>(parcelRequire("bd7A9")).confluenceUnsupportedInline);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("xjCuM")).doc);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("aXBFx")).blockquote);
    $parcel$export(module.exports, "blockquoteWithList", ()=>(parcelRequire("aXBFx")).blockquoteWithList);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>(parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("kjhhp")).bulletList);
    $parcel$export(module.exports, "bulletListSelector", ()=>(parcelRequire("kjhhp")).bulletListSelector);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("8vlrc")).codeBlock);
    $parcel$export(module.exports, "codeBlockToJSON", ()=>(parcelRequire("8vlrc")).toJSON);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("jnMM2")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("lRTZM")).heading);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("M4hHz")).rule);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("dwptW")).orderedList);
    $parcel$export(module.exports, "orderedListSelector", ()=>(parcelRequire("dwptW")).orderedListSelector);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>(parcelRequire("dwptW")).orderedListWithOrder);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("abme3")).paragraph);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("7DoMR")).emoji);
    $parcel$export(module.exports, "image", ()=>(parcelRequire("7lRBh")).image);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("g7Cky")).mention);
    $parcel$export(module.exports, "mentionToJSON", ()=>(parcelRequire("g7Cky")).toJSON);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("2FIVU")).listItem);
    $parcel$export(module.exports, "listItemWithTask", ()=>(parcelRequire("2FIVU")).listItemWithTask);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>(parcelRequire("2FIVU")).listItemWithDecisionStage0);
    $parcel$export(module.exports, "extendedPanel", ()=>(parcelRequire("bFtEE")).extendedPanel);
    $parcel$export(module.exports, "PanelType", ()=>(parcelRequire("bFtEE")).PanelType);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>(parcelRequire("bFtEE")).panelWithBlockquoteStage0);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("3DR6L")).text);
    $parcel$export(module.exports, "unknownBlock", ()=>(parcelRequire("9X587")).default);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5JeV5")).caption);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("7agO8")).media);
    $parcel$export(module.exports, "copyPrivateMediaAttributes", ()=>(parcelRequire("7agO8")).copyPrivateAttributes);
    $parcel$export(module.exports, "mediaToJSON", ()=>(parcelRequire("7agO8")).toJSON);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("92lix")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("7Xgp3")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("bIGZ7")).mediaSingle);
    $parcel$export(module.exports, "mediaSingleSpec", ()=>(parcelRequire("bIGZ7")).mediaSingleSpec);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>(parcelRequire("bIGZ7")).mediaSingleWithCaption);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>(parcelRequire("bIGZ7")).mediaSingleWithWidthType);
    $parcel$export(module.exports, "mediaSingleFull", ()=>(parcelRequire("bIGZ7")).mediaSingleFull);
    $parcel$export(module.exports, "mediaSingleToJSON", ()=>(parcelRequire("bIGZ7")).toJSON);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("9UDEr")).table);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>(parcelRequire("9UDEr")).tableWithNestedTable);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>(parcelRequire("9UDEr")).tableRowWithNestedTable);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>(parcelRequire("9UDEr")).tableCellWithNestedTable);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>(parcelRequire("9UDEr")).tableHeaderWithNestedTable);
    $parcel$export(module.exports, "tableStage0", ()=>(parcelRequire("9UDEr")).tableStage0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>(parcelRequire("9UDEr")).tableWithCustomWidth);
    $parcel$export(module.exports, "tableToJSON", ()=>(parcelRequire("9UDEr")).tableToJSON);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("9UDEr")).tableCell);
    $parcel$export(module.exports, "toJSONTableCell", ()=>(parcelRequire("9UDEr")).toJSONTableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("9UDEr")).tableHeader);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>(parcelRequire("9UDEr")).toJSONTableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("9UDEr")).tableRow);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>(parcelRequire("9UDEr")).tableBackgroundColorPalette);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>(parcelRequire("9UDEr")).tableBackgroundBorderColor);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>(parcelRequire("9UDEr")).tableBackgroundColorNames);
    $parcel$export(module.exports, "getCellAttrs", ()=>(parcelRequire("9UDEr")).getCellAttrs);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>(parcelRequire("9UDEr")).getCellDomAttrs);
    $parcel$export(module.exports, "tablePrefixSelector", ()=>(parcelRequire("9UDEr")).tablePrefixSelector);
    $parcel$export(module.exports, "tableCellSelector", ()=>(parcelRequire("9UDEr")).tableCellSelector);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>(parcelRequire("9UDEr")).tableHeaderSelector);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>(parcelRequire("9UDEr")).tableCellContentWrapperSelector);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>(parcelRequire("9UDEr")).tableCellContentDomSelector);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("8gSD8")).decisionList);
    $parcel$export(module.exports, "decisionListSelector", ()=>(parcelRequire("8gSD8")).decisionListSelector);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("Khvpb")).decisionItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("43mJF")).taskList);
    $parcel$export(module.exports, "taskListSelector", ()=>(parcelRequire("43mJF")).taskListSelector);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("iThOL")).taskItem);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("b2VmY")).date);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("dgJoa")).placeholder);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("gZoER")).layoutSection);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>(parcelRequire("gZoER")).layoutSectionWithSingleColumn);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("4EbxI")).layoutColumn);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("cCBEe")).inlineCard);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("21PS7")).blockCard);
    $parcel$export(module.exports, "unsupportedBlock", ()=>(parcelRequire("d1d6m")).unsupportedBlock);
    $parcel$export(module.exports, "unsupportedInline", ()=>(parcelRequire("6kr5W")).unsupportedInline);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("18bvk")).status);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("dx5eC")).nestedExpand);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("kshOv")).embedCard);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("hhN5g")).extension);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5BOuQ")).inlineExtension);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5AxYU")).bodiedExtension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("47jug")).extensionFrame);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("47jug")).multiBodiedExtension);
    var $7kC9H;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $xjCuM;
    var $aXBFx;
    var $kjhhp;
    var $8vlrc;
    var $jnMM2;
    var $lRTZM;
    var $M4hHz;
    var $dwptW;
    var $abme3;
    var $7DoMR;
    var $7lRBh;
    var $g7Cky;
    var $2FIVU;
    var $bFtEE;
    var $3DR6L;
    var $9X587;
    var $5JeV5;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $9UDEr;
    var $8gSD8;
    var $Khvpb;
    var $43mJF;
    var $iThOL;
    var $b2VmY;
    var $dgJoa;
    var $gZoER;
    var $4EbxI;
    var $cCBEe;
    var $21PS7;
    var $d1d6m;
    var $6kr5W;
    var $18bvk;
    var $dx5eC;
    var $kshOv;
    var $hhN5g;
    var $5BOuQ;
    var $5AxYU;
    var $47jug;
});
parcelRegister("bzwTW", function(module, exports) {
    $parcel$export(module.exports, "insideBreakoutLayout", ()=>$99a90b85f857f7e6$export$d7bc71cca336a3b);
    $parcel$export(module.exports, "insideBlockNode", ()=>$99a90b85f857f7e6$export$42ddc573eb5a7b43);
    $parcel$export(module.exports, "insideMultiBodiedExtension", ()=>$99a90b85f857f7e6$export$9f1e9347b0411934);
    const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
    const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
    const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
    const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
        const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
        const blockNodeNames = [
            expand,
            nestedExpand,
            layoutColumn
        ].filter((node)=>Boolean(node)).map((node)=>node.name);
        return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
    };
    const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
        const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
        return path.some((n)=>n.type === multiBodiedExtension);
    };
});
parcelRegister("12yAL", function(module, exports) {
    $parcel$export(module.exports, "renderDocument", ()=>$af6d4930d9141440$export$59a54f98b9753d5c);
    var $8QpSo;
    var $kOFhM;
    var $eQNWQ;
    var $d54NZ;
    var $4IuOY;
    var $gkwXh;
    var $knXBU;
    var $1cjf7;
    var $4FBRr;
    var $aSk3Q;
    var $kgV4b;
    var $VSDnB;
    const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
    const $af6d4930d9141440$var$withStopwatch = (cb)=>{
        const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const output = cb();
        const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const time = endTime - startTime;
        return {
            output: output,
            time: time
        };
    };
    const $af6d4930d9141440$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
        let result;
        if (useSpecBasedValidator) {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("4FBRr")).transformMediaLinkMarks)(doc);
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).MEDIA_LINK_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            result = (0, (0, parcelRequire("4IuOY")).validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
        } else result = (0, (0, parcelRequire("eQNWQ")).getValidDocument)(doc, schema, adfStage);
        if (!result) return result;
        if (result.type === 'doc' && useSpecBasedValidator) {
            if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
                type: 'paragraph',
                content: []
            });
            if (!result.version) result.version = 1;
        }
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) try {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("aSk3Q")).transformNestedTablesIncomingDocument)(result);
            if (isTransformed) {
                dispatchAnalyticsEvent?.({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                result = transformedAdf;
            }
        } catch (e) {
            dispatchAnalyticsEvent?.({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorStack: 'Failed to transform one or more nested tables in the document'
                }
            });
        }
        return result;
    };
    const $af6d4930d9141440$var$memoValidation = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
        const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
        const result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
        return result;
    });
    const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
        if (docA === docB) return true;
        if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
        if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
        return JSON.stringify(docA) === JSON.stringify(docB);
    };
    const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
        return serializer.serializeFragment(doc.content);
    };
    const $af6d4930d9141440$var$memoSerializeFragment = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
        const [newSerializer, newDoc] = newArgs;
        const [oldSerializer, oldDoc] = lastArgs;
        return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
    });
    const $af6d4930d9141440$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
        const pmNode = schema.nodeFromJSON(doc);
        try {
            pmNode.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorStack: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        }
        return pmNode;
    };
    const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
        const [newSchema, newDoc] = newArgs;
        const [oldSchema, oldDoc] = lastArgs;
        return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
    });
    const $af6d4930d9141440$export$59a54f98b9753d5c = (doc, serializer, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats)=>{
        const stat = {
            sanitizeTime: 0
        };
        const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
        });
        stat.sanitizeTime = sanitizeTime;
        if (!validDoc) return {
            stat: stat,
            result: null
        };
        const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
        });
        stat.buildTreeTime = buildTreeTime;
        const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
        });
        stat.serializeTime = serializeTime;
        if (dispatchAnalyticsEvent && useSpecBasedValidator) {
            (0, (0, parcelRequire("d54NZ")).findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
            if (unsupportedContentLevelsTracking?.enabled) {
                const documentData = {
                    doc: validDoc,
                    appearance: appearance,
                    rendererId: rendererId
                };
                (0, (0, parcelRequire("1cjf7")).trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
            }
        }
        if (includeNodesCountInStats) stat.nodesCount = (0, (0, parcelRequire("kgV4b")).countNodes)(doc);
        return {
            result: result,
            stat: stat,
            pmDoc: node
        };
    };
});
parcelRegister("4IuOY", function(module, exports) {
    $parcel$export(module.exports, "validateADFEntity", ()=>$2c0bbb60cfee2804$export$884cfad20dece33e);
    var $905ey;
    var $gkwXh;
    var $d54NZ;
    const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
    const $2c0bbb60cfee2804$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
        return (entity, error, options)=>{
            return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
        };
    };
    const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
        if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
        if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
        if (options.isNodeAttribute) {
            const entityType = entity && entity.type ? entity.type : undefined;
            return {
                type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
                attrs: {
                    type: {
                        nodeType: entityType
                    },
                    unsupported: error.meta
                }
            };
        }
        if (entity && marks.indexOf(entity.type) > -1) return;
        if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
            type: 'paragraph',
            content: []
        };
        if (error.code === 'INVALID_CONTENT_LENGTH') {
            if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
            else if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        }
        if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        return entity;
    };
    function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
        const meta = error.meta;
        if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
            return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
        });
        if (meta.type === 'minimum') {
            if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
            entity.content = entity.content.filter((x)=>!!x).map((child)=>{
                return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
            });
        }
        return entity;
    }
    function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
        if (!dispatchAnalyticsEvent) return;
        (0, (0, parcelRequire("d54NZ")).fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
            type: entity.type || '',
            ancestry: entity.ancestorHierarchy || '',
            parentType: entity.parentType || '',
            marks: entity.marks || [],
            attrs: entity.attrs || {}
        }, error.code);
    }
    const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
        const nodes = Object.keys(schema.nodes);
        const marks = Object.keys(schema.marks);
        const validate = (0, (0, parcelRequire("905ey")).validator)(nodes, marks, {
            allowPrivateAttributes: true
        });
        const emptyDoc = {
            type: 'doc',
            content: []
        };
        const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
        return entity;
    };
    function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
        let unsupportedNodeType;
        switch(type){
            case 'inline':
                unsupportedNodeType = 'unsupportedInline';
                break;
            case 'mark':
                unsupportedNodeType = 'unsupportedMark';
                break;
            default:
                unsupportedNodeType = 'unsupportedBlock';
        }
        return {
            type: unsupportedNodeType,
            attrs: {
                originalValue: originalValue
            }
        };
    }
});
parcelRegister("905ey", function(module, exports) {
    $parcel$export(module.exports, "validator", ()=>$e861220f24467804$export$956325f45c5d174a);
    var $gsiq1;
    var $iiazc;
    var $1H4Aw;
    function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
        if (spec.props && spec.props.marks) {
            const { items: items, ...rest } = spec.props.marks;
            return {
                ...spec,
                props: {
                    ...spec.props,
                    marks: {
                        ...rest,
                        items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                            fn(items)
                        ] : [
                            []
                        ]
                    }
                }
            };
        } else return spec;
    }
    const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
            const result = predicate(key, obj[key], obj);
            acc[result ? 0 : 1].push(key);
            return acc;
        }, [
            [],
            []
        ]);
    function $e861220f24467804$var$createSpec(nodes, marks) {
        return Object.keys((0, parcelRequire("gsiq1"))).reduce((newSpecs, k)=>{
            const spec = {
                ...(0, parcelRequire("gsiq1"))[k]
            };
            if (spec.props) {
                spec.props = {
                    ...spec.props
                };
                if (spec.props.content) {
                    if ((0, (0, parcelRequire("iiazc")).isString)(spec.props.content)) spec.props.content = (0, parcelRequire("gsiq1"))[spec.props.content];
                    if (Array.isArray(spec.props.content)) spec.props.content = {
                        type: 'array',
                        items: (spec.props.content || []).map((arr)=>arr.items)
                    };
                    else spec.props.content = {
                        ...spec.props.content
                    };
                    spec.props.content.items = spec.props.content.items.map((item)=>(0, (0, parcelRequire("iiazc")).isString)(item) ? Array.isArray((0, parcelRequire("gsiq1"))[item]) ? (0, parcelRequire("gsiq1"))[item] : [
                            item
                        ] : item).map((item)=>item.map((subItem)=>Array.isArray((0, parcelRequire("gsiq1"))[subItem]) ? (0, parcelRequire("gsiq1"))[subItem] : (0, (0, parcelRequire("iiazc")).isString)(subItem) ? subItem : [
                                'text',
                                subItem
                            ]).filter((subItem)=>{
                            if (nodes) {
                                if (Array.isArray(subItem)) {
                                    const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                    if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                    return isMainNodeSupported;
                                }
                                return nodes.indexOf(subItem) > -1;
                            }
                            return true;
                        }).map((subItem)=>Array.isArray(subItem) && marks ? [
                                subItem[0],
                                $e861220f24467804$var$mapMarksItems(subItem[1])
                            ] : subItem));
                }
            }
            newSpecs[k] = spec;
            return newSpecs;
        }, {});
    }
    function $e861220f24467804$var$getOptionsForType(type, list) {
        if (!list) return {};
        for(let i = 0, len = list.length; i < len; i++){
            const spec = list[i];
            let name = spec;
            let options = {};
            if (Array.isArray(spec)) [name, options] = spec;
            if (name === type) return options;
        }
        return false;
    }
    const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
        return !!spec.props;
    };
    function $e861220f24467804$export$66c739158ef99a42(spec, value) {
        if (!(0, (0, parcelRequire("iiazc")).isDefined)(value)) return !!spec.optional;
        if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
            const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>$e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
            return invalidKeys.length === 0;
        }
        if (!(0, (0, parcelRequire("iiazc")).isDefined)(spec.type)) return !!spec.optional;
        switch(spec.type){
            case 'boolean':
                return (0, (0, parcelRequire("iiazc")).isBoolean)(value);
            case 'number':
                return (0, (0, parcelRequire("iiazc")).isNumber)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'integer':
                return (0, (0, parcelRequire("iiazc")).isInteger)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'string':
                const validatorFnPassed = (rule)=>typeof value === 'string' && (0, (0, parcelRequire("iiazc")).isDefined)((0, (0, parcelRequire("1H4Aw")).validatorFnMap)[rule]) && (0, (0, parcelRequire("1H4Aw")).validatorFnMap)[rule](value);
                return (0, (0, parcelRequire("iiazc")).isString)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
            case 'object':
                return (0, (0, parcelRequire("iiazc")).isPlainObject)(value);
            case 'array':
                if (Array.isArray(value)) {
                    const isTuple = !!spec.isTupleLike;
                    const { minItems: minItems, maxItems: maxItems } = spec;
                    if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                    if (isTuple) {
                        const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                        return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                    } else return value.every((valueItem)=>spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
                }
                return false;
            case 'enum':
                return (0, (0, parcelRequire("iiazc")).isString)(value) && spec.values.indexOf(value) > -1;
        }
    }
    const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
    const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
        if (spec && spec.props && spec.props.content) {
            const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
            return {
                allowUnsupportedBlock: allowUnsupportedBlock,
                allowUnsupportedInline: allowUnsupportedInline
            };
        }
        return {};
    };
    const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
        const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message
        }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
    };
    const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
        const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...mark
        }, {
            code: errorCode,
            message: message,
            meta: mark
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: true
        });
    };
    const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            type: entity.type
        }, {
            code: errorCode,
            message: message,
            meta: invalidAttributes
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: false,
            isNodeAttribute: true
        });
    };
    function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
        const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
        const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
        const validate = (entity, errorCallback, allowed, parentSpec)=>{
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        };
        const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
            const { type: type } = entity;
            let newEntity = {
                ...entity
            };
            const err = (code, msg, meta)=>{
                const message = $e861220f24467804$var$errorMessageFor(type, msg);
                if (errorCallback) return {
                    valid: false,
                    entity: errorCallback(newEntity, {
                        code: code,
                        message: message,
                        meta: meta
                    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
                };
                else throw new Error(message);
            };
            if (type) {
                const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
                if (typeOptions === false) return isMark ? {
                    valid: false
                } : err('INVALID_TYPE', 'type not allowed here');
                const spec = validatorSpecs[type];
                if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
                const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
                if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
            } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
            return {
                valid: true,
                entity: newEntity
            };
        };
        return validate;
        function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
            let validationResult;
            if (validator.props && validator.props.marks) {
                const marksSet = allowedMarksFor(validator);
                const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
                validationResult = {
                    valid: true,
                    entity: newEntity,
                    marksValidationOutput: marksValidationResult
                };
            } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
            return validationResult;
        }
        function validatorFor(spec, typeOptions) {
            return {
                ...spec,
                ...typeOptions,
                ...spec.props ? {
                    props: {
                        ...spec.props,
                        ...typeOptions['props'] || {}
                    }
                } : {}
            };
        }
        function marksAfterValidation(entity, errorCallback, marksSet, validator) {
            return entity.marks ? entity.marks.map((mark)=>{
                const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
                if (mode === 'strict' && isAKnownMark) {
                    const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                    const finalMark = finalResult.entity;
                    if (finalMark) return {
                        valid: true,
                        originalMark: mark,
                        newMark: finalMark
                    };
                    else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                        valid: false,
                        originalMark: mark,
                        errorCode: finalResult.marksValidationOutput[0].errorCode,
                        message: finalResult.marksValidationOutput[0].message
                    };
                    else return {
                        valid: false,
                        originalMark: mark,
                        errorCode: 'INVALID_TYPE'
                    };
                } else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_CONTENT'
                };
            }) : [];
        }
        function allowedMarksFor(validator) {
            const { items: items } = validator.props.marks;
            const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
            return marksSet;
        }
        function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
            const errorCode = 'REDUNDANT_MARKS';
            const currentMarks = prevEntity.marks || [];
            const newMarks = currentMarks.map((mark)=>{
                const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
                if (isUnsupportedNodeAttributeMark) return mark;
                return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
            });
            if (newMarks.length) {
                newEntity.marks = newMarks;
                return {
                    valid: true,
                    entity: newEntity
                };
            } else return err('REDUNDANT_MARKS', 'redundant marks', {
                marks: Object.keys(currentMarks)
            });
        }
        function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.required) {
                if (!validatorSpec.required.every((prop)=>(0, (0, parcelRequire("iiazc")).isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
            }
            return result;
        }
        function textPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.text) {
                if ((0, (0, parcelRequire("iiazc")).isDefined)(prevEntity.text) && !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
            }
            return result;
        }
        function contentLengthValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.content && prevEntity.content) {
                const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
                const length = prevEntity.content.length;
                if ((0, (0, parcelRequire("iiazc")).isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                    length: length,
                    requiredLength: minItems,
                    type: 'minimum'
                });
                else if ((0, (0, parcelRequire("iiazc")).isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                    length: length,
                    requiredLength: maxItems,
                    type: 'maximum'
                });
            }
            return result;
        }
        function invalidAttributesFor(validatorSpec, prevEntity) {
            let invalidAttrs = [];
            let validatorAttrs = {};
            if (validatorSpec.props && validatorSpec.props.attrs) {
                const attrOptions = (0, (0, parcelRequire("iiazc")).makeArray)(validatorSpec.props.attrs);
                for(let i = 0, length = attrOptions.length; i < length; ++i){
                    const attrOption = attrOptions[i];
                    if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                        const valueToValidate = prevEntity.attrs[key];
                        return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                    });
                    validatorAttrs = attrOption;
                    if (!invalidAttrs.length) break;
                }
            }
            return {
                invalidAttrs: invalidAttrs,
                validatorAttrs: validatorAttrs
            };
        }
        function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
            const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
            if (prevEntity.attrs) {
                if (!validatorSpecAllowsAttributes) {
                    if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                    const attrs = Object.keys(prevEntity.attrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
                }
                const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
                if (hasUnsupportedAttrs) {
                    if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
                }
            }
            return {
                valid: true,
                entity: prevEntity
            };
        }
        function validateAttributes(validatorSpec, prevEntity, attributes) {
            const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
            const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
            const validatorAttrs = invalidAttributesResult.validatorAttrs;
            const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
            const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
            const hasRedundantAttrs = redundantAttrs.length > 0;
            const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
            return {
                hasUnsupportedAttrs: hasUnsupportedAttrs,
                invalidAttrs: invalidAttrs,
                redundantAttrs: redundantAttrs
            };
        }
        function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
            const attr = invalidAttrs.concat(redundantAttrs);
            let result = {
                valid: true,
                entity: prevEntity
            };
            const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const errorCode = 'UNSUPPORTED_ATTRIBUTES';
            newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
            result = {
                valid: true,
                entity: newEntity
            };
            return result;
        }
        function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
            let errorCode = 'INVALID_ATTRIBUTES';
            let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const hasRedundantAttrs = redundantAttrs.length;
            const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
            if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
                errorCode = 'REDUNDANT_ATTRIBUTES';
                message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
            }
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
            const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
            const errorCode = 'REDUNDANT_ATTRIBUTES';
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
            let invalidValues = {};
            for(let invalidAttr in invalidAttrs){
                invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
                if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
            }
            const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
            const finalEntity = {
                ...newEntity
            };
            if (finalEntity.marks) {
                if (!unsupportedNodeAttributeValues) return finalEntity.marks;
                const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
                if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
                else finalEntity.marks.push(unsupportedNodeAttributeValues);
                return finalEntity.marks;
            } else return [
                unsupportedNodeAttributeValues
            ];
        }
        function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>(0, (0, parcelRequire("iiazc")).isDefined)(validatorSpec.props[k]));
            if (redundantProps.length) {
                if (mode === 'loose') {
                    newEntity = {
                        type: type
                    };
                    requiredProps.reduce((acc, p)=>(0, (0, parcelRequire("iiazc")).copy)(prevEntity, acc, p), newEntity);
                } else {
                    if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                        props: redundantProps
                    });
                }
            }
            return result;
        }
        function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
            let specBasedValidationResult = {
                hasValidated: false
            };
            const validatorSpec = validatorFor(spec, typeOptions);
            if (!validatorSpec) return specBasedValidationResult;
            const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!requiredPropertyValidatonResult.valid) return {
                hasValidated: true,
                result: requiredPropertyValidatonResult
            };
            if (!validatorSpec.props) {
                const props = Object.keys(prevEntity);
                if (props.length > 1) return {
                    hasValidated: true,
                    result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                        props: props
                    })
                };
                return specBasedValidationResult;
            }
            const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!textPropertyValidationResult.valid) return {
                hasValidated: true,
                result: textPropertyValidationResult
            };
            const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
            if (!contentLengthValidationResult.valid) return {
                hasValidated: true,
                result: contentLengthValidationResult
            };
            const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
                const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
                return isOptional || (0, (0, parcelRequire("iiazc")).isDefined)(prevEntity[k]);
            });
            if (missingProps.length) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'required prop missing', {
                    props: missingProps
                })
            };
            const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
            if (!attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            if (isMark && attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
            if (!extraPropsValidationResult.valid) return {
                hasValidated: true,
                result: extraPropsValidationResult
            };
            if (validatorSpec.props.content) {
                const contentValidatorSpec = validatorSpec.props.content;
                if (prevEntity.content) {
                    const validateChildNode = (child, index)=>{
                        if (child === undefined) return child;
                        const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                            let marksAreValid = true;
                            if (childEntity && childEntity.marks && marksValidationOutput) {
                                const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                                const finalMarks = marksValidationOutput.map((mr)=>{
                                    if (mr.valid) return mr.newMark;
                                    else {
                                        if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                        return;
                                    }
                                }).filter(Boolean);
                                if (finalMarks.length) childEntity.marks = finalMarks;
                                else {
                                    delete childEntity.marks;
                                    marksAreValid = false;
                                }
                            }
                            return {
                                valid: marksAreValid,
                                entity: childEntity
                            };
                        };
                        const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                        if (hasMultipleCombinationOfContentAllowed) {
                            const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, (0, parcelRequire("iiazc")).makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                            const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                            return entity;
                        }
                        const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some((spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                        if (allowedSpecsForEntity.length) {
                            if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                            const maybeArray = (0, (0, parcelRequire("iiazc")).makeArray)(allowedSpecsForEntity[0]);
                            const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                            if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                            let firstError;
                            let firstChild;
                            for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                                const allowedValueForCurrentSpec = [
                                    allowedSpecsForChild[i]
                                ];
                                const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                                if (valid) {
                                    const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                    const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                    const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                    if (marksAreValid && !unsupportedMarks.length) return entity;
                                    else firstChild = firstChild || newChildEntity;
                                } else firstChild = firstChild || newChildEntity;
                            } catch (error) {
                                firstError = firstError || error;
                            }
                            if (!errorCallback) throw firstError;
                            else return firstChild;
                        } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                    };
                    newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
                } else if (!contentValidatorSpec.optional) return {
                    hasValidated: true,
                    result: err('MISSING_PROPERTIES', 'missing `content` prop')
                };
            }
            if (prevEntity.marks) return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
            return specBasedValidationResult;
        }
    }
});
parcelRegister("gsiq1", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>(parcelRequire("5fjVx")).alignment);
    $parcel$export(module.exports, "annotation", ()=>(parcelRequire("5fjVx")).annotation);
    $parcel$export(module.exports, "backgroundColor", ()=>(parcelRequire("5fjVx")).backgroundColor);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("5fjVx")).blockCard);
    $parcel$export(module.exports, "block_content", ()=>(parcelRequire("5fjVx")).block_content);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("5fjVx")).blockquote);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5fjVx")).bodiedExtension);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>(parcelRequire("5fjVx")).bodiedExtension_with_marks);
    $parcel$export(module.exports, "border", ()=>(parcelRequire("5fjVx")).border);
    $parcel$export(module.exports, "breakout", ()=>(parcelRequire("5fjVx")).breakout);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("5fjVx")).bulletList);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5fjVx")).caption);
    $parcel$export(module.exports, "code", ()=>(parcelRequire("5fjVx")).code);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("5fjVx")).codeBlock);
    $parcel$export(module.exports, "codeBlock_with_marks", ()=>(parcelRequire("5fjVx")).codeBlock_with_marks);
    $parcel$export(module.exports, "codeBlock_with_no_marks", ()=>(parcelRequire("5fjVx")).codeBlock_with_no_marks);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>(parcelRequire("5fjVx")).confluenceInlineComment);
    $parcel$export(module.exports, "dataConsumer", ()=>(parcelRequire("5fjVx")).dataConsumer);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("5fjVx")).date);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("5fjVx")).decisionItem);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("5fjVx")).decisionList);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("5fjVx")).doc);
    $parcel$export(module.exports, "em", ()=>(parcelRequire("5fjVx")).em);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("5fjVx")).embedCard);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("5fjVx")).emoji);
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("5fjVx")).expand);
    $parcel$export(module.exports, "expand_with_breakout_mark", ()=>(parcelRequire("5fjVx")).expand_with_breakout_mark);
    $parcel$export(module.exports, "expand_with_no_mark", ()=>(parcelRequire("5fjVx")).expand_with_no_mark);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("5fjVx")).extension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("5fjVx")).extensionFrame);
    $parcel$export(module.exports, "extension_with_marks", ()=>(parcelRequire("5fjVx")).extension_with_marks);
    $parcel$export(module.exports, "fragment", ()=>(parcelRequire("5fjVx")).fragment);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("5fjVx")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("5fjVx")).heading);
    $parcel$export(module.exports, "heading_with_alignment", ()=>(parcelRequire("5fjVx")).heading_with_alignment);
    $parcel$export(module.exports, "heading_with_indentation", ()=>(parcelRequire("5fjVx")).heading_with_indentation);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>(parcelRequire("5fjVx")).heading_with_no_marks);
    $parcel$export(module.exports, "indentation", ()=>(parcelRequire("5fjVx")).indentation);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("5fjVx")).inlineCard);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5fjVx")).inlineExtension);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>(parcelRequire("5fjVx")).inlineExtension_with_marks);
    $parcel$export(module.exports, "inline_content", ()=>(parcelRequire("5fjVx")).inline_content);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("5fjVx")).layoutColumn);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("5fjVx")).layoutSection);
    $parcel$export(module.exports, "layoutSection_full", ()=>(parcelRequire("5fjVx")).layoutSection_full);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>(parcelRequire("5fjVx")).layoutSection_with_single_column);
    $parcel$export(module.exports, "link", ()=>(parcelRequire("5fjVx")).link);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("5fjVx")).listItem);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("5fjVx")).media);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("5fjVx")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("5fjVx")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("5fjVx")).mediaSingle);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>(parcelRequire("5fjVx")).mediaSingle_caption);
    $parcel$export(module.exports, "mediaSingle_full", ()=>(parcelRequire("5fjVx")).mediaSingle_full);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("5fjVx")).mention);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("5fjVx")).multiBodiedExtension);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("5fjVx")).nestedExpand);
    $parcel$export(module.exports, "nestedExpand_content", ()=>(parcelRequire("5fjVx")).nestedExpand_content);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>(parcelRequire("5fjVx")).nestedExpand_with_no_marks);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>(parcelRequire("5fjVx")).non_nestable_block_content);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("5fjVx")).orderedList);
    $parcel$export(module.exports, "panel", ()=>(parcelRequire("5fjVx")).panel);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>(parcelRequire("5fjVx")).panel_with_nested_blockquote);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("5fjVx")).paragraph);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>(parcelRequire("5fjVx")).paragraph_with_alignment);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>(parcelRequire("5fjVx")).paragraph_with_indentation);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>(parcelRequire("5fjVx")).paragraph_with_no_marks);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("5fjVx")).placeholder);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("5fjVx")).rule);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("5fjVx")).status);
    $parcel$export(module.exports, "strike", ()=>(parcelRequire("5fjVx")).strike);
    $parcel$export(module.exports, "strong", ()=>(parcelRequire("5fjVx")).strong);
    $parcel$export(module.exports, "subsup", ()=>(parcelRequire("5fjVx")).subsup);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("5fjVx")).table);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("5fjVx")).tableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("5fjVx")).tableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("5fjVx")).tableRow);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("5fjVx")).taskItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("5fjVx")).taskList);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("5fjVx")).text);
    $parcel$export(module.exports, "textColor", ()=>(parcelRequire("5fjVx")).textColor);
    $parcel$export(module.exports, "text_code_inline", ()=>(parcelRequire("5fjVx")).text_code_inline);
    $parcel$export(module.exports, "text_formatted", ()=>(parcelRequire("5fjVx")).text_formatted);
    $parcel$export(module.exports, "text_link_inline", ()=>(parcelRequire("5fjVx")).text_link_inline);
    $parcel$export(module.exports, "underline", ()=>(parcelRequire("5fjVx")).underline);
    var $5fjVx;
});
parcelRegister("5fjVx", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "text", ()=>$3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
    $parcel$export(module.exports, "codeBlock", ()=>$3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "codeBlock_with_marks", ()=>$3d1dcf8b9eccd1a7$export$e6744655acd74d98);
    $parcel$export(module.exports, "codeBlock_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$6e3671492ca8dabf);
    $parcel$export(module.exports, "mediaSingle", ()=>$3d1dcf8b9eccd1a7$export$969fe3781ca15058);
    $parcel$export(module.exports, "media", ()=>$3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "link", ()=>$3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "annotation", ()=>$3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "border", ()=>$3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
    $parcel$export(module.exports, "hardBreak", ()=>$3d1dcf8b9eccd1a7$export$371da9dd35aba193);
    $parcel$export(module.exports, "mention", ()=>$3d1dcf8b9eccd1a7$export$db83999c14438df4);
    $parcel$export(module.exports, "emoji", ()=>$3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "date", ()=>$3d1dcf8b9eccd1a7$export$324d90190a8b822a);
    $parcel$export(module.exports, "placeholder", ()=>$3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "inlineCard", ()=>$3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "status", ()=>$3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "text_formatted", ()=>$3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
    $parcel$export(module.exports, "text_code_inline", ()=>$3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
    $parcel$export(module.exports, "em", ()=>$3d1dcf8b9eccd1a7$export$c63c6f932822f543);
    $parcel$export(module.exports, "strong", ()=>$3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
    $parcel$export(module.exports, "strike", ()=>$3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
    $parcel$export(module.exports, "subsup", ()=>$3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
    $parcel$export(module.exports, "underline", ()=>$3d1dcf8b9eccd1a7$export$425327af25286e5e);
    $parcel$export(module.exports, "textColor", ()=>$3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "backgroundColor", ()=>$3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "code", ()=>$3d1dcf8b9eccd1a7$export$6565f9f03506010b);
    $parcel$export(module.exports, "caption", ()=>$3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>$3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
    $parcel$export(module.exports, "mediaSingle_full", ()=>$3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
    $parcel$export(module.exports, "text_link_inline", ()=>$3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
    $parcel$export(module.exports, "inlineExtension", ()=>$3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$e37f10815f36843d);
    $parcel$export(module.exports, "mediaInline", ()=>$3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
    $parcel$export(module.exports, "inline_content", ()=>$3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
    $parcel$export(module.exports, "paragraph", ()=>$3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
    $parcel$export(module.exports, "taskItem", ()=>$3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "decisionItem", ()=>$3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "bulletList", ()=>$3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "listItem", ()=>$3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "orderedList", ()=>$3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
    $parcel$export(module.exports, "mediaGroup", ()=>$3d1dcf8b9eccd1a7$export$2855e964765eac9);
    $parcel$export(module.exports, "blockquote", ()=>$3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
    $parcel$export(module.exports, "embedCard", ()=>$3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "extension", ()=>$3d1dcf8b9eccd1a7$export$1b45514b112dd749);
    $parcel$export(module.exports, "extension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$15be7c145cec614a);
    $parcel$export(module.exports, "heading", ()=>$3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
    $parcel$export(module.exports, "heading_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
    $parcel$export(module.exports, "heading_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
    $parcel$export(module.exports, "rule", ()=>$3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "panel", ()=>$3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>$3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3);
    $parcel$export(module.exports, "nestedExpand_content", ()=>$3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
    $parcel$export(module.exports, "alignment", ()=>$3d1dcf8b9eccd1a7$export$8e53000a4ec837);
    $parcel$export(module.exports, "indentation", ()=>$3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "dataConsumer", ()=>$3d1dcf8b9eccd1a7$export$3024f02c495408d6);
    $parcel$export(module.exports, "fragment", ()=>$3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "tableCell", ()=>$3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "nestedExpand", ()=>$3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
    $parcel$export(module.exports, "tableHeader", ()=>$3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableRow", ()=>$3d1dcf8b9eccd1a7$export$ce666bf02318c957);
    $parcel$export(module.exports, "table", ()=>$3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>$3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
    $parcel$export(module.exports, "bodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$27903d543b563e39);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
    $parcel$export(module.exports, "expand", ()=>$3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expand_with_no_mark", ()=>$3d1dcf8b9eccd1a7$export$1358dbfffec33cd4);
    $parcel$export(module.exports, "expand_with_breakout_mark", ()=>$3d1dcf8b9eccd1a7$export$c30e395ad81940c1);
    $parcel$export(module.exports, "block_content", ()=>$3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
    $parcel$export(module.exports, "layoutColumn", ()=>$3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>$3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
    $parcel$export(module.exports, "layoutSection_full", ()=>$3d1dcf8b9eccd1a7$export$941b63fbd931e449);
    $parcel$export(module.exports, "extensionFrame", ()=>$3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
    $parcel$export(module.exports, "breakout", ()=>$3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "doc", ()=>$3d1dcf8b9eccd1a7$export$2a111da947c407d2);
    const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            optional: true,
                            validatorFn: 'safeUrl'
                        },
                        datasource: {
                            props: {
                                id: {
                                    type: 'string'
                                },
                                parameters: {
                                    type: 'object'
                                },
                                views: {
                                    items: [
                                        {
                                            props: {
                                                properties: {
                                                    optional: true,
                                                    type: 'object'
                                                },
                                                type: {
                                                    type: 'string'
                                                }
                                            }
                                        }
                                    ],
                                    minItems: 1,
                                    type: 'array'
                                }
                            }
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ]
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'text'
                ]
            },
            text: {
                type: 'string',
                minLength: 1
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'codeBlock'
                ]
            },
            attrs: {
                props: {
                    language: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'text',
                        {
                            props: {
                                marks: {
                                    items: [],
                                    maxItems: 0,
                                    optional: true,
                                    type: 'array'
                                }
                            }
                        }
                    ]
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e6744655acd74d98 = [
        'codeBlock',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$6e3671492ca8dabf = [
        'codeBlock',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaSingle'
                ]
            },
            attrs: [
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0,
                            maximum: 100,
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'percentage'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'pixel'
                            ]
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'media'
                ]
            },
            attrs: [
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'link',
                                'file'
                            ]
                        },
                        id: {
                            minLength: 1,
                            type: 'string'
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        collection: {
                            type: 'string'
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        occurrenceKey: {
                            minLength: 1,
                            type: 'string',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'external'
                            ]
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        url: {
                            type: 'string'
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'link'
                ]
            },
            attrs: {
                props: {
                    href: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    title: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string',
                        optional: true
                    },
                    occurrenceKey: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'annotation'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    annotationType: {
                        type: 'enum',
                        values: [
                            'inlineComment'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'border'
                ]
            },
            attrs: {
                props: {
                    size: {
                        type: 'number',
                        minimum: 1,
                        maximum: 3
                    },
                    color: {
                        pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'hardBreak'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'enum',
                        values: [
                            '\n'
                        ],
                        optional: true
                    }
                },
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mention'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    accessLevel: {
                        type: 'string',
                        optional: true
                    },
                    userType: {
                        type: 'enum',
                        values: [
                            'DEFAULT',
                            'SPECIAL',
                            'APP'
                        ],
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'emoji'
                ]
            },
            attrs: {
                props: {
                    shortName: {
                        type: 'string'
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'date'
                ]
            },
            attrs: {
                props: {
                    timestamp: {
                        minLength: 1,
                        type: 'string'
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'placeholder'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ],
            marks: {
                items: [
                    'annotation'
                ],
                optional: true,
                type: 'array'
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'status'
                ]
            },
            attrs: {
                props: {
                    text: {
                        minLength: 1,
                        type: 'string'
                    },
                    color: {
                        type: 'enum',
                        values: [
                            'neutral',
                            'purple',
                            'blue',
                            'red',
                            'yellow',
                            'green'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    style: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'link',
                            'em',
                            'strong',
                            'strike',
                            'subsup',
                            'underline',
                            'textColor',
                            'annotation',
                            'backgroundColor',
                            null
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'code',
                            'link',
                            'annotation'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'em'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strong'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strike'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'subsup'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'sub',
                            'sup'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'underline'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'textColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        type: 'string',
                        pattern: '^#[0-9a-fA-F]{6}$'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'backgroundColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'confluenceInlineComment'
                ]
            },
            attrs: {
                props: {
                    reference: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'code'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'caption'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'hardBreak',
                        'mention',
                        'emoji',
                        'date',
                        'placeholder',
                        'inlineCard',
                        'status',
                        'text_formatted',
                        'text_code_inline'
                    ]
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        'media',
                        'caption'
                    ],
                    minItems: 1,
                    maxItems: 2,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'link'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
        'inlineExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaInline'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file',
                            'image'
                        ],
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    data: {
                        type: 'object',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
        'text_formatted',
        'text_code_inline',
        'date',
        'emoji',
        'hardBreak',
        'inlineCard',
        'mention',
        'placeholder',
        'status',
        'inlineExtension_with_marks',
        'mediaInline'
    ];
    const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'paragraph'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'enum',
                        values: [
                            'TODO',
                            'DONE'
                        ]
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'taskItem',
                    [
                        'taskItem',
                        'taskList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'decisionItem'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
        'listItem',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'decisionList'
                        ],
                        [
                            'paragraph_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'taskList',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'decisionList'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bulletList'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'listItem'
                ]
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'orderedList'
                ]
            },
            attrs: {
                props: {
                    order: {
                        type: 'number',
                        minimum: 0,
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaGroup'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockquote'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'orderedList',
                        'bulletList',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'embedCard'
                ]
            },
            attrs: {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    width: {
                        type: 'number',
                        maximum: 100,
                        minimum: 0,
                        optional: true
                    },
                    originalHeight: {
                        type: 'number',
                        optional: true
                    },
                    originalWidth: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
        'extension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'heading'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'rule'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'panel'
                ]
            },
            attrs: {
                props: {
                    panelType: {
                        type: 'enum',
                        values: [
                            'info',
                            'note',
                            'tip',
                            'warning',
                            'error',
                            'success',
                            'custom'
                        ]
                    },
                    panelIcon: {
                        type: 'string',
                        optional: true
                    },
                    panelIconId: {
                        type: 'string',
                        optional: true
                    },
                    panelIconText: {
                        type: 'string',
                        optional: true
                    },
                    panelColor: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'rule',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3 = [
        'panel',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'heading_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'blockCard',
                            'mediaGroup',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'taskList',
                            'rule',
                            'decisionList',
                            'blockquote'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
        type: 'array',
        items: [
            [
                'paragraph_with_no_marks',
                'heading_with_no_marks',
                'mediaSingle_caption',
                'mediaSingle_full',
                'mediaGroup',
                'codeBlock_with_no_marks',
                'bulletList',
                'orderedList',
                'taskList',
                'decisionList',
                'rule',
                'panel',
                'blockquote'
            ]
        ],
        minItems: 1,
        allowUnsupportedBlock: true
    };
    const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
        'nestedExpand',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'alignment'
                ]
            },
            attrs: {
                props: {
                    align: {
                        type: 'enum',
                        values: [
                            'center',
                            'end'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'indentation'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'dataConsumer'
                ]
            },
            attrs: {
                props: {
                    sources: {
                        type: 'array',
                        items: [
                            {
                                type: 'string'
                            }
                        ],
                        minItems: 1
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'fragment'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        minLength: 1,
                        type: 'string'
                    },
                    name: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableCell'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'nestedExpand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: 'nestedExpand_content'
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableHeader'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks',
                        'nestedExpand'
                    ]
                ],
                minItems: 1
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableRow'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'tableCell',
                        'tableHeader'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'table'
                ]
            },
            attrs: {
                props: {
                    displayMode: {
                        type: 'enum',
                        values: [
                            'default',
                            'fixed'
                        ],
                        optional: true
                    },
                    isNumberColumnEnabled: {
                        type: 'boolean',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'align-end',
                            'align-start',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        minLength: 1,
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'tableRow'
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fragment'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
        'paragraph_with_no_marks',
        'panel',
        'blockquote',
        'orderedList',
        'bulletList',
        'rule',
        'heading_with_no_marks',
        'codeBlock_with_no_marks',
        'mediaGroup',
        'mediaSingle_caption',
        'mediaSingle_full',
        'decisionList',
        'taskList',
        'table',
        'blockCard',
        'embedCard',
        'extension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'non_nestable_block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
        'bodiedExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'expand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock_with_no_marks',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'decisionList',
                        'taskList',
                        'table',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1358dbfffec33cd4 = [
        'expand',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c30e395ad81940c1 = [
        'expand',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
        'blockCard',
        'paragraph_with_no_marks',
        'paragraph_with_alignment',
        'paragraph_with_indentation',
        'mediaSingle_caption',
        'mediaSingle_full',
        'codeBlock_with_no_marks',
        'taskList',
        'bulletList',
        'orderedList',
        'heading_with_no_marks',
        'heading_with_alignment',
        'heading_with_indentation',
        'mediaGroup',
        'decisionList',
        'rule',
        'panel',
        'panel_with_nested_blockquote',
        'blockquote',
        'extension_with_marks',
        'embedCard',
        'table',
        'expand_with_no_mark',
        'bodiedExtension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutColumn'
                ]
            },
            attrs: {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ]
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
        'layoutSection',
        {
            props: {
                attrs: {
                    props: {
                        columnRuleStyle: {
                            type: 'enum',
                            values: [
                                'solid'
                            ],
                            optional: true
                        }
                    },
                    optional: true
                },
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 1,
                    maxItems: 5,
                    allowUnsupportedBlock: true
                },
                type: {
                    type: 'enum',
                    values: [
                        'layoutSection'
                    ]
                },
                marks: {
                    items: [
                        'breakout'
                    ],
                    optional: true,
                    type: 'array'
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
        'layoutSection',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 2,
                    maxItems: 3,
                    allowUnsupportedBlock: true
                },
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                },
                type: {
                    type: 'enum',
                    values: [
                        'layoutSection'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extensionFrame'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock_with_no_marks',
                        'mediaGroup',
                        'mediaSingle_full',
                        'mediaSingle_caption',
                        'decisionList',
                        'taskList',
                        'table',
                        'extension_with_marks',
                        'bodiedExtension_with_marks',
                        'blockCard',
                        'embedCard'
                    ]
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'multiBodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        type: 'string',
                        minLength: 1
                    },
                    extensionType: {
                        type: 'string',
                        minLength: 1
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'default',
                            'wide',
                            'full-width'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true,
                        minLength: 1
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'extensionFrame'
                ]
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
        'multiBodiedExtension'
    ];
    const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'breakout'
                ]
            },
            attrs: {
                props: {
                    mode: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width'
                        ]
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'doc'
                ]
            },
            version: {
                type: 'enum',
                values: [
                    1
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'blockCard',
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'paragraph_with_indentation',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'bulletList',
                        'orderedList',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'mediaGroup',
                        'decisionList',
                        'rule',
                        'panel',
                        'panel_with_nested_blockquote',
                        'blockquote',
                        'extension_with_marks',
                        'embedCard',
                        'table',
                        'expand_with_no_mark',
                        'bodiedExtension_with_marks',
                        'codeBlock_with_marks',
                        'layoutSection_with_single_column',
                        'layoutSection_full',
                        'multiBodiedExtension',
                        'expand_with_breakout_mark'
                    ]
                ],
                allowUnsupportedBlock: true
            }
        }
    };
});
parcelRegister("iiazc", function(module, exports) {
    $parcel$export(module.exports, "isDefined", ()=>$2c8456da404b8e3f$export$4e62c701997796c1);
    $parcel$export(module.exports, "isNumber", ()=>$2c8456da404b8e3f$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isInteger", ()=>$2c8456da404b8e3f$export$a287f47fed4544b8);
    $parcel$export(module.exports, "isBoolean", ()=>$2c8456da404b8e3f$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "isString", ()=>$2c8456da404b8e3f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isPlainObject", ()=>$2c8456da404b8e3f$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "copy", ()=>$2c8456da404b8e3f$export$784d13d8ee351f07);
    $parcel$export(module.exports, "makeArray", ()=>$2c8456da404b8e3f$export$7b85fd78dd236198);
    const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
    const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
    const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
    const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
    const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
    const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
    const $2c8456da404b8e3f$export$784d13d8ee351f07 = (source, dest, key)=>{
        dest[key] = source[key];
        return dest;
    };
    const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
            maybeArray
        ];
});
parcelRegister("1H4Aw", function(module, exports) {
    $parcel$export(module.exports, "validatorFnMap", ()=>$608e35270d0ca1e8$export$d1b377ca77ac267d);
    var $iZOJ9;
    const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
        safeUrl: (0, (0, parcelRequire("iZOJ9")).isSafeUrl)
    };
});
parcelRegister("1cjf7", function(module, exports) {
    $parcel$export(module.exports, "trackUnsupportedContentLevels", ()=>$dad344c5873159ce$export$a43de96edd8d0a0);
    var $4NUlu;
    var $2KwKW;
    var $gkwXh;
    var $knXBU;
    let $dad344c5873159ce$var$rendersMap = {};
    const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
        try {
            const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, (0, parcelRequire("2KwKW")).getUnsupportedContentLevelData)(item.doc, thresholds);
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    appearance: (0, (0, parcelRequire("4NUlu")).getAnalyticsAppearance)(item.appearance),
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    unsupportedContentLevelSeverity: severity,
                    unsupportedContentLevelPercentage: percentage,
                    unsupportedNodesCount: unsupportedNodes,
                    supportedNodesCount: supportedNodes,
                    unsupportedNodeTypeCount: unsupportedNodeTypeCount
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        } catch (err) {
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    error: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        }
    };
    const $dad344c5873159ce$var$schedule = (fn)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
        else setTimeout(fn, 0);
    };
    const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
    const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
        const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
        const appearance = item.appearance ?? 'unknown';
        if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
        const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
        if (didProcessRenderer) return;
        $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
        const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
        if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
        if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    };
});
parcelRegister("2KwKW", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContentLevelData", ()=>$4210b4deee40727f$export$484b83e0462998d);
    var $l1C1k;
    var $4210b4deee40727f$export$6632e71a22d31bf1;
    (function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    })($4210b4deee40727f$export$6632e71a22d31bf1 || ($4210b4deee40727f$export$6632e71a22d31bf1 = {}));
    const $4210b4deee40727f$export$f9f8a29778652c3e = {
        DEGRADED: 10,
        BLOCKING: 25
    };
    const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
        return {
            degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
            blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
        };
    };
    const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
        let unsupportedNodes = 0;
        let supportedNodes = 0;
        const unsupportedNodeTypeCount = {};
        const unsupportedNodeTypes = [
            'unsupportedInline',
            'unsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceUnsupportedBlock'
        ];
        (0, (0, parcelRequire("l1C1k")).traverse)(validDocument, {
            any: (node)=>{
                if (unsupportedNodeTypes.includes(node.type)) {
                    const originalNode = node.attrs?.originalValue;
                    if (originalNode) (0, (0, parcelRequire("l1C1k")).traverse)(originalNode, {
                        any: (unsupportedNode, parent)=>{
                            unsupportedNodes++;
                            const parentType = parent.parent?.node?.type ?? 'unknown';
                            const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                            unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                        }
                    });
                    return false;
                } else supportedNodes++;
            }
        });
        return {
            unsupportedNodes: unsupportedNodes,
            supportedNodes: supportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        };
    };
    const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
        if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
        if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
        return "normal";
    };
    const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
        const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
        const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
        const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
        const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
        return {
            severity: severity,
            percentage: percentage,
            counts: {
                supportedNodes: supportedNodes,
                unsupportedNodes: unsupportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            }
        };
    };
});
parcelRegister("4FBRr", function(module, exports) {
    $parcel$export(module.exports, "transformMediaLinkMarks", ()=>$75bd921bb3a8c47e$export$6528700f3fa2fe2a);
    var $l1C1k;
    const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            mediaSingle: (node)=>{
                if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
                let linkMark = null;
                node.marks.forEach((mark, i)=>{
                    if (mark.type === 'link') {
                        linkMark = mark;
                        node.marks?.splice(i, 1);
                        isTransformed = true;
                    }
                });
                if (node.marks.length === 0) delete node.marks;
                if (linkMark) {
                    const mediaNode = node.content[0];
                    if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                    else if (!mediaNode.marks) mediaNode.marks = [
                        linkMark
                    ];
                }
                return node;
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("kgV4b", function(module, exports) {
    $parcel$export(module.exports, "countNodes", ()=>$7ac8dee2b321f8fd$export$1daf15cbaf649dad);
    var $3Y1bF;
    function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
        return (0, (0, parcelRequire("3Y1bF")).reduce)(adfDocument, (acc, node)=>{
            acc[node.type] = (acc[node.type] || 0) + 1;
            return acc;
        }, {});
    }
});
parcelRegister("3Y1bF", function(module, exports) {
    $parcel$export(module.exports, "reduce", ()=>$de5bae64a9d3f36e$export$533b26079ad0b4b);
    var $l1C1k;
    function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
        let result = initial;
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                result = callback(result, node);
            }
        });
        return result;
    }
});
parcelRegister("3lRy2", function(module, exports) {
    $parcel$export(module.exports, "TruncatedWrapper", ()=>$de95a93fc343bd51$export$79ad592494094f07);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>(0, (0, parcelRequire("f8Sb3")).css)({
            position: 'relative',
            overflowY: 'hidden',
            maxHeight: `${maxHeight}px`,
            '&::after': {
                content: "''",
                position: 'absolute',
                top: `${top}px`,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
            }
        });
    const $de95a93fc343bd51$var$FadeOut = (props)=>{
        const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
        const top = height - fadeHeight;
        const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, children);
    };
    class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
        }
        render() {
            const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)($de95a93fc343bd51$var$FadeOut, {
                height: height,
                fadeHeight: fadeHeight,
                backgroundColor: backgroundColor
            }, children);
        }
    }
});
parcelRegister("jUVor", function(module, exports) {
    $parcel$export(module.exports, "BreakoutSSRInlineScript", ()=>$5224f7c9e411dec4$export$cfc1361be0de4203);
    var $5uXOq = parcelRequire("5uXOq");
    var $eOOFp;
    var $VSDnB;
    var $OxITw;
    function $5224f7c9e411dec4$export$cfc1361be0de4203() {
        if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
        const id = Math.floor(Math.random() * 9999990001) + 9999;
        const context = $5224f7c9e411dec4$export$92859d13f30c883e(id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-breakout-script-id": id,
            dangerouslySetInnerHTML: {
                __html: context
            }
        });
    }
    function $5224f7c9e411dec4$export$92859d13f30c883e(id) {
        return `
  (function(window){
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
    }
    const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, (0, parcelRequire("eOOFp")).breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, (0, parcelRequire("OxITw")).FullPagePadding).toString()};
`;
    function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
        const MEDIA_NODE_TYPE = 'mediaSingle';
        const WIDE_LAYOUT_MODES = [
            'full-width',
            'wide',
            'custom'
        ];
        function findUp(element, condition) {
            if (!element) return;
            while(element.parentElement){
                if (condition(element)) return element.parentElement;
                element = element.parentElement;
            }
        }
        const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
        if (!renderer) return;
        const observer = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((item)=>{
                if (item.target.nodeType !== Node.ELEMENT_NODE) return;
                if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                    if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                    let width;
                    const node = maybeNode;
                    const mode = node.dataset.mode || node.dataset.layout || '';
                    if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                    if (!shouldFixTableResizing) {
                        if (node.classList.contains('pm-table-container') && mode === 'custom') {
                            const rendererWidth = renderer.offsetWidth;
                            const effectiveWidth = rendererWidth - breakoutConsts.padding;
                            width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                        } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                        if (node.style.width === width) return;
                        node.style.width = width;
                        if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                            const lineLength = breakoutConsts.calcLineLength();
                            const left = lineLength / 2 - parseInt(width) / 2;
                            if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                            else node.style.left = '';
                        }
                    }
                });
                else if (item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
            });
        });
        const applyMediaBreakout = (card)=>{
            if (card.style.width) return;
            const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
            if (tableParent) return;
            const mode = card.dataset.mode || card.dataset.layout || '';
            const width = card.dataset.width;
            const isPixelBasedResizing = card.dataset.widthType === 'pixel';
            if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
            else if (width && !isPixelBasedResizing) card.style.width = `${width}%`;
        };
        observer.observe(renderer, {
            childList: true,
            subtree: true
        });
        const disconnect = ()=>{
            observer.disconnect();
            window.removeEventListener('load', disconnect);
        };
        window.addEventListener('load', disconnect);
    }
    const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, (0, parcelRequire("eOOFp")).breakoutConsts).calcLineLength;
});
parcelRegister("1pTqN", function(module, exports) {
    $parcel$export(module.exports, "ActiveHeaderIdProvider", ()=>$ae2d04c26b960a03$export$20439b49fdd0d26c);
    $parcel$export(module.exports, "ActiveHeaderIdConsumer", ()=>$ae2d04c26b960a03$export$cddc3c6ebe2d2cec);
    var $5uXOq = parcelRequire("5uXOq");
    const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
        const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ae2d04c26b960a03$var$Consumer, null, (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        });
    };
});
parcelRegister("TPpI8", function(module, exports) {
    $parcel$export(module.exports, "isInteractiveElement", ()=>$2d523c4d7c031fc5$export$3dee5e4542c672d9);
    function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
        if ('href' in element && element.href != null) return true;
        if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
        if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
        return false;
    }
});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';
parcelRegister("1urn6", function(module, exports) {
    $parcel$export(module.exports, "EditorMediaClientProvider", ()=>$d9518b7b87f036fd$export$77218b6ff680865f);
    var $5uXOq = parcelRequire("5uXOq");
    var $cEHh7;
    var $9S8fM;
    const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
        const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
        const mediaProvider = (0, (0, parcelRequire("9S8fM")).useProvider)('mediaProvider');
        const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
        const contextMediaClient = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEHh7")).MediaClientContext));
        const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, (0, parcelRequire("cEHh7")).getMediaClient)(mediaClientConfig) : undefined, [
            mediaClientConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (ssr?.config) setMediaClientConfig(ssr.config);
            else if (mediaProvider) mediaProvider.then((provider)=>{
                setMediaClientConfig(provider.viewMediaClientConfig);
            });
        }, [
            mediaProvider,
            ssr
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEHh7")).MediaClientContext).Provider, {
            value: shouldSkipContext ? mediaClient : contextMediaClient
        }, children);
    };
});
parcelRegister("cEHh7", function(module, exports) {
    $parcel$export(module.exports, "MediaClientContext", ()=>$2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
    $parcel$export(module.exports, "getMediaClient", ()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417);
    $parcel$export(module.exports, "MediaClientProvider", ()=>$2a03c62fd3cc05ea$export$5bff351c86f56d97);
    $parcel$export(module.exports, "useMediaClient", ()=>$2a03c62fd3cc05ea$export$8b3e87ea56c3a345);
    var $5uXOq = parcelRequire("5uXOq");
    var $9z04W;
    const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $2a03c62fd3cc05ea$export$f92e83e86b03c398 = new Map();
    const $2a03c62fd3cc05ea$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
        if (!mediaClientConfig) return new (0, (0, parcelRequire("9z04W")).MediaClient)({
            authProvider: ()=>Promise.resolve({
                    clientId: '',
                    token: '',
                    baseUrl: ''
                })
        });
        let mediaClient = $2a03c62fd3cc05ea$export$f92e83e86b03c398.get(mediaClientConfig);
        if (!mediaClient) {
            mediaClient = new (0, (0, parcelRequire("9z04W")).MediaClient)(mediaClientConfig);
            $2a03c62fd3cc05ea$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
        }
        return mediaClient;
    };
    const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
        const mediaClient = (0, $5uXOq.useMemo)(()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417(clientConfig), [
            clientConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
    };
    const $2a03c62fd3cc05ea$export$8b3e87ea56c3a345 = ()=>{
        const mediaClient = (0, ($parcel$interopDefault($5uXOq))).useContext($2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
        if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
        return mediaClient;
    };
});
parcelRegister("9z04W", function(module, exports) {
    $parcel$export(module.exports, "MediaClient", ()=>$a9f77c891230da5c$export$fba8b4ca6d386aec);
    var $7n9mn = parcelRequire("7n9mn");
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $1FyHg;
    var $iKPaV;
    var $5eAc2;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $a9f77c891230da5c$export$fba8b4ca6d386aec {
        constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
            this.mediaClientConfig = mediaClientConfig;
            this.store = store;
            this.mediaStore = mediaApi ?? new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: mediaClientConfig.authProvider,
                initialAuth: mediaClientConfig.initialAuth,
                chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $gPrGh.ChunkHashAlgorithm).Sha256 : (0, $gPrGh.ChunkHashAlgorithm).Sha1,
                authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
            });
            this.config = mediaClientConfig;
            this.file = new (0, (0, parcelRequire("iKPaV")).FileFetcherImpl)(this.mediaStore, this.store);
            this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
            this.stargate = new (0, (0, parcelRequire("5eAc2")).StargateClient)(mediaClientConfig.stargateBaseUrl);
        }
        __DO_NOT_USE__getMediaStore() {
            return this.store;
        }
        getImage(id, params, controller, fetchMaxRes, traceContext) {
            return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
        }
        getImageUrl(id, params) {
            return this.mediaStore.getFileImageURL(id, params);
        }
        getImageUrlSync(id, params) {
            return this.mediaStore.getFileImageURLSync(id, params);
        }
        async getImageMetadata(id, params) {
            return (await this.mediaStore.getImageMetadata(id, params)).metadata;
        }
        async mobileUploadPromise() {
            if (this.mobileUpload) return this.mobileUpload;
            const module = await (parcelRequire("hUEMO"));
            this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
            return this.mobileUpload;
        }
        async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
            await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
        }
        on(event, listener) {
            this.eventEmitter.on(event, listener);
        }
        off(event, listener) {
            this.eventEmitter.off(event, listener);
        }
        emit(event, payload) {
            return this.eventEmitter.emit(event, payload);
        }
    }
});
parcelRegister("LmkUS", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>(parcelRequire("6a8j4")).mediaState);
    $parcel$export(module.exports, "isClientBasedAuth", ()=>(parcelRequire("hQvj4")).isClientBasedAuth);
    $parcel$export(module.exports, "authToOwner", ()=>(parcelRequire("hQvj4")).authToOwner);
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>(parcelRequire("gPrGh")).ChunkHashAlgorithm);
    var $6a8j4 = parcelRequire("6a8j4");
    var $hQvj4 = parcelRequire("hQvj4");
    var $gPrGh = parcelRequire("gPrGh");
});
parcelRegister("6a8j4", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>$dc598dfdde7cc536$export$8cef61637918b288);
    var $7n9mn = parcelRequire("7n9mn");
    var $iwKVT = parcelRequire("iwKVT");
    const $dc598dfdde7cc536$export$8cef61637918b288 = {
        streams: new (0, $iwKVT.LRUMap)(1000),
        stateDeferreds: new Map(),
        eventEmitter: new (0, $7n9mn.EventEmitter2)()
    };
});
parcelRegister("hQvj4", function(module, exports) {
    $parcel$export(module.exports, "isClientBasedAuth", ()=>$449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
    $parcel$export(module.exports, "authToOwner", ()=>$449c85d7d5bc4f1f$export$17f6055767a8d96a);
    function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
        return !!auth.clientId;
    }
    function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
        return !!auth.asapIssuer;
    }
    const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
        if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
        const clientAuth = {
            id: auth.clientId,
            baseUrl: auth.baseUrl,
            token: auth.token
        };
        return clientAuth;
    };
});
parcelRegister("gPrGh", function(module, exports) {
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>$506f1dfda055692a$export$d3e73a50cc549c2e);
    var $506f1dfda055692a$export$d3e73a50cc549c2e;
    (function(ChunkHashAlgorithm) {
        ChunkHashAlgorithm["Sha1"] = "sha1";
        ChunkHashAlgorithm["Sha256"] = "sha256";
    })($506f1dfda055692a$export$d3e73a50cc549c2e || ($506f1dfda055692a$export$d3e73a50cc549c2e = {}));
});
parcelRegister("1FyHg", function(module, exports) {
    $parcel$export(module.exports, "MediaStore", ()=>$5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
    $parcel$export(module.exports, "getMediaEnvironment", ()=>$5d0b8a2b8f8558c8$export$c8b741e18397852a);
    $parcel$export(module.exports, "getMediaRegion", ()=>$5d0b8a2b8f8558c8$export$20f9315304dd6726);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $hQvj4 = parcelRequire("hQvj4");
    var $27T0s;
    var $7E56q;
    var $7LFAu;
    var $hzvnk;
    var $ale1y;
    var $eeVEv;
    var $5cMkQ;
    var $VSDnB;
    var $h2NC7;
    const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
    const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
    const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
        return {
            ...params,
            'max-age': params?.['max-age'] ?? (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE),
            allowAnimated: params?.allowAnimated ?? true,
            mode: params?.mode ?? 'crop',
            ...fetchMaxRes ? {
                width: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION),
                height: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION)
            } : {}
        };
    };
    const $5d0b8a2b8f8558c8$var$jsonHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
        let result = endpoint;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery')) {
            if ((0, (0, parcelRequire("h2NC7")).isCommercial)()) result += '/cdn';
        }
        return result;
    };
    class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
        constructor(config){
            this.config = config;
            this.resolveAuth = (authContext)=>(0, (0, parcelRequire("5cMkQ")).resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
            this.resolveInitialAuth = ()=>(0, (0, parcelRequire("5cMkQ")).resolveInitialAuth)(this.config.initialAuth);
            this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
        }
        async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/collection/{collectionName}'
            };
            const body = {
                actions: [
                    {
                        action: 'remove',
                        item: {
                            type: 'file',
                            id: id,
                            occurrenceKey: occurrenceKey
                        }
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/collection/${collectionName}`, options);
        }
        createUpload(createUpTo = 1, collectionName, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                params: {
                    createUpTo: createUpTo,
                    hashAlgorithm: this._chunkHashAlgorithm
                },
                headers: {
                    Accept: 'application/json'
                },
                traceContext: traceContext
            };
            return this.request(`/upload`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/chunk/{etag}'
            };
            const options = {
                ...metadata,
                params: {
                    uploadId: uploadId,
                    partNumber: partNumber
                },
                authContext: {
                    collectionName: collectionName
                },
                body: blob,
                traceContext: traceContext
            };
            await this.request(`/chunk/${etag}`, options);
        }
        createFileFromUpload(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/upload', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getRejectedResponseFromDescriptor(descriptor, limit) {
            return {
                fileId: descriptor.fileId,
                error: {
                    code: 'ExceedMaxFileSizeLimit',
                    title: 'The expected file size exceeded the maximum size limit.',
                    href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                    limit: limit,
                    size: descriptor.size
                }
            };
        }
        async touchFiles(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload/createWithFiles'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext,
                params: {
                    hashAlgorithm: this._chunkHashAlgorithm
                }
            };
            return this.request('/upload/createWithFiles', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getFile(fileId, params = {}, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${fileId}`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getFileImageURL(id, params) {
            const { collection: collectionName } = params || {};
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            return this.createFileImageURL(id, auth, params);
        }
        getFileImageURLSync(id, params) {
            const auth = this.resolveInitialAuth();
            return this.createFileImageURL(id, auth, params);
        }
        createFileImageURL(id, auth, params) {
            const options = {
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
                auth: auth
            };
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
        }
        async getFileBinary(id, collectionName, abortController, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const headers = {};
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${binaryEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: headers,
                params: {
                    collection: collectionName,
                    'max-age': `${maxAge}`
                }
            };
            return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getFileBinaryURL(id, collectionName, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    dl: true,
                    collection: collectionName,
                    'max-age': maxAge
                },
                auth: auth
            };
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
        }
        async getArtifactURL(artifacts, artifactName, collectionName) {
            const artifactUrl = (0, (0, parcelRequire("7LFAu")).getArtifactUrl)(artifacts, artifactName);
            if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    collection: collectionName,
                    'max-age': (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)
                },
                auth: auth
            };
            return (0, (0, parcelRequire("ale1y")).createUrl)((0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        }
        async getImage(id, params, controller, fetchMaxRes, traceContext) {
            const isWebpSupported = false;
            const headers = {};
            if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${imageEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
                headers: headers,
                traceContext: traceContext,
                addMediaClientParam: (0, (0, parcelRequire("VSDnB")).fg)('platform.media-card-performance-observer_a803k') && true
            };
            return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getItems(ids, collectionName, traceContext) {
            const descriptors = ids.map((id)=>({
                    type: 'file',
                    id: id,
                    collection: collectionName
                }));
            const metadata = {
                method: 'POST',
                endpoint: '/items'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify({
                    descriptors: descriptors
                }),
                traceContext: traceContext
            };
            return this.request('/items', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getImageMetadata(id, params, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}/image/metadata'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/image/metadata`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/upload/{uploadId}/chunks'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/upload/${uploadId}/chunks`, options);
        }
        copyFileWithToken(body, params, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/copy/withToken'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/copy/withToken', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async request(path, options = {
            method: 'GET',
            endpoint: undefined,
            authContext: {}
        }, controller, useMediaCdn) {
            const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
            const auth = await this.resolveAuth(authContext);
            const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
            const extendedTraceContext = traceContext ? {
                ...traceContext,
                spanId: traceContext?.spanId || (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
            } : undefined;
            let url = `${auth.baseUrl}${path}`;
            if (useMediaCdn) url = (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(url, auth.token);
            const response = await (0, (0, parcelRequire("hzvnk")).request)(url, {
                method: method,
                endpoint: endpoint,
                auth: auth,
                params: addMediaClientParam ? {
                    ...params,
                    clientId: clientId
                } : params,
                headers: headers,
                body: body,
                clientOptions: clientOptions,
                traceContext: extendedTraceContext
            }, controller);
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
            return response;
        }
        get chunkHashAlgorithm() {
            return this._chunkHashAlgorithm;
        }
    }
    const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
        return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
    };
    const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
        if (!value || !(window && window.sessionStorage)) return;
        const currentValue = window.sessionStorage.getItem(key);
        if (currentValue !== value) window.sessionStorage.setItem(key, value);
    };
    const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
    };
    const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
    };
});
parcelRegister("27T0s", function(module, exports) {
    $parcel$export(module.exports, "isUndefined", ()=>$5713248736bc73bb$export$fce6876652108ab);
    $parcel$export(module.exports, "omitBy", ()=>$5713248736bc73bb$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "getRandomHex", ()=>$5713248736bc73bb$export$456b25e3a9b4a843);
    const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
    const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
        if (obj === undefined) return {};
        return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
    };
    const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
    const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
        let timeout;
        return (...args)=>{
            clearTimeout(timeout);
            timeout = setTimeout(()=>func(...args), wait);
        };
    };
    const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
        return (obj)=>{
            let key;
            for(key in srcObj){
                if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
            }
            return true;
        };
    };
    function $5713248736bc73bb$var$getRandomHexValues(byte) {
        return [
            ...Array(byte * 2)
        ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
    }
    function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
        let randomHex;
        if (window?.crypto) try {
            randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
        } catch (e) {
            randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        }
        else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        return randomHex;
    }
});
parcelRegister("7E56q", function(module, exports) {
    $parcel$export(module.exports, "RECENTS_COLLECTION", ()=>$7a454a77a18dd963$export$860a16125e30000b);
    $parcel$export(module.exports, "FILE_CACHE_MAX_AGE", ()=>$7a454a77a18dd963$export$bd6e8fe09a90927b);
    $parcel$export(module.exports, "MAX_RESOLUTION", ()=>$7a454a77a18dd963$export$6e70f30e392bc53f);
    $parcel$export(module.exports, "CHUNK_SIZE", ()=>$7a454a77a18dd963$export$c1abb8bab1e615cd);
    $parcel$export(module.exports, "PROCESSING_BATCH_SIZE", ()=>$7a454a77a18dd963$export$3d5157f0def70e54);
    $parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", ()=>$7a454a77a18dd963$export$f14f521f3d306044);
    var $749LC;
    const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
    const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000;
    const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
    const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
    const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB;
});
parcelRegister("749LC", function(module, exports) {
    $parcel$export(module.exports, "isNotFoundMediaItemDetails", ()=>$330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
    $parcel$export(module.exports, "DATA_UNIT", ()=>$330ebd66cbfb5bbe$export$76cfea4c354af843);
    const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
        const defaultPreviewableTypes = [
            'audio',
            'video',
            'image',
            'doc'
        ];
        return defaultPreviewableTypes.indexOf(type) > -1;
    };
    const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
        return 'type' in itemDetails && itemDetails.type === 'not-found';
    };
    var $330ebd66cbfb5bbe$export$76cfea4c354af843;
    (function(DATA_UNIT) {
        DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
        DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
        DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    })($330ebd66cbfb5bbe$export$76cfea4c354af843 || ($330ebd66cbfb5bbe$export$76cfea4c354af843 = {}));
});
parcelRegister("7LFAu", function(module, exports) {
    $parcel$export(module.exports, "getArtifactUrl", ()=>$cc56e843db2c0cea$export$1cc24defa44e7f84);
    var $VSDnB;
    var $h2NC7;
    const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
        if ((0, (0, parcelRequire("h2NC7")).isCommercial)() && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
        return artifacts[prop]?.url;
    };
});
parcelRegister("h2NC7", function(module, exports) {
    $parcel$export(module.exports, "isCommercial", ()=>$bc3c8a168b66c7db$export$df69ff6733e73e50);
    function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
        const global = globalThis;
        const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (perimeter) return perimeter === 'commercial';
        return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
    }
});
parcelRegister("hzvnk", function(module, exports) {
    $parcel$export(module.exports, "request", ()=>$ac16e0b7f5d65450$export$b5fe3f66a567bec0);
    var $1As4I;
    var $ale1y;
    async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
        const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
        const { retryOptions: retryOptions } = clientOptions;
        const metadata = {
            method: method,
            endpoint: endpoint,
            traceContext: traceContext
        };
        const doFetch = ()=>fetch((0, (0, parcelRequire("ale1y")).createUrl)(url, {
                params: params
            }), {
                method: method,
                body: body,
                headers: (0, (0, parcelRequire("ale1y")).extendHeaders)(headers, auth, traceContext),
                signal: controller && controller.signal
            }).then((0, (0, parcelRequire("ale1y")).createProcessFetchResponse)(metadata));
        return (0, (0, parcelRequire("ale1y")).fetchRetry)(doFetch, metadata, retryOptions);
    }
});
parcelRegister("1As4I", function(module, exports) {
    $parcel$export(module.exports, "RequestError", ()=>$a9b96946563d0d09$export$43ee7d0e4f429743);
    $parcel$export(module.exports, "isRequestError", ()=>$a9b96946563d0d09$export$3717b1ffef4428ea);
    var $gFZHi;
    class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, metadata, innerError){
            super(reason);
            this.reason = reason;
            this.metadata = metadata;
            this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
            return {
                reason: reason,
                method: method,
                endpoint: endpoint,
                mediaRegion: mediaRegion,
                mediaEnv: mediaEnv,
                attempts: attempts,
                clientExhaustedRetries: clientExhaustedRetries,
                statusCode: statusCode,
                metadata: {
                    traceContext: traceContext
                },
                innerError: innerError
            };
        }
    }
    function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
        return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
    }
});
parcelRegister("gFZHi", function(module, exports) {
    $parcel$export(module.exports, "BaseMediaClientError", ()=>$fd6342ef86e499fe$export$2b0aca14d61c3190);
    var $loYHr;
    class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
        constructor(message){
            super(message);
            this.message = message;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
});
parcelRegister("loYHr", function(module, exports) {
    $parcel$export(module.exports, "isMediaClientError", ()=>$8608a1f56c9594c2$export$2491e0bbdb59256e);
    $parcel$export(module.exports, "getMediaClientErrorReason", ()=>$8608a1f56c9594c2$export$c15d72765ee2baa4);
    function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
        return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
    }
    function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
        return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
    }
});
parcelRegister("ale1y", function(module, exports) {
    $parcel$export(module.exports, "isRateLimitedError", ()=>$96f7b73b7943f312$export$bc96a6a479480590);
    $parcel$export(module.exports, "createUrl", ()=>$96f7b73b7943f312$export$7138c24907de3954);
    $parcel$export(module.exports, "extendHeaders", ()=>$96f7b73b7943f312$export$18cfbabc415d771c);
    $parcel$export(module.exports, "createMapResponseToJson", ()=>$96f7b73b7943f312$export$e0519b126b73efa6);
    $parcel$export(module.exports, "createMapResponseToBlob", ()=>$96f7b73b7943f312$export$5cc7b0795397da86);
    $parcel$export(module.exports, "fetchRetry", ()=>$96f7b73b7943f312$export$782df2acbe10b22c);
    $parcel$export(module.exports, "createRequestErrorReason", ()=>$96f7b73b7943f312$export$6397609af718d008);
    $parcel$export(module.exports, "createProcessFetchResponse", ()=>$96f7b73b7943f312$export$6e2e477edb7d6032);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $3JV6R;
    var $1As4I;
    function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
        return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
    }
    function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
        return err instanceof TypeError;
    }
    function $96f7b73b7943f312$export$bc96a6a479480590(error) {
        return !!error && (0, (0, parcelRequire("1As4I")).isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
    }
    const $96f7b73b7943f312$export$922566b90d0535ce = {
        traceId: 'x-b3-traceid',
        spanId: 'x-b3-spanid',
        parentSpanId: 'x-b3-parentspanid',
        sampled: 'x-b3-sampled',
        flags: 'x-b3-flags'
    };
    const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
        return traceContext ? {
            [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
            [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
        } : {};
    };
    function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
        if (!auth) return {};
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            'X-Client-Id': auth.clientId,
            Authorization: `Bearer ${auth.token}`
        };
        return {
            'X-Issuer': auth.asapIssuer,
            Authorization: `Bearer ${auth.token}`
        };
    }
    function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
        const parsedUrl = new URL(url, auth?.baseUrl);
        const authParams = auth && (0, (0, parcelRequire("3JV6R")).mapAuthToQueryParameters)(auth) || {};
        const paramsToAppend = {
            ...params,
            ...authParams
        };
        Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
            parsedUrl.searchParams.append(...pair);
        });
        parsedUrl.searchParams.sort();
        return parsedUrl.toString();
    }
    function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
        if (!auth && !traceContext && !headers) return undefined;
        return {
            ...headers ?? {},
            ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
            ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
        };
    }
    function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
        return async (response)=>{
            try {
                return await response.json();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
        return async (response)=>{
            try {
                return await response.blob();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
        startTimeoutInMs: 1000,
        maxAttempts: 5,
        factor: 2
    };
    function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
        const { reason: reason, metadata: metadata, innerError: innerError } = error;
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...extraMetadata
        }, innerError);
    }
    async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
        const options = {
            ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
            ...overwriteOptions
        };
        const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
        let attempts = 0;
        let timeoutInMs = startTimeoutInMs;
        let lastError;
        const waitAndBumpTimeout = async ()=>{
            await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
            timeoutInMs *= factor;
            attempts += 1;
        };
        while(attempts < maxAttempts)try {
            return await functionToRetry();
        } catch (err) {
            lastError = err;
            if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, (0, parcelRequire("1As4I")).RequestError)('clientAbortedRequest', metadata, err);
            if (!$96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) && !(0, (0, parcelRequire("1As4I")).isRequestError)(err) || (0, (0, parcelRequire("1As4I")).isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
            await waitAndBumpTimeout();
        }
        if ((0, (0, parcelRequire("1As4I")).isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
            attempts: attempts,
            clientExhaustedRetries: true
        });
        throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverUnexpectedError', {
            ...metadata,
            attempts: attempts,
            clientExhaustedRetries: true
        }, lastError);
    }
    function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
        switch(statusCode){
            case 400:
                return 'serverBadRequest';
            case 401:
                return 'serverUnauthorized';
            case 403:
                return 'serverForbidden';
            case 404:
                return 'serverNotFound';
            case 429:
                return 'serverRateLimited';
            case 500:
                return 'serverInternalError';
            case 502:
                return 'serverBadGateway';
            default:
                return 'serverUnexpectedError';
        }
    }
    function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
        const { status: statusCode } = response;
        const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...$96f7b73b7943f312$export$ea175c0c5497224(response),
            statusCode: statusCode
        });
    }
    function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
        return (response)=>{
            if (response.ok || response.status < 400) return response;
            const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
            throw requestError;
        };
    }
    function $96f7b73b7943f312$export$ea175c0c5497224(response) {
        const { headers: headers } = response;
        const mediaRegion = headers.get('x-media-region') || 'unknown';
        const mediaEnv = headers.get('x-media-env') || 'unknown';
        return {
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv
        };
    }
});
parcelRegister("3JV6R", function(module, exports) {
    $parcel$export(module.exports, "mapAuthToQueryParameters", ()=>$30be3f63a223d0a0$export$6833b130611df767);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    function $30be3f63a223d0a0$export$6833b130611df767(auth) {
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            client: auth.clientId,
            token: auth.token
        };
        else return {
            issuer: auth.asapIssuer,
            token: auth.token
        };
    }
});
parcelRegister("eeVEv", function(module, exports) {
    $parcel$export(module.exports, "mapToMediaCdnUrl", ()=>$ac061c5da59ee1d7$export$fb88a576cf28364d);
    var $VSDnB;
    var $h2NC7;
    const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
        'api.media.atlassian.com': 'media-cdn.atlassian.com',
        'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
    };
    const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
    function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
        const tokenLength = token?.length ?? 0;
        if (!(0, (0, parcelRequire("h2NC7")).isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_single_host')) try {
            const parsedUrl = new URL(url);
            const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
            if (!cdnHost) return url;
            parsedUrl.host = cdnHost;
            return parsedUrl.toString();
        } catch (error) {
            return url;
        }
        return url;
    }
});
parcelRegister("5cMkQ", function(module, exports) {
    $parcel$export(module.exports, "resolveAuth", ()=>$c6441b149d7d138c$export$4b4cec3dcdfce972);
    $parcel$export(module.exports, "resolveInitialAuth", ()=>$c6441b149d7d138c$export$5211e1371264aec3);
    var $ciNTb;
    var $irn0C;
    const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
    const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
        let auth;
        try {
            auth = await Promise.race([
                authProvider(authContext),
                (0, (0, parcelRequire("irn0C")).rejectTimeout)(authProviderTimeout, new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('authProviderTimedOut'))
            ]);
        } catch (err) {
            if (err instanceof (0, (0, parcelRequire("ciNTb")).MediaStoreError)) throw err;
            throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
        }
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('emptyAuth');
        return auth;
    };
    const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('missingInitialAuth');
        return auth;
    };
});
parcelRegister("ciNTb", function(module, exports) {
    $parcel$export(module.exports, "MediaStoreError", ()=>$63300db0f534a20c$export$b78480bd311630bc);
    $parcel$export(module.exports, "isMediaStoreError", ()=>$63300db0f534a20c$export$8d2a9b675b2ce37a);
    var $gFZHi;
    class $63300db0f534a20c$export$b78480bd311630bc extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, innerError){
            super(reason);
            this.reason = reason;
            this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, innerError: innerError } = this;
            return {
                reason: reason,
                innerError: innerError
            };
        }
    }
    function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
        return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
    }
});
parcelRegister("irn0C", function(module, exports) {
    $parcel$export(module.exports, "rejectTimeout", ()=>$974e005d07aa0732$export$cf2d2a1124beacb2);
    const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
            setTimeout(resolve, timeout, resolveWith);
        });
    const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
            setTimeout(reject, timeout, rejectWith);
        });
});
parcelRegister("iKPaV", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherImpl", ()=>$acdec836078e8c40$export$fe17eabf77aabacb);
    $parcel$export(module.exports, "FileFetcherError", ()=>(parcelRequire("gpU3c")).FileFetcherError);
    var $aZdZn = parcelRequire("aZdZn");
    var $cVFxd = parcelRequire("cVFxd");
    var $bXrHm = parcelRequire("bXrHm");
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $txcJN;
    var $1FyHg;
    var $1Pp1U;
    var $749LC;
    var $gpU3c;
    var $i57HF;
    var $hkwMq;
    var $bfb59;
    var $7E56q;
    var $6CZ6k = parcelRequire("6CZ6k");
    var $7p3Ot;
    var $lVahM;
    var $dhdZw;
    var $gayAy;
    var $j1BIJ;
    var $lYDAe;
    var $29M1K;
    var $2Mh8o;
    var $jzW7G;
    var $gR4o6;
    var $dJ905;
    var $9KWg9;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $acdec836078e8c40$export$fe17eabf77aabacb {
        constructor(mediaApi, store = (0, $fN64m.mediaStore)){
            this.mediaApi = mediaApi;
            this.store = store;
            this.getErrorFileState = (error, id, occurrenceKey)=>{
                const { metadata: metadata, ...attributes } = error?.attributes ?? {};
                return typeof error === 'string' ? {
                    status: 'error',
                    id: id,
                    reason: error,
                    occurrenceKey: occurrenceKey,
                    message: error
                } : {
                    status: 'error',
                    id: id,
                    reason: error?.reason,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    },
                    occurrenceKey: occurrenceKey,
                    message: error?.message
                };
            };
            this.setFileState = (id, fileState)=>{
                this.store.setState((state)=>{
                    state.files[id] = fileState;
                });
            };
            this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const poll = new (0, (0, parcelRequire("dJ905")).PollingFunction)();
                poll.onError = (error)=>subject.error(error);
                poll.execute(async ()=>{
                    const response = await this.dataloader.load({
                        id: id,
                        collectionName: collectionName
                    });
                    if ((0, (0, parcelRequire("749LC")).isNotFoundMediaItemDetails)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('emptyItems', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    if ((0, (0, parcelRequire("9KWg9")).isEmptyFile)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('zeroVersionFile', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    const fileState = (0, (0, parcelRequire("1Pp1U")).mapMediaItemToFileState)(id, response);
                    subject.next(fileState);
                    switch(fileState.status){
                        case 'processing':
                            poll.next();
                            break;
                        case 'processed':
                            subject.complete();
                            break;
                    }
                });
                return subject;
            };
            this.getUploadingFileStateBase = (file, upfrontId)=>{
                if (typeof file.content === 'string') file.content = (0, (0, parcelRequire("gayAy")).convertBase64ToBlob)(file.content);
                const { content: content, name: name = '' } = file;
                const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
                let preview;
                let size = 0;
                let mimeType = '';
                if (content instanceof Blob) {
                    size = content.size;
                    mimeType = content.type;
                    preview = {
                        value: content,
                        origin: 'local'
                    };
                }
                const mediaType = (0, (0, parcelRequire("lVahM")).getMediaTypeFromUploadableFile)(file);
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: mimeType,
                    preview: preview
                };
            };
            this.dataloader = (0, (0, parcelRequire("7p3Ot")).createFileDataloader)(mediaApi);
        }
        getFileState(id, options = {}) {
            const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
            if (!(0, ($parcel$interopDefault($6CZ6k)))(id)) {
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const err = new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('invalidFileId', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const { metadata: metadata, ...attributes } = err?.attributes ?? {};
                const errorFileState = {
                    status: 'error',
                    id: id,
                    reason: err?.reason,
                    message: err?.message,
                    occurrenceKey: occurrenceKey,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    }
                };
                subject.error(err);
                this.setFileState(id, errorFileState);
                return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
            }
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)((0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().getOrInsert(id, ()=>{
                const subject = this.createDownloadFileStream(id, collectionName);
                subject.subscribe({
                    next: (fileState)=>{
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(id, errorFileState);
                    }
                });
                return subject;
            }));
        }
        getCurrentState(id, options) {
            return (0, (0, parcelRequire("lYDAe")).toPromise)(this.getFileState(id, options));
        }
        getArtifactURL(artifacts, artifactName, collectionName) {
            return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
        }
        getFileBinaryURL(id, collectionName, maxAge) {
            return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
        }
        touchFiles(descriptors, collection, traceContext) {
            return this.mediaApi.touchFiles({
                descriptors: descriptors
            }, {
                collection: collection
            }, traceContext).then(({ data: data })=>data);
        }
        generateUploadableFileUpfrontIds(collection, traceContext) {
            const id = (0, ($parcel$interopDefault($bXrHm)))();
            const occurrenceKey = (0, ($parcel$interopDefault($bXrHm)))();
            const touchFileDescriptor = {
                fileId: id,
                occurrenceKey: occurrenceKey,
                collection: collection
            };
            const deferredUploadId = this.touchFiles([
                touchFileDescriptor
            ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
        }
        async uploadExternal(url, collection, traceContext) {
            const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
            const preview = new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) reject('Could not fetch the blob');
                resolve({
                    value: blob,
                    origin: 'remote'
                });
            });
            const name = url.split('/').pop() || '';
            const fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            };
            subject.next(fileState);
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            this.setFileState(id, fileState);
            return new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) return reject('Could not download remote file');
                const { type: type, size: size } = blob;
                const file = {
                    content: blob,
                    mimeType: type,
                    collection: collection,
                    name: name,
                    size: size
                };
                const mediaType = (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
                subject.next({
                    status: 'processing',
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: type,
                    id: id,
                    occurrenceKey: occurrenceKey,
                    preview: preview
                });
                this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                let dimensions;
                try {
                    dimensions = await (0, (0, parcelRequire("29M1K")).getDimensionsFromBlob)(mediaType, blob);
                } catch (error) {
                    reject(error);
                    return;
                }
                resolve({
                    dimensions: dimensions,
                    mimeType: type,
                    uploadableFileUpfrontIds: uploadableFileUpfrontIds
                });
            });
        }
        upload(file, controller, uploadableFileUpfrontIds, traceContext) {
            const { collection: collection } = file;
            const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            const stateBase = this.getUploadingFileStateBase(file, upfrontId);
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            const onProgress = (progress)=>{
                const fileState = {
                    status: 'uploading',
                    ...stateBase,
                    progress: progress
                };
                subject.next(fileState);
                this.setFileState(id, fileState);
            };
            let processingSubscription = new (0, $aZdZn.Subscription)();
            const onUploadFinish = (error)=>{
                if (error) {
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                    return subject.error(error);
                }
                processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                        ...stateBase,
                        ...remoteFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                    }))).subscribe({
                    next: (fileState)=>{
                        subject.next(fileState);
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        subject.error(err);
                        this.setFileState(id, errorFileState);
                    },
                    complete: subject.complete
                });
            };
            const { cancel: cancel } = (0, (0, parcelRequire("i57HF")).uploadFile)(file, this.mediaApi, upfrontId, {
                onUploadFinish: onUploadFinish,
                onProgress: onProgress
            }, traceContext);
            controller?.setAbort(()=>{
                cancel();
                processingSubscription.unsubscribe();
            });
            setTimeout(onProgress, 0, 0);
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
        }
        async downloadBinary(id, name = 'download', collectionName) {
            const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
            (0, (0, parcelRequire("txcJN")).downloadUrl)(url, {
                name: name
            });
            (0, (0, parcelRequire("bfb59")).globalMediaEventEmitter).emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === (0, (0, parcelRequire("7E56q")).RECENTS_COLLECTION),
                viewingLevel: 'download'
            });
        }
        async copyFile(source, destination, options = {}, traceContext) {
            const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
            const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
            const { preview: preview, mimeType: mimeType } = options;
            const mediaStore = destination.mediaStore || new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: destinationAuthProvider
            });
            const owner = (0, $hQvj4.authToOwner)(await authProvider({
                collectionName: sourceCollection
            }));
            const body = {
                sourceFile: {
                    id: id,
                    collection: sourceCollection,
                    owner: owner
                }
            };
            const params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
            };
            const cache = (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)();
            let processingSubscription;
            try {
                const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
                const copiedFileWithMimeType = {
                    ...copiedFile,
                    ...mimeType ? {
                        mimeType: mimeType
                    } : undefined
                };
                const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
                const mediaType = copiedMimeType ? (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                const copiedFileState = (0, (0, parcelRequire("1Pp1U")).mapMediaFileToFileState)({
                    data: copiedFileWithMimeType
                });
                const fileCache = cache.get(copiedId);
                const subject = fileCache || (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const previewOverride = !(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && !!preview ? {
                    preview: preview
                } : {};
                if (!(0, (0, parcelRequire("1Pp1U")).isFinalFileState)(copiedFileState) && copiedMimeType && await (0, (0, parcelRequire("gR4o6")).shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                    const fileState = {
                        ...copiedFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                        ...previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                    processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                        next: (remoteFileState)=>{
                            const fileState = {
                                ...remoteFileState,
                                ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                                ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(remoteFileState) && previewOverride
                            };
                            this.setFileState(copiedId, fileState);
                            return subject.next(fileState);
                        },
                        error: (err)=>{
                            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                            this.setFileState(copiedId, errorFileState);
                            return subject.error(err);
                        },
                        complete: ()=>subject.complete()
                    });
                } else if (!(0, (0, parcelRequire("1Pp1U")).isProcessingFileState)(copiedFileState)) {
                    const fileState = {
                        ...copiedFileState,
                        ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                }
                if (!cache.has(copiedId)) (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(copiedId, subject);
                return copiedFile;
            } catch (error) {
                if (processingSubscription) processingSubscription.unsubscribe();
                if (replaceFileId) {
                    const fileCache = cache.get(replaceFileId);
                    const replaceFileState = this.store.getState().files[replaceFileId];
                    if (fileCache) fileCache.error(error);
                    else cache.set(id, (0, (0, parcelRequire("2Mh8o")).createMediaSubject)(error));
                    const key = replaceFileState ? replaceFileId : id;
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(key, errorFileState);
                }
                throw error;
            }
        }
    }
});
parcelRegister("txcJN", function(module, exports) {
    $parcel$export(module.exports, "downloadUrl", ()=>$4c4bd5defea17306$export$8a96edb1c96563f4);
    const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        if (options && options.name) link.download = options.name;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
});
parcelRegister("1Pp1U", function(module, exports) {
    $parcel$export(module.exports, "isUploadingFileState", ()=>$8f64b07ac8c4c4df$export$70eb3481b487c668);
    $parcel$export(module.exports, "isProcessingFileState", ()=>$8f64b07ac8c4c4df$export$5c30e6dd75278e66);
    $parcel$export(module.exports, "isProcessedFileState", ()=>$8f64b07ac8c4c4df$export$1d17291aafa5f231);
    $parcel$export(module.exports, "isErrorFileState", ()=>$8f64b07ac8c4c4df$export$f863e1e09c8a926);
    $parcel$export(module.exports, "isPreviewableFileState", ()=>$8f64b07ac8c4c4df$export$92dd692b31e42e64);
    $parcel$export(module.exports, "isFinalFileState", ()=>$8f64b07ac8c4c4df$export$270b3fc27120edd0);
    $parcel$export(module.exports, "isImageRepresentationReady", ()=>$8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
    $parcel$export(module.exports, "mapMediaFileToFileState", ()=>$8f64b07ac8c4c4df$export$ddfd67d20657322f);
    $parcel$export(module.exports, "mapMediaItemToFileState", ()=>$8f64b07ac8c4c4df$export$ea3730792e8bebfb);
    const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
    const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
    const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
    const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
    const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
    const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
            'processed',
            'failed-processing',
            'error'
        ].includes(fileState.status);
    const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
        switch(fileState.status){
            case 'processing':
            case 'processed':
            case 'failed-processing':
                return !!(fileState.representations && fileState.representations.image);
            default:
                return false;
        }
    };
    const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
        const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
        const baseState = {
            id: id,
            name: name,
            size: size,
            mediaType: mediaType,
            mimeType: mimeType,
            artifacts: artifacts,
            representations: representations,
            createdAt: createdAt,
            metadataTraceContext: metadataTraceContext
        };
        switch(processingStatus){
            case 'pending':
            case undefined:
                return {
                    ...baseState,
                    status: 'processing'
                };
            case 'succeeded':
                return {
                    ...baseState,
                    status: 'processed'
                };
            case 'failed':
                return {
                    ...baseState,
                    status: 'failed-processing'
                };
        }
    };
    const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
        return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
            data: {
                id: id,
                ...item
            }
        });
    };
});
parcelRegister("gpU3c", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherError", ()=>$5a4b48edf9ec6627$export$e3e60f0dab8641de);
    var $gFZHi;
    class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason);
            this.reason = reason;
            this.id = id;
            this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                ...traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                }
            };
        }
    }
    function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
        return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
    }
});
parcelRegister("i57HF", function(module, exports) {
    $parcel$export(module.exports, "uploadFile", ()=>$8cd2ca9b1610ac88$export$a5575dbeeffdad98);
    var $fEpeZ;
    var $gI62y = parcelRequire("gI62y");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $f6rzU;
    var $20Dmg;
    var $7E56q;
    var $empHz;
    const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
        const hasher = await (0, (0, parcelRequire("f6rzU")).createHasher)(hashAlgorithm);
        return hasher.hash(blob);
    };
    const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
            return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
        };
    const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
        let offset = 0;
        return async (chunks)=>{
            await store.appendChunksToUpload(await deferredUploadId, {
                chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
                offset: offset
            }, collection, traceContext);
            offset += chunks.length;
        };
    };
    const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
        const { collection: collection, name: name, mimeType: mimeType } = file;
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const body = file.size ? {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType,
            conditions: {
                size: file.size
            }
        } : {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType
        };
        return store.createFileFromUpload(body, {
            occurrenceKey: occurrenceKey,
            collection: collection,
            replaceFileId: id
        }, traceContext);
    };
    const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
        const { content: content, collection: collection } = file;
        const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        let chunkSize = (0, (0, parcelRequire("7E56q")).CHUNK_SIZE);
        try {
            if (content instanceof Blob) chunkSize = (0, (0, parcelRequire("empHz")).calculateChunkSize)(content.size);
        } catch (err) {
            if (err instanceof Error && err.message === (0, (0, parcelRequire("empHz")).fileSizeError)) callbacks?.onUploadFinish(new (0, (0, parcelRequire("20Dmg")).UploaderError)(err.message, id, {
                collectionName: collection,
                occurrenceKey: occurrenceKey
            }));
            return {
                cancel: ()=>{
                    callbacks?.onUploadFinish('canceled');
                }
            };
        }
        const chunkinatorObservable = (0, (0, parcelRequire("fEpeZ")).chunkinator)(content, {
            hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
            hashingConcurrency: 5,
            chunkSize: chunkSize,
            uploadingConcurrency: 3,
            uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
            processingBatchSize: (0, (0, parcelRequire("7E56q")).PROCESSING_BATCH_SIZE),
            processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
        }, {
            onProgress (progress) {
                if (callbacks) callbacks.onProgress(progress);
            }
        });
        const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
        const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
            error: (err)=>onUploadFinish(err),
            complete: ()=>onUploadFinish()
        });
        return {
            cancel: ()=>{
                subscription.unsubscribe();
                onUploadFinish('canceled');
            }
        };
    };
    const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);
});
parcelRegister("fEpeZ", function(module, exports) {
    $parcel$export(module.exports, "chunkinator", ()=>$2c9b70a291565367$export$9ab6bef3838698f8);
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $9RLLl = parcelRequire("9RLLl");
    var $bXPjr = parcelRequire("bXPjr");
    var $dglPr;
    var $kDczJ;
    var $4Vmg1;
    var $6SPPN;
    var $RsgFX;
    var $gI62y = parcelRequire("gI62y");
    const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, (0, parcelRequire("RsgFX")).fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
            const { chunkSize: chunkSize } = options;
            const { onProgress: onProgress } = callbacks;
            const totalChunks = Math.ceil(blob.size / chunkSize);
            const slicenatedBlobs = (0, (0, parcelRequire("dglPr")).slicenator)(blob, {
                size: chunkSize
            });
            const hashinatedBlobs = (0, (0, parcelRequire("kDczJ")).hashinator)(slicenatedBlobs, {
                concurrency: options.hashingConcurrency,
                hasher: options.hashingFunction
            });
            let uploadedChunks = 0;
            let uploadedBlobs = (0, (0, parcelRequire("4Vmg1")).uploadinator)(hashinatedBlobs, {
                concurrency: options.uploadingConcurrency,
                uploader: options.uploadingFunction
            });
            if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
                uploadedChunks += 1;
                onProgress(uploadedChunks / totalChunks);
            }));
            return (0, (0, parcelRequire("6SPPN")).processinator)(uploadedBlobs, {
                batchSize: options.processingBatchSize,
                processor: options.processingFunction
            }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
                return (0, $gI62y.from)(batchedChunks);
            }), (0, $9RLLl.bufferCount)(totalChunks));
        }));
    const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
        return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
    };
});
parcelRegister("dglPr", function(module, exports) {
    $parcel$export(module.exports, "slicenator", ()=>$f0508944ab60c7e6$export$5b92d769f2f57509);
    var $eTa7E = parcelRequire("eTa7E");
    var $cVFxd = parcelRequire("cVFxd");
    const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
        const totalChunks = Math.ceil(blob.size / chunkSize);
        return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
            return {
                partNumber: index + 1,
                blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
            };
        }));
    };
});
parcelRegister("kDczJ", function(module, exports) {
    $parcel$export(module.exports, "hashinator", ()=>$3a9c605917062ecc$export$d5f5a550a38ec367);
    var $RsgFX;
    const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                    blob: slicedBlob.blob,
                    hash: `${hash}-${slicedBlob.blob.size}`,
                    partNumber: slicedBlob.partNumber
                }));
    const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, (0, parcelRequire("RsgFX")).asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);
});
parcelRegister("RsgFX", function(module, exports) {
    $parcel$export(module.exports, "fetchBlob", ()=>$32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
    $parcel$export(module.exports, "asyncMap", ()=>$32ba0ece4537a1a3$export$707ee4c4c95d39e3);
    var $kVLXA = parcelRequire("kVLXA");
    var $80gxR = parcelRequire("80gxR");
    async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
        if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
        else return file;
    }
    const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
        const notifier = {
            notifyIfReady: ()=>false
        };
        promise.then((value)=>{
            notifier.notifyIfReady = ()=>{
                observer.next(value);
                observer.complete();
                return true;
            };
            onReady(notifier);
        }, (reason)=>{
            notifier.notifyIfReady = ()=>{
                observer.error(reason);
                return true;
            };
            onReady(notifier);
        });
        return notifier;
    };
    const $32ba0ece4537a1a3$var$mapper = (project)=>{
        const notifiers = new Array();
        const onReady = ()=>{
            const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
            if (notReadyIdx > 0) notifiers.splice(0, notReadyIdx);
        };
        return (value)=>new (0, $kVLXA.Observable)((sub)=>{
                notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
            });
    };
    const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);
});
parcelRegister("4Vmg1", function(module, exports) {
    $parcel$export(module.exports, "uploadinator", ()=>$a4f565ebdd47f0f4$export$94ce0f3fcf999415);
    var $RsgFX;
    const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
        const upload = (blob)=>{
            return options.uploader(blob).then(()=>blob);
        };
        return blobs$.pipe((0, (0, parcelRequire("RsgFX")).asyncMap)(upload, options.concurrency));
    };
});
parcelRegister("6SPPN", function(module, exports) {
    $parcel$export(module.exports, "processinator", ()=>$389997e3e47b2450$export$2f21790600302ed);
    var $9RLLl = parcelRequire("9RLLl");
    var $ib0Rz = parcelRequire("ib0Rz");
    const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
        const process = (blobs)=>{
            if (options.processor) return options.processor(blobs).then(()=>blobs);
            else return Promise.resolve(blobs);
        };
        return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
    };
});
parcelRegister("f6rzU", function(module, exports) {
    $parcel$export(module.exports, "createHasher", ()=>$8249c54a4574cd31$export$14b114effbc08b6b);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    let $8249c54a4574cd31$var$hasher = null;
    let $8249c54a4574cd31$var$sha256Hasher = null;
    const $8249c54a4574cd31$export$b7d263e6bc26b29a = ()=>$8249c54a4574cd31$var$hasher = null;
    const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
        const numWorkers = 3;
        if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
            if (!$8249c54a4574cd31$var$sha256Hasher) {
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("gT6vU"));
                $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
            }
            return $8249c54a4574cd31$var$sha256Hasher;
        } else if (!$8249c54a4574cd31$var$hasher) try {
            const { WorkerHasher: WorkerHasher } = await (parcelRequire("0c3mv"));
            $8249c54a4574cd31$var$hasher = new WorkerHasher(numWorkers);
        } catch (error) {
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("4yBex"));
            $8249c54a4574cd31$var$hasher = new SimpleHasher();
        }
        return $8249c54a4574cd31$var$hasher;
    };
});
parcelRegister("gT6vU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("istkm").then(()=>parcelRequire('kXp7T'));
});
parcelRegister("0c3mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("l0S2x")
    ]).then(()=>parcelRequire('3Gx8H'));
});
parcelRegister("4yBex", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iIdh2")
    ]).then(()=>parcelRequire('e4mxx'));
});
parcelRegister("20Dmg", function(module, exports) {
    $parcel$export(module.exports, "UploaderError", ()=>$5ee433d2b5ace7bb$export$515240c3f059c807);
    var $gFZHi;
    class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason);
            this.reason = reason;
            this.id = id;
            this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            };
        }
    }
    function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
        return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
    }
});
parcelRegister("empHz", function(module, exports) {
    $parcel$export(module.exports, "fileSizeError", ()=>$247cdc788c0fb235$export$b36239e4c33c2902);
    $parcel$export(module.exports, "calculateChunkSize", ()=>$247cdc788c0fb235$export$71f452e02035c1e2);
    var $749LC;
    var $7E56q;
    const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
    const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
        if (fileSize > (0, (0, parcelRequire("7E56q")).MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
        if (fileSize <= 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 0.95 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB) return 100 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        return 210 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    };
});
parcelRegister("hkwMq", function(module, exports) {
    $parcel$export(module.exports, "getFileStreamsCache", ()=>$451397184147c26f$export$f2f061938c1e6810);
    class $451397184147c26f$export$4293896e79732236 {
        constructor(streams){
            this.streams = streams;
        }
        has(id) {
            return !!this.streams.find(id);
        }
        set(id, stream) {
            this.streams.set(id, stream);
        }
        get(id) {
            return this.streams.get(id);
        }
        getOrInsert(id, callback) {
            if (!this.has(id)) this.set(id, callback());
            return this.get(id);
        }
        removeAll() {
            this.streams.clear();
        }
        remove(id) {
            this.streams.delete(id);
        }
        get size() {
            return this.streams.size;
        }
    }
    let $451397184147c26f$var$streamCache;
    const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
        if (!$451397184147c26f$var$streamCache) {
            const mediaState = (parcelRequire("6a8j4")).mediaState;
            $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
        }
        return $451397184147c26f$var$streamCache;
    };
});
parcelRegister("bfb59", function(module, exports) {
    $parcel$export(module.exports, "globalMediaEventEmitter", ()=>$22065e01bf236cb8$export$68d003d3105952ad);
    parcelRequire("LmkUS");
    var $6a8j4 = parcelRequire("6a8j4");
    const $22065e01bf236cb8$export$68d003d3105952ad = {
        on (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
        },
        off (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
        },
        emit (event, payload) {
            if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
            return undefined;
        }
    };
});
parcelRegister("6CZ6k", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
    var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    var $4d35b0145f276bfe$var$_byteToHex = [];
    for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
    function $4d35b0145f276bfe$var$unparse(buf, offset) {
        var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
    }
    module.exports = function(uuid, version) {
        var parsedUuid;
        if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
        else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
        else return false;
        parsedUuid = parsedUuid.toLowerCase();
        if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
        if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
        else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
        switch(version){
            case 1:
            case 2:
                return true;
            case 3:
            case 4:
            case 5:
                return [
                    '8',
                    '9',
                    'a',
                    'b'
                ].indexOf(parsedUuid.charAt(19)) !== -1;
            default:
                throw new Error('Invalid version provided.');
        }
    };
    var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
        return uuid.charAt(14) | 0;
    };
});
parcelRegister("7p3Ot", function(module, exports) {
    $parcel$export(module.exports, "createFileDataloader", ()=>$40dc831f91888cf8$export$ae188fee39529b82);
    var $hhZW9 = parcelRequire("hhZW9");
    var $27T0s;
    const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
    const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
        return result.error instanceof Error;
    };
    const $40dc831f91888cf8$var$isResponseFileItem = (fileItem)=>{
        return 'details' in fileItem;
    };
    const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
    const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
        const itemsByKey = fileItems.reduce((prev, fileItem)=>{
            const { id: id, collection: collection } = fileItem;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
            if ($40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
            else if ($40dc831f91888cf8$var$isResponseFileItem(fileItem)) prev[key] = {
                ...fileItem.details,
                metadataTraceContext: fileItem.metadataTraceContext
            };
            else prev[key] = {
                id: id,
                collection: collection,
                type: 'not-found',
                metadataTraceContext: fileItem.metadataTraceContext
            };
            return prev;
        }, {});
        return dataloaderKeys.map((dataloaderKey)=>{
            const { id: id, collectionName: collectionName } = dataloaderKey;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
            return itemsByKey[key] || {
                id: id,
                type: 'not-found'
            };
        });
    };
    function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
        return async (keys)=>{
            const nonCollectionName = '__media-single-file-collection__';
            const fileIdsByCollection = keys.reduce((acc, key)=>{
                const collectionName = key.collectionName || nonCollectionName;
                const fileIds = acc[collectionName] || [];
                if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                acc[collectionName] = fileIds;
                return acc;
            }, {});
            const items = [];
            await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
                const metadataTraceContext = {
                    traceId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8),
                    spanId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
                };
                const fileIds = fileIdsByCollection[collectionNameKey];
                const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                try {
                    const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                    const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                            ...item,
                            metadataTraceContext: metadataTraceContext
                        }));
                    items.push(...itemsWithMetadataTraceContext);
                    const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                    const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                    fileIdsNotFound.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            type: 'not-found',
                            metadataTraceContext: metadataTraceContext
                        });
                    });
                } catch (error) {
                    fileIds.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            error: error
                        });
                    });
                }
            }));
            return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
        };
    }
    function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
        return new (0, ($parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
            maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
        });
    }
});
parcelRegister("lVahM", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromUploadableFile", ()=>$748ba0ab0f854341$export$ac3214931ffd82af);
    var $jzW7G;
    const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
        if (file.content instanceof Blob) {
            const type = file.content.type;
            return (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
        } else return 'unknown';
    };
});
parcelRegister("jzW7G", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromMimeType", ()=>$08d056d70136c4e2$export$79e1dc0d1801e8ef);
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);
    var $92ewp;
    var $8GKRF;
    var $lF4MN;
    const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
        if ((0, (0, parcelRequire("92ewp")).isArchive)(mimeType)) return 'archive';
        if ((0, (0, parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
        if ((0, (0, parcelRequire("8GKRF")).isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
        if ((0, (0, parcelRequire("8GKRF")).isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
        if ((0, (0, parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
        return 'unknown';
    };
});
parcelRegister("92ewp", function(module, exports) {
    $parcel$export(module.exports, "isArchive", ()=>$addf45fda6198a62$export$f47f3fe506e20fe6);
    const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
            'application/x-archive',
            'application/x-cpio',
            'application/x-shar',
            'application/x-iso9660-image',
            'application/x-sbx',
            'application/x-tar',
            'application/x-bzip2',
            'application/gzip',
            'application/x-gzip',
            'application/x-lzip',
            'application/x-lzma',
            'application/x-lzop',
            'application/x-snappy-framed',
            'application/x-xz',
            'application/x-compress',
            'application/zstd',
            'application/x-7z-compressed',
            'application/x-ace-compressed',
            'application/x-astrotite-afa',
            'application/x-alz-compressed',
            'application/vnd.android.package-archive',
            'application/x-freearc',
            'application/x-arj',
            'application/x-b1',
            'application/vnd.ms-cab-compressed',
            'application/x-cfs-compressed',
            'application/x-dar',
            'application/x-dgc-compressed',
            'application/x-apple-diskimage',
            'application/x-gca-compressed',
            'application/java-archive',
            'application/x-lzh',
            'application/x-lzx',
            'application/x-rar-compressed',
            'application/x-stuffit',
            'application/x-stuffitx',
            'application/x-gtar',
            'application/x-ms-wim',
            'application/x-xar',
            'application/zip',
            'application/x-zoo',
            'application/x-par2'
        ].indexOf(mimeType.toLowerCase()) > -1;
});
parcelRegister("8GKRF", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$c021f2623a75015f);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$74325e3c843a9555);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$ff36075ea755a717);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
    $parcel$export(module.exports, "isMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$55ca6cdaf6093034);
    const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
            'image/apng',
            'image/bmp',
            'image/gif',
            'image/x-icon',
            'image/jpeg',
            'image/png',
            'image/webp'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
    const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
            'audio/aac',
            'audio/flac',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/wav',
            'audio/x-wav'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
            'video/mp4',
            'video/quicktime'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);
});
parcelRegister("lF4MN", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$e9a065a80f76311e);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$86baad7a89d908e9);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$8cba23825d020bbb);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$9c2b4de5fdca2ce3);
    $parcel$export(module.exports, "isMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$548d9148a80556a3);
    const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
            'image/bmp',
            'image/x-windows-bmp',
            'application/dicom',
            'image/gif',
            'image/jpeg',
            'image/jpg',
            'image/jp_',
            'application/jpg',
            'application/x-jpg',
            'image/png',
            'application/png',
            'application/x-png',
            'application/vnd.adobe.photoshop',
            'image/vnd.adobe.photoshop',
            'image/photoshop',
            'image/x-photoshop',
            'image/psd',
            'application/photoshop',
            'application/psd',
            'zz-application/zz-winassoc-psd',
            'image/tiff',
            'image/x-tif',
            'image/x-tiff',
            'application/tif',
            'application/x-tif',
            'application/tiff',
            'application/x-tiff',
            'image/svg+xml',
            'image/heif',
            'image/heif-sequence',
            'image/heic',
            'image/heic-sequence'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
            'application/pdf',
            'application/x-pdf',
            'application/acrobat',
            'applications/vnd.pdf',
            'text/pdf',
            'text/x-pdf',
            'application/vnd.adobe.illustrator',
            'application/vnd.ms-office',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/vnd.ms-word.template.macroenabled.12',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-excel.sheet.macroenabled.12',
            'application/vnd.ms-excel.template.macroenabled.12',
            'application/vnd.ms-excel.addin.macroenabled.12',
            'application/vnd.ms-excel.sheet.macroenabled',
            'application/vnd.ms-excel.template.macroenabled',
            'application/vnd.ms-excel.addin.macroenabled',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.ms-powerpoint.template.macroenabled.12',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
            'application/vnd.sun.xml.writer',
            'application/vnd.sun.xml.writer.template',
            'application/vnd.sun.xml.draw',
            'application/vnd.sun.xml.draw.template',
            'application/vnd.oasis.opendocument.graphics',
            'application/vnd.oasis.opendocument.presentation',
            'application/x-vnd.oasis.opendocument.presentation',
            'application/vnd.sun.xml.calc',
            'application/vnd.sun.xml.calc.template',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.spreadsheet-template',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-template',
            'application/vnd.oasis.opendocument.text-master',
            'application/x-vnd.oasis.opendocument.text',
            'application/x-vnd.oasis.opendocument.text-template',
            'application/x-vnd.oasis.opendocument.text-master',
            'application/vnd.wordperfect',
            'text/csv',
            'text/x-diff',
            'text/x-perl',
            'text/x-python',
            'text/x-ruby',
            'text/rtf',
            'text/richtext',
            'text/plain',
            'application/txt',
            'application/rtf',
            'application/x-rtf',
            'application/postscript'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
            'audio/aac',
            'audio/x-hx-aac-adts',
            'audio/vnd.dolby.dd-raw',
            'audio/aiff',
            'audio/x-aiff',
            'audio/x-monkeys-audio',
            'audio/x-ape',
            'audio/basic',
            'audio/flac',
            'audio/mp4',
            'audio/midi',
            'audio/x-matroska',
            'audio/x-mod',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/x-pn-realaudio',
            'audio/wav',
            'audio/x-wav',
            'audio/x-ms-wma'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
            'video/3gpp',
            'video/3gpp2',
            'video/x-ms-asf',
            'video/avi',
            'video/msvideo',
            'video/x-msvideo',
            'video/x-dv',
            'video/x-flv',
            'video/m2ts',
            'video/x-m4v',
            'video/x-matroska',
            'video/quicktime',
            'video/mp4',
            'video/mpeg',
            'video/ogg',
            'video/x-ogg',
            'video/webm',
            'video/x-ms-wmv'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
            'binary/octet-stream'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);
});
parcelRegister("dhdZw", function(module, exports) {
    $parcel$export(module.exports, "overrideMediaTypeIfUnknown", ()=>$c0fce003746ff4f7$export$89097c0ec1e0dee1);
    var $1Pp1U;
    const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
        if (!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
            mediaType: mediaType
        };
        return {};
    };
});
parcelRegister("gayAy", function(module, exports) {
    $parcel$export(module.exports, "convertBase64ToBlob", ()=>$0fff1104576a2bb3$export$ed17558b11b88056);
    const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
        const sliceSize = 512;
        const base64Data = base64.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: 'image/jpeg'
        });
    };
});
parcelRegister("j1BIJ", function(module, exports) {
    $parcel$export(module.exports, "fromObservable", ()=>$6582fd60bc4bbd36$export$4b2432e2d8723823);
    var $2Mh8o;
    function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
        return {
            subscribe: (observer)=>{
                const subscription = observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
                return {
                    unsubscribe: ()=>{
                        subscription.unsubscribe();
                    }
                };
            }
        };
    }
    function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
        return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, (0, parcelRequire("2Mh8o")).createMediaSubject)(item));
    }
});
parcelRegister("2Mh8o", function(module, exports) {
    $parcel$export(module.exports, "createMediaSubject", ()=>$c9b8fad0d34272f1$export$bc76d51553fa5e35);
    var $dZ0DN = parcelRequire("dZ0DN");
    function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
        const subject = new (0, $dZ0DN.ReplaySubject)(1);
        if (initialState instanceof Error) subject.error(initialState);
        else if (initialState) subject.next(initialState);
        return subject;
    }
});
parcelRegister("lYDAe", function(module, exports) {
    $parcel$export(module.exports, "toPromise", ()=>$44429e0ad2a9ded6$export$4dbaaf6c79705e6c);
    var $aZdZn = parcelRequire("aZdZn");
    const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
                next: (state)=>{
                    resolve(state);
                    subscription.unsubscribe();
                },
                error: (error)=>{
                    reject(error);
                    subscription.unsubscribe();
                }
            })));
});
parcelRegister("29M1K", function(module, exports) {
    $parcel$export(module.exports, "getDimensionsFromBlob", ()=>$c92d9e8096a99b5b$export$71797c284d89a3e1);
    var $8IWWt;
    var $5CbXO;
    const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
        switch(mediaType){
            case 'image':
                {
                    const url = URL.createObjectURL(blob);
                    try {
                        return await (0, (0, parcelRequire("8IWWt")).getImageDimensionsFromBlob)(url);
                    } finally{
                        URL.revokeObjectURL(url);
                    }
                }
            case 'video':
                return (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(blob);
            default:
                throw new Error(`Can't extract dimensions from ${mediaType}`);
        }
    };
});
parcelRegister("8IWWt", function(module, exports) {
    $parcel$export(module.exports, "getImageDimensionsFromBlob", ()=>$094f7e5912c5e863$export$a1c3205f28a20414);
    const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = url;
            img.onload = ()=>resolve({
                    width: img.width,
                    height: img.height
                });
            img.onerror = reject;
        });
});
parcelRegister("5CbXO", function(module, exports) {
    $parcel$export(module.exports, "getVideoDimensionsFromBlob", ()=>$3629651e482443d2$export$62aabd5ff85d0451);
    const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
        return new Promise((resolve, reject)=>{
            const url = URL.createObjectURL(blob);
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;
            video.addEventListener('loadedmetadata', function timeupdateHandler() {
                video.removeEventListener('loadedmetadata', timeupdateHandler);
                resolve({
                    width: video.videoWidth,
                    height: video.videoHeight
                });
                URL.revokeObjectURL(url);
            });
            video.addEventListener('error', ()=>{
                reject(new Error('failed to load video'));
                URL.revokeObjectURL(url);
            });
        });
    };
});
parcelRegister("gR4o6", function(module, exports) {
    $parcel$export(module.exports, "shouldFetchRemoteFileStates", ()=>$81fca2ad541e7785$export$2ccdd6f9a9eba6a);
    var $8GKRF;
    var $lF4MN;
    var $5CbXO;
    async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
        if ((mediaType === 'doc' || !(0, (0, parcelRequire("8GKRF")).isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, (0, parcelRequire("lF4MN")).isMimeTypeSupportedByServer)(mimeType)) return true;
        if (mediaType === 'video' && !!preview) {
            const content = (await preview).value;
            if (!(content instanceof Blob)) return false;
            try {
                const { width: width, height: height } = await (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(content);
                return !width && !height;
            } catch (e) {
                return true;
            }
        }
        return false;
    }
});
parcelRegister("dJ905", function(module, exports) {
    $parcel$export(module.exports, "PollingFunction", ()=>$a9b60fcbc1595cd8$export$4c54d536f8e37dc2);
    var $j8kdR;
    const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
        poll_intervalMs: 3000,
        poll_maxAttempts: 30,
        poll_backoffFactor: 1.25,
        poll_maxIntervalMs: 200000
    };
    class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
        constructor(options){
            this.poll_intervalMs = 0;
            this.attempt = 1;
            this.shouldIterate = true;
            this.timeoutId = 0;
            this.options = {
                ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
                ...options
            };
            this.poll_intervalMs = this.options.poll_intervalMs;
        }
        async execute(executor) {
            const { poll_maxAttempts: poll_maxAttempts } = this.options;
            if (poll_maxAttempts === 0) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            try {
                this.shouldIterate = false;
                await executor();
                if (!this.shouldIterate) return;
                if (this.attempt >= poll_maxAttempts) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                this.attempt++;
                this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
            } catch (error) {
                this.fail(error);
            }
        }
        fail(error) {
            const { onError: onError } = this;
            this.cancel();
            onError && onError(error);
        }
        getIntervalMsForIteration(iteration) {
            let poll_intervalMs = this.options.poll_intervalMs;
            if (iteration === 1) return poll_intervalMs;
            for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
            return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
        }
        next() {
            this.shouldIterate = true;
        }
        cancel() {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
});
parcelRegister("j8kdR", function(module, exports) {
    $parcel$export(module.exports, "PollingError", ()=>$ba72cde1b79a6066$export$c3748c310e92340a);
    $parcel$export(module.exports, "isPollingError", ()=>$ba72cde1b79a6066$export$541e3e52eea6fece);
    var $gFZHi;
    class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, attempts){
            super(reason);
            this.reason = reason;
            this.attempts = attempts;
        }
        get attributes() {
            const { reason: reason, attempts: attempts } = this;
            return {
                reason: reason,
                attempts: attempts
            };
        }
    }
    function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
        return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
    }
});
parcelRegister("9KWg9", function(module, exports) {
    $parcel$export(module.exports, "isEmptyFile", ()=>$6625df65da5f0486$export$728192ce8dd94659);
    const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000;
    function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
        const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
        if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
            const msSinceFileCreation = now - createdAt;
            if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
        }
        return false;
    }
});
parcelRegister("8HaZs", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>(parcelRequire("fN64m")).mediaStore);
    var $fN64m = parcelRequire("fN64m");
});
parcelRegister("fN64m", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>$df71566ec1e8fa2a$export$5785580dea19518d);
    var $bIv98;
    var $70n8Q;
    var $ee7sp;
    const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        }))));
    const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).devtools)((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        })))));
    const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
    const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
        return (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
                files: {},
                ...initialStore
            }))));
    };
});
parcelRegister("bIv98", function(module, exports) {
    $parcel$export(module.exports, "devtools", ()=>$887bf6c78f4461c3$export$6922d3b3a607469e);
    $parcel$export(module.exports, "subscribeWithSelector", ()=>$887bf6c78f4461c3$export$5c593627aef9f076);
    var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/middleware.mjs"
    });
    const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
            api.dispatch = (action)=>{
                set((state)=>reducer(state, action), false, action);
                return action;
            };
            api.dispatchFromDevtools = true;
            return {
                dispatch: (...a)=>api.dispatch(...a),
                ...initial
            };
        };
    const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
    const $887bf6c78f4461c3$var$trackedConnections = new Map();
    const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
        const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
        if (!api) return {};
        return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
                key,
                api2.getState()
            ]));
    };
    const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
        if (store === void 0) return {
            type: "untracked",
            connection: extensionConnector.connect(options)
        };
        const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
        if (existingConnection) return {
            type: "tracked",
            store: store,
            ...existingConnection
        };
        const newConnection = {
            connection: extensionConnector.connect(options),
            stores: {}
        };
        $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
        return {
            type: "tracked",
            store: store,
            ...newConnection
        };
    };
    const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
            const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
            let extensionConnector;
            try {
                extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
            } catch (e) {}
            if (!extensionConnector) {
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
                return fn(set, get, api);
            }
            const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
            let isRecording = true;
            api.setState = (state, replace, nameOrAction)=>{
                const r = set(state, replace);
                if (!isRecording) return r;
                const action = nameOrAction === void 0 ? {
                    type: anonymousActionType || "anonymous"
                } : typeof nameOrAction === "string" ? {
                    type: nameOrAction
                } : nameOrAction;
                if (store === void 0) {
                    connection == null || connection.send(action, get());
                    return r;
                }
                connection == null || connection.send({
                    ...action,
                    type: `${store}/${action.type}`
                }, {
                    ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                    [store]: api.getState()
                });
                return r;
            };
            const setStateFromDevtools = (...a)=>{
                const originalIsRecording = isRecording;
                isRecording = false;
                set(...a);
                isRecording = originalIsRecording;
            };
            const initialState = fn(api.setState, get, api);
            if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
            else {
                connectionInformation.stores[connectionInformation.store] = api;
                connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                        key,
                        key === connectionInformation.store ? initialState : store2.getState()
                    ])));
            }
            if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
                let didWarnAboutReservedActionType = false;
                const originalDispatch = api.dispatch;
                api.dispatch = (...a)=>{
                    if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                        console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                        didWarnAboutReservedActionType = true;
                    }
                    originalDispatch(...a);
                };
            }
            connection.subscribe((message)=>{
                var _a;
                switch(message.type){
                    case "ACTION":
                        if (typeof message.payload !== "string") {
                            console.error("[zustand devtools middleware] Unsupported action format");
                            return;
                        }
                        return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                            if (action.type === "__setState") {
                                if (store === void 0) {
                                    setStateFromDevtools(action.state);
                                    return;
                                }
                                if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                                const stateFromDevtools = action.state[store];
                                if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                                if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                                return;
                            }
                            if (!api.dispatchFromDevtools) return;
                            if (typeof api.dispatch !== "function") return;
                            api.dispatch(action);
                        });
                    case "DISPATCH":
                        switch(message.payload.type){
                            case "RESET":
                                setStateFromDevtools(initialState);
                                if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "COMMIT":
                                if (store === void 0) {
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "ROLLBACK":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        connection == null || connection.init(api.getState());
                                        return;
                                    }
                                    setStateFromDevtools(state[store]);
                                    connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                                });
                            case "JUMP_TO_STATE":
                            case "JUMP_TO_ACTION":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        return;
                                    }
                                    if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                                });
                            case "IMPORT_STATE":
                                {
                                    const { nextLiftedState: nextLiftedState } = message.payload;
                                    const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                    if (!lastComputedState) return;
                                    if (store === void 0) setStateFromDevtools(lastComputedState);
                                    else setStateFromDevtools(lastComputedState[store]);
                                    connection == null || connection.send(null, nextLiftedState);
                                    return;
                                }
                            case "PAUSE_RECORDING":
                                return isRecording = !isRecording;
                        }
                        return;
                }
            });
            return initialState;
        };
    const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
    const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
        let parsed;
        try {
            parsed = JSON.parse(stringified);
        } catch (e) {
            console.error("[zustand devtools middleware] Could not parse the received json", e);
        }
        if (parsed !== void 0) f(parsed);
    };
    const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
            const origSubscribe = api.subscribe;
            api.subscribe = (selector, optListener, options)=>{
                let listener = selector;
                if (optListener) {
                    const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                    let currentSlice = selector(api.getState());
                    listener = (state)=>{
                        const nextSlice = selector(state);
                        if (!equalityFn(currentSlice, nextSlice)) {
                            const previousSlice = currentSlice;
                            optListener(currentSlice = nextSlice, previousSlice);
                        }
                    };
                    if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
                }
                return origSubscribe(listener);
            };
            const initialState = fn(set, get, api);
            return initialState;
        };
    const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
    const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
    function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
        let storage;
        try {
            storage = getStorage();
        } catch (e) {
            return;
        }
        const persistStorage = {
            getItem: (name)=>{
                var _a;
                const parse = (str2)=>{
                    if (str2 === null) return null;
                    return JSON.parse(str2, options == null ? void 0 : options.reviver);
                };
                const str = (_a = storage.getItem(name)) != null ? _a : null;
                if (str instanceof Promise) return str.then(parse);
                return parse(str);
            },
            setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
            removeItem: (name)=>storage.removeItem(name)
        };
        return persistStorage;
    }
    const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
            try {
                const result = fn(input);
                if (result instanceof Promise) return result;
                return {
                    then (onFulfilled) {
                        return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                    },
                    catch (_onRejected) {
                        return this;
                    }
                };
            } catch (e) {
                return {
                    then (_onFulfilled) {
                        return this;
                    },
                    catch (onRejected) {
                        return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                    }
                };
            }
        };
    const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                getStorage: ()=>localStorage,
                serialize: JSON.stringify,
                deserialize: JSON.parse,
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage;
            try {
                storage = options.getStorage();
            } catch (e) {}
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                let errorInSync;
                const thenable = thenableSerialize({
                    state: state,
                    version: options.version
                }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                    errorInSync = e;
                });
                if (errorInSync) throw errorInSync;
                return thenable;
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            let stateFromStorage;
            const hydrate = ()=>{
                var _a;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>cb(get()));
                const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                    if (storageValue) return options.deserialize(storageValue);
                }).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.getStorage) storage = newOptions.getStorage();
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage = options.storage;
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                return storage.setItem(options.name, {
                    state: state,
                    version: options.version
                });
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            api.getInitialState = ()=>configResult;
            let stateFromStorage;
            const hydrate = ()=>{
                var _a, _b;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>{
                    var _a2;
                    return cb((_a2 = get()) != null ? _a2 : configResult);
                });
                const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    stateFromStorage = get();
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.storage) storage = newOptions.storage;
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            if (!options.skipHydration) hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
        if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
            return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
        }
        return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
    };
    const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;
});
parcelRegister("70n8Q", function(module, exports) {
    $parcel$export(module.exports, "immer", ()=>$519a7bf2c276fd5a$export$428de7ec69ac95c);
    var $86xFr;
    const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
            store.setState = (updater, replace, ...a)=>{
                const nextState = typeof updater === "function" ? (0, (0, parcelRequire("86xFr")).produce)(updater) : updater;
                return set(nextState, replace, ...a);
            };
            return initializer(store.setState, get, store);
        };
    const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;
});
parcelRegister("86xFr", function(module, exports) {
    $parcel$export(module.exports, "produce", ()=>fn);
    function n(n) {
        for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
        var i, o;
        throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
            return "'" + n + "'";
        }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function r(n) {
        return !!n && !!n[Q];
    }
    function t(n) {
        var r;
        return !!n && (function(n) {
            if (!n || "object" != typeof n) return !1;
            var r = Object.getPrototypeOf(n);
            if (null === r) return !0;
            var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
            return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
        }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
    }
    function e(t) {
        return r(t) || n(23, t), t[Q].t;
    }
    function i(n, r, t) {
        void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
            t && "symbol" == typeof e || r(e, n[e], n);
        }) : n.forEach(function(t, e) {
            return r(e, t, n);
        });
    }
    function o(n) {
        var r = n[Q];
        return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
    }
    function u(n, r) {
        return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
    }
    function a(n, r) {
        return 2 === o(n) ? n.get(r) : n[r];
    }
    function f(n, r, t) {
        var e = o(n);
        2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
    }
    function c(n, r) {
        return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
    }
    function s(n) {
        return X && n instanceof Map;
    }
    function v(n) {
        return q && n instanceof Set;
    }
    function p(n) {
        return n.o || n.t;
    }
    function l(n) {
        if (Array.isArray(n)) return Array.prototype.slice.call(n);
        var r = rn(n);
        delete r[Q];
        for(var t = nn(r), e = 0; e < t.length; e++){
            var i = t[e], o = r[i];
            !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: n[i]
            });
        }
        return Object.create(Object.getPrototypeOf(n), r);
    }
    function d(n, e) {
        return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
            return d(r, !0);
        }, !0)), n;
    }
    function h() {
        n(2);
    }
    function y(n) {
        return null == n || "object" != typeof n || Object.isFrozen(n);
    }
    function b(r) {
        var t = tn[r];
        return t || n(18, r), t;
    }
    function m(n, r) {
        tn[n] || (tn[n] = r);
    }
    function _() {
        return U;
    }
    function j(n, r) {
        r && (b("Patches"), n.u = [], n.s = [], n.v = r);
    }
    function g(n) {
        O(n), n.p.forEach(S), n.p = null;
    }
    function O(n) {
        n === U && (U = n.l);
    }
    function w(n) {
        return U = {
            p: [],
            l: U,
            h: n,
            m: !0,
            _: 0
        };
    }
    function S(n) {
        var r = n[Q];
        0 === r.i || 1 === r.i ? r.j() : r.g = !0;
    }
    function P(r, e) {
        e._ = e.p.length;
        var i = e.p[0], o = void 0 !== r && r !== i;
        return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
    }
    function M(n, r, t) {
        if (y(r)) return r;
        var e = r[Q];
        if (!e) return i(r, function(i, o) {
            return A(n, e, r, i, o, t);
        }, !0), r;
        if (e.A !== n) return r;
        if (!e.P) return x(n, e.t, !0), e.t;
        if (!e.I) {
            e.I = !0, e.A._--;
            var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
            3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
                return A(n, e, o, r, i, t, a);
            }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
        }
        return e.o;
    }
    function A(e, i, o, a, c, s, v) {
        if (r(c)) {
            var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
            if (f(o, a, p), !r(p)) return;
            e.m = !1;
        } else v && o.add(c);
        if (t(c) && !y(c)) {
            if (!e.h.D && e._ < 1) return;
            M(e, c), i && i.A.l || x(e, c);
        }
    }
    function x(n, r, t) {
        void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
    }
    function z(n, r) {
        var t = n[Q];
        return (t ? p(t) : n)[r];
    }
    function I(n, r) {
        if (r in n) for(var t = Object.getPrototypeOf(n); t;){
            var e = Object.getOwnPropertyDescriptor(t, r);
            if (e) return e;
            t = Object.getPrototypeOf(t);
        }
    }
    function k(n) {
        n.P || (n.P = !0, n.l && k(n.l));
    }
    function E(n) {
        n.o || (n.o = l(n.t));
    }
    function N(n, r, t) {
        var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
            var t = Array.isArray(n), e = {
                i: t ? 1 : 0,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: null,
                o: null,
                j: null,
                C: !1
            }, i = e, o = en;
            t && (i = [
                e
            ], o = on);
            var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
            return e.k = f, e.j = a, f;
        }(r, t) : b("ES5").J(r, t);
        return (t ? t.A : _()).p.push(e), e;
    }
    function R(e) {
        return r(e) || n(22, e), function n(r) {
            if (!t(r)) return r;
            var e, u = r[Q], c = o(r);
            if (u) {
                if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
                u.I = !0, e = D(r, c), u.I = !1;
            } else e = D(r, c);
            return i(e, function(r, t) {
                u && a(u.t, r) === t || f(e, r, n(t));
            }), 3 === c ? new Set(e) : e;
        }(e);
    }
    function D(n, r) {
        switch(r){
            case 2:
                return new Map(n);
            case 3:
                return Array.from(n);
        }
        return l(n);
    }
    function F() {
        function t(n, r) {
            var t = s[n];
            return t ? t.enumerable = r : s[n] = t = {
                configurable: !0,
                enumerable: r,
                get: function() {
                    var r = this[Q];
                    return en.get(r, n);
                },
                set: function(r) {
                    var t = this[Q];
                    en.set(t, n, r);
                }
            }, t;
        }
        function e(n) {
            for(var r = n.length - 1; r >= 0; r--){
                var t = n[r][Q];
                if (!t.P) switch(t.i){
                    case 5:
                        a(t) && k(t);
                        break;
                    case 4:
                        o(t) && k(t);
                }
            }
        }
        function o(n) {
            for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
                var o = e[i];
                if (o !== Q) {
                    var a = r[o];
                    if (void 0 === a && !u(r, o)) return !0;
                    var f = t[o], s = f && f[Q];
                    if (s ? s.t !== a : !c(f, a)) return !0;
                }
            }
            var v = !!r[Q];
            return e.length !== nn(r).length + (v ? 0 : 1);
        }
        function a(n) {
            var r = n.k;
            if (r.length !== n.t.length) return !0;
            var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
            if (t && !t.get) return !0;
            for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
            return !1;
        }
        function f(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var s = {};
        m("ES5", {
            J: function(n, r) {
                var e = Array.isArray(n), i = function(n, r) {
                    if (n) {
                        for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                        return e;
                    }
                    var o = rn(r);
                    delete o[Q];
                    for(var u = nn(o), a = 0; a < u.length; a++){
                        var f = u[a];
                        o[f] = t(f, n || !!o[f].enumerable);
                    }
                    return Object.create(Object.getPrototypeOf(r), o);
                }(e, n), o = {
                    i: e ? 5 : 4,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    R: {},
                    l: r,
                    t: n,
                    k: i,
                    o: null,
                    g: !1,
                    C: !1
                };
                return Object.defineProperty(i, Q, {
                    value: o,
                    writable: !0
                }), i;
            },
            S: function(n, t, o) {
                o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                    if (r && "object" == typeof r) {
                        var t = r[Q];
                        if (t) {
                            var e = t.t, o = t.k, f = t.R, c = t.i;
                            if (4 === c) i(o, function(r) {
                                r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                            }), i(e, function(n) {
                                void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                            });
                            else if (5 === c) {
                                if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                                else for(var v = e.length; v < o.length; v++)f[v] = !0;
                                for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                            }
                        }
                    }
                }(n.p[0]), e(n.p));
            },
            K: function(n) {
                return 4 === n.i ? o(n) : a(n);
            }
        });
    }
    function T() {
        function e(n) {
            if (!t(n)) return n;
            if (Array.isArray(n)) return n.map(e);
            if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
                return [
                    n[0],
                    e(n[1])
                ];
            }));
            if (v(n)) return new Set(Array.from(n).map(e));
            var r = Object.create(Object.getPrototypeOf(n));
            for(var i in n)r[i] = e(n[i]);
            return u(n, L) && (r[L] = n[L]), r;
        }
        function f(n) {
            return r(n) ? e(n) : n;
        }
        var c = "add";
        m("Patches", {
            $: function(r, t) {
                return t.forEach(function(t) {
                    for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                        var v = o(f), p = i[s];
                        "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                    }
                    var l = o(f), d = e(t.value), h = i[i.length - 1];
                    switch(u){
                        case "replace":
                            switch(l){
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    n(16);
                                default:
                                    return f[h] = d;
                            }
                        case c:
                            switch(l){
                                case 1:
                                    return "-" === h ? f.push(d) : f.splice(h, 0, d);
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    return f.add(d);
                                default:
                                    return f[h] = d;
                            }
                        case "remove":
                            switch(l){
                                case 1:
                                    return f.splice(h, 1);
                                case 2:
                                    return f.delete(h);
                                case 3:
                                    return f.delete(t.value);
                                default:
                                    return delete f[h];
                            }
                        default:
                            n(17, u);
                    }
                }), r;
            },
            N: function(n, r, t, e) {
                switch(n.i){
                    case 0:
                    case 4:
                    case 2:
                        return function(n, r, t, e) {
                            var o = n.t, s = n.o;
                            i(n.R, function(n, i) {
                                var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                                if (v !== p || "replace" !== l) {
                                    var d = r.concat(n);
                                    t.push("remove" === l ? {
                                        op: l,
                                        path: d
                                    } : {
                                        op: l,
                                        path: d,
                                        value: p
                                    }), e.push(l === c ? {
                                        op: "remove",
                                        path: d
                                    } : "remove" === l ? {
                                        op: c,
                                        path: d,
                                        value: f(v)
                                    } : {
                                        op: "replace",
                                        path: d,
                                        value: f(v)
                                    });
                                }
                            });
                        }(n, r, t, e);
                    case 5:
                    case 1:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.R, u = n.o;
                            if (u.length < i.length) {
                                var a = [
                                    u,
                                    i
                                ];
                                i = a[0], u = a[1];
                                var s = [
                                    e,
                                    t
                                ];
                                t = s[0], e = s[1];
                            }
                            for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                                var p = r.concat([
                                    v
                                ]);
                                t.push({
                                    op: "replace",
                                    path: p,
                                    value: f(u[v])
                                }), e.push({
                                    op: "replace",
                                    path: p,
                                    value: f(i[v])
                                });
                            }
                            for(var l = i.length; l < u.length; l++){
                                var d = r.concat([
                                    l
                                ]);
                                t.push({
                                    op: c,
                                    path: d,
                                    value: f(u[l])
                                });
                            }
                            i.length < u.length && e.push({
                                op: "replace",
                                path: r.concat([
                                    "length"
                                ]),
                                value: i.length
                            });
                        }(n, r, t, e);
                    case 3:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.o, u = 0;
                            i.forEach(function(n) {
                                if (!o.has(n)) {
                                    var i = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: "remove",
                                        path: i,
                                        value: n
                                    }), e.unshift({
                                        op: c,
                                        path: i,
                                        value: n
                                    });
                                }
                                u++;
                            }), u = 0, o.forEach(function(n) {
                                if (!i.has(n)) {
                                    var o = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: c,
                                        path: o,
                                        value: n
                                    }), e.unshift({
                                        op: "remove",
                                        path: o,
                                        value: n
                                    });
                                }
                                u++;
                            });
                        }(n, r, t, e);
                }
            },
            M: function(n, r, t, e) {
                t.push({
                    op: "replace",
                    path: [],
                    value: r === H ? void 0 : r
                }), e.push({
                    op: "replace",
                    path: [],
                    value: n
                });
            }
        });
    }
    function C() {
        function r(n, r) {
            function t() {
                this.constructor = n;
            }
            a(n, r), n.prototype = (t.prototype = r.prototype, new t);
        }
        function e(n) {
            n.o || (n.R = new Map, n.o = new Map(n.t));
        }
        function o(n) {
            n.o || (n.o = new Set, n.t.forEach(function(r) {
                if (t(r)) {
                    var e = N(n.A.h, r, n);
                    n.p.set(r, e), n.o.add(e);
                } else n.o.add(r);
            }));
        }
        function u(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var a = function(n, r) {
            return (a = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(n, r) {
                n.__proto__ = r;
            } || function(n, r) {
                for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
            })(n, r);
        }, f = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 2,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    R: void 0,
                    t: n,
                    k: this,
                    C: !1,
                    g: !1
                }, this;
            }
            r(n, Map);
            var o = n.prototype;
            return Object.defineProperty(o, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), o.has = function(n) {
                return p(this[Q]).has(n);
            }, o.set = function(n, r) {
                var t = this[Q];
                return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
            }, o.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
            }, o.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                    n.R.set(r, !1);
                }), n.o.clear());
            }, o.forEach = function(n, r) {
                var t = this;
                p(this[Q]).forEach(function(e, i) {
                    n.call(r, t.get(i), i, t);
                });
            }, o.get = function(n) {
                var r = this[Q];
                u(r);
                var i = p(r).get(n);
                if (r.I || !t(i)) return i;
                if (i !== r.t.get(n)) return i;
                var o = N(r.A.h, i, r);
                return e(r), r.o.set(n, o), o;
            }, o.keys = function() {
                return p(this[Q]).keys();
            }, o.values = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.values();
                }, n.next = function() {
                    var n = t.next();
                    return n.done ? n : {
                        done: !1,
                        value: r.get(n.value)
                    };
                }, n;
            }, o.entries = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.entries();
                }, n.next = function() {
                    var n = t.next();
                    if (n.done) return n;
                    var e = r.get(n.value);
                    return {
                        done: !1,
                        value: [
                            n.value,
                            e
                        ]
                    };
                }, n;
            }, o[V] = function() {
                return this.entries();
            }, n;
        }(), c = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 3,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    t: n,
                    k: this,
                    p: new Map,
                    g: !1,
                    C: !1
                }, this;
            }
            r(n, Set);
            var t = n.prototype;
            return Object.defineProperty(t, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), t.has = function(n) {
                var r = this[Q];
                return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
            }, t.add = function(n) {
                var r = this[Q];
                return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
            }, t.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
            }, t.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (o(n), k(n), n.o.clear());
            }, t.values = function() {
                var n = this[Q];
                return u(n), o(n), n.o.values();
            }, t.entries = function() {
                var n = this[Q];
                return u(n), o(n), n.o.entries();
            }, t.keys = function() {
                return this.values();
            }, t[V] = function() {
                return this.values();
            }, t.forEach = function(n, r) {
                for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
            }, n;
        }();
        m("MapSet", {
            F: function(n, r) {
                return new f(n, r);
            },
            T: function(n, r) {
                return new c(n, r);
            }
        });
    }
    function J() {
        F(), C(), T();
    }
    function K(n) {
        return n;
    }
    function $(n) {
        return n;
    }
    var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
        0: "Illegal state",
        1: "Immer drafts cannot have computed properties",
        2: "This object has been frozen and should not be mutated",
        3: function(n) {
            return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
        },
        4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
        5: "Immer forbids circular references",
        6: "The first or second argument to `produce` must be a function",
        7: "The third argument to `produce` must be a function or undefined",
        8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
        9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
        10: "The given draft is already finalized",
        11: "Object.defineProperty() cannot be used on an Immer draft",
        12: "Object.setPrototypeOf() cannot be used on an Immer draft",
        13: "Immer only supports deleting array indices",
        14: "Immer only supports setting array indices and the 'length' property",
        15: function(n) {
            return "Cannot apply patch, path doesn't resolve: " + n;
        },
        16: 'Sets cannot have "replace" patches.',
        17: function(n) {
            return "Unsupported patch operation: " + n;
        },
        18: function(n) {
            return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
        },
        20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
        21: function(n) {
            return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
        },
        22: function(n) {
            return "'current' expects a draft, got: " + n;
        },
        23: function(n) {
            return "'original' expects a draft, got: " + n;
        },
        24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
    }, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
        return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
        var r = {};
        return nn(n).forEach(function(t) {
            r[t] = Object.getOwnPropertyDescriptor(n, t);
        }), r;
    }, tn = {}, en = {
        get: function(n, r) {
            if (r === Q) return n;
            var e = p(n);
            if (!u(e, r)) return function(n, r, t) {
                var e, i = I(r, t);
                return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
            }(n, e, r);
            var i = e[r];
            return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
        },
        has: function(n, r) {
            return r in p(n);
        },
        ownKeys: function(n) {
            return Reflect.ownKeys(p(n));
        },
        set: function(n, r, t) {
            var e = I(p(n), r);
            if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
            if (!n.P) {
                var i = z(p(n), r), o = null == i ? void 0 : i[Q];
                if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
                if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
                E(n), k(n);
            }
            return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
        },
        deleteProperty: function(n, r) {
            return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
        },
        getOwnPropertyDescriptor: function(n, r) {
            var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
            return e ? {
                writable: !0,
                configurable: 1 !== n.i || "length" !== r,
                enumerable: e.enumerable,
                value: t[r]
            } : e;
        },
        defineProperty: function() {
            n(11);
        },
        getPrototypeOf: function(n) {
            return Object.getPrototypeOf(n.t);
        },
        setPrototypeOf: function() {
            n(12);
        }
    }, on = {};
    i(en, function(n, r) {
        on[n] = function() {
            return arguments[0] = arguments[0][0], r.apply(this, arguments);
        };
    }), on.deleteProperty = function(r, t) {
        return on.set.call(this, r, t, void 0);
    }, on.set = function(r, t, e) {
        return en.set.call(this, r[0], t, e, r[0]);
    };
    var un = function() {
        function e(r) {
            var e = this;
            this.O = B, this.D = !0, this.produce = function(r, i, o) {
                if ("function" == typeof r && "function" != typeof i) {
                    var u = i;
                    i = r;
                    var a = e;
                    return function(n) {
                        var r = this;
                        void 0 === n && (n = u);
                        for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                        return a.produce(n, function(n) {
                            var t;
                            return (t = i).call.apply(t, [
                                r,
                                n
                            ].concat(e));
                        });
                    };
                }
                var f;
                if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                    var c = w(e), s = N(e, r, void 0), v = !0;
                    try {
                        f = i(s), v = !1;
                    } finally{
                        v ? g(c) : O(c);
                    }
                    return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                        return j(c, o), P(n, c);
                    }, function(n) {
                        throw g(c), n;
                    }) : (j(c, o), P(f, c));
                }
                if (!r || "object" != typeof r) {
                    if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                        var p = [], l = [];
                        b("Patches").M(r, f, p, l), o(p, l);
                    }
                    return f;
                }
                n(21, r);
            }, this.produceWithPatches = function(n, r) {
                if ("function" == typeof n) return function(r) {
                    for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                    return e.produceWithPatches(r, function(r) {
                        return n.apply(void 0, [
                            r
                        ].concat(i));
                    });
                };
                var t, i, o = e.produce(n, r, function(n, r) {
                    t = n, i = r;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                    return [
                        n,
                        t,
                        i
                    ];
                }) : [
                    o,
                    t,
                    i
                ];
            }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
        }
        var i = e.prototype;
        return i.createDraft = function(e) {
            t(e) || n(8), r(e) && (e = R(e));
            var i = w(this), o = N(this, e, void 0);
            return o[Q].C = !0, O(i), o;
        }, i.finishDraft = function(r, t) {
            var e = r && r[Q];
            var i = e.A;
            return j(i, t), P(void 0, i);
        }, i.setAutoFreeze = function(n) {
            this.D = n;
        }, i.setUseProxies = function(r) {
            r && !B && n(20), this.O = r;
        }, i.applyPatches = function(n, t) {
            var e;
            for(e = t.length - 1; e >= 0; e--){
                var i = t[e];
                if (0 === i.path.length && "replace" === i.op) {
                    n = i.value;
                    break;
                }
            }
            e > -1 && (t = t.slice(e + 1));
            var o = b("Patches").$;
            return r(n) ? o(n, t) : this.produce(n, function(n) {
                return o(n, t);
            });
        }, e;
    }(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
    var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;
});
parcelRegister("ee7sp", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$a5b82856cfbd137f$export$f51a9068ac82ea43);
    var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/vanilla.mjs"
    });
    const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
        let state;
        const listeners = new Set();
        const setState = (partial, replace)=>{
            const nextState = typeof partial === "function" ? partial(state) : partial;
            if (!Object.is(nextState, state)) {
                const previousState = state;
                state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
                listeners.forEach((listener)=>listener(state, previousState));
            }
        };
        const getState = ()=>state;
        const getInitialState = ()=>initialState;
        const subscribe = (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        };
        const destroy = ()=>{
            if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
            listeners.clear();
        };
        const api = {
            setState: setState,
            getState: getState,
            getInitialState: getInitialState,
            subscribe: subscribe,
            destroy: destroy
        };
        const initialState = state = createState(setState, getState, api);
        return api;
    };
    const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
    var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
        return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
    };
});
parcelRegister("5eAc2", function(module, exports) {
    $parcel$export(module.exports, "StargateClient", ()=>$0084b28d1d44d0da$export$c66ca190f89caaac);
    class $0084b28d1d44d0da$export$c66ca190f89caaac {
        constructor(baseUrl){
            this.baseUrl = baseUrl || '/gateway/api';
        }
        async fetchToken(clientId) {
            return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
                credentials: 'include',
                headers: {
                    'x-client-id': clientId
                }
            })).json();
        }
        isTokenExpired(token) {
            const currentTimeInSeconds = new Date().getTime() / 1000;
            return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
        }
    }
});
parcelRegister("hUEMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ais1M").then(()=>parcelRequire('piTsY'));
});
parcelRegister("c75hs", function(module, exports) {
    $parcel$export(module.exports, "useEmitAttachmentMetrics", ()=>$8d1a3c12749d62b3$export$3266ff6df305d226);
    var $5uXOq = parcelRequire("5uXOq");
    var $2hW3Y = parcelRequire("2hW3Y");
    var $2NMNM;
    var $h8yj2;
    var $6Pi9E;
    var $erWXD;
    var $iu3cq;
    const $8d1a3c12749d62b3$export$3266ff6df305d226 = (formStore, view)=>{
        const { mediaApiReadToken: mediaApiReadToken, mediaUploadAndViewContexts: mediaUploadAndViewContexts, projectId: projectId, portalId: portalId, issueKey: issueKey } = (0, (0, parcelRequire("iu3cq")).useMediaContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (view && formStore.numberOfAttachment > 0) try {
                var _mediaUploadAndViewCo;
                const viewContextToken = mediaUploadAndViewContexts ? (_mediaUploadAndViewCo = mediaUploadAndViewContexts.viewContext) === null || _mediaUploadAndViewCo === void 0 ? void 0 : _mediaUploadAndViewCo.token : mediaApiReadToken ? (0, (0, parcelRequire("6Pi9E")).transformReadAttachmentsToken)(mediaApiReadToken).token : null;
                let viewableIds = new Set();
                if (viewContextToken) {
                    const { access: access } = (0, ($parcel$interopDefault($2hW3Y)))(viewContextToken);
                    const viewableFiles = Object.entries(access).filter(([_, value])=>value.includes('read'));
                    viewableIds = new Set(viewableFiles.flatMap(([key, _])=>key.split(':')[3]));
                }
                const brokenFiles = formStore.questions.filter((questionStore)=>questionStore.formQuestion.type === 'at').flatMap((questionStore)=>{
                    const attachments = questionStore.currentAnswer;
                    return attachments.filter((attachment)=>!viewableIds.has(attachment.id));
                });
                const attachmentIdCreationDtStr = (attachments)=>{
                    return attachments.map((attachment)=>`${attachment.id}: ${attachment.creationDate}`).join(', ');
                };
                if (brokenFiles.length > 0) (0, (0, parcelRequire("h8yj2")).fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).ATTACHMENT_VIEWER_CARD,
                    action: (0, (0, parcelRequire("erWXD")).Action).FAILED
                }), `${(0, (0, parcelRequire("erWXD")).ActionSubject).ATTACHMENT_VIEWER_CARD} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, projectId ? {
                    projectId: projectId,
                    issueKey: issueKey,
                    attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
                } : {
                    portalId: portalId,
                    issueKey: issueKey,
                    attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
                });
            } catch (error) {
                (0, (0, parcelRequire("h8yj2")).fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).ATTACHMENT_VIEWER_CARD,
                    action: (0, (0, parcelRequire("erWXD")).Action).FAILED
                }), `${(0, (0, parcelRequire("erWXD")).ActionSubject).ATTACHMENT_VIEWER_CARD} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, projectId ? {
                    projectId: projectId,
                    issueKey: issueKey,
                    error: JSON.stringify(error)
                } : {
                    portalId: portalId,
                    issueKey: issueKey,
                    error: JSON.stringify(error)
                });
            }
        }, [
            createAnalyticsEvent,
            issueKey,
            portalId,
            projectId
        ]);
    };
});
parcelRegister("2hW3Y", function(module, exports) {
    'use strict';
    var $2ep83 = parcelRequire("2ep83");
    function $1aaa356e5fda3e32$var$InvalidTokenError(message) {
        this.message = message;
    }
    $1aaa356e5fda3e32$var$InvalidTokenError.prototype = new Error();
    $1aaa356e5fda3e32$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
    module.exports = function(token, options) {
        if (typeof token !== 'string') throw new $1aaa356e5fda3e32$var$InvalidTokenError('Invalid token specified');
        options = options || {};
        var pos = options.header === true ? 0 : 1;
        try {
            return JSON.parse($2ep83(token.split('.')[pos]));
        } catch (e) {
            throw new $1aaa356e5fda3e32$var$InvalidTokenError('Invalid token specified: ' + e.message);
        }
    };
    module.exports.InvalidTokenError = $1aaa356e5fda3e32$var$InvalidTokenError;
});
parcelRegister("2ep83", function(module, exports) {
    var $byIqd = parcelRequire("byIqd");
    function $1a0061a3b7e63481$var$b64DecodeUnicode(str) {
        return decodeURIComponent($byIqd(str).replace(/(.)/g, function(m, p) {
            var code = p.charCodeAt(0).toString(16).toUpperCase();
            if (code.length < 2) code = '0' + code;
            return '%' + code;
        }));
    }
    module.exports = function(str) {
        var output = str.replace(/-/g, "+").replace(/_/g, "/");
        switch(output.length % 4){
            case 0:
                break;
            case 2:
                output += "==";
                break;
            case 3:
                output += "=";
                break;
            default:
                throw "Illegal base64url string!";
        }
        try {
            return $1a0061a3b7e63481$var$b64DecodeUnicode(output);
        } catch (err) {
            return $byIqd(output);
        }
    };
});
parcelRegister("byIqd", function(module, exports) {
    var $86a553e97b24e6ed$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    function $86a553e97b24e6ed$var$InvalidCharacterError(message) {
        this.message = message;
    }
    $86a553e97b24e6ed$var$InvalidCharacterError.prototype = new Error();
    $86a553e97b24e6ed$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    function $86a553e97b24e6ed$var$polyfill(input) {
        var str = String(input).replace(/=+$/, '');
        if (str.length % 4 == 1) throw new $86a553e97b24e6ed$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
        for(var bc = 0, bs, buffer, idx = 0, output = ''; buffer = str.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))buffer = $86a553e97b24e6ed$var$chars.indexOf(buffer);
        return output;
    }
    module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $86a553e97b24e6ed$var$polyfill;
});
parcelRegister("6Pi9E", function(module, exports) {
    $parcel$export(module.exports, "transformReadAttachmentsToken", ()=>$4f8596a17a4dbe84$export$12a604fa4698eff2);
    $parcel$export(module.exports, "formatFilesWithEditActions", ()=>$4f8596a17a4dbe84$export$3d6c93fa1d202edb);
    $parcel$export(module.exports, "formatFilesWithViewActions", ()=>$4f8596a17a4dbe84$export$42b47cfb0cc8860f);
    $parcel$export(module.exports, "sortFilesYoungestFirstOnLeft", ()=>$4f8596a17a4dbe84$export$9b74b6d805ca078c);
    var $5uXOq = parcelRequire("5uXOq");
    var $hUqzg;
    const $4f8596a17a4dbe84$export$4d271852dd07ca26 = (token)=>{
        let decodedToken;
        try {
            decodedToken = JSON.parse(atob(token.split('.')[1]));
        } catch (error) {
            return {
                tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
                localTimeDelta: undefined,
                tokenExpiryTime: undefined
            };
        }
        const startTimestamp = decodedToken.iat || decodedToken.nbf;
        const getLocalTimeDeltaMilliseconds = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() : undefined;
        return {
            tokenDecodeError: undefined,
            localTimeDelta: getLocalTimeDeltaMilliseconds(startTimestamp * 1000),
            tokenExpiryTime: decodedToken.exp * 1000
        };
    };
    const $4f8596a17a4dbe84$export$12a604fa4698eff2 = (readAttachmentsToken)=>{
        const getFirstTokenIfAvailable = (tokensWithFiles)=>tokensWithFiles.length > 0 ? tokensWithFiles[0].token : null;
        const token = getFirstTokenIfAvailable(readAttachmentsToken.tokensWithFiles);
        const tokenProps = typeof token === 'string' ? $4f8596a17a4dbe84$export$4d271852dd07ca26(token) : {};
        return {
            clientId: readAttachmentsToken.clientId,
            serviceHost: readAttachmentsToken.endpointUrl,
            token: token,
            areTokenPermissionsUpToDate: true,
            tokenLifespanInMs: readAttachmentsToken.tokenLifespanInSeconds * 1000,
            tokenIssueTimestamp: Date.now() - 10000,
            collection: null,
            tokenDecodeError: tokenProps.tokenDecodeError,
            localTimeDelta: tokenProps.localTimeDelta,
            tokenExpiryTime: tokenProps.tokenExpiryTime
        };
    };
    const $4f8596a17a4dbe84$export$e094e7a8aa55f6c7 = (uploadToken)=>{
        return {
            clientId: uploadToken.clientId,
            serviceHost: uploadToken.endpointUrl,
            token: uploadToken.token,
            tokenLifespanInMs: uploadToken.tokenDurationInMins * 60000,
            collection: uploadToken.targetCollection,
            tokenIssueTimestamp: Date.now() - 10000
        };
    };
    const $4f8596a17a4dbe84$export$3ceb62baab058c6b = ({ readToken: readToken, uploadToken: uploadToken })=>{
        return {
            viewContext: readToken ? $4f8596a17a4dbe84$export$12a604fa4698eff2(readToken) : null,
            uploadContext: uploadToken ? $4f8596a17a4dbe84$export$e094e7a8aa55f6c7(uploadToken) : null
        };
    };
    const $4f8596a17a4dbe84$export$3d6c93fa1d202edb = (files, mediaClientConfig, collection, removeFile)=>{
        const toBeUploadedFiles = [];
        files.forEach((file)=>{
            toBeUploadedFiles.push({
                identifier: {
                    id: file.id,
                    mediaItemType: 'file',
                    collectionName: collection
                },
                info: {
                    ...file
                },
                mediaClientConfig: mediaClientConfig,
                actions: [
                    {
                        handler: removeFile,
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hUqzg"))))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: "Delete"
                        }),
                        label: 'Delete'
                    }
                ]
            });
        });
        return toBeUploadedFiles;
    };
    const $4f8596a17a4dbe84$export$42b47cfb0cc8860f = (files, mediaClientConfig, collection)=>{
        const toBeUploadedFiles = [];
        files.forEach((file)=>{
            toBeUploadedFiles.push({
                identifier: {
                    id: file.id,
                    mediaItemType: 'file',
                    collectionName: collection
                },
                info: {
                    ...file
                },
                mediaClientConfig: mediaClientConfig,
                actions: []
            });
        });
        return toBeUploadedFiles;
    };
    const $4f8596a17a4dbe84$export$9b74b6d805ca078c = (a, b)=>{
        return b.info.creationDate && a.info.creationDate ? b.info.creationDate - a.info.creationDate : 0;
    };
});
parcelRegister("hUqzg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d09c4671709f5c19$var$_react = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d09c4671709f5c19$var$_delete = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    var $d09c4671709f5c19$var$_trash = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("3fOYK")));
    function $d09c4671709f5c19$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d09c4671709f5c19$var$DeleteIcon = (props)=>$d09c4671709f5c19$var$_react.default.createElement($d09c4671709f5c19$var$_delete.default, Object.assign({
            LEGACY_fallbackIcon: $d09c4671709f5c19$var$_trash.default
        }, props));
    $d09c4671709f5c19$var$DeleteIcon.Name = 'DeleteIconMigration';
    var $d09c4671709f5c19$var$_default = module.exports.default = $d09c4671709f5c19$var$DeleteIcon;
});
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_UNSAFE_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("3fOYK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25ea512a3c153cf8$var$_react = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25ea512a3c153cf8$var$_delete = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    function $25ea512a3c153cf8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25ea512a3c153cf8$var$TrashIcon = (props)=>$25ea512a3c153cf8$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
        }, props, {
            newIcon: $25ea512a3c153cf8$var$_delete.default
        }));
    $25ea512a3c153cf8$var$TrashIcon.displayName = 'TrashIcon';
    var $25ea512a3c153cf8$var$_default = module.exports.default = $25ea512a3c153cf8$var$TrashIcon;
});
parcelRegister("dwM46", function(module, exports) {
    $parcel$export(module.exports, "HtmlExtension", ()=>$9d938c3fc1de63f6$export$d8b28a189603eb0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kOFhM;
    var $mqniY;
    var $hYNZx;
    var $f5oqj;
    const $9d938c3fc1de63f6$export$d8b28a189603eb0a = ({ extensionId: extensionId, htmlContent: htmlContent })=>{
        try {
            const jiraTransformer = new (0, (0, parcelRequire("mqniY")).JIRATransformer)((0, (0, parcelRequire("kOFhM")).defaultSchema));
            const adfTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
            const pmNode = jiraTransformer.parse(htmlContent);
            const adf = adfTransformer.encode(pmNode);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
                key: extensionId,
                document: adf
            });
        } catch (err) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        }
    };
});
parcelRegister("mqniY", function(module, exports) {
    $parcel$export(module.exports, "JIRATransformer", ()=>$bd978b23c1273cd5$export$f47bcfd72ef563cc);
    var $kCV8T;
    var $7VmzL;
    var $2Tfyt;
    var $jTDkI;
    var $5Sc2i;
    class $bd978b23c1273cd5$export$f47bcfd72ef563cc {
        constructor(schema, customEncoders, mediaContextInfo){
            this.schema = schema;
            this.customEncoders = customEncoders || {};
            this.mediaContextInfo = mediaContextInfo;
        }
        encode(node) {
            this.doc = this.makeDocument();
            this.doc.body.appendChild(this.encodeFragment(node.content));
            const html = this.doc.body.innerHTML;
            if (html === '<p></p>') return '';
            return html.replace(/<br><\/br>/g, '<br />').replace(/<br>/g, '<br />').replace(/<hr><\/hr>/g, '<hr />').replace(/<hr>/g, '<hr />').replace(/&amp;/g, '&');
        }
        parse(html) {
            const convertedNodes = new WeakMap();
            const dom = (0, (0, parcelRequire("2Tfyt")).default)((0, (0, parcelRequire("7VmzL")).default)(html)).querySelector('body');
            const nodes = (0, (0, parcelRequire("jTDkI")).bfsOrder)(dom);
            if (nodes.length === 1 && nodes[0].textContent === '\xa0') {
                const schemaNodes = this.schema.nodes;
                return schemaNodes.doc.createChecked({}, schemaNodes.paragraph.createChecked());
            }
            for(let i = nodes.length - 1; i >= 0; i--){
                const node = nodes[i];
                const targetNode = node.tagName && node.tagName.toUpperCase() === 'TABLE' ? node.firstChild : node;
                const content = this.getContent(targetNode, convertedNodes);
                const candidate = (0, (0, parcelRequire("jTDkI")).convert)(content, node, this.schema);
                if (typeof candidate !== 'undefined') convertedNodes.set(node, candidate);
            }
            const content = this.getContent(dom, convertedNodes);
            const compatibleContent = this.schema.nodes.doc.validContent(content) ? content : (0, (0, parcelRequire("jTDkI")).ensureBlocks)(content, this.schema);
            return this.schema.nodes.doc.createChecked({}, compatibleContent);
        }
        getContent(node, convertedNodes) {
            let fragment = (0, (0, parcelRequire("kCV8T")).Fragment).fromArray([]);
            let childIndex;
            for(childIndex = 0; childIndex < node.childNodes.length; childIndex++){
                const child = node.childNodes[childIndex];
                const thing = convertedNodes.get(child);
                if (thing instanceof (0, (0, parcelRequire("kCV8T")).Fragment) || thing instanceof (0, (0, parcelRequire("kCV8T")).Node)) fragment = fragment.append((0, (0, parcelRequire("kCV8T")).Fragment).from(thing));
            }
            return fragment;
        }
        encodeNode(node) {
            const { blockquote: blockquote, bulletList: bulletList, codeBlock: codeBlock, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, emoji: emoji, orderedList: orderedList, paragraph: paragraph, rule: rule, mediaInline: mediaInline, mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media, table: table } = this.schema.nodes;
            if (node.isText) return this.encodeText(node);
            else if (node.type.name === heading.name) return this.encodeHeading(node);
            else if (node.type.name === rule.name) return this.encodeHorizontalRule();
            else if (node.type.name === paragraph.name) return this.encodeParagraph(node);
            else if (node.type.name === hardBreak.name) return this.encodeHardBreak();
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithLists)(this.schema)) {
                if (node.type.name === bulletList.name) return this.encodeBulletList(node);
                else if (node.type.name === orderedList.name) return this.encodeOrderedList(node);
                else if (node.type.name === listItem.name) return this.encodeListItem(node);
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithMentions)(this.schema) && node.type.name === mention.name) return this.encodeMention(node, this.customEncoders.mention);
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithEmojis)(this.schema) && node.type.name === emoji.name) return this.encodeEmoji(node);
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithCodeBlock)(this.schema) && node.type.name === codeBlock.name) return this.encodeCodeBlock(node);
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithBlockQuotes)(this.schema) && node.type.name === blockquote.name) return this.encodeBlockQuote(node);
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithMedia)(this.schema)) {
                if (node.type.name === mediaGroup.name) return this.encodeMediaGroup(node);
                else if (node.type.name === mediaSingle.name) return this.encodeMediaSingle(node);
                else if (node.type.name === media.name || node.type.name === mediaInline.name) return this.encodeMedia(node);
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithTables)(this.schema) && node.type.name === table.name) return this.encodeTable(node);
            throw new Error(`Unexpected node '${node.type.name}' for HTML encoding`);
        }
        makeDocument() {
            const doc = document.implementation.createHTMLDocument('');
            doc.body = doc.createElement('body');
            doc.documentElement.appendChild(doc.body);
            return doc;
        }
        encodeFragment(fragment) {
            const documentFragment = this.doc.createDocumentFragment();
            fragment.forEach((node)=>documentFragment.appendChild(this.encodeNode(node)));
            return documentFragment;
        }
        encodeHeading(node) {
            function anchorNameEncode(name) {
                const noSpaces = name.replace(/ /g, '');
                const uriEncoded = encodeURIComponent(noSpaces);
                const specialsEncoded = uriEncoded.replace(/[!'()*]/g, (c)=>'%' + c.charCodeAt(0).toString(16));
                return specialsEncoded;
            }
            const { level: level } = node.attrs;
            const elem = this.doc.createElement(`h${level === 6 ? 5 : level}`);
            const anchor = this.doc.createElement('a');
            anchor.setAttribute('name', anchorNameEncode(node.textContent));
            elem.appendChild(anchor);
            elem.appendChild(this.encodeFragment(node.content));
            return elem;
        }
        encodeParagraph(node) {
            const elem = this.doc.createElement('p');
            elem.appendChild(this.encodeFragment(node.content));
            return elem;
        }
        encodeText(node) {
            if (node.text) {
                const root = this.doc.createDocumentFragment();
                let elem = root;
                const { code: code, em: em, link: link, typeAheadQuery: typeAheadQuery, strike: strike, strong: strong, subsup: subsup, underline: underline, textColor: textColor } = this.schema.marks;
                for (const mark of node.marks)switch(mark.type){
                    case strong:
                        elem = elem.appendChild(this.doc.createElement('b'));
                        break;
                    case em:
                        elem = elem.appendChild(this.doc.createElement('em'));
                        break;
                    case code:
                        elem = elem.appendChild(this.doc.createElement('tt'));
                        break;
                    case strike:
                        elem = elem.appendChild(this.doc.createElement('del'));
                        break;
                    case underline:
                        elem = elem.appendChild(this.doc.createElement('ins'));
                        break;
                    case subsup:
                        elem = elem.appendChild(this.doc.createElement(mark.attrs['type']));
                        break;
                    case link:
                        const linkElem = this.doc.createElement('a');
                        const href = mark.attrs['href'];
                        if (!href.match(/^#/)) {
                            linkElem.setAttribute('class', 'external-link');
                            linkElem.setAttribute('rel', 'nofollow');
                        }
                        linkElem.setAttribute('href', href);
                        if (mark.attrs['title']) linkElem.setAttribute('title', mark.attrs['title']);
                        elem = elem.appendChild(linkElem);
                        break;
                    case textColor:
                        const fontElem = this.doc.createElement('font');
                        fontElem.setAttribute('color', mark.attrs['color']);
                        elem = elem.appendChild(fontElem);
                        break;
                    case typeAheadQuery:
                        break;
                    default:
                        throw new Error(`Unable to encode mark '${mark.type.name}'`);
                }
                elem.textContent = node.text;
                return root;
            } else return this.doc.createTextNode('');
        }
        encodeHardBreak() {
            return this.doc.createElement('br');
        }
        encodeHorizontalRule() {
            return this.doc.createElement('hr');
        }
        encodeBulletList(node) {
            const elem = this.doc.createElement('ul');
            elem.setAttribute('class', 'alternate');
            elem.setAttribute('type', 'disc');
            elem.appendChild(this.encodeFragment(node.content));
            for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ul');
            return elem;
        }
        encodeOrderedList(node) {
            const elem = this.doc.createElement('ol');
            elem.appendChild(this.encodeFragment(node.content));
            for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ol');
            return elem;
        }
        encodeListItem(node) {
            const elem = this.doc.createElement('li');
            if (node.content.childCount) {
                let hasBlocks = false;
                node.content.forEach((childNode)=>{
                    if (childNode.type === this.schema.nodes.bulletList || childNode.type === this.schema.nodes.orderedList) {
                        const list = this.encodeNode(childNode);
                        if (list instanceof HTMLElement && list.tagName === 'UL') {
                            list.setAttribute('type', 'circle');
                            [].forEach.call(list.querySelectorAll('ul'), (ul)=>{
                                ul.setAttribute('type', 'square');
                            });
                        }
                        elem.appendChild(list);
                    } else if (childNode.type.name === 'paragraph' && !hasBlocks) elem.appendChild(this.encodeFragment(childNode.content));
                    else {
                        if (childNode.isBlock) hasBlocks = true;
                        elem.appendChild(this.encodeNode(childNode));
                    }
                });
            }
            return elem;
        }
        encodeMention(node, encoder) {
            const elem = this.doc.createElement('a');
            elem.setAttribute('class', 'user-hover');
            elem.setAttribute('href', encoder ? encoder(node.attrs.id) : node.attrs.id);
            elem.setAttribute('rel', node.attrs.id);
            elem.appendChild(this.doc.createTextNode(node.attrs.text));
            return elem;
        }
        encodeEmoji(node) {
            return this.doc.createTextNode(node.attrs && node.attrs.text);
        }
        encodeCodeBlock(node) {
            const elem = this.doc.createElement('div');
            elem.setAttribute('class', 'code panel');
            const content = this.doc.createElement('div');
            content.setAttribute('class', 'codeContent panelContent');
            const pre = this.doc.createElement('pre');
            pre.setAttribute('class', `code-${(node.attrs.language || 'plain').toLocaleLowerCase()}`);
            pre.appendChild(this.encodeFragment(node.content));
            content.appendChild(pre);
            elem.appendChild(content);
            return elem;
        }
        encodeBlockQuote(node) {
            const elem = this.doc.createElement('blockquote');
            elem.appendChild(this.encodeFragment(node.content));
            return elem;
        }
        encodeMediaGroup(node) {
            const elem = this.doc.createElement('p');
            elem.setAttribute('class', 'mediaGroup');
            elem.appendChild(this.encodeFragment(node.content));
            return elem;
        }
        encodeMediaSingle(node) {
            const elem = this.doc.createElement('p');
            elem.setAttribute('class', 'mediaSingle');
            elem.appendChild(this.encodeFragment(node.content));
            return elem;
        }
        addDataToNode(domNode, mediaNode, defaultDisplayType = 'thumbnail') {
            const { id: id, type: type, collection: collection, __fileName: __fileName, __displayType: __displayType, width: width, height: height } = mediaNode.attrs;
            domNode.setAttribute('data-attachment-type', __displayType || defaultDisplayType);
            if (__fileName) domNode.setAttribute('data-attachment-name', __fileName);
            if (width) domNode.setAttribute('data-width', width);
            if (height) domNode.setAttribute('data-height', height);
            domNode.setAttribute('data-media-services-type', type);
            domNode.setAttribute('data-media-services-id', id);
            if (collection) domNode.setAttribute('data-media-services-collection', collection);
        }
        buildURLWithContextInfo(fileId, contextInfo) {
            const { clientId: clientId, baseUrl: baseUrl, token: token, collection: collection } = contextInfo;
            return `${baseUrl}/file/${fileId}/image?token=${token}&client=${clientId}&collection=${collection}&width=200&height=200&mode=fit`;
        }
        isImageMimeType(mimeType) {
            return mimeType && mimeType.indexOf('image/') > -1;
        }
        encodeMedia(node) {
            const elem = this.doc.createElement('span');
            const a = this.doc.createElement('a');
            if (node.attrs.__displayType === 'file' || !(node.attrs.__displayType || this.isImageMimeType(node.attrs.__fileMimeType))) {
                elem.setAttribute('class', 'nobr');
                this.addDataToNode(a, node, 'file');
                a.textContent = node.attrs.__fileName || '';
            } else {
                elem.setAttribute('class', 'image-wrap');
                const img = this.doc.createElement('img');
                img.setAttribute('alt', node.attrs.__fileName);
                if (node.attrs.collection && this.mediaContextInfo && this.mediaContextInfo.uploadContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.uploadContext));
                else if (this.mediaContextInfo && this.mediaContextInfo.viewContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.viewContext));
                this.addDataToNode(img, node);
                const jiraThumb = this.doc.createElement('jira-attachment-thumbnail');
                jiraThumb.appendChild(img);
                a.appendChild(jiraThumb);
            }
            elem.appendChild(a);
            return elem;
        }
        encodeTable(node) {
            const elem = this.doc.createElement('table');
            const tbody = this.doc.createElement('tbody');
            node.descendants((rowNode)=>{
                const rowElement = this.doc.createElement('tr');
                rowNode.descendants((colNode)=>{
                    const cellType = colNode.type === this.schema.nodes.tableCell ? 'd' : 'h';
                    const cellElement = this.doc.createElement(`t${cellType}`);
                    cellElement.setAttribute('class', `confluenceT${cellType}`);
                    cellElement.appendChild(this.encodeFragment(colNode.content));
                    rowElement.appendChild(cellElement);
                    return false;
                });
                tbody.appendChild(rowElement);
                return false;
            });
            elem.appendChild(tbody);
            elem.setAttribute('class', 'confluenceTable');
            return elem;
        }
    }
});
parcelRegister("7VmzL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$169410671f3481c4$export$2e2bcd8739ae039);
    var $3S9yy;
    function $169410671f3481c4$export$2e2bcd8739ae039(fragment) {
        const html = `<!doctype html><html><body>${fragment}</body></html>`;
        const parser = new window.DOMParser();
        const tree = parser.parseFromString(html, 'text/html');
        (0, (0, parcelRequire("3S9yy")).default)(tree.documentElement, $169410671f3481c4$var$isBlock);
        return tree;
    }
    function $169410671f3481c4$var$isBlock(node) {
        switch(node.nodeName.toUpperCase()){
            case 'ADDRESS':
            case 'ARTICLE':
            case 'ASIDE':
            case 'AUDIO':
            case 'BLOCKQUOTE':
            case 'BODY':
            case 'CANVAS':
            case 'CENTER':
            case 'DD':
            case 'DIR':
            case 'DIV':
            case 'DL':
            case 'DT':
            case 'FIELDSET':
            case 'FIGCAPTION':
            case 'FIGURE':
            case 'FOOTER':
            case 'FORM':
            case 'FRAMESET':
            case 'H1':
            case 'H2':
            case 'H3':
            case 'H4':
            case 'H5':
            case 'H6':
            case 'HEADER':
            case 'HGROUP':
            case 'HR':
            case 'HTML':
            case 'ISINDEX':
            case 'LI':
            case 'MAIN':
            case 'MENU':
            case 'NAV':
            case 'NOFRAMES':
            case 'NOSCRIPT':
            case 'OL':
            case 'OUTPUT':
            case 'P':
            case 'PRE':
            case 'SECTION':
            case 'TABLE':
            case 'TBODY':
            case 'TD':
            case 'TFOOT':
            case 'TH':
            case 'THEAD':
            case 'TR':
            case 'UL':
                return true;
        }
        return false;
    }
});
parcelRegister("3S9yy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43b92098fbb2da37$export$2e2bcd8739ae039);
    var $djRVT = parcelRequire("djRVT");
    const $43b92098fbb2da37$var$collapseWhitespace = (0, ($parcel$interopDefault($djRVT)));
    var $43b92098fbb2da37$export$2e2bcd8739ae039 = $43b92098fbb2da37$var$collapseWhitespace;
});
parcelRegister("djRVT", function(module, exports) {
    'use strict';
    var $gZtrJ = parcelRequire("gZtrJ");
    Object.keys($gZtrJ).forEach(function(name) {
        $gZtrJ[name.toUpperCase()] = 1;
    });
    var $9b26e2a3640f01c2$var$blockElements = {};
    (parcelRequire("b6Htb")).forEach(function(name) {
        $9b26e2a3640f01c2$var$blockElements[name.toUpperCase()] = 1;
    });
    function $9b26e2a3640f01c2$var$isBlockElem(node) {
        return !!(node && $9b26e2a3640f01c2$var$blockElements[node.nodeName]);
    }
    function $9b26e2a3640f01c2$var$isPreElem(node) {
        return node.nodeName === 'PRE';
    }
    function $9b26e2a3640f01c2$var$isVoid(node) {
        return !!(node && $gZtrJ[node.nodeName]);
    }
    function $9b26e2a3640f01c2$var$collapseWhitespace(elem, isBlock, isPre) {
        if (!elem.firstChild || elem.nodeName === 'PRE') return;
        if (typeof isBlock !== 'function') isBlock = $9b26e2a3640f01c2$var$isBlockElem;
        if (typeof isPre !== 'function') isPre = $9b26e2a3640f01c2$var$isPreElem;
        var prevText = null;
        var prevVoid = false;
        var prev = null;
        var node = $9b26e2a3640f01c2$var$next(prev, elem, isPre);
        while(node !== elem){
            if (node.nodeType === 3 || node.nodeType === 4) {
                var text = node.data.replace(/[ \r\n\t]+/g, ' ');
                if ((!prevText || / $/.test(prevText.data)) && !prevVoid && text[0] === ' ') text = text.substr(1);
                if (!text) {
                    node = $9b26e2a3640f01c2$var$remove(node);
                    continue;
                }
                node.data = text;
                prevText = node;
            } else if (node.nodeType === 1) {
                if (isBlock(node) || node.nodeName === 'BR') {
                    if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                    prevText = null;
                    prevVoid = false;
                } else if ($9b26e2a3640f01c2$var$isVoid(node)) {
                    prevText = null;
                    prevVoid = true;
                }
            } else {
                node = $9b26e2a3640f01c2$var$remove(node);
                continue;
            }
            var nextNode = $9b26e2a3640f01c2$var$next(prev, node, isPre);
            prev = node;
            node = nextNode;
        }
        if (prevText) {
            prevText.data = prevText.data.replace(/ $/, '');
            if (!prevText.data) $9b26e2a3640f01c2$var$remove(prevText);
        }
    }
    function $9b26e2a3640f01c2$var$remove(node) {
        var next = node.nextSibling || node.parentNode;
        node.parentNode.removeChild(node);
        return next;
    }
    function $9b26e2a3640f01c2$var$next(prev, current, isPre) {
        if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
        return current.firstChild || current.nextSibling || current.parentNode;
    }
    module.exports = $9b26e2a3640f01c2$var$collapseWhitespace;
});
parcelRegister("gZtrJ", function(module, exports) {
    module.exports = {
        "area": true,
        "base": true,
        "br": true,
        "col": true,
        "embed": true,
        "hr": true,
        "img": true,
        "input": true,
        "keygen": true,
        "link": true,
        "menuitem": true,
        "meta": true,
        "param": true,
        "source": true,
        "track": true,
        "wbr": true
    };
});
parcelRegister("b6Htb", function(module, exports) {
    module.exports = [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "dd",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "section",
        "table",
        "tfoot",
        "ul",
        "video"
    ];
});
parcelRegister("2Tfyt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ab1d496749306c5$export$2e2bcd8739ae039);
    function $6ab1d496749306c5$var$getNodeName(node) {
        return node && node.nodeName.toUpperCase();
    }
    function $6ab1d496749306c5$var$isMedia(node) {
        if (!node) return false;
        if ($6ab1d496749306c5$var$getNodeName(node) === 'SPAN' && node instanceof HTMLElement) return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
        return false;
    }
    function $6ab1d496749306c5$var$repairParagraph(p) {
        const paragraphs = [];
        let buffer = [];
        let mediaGroupFound = false;
        let skipBuffer = false;
        const processMedia = ()=>{
            if (buffer.length) {
                const head = buffer[0];
                if ($6ab1d496749306c5$var$getNodeName(head) === 'BR') buffer.shift();
                paragraphs.push(buffer);
                buffer = [];
            }
        };
        for(let i = 0, length = p.childNodes.length; i < length; i++){
            const node = p.childNodes[i];
            skipBuffer = false;
            if ($6ab1d496749306c5$var$getNodeName(node) === 'BR') {
                if (mediaGroupFound) {
                    processMedia();
                    mediaGroupFound = false;
                    skipBuffer = true;
                }
                if ($6ab1d496749306c5$var$isMedia(node.nextSibling)) {
                    mediaGroupFound = true;
                    if (buffer.length) {
                        paragraphs.push(buffer);
                        buffer = [];
                    }
                }
            } else if ($6ab1d496749306c5$var$isMedia(node)) {
                if (node.previousSibling === null) mediaGroupFound = true;
            } else if (mediaGroupFound) {
                if ($6ab1d496749306c5$var$getNodeName(node) === '#TEXT' && (node.textContent || '').trim() === '') continue;
                buffer = (paragraphs.pop() || []).concat(buffer);
                mediaGroupFound = false;
            }
            if (!skipBuffer) buffer.push(node);
        }
        if (mediaGroupFound) processMedia();
        else paragraphs.push(buffer);
        if (paragraphs.length > 1) {
            const fragment = document.createDocumentFragment();
            paragraphs.forEach((childP)=>{
                const innerP = document.createElement('p');
                childP.forEach((child)=>innerP.appendChild(child));
                fragment.appendChild(innerP);
            });
            const parent = p.parentNode;
            parent.insertBefore(fragment, p.nextSibling);
            parent.removeChild(p);
        }
    }
    function $6ab1d496749306c5$export$2e2bcd8739ae039(doc) {
        const paragraphs = doc.querySelectorAll('p');
        for(let i = 0, length = paragraphs.length; i < length; i++)$6ab1d496749306c5$var$repairParagraph(paragraphs[i]);
        return doc;
    }
});
parcelRegister("jTDkI", function(module, exports) {
    $parcel$export(module.exports, "ensureBlocks", ()=>$70a5644617f486cc$export$c389196451c598e2);
    $parcel$export(module.exports, "convert", ()=>$70a5644617f486cc$export$9c68d69a4c5bbcf9);
    $parcel$export(module.exports, "bfsOrder", ()=>$70a5644617f486cc$export$6f3da03763fd5ca0);
    var $51H8P;
    var $5Sc2i;
    var $kCV8T;
    var $8V12i;
    function $70a5644617f486cc$export$c389196451c598e2(fragment, schema, nodeType) {
        if (schema.nodes.paragraph.validContent(fragment)) return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray([
            schema.nodes.paragraph.createChecked({}, fragment)
        ]);
        const blockNodes = [];
        if (nodeType && nodeType === schema.nodes.listItem && fragment.firstChild && (fragment.firstChild.type === schema.nodes.bulletList || fragment.firstChild.type === schema.nodes.orderedList)) blockNodes.push(schema.nodes.paragraph.createAndFill());
        fragment.forEach((child)=>{
            if (child.isBlock) blockNodes.push(child);
            else blockNodes.push(schema.nodes.paragraph.createChecked({}, child));
        });
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(blockNodes);
    }
    const $70a5644617f486cc$export$5cb2cb6b3b363caa = (schema, content, supportedMarks)=>{
        const result = [];
        content.forEach((node)=>{
            if (node.isInline) {
                const filteredMarks = node.marks.filter((mark)=>mark.isInSet(supportedMarks));
                result.push(node.mark(filteredMarks));
                return;
            }
            result.push(schema.text(node.textContent));
        });
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(result);
    };
    function $70a5644617f486cc$export$9c68d69a4c5bbcf9(content, node, schema) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            return text ? schema.text(text) : null;
        }
        if (node instanceof HTMLElement) {
            const tag = node.tagName.toUpperCase();
            switch(tag){
                case 'DEL':
                    if (!(0, (0, parcelRequire("5Sc2i")).isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.strike.create()
                    ]);
                case 'B':
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.strong.create()
                    ]);
                case 'EM':
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.em.create()
                    ]);
                case 'TT':
                    if (!(0, (0, parcelRequire("5Sc2i")).isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.code.create()
                    ]);
                case 'SUB':
                case 'SUP':
                    if (!(0, (0, parcelRequire("5Sc2i")).isSchemaWithSubSupMark)(schema)) return null;
                    const type = tag === 'SUB' ? 'sub' : 'sup';
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.subsup.create({
                            type: type
                        })
                    ]);
                case 'INS':
                    return $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.underline.create()
                    ]);
                case 'FONT':
                    if (!(0, (0, parcelRequire("5Sc2i")).isSchemaWithTextColor)(schema)) return null;
                    const color = (0, (0, parcelRequire("51H8P")).normalizeHexColor)(node.getAttribute('color'), '#333333');
                    return color ? $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.textColor.create({
                            color: color
                        })
                    ]) : content;
                case 'A':
                    if (node.className === 'user-hover' && (0, (0, parcelRequire("5Sc2i")).isSchemaWithMentions)(schema)) return schema.nodes.mention.createChecked({
                        id: node.getAttribute('rel'),
                        text: node.textContent
                    });
                    if (node.className.match('jira-issue-macro-key') || !content || !(0, (0, parcelRequire("5Sc2i")).isSchemaWithLinks)(schema)) return null;
                    const href = node.getAttribute('href');
                    const title = node.getAttribute('title');
                    return href ? $70a5644617f486cc$var$addMarks(content, [
                        schema.marks.link.create({
                            href: href,
                            title: title
                        })
                    ]) : content;
                case 'SPAN':
                    if (node.className.split(' ').indexOf('jira-issue-macro') > -1) {
                        const jiraKey = node.getAttribute('data-jira-key');
                        const link = node.getElementsByTagName('a')[0];
                        if (jiraKey && link) return $70a5644617f486cc$var$addMarks((0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(jiraKey)), [
                            schema.marks.link.create({
                                href: link.getAttribute('href'),
                                title: link.getAttribute('title')
                            })
                        ]);
                        return null;
                    } else if (node.className.match('jira-macro-single-issue-export-pdf')) return null;
                    else if (node.className.match('code-')) return null;
                    else if ($70a5644617f486cc$var$isMedia(node) && (0, (0, parcelRequire("5Sc2i")).isSchemaWithMedia)(schema)) {
                        const dataNode = node.querySelector('[data-media-services-id]');
                        if (dataNode && dataNode instanceof HTMLElement) {
                            const id = dataNode.getAttribute('data-media-services-id');
                            const type = dataNode.getAttribute('data-media-services-type');
                            const collection = dataNode.getAttribute('data-media-services-collection') || '';
                            const attachmentName = dataNode.getAttribute('data-attachment-name');
                            const attachmentType = dataNode.getAttribute('data-attachment-type');
                            const fileName = dataNode.getAttribute('data-file-name');
                            const displayType = dataNode.getAttribute('data-display-type');
                            const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
                            const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
                            return schema.nodes.media.createChecked({
                                id: id,
                                type: type,
                                collection: collection,
                                width: width || null,
                                height: height || null,
                                __fileName: attachmentName || fileName,
                                __displayType: attachmentType || displayType || 'thumbnail'
                            });
                        }
                    }
                    break;
                case 'IMG':
                    if (node.parentElement && node.parentElement.className.match('jira-issue-macro-key')) return null;
                    else if (node.className === 'emoticon') {
                        let emojiResult = (0, (0, parcelRequire("8V12i")).mapImageToEmoji)(node);
                        if (emojiResult) return schema.text(emojiResult);
                    }
                    break;
                case 'H1':
                case 'H2':
                case 'H3':
                case 'H4':
                case 'H5':
                case 'H6':
                    const level = Number(tag.charAt(1));
                    const supportedMarks = [
                        schema.marks.link
                    ].filter((mark)=>!!mark);
                    return schema.nodes.heading.createChecked({
                        level: level === 6 ? 5 : level
                    }, schema.nodes.heading.validContent(content) ? content : $70a5644617f486cc$export$5cb2cb6b3b363caa(schema, content, supportedMarks));
                case 'BR':
                    return schema.nodes.hardBreak.createChecked();
                case 'HR':
                    return schema.nodes.rule.createChecked();
                case 'P':
                    if (node.firstElementChild && $70a5644617f486cc$var$isMedia(node.firstElementChild)) {
                        const { mediaSingle: mediaSingle, mediaGroup: mediaGroup, paragraph: paragraph } = schema.nodes;
                        const mediaArray = [];
                        const contentArray = [];
                        const fragmentArray = [];
                        let hasNonMediaChildren = false;
                        content.forEach((child)=>{
                            if (child.type === schema.nodes.media) {
                                mediaArray.push(child);
                                return;
                            } else if (!(child.isText && /^\s*$/.test(child.text || ''))) hasNonMediaChildren = true;
                            contentArray.push(child);
                        });
                        if (hasNonMediaChildren && contentArray.length) fragmentArray.push(paragraph.createChecked({}, contentArray));
                        if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithMedia)(schema) && mediaArray.length) {
                            const mediaNodeType = $70a5644617f486cc$var$isMediaSingle(node.firstElementChild) ? mediaSingle : mediaGroup;
                            fragmentArray.push(mediaNodeType.createChecked({}, mediaArray));
                        }
                        if (fragmentArray.length) return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(fragmentArray);
                        return null;
                    }
                    return schema.nodes.paragraph.createChecked({}, content);
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithLists)(schema)) switch(tag){
                case 'UL':
                    return schema.nodes.bulletList.createChecked({}, content);
                case 'OL':
                    return schema.nodes.orderedList.createChecked({}, content);
                case 'LI':
                    const compatibleContent = schema.nodes.listItem.validContent(content) ? content : $70a5644617f486cc$export$c389196451c598e2(content, schema, schema.nodes.listItem);
                    return schema.nodes.listItem.createChecked({}, compatibleContent);
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithCodeBlock)(schema)) switch(tag){
                case 'DIV':
                    if (node.className === 'codeContent panelContent' || node.className.match('preformattedContent')) return null;
                    else if (node.className === 'code panel' || node.className === 'preformatted panel') {
                        const pre = node.querySelector('pre');
                        if (!pre) return null;
                        const language = node.className === 'preformatted panel' ? 'plain' : pre.className.split('-')[1];
                        const textContent = (pre.textContent || '').replace(/\r\n/g, '\n');
                        return schema.nodes.codeBlock.createChecked({
                            language: language
                        }, textContent ? schema.text(textContent) : undefined);
                    }
                    break;
                case 'PRE':
                    return null;
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithBlockQuotes)(schema) && tag === 'BLOCKQUOTE') {
                let blockquoteContent = content && content.content.length ? content : schema.nodes.paragraph.createChecked();
                return schema.nodes.blockquote.createChecked({}, blockquoteContent);
            }
            if ((0, (0, parcelRequire("5Sc2i")).isSchemaWithTables)(schema)) switch(tag){
                case 'TABLE':
                    return schema.nodes.table.createChecked({}, content);
                case 'TR':
                    return schema.nodes.tableRow.createChecked({}, content);
                case 'TD':
                    const tdContent = schema.nodes.tableCell.validContent(content) ? content : $70a5644617f486cc$export$c389196451c598e2(content, schema);
                    return schema.nodes.tableCell.createChecked({}, tdContent);
                case 'TH':
                    const thContent = schema.nodes.tableHeader.validContent(content) ? content : $70a5644617f486cc$export$c389196451c598e2(content, schema);
                    return schema.nodes.tableHeader.createChecked({}, thContent);
            }
        }
        return;
    }
    function $70a5644617f486cc$export$6f3da03763fd5ca0(root) {
        const inqueue = [
            root
        ];
        const outqueue = [];
        let elem;
        while(elem = inqueue.shift()){
            outqueue.push(elem);
            let childIndex;
            for(childIndex = 0; childIndex < elem.childNodes.length; childIndex++){
                const child = elem.childNodes[childIndex];
                switch(child.nodeType){
                    case Node.ELEMENT_NODE:
                    case Node.TEXT_NODE:
                        inqueue.push(child);
                        break;
                    default:
                        console.error(`Not pushing: ${child.nodeType} ${child.nodeName}`);
                }
            }
        }
        outqueue.shift();
        return outqueue;
    }
    function $70a5644617f486cc$var$addMarks(fragment, marks) {
        let result = fragment;
        for(let i = 0; i < fragment.childCount; i++){
            const child = result.child(i);
            let newChild = child;
            for (const mark of marks)newChild = newChild.mark(mark.addToSet(newChild.marks));
            result = result.replaceChild(i, newChild);
        }
        return result;
    }
    function $70a5644617f486cc$var$getNodeName(node) {
        return node.nodeName.toUpperCase();
    }
    function $70a5644617f486cc$var$isMedia(node) {
        if (node && node instanceof HTMLElement) {
            if (node.parentNode && $70a5644617f486cc$var$getNodeName(node.parentNode) === 'P') {
                if ($70a5644617f486cc$var$getNodeName(node) === 'SPAN') return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
            }
        }
        return false;
    }
    function $70a5644617f486cc$var$isMediaSingle(node) {
        if ($70a5644617f486cc$var$isMedia(node)) {
            const dataNode = node.querySelector('[data-media-services-id]');
            if (dataNode instanceof HTMLElement) {
                const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
                const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
                if (node.parentNode.classList.contains('mediaSingle') && width && height) return true;
            }
        }
        return false;
    }
});
parcelRegister("5Sc2i", function(module, exports) {
    $parcel$export(module.exports, "isSchemaWithLists", ()=>$446b550712d928f4$export$c7b73e631457b93a);
    $parcel$export(module.exports, "isSchemaWithMentions", ()=>$446b550712d928f4$export$9581c5c4f18e364);
    $parcel$export(module.exports, "isSchemaWithEmojis", ()=>$446b550712d928f4$export$85a55ee1ae0815e3);
    $parcel$export(module.exports, "isSchemaWithLinks", ()=>$446b550712d928f4$export$be604d30ea08e34c);
    $parcel$export(module.exports, "isSchemaWithAdvancedTextFormattingMarks", ()=>$446b550712d928f4$export$6b152f895f3f2d6a);
    $parcel$export(module.exports, "isSchemaWithSubSupMark", ()=>$446b550712d928f4$export$b7fbc21a18ab46d0);
    $parcel$export(module.exports, "isSchemaWithCodeBlock", ()=>$446b550712d928f4$export$24f23e2680c2f593);
    $parcel$export(module.exports, "isSchemaWithBlockQuotes", ()=>$446b550712d928f4$export$2761b627be3a2c10);
    $parcel$export(module.exports, "isSchemaWithMedia", ()=>$446b550712d928f4$export$fce37e3087e971dd);
    $parcel$export(module.exports, "isSchemaWithTextColor", ()=>$446b550712d928f4$export$6bc3d8bd3aad229);
    $parcel$export(module.exports, "isSchemaWithTables", ()=>$446b550712d928f4$export$fff0e9b2ccefb752);
    var $kBho7;
    function $446b550712d928f4$export$2e2bcd8739ae039(config) {
        const nodes = [
            'doc',
            'paragraph',
            'text',
            'hardBreak',
            'heading',
            'rule'
        ];
        const marks = [
            'strong',
            'em',
            'underline',
            'typeAheadQuery',
            'unsupportedMark',
            'unsupportedNodeAttribute'
        ];
        if (config.allowLinks) marks.push('link');
        if (config.allowLists) nodes.push('orderedList', 'bulletList', 'listItem');
        if (config.allowMentions) {
            nodes.push('mention');
            marks.push('mentionQuery');
        }
        if (config.allowEmojis) nodes.push('emoji');
        if (config.allowAdvancedTextFormatting) marks.push('strike', 'code');
        if (config.allowSubSup) marks.push('subsup');
        if (config.allowCodeBlock) nodes.push('codeBlock');
        if (config.allowBlockQuote) nodes.push('blockquote');
        if (config.allowMedia) nodes.push('mediaGroup', 'mediaSingle', 'media', 'caption', 'mediaInline');
        if (config.allowTextColor) marks.push('textColor');
        if (config.allowTables) nodes.push('table', 'tableCell', 'tableHeader', 'tableRow');
        return (0, (0, parcelRequire("kBho7")).createSchema)({
            nodes: nodes,
            marks: marks
        });
    }
    function $446b550712d928f4$export$c7b73e631457b93a(schema) {
        return !!schema.nodes.bulletList;
    }
    function $446b550712d928f4$export$9581c5c4f18e364(schema) {
        return !!schema.nodes.mention;
    }
    function $446b550712d928f4$export$85a55ee1ae0815e3(schema) {
        return !!schema.nodes.emoji;
    }
    function $446b550712d928f4$export$be604d30ea08e34c(schema) {
        return !!schema.marks.link;
    }
    function $446b550712d928f4$export$6b152f895f3f2d6a(schema) {
        return !!schema.marks.code && !!schema.marks.strike;
    }
    function $446b550712d928f4$export$b7fbc21a18ab46d0(schema) {
        return !!schema.marks.subsup;
    }
    function $446b550712d928f4$export$24f23e2680c2f593(schema) {
        return !!schema.nodes.codeBlock;
    }
    function $446b550712d928f4$export$2761b627be3a2c10(schema) {
        return !!schema.nodes.blockquote;
    }
    function $446b550712d928f4$export$fce37e3087e971dd(schema) {
        return !!schema.nodes.mediaGroup && !!schema.nodes.media && !!schema.nodes.mediaInline;
    }
    function $446b550712d928f4$export$6bc3d8bd3aad229(schema) {
        return !!schema.marks.textColor;
    }
    function $446b550712d928f4$export$fff0e9b2ccefb752(schema) {
        return !!schema.nodes.table && !!schema.nodes.tableCell && !!schema.nodes.tableHeader && !!schema.nodes.tableRow;
    }
});
parcelRegister("8V12i", function(module, exports) {
    $parcel$export(module.exports, "mapImageToEmoji", ()=>$d07bb2e10820d36d$export$f0d20a903b124435);
    const $d07bb2e10820d36d$var$emojiMap = {
        'smile.png': "\uD83D\uDE42",
        'sad.png': "\u2639\uFE0F",
        'tongue.png': "\uD83D\uDE1B",
        'biggrin.png': "\uD83D\uDE01",
        'wink.png': "\uD83D\uDE09",
        'thumbs_up.png': "\uD83D\uDC4D",
        'thumbs_down.png': "\uD83D\uDC4E",
        'information.png': "\u2139\uFE0F",
        'check.png': "\u2705",
        'error.png': "\u274C",
        'warning.png': "\u26A0\uFE0F",
        'add.png': "\u2795",
        'forbidden.png': "\u2796",
        'help_16.png': "\u2753",
        'lightbulb_on.png': "\uD83D\uDCA1",
        'lightbulb.png': "\u26D4\uFE0F",
        'star_yellow.png': "\uD83D\uDC9B",
        'star_red.png': "\u2764\uFE0F",
        'star_green.png': "\uD83D\uDC9A",
        'star_blue.png': "\uD83D\uDC99",
        'flag.png': "\uD83D\uDEA9",
        'flag_gray.png': "\uD83C\uDFF3"
    };
    function $d07bb2e10820d36d$export$f0d20a903b124435(imageElement) {
        let src = imageElement.src;
        let slashIndex = src.lastIndexOf('/');
        src = src.substr(slashIndex + 1);
        return $d07bb2e10820d36d$var$emojiMap[src] || null;
    }
});
parcelRegister("31xp0", function(module, exports) {
    $parcel$export(module.exports, "rendererEventHandlers", ()=>$233b601bde61bd9c$export$7099af1d0eb30f39);
    const $233b601bde61bd9c$export$7099af1d0eb30f39 = {
        link: {
            onClick: (event, url)=>{
                event.preventDefault();
                window.open(url, '_blank', 'noopener noreferrer');
            }
        }
    };
});
parcelRegister("a9AOh", function(module, exports) {
    $parcel$export(module.exports, "RenderQuestion", ()=>$76474c573330a931$export$d8f386356b080eb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $ousew;
    var $koVbs;
    var $2x3Cb;
    var $kxqHl;
    var $6yUsV;
    var $VSDnB;
    var $d9Coz;
    var $bEQ2i;
    var $4aJmI;
    var $6lxfx;
    var $9JaSd;
    var $cU8Qs;
    var $gs4em;
    var $4OnBQ;
    var $d6RcY;
    var $hBksn;
    var $bQ3UU;
    var $8iale;
    const $76474c573330a931$var$LinkedFieldIconWrapper = (0, $dAHxw.default).span({
        marginLeft: "var(--ds-space-050, 4px)"
    });
    const $76474c573330a931$var$QuestionLabelWrapper = (0, $dAHxw.default).span({
        display: 'flex'
    });
    const $76474c573330a931$export$d8f386356b080eb1 = (0, $jJXgM.observer)(({ QuestionRenderer: QuestionRenderer, questionTypeRendererMap: questionTypeRendererMap, questionStore: questionStore, displayMode: displayMode, formStore: formStore, blockFormSubmission: blockFormSubmission, linkedFieldNames: linkedFieldNames })=>{
        var _questionTypeRenderer;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { formQuestion: formQuestion, id: questionId, issueFieldData: issueFieldData, revisionToken: revisionToken, validationErrors: validationErrors } = questionStore;
        const fieldId = `pf-${formStore.formId}-${formQuestion.type}-${questionId}`;
        const fieldIdLabel = [
            (0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime,
            (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date,
            (0, (0, parcelRequire("4aJmI")).FormQuestionType).Time
        ].includes(formQuestion.type) ? `react-select-${fieldId}--input` : fieldId;
        const formSaveQuestionError = (0, (0, parcelRequire("bEQ2i")).useFormSaveQuestionError)(questionId);
        const questionProps = {
            questionStore: questionStore,
            formStore: formStore,
            displayMode: displayMode,
            id: fieldId,
            revisionToken: revisionToken,
            blockFormSubmission: blockFormSubmission
        };
        const QuestionTypeRenderer = (_questionTypeRenderer = questionTypeRendererMap === null || questionTypeRendererMap === void 0 ? void 0 : questionTypeRendererMap[formQuestion.type]) !== null && _questionTypeRenderer !== void 0 ? _questionTypeRenderer : (0, (0, parcelRequire("gs4em")).defaultQuestionTypeRendererMap)[formQuestion.type];
        const questionComponent = QuestionTypeRenderer ? (0, ($parcel$interopDefault($5uXOq))).createElement(QuestionTypeRenderer, questionProps) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bQ3UU")).UnknownQuestionType), {
            questionType: formQuestion.type
        });
        let allQuestionErrors = [];
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit) allQuestionErrors = [
            ...validationErrors ? validationErrors : [],
            ...formSaveQuestionError ? [
                {
                    key: (0, (0, parcelRequire("6lxfx")).ValidationErrorMsg).FormSave,
                    message: formSaveQuestionError
                }
            ] : []
        ];
        let warningMessage;
        switch(issueFieldData === null || issueFieldData === void 0 ? void 0 : issueFieldData.readOnlyReason){
            case (0, (0, parcelRequire("d9Coz")).ReadOnlyReason).Anonymous:
                warningMessage = (0, (0, parcelRequire("cU8Qs")).messages).readOnlyReasonAnonymousMessage;
                break;
            case (0, (0, parcelRequire("d9Coz")).ReadOnlyReason).Unlicensed:
                warningMessage = (0, (0, parcelRequire("cU8Qs")).messages).readOnlyReasonUnlicensedMessage;
                break;
            default:
        }
        return QuestionRenderer !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement(QuestionRenderer, {
            questionId: questionId.toString(),
            fieldId: fieldId,
            formQuestion: formQuestion,
            questionComponent: questionComponent
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).LabelWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: (0, (0, parcelRequire("VSDnB")).fg)('dont_use_fieldidlabel_in_question_labels_dwb4') ? fieldId : fieldIdLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($76474c573330a931$var$QuestionLabelWrapper, null, formQuestion.label, formQuestion.validation.rq && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxqHl")).default), null), formQuestion.jiraField && linkedFieldNames && (0, ($parcel$interopDefault($5uXOq))).createElement($76474c573330a931$var$LinkedFieldIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9JaSd")).LinkedFieldIcon), {
            fieldName: linkedFieldNames === null || linkedFieldNames === void 0 ? void 0 : linkedFieldNames.get(formQuestion.jiraField)
        })))), warningMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6yUsV")).default), {
            appearance: "connectivity",
            iconLabel: intl.formatMessage(warningMessage)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), warningMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d6RcY")).QuestionHelperMsg), {
            description: formQuestion.description
        }), questionComponent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4OnBQ")).QuestionErrorMsg), {
            validationErrors: allQuestionErrors.length === 0 ? undefined : allQuestionErrors
        }));
    });
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("6yUsV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2c43b93305034f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fVnbM;
    var $ctg8C;
    var $f5TWP;
    var $cgL5K;
    var $60LNO;
    function $e2c43b93305034f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e2c43b93305034f0$var$rootStyles = {
        name: "ssyr0c",
        styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
    };
    const $e2c43b93305034f0$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$747d86715d4175de})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$a7175d4e9206bc80})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$5aae31392d72caaa})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$4a7404f376229999})`;
        }
    };
    const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const toggleDialog = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((oldState)=>!oldState);
        }, [
            setIsOpen
        ]);
        const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        if (!appearance) appearance = type;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e2c43b93305034f0$var$rootStyles,
            style: {
                '--icon-accent-color': $e2c43b93305034f0$var$iconColor(appearance)
            },
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ctg8C")).default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            "data-ds--inline-message--button": true,
            appearance: "subtle-link",
            onClick: toggleDialog,
            spacing: "none",
            testId: testId && `${testId}--button`,
            "aria-expanded": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("60LNO")).default), {
            isOpen: isOpen,
            appearance: appearance,
            label: iconLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, title && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            testId: testId && `${testId}--title`
        }, title), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "color.text.subtlest",
            maxLines: 1,
            testId: testId && `${testId}--text`
        }, secondaryText))))));
    };
    var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;
});
parcelRegister("60LNO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$474777c4d72d6c07$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $jfSgx;
    function $474777c4d72d6c07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $474777c4d72d6c07$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$940e1f69e873f202})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$b48405b95304b5a1})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$c6930421db9fa514})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
        }
    };
    const $474777c4d72d6c07$var$iconWrapperStyles = {
        name: "kw6wgo",
        styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
    };
    const $474777c4d72d6c07$var$iconColorStyles = {
        name: "1iy94md",
        styles: "color:var(--icon-accent-color)"
    };
    const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
        const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, (0, parcelRequire("jfSgx")).typesMapping);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-ds--inline-message--icon": true,
            style: {
                '--icon-color': $474777c4d72d6c07$var$iconColor(appearance)
            },
            css: [
                $474777c4d72d6c07$var$iconWrapperStyles,
                isOpen && $474777c4d72d6c07$var$iconColorStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        }));
    };
    var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;
});
parcelRegister("jfSgx", function(module, exports) {
    $parcel$export(module.exports, "typesMapping", ()=>$e3da74fa628ddd87$export$4d111645c0b39d5d);
    var $dD7Zc;
    var $1jWct;
    var $c2i4s;
    var $bU3PY;
    const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
        connectivity: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'connectivity inline message'
        },
        confirmation: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))),
            defaultLabel: 'confirmation inline message'
        },
        info: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))),
            defaultLabel: 'info inline message'
        },
        warning: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'warning inline message'
        },
        error: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))),
            defaultLabel: 'error inline message'
        }
    };
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("d9Coz", function(module, exports) {
    $parcel$export(module.exports, "ReadOnlyReason", ()=>$9939e625595b280c$export$3981c7d6e6518dac);
    let $9939e625595b280c$export$3981c7d6e6518dac = function(ReadOnlyReason) {
        ReadOnlyReason["Anonymous"] = "anonymous";
        ReadOnlyReason["Unlicensed"] = "unlicensed";
        return ReadOnlyReason;
    }({});
});
parcelRegister("9JaSd", function(module, exports) {
    $parcel$export(module.exports, "LinkedFieldIcon", ()=>$7150c044d49bfc58$export$e3615186b8ead0ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7a6BY;
    var $3bDjY;
    var $ljThx;
    const $7150c044d49bfc58$export$e3615186b8ead0ae = ({ fieldName: fieldName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const message = fieldName ? formatMessage((0, (0, parcelRequire("ljThx")).messages).tooltip, {
            fieldName: fieldName
        }) : formatMessage((0, (0, parcelRequire("ljThx")).messages).unknownField);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: message
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7a6BY"))))), {
                size: "small",
                label: "Linked field"
            })));
    };
});
parcelRegister("7a6BY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $536e987ca6b29465$var$_react = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $536e987ca6b29465$var$_link = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $536e987ca6b29465$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $536e987ca6b29465$var$LinkFilledIcon = (props)=>$536e987ca6b29465$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
        }, props, {
            newIcon: $536e987ca6b29465$var$_link.default
        }));
    $536e987ca6b29465$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
    var $536e987ca6b29465$var$_default = module.exports.default = $536e987ca6b29465$var$LinkFilledIcon;
});
parcelRegister("ljThx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f856412023fabe65$export$defe85febe8b728c);
    var $7VHMR;
    const $f856412023fabe65$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            id: 'proforma-form-builder.src.components.questiontypes.linked-field-icon.tooltip',
            defaultMessage: "Linked to \u2018{fieldName}\u2018 Jira field",
            description: 'Text for a tooltip indicating the form field is linked to a Jira field.'
        },
        unknownField: {
            id: 'proforma-form-builder.src.components.questiontypes.linked-field-icon.unknown-field',
            defaultMessage: 'Linked to Jira field',
            description: 'Text for a tooltip indicating the form field is linked to an unknown Jira field.'
        }
    });
});
parcelRegister("cU8Qs", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9651937404364adf$export$defe85febe8b728c);
    var $7VHMR;
    const $9651937404364adf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        readOnlyReasonAnonymousMessage: {
            id: 'form-system.renderQuestion.read-only-reason-anonymous-message',
            defaultMessage: 'Log in with a valid account to access this field.',
            description: 'The question is read only because the user is anonymous message to display when mousing over an icon.'
        },
        readOnlyReasonUnlicensedMessage: {
            id: 'form-system.renderQuestion.read-only-reason-unlicensed-message',
            defaultMessage: 'This field is only available to users with Jira access.',
            description: 'The question is read only because the user does not have a Jira license message to display when mousing over an icon.'
        },
        emptyFormName: {
            id: 'form-system.headerBar.emptyFormName',
            defaultMessage: 'Untitled Form',
            description: 'A placeholder for a form with an empty name.'
        }
    });
});
parcelRegister("gs4em", function(module, exports) {
    $parcel$export(module.exports, "defaultQuestionTypeRendererMap", ()=>$bfa28af6ffba73d5$export$75e3472ea9146861);
    var $VSDnB;
    var $4aJmI;
    var $50MJJ;
    var $ey2nO;
    var $aBenK;
    var $cGJ7q;
    var $bchDp;
    var $dCF6m;
    var $jLknN;
    var $6r1D6;
    var $bVxQm;
    var $gqc26;
    var $isuZ1;
    var $aZCPa;
    var $erYCV;
    var $f1Hmw;
    var $bfOs9;
    var $fGwwO;
    var $gyvX2;
    const $bfa28af6ffba73d5$export$75e3472ea9146861 = {
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort]: (0, (0, parcelRequire("erYCV")).ShortText),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong]: (0, (0, parcelRequire("6r1D6")).LongText),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail]: (0, (0, parcelRequire("6r1D6")).LongText),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl]: (0, (0, parcelRequire("fGwwO")).UrlText),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph]: (0, (0, parcelRequire("isuZ1")).Paragraph),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph]: (0, (0, parcelRequire("aZCPa")).RichTextParagraph),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).Number]: (0, (0, parcelRequire("gqc26")).Number),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime]: (0, (0, parcelRequire("bchDp")).DateTime),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).Date]: (0, (0, parcelRequire("cGJ7q")).Date),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).Time]: (0, (0, parcelRequire("bfOs9")).Time),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading]: (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields') ? (0, (0, parcelRequire("ey2nO")).CascadingDropdown) : undefined,
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle]: (0, (0, parcelRequire("f1Hmw")).SingleChoice),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple]: (0, (0, parcelRequire("bVxQm")).MultiChoice),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown]: (0, (0, parcelRequire("dCF6m")).Dropdown),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple]: (0, (0, parcelRequire("jLknN")).DropdownMultiselect),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle]: (0, (0, parcelRequire("gyvX2")).UserPicker),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple]: (0, (0, parcelRequire("gyvX2")).UserPicker),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment]: (0, (0, parcelRequire("50MJJ")).AttachmentAsync),
        [(0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject]: (0, (0, parcelRequire("aBenK")).CmdbDropdown)
    };
});
parcelRegister("50MJJ", function(module, exports) {
    $parcel$export(module.exports, "AttachmentAsync", ()=>$3a62c1f01fa2540a$export$43936e8d08b9b853);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $eZJjh;
    const $3a62c1f01fa2540a$export$43936e8d08b9b853 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6IUiz")).then((mod)=>mod.Attachment),
        loading: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)
    });
});
parcelRegister("6IUiz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7mb2K")
    ]).then(()=>parcelRequire('5UDXB'));
});
parcelRegister("ey2nO", function(module, exports) {
    $parcel$export(module.exports, "CascadingDropdown", ()=>$a97616e10eb11575$export$24252a0c62dc3678);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $9BlW6;
    var $6lRsX;
    const $a97616e10eb11575$export$24252a0c62dc3678 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        var _questionStore$issueF;
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const availableParentOptions = questionStore.availableOptions();
        const currentParentOption = availableParentOptions.find((option)=>{
            var _currentAnswer$choice, _currentAnswer$choice2;
            return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice = currentAnswer.choices) === null || _currentAnswer$choice === void 0 ? void 0 : (_currentAnswer$choice2 = _currentAnswer$choice[0]) === null || _currentAnswer$choice2 === void 0 ? void 0 : _currentAnswer$choice2.split(':')[0]);
        });
        const availableChildOptions = currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.children;
        const currentChildOption = availableChildOptions === null || availableChildOptions === void 0 ? void 0 : availableChildOptions.find((option)=>{
            var _currentAnswer$choice3;
            return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice3 = currentAnswer.choices) === null || _currentAnswer$choice3 === void 0 ? void 0 : _currentAnswer$choice3[0].split(':')[1]);
        });
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
        if (showEditComponent) {
            const onChange = (value)=>{
                const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
                const newChoiceIds = selectedChoiceId ? [
                    selectedChoiceId
                ] : [];
                questionStore.setAnswer({
                    choices: newChoiceIds
                });
            };
            const onChangeChild = (value)=>{
                const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
                const newChoiceIds = selectedChoiceId ? [
                    `${currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.value}:${selectedChoiceId}`
                ] : [];
                questionStore.setAnswer({
                    choices: newChoiceIds
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9BlW6")).EditCascadingDropdown), {
                id: id,
                key: `${id}-${questionStore.dependentFieldChangedCount}`,
                options: availableParentOptions,
                value: currentParentOption,
                childOptions: availableChildOptions,
                childValue: currentChildOption,
                loading: questionStore.loading,
                onChange: onChange,
                onChangeChild: onChangeChild
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lRsX")).ViewCascadingDropdown), {
            id: id,
            value: currentParentOption,
            childValue: currentChildOption,
            displayMode: displayMode
        });
    });
});
parcelRegister("9BlW6", function(module, exports) {
    $parcel$export(module.exports, "EditCascadingDropdown", ()=>$6fd895cdf831d555$export$c12cc085d12a21d6);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $dC5iT;
    var $8CUq3;
    var $7K5PP;
    var $4dI0P;
    var $lsVZ9;
    const $6fd895cdf831d555$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'row'
    });
    const $6fd895cdf831d555$var$parentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%',
        marginRight: 'space.100'
    });
    const $6fd895cdf831d555$var$childStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%'
    });
    const $6fd895cdf831d555$export$c12cc085d12a21d6 = ({ id: id, options: options, value: value, childOptions: childOptions, childValue: childValue, loading: loading, onChange: onChange, onChangeChild: onChangeChild })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6fd895cdf831d555$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6fd895cdf831d555$var$parentStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6fd895cdf831d555$var$EditDropdown, {
            id: id,
            options: options,
            value: value !== null && value !== void 0 ? value : null,
            loading: loading,
            onChange: onChange,
            clearable: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6fd895cdf831d555$var$childStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6fd895cdf831d555$var$EditDropdown, {
            id: `${id}-child`,
            options: childOptions,
            value: childValue !== null && childValue !== void 0 ? childValue : null,
            loading: loading,
            onChange: onChangeChild
        })));
    };
    const $6fd895cdf831d555$var$EditDropdown = ({ id: id, options: options, value: value, loading: loading, onChange: onChange, clearable: clearable = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), (0, $bS32t.default)({
            id: id,
            key: id,
            options: options,
            value: value !== null && value !== void 0 ? value : null,
            isLoading: loading,
            onChange: onChange,
            isSearchable: true,
            isClearable: clearable,
            noOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lsVZ9")).messages).choiceDropdownNoOptions),
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lsVZ9")).messages).choiceDropdownSelect)
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)()));
    };
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("4dI0P", function(module, exports) {
    $parcel$export(module.exports, "getDropDownMenuPosition", ()=>$312a84430896a8a0$export$cc1c1d9e6b32e7b2);
    var $dpaDt;
    const $312a84430896a8a0$export$cc1c1d9e6b32e7b2 = ()=>(0, (0, parcelRequire("dpaDt")).isIPhone)() || (0, (0, parcelRequire("dpaDt")).isIPad)() ? {
            menuPosition: 'absolute'
        } : {
            menuPosition: 'fixed'
        };
});
parcelRegister("dpaDt", function(module, exports) {
    $parcel$export(module.exports, "isMobile", ()=>$9c25dc32dcb71a15$export$d0a8044dce8ff2fc);
    $parcel$export(module.exports, "isIPhone", ()=>$9c25dc32dcb71a15$export$186c6964ca17d99);
    $parcel$export(module.exports, "isIPad", ()=>$9c25dc32dcb71a15$export$7bef049ce92e4224);
    var $eYli8 = parcelRequire("eYli8");
    const $9c25dc32dcb71a15$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
    const $9c25dc32dcb71a15$var$ANDROID_CHROME_USER_AGENT = /Chrome\/[.\d]* Mobile/;
    const $9c25dc32dcb71a15$var$OLD_ANDROID_USER_AGENT = /Linux;(?: U;)? Android (?:[23]\.\d|4\.0\.[12])/;
    const $9c25dc32dcb71a15$var$MOBILE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch;|Linux;(?: U;)? Android)/;
    const $9c25dc32dcb71a15$var$IPHONE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPod;|iPod touch;)/;
    const $9c25dc32dcb71a15$var$IPAD_USER_AGENT = /iPad;/;
    const $9c25dc32dcb71a15$var$isSupportedUserAgent = ()=>{
        var _navigator, _navigator$userAgent;
        if (!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator$userAgent = _navigator.userAgent) !== null && _navigator$userAgent !== void 0 && _navigator$userAgent.length)) return false;
        return $9c25dc32dcb71a15$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $9c25dc32dcb71a15$var$MOBILE_USER_AGENT.test(navigator.userAgent) && !$9c25dc32dcb71a15$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
    };
    const $9c25dc32dcb71a15$var$isDesktopSwitchEnabled = ()=>(0, ($parcel$interopDefault($eYli8))).get($9c25dc32dcb71a15$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
    function $9c25dc32dcb71a15$export$d0a8044dce8ff2fc() {
        return $9c25dc32dcb71a15$var$isSupportedUserAgent() && !$9c25dc32dcb71a15$var$isDesktopSwitchEnabled();
    }
    function $9c25dc32dcb71a15$export$186c6964ca17d99() {
        var _navigator2, _navigator2$userAgent;
        if (!((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2$userAgent = _navigator2.userAgent) !== null && _navigator2$userAgent !== void 0 && _navigator2$userAgent.length)) return false;
        return $9c25dc32dcb71a15$var$IPHONE_USER_AGENT.test(navigator.userAgent);
    }
    function $9c25dc32dcb71a15$export$7bef049ce92e4224() {
        var _navigator3, _navigator3$userAgent, _navigator4, _navigator4$platform;
        if (!navigator || !((_navigator3 = navigator) !== null && _navigator3 !== void 0 && (_navigator3$userAgent = _navigator3.userAgent) !== null && _navigator3$userAgent !== void 0 && _navigator3$userAgent.length) || !((_navigator4 = navigator) !== null && _navigator4 !== void 0 && (_navigator4$platform = _navigator4.platform) !== null && _navigator4$platform !== void 0 && _navigator4$platform.length)) return false;
        const { userAgent: userAgent, platform: platform, maxTouchPoints: maxTouchPoints } = navigator;
        const isIPadUserGgent = $9c25dc32dcb71a15$var$IPAD_USER_AGENT.test(userAgent);
        const isIPadDesktop = platform === 'MacIntel' && maxTouchPoints > 1;
        return isIPadUserGgent || isIPadDesktop;
    }
});
parcelRegister("lsVZ9", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$fa09312fcc50755c$export$defe85febe8b728c);
    var $7VHMR;
    const $fa09312fcc50755c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        choiceDropdownSelect: {
            id: 'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-select',
            defaultMessage: 'Select...',
            description: 'Placeholder text in dropdown waiting for the user to select something.'
        },
        choiceDropdownNoOptions: {
            id: 'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-no-options',
            defaultMessage: 'No options',
            description: 'Placeholder text in dropdown when there are no options.'
        }
    });
});
parcelRegister("6lRsX", function(module, exports) {
    $parcel$export(module.exports, "ViewCascadingDropdown", ()=>$49fe2d7f303ab78a$export$3527cac9cc6cb5cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $51H8P;
    var $dC5iT;
    var $8CUq3;
    var $7K5PP;
    var $8iale;
    var $hBksn;
    const $49fe2d7f303ab78a$var$styles = {
        control: (base)=>({
                ...base,
                backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, (0, parcelRequire("51H8P")).N20})`,
                borderColor: "var(--ds-border-disabled, #DFE1E6)",
                color: "var(--ds-text, #172B4D !important)"
            }),
        menu: (base)=>({
                ...base,
                color: "var(--ds-text, #172B4D)"
            })
    };
    const $49fe2d7f303ab78a$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'row'
    });
    const $49fe2d7f303ab78a$var$parentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%',
        marginRight: 'space.100'
    });
    const $49fe2d7f303ab78a$var$childStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%'
    });
    const $49fe2d7f303ab78a$export$3527cac9cc6cb5cd = ({ id: id, value: value, childValue: childValue, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $49fe2d7f303ab78a$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $49fe2d7f303ab78a$var$parentStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            id: id,
            value: value,
            placeholder: "",
            isDisabled: true,
            styles: $49fe2d7f303ab78a$var$styles
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $49fe2d7f303ab78a$var$childStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            id: id,
            value: childValue,
            placeholder: "",
            isDisabled: true,
            styles: $49fe2d7f303ab78a$var$styles
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value ? `${value.label}` + (childValue ? ` - ${childValue.label}` : '') : '');
    };
});
parcelRegister("hBksn", function(module, exports) {
    $parcel$export(module.exports, "invalidFieldContainerStyles", ()=>$cd05c2a10b87a591$export$4775851963af2f92);
    $parcel$export(module.exports, "FieldDisabledWrapper", ()=>$cd05c2a10b87a591$export$d4e6edaaff357b7c);
    $parcel$export(module.exports, "ChoiceFieldWrapper", ()=>$cd05c2a10b87a591$export$40ba0da6d283da29);
    $parcel$export(module.exports, "TextfieldDisabledWrapper", ()=>$cd05c2a10b87a591$export$500b62c17cc006cd);
    $parcel$export(module.exports, "ShortTextFieldWrapper", ()=>$cd05c2a10b87a591$export$9eab2966dbf9c8a);
    $parcel$export(module.exports, "ChoicePlaceholder", ()=>$cd05c2a10b87a591$export$235f6b91c45162a2);
    $parcel$export(module.exports, "LabelWrapper", ()=>$cd05c2a10b87a591$export$147422f7450ccfac);
    $parcel$export(module.exports, "ErrorWrapper", ()=>$cd05c2a10b87a591$export$bb27b7e39840238f);
    $parcel$export(module.exports, "SelectErrorContainer", ()=>$cd05c2a10b87a591$export$29ae8e181f8cf4c6);
    $parcel$export(module.exports, "ShortFieldWrapper", ()=>$cd05c2a10b87a591$export$be1670a66b7ea819);
    $parcel$export(module.exports, "ViewWrapper", ()=>$cd05c2a10b87a591$export$895814aa5a1cf38c);
    var $dAHxw = parcelRequire("dAHxw");
    const $cd05c2a10b87a591$var$textFieldDisabledStyles = `
  min-height: 36px;
  border-style: solid;
  border-color: ${"var(--ds-border-disabled, #DFE1E6)"};
  border-radius: 3px;
  border-width: 2px;
  background-color: ${`var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`};
  cursor: default;
  color: ${`var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`};

  > div {
    padding: 8px 6px;
    line-height: normal
  }
`;
    const $cd05c2a10b87a591$var$choiceDisabledStyles = `
  > div {
    border-style: none;
    border-color: ${"var(--ds-border-disabled, #DFE1E6)"};
    border-radius: 3px;
    border-width: 2px;
    background-color: none;
    cursor: default;
    pointer-events: none;
  }
`;
    const $cd05c2a10b87a591$var$choiceInvalidStyles = `
  > div {
    border-style: none;
    border-color: ${"var(--ds-border-danger, #FF5630;)"}
    border-radius: 3px;
    border-width: 2px;
    cursor: default;
  }
`;
    const $cd05c2a10b87a591$var$choiceViewStyles = `
  span {
    color: ${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`};
  }
`;
    const $cd05c2a10b87a591$export$4775851963af2f92 = `
  border-style: solid;
  border-color: ${`var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`};
  border-radius: 3px;
  border-width: 2px;
  cursor: default;
`;
    const $cd05c2a10b87a591$export$d4e6edaaff357b7c = (0, $dAHxw.default).div({
        '> div': {
            borderStyle: 'solid',
            borderColor: "var(--ds-border-disabled, #DFE1E6)",
            borderRadius: 3,
            borderWidth: 2,
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            cursor: 'default',
            pointerEvents: 'none',
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        },
        '*': {
            color: "var(--ds-text, #172B4D !important)",
            cursor: 'default'
        }
    });
    const $cd05c2a10b87a591$export$40ba0da6d283da29 = (0, $dAHxw.default)('div')((props)=>props.isDisabled && $cd05c2a10b87a591$var$choiceDisabledStyles, (props)=>props.isInvalid && $cd05c2a10b87a591$var$choiceInvalidStyles, (props)=>props.isView && $cd05c2a10b87a591$var$choiceViewStyles);
    const $cd05c2a10b87a591$export$500b62c17cc006cd = (0, $dAHxw.default).div($cd05c2a10b87a591$var$textFieldDisabledStyles);
    const $cd05c2a10b87a591$export$9eab2966dbf9c8a = (0, $dAHxw.default)('div')({
        maxWidth: '240px'
    }, (props)=>props.isDisabled && $cd05c2a10b87a591$var$textFieldDisabledStyles);
    const $cd05c2a10b87a591$export$235f6b91c45162a2 = (0, $dAHxw.default).div({
        margin: "var(--ds-space-500, 40px)"
    });
    const $cd05c2a10b87a591$export$147422f7450ccfac = (0, $dAHxw.default).div({
        display: 'flex',
        label: {
            fontSize: '12px'
        }
    });
    const $cd05c2a10b87a591$export$bb27b7e39840238f = (0, $dAHxw.default).div({
        height: '16px',
        marginTop: "var(--ds-space-050, 4px)"
    });
    const $cd05c2a10b87a591$export$29ae8e181f8cf4c6 = (0, $dAHxw.default).div((props)=>props.isInvalid && $cd05c2a10b87a591$export$4775851963af2f92);
    const $cd05c2a10b87a591$export$be1670a66b7ea819 = (0, $dAHxw.default).div({
        maxWidth: '160px'
    });
    const $cd05c2a10b87a591$export$895814aa5a1cf38c = (0, $dAHxw.default).div({
        fontSize: '14px',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
    });
});
parcelRegister("aBenK", function(module, exports) {
    $parcel$export(module.exports, "CmdbDropdown", ()=>$7b788407fa8d1282$export$e96bc7c6676f4fad);
    var $5uXOq = parcelRequire("5uXOq");
    var $4QmvR;
    var $dCF6m;
    var $jLknN;
    const $7b788407fa8d1282$export$e96bc7c6676f4fad = (questionProps)=>{
        var _questionStore$issueF;
        const { questionStore: questionStore } = questionProps;
        const shouldRenderMultiple = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.multiple) !== false;
        const hasMultipleAnswers = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.answer).choices.length > 1;
        if (shouldRenderMultiple || hasMultipleAnswers) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jLknN")).DropdownMultiselect), questionProps);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dCF6m")).Dropdown), questionProps);
    };
});
parcelRegister("dCF6m", function(module, exports) {
    $parcel$export(module.exports, "Dropdown", ()=>$9eaeb4df1c5c07fb$export$931cbfb6bfb85fc);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $cnwtr;
    var $kH8LN;
    var $4QmvR;
    var $8iale;
    var $fORQz;
    var $diuGR;
    const $9eaeb4df1c5c07fb$export$931cbfb6bfb85fc = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode })=>{
        var _questionStore$issueF;
        const availableOptions = questionStore.availableOptions();
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const currentOption = questionStore.getAnswerChoicesAsObjects()[0];
        const currentChoiceId = currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
        const hasOtherChoice = !!questionStore.otherChoiceId;
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
        if (showEditComponent) {
            const onChange = (value)=>{
                const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
                const newChoiceIds = selectedChoiceId ? [
                    selectedChoiceId
                ] : [];
                questionStore.setAnswer({
                    text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                    choices: newChoiceIds,
                    choiceObjects: value ? [
                        (0, (0, parcelRequire("4QmvR")).QuestionStore).optionToChoice(value)
                    ] : []
                });
            };
            const otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
            const loadChoicesAsync = questionStore.isAsyncChoicesField ? (0, (0, parcelRequire("cnwtr")).debounce)((inputValue, callback)=>{
                formStore.loadChoicesAsync(questionStore.id, inputValue).then((_)=>callback(questionStore.choices.map((0, (0, parcelRequire("kH8LN")).toSelectOption))));
            }, 500) : undefined;
            const onOtherChoiceTextChange = (event)=>{
                questionStore.setAnswer({
                    text: event.target.value,
                    choices: (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fORQz")).EditDropdown), {
                id: id,
                key: `${id}-${questionStore.dependentFieldChangedCount}`,
                options: availableOptions,
                value: currentOption,
                loading: questionStore.loading,
                loadOptions: loadChoicesAsync,
                onChange: onChange,
                hasOtherOption: hasOtherChoice,
                otherOptionSelected: otherChoiceSelected,
                otherOptionText: currentAnswer.text,
                onOtherOptionTextChange: onOtherChoiceTextChange,
                isInvalid: !!questionStore.validationErrors
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("diuGR")).ViewDropdown), {
            id: id,
            options: availableOptions,
            value: currentOption,
            hasOtherOption: hasOtherChoice,
            otherOptionText: currentAnswer.text,
            displayMode: displayMode
        });
    });
});
parcelRegister("kH8LN", function(module, exports) {
    $parcel$export(module.exports, "toSelectOption", ()=>$f10ea050384b6a90$export$b1200bb97cce0ea8);
    const $f10ea050384b6a90$export$b1200bb97cce0ea8 = (choice)=>{
        var _choice$children;
        return {
            value: choice.id,
            label: choice.label,
            children: (_choice$children = choice.children) === null || _choice$children === void 0 ? void 0 : _choice$children.map($f10ea050384b6a90$export$b1200bb97cce0ea8)
        };
    };
});
parcelRegister("fORQz", function(module, exports) {
    $parcel$export(module.exports, "EditDropdown", ()=>$b8454b6872b7e585$export$16b249c780871ab1);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $d7FF4;
    var $7K5PP;
    var $4dI0P;
    var $hBksn;
    var $3uIOs;
    var $6YPn9;
    const $b8454b6872b7e585$export$16b249c780871ab1 = ({ id: id, options: options, value: value, loading: loading, loadOptions: loadOptions, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, isInvalid: isInvalid })=>{
        const [hasBeenFocused, setHasBeenFocused] = (0, $5uXOq.useState)(false);
        if (loadOptions === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).SelectErrorContainer), {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), (0, $bS32t.default)({
            id: id,
            options: options,
            value: value !== null && value !== void 0 ? value : null,
            isLoading: loading,
            onChange: onChange,
            isSearchable: true,
            noOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNoOptions),
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownSelect)
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)())), hasOtherOption && otherOptionSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uIOs")).EditOtherOption), {
            dropdown: true,
            value: otherOptionText,
            isDisabled: !otherOptionSelected,
            onChange: onOtherOptionTextChange
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).SelectErrorContainer), {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), (0, $bS32t.default)({
            autoFocus: hasBeenFocused,
            defaultMenuIsOpen: hasBeenFocused,
            defaultOptions: hasBeenFocused,
            id: id,
            isSearchable: true,
            key: id + hasBeenFocused,
            isLoading: loading,
            noOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNoOptions),
            loadOptions: loadOptions,
            loadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownLoading)
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)(), {
            onChange: onChange,
            onFocus: ()=>setHasBeenFocused(true),
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownSelect),
            value: value !== null && value !== void 0 ? value : null
        })));
    };
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("3uIOs", function(module, exports) {
    $parcel$export(module.exports, "EditOtherOption", ()=>$28b6ef57e6d15d46$export$589a3e241a77ada7);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $koVbs;
    var $6LCpJ;
    var $6YPn9;
    const $28b6ef57e6d15d46$export$589a3e241a77ada7 = ({ dropdown: dropdown, isDisabled: isDisabled, value: value, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const TextWrapper = dropdown ? $28b6ef57e6d15d46$var$OptionalTextWrapperDropdown : $28b6ef57e6d15d46$var$OptionalTextWrapper;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(TextWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
            appearance: "standard",
            isCompact: false,
            placeholder: intl.formatMessage((0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNewOption),
            isDisabled: isDisabled,
            isReadOnly: false,
            minimumRows: 2,
            maxHeight: "none",
            isMonospaced: false,
            value: value,
            resize: "smart",
            spellCheck: false,
            theme: undefined,
            onBlur: undefined,
            onChange: (event)=>{
                onChange ? onChange(event) : undefined;
            },
            onFocus: undefined
        }));
    };
    const $28b6ef57e6d15d46$var$OptionalTextWrapper = (0, $dAHxw.default).div({
        marginLeft: "var(--ds-space-300, 24px)"
    });
    const $28b6ef57e6d15d46$var$OptionalTextWrapperDropdown = (0, $dAHxw.default).div({
        marginTop: "var(--ds-space-050, 4px)"
    });
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("6YPn9", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$515032243273a247$export$defe85febe8b728c);
    var $7VHMR;
    const $515032243273a247$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        choiceDropdownSelect: {
            id: 'form-system.choice-dropdown.select',
            defaultMessage: 'Select...',
            description: 'Placeholder text in dropdown waiting for the user to select something.'
        },
        choiceDropdownLoading: {
            id: 'form-system.choice-dropdown.loading',
            defaultMessage: 'Loading...',
            description: 'Placeholder text in dropdown while loading.'
        },
        choiceDropdownNoOptions: {
            id: 'form-system.choice-dropdown.no-options',
            defaultMessage: 'No options',
            description: 'Placeholder text in dropdown when there are no options.'
        },
        choiceDropdownNewOption: {
            id: 'form-system.choice-dropdown.new-option',
            defaultMessage: 'New option...',
            description: 'Placeholder text in dropdown when a new option can be created.'
        }
    });
});
parcelRegister("diuGR", function(module, exports) {
    $parcel$export(module.exports, "ViewDropdown", ()=>$9ae4c3417473dd28$export$1a3e8c431e82eb82);
    var $5uXOq = parcelRequire("5uXOq");
    var $51H8P;
    var $7K5PP;
    var $8iale;
    var $hBksn;
    var $5aEbC;
    const $9ae4c3417473dd28$var$styles = {
        control: (base)=>({
                ...base,
                backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, (0, parcelRequire("51H8P")).N20})`,
                borderColor: "var(--ds-border-disabled, #DFE1E6)",
                color: "var(--ds-text, #172B4D !important)"
            }),
        menu: (base)=>({
                ...base,
                color: "var(--ds-text, #172B4D)"
            })
    };
    const $9ae4c3417473dd28$export$1a3e8c431e82eb82 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            key: id,
            id: id,
            options: options,
            value: value,
            placeholder: "",
            isDisabled: true,
            styles: $9ae4c3417473dd28$var$styles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5aEbC")).ViewOtherOption), {
            dropdown: true,
            display: hasOtherOption,
            value: otherOptionText
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, hasOtherOption && otherOptionText || value && value.label);
    };
});
parcelRegister("5aEbC", function(module, exports) {
    $parcel$export(module.exports, "ViewOtherOption", ()=>$3c3d0f1fcc645f3c$export$4444a1a54c5eeec2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    const $3c3d0f1fcc645f3c$export$4444a1a54c5eeec2 = ({ dropdown: dropdown, display: display, value: value })=>{
        if (!display) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        const TextWrapper = dropdown ? $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapperDropdown : $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapper;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(TextWrapper, null, value);
    };
    const $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapper = (0, $dAHxw.default).div`
	padding: ${"var(--ds-space-100, 8px)"};
	margin-left: ${"var(--ds-space-300, 24px)"};
	margin-bottom: ${"var(--ds-space-100, 8px)"};
	margin-right: ${"var(--ds-space-100, 8px)"};
	background-color: ${"var(--ds-background-disabled, white)"};
	color: ${"var(--ds-text-disabled, #172b4d !important)"};
`;
    const $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapperDropdown = (0, $dAHxw.default).div`
	padding: ${"var(--ds-space-100, 8px)"};
	margin-top: ${"var(--ds-space-050, 4px)"};
	background-color: ${"var(--ds-background-disabled, white)"};
	color: ${"var(--ds-text-disabled, #172b4d !important)"};
`;
});
parcelRegister("jLknN", function(module, exports) {
    $parcel$export(module.exports, "DropdownMultiselect", ()=>$e63237b770d73786$export$61a2787f31ddc186);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $cnwtr;
    var $kH8LN;
    var $4QmvR;
    var $ctPpG;
    var $8iale;
    var $cbTKF;
    var $7IStc;
    const $e63237b770d73786$export$61a2787f31ddc186 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode })=>{
        var _questionStore$issueF;
        const availableOptions = questionStore.availableOptions();
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const currentOptions = questionStore.getAnswerChoicesAsObjects();
        const hasOtherChoice = !!questionStore.otherChoiceId;
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
        if (showEditComponent) {
            const otherChoiceSelected = hasOtherChoice && currentOptions.some((option)=>option.value === questionStore.otherChoiceId);
            const onChange = (values)=>{
                const newChoiceIds = values.map((option)=>option.value);
                questionStore.setAnswer({
                    text: otherChoiceSelected ? (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                    choices: newChoiceIds,
                    choiceObjects: values.map((0, (0, parcelRequire("4QmvR")).QuestionStore).optionToChoice)
                });
            };
            const loadChoicesAsync = questionStore.isAsyncChoicesField ? (0, (0, parcelRequire("cnwtr")).debounce)((inputValue, callback)=>{
                formStore.loadChoicesAsync(questionStore.id, inputValue).then((_)=>callback(questionStore.choices.map((0, (0, parcelRequire("kH8LN")).toSelectOption))));
            }, 500) : undefined;
            const onOtherChoiceTextChange = (event)=>{
                questionStore.setAnswer({
                    text: event.target.value,
                    choices: (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbTKF")).EditDropdownMultiselect), {
                id: id,
                key: `${id}-${questionStore.dependentFieldChangedCount}`,
                options: availableOptions,
                value: currentOptions,
                loading: questionStore.loading,
                loadOptions: loadChoicesAsync,
                isCreatable: (0, (0, parcelRequire("ctPpG")).isAsyncCreatable)(questionStore),
                onChange: onChange,
                hasOtherOption: hasOtherChoice,
                otherOptionSelected: otherChoiceSelected,
                otherOptionText: currentAnswer.text,
                onOtherOptionTextChange: onOtherChoiceTextChange,
                isInvalid: !!questionStore.validationErrors
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IStc")).ViewDropdownMultiselect), {
            id: id,
            options: availableOptions,
            value: currentOptions,
            hasOtherOption: hasOtherChoice,
            otherOptionText: currentAnswer.text,
            displayMode: displayMode
        });
    });
});
parcelRegister("cbTKF", function(module, exports) {
    $parcel$export(module.exports, "EditDropdownMultiselect", ()=>$8e01c2400a4a27c3$export$263bc266433bf0b6);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $1ZftP;
    var $d7FF4;
    var $7K5PP;
    var $4dI0P;
    var $hBksn;
    var $3uIOs;
    var $6YPn9;
    const $8e01c2400a4a27c3$export$263bc266433bf0b6 = ({ id: id, options: options, value: value, loading: loading, loadOptions: loadOptions, isCreatable: isCreatable, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, isInvalid: isInvalid })=>{
        const [hasBeenFocused, setHasBeenFocused] = (0, $5uXOq.useState)(false);
        if (loadOptions === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).SelectErrorContainer), {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), (0, $bS32t.default)({
            id: id,
            options: options,
            value: value,
            isLoading: loading,
            onChange: onChange,
            isMulti: true
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)(), {
            isSearchable: true,
            noOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNoOptions),
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownSelect)
        })), hasOtherOption && otherOptionSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uIOs")).EditOtherOption), {
            dropdown: true,
            value: otherOptionText,
            isDisabled: !otherOptionSelected,
            onChange: onOtherOptionTextChange
        }));
        const MaybeCreatableAsyncSelect = isCreatable ? (0, (0, parcelRequire("1ZftP")).default) : (0, (0, parcelRequire("d7FF4")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).SelectErrorContainer), {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(MaybeCreatableAsyncSelect, (0, $bS32t.default)({
            autoFocus: hasBeenFocused,
            defaultMenuIsOpen: hasBeenFocused,
            defaultOptions: hasBeenFocused,
            id: id,
            isMulti: true,
            isSearchable: true,
            isValidNewOption: isCreatable ? (inputValue)=>inputValue.length > 0 && !inputValue.includes(' ') : undefined,
            key: id + hasBeenFocused,
            isLoading: loading,
            noOptionsMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNoOptions),
            loadOptions: loadOptions,
            loadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownLoading),
            onChange: onChange,
            onFocus: ()=>setHasBeenFocused(true),
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownSelect),
            value: value
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)())));
    };
});
parcelRegister("1ZftP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffe39b95a8bd43db$export$2e2bcd8739ae039);
    var $isgat;
    var $3c98u;
    const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("isgat")).default));
    var $ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;
});
parcelRegister("isgat", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6ce0d05b9e97e68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $2HH7Y;
    var $9uJ4X;
    const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const stateManagerProps = (0, (0, parcelRequire("iaInK")).default)(props);
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(stateManagerProps);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("7IStc", function(module, exports) {
    $parcel$export(module.exports, "ViewDropdownMultiselect", ()=>$59f6e50dc3f38ee3$export$70cbf19b62c07ef9);
    var $5uXOq = parcelRequire("5uXOq");
    var $51H8P;
    var $7K5PP;
    var $8iale;
    var $hBksn;
    var $5aEbC;
    const $59f6e50dc3f38ee3$var$styles = {
        control: (base)=>({
                ...base,
                backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, (0, parcelRequire("51H8P")).N20})`,
                borderColor: "var(--ds-border-disabled, #DFE1E6)",
                color: "var(--ds-text, #172B4D !important)"
            }),
        menu: (base)=>({
                ...base,
                color: "var(--ds-text, #172B4D)"
            })
    };
    const $59f6e50dc3f38ee3$export$70cbf19b62c07ef9 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
        const labels = value && value.map((item)=>item.label);
        if (labels && hasOtherOption && otherOptionText) {
            labels.push(otherOptionText);
            const lastIndex = labels.lastIndexOf('Other...');
            if (lastIndex !== -1) labels.splice(lastIndex, 1);
        }
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            id: id,
            options: options,
            value: value,
            isMulti: true,
            placeholder: "",
            isDisabled: true,
            styles: $59f6e50dc3f38ee3$var$styles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5aEbC")).ViewOtherOption), {
            dropdown: true,
            display: hasOtherOption,
            value: otherOptionText
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, labels && labels.join(', '));
    };
});
parcelRegister("cGJ7q", function(module, exports) {
    $parcel$export(module.exports, "Date", ()=>$93cc67ea76b37d18$export$6341f9a885713487);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $fKL5L;
    var $dv29C;
    const $93cc67ea76b37d18$export$6341f9a885713487 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fKL5L")).EditDate), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            onChange: (value)=>questionStore.setAnswer(value)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dv29C")).ViewDate), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    });
});
parcelRegister("fKL5L", function(module, exports) {
    $parcel$export(module.exports, "EditDate", ()=>$b77fae5d063f7451$export$9b310bf64ea058a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $koVbs;
    var $cHapz;
    var $VSDnB;
    var $fiX4W;
    var $dpaDt;
    var $9c6Sr;
    var $hBksn;
    var $fD4eY;
    var $dnKOm;
    const $b77fae5d063f7451$export$9b310bf64ea058a0 = ({ id: id, value: value, isInvalid: isInvalid, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const startOfWeekDay = (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("9c6Sr")).getLocale)(intl.locale), 'options.weekStartsOn', (0, (0, parcelRequire("9c6Sr")).DEFAULT_WEEK_START_DAY));
        return (0, (0, parcelRequire("dpaDt")).isMobile)() && !(0, (0, parcelRequire("VSDnB")).fg)('proforma_use_atlaskit_date_time_picker_for_mobile') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fD4eY")).DatePickerMobile), {
            dateValue: value,
            onChange: onChange
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortFieldWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
            id: id,
            value: value,
            isInvalid: isInvalid,
            onChange: onChange,
            locale: intl.locale || (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE),
            placeholder: intl.formatMessage((0, (0, parcelRequire("dnKOm")).IntlEditDateMessages)[(0, (0, parcelRequire("dnKOm")).EditDateMessages).DatePlaceholder], {
                date: intl.formatDate(new Date(), {})
            }),
            weekStartDay: startOfWeekDay,
            label: "Date"
        }));
    };
});
parcelRegister("cHapz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a844b50b385d50f7$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $2TI0z;
    var $jcbUF;
    const $a844b50b385d50f7$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    var $a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;
});
parcelRegister("cKsfY", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8f027f90da2b6bac$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("2TI0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19201d0a1f7d7d54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
    const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
    const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $19201d0a1f7d7d54$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $19201d0a1f7d7d54$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $19201d0a1f7d7d54$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props);
            this.containerRef = null;
            this.calendarRef = (0, $5uXOq.createRef)();
            this.calendarButtonRef = (0, $5uXOq.createRef)();
            this.getValue = ()=>this.props.value ?? this.state.value;
            this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
            this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("5RLF6")).getParsedISO)({
                        iso: iso
                    })
                });
            };
            this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            };
            this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            };
            this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            };
            this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            };
            this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            };
            this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            };
            this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            };
            this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            };
            this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            };
            this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            };
            this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("gtijU")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("5RLF6")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $19201d0a1f7d7d54$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9KnKW")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $19201d0a1f7d7d54$var$iconContainerStyles,
                        value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $19201d0a1f7d7d54$var$calendarButtonStyles,
                        (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $19201d0a1f7d7d54$var$DatePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'datePicker',
        packageName: $19201d0a1f7d7d54$var$packageName,
        packageVersion: $19201d0a1f7d7d54$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $19201d0a1f7d7d54$var$packageName,
                packageVersion: $19201d0a1f7d7d54$var$packageVersion
            }
        })
    })($19201d0a1f7d7d54$export$df43d21f5faca9f7));
    var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;
});
parcelRegister("acknU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));
    var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
    function $76cad653a4883392$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $76cad653a4883392$var$CalendarIcon = (props)=>$76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
        }, props));
    $76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("jHBnA", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$91948b176ea23188$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$91948b176ea23188$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$91948b176ea23188$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$91948b176ea23188$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$91948b176ea23188$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$91948b176ea23188$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$91948b176ea23188$export$2eeb05a2ecc2ce0a);
    const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
    const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $91948b176ea23188$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
    const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("5RLF6", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$e0db4b6edb7dbfac$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$e0db4b6edb7dbfac$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$e0db4b6edb7dbfac$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$e0db4b6edb7dbfac$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $2ucUe;
    var $jHBnA;
    const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("jHBnA")).placeholderDatetime));
    };
});
parcelRegister("2ucUe", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$ca6f20a476eda5dc$export$4d5430175be73d45);
    const $ca6f20a476eda5dc$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
    const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
    function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("iaQLg", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$d73476b891de3e0c$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $bChGW;
    function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorsContainer, rest));
});
parcelRegister("gtijU", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e800a879ee1613fc$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $1f0Hs;
    var $9MHPe;
    var $k5uoT;
    var $avHVh;
    function $e800a879ee1613fc$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $e800a879ee1613fc$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $e800a879ee1613fc$var$menuStyles,
                ...innerProps
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1f0Hs")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("1f0Hs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16abbcd9b9109722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $ePz3p;
    var $lJWdi;
    var $avO9B;
    var $iioJV;
    var $jihAA;
    var $bbnGB;
    var $hbcve;
    var $2TGJ3;
    var $f9D1v;
    var $9efze;
    const $16abbcd9b9109722$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $16abbcd9b9109722$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $16abbcd9b9109722$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: onFocus = (0, (0, parcelRequire("eGmKJ")).default), onSelect: onSelect = (0, (0, parcelRequire("eGmKJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("jihAA")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("2TGJ3")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("f9D1v")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("bbnGB")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("9efze")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("hbcve")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $16abbcd9b9109722$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ePz3p")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avO9B")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lJWdi")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $16abbcd9b9109722$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($16abbcd9b9109722$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
    var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;
});
parcelRegister("ePz3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995afee12cb828f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $9KnKW;
    var $1dJ6S;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    const $995afee12cb828f6$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("9KnKW")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $995afee12cb828f6$var$Header.displayName = 'Header';
    var $995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("lJWdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43f22a52ec309eeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $1q4y8;
    var $h581D;
    const $43f22a52ec309eeb$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1q4y8")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
    var $43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;
});
parcelRegister("1q4y8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d70b02566a310b79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGmKJ;
    var $bgrar;
    var $h0WbJ;
    const $d70b02566a310b79$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("eGmKJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("h0WbJ")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $d70b02566a310b79$var$Date.displayName = 'Date';
    var $d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;
});
parcelRegister("h0WbJ", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$a52fc59169f9ec00$export$f62807af68630d86);
    const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("h581D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8aba25f4ae00ff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bgrar;
    const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;
});
parcelRegister("avO9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f29b1b1295ce3a84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $h581D;
    const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $f29b1b1295ce3a84$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
    var $f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;
});
parcelRegister("iioJV", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$85c2ac8e9452c4bf$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$85c2ac8e9452c4bf$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
    const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
    const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
    const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];
});
parcelRegister("jihAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$654a69afe715a212$export$2e2bcd8739ae039);
    var $33etG;
    var $f8qry;
    var $3EtUb;
    function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("f8qry")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("33etG")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("33etG")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("33etG")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("33etG")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("3EtUb")).default)(thisMonth)}-${(0, (0, parcelRequire("3EtUb")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("33etG")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("33etG")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("3EtUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd804e1790f6d755$export$2e2bcd8739ae039);
    function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("bbnGB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ccb38b64bb63461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("hbcve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe53b5f3382c02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $iioJV;
    var $6ASl9;
    var $5wbTt;
    function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("iioJV")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("5wbTt")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("iioJV")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5wbTt")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("6ASl9")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("6ASl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ae62fd51c4538f$export$2e2bcd8739ae039);
    var $3EtUb;
    function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("3EtUb")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("3EtUb")).default)(date.day)}`;
    }
});
parcelRegister("5wbTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dff1ed1384abe91$export$2e2bcd8739ae039);
    var $iioJV;
    var $9Zmg7;
    function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("iioJV")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("9Zmg7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$878800070b837d93$export$2e2bcd8739ae039);
    function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("2TGJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caae4eff24f6e8d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    var $9Zmg7;
    const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("iioJV")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("iioJV")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("iioJV")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("iioJV")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("f9D1v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42ec54640e7b9de4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("iioJV")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("9efze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd6f430b06675a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qZ1x;
    function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("avHVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac07968b7cb494a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $5owSH;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $k5uoT;
    class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("5owSH")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("k5uoT")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args);
            this.update = (0, (0, parcelRequire("eGmKJ")).default);
        }
    }
});
parcelRegister("6AqCE", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$caee16c105163c22$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$caee16c105163c22$export$ff525416014fb67d);
    var $k7m40;
    var $2ucUe;
    function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD'));
    }
    function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("dBs4v", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$9661917c82165ad2$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("jcbUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5b21daaca02ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48f5b21daaca02ab$var$packageName = "platform-pkg";
    const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
    const $48f5b21daaca02ab$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $48f5b21daaca02ab$var$packageName,
        packageVersion: $48f5b21daaca02ab$var$packageVersion
    };
    const $48f5b21daaca02ab$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $48f5b21daaca02ab$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $48f5b21daaca02ab$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $48f5b21daaca02ab$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $48f5b21daaca02ab$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$48f5b21daaca02ab$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("5RLF6")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("gtijU")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("5RLF6")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("9KnKW")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $48f5b21daaca02ab$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $48f5b21daaca02ab$var$iconContainerStyles,
                value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $48f5b21daaca02ab$var$calendarButtonStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($48f5b21daaca02ab$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;
});
parcelRegister("9c6Sr", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", ()=>$6b1a91b76b2dd4ba$export$845e1054649a85c2);
    $parcel$export(module.exports, "getLocale", ()=>$6b1a91b76b2dd4ba$export$180605366c04f0cd);
    var $h5fUo;
    var $ffv2q;
    var $dm4b1;
    var $aFgGS;
    var $llpfr;
    var $9iTW1;
    var $jhzA6;
    var $kxtvT;
    var $hEliE;
    var $hIVAh;
    var $5hliK;
    var $jxRuk;
    var $L1VDF;
    var $jZP2w;
    var $l4n7P;
    var $eeqpy;
    var $gsxJS;
    var $30BQk;
    var $9XBqA;
    var $41VsA;
    var $dy8Kh;
    var $bVTfl;
    var $hTCZG;
    var $84SrD;
    var $cuiuC;
    var $7XYbY;
    var $5xGxo;
    var $bYR3G;
    var $fiX4W;
    const $6b1a91b76b2dd4ba$export$df1c34db1371eeed = {
        arDZ: (0, parcelRequire("h5fUo")).default,
        ar: (0, (0, parcelRequire("h5fUo")).default),
        ar_DZ: (0, (0, parcelRequire("h5fUo")).default),
        cs: (0, parcelRequire("ffv2q")).default,
        cs_CZ: (0, (0, parcelRequire("ffv2q")).default),
        'cs-CZ': (0, (0, parcelRequire("ffv2q")).default),
        da: (0, parcelRequire("dm4b1")).default,
        da_DK: (0, (0, parcelRequire("dm4b1")).default),
        'da-DK': (0, (0, parcelRequire("dm4b1")).default),
        de: (0, parcelRequire("aFgGS")).default,
        de_DE: (0, (0, parcelRequire("aFgGS")).default),
        'de-DE': (0, (0, parcelRequire("aFgGS")).default),
        enUS: (0, parcelRequire("jhzA6")).default,
        en_US: (0, (0, parcelRequire("jhzA6")).default),
        'en-US': (0, (0, parcelRequire("jhzA6")).default),
        enGB: (0, parcelRequire("9iTW1")).default,
        en_UK: (0, (0, parcelRequire("9iTW1")).default),
        'en-UK': (0, (0, parcelRequire("9iTW1")).default),
        'en-GB': (0, (0, parcelRequire("9iTW1")).default),
        en_GB: (0, (0, parcelRequire("9iTW1")).default),
        enAU: (0, parcelRequire("llpfr")).default,
        en_AU: (0, (0, parcelRequire("llpfr")).default),
        'en-AU': (0, (0, parcelRequire("llpfr")).default),
        es: (0, parcelRequire("kxtvT")).default,
        es_ES: (0, (0, parcelRequire("kxtvT")).default),
        'es-ES': (0, (0, parcelRequire("kxtvT")).default),
        et: (0, parcelRequire("hEliE")).default,
        et_EE: (0, (0, parcelRequire("hEliE")).default),
        'et-EE': (0, (0, parcelRequire("hEliE")).default),
        fi: (0, parcelRequire("hIVAh")).default,
        fi_FI: (0, (0, parcelRequire("hIVAh")).default),
        'fi-FI': (0, (0, parcelRequire("hIVAh")).default),
        fr: (0, parcelRequire("5hliK")).default,
        fr_FR: (0, (0, parcelRequire("5hliK")).default),
        'fr-FR': (0, (0, parcelRequire("5hliK")).default),
        hu: (0, parcelRequire("jxRuk")).default,
        hu_HU: (0, (0, parcelRequire("jxRuk")).default),
        'hu-HU': (0, (0, parcelRequire("jxRuk")).default),
        is: (0, parcelRequire("L1VDF")).default,
        is_IS: (0, (0, parcelRequire("L1VDF")).default),
        'is-IS': (0, (0, parcelRequire("L1VDF")).default),
        it: (0, parcelRequire("jZP2w")).default,
        it_IT: (0, (0, parcelRequire("jZP2w")).default),
        'it-IT': (0, (0, parcelRequire("jZP2w")).default),
        ja: (0, parcelRequire("l4n7P")).default,
        ja_JP: (0, (0, parcelRequire("l4n7P")).default),
        'ja-JP': (0, (0, parcelRequire("l4n7P")).default),
        ko: (0, parcelRequire("eeqpy")).default,
        ko_KR: (0, (0, parcelRequire("eeqpy")).default),
        'ko-KR': (0, (0, parcelRequire("eeqpy")).default),
        nb: (0, parcelRequire("gsxJS")).default,
        nb_NO: (0, (0, parcelRequire("gsxJS")).default),
        'nb-NO': (0, (0, parcelRequire("gsxJS")).default),
        nl: (0, parcelRequire("30BQk")).default,
        nl_NL: (0, (0, parcelRequire("30BQk")).default),
        'nl-NL': (0, (0, parcelRequire("30BQk")).default),
        pl: (0, parcelRequire("9XBqA")).default,
        pl_PL: (0, (0, parcelRequire("9XBqA")).default),
        'pl-PL': (0, (0, parcelRequire("9XBqA")).default),
        pt: (0, parcelRequire("41VsA")).default,
        'pt-PT': (0, (0, parcelRequire("41VsA")).default),
        pt_PT: (0, (0, parcelRequire("41VsA")).default),
        ptBR: (0, parcelRequire("dy8Kh")).default,
        'pt-BR': (0, (0, parcelRequire("dy8Kh")).default),
        pt_BR: (0, (0, parcelRequire("dy8Kh")).default),
        ro: (0, parcelRequire("bVTfl")).default,
        ro_RO: (0, (0, parcelRequire("bVTfl")).default),
        'ro-RO': (0, (0, parcelRequire("bVTfl")).default),
        ru: (0, parcelRequire("hTCZG")).default,
        ru_RU: (0, (0, parcelRequire("hTCZG")).default),
        'ru-RU': (0, (0, parcelRequire("hTCZG")).default),
        sk: (0, parcelRequire("84SrD")).default,
        sk_SK: (0, (0, parcelRequire("84SrD")).default),
        'sk-SK': (0, (0, parcelRequire("84SrD")).default),
        sv: (0, parcelRequire("cuiuC")).default,
        sv_SE: (0, (0, parcelRequire("cuiuC")).default),
        'sv-SE': (0, (0, parcelRequire("cuiuC")).default),
        tr: (0, parcelRequire("7XYbY")).default,
        'tr-TR': (0, (0, parcelRequire("7XYbY")).default),
        tr_TR: (0, (0, parcelRequire("7XYbY")).default),
        zhCN: (0, parcelRequire("5xGxo")).default,
        'zh-CN': (0, (0, parcelRequire("5xGxo")).default),
        zh_CN: (0, (0, parcelRequire("5xGxo")).default),
        zhTW: (0, parcelRequire("bYR3G")).default,
        'zh-TW': (0, (0, parcelRequire("bYR3G")).default),
        zh_TW: (0, (0, parcelRequire("bYR3G")).default)
    };
    const $6b1a91b76b2dd4ba$export$845e1054649a85c2 = 0;
    const $6b1a91b76b2dd4ba$export$180605366c04f0cd = (localeString)=>{
        const key = localeString;
        return $6b1a91b76b2dd4ba$export$df1c34db1371eeed[key] || $6b1a91b76b2dd4ba$export$df1c34db1371eeed[0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE];
    };
});
parcelRegister("fD4eY", function(module, exports) {
    $parcel$export(module.exports, "DatePickerMobile", ()=>$b60dc999602e0454$export$d4f2531de00bdbd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $koVbs;
    var $dnKOm;
    const $b60dc999602e0454$export$d4f2531de00bdbd4 = ({ id: id, dateValue: dateValue, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b60dc999602e0454$var$DatePickerMobileStyles, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            id: id,
            type: "date",
            value: dateValue,
            onChange: onChange ? (event)=>onChange(event.target.value) : undefined,
            placeholder: intl.formatMessage((0, (0, parcelRequire("dnKOm")).IntlEditDateMessages)[(0, (0, parcelRequire("dnKOm")).EditDateMessages).DatePlaceholder], {
                date: intl.formatDate(new Date(), {})
            })
        }));
    };
    const $b60dc999602e0454$var$DatePickerMobileStyles = (0, $dAHxw.default).div({
        '& > input': {
            whiteSpace: 'initial',
            display: 'flex',
            backgroundColor: "var(--ds-background-input, #f4f5f7)",
            borderColor: "var(--ds-border-inverse, #f4f5f7)",
            borderRadius: "var(--ds-border-radius, 3px)",
            marginBottom: "var(--ds-space-100, 8px)",
            boxShadow: 'none',
            borderStyle: 'solid',
            borderWidth: "var(--ds-border-width, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-075, 6px)",
            boxSizing: 'border-box',
            width: '100%',
            '&:hover': {
                backgroundColor: "var(--ds-background-input-hovered, #ebecf0)"
            }
        }
    });
});
parcelRegister("dnKOm", function(module, exports) {
    $parcel$export(module.exports, "EditDateMessages", ()=>$9be1bc18bc18050f$export$f52547d1f3be6201);
    $parcel$export(module.exports, "IntlEditDateMessages", ()=>$9be1bc18bc18050f$export$4c6d5d4699fcb1bd);
    var $7VHMR;
    let $9be1bc18bc18050f$export$f52547d1f3be6201 = function(EditDateMessages) {
        EditDateMessages["DatePlaceholder"] = "DatePlaceholder";
        return EditDateMessages;
    }({});
    const $9be1bc18bc18050f$export$4c6d5d4699fcb1bd = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$9be1bc18bc18050f$export$f52547d1f3be6201.DatePlaceholder]: {
            id: 'form-system.DateQuestion.DatePlaceholder',
            defaultMessage: 'e.g. {date}'
        }
    });
});
parcelRegister("dv29C", function(module, exports) {
    $parcel$export(module.exports, "ViewDate", ()=>$9d3fd76483ccf621$export$2c30cd42d7b40e0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cHapz;
    var $fiX4W;
    var $8iale;
    var $6YylQ;
    var $hBksn;
    const $9d3fd76483ccf621$var$formatValueForView = (currentAnswer, locale)=>{
        if (!currentAnswer || currentAnswer.length === 0) return '';
        return new Intl.DateTimeFormat(locale, {
            ...(0, (0, parcelRequire("6YylQ")).longDateOnlyFormat),
            timeZone: 'UTC'
        }).format(Date.parse(currentAnswer));
    };
    const $9d3fd76483ccf621$export$2c30cd42d7b40e0f = ({ id: id, value: value, displayMode: displayMode })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortFieldWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).FieldDisabledWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
            id: id,
            value: value,
            locale: intl.locale || (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE),
            placeholder: " ",
            isDisabled: true,
            appearance: "subtle"
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, $9d3fd76483ccf621$var$formatValueForView(value, intl.locale));
    };
});
parcelRegister("6YylQ", function(module, exports) {
    $parcel$export(module.exports, "longDateOnlyFormat", ()=>$5142fe259e6a615c$export$51f819d50bcd4ae1);
    $parcel$export(module.exports, "longTimeOnlyFormat", ()=>$5142fe259e6a615c$export$a3aff10871f7171c);
    const $5142fe259e6a615c$export$f2f390060309965 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    };
    const $5142fe259e6a615c$export$51f819d50bcd4ae1 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
    const $5142fe259e6a615c$export$a3aff10871f7171c = {
        hour: 'numeric',
        minute: 'numeric'
    };
});
parcelRegister("bchDp", function(module, exports) {
    $parcel$export(module.exports, "DateTime", ()=>$826e7e9134f8351b$export$82f9ebd9adeba146);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $hYgPO;
    var $37690;
    const $826e7e9134f8351b$export$82f9ebd9adeba146 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYgPO")).EditDateTime), {
            id: id,
            dateValue: currentAnswer.date,
            timeValue: currentAnswer.time,
            isInvalid: !!questionStore.validationErrors,
            onDateChange: (value)=>{
                questionStore.setAnswer({
                    date: value,
                    time: (0, (0, parcelRequire("4QmvR")).toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer).time
                });
            },
            onTimeChange: (value)=>{
                questionStore.setAnswer({
                    date: (0, (0, parcelRequire("4QmvR")).toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer).date,
                    time: value
                });
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("37690")).ViewDateTime), {
            id: id,
            dateValue: currentAnswer.date,
            timeValue: currentAnswer.time,
            displayMode: displayMode
        });
    });
});
parcelRegister("hYgPO", function(module, exports) {
    $parcel$export(module.exports, "EditDateTime", ()=>$d1551943753e3384$export$eee3c3913c1d4b94);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $hBksn;
    var $fKL5L;
    var $6MwDx;
    const $d1551943753e3384$export$eee3c3913c1d4b94 = ({ id: id, dateValue: dateValue, timeValue: timeValue, isInvalid: isInvalid, onDateChange: onDateChange, onTimeChange: onTimeChange })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d1551943753e3384$var$DateTimePickerContainer, {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fKL5L")).EditDate), {
            id: id,
            value: dateValue,
            isInvalid: false,
            onChange: onDateChange
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MwDx")).EditTime), {
            id: id + '-time',
            value: timeValue,
            isInvalid: false,
            onChange: onTimeChange
        }));
    };
    const $d1551943753e3384$var$DateTimePickerContainer = (0, $dAHxw.default).div({
        display: 'flex',
        '> div': {
            width: '50%'
        }
    }, (props)=>props.isInvalid && (0, (0, parcelRequire("hBksn")).invalidFieldContainerStyles));
});
parcelRegister("6MwDx", function(module, exports) {
    $parcel$export(module.exports, "EditTime", ()=>$4f008ac450d5ca31$export$289bb9c0e3074c18);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jdTq6;
    var $VSDnB;
    var $fiX4W;
    var $dpaDt;
    var $giaor;
    var $hBksn;
    var $ak9K8;
    var $6LBmA;
    const $4f008ac450d5ca31$export$289bb9c0e3074c18 = ({ id: id, value: value, isInvalid: isInvalid, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("dpaDt")).isMobile)() && !(0, (0, parcelRequire("VSDnB")).fg)('proforma_use_atlaskit_date_time_picker_for_mobile') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ak9K8")).TimePickerMobile), {
            timeValue: value,
            onChange: onChange
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortFieldWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdTq6")).default), {
            id: id,
            times: (0, (0, parcelRequire("giaor")).times),
            value: value,
            isInvalid: isInvalid,
            onChange: onChange,
            locale: intl.locale || (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE),
            timeIsEditable: true,
            placeholder: intl.formatMessage((0, (0, parcelRequire("6LBmA")).IntlEditTimeMessages)[(0, (0, parcelRequire("6LBmA")).EditTimeMessages).TimePlaceholder], {
                time: intl.formatTime(new Date(), {})
            }),
            label: "Time"
        }));
    };
});
parcelRegister("jdTq6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$420c0ce16dc216b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k7m40;
    var $jovBr;
    var $6QvkM;
    var $eGmKJ;
    var $7qZ1x;
    var $iOwNT;
    var $7K5PP;
    var $7VXAu;
    var $jHBnA;
    var $imOgG;
    var $j537G;
    var $2ucUe;
    var $dBs4v;
    const $420c0ce16dc216b4$var$packageName = "platform-pkg";
    const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
    const $420c0ce16dc216b4$var$menuStyles = {
        position: 'static',
        overflowY: 'auto',
        margin: 0
    };
    const $420c0ce16dc216b4$var$analyticsAttributes = {
        componentName: 'timePicker',
        packageName: $420c0ce16dc216b4$var$packageName,
        packageVersion: $420c0ce16dc216b4$var$packageVersion
    };
    const $420c0ce16dc216b4$var$TimePicker = (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: providedOnChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: providedOnFocus = (0, (0, parcelRequire("eGmKJ")).default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, (0, parcelRequire("j537G")).default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, (0, parcelRequire("jHBnA")).defaultTimes), value: providedValue }, ref)=>{
        const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
        const providedOnChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnChange,
            action: 'selectedTime',
            ...$420c0ce16dc216b4$var$analyticsAttributes
        });
        (0, $5uXOq.useEffect)(()=>{
            if (providedValue) setValue(providedValue);
        }, [
            providedValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (providedIsOpen) setIsOpen(providedIsOpen);
        }, [
            providedIsOpen
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
            const rawValue = newValue ? newValue.value || newValue : '';
            const finalValue = rawValue.toString();
            setValue(finalValue);
            if (action && action.action === 'clear') setClearingFromIcon(true);
            providedOnChangeWithAnalytics(finalValue);
        }, [
            providedOnChangeWithAnalytics
        ]);
        const onCreateOption = (inputValue)=>{
            if (timeIsEditable) {
                let sanitizedInput;
                try {
                    sanitizedInput = parseInputValue(inputValue, timeFormat || (0, (0, parcelRequire("jHBnA")).defaultTimeFormat));
                } catch (e) {
                    return;
                }
                const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
                const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
                const formattedValue = (0, (0, parcelRequire("k7m40")).default)(sanitizedInput, formatFormat) || '';
                setValue(formattedValue);
                providedOnChangeWithAnalytics(formattedValue);
            } else providedOnChangeWithAnalytics(inputValue);
        };
        const onMenuOpen = ()=>{
            if (clearingFromIcon) setClearingFromIcon(false);
            else setIsOpen(true);
        };
        const onMenuClose = ()=>{
            if (clearingFromIcon) setClearingFromIcon(false);
            else setIsOpen(false);
        };
        const setInternalContainerRef = (ref)=>{
            const oldRef = containerRef;
            setContainerRef(ref);
            if (oldRef === null && ref !== null) forceUpdate();
        };
        const onBlur = (event)=>{
            setIsFocused(false);
            providedOnBlur(event);
        };
        const onFocus = (event)=>{
            setIsFocused(true);
            providedOnFocus(event);
        };
        const onSelectKeyDown = (event)=>{
            const { key: key } = event;
            const keyPressed = key.toLowerCase();
            if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) setClearingFromIcon(false);
        };
        const ICON_PADDING = 2;
        const GRID_SIZE = 8;
        const l10n = (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale);
        const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
        const SelectComponent = timeIsEditable ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
        const formatTime = (time)=>{
            if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, (0, parcelRequire("jHBnA")).defaultTimeFormat));
            const date = (0, (0, parcelRequire("j537G")).default)(time);
            if (!(date instanceof Date)) return '';
            if (!(0, (0, parcelRequire("jovBr")).default)(date)) return time;
            if (timeFormat) return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(timeFormat));
            return l10n.formatTime(date);
        };
        const options = times.map((time)=>{
            return {
                label: formatTime(time),
                value: time
            };
        });
        let initialValue;
        if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
            label: formatTime(providedValue),
            value: providedValue
        };
        else if (providedValue !== '' && value) initialValue = {
            label: formatTime(value),
            value: value
        };
        else initialValue = null;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: locale
        });
        const selectComponents = {
            DropdownIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent),
            Menu: (0, (0, parcelRequire("imOgG")).FixedLayerMenu),
            SingleValue: SingleValue,
            ...hideIcon && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const renderIconContainer = Boolean(!hideIcon && value);
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base
                }),
            menu: (base)=>({
                    ...base,
                    ...$420c0ce16dc216b4$var$menuStyles,
                    width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                    paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
                })
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ...innerProps,
            ref: setInternalContainerRef,
            "data-testid": testId && `${testId}--container`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`,
            onKeyDown: onSelectKeyDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            appearance: appearance,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            components: selectComponents,
            inputId: id,
            isClearable: true,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: isOpen && !isDisabled,
            menuPlacement: "auto",
            openMenuOnFocus: true,
            onBlur: onBlur,
            onCreateOption: onCreateOption,
            onChange: onChange,
            options: options,
            onFocus: onFocus,
            onMenuOpen: onMenuOpen,
            onMenuClose: onMenuClose,
            placeholder: placeholder || l10n.formatTime((0, (0, parcelRequire("jHBnA")).placeholderDatetime)),
            styles: mergedStyles,
            value: initialValue,
            spacing: spacing,
            fixedLayerRef: containerRef,
            isInvalid: isInvalid,
            testId: testId,
            ...otherSelectProps
        }));
    });
    var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("imOgG", function(module, exports) {
    $parcel$export(module.exports, "FixedLayerMenu", ()=>$cf860f703ecf4b3d$export$982ad994195b4356);
    var $f8Sb3;
    var $bChGW;
    var $avHVh;
    const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, children: children, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.fixedLayerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Menu, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: innerProps,
                innerRef: innerRef,
                isLoading: isLoading,
                isMulti: isMulti,
                isRtl: isRtl,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView,
                minMenuHeight: minMenuHeight,
                options: options,
                placement: placement,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children),
            testId: selectProps.testId
        });
});
parcelRegister("j537G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5e493719c30ce57$export$2e2bcd8739ae039);
    const $b5e493719c30ce57$var$map24 = {
        '12': '12',
        '01': '13',
        '02': '14',
        '03': '15',
        '04': '16',
        '05': '17',
        '06': '18',
        '07': '19',
        '08': '20',
        '09': '21',
        '10': '22',
        '11': '23'
    };
    function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
        const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
        const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
        const num = timeString.replace(/[^0-9]/g, '');
        const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
        if (!time && !time24hr) return false;
        if (time && !time[1]) return false;
        if (num.length > 6) return false;
        if (num.length > 4 && !includesSeconds) return false;
        if (num.length === 2 && parseInt(num, 10) > 12) return false;
        return true;
    }
    function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
        return time.replace(/[:.]/g, '');
    }
    function $b5e493719c30ce57$export$c38a243baf9c6083(time) {
        if (time.length === 1) return `0${time}00`;
        if (time.length === 2) return `${time}00`;
        if (time.length === 3 || time.length === 5) return `0${time}`;
        return time;
    }
    function $b5e493719c30ce57$export$ed20539f7181c701(hour, meridiem) {
        if (hour > '24') return null;
        if (hour === '12' && meridiem === 'a') return '00';
        if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
        return hour;
    }
    function $b5e493719c30ce57$export$4077529dfc44a251(value) {
        if (value > '59') return null;
        return value;
    }
    function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
        const timeArray = time.toLowerCase().split(/(p|a)/i);
        const meridiem = timeArray[1];
        const semi24 = $b5e493719c30ce57$export$c38a243baf9c6083(timeArray[0].trim());
        const hour = $b5e493719c30ce57$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
        const minute = $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(2, 4));
        const seconds = semi24.length === 6 && $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(4, 6));
        if (!hour || !minute) return null;
        return {
            hour: parseInt(hour, 10),
            minute: parseInt(minute, 10),
            seconds: parseInt(seconds || '0', 10) || 0
        };
    }
    function $b5e493719c30ce57$export$865db99128311580(time) {
        const dateTime = new Date();
        dateTime.setHours(time.hour);
        dateTime.setMinutes(time.minute);
        dateTime.setSeconds(time.seconds || 0, 0);
        return dateTime;
    }
    function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
        const trimmedTime = time.toString().trim();
        if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
        const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
        const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
        if (!time2) throw RangeError('invalid time format');
        return $b5e493719c30ce57$export$865db99128311580(time2);
    }
});
parcelRegister("giaor", function(module, exports) {
    $parcel$export(module.exports, "times", ()=>$bdc663adda57dc5c$export$b5bc26e198ce73d0);
    const $bdc663adda57dc5c$export$b5bc26e198ce73d0 = [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30'
    ];
});
parcelRegister("ak9K8", function(module, exports) {
    $parcel$export(module.exports, "TimePickerMobile", ()=>$7843546acdea69f8$export$3378012995be7fff);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $koVbs;
    var $6LBmA;
    const $7843546acdea69f8$export$3378012995be7fff = ({ id: id, timeValue: timeValue, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7843546acdea69f8$var$TimePickerMobileStyles, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            id: id,
            type: "time",
            step: 1800,
            value: timeValue,
            onChange: onChange ? (event)=>onChange(event.target.value) : undefined,
            placeholder: intl.formatMessage((0, (0, parcelRequire("6LBmA")).IntlEditTimeMessages)[(0, (0, parcelRequire("6LBmA")).EditTimeMessages).TimePlaceholder], {
                date: intl.formatDate(new Date(), {})
            })
        }));
    };
    const $7843546acdea69f8$var$TimePickerMobileStyles = (0, $dAHxw.default).div({
        '& > input': {
            whiteSpace: 'initial',
            display: 'flex',
            backgroundColor: "var(--ds-background-input, #f4f5f7)",
            borderColor: "var(--ds-border-inverse, #f4f5f7)",
            borderRadius: "var(--ds-border-radius, 3px)",
            marginBottom: "var(--ds-space-100, 8px)",
            boxShadow: 'none',
            borderStyle: 'solid',
            borderWidth: "var(--ds-border-width, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-075, 6px)",
            boxSizing: 'border-box',
            width: '100%',
            '&:hover': {
                backgroundColor: "var(--ds-background-input-hovered, #ebecf0)"
            }
        }
    });
});
parcelRegister("6LBmA", function(module, exports) {
    $parcel$export(module.exports, "EditTimeMessages", ()=>$4ed41d6b41268a11$export$294574788aa92dac);
    $parcel$export(module.exports, "IntlEditTimeMessages", ()=>$4ed41d6b41268a11$export$9e56ea5118404c6c);
    var $7VHMR;
    let $4ed41d6b41268a11$export$294574788aa92dac = function(EditTimeMessages) {
        EditTimeMessages["TimePlaceholder"] = "TimePlaceholder";
        return EditTimeMessages;
    }({});
    const $4ed41d6b41268a11$export$9e56ea5118404c6c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$4ed41d6b41268a11$export$294574788aa92dac.TimePlaceholder]: {
            id: 'form-system.TimeQuestion.TimePlaceholder',
            defaultMessage: 'e.g. {time}'
        }
    });
});
parcelRegister("37690", function(module, exports) {
    $parcel$export(module.exports, "ViewDateTime", ()=>$2446caa628a316e5$export$2c68b874ce2247d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $koVbs;
    var $8iale;
    var $6YylQ;
    var $hBksn;
    function $2446caa628a316e5$var$parseDatetimeValueForView(dateAnswer, timeAnswer, intl) {
        const formattedDateValue = dateAnswer.length < 1 ? '' : new Intl.DateTimeFormat(intl.locale, {
            ...(0, (0, parcelRequire("6YylQ")).longDateOnlyFormat),
            timeZone: 'UTC'
        }).format(new Date(dateAnswer));
        let formattedTimeValue = '';
        if (timeAnswer.length) {
            const timeSplit = timeAnswer.split(':');
            const hours = parseInt(timeSplit[0], 10);
            const minutes = parseInt(timeSplit[1], 10);
            formattedTimeValue = new Intl.DateTimeFormat(intl.locale, {
                ...(0, (0, parcelRequire("6YylQ")).longTimeOnlyFormat),
                timeZone: 'UTC'
            }).format(Date.UTC(0, 0, 1, hours, minutes));
        }
        return {
            formattedDateValue: formattedDateValue,
            formattedTimeValue: formattedTimeValue
        };
    }
    const $2446caa628a316e5$export$2c68b874ce2247d1 = ({ dateValue: dateValue, timeValue: timeValue, displayMode: displayMode })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { formattedDateValue: formattedDateValue, formattedTimeValue: formattedTimeValue } = $2446caa628a316e5$var$parseDatetimeValueForView(dateValue || '', timeValue || '', intl);
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$LongDisabledQuestionPlaceholder, null, (0, ($parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$DateTimeQuestionSubPlaceholder, null, formattedDateValue), (0, ($parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$DateTimeQuestionSubPlaceholder, null, formattedTimeValue));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, formattedDateValue && !formattedTimeValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formattedDateValue), !formattedDateValue && formattedTimeValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formattedTimeValue), formattedDateValue && formattedTimeValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `${formattedDateValue}, ${formattedTimeValue}`));
    };
    const $2446caa628a316e5$var$DateTimeQuestionSubPlaceholder = (0, $dAHxw.default).div({
        width: '50%',
        padding: "var(--ds-space-100, 8px)"
    });
    const $2446caa628a316e5$var$LongDisabledQuestionPlaceholder = (0, $dAHxw.default).div({
        borderStyle: 'solid',
        borderColor: "var(--ds-border-disabled, #DFE1E6)",
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: "var(--ds-border-width, 2px)",
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        cursor: 'default',
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        width: '320px'
    });
});
parcelRegister("6r1D6", function(module, exports) {
    $parcel$export(module.exports, "LongText", ()=>$4af6874d47ad7dec$export$7e7c4cb6f8068ef2);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $5SeaB;
    var $iBr5x;
    var $1ZO5m;
    const $4af6874d47ad7dec$export$7e7c4cb6f8068ef2 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBr5x")).EditLongText), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            onChange: (event)=>questionStore.setAnswer(event.target.value)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SeaB")).KbSuggestionFieldWrapper), {
            questionStore: questionStore
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ZO5m")).ViewLongText), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    });
});
parcelRegister("5SeaB", function(module, exports) {
    $parcel$export(module.exports, "KbSuggestionFieldWrapper", ()=>$446cfcc8f4b78ed4$export$452cd7af2ce503e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $e96BB;
    const $446cfcc8f4b78ed4$export$452cd7af2ce503e3 = ({ questionStore: questionStore })=>{
        const { KbSuggestionField: KbSuggestionField } = (0, (0, parcelRequire("e96BB")).usePortalCreateContext)();
        return questionStore.formQuestion.jiraField === 'summary' && KbSuggestionField ? (0, ($parcel$interopDefault($5uXOq))).createElement(KbSuggestionField, null) : null;
    };
});
parcelRegister("e96BB", function(module, exports) {
    $parcel$export(module.exports, "usePortalCreateContext", ()=>$a4c707a6de8d86a1$export$32ac7395fd280394);
    var $5uXOq = parcelRequire("5uXOq");
    const $a4c707a6de8d86a1$var$PortalCreateContext = (0, $5uXOq.createContext)(undefined);
    const $a4c707a6de8d86a1$export$2d5163f5d25155ab = ({ KbSuggestionField: KbSuggestionField, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a4c707a6de8d86a1$var$PortalCreateContext.Provider, {
            value: {
                KbSuggestionField: KbSuggestionField
            }
        }, children);
    };
    function $a4c707a6de8d86a1$export$32ac7395fd280394() {
        var _portalCreateContextD;
        const portalCreateContextData = (0, $5uXOq.useContext)($a4c707a6de8d86a1$var$PortalCreateContext);
        return {
            KbSuggestionField: (_portalCreateContextD = portalCreateContextData === null || portalCreateContextData === void 0 ? void 0 : portalCreateContextData.KbSuggestionField) !== null && _portalCreateContextD !== void 0 ? _portalCreateContextD : undefined
        };
    }
});
parcelRegister("iBr5x", function(module, exports) {
    $parcel$export(module.exports, "EditLongText", ()=>$d8b0b1e5cea9ff67$export$dbe61e9bf5805eb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $kY99m;
    const $d8b0b1e5cea9ff67$export$dbe61e9bf5805eb5 = ({ id: id, value: value, isInvalid: isInvalid, onChange: onChange })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            id: id,
            value: value,
            isInvalid: isInvalid,
            onChange: onChange,
            label: "long text",
            "aria-label": "long text field",
            title: "long text",
            placeholder: ""
        }));
    };
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("1ZO5m", function(module, exports) {
    $parcel$export(module.exports, "ViewLongText", ()=>$174256dcd4e2615e$export$39f50b0a4ef9ef2b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8iale;
    var $hBksn;
    const $174256dcd4e2615e$export$39f50b0a4ef9ef2b = ({ value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).TextfieldDisabledWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, value));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value);
    };
});
parcelRegister("bVxQm", function(module, exports) {
    $parcel$export(module.exports, "MultiChoice", ()=>$8aef4533a6df0de3$export$70859b46811b52c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $alnGD = parcelRequire("alnGD");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $fwzSF;
    var $gIvFI;
    const $8aef4533a6df0de3$export$70859b46811b52c1 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const availableOptions = questionStore.availableOptions();
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const currentOptions = availableOptions.filter((option)=>currentAnswer.choices.includes(option.value));
        const hasOtherChoice = !!questionStore.otherChoiceId;
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) {
            const onChange = (event)=>{
                const newChoiceId = event.target.value;
                const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
                let newChoiceIds = [
                    ...(0, $alnGD.toJS)(currentAnswer.choices)
                ];
                if (newChoiceIds.includes(newChoiceId)) newChoiceIds = newChoiceIds.filter((choiceId)=>choiceId !== newChoiceId);
                else newChoiceIds.push(newChoiceId);
                questionStore.setAnswer({
                    text: hasOtherChoice && newChoiceIds.some((choiceId)=>choiceId === questionStore.otherChoiceId) ? currentAnswer.text : '',
                    choices: newChoiceIds
                });
            };
            const otherChoiceSelected = hasOtherChoice && currentOptions.some((option)=>option.value === questionStore.otherChoiceId);
            const onOtherChoiceTextChange = (event)=>{
                questionStore.setAnswer({
                    text: event.target.value,
                    choices: (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwzSF")).EditMultiChoice), {
                id: id,
                options: availableOptions,
                value: currentOptions,
                isInvalid: !!questionStore.validationErrors,
                onChange: onChange,
                hasOtherOption: hasOtherChoice,
                otherOptionSelected: otherChoiceSelected,
                otherOptionText: currentAnswer.text,
                onOtherOptionTextChange: onOtherChoiceTextChange
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gIvFI")).ViewMultiChoice), {
            id: id,
            options: availableOptions,
            value: currentOptions,
            hasOtherOption: hasOtherChoice,
            otherOptionText: currentAnswer.text,
            displayMode: displayMode
        });
    });
});
parcelRegister("fwzSF", function(module, exports) {
    $parcel$export(module.exports, "EditMultiChoice", ()=>$b4d5ad53df3ef11d$export$15915f0c4ed40c0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $92Z2l;
    var $i1R0l;
    var $hBksn;
    var $3uIOs;
    const $b4d5ad53df3ef11d$export$15915f0c4ed40c0a = ({ id: id, options: options, value: value, isInvalid: isInvalid, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, warningMessage: warningMessage })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoiceFieldWrapper), {
            isDisabled: false,
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, options !== null && options !== void 0 && options.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i1R0l")).ChoiceQuestionStyles), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: id
        }, options.map((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
                name: id,
                key: option.value,
                value: option.value,
                label: option.label,
                isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
                onChange: onChange
            })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoicePlaceholder), null), hasOtherOption && otherOptionSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uIOs")).EditOtherOption), {
            dropdown: false,
            value: otherOptionText,
            isDisabled: !otherOptionSelected,
            onChange: onOtherOptionTextChange
        }))), warningMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, warningMessage));
    };
});
parcelRegister("i1R0l", function(module, exports) {
    $parcel$export(module.exports, "ChoiceQuestionStyles", ()=>$d2016f9c4b338c04$export$c19d7d5bbf8b0a0a);
    $parcel$export(module.exports, "darkSelectStyles", ()=>$d2016f9c4b338c04$export$a4905290da34703d);
    var $dAHxw = parcelRequire("dAHxw");
    const $d2016f9c4b338c04$export$c19d7d5bbf8b0a0a = (0, $dAHxw.default).div({
        lineHeight: 'initial'
    });
    const $d2016f9c4b338c04$export$a4905290da34703d = {
        control: (provided)=>({
                ...provided,
                backgroundColor: `var(--ds-background-input, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                borderWidth: '2px',
                borderColor: `var(--ds-border, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                borderRadius: '3px'
            })
    };
});
parcelRegister("gIvFI", function(module, exports) {
    $parcel$export(module.exports, "ViewMultiChoice", ()=>$c2b952caaf3b0bfb$export$44f53fea20230d97);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $8iale;
    var $i1R0l;
    var $hBksn;
    var $5aEbC;
    const $c2b952caaf3b0bfb$export$44f53fea20230d97 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
        const labels = value && value.map((item)=>item.label);
        if (labels && hasOtherOption && otherOptionText) {
            labels.push(otherOptionText);
            const lastIndex = labels.lastIndexOf('Other...');
            if (lastIndex !== -1) labels.splice(lastIndex, 1);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoiceFieldWrapper), {
            isDisabled: true,
            isView: displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).View
        }, options !== null && options !== void 0 && options.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i1R0l")).ChoiceQuestionStyles), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: id
        }, options.map((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
                name: id,
                key: option.value,
                value: option.value,
                label: option.label,
                isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
                isDisabled: true
            })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoicePlaceholder), null), otherOptionText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5aEbC")).ViewOtherOption), {
            dropdown: false,
            display: hasOtherOption,
            value: otherOptionText
        }));
    };
});
parcelRegister("gqc26", function(module, exports) {
    $parcel$export(module.exports, "Number", ()=>$bf48688a24befee2$export$fffa67e515d04022);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $dfSSA;
    var $lSbYB;
    const $bf48688a24befee2$export$fffa67e515d04022 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dfSSA")).EditNumber), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            onChange: (event)=>{
                const value = event.target.value.trim().replace(/[^\d.\-,]/g, '');
                questionStore.setAnswer(value);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lSbYB")).ViewNumber), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    });
});
parcelRegister("dfSSA", function(module, exports) {
    $parcel$export(module.exports, "EditNumber", ()=>$9a673f024c5e3de4$export$63f6e55a0e1fdd5);
    var $5uXOq = parcelRequire("5uXOq");
    var $kY99m;
    const $9a673f024c5e3de4$export$63f6e55a0e1fdd5 = ({ id: id, value: value, isInvalid: isInvalid, onChange: onChange })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            id: id,
            value: value,
            isInvalid: isInvalid,
            onChange: onChange,
            width: "small",
            label: "number",
            "aria-label": "number field",
            title: "number",
            placeholder: ""
        });
    };
});
parcelRegister("lSbYB", function(module, exports) {
    $parcel$export(module.exports, "ViewNumber", ()=>$fec7ee67db18a81b$export$ba244afa8d066f60);
    var $5uXOq = parcelRequire("5uXOq");
    var $kY99m;
    var $8iale;
    var $hBksn;
    const $fec7ee67db18a81b$export$ba244afa8d066f60 = ({ id: id, value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).FieldDisabledWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            id: id,
            value: value,
            isReadOnly: true,
            width: "small",
            label: "number",
            "aria-label": "number field",
            title: "number",
            placeholder: "",
            role: "presentation"
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value);
    };
});
parcelRegister("isuZ1", function(module, exports) {
    $parcel$export(module.exports, "Paragraph", ()=>$d702e0296fa8e174$export$358a232cca1ab2ac);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $jF2nc;
    var $2FULG;
    const $d702e0296fa8e174$export$358a232cca1ab2ac = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jF2nc")).EditParagraph), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            onChange: (event)=>questionStore.setAnswer(event.target.value)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FULG")).ViewParagraph), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    });
});
parcelRegister("jF2nc", function(module, exports) {
    $parcel$export(module.exports, "EditParagraph", ()=>$03b19b9caa1c2997$export$cffad3bd4cd5e3a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $6LCpJ;
    const $03b19b9caa1c2997$export$cffad3bd4cd5e3a2 = ({ value: value, isInvalid: isInvalid, onChange: onChange })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
            appearance: "standard",
            isCompact: false,
            isDisabled: false,
            isReadOnly: false,
            isInvalid: isInvalid,
            minimumRows: 5,
            maxHeight: "none",
            isMonospaced: false,
            value: value,
            defaultValue: undefined,
            resize: "smart",
            spellCheck: false,
            theme: undefined,
            onBlur: undefined,
            onChange: onChange,
            onFocus: undefined
        });
    };
});
parcelRegister("2FULG", function(module, exports) {
    $parcel$export(module.exports, "ViewParagraph", ()=>$1f2b72149b30f41c$export$c181b145ef549ce6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $8iale;
    var $hBksn;
    const $1f2b72149b30f41c$export$c181b145ef549ce6 = ({ value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement($1f2b72149b30f41c$var$DisabledParagraphPlaceholder, null, value);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value);
    };
    const $1f2b72149b30f41c$var$DisabledParagraphPlaceholder = (0, $dAHxw.default).div({
        borderStyle: 'solid',
        borderColor: `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '3px',
        borderWidth: '2px',
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        cursor: 'default',
        padding: "var(--ds-space-075, 6px)",
        minHeight: '100px',
        lineHeight: 1.42857,
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
    });
});
parcelRegister("aZCPa", function(module, exports) {
    $parcel$export(module.exports, "RichTextParagraph", ()=>$800db79ae66c9018$export$ef0485d3887498d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $LpImS = parcelRequire("LpImS");
    var $ajpes = parcelRequire("ajpes");
    var $alnGD = parcelRequire("alnGD");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $2UP8x;
    var $6g7dR;
    const $800db79ae66c9018$export$ef0485d3887498d6 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const richTextValue = (0, $alnGD.toJS)((0, (0, parcelRequire("4QmvR")).toRichTextQuestionAnswer)(questionStore.currentAnswer));
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        const richTextValueCloned = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($LpImS)))(richTextValue), [
            richTextValue
        ]);
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2UP8x")).AsyncEditRichTextParagraph), {
            id: id,
            value: richTextValueCloned,
            isInvalid: !!questionStore.validationErrors,
            onChange: (answer)=>{
                if (!(0, ($parcel$interopDefault($ajpes)))(richTextValue, answer)) questionStore.setAnswer(answer);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6g7dR")).ViewRichTextParagraph), {
            id: id,
            value: richTextValue,
            displayMode: displayMode
        });
    });
});
parcelRegister("2UP8x", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditRichTextParagraph", ()=>$21f87a701b042d2d$export$295cea8a1bb83d62);
    var $5uXOq = parcelRequire("5uXOq");
    var $kc9vJ = parcelRequire("kc9vJ");
    const $21f87a701b042d2d$var$LazyEditRichTextParagraph = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("7Fhvn")).then(({ EditRichTextParagraph: EditRichTextParagraph })=>EditRichTextParagraph), {
        ssr: false
    });
    const $21f87a701b042d2d$export$295cea8a1bb83d62 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kc9vJ.LazySuspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($21f87a701b042d2d$var$LazyEditRichTextParagraph, props));
    };
});
parcelRegister("7Fhvn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("azJuy")
    ]).then(()=>parcelRequire('8tcuo'));
});
parcelRegister("6g7dR", function(module, exports) {
    $parcel$export(module.exports, "ViewRichTextParagraph", ()=>$48e9d6f51b32d840$export$9f8ac553fae1fe6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $f5oqj;
    var $8iale;
    var $hBksn;
    const $48e9d6f51b32d840$export$9f8ac553fae1fe6 = ({ value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement($48e9d6f51b32d840$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
            document: value
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
            document: value
        }));
    };
    const $48e9d6f51b32d840$var$Wrapper = (0, $dAHxw.default).div({
        borderStyle: 'solid',
        borderColor: `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '3px',
        borderWidth: '2px',
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        padding: "var(--ds-space-075, 6px)",
        minHeight: '100px',
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
    });
});
parcelRegister("erYCV", function(module, exports) {
    $parcel$export(module.exports, "ShortText", ()=>$a8529d85c0ff25d6$export$5f45173d0e4e8a25);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $5SeaB;
    var $kjJHk;
    var $5rWjI;
    const $a8529d85c0ff25d6$export$5f45173d0e4e8a25 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const value = (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer);
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjJHk")).EditShortText), {
            id: id,
            value: value,
            isInvalid: !!questionStore.validationErrors,
            onChange: (event)=>questionStore.setAnswer(event.target.value)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SeaB")).KbSuggestionFieldWrapper), {
            questionStore: questionStore
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rWjI")).ViewShortText), {
            id: id,
            value: value,
            displayMode: displayMode
        });
    });
});
parcelRegister("kjJHk", function(module, exports) {
    $parcel$export(module.exports, "EditShortText", ()=>$eca907a382ad1335$export$64676e3eaae6b70f);
    var $5uXOq = parcelRequire("5uXOq");
    var $kY99m;
    var $hBksn;
    const $eca907a382ad1335$export$64676e3eaae6b70f = ({ id: id, value: value, isInvalid: isInvalid, onChange: onChange })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortTextFieldWrapper), {
            isDisabled: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            id: id,
            value: value,
            isInvalid: isInvalid,
            onChange: onChange,
            width: "medium",
            label: "short text",
            "aria-label": "short text field",
            title: "short text",
            placeholder: ""
        }));
    };
});
parcelRegister("5rWjI", function(module, exports) {
    $parcel$export(module.exports, "ViewShortText", ()=>$3f7cb5e56b5e559f$export$871f3649be20241);
    var $5uXOq = parcelRequire("5uXOq");
    var $8iale;
    var $hBksn;
    const $3f7cb5e56b5e559f$export$871f3649be20241 = ({ value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortTextFieldWrapper), {
            isDisabled: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, value));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value);
    };
});
parcelRegister("f1Hmw", function(module, exports) {
    $parcel$export(module.exports, "SingleChoice", ()=>$af0895dbcf5ab3c8$export$518ee1f8a60ca514);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $kDNl4;
    var $3jE9l;
    const $af0895dbcf5ab3c8$export$518ee1f8a60ca514 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        var _currentAnswer$choice;
        const availableOptions = questionStore.availableOptions();
        const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
        const currentChoiceId = (_currentAnswer$choice = currentAnswer.choices) !== null && _currentAnswer$choice !== void 0 && _currentAnswer$choice.length ? currentAnswer.choices[0] : undefined;
        const currentOption = availableOptions.find((option)=>option.value === currentChoiceId);
        const hasOtherChoice = !!questionStore.otherChoiceId;
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) {
            const onChange = (event)=>{
                const selectedChoiceId = event.target.value;
                const newChoiceId = selectedChoiceId ? [
                    selectedChoiceId
                ] : [];
                questionStore.setAnswer({
                    text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                    choices: newChoiceId
                });
            };
            const otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
            const onOtherChoiceTextChange = (event)=>{
                questionStore.setAnswer({
                    text: event.target.value,
                    choices: (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDNl4")).EditSingleChoice), {
                id: id,
                options: availableOptions,
                value: currentOption,
                isInvalid: !!questionStore.validationErrors,
                onChange: onChange,
                hasOtherOption: hasOtherChoice,
                otherOptionSelected: otherChoiceSelected,
                otherOptionText: currentAnswer.text,
                onOtherOptionTextChange: onOtherChoiceTextChange
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3jE9l")).ViewSingleChoice), {
            id: id,
            options: availableOptions,
            value: currentOption,
            hasOtherOption: hasOtherChoice,
            otherOptionText: currentAnswer.text,
            displayMode: displayMode
        });
    });
});
parcelRegister("kDNl4", function(module, exports) {
    $parcel$export(module.exports, "EditSingleChoice", ()=>$f06db8cee684911e$export$acb5351231003cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rLiX;
    var $92Z2l;
    var $i1R0l;
    var $hBksn;
    var $3uIOs;
    const $f06db8cee684911e$export$acb5351231003cc = ({ id: id, options: options, value: value, isInvalid: isInvalid, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, warningMessage: warningMessage })=>{
        var _value$value;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoiceFieldWrapper), {
            isDisabled: false,
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, options !== null && options !== void 0 && options.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i1R0l")).ChoiceQuestionStyles), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
            name: id,
            options: options,
            value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : null,
            onChange: onChange
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoicePlaceholder), null), hasOtherOption && otherOptionSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uIOs")).EditOtherOption), {
            dropdown: false,
            value: otherOptionText,
            isDisabled: !otherOptionSelected,
            onChange: onOtherOptionTextChange
        }))), warningMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, warningMessage));
    };
});
parcelRegister("3rLiX", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$ca8b717dad009c8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $jouoW;
    const $ca8b717dad009c8c$var$noOptions = [];
    function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
        const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, (0, parcelRequire("eGmKJ")).default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
        const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
        const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setSelectedValue(e.currentTarget.value);
            if (onChange) onChange(e, analyticsEvent);
        }, [
            onChange
        ]);
        const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "radiogroup",
            "aria-labelledby": ariaLabelledBy,
            "data-testid": testId
        }, options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        }));
    }
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: $5d22fafff331be84$var$radioStyles,
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("3jE9l", function(module, exports) {
    $parcel$export(module.exports, "ViewSingleChoice", ()=>$26a24a599612ab04$export$edf119980eaa894f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rLiX;
    var $8iale;
    var $i1R0l;
    var $hBksn;
    var $5aEbC;
    const $26a24a599612ab04$export$edf119980eaa894f = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoiceFieldWrapper), {
            isDisabled: true,
            isView: displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).View
        }, options !== null && options !== void 0 && options.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i1R0l")).ChoiceQuestionStyles), null, options.map((option, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
                key: index,
                name: id,
                value: value === null || value === void 0 ? void 0 : value.value,
                options: [
                    option
                ],
                isDisabled: true
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ChoicePlaceholder), null), otherOptionText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5aEbC")).ViewOtherOption), {
            dropdown: false,
            display: hasOtherOption,
            value: otherOptionText
        }));
    };
});
parcelRegister("bfOs9", function(module, exports) {
    $parcel$export(module.exports, "Time", ()=>$83183b5c5738b0f1$export$680ea196effce5f);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $4QmvR;
    var $8iale;
    var $6MwDx;
    var $70VLf;
    const $83183b5c5738b0f1$export$680ea196effce5f = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MwDx")).EditTime), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            onChange: (value)=>{
                let returnValue = value;
                if (value.includes('am') || value.includes('pm')) returnValue = value.slice(0, -2);
                questionStore.setAnswer(returnValue);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("70VLf")).ViewTime), {
            id: id,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    });
});
parcelRegister("70VLf", function(module, exports) {
    $parcel$export(module.exports, "ViewTime", ()=>$51b5569efddb9e93$export$90499bba0174747e);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jdTq6;
    var $fiX4W;
    var $8iale;
    var $giaor;
    var $6YylQ;
    var $hBksn;
    const $51b5569efddb9e93$var$formatValueForView = (value, locale)=>{
        if (!value || value.length === 0) return '';
        const timeSplit = value.split(':');
        const hours = parseInt(timeSplit[0], 10);
        const minutes = parseInt(timeSplit[1], 10);
        return new Intl.DateTimeFormat(locale, {
            ...(0, (0, parcelRequire("6YylQ")).longTimeOnlyFormat),
            timeZone: 'UTC'
        }).format(Date.UTC(0, 0, 1, hours, minutes));
    };
    const $51b5569efddb9e93$export$90499bba0174747e = ({ id: id, value: value, displayMode: displayMode })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ShortFieldWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).FieldDisabledWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdTq6")).default), {
            id: id,
            value: value,
            locale: intl.locale || (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE),
            timeIsEditable: true,
            placeholder: " ",
            isDisabled: true,
            appearance: "subtle",
            times: (0, (0, parcelRequire("giaor")).times)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, $51b5569efddb9e93$var$formatValueForView(value, intl.locale));
    };
});
parcelRegister("fGwwO", function(module, exports) {
    $parcel$export(module.exports, "UrlText", ()=>$02f26323d352870a$export$9540a67a0f90e032);
    var $5uXOq = parcelRequire("5uXOq");
    var $4QmvR;
    var $8iale;
    var $6r1D6;
    var $l4CPE;
    const $02f26323d352870a$export$9540a67a0f90e032 = (questionProps)=>{
        const { questionStore: questionStore, displayMode: displayMode, id: fieldId } = questionProps;
        return displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6r1D6")).LongText), questionProps) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l4CPE")).ViewUrlText), {
            id: fieldId,
            value: (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(questionStore.currentAnswer),
            displayMode: displayMode
        });
    };
});
parcelRegister("l4CPE", function(module, exports) {
    $parcel$export(module.exports, "ViewUrlText", ()=>$f57817edfd8aebbf$export$3eaa24e64e359c45);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZOJ9;
    var $8iale;
    var $hBksn;
    const $f57817edfd8aebbf$export$3eaa24e64e359c45 = ({ value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).TextfieldDisabledWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, value !== undefined && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(value) ? (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: value,
            target: "_blank",
            rel: "noopener noreferrer"
        }, value) : value));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, value !== undefined && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(value) ? (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: value,
            target: "_blank",
            rel: "noopener noreferrer"
        }, value) : value);
    };
});
parcelRegister("gyvX2", function(module, exports) {
    $parcel$export(module.exports, "UserPicker", ()=>$c0d89b26febf513c$export$83e0c73b09b3a9cd);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("f2sTC");
    var $jJXgM = parcelRequire("jJXgM");
    var $cnwtr;
    var $4aJmI;
    var $4QmvR;
    var $8iale;
    var $lz5Pa;
    var $1JRg6;
    const $c0d89b26febf513c$export$83e0c73b09b3a9cd = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode })=>{
        const isMulti = questionStore.formQuestion.type === (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple;
        const value = questionStore.currentAnswer ? (0, (0, parcelRequire("4QmvR")).toUserPickerQuestionAnswerOrEmpty)(questionStore.currentAnswer).map((item)=>({
                value: item.id,
                label: item.name
            })) : null;
        const showEditComponent = displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit;
        if (showEditComponent) {
            const loadOptions = (0, (0, parcelRequire("cnwtr")).debounce)((inputValue, callback)=>{
                const input = inputValue.trim();
                if (input) {
                    var _questionStore$issueF;
                    formStore.searchUsersWithFieldConfig(questionStore.formQuestion.jiraField, (_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.fieldConfigId, input).then((results)=>{
                        callback(results);
                    }).catch((error)=>{
                        callback([]);
                    });
                } else callback([]);
            }, 500);
            const onChange = (newValue)=>{
                let values;
                if (!newValue) values = [];
                else if (isMulti) values = newValue.map((item)=>{
                    return {
                        id: item.value,
                        name: item.label
                    };
                });
                else values = [
                    {
                        id: newValue.value,
                        name: newValue.label
                    }
                ];
                questionStore.setAnswer(values);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lz5Pa")).EditUserPicker), {
                id: id,
                isMulti: isMulti,
                value: value,
                loadOptions: loadOptions,
                onChange: onChange,
                isInvalid: !!questionStore.validationErrors
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1JRg6")).ViewUserPicker), {
            id: id,
            isMulti: isMulti,
            value: value,
            displayMode: displayMode
        });
    });
});
parcelRegister("lz5Pa", function(module, exports) {
    $parcel$export(module.exports, "EditUserPicker", ()=>$fb3162767ca80cc2$export$77369e24c8177d52);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $d7FF4;
    var $4dI0P;
    var $hBksn;
    var $i3bxp;
    var $6YPn9;
    const $fb3162767ca80cc2$export$77369e24c8177d52 = ({ id: id, isMulti: isMulti, value: value, loadOptions: loadOptions, onChange: onChange, isInvalid: isInvalid })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).SelectErrorContainer), {
            isInvalid: isInvalid
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), (0, $bS32t.default)({
            id: id,
            value: value,
            loadOptions: loadOptions,
            noOptionsMessage: (input)=>{
                if (input !== null && input !== void 0 && input.inputValue) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownNoOptions);
                return intl.formatMessage((0, (0, parcelRequire("i3bxp")).IntlEditUserPickerMessages)[(0, (0, parcelRequire("i3bxp")).EditUserPickerMessage).UserPickerStartTyping]);
            },
            cacheOptions: true,
            isMulti: isMulti,
            isClearable: true,
            loadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownLoading),
            defaultOptions: true,
            onChange: onChange,
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("6YPn9")).messages).choiceDropdownSelect)
        }, (0, (0, parcelRequire("4dI0P")).getDropDownMenuPosition)())));
    };
});
parcelRegister("i3bxp", function(module, exports) {
    $parcel$export(module.exports, "EditUserPickerMessage", ()=>$0364270c64e8bfa2$export$16234d9772cc0f0b);
    $parcel$export(module.exports, "IntlEditUserPickerMessages", ()=>$0364270c64e8bfa2$export$37c452ac81af37c9);
    var $7VHMR;
    let $0364270c64e8bfa2$export$16234d9772cc0f0b = function(EditUserPickerMessage) {
        EditUserPickerMessage["UserPickerStartTyping"] = "UserPickerStartTyping";
        return EditUserPickerMessage;
    }({});
    const $0364270c64e8bfa2$export$37c452ac81af37c9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$0364270c64e8bfa2$export$16234d9772cc0f0b.UserPickerStartTyping]: {
            id: 'form-system.UserPicker.UserPickerStartTyping',
            defaultMessage: 'Start typing to search for users'
        }
    });
});
parcelRegister("1JRg6", function(module, exports) {
    $parcel$export(module.exports, "ViewUserPicker", ()=>$14434e824cb0001e$export$df59b12b504e64b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $8iale;
    var $hBksn;
    const $14434e824cb0001e$export$df59b12b504e64b4 = ({ id: id, isMulti: isMulti, value: value, displayMode: displayMode })=>{
        if (displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Edit || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Preview || displayMode === (0, (0, parcelRequire("8iale")).DisplayMode).Translate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            id: id,
            value: value,
            isMulti: isMulti,
            isDisabled: true,
            styles: {
                control: (base)=>({
                        ...base,
                        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                        borderColor: "var(--ds-border-disabled, #DFE1E6)",
                        color: "var(--ds-text, #172B4D !important)"
                    }),
                menu: (base)=>({
                        ...base,
                        color: "var(--ds-text-subtle, #172B4D)"
                    })
            },
            isClearable: true,
            defaultOptions: true,
            placeholder: ""
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ViewWrapper), null, value && value.map((item)=>item.label).join(', '));
    };
});
parcelRegister("4OnBQ", function(module, exports) {
    $parcel$export(module.exports, "QuestionErrorMsg", ()=>$380e253ff8ebade2$export$4cac87f7e054d053);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $hBksn;
    const $380e253ff8ebade2$export$4cac87f7e054d053 = ({ validationErrors: validationErrors })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBksn")).ErrorWrapper), null, validationErrors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, validationErrors.map((validationError)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: validationError.key
            }, validationError.message, "\xA0");
        }), "\xA0"));
    };
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("d6RcY", function(module, exports) {
    $parcel$export(module.exports, "QuestionHelperMsg", ()=>$98b51bee2b5403ca$export$1872e1e6dda4cf63);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $qfj8c;
    const $98b51bee2b5403ca$export$1872e1e6dda4cf63 = ({ description: description })=>{
        return !!description ? (0, ($parcel$interopDefault($5uXOq))).createElement($98b51bee2b5403ca$var$HelperMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": "description"
        }, description))) : null;
    };
    const $98b51bee2b5403ca$var$HelperMessageWrapper = (0, $dAHxw.default).div({
        '> div': {
            fontSize: '11px',
            marginBottom: "var(--ds-space-050, 4px)"
        }
    });
});
parcelRegister("bQ3UU", function(module, exports) {
    $parcel$export(module.exports, "UnknownQuestionType", ()=>$89e796d82e5a277c$export$83ab0504c2d7cd30);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2Ce34;
    var $dXYuS;
    var $7gmPx;
    var $eaUiW;
    function $89e796d82e5a277c$export$83ab0504c2d7cd30({ questionType: questionType }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const questionTypeMessage = (0, (0, parcelRequire("2Ce34")).IntlQuestionTypeMessages)[(0, (0, parcelRequire("dXYuS")).questionTypeToQuestionTypeMessage)(questionType)];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eaUiW")).UnknownQuestionTypeText), {
            "data-testid": "proforma-unknown-question"
        }, intl.formatMessage((0, (0, parcelRequire("7gmPx")).messages).unknownQuestionType, {
            questionType: questionTypeMessage ? intl.formatMessage(questionTypeMessage) : '',
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("strong", null, chunks)
        }));
    }
});
parcelRegister("2Ce34", function(module, exports) {
    $parcel$export(module.exports, "QuestionTypeMessage", ()=>$1e7a071bc1fc5bb0$export$8f21f8f314b6a220);
    $parcel$export(module.exports, "IntlQuestionTypeMessages", ()=>$1e7a071bc1fc5bb0$export$1fcc5e9b2fea45ca);
    var $7VHMR;
    let $1e7a071bc1fc5bb0$export$8f21f8f314b6a220 = function(QuestionTypeMessage) {
        QuestionTypeMessage["TextQuestionsGroupLabel"] = "TextQuestionsGroupLabel";
        QuestionTypeMessage["TextShortLabel"] = "TextShortLabel";
        QuestionTypeMessage["TextAttachmentLabel"] = "TextAttachmentLabel";
        QuestionTypeMessage["TextLongLabel"] = "TextLongLabel";
        QuestionTypeMessage["TextParagraphLabel"] = "TextParagraphLabel";
        QuestionTypeMessage["PlainTextParagraphLabel"] = "PlainTextParagraphLabel";
        QuestionTypeMessage["RichTextParagraphLabel"] = "RichTextParagraphLabel";
        QuestionTypeMessage["TextEmailLabel"] = "TextEmailLabel";
        QuestionTypeMessage["TextUrlLabel"] = "TextUrlLabel";
        QuestionTypeMessage["ChoiceCascadingLabel"] = "ChoiceCascadingLabel";
        QuestionTypeMessage["ChoiceQuestionsGroupLabel"] = "ChoiceQuestionsGroupLabel";
        QuestionTypeMessage["ChoiceSingleLabel"] = "ChoiceSingleLabel";
        QuestionTypeMessage["ChoiceMultipleLabel"] = "ChoiceMultipleLabel";
        QuestionTypeMessage["ChoiceDropdownLabel"] = "ChoiceDropdownLabel";
        QuestionTypeMessage["ChoiceDropdownMultipleLabel"] = "ChoiceDropdownMultipleLabel";
        QuestionTypeMessage["CmdbObjectLabel"] = "CmdbObjectLabel";
        QuestionTypeMessage["DateQuestionsGroupLabel"] = "DateQuestionsGroupLabel";
        QuestionTypeMessage["DateLabel"] = "DateLabel";
        QuestionTypeMessage["DateTimeLabel"] = "DateTimeLabel";
        QuestionTypeMessage["TimeLabel"] = "TimeLabel";
        QuestionTypeMessage["NumericQuestionsGroupLabel"] = "NumericQuestionsGroupLabel";
        QuestionTypeMessage["NumberLabel"] = "NumberLabel";
        QuestionTypeMessage["UserQuestionsGroupLabel"] = "UserQuestionsGroupLabel";
        QuestionTypeMessage["UserSingleLabel"] = "UserSingleLabel";
        QuestionTypeMessage["UserMultipleLabel"] = "UserMultipleLabel";
        QuestionTypeMessage["UnsupportedLabel"] = "UnsupportedLabel";
        return QuestionTypeMessage;
    }({});
    const $1e7a071bc1fc5bb0$export$1fcc5e9b2fea45ca = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextQuestionsGroupLabel]: {
            id: 'form-builder.QuestionType.TextQuestionsGroupLabel',
            defaultMessage: 'Text fields'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextAttachmentLabel]: {
            id: 'form-builder.QuestionType.TextAttachmentLabel',
            defaultMessage: 'Attachment'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextShortLabel]: {
            id: 'form-builder.QuestionType.TextShortLabel',
            defaultMessage: 'Short text'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextLongLabel]: {
            id: 'form-builder.QuestionType.TextLongLabel',
            defaultMessage: 'Long text'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextParagraphLabel]: {
            id: 'form-builder.QuestionType.TextParagraphLabel',
            defaultMessage: 'Paragraph'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.PlainTextParagraphLabel]: {
            id: 'form-builder.QuestionType.PlainTextParagraphLabel',
            defaultMessage: 'Paragraph (Plain text)'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.RichTextParagraphLabel]: {
            id: 'form-builder.QuestionType.RichTextParagraphLabel',
            defaultMessage: 'Paragraph'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextEmailLabel]: {
            id: 'form-builder.QuestionType.TextEmailLabel',
            defaultMessage: 'Email'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextUrlLabel]: {
            id: 'form-builder.QuestionType.TextUrlLabel',
            defaultMessage: 'URL'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceQuestionsGroupLabel]: {
            id: 'form-builder.QuestionType.ChoiceQuestionsGroupLabel',
            defaultMessage: 'Choice fields'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceCascadingLabel]: {
            id: 'form-builder.QuestionType.ChoiceCascadingLabel',
            defaultMessage: 'Cascading dropdown'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceSingleLabel]: {
            id: 'form-builder.QuestionType.ChoiceSingleLabel',
            defaultMessage: 'Radio buttons'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceMultipleLabel]: {
            id: 'form-builder.QuestionType.ChoiceMultipleLabel',
            defaultMessage: 'Checkboxes'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceDropdownLabel]: {
            id: 'form-builder.QuestionType.ChoiceDropdownLabel',
            defaultMessage: 'Dropdown'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceDropdownMultipleLabel]: {
            id: 'form-builder.QuestionType.ChoiceDropdownMultipleLabel',
            defaultMessage: 'Multiselect dropdown'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.CmdbObjectLabel]: {
            id: 'form-builder.QuestionType.CmdbObjectLabel',
            defaultMessage: 'Assets object/s'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateQuestionsGroupLabel]: {
            id: 'form-builder.QuestionType.DateQuestionsGroupLabel',
            defaultMessage: 'Date fields'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateLabel]: {
            id: 'form-builder.QuestionType.DateLabel',
            defaultMessage: 'Date'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateTimeLabel]: {
            id: 'form-builder.QuestionType.DateTimeLabel',
            defaultMessage: 'Date & Time'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TimeLabel]: {
            id: 'form-builder.QuestionType.TimeLabel',
            defaultMessage: 'Time'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.NumericQuestionsGroupLabel]: {
            id: 'form-builder.QuestionType.NumericQuestionsGroupLabel',
            defaultMessage: 'Numeric fields'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.NumberLabel]: {
            id: 'form-builder.QuestionType.NumberLabel',
            defaultMessage: 'Number'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserQuestionsGroupLabel]: {
            id: 'form-builder.QuestionType.UserQuestionsGroupLabel',
            defaultMessage: 'User fields'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserSingleLabel]: {
            id: 'form-builder.QuestionType.UserSingleLabel',
            defaultMessage: 'Single user'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserMultipleLabel]: {
            id: 'form-builder.QuestionType.UserMultipleLabel',
            defaultMessage: 'Multiple users'
        },
        [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UnsupportedLabel]: {
            id: 'form-builder.QuestionType.UnsupportedLabel',
            defaultMessage: 'Unsupported'
        }
    });
});
parcelRegister("dXYuS", function(module, exports) {
    $parcel$export(module.exports, "questionTypeToQuestionTypeMessage", ()=>$a2afb6844be32e55$export$a64008dcb04384c9);
    var $4aJmI;
    var $2Ce34;
    function $a2afb6844be32e55$export$a64008dcb04384c9(questionType) {
        switch(questionType){
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).TextShortLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).TextLongLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).PlainTextParagraphLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).RichTextParagraphLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).TextEmailLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).TextUrlLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).ChoiceCascadingLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).ChoiceDropdownLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).ChoiceSingleLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).ChoiceMultipleLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).ChoiceDropdownMultipleLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).CmdbObjectLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).DateLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).DateTime:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).DateTimeLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Time:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).TimeLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Number:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).NumberLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).UserSingleLabel;
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).UserMultipleLabel;
            default:
                return (0, (0, parcelRequire("2Ce34")).QuestionTypeMessage).UnsupportedLabel;
        }
    }
});
parcelRegister("7gmPx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$549bbca0c169f13e$export$defe85febe8b728c);
    var $7VHMR;
    const $549bbca0c169f13e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unknownQuestionType: {
            defaultMessage: "We couldn't load the <strong>{questionType}</strong> field type at this time.",
            description: 'Shown when a form field is unable to be shown',
            id: 'form-system.unknown-question-type'
        }
    });
});
parcelRegister("eaUiW", function(module, exports) {
    $parcel$export(module.exports, "UnknownQuestionTypeText", ()=>$a51dacc64d3da6db$export$284247789c6eec03);
    var $dAHxw = parcelRequire("dAHxw");
    const $a51dacc64d3da6db$export$284247789c6eec03 = (0, $dAHxw.default).p({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    });
});
parcelRegister("8iiJB", function(module, exports) {
    $parcel$export(module.exports, "ViewFormMessage", ()=>$609e8970ac2d98e4$export$e6feff1a2af45d34);
    $parcel$export(module.exports, "IntlViewFormMessages", ()=>$609e8970ac2d98e4$export$8d484546a77c3c19);
    var $7VHMR;
    let $609e8970ac2d98e4$export$e6feff1a2af45d34 = function(ViewFormMessage) {
        ViewFormMessage["HiddenSection"] = "HiddenSection";
        return ViewFormMessage;
    }({});
    const $609e8970ac2d98e4$export$8d484546a77c3c19 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$609e8970ac2d98e4$export$e6feff1a2af45d34.HiddenSection]: {
            id: 'form-system.viewForm.HiddenSection',
            defaultMessage: 'Hidden section - Conditions apply'
        }
    });
});
parcelRegister("99yBG", function(module, exports) {
    $parcel$export(module.exports, "FormNameWrapper", ()=>$6a9fcc86874726a2$export$f21e68efbab8f6ed);
    var $dAHxw = parcelRequire("dAHxw");
    const $6a9fcc86874726a2$export$f21e68efbab8f6ed = (0, $dAHxw.default).h3({
        marginBottom: "var(--ds-space-300, 24px)",
        '&:first-child': {
            marginTop: "var(--ds-space-300, 24px)"
        }
    });
});
parcelRegister("gjvhH", function(module, exports) {
    $parcel$export(module.exports, "IssueFormsBody", ()=>$be06b025ea93e278$export$6bcc8a1d8a71af4f);
    $parcel$export(module.exports, "IssueFormsBodyWrapper", ()=>$be06b025ea93e278$export$6b31631d3b81350b);
    $parcel$export(module.exports, "IssueFormsContent", ()=>$be06b025ea93e278$export$45522c476b2e12c8);
    var $dAHxw = parcelRequire("dAHxw");
    const $be06b025ea93e278$export$6bcc8a1d8a71af4f = (0, $dAHxw.default).div({
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        fontSize: '14px',
        maxWidth: '800px',
        minWidth: '400px',
        overflow: 'visible',
        paddingBottom: "var(--ds-space-250, 20px)"
    });
    const $be06b025ea93e278$export$6b31631d3b81350b = (0, $dAHxw.default).div({
        boxSizing: 'border-box',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        scrollbarGutter: 'stable both-edges',
        overflowY: 'auto'
    });
    const $be06b025ea93e278$export$45522c476b2e12c8 = (0, $dAHxw.default).div({
        backgroundColor: "var(--ds-surface, white)",
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    });
});
parcelRegister("anpr8", function(module, exports) {
    $parcel$export(module.exports, "useFormStoreController", ()=>$78dfc88eea7dbb94$export$1068f931a14b3114);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $bKCvK;
    var $bEQ2i;
    var $imEoS;
    var $ctPpG;
    var $iPJqX;
    var $ex6Rw;
    var $3G30a;
    var $c66GK;
    var $ln9gy;
    var $ilbIo;
    var $2Zsrr;
    var $30GOg;
    var $5R2g4;
    var $dQKc8;
    var $ewILP;
    var $ke4ek;
    var $916YZ;
    const $78dfc88eea7dbb94$export$1068f931a14b3114 = (reporterAccountId)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { clear: clearFormSaveErrors } = (0, (0, parcelRequire("bEQ2i")).useFormSaveErrorsActions)();
        const [{ data: fieldData, error: fieldDataError, loading: fieldDataLoading }, { load: loadFieldData }] = (0, (0, parcelRequire("5R2g4")).useFieldDataService)();
        const [{ data: formChoices, error: formChoicesError, loading: formChoicesLoading }, { load: loadFormChoices }] = (0, (0, parcelRequire("dQKc8")).useFormChoicesService)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const [{ data: labelChoices, error: labelChoicesError, loading: labelChoicesLoading }, { load: loadLabelChoices }] = (0, (0, parcelRequire("ewILP")).useLabelChoicesService)();
        const errorUtils = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const [{ data: userChoices, error: userChoicesError, loading: userChoicesLoading }, { load: loadUserChoices, loadWithFieldConfig: loadUserChoicesWithFieldConfig }] = (0, (0, parcelRequire("ke4ek")).useUserChoicesService)();
        const [{ data: affectedServicesChoices, error: affectedServicesChoicesError, loading: affectedServicesChoicesLoading }, { load: loadAffectedServicesChoices }] = (0, (0, parcelRequire("2Zsrr")).useAffectedServicesChoicesService)();
        const [{ data: cmdbChoices, error: cmdbChoicesError, loading: cmdbChoicesLoading }, { load: loadCmdbChoices }] = (0, (0, parcelRequire("30GOg")).useCmdbChoicesService)();
        const createFieldDataPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(fieldData, fieldDataError);
        const createFormChoicesPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(formChoices, formChoicesError);
        const createLabelChoicesPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(labelChoices, labelChoicesError);
        const createUserChoicesPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(userChoices, userChoicesError);
        const createAffectedServicesChoicesPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(affectedServicesChoices, affectedServicesChoicesError);
        const createCmdbChoicesPromise = (0, (0, parcelRequire("ilbIo")).useConvertServiceResponseToPromise)(cmdbChoices, cmdbChoicesError);
        const [state, setState] = (0, $5uXOq.useState)({});
        const actions = (0, $5uXOq.useMemo)(()=>({
                clear: ()=>{
                    setState({});
                    clearFormSaveErrors();
                },
                create: (formDetails, form)=>{
                    setState({
                        formStore: new (0, (0, parcelRequire("imEoS")).FormStore)(intl, createAnalyticsEvent, (0, (0, parcelRequire("ln9gy")).loadFieldDataFn)((request)=>{
                            if (fieldDataLoading) return Promise.reject(new Error('Field data request already underway.'));
                            loadFieldData(formDetails, request);
                            return createFieldDataPromise();
                        }, errorUtils, false), (0, (0, parcelRequire("c66GK")).loadChoicesFn)(()=>{
                            if (formChoicesLoading) return Promise.reject(new Error('Form choices request already underway.'));
                            loadFormChoices(formDetails);
                            return createFormChoicesPromise();
                        }, errorUtils), (0, (0, parcelRequire("3G30a")).loadChoicesAsyncFn)({
                            custom: {
                                [(0, (0, parcelRequire("ctPpG")).AFFECTED_SERVICES_SCHEMA_CUSTOM)]: {
                                    searchOptionsFn: (_, query)=>{
                                        if (affectedServicesChoicesLoading) return Promise.reject(new Error('Affected Services choices loading underway.'));
                                        loadAffectedServicesChoices(query);
                                        return createAffectedServicesChoicesPromise();
                                    }
                                },
                                [(0, (0, parcelRequire("ctPpG")).CMDB_SCHEMA_CUSTOM)]: {
                                    searchOptionsFn: (jiraField, query, issueFieldData, formStore)=>{
                                        if (cmdbChoicesLoading) return Promise.reject(new Error('CMDB choices request already underway.'));
                                        if (issueFieldData !== null && issueFieldData !== void 0 && issueFieldData.fieldConfigId && formStore) {
                                            var _formDetails$requestT;
                                            loadCmdbChoices(jiraField, query, formDetails.projectId.toString(), formDetails.issueType.id, (_formDetails$requestT = formDetails.requestType) === null || _formDetails$requestT === void 0 ? void 0 : _formDetails$requestT.id, formDetails.projectFormId, issueFieldData === null || issueFieldData === void 0 ? void 0 : issueFieldData.fieldConfigId, (0, (0, parcelRequire("iPJqX")).getCmdbFieldValueMap)(formStore));
                                            return createCmdbChoicesPromise();
                                        }
                                        return Promise.resolve([]);
                                    },
                                    onSearchError: ({ status: status })=>{
                                        if (status === 400) return {
                                            title: intl.formatMessage((0, (0, parcelRequire("916YZ")).messages).objectSearchErrorTitle),
                                            description: intl.formatMessage((0, (0, parcelRequire("916YZ")).messages).objectSearchErrorDescription)
                                        };
                                    }
                                },
                                [(0, (0, parcelRequire("ctPpG")).LABELS_SCHEMA_CUSTOM)]: {
                                    searchOptionsFn: (jiraField, query)=>{
                                        if (labelChoicesLoading) return Promise.reject(new Error('Label choices request already underway.'));
                                        if (!query.includes(' ')) {
                                            loadLabelChoices(jiraField, query);
                                            return createLabelChoicesPromise();
                                        }
                                        return Promise.resolve([]);
                                    }
                                }
                            },
                            system: {
                                [(0, (0, parcelRequire("ctPpG")).LABELS_SCHEMA_SYSTEM)]: {
                                    searchOptionsFn: (jiraField, query)=>{
                                        if (labelChoicesLoading) return Promise.reject(new Error('Label choices request already underway.'));
                                        if (!query.includes(' ')) {
                                            loadLabelChoices(jiraField, query);
                                            return createLabelChoicesPromise();
                                        }
                                        return Promise.resolve([]);
                                    }
                                }
                            }
                        }, errorUtils, createAnalyticsEvent, showFlag), (jiraField, query)=>{
                            if (userChoicesLoading) return Promise.reject(new Error('User search request already underway.'));
                            loadUserChoices(formDetails.projectId, jiraField, query);
                            return createUserChoicesPromise();
                        }, (jiraField, fieldConfigId, query)=>{
                            if (userChoicesLoading) return Promise.reject(new Error('User search request already underway.'));
                            loadUserChoicesWithFieldConfig(jiraField, fieldConfigId, formDetails.projectId, query);
                            return createUserChoicesPromise();
                        }, form, false)
                    });
                    clearFormSaveErrors();
                }
            }), [
            clearFormSaveErrors,
            createAnalyticsEvent,
            createAffectedServicesChoicesPromise,
            createCmdbChoicesPromise,
            createFieldDataPromise,
            createFormChoicesPromise,
            createLabelChoicesPromise,
            createUserChoicesPromise,
            errorUtils,
            loadAffectedServicesChoices,
            loadCmdbChoices,
            loadFieldData,
            loadFormChoices,
            loadLabelChoices,
            loadUserChoices
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (state.formStore) state.formStore.onFieldChange('reporter');
        }, [
            reporterAccountId,
            state.formStore
        ]);
        return [
            state,
            actions
        ];
    };
});
parcelRegister("imEoS", function(module, exports) {
    $parcel$export(module.exports, "FormStore", ()=>$d5e99eb3f1ac4fc8$export$75ff1ab1187e691);
    var $9kzTP = parcelRequire("9kzTP");
    var $7Jkpx = parcelRequire("7Jkpx");
    parcelRequire("cTQjS");
    var $alnGD = parcelRequire("alnGD");
    var $lmhF9;
    var $VSDnB;
    var $4aJmI;
    var $chyFx;
    var $4QmvR;
    var $d5e99eb3f1ac4fc8$var$_class, $d5e99eb3f1ac4fc8$var$_descriptor, $d5e99eb3f1ac4fc8$var$_descriptor2, $d5e99eb3f1ac4fc8$var$_descriptor3, $d5e99eb3f1ac4fc8$var$_descriptor4, $d5e99eb3f1ac4fc8$var$_descriptor5, $d5e99eb3f1ac4fc8$var$_descriptor6, $d5e99eb3f1ac4fc8$var$_descriptor7, $d5e99eb3f1ac4fc8$var$_descriptor8, $d5e99eb3f1ac4fc8$var$_descriptor9, $d5e99eb3f1ac4fc8$var$_descriptor10, $d5e99eb3f1ac4fc8$var$_descriptor11, $d5e99eb3f1ac4fc8$var$_descriptor12;
    let $d5e99eb3f1ac4fc8$export$75ff1ab1187e691 = ($d5e99eb3f1ac4fc8$var$_class = class FormStore {
        constructor(intl, createAnalyticsEvent, loadFieldDataFn, loadChoicesFn, loadChoicesAsyncFn, searchUsers, searchUsersWithFieldConfig, _form, populateDefaultValueOnEmptySearch, issueKey, jiraFieldMap, onFieldChange, onFieldDirty){
            var _form$publish, _form$publish2;
            this.formId = void 0;
            this.issueKey = void 0;
            (0, $9kzTP.default)(this, "savingAnswers", $d5e99eb3f1ac4fc8$var$_descriptor, this);
            (0, $9kzTP.default)(this, "submittingForm", $d5e99eb3f1ac4fc8$var$_descriptor2, this);
            this.templateFormId = void 0;
            this.formName = void 0;
            this.language = void 0;
            (0, $9kzTP.default)(this, "updated", $d5e99eb3f1ac4fc8$var$_descriptor3, this);
            (0, $9kzTP.default)(this, "status", $d5e99eb3f1ac4fc8$var$_descriptor4, this);
            this.submitLock = void 0;
            this.submitPdf = void 0;
            (0, $9kzTP.default)(this, "questions", $d5e99eb3f1ac4fc8$var$_descriptor5, this);
            this.layout = void 0;
            (0, $9kzTP.default)(this, "internal", $d5e99eb3f1ac4fc8$var$_descriptor6, this);
            this.conditions = void 0;
            this.sections = void 0;
            (0, $9kzTP.default)(this, "invalid", $d5e99eb3f1ac4fc8$var$_descriptor7, this);
            this.createOpen = void 0;
            this.validateOnCreate = void 0;
            this.portalCanSubmit = void 0;
            this.analyticsAttributes = void 0;
            this.prevVisibleSections = void 0;
            this.primaryLocale = void 0;
            this.translatedLocale = void 0;
            this.loadFieldData = void 0;
            this.loadChoices = void 0;
            this.loadChoicesAsync = void 0;
            this.searchUsers = void 0;
            this.searchUsersWithFieldConfig = void 0;
            (0, $9kzTP.default)(this, "attachQuestionsToSections", $d5e99eb3f1ac4fc8$var$_descriptor8, this);
            this.getQuestionIdsFromSectionContent = (sectionContent)=>{
                return (0, (0, parcelRequire("lmhF9")).filter)(sectionContent, (node)=>{
                    if (!node.attrs || !node.attrs.parameters || !node.attrs.parameters.id) return false;
                    return node.attrs.extensionKey === 'question';
                }).map((node)=>node.attrs.parameters.id.toString());
            };
            (0, $9kzTP.default)(this, "update", $d5e99eb3f1ac4fc8$var$_descriptor9, this);
            this._update = (constructing, form, refreshChoices = false)=>{
                this.updated = form.updated;
                this.status = form.state.status;
                this.internal = form.state.visibility === (0, (0, parcelRequire("4aJmI")).FormVisibility).Internal;
                if (!constructing) {
                    this.invalid = false;
                    this.questions.forEach((question)=>{
                        const questionKey = question.id.toString();
                        const formQuestion = {
                            ...form.design.questions[questionKey],
                            choices: question.choices
                        };
                        question.update(formQuestion, form.state.answers[questionKey]);
                    });
                    if (!refreshChoices) return this.loadFieldData().then(()=>this.afterUpdate());
                }
                return Promise.all([
                    this.loadFieldData(),
                    this.loadChoices()
                ]).then(()=>this.afterUpdate());
            };
            this.validate = ()=>{
                const visibleQuestions = this.questions.filter((question)=>!this.hiddenQuestions.includes(question.id.toString()));
                let allQuestionsValid = true;
                visibleQuestions.forEach((questionStore)=>{
                    questionStore.validate();
                    if (!!questionStore.validationErrors) allQuestionsValid = false;
                });
                (0, $alnGD.runInAction)(()=>{
                    this.invalid = !allQuestionsValid;
                });
            };
            (0, $9kzTP.default)(this, "hideValidations", $d5e99eb3f1ac4fc8$var$_descriptor10, this);
            (0, $9kzTP.default)(this, "discardModifiedAnswers", $d5e99eb3f1ac4fc8$var$_descriptor11, this);
            (0, $9kzTP.default)(this, "onFieldChange", $d5e99eb3f1ac4fc8$var$_descriptor12, this);
            this.formId = _form.id;
            this.issueKey = issueKey;
            const formSettings = _form.design.settings;
            this.templateFormId = formSettings.templateId;
            this.formName = formSettings.name;
            this.language = formSettings.language;
            this.submitLock = formSettings.submit.lock;
            this.submitPdf = formSettings.submit.pdf;
            this.createOpen = ((_form$publish = _form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.portal) !== undefined && !_form.publish.portal.submitOnCreate;
            this.validateOnCreate = !this.createOpen || ((_form$publish2 = _form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal) !== undefined && _form.publish.portal.validateOnCreate;
            this.portalCanSubmit = !formSettings.portal || formSettings.portal.canSubmit;
            this.conditions = _form.design.conditions;
            this.layout = _form.design.layout;
            this.sections = {
                ..._form.design.sections
            };
            this.attachQuestionsToSections();
            this.analyticsAttributes = {
                ...(0, (0, parcelRequire("chyFx")).getFormAnalyticsAttributes)(_form),
                formId: this.formId,
                templateFormId: this.templateFormId
            };
            this.primaryLocale = formSettings.primaryLocale;
            this.translatedLocale = formSettings.translatedLocale;
            if (_form.design.questions) this.questions = Object.keys(_form.design.questions).map((questionKey)=>{
                const formQuestion = _form.design.questions[questionKey];
                return new (0, (0, parcelRequire("4QmvR")).QuestionStore)(intl, questionKey, formQuestion, (query)=>loadChoicesAsyncFn(this)(parseInt(questionKey, 10), query), (fieldMeta, value)=>{
                    this.onFieldChange(fieldMeta.jiraField);
                    onFieldChange === null || onFieldChange === void 0 || onFieldChange(fieldMeta, value);
                }, populateDefaultValueOnEmptySearch, _form.state.answers[questionKey], onFieldDirty);
            });
            else this.questions = [];
            this.loadFieldData = loadFieldDataFn(this);
            this.loadChoices = loadChoicesFn(this);
            this.loadChoicesAsync = loadChoicesAsyncFn(this);
            this.searchUsers = searchUsers;
            this.searchUsersWithFieldConfig = searchUsersWithFieldConfig;
            this._update(true, _form);
        }
        get formIsBlank() {
            if (!this.layout) return true;
            return this.layout.every((subLayout)=>subLayout.content.length === 0);
        }
        get answersModified() {
            for (const questionStore of this.questions){
                if (questionStore.answerModified) return true;
            }
            return false;
        }
        get satisfiedConditions() {
            if (!this.conditions) return [];
            const satisfiedConditions = [];
            Object.keys(this.conditions).forEach((conditionKey)=>{
                const condition = this.conditions[conditionKey];
                if (this.conditionIsSatisfied(condition)) satisfiedConditions.push(conditionKey);
            });
            return satisfiedConditions;
        }
        conditionIsSatisfied(condition) {
            if (condition.i.co) for(const conditionQuestionId in condition.i.co.cIds){
                const trackedQuestion = this.questions.find((question)=>`${question.id}` === conditionQuestionId);
                const currentAnswer = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswer)(trackedQuestion === null || trackedQuestion === void 0 ? void 0 : trackedQuestion.currentAnswer);
                if (!(currentAnswer !== null && currentAnswer !== void 0 && currentAnswer.choices)) return false;
                const conditionInput = condition.i.co.cIds[conditionQuestionId];
                return currentAnswer.choices.some((choice)=>conditionInput.includes(choice) || conditionInput.includes(choice.split(':')[0]) && (0, (0, parcelRequire("VSDnB")).fg)('proforma_cascading_fields'));
            }
            return false;
        }
        get visibleSections() {
            if (!this.sections) return [
                '0'
            ];
            const { satisfiedConditions: satisfiedConditions } = this;
            const visibleSections = [
                '0'
            ];
            Object.keys(this.sections).forEach((sectionKey)=>{
                const section = this.sections[sectionKey];
                if (!section.conditions) visibleSections.push(sectionKey);
                if (section.conditions && section.conditions.every((condition)=>satisfiedConditions.includes(condition))) visibleSections.push(sectionKey);
            });
            return visibleSections;
        }
        get hiddenQuestions() {
            if (!this.sections) return this.questions.map((question)=>question.id.toString());
            const hiddenSections = [];
            Object.keys(this.sections).forEach((sectionKey)=>{
                if (!this.visibleSections.includes(sectionKey)) hiddenSections.push(this.sections[sectionKey]);
            });
            return this.questions.filter((question)=>{
                return hiddenSections.some((hiddenSection)=>hiddenSection.questions && hiddenSection.questions.includes(question.id.toString()));
            }).map((question)=>question.id.toString());
        }
        get visibleQuestions() {
            return this.questions.filter((question)=>!this.hiddenQuestions.includes(question.id.toString()));
        }
        get isUploadingMedia() {
            for (const questionStore of this.questions){
                if (questionStore.isUploadingMedia) return true;
            }
            return false;
        }
        get hasAttachmentField() {
            for (const questionStore of this.questions){
                if (questionStore.formQuestion.type === (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment) return true;
            }
            return false;
        }
        get numberOfAttachment() {
            let size = 0;
            for (const questionStore of this.questions)if (questionStore.formQuestion.type === (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment) {
                const attachments = questionStore.currentAnswer;
                size += attachments.length;
            }
            return size;
        }
        get attachmentIds() {
            const attachmentIds = new Set();
            for (const questionStore of this.questions)if (questionStore.formQuestion.type === (0, (0, parcelRequire("4aJmI")).FormQuestionType).Attachment) {
                const attachments = questionStore.answer ? questionStore.answer : [];
                attachments.forEach((attachment)=>attachmentIds.add(attachment.id));
            }
            return attachmentIds;
        }
        afterUpdate() {
            this.prevVisibleSections = this.visibleSections;
            this.visibleQuestions.forEach((question)=>question.doPopulateDefaultValueOnEmptySearch());
        }
        getNewlyVisibleQuestions() {
            if (!this.prevVisibleSections) return [];
            const newlyVisibleSections = this.visibleSections.filter((sectionId)=>{
                var _this$prevVisibleSect;
                return !((_this$prevVisibleSect = this.prevVisibleSections) !== null && _this$prevVisibleSect !== void 0 && _this$prevVisibleSect.includes(sectionId));
            });
            const newlyVisibleQuestions = newlyVisibleSections.reduce((accumulatedQuestions, sectionId)=>{
                var _this$sections;
                const section = (_this$sections = this.sections) === null || _this$sections === void 0 ? void 0 : _this$sections[sectionId];
                if (!section) return accumulatedQuestions;
                return [
                    ...accumulatedQuestions,
                    ...this.questions.filter((question)=>{
                        var _section$questions;
                        return (_section$questions = section.questions) === null || _section$questions === void 0 ? void 0 : _section$questions.includes(question.id.toString());
                    })
                ];
            }, []);
            this.prevVisibleSections = this.visibleSections;
            return newlyVisibleQuestions;
        }
    }, $d5e99eb3f1ac4fc8$var$_descriptor = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "savingAnswers", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return false;
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor2 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "submittingForm", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return false;
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor3 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "updated", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $d5e99eb3f1ac4fc8$var$_descriptor4 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "status", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $d5e99eb3f1ac4fc8$var$_descriptor5 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "questions", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $d5e99eb3f1ac4fc8$var$_descriptor6 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "internal", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), $d5e99eb3f1ac4fc8$var$_descriptor7 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "invalid", [
        (0, $alnGD.observable)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
    }), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "formIsBlank", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "formIsBlank"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "answersModified", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "answersModified"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "satisfiedConditions", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "satisfiedConditions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleSections", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleSections"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hiddenQuestions", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "hiddenQuestions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleQuestions", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleQuestions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "isUploadingMedia", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "isUploadingMedia"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hasAttachmentField", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "hasAttachmentField"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "numberOfAttachment", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "numberOfAttachment"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "attachmentIds", [
        (0, $alnGD.computed)
    ], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "attachmentIds"), $d5e99eb3f1ac4fc8$var$_class.prototype), $d5e99eb3f1ac4fc8$var$_descriptor8 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "attachQuestionsToSections", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                if (!this.layout || !this.layout[0]) return;
                const sectionsAdf = this.layout.map((sectionLayout, index)=>({
                        id: index,
                        questions: sectionLayout.content ? this.getQuestionIdsFromSectionContent(sectionLayout) : []
                    }));
                sectionsAdf.forEach((section)=>{
                    const { sections: sections } = this;
                    if (sections && sections[section.id]) sections[section.id].questions = section.questions;
                });
            };
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor9 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "update", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (form, refreshChoices = false)=>{
                return this._update(false, form, refreshChoices);
            };
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor10 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hideValidations", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.invalid = false;
                this.questions.forEach((question)=>question.hideValidation());
            };
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor11 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "discardModifiedAnswers", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return ()=>{
                this.questions.forEach((question)=>question.discardModifiedAnswer());
            };
        }
    }), $d5e99eb3f1ac4fc8$var$_descriptor12 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "onFieldChange", [
        (0, $alnGD.action)
    ], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: function() {
            return (jiraField)=>{
                const dependentVisibleQuestions = jiraField ? this.visibleQuestions.filter((question)=>{
                    var _question$issueFieldD, _question$issueFieldD2;
                    return (_question$issueFieldD = question.issueFieldData) === null || _question$issueFieldD === void 0 ? void 0 : (_question$issueFieldD2 = _question$issueFieldD.dependsOn) === null || _question$issueFieldD2 === void 0 ? void 0 : _question$issueFieldD2.includes(jiraField);
                }) : [];
                const newlyVisibleNonDependentQuestions = this.getNewlyVisibleQuestions().filter((newlyVisibleQuestion)=>!dependentVisibleQuestions.some((dependentQuestion)=>dependentQuestion.id === newlyVisibleQuestion.id));
                dependentVisibleQuestions.forEach((question)=>{
                    question.onDependentFieldChanged();
                    question.doPopulateDefaultValueOnEmptySearch();
                });
                newlyVisibleNonDependentQuestions.forEach((question)=>question.doPopulateDefaultValueOnEmptySearch());
            };
        }
    }), $d5e99eb3f1ac4fc8$var$_class);
});
parcelRegister("lmhF9", function(module, exports) {
    $parcel$export(module.exports, "filter", ()=>$cb7d90be6f5f5975$export$3dea766d36a8935f);
    var $l1C1k;
    function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
        const result = [];
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                if (callback(node)) result.push(node);
            }
        });
        return result;
    }
});
parcelRegister("chyFx", function(module, exports) {
    $parcel$export(module.exports, "getFormAnalyticsAttributes", ()=>$8f11f71a45f1b0de$export$74358040f8588ae5);
    $parcel$export(module.exports, "getTemplateFormAnalyticsAttributes", ()=>$8f11f71a45f1b0de$export$e9ac6861e8924d45);
    const $8f11f71a45f1b0de$var$capitaliseFirstLetter = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
    const $8f11f71a45f1b0de$export$74358040f8588ae5 = (form)=>{
        var _form$publish, _form$publish2, _jiraConfig$issueRequ, _jiraConfig$issueRequ2, _portalConfig$portalR, _portalConfig$portalR2, _jiraConfig$newIssueI, _jiraConfig$newIssueI2, _jiraConfig$newIssueR, _jiraConfig$newIssueR2;
        const jiraConfig = (_form$publish = form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.jira;
        const portalConfig = (_form$publish2 = form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal;
        const design = form.design;
        const questions = Object.entries(design.questions);
        const sections = Object.values(design.sections);
        const conditions = Object.values(design.conditions);
        const questionsAttributes = {};
        const questionsRequiredAttributes = {};
        const questionsUsedAsSectionConditionAttributes = {};
        const jiraFieldAttributes = {};
        const dataConnectionsAttributes = {};
        questions.forEach(([id, question])=>{
            var _questionsAttributes$, _questionsRequiredAtt, _questionsUsedAsSecti;
            const questionType = $8f11f71a45f1b0de$var$capitaliseFirstLetter(question.type);
            const questionAttribute = `templateFormQuestion${questionType}Count`;
            questionsAttributes[questionAttribute] = ((_questionsAttributes$ = questionsAttributes[questionAttribute]) !== null && _questionsAttributes$ !== void 0 ? _questionsAttributes$ : 0) + 1;
            const questionRequiredAttribute = `templateFormRequiredQuestion${questionType}Count`;
            questionsRequiredAttributes[questionRequiredAttribute] = ((_questionsRequiredAtt = questionsRequiredAttributes[questionRequiredAttribute]) !== null && _questionsRequiredAtt !== void 0 ? _questionsRequiredAtt : 0) + (question.validation.rq ? 1 : 0);
            if (question.jiraField) {
                var _jiraFieldAttributes$;
                const jiraFieldAttribute = `templateFormJiraFieldQuestion${questionType}Count`;
                jiraFieldAttributes[jiraFieldAttribute] = ((_jiraFieldAttributes$ = jiraFieldAttributes[jiraFieldAttribute]) !== null && _jiraFieldAttributes$ !== void 0 ? _jiraFieldAttributes$ : 0) + 1;
            }
            if (question.dcId) {
                var _dataConnectionsAttri;
                const dataConnectionAttribute = `templateFormDataConnectionQuestion${questionType}Count`;
                dataConnectionsAttributes[dataConnectionAttribute] = ((_dataConnectionsAttri = dataConnectionsAttributes[dataConnectionAttribute]) !== null && _dataConnectionsAttri !== void 0 ? _dataConnectionsAttri : 0) + 1;
            }
            const questionUsedAsSectionConditionAttribute = `templateFormUsedAsSectionConditionQuestion${questionType}Count`;
            const questionUsedAsSectionConditionCount = conditions.filter((condition)=>{
                var _condition$i$co;
                return (_condition$i$co = condition.i.co) === null || _condition$i$co === void 0 ? void 0 : _condition$i$co.cIds[id];
            }).length;
            questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute] = ((_questionsUsedAsSecti = questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute]) !== null && _questionsUsedAsSecti !== void 0 ? _questionsUsedAsSecti : 0) + questionUsedAsSectionConditionCount;
        });
        const layoutItemAttributes = {};
        const recurseLayoutItemAttributes = (layoutItemNodes)=>{
            layoutItemNodes.forEach((layoutItemNode)=>{
                var _layoutItemAttributes, _layoutItemNode$conte;
                const layoutItemType = $8f11f71a45f1b0de$var$capitaliseFirstLetter(layoutItemNode.type);
                const layoutItemName = `templateFormLayoutItem${layoutItemType}Count`;
                layoutItemAttributes[layoutItemName] = ((_layoutItemAttributes = layoutItemAttributes[layoutItemName]) !== null && _layoutItemAttributes !== void 0 ? _layoutItemAttributes : 0) + 1;
                recurseLayoutItemAttributes((_layoutItemNode$conte = layoutItemNode.content) !== null && _layoutItemNode$conte !== void 0 ? _layoutItemNode$conte : []);
            });
        };
        recurseLayoutItemAttributes(design.layout);
        return {
            ...questionsAttributes,
            ...questionsRequiredAttributes,
            ...questionsUsedAsSectionConditionAttributes,
            ...jiraFieldAttributes,
            ...dataConnectionsAttributes,
            ...layoutItemAttributes,
            templateFormQuestionsCount: questions.length,
            templateFormSectionsCount: sections.length,
            templateFormConditionalSectionsCount: sections.filter((section)=>{
                var _section$conditions;
                return (_section$conditions = section.conditions) === null || _section$conditions === void 0 ? void 0 : _section$conditions.length;
            }).length,
            templateFormConditionsCount: conditions.length,
            templateFormLinkedFieldsCount: questions.filter(([, question])=>question.jiraField).length,
            templateFormDataConnectionFieldsCount: questions.filter(([, question])=>question.dcId).length,
            templateFormRecommendedCount: (_jiraConfig$issueRequ = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$issueRequ2 = jiraConfig.issueRequestTypeIds) === null || _jiraConfig$issueRequ2 === void 0 ? void 0 : _jiraConfig$issueRequ2.length) !== null && _jiraConfig$issueRequ !== void 0 ? _jiraConfig$issueRequ : 0,
            templateFormPortalFormsCount: (_portalConfig$portalR = portalConfig === null || portalConfig === void 0 ? void 0 : (_portalConfig$portalR2 = portalConfig.portalRequestTypeIds) === null || _portalConfig$portalR2 === void 0 ? void 0 : _portalConfig$portalR2.length) !== null && _portalConfig$portalR !== void 0 ? _portalConfig$portalR : 0,
            templateFormIssueFormsCount: ((_jiraConfig$newIssueI = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$newIssueI2 = jiraConfig.newIssueIssueTypeIds) === null || _jiraConfig$newIssueI2 === void 0 ? void 0 : _jiraConfig$newIssueI2.length) !== null && _jiraConfig$newIssueI !== void 0 ? _jiraConfig$newIssueI : 0) + ((_jiraConfig$newIssueR = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$newIssueR2 = jiraConfig.newIssueRequestTypeIds) === null || _jiraConfig$newIssueR2 === void 0 ? void 0 : _jiraConfig$newIssueR2.length) !== null && _jiraConfig$newIssueR !== void 0 ? _jiraConfig$newIssueR : 0),
            isTemplateFormSubmitOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || false,
            isTemplateFormValidateOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.validateOnCreate) || false,
            isTemplateFormGeneratePDFOnSubmit: design.settings.submit.pdf,
            isTemplateFormLockOnSubmit: design.settings.submit.lock
        };
    };
    const $8f11f71a45f1b0de$export$e9ac6861e8924d45 = (updatedTemplateForm, oldTemplateForm)=>{
        var _oldTemplateForm$publ, _oldTemplateForm$publ2, _oldTemplateForm$publ3, _updatedTemplateForm$, _updatedTemplateForm$2, _updatedTemplateForm$3;
        const updatedFormAttributes = $8f11f71a45f1b0de$export$74358040f8588ae5(updatedTemplateForm);
        const oldFormAttributes = $8f11f71a45f1b0de$export$74358040f8588ae5(oldTemplateForm);
        const deltaAttributes = {};
        const toggleAttributes = {};
        function addDeltaAttribute(numberAttributeKey) {
            var _ref, _ref2;
            const oldValue = (_ref = oldFormAttributes[numberAttributeKey]) !== null && _ref !== void 0 ? _ref : 0;
            const newValue = (_ref2 = updatedFormAttributes[numberAttributeKey]) !== null && _ref2 !== void 0 ? _ref2 : 0;
            deltaAttributes[`${numberAttributeKey}Delta`] = newValue - oldValue;
        }
        function addToggleAttribute(booleanAttributeKey) {
            const oldValue = oldFormAttributes[booleanAttributeKey];
            const newValue = updatedFormAttributes[booleanAttributeKey];
            if (oldValue && !newValue) toggleAttributes[`${booleanAttributeKey}Toggled`] = 'off';
            else if (!oldValue && newValue) toggleAttributes[`${booleanAttributeKey}Toggled`] = 'on';
        }
        Object.entries(updatedFormAttributes).forEach(([key, value])=>{
            if (typeof value === 'number') addDeltaAttribute(key);
            else if (typeof value === 'boolean') addToggleAttribute(key);
        });
        Object.entries(oldFormAttributes).forEach(([key, value])=>{
            if (typeof value === 'number' && deltaAttributes[`${key}Delta`] === undefined) addDeltaAttribute(key);
            else if (typeof value === 'boolean' && deltaAttributes[`${key}Toggled`] === undefined) addToggleAttribute(key);
        });
        const oldPortalForms = (_oldTemplateForm$publ = (_oldTemplateForm$publ2 = oldTemplateForm.publish) === null || _oldTemplateForm$publ2 === void 0 ? void 0 : (_oldTemplateForm$publ3 = _oldTemplateForm$publ2.portal) === null || _oldTemplateForm$publ3 === void 0 ? void 0 : _oldTemplateForm$publ3.portalRequestTypeIds) !== null && _oldTemplateForm$publ !== void 0 ? _oldTemplateForm$publ : [];
        const newPortalForms = (_updatedTemplateForm$ = (_updatedTemplateForm$2 = updatedTemplateForm.publish) === null || _updatedTemplateForm$2 === void 0 ? void 0 : (_updatedTemplateForm$3 = _updatedTemplateForm$2.portal) === null || _updatedTemplateForm$3 === void 0 ? void 0 : _updatedTemplateForm$3.portalRequestTypeIds) !== null && _updatedTemplateForm$ !== void 0 ? _updatedTemplateForm$ : [];
        const templateFormPortalFormAdded = newPortalForms.filter((n)=>!oldPortalForms.includes(n)).length;
        const templateFormPortalFormRemoved = oldPortalForms.filter((n)=>!newPortalForms.includes(n)).length;
        return {
            ...updatedFormAttributes,
            ...deltaAttributes,
            ...toggleAttributes,
            templateFormPortalFormAdded: templateFormPortalFormAdded,
            templateFormPortalFormRemoved: templateFormPortalFormRemoved
        };
    };
});
parcelRegister("iPJqX", function(module, exports) {
    $parcel$export(module.exports, "getCmdbFieldValueMap", ()=>$db603b9cdd007a8c$export$2b093d36da44d0ce);
    var $4aJmI;
    var $4QmvR;
    var $4QmvR;
    const $db603b9cdd007a8c$var$getCmdbContextValue = (question)=>{
        var _toChoiceQuestionAnsw, _toUserPickerQuestion;
        switch(question.formQuestion.type){
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextShort:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextLong:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextEmail:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextUrl:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Date:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).Number:
                return (0, (0, parcelRequire("4QmvR")).toTextQuestionAnswer)(question.currentAnswer);
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).CmdbObject:
                return (_toChoiceQuestionAnsw = (0, (0, parcelRequire("4QmvR")).toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.choices.join(',');
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserSingle:
            case (0, (0, parcelRequire("4aJmI")).FormQuestionType).UserMultiple:
                return (_toUserPickerQuestion = (0, (0, parcelRequire("4QmvR")).toUserPickerQuestionAnswer)(question.currentAnswer)) === null || _toUserPickerQuestion === void 0 ? void 0 : _toUserPickerQuestion.map(({ id: id })=>id).join(',');
            default:
                return undefined;
        }
    };
    const $db603b9cdd007a8c$export$2b093d36da44d0ce = (form)=>{
        const cmdbFieldValueMap = {};
        form.questions.forEach((question)=>{
            if (question.formQuestion.jiraField) {
                const cmdbContextValue = $db603b9cdd007a8c$var$getCmdbContextValue(question);
                if (cmdbContextValue !== undefined) cmdbFieldValueMap[question.formQuestion.jiraField] = cmdbContextValue;
            }
        });
        return cmdbFieldValueMap;
    };
});
parcelRegister("3G30a", function(module, exports) {
    $parcel$export(module.exports, "loadChoicesAsyncFn", ()=>$2ad79f68e5b2ef37$export$21296cd1cc9ee2ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $h8yj2;
    var $erWXD;
    const $2ad79f68e5b2ef37$export$21296cd1cc9ee2ae = (jiraFieldsSearchOptionFns, errorUtils, createAnalyticsEvent, showFlag)=>{
        return (formStore)=>{
            return (questionId, query)=>{
                try {
                    for (const questionStore of formStore.questions)if (questionStore.id === questionId && questionStore.formQuestion.jiraField) {
                        var _questionStore$issueF, _questionStore$issueF2, _questionStore$issueF3, _questionStore$issueF4;
                        const searchOptions = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : (_questionStore$issueF2 = _questionStore$issueF.schema) === null || _questionStore$issueF2 === void 0 ? void 0 : _questionStore$issueF2.custom) && jiraFieldsSearchOptionFns.custom[questionStore.issueFieldData.schema.custom] || ((_questionStore$issueF3 = questionStore.issueFieldData) === null || _questionStore$issueF3 === void 0 ? void 0 : (_questionStore$issueF4 = _questionStore$issueF3.schema) === null || _questionStore$issueF4 === void 0 ? void 0 : _questionStore$issueF4.system) && jiraFieldsSearchOptionFns.system[questionStore.issueFieldData.schema.system] || undefined;
                        if (searchOptions !== undefined) {
                            const { searchOptionsFn: searchOptionsFn, onSearchError: onSearchError } = searchOptions;
                            return searchOptionsFn(questionStore.formQuestion.jiraField, query, questionStore.issueFieldData, formStore).then((options)=>{
                                var _questionStore$issueF5, _questionStore$issueF6, _questionStore$issueF7, _questionStore$issueF8, _questionStore$issueF9;
                                questionStore.setChoices(options.map((option)=>({
                                        id: option.value,
                                        label: option.label
                                    })));
                                (0, (0, parcelRequire("h8yj2")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).SEARCH_ASYNC_CHOICES} ${(0, (0, parcelRequire("erWXD")).Action).FINISHED}`, {
                                    schemaKey: (_questionStore$issueF5 = (_questionStore$issueF6 = questionStore.issueFieldData) === null || _questionStore$issueF6 === void 0 ? void 0 : (_questionStore$issueF7 = _questionStore$issueF6.schema) === null || _questionStore$issueF7 === void 0 ? void 0 : _questionStore$issueF7.system) !== null && _questionStore$issueF5 !== void 0 ? _questionStore$issueF5 : (_questionStore$issueF8 = questionStore.issueFieldData) === null || _questionStore$issueF8 === void 0 ? void 0 : (_questionStore$issueF9 = _questionStore$issueF8.schema) === null || _questionStore$issueF9 === void 0 ? void 0 : _questionStore$issueF9.custom
                                });
                                return options;
                            }).catch((error)=>{
                                var _questionStore$issueF10, _questionStore$issueF11, _questionStore$issueF12, _questionStore$issueF13, _questionStore$issueF14;
                                errorUtils.reportError(error, {
                                    id: (0, (0, parcelRequire("erWXD")).ActionSubject).SEARCH_ASYNC_CHOICES,
                                    attributes: {
                                        schemaKey: (_questionStore$issueF10 = (_questionStore$issueF11 = questionStore.issueFieldData) === null || _questionStore$issueF11 === void 0 ? void 0 : (_questionStore$issueF12 = _questionStore$issueF11.schema) === null || _questionStore$issueF12 === void 0 ? void 0 : _questionStore$issueF12.system) !== null && _questionStore$issueF10 !== void 0 ? _questionStore$issueF10 : (_questionStore$issueF13 = questionStore.issueFieldData) === null || _questionStore$issueF13 === void 0 ? void 0 : (_questionStore$issueF14 = _questionStore$issueF13.schema) === null || _questionStore$issueF14 === void 0 ? void 0 : _questionStore$issueF14.custom
                                    }
                                });
                                if (error.error) {
                                    const flag = onSearchError === null || onSearchError === void 0 ? void 0 : onSearchError(error);
                                    if (flag) showFlag({
                                        title: flag.title,
                                        description: flag.description,
                                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                                            label: "Error",
                                            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
                                        }),
                                        isAutoDismiss: true
                                    });
                                }
                                return Promise.resolve([]);
                            });
                        }
                    }
                    throw new Error('`questionId` not found while trying to load search choices.');
                } catch (error) {
                    errorUtils.reportError(error, {
                        id: (0, (0, parcelRequire("erWXD")).ActionSubject).SEARCH_ASYNC_CHOICES
                    });
                    return Promise.resolve([]);
                }
            };
        };
    };
});
parcelRegister("c66GK", function(module, exports) {
    $parcel$export(module.exports, "loadChoicesFn", ()=>$8ceb3bc5f7614ba5$export$fc6667e6aad0d9af);
    var $4aJmI;
    var $5e1Fe;
    const $8ceb3bc5f7614ba5$export$fc6667e6aad0d9af = (getFormChoices, errorUtils, loadFormChoicesForASubmittedForm = true)=>{
        return (formStore)=>{
            return (questionId, query)=>{
                if (!loadFormChoicesForASubmittedForm && formStore.status !== (0, (0, parcelRequire("4aJmI")).FormStatus).Open) return Promise.resolve();
                const jiraFieldQuestionMap = new Map();
                const dataConnectionQuestionMap = new Map();
                formStore.questions.forEach((question)=>{
                    if (!questionId || questionId === question.id) {
                        if (question.formQuestion.jiraField && $8ceb3bc5f7614ba5$var$isChoiceType(question.formQuestion.type)) {
                            let questionStores;
                            if (jiraFieldQuestionMap.has(question.formQuestion.jiraField)) questionStores = jiraFieldQuestionMap.get(question.formQuestion.jiraField);
                            else {
                                questionStores = [];
                                jiraFieldQuestionMap.set(question.formQuestion.jiraField, questionStores);
                            }
                            questionStores.push(question);
                        }
                        if (question.formQuestion.dcId) {
                            let questionStores = dataConnectionQuestionMap.get(question.formQuestion.dcId);
                            if (questionStores === undefined) {
                                questionStores = [];
                                dataConnectionQuestionMap.set(question.formQuestion.dcId, questionStores);
                            }
                            questionStores.push(question);
                        }
                    }
                });
                const lookups = [];
                if (jiraFieldQuestionMap.size > 0 || dataConnectionQuestionMap.size > 0) lookups.push(getFormChoices(formStore.templateFormId, formStore.formId).then((response)=>{
                    const validationResult = (0, (0, parcelRequire("5e1Fe")).validate)('ApiFormChoicesResponseSchema', response);
                    if (!validationResult.isValid) {
                        errorUtils.reportError(new Error('Response type mismatch'), {
                            id: 'ApiFormChoicesResponseSchema',
                            attributes: {
                                errors: JSON.stringify(validationResult.errors)
                            }
                        });
                        return;
                    }
                    const { fields: fields, dataConnections: dataConnections } = response;
                    jiraFieldQuestionMap.forEach((questionStores, jiraField)=>{
                        if (fields[jiraField]) questionStores.forEach((questionStore)=>questionStore.setChoices(fields[jiraField]));
                    });
                    dataConnectionQuestionMap.forEach((questionStores, dcId)=>{
                        if (dataConnections[dcId]) questionStores.forEach((questionStore)=>{
                            questionStore.setChoices(dataConnections[dcId]);
                        });
                    });
                }));
                return Promise.all(lookups).then((_)=>{});
            };
        };
    };
    function $8ceb3bc5f7614ba5$var$isChoiceType(questionType) {
        return questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceCascading || questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdown || questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceSingle || questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceMultiple || questionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).ChoiceDropdownMultiple;
    }
});
parcelRegister("5e1Fe", function(module, exports) {
    $parcel$export(module.exports, "validate", ()=>$3cdf8cfb98827350$export$a22775fa5e2eebd9);
    var $hWnzn = parcelRequire("hWnzn");
    var $jngaF;
    var $Z8Nv6;
    const $3cdf8cfb98827350$var$ajv = new (0, ($parcel$interopDefault($hWnzn)))({
        allErrors: true,
        coerceTypes: false,
        format: 'fast',
        nullable: true,
        schemaId: 'auto',
        unicode: true,
        uniqueItems: true,
        useDefaults: true
    }).addMetaSchema((parcelRequire("9uYSm")));
    const $3cdf8cfb98827350$var$schemas = {
        ApiFieldDataResponseSchema: (0, parcelRequire("jngaF")).ApiFieldDataResponseSchema,
        ApiFormChoicesResponseSchema: (0, parcelRequire("Z8Nv6")).ApiFormChoicesResponseSchema
    };
    const $3cdf8cfb98827350$export$a22775fa5e2eebd9 = (schema, data)=>{
        var _ajv$errors;
        const schemaInUse = $3cdf8cfb98827350$var$schemas[schema];
        const isValid = !!$3cdf8cfb98827350$var$ajv.validate(schemaInUse, data);
        return {
            isValid: isValid,
            errors: (_ajv$errors = $3cdf8cfb98827350$var$ajv.errors) !== null && _ajv$errors !== void 0 ? _ajv$errors : undefined
        };
    };
});
parcelRegister("hWnzn", function(module, exports) {
    'use strict';
    var $9FouK = parcelRequire("9FouK");
    var $1j7as = parcelRequire("1j7as");
    var $9Adha = parcelRequire("9Adha");
    var $6DxU7 = parcelRequire("6DxU7");
    var $fkrBp = parcelRequire("fkrBp");
    var $2OkcI = parcelRequire("2OkcI");
    var $YWKwU = parcelRequire("YWKwU");
    var $9RO5v = parcelRequire("9RO5v");
    var $dkv5E = parcelRequire("dkv5E");
    module.exports = $d0fa22dfd3a49ce0$var$Ajv;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.validate = $d0fa22dfd3a49ce0$var$validate;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.compile = $d0fa22dfd3a49ce0$var$compile;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.addSchema = $d0fa22dfd3a49ce0$var$addSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.addMetaSchema = $d0fa22dfd3a49ce0$var$addMetaSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.validateSchema = $d0fa22dfd3a49ce0$var$validateSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.getSchema = $d0fa22dfd3a49ce0$var$getSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.removeSchema = $d0fa22dfd3a49ce0$var$removeSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.addFormat = $d0fa22dfd3a49ce0$var$addFormat;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.errorsText = $d0fa22dfd3a49ce0$var$errorsText;
    $d0fa22dfd3a49ce0$var$Ajv.prototype._addSchema = $d0fa22dfd3a49ce0$var$_addSchema;
    $d0fa22dfd3a49ce0$var$Ajv.prototype._compile = $d0fa22dfd3a49ce0$var$_compile;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.compileAsync = (parcelRequire("3X6GU"));
    var $bqG4N = parcelRequire("bqG4N");
    $d0fa22dfd3a49ce0$var$Ajv.prototype.addKeyword = $bqG4N.add;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.getKeyword = $bqG4N.get;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.removeKeyword = $bqG4N.remove;
    $d0fa22dfd3a49ce0$var$Ajv.prototype.validateKeyword = $bqG4N.validate;
    var $go5fO = parcelRequire("go5fO");
    $d0fa22dfd3a49ce0$var$Ajv.ValidationError = $go5fO.Validation;
    $d0fa22dfd3a49ce0$var$Ajv.MissingRefError = $go5fO.MissingRef;
    $d0fa22dfd3a49ce0$var$Ajv.$dataMetaSchema = $9RO5v;
    var $d0fa22dfd3a49ce0$var$META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';
    var $d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS = [
        'removeAdditional',
        'useDefaults',
        'coerceTypes',
        'strictDefaults'
    ];
    var $d0fa22dfd3a49ce0$var$META_SUPPORT_DATA = [
        '/properties'
    ];
    function $d0fa22dfd3a49ce0$var$Ajv(opts) {
        if (!(this instanceof $d0fa22dfd3a49ce0$var$Ajv)) return new $d0fa22dfd3a49ce0$var$Ajv(opts);
        opts = this._opts = $dkv5E.copy(opts) || {};
        $d0fa22dfd3a49ce0$var$setLogger(this);
        this._schemas = {};
        this._refs = {};
        this._fragments = {};
        this._formats = $2OkcI(opts.format);
        this._cache = opts.cache || new $9Adha;
        this._loadingSchemas = {};
        this._compilations = [];
        this.RULES = $YWKwU();
        this._getId = $d0fa22dfd3a49ce0$var$chooseGetId(opts);
        opts.loopRequired = opts.loopRequired || Infinity;
        if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
        if (opts.serialize === undefined) opts.serialize = $fkrBp;
        this._metaOpts = $d0fa22dfd3a49ce0$var$getMetaSchemaOptions(this);
        if (opts.formats) $d0fa22dfd3a49ce0$var$addInitialFormats(this);
        if (opts.keywords) $d0fa22dfd3a49ce0$var$addInitialKeywords(this);
        $d0fa22dfd3a49ce0$var$addDefaultMetaSchema(this);
        if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
        if (opts.nullable) this.addKeyword('nullable', {
            metaSchema: {
                type: 'boolean'
            }
        });
        $d0fa22dfd3a49ce0$var$addInitialSchemas(this);
    }
    function $d0fa22dfd3a49ce0$var$validate(schemaKeyRef, data) {
        var v;
        if (typeof schemaKeyRef == 'string') {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
        } else {
            var schemaObj = this._addSchema(schemaKeyRef);
            v = schemaObj.validate || this._compile(schemaObj);
        }
        var valid = v(data);
        if (v.$async !== true) this.errors = v.errors;
        return valid;
    }
    function $d0fa22dfd3a49ce0$var$compile(schema, _meta) {
        var schemaObj = this._addSchema(schema, undefined, _meta);
        return schemaObj.validate || this._compile(schemaObj);
    }
    function $d0fa22dfd3a49ce0$var$addSchema(schema, key, _skipValidation, _meta) {
        if (Array.isArray(schema)) {
            for(var i = 0; i < schema.length; i++)this.addSchema(schema[i], undefined, _skipValidation, _meta);
            return this;
        }
        var id = this._getId(schema);
        if (id !== undefined && typeof id != 'string') throw new Error('schema id must be string');
        key = $1j7as.normalizeId(key || id);
        $d0fa22dfd3a49ce0$var$checkUnique(this, key);
        this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
        return this;
    }
    function $d0fa22dfd3a49ce0$var$addMetaSchema(schema, key, skipValidation) {
        this.addSchema(schema, key, skipValidation, true);
        return this;
    }
    function $d0fa22dfd3a49ce0$var$validateSchema(schema, throwOrLogError) {
        var $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != 'string') throw new Error('$schema must be a string');
        $schema = $schema || this._opts.defaultMeta || $d0fa22dfd3a49ce0$var$defaultMeta(this);
        if (!$schema) {
            this.logger.warn('meta-schema not available');
            this.errors = null;
            return true;
        }
        var valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            var message = 'schema is invalid: ' + this.errorsText();
            if (this._opts.validateSchema == 'log') this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    function $d0fa22dfd3a49ce0$var$defaultMeta(self) {
        var meta = self._opts.meta;
        self._opts.defaultMeta = typeof meta == 'object' ? self._getId(meta) || meta : self.getSchema($d0fa22dfd3a49ce0$var$META_SCHEMA_ID) ? $d0fa22dfd3a49ce0$var$META_SCHEMA_ID : undefined;
        return self._opts.defaultMeta;
    }
    function $d0fa22dfd3a49ce0$var$getSchema(keyRef) {
        var schemaObj = $d0fa22dfd3a49ce0$var$_getSchemaObj(this, keyRef);
        switch(typeof schemaObj){
            case 'object':
                return schemaObj.validate || this._compile(schemaObj);
            case 'string':
                return this.getSchema(schemaObj);
            case 'undefined':
                return $d0fa22dfd3a49ce0$var$_getSchemaFragment(this, keyRef);
        }
    }
    function $d0fa22dfd3a49ce0$var$_getSchemaFragment(self, ref) {
        var res = $1j7as.schema.call(self, {
            schema: {}
        }, ref);
        if (res) {
            var schema = res.schema, root = res.root, baseId = res.baseId;
            var v = $9FouK.call(self, schema, root, undefined, baseId);
            self._fragments[ref] = new $6DxU7({
                ref: ref,
                fragment: true,
                schema: schema,
                root: root,
                baseId: baseId,
                validate: v
            });
            return v;
        }
    }
    function $d0fa22dfd3a49ce0$var$_getSchemaObj(self, keyRef) {
        keyRef = $1j7as.normalizeId(keyRef);
        return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
    }
    function $d0fa22dfd3a49ce0$var$removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._schemas, schemaKeyRef);
            $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case 'undefined':
                $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._schemas);
                $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._refs);
                this._cache.clear();
                return this;
            case 'string':
                var schemaObj = $d0fa22dfd3a49ce0$var$_getSchemaObj(this, schemaKeyRef);
                if (schemaObj) this._cache.del(schemaObj.cacheKey);
                delete this._schemas[schemaKeyRef];
                delete this._refs[schemaKeyRef];
                return this;
            case 'object':
                var serialize = this._opts.serialize;
                var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
                this._cache.del(cacheKey);
                var id = this._getId(schemaKeyRef);
                if (id) {
                    id = $1j7as.normalizeId(id);
                    delete this._schemas[id];
                    delete this._refs[id];
                }
        }
        return this;
    }
    function $d0fa22dfd3a49ce0$var$_removeAllSchemas(self, schemas, regex) {
        for(var keyRef in schemas){
            var schemaObj = schemas[keyRef];
            if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
                self._cache.del(schemaObj.cacheKey);
                delete schemas[keyRef];
            }
        }
    }
    function $d0fa22dfd3a49ce0$var$_addSchema(schema, skipValidation, meta, shouldAddSchema) {
        if (typeof schema != 'object' && typeof schema != 'boolean') throw new Error('schema should be object or boolean');
        var serialize = this._opts.serialize;
        var cacheKey = serialize ? serialize(schema) : schema;
        var cached = this._cache.get(cacheKey);
        if (cached) return cached;
        shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
        var id = $1j7as.normalizeId(this._getId(schema));
        if (id && shouldAddSchema) $d0fa22dfd3a49ce0$var$checkUnique(this, id);
        var willValidate = this._opts.validateSchema !== false && !skipValidation;
        var recursiveMeta;
        if (willValidate && !(recursiveMeta = id && id == $1j7as.normalizeId(schema.$schema))) this.validateSchema(schema, true);
        var localRefs = $1j7as.ids.call(this, schema);
        var schemaObj = new $6DxU7({
            id: id,
            schema: schema,
            localRefs: localRefs,
            cacheKey: cacheKey,
            meta: meta
        });
        if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
        this._cache.put(cacheKey, schemaObj);
        if (willValidate && recursiveMeta) this.validateSchema(schema, true);
        return schemaObj;
    }
    function $d0fa22dfd3a49ce0$var$_compile(schemaObj, root) {
        if (schemaObj.compiling) {
            schemaObj.validate = callValidate;
            callValidate.schema = schemaObj.schema;
            callValidate.errors = null;
            callValidate.root = root ? root : callValidate;
            if (schemaObj.schema.$async === true) callValidate.$async = true;
            return callValidate;
        }
        schemaObj.compiling = true;
        var currentOpts;
        if (schemaObj.meta) {
            currentOpts = this._opts;
            this._opts = this._metaOpts;
        }
        var v;
        try {
            v = $9FouK.call(this, schemaObj.schema, root, schemaObj.localRefs);
        } catch (e) {
            delete schemaObj.validate;
            throw e;
        } finally{
            schemaObj.compiling = false;
            if (schemaObj.meta) this._opts = currentOpts;
        }
        schemaObj.validate = v;
        schemaObj.refs = v.refs;
        schemaObj.refVal = v.refVal;
        schemaObj.root = v.root;
        return v;
        function callValidate() {
            var _validate = schemaObj.validate;
            var result = _validate.apply(this, arguments);
            callValidate.errors = _validate.errors;
            return result;
        }
    }
    function $d0fa22dfd3a49ce0$var$chooseGetId(opts) {
        switch(opts.schemaId){
            case 'auto':
                return $d0fa22dfd3a49ce0$var$_get$IdOrId;
            case 'id':
                return $d0fa22dfd3a49ce0$var$_getId;
            default:
                return $d0fa22dfd3a49ce0$var$_get$Id;
        }
    }
    function $d0fa22dfd3a49ce0$var$_getId(schema) {
        if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
        return schema.id;
    }
    function $d0fa22dfd3a49ce0$var$_get$Id(schema) {
        if (schema.id) this.logger.warn('schema id ignored', schema.id);
        return schema.$id;
    }
    function $d0fa22dfd3a49ce0$var$_get$IdOrId(schema) {
        if (schema.$id && schema.id && schema.$id != schema.id) throw new Error('schema $id is different from id');
        return schema.$id || schema.id;
    }
    function $d0fa22dfd3a49ce0$var$errorsText(errors, options) {
        errors = errors || this.errors;
        if (!errors) return 'No errors';
        options = options || {};
        var separator = options.separator === undefined ? ', ' : options.separator;
        var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;
        var text = '';
        for(var i = 0; i < errors.length; i++){
            var e = errors[i];
            if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
        }
        return text.slice(0, -separator.length);
    }
    function $d0fa22dfd3a49ce0$var$addFormat(name, format) {
        if (typeof format == 'string') format = new RegExp(format);
        this._formats[name] = format;
        return this;
    }
    function $d0fa22dfd3a49ce0$var$addDefaultMetaSchema(self) {
        var $dataSchema;
        if (self._opts.$data) {
            $dataSchema = (parcelRequire("cX7mp"));
            self.addMetaSchema($dataSchema, $dataSchema.$id, true);
        }
        if (self._opts.meta === false) return;
        var metaSchema = (parcelRequire("1zxWt"));
        if (self._opts.$data) metaSchema = $9RO5v(metaSchema, $d0fa22dfd3a49ce0$var$META_SUPPORT_DATA);
        self.addMetaSchema(metaSchema, $d0fa22dfd3a49ce0$var$META_SCHEMA_ID, true);
        self._refs['http://json-schema.org/schema'] = $d0fa22dfd3a49ce0$var$META_SCHEMA_ID;
    }
    function $d0fa22dfd3a49ce0$var$addInitialSchemas(self) {
        var optsSchemas = self._opts.schemas;
        if (!optsSchemas) return;
        if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
        else for(var key in optsSchemas)self.addSchema(optsSchemas[key], key);
    }
    function $d0fa22dfd3a49ce0$var$addInitialFormats(self) {
        for(var name in self._opts.formats){
            var format = self._opts.formats[name];
            self.addFormat(name, format);
        }
    }
    function $d0fa22dfd3a49ce0$var$addInitialKeywords(self) {
        for(var name in self._opts.keywords){
            var keyword = self._opts.keywords[name];
            self.addKeyword(name, keyword);
        }
    }
    function $d0fa22dfd3a49ce0$var$checkUnique(self, id) {
        if (self._schemas[id] || self._refs[id]) throw new Error('schema with key or id "' + id + '" already exists');
    }
    function $d0fa22dfd3a49ce0$var$getMetaSchemaOptions(self) {
        var metaOpts = $dkv5E.copy(self._opts);
        for(var i = 0; i < $d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS.length; i++)delete metaOpts[$d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS[i]];
        return metaOpts;
    }
    function $d0fa22dfd3a49ce0$var$setLogger(self) {
        var logger = self._opts.logger;
        if (logger === false) self.logger = {
            log: $d0fa22dfd3a49ce0$var$noop,
            warn: $d0fa22dfd3a49ce0$var$noop,
            error: $d0fa22dfd3a49ce0$var$noop
        };
        else {
            if (logger === undefined) logger = console;
            if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error)) throw new Error('logger must implement log, warn and error methods');
            self.logger = logger;
        }
    }
    function $d0fa22dfd3a49ce0$var$noop() {}
});
parcelRegister("9FouK", function(module, exports) {
    'use strict';
    var $1j7as = parcelRequire("1j7as");
    var $dkv5E = parcelRequire("dkv5E");
    var $go5fO = parcelRequire("go5fO");
    var $fkrBp = parcelRequire("fkrBp");
    var $dNYSY = parcelRequire("dNYSY");
    var $709af1938efbe8dc$var$ucs2length = $dkv5E.ucs2length;
    var $1SBaA = parcelRequire("1SBaA");
    var $709af1938efbe8dc$var$ValidationError = $go5fO.Validation;
    module.exports = $709af1938efbe8dc$var$compile;
    function $709af1938efbe8dc$var$compile(schema, root, localRefs, baseId) {
        var self = this, opts = this._opts, refVal = [
            undefined
        ], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
        root = root || {
            schema: schema,
            refVal: refVal,
            refs: refs
        };
        var c = $709af1938efbe8dc$var$checkCompiling.call(this, schema, root, baseId);
        var compilation = this._compilations[c.index];
        if (c.compiling) return compilation.callValidate = callValidate;
        var formats = this._formats;
        var RULES = this.RULES;
        try {
            var v = localCompile(schema, root, localRefs, baseId);
            compilation.validate = v;
            var cv = compilation.callValidate;
            if (cv) {
                cv.schema = v.schema;
                cv.errors = null;
                cv.refs = v.refs;
                cv.refVal = v.refVal;
                cv.root = v.root;
                cv.$async = v.$async;
                if (opts.sourceCode) cv.source = v.source;
            }
            return v;
        } finally{
            $709af1938efbe8dc$var$endCompiling.call(this, schema, root, baseId);
        }
        function callValidate() {
            var validate = compilation.validate;
            var result = validate.apply(this, arguments);
            callValidate.errors = validate.errors;
            return result;
        }
        function localCompile(_schema, _root, localRefs, baseId) {
            var isRoot = !_root || _root && _root.schema == _schema;
            if (_root.schema != root.schema) return $709af1938efbe8dc$var$compile.call(self, _schema, _root, localRefs, baseId);
            var $async = _schema.$async === true;
            var sourceCode = $dNYSY({
                isTop: true,
                schema: _schema,
                isRoot: isRoot,
                baseId: baseId,
                root: _root,
                schemaPath: '',
                errSchemaPath: '#',
                errorPath: '""',
                MissingRefError: $go5fO.MissingRef,
                RULES: RULES,
                validate: $dNYSY,
                util: $dkv5E,
                resolve: $1j7as,
                resolveRef: resolveRef,
                usePattern: usePattern,
                useDefault: useDefault,
                useCustomRule: useCustomRule,
                opts: opts,
                formats: formats,
                logger: self.logger,
                self: self
            });
            sourceCode = $709af1938efbe8dc$var$vars(refVal, $709af1938efbe8dc$var$refValCode) + $709af1938efbe8dc$var$vars(patterns, $709af1938efbe8dc$var$patternCode) + $709af1938efbe8dc$var$vars(defaults, $709af1938efbe8dc$var$defaultCode) + $709af1938efbe8dc$var$vars(customRules, $709af1938efbe8dc$var$customRuleCode) + sourceCode;
            if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
            var validate;
            try {
                var makeValidate = new Function('self', 'RULES', 'formats', 'root', 'refVal', 'defaults', 'customRules', 'equal', 'ucs2length', 'ValidationError', sourceCode);
                validate = makeValidate(self, RULES, formats, root, refVal, defaults, customRules, $1SBaA, $709af1938efbe8dc$var$ucs2length, $709af1938efbe8dc$var$ValidationError);
                refVal[0] = validate;
            } catch (e) {
                self.logger.error('Error compiling schema, function code:', sourceCode);
                throw e;
            }
            validate.schema = _schema;
            validate.errors = null;
            validate.refs = refs;
            validate.refVal = refVal;
            validate.root = isRoot ? validate : _root;
            if ($async) validate.$async = true;
            if (opts.sourceCode === true) validate.source = {
                code: sourceCode,
                patterns: patterns,
                defaults: defaults
            };
            return validate;
        }
        function resolveRef(baseId, ref, isRoot) {
            ref = $1j7as.url(baseId, ref);
            var refIndex = refs[ref];
            var _refVal, refCode;
            if (refIndex !== undefined) {
                _refVal = refVal[refIndex];
                refCode = 'refVal[' + refIndex + ']';
                return resolvedRef(_refVal, refCode);
            }
            if (!isRoot && root.refs) {
                var rootRefId = root.refs[ref];
                if (rootRefId !== undefined) {
                    _refVal = root.refVal[rootRefId];
                    refCode = addLocalRef(ref, _refVal);
                    return resolvedRef(_refVal, refCode);
                }
            }
            refCode = addLocalRef(ref);
            var v = $1j7as.call(self, localCompile, root, ref);
            if (v === undefined) {
                var localSchema = localRefs && localRefs[ref];
                if (localSchema) v = $1j7as.inlineRef(localSchema, opts.inlineRefs) ? localSchema : $709af1938efbe8dc$var$compile.call(self, localSchema, root, localRefs, baseId);
            }
            if (v === undefined) removeLocalRef(ref);
            else {
                replaceLocalRef(ref, v);
                return resolvedRef(v, refCode);
            }
        }
        function addLocalRef(ref, v) {
            var refId = refVal.length;
            refVal[refId] = v;
            refs[ref] = refId;
            return 'refVal' + refId;
        }
        function removeLocalRef(ref) {
            delete refs[ref];
        }
        function replaceLocalRef(ref, v) {
            var refId = refs[ref];
            refVal[refId] = v;
        }
        function resolvedRef(refVal, code) {
            return typeof refVal == 'object' || typeof refVal == 'boolean' ? {
                code: code,
                schema: refVal,
                inline: true
            } : {
                code: code,
                $async: refVal && !!refVal.$async
            };
        }
        function usePattern(regexStr) {
            var index = patternsHash[regexStr];
            if (index === undefined) {
                index = patternsHash[regexStr] = patterns.length;
                patterns[index] = regexStr;
            }
            return 'pattern' + index;
        }
        function useDefault(value) {
            switch(typeof value){
                case 'boolean':
                case 'number':
                    return '' + value;
                case 'string':
                    return $dkv5E.toQuotedString(value);
                case 'object':
                    if (value === null) return 'null';
                    var valueStr = $fkrBp(value);
                    var index = defaultsHash[valueStr];
                    if (index === undefined) {
                        index = defaultsHash[valueStr] = defaults.length;
                        defaults[index] = value;
                    }
                    return 'default' + index;
            }
        }
        function useCustomRule(rule, schema, parentSchema, it) {
            if (self._opts.validateSchema !== false) {
                var deps = rule.definition.dependencies;
                if (deps && !deps.every(function(keyword) {
                    return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
                })) throw new Error('parent schema must have all required keywords: ' + deps.join(','));
                var validateSchema = rule.definition.validateSchema;
                if (validateSchema) {
                    var valid = validateSchema(schema);
                    if (!valid) {
                        var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
                        if (self._opts.validateSchema == 'log') self.logger.error(message);
                        else throw new Error(message);
                    }
                }
            }
            var compile = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
            var validate;
            if (compile) validate = compile.call(self, schema, parentSchema, it);
            else if (macro) {
                validate = macro.call(self, schema, parentSchema, it);
                if (opts.validateSchema !== false) self.validateSchema(validate, true);
            } else if (inline) validate = inline.call(self, it, rule.keyword, schema, parentSchema);
            else {
                validate = rule.definition.validate;
                if (!validate) return;
            }
            if (validate === undefined) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
            var index = customRules.length;
            customRules[index] = validate;
            return {
                code: 'customRule' + index,
                validate: validate
            };
        }
    }
    function $709af1938efbe8dc$var$checkCompiling(schema, root, baseId) {
        var index = $709af1938efbe8dc$var$compIndex.call(this, schema, root, baseId);
        if (index >= 0) return {
            index: index,
            compiling: true
        };
        index = this._compilations.length;
        this._compilations[index] = {
            schema: schema,
            root: root,
            baseId: baseId
        };
        return {
            index: index,
            compiling: false
        };
    }
    function $709af1938efbe8dc$var$endCompiling(schema, root, baseId) {
        var i = $709af1938efbe8dc$var$compIndex.call(this, schema, root, baseId);
        if (i >= 0) this._compilations.splice(i, 1);
    }
    function $709af1938efbe8dc$var$compIndex(schema, root, baseId) {
        for(var i = 0; i < this._compilations.length; i++){
            var c = this._compilations[i];
            if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
        }
        return -1;
    }
    function $709af1938efbe8dc$var$patternCode(i, patterns) {
        return 'var pattern' + i + ' = new RegExp(' + $dkv5E.toQuotedString(patterns[i]) + ');';
    }
    function $709af1938efbe8dc$var$defaultCode(i) {
        return 'var default' + i + ' = defaults[' + i + '];';
    }
    function $709af1938efbe8dc$var$refValCode(i, refVal) {
        return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
    }
    function $709af1938efbe8dc$var$customRuleCode(i) {
        return 'var customRule' + i + ' = customRules[' + i + '];';
    }
    function $709af1938efbe8dc$var$vars(arr, statement) {
        if (!arr.length) return '';
        var code = '';
        for(var i = 0; i < arr.length; i++)code += statement(i, arr);
        return code;
    }
});
parcelRegister("1j7as", function(module, exports) {
    'use strict';
    var $jzwjK = parcelRequire("jzwjK");
    var $1SBaA = parcelRequire("1SBaA");
    var $dkv5E = parcelRequire("dkv5E");
    var $6DxU7 = parcelRequire("6DxU7");
    var $9O5cx = parcelRequire("9O5cx");
    module.exports = $0f3d2021b76b463f$var$resolve;
    $0f3d2021b76b463f$var$resolve.normalizeId = $0f3d2021b76b463f$var$normalizeId;
    $0f3d2021b76b463f$var$resolve.fullPath = $0f3d2021b76b463f$var$getFullPath;
    $0f3d2021b76b463f$var$resolve.url = $0f3d2021b76b463f$var$resolveUrl;
    $0f3d2021b76b463f$var$resolve.ids = $0f3d2021b76b463f$var$resolveIds;
    $0f3d2021b76b463f$var$resolve.inlineRef = $0f3d2021b76b463f$var$inlineRef;
    $0f3d2021b76b463f$var$resolve.schema = $0f3d2021b76b463f$var$resolveSchema;
    function $0f3d2021b76b463f$var$resolve(compile, root, ref) {
        var refVal = this._refs[ref];
        if (typeof refVal == 'string') {
            if (this._refs[refVal]) refVal = this._refs[refVal];
            else return $0f3d2021b76b463f$var$resolve.call(this, compile, root, refVal);
        }
        refVal = refVal || this._schemas[ref];
        if (refVal instanceof $6DxU7) return $0f3d2021b76b463f$var$inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
        var res = $0f3d2021b76b463f$var$resolveSchema.call(this, root, ref);
        var schema, v, baseId;
        if (res) {
            schema = res.schema;
            root = res.root;
            baseId = res.baseId;
        }
        if (schema instanceof $6DxU7) v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
        else if (schema !== undefined) v = $0f3d2021b76b463f$var$inlineRef(schema, this._opts.inlineRefs) ? schema : compile.call(this, schema, root, undefined, baseId);
        return v;
    }
    function $0f3d2021b76b463f$var$resolveSchema(root, ref) {
        var p = $jzwjK.parse(ref), refPath = $0f3d2021b76b463f$var$_getFullPath(p), baseId = $0f3d2021b76b463f$var$getFullPath(this._getId(root.schema));
        if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
            var id = $0f3d2021b76b463f$var$normalizeId(refPath);
            var refVal = this._refs[id];
            if (typeof refVal == 'string') return $0f3d2021b76b463f$var$resolveRecursive.call(this, root, refVal, p);
            else if (refVal instanceof $6DxU7) {
                if (!refVal.validate) this._compile(refVal);
                root = refVal;
            } else {
                refVal = this._schemas[id];
                if (refVal instanceof $6DxU7) {
                    if (!refVal.validate) this._compile(refVal);
                    if (id == $0f3d2021b76b463f$var$normalizeId(ref)) return {
                        schema: refVal,
                        root: root,
                        baseId: baseId
                    };
                    root = refVal;
                } else return;
            }
            if (!root.schema) return;
            baseId = $0f3d2021b76b463f$var$getFullPath(this._getId(root.schema));
        }
        return $0f3d2021b76b463f$var$getJsonPointer.call(this, p, baseId, root.schema, root);
    }
    function $0f3d2021b76b463f$var$resolveRecursive(root, ref, parsedRef) {
        var res = $0f3d2021b76b463f$var$resolveSchema.call(this, root, ref);
        if (res) {
            var schema = res.schema;
            var baseId = res.baseId;
            root = res.root;
            var id = this._getId(schema);
            if (id) baseId = $0f3d2021b76b463f$var$resolveUrl(baseId, id);
            return $0f3d2021b76b463f$var$getJsonPointer.call(this, parsedRef, baseId, schema, root);
        }
    }
    var $0f3d2021b76b463f$var$PREVENT_SCOPE_CHANGE = $dkv5E.toHash([
        'properties',
        'patternProperties',
        'enum',
        'dependencies',
        'definitions'
    ]);
    function $0f3d2021b76b463f$var$getJsonPointer(parsedRef, baseId, schema, root) {
        parsedRef.fragment = parsedRef.fragment || '';
        if (parsedRef.fragment.slice(0, 1) != '/') return;
        var parts = parsedRef.fragment.split('/');
        for(var i = 1; i < parts.length; i++){
            var part = parts[i];
            if (part) {
                part = $dkv5E.unescapeFragment(part);
                schema = schema[part];
                if (schema === undefined) break;
                var id;
                if (!$0f3d2021b76b463f$var$PREVENT_SCOPE_CHANGE[part]) {
                    id = this._getId(schema);
                    if (id) baseId = $0f3d2021b76b463f$var$resolveUrl(baseId, id);
                    if (schema.$ref) {
                        var $ref = $0f3d2021b76b463f$var$resolveUrl(baseId, schema.$ref);
                        var res = $0f3d2021b76b463f$var$resolveSchema.call(this, root, $ref);
                        if (res) {
                            schema = res.schema;
                            root = res.root;
                            baseId = res.baseId;
                        }
                    }
                }
            }
        }
        if (schema !== undefined && schema !== root.schema) return {
            schema: schema,
            root: root,
            baseId: baseId
        };
    }
    var $0f3d2021b76b463f$var$SIMPLE_INLINED = $dkv5E.toHash([
        'type',
        'format',
        'pattern',
        'maxLength',
        'minLength',
        'maxProperties',
        'minProperties',
        'maxItems',
        'minItems',
        'maximum',
        'minimum',
        'uniqueItems',
        'multipleOf',
        'required',
        'enum'
    ]);
    function $0f3d2021b76b463f$var$inlineRef(schema, limit) {
        if (limit === false) return false;
        if (limit === undefined || limit === true) return $0f3d2021b76b463f$var$checkNoRef(schema);
        else if (limit) return $0f3d2021b76b463f$var$countKeys(schema) <= limit;
    }
    function $0f3d2021b76b463f$var$checkNoRef(schema) {
        var item;
        if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
            item = schema[i];
            if (typeof item == 'object' && !$0f3d2021b76b463f$var$checkNoRef(item)) return false;
        }
        else for(var key in schema){
            if (key == '$ref') return false;
            item = schema[key];
            if (typeof item == 'object' && !$0f3d2021b76b463f$var$checkNoRef(item)) return false;
        }
        return true;
    }
    function $0f3d2021b76b463f$var$countKeys(schema) {
        var count = 0, item;
        if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
            item = schema[i];
            if (typeof item == 'object') count += $0f3d2021b76b463f$var$countKeys(item);
            if (count == Infinity) return Infinity;
        }
        else for(var key in schema){
            if (key == '$ref') return Infinity;
            if ($0f3d2021b76b463f$var$SIMPLE_INLINED[key]) count++;
            else {
                item = schema[key];
                if (typeof item == 'object') count += $0f3d2021b76b463f$var$countKeys(item) + 1;
                if (count == Infinity) return Infinity;
            }
        }
        return count;
    }
    function $0f3d2021b76b463f$var$getFullPath(id, normalize) {
        if (normalize !== false) id = $0f3d2021b76b463f$var$normalizeId(id);
        var p = $jzwjK.parse(id);
        return $0f3d2021b76b463f$var$_getFullPath(p);
    }
    function $0f3d2021b76b463f$var$_getFullPath(p) {
        return $jzwjK.serialize(p).split('#')[0] + '#';
    }
    var $0f3d2021b76b463f$var$TRAILING_SLASH_HASH = /#\/?$/;
    function $0f3d2021b76b463f$var$normalizeId(id) {
        return id ? id.replace($0f3d2021b76b463f$var$TRAILING_SLASH_HASH, '') : '';
    }
    function $0f3d2021b76b463f$var$resolveUrl(baseId, id) {
        id = $0f3d2021b76b463f$var$normalizeId(id);
        return $jzwjK.resolve(baseId, id);
    }
    function $0f3d2021b76b463f$var$resolveIds(schema) {
        var schemaId = $0f3d2021b76b463f$var$normalizeId(this._getId(schema));
        var baseIds = {
            '': schemaId
        };
        var fullPaths = {
            '': $0f3d2021b76b463f$var$getFullPath(schemaId, false)
        };
        var localRefs = {};
        var self = this;
        $9O5cx(schema, {
            allKeys: true
        }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
            if (jsonPtr === '') return;
            var id = self._getId(sch);
            var baseId = baseIds[parentJsonPtr];
            var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
            if (keyIndex !== undefined) fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : $dkv5E.escapeFragment(keyIndex));
            if (typeof id == 'string') {
                id = baseId = $0f3d2021b76b463f$var$normalizeId(baseId ? $jzwjK.resolve(baseId, id) : id);
                var refVal = self._refs[id];
                if (typeof refVal == 'string') refVal = self._refs[refVal];
                if (refVal && refVal.schema) {
                    if (!$1SBaA(sch, refVal.schema)) throw new Error('id "' + id + '" resolves to more than one schema');
                } else if (id != $0f3d2021b76b463f$var$normalizeId(fullPath)) {
                    if (id[0] == '#') {
                        if (localRefs[id] && !$1SBaA(sch, localRefs[id])) throw new Error('id "' + id + '" resolves to more than one schema');
                        localRefs[id] = sch;
                    } else self._refs[id] = fullPath;
                }
            }
            baseIds[jsonPtr] = baseId;
            fullPaths[jsonPtr] = fullPath;
        });
        return localRefs;
    }
});
parcelRegister("jzwjK", function(module, exports) {
    (function(global, factory) {
        factory(module.exports);
    })(module.exports, function(exports1) {
        'use strict';
        function merge() {
            for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
            if (sets.length > 1) {
                sets[0] = sets[0].slice(0, -1);
                var xl = sets.length - 1;
                for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
                sets[xl] = sets[xl].slice(1);
                return sets.join('');
            } else return sets[0];
        }
        function subexp(str) {
            return "(?:" + str + ")";
        }
        function typeOf(o) {
            return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
        }
        function toUpperCase(str) {
            return str.toUpperCase();
        }
        function toArray(obj) {
            return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
                obj
            ] : Array.prototype.slice.call(obj) : [];
        }
        function assign(target, source) {
            var obj = target;
            if (source) for(var key in source)obj[key] = source[key];
            return obj;
        }
        function buildExps(isIRI) {
            var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), IPV6ADDRESS$ = subexp([
                IPV6ADDRESS1$,
                IPV6ADDRESS2$,
                IPV6ADDRESS3$,
                IPV6ADDRESS4$,
                IPV6ADDRESS5$,
                IPV6ADDRESS6$,
                IPV6ADDRESS7$,
                IPV6ADDRESS8$,
                IPV6ADDRESS9$
            ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
            return {
                NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
                NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
                NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
                NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
                NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
                NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
                NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
                ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
                UNRESERVED: new RegExp(UNRESERVED$$, "g"),
                OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
                PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
                IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
                IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$")
            };
        }
        var URI_PROTOCOL = buildExps(false);
        var IRI_PROTOCOL = buildExps(true);
        var slicedToArray = function() {
            function sliceIterator(arr, i) {
                var _arr = [];
                var _n = true;
                var _d = false;
                var _e = undefined;
                try {
                    for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                    }
                } catch (err) {
                    _d = true;
                    _e = err;
                } finally{
                    try {
                        if (!_n && _i["return"]) _i["return"]();
                    } finally{
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
            return function(arr, i) {
                if (Array.isArray(arr)) return arr;
                else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
        }();
        var toConsumableArray = function(arr) {
            if (Array.isArray(arr)) {
                for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                return arr2;
            } else return Array.from(arr);
        };
        var maxInt = 2147483647;
        var base = 36;
        var tMin = 1;
        var tMax = 26;
        var skew = 38;
        var damp = 700;
        var initialBias = 72;
        var initialN = 128;
        var delimiter = '-';
        var regexPunycode = /^xn--/;
        var regexNonASCII = /[^\0-\x7E]/;
        var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
        var errors = {
            'overflow': 'Overflow: input needs wider integers to process',
            'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
            'invalid-input': 'Invalid input'
        };
        var baseMinusTMin = base - tMin;
        var floor = Math.floor;
        var stringFromCharCode = String.fromCharCode;
        function error$1(type) {
            throw new RangeError(errors[type]);
        }
        function map(array, fn) {
            var result = [];
            var length = array.length;
            while(length--)result[length] = fn(array[length]);
            return result;
        }
        function mapDomain(string, fn) {
            var parts = string.split('@');
            var result = '';
            if (parts.length > 1) {
                result = parts[0] + '@';
                string = parts[1];
            }
            string = string.replace(regexSeparators, '\x2E');
            var labels = string.split('.');
            var encoded = map(labels, fn).join('.');
            return result + encoded;
        }
        function ucs2decode(string) {
            var output = [];
            var counter = 0;
            var length = string.length;
            while(counter < length){
                var value = string.charCodeAt(counter++);
                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                    var extra = string.charCodeAt(counter++);
                    if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                    else {
                        output.push(value);
                        counter--;
                    }
                } else output.push(value);
            }
            return output;
        }
        var ucs2encode = function ucs2encode(array) {
            return String.fromCodePoint.apply(String, toConsumableArray(array));
        };
        var basicToDigit = function basicToDigit(codePoint) {
            if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
            if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
            if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
            return base;
        };
        var digitToBasic = function digitToBasic(digit, flag) {
            return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
        };
        var adapt = function adapt(delta, numPoints, firstTime) {
            var k = 0;
            delta = firstTime ? floor(delta / damp) : delta >> 1;
            delta += floor(delta / numPoints);
            for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
            return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
        };
        var decode = function decode(input) {
            var output = [];
            var inputLength = input.length;
            var i = 0;
            var n = initialN;
            var bias = initialBias;
            var basic = input.lastIndexOf(delimiter);
            if (basic < 0) basic = 0;
            for(var j = 0; j < basic; ++j){
                if (input.charCodeAt(j) >= 0x80) error$1('not-basic');
                output.push(input.charCodeAt(j));
            }
            for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                var oldi = i;
                for(var w = 1, k = base;; k += base){
                    if (index >= inputLength) error$1('invalid-input');
                    var digit = basicToDigit(input.charCodeAt(index++));
                    if (digit >= base || digit > floor((maxInt - i) / w)) error$1('overflow');
                    i += digit * w;
                    var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (digit < t) break;
                    var baseMinusT = base - t;
                    if (w > floor(maxInt / baseMinusT)) error$1('overflow');
                    w *= baseMinusT;
                }
                var out = output.length + 1;
                bias = adapt(i - oldi, out, oldi == 0);
                if (floor(i / out) > maxInt - n) error$1('overflow');
                n += floor(i / out);
                i %= out;
                output.splice(i++, 0, n);
            }
            return String.fromCodePoint.apply(String, output);
        };
        var encode = function encode(input) {
            var output = [];
            input = ucs2decode(input);
            var inputLength = input.length;
            var n = initialN;
            var delta = 0;
            var bias = initialBias;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;
            try {
                for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _currentValue2 = _step.value;
                    if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                } finally{
                    if (_didIteratorError) throw _iteratorError;
                }
            }
            var basicLength = output.length;
            var handledCPCount = basicLength;
            if (basicLength) output.push(delimiter);
            while(handledCPCount < inputLength){
                var m = maxInt;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var currentValue = _step2.value;
                        if (currentValue >= n && currentValue < m) m = currentValue;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                var handledCPCountPlusOne = handledCPCount + 1;
                if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1('overflow');
                delta += (m - n) * handledCPCountPlusOne;
                n = m;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var _currentValue = _step3.value;
                        if (_currentValue < n && ++delta > maxInt) error$1('overflow');
                        if (_currentValue == n) {
                            var q = delta;
                            for(var k = base;; k += base){
                                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                if (q < t) break;
                                var qMinusT = q - t;
                                var baseMinusT = base - t;
                                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                q = floor(qMinusT / baseMinusT);
                            }
                            output.push(stringFromCharCode(digitToBasic(q, 0)));
                            bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                            delta = 0;
                            ++handledCPCount;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                    } finally{
                        if (_didIteratorError3) throw _iteratorError3;
                    }
                }
                ++delta;
                ++n;
            }
            return output.join('');
        };
        var toUnicode = function toUnicode(input) {
            return mapDomain(input, function(string) {
                return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
            });
        };
        var toASCII = function toASCII(input) {
            return mapDomain(input, function(string) {
                return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
            });
        };
        var punycode = {
            'version': '2.1.0',
            'ucs2': {
                'decode': ucs2decode,
                'encode': ucs2encode
            },
            'decode': decode,
            'encode': encode,
            'toASCII': toASCII,
            'toUnicode': toUnicode
        };
        var SCHEMES = {};
        function pctEncChar(chr) {
            var c = chr.charCodeAt(0);
            var e = void 0;
            if (c < 16) e = "%0" + c.toString(16).toUpperCase();
            else if (c < 128) e = "%" + c.toString(16).toUpperCase();
            else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
            else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
            return e;
        }
        function pctDecChars(str) {
            var newStr = "";
            var i = 0;
            var il = str.length;
            while(i < il){
                var c = parseInt(str.substr(i + 1, 2), 16);
                if (c < 128) {
                    newStr += String.fromCharCode(c);
                    i += 3;
                } else if (c >= 194 && c < 224) {
                    if (il - i >= 6) {
                        var c2 = parseInt(str.substr(i + 4, 2), 16);
                        newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                    } else newStr += str.substr(i, 6);
                    i += 6;
                } else if (c >= 224) {
                    if (il - i >= 9) {
                        var _c = parseInt(str.substr(i + 4, 2), 16);
                        var c3 = parseInt(str.substr(i + 7, 2), 16);
                        newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                    } else newStr += str.substr(i, 9);
                    i += 9;
                } else {
                    newStr += str.substr(i, 3);
                    i += 3;
                }
            }
            return newStr;
        }
        function _normalizeComponentEncoding(components, protocol) {
            function decodeUnreserved(str) {
                var decStr = pctDecChars(str);
                return !decStr.match(protocol.UNRESERVED) ? str : decStr;
            }
            if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
            if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
            if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
            if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
            if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
            if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
            return components;
        }
        function _stripLeadingZeros(str) {
            return str.replace(/^0*(.*)/, "$1") || "0";
        }
        function _normalizeIPv4(host, protocol) {
            var matches = host.match(protocol.IPV4ADDRESS) || [];
            var _matches = slicedToArray(matches, 2), address = _matches[1];
            if (address) return address.split(".").map(_stripLeadingZeros).join(".");
            else return host;
        }
        function _normalizeIPv6(host, protocol) {
            var matches = host.match(protocol.IPV6ADDRESS) || [];
            var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
            if (address) {
                var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
                var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
                var lastFields = last.split(":").map(_stripLeadingZeros);
                var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
                var fieldCount = isLastFieldIPv4Address ? 7 : 8;
                var lastFieldsStart = lastFields.length - fieldCount;
                var fields = Array(fieldCount);
                for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
                if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
                var allZeroFields = fields.reduce(function(acc, field, index) {
                    if (!field || field === "0") {
                        var lastLongest = acc[acc.length - 1];
                        if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                        else acc.push({
                            index: index,
                            length: 1
                        });
                    }
                    return acc;
                }, []);
                var longestZeroFields = allZeroFields.sort(function(a, b) {
                    return b.length - a.length;
                })[0];
                var newHost = void 0;
                if (longestZeroFields && longestZeroFields.length > 1) {
                    var newFirst = fields.slice(0, longestZeroFields.index);
                    var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                    newHost = newFirst.join(":") + "::" + newLast.join(":");
                } else newHost = fields.join(":");
                if (zone) newHost += "%" + zone;
                return newHost;
            } else return host;
        }
        var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
        var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
        function parse(uriString) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var components = {};
            var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
            if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
            var matches = uriString.match(URI_PARSE);
            if (matches) {
                if (NO_MATCH_IS_UNDEFINED) {
                    components.scheme = matches[1];
                    components.userinfo = matches[3];
                    components.host = matches[4];
                    components.port = parseInt(matches[5], 10);
                    components.path = matches[6] || "";
                    components.query = matches[7];
                    components.fragment = matches[8];
                    if (isNaN(components.port)) components.port = matches[5];
                } else {
                    components.scheme = matches[1] || undefined;
                    components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                    components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                    components.port = parseInt(matches[5], 10);
                    components.path = matches[6] || "";
                    components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                    components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                    if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
                }
                if (components.host) components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
                if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
                else if (components.scheme === undefined) components.reference = "relative";
                else if (components.fragment === undefined) components.reference = "absolute";
                else components.reference = "uri";
                if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
                var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
                if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                    if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) try {
                        components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                    } catch (e) {
                        components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                    }
                    _normalizeComponentEncoding(components, URI_PROTOCOL);
                } else _normalizeComponentEncoding(components, protocol);
                if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
            } else components.error = components.error || "URI can not be parsed.";
            return components;
        }
        function _recomposeAuthority(components, options) {
            var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
            var uriTokens = [];
            if (components.userinfo !== undefined) {
                uriTokens.push(components.userinfo);
                uriTokens.push("@");
            }
            if (components.host !== undefined) uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
                return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
            }));
            if (typeof components.port === "number") {
                uriTokens.push(":");
                uriTokens.push(components.port.toString(10));
            }
            return uriTokens.length ? uriTokens.join("") : undefined;
        }
        var RDS1 = /^\.\.?\//;
        var RDS2 = /^\/\.(\/|$)/;
        var RDS3 = /^\/\.\.(\/|$)/;
        var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
        function removeDotSegments(input) {
            var output = [];
            while(input.length){
                if (input.match(RDS1)) input = input.replace(RDS1, "");
                else if (input.match(RDS2)) input = input.replace(RDS2, "/");
                else if (input.match(RDS3)) {
                    input = input.replace(RDS3, "/");
                    output.pop();
                } else if (input === "." || input === "..") input = "";
                else {
                    var im = input.match(RDS5);
                    if (im) {
                        var s = im[0];
                        input = input.slice(s.length);
                        output.push(s);
                    } else throw new Error("Unexpected dot segment condition");
                }
            }
            return output.join("");
        }
        function serialize(components) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
            var uriTokens = [];
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
            if (components.host) {
                if (protocol.IPV6ADDRESS.test(components.host)) ;
                else if (options.domainHost || schemeHandler && schemeHandler.domainHost) try {
                    components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
            }
            _normalizeComponentEncoding(components, protocol);
            if (options.reference !== "suffix" && components.scheme) {
                uriTokens.push(components.scheme);
                uriTokens.push(":");
            }
            var authority = _recomposeAuthority(components, options);
            if (authority !== undefined) {
                if (options.reference !== "suffix") uriTokens.push("//");
                uriTokens.push(authority);
                if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
            }
            if (components.path !== undefined) {
                var s = components.path;
                if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
                if (authority === undefined) s = s.replace(/^\/\//, "/%2F");
                uriTokens.push(s);
            }
            if (components.query !== undefined) {
                uriTokens.push("?");
                uriTokens.push(components.query);
            }
            if (components.fragment !== undefined) {
                uriTokens.push("#");
                uriTokens.push(components.fragment);
            }
            return uriTokens.join("");
        }
        function resolveComponents(base, relative) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var skipNormalization = arguments[3];
            var target = {};
            if (!skipNormalization) {
                base = parse(serialize(base, options), options);
                relative = parse(serialize(relative, options), options);
            }
            options = options || {};
            if (!options.tolerant && relative.scheme) {
                target.scheme = relative.scheme;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                    target.userinfo = relative.userinfo;
                    target.host = relative.host;
                    target.port = relative.port;
                    target.path = removeDotSegments(relative.path || "");
                    target.query = relative.query;
                } else {
                    if (!relative.path) {
                        target.path = base.path;
                        if (relative.query !== undefined) target.query = relative.query;
                        else target.query = base.query;
                    } else {
                        if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                        else {
                            if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                            else if (!base.path) target.path = relative.path;
                            else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                            target.path = removeDotSegments(target.path);
                        }
                        target.query = relative.query;
                    }
                    target.userinfo = base.userinfo;
                    target.host = base.host;
                    target.port = base.port;
                }
                target.scheme = base.scheme;
            }
            target.fragment = relative.fragment;
            return target;
        }
        function resolve(baseURI, relativeURI, options) {
            var schemelessOptions = assign({
                scheme: 'null'
            }, options);
            return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
        }
        function normalize(uri, options) {
            if (typeof uri === "string") uri = serialize(parse(uri, options), options);
            else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
            return uri;
        }
        function equal(uriA, uriB, options) {
            if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
            else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
            if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
            else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
            return uriA === uriB;
        }
        function escapeComponent(str, options) {
            return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
        }
        function unescapeComponent(str, options) {
            return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
        }
        var handler = {
            scheme: "http",
            domainHost: true,
            parse: function parse(components, options) {
                if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
                return components;
            },
            serialize: function serialize(components, options) {
                if (components.port === (String(components.scheme).toLowerCase() !== "https" ? 80 : 443) || components.port === "") components.port = undefined;
                if (!components.path) components.path = "/";
                return components;
            }
        };
        var handler$1 = {
            scheme: "https",
            domainHost: handler.domainHost,
            parse: handler.parse,
            serialize: handler.serialize
        };
        var O = {};
        var isIRI = true;
        var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
        var HEXDIG$$ = "[0-9A-Fa-f]";
        var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$));
        var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
        var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
        var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
        var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
        var UNRESERVED = new RegExp(UNRESERVED$$, "g");
        var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
        var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
        var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
        var NOT_HFVALUE = NOT_HFNAME;
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(UNRESERVED) ? str : decStr;
        }
        var handler$2 = {
            scheme: "mailto",
            parse: function parse$$1(components, options) {
                var mailtoComponents = components;
                var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
                mailtoComponents.path = undefined;
                if (mailtoComponents.query) {
                    var unknownHeaders = false;
                    var headers = {};
                    var hfields = mailtoComponents.query.split("&");
                    for(var x = 0, xl = hfields.length; x < xl; ++x){
                        var hfield = hfields[x].split("=");
                        switch(hfield[0]){
                            case "to":
                                var toAddrs = hfield[1].split(",");
                                for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                                break;
                            case "subject":
                                mailtoComponents.subject = unescapeComponent(hfield[1], options);
                                break;
                            case "body":
                                mailtoComponents.body = unescapeComponent(hfield[1], options);
                                break;
                            default:
                                unknownHeaders = true;
                                headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                                break;
                        }
                    }
                    if (unknownHeaders) mailtoComponents.headers = headers;
                }
                mailtoComponents.query = undefined;
                for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                    var addr = to[_x2].split("@");
                    addr[0] = unescapeComponent(addr[0]);
                    if (!options.unicodeSupport) try {
                        addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                    } catch (e) {
                        mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                    }
                    else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                    to[_x2] = addr.join("@");
                }
                return mailtoComponents;
            },
            serialize: function serialize$$1(mailtoComponents, options) {
                var components = mailtoComponents;
                var to = toArray(mailtoComponents.to);
                if (to) {
                    for(var x = 0, xl = to.length; x < xl; ++x){
                        var toAddr = String(to[x]);
                        var atIdx = toAddr.lastIndexOf("@");
                        var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                        var domain = toAddr.slice(atIdx + 1);
                        try {
                            domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                        } catch (e) {
                            components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                        }
                        to[x] = localPart + "@" + domain;
                    }
                    components.path = to.join(",");
                }
                var headers = mailtoComponents.headers = mailtoComponents.headers || {};
                if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
                if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
                var fields = [];
                for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
                if (fields.length) components.query = fields.join("&");
                return components;
            }
        };
        var URN_PARSE = /^([^\:]+)\:(.*)/;
        var handler$3 = {
            scheme: "urn",
            parse: function parse$$1(components, options) {
                var matches = components.path && components.path.match(URN_PARSE);
                var urnComponents = components;
                if (matches) {
                    var scheme = options.scheme || urnComponents.scheme || "urn";
                    var nid = matches[1].toLowerCase();
                    var nss = matches[2];
                    var urnScheme = scheme + ":" + (options.nid || nid);
                    var schemeHandler = SCHEMES[urnScheme];
                    urnComponents.nid = nid;
                    urnComponents.nss = nss;
                    urnComponents.path = undefined;
                    if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
                } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
                return urnComponents;
            },
            serialize: function serialize$$1(urnComponents, options) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = urnComponents.nid;
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
                var uriComponents = urnComponents;
                var nss = urnComponents.nss;
                uriComponents.path = (nid || options.nid) + ":" + nss;
                return uriComponents;
            }
        };
        var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
        var handler$4 = {
            scheme: "urn:uuid",
            parse: function parse(urnComponents, options) {
                var uuidComponents = urnComponents;
                uuidComponents.uuid = uuidComponents.nss;
                uuidComponents.nss = undefined;
                if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
                return uuidComponents;
            },
            serialize: function serialize(uuidComponents, options) {
                var urnComponents = uuidComponents;
                urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
                return urnComponents;
            }
        };
        SCHEMES[handler.scheme] = handler;
        SCHEMES[handler$1.scheme] = handler$1;
        SCHEMES[handler$2.scheme] = handler$2;
        SCHEMES[handler$3.scheme] = handler$3;
        SCHEMES[handler$4.scheme] = handler$4;
        exports1.SCHEMES = SCHEMES;
        exports1.pctEncChar = pctEncChar;
        exports1.pctDecChars = pctDecChars;
        exports1.parse = parse;
        exports1.removeDotSegments = removeDotSegments;
        exports1.serialize = serialize;
        exports1.resolveComponents = resolveComponents;
        exports1.resolve = resolve;
        exports1.normalize = normalize;
        exports1.equal = equal;
        exports1.escapeComponent = escapeComponent;
        exports1.unescapeComponent = unescapeComponent;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    });
});
parcelRegister("1SBaA", function(module, exports) {
    'use strict';
    module.exports = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        return a !== a && b !== b;
    };
});
parcelRegister("dkv5E", function(module, exports) {
    'use strict';
    module.exports = {
        copy: $9b45427d091d9eb6$var$copy,
        checkDataType: $9b45427d091d9eb6$var$checkDataType,
        checkDataTypes: $9b45427d091d9eb6$var$checkDataTypes,
        coerceToTypes: $9b45427d091d9eb6$var$coerceToTypes,
        toHash: $9b45427d091d9eb6$var$toHash,
        getProperty: $9b45427d091d9eb6$var$getProperty,
        escapeQuotes: $9b45427d091d9eb6$var$escapeQuotes,
        equal: (parcelRequire("1SBaA")),
        ucs2length: (parcelRequire("h0gMf")),
        varOccurences: $9b45427d091d9eb6$var$varOccurences,
        varReplace: $9b45427d091d9eb6$var$varReplace,
        schemaHasRules: $9b45427d091d9eb6$var$schemaHasRules,
        schemaHasRulesExcept: $9b45427d091d9eb6$var$schemaHasRulesExcept,
        schemaUnknownRules: $9b45427d091d9eb6$var$schemaUnknownRules,
        toQuotedString: $9b45427d091d9eb6$var$toQuotedString,
        getPathExpr: $9b45427d091d9eb6$var$getPathExpr,
        getPath: $9b45427d091d9eb6$var$getPath,
        getData: $9b45427d091d9eb6$var$getData,
        unescapeFragment: $9b45427d091d9eb6$var$unescapeFragment,
        unescapeJsonPointer: $9b45427d091d9eb6$var$unescapeJsonPointer,
        escapeFragment: $9b45427d091d9eb6$var$escapeFragment,
        escapeJsonPointer: $9b45427d091d9eb6$var$escapeJsonPointer
    };
    function $9b45427d091d9eb6$var$copy(o, to) {
        to = to || {};
        for(var key in o)to[key] = o[key];
        return to;
    }
    function $9b45427d091d9eb6$var$checkDataType(dataType, data, strictNumbers, negate) {
        var EQUAL = negate ? ' !== ' : ' === ', AND = negate ? ' || ' : ' && ', OK = negate ? '!' : '', NOT = negate ? '' : '!';
        switch(dataType){
            case 'null':
                return data + EQUAL + 'null';
            case 'array':
                return OK + 'Array.isArray(' + data + ')';
            case 'object':
                return '(' + OK + data + AND + 'typeof ' + data + EQUAL + '"object"' + AND + NOT + 'Array.isArray(' + data + '))';
            case 'integer':
                return '(typeof ' + data + EQUAL + '"number"' + AND + NOT + '(' + data + ' % 1)' + AND + data + EQUAL + data + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
            case 'number':
                return '(typeof ' + data + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
            default:
                return 'typeof ' + data + EQUAL + '"' + dataType + '"';
        }
    }
    function $9b45427d091d9eb6$var$checkDataTypes(dataTypes, data, strictNumbers) {
        switch(dataTypes.length){
            case 1:
                return $9b45427d091d9eb6$var$checkDataType(dataTypes[0], data, strictNumbers, true);
            default:
                var code = '';
                var types = $9b45427d091d9eb6$var$toHash(dataTypes);
                if (types.array && types.object) {
                    code = types.null ? '(' : '(!' + data + ' || ';
                    code += 'typeof ' + data + ' !== "object")';
                    delete types.null;
                    delete types.array;
                    delete types.object;
                }
                if (types.number) delete types.integer;
                for(var t in types)code += (code ? ' && ' : '') + $9b45427d091d9eb6$var$checkDataType(t, data, strictNumbers, true);
                return code;
        }
    }
    var $9b45427d091d9eb6$var$COERCE_TO_TYPES = $9b45427d091d9eb6$var$toHash([
        'string',
        'number',
        'integer',
        'boolean',
        'null'
    ]);
    function $9b45427d091d9eb6$var$coerceToTypes(optionCoerceTypes, dataTypes) {
        if (Array.isArray(dataTypes)) {
            var types = [];
            for(var i = 0; i < dataTypes.length; i++){
                var t = dataTypes[i];
                if ($9b45427d091d9eb6$var$COERCE_TO_TYPES[t]) types[types.length] = t;
                else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
            }
            if (types.length) return types;
        } else if ($9b45427d091d9eb6$var$COERCE_TO_TYPES[dataTypes]) return [
            dataTypes
        ];
        else if (optionCoerceTypes === 'array' && dataTypes === 'array') return [
            'array'
        ];
    }
    function $9b45427d091d9eb6$var$toHash(arr) {
        var hash = {};
        for(var i = 0; i < arr.length; i++)hash[arr[i]] = true;
        return hash;
    }
    var $9b45427d091d9eb6$var$IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
    var $9b45427d091d9eb6$var$SINGLE_QUOTE = /'|\\/g;
    function $9b45427d091d9eb6$var$getProperty(key) {
        return typeof key == 'number' ? '[' + key + ']' : $9b45427d091d9eb6$var$IDENTIFIER.test(key) ? '.' + key : "['" + $9b45427d091d9eb6$var$escapeQuotes(key) + "']";
    }
    function $9b45427d091d9eb6$var$escapeQuotes(str) {
        return str.replace($9b45427d091d9eb6$var$SINGLE_QUOTE, '\\$&').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\f/g, '\\f').replace(/\t/g, '\\t');
    }
    function $9b45427d091d9eb6$var$varOccurences(str, dataVar) {
        dataVar += '[^0-9]';
        var matches = str.match(new RegExp(dataVar, 'g'));
        return matches ? matches.length : 0;
    }
    function $9b45427d091d9eb6$var$varReplace(str, dataVar, expr) {
        dataVar += '([^0-9])';
        expr = expr.replace(/\$/g, '$$$$');
        return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
    }
    function $9b45427d091d9eb6$var$schemaHasRules(schema, rules) {
        if (typeof schema == 'boolean') return !schema;
        for(var key in schema)if (rules[key]) return true;
    }
    function $9b45427d091d9eb6$var$schemaHasRulesExcept(schema, rules, exceptKeyword) {
        if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
        for(var key in schema)if (key != exceptKeyword && rules[key]) return true;
    }
    function $9b45427d091d9eb6$var$schemaUnknownRules(schema, rules) {
        if (typeof schema == 'boolean') return;
        for(var key in schema)if (!rules[key]) return key;
    }
    function $9b45427d091d9eb6$var$toQuotedString(str) {
        return '\'' + $9b45427d091d9eb6$var$escapeQuotes(str) + '\'';
    }
    function $9b45427d091d9eb6$var$getPathExpr(currentPath, expr, jsonPointers, isNumber) {
        var path = jsonPointers ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')') : isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'';
        return $9b45427d091d9eb6$var$joinPaths(currentPath, path);
    }
    function $9b45427d091d9eb6$var$getPath(currentPath, prop, jsonPointers) {
        var path = jsonPointers ? $9b45427d091d9eb6$var$toQuotedString('/' + $9b45427d091d9eb6$var$escapeJsonPointer(prop)) : $9b45427d091d9eb6$var$toQuotedString($9b45427d091d9eb6$var$getProperty(prop));
        return $9b45427d091d9eb6$var$joinPaths(currentPath, path);
    }
    var $9b45427d091d9eb6$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
    var $9b45427d091d9eb6$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
    function $9b45427d091d9eb6$var$getData($data, lvl, paths) {
        var up, jsonPointer, data, matches;
        if ($data === '') return 'rootData';
        if ($data[0] == '/') {
            if (!$9b45427d091d9eb6$var$JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
            jsonPointer = $data;
            data = 'rootData';
        } else {
            matches = $data.match($9b45427d091d9eb6$var$RELATIVE_JSON_POINTER);
            if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
            up = +matches[1];
            jsonPointer = matches[2];
            if (jsonPointer == '#') {
                if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
                return paths[lvl - up];
            }
            if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
            data = 'data' + (lvl - up || '');
            if (!jsonPointer) return data;
        }
        var expr = data;
        var segments = jsonPointer.split('/');
        for(var i = 0; i < segments.length; i++){
            var segment = segments[i];
            if (segment) {
                data += $9b45427d091d9eb6$var$getProperty($9b45427d091d9eb6$var$unescapeJsonPointer(segment));
                expr += ' && ' + data;
            }
        }
        return expr;
    }
    function $9b45427d091d9eb6$var$joinPaths(a, b) {
        if (a == '""') return b;
        return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
    }
    function $9b45427d091d9eb6$var$unescapeFragment(str) {
        return $9b45427d091d9eb6$var$unescapeJsonPointer(decodeURIComponent(str));
    }
    function $9b45427d091d9eb6$var$escapeFragment(str) {
        return encodeURIComponent($9b45427d091d9eb6$var$escapeJsonPointer(str));
    }
    function $9b45427d091d9eb6$var$escapeJsonPointer(str) {
        return str.replace(/~/g, '~0').replace(/\//g, '~1');
    }
    function $9b45427d091d9eb6$var$unescapeJsonPointer(str) {
        return str.replace(/~1/g, '/').replace(/~0/g, '~');
    }
});
parcelRegister("h0gMf", function(module, exports) {
    'use strict';
    module.exports = function ucs2length(str) {
        var length = 0, len = str.length, pos = 0, value;
        while(pos < len){
            length++;
            value = str.charCodeAt(pos++);
            if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
                value = str.charCodeAt(pos);
                if ((value & 0xFC00) == 0xDC00) pos++;
            }
        }
        return length;
    };
});
parcelRegister("6DxU7", function(module, exports) {
    'use strict';
    var $dkv5E = parcelRequire("dkv5E");
    module.exports = $4d50af3fe3bdabf5$var$SchemaObject;
    function $4d50af3fe3bdabf5$var$SchemaObject(obj) {
        $dkv5E.copy(obj, this);
    }
});
parcelRegister("9O5cx", function(module, exports) {
    'use strict';
    var $723cd16ff2f707ae$var$traverse = module.exports = function(schema, opts, cb) {
        if (typeof opts == 'function') {
            cb = opts;
            opts = {};
        }
        cb = opts.cb || cb;
        var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
        var post = cb.post || function() {};
        $723cd16ff2f707ae$var$_traverse(opts, pre, post, schema, '', schema);
    };
    $723cd16ff2f707ae$var$traverse.keywords = {
        additionalItems: true,
        items: true,
        contains: true,
        additionalProperties: true,
        propertyNames: true,
        not: true
    };
    $723cd16ff2f707ae$var$traverse.arrayKeywords = {
        items: true,
        allOf: true,
        anyOf: true,
        oneOf: true
    };
    $723cd16ff2f707ae$var$traverse.propsKeywords = {
        definitions: true,
        properties: true,
        patternProperties: true,
        dependencies: true
    };
    $723cd16ff2f707ae$var$traverse.skipKeywords = {
        default: true,
        enum: true,
        const: true,
        required: true,
        maximum: true,
        minimum: true,
        exclusiveMaximum: true,
        exclusiveMinimum: true,
        multipleOf: true,
        maxLength: true,
        minLength: true,
        pattern: true,
        format: true,
        maxItems: true,
        minItems: true,
        uniqueItems: true,
        maxProperties: true,
        minProperties: true
    };
    function $723cd16ff2f707ae$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
            pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
            for(var key in schema){
                var sch = schema[key];
                if (Array.isArray(sch)) {
                    if (key in $723cd16ff2f707ae$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$723cd16ff2f707ae$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
                } else if (key in $723cd16ff2f707ae$var$traverse.propsKeywords) {
                    if (sch && typeof sch == 'object') for(var prop in sch)$723cd16ff2f707ae$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $723cd16ff2f707ae$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
                } else if (key in $723cd16ff2f707ae$var$traverse.keywords || opts.allKeys && !(key in $723cd16ff2f707ae$var$traverse.skipKeywords)) $723cd16ff2f707ae$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
            }
            post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        }
    }
    function $723cd16ff2f707ae$var$escapeJsonPtr(str) {
        return str.replace(/~/g, '~0').replace(/\//g, '~1');
    }
});
parcelRegister("go5fO", function(module, exports) {
    'use strict';
    var $1j7as = parcelRequire("1j7as");
    module.exports = {
        Validation: $bee2f6994478167f$var$errorSubclass($bee2f6994478167f$var$ValidationError),
        MissingRef: $bee2f6994478167f$var$errorSubclass($bee2f6994478167f$var$MissingRefError)
    };
    function $bee2f6994478167f$var$ValidationError(errors) {
        this.message = 'validation failed';
        this.errors = errors;
        this.ajv = this.validation = true;
    }
    $bee2f6994478167f$var$MissingRefError.message = function(baseId, ref) {
        return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
    };
    function $bee2f6994478167f$var$MissingRefError(baseId, ref, message) {
        this.message = message || $bee2f6994478167f$var$MissingRefError.message(baseId, ref);
        this.missingRef = $1j7as.url(baseId, ref);
        this.missingSchema = $1j7as.normalizeId($1j7as.fullPath(this.missingRef));
    }
    function $bee2f6994478167f$var$errorSubclass(Subclass) {
        Subclass.prototype = Object.create(Error.prototype);
        Subclass.prototype.constructor = Subclass;
        return Subclass;
    }
});
parcelRegister("dNYSY", function(module, exports) {
    'use strict';
    module.exports = function generate_validate(it, $keyword, $ruleType) {
        var out = '';
        var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'), $id = it.self._getId(it.schema);
        if (it.opts.strictKeywords) {
            var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
            if ($unknownKwd) {
                var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
                if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
                else throw new Error($keywordsMsg);
            }
        }
        if (it.isTop) {
            out += ' var validate = ';
            if ($async) {
                it.async = true;
                out += 'async ';
            }
            out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
            if ($id && (it.opts.sourceCode || it.opts.processCode)) out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
        }
        if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
            var $keyword = 'false schema';
            var $lvl = it.level;
            var $dataLvl = it.dataLevel;
            var $schema = it.schema[$keyword];
            var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
            var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
            var $breakOnError = !it.opts.allErrors;
            var $errorKeyword;
            var $data = 'data' + ($dataLvl || '');
            var $valid = 'valid' + $lvl;
            if (it.schema === false) {
                if (it.isTop) $breakOnError = true;
                else out += ' var ' + $valid + ' = false; ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = '';
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                    if (it.opts.messages !== false) out += ' , message: \'boolean schema is false\' ';
                    if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            } else if (it.isTop) {
                if ($async) out += ' return data; ';
                else out += ' validate.errors = null; return true; ';
            } else out += ' var ' + $valid + ' = true; ';
            if (it.isTop) out += ' }; return validate; ';
            return out;
        }
        if (it.isTop) {
            var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = 'data';
            it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
            it.baseId = it.baseId || it.rootId;
            delete it.isTop;
            it.dataPathArr = [
                ""
            ];
            if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
                var $defaultMsg = 'default is ignored in the schema root';
                if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                else throw new Error($defaultMsg);
            }
            out += ' var vErrors = null; ';
            out += ' var errors = 0;     ';
            out += ' if (rootData === undefined) rootData = data; ';
        } else {
            var $lvl = it.level, $dataLvl = it.dataLevel, $data = 'data' + ($dataLvl || '');
            if ($id) it.baseId = it.resolve.url(it.baseId, $id);
            if ($async && !it.async) throw new Error('async schema in sync schema');
            out += ' var errs_' + $lvl + ' = errors;';
        }
        var $valid = 'valid' + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = '', $closingBraces2 = '';
        var $errorKeyword;
        var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
        if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
            if ($typeIsArray) {
                if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
            } else if ($typeSchema != 'null') {
                $typeSchema = [
                    $typeSchema,
                    'null'
                ];
                $typeIsArray = true;
            }
        }
        if ($typeIsArray && $typeSchema.length == 1) {
            $typeSchema = $typeSchema[0];
            $typeIsArray = false;
        }
        if (it.schema.$ref && $refKeywords) {
            if (it.opts.extendRefs == 'fail') throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
            else if (it.opts.extendRefs !== true) {
                $refKeywords = false;
                it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
            }
        }
        if (it.schema.$comment && it.opts.$comment) out += ' ' + it.RULES.all.$comment.code(it, '$comment');
        if ($typeSchema) {
            if (it.opts.coerceTypes) var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
            var $rulesGroup = it.RULES.types[$typeSchema];
            if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
                var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
                var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type', $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
                out += ' if (' + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ') { ';
                if ($coerceToTypes) {
                    var $dataType = 'dataType' + $lvl, $coerced = 'coerced' + $lvl;
                    out += ' var ' + $dataType + ' = typeof ' + $data + '; var ' + $coerced + ' = undefined; ';
                    if (it.opts.coerceTypes == 'array') out += ' if (' + $dataType + ' == \'object\' && Array.isArray(' + $data + ') && ' + $data + '.length == 1) { ' + $data + ' = ' + $data + '[0]; ' + $dataType + ' = typeof ' + $data + '; if (' + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ') ' + $coerced + ' = ' + $data + '; } ';
                    out += ' if (' + $coerced + ' !== undefined) ; ';
                    var arr1 = $coerceToTypes;
                    if (arr1) {
                        var $type, $i = -1, l1 = arr1.length - 1;
                        while($i < l1){
                            $type = arr1[$i += 1];
                            if ($type == 'string') out += ' else if (' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\') ' + $coerced + ' = \'\' + ' + $data + '; else if (' + $data + ' === null) ' + $coerced + ' = \'\'; ';
                            else if ($type == 'number' || $type == 'integer') {
                                out += ' else if (' + $dataType + ' == \'boolean\' || ' + $data + ' === null || (' + $dataType + ' == \'string\' && ' + $data + ' && ' + $data + ' == +' + $data + ' ';
                                if ($type == 'integer') out += ' && !(' + $data + ' % 1)';
                                out += ')) ' + $coerced + ' = +' + $data + '; ';
                            } else if ($type == 'boolean') out += ' else if (' + $data + ' === \'false\' || ' + $data + ' === 0 || ' + $data + ' === null) ' + $coerced + ' = false; else if (' + $data + ' === \'true\' || ' + $data + ' === 1) ' + $coerced + ' = true; ';
                            else if ($type == 'null') out += ' else if (' + $data + ' === \'\' || ' + $data + ' === 0 || ' + $data + ' === false) ' + $coerced + ' = null; ';
                            else if (it.opts.coerceTypes == 'array' && $type == 'array') out += ' else if (' + $dataType + ' == \'string\' || ' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\' || ' + $data + ' == null) ' + $coerced + ' = [' + $data + ']; ';
                        }
                    }
                    out += ' else {   ';
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'should be ';
                            if ($typeIsArray) out += '' + $typeSchema.join(",");
                            else out += '' + $typeSchema;
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    out += ' } if (' + $coerced + ' !== undefined) {  ';
                    var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
                    out += ' ' + $data + ' = ' + $coerced + '; ';
                    if (!$dataLvl) out += 'if (' + $parentData + ' !== undefined)';
                    out += ' ' + $parentData + '[' + $parentDataProperty + '] = ' + $coerced + '; } ';
                } else {
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'should be ';
                            if ($typeIsArray) out += '' + $typeSchema.join(",");
                            else out += '' + $typeSchema;
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                }
                out += ' } ';
            }
        }
        if (it.schema.$ref && !$refKeywords) {
            out += ' ' + it.RULES.all.$ref.code(it, '$ref') + ' ';
            if ($breakOnError) {
                out += ' } if (errors === ';
                if ($top) out += '0';
                else out += 'errs_' + $lvl;
                out += ') { ';
                $closingBraces2 += '}';
            }
        } else {
            var arr2 = it.RULES;
            if (arr2) {
                var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
                while(i2 < l2){
                    $rulesGroup = arr2[i2 += 1];
                    if ($shouldUseGroup($rulesGroup)) {
                        if ($rulesGroup.type) out += ' if (' + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ') { ';
                        if (it.opts.useDefaults) {
                            if ($rulesGroup.type == 'object' && it.schema.properties) {
                                var $schema = it.schema.properties, $schemaKeys = Object.keys($schema);
                                var arr3 = $schemaKeys;
                                if (arr3) {
                                    var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                                    while(i3 < l3){
                                        $propertyKey = arr3[i3 += 1];
                                        var $sch = $schema[$propertyKey];
                                        if ($sch.default !== undefined) {
                                            var $passData = $data + it.util.getProperty($propertyKey);
                                            if (it.compositeRule) {
                                                if (it.opts.strictDefaults) {
                                                    var $defaultMsg = 'default is ignored for: ' + $passData;
                                                    if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                    else throw new Error($defaultMsg);
                                                }
                                            } else {
                                                out += ' if (' + $passData + ' === undefined ';
                                                if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                                out += ' ) ' + $passData + ' = ';
                                                if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                                else out += ' ' + JSON.stringify($sch.default) + ' ';
                                                out += '; ';
                                            }
                                        }
                                    }
                                }
                            } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
                                var arr4 = it.schema.items;
                                if (arr4) {
                                    var $sch, $i = -1, l4 = arr4.length - 1;
                                    while($i < l4){
                                        $sch = arr4[$i += 1];
                                        if ($sch.default !== undefined) {
                                            var $passData = $data + '[' + $i + ']';
                                            if (it.compositeRule) {
                                                if (it.opts.strictDefaults) {
                                                    var $defaultMsg = 'default is ignored for: ' + $passData;
                                                    if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                    else throw new Error($defaultMsg);
                                                }
                                            } else {
                                                out += ' if (' + $passData + ' === undefined ';
                                                if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                                out += ' ) ' + $passData + ' = ';
                                                if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                                else out += ' ' + JSON.stringify($sch.default) + ' ';
                                                out += '; ';
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        var arr5 = $rulesGroup.rules;
                        if (arr5) {
                            var $rule, i5 = -1, l5 = arr5.length - 1;
                            while(i5 < l5){
                                $rule = arr5[i5 += 1];
                                if ($shouldUseRule($rule)) {
                                    var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                                    if ($code) {
                                        out += ' ' + $code + ' ';
                                        if ($breakOnError) $closingBraces1 += '}';
                                    }
                                }
                            }
                        }
                        if ($breakOnError) {
                            out += ' ' + $closingBraces1 + ' ';
                            $closingBraces1 = '';
                        }
                        if ($rulesGroup.type) {
                            out += ' } ';
                            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                                out += ' else { ';
                                var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
                                var $$outStack = $$outStack || [];
                                $$outStack.push(out);
                                out = '';
                                if (it.createErrors !== false) {
                                    out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                                    else out += '' + $typeSchema;
                                    out += '\' } ';
                                    if (it.opts.messages !== false) {
                                        out += ' , message: \'should be ';
                                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                                        else out += '' + $typeSchema;
                                        out += '\' ';
                                    }
                                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                    out += ' } ';
                                } else out += ' {} ';
                                var __err = out;
                                out = $$outStack.pop();
                                if (!it.compositeRule && $breakOnError) {
                                    if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                    else out += ' validate.errors = [' + __err + ']; return false; ';
                                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                                out += ' } ';
                            }
                        }
                        if ($breakOnError) {
                            out += ' if (errors === ';
                            if ($top) out += '0';
                            else out += 'errs_' + $lvl;
                            out += ') { ';
                            $closingBraces2 += '}';
                        }
                    }
                }
            }
        }
        if ($breakOnError) out += ' ' + $closingBraces2 + ' ';
        if ($top) {
            if ($async) {
                out += ' if (errors === 0) return data;           ';
                out += ' else throw new ValidationError(vErrors); ';
            } else {
                out += ' validate.errors = vErrors; ';
                out += ' return errors === 0;       ';
            }
            out += ' }; return validate;';
        } else out += ' var ' + $valid + ' = errors === errs_' + $lvl + ';';
        function $shouldUseGroup($rulesGroup) {
            var rules = $rulesGroup.rules;
            for(var i = 0; i < rules.length; i++)if ($shouldUseRule(rules[i])) return true;
        }
        function $shouldUseRule($rule) {
            return it.schema[$rule.keyword] !== undefined || $rule.implements && $ruleImplementsSomeKeyword($rule);
        }
        function $ruleImplementsSomeKeyword($rule) {
            var impl = $rule.implements;
            for(var i = 0; i < impl.length; i++)if (it.schema[impl[i]] !== undefined) return true;
        }
        return out;
    };
});
parcelRegister("9Adha", function(module, exports) {
    'use strict';
    var $6fa1c626a66085a0$var$Cache = module.exports = function Cache() {
        this._cache = {};
    };
    $6fa1c626a66085a0$var$Cache.prototype.put = function Cache_put(key, value) {
        this._cache[key] = value;
    };
    $6fa1c626a66085a0$var$Cache.prototype.get = function Cache_get(key) {
        return this._cache[key];
    };
    $6fa1c626a66085a0$var$Cache.prototype.del = function Cache_del(key) {
        delete this._cache[key];
    };
    $6fa1c626a66085a0$var$Cache.prototype.clear = function Cache_clear() {
        this._cache = {};
    };
});
parcelRegister("2OkcI", function(module, exports) {
    'use strict';
    var $dkv5E = parcelRequire("dkv5E");
    var $20bfec624c55bc87$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    var $20bfec624c55bc87$var$DAYS = [
        0,
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $20bfec624c55bc87$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
    var $20bfec624c55bc87$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
    var $20bfec624c55bc87$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    var $20bfec624c55bc87$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    var $20bfec624c55bc87$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
    var $20bfec624c55bc87$var$URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
    var $20bfec624c55bc87$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
    var $20bfec624c55bc87$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
    var $20bfec624c55bc87$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
    var $20bfec624c55bc87$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
    module.exports = $20bfec624c55bc87$var$formats;
    function $20bfec624c55bc87$var$formats(mode) {
        mode = mode == 'full' ? 'full' : 'fast';
        return $dkv5E.copy($20bfec624c55bc87$var$formats[mode]);
    }
    $20bfec624c55bc87$var$formats.fast = {
        date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
        time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
        'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
        uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
        'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
        'uri-template': $20bfec624c55bc87$var$URITEMPLATE,
        url: $20bfec624c55bc87$var$URL,
        email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
        hostname: $20bfec624c55bc87$var$HOSTNAME,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: $20bfec624c55bc87$var$regex,
        uuid: $20bfec624c55bc87$var$UUID,
        'json-pointer': $20bfec624c55bc87$var$JSON_POINTER,
        'json-pointer-uri-fragment': $20bfec624c55bc87$var$JSON_POINTER_URI_FRAGMENT,
        'relative-json-pointer': $20bfec624c55bc87$var$RELATIVE_JSON_POINTER
    };
    $20bfec624c55bc87$var$formats.full = {
        date: $20bfec624c55bc87$var$date,
        time: $20bfec624c55bc87$var$time,
        'date-time': $20bfec624c55bc87$var$date_time,
        uri: $20bfec624c55bc87$var$uri,
        'uri-reference': $20bfec624c55bc87$var$URIREF,
        'uri-template': $20bfec624c55bc87$var$URITEMPLATE,
        url: $20bfec624c55bc87$var$URL,
        email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
        hostname: $20bfec624c55bc87$var$HOSTNAME,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: $20bfec624c55bc87$var$regex,
        uuid: $20bfec624c55bc87$var$UUID,
        'json-pointer': $20bfec624c55bc87$var$JSON_POINTER,
        'json-pointer-uri-fragment': $20bfec624c55bc87$var$JSON_POINTER_URI_FRAGMENT,
        'relative-json-pointer': $20bfec624c55bc87$var$RELATIVE_JSON_POINTER
    };
    function $20bfec624c55bc87$var$isLeapYear(year) {
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    }
    function $20bfec624c55bc87$var$date(str) {
        var matches = str.match($20bfec624c55bc87$var$DATE);
        if (!matches) return false;
        var year = +matches[1];
        var month = +matches[2];
        var day = +matches[3];
        return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && $20bfec624c55bc87$var$isLeapYear(year) ? 29 : $20bfec624c55bc87$var$DAYS[month]);
    }
    function $20bfec624c55bc87$var$time(str, full) {
        var matches = str.match($20bfec624c55bc87$var$TIME);
        if (!matches) return false;
        var hour = matches[1];
        var minute = matches[2];
        var second = matches[3];
        var timeZone = matches[5];
        return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
    }
    var $20bfec624c55bc87$var$DATE_TIME_SEPARATOR = /t|\s/i;
    function $20bfec624c55bc87$var$date_time(str) {
        var dateTime = str.split($20bfec624c55bc87$var$DATE_TIME_SEPARATOR);
        return dateTime.length == 2 && $20bfec624c55bc87$var$date(dateTime[0]) && $20bfec624c55bc87$var$time(dateTime[1], true);
    }
    var $20bfec624c55bc87$var$NOT_URI_FRAGMENT = /\/|:/;
    function $20bfec624c55bc87$var$uri(str) {
        return $20bfec624c55bc87$var$NOT_URI_FRAGMENT.test(str) && $20bfec624c55bc87$var$URI.test(str);
    }
    var $20bfec624c55bc87$var$Z_ANCHOR = /[^\\]\\Z/;
    function $20bfec624c55bc87$var$regex(str) {
        if ($20bfec624c55bc87$var$Z_ANCHOR.test(str)) return false;
        try {
            new RegExp(str);
            return true;
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("YWKwU", function(module, exports) {
    'use strict';
    var $2vdkJ = parcelRequire("2vdkJ");
    var $dkv5E = parcelRequire("dkv5E");
    var $0b732d227a0c40b3$require$toHash = $dkv5E.toHash;
    module.exports = function rules() {
        var RULES = [
            {
                type: 'number',
                rules: [
                    {
                        'maximum': [
                            'exclusiveMaximum'
                        ]
                    },
                    {
                        'minimum': [
                            'exclusiveMinimum'
                        ]
                    },
                    'multipleOf',
                    'format'
                ]
            },
            {
                type: 'string',
                rules: [
                    'maxLength',
                    'minLength',
                    'pattern',
                    'format'
                ]
            },
            {
                type: 'array',
                rules: [
                    'maxItems',
                    'minItems',
                    'items',
                    'contains',
                    'uniqueItems'
                ]
            },
            {
                type: 'object',
                rules: [
                    'maxProperties',
                    'minProperties',
                    'required',
                    'dependencies',
                    'propertyNames',
                    {
                        'properties': [
                            'additionalProperties',
                            'patternProperties'
                        ]
                    }
                ]
            },
            {
                rules: [
                    '$ref',
                    'const',
                    'enum',
                    'not',
                    'anyOf',
                    'oneOf',
                    'allOf',
                    'if'
                ]
            }
        ];
        var ALL = [
            'type',
            '$comment'
        ];
        var KEYWORDS = [
            '$schema',
            '$id',
            'id',
            '$data',
            '$async',
            'title',
            'description',
            'default',
            'definitions',
            'examples',
            'readOnly',
            'writeOnly',
            'contentMediaType',
            'contentEncoding',
            'additionalItems',
            'then',
            'else'
        ];
        var TYPES = [
            'number',
            'integer',
            'string',
            'array',
            'object',
            'boolean',
            'null'
        ];
        RULES.all = $0b732d227a0c40b3$require$toHash(ALL);
        RULES.types = $0b732d227a0c40b3$require$toHash(TYPES);
        RULES.forEach(function(group) {
            group.rules = group.rules.map(function(keyword) {
                var implKeywords;
                if (typeof keyword == 'object') {
                    var key = Object.keys(keyword)[0];
                    implKeywords = keyword[key];
                    keyword = key;
                    implKeywords.forEach(function(k) {
                        ALL.push(k);
                        RULES.all[k] = true;
                    });
                }
                ALL.push(keyword);
                var rule = RULES.all[keyword] = {
                    keyword: keyword,
                    code: $2vdkJ[keyword],
                    implements: implKeywords
                };
                return rule;
            });
            RULES.all.$comment = {
                keyword: '$comment',
                code: $2vdkJ.$comment
            };
            if (group.type) RULES.types[group.type] = group;
        });
        RULES.keywords = $0b732d227a0c40b3$require$toHash(ALL.concat(KEYWORDS));
        RULES.custom = {};
        return RULES;
    };
});
parcelRegister("2vdkJ", function(module, exports) {
    'use strict';
    module.exports = {
        '$ref': (parcelRequire("3jxBi")),
        allOf: (parcelRequire("8atcI")),
        anyOf: (parcelRequire("a6Wfm")),
        '$comment': (parcelRequire("9C3y9")),
        const: (parcelRequire("izvHf")),
        contains: (parcelRequire("kaga8")),
        dependencies: (parcelRequire("duUIH")),
        'enum': (parcelRequire("47h3L")),
        format: (parcelRequire("gidep")),
        'if': (parcelRequire("jwwOE")),
        items: (parcelRequire("9AuuC")),
        maximum: (parcelRequire("kgZKE")),
        minimum: (parcelRequire("kgZKE")),
        maxItems: (parcelRequire("3J8oy")),
        minItems: (parcelRequire("3J8oy")),
        maxLength: (parcelRequire("6gLWr")),
        minLength: (parcelRequire("6gLWr")),
        maxProperties: (parcelRequire("lsgEb")),
        minProperties: (parcelRequire("lsgEb")),
        multipleOf: (parcelRequire("Tw8Zf")),
        not: (parcelRequire("91mPq")),
        oneOf: (parcelRequire("3NScL")),
        pattern: (parcelRequire("aPaOH")),
        properties: (parcelRequire("3BVOF")),
        propertyNames: (parcelRequire("kwLjX")),
        required: (parcelRequire("jApap")),
        uniqueItems: (parcelRequire("k0Zdf")),
        validate: (parcelRequire("dNYSY"))
    };
});
parcelRegister("3jxBi", function(module, exports) {
    'use strict';
    module.exports = function generate_ref(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $async, $refCode;
        if ($schema == '#' || $schema == '#/') {
            if (it.isRoot) {
                $async = it.async;
                $refCode = 'validate';
            } else {
                $async = it.root.schema.$async === true;
                $refCode = 'root.refVal[0]';
            }
        } else {
            var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
            if ($refVal === undefined) {
                var $message = it.MissingRefError.message(it.baseId, $schema);
                if (it.opts.missingRefs == 'fail') {
                    it.logger.error($message);
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { ref: \'' + it.util.escapeQuotes($schema) + '\' } ';
                        if (it.opts.messages !== false) out += ' , message: \'can\\\'t resolve reference ' + it.util.escapeQuotes($schema) + '\' ';
                        if (it.opts.verbose) out += ' , schema: ' + it.util.toQuotedString($schema) + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    if ($breakOnError) out += ' if (false) { ';
                } else if (it.opts.missingRefs == 'ignore') {
                    it.logger.warn($message);
                    if ($breakOnError) out += ' if (true) { ';
                } else throw new it.MissingRefError(it.baseId, $schema, $message);
            } else if ($refVal.inline) {
                var $it = it.util.copy(it);
                $it.level++;
                var $nextValid = 'valid' + $it.level;
                $it.schema = $refVal.schema;
                $it.schemaPath = '';
                $it.errSchemaPath = $schema;
                var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
                out += ' ' + $code + ' ';
                if ($breakOnError) out += ' if (' + $nextValid + ') { ';
            } else {
                $async = $refVal.$async === true || it.async && $refVal.$async !== false;
                $refCode = $refVal.code;
            }
        }
        if ($refCode) {
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            if (it.opts.passContext) out += ' ' + $refCode + '.call(this, ';
            else out += ' ' + $refCode + '( ';
            out += ' ' + $data + ', (dataPath || \'\')';
            if (it.errorPath != '""') out += ' + ' + it.errorPath;
            var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
            out += ' , ' + $parentData + ' , ' + $parentDataProperty + ', rootData)  ';
            var __callValidate = out;
            out = $$outStack.pop();
            if ($async) {
                if (!it.async) throw new Error('async schema referenced by sync schema');
                if ($breakOnError) out += ' var ' + $valid + '; ';
                out += ' try { await ' + __callValidate + '; ';
                if ($breakOnError) out += ' ' + $valid + ' = true; ';
                out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
                if ($breakOnError) out += ' ' + $valid + ' = false; ';
                out += ' } ';
                if ($breakOnError) out += ' if (' + $valid + ') { ';
            } else {
                out += ' if (!' + __callValidate + ') { if (vErrors === null) vErrors = ' + $refCode + '.errors; else vErrors = vErrors.concat(' + $refCode + '.errors); errors = vErrors.length; } ';
                if ($breakOnError) out += ' else { ';
            }
        }
        return out;
    };
});
parcelRegister("8atcI", function(module, exports) {
    'use strict';
    module.exports = function generate_allOf(it, $keyword, $ruleType) {
        var out = ' ';
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $allSchemasEmpty = false;
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + '[' + $i + ']';
                    $it.errSchemaPath = $errSchemaPath + '/' + $i;
                    out += '  ' + it.validate($it) + ' ';
                    $it.baseId = $currentBaseId;
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
        if ($breakOnError) {
            if ($allSchemasEmpty) out += ' if (true) { ';
            else out += ' ' + $closingBraces.slice(0, -1) + ' ';
        }
        return out;
    };
});
parcelRegister("a6Wfm", function(module, exports) {
    'use strict';
    module.exports = function generate_anyOf(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $noEmptySchema = $schema.every(function($sch) {
            return it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all);
        });
        if ($noEmptySchema) {
            var $currentBaseId = $it.baseId;
            out += ' var ' + $errs + ' = errors; var ' + $valid + ' = false;  ';
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            var arr1 = $schema;
            if (arr1) {
                var $sch, $i = -1, l1 = arr1.length - 1;
                while($i < l1){
                    $sch = arr1[$i += 1];
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + '[' + $i + ']';
                    $it.errSchemaPath = $errSchemaPath + '/' + $i;
                    out += '  ' + it.validate($it) + ' ';
                    $it.baseId = $currentBaseId;
                    out += ' ' + $valid + ' = ' + $valid + ' || ' + $nextValid + '; if (!' + $valid + ') { ';
                    $closingBraces += '}';
                }
            }
            it.compositeRule = $it.compositeRule = $wasComposite;
            out += ' ' + $closingBraces + ' if (!' + $valid + ') {   var err =   ';
            if (it.createErrors !== false) {
                out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'should match some schema in anyOf\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError(vErrors); ';
                else out += ' validate.errors = vErrors; return false; ';
            }
            out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
            if (it.opts.allErrors) out += ' } ';
        } else if ($breakOnError) out += ' if (true) { ';
        return out;
    };
});
parcelRegister("9C3y9", function(module, exports) {
    'use strict';
    module.exports = function generate_comment(it, $keyword, $ruleType) {
        var out = ' ';
        var $schema = it.schema[$keyword];
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $comment = it.util.toQuotedString($schema);
        if (it.opts.$comment === true) out += ' console.log(' + $comment + ');';
        else if (typeof it.opts.$comment == 'function') out += ' self._opts.$comment(' + $comment + ', ' + it.util.toQuotedString($errSchemaPath) + ', validate.root.schema);';
        return out;
    };
});
parcelRegister("izvHf", function(module, exports) {
    'use strict';
    module.exports = function generate_const(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (!$isData) out += ' var schema' + $lvl + ' = validate.schema' + $schemaPath + ';';
        out += 'var ' + $valid + ' = equal(' + $data + ', schema' + $lvl + '); if (!' + $valid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValue: schema' + $lvl + ' } ';
            if (it.opts.messages !== false) out += ' , message: \'should be equal to constant\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' }';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("kaga8", function(module, exports) {
    'use strict';
    module.exports = function generate_contains(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all);
        out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
        if ($nonEmptySchema) {
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            $it.schema = $schema;
            $it.schemaPath = $schemaPath;
            $it.errSchemaPath = $errSchemaPath;
            out += ' var ' + $nextValid + ' = false; for (var ' + $idx + ' = 0; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + '[' + $idx + ']';
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
            else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
            out += ' if (' + $nextValid + ') break; }  ';
            it.compositeRule = $it.compositeRule = $wasComposite;
            out += ' ' + $closingBraces + ' if (!' + $nextValid + ') {';
        } else out += ' if (' + $data + '.length == 0) {';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should contain a valid item\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } else { ';
        if ($nonEmptySchema) out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
        if (it.opts.allErrors) out += ' } ';
        return out;
    };
});
parcelRegister("duUIH", function(module, exports) {
    'use strict';
    module.exports = function generate_dependencies(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
        for($property in $schema){
            if ($property == '__proto__') continue;
            var $sch = $schema[$property];
            var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
            $deps[$property] = $sch;
        }
        out += 'var ' + $errs + ' = errors;';
        var $currentErrorPath = it.errorPath;
        out += 'var missing' + $lvl + ';';
        for(var $property in $propertyDeps){
            $deps = $propertyDeps[$property];
            if ($deps.length) {
                out += ' if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
                if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
                if ($breakOnError) {
                    out += ' && ( ';
                    var arr1 = $deps;
                    if (arr1) {
                        var $propertyKey, $i = -1, l1 = arr1.length - 1;
                        while($i < l1){
                            $propertyKey = arr1[$i += 1];
                            if ($i) out += ' || ';
                            var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                            out += ' ( ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                        }
                    }
                    out += ')) {  ';
                    var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                    if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'should have ';
                            if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                            else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                            out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                } else {
                    out += ' ) { ';
                    var arr2 = $deps;
                    if (arr2) {
                        var $propertyKey, i2 = -1, l2 = arr2.length - 1;
                        while(i2 < l2){
                            $propertyKey = arr2[i2 += 1];
                            var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                            out += ' if ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') {  var err =   ';
                            if (it.createErrors !== false) {
                                out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                                if (it.opts.messages !== false) {
                                    out += ' , message: \'should have ';
                                    if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                                    else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                                    out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                                }
                                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                out += ' } ';
                            } else out += ' {} ';
                            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                        }
                    }
                }
                out += ' }   ';
                if ($breakOnError) {
                    $closingBraces += '}';
                    out += ' else { ';
                }
            }
        }
        it.errorPath = $currentErrorPath;
        var $currentBaseId = $it.baseId;
        for(var $property in $schemaDeps){
            var $sch = $schemaDeps[$property];
            if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                out += ' ' + $nextValid + ' = true; if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
                if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
                out += ') { ';
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + it.util.getProperty($property);
                $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                out += ' }  ';
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        }
        if ($breakOnError) out += '   ' + $closingBraces + ' if (' + $errs + ' == errors) {';
        return out;
    };
});
parcelRegister("47h3L", function(module, exports) {
    'use strict';
    module.exports = function generate_enum(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $i = 'i' + $lvl, $vSchema = 'schema' + $lvl;
        if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + ';';
        out += 'var ' + $valid + ';';
        if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
        out += '' + $valid + ' = false;for (var ' + $i + '=0; ' + $i + '<' + $vSchema + '.length; ' + $i + '++) if (equal(' + $data + ', ' + $vSchema + '[' + $i + '])) { ' + $valid + ' = true; break; }';
        if ($isData) out += '  }  ';
        out += ' if (!' + $valid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValues: schema' + $lvl + ' } ';
            if (it.opts.messages !== false) out += ' , message: \'should be equal to one of the allowed values\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' }';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("gidep", function(module, exports) {
    'use strict';
    module.exports = function generate_format(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        if (it.opts.format === false) {
            if ($breakOnError) out += ' if (true) { ';
            return out;
        }
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
        if ($isData) {
            var $format = 'format' + $lvl, $isObject = 'isObject' + $lvl, $formatType = 'formatType' + $lvl;
            out += ' var ' + $format + ' = formats[' + $schemaValue + ']; var ' + $isObject + ' = typeof ' + $format + ' == \'object\' && !(' + $format + ' instanceof RegExp) && ' + $format + '.validate; var ' + $formatType + ' = ' + $isObject + ' && ' + $format + '.type || \'string\'; if (' + $isObject + ') { ';
            if (it.async) out += ' var async' + $lvl + ' = ' + $format + '.async; ';
            out += ' ' + $format + ' = ' + $format + '.validate; } if (  ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
            out += ' (';
            if ($unknownFormats != 'ignore') {
                out += ' (' + $schemaValue + ' && !' + $format + ' ';
                if ($allowUnknown) out += ' && self._opts.unknownFormats.indexOf(' + $schemaValue + ') == -1 ';
                out += ') || ';
            }
            out += ' (' + $format + ' && ' + $formatType + ' == \'' + $ruleType + '\' && !(typeof ' + $format + ' == \'function\' ? ';
            if (it.async) out += ' (async' + $lvl + ' ? await ' + $format + '(' + $data + ') : ' + $format + '(' + $data + ')) ';
            else out += ' ' + $format + '(' + $data + ') ';
            out += ' : ' + $format + '.test(' + $data + '))))) {';
        } else {
            var $format = it.formats[$schema];
            if (!$format) {
                if ($unknownFormats == 'ignore') {
                    it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
                    if ($breakOnError) out += ' if (true) { ';
                    return out;
                } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
                    if ($breakOnError) out += ' if (true) { ';
                    return out;
                } else throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
            }
            var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
            var $formatType = $isObject && $format.type || 'string';
            if ($isObject) {
                var $async = $format.async === true;
                $format = $format.validate;
            }
            if ($formatType != $ruleType) {
                if ($breakOnError) out += ' if (true) { ';
                return out;
            }
            if ($async) {
                if (!it.async) throw new Error('async format in sync schema');
                var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
                out += ' if (!(await ' + $formatRef + '(' + $data + '))) { ';
            } else {
                out += ' if (! ';
                var $formatRef = 'formats' + it.util.getProperty($schema);
                if ($isObject) $formatRef += '.validate';
                if (typeof $format == 'function') out += ' ' + $formatRef + '(' + $data + ') ';
                else out += ' ' + $formatRef + '.test(' + $data + ') ';
                out += ') { ';
            }
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { format:  ';
            if ($isData) out += '' + $schemaValue;
            else out += '' + it.util.toQuotedString($schema);
            out += '  } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should match format "';
                if ($isData) out += '\' + ' + $schemaValue + ' + \'';
                else out += '' + it.util.escapeQuotes($schema);
                out += '"\' ';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + it.util.toQuotedString($schema);
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("jwwOE", function(module, exports) {
    'use strict';
    module.exports = function generate_if(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $thenSch = it.schema['then'], $elseSch = it.schema['else'], $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? typeof $thenSch == 'object' && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? typeof $elseSch == 'object' && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
        if ($thenPresent || $elsePresent) {
            var $ifClause;
            $it.createErrors = false;
            $it.schema = $schema;
            $it.schemaPath = $schemaPath;
            $it.errSchemaPath = $errSchemaPath;
            out += ' var ' + $errs + ' = errors; var ' + $valid + ' = true;  ';
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            $it.createErrors = true;
            out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }  ';
            it.compositeRule = $it.compositeRule = $wasComposite;
            if ($thenPresent) {
                out += ' if (' + $nextValid + ') {  ';
                $it.schema = it.schema['then'];
                $it.schemaPath = it.schemaPath + '.then';
                $it.errSchemaPath = it.errSchemaPath + '/then';
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                out += ' ' + $valid + ' = ' + $nextValid + '; ';
                if ($thenPresent && $elsePresent) {
                    $ifClause = 'ifClause' + $lvl;
                    out += ' var ' + $ifClause + ' = \'then\'; ';
                } else $ifClause = '\'then\'';
                out += ' } ';
                if ($elsePresent) out += ' else { ';
            } else out += ' if (!' + $nextValid + ') { ';
            if ($elsePresent) {
                $it.schema = it.schema['else'];
                $it.schemaPath = it.schemaPath + '.else';
                $it.errSchemaPath = it.errSchemaPath + '/else';
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                out += ' ' + $valid + ' = ' + $nextValid + '; ';
                if ($thenPresent && $elsePresent) {
                    $ifClause = 'ifClause' + $lvl;
                    out += ' var ' + $ifClause + ' = \'else\'; ';
                } else $ifClause = '\'else\'';
                out += ' } ';
            }
            out += ' if (!' + $valid + ') {   var err =   ';
            if (it.createErrors !== false) {
                out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { failingKeyword: ' + $ifClause + ' } ';
                if (it.opts.messages !== false) out += ' , message: \'should match "\' + ' + $ifClause + ' + \'" schema\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError(vErrors); ';
                else out += ' validate.errors = vErrors; return false; ';
            }
            out += ' }   ';
            if ($breakOnError) out += ' else { ';
        } else if ($breakOnError) out += ' if (true) { ';
        return out;
    };
});
parcelRegister("9AuuC", function(module, exports) {
    'use strict';
    module.exports = function generate_items(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId;
        out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
        if (Array.isArray($schema)) {
            var $additionalItems = it.schema.additionalItems;
            if ($additionalItems === false) {
                out += ' ' + $valid + ' = ' + $data + '.length <= ' + $schema.length + '; ';
                var $currErrSchemaPath = $errSchemaPath;
                $errSchemaPath = it.errSchemaPath + '/additionalItems';
                out += '  if (!' + $valid + ') {   ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = '';
                if (it.createErrors !== false) {
                    out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schema.length + ' } ';
                    if (it.opts.messages !== false) out += ' , message: \'should NOT have more than ' + $schema.length + ' items\' ';
                    if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } ';
                $errSchemaPath = $currErrSchemaPath;
                if ($breakOnError) {
                    $closingBraces += '}';
                    out += ' else { ';
                }
            }
            var arr1 = $schema;
            if (arr1) {
                var $sch, $i = -1, l1 = arr1.length - 1;
                while($i < l1){
                    $sch = arr1[$i += 1];
                    if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                        out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $i + ') { ';
                        var $passData = $data + '[' + $i + ']';
                        $it.schema = $sch;
                        $it.schemaPath = $schemaPath + '[' + $i + ']';
                        $it.errSchemaPath = $errSchemaPath + '/' + $i;
                        $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
                        $it.dataPathArr[$dataNxt] = $i;
                        var $code = it.validate($it);
                        $it.baseId = $currentBaseId;
                        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                        out += ' }  ';
                        if ($breakOnError) {
                            out += ' if (' + $nextValid + ') { ';
                            $closingBraces += '}';
                        }
                    }
                }
            }
            if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
                $it.schema = $additionalItems;
                $it.schemaPath = it.schemaPath + '.additionalItems';
                $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
                out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $schema.length + ') {  for (var ' + $idx + ' = ' + $schema.length + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
                $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
                var $passData = $data + '[' + $idx + ']';
                $it.dataPathArr[$dataNxt] = $idx;
                var $code = it.validate($it);
                $it.baseId = $currentBaseId;
                if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                out += ' } }  ';
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        } else if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
            $it.schema = $schema;
            $it.schemaPath = $schemaPath;
            $it.errSchemaPath = $errSchemaPath;
            out += '  for (var ' + $idx + ' = ' + 0 + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + '[' + $idx + ']';
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
            else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
            if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
            out += ' }';
        }
        if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
        return out;
    };
});
parcelRegister("kgZKE", function(module, exports) {
    'use strict';
    module.exports = function generate__limit(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $isMax = $keyword == 'maximum', $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum', $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? '<' : '>', $notOp = $isMax ? '>' : '<', $errorKeyword = undefined;
        if (!($isData || typeof $schema == 'number' || $schema === undefined)) throw new Error($keyword + ' must be number');
        if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) throw new Error($exclusiveKeyword + ' must be number or boolean');
        if ($isDataExcl) {
            var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = 'exclusive' + $lvl, $exclType = 'exclType' + $lvl, $exclIsNumber = 'exclIsNumber' + $lvl, $opExpr = 'op' + $lvl, $opStr = '\' + ' + $opExpr + ' + \'';
            out += ' var schemaExcl' + $lvl + ' = ' + $schemaValueExcl + '; ';
            $schemaValueExcl = 'schemaExcl' + $lvl;
            out += ' var ' + $exclusive + '; var ' + $exclType + ' = typeof ' + $schemaValueExcl + '; if (' + $exclType + ' != \'boolean\' && ' + $exclType + ' != \'undefined\' && ' + $exclType + ' != \'number\') { ';
            var $errorKeyword = $exclusiveKeyword;
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'' + $exclusiveKeyword + ' should be boolean\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            out += ' } else if ( ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
            out += ' ' + $exclType + ' == \'number\' ? ( (' + $exclusive + ' = ' + $schemaValue + ' === undefined || ' + $schemaValueExcl + ' ' + $op + '= ' + $schemaValue + ') ? ' + $data + ' ' + $notOp + '= ' + $schemaValueExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) : ( (' + $exclusive + ' = ' + $schemaValueExcl + ' === true) ? ' + $data + ' ' + $notOp + '= ' + $schemaValue + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { var op' + $lvl + ' = ' + $exclusive + ' ? \'' + $op + '\' : \'' + $op + '=\'; ';
            if ($schema === undefined) {
                $errorKeyword = $exclusiveKeyword;
                $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                $schemaValue = $schemaValueExcl;
                $isData = $isDataExcl;
            }
        } else {
            var $exclIsNumber = typeof $schemaExcl == 'number', $opStr = $op;
            if ($exclIsNumber && $isData) {
                var $opExpr = '\'' + $opStr + '\'';
                out += ' if ( ';
                if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
                out += ' ( ' + $schemaValue + ' === undefined || ' + $schemaExcl + ' ' + $op + '= ' + $schemaValue + ' ? ' + $data + ' ' + $notOp + '= ' + $schemaExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { ';
            } else {
                if ($exclIsNumber && $schema === undefined) {
                    $exclusive = true;
                    $errorKeyword = $exclusiveKeyword;
                    $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                    $schemaValue = $schemaExcl;
                    $notOp += '=';
                } else {
                    if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
                    if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
                        $exclusive = true;
                        $errorKeyword = $exclusiveKeyword;
                        $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                        $notOp += '=';
                    } else {
                        $exclusive = false;
                        $opStr += '=';
                    }
                }
                var $opExpr = '\'' + $opStr + '\'';
                out += ' if ( ';
                if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
                out += ' ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' || ' + $data + ' !== ' + $data + ') { ';
            }
        }
        $errorKeyword = $errorKeyword || $keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { comparison: ' + $opExpr + ', limit: ' + $schemaValue + ', exclusive: ' + $exclusive + ' } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should be ' + $opStr + ' ';
                if ($isData) out += '\' + ' + $schemaValue;
                else out += '' + $schemaValue + '\'';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("3J8oy", function(module, exports) {
    'use strict';
    module.exports = function generate__limitItems(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
        var $op = $keyword == 'maxItems' ? '>' : '<';
        out += 'if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
        out += ' ' + $data + '.length ' + $op + ' ' + $schemaValue + ') { ';
        var $errorKeyword = $keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should NOT have ';
                if ($keyword == 'maxItems') out += 'more';
                else out += 'fewer';
                out += ' than ';
                if ($isData) out += '\' + ' + $schemaValue + ' + \'';
                else out += '' + $schema;
                out += ' items\' ';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += '} ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("6gLWr", function(module, exports) {
    'use strict';
    module.exports = function generate__limitLength(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
        var $op = $keyword == 'maxLength' ? '>' : '<';
        out += 'if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
        if (it.opts.unicode === false) out += ' ' + $data + '.length ';
        else out += ' ucs2length(' + $data + ') ';
        out += ' ' + $op + ' ' + $schemaValue + ') { ';
        var $errorKeyword = $keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should NOT be ';
                if ($keyword == 'maxLength') out += 'longer';
                else out += 'shorter';
                out += ' than ';
                if ($isData) out += '\' + ' + $schemaValue + ' + \'';
                else out += '' + $schema;
                out += ' characters\' ';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += '} ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("lsgEb", function(module, exports) {
    'use strict';
    module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
        var $op = $keyword == 'maxProperties' ? '>' : '<';
        out += 'if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
        out += ' Object.keys(' + $data + ').length ' + $op + ' ' + $schemaValue + ') { ';
        var $errorKeyword = $keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should NOT have ';
                if ($keyword == 'maxProperties') out += 'more';
                else out += 'fewer';
                out += ' than ';
                if ($isData) out += '\' + ' + $schemaValue + ' + \'';
                else out += '' + $schema;
                out += ' properties\' ';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += '} ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("Tw8Zf", function(module, exports) {
    'use strict';
    module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
        out += 'var division' + $lvl + ';if (';
        if ($isData) out += ' ' + $schemaValue + ' !== undefined && ( typeof ' + $schemaValue + ' != \'number\' || ';
        out += ' (division' + $lvl + ' = ' + $data + ' / ' + $schemaValue + ', ';
        if (it.opts.multipleOfPrecision) out += ' Math.abs(Math.round(division' + $lvl + ') - division' + $lvl + ') > 1e-' + it.opts.multipleOfPrecision + ' ';
        else out += ' division' + $lvl + ' !== parseInt(division' + $lvl + ') ';
        out += ' ) ';
        if ($isData) out += '  )  ';
        out += ' ) {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { multipleOf: ' + $schemaValue + ' } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should be multiple of ';
                if ($isData) out += '\' + ' + $schemaValue;
                else out += '' + $schemaValue + '\'';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += '} ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("91mPq", function(module, exports) {
    'use strict';
    module.exports = function generate_not(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
            $it.schema = $schema;
            $it.schemaPath = $schemaPath;
            $it.errSchemaPath = $errSchemaPath;
            out += ' var ' + $errs + ' = errors;  ';
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            $it.createErrors = false;
            var $allErrorsOption;
            if ($it.opts.allErrors) {
                $allErrorsOption = $it.opts.allErrors;
                $it.opts.allErrors = false;
            }
            out += ' ' + it.validate($it) + ' ';
            $it.createErrors = true;
            if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
            it.compositeRule = $it.compositeRule = $wasComposite;
            out += ' if (' + $nextValid + ') {   ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            if (it.createErrors !== false) {
                out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
            if (it.opts.allErrors) out += ' } ';
        } else {
            out += '  var err =   ';
            if (it.createErrors !== false) {
                out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if ($breakOnError) out += ' if (false) { ';
        }
        return out;
    };
});
parcelRegister("3NScL", function(module, exports) {
    'use strict';
    module.exports = function generate_oneOf(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $currentBaseId = $it.baseId, $prevValid = 'prevValid' + $lvl, $passingSchemas = 'passingSchemas' + $lvl;
        out += 'var ' + $errs + ' = errors , ' + $prevValid + ' = false , ' + $valid + ' = false , ' + $passingSchemas + ' = null; ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + '[' + $i + ']';
                    $it.errSchemaPath = $errSchemaPath + '/' + $i;
                    out += '  ' + it.validate($it) + ' ';
                    $it.baseId = $currentBaseId;
                } else out += ' var ' + $nextValid + ' = true; ';
                if ($i) {
                    out += ' if (' + $nextValid + ' && ' + $prevValid + ') { ' + $valid + ' = false; ' + $passingSchemas + ' = [' + $passingSchemas + ', ' + $i + ']; } else { ';
                    $closingBraces += '}';
                }
                out += ' if (' + $nextValid + ') { ' + $valid + ' = ' + $prevValid + ' = true; ' + $passingSchemas + ' = ' + $i + '; }';
            }
        }
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += '' + $closingBraces + 'if (!' + $valid + ') {   var err =   ';
        if (it.createErrors !== false) {
            out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { passingSchemas: ' + $passingSchemas + ' } ';
            if (it.opts.messages !== false) out += ' , message: \'should match exactly one schema in oneOf\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        out += '} else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }';
        if (it.opts.allErrors) out += ' } ';
        return out;
    };
});
parcelRegister("aPaOH", function(module, exports) {
    'use strict';
    module.exports = function generate_pattern(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
        out += 'if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
        out += ' !' + $regexp + '.test(' + $data + ') ) {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.createErrors !== false) {
            out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { pattern:  ';
            if ($isData) out += '' + $schemaValue;
            else out += '' + it.util.toQuotedString($schema);
            out += '  } ';
            if (it.opts.messages !== false) {
                out += ' , message: \'should match pattern "';
                if ($isData) out += '\' + ' + $schemaValue + ' + \'';
                else out += '' + it.util.escapeQuotes($schema);
                out += '"\' ';
            }
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + it.util.toQuotedString($schema);
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += '} ';
        if ($breakOnError) out += ' else { ';
        return out;
    };
});
parcelRegister("3BVOF", function(module, exports) {
    'use strict';
    module.exports = function generate_properties(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl;
        var $schemaKeys = Object.keys($schema || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
        var $required = it.schema.required;
        if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
        function notProto(p) {
            return p !== '__proto__';
        }
        out += 'var ' + $errs + ' = errors;var ' + $nextValid + ' = true;';
        if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined;';
        if ($checkAdditional) {
            if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
            else out += ' for (var ' + $key + ' in ' + $data + ') { ';
            if ($someProperties) {
                out += ' var isAdditional' + $lvl + ' = !(false ';
                if ($schemaKeys.length) {
                    if ($schemaKeys.length > 8) out += ' || validate.schema' + $schemaPath + '.hasOwnProperty(' + $key + ') ';
                    else {
                        var arr1 = $schemaKeys;
                        if (arr1) {
                            var $propertyKey, i1 = -1, l1 = arr1.length - 1;
                            while(i1 < l1){
                                $propertyKey = arr1[i1 += 1];
                                out += ' || ' + $key + ' == ' + it.util.toQuotedString($propertyKey) + ' ';
                            }
                        }
                    }
                }
                if ($pPropertyKeys.length) {
                    var arr2 = $pPropertyKeys;
                    if (arr2) {
                        var $pProperty, $i = -1, l2 = arr2.length - 1;
                        while($i < l2){
                            $pProperty = arr2[$i += 1];
                            out += ' || ' + it.usePattern($pProperty) + '.test(' + $key + ') ';
                        }
                    }
                }
                out += ' ); if (isAdditional' + $lvl + ') { ';
            }
            if ($removeAdditional == 'all') out += ' delete ' + $data + '[' + $key + ']; ';
            else {
                var $currentErrorPath = it.errorPath;
                var $additionalProperty = '\' + ' + $key + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                if ($noAdditional) {
                    if ($removeAdditional) out += ' delete ' + $data + '[' + $key + ']; ';
                    else {
                        out += ' ' + $nextValid + ' = false; ';
                        var $currErrSchemaPath = $errSchemaPath;
                        $errSchemaPath = it.errSchemaPath + '/additionalProperties';
                        var $$outStack = $$outStack || [];
                        $$outStack.push(out);
                        out = '';
                        if (it.createErrors !== false) {
                            out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { additionalProperty: \'' + $additionalProperty + '\' } ';
                            if (it.opts.messages !== false) {
                                out += ' , message: \'';
                                if (it.opts._errorDataPathProperty) out += 'is an invalid additional property';
                                else out += 'should NOT have additional properties';
                                out += '\' ';
                            }
                            if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                            out += ' } ';
                        } else out += ' {} ';
                        var __err = out;
                        out = $$outStack.pop();
                        if (!it.compositeRule && $breakOnError) {
                            if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                            else out += ' validate.errors = [' + __err + ']; return false; ';
                        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                        $errSchemaPath = $currErrSchemaPath;
                        if ($breakOnError) out += ' break; ';
                    }
                } else if ($additionalIsSchema) {
                    if ($removeAdditional == 'failing') {
                        out += ' var ' + $errs + ' = errors;  ';
                        var $wasComposite = it.compositeRule;
                        it.compositeRule = $it.compositeRule = true;
                        $it.schema = $aProperties;
                        $it.schemaPath = it.schemaPath + '.additionalProperties';
                        $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                        $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                        var $passData = $data + '[' + $key + ']';
                        $it.dataPathArr[$dataNxt] = $key;
                        var $code = it.validate($it);
                        $it.baseId = $currentBaseId;
                        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                        out += ' if (!' + $nextValid + ') { errors = ' + $errs + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + $data + '[' + $key + ']; }  ';
                        it.compositeRule = $it.compositeRule = $wasComposite;
                    } else {
                        $it.schema = $aProperties;
                        $it.schemaPath = it.schemaPath + '.additionalProperties';
                        $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                        $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                        var $passData = $data + '[' + $key + ']';
                        $it.dataPathArr[$dataNxt] = $key;
                        var $code = it.validate($it);
                        $it.baseId = $currentBaseId;
                        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                        if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                    }
                }
                it.errorPath = $currentErrorPath;
            }
            if ($someProperties) out += ' } ';
            out += ' }  ';
            if ($breakOnError) {
                out += ' if (' + $nextValid + ') { ';
                $closingBraces += '}';
            }
        }
        var $useDefaults = it.opts.useDefaults && !it.compositeRule;
        if ($schemaKeys.length) {
            var arr3 = $schemaKeys;
            if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while(i3 < l3){
                    $propertyKey = arr3[i3 += 1];
                    var $sch = $schema[$propertyKey];
                    if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                        var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== undefined;
                        $it.schema = $sch;
                        $it.schemaPath = $schemaPath + $prop;
                        $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
                        $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
                        $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
                        var $code = it.validate($it);
                        $it.baseId = $currentBaseId;
                        if (it.util.varOccurences($code, $nextData) < 2) {
                            $code = it.util.varReplace($code, $nextData, $passData);
                            var $useData = $passData;
                        } else {
                            var $useData = $nextData;
                            out += ' var ' + $nextData + ' = ' + $passData + '; ';
                        }
                        if ($hasDefault) out += ' ' + $code + ' ';
                        else {
                            if ($requiredHash && $requiredHash[$propertyKey]) {
                                out += ' if ( ' + $useData + ' === undefined ';
                                if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                                out += ') { ' + $nextValid + ' = false; ';
                                var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
                                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                                $errSchemaPath = it.errSchemaPath + '/required';
                                var $$outStack = $$outStack || [];
                                $$outStack.push(out);
                                out = '';
                                if (it.createErrors !== false) {
                                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                                    if (it.opts.messages !== false) {
                                        out += ' , message: \'';
                                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                                        out += '\' ';
                                    }
                                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                    out += ' } ';
                                } else out += ' {} ';
                                var __err = out;
                                out = $$outStack.pop();
                                if (!it.compositeRule && $breakOnError) {
                                    if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                    else out += ' validate.errors = [' + __err + ']; return false; ';
                                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                                $errSchemaPath = $currErrSchemaPath;
                                it.errorPath = $currentErrorPath;
                                out += ' } else { ';
                            } else if ($breakOnError) {
                                out += ' if ( ' + $useData + ' === undefined ';
                                if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                                out += ') { ' + $nextValid + ' = true; } else { ';
                            } else {
                                out += ' if (' + $useData + ' !== undefined ';
                                if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                                out += ' ) { ';
                            }
                            out += ' ' + $code + ' } ';
                        }
                    }
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
        if ($pPropertyKeys.length) {
            var arr4 = $pPropertyKeys;
            if (arr4) {
                var $pProperty, i4 = -1, l4 = arr4.length - 1;
                while(i4 < l4){
                    $pProperty = arr4[i4 += 1];
                    var $sch = $pProperties[$pProperty];
                    if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                        $it.schema = $sch;
                        $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
                        $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
                        if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
                        else out += ' for (var ' + $key + ' in ' + $data + ') { ';
                        out += ' if (' + it.usePattern($pProperty) + '.test(' + $key + ')) { ';
                        $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                        var $passData = $data + '[' + $key + ']';
                        $it.dataPathArr[$dataNxt] = $key;
                        var $code = it.validate($it);
                        $it.baseId = $currentBaseId;
                        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                        if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                        out += ' } ';
                        if ($breakOnError) out += ' else ' + $nextValid + ' = true; ';
                        out += ' }  ';
                        if ($breakOnError) {
                            out += ' if (' + $nextValid + ') { ';
                            $closingBraces += '}';
                        }
                    }
                }
            }
        }
        if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
        return out;
    };
});
parcelRegister("kwLjX", function(module, exports) {
    'use strict';
    module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $errs = 'errs__' + $lvl;
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        out += 'var ' + $errs + ' = errors;';
        if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
            $it.schema = $schema;
            $it.schemaPath = $schemaPath;
            $it.errSchemaPath = $errSchemaPath;
            var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $i = 'i' + $lvl, $invalidName = '\' + ' + $key + ' + \'', $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
            if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined; ';
            if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
            else out += ' for (var ' + $key + ' in ' + $data + ') { ';
            out += ' var startErrs' + $lvl + ' = errors; ';
            var $passData = $key;
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
            else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
            it.compositeRule = $it.compositeRule = $wasComposite;
            out += ' if (!' + $nextValid + ') { for (var ' + $i + '=startErrs' + $lvl + '; ' + $i + '<errors; ' + $i + '++) { vErrors[' + $i + '].propertyName = ' + $key + '; }   var err =   ';
            if (it.createErrors !== false) {
                out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { propertyName: \'' + $invalidName + '\' } ';
                if (it.opts.messages !== false) out += ' , message: \'property name \\\'' + $invalidName + '\\\' is invalid\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError(vErrors); ';
                else out += ' validate.errors = vErrors; return false; ';
            }
            if ($breakOnError) out += ' break; ';
            out += ' } }';
        }
        if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
        return out;
    };
});
parcelRegister("jApap", function(module, exports) {
    'use strict';
    module.exports = function generate_required(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $vSchema = 'schema' + $lvl;
        if (!$isData) {
            if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
                var $required = [];
                var arr1 = $schema;
                if (arr1) {
                    var $property, i1 = -1, l1 = arr1.length - 1;
                    while(i1 < l1){
                        $property = arr1[i1 += 1];
                        var $propertySch = it.schema.properties[$property];
                        if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == 'object' && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) $required[$required.length] = $property;
                    }
                }
            } else var $required = $schema;
        }
        if ($isData || $required.length) {
            var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
            if ($breakOnError) {
                out += ' var missing' + $lvl + '; ';
                if ($loopRequired) {
                    if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
                    var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
                    if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                    out += ' var ' + $valid + ' = true; ';
                    if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
                    out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { ' + $valid + ' = ' + $data + '[' + $vSchema + '[' + $i + ']] !== undefined ';
                    if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
                    out += '; if (!' + $valid + ') break; } ';
                    if ($isData) out += '  }  ';
                    out += '  if (!' + $valid + ') {   ';
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is a required property';
                            else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    out += ' } else { ';
                } else {
                    out += ' if ( ';
                    var arr2 = $required;
                    if (arr2) {
                        var $propertyKey, $i = -1, l2 = arr2.length - 1;
                        while($i < l2){
                            $propertyKey = arr2[$i += 1];
                            if ($i) out += ' || ';
                            var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                            out += ' ( ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                        }
                    }
                    out += ') {  ';
                    var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                    if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = '';
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is a required property';
                            else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    out += ' } else { ';
                }
            } else if ($loopRequired) {
                if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
                var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                if ($isData) {
                    out += ' if (' + $vSchema + ' && !Array.isArray(' + $vSchema + ')) {  var err =   ';
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is a required property';
                            else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + $vSchema + ' !== undefined) { ';
                }
                out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { if (' + $data + '[' + $vSchema + '[' + $i + ']] === undefined ';
                if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
                out += ') {  var err =   ';
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
                if ($isData) out += '  }  ';
            } else {
                var arr3 = $required;
                if (arr3) {
                    var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                    while(i3 < l3){
                        $propertyKey = arr3[i3 += 1];
                        var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                        if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                        out += ' if ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') {  var err =   ';
                        if (it.createErrors !== false) {
                            out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                            if (it.opts.messages !== false) {
                                out += ' , message: \'';
                                if (it.opts._errorDataPathProperty) out += 'is a required property';
                                else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                                out += '\' ';
                            }
                            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                            out += ' } ';
                        } else out += ' {} ';
                        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                    }
                }
            }
            it.errorPath = $currentErrorPath;
        } else if ($breakOnError) out += ' if (true) {';
        return out;
    };
});
parcelRegister("k0Zdf", function(module, exports) {
    'use strict';
    module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        if (($schema || $isData) && it.opts.uniqueItems !== false) {
            if ($isData) out += ' var ' + $valid + '; if (' + $schemaValue + ' === false || ' + $schemaValue + ' === undefined) ' + $valid + ' = true; else if (typeof ' + $schemaValue + ' != \'boolean\') ' + $valid + ' = false; else { ';
            out += ' var i = ' + $data + '.length , ' + $valid + ' = true , j; if (i > 1) { ';
            var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
            if (!$itemType || $itemType == 'object' || $itemType == 'array' || $typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0)) out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + $data + '[i], ' + $data + '[j])) { ' + $valid + ' = false; break outer; } } } ';
            else {
                out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + $data + '[i]; ';
                var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
                out += ' if (' + it.util[$method]($itemType, 'item', it.opts.strictNumbers, true) + ') continue; ';
                if ($typeIsArray) out += ' if (typeof item == \'string\') item = \'"\' + item; ';
                out += ' if (typeof itemIndices[item] == \'number\') { ' + $valid + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
            }
            out += ' } ';
            if ($isData) out += '  }  ';
            out += ' if (!' + $valid + ') {   ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            if (it.createErrors !== false) {
                out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { i: i, j: j } ';
                if (it.opts.messages !== false) out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
                if (it.opts.verbose) {
                    out += ' , schema:  ';
                    if ($isData) out += 'validate.schema' + $schemaPath;
                    else out += '' + $schema;
                    out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                }
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            out += ' } ';
            if ($breakOnError) out += ' else { ';
        } else if ($breakOnError) out += ' if (true) { ';
        return out;
    };
});
parcelRegister("9RO5v", function(module, exports) {
    'use strict';
    var $72efeaac0e8588fc$var$KEYWORDS = [
        'multipleOf',
        'maximum',
        'exclusiveMaximum',
        'minimum',
        'exclusiveMinimum',
        'maxLength',
        'minLength',
        'pattern',
        'additionalItems',
        'maxItems',
        'minItems',
        'uniqueItems',
        'maxProperties',
        'minProperties',
        'required',
        'additionalProperties',
        'enum',
        'format',
        'const'
    ];
    module.exports = function(metaSchema, keywordsJsonPointers) {
        for(var i = 0; i < keywordsJsonPointers.length; i++){
            metaSchema = JSON.parse(JSON.stringify(metaSchema));
            var segments = keywordsJsonPointers[i].split('/');
            var keywords = metaSchema;
            var j;
            for(j = 1; j < segments.length; j++)keywords = keywords[segments[j]];
            for(j = 0; j < $72efeaac0e8588fc$var$KEYWORDS.length; j++){
                var key = $72efeaac0e8588fc$var$KEYWORDS[j];
                var schema = keywords[key];
                if (schema) keywords[key] = {
                    anyOf: [
                        schema,
                        {
                            $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                        }
                    ]
                };
            }
        }
        return metaSchema;
    };
});
parcelRegister("3X6GU", function(module, exports) {
    'use strict';
    var $go5fO = parcelRequire("go5fO");
    var $2e0c128471100764$require$MissingRefError = $go5fO.MissingRef;
    module.exports = $2e0c128471100764$var$compileAsync;
    function $2e0c128471100764$var$compileAsync(schema, meta, callback) {
        var self = this;
        if (typeof this._opts.loadSchema != 'function') throw new Error('options.loadSchema should be a function');
        if (typeof meta == 'function') {
            callback = meta;
            meta = undefined;
        }
        var p = loadMetaSchemaOf(schema).then(function() {
            var schemaObj = self._addSchema(schema, undefined, meta);
            return schemaObj.validate || _compileAsync(schemaObj);
        });
        if (callback) p.then(function(v) {
            callback(null, v);
        }, callback);
        return p;
        function loadMetaSchemaOf(sch) {
            var $schema = sch.$schema;
            return $schema && !self.getSchema($schema) ? $2e0c128471100764$var$compileAsync.call(self, {
                $ref: $schema
            }, true) : Promise.resolve();
        }
        function _compileAsync(schemaObj) {
            try {
                return self._compile(schemaObj);
            } catch (e) {
                if (e instanceof $2e0c128471100764$require$MissingRefError) return loadMissingSchema(e);
                throw e;
            }
            function loadMissingSchema(e) {
                var ref = e.missingSchema;
                if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');
                var schemaPromise = self._loadingSchemas[ref];
                if (!schemaPromise) {
                    schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
                    schemaPromise.then(removePromise, removePromise);
                }
                return schemaPromise.then(function(sch) {
                    if (!added(ref)) return loadMetaSchemaOf(sch).then(function() {
                        if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
                    });
                }).then(function() {
                    return _compileAsync(schemaObj);
                });
                function removePromise() {
                    delete self._loadingSchemas[ref];
                }
                function added(ref) {
                    return self._refs[ref] || self._schemas[ref];
                }
            }
        }
    }
});
parcelRegister("bqG4N", function(module, exports) {
    'use strict';
    var $8522c2ebd8b54867$var$IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
    var $lD9me = parcelRequire("lD9me");
    var $78gv1 = parcelRequire("78gv1");
    module.exports = {
        add: $8522c2ebd8b54867$var$addKeyword,
        get: $8522c2ebd8b54867$var$getKeyword,
        remove: $8522c2ebd8b54867$var$removeKeyword,
        validate: $8522c2ebd8b54867$var$validateKeyword
    };
    function $8522c2ebd8b54867$var$addKeyword(keyword, definition) {
        var RULES = this.RULES;
        if (RULES.keywords[keyword]) throw new Error('Keyword ' + keyword + ' is already defined');
        if (!$8522c2ebd8b54867$var$IDENTIFIER.test(keyword)) throw new Error('Keyword ' + keyword + ' is not a valid identifier');
        if (definition) {
            this.validateKeyword(definition, true);
            var dataType = definition.type;
            if (Array.isArray(dataType)) for(var i = 0; i < dataType.length; i++)_addRule(keyword, dataType[i], definition);
            else _addRule(keyword, dataType, definition);
            var metaSchema = definition.metaSchema;
            if (metaSchema) {
                if (definition.$data && this._opts.$data) metaSchema = {
                    anyOf: [
                        metaSchema,
                        {
                            '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                        }
                    ]
                };
                definition.validateSchema = this.compile(metaSchema, true);
            }
        }
        RULES.keywords[keyword] = RULES.all[keyword] = true;
        function _addRule(keyword, dataType, definition) {
            var ruleGroup;
            for(var i = 0; i < RULES.length; i++){
                var rg = RULES[i];
                if (rg.type == dataType) {
                    ruleGroup = rg;
                    break;
                }
            }
            if (!ruleGroup) {
                ruleGroup = {
                    type: dataType,
                    rules: []
                };
                RULES.push(ruleGroup);
            }
            var rule = {
                keyword: keyword,
                definition: definition,
                custom: true,
                code: $lD9me,
                implements: definition.implements
            };
            ruleGroup.rules.push(rule);
            RULES.custom[keyword] = rule;
        }
        return this;
    }
    function $8522c2ebd8b54867$var$getKeyword(keyword) {
        var rule = this.RULES.custom[keyword];
        return rule ? rule.definition : this.RULES.keywords[keyword] || false;
    }
    function $8522c2ebd8b54867$var$removeKeyword(keyword) {
        var RULES = this.RULES;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        delete RULES.custom[keyword];
        for(var i = 0; i < RULES.length; i++){
            var rules = RULES[i].rules;
            for(var j = 0; j < rules.length; j++)if (rules[j].keyword == keyword) {
                rules.splice(j, 1);
                break;
            }
        }
        return this;
    }
    function $8522c2ebd8b54867$var$validateKeyword(definition, throwError) {
        $8522c2ebd8b54867$var$validateKeyword.errors = null;
        var v = this._validateKeyword = this._validateKeyword || this.compile($78gv1, true);
        if (v(definition)) return true;
        $8522c2ebd8b54867$var$validateKeyword.errors = v.errors;
        if (throwError) throw new Error('custom keyword definition is invalid: ' + this.errorsText(v.errors));
        else return false;
    }
});
parcelRegister("lD9me", function(module, exports) {
    'use strict';
    module.exports = function generate_custom(it, $keyword, $ruleType) {
        var out = ' ';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        var $errs = 'errs__' + $lvl;
        var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
        if ($isData) {
            out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
            $schemaValue = 'schema' + $lvl;
        } else $schemaValue = $schema;
        var $rule = this, $definition = 'definition' + $lvl, $rDef = $rule.definition, $closingBraces = '';
        var $compile, $inline, $macro, $ruleValidate, $validateCode;
        if ($isData && $rDef.$data) {
            $validateCode = 'keywordValidate' + $lvl;
            var $validateSchema = $rDef.validateSchema;
            out += ' var ' + $definition + ' = RULES.custom[\'' + $keyword + '\'].definition; var ' + $validateCode + ' = ' + $definition + '.validate;';
        } else {
            $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
            if (!$ruleValidate) return;
            $schemaValue = 'validate.schema' + $schemaPath;
            $validateCode = $ruleValidate.code;
            $compile = $rDef.compile;
            $inline = $rDef.inline;
            $macro = $rDef.macro;
        }
        var $ruleErrs = $validateCode + '.errors', $i = 'i' + $lvl, $ruleErr = 'ruleErr' + $lvl, $asyncKeyword = $rDef.async;
        if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
        if (!($inline || $macro)) out += '' + $ruleErrs + ' = null;';
        out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
        if ($isData && $rDef.$data) {
            $closingBraces += '}';
            out += ' if (' + $schemaValue + ' === undefined) { ' + $valid + ' = true; } else { ';
            if ($validateSchema) {
                $closingBraces += '}';
                out += ' ' + $valid + ' = ' + $definition + '.validateSchema(' + $schemaValue + '); if (' + $valid + ') { ';
            }
        }
        if ($inline) {
            if ($rDef.statements) out += ' ' + $ruleValidate.validate + ' ';
            else out += ' ' + $valid + ' = ' + $ruleValidate.validate + '; ';
        } else if ($macro) {
            var $it = it.util.copy(it);
            var $closingBraces = '';
            $it.level++;
            var $nextValid = 'valid' + $it.level;
            $it.schema = $ruleValidate.validate;
            $it.schemaPath = '';
            var $wasComposite = it.compositeRule;
            it.compositeRule = $it.compositeRule = true;
            var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
            it.compositeRule = $it.compositeRule = $wasComposite;
            out += ' ' + $code;
        } else {
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            out += '  ' + $validateCode + '.call( ';
            if (it.opts.passContext) out += 'this';
            else out += 'self';
            if ($compile || $rDef.schema === false) out += ' , ' + $data + ' ';
            else out += ' , ' + $schemaValue + ' , ' + $data + ' , validate.schema' + it.schemaPath + ' ';
            out += ' , (dataPath || \'\')';
            if (it.errorPath != '""') out += ' + ' + it.errorPath;
            var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
            out += ' , ' + $parentData + ' , ' + $parentDataProperty + ' , rootData )  ';
            var def_callRuleValidate = out;
            out = $$outStack.pop();
            if ($rDef.errors === false) {
                out += ' ' + $valid + ' = ';
                if ($asyncKeyword) out += 'await ';
                out += '' + def_callRuleValidate + '; ';
            } else if ($asyncKeyword) {
                $ruleErrs = 'customErrors' + $lvl;
                out += ' var ' + $ruleErrs + ' = null; try { ' + $valid + ' = await ' + def_callRuleValidate + '; } catch (e) { ' + $valid + ' = false; if (e instanceof ValidationError) ' + $ruleErrs + ' = e.errors; else throw e; } ';
            } else out += ' ' + $ruleErrs + ' = null; ' + $valid + ' = ' + def_callRuleValidate + '; ';
        }
        if ($rDef.modifying) out += ' if (' + $parentData + ') ' + $data + ' = ' + $parentData + '[' + $parentDataProperty + '];';
        out += '' + $closingBraces;
        if ($rDef.valid) {
            if ($breakOnError) out += ' if (true) { ';
        } else {
            out += ' if ( ';
            if ($rDef.valid === undefined) {
                out += ' !';
                if ($macro) out += '' + $nextValid;
                else out += '' + $valid;
            } else out += ' ' + !$rDef.valid + ' ';
            out += ') { ';
            $errorKeyword = $rule.keyword;
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = '';
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
                if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            var def_customError = out;
            out = $$outStack.pop();
            if ($inline) {
                if ($rDef.errors) {
                    if ($rDef.errors != 'full') {
                        out += '  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                        if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                        out += ' } ';
                    }
                } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
                else {
                    out += ' if (' + $errs + ' == errors) { ' + def_customError + ' } else {  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                    if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                    out += ' } } ';
                }
            } else if ($macro) {
                out += '   var err =   ';
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
                    if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                if (!it.compositeRule && $breakOnError) {
                    if (it.async) out += ' throw new ValidationError(vErrors); ';
                    else out += ' validate.errors = vErrors; return false; ';
                }
            } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
            else {
                out += ' if (Array.isArray(' + $ruleErrs + ')) { if (vErrors === null) vErrors = ' + $ruleErrs + '; else vErrors = vErrors.concat(' + $ruleErrs + '); errors = vErrors.length;  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + ';  ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
                if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                out += ' } } else { ' + def_customError + ' } ';
            }
            out += ' } ';
            if ($breakOnError) out += ' else { ';
        }
        return out;
    };
});
parcelRegister("78gv1", function(module, exports) {
    'use strict';
    var $1zxWt = parcelRequire("1zxWt");
    module.exports = {
        $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
        definitions: {
            simpleTypes: $1zxWt.definitions.simpleTypes
        },
        type: 'object',
        dependencies: {
            schema: [
                'validate'
            ],
            $data: [
                'validate'
            ],
            statements: [
                'inline'
            ],
            valid: {
                not: {
                    required: [
                        'macro'
                    ]
                }
            }
        },
        properties: {
            type: $1zxWt.properties.type,
            schema: {
                type: 'boolean'
            },
            statements: {
                type: 'boolean'
            },
            dependencies: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            metaSchema: {
                type: 'object'
            },
            modifying: {
                type: 'boolean'
            },
            valid: {
                type: 'boolean'
            },
            $data: {
                type: 'boolean'
            },
            async: {
                type: 'boolean'
            },
            errors: {
                anyOf: [
                    {
                        type: 'boolean'
                    },
                    {
                        const: 'full'
                    }
                ]
            }
        }
    };
});
parcelRegister("1zxWt", function(module, exports) {
    module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");
});
parcelRegister("cX7mp", function(module, exports) {
    module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON Schema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");
});
parcelRegister("jngaF", function(module, exports) {
    $parcel$export(module.exports, "ApiFieldDataResponseSchema", ()=>$e1acb58b182a1b74$export$d3e97414e885ab0b);
    const $e1acb58b182a1b74$export$d3e97414e885ab0b = {
        $schema: 'http://json-schema.org/draft-04/schema#',
        description: 'Schema for the response of API fielddata.',
        $ref: '#/definitions/fielddata',
        definitions: {
            fielddata: {
                type: 'object',
                patternProperties: {
                    '^[a-zA-Z0-9{}/]+$': {
                        $ref: '#/definitions/issuefielddata'
                    }
                }
            },
            issuefielddata: {
                properties: {
                    value: {
                        $ref: '#/definitions/issuefieldvalue'
                    },
                    readOnlyReason: {
                        type: 'string'
                    },
                    maxAllowedChoices: {
                        type: 'number'
                    },
                    multiple: {
                        type: 'boolean'
                    },
                    fieldConfigId: {
                        type: 'string'
                    },
                    populateDefaultValueOnEmptySearch: {
                        type: 'boolean'
                    },
                    dependsOn: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    schema: {
                        $ref: '#/definitions/schema'
                    }
                },
                required: [
                    'value'
                ],
                type: 'object'
            },
            schema: {
                properties: {
                    type: {
                        type: 'string'
                    },
                    custom: {
                        type: 'string'
                    },
                    system: {
                        type: 'string'
                    }
                },
                type: 'object'
            },
            issuefieldvalue: {
                properties: {
                    choices: {
                        type: 'array',
                        items: {
                            $ref: '#/definitions/jirafieldchoice'
                        }
                    },
                    date: {
                        type: 'string'
                    },
                    text: {
                        type: 'string'
                    },
                    time: {
                        type: 'string'
                    },
                    users: {
                        items: {
                            $ref: '#/definitions/userpickeruser'
                        },
                        type: 'array'
                    }
                },
                type: 'object'
            },
            jirafieldchoice: {
                defaultProperties: [],
                properties: {
                    id: {
                        type: 'string'
                    },
                    label: {
                        type: 'string'
                    }
                },
                required: [
                    'id',
                    'label'
                ],
                type: 'object'
            },
            userpickeruser: {
                defaultProperties: [],
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: [
                    'id',
                    'name'
                ],
                type: 'object'
            }
        }
    };
});
parcelRegister("Z8Nv6", function(module, exports) {
    $parcel$export(module.exports, "ApiFormChoicesResponseSchema", ()=>$0b7c85999398c70b$export$d8f14bc9d28df3b4);
    const $0b7c85999398c70b$export$d8f14bc9d28df3b4 = {
        $schema: 'http://json-schema.org/draft-04/schema#',
        description: 'Schema for the response of API formchoices.',
        $ref: '#/definitions/formchoices',
        definitions: {
            formchoices: {
                defaultProperties: [],
                properties: {
                    fields: {
                        type: 'object',
                        patternProperties: {
                            '^[a-zA-Z0-9{}/]+$': {
                                items: {
                                    $ref: '#/definitions/jirafieldchoice'
                                },
                                type: 'array'
                            }
                        }
                    },
                    dataConnections: {
                        type: 'object',
                        patternProperties: {
                            '^[a-zA-Z0-9{}/]+$': {
                                items: {
                                    $ref: '#/definitions/jirafieldchoice'
                                },
                                type: 'array'
                            }
                        }
                    }
                },
                required: [
                    'dataConnections',
                    'fields'
                ],
                type: 'object'
            },
            jirafieldchoice: {
                properties: {
                    id: {
                        type: 'string'
                    },
                    label: {
                        type: 'string'
                    }
                },
                required: [
                    'id',
                    'label'
                ],
                type: 'object'
            }
        }
    };
});
parcelRegister("9uYSm", function(module, exports) {
    module.exports = JSON.parse("{\"id\":\"http://json-schema.org/draft-04/schema#\",\"$schema\":\"http://json-schema.org/draft-04/schema#\",\"description\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"positiveInteger\":{\"type\":\"integer\",\"minimum\":0},\"positiveIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/positiveInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1,\"uniqueItems\":true}},\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"$schema\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"multipleOf\":{\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"boolean\",\"default\":false},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"boolean\",\"default\":false},\"maxLength\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minLength\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minItems\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxProperties\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"dependencies\":{\"exclusiveMaximum\":[\"maximum\"],\"exclusiveMinimum\":[\"minimum\"]},\"default\":{}}");
});
parcelRegister("ln9gy", function(module, exports) {
    $parcel$export(module.exports, "loadFieldDataFn", ()=>$f8f2eeffb9900a7d$export$ed2a368872b32c4b);
    var $alnGD = parcelRequire("alnGD");
    var $4aJmI;
    var $iSRld;
    var $5e1Fe;
    const $f8f2eeffb9900a7d$var$shouldOverwriteAnswerWithFieldValueAnswer = (fieldValueAnswer)=>{
        const isFieldValueAnswerEmpty = Object.keys(fieldValueAnswer).length === 0;
        return !isFieldValueAnswerEmpty;
    };
    const $f8f2eeffb9900a7d$var$getRichTextFormat = (formQuestionType)=>{
        if (formQuestionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).RichTextParagraph) return (0, (0, parcelRequire("iSRld")).RichTextFormat).Adf;
        else if (formQuestionType === (0, (0, parcelRequire("4aJmI")).FormQuestionType).TextParagraph) return (0, (0, parcelRequire("iSRld")).RichTextFormat).Wiki;
        return undefined;
    };
    const $f8f2eeffb9900a7d$export$ed2a368872b32c4b = (requestFieldData, errorUtils, isAlwaysOverwriteEmptyLinkedFields = true)=>{
        return (formStore)=>{
            return ()=>{
                const fieldsInUse = formStore.questions.reduce((fieldsInUse, questionStore)=>{
                    if (questionStore.formQuestion.jiraField) fieldsInUse.push({
                        fieldKey: questionStore.formQuestion.jiraField,
                        format: $f8f2eeffb9900a7d$var$getRichTextFormat(questionStore.formQuestion.type)
                    });
                    return fieldsInUse;
                }, []);
                if (fieldsInUse.length === 0) return Promise.resolve();
                return requestFieldData({
                    fields: fieldsInUse
                }).then((fieldData)=>{
                    const validationResult = (0, (0, parcelRequire("5e1Fe")).validate)('ApiFieldDataResponseSchema', fieldData);
                    if (!validationResult.isValid) {
                        errorUtils.reportError(new Error('Response type mismatch'), {
                            id: 'ApiFieldDataResponseSchema',
                            attributes: {
                                errors: JSON.stringify(validationResult.errors)
                            }
                        });
                        return;
                    }
                    const fieldMap = new Map(Object.entries(fieldData));
                    (0, $alnGD.runInAction)(()=>{
                        formStore.questions.forEach((questionStore)=>{
                            if (questionStore.formQuestion.jiraField && fieldMap.has(questionStore.formQuestion.jiraField)) {
                                const issueFieldData = fieldMap.get(questionStore.formQuestion.jiraField);
                                const issueFieldValue = issueFieldData.value;
                                const answer = {
                                    ...issueFieldValue.text && {
                                        text: issueFieldValue.text
                                    },
                                    ...issueFieldValue.adf && {
                                        adf: issueFieldValue.adf
                                    },
                                    ...issueFieldValue.date && {
                                        date: issueFieldValue.date
                                    },
                                    ...issueFieldValue.time && {
                                        time: !!issueFieldValue.time.match(/^\d+:\d+:\d+$/) ? issueFieldValue.time.replace(/:\d+$/, '') : issueFieldValue.time
                                    },
                                    ...issueFieldValue.choices && {
                                        choices: issueFieldValue.choices.map((choice)=>choice.id)
                                    },
                                    ...issueFieldValue.users && {
                                        users: issueFieldValue.users
                                    }
                                };
                                questionStore.setIssueFieldData(issueFieldData);
                                if (formStore.status === (0, (0, parcelRequire("4aJmI")).FormStatus).Open) {
                                    if (isAlwaysOverwriteEmptyLinkedFields || $f8f2eeffb9900a7d$var$shouldOverwriteAnswerWithFieldValueAnswer(answer)) {
                                        questionStore.setAnswerFromFieldValue(answer);
                                        questionStore.setAnswerChoicesAsObjects(issueFieldValue.choices || []);
                                    }
                                }
                            }
                        });
                    });
                });
            };
        };
    };
});
parcelRegister("iSRld", function(module, exports) {
    $parcel$export(module.exports, "RichTextFormat", ()=>$dbf6a5987f7a8f34$export$1a67d705855415ad);
    let $dbf6a5987f7a8f34$export$1a67d705855415ad = function(RichTextFormat) {
        RichTextFormat["Adf"] = "adf";
        RichTextFormat["Wiki"] = "wiki";
        return RichTextFormat;
    }({});
});
parcelRegister("ilbIo", function(module, exports) {
    $parcel$export(module.exports, "useConvertServiceResponseToPromise", ()=>$d5a346868e8f7919$export$f596204d0a1270a);
    var $5uXOq = parcelRequire("5uXOq");
    const $d5a346868e8f7919$export$f596204d0a1270a = (data, error)=>{
        const [promiseState, setPromiseState] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (data && promiseState) {
                promiseState.resolve(data);
                setPromiseState(undefined);
            }
        }, [
            data,
            promiseState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error && promiseState) {
                promiseState.reject(error);
                setPromiseState(undefined);
            }
        }, [
            error,
            promiseState
        ]);
        const createPromise = (0, $5uXOq.useMemo)(()=>()=>new Promise((resolve, reject)=>{
                    setPromiseState({
                        resolve: resolve,
                        reject: reject
                    });
                }), []);
        return createPromise;
    };
});
parcelRegister("916YZ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$69099fae51353702$export$defe85febe8b728c);
    var $7VHMR;
    const $69099fae51353702$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        objectSearchErrorTitle: {
            id: 'proforma-jira-issue-forms.controllers.form-store.object-search-error-title',
            defaultMessage: "We couldn't fetch any objects for this field",
            description: 'Error title informing the user that there was an error while fetching CMDB objects in jira issue view'
        },
        objectSearchErrorDescription: {
            id: 'proforma-jira-issue-forms.controllers.form-store.object-search-error-description',
            defaultMessage: 'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
            description: 'Error message informing user the potential issues of failing CMDB object search in jira issue view'
        }
    });
});
parcelRegister("bGdl8", function(module, exports) {
    $parcel$export(module.exports, "IssueCreatedEmbedded", ()=>$880df6fd8f39cc23$export$685fe03cbb5a9c15);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $2rqOp;
    var $6XWmw;
    var $2s322;
    var $8NzMB;
    const $880df6fd8f39cc23$export$685fe03cbb5a9c15 = ({ issueKey: issueKey, onCreateClick: onCreateClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).Rectangle), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).SuccessWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).ResultContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XWmw")).CustomCheckCircle), {
            circle: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
            tick: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            size: "84"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).Heading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2s322")).messages).successfullyCreatedTitleEmbed)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).Content), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("2s322")).messages).successfullyCreatedDescriptionWithLinkEmbed, {
            values: {
                a: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        appearance: "link",
                        spacing: "none",
                        href: `/browse/${issueKey}`,
                        target: "_blank"
                    }, issueKey)
            }
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8NzMB")).SubmitAnotherButtonWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: onCreateClick,
            testId: "proforma-jira-issue-forms.ui.issue-forms.smart-links.create-another-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2s322")).messages).successfullyCreatedButtonEmbed))))));
});
parcelRegister("6XWmw", function(module, exports) {
    $parcel$export(module.exports, "CustomCheckCircle", ()=>$5125864c1fb0cda1$export$2ee96c09d33a74f6);
    var $5uXOq = parcelRequire("5uXOq");
    const $5125864c1fb0cda1$export$2ee96c09d33a74f6 = ({ circle: circle, tick: tick, size: size })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: circle,
            cx: "12",
            cy: "12",
            r: "10"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: tick
        })));
});
parcelRegister("2s322", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1c908c5677732e93$export$defe85febe8b728c);
    var $7VHMR;
    const $1c908c5677732e93$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successfullyCreatedButtonEmbed: {
            id: 'proforma-jira-issue-forms.ui.direct.embed.successfully-created-button-embed',
            defaultMessage: 'Create another issue',
            description: 'Create another issue button displayed when the issue is successfully created in embedded ProForma Issue Forms.'
        },
        successfullyCreatedTitleEmbed: {
            id: 'proforma-jira-issue-forms.ui.direct.embed.successfully-created-title-embed',
            defaultMessage: "We\u2019ve created your issue",
            description: 'Title displayed when the issue is successfully created in an embedded ProForma Issue Forms.'
        },
        successfullyCreatedDescriptionWithLinkEmbed: {
            id: 'proforma-jira-issue-forms.ui.direct.embed.successfully-created-description-with-link-embed',
            defaultMessage: 'View <a>issueKey</a> to update, or manage this issue.',
            description: 'Description displayed when the issue is successfully created in an embedded ProForma Issue Forms.'
        }
    });
});
parcelRegister("8NzMB", function(module, exports) {
    $parcel$export(module.exports, "SuccessWrapper", ()=>$667ea81606266581$export$af661ccd4dd193f2);
    $parcel$export(module.exports, "Heading", ()=>$667ea81606266581$export$a8a3e93435678ff9);
    $parcel$export(module.exports, "Content", ()=>$667ea81606266581$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "SubmitAnotherButtonWrapper", ()=>$667ea81606266581$export$21a7210a56002e5d);
    $parcel$export(module.exports, "Rectangle", ()=>$667ea81606266581$export$4617fb02663045ef);
    $parcel$export(module.exports, "ResultContainer", ()=>$667ea81606266581$export$ab35601bed9ca017);
    var $f8Sb3;
    var $dAHxw = parcelRequire("dAHxw");
    var $3RZIb;
    const $667ea81606266581$var$illustrationHeight = 64;
    const $667ea81606266581$var$wrapperStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        textAlign: 'center',
        '&::before': {
            lineHeight: `${$667ea81606266581$var$illustrationHeight}px`,
            margin: `${"var(--ds-space-250, 20px)"} 0`,
            fontSize: `${$667ea81606266581$var$illustrationHeight}px`
        }
    });
    const $667ea81606266581$export$af661ccd4dd193f2 = (0, $dAHxw.default).div($667ea81606266581$var$wrapperStyle, {
        margin: `0 -${"var(--ds-space-250, 20px)"}`,
        zIndex: 1,
        display: 'flex',
        alignItems: 'center'
    });
    const $667ea81606266581$export$a8a3e93435678ff9 = (0, $dAHxw.default).h1((0, (0, parcelRequire("3RZIb")).h700)(), {
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        margin: `${"var(--ds-space-200, 16px)"} 0`,
        fontWeight: 500
    });
    const $667ea81606266581$export$7c6e2c02157bb7d2 = (0, $dAHxw.default).p({
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        margin: `${"var(--ds-space-200, 16px)"} 0`
    });
    const $667ea81606266581$export$21a7210a56002e5d = (0, $dAHxw.default).div({
        paddingTop: "var(--ds-space-250, 20px)",
        margin: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-500, 40px)"} 0`
    });
    const $667ea81606266581$export$4617fb02663045ef = (0, $dAHxw.default).div({
        background: `linear-gradient( 204.44deg, ${`var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`} 10.89%, ${`var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`} 79.93% )`,
        transform: 'matrix(1, 0, 0, -1, 0, 0)',
        minHeight: '200px',
        height: '300px',
        width: '100%',
        position: 'absolute',
        zIndex: 0
    });
    const $667ea81606266581$export$ab35601bed9ca017 = (0, $dAHxw.default).div({
        background: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        boxShadow: "var(--ds-shadow-raised, 0px 0px 1px rgba(0, 0, 0, 0.31), 0px 1px 1px rgba(0, 0, 0, 0.25))",
        borderRadius: '10px',
        padding: `${"var(--ds-space-800, 64px)"} ${"var(--ds-space-600, 48px)"}`,
        zIndex: 1,
        width: '320px',
        margin: `${"var(--ds-space-1000, 80px)"} auto`
    });
});
parcelRegister("foFS5", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAttributesForIssueFormsDirect", ()=>$b35993b55ee07749$export$8c658502648961e3);
    const $b35993b55ee07749$export$8c658502648961e3 = (settings)=>{
        const { projectId: projectId, projectType: projectType, templateFormId: templateFormId, isSimplifiedProject: isSimplifiedProject, issueTypeId: issueTypeId, requestTypeId: requestTypeId, userIsProjectAdmin: userIsProjectAdmin, isEmbed: isEmbed } = settings;
        return {
            projectId: projectId,
            projectType: projectType,
            templateFormId: templateFormId,
            isSimplifiedProject: isSimplifiedProject,
            issueTypeId: issueTypeId,
            requestTypeId: requestTypeId,
            isProjectAdmin: userIsProjectAdmin || false,
            isEmbed: isEmbed
        };
    };
});
